//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import {
  Observable,
  from as _observableFrom,
  of as _observableOf,
  throwError as _observableThrow,
} from 'rxjs';
import {
  catchError as _observableCatch,
  mergeMap as _observableMergeMap,
} from 'rxjs/operators';
import { ApiConfig } from './api-config';

export module ApiClient {
  export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

  export class ApiBase {
    protected constructor(private apiConfig: ApiConfig) {}

    protected async transformOptions(options: any): Promise<any> {
      const accessToken = await this.apiConfig.getAccessToken();

      options.headers = options.headers.append(
        'authorization',
        `Bearer ${accessToken}`,
      );

      return Promise.resolve(options);
    }
  }

  export interface IExchangeRateFileService {
    downloadExchangeRateFileTemplate(
      clientId?: string | undefined,
    ): Observable<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess>;
    uploadExchangeRateBatchFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
    ): Observable<UploadExchangeRateTransactionFileCommandResultSuccess>;
    getClientProvidedExchangeRateDetails(
      clientId?: string | undefined,
    ): Observable<GetExchangeRateTransactionDetailsQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ExchangeRateFileService
    extends ApiBase
    implements IExchangeRateFileService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    downloadExchangeRateFileTemplate(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ExchangeRateFile.DownloadExchangeRateFileTemplate?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadExchangeRateFileTemplate(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadExchangeRateFileTemplate(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadExchangeRateFileTemplate(
      response: HttpResponseBase,
    ): Observable<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadExchangeRateTransactionFileTemplateCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadExchangeRateTransactionFileTemplateCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadExchangeRateTransactionFileTemplateCommandResultSuccess>(
        null as any,
      );
    }

    uploadExchangeRateBatchFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadExchangeRateTransactionFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ExchangeRateFile.UploadExchangeRateBatchFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadExchangeRateBatchFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadExchangeRateBatchFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadExchangeRateTransactionFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadExchangeRateTransactionFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadExchangeRateBatchFile(
      response: HttpResponseBase,
    ): Observable<UploadExchangeRateTransactionFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadExchangeRateTransactionFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadExchangeRateTransactionFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadExchangeRateTransactionFileCommandResultSuccess>(
        null as any,
      );
    }

    getClientProvidedExchangeRateDetails(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetExchangeRateTransactionDetailsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ExchangeRateFile.GetClientProvidedExchangeRateDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientProvidedExchangeRateDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientProvidedExchangeRateDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetExchangeRateTransactionDetailsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetExchangeRateTransactionDetailsQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientProvidedExchangeRateDetails(
      response: HttpResponseBase,
    ): Observable<GetExchangeRateTransactionDetailsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetExchangeRateTransactionDetailsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetExchangeRateTransactionDetailsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetExchangeRateTransactionDetailsQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IPolicyExceptionsPageService {
    getUpsertPolicyExceptionPageData(
      clientId?: string | undefined,
      configurationPageType?: ConfigurationPageType | undefined,
      policyExceptionId?: string | null | undefined,
    ): Observable<GetUpsertPolicyExceptionPageDataQueryResultSuccess>;
    upsertPolicyException(
      request: UpsertPolicyExceptionCommand,
    ): Observable<UpsertPolicyExceptionCommandResultSuccess>;
    deletePolicyException(
      clientId?: string | undefined,
      configurationPageType?: ConfigurationPageType | undefined,
      policyExceptionId?: string | undefined,
    ): Observable<DeletePolicyExceptionCommandResultSuccess>;
    getViewPolicyExceptionsPageData(
      clientId?: string | undefined,
    ): Observable<GetViewPolicyExceptionsPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class PolicyExceptionsPageService
    extends ApiBase
    implements IPolicyExceptionsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getUpsertPolicyExceptionPageData(
      clientId?: string | undefined,
      configurationPageType?: ConfigurationPageType | undefined,
      policyExceptionId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetUpsertPolicyExceptionPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PolicyExceptionsPage.GetUpsertPolicyExceptionPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (configurationPageType === null)
        throw new Error(
          "The parameter 'configurationPageType' cannot be null.",
        );
      else if (configurationPageType !== undefined)
        url_ +=
          'ConfigurationPageType=' +
          encodeURIComponent('' + configurationPageType) +
          '&';
      if (policyExceptionId !== undefined && policyExceptionId !== null)
        url_ +=
          'PolicyExceptionId=' +
          encodeURIComponent('' + policyExceptionId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetUpsertPolicyExceptionPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetUpsertPolicyExceptionPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetUpsertPolicyExceptionPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetUpsertPolicyExceptionPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetUpsertPolicyExceptionPageData(
      response: HttpResponseBase,
    ): Observable<GetUpsertPolicyExceptionPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetUpsertPolicyExceptionPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetUpsertPolicyExceptionPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetUpsertPolicyExceptionPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertPolicyException(
      request: UpsertPolicyExceptionCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertPolicyExceptionCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PolicyExceptionsPage.UpsertPolicyException';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertPolicyException(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertPolicyException(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertPolicyExceptionCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertPolicyExceptionCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertPolicyException(
      response: HttpResponseBase,
    ): Observable<UpsertPolicyExceptionCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertPolicyExceptionCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertPolicyExceptionCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertPolicyExceptionCommandResultSuccess>(
        null as any,
      );
    }

    deletePolicyException(
      clientId?: string | undefined,
      configurationPageType?: ConfigurationPageType | undefined,
      policyExceptionId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeletePolicyExceptionCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PolicyExceptionsPage.DeletePolicyException?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (configurationPageType === null)
        throw new Error(
          "The parameter 'configurationPageType' cannot be null.",
        );
      else if (configurationPageType !== undefined)
        url_ +=
          'ConfigurationPageType=' +
          encodeURIComponent('' + configurationPageType) +
          '&';
      if (policyExceptionId === null)
        throw new Error("The parameter 'policyExceptionId' cannot be null.");
      else if (policyExceptionId !== undefined)
        url_ +=
          'PolicyExceptionId=' +
          encodeURIComponent('' + policyExceptionId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeletePolicyException(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeletePolicyException(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeletePolicyExceptionCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeletePolicyExceptionCommandResultSuccess>;
          }),
        );
    }

    protected processDeletePolicyException(
      response: HttpResponseBase,
    ): Observable<DeletePolicyExceptionCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeletePolicyExceptionCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeletePolicyExceptionCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeletePolicyExceptionCommandResultSuccess>(
        null as any,
      );
    }

    getViewPolicyExceptionsPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetViewPolicyExceptionsPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PolicyExceptionsPage.GetViewPolicyExceptionsPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetViewPolicyExceptionsPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetViewPolicyExceptionsPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetViewPolicyExceptionsPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetViewPolicyExceptionsPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetViewPolicyExceptionsPageData(
      response: HttpResponseBase,
    ): Observable<GetViewPolicyExceptionsPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetViewPolicyExceptionsPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetViewPolicyExceptionsPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetViewPolicyExceptionsPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICertificateOfCoverageTestService {
    getCoCCountries(): Observable<void>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CertificateOfCoverageTestService
    extends ApiBase
    implements ICertificateOfCoverageTestService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCoCCountries(httpContext?: HttpContext): Observable<void> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CertificateOfCoverageTest.GetCoCCountries';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({}),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCoCCountries(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCoCCountries(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<void>;
              }
            } else
              return _observableThrow(response_) as any as Observable<void>;
          }),
        );
    }

    protected processGetCoCCountries(
      response: HttpResponseBase,
    ): Observable<void> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<void>(null as any);
    }
  }

  export interface IVirusScanningService {
    getVirusScanningJobsStatus(
      clientId?: string | undefined,
      virusScanningJobIds?: string[] | undefined,
    ): Observable<GetVirusScanningJobsStatusQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class VirusScanningService
    extends ApiBase
    implements IVirusScanningService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getVirusScanningJobsStatus(
      clientId?: string | undefined,
      virusScanningJobIds?: string[] | undefined,
      httpContext?: HttpContext,
    ): Observable<GetVirusScanningJobsStatusQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/VirusScanning.GetVirusScanningJobsStatus?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (virusScanningJobIds === null)
        throw new Error("The parameter 'virusScanningJobIds' cannot be null.");
      else if (virusScanningJobIds !== undefined)
        virusScanningJobIds &&
          virusScanningJobIds.forEach((item) => {
            url_ +=
              'VirusScanningJobIds=' + encodeURIComponent('' + item) + '&';
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetVirusScanningJobsStatus(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetVirusScanningJobsStatus(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetVirusScanningJobsStatusQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetVirusScanningJobsStatusQueryResultSuccess>;
          }),
        );
    }

    protected processGetVirusScanningJobsStatus(
      response: HttpResponseBase,
    ): Observable<GetVirusScanningJobsStatusQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetVirusScanningJobsStatusQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetVirusScanningJobsStatusQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetVirusScanningJobsStatusQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IUserContextService {
    getUserContext(
      query?: GetUserContextQuery | undefined,
    ): Observable<GetUserContextQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class UserContextService
    extends ApiBase
    implements IUserContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getUserContext(
      query?: GetUserContextQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetUserContextQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/UserContext.GetUserContext?';
      if (query === null)
        throw new Error("The parameter 'query' cannot be null.");
      else if (query !== undefined)
        url_ += 'query=' + encodeURIComponent('' + query) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetUserContext(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetUserContext(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetUserContextQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetUserContextQueryResultSuccess>;
          }),
        );
    }

    protected processGetUserContext(
      response: HttpResponseBase,
    ): Observable<GetUserContextQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserContextQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetUserContextQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetUserContextQueryResultSuccess>(null as any);
    }
  }

  export interface ITeqWorkLocationSettingsPageService {
    getPageData(
      clientId?: string | undefined,
      workLocationPolicyId?: string | undefined,
    ): Observable<GetTeqSettingsByWorkLocationQueryResultSuccess>;
    saveTeqWorkLocationSettings(
      request: UpsertTeqSettingsByWorkLocationCommand,
    ): Observable<UpsertTeqSettingsByWorkLocationCommandResultSuccess>;
    saveTeqWorkLocationSettingsWorkflowStep(
      command: SaveTeqWorkLocationSettingsWorkflowStepCommand,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TeqWorkLocationSettingsPageService
    extends ApiBase
    implements ITeqWorkLocationSettingsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      workLocationPolicyId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTeqSettingsByWorkLocationQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TeqWorkLocationSettingsPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (workLocationPolicyId === null)
        throw new Error("The parameter 'workLocationPolicyId' cannot be null.");
      else if (workLocationPolicyId !== undefined)
        url_ +=
          'WorkLocationPolicyId=' +
          encodeURIComponent('' + workLocationPolicyId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTeqSettingsByWorkLocationQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTeqSettingsByWorkLocationQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTeqSettingsByWorkLocationQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTeqSettingsByWorkLocationQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTeqSettingsByWorkLocationQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTeqSettingsByWorkLocationQueryResultSuccess>(
        null as any,
      );
    }

    saveTeqWorkLocationSettings(
      request: UpsertTeqSettingsByWorkLocationCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTeqSettingsByWorkLocationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqWorkLocationSettingsPage.SaveTeqWorkLocationSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveTeqWorkLocationSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveTeqWorkLocationSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTeqSettingsByWorkLocationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTeqSettingsByWorkLocationCommandResultSuccess>;
          }),
        );
    }

    protected processSaveTeqWorkLocationSettings(
      response: HttpResponseBase,
    ): Observable<UpsertTeqSettingsByWorkLocationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTeqSettingsByWorkLocationCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTeqSettingsByWorkLocationCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTeqSettingsByWorkLocationCommandResultSuccess>(
        null as any,
      );
    }

    saveTeqWorkLocationSettingsWorkflowStep(
      command: SaveTeqWorkLocationSettingsWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqWorkLocationSettingsPage.SaveTeqWorkLocationSettingsWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveTeqWorkLocationSettingsWorkflowStep(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveTeqWorkLocationSettingsWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveTeqWorkLocationSettingsWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IWorkLocationPolicyTypePageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetWorkLocationPolicyTypeQueryResultSuccess>;
    saveTeqWorkLocationSettingsWorkflowStepCommand(
      request: SaveTeqWorkLocationSettingsWorkflowStepCommand,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class WorkLocationPolicyTypePageService
    extends ApiBase
    implements IWorkLocationPolicyTypePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetWorkLocationPolicyTypeQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/WorkLocationPolicyTypePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetWorkLocationPolicyTypeQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetWorkLocationPolicyTypeQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetWorkLocationPolicyTypeQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetWorkLocationPolicyTypeQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetWorkLocationPolicyTypeQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetWorkLocationPolicyTypeQueryResultSuccess>(
        null as any,
      );
    }

    saveTeqWorkLocationSettingsWorkflowStepCommand(
      request: SaveTeqWorkLocationSettingsWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/WorkLocationPolicyTypePage.SaveTeqWorkLocationSettingsWorkflowStepCommand';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveTeqWorkLocationSettingsWorkflowStepCommand(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveTeqWorkLocationSettingsWorkflowStepCommand(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveTeqWorkLocationSettingsWorkflowStepCommand(
      response: HttpResponseBase,
    ): Observable<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITeqOverridesPageService {
    getIndexPageData(
      clientId?: string | undefined,
    ): Observable<GetTeqOverridesIndexPageDataQueryResultSuccess>;
    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetTeqOverrideQueryResultSuccess>;
    addTeqOverride(
      request: AddTeqOverrideCommand,
    ): Observable<AddTeqOverrideCommandResultSuccess>;
    updateTeqOverrideGrossUpSetting(
      command: UpdateTeqOverrideGrossUpSettingCommand,
    ): Observable<UpdateTeqOverrideGrossUpSettingCommandResultSuccess>;
    updateTeqOverrideHypo(
      command: UpdateTeqOverrideHypoCommand,
    ): Observable<UpdateTeqOverrideHypoCommandResultSuccess>;
    updateTeqOverrideWorkLocation(
      command: UpdateTeqOverrideWorkLocationCommand,
    ): Observable<UpdateTeqOverrideWorkLocationCommandResultSuccess>;
    deleteTeqOverrideOverride(
      command: DeleteTeqOverrideCommand,
    ): Observable<DeleteTeqOverrideCommandResultSuccess>;
    downloadTeqOverridesFile(
      command: DownloadTeqOverridesFileCommand,
    ): Observable<string>;
    parseTeqOverridesFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
    ): Observable<ParseTeqOverridesCommandResultSuccess>;
    checkEmployeeOverrideDuplicateData(
      command: CheckTeqOverrideDuplicateDataCommand,
    ): Observable<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TeqOverridesPageService
    extends ApiBase
    implements ITeqOverridesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getIndexPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTeqOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TeqOverridesPage.GetIndexPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetIndexPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetIndexPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTeqOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTeqOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetIndexPageData(
      response: HttpResponseBase,
    ): Observable<GetTeqOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTeqOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTeqOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTeqOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }

    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTeqOverrideQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/TeqOverridesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTeqOverrideQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTeqOverrideQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTeqOverrideQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTeqOverrideQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetTeqOverrideQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTeqOverrideQueryResultSuccess>(null as any);
    }

    addTeqOverride(
      request: AddTeqOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<AddTeqOverrideCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/TeqOverridesPage.AddTeqOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddTeqOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddTeqOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddTeqOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddTeqOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processAddTeqOverride(
      response: HttpResponseBase,
    ): Observable<AddTeqOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddTeqOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddTeqOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddTeqOverrideCommandResultSuccess>(null as any);
    }

    updateTeqOverrideGrossUpSetting(
      command: UpdateTeqOverrideGrossUpSettingCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateTeqOverrideGrossUpSettingCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqOverridesPage.UpdateTeqOverrideGrossUpSetting';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateTeqOverrideGrossUpSetting(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateTeqOverrideGrossUpSetting(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateTeqOverrideGrossUpSettingCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateTeqOverrideGrossUpSettingCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateTeqOverrideGrossUpSetting(
      response: HttpResponseBase,
    ): Observable<UpdateTeqOverrideGrossUpSettingCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateTeqOverrideGrossUpSettingCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateTeqOverrideGrossUpSettingCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateTeqOverrideGrossUpSettingCommandResultSuccess>(
        null as any,
      );
    }

    updateTeqOverrideHypo(
      command: UpdateTeqOverrideHypoCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateTeqOverrideHypoCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TeqOverridesPage.UpdateTeqOverrideHypo';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateTeqOverrideHypo(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateTeqOverrideHypo(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateTeqOverrideHypoCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateTeqOverrideHypoCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateTeqOverrideHypo(
      response: HttpResponseBase,
    ): Observable<UpdateTeqOverrideHypoCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateTeqOverrideHypoCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateTeqOverrideHypoCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateTeqOverrideHypoCommandResultSuccess>(
        null as any,
      );
    }

    updateTeqOverrideWorkLocation(
      command: UpdateTeqOverrideWorkLocationCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateTeqOverrideWorkLocationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqOverridesPage.UpdateTeqOverrideWorkLocation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateTeqOverrideWorkLocation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateTeqOverrideWorkLocation(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateTeqOverrideWorkLocationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateTeqOverrideWorkLocationCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateTeqOverrideWorkLocation(
      response: HttpResponseBase,
    ): Observable<UpdateTeqOverrideWorkLocationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateTeqOverrideWorkLocationCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateTeqOverrideWorkLocationCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateTeqOverrideWorkLocationCommandResultSuccess>(
        null as any,
      );
    }

    deleteTeqOverrideOverride(
      command: DeleteTeqOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteTeqOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqOverridesPage.DeleteTeqOverrideOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteTeqOverrideOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteTeqOverrideOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteTeqOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteTeqOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteTeqOverrideOverride(
      response: HttpResponseBase,
    ): Observable<DeleteTeqOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteTeqOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteTeqOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteTeqOverrideCommandResultSuccess>(null as any);
    }

    downloadTeqOverridesFile(
      command: DownloadTeqOverridesFileCommand,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqOverridesPage.DownloadTeqOverridesFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTeqOverridesFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTeqOverridesFile(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTeqOverridesFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    parseTeqOverridesFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<ParseTeqOverridesCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TeqOverridesPage.ParseTeqOverridesFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processParseTeqOverridesFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processParseTeqOverridesFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ParseTeqOverridesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ParseTeqOverridesCommandResultSuccess>;
          }),
        );
    }

    protected processParseTeqOverridesFile(
      response: HttpResponseBase,
    ): Observable<ParseTeqOverridesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ParseTeqOverridesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ParseTeqOverridesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ParseTeqOverridesCommandResultSuccess>(null as any);
    }

    checkEmployeeOverrideDuplicateData(
      command: CheckTeqOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqOverridesPage.CheckEmployeeOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckEmployeeOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckEmployeeOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckEmployeeOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckTeqOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITeqClientSettingsPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetTeqClientSettingsQueryResultSuccess>;
    saveTeqClientSettings(
      request: UpsertTeqClientSettingsCommand,
    ): Observable<UpsertTeqClientSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TeqClientSettingsPageService
    extends ApiBase
    implements ITeqClientSettingsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTeqClientSettingsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TeqClientSettingsPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTeqClientSettingsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTeqClientSettingsQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTeqClientSettingsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTeqClientSettingsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTeqClientSettingsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTeqClientSettingsQueryResultSuccess>(null as any);
    }

    saveTeqClientSettings(
      request: UpsertTeqClientSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTeqClientSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TeqClientSettingsPage.SaveTeqClientSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveTeqClientSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveTeqClientSettings(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTeqClientSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTeqClientSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveTeqClientSettings(
      response: HttpResponseBase,
    ): Observable<UpsertTeqClientSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTeqClientSettingsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTeqClientSettingsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTeqClientSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxRatePolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetTaxRatePolicyPageDataQueryResultSuccess>;
    upsertTaxRatePolicySettings(
      command: UpsertTaxRatePolicySettingsCommand,
    ): Observable<UpsertTaxRatePolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxRatePolicyPageService
    extends ApiBase
    implements ITaxRatePolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRatePolicyPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/TaxRatePolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRatePolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRatePolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxRatePolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxRatePolicyPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxRatePolicyPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRatePolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertTaxRatePolicySettings(
      command: UpsertTaxRatePolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTaxRatePolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyPage.UpsertTaxRatePolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertTaxRatePolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertTaxRatePolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTaxRatePolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTaxRatePolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertTaxRatePolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertTaxRatePolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTaxRatePolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTaxRatePolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTaxRatePolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRegionTaxPositionsPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRegionTaxPositionsPageDataQueryResultSuccess>;
    saveCountryRegionTaxPositionsWorkflowStep(
      command: SaveCountryRegionTaxPositionsWorkflowStepCommand,
    ): Observable<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess>;
    downloadCountryRegionTaxPositionsData(
      command: DownloadRegionTaxPositionsDataCommand,
    ): Observable<DownloadRegionTaxPositionsDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RegionTaxPositionsPageService
    extends ApiBase
    implements IRegionTaxPositionsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRegionTaxPositionsPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RegionTaxPositionsPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionTaxPositionsPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionTaxPositionsPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRegionTaxPositionsPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionTaxPositionsPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionTaxPositionsPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionTaxPositionsPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveCountryRegionTaxPositionsWorkflowStep(
      command: SaveCountryRegionTaxPositionsWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxPositionsPage.SaveCountryRegionTaxPositionsWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCountryRegionTaxPositionsWorkflowStep(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCountryRegionTaxPositionsWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCountryRegionTaxPositionsWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadCountryRegionTaxPositionsData(
      command: DownloadRegionTaxPositionsDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadRegionTaxPositionsDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxPositionsPage.DownloadCountryRegionTaxPositionsData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadCountryRegionTaxPositionsData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadCountryRegionTaxPositionsData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadRegionTaxPositionsDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadRegionTaxPositionsDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadCountryRegionTaxPositionsData(
      response: HttpResponseBase,
    ): Observable<DownloadRegionTaxPositionsDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadRegionTaxPositionsDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadRegionTaxPositionsDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadRegionTaxPositionsDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRegionTaxPositionsCountryPageService {
    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
    ): Observable<GetRegionTaxPositionsCountryPageDataQueryResultSuccess>;
    upsertRegionTaxPositions(
      command: UpsertRegionTaxPositionsCommand,
    ): Observable<UpsertRegionTaxPositionsCommandResultSuccess>;
    markCountryRegionTaxPositionStatusAsRead(
      command: MarkCountryRegionTaxPositionStatusAsReadCommand,
    ): Observable<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RegionTaxPositionsCountryPageService
    extends ApiBase
    implements IRegionTaxPositionsCountryPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRegionTaxPositionsCountryPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxPositionsCountryPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionTaxPositionsCountryPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionTaxPositionsCountryPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRegionTaxPositionsCountryPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionTaxPositionsCountryPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionTaxPositionsCountryPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionTaxPositionsCountryPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertRegionTaxPositions(
      command: UpsertRegionTaxPositionsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRegionTaxPositionsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxPositionsCountryPage.UpsertRegionTaxPositions';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRegionTaxPositions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRegionTaxPositions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRegionTaxPositionsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRegionTaxPositionsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRegionTaxPositions(
      response: HttpResponseBase,
    ): Observable<UpsertRegionTaxPositionsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRegionTaxPositionsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRegionTaxPositionsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRegionTaxPositionsCommandResultSuccess>(
        null as any,
      );
    }

    markCountryRegionTaxPositionStatusAsRead(
      command: MarkCountryRegionTaxPositionStatusAsReadCommand,
      httpContext?: HttpContext,
    ): Observable<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxPositionsCountryPage.MarkCountryRegionTaxPositionStatusAsRead';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processMarkCountryRegionTaxPositionStatusAsRead(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processMarkCountryRegionTaxPositionStatusAsRead(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess>;
          }),
        );
    }

    protected processMarkCountryRegionTaxPositionStatusAsRead(
      response: HttpResponseBase,
    ): Observable<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              MarkCountryRegionTaxPositionStatusAsReadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IEmployeeOverridesPageService {
    getEmployeeOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetEmployeeOverridesPageDataQueryResultSuccess>;
    getTaxPositions(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
    ): Observable<GetTaxPositionsQueryResultSuccess>;
    upsertEmployeeOverride(
      command: UpsertEmployeeOverrideCommand,
    ): Observable<UpsertEmployeeOverrideCommandResultSuccess>;
    downloadMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand,
    ): Observable<string>;
    uploadMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
    ): Observable<UploadMultipleOverrideFileCommandResultSuccess>;
    checkEmployeeOverrideDuplicateData(
      command: CheckEmployeeOverrideDuplicateDataCommand,
    ): Observable<CheckEmployeeOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class EmployeeOverridesPageService
    extends ApiBase
    implements IEmployeeOverridesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getEmployeeOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEmployeeOverridesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesPage.GetEmployeeOverridesPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetEmployeeOverridesPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetEmployeeOverridesPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEmployeeOverridesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEmployeeOverridesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetEmployeeOverridesPageData(
      response: HttpResponseBase,
    ): Observable<GetEmployeeOverridesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEmployeeOverridesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEmployeeOverridesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEmployeeOverridesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    getTaxPositions(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxPositionsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/EmployeeOverridesPage.GetTaxPositions?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      if (regionCode !== undefined && regionCode !== null)
        url_ += 'RegionCode=' + encodeURIComponent('' + regionCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetTaxPositions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTaxPositions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxPositionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxPositionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetTaxPositions(
      response: HttpResponseBase,
    ): Observable<GetTaxPositionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaxPositionsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetTaxPositionsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxPositionsQueryResultSuccess>(null as any);
    }

    upsertEmployeeOverride(
      command: UpsertEmployeeOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertEmployeeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesPage.UpsertEmployeeOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertEmployeeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertEmployeeOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertEmployeeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertEmployeeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertEmployeeOverride(
      response: HttpResponseBase,
    ): Observable<UpsertEmployeeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertEmployeeOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertEmployeeOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertEmployeeOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesPage.DownloadMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesPage.UploadMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadMultipleOverrideFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    checkEmployeeOverrideDuplicateData(
      command: CheckEmployeeOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckEmployeeOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesPage.CheckEmployeeOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckEmployeeOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckEmployeeOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckEmployeeOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckEmployeeOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckEmployeeOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckEmployeeOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckEmployeeOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckEmployeeOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckEmployeeOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IEmployeeOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
      behavior?: GetEmployeeOverridesIndexPageDataQueryBehavior | undefined,
    ): Observable<GetEmployeeOverridesIndexPageDataQueryResultSuccess>;
    deleteEmployeeOverride(
      clientId?: string | undefined,
      id?: string | undefined,
    ): Observable<DeleteEmployeeOverrideCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class EmployeeOverridesIndexPageService
    extends ApiBase
    implements IEmployeeOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      behavior?: GetEmployeeOverridesIndexPageDataQueryBehavior | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEmployeeOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/EmployeeOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (behavior === null)
        throw new Error("The parameter 'behavior' cannot be null.");
      else if (behavior !== undefined)
        url_ += 'Behavior=' + encodeURIComponent('' + behavior) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEmployeeOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEmployeeOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetEmployeeOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEmployeeOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEmployeeOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEmployeeOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }

    deleteEmployeeOverride(
      clientId?: string | undefined,
      id?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteEmployeeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeeOverridesIndexPage.DeleteEmployeeOverride?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id === null) throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteEmployeeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteEmployeeOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteEmployeeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteEmployeeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteEmployeeOverride(
      response: HttpResponseBase,
    ): Observable<DeleteEmployeeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteEmployeeOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteEmployeeOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteEmployeeOverrideCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICountryTaxPositionsPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetCountryTaxPositionsPageDataQueryResultSuccess>;
    markCountryAsRead(
      command: MarkCountryTaxPositionStatusAsReadCommand,
    ): Observable<MarkCountryTaxPositionStatusAsReadCommandResultSuccess>;
    saveCountryTaxPositionsWorkflowStep(
      command: SaveCountryTaxPositionsWorkflowStepCommand,
    ): Observable<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess>;
    downloadCountryTaxPositionsData(
      command: DownloadCountryTaxPositionsDataCommand,
    ): Observable<DownloadCountryTaxPositionsDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CountryTaxPositionsPageService
    extends ApiBase
    implements ICountryTaxPositionsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryTaxPositionsPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CountryTaxPositionsPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryTaxPositionsPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryTaxPositionsPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCountryTaxPositionsPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryTaxPositionsPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryTaxPositionsPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryTaxPositionsPageDataQueryResultSuccess>(
        null as any,
      );
    }

    markCountryAsRead(
      command: MarkCountryTaxPositionStatusAsReadCommand,
      httpContext?: HttpContext,
    ): Observable<MarkCountryTaxPositionStatusAsReadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsPage.MarkCountryAsRead';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processMarkCountryAsRead(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processMarkCountryAsRead(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<MarkCountryTaxPositionStatusAsReadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<MarkCountryTaxPositionStatusAsReadCommandResultSuccess>;
          }),
        );
    }

    protected processMarkCountryAsRead(
      response: HttpResponseBase,
    ): Observable<MarkCountryTaxPositionStatusAsReadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              MarkCountryTaxPositionStatusAsReadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              MarkCountryTaxPositionStatusAsReadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<MarkCountryTaxPositionStatusAsReadCommandResultSuccess>(
        null as any,
      );
    }

    saveCountryTaxPositionsWorkflowStep(
      command: SaveCountryTaxPositionsWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsPage.SaveCountryTaxPositionsWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCountryTaxPositionsWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCountryTaxPositionsWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCountryTaxPositionsWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCountryTaxPositionsWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCountryTaxPositionsWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCountryTaxPositionsWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadCountryTaxPositionsData(
      command: DownloadCountryTaxPositionsDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadCountryTaxPositionsDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsPage.DownloadCountryTaxPositionsData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadCountryTaxPositionsData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadCountryTaxPositionsData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadCountryTaxPositionsDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadCountryTaxPositionsDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadCountryTaxPositionsData(
      response: HttpResponseBase,
    ): Observable<DownloadCountryTaxPositionsDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadCountryTaxPositionsDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadCountryTaxPositionsDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadCountryTaxPositionsDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICountryTaxPositionsCountryPageService {
    getPageData(
      clientId?: string | undefined,
      countryIsoCode?: string | undefined,
    ): Observable<GetCountryTaxPositionsCountryPageDataQueryResultSuccess>;
    save(
      command: UpsertCountryTaxPositionsCommand,
    ): Observable<UpsertCountryTaxPositionsCommandResultSuccess>;
    getConfigurationPolicies(
      clientId?: string | undefined,
      countryCode?: string | undefined,
    ): Observable<GetCountryConfigurationPoliciesQueryResultSuccess>;
    downloadCountryPositionDocument(
      countryCode?: string | undefined,
      requestedFileType?: CountryPositionDocumentFileType | undefined,
    ): Observable<DownloadCountryPositionDocumentQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CountryTaxPositionsCountryPageService
    extends ApiBase
    implements ICountryTaxPositionsCountryPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      countryIsoCode?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryTaxPositionsCountryPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsCountryPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryIsoCode === null)
        throw new Error("The parameter 'countryIsoCode' cannot be null.");
      else if (countryIsoCode !== undefined)
        url_ +=
          'CountryIsoCode=' + encodeURIComponent('' + countryIsoCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryTaxPositionsCountryPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryTaxPositionsCountryPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCountryTaxPositionsCountryPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryTaxPositionsCountryPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryTaxPositionsCountryPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryTaxPositionsCountryPageDataQueryResultSuccess>(
        null as any,
      );
    }

    save(
      command: UpsertCountryTaxPositionsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCountryTaxPositionsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CountryTaxPositionsCountryPage.Save';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSave(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSave(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCountryTaxPositionsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCountryTaxPositionsCommandResultSuccess>;
          }),
        );
    }

    protected processSave(
      response: HttpResponseBase,
    ): Observable<UpsertCountryTaxPositionsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCountryTaxPositionsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCountryTaxPositionsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCountryTaxPositionsCommandResultSuccess>(
        null as any,
      );
    }

    getConfigurationPolicies(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryConfigurationPoliciesQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsCountryPage.GetConfigurationPolicies?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetConfigurationPolicies(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetConfigurationPolicies(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryConfigurationPoliciesQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryConfigurationPoliciesQueryResultSuccess>;
          }),
        );
    }

    protected processGetConfigurationPolicies(
      response: HttpResponseBase,
    ): Observable<GetCountryConfigurationPoliciesQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryConfigurationPoliciesQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryConfigurationPoliciesQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryConfigurationPoliciesQueryResultSuccess>(
        null as any,
      );
    }

    downloadCountryPositionDocument(
      countryCode?: string | undefined,
      requestedFileType?: CountryPositionDocumentFileType | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadCountryPositionDocumentQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxPositionsCountryPage.DownloadCountryPositionDocument?';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      if (requestedFileType === null)
        throw new Error("The parameter 'requestedFileType' cannot be null.");
      else if (requestedFileType !== undefined)
        url_ +=
          'RequestedFileType=' +
          encodeURIComponent('' + requestedFileType) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadCountryPositionDocument(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadCountryPositionDocument(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadCountryPositionDocumentQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadCountryPositionDocumentQueryResultSuccess>;
          }),
        );
    }

    protected processDownloadCountryPositionDocument(
      response: HttpResponseBase,
    ): Observable<DownloadCountryPositionDocumentQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadCountryPositionDocumentQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadCountryPositionDocumentQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadCountryPositionDocumentQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxTypeDescriptionService {
    getTaxTypeDescription(
      command: GetTaxTypeDescriptionDataCommand,
    ): Observable<GetTaxTypeDescriptionDataCommandResultSuccess>;
    getRegionCodeFromTaxTypeDescription(
      command: GetRegionCodeFromTaxTypeDescriptionCommand,
    ): Observable<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxTypeDescriptionService
    extends ApiBase
    implements ITaxTypeDescriptionService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getTaxTypeDescription(
      command: GetTaxTypeDescriptionDataCommand,
      httpContext?: HttpContext,
    ): Observable<GetTaxTypeDescriptionDataCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxTypeDescription.GetTaxTypeDescription';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetTaxTypeDescription(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTaxTypeDescription(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxTypeDescriptionDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxTypeDescriptionDataCommandResultSuccess>;
          }),
        );
    }

    protected processGetTaxTypeDescription(
      response: HttpResponseBase,
    ): Observable<GetTaxTypeDescriptionDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxTypeDescriptionDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxTypeDescriptionDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxTypeDescriptionDataCommandResultSuccess>(
        null as any,
      );
    }

    getRegionCodeFromTaxTypeDescription(
      command: GetRegionCodeFromTaxTypeDescriptionCommand,
      httpContext?: HttpContext,
    ): Observable<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxTypeDescription.GetRegionCodeFromTaxTypeDescription';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetRegionCodeFromTaxTypeDescription(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRegionCodeFromTaxTypeDescription(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess>;
          }),
        );
    }

    protected processGetRegionCodeFromTaxTypeDescription(
      response: HttpResponseBase,
    ): Observable<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionCodeFromTaxTypeDescriptionCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxRateEmployeeOverridePageService {
    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetTaxRateEmployeeOverridePageDataQueryResultSuccess>;
    getTaxRateTypes(
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
    ): Observable<GetTaxRateTypesQueryResultSuccess>;
    upsertTaxRateEmployeeOverride(
      command: UpsertTaxRateEmployeeOverrideCommand,
    ): Observable<UpsertTaxRateEmployeeOverrideCommandResultSuccess>;
    checkTaxRateEmployeeOverrideDuplicateData(
      command: CheckTaxRateEmployeeOverrideDuplicateDataCommand,
    ): Observable<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess>;
    downloadClientProvidedRatesTemplate(
      clientId?: string | undefined,
    ): Observable<DownloadClientProvidedRatesTemplateQueryResultSuccess>;
    uploadClientProvidedRatesFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      saveRates?: boolean | undefined,
    ): Observable<UploadClientProvidedRatesFileCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxRateEmployeeOverridePageService
    extends ApiBase
    implements ITaxRateEmployeeOverridePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRateEmployeeOverridePageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxRateEmployeeOverridePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRateEmployeeOverridePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRateEmployeeOverridePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxRateEmployeeOverridePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxRateEmployeeOverridePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxRateEmployeeOverridePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRateEmployeeOverridePageDataQueryResultSuccess>(
        null as any,
      );
    }

    getTaxRateTypes(
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRateTypesQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverridePage.GetTaxRateTypes?';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      if (regionCode !== undefined && regionCode !== null)
        url_ += 'RegionCode=' + encodeURIComponent('' + regionCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetTaxRateTypes(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTaxRateTypes(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRateTypesQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRateTypesQueryResultSuccess>;
          }),
        );
    }

    protected processGetTaxRateTypes(
      response: HttpResponseBase,
    ): Observable<GetTaxRateTypesQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaxRateTypesQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetTaxRateTypesQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRateTypesQueryResultSuccess>(null as any);
    }

    upsertTaxRateEmployeeOverride(
      command: UpsertTaxRateEmployeeOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTaxRateEmployeeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverridePage.UpsertTaxRateEmployeeOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertTaxRateEmployeeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertTaxRateEmployeeOverride(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTaxRateEmployeeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTaxRateEmployeeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertTaxRateEmployeeOverride(
      response: HttpResponseBase,
    ): Observable<UpsertTaxRateEmployeeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTaxRateEmployeeOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTaxRateEmployeeOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTaxRateEmployeeOverrideCommandResultSuccess>(
        null as any,
      );
    }

    checkTaxRateEmployeeOverrideDuplicateData(
      command: CheckTaxRateEmployeeOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverridePage.CheckTaxRateEmployeeOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckTaxRateEmployeeOverrideDuplicateData(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckTaxRateEmployeeOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckTaxRateEmployeeOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }

    downloadClientProvidedRatesTemplate(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadClientProvidedRatesTemplateQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverridePage.DownloadClientProvidedRatesTemplate?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadClientProvidedRatesTemplate(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadClientProvidedRatesTemplate(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadClientProvidedRatesTemplateQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadClientProvidedRatesTemplateQueryResultSuccess>;
          }),
        );
    }

    protected processDownloadClientProvidedRatesTemplate(
      response: HttpResponseBase,
    ): Observable<DownloadClientProvidedRatesTemplateQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadClientProvidedRatesTemplateQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadClientProvidedRatesTemplateQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadClientProvidedRatesTemplateQueryResultSuccess>(
        null as any,
      );
    }

    uploadClientProvidedRatesFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      saveRates?: boolean | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadClientProvidedRatesFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverridePage.UploadClientProvidedRatesFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (saveRates === null || saveRates === undefined)
        throw new Error("The parameter 'saveRates' cannot be null.");
      else content_.append('SaveRates', saveRates.toString());

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadClientProvidedRatesFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadClientProvidedRatesFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadClientProvidedRatesFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadClientProvidedRatesFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadClientProvidedRatesFile(
      response: HttpResponseBase,
    ): Observable<UploadClientProvidedRatesFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadClientProvidedRatesFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadClientProvidedRatesFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadClientProvidedRatesFileCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxRateEmployeeOverrideIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess>;
    deleteTaxRateEmployeeOverride(
      command: DeleteTaxRateEmployeeOverrideCommand,
    ): Observable<DeleteTaxRateEmployeeOverrideCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxRateEmployeeOverrideIndexPageService
    extends ApiBase
    implements ITaxRateEmployeeOverrideIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverrideIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }

    deleteTaxRateEmployeeOverride(
      command: DeleteTaxRateEmployeeOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteTaxRateEmployeeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRateEmployeeOverrideIndexPage.DeleteTaxRateEmployeeOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteTaxRateEmployeeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteTaxRateEmployeeOverride(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteTaxRateEmployeeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteTaxRateEmployeeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteTaxRateEmployeeOverride(
      response: HttpResponseBase,
    ): Observable<DeleteTaxRateEmployeeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteTaxRateEmployeeOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteTaxRateEmployeeOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteTaxRateEmployeeOverrideCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRegionTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRegionTaxRatesPageDataQueryResultSuccess>;
    saveRegionTaxWorkflowStep(
      command: SaveRegionTaxRatesWorkflowStepCommand,
    ): Observable<SaveRegionTaxRatesWorkflowStepCommandResultSuccess>;
    downloadRegionCountryTaxesData(
      command: DownloadRegionTaxRatePageDataCommand,
    ): Observable<DownloadRegionTaxRatePageDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RegionTaxRatesPageService
    extends ApiBase
    implements IRegionTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRegionTaxRatesPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/RegionTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRegionTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionTaxRatesPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionTaxRatesPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveRegionTaxWorkflowStep(
      command: SaveRegionTaxRatesWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveRegionTaxRatesWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxRatesPage.SaveRegionTaxWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveRegionTaxWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveRegionTaxWorkflowStep(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveRegionTaxRatesWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveRegionTaxRatesWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveRegionTaxWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveRegionTaxRatesWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveRegionTaxRatesWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveRegionTaxRatesWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveRegionTaxRatesWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadRegionCountryTaxesData(
      command: DownloadRegionTaxRatePageDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadRegionTaxRatePageDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxRatesPage.DownloadRegionCountryTaxesData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadRegionCountryTaxesData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadRegionCountryTaxesData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadRegionTaxRatePageDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadRegionTaxRatePageDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadRegionCountryTaxesData(
      response: HttpResponseBase,
    ): Observable<DownloadRegionTaxRatePageDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadRegionTaxRatePageDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadRegionTaxRatePageDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadRegionTaxRatePageDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IHypoSpecificCustomTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
    ): Observable<GetHypoCustomTaxesOverrideQueryResultSuccess>;
    upsertHypoCustomTaxRateOverrides(
      request: UpsertHypoCustomTaxRateOverridesCommand,
    ): Observable<UpsertHypoCustomTaxRateOverridesCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class HypoSpecificCustomTaxRatesPageService
    extends ApiBase
    implements IHypoSpecificCustomTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetHypoCustomTaxesOverrideQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoSpecificCustomTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetHypoCustomTaxesOverrideQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetHypoCustomTaxesOverrideQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetHypoCustomTaxesOverrideQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetHypoCustomTaxesOverrideQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetHypoCustomTaxesOverrideQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetHypoCustomTaxesOverrideQueryResultSuccess>(
        null as any,
      );
    }

    upsertHypoCustomTaxRateOverrides(
      request: UpsertHypoCustomTaxRateOverridesCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertHypoCustomTaxRateOverridesCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoSpecificCustomTaxRatesPage.UpsertHypoCustomTaxRateOverrides';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertHypoCustomTaxRateOverrides(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertHypoCustomTaxRateOverrides(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertHypoCustomTaxRateOverridesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertHypoCustomTaxRateOverridesCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertHypoCustomTaxRateOverrides(
      response: HttpResponseBase,
    ): Observable<UpsertHypoCustomTaxRateOverridesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertHypoCustomTaxRateOverridesCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertHypoCustomTaxRateOverridesCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertHypoCustomTaxRateOverridesCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISpecificCountryRegionTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
    ): Observable<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
    upsertCountryRegionTaxRateOverrides(
      request: UpsertCountryRegionTaxRateOverridesCommand,
    ): Observable<UpsertCountryRegionTaxRateOverridesCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SpecificCountryRegionTaxRatesPageService
    extends ApiBase
    implements ISpecificCountryRegionTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SpecificCountryRegionTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      if (regionCode !== undefined && regionCode !== null)
        url_ += 'RegionCode=' + encodeURIComponent('' + regionCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSpecificCountryRegionTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertCountryRegionTaxRateOverrides(
      request: UpsertCountryRegionTaxRateOverridesCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCountryRegionTaxRateOverridesCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SpecificCountryRegionTaxRatesPage.UpsertCountryRegionTaxRateOverrides';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertCountryRegionTaxRateOverrides(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertCountryRegionTaxRateOverrides(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCountryRegionTaxRateOverridesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCountryRegionTaxRateOverridesCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertCountryRegionTaxRateOverrides(
      response: HttpResponseBase,
    ): Observable<UpsertCountryRegionTaxRateOverridesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCountryRegionTaxRateOverridesCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCountryRegionTaxRateOverridesCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCountryRegionTaxRateOverridesCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IHypoSpecificCountryRegionTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
    ): Observable<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
    upsertHypoCountryRegionTaxRateOverrides(
      request: UpsertHypoCountryRegionTaxRateOverridesCommand,
    ): Observable<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class HypoSpecificCountryRegionTaxRatesPageService
    extends ApiBase
    implements IHypoSpecificCountryRegionTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      countryCode?: string | undefined,
      regionCode?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoSpecificCountryRegionTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (countryCode === null)
        throw new Error("The parameter 'countryCode' cannot be null.");
      else if (countryCode !== undefined)
        url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
      if (regionCode !== undefined && regionCode !== null)
        url_ += 'RegionCode=' + encodeURIComponent('' + regionCode) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertHypoCountryRegionTaxRateOverrides(
      request: UpsertHypoCountryRegionTaxRateOverridesCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoSpecificCountryRegionTaxRatesPage.UpsertHypoCountryRegionTaxRateOverrides';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertHypoCountryRegionTaxRateOverrides(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertHypoCountryRegionTaxRateOverrides(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertHypoCountryRegionTaxRateOverrides(
      response: HttpResponseBase,
    ): Observable<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertHypoCountryRegionTaxRateOverridesCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IHypoRegionTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetHypoRegionTaxRatesPageDataQueryResultSuccess>;
    saveHypoRegionTaxWorkflowStep(
      command: SaveHypoRegionTaxRatesWorkflowStepCommand,
    ): Observable<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess>;
    downloadHypoRegionCountryTaxesData(
      command: DownloadHypoRegionTaxRatePageDataCommand,
    ): Observable<DownloadHypoRegionTaxRatePageDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class HypoRegionTaxRatesPageService
    extends ApiBase
    implements IHypoRegionTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetHypoRegionTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/HypoRegionTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetHypoRegionTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetHypoRegionTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetHypoRegionTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetHypoRegionTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetHypoRegionTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetHypoRegionTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveHypoRegionTaxWorkflowStep(
      command: SaveHypoRegionTaxRatesWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoRegionTaxRatesPage.SaveHypoRegionTaxWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveHypoRegionTaxWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveHypoRegionTaxWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveHypoRegionTaxWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveHypoRegionTaxRatesWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadHypoRegionCountryTaxesData(
      command: DownloadHypoRegionTaxRatePageDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadHypoRegionTaxRatePageDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoRegionTaxRatesPage.DownloadHypoRegionCountryTaxesData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadHypoRegionCountryTaxesData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadHypoRegionCountryTaxesData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadHypoRegionTaxRatePageDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadHypoRegionTaxRatePageDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadHypoRegionCountryTaxesData(
      response: HttpResponseBase,
    ): Observable<DownloadHypoRegionTaxRatePageDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadHypoRegionTaxRatePageDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadHypoRegionTaxRatePageDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadHypoRegionTaxRatePageDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IHypoCustomTaxRatesPageService {
    getHypoCustomTaxes(
      clientId?: string | undefined,
    ): Observable<GetHypoCustomTaxesQueryResultSuccess>;
    saveHypoCustomTaxWorkflowStep(
      command: SaveHypoCustomTaxRatesWorkflowStepCommand,
    ): Observable<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess>;
    downloadHypoCustomTaxRatesData(
      command: DownloadHypoCustomTaxRatesDataCommand,
    ): Observable<DownloadHypoCustomTaxRatesDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class HypoCustomTaxRatesPageService
    extends ApiBase
    implements IHypoCustomTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getHypoCustomTaxes(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetHypoCustomTaxesQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoCustomTaxRatesPage.GetHypoCustomTaxes?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetHypoCustomTaxes(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetHypoCustomTaxes(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetHypoCustomTaxesQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetHypoCustomTaxesQueryResultSuccess>;
          }),
        );
    }

    protected processGetHypoCustomTaxes(
      response: HttpResponseBase,
    ): Observable<GetHypoCustomTaxesQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetHypoCustomTaxesQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetHypoCustomTaxesQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetHypoCustomTaxesQueryResultSuccess>(null as any);
    }

    saveHypoCustomTaxWorkflowStep(
      command: SaveHypoCustomTaxRatesWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoCustomTaxRatesPage.SaveHypoCustomTaxWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveHypoCustomTaxWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveHypoCustomTaxWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveHypoCustomTaxWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveHypoCustomTaxRatesWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadHypoCustomTaxRatesData(
      command: DownloadHypoCustomTaxRatesDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadHypoCustomTaxRatesDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoCustomTaxRatesPage.DownloadHypoCustomTaxRatesData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadHypoCustomTaxRatesData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadHypoCustomTaxRatesData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadHypoCustomTaxRatesDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadHypoCustomTaxRatesDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadHypoCustomTaxRatesData(
      response: HttpResponseBase,
    ): Observable<DownloadHypoCustomTaxRatesDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadHypoCustomTaxRatesDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadHypoCustomTaxRatesDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadHypoCustomTaxRatesDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IHypoCountryTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetHypoCountryTaxRatesPageDataQueryResultSuccess>;
    saveHypoCountryTaxWorkflowStep(
      command: SaveHypoCountryTaxRatesWorkflowStepCommand,
    ): Observable<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess>;
    downloadHypoCountryTaxRatesData(
      command: DownloadHypoCountryTaxRatesDataCommand,
    ): Observable<DownloadHypoCountryTaxRatesDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class HypoCountryTaxRatesPageService
    extends ApiBase
    implements IHypoCountryTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetHypoCountryTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/HypoCountryTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetHypoCountryTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetHypoCountryTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetHypoCountryTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetHypoCountryTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetHypoCountryTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetHypoCountryTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveHypoCountryTaxWorkflowStep(
      command: SaveHypoCountryTaxRatesWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoCountryTaxRatesPage.SaveHypoCountryTaxWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveHypoCountryTaxWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveHypoCountryTaxWorkflowStep(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveHypoCountryTaxWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveHypoCountryTaxRatesWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadHypoCountryTaxRatesData(
      command: DownloadHypoCountryTaxRatesDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadHypoCountryTaxRatesDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/HypoCountryTaxRatesPage.DownloadHypoCountryTaxRatesData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadHypoCountryTaxRatesData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadHypoCountryTaxRatesData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadHypoCountryTaxRatesDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadHypoCountryTaxRatesDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadHypoCountryTaxRatesData(
      response: HttpResponseBase,
    ): Observable<DownloadHypoCountryTaxRatesDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadHypoCountryTaxRatesDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadHypoCountryTaxRatesDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadHypoCountryTaxRatesDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IExchangeTaxRatesPageService {
    getExchangeTaxRatesPageData(
      clientId?: string | undefined,
    ): Observable<GetExchangeTaxRatesPageDataQueryResultSuccess>;
    upsertExchangeTaxRatesPolicySettings(
      command: UpsertExchangeTaxRatesPolicySettingsCommand,
    ): Observable<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ExchangeTaxRatesPageService
    extends ApiBase
    implements IExchangeTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getExchangeTaxRatesPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetExchangeTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ExchangeTaxRatesPage.GetExchangeTaxRatesPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetExchangeTaxRatesPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetExchangeTaxRatesPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetExchangeTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetExchangeTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetExchangeTaxRatesPageData(
      response: HttpResponseBase,
    ): Observable<GetExchangeTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetExchangeTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetExchangeTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetExchangeTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertExchangeTaxRatesPolicySettings(
      command: UpsertExchangeTaxRatesPolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ExchangeTaxRatesPage.UpsertExchangeTaxRatesPolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertExchangeTaxRatesPolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertExchangeTaxRatesPolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertExchangeTaxRatesPolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertExchangeTaxRatesPolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICountryTaxRatesPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetCountryTaxRatesPageDataQueryResultSuccess>;
    saveCountryTaxWorkflowStep(
      command: SaveCountryTaxRatesWorkflowStepCommand,
    ): Observable<SaveCountryTaxRatesWorkflowStepCommandResultSuccess>;
    downloadCountryTaxesData(
      command: DownloadCountryTaxRatePageDataCommand,
    ): Observable<DownloadCountryTaxRatePageDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CountryTaxRatesPageService
    extends ApiBase
    implements ICountryTaxRatesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryTaxRatesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CountryTaxRatesPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryTaxRatesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryTaxRatesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCountryTaxRatesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryTaxRatesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryTaxRatesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryTaxRatesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveCountryTaxWorkflowStep(
      command: SaveCountryTaxRatesWorkflowStepCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCountryTaxRatesWorkflowStepCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxRatesPage.SaveCountryTaxWorkflowStep';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCountryTaxWorkflowStep(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCountryTaxWorkflowStep(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCountryTaxRatesWorkflowStepCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCountryTaxRatesWorkflowStepCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCountryTaxWorkflowStep(
      response: HttpResponseBase,
    ): Observable<SaveCountryTaxRatesWorkflowStepCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCountryTaxRatesWorkflowStepCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCountryTaxRatesWorkflowStepCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCountryTaxRatesWorkflowStepCommandResultSuccess>(
        null as any,
      );
    }

    downloadCountryTaxesData(
      command: DownloadCountryTaxRatePageDataCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadCountryTaxRatePageDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryTaxRatesPage.DownloadCountryTaxesData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadCountryTaxesData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadCountryTaxesData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadCountryTaxRatePageDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadCountryTaxRatePageDataCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadCountryTaxesData(
      response: HttpResponseBase,
    ): Observable<DownloadCountryTaxRatePageDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadCountryTaxRatePageDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadCountryTaxRatePageDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadCountryTaxRatePageDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxRateOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetTaxRateOverridesIndexPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxRateOverridesIndexPageService
    extends ApiBase
    implements ITaxRateOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRateOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxRateOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRateOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRateOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxRateOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxRateOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxRateOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRateOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxRatePolicyOverridePageService {
    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetTaxRatePolicyOverridePageDataQueryResultSuccess>;
    upsertTaxRatePolicyOverrideSettings(
      command: UpsertTaxRatePolicyOverrideSettingsCommand,
    ): Observable<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess>;
    deleteTaxRatePolicyOverrideSettings(
      command: DeleteTaxRatePolicyOverrideCommand,
    ): Observable<DeleteTaxRatePolicyOverrideCommandResultSuccess>;
    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideWithoutTransactionIdCommand,
    ): Observable<string>;
    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
    checkTaxRateOverrideDuplicateData(
      command: CheckTaxRateOverrideDuplicateDataCommand,
    ): Observable<CheckTaxRateOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxRatePolicyOverridePageService
    extends ApiBase
    implements ITaxRatePolicyOverridePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxRatePolicyOverridePageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxRatePolicyOverridePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxRatePolicyOverridePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxRatePolicyOverridePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxRatePolicyOverridePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxRatePolicyOverridePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxRatePolicyOverridePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxRatePolicyOverridePageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertTaxRatePolicyOverrideSettings(
      command: UpsertTaxRatePolicyOverrideSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyOverridePage.UpsertTaxRatePolicyOverrideSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertTaxRatePolicyOverrideSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertTaxRatePolicyOverrideSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertTaxRatePolicyOverrideSettings(
      response: HttpResponseBase,
    ): Observable<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTaxRatePolicyOverrideSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess>(
        null as any,
      );
    }

    deleteTaxRatePolicyOverrideSettings(
      command: DeleteTaxRatePolicyOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteTaxRatePolicyOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyOverridePage.DeleteTaxRatePolicyOverrideSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteTaxRatePolicyOverrideSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteTaxRatePolicyOverrideSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteTaxRatePolicyOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteTaxRatePolicyOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteTaxRatePolicyOverrideSettings(
      response: HttpResponseBase,
    ): Observable<DeleteTaxRatePolicyOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteTaxRatePolicyOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteTaxRatePolicyOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteTaxRatePolicyOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideWithoutTransactionIdCommand,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyOverridePage.DownloadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyOverridePage.UploadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (
        taxPolicyOverrideSubType === null ||
        taxPolicyOverrideSubType === undefined
      )
        throw new Error(
          "The parameter 'taxPolicyOverrideSubType' cannot be null.",
        );
      else
        content_.append(
          'TaxPolicyOverrideSubType',
          taxPolicyOverrideSubType.toString(),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxPolicyMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxPolicyMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    checkTaxRateOverrideDuplicateData(
      command: CheckTaxRateOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckTaxRateOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxRatePolicyOverridePage.CheckTaxRateOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckTaxRateOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckTaxRateOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckTaxRateOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckTaxRateOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckTaxRateOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckTaxRateOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckTaxRateOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckTaxRateOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckTaxRateOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISocialTaxPolicyOverridePageService {
    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetSocialTaxPolicyOverridePageDataQueryResultSuccess>;
    upsertSocialTaxPolicyOverrideSettings(
      command: UpsertSocialTaxPolicyOverrideSettingsCommand,
    ): Observable<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess>;
    deleteSocialTaxPolicyOverrideSettings(
      command: DeleteSocialTaxPolicyOverrideCommand,
    ): Observable<DeleteSocialTaxPolicyOverrideCommandResultSuccess>;
    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideWithoutTransactionIdCommand,
    ): Observable<string>;
    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
    checkSocialTaxOverrideDuplicateData(
      command: CheckSocialTaxOverrideDuplicateDataCommand,
    ): Observable<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SocialTaxPolicyOverridePageService
    extends ApiBase
    implements ISocialTaxPolicyOverridePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSocialTaxPolicyOverridePageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/SocialTaxPolicyOverridePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSocialTaxPolicyOverridePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSocialTaxPolicyOverridePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSocialTaxPolicyOverridePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSocialTaxPolicyOverridePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSocialTaxPolicyOverridePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSocialTaxPolicyOverridePageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertSocialTaxPolicyOverrideSettings(
      command: UpsertSocialTaxPolicyOverrideSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyOverridePage.UpsertSocialTaxPolicyOverrideSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertSocialTaxPolicyOverrideSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertSocialTaxPolicyOverrideSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertSocialTaxPolicyOverrideSettings(
      response: HttpResponseBase,
    ): Observable<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertSocialTaxPolicyOverrideSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess>(
        null as any,
      );
    }

    deleteSocialTaxPolicyOverrideSettings(
      command: DeleteSocialTaxPolicyOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteSocialTaxPolicyOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyOverridePage.DeleteSocialTaxPolicyOverrideSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteSocialTaxPolicyOverrideSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteSocialTaxPolicyOverrideSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteSocialTaxPolicyOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteSocialTaxPolicyOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteSocialTaxPolicyOverrideSettings(
      response: HttpResponseBase,
    ): Observable<DeleteSocialTaxPolicyOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteSocialTaxPolicyOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteSocialTaxPolicyOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteSocialTaxPolicyOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideWithoutTransactionIdCommand,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyOverridePage.DownloadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyOverridePage.UploadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (
        taxPolicyOverrideSubType === null ||
        taxPolicyOverrideSubType === undefined
      )
        throw new Error(
          "The parameter 'taxPolicyOverrideSubType' cannot be null.",
        );
      else
        content_.append(
          'TaxPolicyOverrideSubType',
          taxPolicyOverrideSubType.toString(),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxPolicyMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxPolicyMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    checkSocialTaxOverrideDuplicateData(
      command: CheckSocialTaxOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyOverridePage.CheckSocialTaxOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckSocialTaxOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckSocialTaxOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckSocialTaxOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckSocialTaxOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckSocialTaxOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckSocialTaxOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISocialTaxOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetSocialTaxOverridesIndexPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SocialTaxOverridesIndexPageService
    extends ApiBase
    implements ISocialTaxOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSocialTaxOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/SocialTaxOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSocialTaxOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSocialTaxOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSocialTaxOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSocialTaxOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSocialTaxOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSocialTaxOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRechargeOverridesPageService {
    getRechargeOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetRechargeOverridesPageDataQueryResultSuccess>;
    upsertRechargeOverride(
      command: UpsertRechargeOverrideCommand,
    ): Observable<UpsertRechargeOverrideCommandResultSuccess>;
    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
    ): Observable<string>;
    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
    deleteRechargeOverride(
      command: DeleteRechargeOverrideCommand,
    ): Observable<DeleteRechargeOverrideCommandResultSuccess>;
    checkRechargeOverrideDuplicateData(
      command: CheckRechargeOverrideDuplicateDataCommand,
    ): Observable<CheckRechargeOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RechargeOverridesPageService
    extends ApiBase
    implements IRechargeOverridesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getRechargeOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRechargeOverridesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.GetRechargeOverridesPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetRechargeOverridesPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRechargeOverridesPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRechargeOverridesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRechargeOverridesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetRechargeOverridesPageData(
      response: HttpResponseBase,
    ): Observable<GetRechargeOverridesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRechargeOverridesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRechargeOverridesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRechargeOverridesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertRechargeOverride(
      command: UpsertRechargeOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRechargeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.UpsertRechargeOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRechargeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRechargeOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRechargeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRechargeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRechargeOverride(
      response: HttpResponseBase,
    ): Observable<UpsertRechargeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRechargeOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRechargeOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRechargeOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.DownloadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.UploadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (
        taxPolicyOverrideSubType === null ||
        taxPolicyOverrideSubType === undefined
      )
        throw new Error(
          "The parameter 'taxPolicyOverrideSubType' cannot be null.",
        );
      else
        content_.append(
          'TaxPolicyOverrideSubType',
          taxPolicyOverrideSubType.toString(),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxPolicyMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxPolicyMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    deleteRechargeOverride(
      command: DeleteRechargeOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteRechargeOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.DeleteRechargeOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteRechargeOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteRechargeOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteRechargeOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteRechargeOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteRechargeOverride(
      response: HttpResponseBase,
    ): Observable<DeleteRechargeOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteRechargeOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteRechargeOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteRechargeOverrideCommandResultSuccess>(
        null as any,
      );
    }

    checkRechargeOverrideDuplicateData(
      command: CheckRechargeOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckRechargeOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeOverridesPage.CheckRechargeOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckRechargeOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckRechargeOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckRechargeOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckRechargeOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckRechargeOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckRechargeOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckRechargeOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckRechargeOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckRechargeOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRechargeOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRechargeOverridesIndexPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RechargeOverridesIndexPageService
    extends ApiBase
    implements IRechargeOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRechargeOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RechargeOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRechargeOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRechargeOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRechargeOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRechargeOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRechargeOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRechargeOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IDoubleTaxReliefOverridePageService {
    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
    upsertDoubleTaxReliefPolicyOverrideSettings(
      command: UpsertDoubleTaxReliefPolicyOverrideSettingsCommand,
    ): Observable<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess>;
    deleteDoubleTaxReliefPolicyOverrideSetting(
      command: DeleteDoubleTaxReliefPolicyOverrideCommand,
    ): Observable<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess>;
    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
    ): Observable<string>;
    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
    checkDoubleTaxReliefOverrideDuplicateData(
      command: CheckDoubleTaxReliefOverrideDuplicateDataCommand,
    ): Observable<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class DoubleTaxReliefOverridePageService
    extends ApiBase
    implements IDoubleTaxReliefOverridePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DoubleTaxReliefOverridePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDoubleTaxReliefPolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDoubleTaxReliefPolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertDoubleTaxReliefPolicyOverrideSettings(
      command: UpsertDoubleTaxReliefPolicyOverrideSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridePage.UpsertDoubleTaxReliefPolicyOverrideSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertDoubleTaxReliefPolicyOverrideSettings(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertDoubleTaxReliefPolicyOverrideSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertDoubleTaxReliefPolicyOverrideSettings(
      response: HttpResponseBase,
    ): Observable<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess>(
        null as any,
      );
    }

    deleteDoubleTaxReliefPolicyOverrideSetting(
      command: DeleteDoubleTaxReliefPolicyOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridePage.DeleteDoubleTaxReliefPolicyOverrideSetting';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteDoubleTaxReliefPolicyOverrideSetting(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteDoubleTaxReliefPolicyOverrideSetting(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteDoubleTaxReliefPolicyOverrideSetting(
      response: HttpResponseBase,
    ): Observable<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteDoubleTaxReliefPolicyOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridePage.DownloadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridePage.UploadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (
        taxPolicyOverrideSubType === null ||
        taxPolicyOverrideSubType === undefined
      )
        throw new Error(
          "The parameter 'taxPolicyOverrideSubType' cannot be null.",
        );
      else
        content_.append(
          'TaxPolicyOverrideSubType',
          taxPolicyOverrideSubType.toString(),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxPolicyMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxPolicyMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    checkDoubleTaxReliefOverrideDuplicateData(
      command: CheckDoubleTaxReliefOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridePage.CheckDoubleTaxReliefOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckDoubleTaxReliefOverrideDuplicateData(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckDoubleTaxReliefOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckDoubleTaxReliefOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IDoubleTaxReliefOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class DoubleTaxReliefOverridesIndexPageService
    extends ApiBase
    implements IDoubleTaxReliefOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICashPaymentOverridesPageService {
    getCashPaymentOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
    ): Observable<GetCashPaymentOverridesPageDataQueryResultSuccess>;
    upsertCashPaymentOverride(
      command: UpsertCashPaymentOverrideCommand,
    ): Observable<UpsertCashPaymentOverrideCommandResultSuccess>;
    deleteCashPaymentOverride(
      command: DeleteCashPaymentOverrideCommand,
    ): Observable<DeleteCashPaymentOverrideCommandResultSuccess>;
    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
    ): Observable<string>;
    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
    checkCashPaymentOverrideDuplicateData(
      command: CheckCashPaymentOverrideDuplicateDataCommand,
    ): Observable<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CashPaymentOverridesPageService
    extends ApiBase
    implements ICashPaymentOverridesPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCashPaymentOverridesPageData(
      clientId?: string | undefined,
      id?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCashPaymentOverridesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.GetCashPaymentOverridesPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id !== undefined && id !== null)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCashPaymentOverridesPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCashPaymentOverridesPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCashPaymentOverridesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCashPaymentOverridesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetCashPaymentOverridesPageData(
      response: HttpResponseBase,
    ): Observable<GetCashPaymentOverridesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCashPaymentOverridesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCashPaymentOverridesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCashPaymentOverridesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertCashPaymentOverride(
      command: UpsertCashPaymentOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCashPaymentOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.UpsertCashPaymentOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertCashPaymentOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertCashPaymentOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCashPaymentOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCashPaymentOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertCashPaymentOverride(
      response: HttpResponseBase,
    ): Observable<UpsertCashPaymentOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCashPaymentOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCashPaymentOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCashPaymentOverrideCommandResultSuccess>(
        null as any,
      );
    }

    deleteCashPaymentOverride(
      command: DeleteCashPaymentOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteCashPaymentOverrideCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.DeleteCashPaymentOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteCashPaymentOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteCashPaymentOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteCashPaymentOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteCashPaymentOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteCashPaymentOverride(
      response: HttpResponseBase,
    ): Observable<DeleteCashPaymentOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteCashPaymentOverrideCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteCashPaymentOverrideCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteCashPaymentOverrideCommandResultSuccess>(
        null as any,
      );
    }

    downloadTaxPolicyMultipleOverrideFile(
      command: DownloadMultipleOverrideFileCommand2,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.DownloadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadTaxPolicyMultipleOverrideFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      taxPolicyOverrideSubType?: OverrideSubType | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.UploadTaxPolicyMultipleOverrideFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );
      if (
        taxPolicyOverrideSubType === null ||
        taxPolicyOverrideSubType === undefined
      )
        throw new Error(
          "The parameter 'taxPolicyOverrideSubType' cannot be null.",
        );
      else
        content_.append(
          'TaxPolicyOverrideSubType',
          taxPolicyOverrideSubType.toString(),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxPolicyMultipleOverrideFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxPolicyMultipleOverrideFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxPolicyMultipleOverrideFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxPolicyMultipleOverrideFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxPolicyMultipleOverrideFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxPolicyMultipleOverrideFileCommandResultSuccess>(
        null as any,
      );
    }

    checkCashPaymentOverrideDuplicateData(
      command: CheckCashPaymentOverrideDuplicateDataCommand,
      httpContext?: HttpContext,
    ): Observable<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesPage.CheckCashPaymentOverrideDuplicateData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckCashPaymentOverrideDuplicateData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckCashPaymentOverrideDuplicateData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess>;
          }),
        );
    }

    protected processCheckCashPaymentOverrideDuplicateData(
      response: HttpResponseBase,
    ): Observable<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckCashPaymentOverrideDuplicateDataCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckCashPaymentOverrideDuplicateDataCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckCashPaymentOverrideDuplicateDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICashPaymentOverridesIndexPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetCashPaymentOverridesIndexPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CashPaymentOverridesIndexPageService
    extends ApiBase
    implements ICashPaymentOverridesIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCashPaymentOverridesIndexPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentOverridesIndexPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCashPaymentOverridesIndexPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCashPaymentOverridesIndexPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCashPaymentOverridesIndexPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCashPaymentOverridesIndexPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCashPaymentOverridesIndexPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCashPaymentOverridesIndexPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxAdjustmentsPageService {
    getTaxAdjustmentsData(
      clientId?: string | undefined,
    ): Observable<GetTaxAdjustmentDataQueryResultSuccess>;
    upsertTaxAdjustment(
      command: UpsertTaxAdjustmentCommand,
    ): Observable<UpsertTaxAdjustmentCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxAdjustmentsPageService
    extends ApiBase
    implements ITaxAdjustmentsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getTaxAdjustmentsData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxAdjustmentDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxAdjustmentsPage.GetTaxAdjustmentsData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetTaxAdjustmentsData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTaxAdjustmentsData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxAdjustmentDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxAdjustmentDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetTaxAdjustmentsData(
      response: HttpResponseBase,
    ): Observable<GetTaxAdjustmentDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxAdjustmentDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxAdjustmentDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxAdjustmentDataQueryResultSuccess>(null as any);
    }

    upsertTaxAdjustment(
      command: UpsertTaxAdjustmentCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTaxAdjustmentCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxAdjustmentsPage.UpsertTaxAdjustment';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertTaxAdjustment(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertTaxAdjustment(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTaxAdjustmentCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTaxAdjustmentCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertTaxAdjustment(
      response: HttpResponseBase,
    ): Observable<UpsertTaxAdjustmentCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTaxAdjustmentCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTaxAdjustmentCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTaxAdjustmentCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITaxableConsiderationPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetTaxableConsiderationPageDataQueryResultSuccess>;
    upsertTaxableConsiderationSettings(
      command: UpsertTaxableConsiderationSettingsCommand,
    ): Observable<UpsertTaxableConsiderationSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxableConsiderationPageService
    extends ApiBase
    implements ITaxableConsiderationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTaxableConsiderationPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/TaxableConsiderationPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTaxableConsiderationPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTaxableConsiderationPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetTaxableConsiderationPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTaxableConsiderationPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTaxableConsiderationPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTaxableConsiderationPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertTaxableConsiderationSettings(
      command: UpsertTaxableConsiderationSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertTaxableConsiderationSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxableConsiderationPage.UpsertTaxableConsiderationSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertTaxableConsiderationSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertTaxableConsiderationSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertTaxableConsiderationSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertTaxableConsiderationSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertTaxableConsiderationSettings(
      response: HttpResponseBase,
    ): Observable<UpsertTaxableConsiderationSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertTaxableConsiderationSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertTaxableConsiderationSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertTaxableConsiderationSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISocialTaxRatePolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetSocialTaxRatePolicyPageDataQueryResultSuccess>;
    upsertSocialTaxRatePolicySettings(
      command: UpsertSocialTaxRatePolicySettingsCommand,
    ): Observable<UpsertSocialTaxRatePolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SocialTaxRatePolicyPageService
    extends ApiBase
    implements ISocialTaxRatePolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSocialTaxRatePolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/SocialTaxRatePolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSocialTaxRatePolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSocialTaxRatePolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSocialTaxRatePolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSocialTaxRatePolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSocialTaxRatePolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSocialTaxRatePolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertSocialTaxRatePolicySettings(
      command: UpsertSocialTaxRatePolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertSocialTaxRatePolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxRatePolicyPage.UpsertSocialTaxRatePolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertSocialTaxRatePolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertSocialTaxRatePolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertSocialTaxRatePolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertSocialTaxRatePolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertSocialTaxRatePolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertSocialTaxRatePolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertSocialTaxRatePolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertSocialTaxRatePolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertSocialTaxRatePolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISocialTaxPolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetSocialTaxPolicyPageDataQueryResultSuccess>;
    upsertSocialTaxPolicySettings(
      command: UpsertSocialTaxPolicySettingsCommand,
    ): Observable<UpsertSocialTaxPolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SocialTaxPolicyPageService
    extends ApiBase
    implements ISocialTaxPolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSocialTaxPolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/SocialTaxPolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSocialTaxPolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSocialTaxPolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSocialTaxPolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSocialTaxPolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSocialTaxPolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSocialTaxPolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertSocialTaxPolicySettings(
      command: UpsertSocialTaxPolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertSocialTaxPolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SocialTaxPolicyPage.UpsertSocialTaxPolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertSocialTaxPolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertSocialTaxPolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertSocialTaxPolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertSocialTaxPolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertSocialTaxPolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertSocialTaxPolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertSocialTaxPolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertSocialTaxPolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertSocialTaxPolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ISetupByCountryPageService {
    getPageData(
      clientId?: string | undefined,
      planType?: PlanType | undefined,
    ): Observable<GetSetupByCountryPageDataQueryResultSuccess>;
    saveCountryPlanAutomationSettings(
      command: SaveCountryPlanAutomationSettingsCommand,
    ): Observable<SaveCountryPlanAutomationSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class SetupByCountryPageService
    extends ApiBase
    implements ISetupByCountryPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      planType?: PlanType | undefined,
      httpContext?: HttpContext,
    ): Observable<GetSetupByCountryPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/SetupByCountryPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (planType === null)
        throw new Error("The parameter 'planType' cannot be null.");
      else if (planType !== undefined)
        url_ += 'PlanType=' + encodeURIComponent('' + planType) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetSetupByCountryPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetSetupByCountryPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetSetupByCountryPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetSetupByCountryPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetSetupByCountryPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetSetupByCountryPageDataQueryResultSuccess>(
        null as any,
      );
    }

    saveCountryPlanAutomationSettings(
      command: SaveCountryPlanAutomationSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCountryPlanAutomationSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/SetupByCountryPage.SaveCountryPlanAutomationSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCountryPlanAutomationSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCountryPlanAutomationSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCountryPlanAutomationSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCountryPlanAutomationSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCountryPlanAutomationSettings(
      response: HttpResponseBase,
    ): Observable<SaveCountryPlanAutomationSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCountryPlanAutomationSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCountryPlanAutomationSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCountryPlanAutomationSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IResidencyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetResidencyPageDataQueryResultSuccess>;
    upsertResidencySettings(
      command: UpsertResidencySettingsCommand,
    ): Observable<UpsertResidencySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ResidencyPageService
    extends ApiBase
    implements IResidencyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetResidencyPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/ResidencyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetResidencyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetResidencyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetResidencyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetResidencyPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetResidencyPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetResidencyPageDataQueryResultSuccess>(null as any);
    }

    upsertResidencySettings(
      command: UpsertResidencySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertResidencySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ResidencyPage.UpsertResidencySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertResidencySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertResidencySettings(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertResidencySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertResidencySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertResidencySettings(
      response: HttpResponseBase,
    ): Observable<UpsertResidencySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertResidencySettingsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertResidencySettingsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertResidencySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IReportingService {
    getClientTeam(
      clientId?: string | undefined,
    ): Observable<GetClientTeamQueryResultSuccess>;
    getCountryFootprint(
      clientId?: string | undefined,
    ): Observable<GetCountryFootprintQueryResultSuccess>;
    getEngagementRoles(
      query?: GetEngagementRolesQuery | undefined,
    ): Observable<GetEngagementRolesQueryResultSuccess>;
    getPlans(
      clientId?: string | undefined,
    ): Observable<GetPlansQueryResultSuccess>;
    getDeloitteTeamMemberRole(
      clientId?: string | undefined,
    ): Observable<GetDeloitteTeamMemberRoleQueryResultSuccess>;
    getBatchIds(
      clientId?: string | undefined,
    ): Observable<GetBatchIdsQueryResultSuccess>;
    searchBatchIds(
      command: SearchBatchIdsCommand,
    ): Observable<SearchBatchIdsCommandResultSuccess>;
    getReportCriteriaIds(
      clientId?: string | undefined,
      numberOfLatestBatches?: number | undefined,
    ): Observable<GetReportCriteraIdsQueryResultSuccess>;
    searchReportCriteriaIds(
      query: SearchReportCriteriaIdsQuery,
    ): Observable<SearchReportCriteriaIdsQueryResultSuccess>;
    getEmployeePopulation(
      clientId?: string | undefined,
    ): Observable<GetEmployeePopulationQueryResultSuccess>;
    getLimitedClientIds(
      clientId?: string | undefined,
    ): Observable<GetLimitedClientIdsQueryResultSuccess>;
    getClientByPortalId(
      clientPortalId?: string | undefined,
      doCrossEnvLookUp?: boolean | null | undefined,
    ): Observable<GetClientByPortalIdQueryandResultSuccess>;
    getClientByOrgId(
      clientId?: string | undefined,
    ): Observable<GetClientByOrgIdQueryResultSuccess>;
    getCalculationIdsForBatch(
      batchId?: string | undefined,
    ): Observable<GetCalculationIdsByBatchIdQueryResultSuccess>;
    getCompany(
      getCompanyQuery?: GetCompanyQuery | undefined,
    ): Observable<GetCompanyQueryResultSuccess>;
    getCustomTaxesForClient(
      clientId?: string | undefined,
    ): Observable<GetCustomTaxesQueryResultSuccess>;
    getClientPortalIdFromOrgId(
      clientId?: string | undefined,
    ): Observable<GetClientPortalIdFromOrgIdQueryResultSuccess>;
    getCustomTaxTypeDescriptionsFromOrgId(
      command: GetCustomTaxTypeDescriptionsFromOrgIdCommand,
    ): Observable<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ReportingService extends ApiBase implements IReportingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientTeam(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientTeamQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetClientTeam?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientTeam(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientTeam(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientTeamQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientTeamQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientTeam(
      response: HttpResponseBase,
    ): Observable<GetClientTeamQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientTeamQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetClientTeamQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientTeamQueryResultSuccess>(null as any);
    }

    getCountryFootprint(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryFootprintQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetCountryFootprint?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCountryFootprint(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCountryFootprint(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryFootprintQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryFootprintQueryResultSuccess>;
          }),
        );
    }

    protected processGetCountryFootprint(
      response: HttpResponseBase,
    ): Observable<GetCountryFootprintQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryFootprintQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryFootprintQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryFootprintQueryResultSuccess>(null as any);
    }

    getEngagementRoles(
      query?: GetEngagementRolesQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEngagementRolesQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetEngagementRoles?';
      if (query === null)
        throw new Error("The parameter 'query' cannot be null.");
      else if (query !== undefined)
        url_ += 'query=' + encodeURIComponent('' + query) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetEngagementRoles(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetEngagementRoles(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEngagementRolesQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEngagementRolesQueryResultSuccess>;
          }),
        );
    }

    protected processGetEngagementRoles(
      response: HttpResponseBase,
    ): Observable<GetEngagementRolesQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEngagementRolesQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEngagementRolesQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEngagementRolesQueryResultSuccess>(null as any);
    }

    getPlans(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPlansQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetPlans?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPlans(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPlans(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPlansQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPlansQueryResultSuccess>;
          }),
        );
    }

    protected processGetPlans(
      response: HttpResponseBase,
    ): Observable<GetPlansQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlansQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetPlansQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPlansQueryResultSuccess>(null as any);
    }

    getDeloitteTeamMemberRole(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDeloitteTeamMemberRoleQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.GetDeloitteTeamMemberRole?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDeloitteTeamMemberRole(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDeloitteTeamMemberRole(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeloitteTeamMemberRoleQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeloitteTeamMemberRoleQueryResultSuccess>;
          }),
        );
    }

    protected processGetDeloitteTeamMemberRole(
      response: HttpResponseBase,
    ): Observable<GetDeloitteTeamMemberRoleQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeloitteTeamMemberRoleQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeloitteTeamMemberRoleQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeloitteTeamMemberRoleQueryResultSuccess>(
        null as any,
      );
    }

    getBatchIds(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchIdsQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetBatchIds?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchIdsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchIdsQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchIds(
      response: HttpResponseBase,
    ): Observable<GetBatchIdsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBatchIdsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetBatchIdsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchIdsQueryResultSuccess>(null as any);
    }

    searchBatchIds(
      command: SearchBatchIdsCommand,
      httpContext?: HttpContext,
    ): Observable<SearchBatchIdsCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.SearchBatchIds';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchBatchIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchBatchIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchBatchIdsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchBatchIdsCommandResultSuccess>;
          }),
        );
    }

    protected processSearchBatchIds(
      response: HttpResponseBase,
    ): Observable<SearchBatchIdsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchBatchIdsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchBatchIdsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchBatchIdsCommandResultSuccess>(null as any);
    }

    getReportCriteriaIds(
      clientId?: string | undefined,
      numberOfLatestBatches?: number | undefined,
      httpContext?: HttpContext,
    ): Observable<GetReportCriteraIdsQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetReportCriteriaIds?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (numberOfLatestBatches === null)
        throw new Error(
          "The parameter 'numberOfLatestBatches' cannot be null.",
        );
      else if (numberOfLatestBatches !== undefined)
        url_ +=
          'NumberOfLatestBatches=' +
          encodeURIComponent('' + numberOfLatestBatches) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetReportCriteriaIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetReportCriteriaIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetReportCriteraIdsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetReportCriteraIdsQueryResultSuccess>;
          }),
        );
    }

    protected processGetReportCriteriaIds(
      response: HttpResponseBase,
    ): Observable<GetReportCriteraIdsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetReportCriteraIdsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetReportCriteraIdsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetReportCriteraIdsQueryResultSuccess>(null as any);
    }

    searchReportCriteriaIds(
      query: SearchReportCriteriaIdsQuery,
      httpContext?: HttpContext,
    ): Observable<SearchReportCriteriaIdsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.SearchReportCriteriaIds';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(query);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchReportCriteriaIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchReportCriteriaIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchReportCriteriaIdsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchReportCriteriaIdsQueryResultSuccess>;
          }),
        );
    }

    protected processSearchReportCriteriaIds(
      response: HttpResponseBase,
    ): Observable<SearchReportCriteriaIdsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchReportCriteriaIdsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchReportCriteriaIdsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchReportCriteriaIdsQueryResultSuccess>(
        null as any,
      );
    }

    getEmployeePopulation(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEmployeePopulationQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.GetEmployeePopulation?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetEmployeePopulation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetEmployeePopulation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEmployeePopulationQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEmployeePopulationQueryResultSuccess>;
          }),
        );
    }

    protected processGetEmployeePopulation(
      response: HttpResponseBase,
    ): Observable<GetEmployeePopulationQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEmployeePopulationQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEmployeePopulationQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEmployeePopulationQueryResultSuccess>(
        null as any,
      );
    }

    getLimitedClientIds(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetLimitedClientIdsQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetLimitedClientIds?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetLimitedClientIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetLimitedClientIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetLimitedClientIdsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetLimitedClientIdsQueryResultSuccess>;
          }),
        );
    }

    protected processGetLimitedClientIds(
      response: HttpResponseBase,
    ): Observable<GetLimitedClientIdsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetLimitedClientIdsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetLimitedClientIdsResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetLimitedClientIdsQueryResultSuccess>(null as any);
    }

    getClientByPortalId(
      clientPortalId?: string | undefined,
      doCrossEnvLookUp?: boolean | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientByPortalIdQueryandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetClientByPortalId?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (doCrossEnvLookUp !== undefined && doCrossEnvLookUp !== null)
        url_ +=
          'DoCrossEnvLookUp=' + encodeURIComponent('' + doCrossEnvLookUp) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientByPortalId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientByPortalId(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientByPortalIdQueryandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientByPortalIdQueryandResultSuccess>;
          }),
        );
    }

    protected processGetClientByPortalId(
      response: HttpResponseBase,
    ): Observable<GetClientByPortalIdQueryandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientByPortalIdQueryandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientByPortalIdQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientByPortalIdQueryandResultSuccess>(
        null as any,
      );
    }

    getClientByOrgId(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientByOrgIdQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetClientByOrgId?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientByOrgId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientByOrgId(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientByOrgIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientByOrgIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientByOrgId(
      response: HttpResponseBase,
    ): Observable<GetClientByOrgIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientByOrgIdQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientByOrgIdQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientByOrgIdQueryResultSuccess>(null as any);
    }

    getCalculationIdsForBatch(
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationIdsByBatchIdQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.GetCalculationIdsForBatch?';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationIdsForBatch(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationIdsForBatch(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationIdsByBatchIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationIdsByBatchIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationIdsForBatch(
      response: HttpResponseBase,
    ): Observable<GetCalculationIdsByBatchIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationIdsByBatchIdQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationIdsByBatchIdQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationIdsByBatchIdQueryResultSuccess>(
        null as any,
      );
    }

    getCompany(
      getCompanyQuery?: GetCompanyQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCompanyQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Reporting.GetCompany?';
      if (getCompanyQuery === null)
        throw new Error("The parameter 'getCompanyQuery' cannot be null.");
      else if (getCompanyQuery !== undefined)
        url_ +=
          'getCompanyQuery=' + encodeURIComponent('' + getCompanyQuery) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCompany(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCompany(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCompanyQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCompanyQueryResultSuccess>;
          }),
        );
    }

    protected processGetCompany(
      response: HttpResponseBase,
    ): Observable<GetCompanyQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetCompanyQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCompanyQueryResultSuccess>(null as any);
    }

    getCustomTaxesForClient(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCustomTaxesQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.GetCustomTaxesForClient?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCustomTaxesForClient(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCustomTaxesForClient(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCustomTaxesQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCustomTaxesQueryResultSuccess>;
          }),
        );
    }

    protected processGetCustomTaxesForClient(
      response: HttpResponseBase,
    ): Observable<GetCustomTaxesQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomTaxesQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetCustomTaxesQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCustomTaxesQueryResultSuccess>(null as any);
    }

    getClientPortalIdFromOrgId(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientPortalIdFromOrgIdQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Reporting.GetClientPortalIdFromOrgId?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientPortalIdFromOrgId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientPortalIdFromOrgId(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientPortalIdFromOrgIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientPortalIdFromOrgIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientPortalIdFromOrgId(
      response: HttpResponseBase,
    ): Observable<GetClientPortalIdFromOrgIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientPortalIdFromOrgIdQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientPortalIdFromOrgIdQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientPortalIdFromOrgIdQueryResultSuccess>(
        null as any,
      );
    }

    getCustomTaxTypeDescriptionsFromOrgId(
      command: GetCustomTaxTypeDescriptionsFromOrgIdCommand,
      httpContext?: HttpContext,
    ): Observable<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/Reporting.GetCustomTaxTypeDescriptionsFromOrgId';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCustomTaxTypeDescriptionsFromOrgId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCustomTaxTypeDescriptionsFromOrgId(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess>;
          }),
        );
    }

    protected processGetCustomTaxTypeDescriptionsFromOrgId(
      response: HttpResponseBase,
    ): Observable<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IMyConfiguredReportsPageService {
    getDeletionStatusCounts(
      clientPortalId?: string | undefined,
    ): Observable<GetDeletionStatusCountsQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class MyConfiguredReportsPageService
    extends ApiBase
    implements IMyConfiguredReportsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getDeletionStatusCounts(
      clientPortalId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDeletionStatusCountsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/MyConfiguredReportsPage.GetDeletionStatusCounts?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDeletionStatusCounts(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDeletionStatusCounts(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeletionStatusCountsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeletionStatusCountsQueryResultSuccess>;
          }),
        );
    }

    protected processGetDeletionStatusCounts(
      response: HttpResponseBase,
    ): Observable<GetDeletionStatusCountsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeletionStatusCountsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeletionStatusCountsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeletionStatusCountsQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRegionTaxRatePolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRegionTaxRatePolicyPageDataQueryResultSuccess>;
    upsertRegionTaxRatePolicySettings(
      command: UpsertRegionTaxRatePolicySettingsCommand,
    ): Observable<UpsertRegionTaxRatePolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RegionTaxRatePolicyPageService
    extends ApiBase
    implements IRegionTaxRatePolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRegionTaxRatePolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RegionTaxRatePolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionTaxRatePolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionTaxRatePolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRegionTaxRatePolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionTaxRatePolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionTaxRatePolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionTaxRatePolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertRegionTaxRatePolicySettings(
      command: UpsertRegionTaxRatePolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRegionTaxRatePolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionTaxRatePolicyPage.UpsertRegionTaxRatePolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRegionTaxRatePolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRegionTaxRatePolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRegionTaxRatePolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRegionTaxRatePolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRegionTaxRatePolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertRegionTaxRatePolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRegionTaxRatePolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRegionTaxRatePolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRegionTaxRatePolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRegionDoubleTaxReliefPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
    upsertRegionDoubleTaxReliefPolicySettings(
      command: UpsertRegionDoubleTaxReliefPolicySettingsCommand,
    ): Observable<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RegionDoubleTaxReliefPageService
    extends ApiBase
    implements IRegionDoubleTaxReliefPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RegionDoubleTaxReliefPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertRegionDoubleTaxReliefPolicySettings(
      command: UpsertRegionDoubleTaxReliefPolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RegionDoubleTaxReliefPage.UpsertRegionDoubleTaxReliefPolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRegionDoubleTaxReliefPolicySettings(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRegionDoubleTaxReliefPolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRegionDoubleTaxReliefPolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRechargePolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetRechargePolicyPageDataQueryResultSuccess>;
    upsertRechargePolicySettings(
      command: UpsertRechargePolicySettingsCommand,
    ): Observable<UpsertRechargePolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RechargePolicyPageService
    extends ApiBase
    implements IRechargePolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRechargePolicyPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/RechargePolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRechargePolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRechargePolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetRechargePolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRechargePolicyPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRechargePolicyPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRechargePolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertRechargePolicySettings(
      command: UpsertRechargePolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRechargePolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargePolicyPage.UpsertRechargePolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRechargePolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRechargePolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRechargePolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRechargePolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRechargePolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertRechargePolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRechargePolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRechargePolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRechargePolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRechargeCountryAmountsService {
    upsertRechargePolicySettings(
      command: UpsertRechargeCountryAmountSettingsCommand,
    ): Observable<UpsertRechargeCountryAmountSettingsCommandResultSuccess>;
    getRechargeCountryAmountPageData(
      clientId?: string | undefined,
      rechargeCountryAmountSettingsId?: string | null | undefined,
    ): Observable<GetRechargeCountryAmountPageDataQueryResultSuccess>;
    getRechargeCountryAmounts(
      clientId?: string | undefined,
    ): Observable<GetRechargeCountryAmountsQueryResultSuccess>;
    deleteRechargePolicySetting(
      command: DeleteRechargeCountryAmountSettingsCommand,
    ): Observable<DeleteRechargeCountryAmountSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RechargeCountryAmountsService
    extends ApiBase
    implements IRechargeCountryAmountsService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    upsertRechargePolicySettings(
      command: UpsertRechargeCountryAmountSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertRechargeCountryAmountSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeCountryAmounts.UpsertRechargePolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertRechargePolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertRechargePolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertRechargeCountryAmountSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertRechargeCountryAmountSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertRechargePolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertRechargeCountryAmountSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertRechargeCountryAmountSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertRechargeCountryAmountSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertRechargeCountryAmountSettingsCommandResultSuccess>(
        null as any,
      );
    }

    getRechargeCountryAmountPageData(
      clientId?: string | undefined,
      rechargeCountryAmountSettingsId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRechargeCountryAmountPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeCountryAmounts.GetRechargeCountryAmountPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (
        rechargeCountryAmountSettingsId !== undefined &&
        rechargeCountryAmountSettingsId !== null
      )
        url_ +=
          'RechargeCountryAmountSettingsId=' +
          encodeURIComponent('' + rechargeCountryAmountSettingsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetRechargeCountryAmountPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRechargeCountryAmountPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRechargeCountryAmountPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRechargeCountryAmountPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetRechargeCountryAmountPageData(
      response: HttpResponseBase,
    ): Observable<GetRechargeCountryAmountPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRechargeCountryAmountPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRechargeCountryAmountPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRechargeCountryAmountPageDataQueryResultSuccess>(
        null as any,
      );
    }

    getRechargeCountryAmounts(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRechargeCountryAmountsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeCountryAmounts.GetRechargeCountryAmounts?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetRechargeCountryAmounts(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRechargeCountryAmounts(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRechargeCountryAmountsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRechargeCountryAmountsQueryResultSuccess>;
          }),
        );
    }

    protected processGetRechargeCountryAmounts(
      response: HttpResponseBase,
    ): Observable<GetRechargeCountryAmountsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRechargeCountryAmountsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRechargeCountryAmountsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRechargeCountryAmountsQueryResultSuccess>(
        null as any,
      );
    }

    deleteRechargePolicySetting(
      command: DeleteRechargeCountryAmountSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteRechargeCountryAmountSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RechargeCountryAmounts.DeleteRechargePolicySetting';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteRechargePolicySetting(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteRechargePolicySetting(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteRechargeCountryAmountSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteRechargeCountryAmountSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteRechargePolicySetting(
      response: HttpResponseBase,
    ): Observable<DeleteRechargeCountryAmountSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteRechargeCountryAmountSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteRechargeCountryAmountSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteRechargeCountryAmountSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IPrecisionPageService {
    getPrecisionPageData(
      clientId?: string | undefined,
    ): Observable<GetPrecisionPageDataQueryResultSuccess>;
    upsertPrecisionSettings(
      command: UpsertPrecisionSettingsCommand,
    ): Observable<UpsertPrecisionSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class PrecisionPageService
    extends ApiBase
    implements IPrecisionPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPrecisionPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPrecisionPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PrecisionPage.GetPrecisionPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPrecisionPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPrecisionPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPrecisionPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPrecisionPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPrecisionPageData(
      response: HttpResponseBase,
    ): Observable<GetPrecisionPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetPrecisionPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetPrecisionPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPrecisionPageDataQueryResultSuccess>(null as any);
    }

    upsertPrecisionSettings(
      command: UpsertPrecisionSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertPrecisionSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PrecisionPage.UpsertPrecisionSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertPrecisionSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertPrecisionSettings(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertPrecisionSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertPrecisionSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertPrecisionSettings(
      response: HttpResponseBase,
    ): Observable<UpsertPrecisionSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertPrecisionSettingsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertPrecisionSettingsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertPrecisionSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IPlanSetupPageService {
    getPlanSetupPageData(
      clientId?: string | undefined,
    ): Observable<GetPlanSetupPageDataQueryResultSuccess>;
    savePlanSetupDetails(
      clientId?: string | undefined,
    ): Observable<SavePlanSetupDetailsCommandResultSuccess>;
    addRsuPlanTypeDetails(
      command: AddRsuPlanTypeDetailsCommand,
    ): Observable<AddRsuPlanTypeDetailsCommandResultSuccess>;
    updateRsuPlanTypeDetails(
      command: UpdateRsuPlanTypeDetailsCommand,
    ): Observable<UpdateRsuPlanTypeDetailsCommandResultSuccess>;
    deleteRsuPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
    ): Observable<DeleteRsuPlanTypeDetailsCommandResultSuccess>;
    addStockOptionPlanTypeDetails(
      command: AddStockOptionPlanTypeDetailsCommand,
    ): Observable<AddStockOptionPlanTypeDetailsCommandResultSuccess>;
    updateStockOptionPlanTypeDetails(
      command: UpdateStockOptionPlanTypeDetailsCommand,
    ): Observable<UpdateStockOptionPlanTypeDetailsCommandResultSuccess>;
    deleteStockOptionPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
    ): Observable<DeleteStockOptionPlanTypeDetailsCommandResultSuccess>;
    addCashBonusPlanTypeDetails(
      command: AddCashBonusPlanTypeDetailsCommand,
    ): Observable<AddCashBonusPlanTypeDetailsCommandResultSuccess>;
    updateCashBonusPlanTypeDetails(
      command: UpdateCashBonusPlanTypeDetailsCommand,
    ): Observable<UpdateCashBonusPlanTypeDetailsCommandResultSuccess>;
    deleteCashBonusPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
    ): Observable<DeleteCashBonusPlanTypeDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class PlanSetupPageService
    extends ApiBase
    implements IPlanSetupPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPlanSetupPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPlanSetupPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PlanSetupPage.GetPlanSetupPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPlanSetupPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPlanSetupPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPlanSetupPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPlanSetupPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPlanSetupPageData(
      response: HttpResponseBase,
    ): Observable<GetPlanSetupPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetPlanSetupPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetPlanSetupPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPlanSetupPageDataQueryResultSuccess>(null as any);
    }

    savePlanSetupDetails(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<SavePlanSetupDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PlanSetupPage.SavePlanSetupDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSavePlanSetupDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSavePlanSetupDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SavePlanSetupDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SavePlanSetupDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSavePlanSetupDetails(
      response: HttpResponseBase,
    ): Observable<SavePlanSetupDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SavePlanSetupDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SavePlanSetupDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SavePlanSetupDetailsCommandResultSuccess>(
        null as any,
      );
    }

    addRsuPlanTypeDetails(
      command: AddRsuPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<AddRsuPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PlanSetupPage.AddRsuPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddRsuPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddRsuPlanTypeDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddRsuPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddRsuPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processAddRsuPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<AddRsuPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddRsuPlanTypeDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddRsuPlanTypeDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddRsuPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    updateRsuPlanTypeDetails(
      command: UpdateRsuPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateRsuPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PlanSetupPage.UpdateRsuPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateRsuPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateRsuPlanTypeDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateRsuPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateRsuPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateRsuPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<UpdateRsuPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateRsuPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateRsuPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateRsuPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    deleteRsuPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteRsuPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PlanSetupPage.DeleteRsuPlanTypeDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (planTypeDetailsId === null)
        throw new Error("The parameter 'planTypeDetailsId' cannot be null.");
      else if (planTypeDetailsId !== undefined)
        url_ +=
          'PlanTypeDetailsId=' +
          encodeURIComponent('' + planTypeDetailsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteRsuPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteRsuPlanTypeDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteRsuPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteRsuPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteRsuPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<DeleteRsuPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteRsuPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteRsuPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteRsuPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    addStockOptionPlanTypeDetails(
      command: AddStockOptionPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<AddStockOptionPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.AddStockOptionPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddStockOptionPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddStockOptionPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddStockOptionPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddStockOptionPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processAddStockOptionPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<AddStockOptionPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddStockOptionPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddStockOptionPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddStockOptionPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    updateStockOptionPlanTypeDetails(
      command: UpdateStockOptionPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateStockOptionPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.UpdateStockOptionPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateStockOptionPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateStockOptionPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateStockOptionPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateStockOptionPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateStockOptionPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<UpdateStockOptionPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateStockOptionPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateStockOptionPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateStockOptionPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    deleteStockOptionPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteStockOptionPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.DeleteStockOptionPlanTypeDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (planTypeDetailsId === null)
        throw new Error("The parameter 'planTypeDetailsId' cannot be null.");
      else if (planTypeDetailsId !== undefined)
        url_ +=
          'PlanTypeDetailsId=' +
          encodeURIComponent('' + planTypeDetailsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteStockOptionPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteStockOptionPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteStockOptionPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteStockOptionPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteStockOptionPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<DeleteStockOptionPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteStockOptionPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteStockOptionPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteStockOptionPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    addCashBonusPlanTypeDetails(
      command: AddCashBonusPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<AddCashBonusPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.AddCashBonusPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddCashBonusPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddCashBonusPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddCashBonusPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddCashBonusPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processAddCashBonusPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<AddCashBonusPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddCashBonusPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddCashBonusPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddCashBonusPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    updateCashBonusPlanTypeDetails(
      command: UpdateCashBonusPlanTypeDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateCashBonusPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.UpdateCashBonusPlanTypeDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateCashBonusPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateCashBonusPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateCashBonusPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateCashBonusPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateCashBonusPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<UpdateCashBonusPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateCashBonusPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateCashBonusPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateCashBonusPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }

    deleteCashBonusPlanTypeDetails(
      clientId?: string | undefined,
      planTypeDetailsId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteCashBonusPlanTypeDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PlanSetupPage.DeleteCashBonusPlanTypeDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (planTypeDetailsId === null)
        throw new Error("The parameter 'planTypeDetailsId' cannot be null.");
      else if (planTypeDetailsId !== undefined)
        url_ +=
          'PlanTypeDetailsId=' +
          encodeURIComponent('' + planTypeDetailsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteCashBonusPlanTypeDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteCashBonusPlanTypeDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteCashBonusPlanTypeDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteCashBonusPlanTypeDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteCashBonusPlanTypeDetails(
      response: HttpResponseBase,
    ): Observable<DeleteCashBonusPlanTypeDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteCashBonusPlanTypeDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteCashBonusPlanTypeDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteCashBonusPlanTypeDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IOverridesDashboardService {
    downloadExportOverridesFile(
      command: DownloadExportOverridesFileCommand,
    ): Observable<DownloadExportOverridesFileCommandResultSuccess>;
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetOverridesDashboardIndexQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class OverridesDashboardService
    extends ApiBase
    implements IOverridesDashboardService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    downloadExportOverridesFile(
      command: DownloadExportOverridesFileCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadExportOverridesFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/OverridesDashboard.DownloadExportOverridesFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadExportOverridesFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadExportOverridesFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadExportOverridesFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadExportOverridesFileCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadExportOverridesFile(
      response: HttpResponseBase,
    ): Observable<DownloadExportOverridesFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadExportOverridesFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadExportOverridesFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadExportOverridesFileCommandResultSuccess>(
        null as any,
      );
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetOverridesDashboardIndexQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/OverridesDashboard.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetOverridesDashboardIndexQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetOverridesDashboardIndexQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetOverridesDashboardIndexQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetOverridesDashboardIndexQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetOverridesDashboardIndexQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetOverridesDashboardIndexQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IMenuService {
    getPortalAppTiles(
      command?: GetPortalAppsDataQuery | undefined,
    ): Observable<GetPortalAppsDataQueryResultSuccess>;
    portalTileOrToolClickedResult(
      command: PortalTileOrToolClickedQuery,
    ): Observable<PortalTileOrToolClickedQueryResultSuccess>;
    postSAMLData(
      command: PostSAMLDataQuery,
    ): Observable<PostSAMLDataQueryResultSuccess>;
    postSAMLDataByProdId(
      command: PostSAMLDataByProdIdQuery,
    ): Observable<PostSAMLDataByProdIdQueryResultSuccess>;
    search(q: SearchCommand): Observable<GlobalSearchCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class MenuService extends ApiBase implements IMenuService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPortalAppTiles(
      command?: GetPortalAppsDataQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPortalAppsDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Menu.GetPortalAppTiles?';
      if (command === null)
        throw new Error("The parameter 'command' cannot be null.");
      else if (command !== undefined)
        url_ += 'command=' + encodeURIComponent('' + command) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPortalAppTiles(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPortalAppTiles(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPortalAppsDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPortalAppsDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPortalAppTiles(
      response: HttpResponseBase,
    ): Observable<GetPortalAppsDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetPortalAppsDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetPortalAppsDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPortalAppsDataQueryResultSuccess>(null as any);
    }

    portalTileOrToolClickedResult(
      command: PortalTileOrToolClickedQuery,
      httpContext?: HttpContext,
    ): Observable<PortalTileOrToolClickedQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/Menu.PortalTileOrToolClickedResult';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPortalTileOrToolClickedResult(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPortalTileOrToolClickedResult(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PortalTileOrToolClickedQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PortalTileOrToolClickedQueryResultSuccess>;
          }),
        );
    }

    protected processPortalTileOrToolClickedResult(
      response: HttpResponseBase,
    ): Observable<PortalTileOrToolClickedQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              PortalTileOrToolClickedQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              PortalTileOrToolClickedQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PortalTileOrToolClickedQueryResultSuccess>(
        null as any,
      );
    }

    postSAMLData(
      command: PostSAMLDataQuery,
      httpContext?: HttpContext,
    ): Observable<PostSAMLDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Menu.PostSAMLData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPostSAMLData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPostSAMLData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PostSAMLDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PostSAMLDataQueryResultSuccess>;
          }),
        );
    }

    protected processPostSAMLData(
      response: HttpResponseBase,
    ): Observable<PostSAMLDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostSAMLDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PostSAMLDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PostSAMLDataQueryResultSuccess>(null as any);
    }

    postSAMLDataByProdId(
      command: PostSAMLDataByProdIdQuery,
      httpContext?: HttpContext,
    ): Observable<PostSAMLDataByProdIdQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Menu.PostSAMLDataByProdId';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPostSAMLDataByProdId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPostSAMLDataByProdId(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PostSAMLDataByProdIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PostSAMLDataByProdIdQueryResultSuccess>;
          }),
        );
    }

    protected processPostSAMLDataByProdId(
      response: HttpResponseBase,
    ): Observable<PostSAMLDataByProdIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              PostSAMLDataByProdIdQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              PostSAMLDataByProdIdQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PostSAMLDataByProdIdQueryResultSuccess>(null as any);
    }

    search(
      q: SearchCommand,
      httpContext?: HttpContext,
    ): Observable<GlobalSearchCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Menu.Search';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(q);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearch(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearch(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GlobalSearchCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GlobalSearchCommandResultSuccess>;
          }),
        );
    }

    protected processSearch(
      response: HttpResponseBase,
    ): Observable<GlobalSearchCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GlobalSearchCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GlobalSearchCommandResultSuccess>(null as any);
    }
  }

  export interface IManualCalculationsService {
    getManualCalculationsSettings(
      clientId?: string | undefined,
    ): Observable<GetManualCalculationsSettingsQueryResultSuccess>;
    saveManualCalculationsSettings(
      command: SaveManualCalculationsSettingsCommand,
    ): Observable<SaveManualCalculationsSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ManualCalculationsService
    extends ApiBase
    implements IManualCalculationsService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getManualCalculationsSettings(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetManualCalculationsSettingsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculations.GetManualCalculationsSettings?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetManualCalculationsSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetManualCalculationsSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetManualCalculationsSettingsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetManualCalculationsSettingsQueryResultSuccess>;
          }),
        );
    }

    protected processGetManualCalculationsSettings(
      response: HttpResponseBase,
    ): Observable<GetManualCalculationsSettingsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetManualCalculationsSettingsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetManualCalculationsSettingsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetManualCalculationsSettingsQueryResultSuccess>(
        null as any,
      );
    }

    saveManualCalculationsSettings(
      command: SaveManualCalculationsSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveManualCalculationsSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculations.SaveManualCalculationsSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveManualCalculationsSettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveManualCalculationsSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveManualCalculationsSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveManualCalculationsSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveManualCalculationsSettings(
      response: HttpResponseBase,
    ): Observable<SaveManualCalculationsSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveManualCalculationsSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveManualCalculationsSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveManualCalculationsSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ILoggingService {
    logMetrics(
      command: LogMetricsCommand,
    ): Observable<LogMetricsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class LoggingService extends ApiBase implements ILoggingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    logMetrics(
      command: LogMetricsCommand,
      httpContext?: HttpContext,
    ): Observable<LogMetricsCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Logging.LogMetrics';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processLogMetrics(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processLogMetrics(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<LogMetricsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<LogMetricsCommandResultSuccess>;
          }),
        );
    }

    protected processLogMetrics(
      response: HttpResponseBase,
    ): Observable<LogMetricsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogMetricsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = LogMetricsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<LogMetricsCommandResultSuccess>(null as any);
    }
  }

  export interface ILiveEventsService {
    getLiveEventDetails(
      clientId?: string | undefined,
    ): Observable<GetLiveEventDetailsResultSuccess>;
    upsertLiveEventItem(
      command: UpsertLiveEventItemCommand,
    ): Observable<UpsertLiveEventItemCommandResultSuccess>;
    deleteLiveEventItem(
      clientId?: string | undefined,
      liveEventItemId?: string | undefined,
    ): Observable<DeleteLiveEventItemCommandResultSuccess>;
    updateVestSchedule(
      command: UpdateVestScheduleCommand,
    ): Observable<UpdateVestScheduleCommandResultSuccess>;
    saveLiveEventDetails(
      command: SaveLiveEventDetailsCommand,
    ): Observable<SaveLiveEventDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class LiveEventsService extends ApiBase implements ILiveEventsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getLiveEventDetails(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetLiveEventDetailsResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LiveEvents.GetLiveEventDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetLiveEventDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetLiveEventDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetLiveEventDetailsResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetLiveEventDetailsResultSuccess>;
          }),
        );
    }

    protected processGetLiveEventDetails(
      response: HttpResponseBase,
    ): Observable<GetLiveEventDetailsResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLiveEventDetailsResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetLiveEventDetailsResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetLiveEventDetailsResultSuccess>(null as any);
    }

    upsertLiveEventItem(
      command: UpsertLiveEventItemCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertLiveEventItemCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LiveEvents.UpsertLiveEventItem';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertLiveEventItem(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertLiveEventItem(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertLiveEventItemCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertLiveEventItemCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertLiveEventItem(
      response: HttpResponseBase,
    ): Observable<UpsertLiveEventItemCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertLiveEventItemCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertLiveEventItemCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertLiveEventItemCommandResultSuccess>(
        null as any,
      );
    }

    deleteLiveEventItem(
      clientId?: string | undefined,
      liveEventItemId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteLiveEventItemCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LiveEvents.DeleteLiveEventItem?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (liveEventItemId === null)
        throw new Error("The parameter 'liveEventItemId' cannot be null.");
      else if (liveEventItemId !== undefined)
        url_ +=
          'LiveEventItemId=' + encodeURIComponent('' + liveEventItemId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteLiveEventItem(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteLiveEventItem(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteLiveEventItemCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteLiveEventItemCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteLiveEventItem(
      response: HttpResponseBase,
    ): Observable<DeleteLiveEventItemCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteLiveEventItemCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteLiveEventItemCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteLiveEventItemCommandResultSuccess>(
        null as any,
      );
    }

    updateVestSchedule(
      command: UpdateVestScheduleCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateVestScheduleCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LiveEvents.UpdateVestSchedule';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateVestSchedule(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateVestSchedule(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateVestScheduleCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateVestScheduleCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateVestSchedule(
      response: HttpResponseBase,
    ): Observable<UpdateVestScheduleCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateVestScheduleCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateVestScheduleCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateVestScheduleCommandResultSuccess>(null as any);
    }

    saveLiveEventDetails(
      command: SaveLiveEventDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveLiveEventDetailsCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LiveEvents.SaveLiveEventDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveLiveEventDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveLiveEventDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveLiveEventDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveLiveEventDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveLiveEventDetails(
      response: HttpResponseBase,
    ): Observable<SaveLiveEventDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveLiveEventDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveLiveEventDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveLiveEventDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IEmployeePopulationPageService {
    saveClientEmployeePopulation(
      request: SaveEmployeePopulationDetailsCommand,
    ): Observable<SaveEmployeePopulationDetailsCommandResultSuccess>;
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetEmployeePopulationDetailsQueryResultSuccess>;
    addEmployeePopulationPolicyDetails(
      command: AddEmployeePopulationPolicyDetailsCommand,
    ): Observable<AddEmployeePopulationPolicyDetailsCommandResultSuccess>;
    updateEmployeePopulationPolicyDetails(
      command: UpdateEmployeePopulationPolicyDetailsCommand,
    ): Observable<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess>;
    deleteEmployeePopulationPolicyDetails(
      clientId?: string | undefined,
      employeePopulationDetailsId?: string | undefined,
      employeePopulationPolicyDetailsId?: string | undefined,
    ): Observable<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class EmployeePopulationPageService
    extends ApiBase
    implements IEmployeePopulationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    saveClientEmployeePopulation(
      request: SaveEmployeePopulationDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveEmployeePopulationDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeePopulationPage.SaveClientEmployeePopulation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveClientEmployeePopulation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveClientEmployeePopulation(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveEmployeePopulationDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveEmployeePopulationDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveClientEmployeePopulation(
      response: HttpResponseBase,
    ): Observable<SaveEmployeePopulationDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveEmployeePopulationDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveEmployeePopulationDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveEmployeePopulationDetailsCommandResultSuccess>(
        null as any,
      );
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEmployeePopulationDetailsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/EmployeePopulationPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEmployeePopulationDetailsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEmployeePopulationDetailsQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetEmployeePopulationDetailsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEmployeePopulationDetailsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEmployeePopulationDetailsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEmployeePopulationDetailsQueryResultSuccess>(
        null as any,
      );
    }

    addEmployeePopulationPolicyDetails(
      command: AddEmployeePopulationPolicyDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<AddEmployeePopulationPolicyDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeePopulationPage.AddEmployeePopulationPolicyDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddEmployeePopulationPolicyDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddEmployeePopulationPolicyDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddEmployeePopulationPolicyDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddEmployeePopulationPolicyDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processAddEmployeePopulationPolicyDetails(
      response: HttpResponseBase,
    ): Observable<AddEmployeePopulationPolicyDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddEmployeePopulationPolicyDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddEmployeePopulationPolicyDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddEmployeePopulationPolicyDetailsCommandResultSuccess>(
        null as any,
      );
    }

    updateEmployeePopulationPolicyDetails(
      command: UpdateEmployeePopulationPolicyDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeePopulationPage.UpdateEmployeePopulationPolicyDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateEmployeePopulationPolicyDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateEmployeePopulationPolicyDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateEmployeePopulationPolicyDetails(
      response: HttpResponseBase,
    ): Observable<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateEmployeePopulationPolicyDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateEmployeePopulationPolicyDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateEmployeePopulationPolicyDetailsCommandResultSuccess>(
        null as any,
      );
    }

    deleteEmployeePopulationPolicyDetails(
      clientId?: string | undefined,
      employeePopulationDetailsId?: string | undefined,
      employeePopulationPolicyDetailsId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EmployeePopulationPage.DeleteEmployeePopulationPolicyDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (employeePopulationDetailsId === null)
        throw new Error(
          "The parameter 'employeePopulationDetailsId' cannot be null.",
        );
      else if (employeePopulationDetailsId !== undefined)
        url_ +=
          'EmployeePopulationDetailsId=' +
          encodeURIComponent('' + employeePopulationDetailsId) +
          '&';
      if (employeePopulationPolicyDetailsId === null)
        throw new Error(
          "The parameter 'employeePopulationPolicyDetailsId' cannot be null.",
        );
      else if (employeePopulationPolicyDetailsId !== undefined)
        url_ +=
          'EmployeePopulationPolicyDetailsId=' +
          encodeURIComponent('' + employeePopulationPolicyDetailsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteEmployeePopulationPolicyDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteEmployeePopulationPolicyDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteEmployeePopulationPolicyDetails(
      response: HttpResponseBase,
    ): Observable<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteEmployeePopulationPolicyDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteEmployeePopulationPolicyDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteEmployeePopulationPolicyDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IDoubleTaxReliefPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2>;
    upsertDoubleTaxReliefPolicySettings(
      command: UpsertDoubleTaxReliefPolicySettingsCommand,
    ): Observable<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class DoubleTaxReliefPageService
    extends ApiBase
    implements IDoubleTaxReliefPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2> {
      let url_ =
        this.baseUrl + '/core-bff-api/DoubleTaxReliefPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDoubleTaxReliefPolicyPageDataQueryResultFailure2.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2>(
        null as any,
      );
    }

    upsertDoubleTaxReliefPolicySettings(
      command: UpsertDoubleTaxReliefPolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/DoubleTaxReliefPage.UpsertDoubleTaxReliefPolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertDoubleTaxReliefPolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertDoubleTaxReliefPolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertDoubleTaxReliefPolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertDoubleTaxReliefPolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IDeloitteTeamService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetDeloitteTeamDetailsQueryResultSuccess>;
    getDeloitteOfficeOptions(
      nameStartsWith?: string | undefined,
      maxNumberOfItemsToReturn?: number | null | undefined,
    ): Observable<GetDeloitteOfficeOptionsQueryResultSuccess>;
    getDeloitteUserOptions(
      clientId?: string | undefined,
      nameStartsWith?: string | undefined,
      filterOutExistingMembers?: boolean | undefined,
    ): Observable<GetDeloitteUserOptionsQueryResultSuccess>;
    saveDeloitteTeamDetails(
      command: SaveDeloitteTeamDetailsCommand,
    ): Observable<SaveDeloitteTeamDetailsCommandResultSuccess>;
    saveDeloitteTeamMembers(
      command: SaveDeloitteTeamMembersCommand,
    ): Observable<SaveDeloitteTeamMembersCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class DeloitteTeamService
    extends ApiBase
    implements IDeloitteTeamService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDeloitteTeamDetailsQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/DeloitteTeam.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeloitteTeamDetailsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeloitteTeamDetailsQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetDeloitteTeamDetailsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeloitteTeamDetailsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeloitteTeamDetailsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeloitteTeamDetailsQueryResultSuccess>(
        null as any,
      );
    }

    getDeloitteOfficeOptions(
      nameStartsWith?: string | undefined,
      maxNumberOfItemsToReturn?: number | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDeloitteOfficeOptionsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DeloitteTeam.GetDeloitteOfficeOptions?';
      if (nameStartsWith === null)
        throw new Error("The parameter 'nameStartsWith' cannot be null.");
      else if (nameStartsWith !== undefined)
        url_ +=
          'NameStartsWith=' + encodeURIComponent('' + nameStartsWith) + '&';
      if (
        maxNumberOfItemsToReturn !== undefined &&
        maxNumberOfItemsToReturn !== null
      )
        url_ +=
          'MaxNumberOfItemsToReturn=' +
          encodeURIComponent('' + maxNumberOfItemsToReturn) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDeloitteOfficeOptions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDeloitteOfficeOptions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeloitteOfficeOptionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeloitteOfficeOptionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetDeloitteOfficeOptions(
      response: HttpResponseBase,
    ): Observable<GetDeloitteOfficeOptionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeloitteOfficeOptionsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeloitteOfficeOptionsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeloitteOfficeOptionsQueryResultSuccess>(
        null as any,
      );
    }

    getDeloitteUserOptions(
      clientId?: string | undefined,
      nameStartsWith?: string | undefined,
      filterOutExistingMembers?: boolean | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDeloitteUserOptionsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DeloitteTeam.GetDeloitteUserOptions?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (nameStartsWith === null)
        throw new Error("The parameter 'nameStartsWith' cannot be null.");
      else if (nameStartsWith !== undefined)
        url_ +=
          'NameStartsWith=' + encodeURIComponent('' + nameStartsWith) + '&';
      if (filterOutExistingMembers === null)
        throw new Error(
          "The parameter 'filterOutExistingMembers' cannot be null.",
        );
      else if (filterOutExistingMembers !== undefined)
        url_ +=
          'FilterOutExistingMembers=' +
          encodeURIComponent('' + filterOutExistingMembers) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDeloitteUserOptions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDeloitteUserOptions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeloitteUserOptionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeloitteUserOptionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetDeloitteUserOptions(
      response: HttpResponseBase,
    ): Observable<GetDeloitteUserOptionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeloitteUserOptionsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeloitteUserOptionsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeloitteUserOptionsQueryResultSuccess>(
        null as any,
      );
    }

    saveDeloitteTeamDetails(
      command: SaveDeloitteTeamDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveDeloitteTeamDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DeloitteTeam.SaveDeloitteTeamDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveDeloitteTeamDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveDeloitteTeamDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveDeloitteTeamDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveDeloitteTeamDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveDeloitteTeamDetails(
      response: HttpResponseBase,
    ): Observable<SaveDeloitteTeamDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveDeloitteTeamDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveDeloitteTeamDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveDeloitteTeamDetailsCommandResultSuccess>(
        null as any,
      );
    }

    saveDeloitteTeamMembers(
      command: SaveDeloitteTeamMembersCommand,
      httpContext?: HttpContext,
    ): Observable<SaveDeloitteTeamMembersCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DeloitteTeam.SaveDeloitteTeamMembers';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveDeloitteTeamMembers(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveDeloitteTeamMembers(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveDeloitteTeamMembersCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveDeloitteTeamMembersCommandResultSuccess>;
          }),
        );
    }

    protected processSaveDeloitteTeamMembers(
      response: HttpResponseBase,
    ): Observable<SaveDeloitteTeamMembersCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveDeloitteTeamMembersCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveDeloitteTeamMembersCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveDeloitteTeamMembersCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IInputMappingsPageService {
    downloadInputMappingsTemplateFile(
      command?: DownloadInputMappingsTemplateFileCommand | undefined,
    ): Observable<DownloadInputMappingsTemplateFileCommandResultSuccess>;
    getInputMappingsPageData(
      clientId?: string | undefined,
    ): Observable<GetInputMappingsPageDataQueryResultSuccess>;
    handlePostInputMappingsUpload(
      clientId?: string | undefined,
      uploadedFiles?: string[] | undefined,
    ): Observable<HandlePostInputMappingsUploadCommandResultSuccess>;
    deleteInputMappingsFile(
      clientId?: string | undefined,
      fileName?: string | undefined,
    ): Observable<DeleteInputMappingsFileCommandResultSuccess>;
    getInputMappingsFilePreSignedUrlForDownload(
      clientId?: string | undefined,
      fileName?: string | undefined,
    ): Observable<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess>;
    updateInputMappingsStatus(
      clientId?: string | undefined,
      status?: InputMappingsStatusDto | undefined,
      comment?: string | undefined,
    ): Observable<UpdateInputMappingsCommandResultSuccess>;
    getInputMappingsFilesPreSignedUrlsForUpload(
      clientPortalId?: string | undefined,
      getPreSignedUrls?: GetInputMappingsFilePreSignedUrlDto[] | undefined,
    ): Observable<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class InputMappingsPageService
    extends ApiBase
    implements IInputMappingsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    downloadInputMappingsTemplateFile(
      command?: DownloadInputMappingsTemplateFileCommand | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadInputMappingsTemplateFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.DownloadInputMappingsTemplateFile?';
      if (command === null)
        throw new Error("The parameter 'command' cannot be null.");
      else if (command !== undefined)
        url_ += 'command=' + encodeURIComponent('' + command) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadInputMappingsTemplateFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadInputMappingsTemplateFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadInputMappingsTemplateFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadInputMappingsTemplateFileCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadInputMappingsTemplateFile(
      response: HttpResponseBase,
    ): Observable<DownloadInputMappingsTemplateFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadInputMappingsTemplateFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadInputMappingsTemplateFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadInputMappingsTemplateFileCommandResultSuccess>(
        null as any,
      );
    }

    getInputMappingsPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetInputMappingsPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.GetInputMappingsPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetInputMappingsPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetInputMappingsPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetInputMappingsPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetInputMappingsPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetInputMappingsPageData(
      response: HttpResponseBase,
    ): Observable<GetInputMappingsPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetInputMappingsPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetInputMappingsPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetInputMappingsPageDataQueryResultSuccess>(
        null as any,
      );
    }

    handlePostInputMappingsUpload(
      clientId?: string | undefined,
      uploadedFiles?: string[] | undefined,
      httpContext?: HttpContext,
    ): Observable<HandlePostInputMappingsUploadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.HandlePostInputMappingsUpload?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (uploadedFiles === null)
        throw new Error("The parameter 'uploadedFiles' cannot be null.");
      else if (uploadedFiles !== undefined)
        uploadedFiles &&
          uploadedFiles.forEach((item) => {
            url_ += 'UploadedFiles=' + encodeURIComponent('' + item) + '&';
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processHandlePostInputMappingsUpload(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processHandlePostInputMappingsUpload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<HandlePostInputMappingsUploadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<HandlePostInputMappingsUploadCommandResultSuccess>;
          }),
        );
    }

    protected processHandlePostInputMappingsUpload(
      response: HttpResponseBase,
    ): Observable<HandlePostInputMappingsUploadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              HandlePostInputMappingsUploadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              HandlePostInputMappingsUploadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<HandlePostInputMappingsUploadCommandResultSuccess>(
        null as any,
      );
    }

    deleteInputMappingsFile(
      clientId?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteInputMappingsFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.DeleteInputMappingsFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteInputMappingsFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteInputMappingsFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteInputMappingsFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteInputMappingsFileCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteInputMappingsFile(
      response: HttpResponseBase,
    ): Observable<DeleteInputMappingsFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteInputMappingsFileCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteInputMappingsFileCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteInputMappingsFileCommandResultSuccess>(
        null as any,
      );
    }

    getInputMappingsFilePreSignedUrlForDownload(
      clientId?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.GetInputMappingsFilePreSignedUrlForDownload?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetInputMappingsFilePreSignedUrlForDownload(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetInputMappingsFilePreSignedUrlForDownload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess>;
          }),
        );
    }

    protected processGetInputMappingsFilePreSignedUrlForDownload(
      response: HttpResponseBase,
    ): Observable<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetInputMappingsFilePreSignedUrlForDownloadResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess>(
        null as any,
      );
    }

    updateInputMappingsStatus(
      clientId?: string | undefined,
      status?: InputMappingsStatusDto | undefined,
      comment?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<UpdateInputMappingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.UpdateInputMappingsStatus?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (status === null)
        throw new Error("The parameter 'status' cannot be null.");
      else if (status !== undefined)
        url_ += 'Status=' + encodeURIComponent('' + status) + '&';
      if (comment === null)
        throw new Error("The parameter 'comment' cannot be null.");
      else if (comment !== undefined)
        url_ += 'Comment=' + encodeURIComponent('' + comment) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateInputMappingsStatus(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateInputMappingsStatus(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateInputMappingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateInputMappingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateInputMappingsStatus(
      response: HttpResponseBase,
    ): Observable<UpdateInputMappingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateInputMappingsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateInputMappingsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateInputMappingsCommandResultSuccess>(
        null as any,
      );
    }

    getInputMappingsFilesPreSignedUrlsForUpload(
      clientPortalId?: string | undefined,
      getPreSignedUrls?: GetInputMappingsFilePreSignedUrlDto[] | undefined,
      httpContext?: HttpContext,
    ): Observable<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/InputMappingsPage.GetInputMappingsFilesPreSignedUrlsForUpload?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (getPreSignedUrls === null)
        throw new Error("The parameter 'getPreSignedUrls' cannot be null.");
      else if (getPreSignedUrls !== undefined)
        getPreSignedUrls &&
          getPreSignedUrls.forEach((item, index) => {
            for (const attr in item)
              if (item.hasOwnProperty(attr)) {
                url_ +=
                  'GetPreSignedUrls[' +
                  index +
                  '].' +
                  attr +
                  '=' +
                  encodeURIComponent('' + (item as any)[attr]) +
                  '&';
              }
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetInputMappingsFilesPreSignedUrlsForUpload(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetInputMappingsFilesPreSignedUrlsForUpload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess>;
          }),
        );
    }

    protected processGetInputMappingsFilesPreSignedUrlsForUpload(
      response: HttpResponseBase,
    ): Observable<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IChangesLogPageService {
    getChangesLogPageData(
      clientId?: string | undefined,
    ): Observable<GetChangesLogPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ChangesLogPageService
    extends ApiBase
    implements IChangesLogPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getChangesLogPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetChangesLogPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ChangesLogPage.GetChangesLogPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetChangesLogPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetChangesLogPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetChangesLogPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetChangesLogPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetChangesLogPageData(
      response: HttpResponseBase,
    ): Observable<GetChangesLogPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetChangesLogPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetChangesLogPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetChangesLogPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICustomTaxesService {
    getCustomTaxes(
      clientId?: string | undefined,
    ): Observable<GetCustomTaxesQueryResultSuccess2>;
    upsertCustomTax(
      command: UpsertCustomTaxCommand,
    ): Observable<UpsertCustomTaxCommandResultSuccess>;
    deleteCustomTax(
      clientId?: string | undefined,
      id?: string | undefined,
    ): Observable<DeleteCustomTaxCommandResultSuccess>;
    saveCustomTaxes(
      command: SaveCustomTaxesCommand,
    ): Observable<SaveCustomTaxesCommandResultSuccess>;
    uploadCustomTaxes(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
    ): Observable<UploadCustomTaxesCommandResultSuccess>;
    downloadCustomTaxesTemplate(
      clientId?: string | undefined,
    ): Observable<DownloadCustomTaxesTemplateCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CustomTaxesService
    extends ApiBase
    implements ICustomTaxesService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCustomTaxes(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCustomTaxesQueryResultSuccess2> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTaxes.GetCustomTaxes?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCustomTaxes(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCustomTaxes(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCustomTaxesQueryResultSuccess2>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCustomTaxesQueryResultSuccess2>;
          }),
        );
    }

    protected processGetCustomTaxes(
      response: HttpResponseBase,
    ): Observable<GetCustomTaxesQueryResultSuccess2> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomTaxesQueryResultSuccess2.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetCustomTaxesQueryResultFailure2.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCustomTaxesQueryResultSuccess2>(null as any);
    }

    upsertCustomTax(
      command: UpsertCustomTaxCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCustomTaxCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTaxes.UpsertCustomTax';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertCustomTax(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertCustomTax(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCustomTaxCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCustomTaxCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertCustomTax(
      response: HttpResponseBase,
    ): Observable<UpsertCustomTaxCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCustomTaxCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCustomTaxCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCustomTaxCommandResultSuccess>(null as any);
    }

    deleteCustomTax(
      clientId?: string | undefined,
      id?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteCustomTaxCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTaxes.DeleteCustomTax?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (id === null) throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined)
        url_ += 'Id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteCustomTax(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteCustomTax(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteCustomTaxCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteCustomTaxCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteCustomTax(
      response: HttpResponseBase,
    ): Observable<DeleteCustomTaxCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteCustomTaxCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteCustomTaxCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteCustomTaxCommandResultSuccess>(null as any);
    }

    saveCustomTaxes(
      command: SaveCustomTaxesCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCustomTaxesCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTaxes.SaveCustomTaxes';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCustomTaxes(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCustomTaxes(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCustomTaxesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCustomTaxesCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCustomTaxes(
      response: HttpResponseBase,
    ): Observable<SaveCustomTaxesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCustomTaxesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCustomTaxesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCustomTaxesCommandResultSuccess>(null as any);
    }

    uploadCustomTaxes(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadCustomTaxesCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTaxes.UploadCustomTaxes';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadCustomTaxes(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadCustomTaxes(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadCustomTaxesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadCustomTaxesCommandResultSuccess>;
          }),
        );
    }

    protected processUploadCustomTaxes(
      response: HttpResponseBase,
    ): Observable<UploadCustomTaxesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadCustomTaxesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadCustomTaxesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadCustomTaxesCommandResultSuccess>(null as any);
    }

    downloadCustomTaxesTemplate(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadCustomTaxesTemplateCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CustomTaxes.DownloadCustomTaxesTemplate?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadCustomTaxesTemplate(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadCustomTaxesTemplate(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadCustomTaxesTemplateCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadCustomTaxesTemplateCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadCustomTaxesTemplate(
      response: HttpResponseBase,
    ): Observable<DownloadCustomTaxesTemplateCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadCustomTaxesTemplateCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadCustomTaxesTemplateCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadCustomTaxesTemplateCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICurrencyConversionContextService {
    getExchangeRateByDate(
      fromCurrency?: string | undefined,
      toCurrency?: string | undefined,
      date?: Date | undefined,
    ): Observable<GetExchangeRateByDateQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CurrencyConversionContextService
    extends ApiBase
    implements ICurrencyConversionContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getExchangeRateByDate(
      fromCurrency?: string | undefined,
      toCurrency?: string | undefined,
      date?: Date | undefined,
      httpContext?: HttpContext,
    ): Observable<GetExchangeRateByDateQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CurrencyConversionContext.GetExchangeRateByDate?';
      if (fromCurrency === null)
        throw new Error("The parameter 'fromCurrency' cannot be null.");
      else if (fromCurrency !== undefined)
        url_ += 'FromCurrency=' + encodeURIComponent('' + fromCurrency) + '&';
      if (toCurrency === null)
        throw new Error("The parameter 'toCurrency' cannot be null.");
      else if (toCurrency !== undefined)
        url_ += 'ToCurrency=' + encodeURIComponent('' + toCurrency) + '&';
      if (date === null)
        throw new Error("The parameter 'date' cannot be null.");
      else if (date !== undefined)
        url_ +=
          'Date=' +
          encodeURIComponent(date ? '' + date.toISOString() : '') +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetExchangeRateByDate(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetExchangeRateByDate(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetExchangeRateByDateQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetExchangeRateByDateQueryResultSuccess>;
          }),
        );
    }

    protected processGetExchangeRateByDate(
      response: HttpResponseBase,
    ): Observable<GetExchangeRateByDateQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetExchangeRateByDateQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetExchangeRateByDateQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetExchangeRateByDateQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICountryRegionDataBffService {
    getCountryRegionData(
      query?: GetCountryRegionDataQuery | undefined,
    ): Observable<GetCountryRegionDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CountryRegionDataBffService
    extends ApiBase
    implements ICountryRegionDataBffService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCountryRegionData(
      query?: GetCountryRegionDataQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryRegionDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryRegionDataBff.GetCountryRegionData?';
      if (query === null)
        throw new Error("The parameter 'query' cannot be null.");
      else if (query !== undefined)
        url_ += 'query=' + encodeURIComponent('' + query) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCountryRegionData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCountryRegionData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryRegionDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryRegionDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetCountryRegionData(
      response: HttpResponseBase,
    ): Observable<GetCountryRegionDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryRegionDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryRegionDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryRegionDataQueryResultSuccess>(null as any);
    }
  }

  export interface ICountryFootprintService {
    getCountryFootprintDetails(
      clientId?: string | undefined,
    ): Observable<GetCountryFootprintDetailsQueryResultSuccess>;
    generateCountryFootPrintFile(
      command: GenerateCountryFootPrintFileCommand,
    ): Observable<string>;
    saveCountryFootprintDetails(
      command: SaveCountryFootprintDetailsCommand,
    ): Observable<SaveCountryFootprintDetailsCommandResultSuccess>;
    parseCountriesFromTemplateFile(
      formFile?: FileParameter | undefined,
    ): Observable<ParseCountriesFromTemplateFileCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CountryFootprintService
    extends ApiBase
    implements ICountryFootprintService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCountryFootprintDetails(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryFootprintDetailsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryFootprint.GetCountryFootprintDetails?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCountryFootprintDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCountryFootprintDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryFootprintDetailsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryFootprintDetailsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCountryFootprintDetails(
      response: HttpResponseBase,
    ): Observable<GetCountryFootprintDetailsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryFootprintDetailsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryFootprintDetailsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryFootprintDetailsQueryResultSuccess>(
        null as any,
      );
    }

    generateCountryFootPrintFile(
      command: GenerateCountryFootPrintFileCommand,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryFootprint.GenerateCountryFootPrintFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGenerateCountryFootPrintFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGenerateCountryFootPrintFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processGenerateCountryFootPrintFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    saveCountryFootprintDetails(
      command: SaveCountryFootprintDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveCountryFootprintDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryFootprint.SaveCountryFootprintDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveCountryFootprintDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveCountryFootprintDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveCountryFootprintDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveCountryFootprintDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveCountryFootprintDetails(
      response: HttpResponseBase,
    ): Observable<SaveCountryFootprintDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveCountryFootprintDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveCountryFootprintDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveCountryFootprintDetailsCommandResultSuccess>(
        null as any,
      );
    }

    parseCountriesFromTemplateFile(
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<ParseCountriesFromTemplateFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CountryFootprint.ParseCountriesFromTemplateFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processParseCountriesFromTemplateFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processParseCountriesFromTemplateFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ParseCountriesFromTemplateFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ParseCountriesFromTemplateFileCommandResultSuccess>;
          }),
        );
    }

    protected processParseCountriesFromTemplateFile(
      response: HttpResponseBase,
    ): Observable<ParseCountriesFromTemplateFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ParseCountriesFromTemplateFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ParseCountriesFromTemplateFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ParseCountriesFromTemplateFileCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IContractAndPricingPageService {
    downloadContractFile(
      clientId?: string | undefined,
      contractAndPricingId?: string | undefined,
      contractFileInfoId?: string | undefined,
    ): Observable<string>;
    uploadContractFile(
      clientId?: string | undefined,
      files?: FileParameter[] | undefined,
    ): Observable<UploadContractFileCommandResultSuccess>;
    deleteContractFile(
      clientId?: string | undefined,
      contractAndPricingId?: string | undefined,
      contractFileInfoId?: string | undefined,
    ): Observable<DeleteContractFileCommandResultSuccess>;
    saveContractAndPricing(
      command: SaveContractAndPricingCommand,
    ): Observable<SaveContractAndPricingCommandResultSuccess>;
    getContractAndPricing(
      clientId?: string | undefined,
    ): Observable<GetContractAndPricingQueryResultSuccess>;
    submitContractFilesForApproval(
      clientId?: string | undefined,
    ): Observable<SubmitContractFilesForApprovalCommandResultSuccess>;
    approveContractFiles(
      clientId?: string | undefined,
    ): Observable<ApproveContractFilesCommandResultSuccess>;
    rejectContractFiles(
      clientId?: string | undefined,
      comment?: string | undefined,
    ): Observable<RejectContractFilesCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ContractAndPricingPageService
    extends ApiBase
    implements IContractAndPricingPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    downloadContractFile(
      clientId?: string | undefined,
      contractAndPricingId?: string | undefined,
      contractFileInfoId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.DownloadContractFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (contractAndPricingId === null)
        throw new Error("The parameter 'contractAndPricingId' cannot be null.");
      else if (contractAndPricingId !== undefined)
        url_ +=
          'ContractAndPricingId=' +
          encodeURIComponent('' + contractAndPricingId) +
          '&';
      if (contractFileInfoId === null)
        throw new Error("The parameter 'contractFileInfoId' cannot be null.");
      else if (contractFileInfoId !== undefined)
        url_ +=
          'ContractFileInfoId=' +
          encodeURIComponent('' + contractFileInfoId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadContractFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadContractFile(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadContractFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadContractFile(
      clientId?: string | undefined,
      files?: FileParameter[] | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadContractFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.UploadContractFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (files === null || files === undefined)
        throw new Error("The parameter 'files' cannot be null.");
      else
        files.forEach((item_) =>
          content_.append(
            'Files',
            item_.data,
            item_.fileName ? item_.fileName : 'Files',
          ),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadContractFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadContractFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadContractFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadContractFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadContractFile(
      response: HttpResponseBase,
    ): Observable<UploadContractFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadContractFileCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadContractFileCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadContractFileCommandResultSuccess>(null as any);
    }

    deleteContractFile(
      clientId?: string | undefined,
      contractAndPricingId?: string | undefined,
      contractFileInfoId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteContractFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.DeleteContractFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (contractAndPricingId === null)
        throw new Error("The parameter 'contractAndPricingId' cannot be null.");
      else if (contractAndPricingId !== undefined)
        url_ +=
          'ContractAndPricingId=' +
          encodeURIComponent('' + contractAndPricingId) +
          '&';
      if (contractFileInfoId === null)
        throw new Error("The parameter 'contractFileInfoId' cannot be null.");
      else if (contractFileInfoId !== undefined)
        url_ +=
          'ContractFileInfoId=' +
          encodeURIComponent('' + contractFileInfoId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteContractFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteContractFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteContractFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteContractFileCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteContractFile(
      response: HttpResponseBase,
    ): Observable<DeleteContractFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteContractFileCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteContractFileCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteContractFileCommandResultSuccess>(null as any);
    }

    saveContractAndPricing(
      command: SaveContractAndPricingCommand,
      httpContext?: HttpContext,
    ): Observable<SaveContractAndPricingCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.SaveContractAndPricing';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveContractAndPricing(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveContractAndPricing(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveContractAndPricingCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveContractAndPricingCommandResultSuccess>;
          }),
        );
    }

    protected processSaveContractAndPricing(
      response: HttpResponseBase,
    ): Observable<SaveContractAndPricingCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveContractAndPricingCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveContractAndPricingCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveContractAndPricingCommandResultSuccess>(
        null as any,
      );
    }

    getContractAndPricing(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetContractAndPricingQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.GetContractAndPricing?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetContractAndPricing(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetContractAndPricing(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetContractAndPricingQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetContractAndPricingQueryResultSuccess>;
          }),
        );
    }

    protected processGetContractAndPricing(
      response: HttpResponseBase,
    ): Observable<GetContractAndPricingQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetContractAndPricingQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetContractAndPricingQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetContractAndPricingQueryResultSuccess>(
        null as any,
      );
    }

    submitContractFilesForApproval(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<SubmitContractFilesForApprovalCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.SubmitContractFilesForApproval?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSubmitContractFilesForApproval(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSubmitContractFilesForApproval(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SubmitContractFilesForApprovalCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SubmitContractFilesForApprovalCommandResultSuccess>;
          }),
        );
    }

    protected processSubmitContractFilesForApproval(
      response: HttpResponseBase,
    ): Observable<SubmitContractFilesForApprovalCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SubmitContractFilesForApprovalCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SubmitContractFilesForApprovalCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SubmitContractFilesForApprovalCommandResultSuccess>(
        null as any,
      );
    }

    approveContractFiles(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<ApproveContractFilesCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.ApproveContractFiles?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processApproveContractFiles(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processApproveContractFiles(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ApproveContractFilesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ApproveContractFilesCommandResultSuccess>;
          }),
        );
    }

    protected processApproveContractFiles(
      response: HttpResponseBase,
    ): Observable<ApproveContractFilesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ApproveContractFilesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ApproveContractFilesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ApproveContractFilesCommandResultSuccess>(
        null as any,
      );
    }

    rejectContractFiles(
      clientId?: string | undefined,
      comment?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<RejectContractFilesCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ContractAndPricingPage.RejectContractFiles?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (comment === null)
        throw new Error("The parameter 'comment' cannot be null.");
      else if (comment !== undefined)
        url_ += 'Comment=' + encodeURIComponent('' + comment) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processRejectContractFiles(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processRejectContractFiles(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<RejectContractFilesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<RejectContractFilesCommandResultSuccess>;
          }),
        );
    }

    protected processRejectContractFiles(
      response: HttpResponseBase,
    ): Observable<RejectContractFilesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              RejectContractFilesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              RejectContractFilesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<RejectContractFilesCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IClientTeamService {
    getClientTeamPageData(
      clientId?: string | undefined,
    ): Observable<GetClientTeamPageDataQueryResultSuccess>;
    addClientTeamMember(
      command: AddClientTeamMemberCommand,
    ): Observable<AddClientTeamMemberCommandResultSuccess>;
    updateClientTeamMember(
      command: UpdateClientTeamMemberCommand,
    ): Observable<UpdateClientTeamMemberCommandResultSuccess>;
    deleteClientTeamMember(
      clientId?: string | undefined,
      clientTeamMemberId?: string | undefined,
    ): Observable<DeleteClientTeamMemberCommandResultSuccess>;
    saveClientTeamDetails(
      command: SaveClientTeamDetailsCommand,
    ): Observable<SaveClientTeamDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ClientTeamService extends ApiBase implements IClientTeamService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientTeamPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientTeamPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientTeam.GetClientTeamPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientTeamPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientTeamPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientTeamPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientTeamPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientTeamPageData(
      response: HttpResponseBase,
    ): Observable<GetClientTeamPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientTeamPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientTeamPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientTeamPageDataQueryResultSuccess>(
        null as any,
      );
    }

    addClientTeamMember(
      command: AddClientTeamMemberCommand,
      httpContext?: HttpContext,
    ): Observable<AddClientTeamMemberCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/ClientTeam.AddClientTeamMember';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processAddClientTeamMember(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processAddClientTeamMember(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<AddClientTeamMemberCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<AddClientTeamMemberCommandResultSuccess>;
          }),
        );
    }

    protected processAddClientTeamMember(
      response: HttpResponseBase,
    ): Observable<AddClientTeamMemberCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              AddClientTeamMemberCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              AddClientTeamMemberCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<AddClientTeamMemberCommandResultSuccess>(
        null as any,
      );
    }

    updateClientTeamMember(
      command: UpdateClientTeamMemberCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateClientTeamMemberCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientTeam.UpdateClientTeamMember';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('put', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateClientTeamMember(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateClientTeamMember(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateClientTeamMemberCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateClientTeamMemberCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateClientTeamMember(
      response: HttpResponseBase,
    ): Observable<UpdateClientTeamMemberCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateClientTeamMemberCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateClientTeamMemberCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateClientTeamMemberCommandResultSuccess>(
        null as any,
      );
    }

    deleteClientTeamMember(
      clientId?: string | undefined,
      clientTeamMemberId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteClientTeamMemberCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientTeam.DeleteClientTeamMember?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (clientTeamMemberId === null)
        throw new Error("The parameter 'clientTeamMemberId' cannot be null.");
      else if (clientTeamMemberId !== undefined)
        url_ +=
          'ClientTeamMemberId=' +
          encodeURIComponent('' + clientTeamMemberId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteClientTeamMember(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteClientTeamMember(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteClientTeamMemberCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteClientTeamMemberCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteClientTeamMember(
      response: HttpResponseBase,
    ): Observable<DeleteClientTeamMemberCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteClientTeamMemberCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteClientTeamMemberCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteClientTeamMemberCommandResultSuccess>(
        null as any,
      );
    }

    saveClientTeamDetails(
      command: SaveClientTeamDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveClientTeamDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientTeam.SaveClientTeamDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveClientTeamDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveClientTeamDetails(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveClientTeamDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveClientTeamDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveClientTeamDetails(
      response: HttpResponseBase,
    ): Observable<SaveClientTeamDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveClientTeamDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveClientTeamDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveClientTeamDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IPayrollPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetPayrollPageDataQueryResultSuccess>;
    saveClientPayroll(
      request: SaveClientPayrollDetailsCommand,
    ): Observable<SaveClientPayrollDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class PayrollPageService
    extends ApiBase
    implements IPayrollPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPayrollPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/PayrollPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPayrollPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPayrollPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetPayrollPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetPayrollPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetPayrollPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPayrollPageDataQueryResultSuccess>(null as any);
    }

    saveClientPayroll(
      request: SaveClientPayrollDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveClientPayrollDetailsCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/PayrollPage.SaveClientPayroll';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveClientPayroll(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveClientPayroll(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveClientPayrollDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveClientPayrollDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveClientPayroll(
      response: HttpResponseBase,
    ): Observable<SaveClientPayrollDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveClientPayrollDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveClientPayrollDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveClientPayrollDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IEnrollClientPageService {
    getClientEnrollmentOptions(
      nameStartsWith?: string | undefined,
      maxNumberOfItemsToReturn?: number | null | undefined,
    ): Observable<GetClientEnrollmentOptionsQueryResultSuccess>;
    enrollClient(
      command: EnrollClientCommand,
    ): Observable<EnrollClientCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class EnrollClientPageService
    extends ApiBase
    implements IEnrollClientPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientEnrollmentOptions(
      nameStartsWith?: string | undefined,
      maxNumberOfItemsToReturn?: number | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientEnrollmentOptionsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/EnrollClientPage.GetClientEnrollmentOptions?';
      if (nameStartsWith === null)
        throw new Error("The parameter 'nameStartsWith' cannot be null.");
      else if (nameStartsWith !== undefined)
        url_ +=
          'NameStartsWith=' + encodeURIComponent('' + nameStartsWith) + '&';
      if (
        maxNumberOfItemsToReturn !== undefined &&
        maxNumberOfItemsToReturn !== null
      )
        url_ +=
          'MaxNumberOfItemsToReturn=' +
          encodeURIComponent('' + maxNumberOfItemsToReturn) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientEnrollmentOptions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientEnrollmentOptions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientEnrollmentOptionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientEnrollmentOptionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientEnrollmentOptions(
      response: HttpResponseBase,
    ): Observable<GetClientEnrollmentOptionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientEnrollmentOptionsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientEnrollmentOptionsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientEnrollmentOptionsQueryResultSuccess>(
        null as any,
      );
    }

    enrollClient(
      command: EnrollClientCommand,
      httpContext?: HttpContext,
    ): Observable<EnrollClientCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/EnrollClientPage.EnrollClient';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processEnrollClient(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processEnrollClient(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<EnrollClientCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<EnrollClientCommandResultSuccess>;
          }),
        );
    }

    protected processEnrollClient(
      response: HttpResponseBase,
    ): Observable<EnrollClientCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnrollClientCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = EnrollClientCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<EnrollClientCommandResultSuccess>(null as any);
    }
  }

  export interface IClientsIndexPageService {
    getClientIndexPageRows(
      clientIndexPageQuery: ClientIndexPageQuery,
    ): Observable<ClientIndexPageQuerySuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ClientsIndexPageService
    extends ApiBase
    implements IClientsIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientIndexPageRows(
      clientIndexPageQuery: ClientIndexPageQuery,
      httpContext?: HttpContext,
    ): Observable<ClientIndexPageQuerySuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientsIndexPage.GetClientIndexPageRows';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(clientIndexPageQuery);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientIndexPageRows(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientIndexPageRows(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ClientIndexPageQuerySuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ClientIndexPageQuerySuccess>;
          }),
        );
    }

    protected processGetClientIndexPageRows(
      response: HttpResponseBase,
    ): Observable<ClientIndexPageQuerySuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientIndexPageQuerySuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ClientIndexPageQueryFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ClientIndexPageQuerySuccess>(null as any);
    }
  }

  export interface IClientContextService {
    getClientContextByPortalId(
      clientPortalId?: string | undefined,
    ): Observable<GetClientContextByPortalIdQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ClientContextService
    extends ApiBase
    implements IClientContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientContextByPortalId(
      clientPortalId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientContextByPortalIdQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ClientContext.GetClientContextByPortalId?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientContextByPortalId(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientContextByPortalId(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientContextByPortalIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientContextByPortalIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientContextByPortalId(
      response: HttpResponseBase,
    ): Observable<GetClientContextByPortalIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientContextByPortalIdQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientContextByPortalIdQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientContextByPortalIdQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITransactionsSearchPageService {
    searchTransactions(
      q: SearchTransactionsCommand,
    ): Observable<SearchTransactionsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TransactionsSearchPageService
    extends ApiBase
    implements ITransactionsSearchPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    searchTransactions(
      q: SearchTransactionsCommand,
      httpContext?: HttpContext,
    ): Observable<SearchTransactionsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TransactionsSearchPage.SearchTransactions';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(q);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchTransactions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchTransactions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchTransactionsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchTransactionsCommandResultSuccess>;
          }),
        );
    }

    protected processSearchTransactions(
      response: HttpResponseBase,
    ): Observable<SearchTransactionsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchTransactionsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchTransactionsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchTransactionsCommandResultSuccess>(null as any);
    }
  }

  export interface ITaxAdjustmentFromBatchFilePageService {
    downloadTaxAdjustmentBatchFileTemplate(
      clientId?: string | undefined,
    ): Observable<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess>;
    downloadPrePopulatedTaxAdjustmentBatchFile(
      command: DownloadPrePopulatedTaxAdjustmentBatchFileCommand,
    ): Observable<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess>;
    uploadTaxAdjustmentBatchFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
    ): Observable<UploadTaxAdjustmentBatchFileCommandResultSuccess>;
    getBrokerAdjustmentJob(
      clientId?: string | undefined,
      brokerAdjustmentJobId?: string | undefined,
    ): Observable<GetBrokerAdjustmentJobQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TaxAdjustmentFromBatchFilePageService
    extends ApiBase
    implements ITaxAdjustmentFromBatchFilePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    downloadTaxAdjustmentBatchFileTemplate(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxAdjustmentFromBatchFilePage.DownloadTaxAdjustmentBatchFileTemplate?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadTaxAdjustmentBatchFileTemplate(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadTaxAdjustmentBatchFileTemplate(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadTaxAdjustmentBatchFileTemplate(
      response: HttpResponseBase,
    ): Observable<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadTaxAdjustmentBatchFileTemplateCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess>(
        null as any,
      );
    }

    downloadPrePopulatedTaxAdjustmentBatchFile(
      command: DownloadPrePopulatedTaxAdjustmentBatchFileCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxAdjustmentFromBatchFilePage.DownloadPrePopulatedTaxAdjustmentBatchFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadPrePopulatedTaxAdjustmentBatchFile(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadPrePopulatedTaxAdjustmentBatchFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadPrePopulatedTaxAdjustmentBatchFile(
      response: HttpResponseBase,
    ): Observable<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess>(
        null as any,
      );
    }

    uploadTaxAdjustmentBatchFile(
      clientId?: string | undefined,
      formFile?: FileParameter | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadTaxAdjustmentBatchFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxAdjustmentFromBatchFilePage.UploadTaxAdjustmentBatchFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (formFile === null || formFile === undefined)
        throw new Error("The parameter 'formFile' cannot be null.");
      else
        content_.append(
          'FormFile',
          formFile.data,
          formFile.fileName ? formFile.fileName : 'FormFile',
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadTaxAdjustmentBatchFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadTaxAdjustmentBatchFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadTaxAdjustmentBatchFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadTaxAdjustmentBatchFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadTaxAdjustmentBatchFile(
      response: HttpResponseBase,
    ): Observable<UploadTaxAdjustmentBatchFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadTaxAdjustmentBatchFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadTaxAdjustmentBatchFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadTaxAdjustmentBatchFileCommandResultSuccess>(
        null as any,
      );
    }

    getBrokerAdjustmentJob(
      clientId?: string | undefined,
      brokerAdjustmentJobId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBrokerAdjustmentJobQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TaxAdjustmentFromBatchFilePage.GetBrokerAdjustmentJob?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (brokerAdjustmentJobId === null)
        throw new Error(
          "The parameter 'brokerAdjustmentJobId' cannot be null.",
        );
      else if (brokerAdjustmentJobId !== undefined)
        url_ +=
          'BrokerAdjustmentJobId=' +
          encodeURIComponent('' + brokerAdjustmentJobId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBrokerAdjustmentJob(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBrokerAdjustmentJob(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBrokerAdjustmentJobQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBrokerAdjustmentJobQueryResultSuccess>;
          }),
        );
    }

    protected processGetBrokerAdjustmentJob(
      response: HttpResponseBase,
    ): Observable<GetBrokerAdjustmentJobQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBrokerAdjustmentJobQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBrokerAdjustmentJobQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBrokerAdjustmentJobQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRunFromBatchFilePageService {
    getBatchFileStatus(
      clientId?: string | undefined,
      batchId?: string | undefined,
    ): Observable<GetBatchFileStatusQueryResultSuccess>;
    createBatch(
      request: CreateBatchCommand,
    ): Observable<CreateBatchCommandResultSuccess>;
    getBatchFileUploadUrl(
      clientId?: string | undefined,
      batchId?: string | undefined,
      fileName?: string | undefined,
    ): Observable<GetBatchFileUploadUrlCommandResultSuccess>;
    downloadBatchFileTemplate(
      clientId?: string | undefined,
    ): Observable<DownloadBatchFileTemplateCommandResultSuccess>;
    handleBatchFileUploadFailure(
      request: HandleBatchFileUploadFailureCommand,
    ): Observable<HandleBatchFileUploadFailureCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RunFromBatchFilePageService
    extends ApiBase
    implements IRunFromBatchFilePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getBatchFileStatus(
      clientId?: string | undefined,
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchFileStatusQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RunFromBatchFilePage.GetBatchFileStatus?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchFileStatus(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchFileStatus(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchFileStatusQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchFileStatusQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchFileStatus(
      response: HttpResponseBase,
    ): Observable<GetBatchFileStatusQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchFileStatusQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchFileStatusQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchFileStatusQueryResultSuccess>(null as any);
    }

    createBatch(
      request: CreateBatchCommand,
      httpContext?: HttpContext,
    ): Observable<CreateBatchCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RunFromBatchFilePage.CreateBatch';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCreateBatch(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCreateBatch(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CreateBatchCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CreateBatchCommandResultSuccess>;
          }),
        );
    }

    protected processCreateBatch(
      response: HttpResponseBase,
    ): Observable<CreateBatchCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateBatchCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = CreateBatchCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CreateBatchCommandResultSuccess>(null as any);
    }

    getBatchFileUploadUrl(
      clientId?: string | undefined,
      batchId?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchFileUploadUrlCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunFromBatchFilePage.GetBatchFileUploadUrl?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchFileUploadUrl(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchFileUploadUrl(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchFileUploadUrlCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchFileUploadUrlCommandResultSuccess>;
          }),
        );
    }

    protected processGetBatchFileUploadUrl(
      response: HttpResponseBase,
    ): Observable<GetBatchFileUploadUrlCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchFileUploadUrlCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchFileUploadUrlCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchFileUploadUrlCommandResultSuccess>(
        null as any,
      );
    }

    downloadBatchFileTemplate(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DownloadBatchFileTemplateCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunFromBatchFilePage.DownloadBatchFileTemplate?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadBatchFileTemplate(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadBatchFileTemplate(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadBatchFileTemplateCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadBatchFileTemplateCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadBatchFileTemplate(
      response: HttpResponseBase,
    ): Observable<DownloadBatchFileTemplateCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadBatchFileTemplateCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadBatchFileTemplateCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadBatchFileTemplateCommandResultSuccess>(
        null as any,
      );
    }

    handleBatchFileUploadFailure(
      request: HandleBatchFileUploadFailureCommand,
      httpContext?: HttpContext,
    ): Observable<HandleBatchFileUploadFailureCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunFromBatchFilePage.HandleBatchFileUploadFailure';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processHandleBatchFileUploadFailure(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processHandleBatchFileUploadFailure(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<HandleBatchFileUploadFailureCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<HandleBatchFileUploadFailureCommandResultSuccess>;
          }),
        );
    }

    protected processHandleBatchFileUploadFailure(
      response: HttpResponseBase,
    ): Observable<HandleBatchFileUploadFailureCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              HandleBatchFileUploadFailureCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              HandleBatchFileUploadFailureCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<HandleBatchFileUploadFailureCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRunCalculationPageService {
    runCalculation(
      command: RunBatchOfOneCommand,
    ): Observable<RunBatchOfOneCommandResultSuccess>;
    getCalculationStatusById(
      calculationId?: string | undefined,
      clientId?: string | undefined,
    ): Observable<GetCalculationStatusByIdQueryResultSuccess>;
    enqueueRunBatchOfOne(
      command: EnqueueRunBatchOfOneCommand,
    ): Observable<EnqueueRunBatchOfOneCommandResultSuccess>;
    validateCalculation(
      command: ValidateCalculationCommand,
    ): Observable<ValidateCalculationCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RunCalculationPageService
    extends ApiBase
    implements IRunCalculationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    runCalculation(
      command: RunBatchOfOneCommand,
      httpContext?: HttpContext,
    ): Observable<RunBatchOfOneCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RunCalculationPage.RunCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processRunCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processRunCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<RunBatchOfOneCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<RunBatchOfOneCommandResultSuccess>;
          }),
        );
    }

    protected processRunCalculation(
      response: HttpResponseBase,
    ): Observable<RunBatchOfOneCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunBatchOfOneCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RunBatchOfOneCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<RunBatchOfOneCommandResultSuccess>(null as any);
    }

    getCalculationStatusById(
      calculationId?: string | undefined,
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationStatusByIdQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunCalculationPage.GetCalculationStatusById?';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationStatusById(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationStatusById(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationStatusByIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationStatusByIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationStatusById(
      response: HttpResponseBase,
    ): Observable<GetCalculationStatusByIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationStatusByIdQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationStatusByIdQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationStatusByIdQueryResultSuccess>(
        null as any,
      );
    }

    enqueueRunBatchOfOne(
      command: EnqueueRunBatchOfOneCommand,
      httpContext?: HttpContext,
    ): Observable<EnqueueRunBatchOfOneCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RunCalculationPage.EnqueueRunBatchOfOne';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processEnqueueRunBatchOfOne(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processEnqueueRunBatchOfOne(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<EnqueueRunBatchOfOneCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<EnqueueRunBatchOfOneCommandResultSuccess>;
          }),
        );
    }

    protected processEnqueueRunBatchOfOne(
      response: HttpResponseBase,
    ): Observable<EnqueueRunBatchOfOneCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              EnqueueRunBatchOfOneCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              EnqueueRunBatchOfOneCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<EnqueueRunBatchOfOneCommandResultSuccess>(
        null as any,
      );
    }

    validateCalculation(
      command: ValidateCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<ValidateCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/RunCalculationPage.ValidateCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processValidateCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processValidateCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ValidateCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ValidateCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processValidateCalculation(
      response: HttpResponseBase,
    ): Observable<ValidateCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ValidateCalculationCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ValidateCalculationCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ValidateCalculationCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IRunCalculationBottomBarComponentService {
    updateCalculation(
      command: UpdateCalculationCommand,
    ): Observable<UpdateCalculationCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RunCalculationBottomBarComponentService
    extends ApiBase
    implements IRunCalculationBottomBarComponentService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    updateCalculation(
      command: UpdateCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunCalculationBottomBarComponent.UpdateCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateCalculation(
      response: HttpResponseBase,
    ): Observable<UpdateCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateCalculationCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateCalculationCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateCalculationCommandResultSuccess>(null as any);
    }
  }

  export interface IRunBatchViaDataExchangePageService {
    getRunBatchViaDataExchangePageData(
      clientId?: string | undefined,
    ): Observable<GetRunBatchViaDataExchangePageDataQueryResultSuccess>;
    getStagingFilesPreSignedUrlsForUpload(
      clientId?: string | undefined,
      getPreSignedUrls?: GetStagingFilePreSignedUrlDto[] | undefined,
    ): Observable<GetStagingFilesPreSignedUrlsForUploadResultSuccess>;
    handlePostStagingFilesUpload(
      command: HandlePostStagingFilesUploadCommand,
    ): Observable<HandlePostStagingFilesUploadCommandResultSuccess>;
    getStagingFilePreSignedUrlsForDownlod(
      clientId?: string | undefined,
      fileName?: string | undefined,
    ): Observable<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess>;
    deleteStagingFile(
      clientId?: string | undefined,
      fileName?: string | undefined,
    ): Observable<DeleteStagingFileCommandResultSuccess>;
    getBatchStatus(
      batchId?: string | undefined,
    ): Observable<GetBatchStatusQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class RunBatchViaDataExchangePageService
    extends ApiBase
    implements IRunBatchViaDataExchangePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getRunBatchViaDataExchangePageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetRunBatchViaDataExchangePageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.GetRunBatchViaDataExchangePageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetRunBatchViaDataExchangePageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRunBatchViaDataExchangePageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetRunBatchViaDataExchangePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetRunBatchViaDataExchangePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetRunBatchViaDataExchangePageData(
      response: HttpResponseBase,
    ): Observable<GetRunBatchViaDataExchangePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetRunBatchViaDataExchangePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetRunBatchViaDataExchangePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetRunBatchViaDataExchangePageDataQueryResultSuccess>(
        null as any,
      );
    }

    getStagingFilesPreSignedUrlsForUpload(
      clientId?: string | undefined,
      getPreSignedUrls?: GetStagingFilePreSignedUrlDto[] | undefined,
      httpContext?: HttpContext,
    ): Observable<GetStagingFilesPreSignedUrlsForUploadResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.GetStagingFilesPreSignedUrlsForUpload?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (getPreSignedUrls === null)
        throw new Error("The parameter 'getPreSignedUrls' cannot be null.");
      else if (getPreSignedUrls !== undefined)
        getPreSignedUrls &&
          getPreSignedUrls.forEach((item, index) => {
            for (const attr in item)
              if (item.hasOwnProperty(attr)) {
                url_ +=
                  'GetPreSignedUrls[' +
                  index +
                  '].' +
                  attr +
                  '=' +
                  encodeURIComponent('' + (item as any)[attr]) +
                  '&';
              }
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetStagingFilesPreSignedUrlsForUpload(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetStagingFilesPreSignedUrlsForUpload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetStagingFilesPreSignedUrlsForUploadResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetStagingFilesPreSignedUrlsForUploadResultSuccess>;
          }),
        );
    }

    protected processGetStagingFilesPreSignedUrlsForUpload(
      response: HttpResponseBase,
    ): Observable<GetStagingFilesPreSignedUrlsForUploadResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetStagingFilesPreSignedUrlsForUploadResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetStagingFilesPreSignedUrlsForUploadResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetStagingFilesPreSignedUrlsForUploadResultSuccess>(
        null as any,
      );
    }

    handlePostStagingFilesUpload(
      command: HandlePostStagingFilesUploadCommand,
      httpContext?: HttpContext,
    ): Observable<HandlePostStagingFilesUploadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.HandlePostStagingFilesUpload';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processHandlePostStagingFilesUpload(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processHandlePostStagingFilesUpload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<HandlePostStagingFilesUploadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<HandlePostStagingFilesUploadCommandResultSuccess>;
          }),
        );
    }

    protected processHandlePostStagingFilesUpload(
      response: HttpResponseBase,
    ): Observable<HandlePostStagingFilesUploadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              HandlePostStagingFilesUploadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              HandlePostStagingFilesUploadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<HandlePostStagingFilesUploadCommandResultSuccess>(
        null as any,
      );
    }

    getStagingFilePreSignedUrlsForDownlod(
      clientId?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.GetStagingFilePreSignedUrlsForDownlod?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetStagingFilePreSignedUrlsForDownlod(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetStagingFilePreSignedUrlsForDownlod(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess>;
          }),
        );
    }

    protected processGetStagingFilePreSignedUrlsForDownlod(
      response: HttpResponseBase,
    ): Observable<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetStagingFilePreSignedUrlsForDownloadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess>(
        null as any,
      );
    }

    deleteStagingFile(
      clientId?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteStagingFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.DeleteStagingFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteStagingFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteStagingFile(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteStagingFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteStagingFileCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteStagingFile(
      response: HttpResponseBase,
    ): Observable<DeleteStagingFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteStagingFileCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteStagingFileCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteStagingFileCommandResultSuccess>(null as any);
    }

    getBatchStatus(
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchStatusQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/RunBatchViaDataExchangePage.GetBatchStatus?';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchStatus(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchStatus(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchStatusQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchStatusQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchStatus(
      response: HttpResponseBase,
    ): Observable<GetBatchStatusQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBatchStatusQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetBatchStatusQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchStatusQueryResultSuccess>(null as any);
    }
  }

  export interface IManualCalculationsTransactionInputsPageService {
    updateManualCalculationEngineResults(
      command: UpdateManualCalculationEngineResultsCommand,
    ): Observable<UpdateManualCalculationEngineResultsCommandResultSuccess>;
    recalculateTotals(
      command: RecalculateManualTotalsCommand,
    ): Observable<RecalculateManualTotalsCommandResultSuccess>;
    getPageData(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
    ): Observable<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess>;
    downloadManualCalculationsTransactionInputFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      fileName?: string | undefined,
    ): Observable<string>;
    uploadManualCalculationsTransactionInputFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      files?: FileParameter[] | undefined,
    ): Observable<UploadManualCalculationsTransactionInputsFileCommandResultSuccess>;
    deleteManualCalculationsTransactionInputsFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      fileName?: string | undefined,
    ): Observable<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ManualCalculationsTransactionInputsPageService
    extends ApiBase
    implements IManualCalculationsTransactionInputsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    updateManualCalculationEngineResults(
      command: UpdateManualCalculationEngineResultsCommand,
      httpContext?: HttpContext,
    ): Observable<UpdateManualCalculationEngineResultsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.UpdateManualCalculationEngineResults';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpdateManualCalculationEngineResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpdateManualCalculationEngineResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpdateManualCalculationEngineResultsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpdateManualCalculationEngineResultsCommandResultSuccess>;
          }),
        );
    }

    protected processUpdateManualCalculationEngineResults(
      response: HttpResponseBase,
    ): Observable<UpdateManualCalculationEngineResultsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpdateManualCalculationEngineResultsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpdateManualCalculationEngineResultsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpdateManualCalculationEngineResultsCommandResultSuccess>(
        null as any,
      );
    }

    recalculateTotals(
      command: RecalculateManualTotalsCommand,
      httpContext?: HttpContext,
    ): Observable<RecalculateManualTotalsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.RecalculateTotals';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processRecalculateTotals(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processRecalculateTotals(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<RecalculateManualTotalsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<RecalculateManualTotalsCommandResultSuccess>;
          }),
        );
    }

    protected processRecalculateTotals(
      response: HttpResponseBase,
    ): Observable<RecalculateManualTotalsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              RecalculateManualTotalsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              RecalculateManualTotalsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<RecalculateManualTotalsCommandResultSuccess>(
        null as any,
      );
    }

    getPageData(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      if (transactionGuid === null)
        throw new Error("The parameter 'transactionGuid' cannot be null.");
      else if (transactionGuid !== undefined)
        url_ +=
          'TransactionGuid=' + encodeURIComponent('' + transactionGuid) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetManualCalculationsTransactionInputsPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetManualCalculationsTransactionInputsPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetManualCalculationsTransactionInputsPageDataQueryResultSuccess>(
        null as any,
      );
    }

    downloadManualCalculationsTransactionInputFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.DownloadManualCalculationsTransactionInputFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      if (transactionGuid === null)
        throw new Error("The parameter 'transactionGuid' cannot be null.");
      else if (transactionGuid !== undefined)
        url_ +=
          'TransactionGuid=' + encodeURIComponent('' + transactionGuid) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadManualCalculationsTransactionInputFile(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadManualCalculationsTransactionInputFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadManualCalculationsTransactionInputFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }

    uploadManualCalculationsTransactionInputFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      files?: FileParameter[] | undefined,
      httpContext?: HttpContext,
    ): Observable<UploadManualCalculationsTransactionInputsFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.UploadManualCalculationsTransactionInputFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (clientId === null || clientId === undefined)
        throw new Error("The parameter 'clientId' cannot be null.");
      else content_.append('ClientId', clientId.toString());
      if (calculationId === null || calculationId === undefined)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else content_.append('CalculationId', calculationId.toString());
      if (transactionGuid === null || transactionGuid === undefined)
        throw new Error("The parameter 'transactionGuid' cannot be null.");
      else content_.append('TransactionGuid', transactionGuid.toString());
      if (files === null || files === undefined)
        throw new Error("The parameter 'files' cannot be null.");
      else
        files.forEach((item_) =>
          content_.append(
            'Files',
            item_.data,
            item_.fileName ? item_.fileName : 'Files',
          ),
        );

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUploadManualCalculationsTransactionInputFile(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUploadManualCalculationsTransactionInputFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UploadManualCalculationsTransactionInputsFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UploadManualCalculationsTransactionInputsFileCommandResultSuccess>;
          }),
        );
    }

    protected processUploadManualCalculationsTransactionInputFile(
      response: HttpResponseBase,
    ): Observable<UploadManualCalculationsTransactionInputsFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UploadManualCalculationsTransactionInputsFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UploadManualCalculationsTransactionInputsFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UploadManualCalculationsTransactionInputsFileCommandResultSuccess>(
        null as any,
      );
    }

    deleteManualCalculationsTransactionInputsFile(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      transactionGuid?: string | undefined,
      fileName?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsTransactionInputsPage.DeleteManualCalculationsTransactionInputsFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      if (transactionGuid === null)
        throw new Error("The parameter 'transactionGuid' cannot be null.");
      else if (transactionGuid !== undefined)
        url_ +=
          'TransactionGuid=' + encodeURIComponent('' + transactionGuid) + '&';
      if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
      else if (fileName !== undefined)
        url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('delete', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteManualCalculationsTransactionInputsFile(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteManualCalculationsTransactionInputsFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteManualCalculationsTransactionInputsFile(
      response: HttpResponseBase,
    ): Observable<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteManualCalculationsTransactionInputsFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteManualCalculationsTransactionInputsFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteManualCalculationsTransactionInputsFileCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IManualCalculationsSummaryPageService {
    approveCalculation(
      command: ApproveCalculationFromSummaryPageCommand,
    ): Observable<ApproveCalculationFromSummaryPageCommandResultSuccess>;
    returnCalculation(
      command: ReturnCalculationFromSummaryPageCommand,
    ): Observable<ReturnCalculationFromSummaryPageCommandResultSuccess>;
    sendCalculationForApproval(
      command: SendCalculationForApprovalFromSummaryPageCommand,
    ): Observable<SendCalculationForApprovalFromSummaryPageCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ManualCalculationsSummaryPageService
    extends ApiBase
    implements IManualCalculationsSummaryPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    approveCalculation(
      command: ApproveCalculationFromSummaryPageCommand,
      httpContext?: HttpContext,
    ): Observable<ApproveCalculationFromSummaryPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsSummaryPage.ApproveCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processApproveCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processApproveCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ApproveCalculationFromSummaryPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ApproveCalculationFromSummaryPageCommandResultSuccess>;
          }),
        );
    }

    protected processApproveCalculation(
      response: HttpResponseBase,
    ): Observable<ApproveCalculationFromSummaryPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ApproveCalculationFromSummaryPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ApproveCalculationFromSummaryPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ApproveCalculationFromSummaryPageCommandResultSuccess>(
        null as any,
      );
    }

    returnCalculation(
      command: ReturnCalculationFromSummaryPageCommand,
      httpContext?: HttpContext,
    ): Observable<ReturnCalculationFromSummaryPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsSummaryPage.ReturnCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processReturnCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processReturnCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ReturnCalculationFromSummaryPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ReturnCalculationFromSummaryPageCommandResultSuccess>;
          }),
        );
    }

    protected processReturnCalculation(
      response: HttpResponseBase,
    ): Observable<ReturnCalculationFromSummaryPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ReturnCalculationFromSummaryPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ReturnCalculationFromSummaryPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ReturnCalculationFromSummaryPageCommandResultSuccess>(
        null as any,
      );
    }

    sendCalculationForApproval(
      command: SendCalculationForApprovalFromSummaryPageCommand,
      httpContext?: HttpContext,
    ): Observable<SendCalculationForApprovalFromSummaryPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsSummaryPage.SendCalculationForApproval';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSendCalculationForApproval(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSendCalculationForApproval(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SendCalculationForApprovalFromSummaryPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SendCalculationForApprovalFromSummaryPageCommandResultSuccess>;
          }),
        );
    }

    protected processSendCalculationForApproval(
      response: HttpResponseBase,
    ): Observable<SendCalculationForApprovalFromSummaryPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SendCalculationForApprovalFromSummaryPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SendCalculationForApprovalFromSummaryPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SendCalculationForApprovalFromSummaryPageCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IManualCalculationsPageService {
    getManualCalculationAggregations(
      clientId?: string | undefined,
    ): Observable<GetManualCalculationAggregationsQueryResultSuccess>;
    searchManualCalculations(
      command: SearchManualCalculationsCommand,
    ): Observable<SearchManualCalculationsCommandResultSuccess>;
    checkOutManualCalculation(
      command: CheckOutManualCalculationCommand,
    ): Observable<CheckOutManualCalculationCommandResultSuccess>;
    releaseManualCalculation(
      command: ReleaseManualCalculationCommand,
    ): Observable<ReleaseManualCalculationCommandResultSuccess>;
    sendManualCalculationForApproval(
      command: SendForApprovalFromManualCalculationsPageCommand,
    ): Observable<SendForApprovalFromManualCalculationsPageCommandResultSuccess>;
    returnManualCalculationToReviewer(
      command: ReturnCalculationFromManualCalculationsPageCommand,
    ): Observable<ReturnCalculationFromManualCalculationsPageCommandResultSuccess>;
    approveManualCalculation(
      command: ApproveCalculationFromManualCalculationsPageCommand,
    ): Observable<ApproveCalculationFromManualCalculationsPageCommandResultSuccess>;
    downloadManualCalculations(
      command: DownloadManualCalculationCommand,
    ): Observable<DownloadManualCalculationCommandResultSuccess>;
    getDownloadManualCalculationsDetailsByJobId(
      clientId?: string | undefined,
      jobId?: string | undefined,
    ): Observable<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ManualCalculationsPageService
    extends ApiBase
    implements IManualCalculationsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getManualCalculationAggregations(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetManualCalculationAggregationsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.GetManualCalculationAggregations?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetManualCalculationAggregations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetManualCalculationAggregations(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetManualCalculationAggregationsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetManualCalculationAggregationsQueryResultSuccess>;
          }),
        );
    }

    protected processGetManualCalculationAggregations(
      response: HttpResponseBase,
    ): Observable<GetManualCalculationAggregationsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetManualCalculationAggregationsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetManualCalculationAggregationsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetManualCalculationAggregationsQueryResultSuccess>(
        null as any,
      );
    }

    searchManualCalculations(
      command: SearchManualCalculationsCommand,
      httpContext?: HttpContext,
    ): Observable<SearchManualCalculationsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.SearchManualCalculations';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchManualCalculations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchManualCalculations(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchManualCalculationsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchManualCalculationsCommandResultSuccess>;
          }),
        );
    }

    protected processSearchManualCalculations(
      response: HttpResponseBase,
    ): Observable<SearchManualCalculationsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchManualCalculationsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchManualCalculationsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchManualCalculationsCommandResultSuccess>(
        null as any,
      );
    }

    checkOutManualCalculation(
      command: CheckOutManualCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<CheckOutManualCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.CheckOutManualCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCheckOutManualCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCheckOutManualCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CheckOutManualCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CheckOutManualCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processCheckOutManualCalculation(
      response: HttpResponseBase,
    ): Observable<CheckOutManualCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CheckOutManualCalculationCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CheckOutManualCalculationCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CheckOutManualCalculationCommandResultSuccess>(
        null as any,
      );
    }

    releaseManualCalculation(
      command: ReleaseManualCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<ReleaseManualCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.ReleaseManualCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processReleaseManualCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processReleaseManualCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ReleaseManualCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ReleaseManualCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processReleaseManualCalculation(
      response: HttpResponseBase,
    ): Observable<ReleaseManualCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ReleaseManualCalculationCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ReleaseManualCalculationCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ReleaseManualCalculationCommandResultSuccess>(
        null as any,
      );
    }

    sendManualCalculationForApproval(
      command: SendForApprovalFromManualCalculationsPageCommand,
      httpContext?: HttpContext,
    ): Observable<SendForApprovalFromManualCalculationsPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.SendManualCalculationForApproval';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSendManualCalculationForApproval(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSendManualCalculationForApproval(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SendForApprovalFromManualCalculationsPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SendForApprovalFromManualCalculationsPageCommandResultSuccess>;
          }),
        );
    }

    protected processSendManualCalculationForApproval(
      response: HttpResponseBase,
    ): Observable<SendForApprovalFromManualCalculationsPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SendForApprovalFromManualCalculationsPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SendForApprovalFromManualCalculationsPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SendForApprovalFromManualCalculationsPageCommandResultSuccess>(
        null as any,
      );
    }

    returnManualCalculationToReviewer(
      command: ReturnCalculationFromManualCalculationsPageCommand,
      httpContext?: HttpContext,
    ): Observable<ReturnCalculationFromManualCalculationsPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.ReturnManualCalculationToReviewer';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processReturnManualCalculationToReviewer(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processReturnManualCalculationToReviewer(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ReturnCalculationFromManualCalculationsPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ReturnCalculationFromManualCalculationsPageCommandResultSuccess>;
          }),
        );
    }

    protected processReturnManualCalculationToReviewer(
      response: HttpResponseBase,
    ): Observable<ReturnCalculationFromManualCalculationsPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ReturnCalculationFromManualCalculationsPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ReturnCalculationFromManualCalculationsPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ReturnCalculationFromManualCalculationsPageCommandResultSuccess>(
        null as any,
      );
    }

    approveManualCalculation(
      command: ApproveCalculationFromManualCalculationsPageCommand,
      httpContext?: HttpContext,
    ): Observable<ApproveCalculationFromManualCalculationsPageCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.ApproveManualCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processApproveManualCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processApproveManualCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ApproveCalculationFromManualCalculationsPageCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ApproveCalculationFromManualCalculationsPageCommandResultSuccess>;
          }),
        );
    }

    protected processApproveManualCalculation(
      response: HttpResponseBase,
    ): Observable<ApproveCalculationFromManualCalculationsPageCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ApproveCalculationFromManualCalculationsPageCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ApproveCalculationFromManualCalculationsPageCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ApproveCalculationFromManualCalculationsPageCommandResultSuccess>(
        null as any,
      );
    }

    downloadManualCalculations(
      command: DownloadManualCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadManualCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.DownloadManualCalculations';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadManualCalculations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadManualCalculations(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadManualCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadManualCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadManualCalculations(
      response: HttpResponseBase,
    ): Observable<DownloadManualCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadManualCalculationCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadManualCalculationCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadManualCalculationCommandResultSuccess>(
        null as any,
      );
    }

    getDownloadManualCalculationsDetailsByJobId(
      clientId?: string | undefined,
      jobId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ManualCalculationsPage.GetDownloadManualCalculationsDetailsByJobId?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (jobId === null)
        throw new Error("The parameter 'jobId' cannot be null.");
      else if (jobId !== undefined)
        url_ += 'JobId=' + encodeURIComponent('' + jobId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDownloadManualCalculationsDetailsByJobId(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDownloadManualCalculationsDetailsByJobId(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetDownloadManualCalculationsDetailsByJobId(
      response: HttpResponseBase,
    ): Observable<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDownloadManualCalculationsDetailsByJobIdQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IMobilityInformationPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetMobilityInformationPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class MobilityInformationPageService
    extends ApiBase
    implements IMobilityInformationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetMobilityInformationPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/MobilityInformationPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetMobilityInformationPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetMobilityInformationPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetMobilityInformationPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetMobilityInformationPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetMobilityInformationPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetMobilityInformationPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ITransactionInformationPageService {
    getTransactionInformationPageData(
      clientId?: string | undefined,
    ): Observable<GetTransactionInformationPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class TransactionInformationPageService
    extends ApiBase
    implements ITransactionInformationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getTransactionInformationPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetTransactionInformationPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/TransactionInformationPage.GetTransactionInformationPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetTransactionInformationPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTransactionInformationPageData(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetTransactionInformationPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetTransactionInformationPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetTransactionInformationPageData(
      response: HttpResponseBase,
    ): Observable<GetTransactionInformationPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetTransactionInformationPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetTransactionInformationPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetTransactionInformationPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ILocationPeriodPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetLocationPeriodPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class LocationPeriodPageService
    extends ApiBase
    implements ILocationPeriodPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetLocationPeriodPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/LocationPeriodPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetLocationPeriodPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetLocationPeriodPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetLocationPeriodPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetLocationPeriodPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetLocationPeriodPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetLocationPeriodPageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IEmployeeHypoProfilePageService {
    getPageData(
      clientId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetEmployeeHypoProfilePageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class EmployeeHypoProfilePageService
    extends ApiBase
    implements IEmployeeHypoProfilePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetEmployeeHypoProfilePageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/EmployeeHypoProfilePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetEmployeeHypoProfilePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetEmployeeHypoProfilePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetEmployeeHypoProfilePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetEmployeeHypoProfilePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetEmployeeHypoProfilePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetEmployeeHypoProfilePageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IFairMarketValueService {
    getFMVPageData(
      clientId?: string | undefined,
    ): Observable<GetFairMarketValuePageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class FairMarketValueService
    extends ApiBase
    implements IFairMarketValueService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getFMVPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetFairMarketValuePageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/FairMarketValue.GetFMVPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetFMVPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetFMVPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetFairMarketValuePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetFairMarketValuePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetFMVPageData(
      response: HttpResponseBase,
    ): Observable<GetFairMarketValuePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetFairMarketValuePageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetFairMarketValuePageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetFairMarketValuePageDataQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICustomTaxService {
    getCustomTaxPageData(
      clientId?: string | undefined,
    ): Observable<GetCustomTaxPageDataQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CustomTaxService extends ApiBase implements ICustomTaxService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCustomTaxPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCustomTaxPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/CustomTax.GetCustomTaxPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCustomTaxPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCustomTaxPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCustomTaxPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCustomTaxPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetCustomTaxPageData(
      response: HttpResponseBase,
    ): Observable<GetCustomTaxPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCustomTaxPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCustomTaxPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCustomTaxPageDataQueryResultSuccess>(null as any);
    }
  }

  export interface ICreateCalculationPageService {
    createCalculation(
      command: CreateCalculationCommand,
    ): Observable<CreateCalculationCommandResultSuccess>;
    cloneCalculation(
      command: CloneCalculationCommand,
    ): Observable<CloneCalculationCommandResultSuccess>;
    cloneCalculationToOriginalBatch(
      command: CloneCalculationToOriginalBatchCommand,
    ): Observable<CloneCalculationToOriginalBatchCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CreateCalculationPageService
    extends ApiBase
    implements ICreateCalculationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    createCalculation(
      command: CreateCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<CreateCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CreateCalculationPage.CreateCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCreateCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCreateCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CreateCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CreateCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processCreateCalculation(
      response: HttpResponseBase,
    ): Observable<CreateCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CreateCalculationCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CreateCalculationCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CreateCalculationCommandResultSuccess>(null as any);
    }

    cloneCalculation(
      command: CloneCalculationCommand,
      httpContext?: HttpContext,
    ): Observable<CloneCalculationCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CreateCalculationPage.CloneCalculation';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCloneCalculation(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCloneCalculation(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CloneCalculationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CloneCalculationCommandResultSuccess>;
          }),
        );
    }

    protected processCloneCalculation(
      response: HttpResponseBase,
    ): Observable<CloneCalculationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CloneCalculationCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CloneCalculationCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CloneCalculationCommandResultSuccess>(null as any);
    }

    cloneCalculationToOriginalBatch(
      command: CloneCalculationToOriginalBatchCommand,
      httpContext?: HttpContext,
    ): Observable<CloneCalculationToOriginalBatchCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CreateCalculationPage.CloneCalculationToOriginalBatch';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processCloneCalculationToOriginalBatch(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processCloneCalculationToOriginalBatch(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<CloneCalculationToOriginalBatchCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<CloneCalculationToOriginalBatchCommandResultSuccess>;
          }),
        );
    }

    protected processCloneCalculationToOriginalBatch(
      response: HttpResponseBase,
    ): Observable<CloneCalculationToOriginalBatchCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              CloneCalculationToOriginalBatchCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              CloneCalculationToOriginalBatchCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<CloneCalculationToOriginalBatchCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICalculationsSearchPageService {
    searchCalculations(
      q: SearchCalculationsCommand,
    ): Observable<SearchCalculationsCommandResultSuccess>;
    deleteCalculations(
      c: DeleteCalculationsCommand,
    ): Observable<DeleteCalculationsCommandResultSuccess>;
    getDeleteCalculationDeatils(
      c: GetDeleteCalculationDetailsByJobIdQuery,
    ): Observable<GetDeleteCalculationDetailsByJobIdQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CalculationsSearchPageService
    extends ApiBase
    implements ICalculationsSearchPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    searchCalculations(
      q: SearchCalculationsCommand,
      httpContext?: HttpContext,
    ): Observable<SearchCalculationsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationsSearchPage.SearchCalculations';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(q);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchCalculations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchCalculations(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchCalculationsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchCalculationsCommandResultSuccess>;
          }),
        );
    }

    protected processSearchCalculations(
      response: HttpResponseBase,
    ): Observable<SearchCalculationsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchCalculationsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchCalculationsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchCalculationsCommandResultSuccess>(null as any);
    }

    deleteCalculations(
      c: DeleteCalculationsCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteCalculationsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationsSearchPage.DeleteCalculations';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(c);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteCalculations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteCalculations(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteCalculationsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteCalculationsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteCalculations(
      response: HttpResponseBase,
    ): Observable<DeleteCalculationsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteCalculationsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteCalculationsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteCalculationsCommandResultSuccess>(null as any);
    }

    getDeleteCalculationDeatils(
      c: GetDeleteCalculationDetailsByJobIdQuery,
      httpContext?: HttpContext,
    ): Observable<GetDeleteCalculationDetailsByJobIdQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationsSearchPage.GetDeleteCalculationDeatils';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(c);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetDeleteCalculationDeatils(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetDeleteCalculationDeatils(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDeleteCalculationDetailsByJobIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDeleteCalculationDetailsByJobIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetDeleteCalculationDeatils(
      response: HttpResponseBase,
    ): Observable<GetDeleteCalculationDetailsByJobIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDeleteCalculationDetailsByJobIdQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDeleteCalculationDetailsByJobIdQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDeleteCalculationDetailsByJobIdQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICalculationContextService {
    getCalculationContextById(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationContextByIdQueryResultSuccess>;
    getCalculationAndPreProcessorInputs(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationAndPreProcessorInputsQueryResultSuccess>;
    getCalculationEngineInputs(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationEngineInputsQueryResultSuccess>;
    getCalculationEngineResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationEngineResultsQueryResultSuccess>;
    getCalculationEngineFailureResult(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationEngineFailureResultQueryResultSuccess>;
    getLatestFormattedInputsAndResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetLatestFormattedInputsAndResultsQueryResultSuccess>;
    getCalculationEngineOriginalResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationEngineOriginalResultsQueryResultSuccess>;
    recomputeCalculationResults(
      command: RecomputeCalculationResultsCommand,
    ): Observable<RecomputeCalculationResultsCommandResultSuccess>;
    recomputeFullCalculationResults(
      command: RecomputeFullCalculationResultsCommand,
    ): Observable<RecomputeFullCalculationResultsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CalculationContextService
    extends ApiBase
    implements ICalculationContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCalculationContextById(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationContextByIdQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationContextById?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationContextById(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationContextById(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationContextByIdQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationContextByIdQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationContextById(
      response: HttpResponseBase,
    ): Observable<GetCalculationContextByIdQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationContextByIdQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationContextByIdQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationContextByIdQueryResultSuccess>(
        null as any,
      );
    }

    getCalculationAndPreProcessorInputs(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationAndPreProcessorInputsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationAndPreProcessorInputs?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationAndPreProcessorInputs(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationAndPreProcessorInputs(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationAndPreProcessorInputsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationAndPreProcessorInputsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationAndPreProcessorInputs(
      response: HttpResponseBase,
    ): Observable<GetCalculationAndPreProcessorInputsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationAndPreProcessorInputsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationAndPreProcessorInputsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationAndPreProcessorInputsQueryResultSuccess>(
        null as any,
      );
    }

    getCalculationEngineInputs(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationEngineInputsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationEngineInputs?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationEngineInputs(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationEngineInputs(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationEngineInputsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationEngineInputsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationEngineInputs(
      response: HttpResponseBase,
    ): Observable<GetCalculationEngineInputsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationEngineInputsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationEngineInputsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationEngineInputsQueryResultSuccess>(
        null as any,
      );
    }

    getCalculationEngineResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationEngineResultsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationEngineResults?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationEngineResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationEngineResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationEngineResultsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationEngineResultsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationEngineResults(
      response: HttpResponseBase,
    ): Observable<GetCalculationEngineResultsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationEngineResultsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationEngineResultsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationEngineResultsQueryResultSuccess>(
        null as any,
      );
    }

    getCalculationEngineFailureResult(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationEngineFailureResultQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationEngineFailureResult?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationEngineFailureResult(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationEngineFailureResult(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationEngineFailureResultQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationEngineFailureResultQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationEngineFailureResult(
      response: HttpResponseBase,
    ): Observable<GetCalculationEngineFailureResultQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationEngineFailureResultQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationEngineFailureResultQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationEngineFailureResultQueryResultSuccess>(
        null as any,
      );
    }

    getLatestFormattedInputsAndResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetLatestFormattedInputsAndResultsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetLatestFormattedInputsAndResults?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetLatestFormattedInputsAndResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetLatestFormattedInputsAndResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetLatestFormattedInputsAndResultsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetLatestFormattedInputsAndResultsQueryResultSuccess>;
          }),
        );
    }

    protected processGetLatestFormattedInputsAndResults(
      response: HttpResponseBase,
    ): Observable<GetLatestFormattedInputsAndResultsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetLatestFormattedInputsAndResultsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetLatestFormattedInputsAndResultsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetLatestFormattedInputsAndResultsQueryResultSuccess>(
        null as any,
      );
    }

    getCalculationEngineOriginalResults(
      clientPortalId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationEngineOriginalResultsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.GetCalculationEngineOriginalResults?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculationEngineOriginalResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculationEngineOriginalResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationEngineOriginalResultsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationEngineOriginalResultsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculationEngineOriginalResults(
      response: HttpResponseBase,
    ): Observable<GetCalculationEngineOriginalResultsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationEngineOriginalResultsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationEngineOriginalResultsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationEngineOriginalResultsQueryResultSuccess>(
        null as any,
      );
    }

    recomputeCalculationResults(
      command: RecomputeCalculationResultsCommand,
      httpContext?: HttpContext,
    ): Observable<RecomputeCalculationResultsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.RecomputeCalculationResults';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processRecomputeCalculationResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processRecomputeCalculationResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<RecomputeCalculationResultsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<RecomputeCalculationResultsCommandResultSuccess>;
          }),
        );
    }

    protected processRecomputeCalculationResults(
      response: HttpResponseBase,
    ): Observable<RecomputeCalculationResultsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              RecomputeCalculationResultsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              RecomputeCalculationResultsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<RecomputeCalculationResultsCommandResultSuccess>(
        null as any,
      );
    }

    recomputeFullCalculationResults(
      command: RecomputeFullCalculationResultsCommand,
      httpContext?: HttpContext,
    ): Observable<RecomputeFullCalculationResultsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CalculationContext.RecomputeFullCalculationResults';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processRecomputeFullCalculationResults(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processRecomputeFullCalculationResults(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<RecomputeFullCalculationResultsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<RecomputeFullCalculationResultsCommandResultSuccess>;
          }),
        );
    }

    protected processRecomputeFullCalculationResults(
      response: HttpResponseBase,
    ): Observable<RecomputeFullCalculationResultsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              RecomputeFullCalculationResultsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              RecomputeFullCalculationResultsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<RecomputeFullCalculationResultsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBrokerPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetBrokerPageDataQueryResultSuccess>;
    saveClientBroker(
      request: SaveClientBrokerDetailsCommand,
    ): Observable<SaveClientBrokerDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BrokerPageService extends ApiBase implements IBrokerPageService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBrokerPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/BrokerPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBrokerPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBrokerPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetBrokerPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBrokerPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBrokerPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBrokerPageDataQueryResultSuccess>(null as any);
    }

    saveClientBroker(
      request: SaveClientBrokerDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<SaveClientBrokerDetailsCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/BrokerPage.SaveClientBroker';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(request);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSaveClientBroker(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSaveClientBroker(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SaveClientBrokerDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SaveClientBrokerDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processSaveClientBroker(
      response: HttpResponseBase,
    ): Observable<SaveClientBrokerDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SaveClientBrokerDetailsCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SaveClientBrokerDetailsCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SaveClientBrokerDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IClientDataService {
    getClientDataContext(
      query?: GetClientDataContextQuery | undefined,
    ): Observable<GetClientDataContextQueryResultSuccess>;
    getClientDataExportContext(
      clientId?: string | undefined,
    ): Observable<GetClientDataExportContextQueryResultSuccess>;
    exportClientData(
      clientId?: string | undefined,
    ): Observable<ExportClientDataCommandResultSuccess>;
    importClientPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
    ): Observable<ImportClientPIIDataCommandResultSuccess>;
    importClientNonPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess>;
    importNewClientPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
    ): Observable<ImportClientPIIDataCommandResultSuccess>;
    importNewClientNonPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ClientDataService extends ApiBase implements IClientDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientDataContext(
      query?: GetClientDataContextQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientDataContextQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientData.GetClientDataContext?';
      if (query === null)
        throw new Error("The parameter 'query' cannot be null.");
      else if (query !== undefined)
        url_ += 'query=' + encodeURIComponent('' + query) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientDataContext(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientDataContext(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientDataContextQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientDataContextQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientDataContext(
      response: HttpResponseBase,
    ): Observable<GetClientDataContextQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientDataContextQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientDataContextQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientDataContextQueryResultSuccess>(null as any);
    }

    getClientDataExportContext(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetClientDataExportContextQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientData.GetClientDataExportContext?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientDataExportContext(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientDataExportContext(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetClientDataExportContextQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetClientDataExportContextQueryResultSuccess>;
          }),
        );
    }

    protected processGetClientDataExportContext(
      response: HttpResponseBase,
    ): Observable<GetClientDataExportContextQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetClientDataExportContextQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetClientDataExportContextQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetClientDataExportContextQueryResultSuccess>(
        null as any,
      );
    }

    exportClientData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<ExportClientDataCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/ClientData.ExportClientData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processExportClientData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processExportClientData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ExportClientDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ExportClientDataCommandResultSuccess>;
          }),
        );
    }

    protected processExportClientData(
      response: HttpResponseBase,
    ): Observable<ExportClientDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ExportClientDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ExportClientDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ExportClientDataCommandResultSuccess>(null as any);
    }

    importClientPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<ImportClientPIIDataCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/ClientData.ImportClientPIIData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
      else
        content_.append(
          'File',
          file.data,
          file.fileName ? file.fileName : 'File',
        );
      if (clientPortalId !== null && clientPortalId !== undefined)
        content_.append('ClientPortalId', clientPortalId.toString());

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processImportClientPIIData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processImportClientPIIData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ImportClientPIIDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ImportClientPIIDataCommandResultSuccess>;
          }),
        );
    }

    protected processImportClientPIIData(
      response: HttpResponseBase,
    ): Observable<ImportClientPIIDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ImportClientPIIDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ImportClientPIIDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ImportClientPIIDataCommandResultSuccess>(
        null as any,
      );
    }

    importClientNonPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientData.ImportClientNonPIIData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
      else
        content_.append(
          'File',
          file.data,
          file.fileName ? file.fileName : 'File',
        );
      if (clientPortalId !== null && clientPortalId !== undefined)
        content_.append('ClientPortalId', clientPortalId.toString());

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processImportClientNonPIIData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processImportClientNonPIIData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ImportClientNonPIIDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ImportClientNonPIIDataCommandResultSuccess>;
          }),
        );
    }

    protected processImportClientNonPIIData(
      response: HttpResponseBase,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ImportClientNonPIIDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ImportClientNonPIIDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ImportClientNonPIIDataCommandResultSuccess>(
        null as any,
      );
    }

    importNewClientPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<ImportClientPIIDataCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientData.ImportNewClientPIIData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
      else
        content_.append(
          'File',
          file.data,
          file.fileName ? file.fileName : 'File',
        );
      if (clientPortalId !== null && clientPortalId !== undefined)
        content_.append('ClientPortalId', clientPortalId.toString());

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processImportNewClientPIIData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processImportNewClientPIIData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ImportClientPIIDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ImportClientPIIDataCommandResultSuccess>;
          }),
        );
    }

    protected processImportNewClientPIIData(
      response: HttpResponseBase,
    ): Observable<ImportClientPIIDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ImportClientPIIDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ImportClientPIIDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ImportClientPIIDataCommandResultSuccess>(
        null as any,
      );
    }

    importNewClientNonPIIData(
      file?: FileParameter | undefined,
      clientPortalId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ClientData.ImportNewClientNonPIIData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
      else
        content_.append(
          'File',
          file.data,
          file.fileName ? file.fileName : 'File',
        );
      if (clientPortalId !== null && clientPortalId !== undefined)
        content_.append('ClientPortalId', clientPortalId.toString());

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processImportNewClientNonPIIData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processImportNewClientNonPIIData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ImportClientNonPIIDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ImportClientNonPIIDataCommandResultSuccess>;
          }),
        );
    }

    protected processImportNewClientNonPIIData(
      response: HttpResponseBase,
    ): Observable<ImportClientNonPIIDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              ImportClientNonPIIDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              ImportClientNonPIIDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<ImportClientNonPIIDataCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICashPaymentPolicyPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetCashPaymentPolicyPageDataQueryResultSuccess>;
    upsertCashPaymentPolicySettings(
      command: UpsertCashPaymentPolicySettingsCommand,
    ): Observable<UpsertCashPaymentPolicySettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CashPaymentPolicyPageService
    extends ApiBase
    implements ICashPaymentPolicyPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCashPaymentPolicyPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CashPaymentPolicyPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCashPaymentPolicyPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCashPaymentPolicyPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCashPaymentPolicyPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCashPaymentPolicyPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCashPaymentPolicyPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCashPaymentPolicyPageDataQueryResultSuccess>(
        null as any,
      );
    }

    upsertCashPaymentPolicySettings(
      command: UpsertCashPaymentPolicySettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCashPaymentPolicySettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentPolicyPage.UpsertCashPaymentPolicySettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertCashPaymentPolicySettings(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertCashPaymentPolicySettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCashPaymentPolicySettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCashPaymentPolicySettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertCashPaymentPolicySettings(
      response: HttpResponseBase,
    ): Observable<UpsertCashPaymentPolicySettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCashPaymentPolicySettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCashPaymentPolicySettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCashPaymentPolicySettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICashPaymentCountryAmountsService {
    getPageData(
      clientId?: string | undefined,
      cashPaymentCountryAmountSettingsId?: string | null | undefined,
    ): Observable<GetCashPaymentCountryAmountPageDataQueryResultSuccess>;
    getCashPaymentCountryAmounts(
      clientId?: string | undefined,
    ): Observable<GetCountryAmountCashPaymentsQueryResultSuccess>;
    upsertCashPaymentCountryAmountSettings(
      command: UpsertCashPaymentCountryAmountSettingsCommand,
    ): Observable<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess>;
    deleteCashPaymentPolicySetting(
      command: DeleteCashPaymentCountryAmountSettingsCommand,
    ): Observable<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CashPaymentCountryAmountsService
    extends ApiBase
    implements ICashPaymentCountryAmountsService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      cashPaymentCountryAmountSettingsId?: string | null | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCashPaymentCountryAmountPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CashPaymentCountryAmounts.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (
        cashPaymentCountryAmountSettingsId !== undefined &&
        cashPaymentCountryAmountSettingsId !== null
      )
        url_ +=
          'CashPaymentCountryAmountSettingsId=' +
          encodeURIComponent('' + cashPaymentCountryAmountSettingsId) +
          '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCashPaymentCountryAmountPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCashPaymentCountryAmountPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetCashPaymentCountryAmountPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCashPaymentCountryAmountPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCashPaymentCountryAmountPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCashPaymentCountryAmountPageDataQueryResultSuccess>(
        null as any,
      );
    }

    getCashPaymentCountryAmounts(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCountryAmountCashPaymentsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentCountryAmounts.GetCashPaymentCountryAmounts?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCashPaymentCountryAmounts(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCashPaymentCountryAmounts(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCountryAmountCashPaymentsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCountryAmountCashPaymentsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCashPaymentCountryAmounts(
      response: HttpResponseBase,
    ): Observable<GetCountryAmountCashPaymentsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCountryAmountCashPaymentsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCountryAmountCashPaymentsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCountryAmountCashPaymentsQueryResultSuccess>(
        null as any,
      );
    }

    upsertCashPaymentCountryAmountSettings(
      command: UpsertCashPaymentCountryAmountSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentCountryAmounts.UpsertCashPaymentCountryAmountSettings';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertCashPaymentCountryAmountSettings(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertCashPaymentCountryAmountSettings(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertCashPaymentCountryAmountSettings(
      response: HttpResponseBase,
    ): Observable<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertCashPaymentCountryAmountSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertCashPaymentCountryAmountSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertCashPaymentCountryAmountSettingsCommandResultSuccess>(
        null as any,
      );
    }

    deleteCashPaymentPolicySetting(
      command: DeleteCashPaymentCountryAmountSettingsCommand,
      httpContext?: HttpContext,
    ): Observable<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/CashPaymentCountryAmounts.DeleteCashPaymentPolicySetting';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDeleteCashPaymentPolicySetting(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDeleteCashPaymentPolicySetting(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess>;
          }),
        );
    }

    protected processDeleteCashPaymentPolicySetting(
      response: HttpResponseBase,
    ): Observable<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DeleteCashPaymentCountryAmountSettingsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DeleteCashPaymentCountryAmountSettingsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DeleteCashPaymentCountryAmountSettingsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface ICalculationAuditLogPageService {
    getAuditLog(
      clientId?: string | undefined,
      calculationId?: string | undefined,
    ): Observable<GetCalculationAuditLogQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class CalculationAuditLogPageService
    extends ApiBase
    implements ICalculationAuditLogPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getAuditLog(
      clientId?: string | undefined,
      calculationId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCalculationAuditLogQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/CalculationAuditLogPage.GetAuditLog?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (calculationId === null)
        throw new Error("The parameter 'calculationId' cannot be null.");
      else if (calculationId !== undefined)
        url_ += 'CalculationId=' + encodeURIComponent('' + calculationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetAuditLog(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetAuditLog(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCalculationAuditLogQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCalculationAuditLogQueryResultSuccess>;
          }),
        );
    }

    protected processGetAuditLog(
      response: HttpResponseBase,
    ): Observable<GetCalculationAuditLogQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCalculationAuditLogQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCalculationAuditLogQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCalculationAuditLogQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBatchInputFilesService {
    getBatchInputFilesPageData(
      batchId?: string | undefined,
      clientId?: string | undefined,
    ): Observable<GetBatchInputFilesPageDataQueryResultSuccess>;
    getBatchInputFilePreSignedUrlForDownload(
      command: GetBatchInputFilePreSignedUrlForDownloadCommand,
    ): Observable<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchInputFilesService
    extends ApiBase
    implements IBatchInputFilesService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getBatchInputFilesPageData(
      batchId?: string | undefined,
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchInputFilesPageDataQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/BatchInputFiles.GetBatchInputFilesPageData?';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchInputFilesPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchInputFilesPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchInputFilesPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchInputFilesPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchInputFilesPageData(
      response: HttpResponseBase,
    ): Observable<GetBatchInputFilesPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchInputFilesPageDataQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchInputFilesPageDataQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchInputFilesPageDataQueryResultSuccess>(
        null as any,
      );
    }

    getBatchInputFilePreSignedUrlForDownload(
      command: GetBatchInputFilePreSignedUrlForDownloadCommand,
      httpContext?: HttpContext,
    ): Observable<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/BatchInputFiles.GetBatchInputFilePreSignedUrlForDownload';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchInputFilePreSignedUrlForDownload(
              response_,
            );
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchInputFilePreSignedUrlForDownload(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess>;
          }),
        );
    }

    protected processGetBatchInputFilePreSignedUrlForDownload(
      response: HttpResponseBase,
    ): Observable<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchInputFilePreSignedUrlForDownloadCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBatchIndexPageService {
    getClientBatches(
      command: SearchClientBatchesCommand,
    ): Observable<SearchClientBatchesCommandResultSuccess>;
    markBatchesForDeletion(
      command: MarkBatchesForDeletionCommand,
    ): Observable<MarkBatchesForDeletionCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchIndexPageService
    extends ApiBase
    implements IBatchIndexPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getClientBatches(
      command: SearchClientBatchesCommand,
      httpContext?: HttpContext,
    ): Observable<SearchClientBatchesCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/BatchIndexPage.GetClientBatches';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetClientBatches(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetClientBatches(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchClientBatchesCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchClientBatchesCommandResultSuccess>;
          }),
        );
    }

    protected processGetClientBatches(
      response: HttpResponseBase,
    ): Observable<SearchClientBatchesCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchClientBatchesCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchClientBatchesCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchClientBatchesCommandResultSuccess>(
        null as any,
      );
    }

    markBatchesForDeletion(
      command: MarkBatchesForDeletionCommand,
      httpContext?: HttpContext,
    ): Observable<MarkBatchesForDeletionCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/BatchIndexPage.MarkBatchesForDeletion';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processMarkBatchesForDeletion(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processMarkBatchesForDeletion(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<MarkBatchesForDeletionCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<MarkBatchesForDeletionCommandResultSuccess>;
          }),
        );
    }

    protected processMarkBatchesForDeletion(
      response: HttpResponseBase,
    ): Observable<MarkBatchesForDeletionCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              MarkBatchesForDeletionCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              MarkBatchesForDeletionCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<MarkBatchesForDeletionCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBatchIdsDropdownComponentService {
    searchBatchIds(
      command: SearchBatchIdsDropdownCommand,
    ): Observable<SearchBatchIdsDropdownCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchIdsDropdownComponentService
    extends ApiBase
    implements IBatchIdsDropdownComponentService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    searchBatchIds(
      command: SearchBatchIdsDropdownCommand,
      httpContext?: HttpContext,
    ): Observable<SearchBatchIdsDropdownCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/BatchIdsDropdownComponent.SearchBatchIds';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processSearchBatchIds(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSearchBatchIds(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<SearchBatchIdsDropdownCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<SearchBatchIdsDropdownCommandResultSuccess>;
          }),
        );
    }

    protected processSearchBatchIds(
      response: HttpResponseBase,
    ): Observable<SearchBatchIdsDropdownCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              SearchBatchIdsDropdownCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              SearchBatchIdsDropdownCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<SearchBatchIdsDropdownCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBatchCalculationsPageService {
    getCalculations(
      clientId?: string | undefined,
      batchId?: string | undefined,
      status?: CalculationStatus | null | undefined,
      filterByStatus?: CalculationStatus[] | undefined,
      page?: number | undefined,
      pageSize?: number | undefined,
      sortBy_Field?: CalculationIndexSortableFields | undefined,
      sortBy_Direction?: SortDirection | undefined,
    ): Observable<GetBatchCalculationsQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchCalculationsPageService
    extends ApiBase
    implements IBatchCalculationsPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCalculations(
      clientId?: string | undefined,
      batchId?: string | undefined,
      status?: CalculationStatus | null | undefined,
      filterByStatus?: CalculationStatus[] | undefined,
      page?: number | undefined,
      pageSize?: number | undefined,
      sortBy_Field?: CalculationIndexSortableFields | undefined,
      sortBy_Direction?: SortDirection | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchCalculationsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/BatchCalculationsPage.GetCalculations?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      if (status !== undefined && status !== null)
        url_ += 'Status=' + encodeURIComponent('' + status) + '&';
      if (filterByStatus === null)
        throw new Error("The parameter 'filterByStatus' cannot be null.");
      else if (filterByStatus !== undefined)
        filterByStatus &&
          filterByStatus.forEach((item) => {
            url_ += 'FilterByStatus=' + encodeURIComponent('' + item) + '&';
          });
      if (page === null)
        throw new Error("The parameter 'page' cannot be null.");
      else if (page !== undefined)
        url_ += 'Page=' + encodeURIComponent('' + page) + '&';
      if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
        url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
      if (sortBy_Field === null)
        throw new Error("The parameter 'sortBy_Field' cannot be null.");
      else if (sortBy_Field !== undefined)
        url_ += 'SortBy.Field=' + encodeURIComponent('' + sortBy_Field) + '&';
      if (sortBy_Direction === null)
        throw new Error("The parameter 'sortBy_Direction' cannot be null.");
      else if (sortBy_Direction !== undefined)
        url_ +=
          'SortBy.Direction=' + encodeURIComponent('' + sortBy_Direction) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCalculations(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCalculations(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchCalculationsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchCalculationsQueryResultSuccess>;
          }),
        );
    }

    protected processGetCalculations(
      response: HttpResponseBase,
    ): Observable<GetBatchCalculationsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchCalculationsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchCalculationsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchCalculationsQueryResultSuccess>(null as any);
    }
  }

  export interface IBatchContextService {
    getBatchContext(
      clientPortalId?: string | undefined,
      batchId?: string | undefined,
    ): Observable<GetBatchContextQueryResultSuccess>;
    downloadBatchFile(
      clientId?: string | undefined,
      batchId?: string | undefined,
    ): Observable<string>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchContextService
    extends ApiBase
    implements IBatchContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getBatchContext(
      clientPortalId?: string | undefined,
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchContextQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/BatchContext.GetBatchContext?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchContext(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchContext(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchContextQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchContextQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchContext(
      response: HttpResponseBase,
    ): Observable<GetBatchContextQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBatchContextQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetBatchContextQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchContextQueryResultSuccess>(null as any);
    }

    downloadBatchFile(
      clientId?: string | undefined,
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<string> {
      let url_ = this.baseUrl + '/core-bff-api/BatchContext.DownloadBatchFile?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadBatchFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadBatchFile(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<string>;
              }
            } else
              return _observableThrow(response_) as any as Observable<string>;
          }),
        );
    }

    protected processDownloadBatchFile(
      response: HttpResponseBase,
    ): Observable<string> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<string>(null as any);
    }
  }

  export interface IBatchCalculationErrorySummaryPageService {
    getBatchCalculationErrors(
      clientId?: string | undefined,
      batchId?: string | undefined,
    ): Observable<GetBatchCalculationErrorSummaryQueryResultSuccess>;
    downloadBatchCalculationErrorsFile(
      command: DownloadBatchCalculationErrorsFileCommand,
    ): Observable<DownloadBatchCalculationErrorsFileCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchCalculationErrorySummaryPageService
    extends ApiBase
    implements IBatchCalculationErrorySummaryPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getBatchCalculationErrors(
      clientId?: string | undefined,
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchCalculationErrorSummaryQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/BatchCalculationErrorySummaryPage.GetBatchCalculationErrors?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetBatchCalculationErrors(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetBatchCalculationErrors(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchCalculationErrorSummaryQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchCalculationErrorSummaryQueryResultSuccess>;
          }),
        );
    }

    protected processGetBatchCalculationErrors(
      response: HttpResponseBase,
    ): Observable<GetBatchCalculationErrorSummaryQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchCalculationErrorSummaryQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchCalculationErrorSummaryQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchCalculationErrorSummaryQueryResultSuccess>(
        null as any,
      );
    }

    downloadBatchCalculationErrorsFile(
      command: DownloadBatchCalculationErrorsFileCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadBatchCalculationErrorsFileCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/BatchCalculationErrorySummaryPage.DownloadBatchCalculationErrorsFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadBatchCalculationErrorsFile(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadBatchCalculationErrorsFile(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadBatchCalculationErrorsFileCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadBatchCalculationErrorsFileCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadBatchCalculationErrorsFile(
      response: HttpResponseBase,
    ): Observable<DownloadBatchCalculationErrorsFileCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadBatchCalculationErrorsFileCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadBatchCalculationErrorsFileCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadBatchCalculationErrorsFileCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IBatchAuditLogPageService {
    getAuditLog(
      clientId?: string | undefined,
      batchId?: string | undefined,
    ): Observable<GetBatchAuditLogQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class BatchAuditLogPageService
    extends ApiBase
    implements IBatchAuditLogPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getAuditLog(
      clientId?: string | undefined,
      batchId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetBatchAuditLogQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/BatchAuditLogPage.GetAuditLog?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      if (batchId === null)
        throw new Error("The parameter 'batchId' cannot be null.");
      else if (batchId !== undefined)
        url_ += 'BatchId=' + encodeURIComponent('' + batchId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetAuditLog(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetAuditLog(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetBatchAuditLogQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetBatchAuditLogQueryResultSuccess>;
          }),
        );
    }

    protected processGetAuditLog(
      response: HttpResponseBase,
    ): Observable<GetBatchAuditLogQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetBatchAuditLogQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetBatchAuditLogQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetBatchAuditLogQueryResultSuccess>(null as any);
    }
  }

  export interface IApplicationContextService {
    get(): Observable<ApplicationContextDto>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ApplicationContextService
    extends ApiBase
    implements IApplicationContextService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    get(httpContext?: HttpContext): Observable<ApplicationContextDto> {
      let url_ = this.baseUrl + '/core-bff-api/ApplicationContext.Get';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGet(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGet(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<ApplicationContextDto>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<ApplicationContextDto>;
          }),
        );
    }

    protected processGet(
      response: HttpResponseBase,
    ): Observable<ApplicationContextDto> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ApplicationContextDto.fromJS(resultDatadefault);
            return _observableOf(resultdefault);
          }),
        );
      }
    }
  }

  export interface IAdminService {
    getCodeBaseVersion(
      query?: GetCodeBaseVersionQuery | undefined,
    ): Observable<GetCodeBaseVersionQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class AdminService extends ApiBase implements IAdminService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getCodeBaseVersion(
      query?: GetCodeBaseVersionQuery | undefined,
      httpContext?: HttpContext,
    ): Observable<GetCodeBaseVersionQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/Admin.GetCodeBaseVersion?';
      if (query === null)
        throw new Error("The parameter 'query' cannot be null.");
      else if (query !== undefined)
        url_ += 'query=' + encodeURIComponent('' + query) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetCodeBaseVersion(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetCodeBaseVersion(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetCodeBaseVersionQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetCodeBaseVersionQueryResultSuccess>;
          }),
        );
    }

    protected processGetCodeBaseVersion(
      response: HttpResponseBase,
    ): Observable<GetCodeBaseVersionQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetCodeBaseVersionQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetCodeBaseVersionQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetCodeBaseVersionQueryResultSuccess>(null as any);
    }
  }

  export interface IPromotionAccessPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetPromotionAccessDetailsQueryResultSuccess>;
    upsertPromotionAccessDetails(
      command: UpsertPromotionAccessDetailsCommand,
    ): Observable<UpsertPromotionAccessDetailsCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class PromotionAccessPageService
    extends ApiBase
    implements IPromotionAccessPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetPromotionAccessDetailsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/PromotionAccessPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetPromotionAccessDetailsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetPromotionAccessDetailsQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetPromotionAccessDetailsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetPromotionAccessDetailsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetPromotionAccessDetailsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetPromotionAccessDetailsQueryResultSuccess>(
        null as any,
      );
    }

    upsertPromotionAccessDetails(
      command: UpsertPromotionAccessDetailsCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertPromotionAccessDetailsCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/PromotionAccessPage.UpsertPromotionAccessDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertPromotionAccessDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertPromotionAccessDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertPromotionAccessDetailsCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertPromotionAccessDetailsCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertPromotionAccessDetails(
      response: HttpResponseBase,
    ): Observable<UpsertPromotionAccessDetailsCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertPromotionAccessDetailsCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertPromotionAccessDetailsCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertPromotionAccessDetailsCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IOverridePageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetOverridePageDataQueryResultSuccess>;
    promoteOverride(
      command: PromoteOverrideCommand,
    ): Observable<PromoteOverrideCommandResultSuccess>;
    upsertOverrideData(
      command: UpsertOverrideDataCommand,
    ): Observable<UpsertOverrideDataCommandResultSuccess>;
    getOverridePromotions(
      clientPortalId?: string | undefined,
    ): Observable<GetOverridePromotionsQueryResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class OverridePageService
    extends ApiBase
    implements IOverridePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetOverridePageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/OverridePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetOverridePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetOverridePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetOverridePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetOverridePageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetOverridePageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetOverridePageDataQueryResultSuccess>(null as any);
    }

    promoteOverride(
      command: PromoteOverrideCommand,
      httpContext?: HttpContext,
    ): Observable<PromoteOverrideCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/OverridePage.PromoteOverride';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPromoteOverride(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPromoteOverride(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PromoteOverrideCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PromoteOverrideCommandResultSuccess>;
          }),
        );
    }

    protected processPromoteOverride(
      response: HttpResponseBase,
    ): Observable<PromoteOverrideCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              PromoteOverrideCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              PromoteOverrideCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PromoteOverrideCommandResultSuccess>(null as any);
    }

    upsertOverrideData(
      command: UpsertOverrideDataCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertOverrideDataCommandResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/OverridePage.UpsertOverrideData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertOverrideData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertOverrideData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertOverrideDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertOverrideDataCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertOverrideData(
      response: HttpResponseBase,
    ): Observable<UpsertOverrideDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertOverrideDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertOverrideDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertOverrideDataCommandResultSuccess>(null as any);
    }

    getOverridePromotions(
      clientPortalId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetOverridePromotionsQueryResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/OverridePage.GetOverridePromotions?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetOverridePromotions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetOverridePromotions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetOverridePromotionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetOverridePromotionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetOverridePromotions(
      response: HttpResponseBase,
    ): Observable<GetOverridePromotionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetOverridePromotionsQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetOverridePromotionsQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetOverridePromotionsQueryResultSuccess>(
        null as any,
      );
    }
  }

  export interface IConfigurationPageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetConfigurationPageDataQueryResultSuccess>;
    promoteConfiguration(
      command: PromoteConfigurationCommand,
    ): Observable<PromoteConfigurationCommandResultSuccess>;
    upsertConfigurationData(
      command: UpsertConfigurationDataCommand,
    ): Observable<UpsertConfigurationDataCommandResultSuccess>;
    getConfigurationPromotions(
      clientPortalId?: string | undefined,
    ): Observable<GetConfigurationPromotionsQueryResultSuccess>;
    downloadConfigurationSummaryDetails(
      query: DownloadPromotionConfigurationSummaryCommand,
    ): Observable<DownloadPromotionConfigurationSummaryCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class ConfigurationPageService
    extends ApiBase
    implements IConfigurationPageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetConfigurationPageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/ConfigurationPage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetConfigurationPageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetConfigurationPageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetConfigurationPageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetConfigurationPageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetConfigurationPageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetConfigurationPageDataQueryResultSuccess>(
        null as any,
      );
    }

    promoteConfiguration(
      command: PromoteConfigurationCommand,
      httpContext?: HttpContext,
    ): Observable<PromoteConfigurationCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/ConfigurationPage.PromoteConfiguration';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPromoteConfiguration(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPromoteConfiguration(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PromoteConfigurationCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PromoteConfigurationCommandResultSuccess>;
          }),
        );
    }

    protected processPromoteConfiguration(
      response: HttpResponseBase,
    ): Observable<PromoteConfigurationCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              PromoteConfigurationCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              PromoteConfigurationCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PromoteConfigurationCommandResultSuccess>(
        null as any,
      );
    }

    upsertConfigurationData(
      command: UpsertConfigurationDataCommand,
      httpContext?: HttpContext,
    ): Observable<UpsertConfigurationDataCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ConfigurationPage.UpsertConfigurationData';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processUpsertConfigurationData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpsertConfigurationData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<UpsertConfigurationDataCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<UpsertConfigurationDataCommandResultSuccess>;
          }),
        );
    }

    protected processUpsertConfigurationData(
      response: HttpResponseBase,
    ): Observable<UpsertConfigurationDataCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              UpsertConfigurationDataCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              UpsertConfigurationDataCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<UpsertConfigurationDataCommandResultSuccess>(
        null as any,
      );
    }

    getConfigurationPromotions(
      clientPortalId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetConfigurationPromotionsQueryResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ConfigurationPage.GetConfigurationPromotions?';
      if (clientPortalId === null)
        throw new Error("The parameter 'clientPortalId' cannot be null.");
      else if (clientPortalId !== undefined)
        url_ +=
          'ClientPortalId=' + encodeURIComponent('' + clientPortalId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetConfigurationPromotions(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetConfigurationPromotions(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetConfigurationPromotionsQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetConfigurationPromotionsQueryResultSuccess>;
          }),
        );
    }

    protected processGetConfigurationPromotions(
      response: HttpResponseBase,
    ): Observable<GetConfigurationPromotionsQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetConfigurationPromotionsQueryResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetConfigurationPromotionsQueryResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetConfigurationPromotionsQueryResultSuccess>(
        null as any,
      );
    }

    downloadConfigurationSummaryDetails(
      query: DownloadPromotionConfigurationSummaryCommand,
      httpContext?: HttpContext,
    ): Observable<DownloadPromotionConfigurationSummaryCommandResultSuccess> {
      let url_ =
        this.baseUrl +
        '/core-bff-api/ConfigurationPage.DownloadConfigurationSummaryDetails';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(query);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadConfigurationSummaryDetails(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processDownloadConfigurationSummaryDetails(
                  response_ as any,
                );
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<DownloadPromotionConfigurationSummaryCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<DownloadPromotionConfigurationSummaryCommandResultSuccess>;
          }),
        );
    }

    protected processDownloadConfigurationSummaryDetails(
      response: HttpResponseBase,
    ): Observable<DownloadPromotionConfigurationSummaryCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              DownloadPromotionConfigurationSummaryCommandResultSuccess.fromJS(
                resultData200,
              );
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              DownloadPromotionConfigurationSummaryCommandResultFailure.fromJS(
                resultData400,
              );
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<DownloadPromotionConfigurationSummaryCommandResultSuccess>(
        null as any,
      );
    }
  }

  export interface IDataExchangePageService {
    getPageData(
      clientId?: string | undefined,
    ): Observable<GetDataExchangePageDataQueryResultSuccess>;
    promoteDataExchange(
      command: PromoteDataExchangeCommand,
    ): Observable<PromoteDataExchangeCommandResultSuccess>;
  }

  @Injectable({
    providedIn: 'root',
  })
  export class DataExchangePageService
    extends ApiBase
    implements IDataExchangePageService
  {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
      undefined;

    constructor(
      @Inject(ApiConfig) configuration: ApiConfig,
      @Inject(HttpClient) http: HttpClient,
      @Optional() @Inject(API_BASE_URL) baseUrl?: string,
    ) {
      super(configuration);
      this.http = http;
      this.baseUrl = baseUrl ?? '';
    }

    getPageData(
      clientId?: string | undefined,
      httpContext?: HttpContext,
    ): Observable<GetDataExchangePageDataQueryResultSuccess> {
      let url_ = this.baseUrl + '/core-bff-api/DataExchangePage.GetPageData?';
      if (clientId === null)
        throw new Error("The parameter 'clientId' cannot be null.");
      else if (clientId !== undefined)
        url_ += 'ClientId=' + encodeURIComponent('' + clientId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: any = {
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('get', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processGetPageData(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetPageData(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<GetDataExchangePageDataQueryResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<GetDataExchangePageDataQueryResultSuccess>;
          }),
        );
    }

    protected processGetPageData(
      response: HttpResponseBase,
    ): Observable<GetDataExchangePageDataQueryResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              GetDataExchangePageDataQueryResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              GetDataExchangePageDataQueryResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<GetDataExchangePageDataQueryResultSuccess>(
        null as any,
      );
    }

    promoteDataExchange(
      command: PromoteDataExchangeCommand,
      httpContext?: HttpContext,
    ): Observable<PromoteDataExchangeCommandResultSuccess> {
      let url_ =
        this.baseUrl + '/core-bff-api/DataExchangePage.PromoteDataExchange';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(command);

      let options_: any = {
        body: content_,
        observe: 'response',
        responseType: 'blob',
        context: httpContext,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),
      };

      return _observableFrom(this.transformOptions(options_))
        .pipe(
          _observableMergeMap((transformedOptions_) => {
            return this.http.request('post', url_, transformedOptions_);
          }),
        )
        .pipe(
          _observableMergeMap((response_: any) => {
            return this.processPromoteDataExchange(response_);
          }),
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPromoteDataExchange(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e,
                ) as any as Observable<PromoteDataExchangeCommandResultSuccess>;
              }
            } else
              return _observableThrow(
                response_,
              ) as any as Observable<PromoteDataExchangeCommandResultSuccess>;
          }),
        );
    }

    protected processPromoteDataExchange(
      response: HttpResponseBase,
    ): Observable<PromoteDataExchangeCommandResultSuccess> {
      const status = response.status;
      const responseBlob =
        response instanceof HttpResponse
          ? response.body
          : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;

      let _headers: any = {};
      if (response.headers) {
        for (let key of response.headers.keys()) {
          _headers[key] = response.headers.get(key);
        }
      }
      if (status === 200) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result200: any = null;
            let resultData200 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result200 =
              PromoteDataExchangeCommandResultSuccess.fromJS(resultData200);
            return _observableOf(result200);
          }),
        );
      } else if (status === 400) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            let result400: any = null;
            let resultData400 =
              _responseText === ''
                ? null
                : JSON.parse(_responseText, this.jsonParseReviver);
            result400 =
              PromoteDataExchangeCommandResultFailure.fromJS(resultData400);
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
              result400,
            );
          }),
        );
      } else if (status === 403) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'A server side error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      } else if (status !== 200 && status !== 204) {
        return blobToText(responseBlob).pipe(
          _observableMergeMap((_responseText) => {
            return throwException(
              'An unexpected server error occurred.',
              status,
              _responseText,
              _headers,
            );
          }),
        );
      }
      return _observableOf<PromoteDataExchangeCommandResultSuccess>(
        null as any,
      );
    }
  }

  export class DownloadExchangeRateTransactionFileTemplateCommandResult
    implements IDownloadExchangeRateTransactionFileTemplateCommandResult
  {
    constructor(
      data?: IDownloadExchangeRateTransactionFileTemplateCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DownloadExchangeRateTransactionFileTemplateCommandResult {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadExchangeRateTransactionFileTemplateCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadExchangeRateTransactionFileTemplateCommandResult {}

  export class DownloadExchangeRateTransactionFileTemplateCommandResultSuccess
    extends DownloadExchangeRateTransactionFileTemplateCommandResult
    implements IDownloadExchangeRateTransactionFileTemplateCommandResultSuccess
  {
    result!: string;

    constructor(
      data?: IDownloadExchangeRateTransactionFileTemplateCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadExchangeRateTransactionFileTemplateCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadExchangeRateTransactionFileTemplateCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadExchangeRateTransactionFileTemplateCommandResultSuccess
    extends IDownloadExchangeRateTransactionFileTemplateCommandResult {
    result: string;
  }

  export class DownloadExchangeRateTransactionFileTemplateCommandResultFailure
    extends DownloadExchangeRateTransactionFileTemplateCommandResult
    implements IDownloadExchangeRateTransactionFileTemplateCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IDownloadExchangeRateTransactionFileTemplateCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadExchangeRateTransactionFileTemplateCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadExchangeRateTransactionFileTemplateCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadExchangeRateTransactionFileTemplateCommandResultFailure
    extends IDownloadExchangeRateTransactionFileTemplateCommandResult {
    errors: ResultError[];
  }

  export class ResultError implements IResultError {
    code!: string;
    message!: string;

    constructor(data?: IResultError) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.message =
          _data['message'] !== undefined ? _data['message'] : <any>null;
      }
    }

    static fromJS(data: any): ResultError {
      data = typeof data === 'object' ? data : {};
      let result = new ResultError();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['message'] = this.message !== undefined ? this.message : <any>null;
      return data;
    }
  }

  export interface IResultError {
    code: string;
    message: string;
  }

  export class UploadExchangeRateTransactionFileCommandResult
    implements IUploadExchangeRateTransactionFileCommandResult
  {
    constructor(data?: IUploadExchangeRateTransactionFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadExchangeRateTransactionFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadExchangeRateTransactionFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadExchangeRateTransactionFileCommandResult {}

  export class UploadExchangeRateTransactionFileCommandResultSuccess
    extends UploadExchangeRateTransactionFileCommandResult
    implements IUploadExchangeRateTransactionFileCommandResultSuccess
  {
    constructor(data?: IUploadExchangeRateTransactionFileCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UploadExchangeRateTransactionFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadExchangeRateTransactionFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadExchangeRateTransactionFileCommandResultSuccess
    extends IUploadExchangeRateTransactionFileCommandResult {}

  export class UploadExchangeRateTransactionFileCommandResultFailure
    extends UploadExchangeRateTransactionFileCommandResult
    implements IUploadExchangeRateTransactionFileCommandResultFailure
  {
    errors!: ExcelValidationErrorDto[];

    constructor(data?: IUploadExchangeRateTransactionFileCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ExcelValidationErrorDto.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UploadExchangeRateTransactionFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadExchangeRateTransactionFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadExchangeRateTransactionFileCommandResultFailure
    extends IUploadExchangeRateTransactionFileCommandResult {
    errors: ExcelValidationErrorDto[];
  }

  export class ExcelValidationErrorDto implements IExcelValidationErrorDto {
    sheetName!: string | null;
    rowNumber!: string | null;
    cellName!: string | null;
    errorMessage!: string;

    constructor(data?: IExcelValidationErrorDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.sheetName =
          _data['sheetName'] !== undefined ? _data['sheetName'] : <any>null;
        this.rowNumber =
          _data['rowNumber'] !== undefined ? _data['rowNumber'] : <any>null;
        this.cellName =
          _data['cellName'] !== undefined ? _data['cellName'] : <any>null;
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static fromJS(data: any): ExcelValidationErrorDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExcelValidationErrorDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['sheetName'] =
        this.sheetName !== undefined ? this.sheetName : <any>null;
      data['rowNumber'] =
        this.rowNumber !== undefined ? this.rowNumber : <any>null;
      data['cellName'] =
        this.cellName !== undefined ? this.cellName : <any>null;
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      return data;
    }
  }

  export interface IExcelValidationErrorDto {
    sheetName: string | null;
    rowNumber: string | null;
    cellName: string | null;
    errorMessage: string;
  }

  export abstract class GetExchangeRateTransactionDetailsQueryResult
    implements IGetExchangeRateTransactionDetailsQueryResult
  {
    constructor(data?: IGetExchangeRateTransactionDetailsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetExchangeRateTransactionDetailsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetExchangeRateTransactionDetailsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetExchangeRateTransactionDetailsQueryResult {}

  export class GetExchangeRateTransactionDetailsQueryResultSuccess
    extends GetExchangeRateTransactionDetailsQueryResult
    implements IGetExchangeRateTransactionDetailsQueryResultSuccess
  {
    clientProvidedExchangeRateDetailsDto!: ClientProvidedExchangeRateDetailsDto | null;

    constructor(data?: IGetExchangeRateTransactionDetailsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientProvidedExchangeRateDetailsDto = _data[
          'clientProvidedExchangeRateDetailsDto'
        ]
          ? ClientProvidedExchangeRateDetailsDto.fromJS(
              _data['clientProvidedExchangeRateDetailsDto'],
            )
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetExchangeRateTransactionDetailsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeRateTransactionDetailsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientProvidedExchangeRateDetailsDto'] = this
        .clientProvidedExchangeRateDetailsDto
        ? this.clientProvidedExchangeRateDetailsDto.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeRateTransactionDetailsQueryResultSuccess
    extends IGetExchangeRateTransactionDetailsQueryResult {
    clientProvidedExchangeRateDetailsDto: ClientProvidedExchangeRateDetailsDto | null;
  }

  export class ClientProvidedExchangeRateDetailsDto
    implements IClientProvidedExchangeRateDetailsDto
  {
    clientId!: string;
    fileName!: string;
    uploadDate!: Date;

    constructor(data?: IClientProvidedExchangeRateDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.uploadDate = _data['uploadDate']
          ? new Date(_data['uploadDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ClientProvidedExchangeRateDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientProvidedExchangeRateDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['uploadDate'] = this.uploadDate
        ? this.uploadDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IClientProvidedExchangeRateDetailsDto {
    clientId: string;
    fileName: string;
    uploadDate: Date;
  }

  export class GetExchangeRateTransactionDetailsQueryResultFailure
    extends GetExchangeRateTransactionDetailsQueryResult
    implements IGetExchangeRateTransactionDetailsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetExchangeRateTransactionDetailsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetExchangeRateTransactionDetailsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeRateTransactionDetailsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeRateTransactionDetailsQueryResultFailure
    extends IGetExchangeRateTransactionDetailsQueryResult {
    errorMessage: string;
  }

  export class GetUpsertPolicyExceptionPageDataQueryResult
    implements IGetUpsertPolicyExceptionPageDataQueryResult
  {
    constructor(data?: IGetUpsertPolicyExceptionPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetUpsertPolicyExceptionPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetUpsertPolicyExceptionPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetUpsertPolicyExceptionPageDataQueryResult {}

  export class GetUpsertPolicyExceptionPageDataQueryResultSuccess
    extends GetUpsertPolicyExceptionPageDataQueryResult
    implements IGetUpsertPolicyExceptionPageDataQueryResultSuccess
  {
    result!: UpsertPolicyExceptionPageData;

    constructor(data?: IGetUpsertPolicyExceptionPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new UpsertPolicyExceptionPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? UpsertPolicyExceptionPageData.fromJS(_data['result'])
          : new UpsertPolicyExceptionPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetUpsertPolicyExceptionPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetUpsertPolicyExceptionPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetUpsertPolicyExceptionPageDataQueryResultSuccess
    extends IGetUpsertPolicyExceptionPageDataQueryResult {
    result: UpsertPolicyExceptionPageData;
  }

  export class UpsertPolicyExceptionPageData
    implements IUpsertPolicyExceptionPageData
  {
    countriesInFootprint!: PolicyExceptionsCountryDto[];
    planTypes!: PolicyExceptionPlanTypeDto[];
    planCodes!: PolicyExceptionsPlanCodeDto[];
    workLocationTypes!: PolicyExceptionWorkLocationTypeDto[];
    clientWorkLocationTypes!: PolicyExceptionsClientWorkLocationTypeDto[];
    policyException!: PolicyExceptionDto | null;

    constructor(data?: IUpsertPolicyExceptionPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.planTypes = [];
        this.planCodes = [];
        this.workLocationTypes = [];
        this.clientWorkLocationTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              PolicyExceptionsCountryDto.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PolicyExceptionPlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['planCodes'])) {
          this.planCodes = [] as any;
          for (let item of _data['planCodes'])
            this.planCodes!.push(PolicyExceptionsPlanCodeDto.fromJS(item));
        } else {
          this.planCodes = <any>null;
        }
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(
              PolicyExceptionWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.workLocationTypes = <any>null;
        }
        if (Array.isArray(_data['clientWorkLocationTypes'])) {
          this.clientWorkLocationTypes = [] as any;
          for (let item of _data['clientWorkLocationTypes'])
            this.clientWorkLocationTypes!.push(
              PolicyExceptionsClientWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.clientWorkLocationTypes = <any>null;
        }
        this.policyException = _data['policyException']
          ? PolicyExceptionDto.fromJS(_data['policyException'])
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertPolicyExceptionPageData {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPolicyExceptionPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.planCodes)) {
        data['planCodes'] = [];
        for (let item of this.planCodes) data['planCodes'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.clientWorkLocationTypes)) {
        data['clientWorkLocationTypes'] = [];
        for (let item of this.clientWorkLocationTypes)
          data['clientWorkLocationTypes'].push(item.toJSON());
      }
      data['policyException'] = this.policyException
        ? this.policyException.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertPolicyExceptionPageData {
    countriesInFootprint: PolicyExceptionsCountryDto[];
    planTypes: PolicyExceptionPlanTypeDto[];
    planCodes: PolicyExceptionsPlanCodeDto[];
    workLocationTypes: PolicyExceptionWorkLocationTypeDto[];
    clientWorkLocationTypes: PolicyExceptionsClientWorkLocationTypeDto[];
    policyException: PolicyExceptionDto | null;
  }

  export class PolicyExceptionsCountryDto
    implements IPolicyExceptionsCountryDto
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IPolicyExceptionsCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): PolicyExceptionsCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionsCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IPolicyExceptionsCountryDto {
    countryCode: string;
    countryName: string;
  }

  export class PolicyExceptionPlanTypeDto
    implements IPolicyExceptionPlanTypeDto
  {
    display!: string;
    code!: PlanType;

    constructor(data?: IPolicyExceptionPlanTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PolicyExceptionPlanTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionPlanTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPolicyExceptionPlanTypeDto {
    display: string;
    code: PlanType;
  }

  export enum PlanType {
    RestrictedStockUnit = 'RestrictedStockUnit',
    StockOption = 'StockOption',
    CashBonus = 'CashBonus',
  }

  export class PolicyExceptionsPlanCodeDto
    implements IPolicyExceptionsPlanCodeDto
  {
    id!: string;
    code!: string;

    constructor(data?: IPolicyExceptionsPlanCodeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PolicyExceptionsPlanCodeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionsPlanCodeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPolicyExceptionsPlanCodeDto {
    id: string;
    code: string;
  }

  export class PolicyExceptionWorkLocationTypeDto
    implements IPolicyExceptionWorkLocationTypeDto
  {
    display!: string;
    code!: WorkLocationTypeSetting;

    constructor(data?: IPolicyExceptionWorkLocationTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PolicyExceptionWorkLocationTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionWorkLocationTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPolicyExceptionWorkLocationTypeDto {
    display: string;
    code: WorkLocationTypeSetting;
  }

  export enum WorkLocationTypeSetting {
    LongTermAssignment = 'LongTermAssignment',
    RemoteWorker = 'RemoteWorker',
    Local = 'Local',
  }

  export class PolicyExceptionsClientWorkLocationTypeDto
    implements IPolicyExceptionsClientWorkLocationTypeDto
  {
    id!: string;
    name!: string;

    constructor(data?: IPolicyExceptionsClientWorkLocationTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): PolicyExceptionsClientWorkLocationTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionsClientWorkLocationTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IPolicyExceptionsClientWorkLocationTypeDto {
    id: string;
    name: string;
  }

  export class PolicyExceptionDto implements IPolicyExceptionDto {
    id!: string;
    exceptionType!: ExceptionType;
    allCountries!: boolean;
    selectedCountries!: string[];
    planTypes!: PlanType[];
    planCodeIds!: string[];
    workLocationTypes!: WorkLocationTypeSetting[];
    clientWorkLocationTypeIds!: string[];
    values!: string[];

    constructor(data?: IPolicyExceptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.selectedCountries = [];
        this.planTypes = [];
        this.planCodeIds = [];
        this.workLocationTypes = [];
        this.clientWorkLocationTypeIds = [];
        this.values = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.exceptionType =
          _data['exceptionType'] !== undefined
            ? _data['exceptionType']
            : <any>null;
        this.allCountries =
          _data['allCountries'] !== undefined
            ? _data['allCountries']
            : <any>null;
        if (Array.isArray(_data['selectedCountries'])) {
          this.selectedCountries = [] as any;
          for (let item of _data['selectedCountries'])
            this.selectedCountries!.push(item);
        } else {
          this.selectedCountries = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['planCodeIds'])) {
          this.planCodeIds = [] as any;
          for (let item of _data['planCodeIds']) this.planCodeIds!.push(item);
        } else {
          this.planCodeIds = <any>null;
        }
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(item);
        } else {
          this.workLocationTypes = <any>null;
        }
        if (Array.isArray(_data['clientWorkLocationTypeIds'])) {
          this.clientWorkLocationTypeIds = [] as any;
          for (let item of _data['clientWorkLocationTypeIds'])
            this.clientWorkLocationTypeIds!.push(item);
        } else {
          this.clientWorkLocationTypeIds = <any>null;
        }
        if (Array.isArray(_data['values'])) {
          this.values = [] as any;
          for (let item of _data['values']) this.values!.push(item);
        } else {
          this.values = <any>null;
        }
      }
    }

    static fromJS(data: any): PolicyExceptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyExceptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['exceptionType'] =
        this.exceptionType !== undefined ? this.exceptionType : <any>null;
      data['allCountries'] =
        this.allCountries !== undefined ? this.allCountries : <any>null;
      if (Array.isArray(this.selectedCountries)) {
        data['selectedCountries'] = [];
        for (let item of this.selectedCountries)
          data['selectedCountries'].push(item);
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.planCodeIds)) {
        data['planCodeIds'] = [];
        for (let item of this.planCodeIds) data['planCodeIds'].push(item);
      }
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item);
      }
      if (Array.isArray(this.clientWorkLocationTypeIds)) {
        data['clientWorkLocationTypeIds'] = [];
        for (let item of this.clientWorkLocationTypeIds)
          data['clientWorkLocationTypeIds'].push(item);
      }
      if (Array.isArray(this.values)) {
        data['values'] = [];
        for (let item of this.values) data['values'].push(item);
      }
      return data;
    }
  }

  export interface IPolicyExceptionDto {
    id: string;
    exceptionType: ExceptionType;
    allCountries: boolean;
    selectedCountries: string[];
    planTypes: PlanType[];
    planCodeIds: string[];
    workLocationTypes: WorkLocationTypeSetting[];
    clientWorkLocationTypeIds: string[];
    values: string[];
  }

  export enum ExceptionType {
    GrossUp = 'GrossUp',
    TaxesToGrossUp = 'TaxesToGrossUp',
    HypotheticalTaxDeduction = 'HypotheticalTaxDeduction',
  }

  export class GetUpsertPolicyExceptionPageDataQueryResultFailure
    extends GetUpsertPolicyExceptionPageDataQueryResult
    implements IGetUpsertPolicyExceptionPageDataQueryResultFailure
  {
    constructor(data?: IGetUpsertPolicyExceptionPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetUpsertPolicyExceptionPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetUpsertPolicyExceptionPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetUpsertPolicyExceptionPageDataQueryResultFailure
    extends IGetUpsertPolicyExceptionPageDataQueryResult {}

  export enum ConfigurationPageType {
    TEQClientSettings = 'TEQClientSettings',
  }

  export class UpsertPolicyExceptionCommandResult
    implements IUpsertPolicyExceptionCommandResult
  {
    constructor(data?: IUpsertPolicyExceptionCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertPolicyExceptionCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPolicyExceptionCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertPolicyExceptionCommandResult {}

  export class UpsertPolicyExceptionCommandResultSuccess
    extends UpsertPolicyExceptionCommandResult
    implements IUpsertPolicyExceptionCommandResultSuccess
  {
    policyException!: PolicyExceptionDto;

    constructor(data?: IUpsertPolicyExceptionCommandResultSuccess) {
      super(data);
      if (!data) {
        this.policyException = new PolicyExceptionDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.policyException = _data['policyException']
          ? PolicyExceptionDto.fromJS(_data['policyException'])
          : new PolicyExceptionDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpsertPolicyExceptionCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPolicyExceptionCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policyException'] = this.policyException
        ? this.policyException.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPolicyExceptionCommandResultSuccess
    extends IUpsertPolicyExceptionCommandResult {
    policyException: PolicyExceptionDto;
  }

  export class UpsertPolicyExceptionCommandResultFailure
    extends UpsertPolicyExceptionCommandResult
    implements IUpsertPolicyExceptionCommandResultFailure
  {
    constructor(data?: IUpsertPolicyExceptionCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertPolicyExceptionCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPolicyExceptionCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPolicyExceptionCommandResultFailure
    extends IUpsertPolicyExceptionCommandResult {}

  export class UpsertPolicyExceptionCommand
    implements IUpsertPolicyExceptionCommand
  {
    clientId!: string;
    configurationPageType!: ConfigurationPageType;
    exceptionType!: ExceptionType;
    policyExceptionId!: string | null;
    allCountries!: boolean;
    selectedCountries!: string[];
    planTypes!: PlanType[];
    planCodeIds!: string[];
    workLocationTypes!: WorkLocationTypeSetting[];
    clientWorkLocationTypeIds!: string[];
    values!: string[];

    constructor(data?: IUpsertPolicyExceptionCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.selectedCountries = [];
        this.planTypes = [];
        this.planCodeIds = [];
        this.workLocationTypes = [];
        this.clientWorkLocationTypeIds = [];
        this.values = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.configurationPageType =
          _data['configurationPageType'] !== undefined
            ? _data['configurationPageType']
            : <any>null;
        this.exceptionType =
          _data['exceptionType'] !== undefined
            ? _data['exceptionType']
            : <any>null;
        this.policyExceptionId =
          _data['policyExceptionId'] !== undefined
            ? _data['policyExceptionId']
            : <any>null;
        this.allCountries =
          _data['allCountries'] !== undefined
            ? _data['allCountries']
            : <any>null;
        if (Array.isArray(_data['selectedCountries'])) {
          this.selectedCountries = [] as any;
          for (let item of _data['selectedCountries'])
            this.selectedCountries!.push(item);
        } else {
          this.selectedCountries = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['planCodeIds'])) {
          this.planCodeIds = [] as any;
          for (let item of _data['planCodeIds']) this.planCodeIds!.push(item);
        } else {
          this.planCodeIds = <any>null;
        }
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(item);
        } else {
          this.workLocationTypes = <any>null;
        }
        if (Array.isArray(_data['clientWorkLocationTypeIds'])) {
          this.clientWorkLocationTypeIds = [] as any;
          for (let item of _data['clientWorkLocationTypeIds'])
            this.clientWorkLocationTypeIds!.push(item);
        } else {
          this.clientWorkLocationTypeIds = <any>null;
        }
        if (Array.isArray(_data['values'])) {
          this.values = [] as any;
          for (let item of _data['values']) this.values!.push(item);
        } else {
          this.values = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertPolicyExceptionCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPolicyExceptionCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['configurationPageType'] =
        this.configurationPageType !== undefined
          ? this.configurationPageType
          : <any>null;
      data['exceptionType'] =
        this.exceptionType !== undefined ? this.exceptionType : <any>null;
      data['policyExceptionId'] =
        this.policyExceptionId !== undefined
          ? this.policyExceptionId
          : <any>null;
      data['allCountries'] =
        this.allCountries !== undefined ? this.allCountries : <any>null;
      if (Array.isArray(this.selectedCountries)) {
        data['selectedCountries'] = [];
        for (let item of this.selectedCountries)
          data['selectedCountries'].push(item);
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.planCodeIds)) {
        data['planCodeIds'] = [];
        for (let item of this.planCodeIds) data['planCodeIds'].push(item);
      }
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item);
      }
      if (Array.isArray(this.clientWorkLocationTypeIds)) {
        data['clientWorkLocationTypeIds'] = [];
        for (let item of this.clientWorkLocationTypeIds)
          data['clientWorkLocationTypeIds'].push(item);
      }
      if (Array.isArray(this.values)) {
        data['values'] = [];
        for (let item of this.values) data['values'].push(item);
      }
      return data;
    }
  }

  export interface IUpsertPolicyExceptionCommand {
    clientId: string;
    configurationPageType: ConfigurationPageType;
    exceptionType: ExceptionType;
    policyExceptionId: string | null;
    allCountries: boolean;
    selectedCountries: string[];
    planTypes: PlanType[];
    planCodeIds: string[];
    workLocationTypes: WorkLocationTypeSetting[];
    clientWorkLocationTypeIds: string[];
    values: string[];
  }

  export class DeletePolicyExceptionCommandResult
    implements IDeletePolicyExceptionCommandResult
  {
    constructor(data?: IDeletePolicyExceptionCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeletePolicyExceptionCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeletePolicyExceptionCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeletePolicyExceptionCommandResult {}

  export class DeletePolicyExceptionCommandResultSuccess
    extends DeletePolicyExceptionCommandResult
    implements IDeletePolicyExceptionCommandResultSuccess
  {
    constructor(data?: IDeletePolicyExceptionCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeletePolicyExceptionCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeletePolicyExceptionCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeletePolicyExceptionCommandResultSuccess
    extends IDeletePolicyExceptionCommandResult {}

  export class DeletePolicyExceptionCommandResultFailure
    extends DeletePolicyExceptionCommandResult
    implements IDeletePolicyExceptionCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeletePolicyExceptionCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeletePolicyExceptionCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeletePolicyExceptionCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeletePolicyExceptionCommandResultFailure
    extends IDeletePolicyExceptionCommandResult {
    errors: ResultError[];
  }

  export class GetViewPolicyExceptionsPageDataQueryResult
    implements IGetViewPolicyExceptionsPageDataQueryResult
  {
    constructor(data?: IGetViewPolicyExceptionsPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetViewPolicyExceptionsPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetViewPolicyExceptionsPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetViewPolicyExceptionsPageDataQueryResult {}

  export class GetViewPolicyExceptionsPageDataQueryResultSuccess
    extends GetViewPolicyExceptionsPageDataQueryResult
    implements IGetViewPolicyExceptionsPageDataQueryResultSuccess
  {
    pageData!: ViewPolicyExceptionsPageData;

    constructor(data?: IGetViewPolicyExceptionsPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.pageData = new ViewPolicyExceptionsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.pageData = _data['pageData']
          ? ViewPolicyExceptionsPageData.fromJS(_data['pageData'])
          : new ViewPolicyExceptionsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetViewPolicyExceptionsPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetViewPolicyExceptionsPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pageData'] = this.pageData ? this.pageData.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetViewPolicyExceptionsPageDataQueryResultSuccess
    extends IGetViewPolicyExceptionsPageDataQueryResult {
    pageData: ViewPolicyExceptionsPageData;
  }

  export class ViewPolicyExceptionsPageData
    implements IViewPolicyExceptionsPageData
  {
    countriesInFootprint!: PolicyExceptionsCountryDto[];
    planTypes!: PolicyExceptionPlanTypeDto[];
    planCodes!: PolicyExceptionsPlanCodeDto[];
    workLocationTypes!: PolicyExceptionWorkLocationTypeDto[];
    clientWorkLocationTypes!: PolicyExceptionsClientWorkLocationTypeDto[];

    constructor(data?: IViewPolicyExceptionsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.planTypes = [];
        this.planCodes = [];
        this.workLocationTypes = [];
        this.clientWorkLocationTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              PolicyExceptionsCountryDto.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PolicyExceptionPlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['planCodes'])) {
          this.planCodes = [] as any;
          for (let item of _data['planCodes'])
            this.planCodes!.push(PolicyExceptionsPlanCodeDto.fromJS(item));
        } else {
          this.planCodes = <any>null;
        }
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(
              PolicyExceptionWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.workLocationTypes = <any>null;
        }
        if (Array.isArray(_data['clientWorkLocationTypes'])) {
          this.clientWorkLocationTypes = [] as any;
          for (let item of _data['clientWorkLocationTypes'])
            this.clientWorkLocationTypes!.push(
              PolicyExceptionsClientWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.clientWorkLocationTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): ViewPolicyExceptionsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ViewPolicyExceptionsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.planCodes)) {
        data['planCodes'] = [];
        for (let item of this.planCodes) data['planCodes'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.clientWorkLocationTypes)) {
        data['clientWorkLocationTypes'] = [];
        for (let item of this.clientWorkLocationTypes)
          data['clientWorkLocationTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IViewPolicyExceptionsPageData {
    countriesInFootprint: PolicyExceptionsCountryDto[];
    planTypes: PolicyExceptionPlanTypeDto[];
    planCodes: PolicyExceptionsPlanCodeDto[];
    workLocationTypes: PolicyExceptionWorkLocationTypeDto[];
    clientWorkLocationTypes: PolicyExceptionsClientWorkLocationTypeDto[];
  }

  export class GetViewPolicyExceptionsPageDataQueryResultFailure
    extends GetViewPolicyExceptionsPageDataQueryResult
    implements IGetViewPolicyExceptionsPageDataQueryResultFailure
  {
    constructor(data?: IGetViewPolicyExceptionsPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetViewPolicyExceptionsPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetViewPolicyExceptionsPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetViewPolicyExceptionsPageDataQueryResultFailure
    extends IGetViewPolicyExceptionsPageDataQueryResult {}

  export abstract class GetVirusScanningJobsStatusQueryResult
    implements IGetVirusScanningJobsStatusQueryResult
  {
    constructor(data?: IGetVirusScanningJobsStatusQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetVirusScanningJobsStatusQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetVirusScanningJobsStatusQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetVirusScanningJobsStatusQueryResult {}

  export class GetVirusScanningJobsStatusQueryResultSuccess
    extends GetVirusScanningJobsStatusQueryResult
    implements IGetVirusScanningJobsStatusQueryResultSuccess
  {
    virusScanningJobs!: VirusScanningJobDto[];

    constructor(data?: IGetVirusScanningJobsStatusQueryResultSuccess) {
      super(data);
      if (!data) {
        this.virusScanningJobs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['virusScanningJobs'])) {
          this.virusScanningJobs = [] as any;
          for (let item of _data['virusScanningJobs'])
            this.virusScanningJobs!.push(VirusScanningJobDto.fromJS(item));
        } else {
          this.virusScanningJobs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetVirusScanningJobsStatusQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetVirusScanningJobsStatusQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.virusScanningJobs)) {
        data['virusScanningJobs'] = [];
        for (let item of this.virusScanningJobs)
          data['virusScanningJobs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetVirusScanningJobsStatusQueryResultSuccess
    extends IGetVirusScanningJobsStatusQueryResult {
    virusScanningJobs: VirusScanningJobDto[];
  }

  export class VirusScanningJobDto implements IVirusScanningJobDto {
    jobId!: string;
    status!: VirusScanningJobStatus;

    constructor(data?: IVirusScanningJobDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.jobId = _data['jobId'] !== undefined ? _data['jobId'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
      }
    }

    static fromJS(data: any): VirusScanningJobDto {
      data = typeof data === 'object' ? data : {};
      let result = new VirusScanningJobDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['jobId'] = this.jobId !== undefined ? this.jobId : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      return data;
    }
  }

  export interface IVirusScanningJobDto {
    jobId: string;
    status: VirusScanningJobStatus;
  }

  export enum VirusScanningJobStatus {
    New = 'New',
    ScanSuccess = 'ScanSuccess',
    ScanFail = 'ScanFail',
    Error = 'Error',
  }

  export class GetVirusScanningJobsStatusQueryResultFailure
    extends GetVirusScanningJobsStatusQueryResult
    implements IGetVirusScanningJobsStatusQueryResultFailure
  {
    constructor(data?: IGetVirusScanningJobsStatusQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetVirusScanningJobsStatusQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetVirusScanningJobsStatusQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetVirusScanningJobsStatusQueryResultFailure
    extends IGetVirusScanningJobsStatusQueryResult {}

  export abstract class GetUserContextQueryResult
    implements IGetUserContextQueryResult
  {
    constructor(data?: IGetUserContextQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetUserContextQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetUserContextQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetUserContextQueryResult {}

  export class GetUserContextQueryResultSuccess
    extends GetUserContextQueryResult
    implements IGetUserContextQueryResultSuccess
  {
    userContext!: GainUserContextDto;

    constructor(data?: IGetUserContextQueryResultSuccess) {
      super(data);
      if (!data) {
        this.userContext = new GainUserContextDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.userContext = _data['userContext']
          ? GainUserContextDto.fromJS(_data['userContext'])
          : new GainUserContextDto();
      }
    }

    static override fromJS(data: any): GetUserContextQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetUserContextQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userContext'] = this.userContext
        ? this.userContext.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetUserContextQueryResultSuccess
    extends IGetUserContextQueryResult {
    userContext: GainUserContextDto;
  }

  export class GainUserContextDto implements IGainUserContextDto {
    portalId!: string;
    firstName!: string | null;
    lastName!: string | null;
    email!: string | null;
    applicationRoles!: string[];
    clientRoles!: GainUserClientRoleDto[];
    canEnrollClient!: boolean;

    constructor(data?: IGainUserContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.applicationRoles = [];
        this.clientRoles = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        if (Array.isArray(_data['applicationRoles'])) {
          this.applicationRoles = [] as any;
          for (let item of _data['applicationRoles'])
            this.applicationRoles!.push(item);
        } else {
          this.applicationRoles = <any>null;
        }
        if (Array.isArray(_data['clientRoles'])) {
          this.clientRoles = [] as any;
          for (let item of _data['clientRoles'])
            this.clientRoles!.push(GainUserClientRoleDto.fromJS(item));
        } else {
          this.clientRoles = <any>null;
        }
        this.canEnrollClient =
          _data['canEnrollClient'] !== undefined
            ? _data['canEnrollClient']
            : <any>null;
      }
    }

    static fromJS(data: any): GainUserContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new GainUserContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      if (Array.isArray(this.applicationRoles)) {
        data['applicationRoles'] = [];
        for (let item of this.applicationRoles)
          data['applicationRoles'].push(item);
      }
      if (Array.isArray(this.clientRoles)) {
        data['clientRoles'] = [];
        for (let item of this.clientRoles)
          data['clientRoles'].push(item.toJSON());
      }
      data['canEnrollClient'] =
        this.canEnrollClient !== undefined ? this.canEnrollClient : <any>null;
      return data;
    }
  }

  export interface IGainUserContextDto {
    portalId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    applicationRoles: string[];
    clientRoles: GainUserClientRoleDto[];
    canEnrollClient: boolean;
  }

  export class GainUserClientRoleDto implements IGainUserClientRoleDto {
    clientId!: string;
    role!: ClientRole;
    canApproveManualCalculations!: boolean;

    constructor(data?: IGainUserClientRoleDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.role = _data['role'] !== undefined ? _data['role'] : <any>null;
        this.canApproveManualCalculations =
          _data['canApproveManualCalculations'] !== undefined
            ? _data['canApproveManualCalculations']
            : <any>null;
      }
    }

    static fromJS(data: any): GainUserClientRoleDto {
      data = typeof data === 'object' ? data : {};
      let result = new GainUserClientRoleDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['role'] = this.role !== undefined ? this.role : <any>null;
      data['canApproveManualCalculations'] =
        this.canApproveManualCalculations !== undefined
          ? this.canApproveManualCalculations
          : <any>null;
      return data;
    }
  }

  export interface IGainUserClientRoleDto {
    clientId: string;
    role: ClientRole;
    canApproveManualCalculations: boolean;
  }

  export enum ClientRole {
    EngagementLead = 'EngagementLead',
    EngagementMember = 'EngagementMember',
  }

  export class GetUserContextQueryResultFailure
    extends GetUserContextQueryResult
    implements IGetUserContextQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetUserContextQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetUserContextQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetUserContextQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetUserContextQueryResultFailure
    extends IGetUserContextQueryResult {
    errorMessage: string;
  }

  export class GetUserContextQuery implements IGetUserContextQuery {
    constructor(data?: IGetUserContextQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetUserContextQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetUserContextQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetUserContextQuery {}

  export class GetTeqSettingsByWorkLocationTypeQueryResult
    implements IGetTeqSettingsByWorkLocationTypeQueryResult
  {
    constructor(data?: IGetTeqSettingsByWorkLocationTypeQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTeqSettingsByWorkLocationTypeQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqSettingsByWorkLocationTypeQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTeqSettingsByWorkLocationTypeQueryResult {}

  export class GetTeqSettingsByWorkLocationQueryResultSuccess
    extends GetTeqSettingsByWorkLocationTypeQueryResult
    implements IGetTeqSettingsByWorkLocationQueryResultSuccess
  {
    result!: TeqWorkLocationSettingsPageData;

    constructor(data?: IGetTeqSettingsByWorkLocationQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TeqWorkLocationSettingsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TeqWorkLocationSettingsPageData.fromJS(_data['result'])
          : new TeqWorkLocationSettingsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTeqSettingsByWorkLocationQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqSettingsByWorkLocationQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqSettingsByWorkLocationQueryResultSuccess
    extends IGetTeqSettingsByWorkLocationTypeQueryResult {
    result: TeqWorkLocationSettingsPageData;
  }

  export class TeqWorkLocationSettingsPageData
    implements ITeqWorkLocationSettingsPageData
  {
    workLocationTaxTypeDto!: WorkLocationTaxTypeDto[];
    workLocationHypothethicalTaxOptionDto!: WorkLocationHypothethicalTaxOptionDto[];
    workLocationTaxOptionDto!: WorkLocationTaxOptionDto[];
    otherLocationTaxPolicyDto!: OtherLocationTaxPolicyDto[];
    workLocationPolicyTypeDto!: WorkLocationPolicyTypeDto | null;
    teqWorkLocationSettingsDto!: TeqWorkLocationSettingsDto | null;

    constructor(data?: ITeqWorkLocationSettingsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationTaxTypeDto = [];
        this.workLocationHypothethicalTaxOptionDto = [];
        this.workLocationTaxOptionDto = [];
        this.otherLocationTaxPolicyDto = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['workLocationTaxTypeDto'])) {
          this.workLocationTaxTypeDto = [] as any;
          for (let item of _data['workLocationTaxTypeDto'])
            this.workLocationTaxTypeDto!.push(
              WorkLocationTaxTypeDto.fromJS(item),
            );
        } else {
          this.workLocationTaxTypeDto = <any>null;
        }
        if (Array.isArray(_data['workLocationHypothethicalTaxOptionDto'])) {
          this.workLocationHypothethicalTaxOptionDto = [] as any;
          for (let item of _data['workLocationHypothethicalTaxOptionDto'])
            this.workLocationHypothethicalTaxOptionDto!.push(
              WorkLocationHypothethicalTaxOptionDto.fromJS(item),
            );
        } else {
          this.workLocationHypothethicalTaxOptionDto = <any>null;
        }
        if (Array.isArray(_data['workLocationTaxOptionDto'])) {
          this.workLocationTaxOptionDto = [] as any;
          for (let item of _data['workLocationTaxOptionDto'])
            this.workLocationTaxOptionDto!.push(
              WorkLocationTaxOptionDto.fromJS(item),
            );
        } else {
          this.workLocationTaxOptionDto = <any>null;
        }
        if (Array.isArray(_data['otherLocationTaxPolicyDto'])) {
          this.otherLocationTaxPolicyDto = [] as any;
          for (let item of _data['otherLocationTaxPolicyDto'])
            this.otherLocationTaxPolicyDto!.push(
              OtherLocationTaxPolicyDto.fromJS(item),
            );
        } else {
          this.otherLocationTaxPolicyDto = <any>null;
        }
        this.workLocationPolicyTypeDto = _data['workLocationPolicyTypeDto']
          ? WorkLocationPolicyTypeDto.fromJS(_data['workLocationPolicyTypeDto'])
          : <any>null;
        this.teqWorkLocationSettingsDto = _data['teqWorkLocationSettingsDto']
          ? TeqWorkLocationSettingsDto.fromJS(
              _data['teqWorkLocationSettingsDto'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): TeqWorkLocationSettingsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TeqWorkLocationSettingsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationTaxTypeDto)) {
        data['workLocationTaxTypeDto'] = [];
        for (let item of this.workLocationTaxTypeDto)
          data['workLocationTaxTypeDto'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationHypothethicalTaxOptionDto)) {
        data['workLocationHypothethicalTaxOptionDto'] = [];
        for (let item of this.workLocationHypothethicalTaxOptionDto)
          data['workLocationHypothethicalTaxOptionDto'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationTaxOptionDto)) {
        data['workLocationTaxOptionDto'] = [];
        for (let item of this.workLocationTaxOptionDto)
          data['workLocationTaxOptionDto'].push(item.toJSON());
      }
      if (Array.isArray(this.otherLocationTaxPolicyDto)) {
        data['otherLocationTaxPolicyDto'] = [];
        for (let item of this.otherLocationTaxPolicyDto)
          data['otherLocationTaxPolicyDto'].push(item.toJSON());
      }
      data['workLocationPolicyTypeDto'] = this.workLocationPolicyTypeDto
        ? this.workLocationPolicyTypeDto.toJSON()
        : <any>null;
      data['teqWorkLocationSettingsDto'] = this.teqWorkLocationSettingsDto
        ? this.teqWorkLocationSettingsDto.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITeqWorkLocationSettingsPageData {
    workLocationTaxTypeDto: WorkLocationTaxTypeDto[];
    workLocationHypothethicalTaxOptionDto: WorkLocationHypothethicalTaxOptionDto[];
    workLocationTaxOptionDto: WorkLocationTaxOptionDto[];
    otherLocationTaxPolicyDto: OtherLocationTaxPolicyDto[];
    workLocationPolicyTypeDto: WorkLocationPolicyTypeDto | null;
    teqWorkLocationSettingsDto: TeqWorkLocationSettingsDto | null;
  }

  export class WorkLocationTaxTypeDto implements IWorkLocationTaxTypeDto {
    optionValue!: WorkLocationTaxType;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationTaxTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationTaxTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTaxTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationTaxTypeDto {
    optionValue: WorkLocationTaxType;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum WorkLocationTaxType {
    Income = 'Income',
    Social = 'Social',
    Region = 'Region',
  }

  export class WorkLocationHypothethicalTaxOptionDto
    implements IWorkLocationHypothethicalTaxOptionDto
  {
    optionValue!: WorkLocationHypothethicalTaxOption;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationHypothethicalTaxOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationHypothethicalTaxOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationHypothethicalTaxOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationHypothethicalTaxOptionDto {
    optionValue: WorkLocationHypothethicalTaxOption;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum WorkLocationHypothethicalTaxOption {
    NA = 'NA',
    Employee = 'Employee',
  }

  export class WorkLocationTaxOptionDto implements IWorkLocationTaxOptionDto {
    optionValue!: WorkLocationTaxOption;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationTaxOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationTaxOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTaxOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationTaxOptionDto {
    optionValue: WorkLocationTaxOption;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum WorkLocationTaxOption {
    Employee = 'Employee',
    Employer = 'Employer',
  }

  export class OtherLocationTaxPolicyDto implements IOtherLocationTaxPolicyDto {
    optionValue!: OtherLocationTaxPolicy;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IOtherLocationTaxPolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): OtherLocationTaxPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new OtherLocationTaxPolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IOtherLocationTaxPolicyDto {
    optionValue: OtherLocationTaxPolicy;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum OtherLocationTaxPolicy {
    EmploymentContractPolicy = 'EmploymentContractPolicy',
    AssignedWorkLocationPolicy = 'AssignedWorkLocationPolicy',
  }

  export class WorkLocationPolicyTypeDto implements IWorkLocationPolicyTypeDto {
    id!: string;
    clientPolicyName!: string;
    clientPolicyId!: WorkLocationTypeSetting;
    teqConsidered!: boolean;
    teqSettingsCompleted!: boolean;

    constructor(data?: IWorkLocationPolicyTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyId =
          _data['clientPolicyId'] !== undefined
            ? _data['clientPolicyId']
            : <any>null;
        this.teqConsidered =
          _data['teqConsidered'] !== undefined
            ? _data['teqConsidered']
            : <any>null;
        this.teqSettingsCompleted =
          _data['teqSettingsCompleted'] !== undefined
            ? _data['teqSettingsCompleted']
            : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationPolicyTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationPolicyTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyId'] =
        this.clientPolicyId !== undefined ? this.clientPolicyId : <any>null;
      data['teqConsidered'] =
        this.teqConsidered !== undefined ? this.teqConsidered : <any>null;
      data['teqSettingsCompleted'] =
        this.teqSettingsCompleted !== undefined
          ? this.teqSettingsCompleted
          : <any>null;
      return data;
    }
  }

  export interface IWorkLocationPolicyTypeDto {
    id: string;
    clientPolicyName: string;
    clientPolicyId: WorkLocationTypeSetting;
    teqConsidered: boolean;
    teqSettingsCompleted: boolean;
  }

  export class TeqWorkLocationSettingsDto
    implements ITeqWorkLocationSettingsDto
  {
    teqWorkLocationConfiguration!: TeqWorkLocationConfigurationDto;

    constructor(data?: ITeqWorkLocationSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.teqWorkLocationConfiguration =
          new TeqWorkLocationConfigurationDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.teqWorkLocationConfiguration = _data[
          'teqWorkLocationConfiguration'
        ]
          ? TeqWorkLocationConfigurationDto.fromJS(
              _data['teqWorkLocationConfiguration'],
            )
          : new TeqWorkLocationConfigurationDto();
      }
    }

    static fromJS(data: any): TeqWorkLocationSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqWorkLocationSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['teqWorkLocationConfiguration'] = this.teqWorkLocationConfiguration
        ? this.teqWorkLocationConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITeqWorkLocationSettingsDto {
    teqWorkLocationConfiguration: TeqWorkLocationConfigurationDto;
  }

  export class TeqWorkLocationConfigurationDto
    implements ITeqWorkLocationConfigurationDto
  {
    assignedWorkLocationList!: TeqAssignedWorkLocationConfigurationDto[];
    employeeContractLocationList!: TeqEmployeeContractLocationConfigurationDto[];
    otherLocationTaxPolicy!: OtherLocationTaxPolicy;

    constructor(data?: ITeqWorkLocationConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.assignedWorkLocationList = [];
        this.employeeContractLocationList = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['assignedWorkLocationList'])) {
          this.assignedWorkLocationList = [] as any;
          for (let item of _data['assignedWorkLocationList'])
            this.assignedWorkLocationList!.push(
              TeqAssignedWorkLocationConfigurationDto.fromJS(item),
            );
        } else {
          this.assignedWorkLocationList = <any>null;
        }
        if (Array.isArray(_data['employeeContractLocationList'])) {
          this.employeeContractLocationList = [] as any;
          for (let item of _data['employeeContractLocationList'])
            this.employeeContractLocationList!.push(
              TeqEmployeeContractLocationConfigurationDto.fromJS(item),
            );
        } else {
          this.employeeContractLocationList = <any>null;
        }
        this.otherLocationTaxPolicy =
          _data['otherLocationTaxPolicy'] !== undefined
            ? _data['otherLocationTaxPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): TeqWorkLocationConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqWorkLocationConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.assignedWorkLocationList)) {
        data['assignedWorkLocationList'] = [];
        for (let item of this.assignedWorkLocationList)
          data['assignedWorkLocationList'].push(item.toJSON());
      }
      if (Array.isArray(this.employeeContractLocationList)) {
        data['employeeContractLocationList'] = [];
        for (let item of this.employeeContractLocationList)
          data['employeeContractLocationList'].push(item.toJSON());
      }
      data['otherLocationTaxPolicy'] =
        this.otherLocationTaxPolicy !== undefined
          ? this.otherLocationTaxPolicy
          : <any>null;
      return data;
    }
  }

  export interface ITeqWorkLocationConfigurationDto {
    assignedWorkLocationList: TeqAssignedWorkLocationConfigurationDto[];
    employeeContractLocationList: TeqEmployeeContractLocationConfigurationDto[];
    otherLocationTaxPolicy: OtherLocationTaxPolicy;
  }

  export class TeqAssignedWorkLocationConfigurationDto
    implements ITeqAssignedWorkLocationConfigurationDto
  {
    type!: WorkLocationTaxType;
    workLocationHypothethicalTaxOption!: WorkLocationHypothethicalTaxOption;
    actualTax!: WorkLocationTaxOption;
    grossUpTax!: WorkLocationTaxOption;

    constructor(data?: ITeqAssignedWorkLocationConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.workLocationHypothethicalTaxOption =
          _data['workLocationHypothethicalTaxOption'] !== undefined
            ? _data['workLocationHypothethicalTaxOption']
            : <any>null;
        this.actualTax =
          _data['actualTax'] !== undefined ? _data['actualTax'] : <any>null;
        this.grossUpTax =
          _data['grossUpTax'] !== undefined ? _data['grossUpTax'] : <any>null;
      }
    }

    static fromJS(data: any): TeqAssignedWorkLocationConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqAssignedWorkLocationConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['workLocationHypothethicalTaxOption'] =
        this.workLocationHypothethicalTaxOption !== undefined
          ? this.workLocationHypothethicalTaxOption
          : <any>null;
      data['actualTax'] =
        this.actualTax !== undefined ? this.actualTax : <any>null;
      data['grossUpTax'] =
        this.grossUpTax !== undefined ? this.grossUpTax : <any>null;
      return data;
    }
  }

  export interface ITeqAssignedWorkLocationConfigurationDto {
    type: WorkLocationTaxType;
    workLocationHypothethicalTaxOption: WorkLocationHypothethicalTaxOption;
    actualTax: WorkLocationTaxOption;
    grossUpTax: WorkLocationTaxOption;
  }

  export class TeqEmployeeContractLocationConfigurationDto
    implements ITeqEmployeeContractLocationConfigurationDto
  {
    type!: WorkLocationTaxType;
    actualTax!: WorkLocationTaxOption;
    grossUpTax!: WorkLocationTaxOption;

    constructor(data?: ITeqEmployeeContractLocationConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.actualTax =
          _data['actualTax'] !== undefined ? _data['actualTax'] : <any>null;
        this.grossUpTax =
          _data['grossUpTax'] !== undefined ? _data['grossUpTax'] : <any>null;
      }
    }

    static fromJS(data: any): TeqEmployeeContractLocationConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqEmployeeContractLocationConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['actualTax'] =
        this.actualTax !== undefined ? this.actualTax : <any>null;
      data['grossUpTax'] =
        this.grossUpTax !== undefined ? this.grossUpTax : <any>null;
      return data;
    }
  }

  export interface ITeqEmployeeContractLocationConfigurationDto {
    type: WorkLocationTaxType;
    actualTax: WorkLocationTaxOption;
    grossUpTax: WorkLocationTaxOption;
  }

  export class GetTeqSettingsByWorkLocationQueryResultFailure
    extends GetTeqSettingsByWorkLocationTypeQueryResult
    implements IGetTeqSettingsByWorkLocationQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTeqSettingsByWorkLocationQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTeqSettingsByWorkLocationQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqSettingsByWorkLocationQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqSettingsByWorkLocationQueryResultFailure
    extends IGetTeqSettingsByWorkLocationTypeQueryResult {
    errors: ResultError[];
  }

  export class UpsertTeqSettingsByWorkLocationCommandResult
    implements IUpsertTeqSettingsByWorkLocationCommandResult
  {
    constructor(data?: IUpsertTeqSettingsByWorkLocationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTeqSettingsByWorkLocationCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqSettingsByWorkLocationCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTeqSettingsByWorkLocationCommandResult {}

  export class UpsertTeqSettingsByWorkLocationCommandResultSuccess
    extends UpsertTeqSettingsByWorkLocationCommandResult
    implements IUpsertTeqSettingsByWorkLocationCommandResultSuccess
  {
    constructor(data?: IUpsertTeqSettingsByWorkLocationCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTeqSettingsByWorkLocationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqSettingsByWorkLocationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTeqSettingsByWorkLocationCommandResultSuccess
    extends IUpsertTeqSettingsByWorkLocationCommandResult {}

  export class UpsertTeqSettingsByWorkLocationCommandResultFailure
    extends UpsertTeqSettingsByWorkLocationCommandResult
    implements IUpsertTeqSettingsByWorkLocationCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertTeqSettingsByWorkLocationCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTeqSettingsByWorkLocationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqSettingsByWorkLocationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTeqSettingsByWorkLocationCommandResultFailure
    extends IUpsertTeqSettingsByWorkLocationCommandResult {
    errors: ResultError[];
  }

  export class UpsertTeqSettingsByWorkLocationCommand
    implements IUpsertTeqSettingsByWorkLocationCommand
  {
    clientId!: string;
    workLocationPolicyId!: string;
    workLocationConfigurationSettings!: TeqWorkLocationConfigurationDto;

    constructor(data?: IUpsertTeqSettingsByWorkLocationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationConfigurationSettings =
          new TeqWorkLocationConfigurationDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.workLocationPolicyId =
          _data['workLocationPolicyId'] !== undefined
            ? _data['workLocationPolicyId']
            : <any>null;
        this.workLocationConfigurationSettings = _data[
          'workLocationConfigurationSettings'
        ]
          ? TeqWorkLocationConfigurationDto.fromJS(
              _data['workLocationConfigurationSettings'],
            )
          : new TeqWorkLocationConfigurationDto();
      }
    }

    static fromJS(data: any): UpsertTeqSettingsByWorkLocationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqSettingsByWorkLocationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['workLocationPolicyId'] =
        this.workLocationPolicyId !== undefined
          ? this.workLocationPolicyId
          : <any>null;
      data['workLocationConfigurationSettings'] = this
        .workLocationConfigurationSettings
        ? this.workLocationConfigurationSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertTeqSettingsByWorkLocationCommand {
    clientId: string;
    workLocationPolicyId: string;
    workLocationConfigurationSettings: TeqWorkLocationConfigurationDto;
  }

  export abstract class SaveTeqWorkLocationSettingsWorkflowStepCommandResult
    implements ISaveTeqWorkLocationSettingsWorkflowStepCommandResult
  {
    constructor(data?: ISaveTeqWorkLocationSettingsWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): SaveTeqWorkLocationSettingsWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveTeqWorkLocationSettingsWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveTeqWorkLocationSettingsWorkflowStepCommandResult {}

  export class SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess
    extends SaveTeqWorkLocationSettingsWorkflowStepCommandResult
    implements ISaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveTeqWorkLocationSettingsWorkflowStepCommandResultSuccess
    extends ISaveTeqWorkLocationSettingsWorkflowStepCommandResult {}

  export class SaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure
    extends SaveTeqWorkLocationSettingsWorkflowStepCommandResult
    implements ISaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveTeqWorkLocationSettingsWorkflowStepCommandResultFailure
    extends ISaveTeqWorkLocationSettingsWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveTeqWorkLocationSettingsWorkflowStepCommand
    implements ISaveTeqWorkLocationSettingsWorkflowStepCommand
  {
    clientId!: string;
    teqSettingsCompleted!: boolean;

    constructor(data?: ISaveTeqWorkLocationSettingsWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.teqSettingsCompleted =
          _data['teqSettingsCompleted'] !== undefined
            ? _data['teqSettingsCompleted']
            : <any>null;
      }
    }

    static fromJS(data: any): SaveTeqWorkLocationSettingsWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveTeqWorkLocationSettingsWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['teqSettingsCompleted'] =
        this.teqSettingsCompleted !== undefined
          ? this.teqSettingsCompleted
          : <any>null;
      return data;
    }
  }

  export interface ISaveTeqWorkLocationSettingsWorkflowStepCommand {
    clientId: string;
    teqSettingsCompleted: boolean;
  }

  export class GetWorkLocationPolicyTypeQueryResult
    implements IGetWorkLocationPolicyTypeQueryResult
  {
    constructor(data?: IGetWorkLocationPolicyTypeQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetWorkLocationPolicyTypeQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetWorkLocationPolicyTypeQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetWorkLocationPolicyTypeQueryResult {}

  export class GetWorkLocationPolicyTypeQueryResultSuccess
    extends GetWorkLocationPolicyTypeQueryResult
    implements IGetWorkLocationPolicyTypeQueryResultSuccess
  {
    result!: WorkLocationPolicyTypePageData;

    constructor(data?: IGetWorkLocationPolicyTypeQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new WorkLocationPolicyTypePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? WorkLocationPolicyTypePageData.fromJS(_data['result'])
          : new WorkLocationPolicyTypePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetWorkLocationPolicyTypeQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetWorkLocationPolicyTypeQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetWorkLocationPolicyTypeQueryResultSuccess
    extends IGetWorkLocationPolicyTypeQueryResult {
    result: WorkLocationPolicyTypePageData;
  }

  export class WorkLocationPolicyTypePageData
    implements IWorkLocationPolicyTypePageData
  {
    workLocationPolicyList!: WorkLocationPolicyTypeDto[] | null;

    constructor(data?: IWorkLocationPolicyTypePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['workLocationPolicyList'])) {
          this.workLocationPolicyList = [] as any;
          for (let item of _data['workLocationPolicyList'])
            this.workLocationPolicyList!.push(
              WorkLocationPolicyTypeDto.fromJS(item),
            );
        } else {
          this.workLocationPolicyList = <any>null;
        }
      }
    }

    static fromJS(data: any): WorkLocationPolicyTypePageData {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationPolicyTypePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationPolicyList)) {
        data['workLocationPolicyList'] = [];
        for (let item of this.workLocationPolicyList)
          data['workLocationPolicyList'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IWorkLocationPolicyTypePageData {
    workLocationPolicyList: WorkLocationPolicyTypeDto[] | null;
  }

  export class GetWorkLocationPolicyTypeQueryResultFailure
    extends GetWorkLocationPolicyTypeQueryResult
    implements IGetWorkLocationPolicyTypeQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetWorkLocationPolicyTypeQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetWorkLocationPolicyTypeQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetWorkLocationPolicyTypeQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetWorkLocationPolicyTypeQueryResultFailure
    extends IGetWorkLocationPolicyTypeQueryResult {
    errors: ResultError[];
  }

  export abstract class GetTeqOverridesIndexPageDataQueryResult
    implements IGetTeqOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetTeqOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTeqOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTeqOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTeqOverridesIndexPageDataQueryResult {}

  export class GetTeqOverridesIndexPageDataQueryResultSuccess
    extends GetTeqOverridesIndexPageDataQueryResult
    implements IGetTeqOverridesIndexPageDataQueryResultSuccess
  {
    result!: TeqOverridesIndexPageData;

    constructor(data?: IGetTeqOverridesIndexPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TeqOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TeqOverridesIndexPageData.fromJS(_data['result'])
          : new TeqOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTeqOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqOverridesIndexPageDataQueryResultSuccess
    extends IGetTeqOverridesIndexPageDataQueryResult {
    result: TeqOverridesIndexPageData;
  }

  export class TeqOverridesIndexPageData implements ITeqOverridesIndexPageData {
    lineItems!: TeqOverrideIndexPageLineItemDto[];

    constructor(data?: ITeqOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.lineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(TeqOverrideIndexPageLineItemDto.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): TeqOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TeqOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITeqOverridesIndexPageData {
    lineItems: TeqOverrideIndexPageLineItemDto[];
  }

  export class TeqOverrideIndexPageLineItemDto
    implements ITeqOverrideIndexPageLineItemDto
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    grossUpSetting!: GrossUpSetting | null;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds!: string[] | null;
    workLocationPolicy!: string;
    policyOverride!: string;
    taxEqualizationPolicy!: string;

    constructor(data?: ITeqOverrideIndexPageLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
        if (Array.isArray(_data['selectedWorkLocationPolicyIds'])) {
          this.selectedWorkLocationPolicyIds = [] as any;
          for (let item of _data['selectedWorkLocationPolicyIds'])
            this.selectedWorkLocationPolicyIds!.push(item);
        } else {
          this.selectedWorkLocationPolicyIds = <any>null;
        }
        this.workLocationPolicy =
          _data['workLocationPolicy'] !== undefined
            ? _data['workLocationPolicy']
            : <any>null;
        this.policyOverride =
          _data['policyOverride'] !== undefined
            ? _data['policyOverride']
            : <any>null;
        this.taxEqualizationPolicy =
          _data['taxEqualizationPolicy'] !== undefined
            ? _data['taxEqualizationPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): TeqOverrideIndexPageLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqOverrideIndexPageLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      if (Array.isArray(this.selectedWorkLocationPolicyIds)) {
        data['selectedWorkLocationPolicyIds'] = [];
        for (let item of this.selectedWorkLocationPolicyIds)
          data['selectedWorkLocationPolicyIds'].push(item);
      }
      data['workLocationPolicy'] =
        this.workLocationPolicy !== undefined
          ? this.workLocationPolicy
          : <any>null;
      data['policyOverride'] =
        this.policyOverride !== undefined ? this.policyOverride : <any>null;
      data['taxEqualizationPolicy'] =
        this.taxEqualizationPolicy !== undefined
          ? this.taxEqualizationPolicy
          : <any>null;
      return data;
    }
  }

  export interface ITeqOverrideIndexPageLineItemDto {
    id: string;
    employeeId: string;
    transactionId: string | null;
    grossUpSetting: GrossUpSetting | null;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds: string[] | null;
    workLocationPolicy: string;
    policyOverride: string;
    taxEqualizationPolicy: string;
  }

  export enum GrossUpSetting {
    InCountryGrossUp = 'InCountryGrossUp',
    NoGrossUp = 'NoGrossUp',
  }

  export enum HypotheticalTaxDeduction {
    FollowCountryLegislation = 'FollowCountryLegislation',
    DoNotApplyHypotheticalTaxDeductions = 'DoNotApplyHypotheticalTaxDeductions',
    ApplyHypotheticalTaxDeductions = 'ApplyHypotheticalTaxDeductions',
  }

  export class GetTeqOverridesIndexPageDataQueryResultFailure
    extends GetTeqOverridesIndexPageDataQueryResult
    implements IGetTeqOverridesIndexPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetTeqOverridesIndexPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetTeqOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqOverridesIndexPageDataQueryResultFailure
    extends IGetTeqOverridesIndexPageDataQueryResult {
    errorMessage: string;
  }

  export class GetTeqOverrideQueryResult implements IGetTeqOverrideQueryResult {
    constructor(data?: IGetTeqOverrideQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTeqOverrideQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqOverrideQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTeqOverrideQueryResult {}

  export class GetTeqOverrideQueryResultSuccess
    extends GetTeqOverrideQueryResult
    implements IGetTeqOverrideQueryResultSuccess
  {
    result!: TeqOverridesPageData;

    constructor(data?: IGetTeqOverrideQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TeqOverridesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TeqOverridesPageData.fromJS(_data['result'])
          : new TeqOverridesPageData();
      }
    }

    static override fromJS(data: any): GetTeqOverrideQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqOverrideQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqOverrideQueryResultSuccess
    extends IGetTeqOverrideQueryResult {
    result: TeqOverridesPageData;
  }

  export class TeqOverridesPageData implements ITeqOverridesPageData {
    grossUpSettingOverrideDto!: GrossUpSettingOverrideDto[];
    hypotheticalTaxDeductionsOverrideDto!: HypotheticalTaxDeductionsOverrideDto[];
    workLocationTaxTypeOverrideDto!: WorkLocationTaxTypeOverrideDto[];
    workLocationHypothethicalTaxOptionOverrideDto!: WorkLocationHypothethicalTaxOptionOverrideDto[];
    workLocationTaxOptionOverrideDto!: WorkLocationTaxOptionOverrideDto[];
    otherLocationTaxPolicyOverrideDto!: OtherLocationTaxPolicyOverrideDto[];
    workLocationPolicyTypeOverrideDto!: WorkLocationPolicyTypeOverrideDto[];
    teqOverrideLineItem!: TeqOverrideLineItemDto | null;

    constructor(data?: ITeqOverridesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.grossUpSettingOverrideDto = [];
        this.hypotheticalTaxDeductionsOverrideDto = [];
        this.workLocationTaxTypeOverrideDto = [];
        this.workLocationHypothethicalTaxOptionOverrideDto = [];
        this.workLocationTaxOptionOverrideDto = [];
        this.otherLocationTaxPolicyOverrideDto = [];
        this.workLocationPolicyTypeOverrideDto = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['grossUpSettingOverrideDto'])) {
          this.grossUpSettingOverrideDto = [] as any;
          for (let item of _data['grossUpSettingOverrideDto'])
            this.grossUpSettingOverrideDto!.push(
              GrossUpSettingOverrideDto.fromJS(item),
            );
        } else {
          this.grossUpSettingOverrideDto = <any>null;
        }
        if (Array.isArray(_data['hypotheticalTaxDeductionsOverrideDto'])) {
          this.hypotheticalTaxDeductionsOverrideDto = [] as any;
          for (let item of _data['hypotheticalTaxDeductionsOverrideDto'])
            this.hypotheticalTaxDeductionsOverrideDto!.push(
              HypotheticalTaxDeductionsOverrideDto.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductionsOverrideDto = <any>null;
        }
        if (Array.isArray(_data['workLocationTaxTypeOverrideDto'])) {
          this.workLocationTaxTypeOverrideDto = [] as any;
          for (let item of _data['workLocationTaxTypeOverrideDto'])
            this.workLocationTaxTypeOverrideDto!.push(
              WorkLocationTaxTypeOverrideDto.fromJS(item),
            );
        } else {
          this.workLocationTaxTypeOverrideDto = <any>null;
        }
        if (
          Array.isArray(_data['workLocationHypothethicalTaxOptionOverrideDto'])
        ) {
          this.workLocationHypothethicalTaxOptionOverrideDto = [] as any;
          for (let item of _data[
            'workLocationHypothethicalTaxOptionOverrideDto'
          ])
            this.workLocationHypothethicalTaxOptionOverrideDto!.push(
              WorkLocationHypothethicalTaxOptionOverrideDto.fromJS(item),
            );
        } else {
          this.workLocationHypothethicalTaxOptionOverrideDto = <any>null;
        }
        if (Array.isArray(_data['workLocationTaxOptionOverrideDto'])) {
          this.workLocationTaxOptionOverrideDto = [] as any;
          for (let item of _data['workLocationTaxOptionOverrideDto'])
            this.workLocationTaxOptionOverrideDto!.push(
              WorkLocationTaxOptionOverrideDto.fromJS(item),
            );
        } else {
          this.workLocationTaxOptionOverrideDto = <any>null;
        }
        if (Array.isArray(_data['otherLocationTaxPolicyOverrideDto'])) {
          this.otherLocationTaxPolicyOverrideDto = [] as any;
          for (let item of _data['otherLocationTaxPolicyOverrideDto'])
            this.otherLocationTaxPolicyOverrideDto!.push(
              OtherLocationTaxPolicyOverrideDto.fromJS(item),
            );
        } else {
          this.otherLocationTaxPolicyOverrideDto = <any>null;
        }
        if (Array.isArray(_data['workLocationPolicyTypeOverrideDto'])) {
          this.workLocationPolicyTypeOverrideDto = [] as any;
          for (let item of _data['workLocationPolicyTypeOverrideDto'])
            this.workLocationPolicyTypeOverrideDto!.push(
              WorkLocationPolicyTypeOverrideDto.fromJS(item),
            );
        } else {
          this.workLocationPolicyTypeOverrideDto = <any>null;
        }
        this.teqOverrideLineItem = _data['teqOverrideLineItem']
          ? TeqOverrideLineItemDto.fromJS(_data['teqOverrideLineItem'])
          : <any>null;
      }
    }

    static fromJS(data: any): TeqOverridesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TeqOverridesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.grossUpSettingOverrideDto)) {
        data['grossUpSettingOverrideDto'] = [];
        for (let item of this.grossUpSettingOverrideDto)
          data['grossUpSettingOverrideDto'].push(item.toJSON());
      }
      if (Array.isArray(this.hypotheticalTaxDeductionsOverrideDto)) {
        data['hypotheticalTaxDeductionsOverrideDto'] = [];
        for (let item of this.hypotheticalTaxDeductionsOverrideDto)
          data['hypotheticalTaxDeductionsOverrideDto'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationTaxTypeOverrideDto)) {
        data['workLocationTaxTypeOverrideDto'] = [];
        for (let item of this.workLocationTaxTypeOverrideDto)
          data['workLocationTaxTypeOverrideDto'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationHypothethicalTaxOptionOverrideDto)) {
        data['workLocationHypothethicalTaxOptionOverrideDto'] = [];
        for (let item of this.workLocationHypothethicalTaxOptionOverrideDto)
          data['workLocationHypothethicalTaxOptionOverrideDto'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.workLocationTaxOptionOverrideDto)) {
        data['workLocationTaxOptionOverrideDto'] = [];
        for (let item of this.workLocationTaxOptionOverrideDto)
          data['workLocationTaxOptionOverrideDto'].push(item.toJSON());
      }
      if (Array.isArray(this.otherLocationTaxPolicyOverrideDto)) {
        data['otherLocationTaxPolicyOverrideDto'] = [];
        for (let item of this.otherLocationTaxPolicyOverrideDto)
          data['otherLocationTaxPolicyOverrideDto'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationPolicyTypeOverrideDto)) {
        data['workLocationPolicyTypeOverrideDto'] = [];
        for (let item of this.workLocationPolicyTypeOverrideDto)
          data['workLocationPolicyTypeOverrideDto'].push(item.toJSON());
      }
      data['teqOverrideLineItem'] = this.teqOverrideLineItem
        ? this.teqOverrideLineItem.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITeqOverridesPageData {
    grossUpSettingOverrideDto: GrossUpSettingOverrideDto[];
    hypotheticalTaxDeductionsOverrideDto: HypotheticalTaxDeductionsOverrideDto[];
    workLocationTaxTypeOverrideDto: WorkLocationTaxTypeOverrideDto[];
    workLocationHypothethicalTaxOptionOverrideDto: WorkLocationHypothethicalTaxOptionOverrideDto[];
    workLocationTaxOptionOverrideDto: WorkLocationTaxOptionOverrideDto[];
    otherLocationTaxPolicyOverrideDto: OtherLocationTaxPolicyOverrideDto[];
    workLocationPolicyTypeOverrideDto: WorkLocationPolicyTypeOverrideDto[];
    teqOverrideLineItem: TeqOverrideLineItemDto | null;
  }

  export class GrossUpSettingOverrideDto implements IGrossUpSettingOverrideDto {
    optionValue!: GrossUpSetting;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IGrossUpSettingOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): GrossUpSettingOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new GrossUpSettingOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IGrossUpSettingOverrideDto {
    optionValue: GrossUpSetting;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class HypotheticalTaxDeductionsOverrideDto
    implements IHypotheticalTaxDeductionsOverrideDto
  {
    optionValue!: HypotheticalTaxDeduction;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IHypotheticalTaxDeductionsOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalTaxDeductionsOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalTaxDeductionsOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IHypotheticalTaxDeductionsOverrideDto {
    optionValue: HypotheticalTaxDeduction;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class WorkLocationTaxTypeOverrideDto
    implements IWorkLocationTaxTypeOverrideDto
  {
    optionValue!: WorkLocationTaxType;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationTaxTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationTaxTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTaxTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationTaxTypeOverrideDto {
    optionValue: WorkLocationTaxType;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class WorkLocationHypothethicalTaxOptionOverrideDto
    implements IWorkLocationHypothethicalTaxOptionOverrideDto
  {
    optionValue!: WorkLocationHypothethicalTaxOption;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationHypothethicalTaxOptionOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationHypothethicalTaxOptionOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationHypothethicalTaxOptionOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationHypothethicalTaxOptionOverrideDto {
    optionValue: WorkLocationHypothethicalTaxOption;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class WorkLocationTaxOptionOverrideDto
    implements IWorkLocationTaxOptionOverrideDto
  {
    optionValue!: WorkLocationTaxOption;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IWorkLocationTaxOptionOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationTaxOptionOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTaxOptionOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IWorkLocationTaxOptionOverrideDto {
    optionValue: WorkLocationTaxOption;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class OtherLocationTaxPolicyOverrideDto
    implements IOtherLocationTaxPolicyOverrideDto
  {
    optionValue!: OtherLocationTaxPolicy;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IOtherLocationTaxPolicyOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): OtherLocationTaxPolicyOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new OtherLocationTaxPolicyOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IOtherLocationTaxPolicyOverrideDto {
    optionValue: OtherLocationTaxPolicy;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class WorkLocationPolicyTypeOverrideDto
    implements IWorkLocationPolicyTypeOverrideDto
  {
    id!: string;
    clientPolicyName!: string;
    clientPolicyId!: WorkLocationTypeSetting;
    teqConsidered!: boolean;

    constructor(data?: IWorkLocationPolicyTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyId =
          _data['clientPolicyId'] !== undefined
            ? _data['clientPolicyId']
            : <any>null;
        this.teqConsidered =
          _data['teqConsidered'] !== undefined
            ? _data['teqConsidered']
            : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationPolicyTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationPolicyTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyId'] =
        this.clientPolicyId !== undefined ? this.clientPolicyId : <any>null;
      data['teqConsidered'] =
        this.teqConsidered !== undefined ? this.teqConsidered : <any>null;
      return data;
    }
  }

  export interface IWorkLocationPolicyTypeOverrideDto {
    id: string;
    clientPolicyName: string;
    clientPolicyId: WorkLocationTypeSetting;
    teqConsidered: boolean;
  }

  export class TeqOverrideLineItemDto implements ITeqOverrideLineItemDto {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    grossUpSetting!: GrossUpSetting | null;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds!: string[] | null;
    workLocationPolicy!: string;
    teqWorkLocationConfiguration!: TeqWorkLocationConfiguration | null;
    policyOverride!: string;
    taxEqualizationPolicy!: string;

    constructor(data?: ITeqOverrideLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
        if (Array.isArray(_data['selectedWorkLocationPolicyIds'])) {
          this.selectedWorkLocationPolicyIds = [] as any;
          for (let item of _data['selectedWorkLocationPolicyIds'])
            this.selectedWorkLocationPolicyIds!.push(item);
        } else {
          this.selectedWorkLocationPolicyIds = <any>null;
        }
        this.workLocationPolicy =
          _data['workLocationPolicy'] !== undefined
            ? _data['workLocationPolicy']
            : <any>null;
        this.teqWorkLocationConfiguration = _data[
          'teqWorkLocationConfiguration'
        ]
          ? TeqWorkLocationConfiguration.fromJS(
              _data['teqWorkLocationConfiguration'],
            )
          : <any>null;
        this.policyOverride =
          _data['policyOverride'] !== undefined
            ? _data['policyOverride']
            : <any>null;
        this.taxEqualizationPolicy =
          _data['taxEqualizationPolicy'] !== undefined
            ? _data['taxEqualizationPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): TeqOverrideLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqOverrideLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      if (Array.isArray(this.selectedWorkLocationPolicyIds)) {
        data['selectedWorkLocationPolicyIds'] = [];
        for (let item of this.selectedWorkLocationPolicyIds)
          data['selectedWorkLocationPolicyIds'].push(item);
      }
      data['workLocationPolicy'] =
        this.workLocationPolicy !== undefined
          ? this.workLocationPolicy
          : <any>null;
      data['teqWorkLocationConfiguration'] = this.teqWorkLocationConfiguration
        ? this.teqWorkLocationConfiguration.toJSON()
        : <any>null;
      data['policyOverride'] =
        this.policyOverride !== undefined ? this.policyOverride : <any>null;
      data['taxEqualizationPolicy'] =
        this.taxEqualizationPolicy !== undefined
          ? this.taxEqualizationPolicy
          : <any>null;
      return data;
    }
  }

  export interface ITeqOverrideLineItemDto {
    id: string;
    employeeId: string;
    transactionId: string | null;
    grossUpSetting: GrossUpSetting | null;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds: string[] | null;
    workLocationPolicy: string;
    teqWorkLocationConfiguration: TeqWorkLocationConfiguration | null;
    policyOverride: string;
    taxEqualizationPolicy: string;
  }

  export class TeqWorkLocationConfiguration
    implements ITeqWorkLocationConfiguration
  {
    assignedWorkLocationList!: TeqAssignedWorkLocationConfiguration[];
    employeeContractLocationList!: TeqEmployeeContractLocationConfiguration[];
    otherLocationTaxPolicy!: OtherLocationTaxPolicy;

    constructor(data?: ITeqWorkLocationConfiguration) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.assignedWorkLocationList = [];
        this.employeeContractLocationList = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['assignedWorkLocationList'])) {
          this.assignedWorkLocationList = [] as any;
          for (let item of _data['assignedWorkLocationList'])
            this.assignedWorkLocationList!.push(
              TeqAssignedWorkLocationConfiguration.fromJS(item),
            );
        } else {
          this.assignedWorkLocationList = <any>null;
        }
        if (Array.isArray(_data['employeeContractLocationList'])) {
          this.employeeContractLocationList = [] as any;
          for (let item of _data['employeeContractLocationList'])
            this.employeeContractLocationList!.push(
              TeqEmployeeContractLocationConfiguration.fromJS(item),
            );
        } else {
          this.employeeContractLocationList = <any>null;
        }
        this.otherLocationTaxPolicy =
          _data['otherLocationTaxPolicy'] !== undefined
            ? _data['otherLocationTaxPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): TeqWorkLocationConfiguration {
      data = typeof data === 'object' ? data : {};
      let result = new TeqWorkLocationConfiguration();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.assignedWorkLocationList)) {
        data['assignedWorkLocationList'] = [];
        for (let item of this.assignedWorkLocationList)
          data['assignedWorkLocationList'].push(item.toJSON());
      }
      if (Array.isArray(this.employeeContractLocationList)) {
        data['employeeContractLocationList'] = [];
        for (let item of this.employeeContractLocationList)
          data['employeeContractLocationList'].push(item.toJSON());
      }
      data['otherLocationTaxPolicy'] =
        this.otherLocationTaxPolicy !== undefined
          ? this.otherLocationTaxPolicy
          : <any>null;
      return data;
    }
  }

  export interface ITeqWorkLocationConfiguration {
    assignedWorkLocationList: TeqAssignedWorkLocationConfiguration[];
    employeeContractLocationList: TeqEmployeeContractLocationConfiguration[];
    otherLocationTaxPolicy: OtherLocationTaxPolicy;
  }

  export class TeqAssignedWorkLocationConfiguration
    implements ITeqAssignedWorkLocationConfiguration
  {
    type!: WorkLocationTaxType;
    workLocationHypothethicalTaxOption!: WorkLocationHypothethicalTaxOption;
    actualTax!: WorkLocationTaxOption;
    grossUpTax!: WorkLocationTaxOption;

    constructor(data?: ITeqAssignedWorkLocationConfiguration) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.workLocationHypothethicalTaxOption =
          _data['workLocationHypothethicalTaxOption'] !== undefined
            ? _data['workLocationHypothethicalTaxOption']
            : <any>null;
        this.actualTax =
          _data['actualTax'] !== undefined ? _data['actualTax'] : <any>null;
        this.grossUpTax =
          _data['grossUpTax'] !== undefined ? _data['grossUpTax'] : <any>null;
      }
    }

    static fromJS(data: any): TeqAssignedWorkLocationConfiguration {
      data = typeof data === 'object' ? data : {};
      let result = new TeqAssignedWorkLocationConfiguration();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['workLocationHypothethicalTaxOption'] =
        this.workLocationHypothethicalTaxOption !== undefined
          ? this.workLocationHypothethicalTaxOption
          : <any>null;
      data['actualTax'] =
        this.actualTax !== undefined ? this.actualTax : <any>null;
      data['grossUpTax'] =
        this.grossUpTax !== undefined ? this.grossUpTax : <any>null;
      return data;
    }
  }

  export interface ITeqAssignedWorkLocationConfiguration {
    type: WorkLocationTaxType;
    workLocationHypothethicalTaxOption: WorkLocationHypothethicalTaxOption;
    actualTax: WorkLocationTaxOption;
    grossUpTax: WorkLocationTaxOption;
  }

  export class TeqEmployeeContractLocationConfiguration
    implements ITeqEmployeeContractLocationConfiguration
  {
    type!: WorkLocationTaxType;
    actualTax!: WorkLocationTaxOption;
    grossUpTax!: WorkLocationTaxOption;

    constructor(data?: ITeqEmployeeContractLocationConfiguration) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.actualTax =
          _data['actualTax'] !== undefined ? _data['actualTax'] : <any>null;
        this.grossUpTax =
          _data['grossUpTax'] !== undefined ? _data['grossUpTax'] : <any>null;
      }
    }

    static fromJS(data: any): TeqEmployeeContractLocationConfiguration {
      data = typeof data === 'object' ? data : {};
      let result = new TeqEmployeeContractLocationConfiguration();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['actualTax'] =
        this.actualTax !== undefined ? this.actualTax : <any>null;
      data['grossUpTax'] =
        this.grossUpTax !== undefined ? this.grossUpTax : <any>null;
      return data;
    }
  }

  export interface ITeqEmployeeContractLocationConfiguration {
    type: WorkLocationTaxType;
    actualTax: WorkLocationTaxOption;
    grossUpTax: WorkLocationTaxOption;
  }

  export class GetTeqOverrideQueryResultFailure
    extends GetTeqOverrideQueryResult
    implements IGetTeqOverrideQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTeqOverrideQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTeqOverrideQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqOverrideQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqOverrideQueryResultFailure
    extends IGetTeqOverrideQueryResult {
    errors: ResultError[];
  }

  export abstract class AddTeqOverrideCommandResult
    implements IAddTeqOverrideCommandResult
  {
    constructor(data?: IAddTeqOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddTeqOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'AddTeqOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddTeqOverrideCommandResult {}

  export class AddTeqOverrideCommandResultSuccess
    extends AddTeqOverrideCommandResult
    implements IAddTeqOverrideCommandResultSuccess
  {
    constructor(data?: IAddTeqOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): AddTeqOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddTeqOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddTeqOverrideCommandResultSuccess
    extends IAddTeqOverrideCommandResult {}

  export class AddTeqOverrideCommandResultFailure
    extends AddTeqOverrideCommandResult
    implements IAddTeqOverrideCommandResultFailure
  {
    errors!: string;

    constructor(data?: IAddTeqOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(data: any): AddTeqOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddTeqOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddTeqOverrideCommandResultFailure
    extends IAddTeqOverrideCommandResult {
    errors: string;
  }

  export class AddTeqOverrideCommand implements IAddTeqOverrideCommand {
    clientId!: string;
    employeeTransactionIds!: UpsertEmployeeIdTransactionIdSettingDto[];
    grossUpSetting!: GrossUpSetting | null;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds!: string[];
    teqWorkLocationConfiguration!: TeqWorkLocationConfiguration | null;

    constructor(data?: IAddTeqOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedWorkLocationPolicyIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              UpsertEmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
        if (Array.isArray(_data['selectedWorkLocationPolicyIds'])) {
          this.selectedWorkLocationPolicyIds = [] as any;
          for (let item of _data['selectedWorkLocationPolicyIds'])
            this.selectedWorkLocationPolicyIds!.push(item);
        } else {
          this.selectedWorkLocationPolicyIds = <any>null;
        }
        this.teqWorkLocationConfiguration = _data[
          'teqWorkLocationConfiguration'
        ]
          ? TeqWorkLocationConfiguration.fromJS(
              _data['teqWorkLocationConfiguration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): AddTeqOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddTeqOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      if (Array.isArray(this.selectedWorkLocationPolicyIds)) {
        data['selectedWorkLocationPolicyIds'] = [];
        for (let item of this.selectedWorkLocationPolicyIds)
          data['selectedWorkLocationPolicyIds'].push(item);
      }
      data['teqWorkLocationConfiguration'] = this.teqWorkLocationConfiguration
        ? this.teqWorkLocationConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IAddTeqOverrideCommand {
    clientId: string;
    employeeTransactionIds: UpsertEmployeeIdTransactionIdSettingDto[];
    grossUpSetting: GrossUpSetting | null;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction | null;
    selectedWorkLocationPolicyIds: string[];
    teqWorkLocationConfiguration: TeqWorkLocationConfiguration | null;
  }

  export class UpsertEmployeeIdTransactionIdSettingDto
    implements IUpsertEmployeeIdTransactionIdSettingDto
  {
    employeeId!: string;
    transactionId!: string | null;
    isRecordDuplicate!: boolean;

    constructor(data?: IUpsertEmployeeIdTransactionIdSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.isRecordDuplicate =
          _data['isRecordDuplicate'] !== undefined
            ? _data['isRecordDuplicate']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertEmployeeIdTransactionIdSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertEmployeeIdTransactionIdSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['isRecordDuplicate'] =
        this.isRecordDuplicate !== undefined
          ? this.isRecordDuplicate
          : <any>null;
      return data;
    }
  }

  export interface IUpsertEmployeeIdTransactionIdSettingDto {
    employeeId: string;
    transactionId: string | null;
    isRecordDuplicate: boolean;
  }

  export abstract class UpdateTeqOverrideGrossUpSettingCommandResult
    implements IUpdateTeqOverrideGrossUpSettingCommandResult
  {
    constructor(data?: IUpdateTeqOverrideGrossUpSettingCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateTeqOverrideGrossUpSettingCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpdateTeqOverrideGrossUpSettingCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateTeqOverrideGrossUpSettingCommandResult {}

  export class UpdateTeqOverrideGrossUpSettingCommandResultSuccess
    extends UpdateTeqOverrideGrossUpSettingCommandResult
    implements IUpdateTeqOverrideGrossUpSettingCommandResultSuccess
  {
    constructor(data?: IUpdateTeqOverrideGrossUpSettingCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideGrossUpSettingCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideGrossUpSettingCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideGrossUpSettingCommandResultSuccess
    extends IUpdateTeqOverrideGrossUpSettingCommandResult {}

  export class UpdateTeqOverrideGrossUpSettingCommandResultFailure
    extends UpdateTeqOverrideGrossUpSettingCommandResult
    implements IUpdateTeqOverrideGrossUpSettingCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpdateTeqOverrideGrossUpSettingCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideGrossUpSettingCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideGrossUpSettingCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideGrossUpSettingCommandResultFailure
    extends IUpdateTeqOverrideGrossUpSettingCommandResult {
    errors: string;
  }

  export class UpdateTeqOverrideGrossUpSettingCommand
    implements IUpdateTeqOverrideGrossUpSettingCommand
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    grossUpSetting!: GrossUpSetting;

    constructor(data?: IUpdateTeqOverrideGrossUpSettingCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateTeqOverrideGrossUpSettingCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideGrossUpSettingCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      return data;
    }
  }

  export interface IUpdateTeqOverrideGrossUpSettingCommand {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    grossUpSetting: GrossUpSetting;
  }

  export abstract class UpdateTeqOverrideHypoCommandResult
    implements IUpdateTeqOverrideHypoCommandResult
  {
    constructor(data?: IUpdateTeqOverrideHypoCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateTeqOverrideHypoCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpdateTeqOverrideHypoCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateTeqOverrideHypoCommandResult {}

  export class UpdateTeqOverrideHypoCommandResultSuccess
    extends UpdateTeqOverrideHypoCommandResult
    implements IUpdateTeqOverrideHypoCommandResultSuccess
  {
    constructor(data?: IUpdateTeqOverrideHypoCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideHypoCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideHypoCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideHypoCommandResultSuccess
    extends IUpdateTeqOverrideHypoCommandResult {}

  export class UpdateTeqOverrideHypoCommandResultFailure
    extends UpdateTeqOverrideHypoCommandResult
    implements IUpdateTeqOverrideHypoCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpdateTeqOverrideHypoCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideHypoCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideHypoCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideHypoCommandResultFailure
    extends IUpdateTeqOverrideHypoCommandResult {
    errors: string;
  }

  export class UpdateTeqOverrideHypoCommand
    implements IUpdateTeqOverrideHypoCommand
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction;

    constructor(data?: IUpdateTeqOverrideHypoCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateTeqOverrideHypoCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideHypoCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      return data;
    }
  }

  export interface IUpdateTeqOverrideHypoCommand {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction;
  }

  export abstract class UpdateTeqOverrideWorkLocationCommandResult
    implements IUpdateTeqOverrideWorkLocationCommandResult
  {
    constructor(data?: IUpdateTeqOverrideWorkLocationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateTeqOverrideWorkLocationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpdateTeqOverrideWorkLocationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateTeqOverrideWorkLocationCommandResult {}

  export class UpdateTeqOverrideWorkLocationCommandResultSuccess
    extends UpdateTeqOverrideWorkLocationCommandResult
    implements IUpdateTeqOverrideWorkLocationCommandResultSuccess
  {
    constructor(data?: IUpdateTeqOverrideWorkLocationCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideWorkLocationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideWorkLocationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideWorkLocationCommandResultSuccess
    extends IUpdateTeqOverrideWorkLocationCommandResult {}

  export class UpdateTeqOverrideWorkLocationCommandResultFailure
    extends UpdateTeqOverrideWorkLocationCommandResult
    implements IUpdateTeqOverrideWorkLocationCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpdateTeqOverrideWorkLocationCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpdateTeqOverrideWorkLocationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideWorkLocationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateTeqOverrideWorkLocationCommandResultFailure
    extends IUpdateTeqOverrideWorkLocationCommandResult {
    errors: string;
  }

  export class UpdateTeqOverrideWorkLocationCommand
    implements IUpdateTeqOverrideWorkLocationCommand
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    employeeTransactionIds!: UpsertEmployeeIdTransactionIdSettingDto[];
    selectedWorkLocationPolicyIds!: string[];
    teqWorkLocationConfiguration!: TeqWorkLocationConfiguration;

    constructor(data?: IUpdateTeqOverrideWorkLocationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedWorkLocationPolicyIds = [];
        this.teqWorkLocationConfiguration = new TeqWorkLocationConfiguration();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              UpsertEmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedWorkLocationPolicyIds'])) {
          this.selectedWorkLocationPolicyIds = [] as any;
          for (let item of _data['selectedWorkLocationPolicyIds'])
            this.selectedWorkLocationPolicyIds!.push(item);
        } else {
          this.selectedWorkLocationPolicyIds = <any>null;
        }
        this.teqWorkLocationConfiguration = _data[
          'teqWorkLocationConfiguration'
        ]
          ? TeqWorkLocationConfiguration.fromJS(
              _data['teqWorkLocationConfiguration'],
            )
          : new TeqWorkLocationConfiguration();
      }
    }

    static fromJS(data: any): UpdateTeqOverrideWorkLocationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateTeqOverrideWorkLocationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedWorkLocationPolicyIds)) {
        data['selectedWorkLocationPolicyIds'] = [];
        for (let item of this.selectedWorkLocationPolicyIds)
          data['selectedWorkLocationPolicyIds'].push(item);
      }
      data['teqWorkLocationConfiguration'] = this.teqWorkLocationConfiguration
        ? this.teqWorkLocationConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpdateTeqOverrideWorkLocationCommand {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    employeeTransactionIds: UpsertEmployeeIdTransactionIdSettingDto[];
    selectedWorkLocationPolicyIds: string[];
    teqWorkLocationConfiguration: TeqWorkLocationConfiguration;
  }

  export class DeleteTeqOverrideCommandResult
    implements IDeleteTeqOverrideCommandResult
  {
    constructor(data?: IDeleteTeqOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteTeqOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTeqOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteTeqOverrideCommandResult {}

  export class DeleteTeqOverrideCommandResultSuccess
    extends DeleteTeqOverrideCommandResult
    implements IDeleteTeqOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteTeqOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): DeleteTeqOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTeqOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTeqOverrideCommandResultSuccess
    extends IDeleteTeqOverrideCommandResult {}

  export class DeleteTeqOverrideCommandResultFailure
    extends DeleteTeqOverrideCommandResult
    implements IDeleteTeqOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteTeqOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): DeleteTeqOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTeqOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTeqOverrideCommandResultFailure
    extends IDeleteTeqOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteTeqOverrideCommand implements IDeleteTeqOverrideCommand {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteTeqOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteTeqOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTeqOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteTeqOverrideCommand {
    clientId: string;
    id: string;
  }

  export class DownloadTeqOverridesFileCommand
    implements IDownloadTeqOverridesFileCommand
  {
    constructor(data?: IDownloadTeqOverridesFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadTeqOverridesFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadTeqOverridesFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadTeqOverridesFileCommand {}

  export class ParseTeqOverridesCommandResult
    implements IParseTeqOverridesCommandResult
  {
    constructor(data?: IParseTeqOverridesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ParseTeqOverridesCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ParseTeqOverridesCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IParseTeqOverridesCommandResult {}

  export class ParseTeqOverridesCommandResultSuccess
    extends ParseTeqOverridesCommandResult
    implements IParseTeqOverridesCommandResultSuccess
  {
    result!: UpsertEmployeeIdTransactionIdSettingDto[];

    constructor(data?: IParseTeqOverridesCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(
              UpsertEmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(data: any): ParseTeqOverridesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ParseTeqOverridesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IParseTeqOverridesCommandResultSuccess
    extends IParseTeqOverridesCommandResult {
    result: UpsertEmployeeIdTransactionIdSettingDto[];
  }

  export class ParseTeqOverridesCommandResultFailure
    extends ParseTeqOverridesCommandResult
    implements IParseTeqOverridesCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IParseTeqOverridesCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): ParseTeqOverridesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ParseTeqOverridesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IParseTeqOverridesCommandResultFailure
    extends IParseTeqOverridesCommandResult {
    errorMessage: string;
  }

  export abstract class CheckTeqOverrideDuplicateDataCommandResult
    implements ICheckTeqOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckTeqOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckTeqOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckTeqOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckTeqOverrideDuplicateDataCommandResult {}

  export class CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess
    extends CheckTeqOverrideDuplicateDataCommandResult
    implements ICheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTeqEmployeeTeqOverrideDuplicateDataCommandResultSuccess
    extends ICheckTeqOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckTeqOverrideDuplicateDataCommandResultFailure
    extends CheckTeqOverrideDuplicateDataCommandResult
    implements ICheckTeqOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ICheckTeqOverrideDuplicateDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTeqOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTeqOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTeqOverrideDuplicateDataCommandResultFailure
    extends ICheckTeqOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckTeqOverrideDuplicateDataCommand
    implements ICheckTeqOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    grossUpSetting!: GrossUpSetting | null;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction | null;
    workLocationPolicyIds!: string[] | null;

    constructor(data?: ICheckTeqOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
        if (Array.isArray(_data['workLocationPolicyIds'])) {
          this.workLocationPolicyIds = [] as any;
          for (let item of _data['workLocationPolicyIds'])
            this.workLocationPolicyIds!.push(item);
        } else {
          this.workLocationPolicyIds = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckTeqOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTeqOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      if (Array.isArray(this.workLocationPolicyIds)) {
        data['workLocationPolicyIds'] = [];
        for (let item of this.workLocationPolicyIds)
          data['workLocationPolicyIds'].push(item);
      }
      return data;
    }
  }

  export interface ICheckTeqOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    grossUpSetting: GrossUpSetting | null;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction | null;
    workLocationPolicyIds: string[] | null;
  }

  export class EmployeeIdTransactionIdSettingDto
    implements IEmployeeIdTransactionIdSettingDto
  {
    employeeId!: string;
    transactionId!: string | null;
    isRecordDuplicate!: boolean;

    constructor(data?: IEmployeeIdTransactionIdSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.isRecordDuplicate =
          _data['isRecordDuplicate'] !== undefined
            ? _data['isRecordDuplicate']
            : <any>null;
      }
    }

    static fromJS(data: any): EmployeeIdTransactionIdSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeIdTransactionIdSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['isRecordDuplicate'] =
        this.isRecordDuplicate !== undefined
          ? this.isRecordDuplicate
          : <any>null;
      return data;
    }
  }

  export interface IEmployeeIdTransactionIdSettingDto {
    employeeId: string;
    transactionId: string | null;
    isRecordDuplicate: boolean;
  }

  export class GetTeqClientSettingsQueryResult
    implements IGetTeqClientSettingsQueryResult
  {
    constructor(data?: IGetTeqClientSettingsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTeqClientSettingsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqClientSettingsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTeqClientSettingsQueryResult {}

  export class GetTeqClientSettingsQueryResultSuccess
    extends GetTeqClientSettingsQueryResult
    implements IGetTeqClientSettingsQueryResultSuccess
  {
    result!: TeqClientSettingsPageData;

    constructor(data?: IGetTeqClientSettingsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TeqClientSettingsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TeqClientSettingsPageData.fromJS(_data['result'])
          : new TeqClientSettingsPageData();
      }
    }

    static override fromJS(data: any): GetTeqClientSettingsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqClientSettingsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqClientSettingsQueryResultSuccess
    extends IGetTeqClientSettingsQueryResult {
    result: TeqClientSettingsPageData;
  }

  export class TeqClientSettingsPageData implements ITeqClientSettingsPageData {
    periodOfCoverageDto!: PeriodOfCoverageDto[];
    multiplePeriodsOfCoverageDto!: MultiplePeriodsOfCoverageDto[];
    grossUpSettingDto!: GrossUpSettingDto[];
    grossUpTaxesDto!: GrossUpTaxesDto[];
    hypotheticalTaxDeductionDto!: HypotheticalTaxDeductionDto[];
    grossUpTaxTypeDto!: GrossUpTaxTypeDto[];
    teqClientSettingsDto!: TeqClientSettingsDto | null;
    policyExceptions!: PolicyExceptionDto[];

    constructor(data?: ITeqClientSettingsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.periodOfCoverageDto = [];
        this.multiplePeriodsOfCoverageDto = [];
        this.grossUpSettingDto = [];
        this.grossUpTaxesDto = [];
        this.hypotheticalTaxDeductionDto = [];
        this.grossUpTaxTypeDto = [];
        this.policyExceptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['periodOfCoverageDto'])) {
          this.periodOfCoverageDto = [] as any;
          for (let item of _data['periodOfCoverageDto'])
            this.periodOfCoverageDto!.push(PeriodOfCoverageDto.fromJS(item));
        } else {
          this.periodOfCoverageDto = <any>null;
        }
        if (Array.isArray(_data['multiplePeriodsOfCoverageDto'])) {
          this.multiplePeriodsOfCoverageDto = [] as any;
          for (let item of _data['multiplePeriodsOfCoverageDto'])
            this.multiplePeriodsOfCoverageDto!.push(
              MultiplePeriodsOfCoverageDto.fromJS(item),
            );
        } else {
          this.multiplePeriodsOfCoverageDto = <any>null;
        }
        if (Array.isArray(_data['grossUpSettingDto'])) {
          this.grossUpSettingDto = [] as any;
          for (let item of _data['grossUpSettingDto'])
            this.grossUpSettingDto!.push(GrossUpSettingDto.fromJS(item));
        } else {
          this.grossUpSettingDto = <any>null;
        }
        if (Array.isArray(_data['grossUpTaxesDto'])) {
          this.grossUpTaxesDto = [] as any;
          for (let item of _data['grossUpTaxesDto'])
            this.grossUpTaxesDto!.push(GrossUpTaxesDto.fromJS(item));
        } else {
          this.grossUpTaxesDto = <any>null;
        }
        if (Array.isArray(_data['hypotheticalTaxDeductionDto'])) {
          this.hypotheticalTaxDeductionDto = [] as any;
          for (let item of _data['hypotheticalTaxDeductionDto'])
            this.hypotheticalTaxDeductionDto!.push(
              HypotheticalTaxDeductionDto.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductionDto = <any>null;
        }
        if (Array.isArray(_data['grossUpTaxTypeDto'])) {
          this.grossUpTaxTypeDto = [] as any;
          for (let item of _data['grossUpTaxTypeDto'])
            this.grossUpTaxTypeDto!.push(GrossUpTaxTypeDto.fromJS(item));
        } else {
          this.grossUpTaxTypeDto = <any>null;
        }
        this.teqClientSettingsDto = _data['teqClientSettingsDto']
          ? TeqClientSettingsDto.fromJS(_data['teqClientSettingsDto'])
          : <any>null;
        if (Array.isArray(_data['policyExceptions'])) {
          this.policyExceptions = [] as any;
          for (let item of _data['policyExceptions'])
            this.policyExceptions!.push(PolicyExceptionDto.fromJS(item));
        } else {
          this.policyExceptions = <any>null;
        }
      }
    }

    static fromJS(data: any): TeqClientSettingsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TeqClientSettingsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.periodOfCoverageDto)) {
        data['periodOfCoverageDto'] = [];
        for (let item of this.periodOfCoverageDto)
          data['periodOfCoverageDto'].push(item.toJSON());
      }
      if (Array.isArray(this.multiplePeriodsOfCoverageDto)) {
        data['multiplePeriodsOfCoverageDto'] = [];
        for (let item of this.multiplePeriodsOfCoverageDto)
          data['multiplePeriodsOfCoverageDto'].push(item.toJSON());
      }
      if (Array.isArray(this.grossUpSettingDto)) {
        data['grossUpSettingDto'] = [];
        for (let item of this.grossUpSettingDto)
          data['grossUpSettingDto'].push(item.toJSON());
      }
      if (Array.isArray(this.grossUpTaxesDto)) {
        data['grossUpTaxesDto'] = [];
        for (let item of this.grossUpTaxesDto)
          data['grossUpTaxesDto'].push(item.toJSON());
      }
      if (Array.isArray(this.hypotheticalTaxDeductionDto)) {
        data['hypotheticalTaxDeductionDto'] = [];
        for (let item of this.hypotheticalTaxDeductionDto)
          data['hypotheticalTaxDeductionDto'].push(item.toJSON());
      }
      if (Array.isArray(this.grossUpTaxTypeDto)) {
        data['grossUpTaxTypeDto'] = [];
        for (let item of this.grossUpTaxTypeDto)
          data['grossUpTaxTypeDto'].push(item.toJSON());
      }
      data['teqClientSettingsDto'] = this.teqClientSettingsDto
        ? this.teqClientSettingsDto.toJSON()
        : <any>null;
      if (Array.isArray(this.policyExceptions)) {
        data['policyExceptions'] = [];
        for (let item of this.policyExceptions)
          data['policyExceptions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITeqClientSettingsPageData {
    periodOfCoverageDto: PeriodOfCoverageDto[];
    multiplePeriodsOfCoverageDto: MultiplePeriodsOfCoverageDto[];
    grossUpSettingDto: GrossUpSettingDto[];
    grossUpTaxesDto: GrossUpTaxesDto[];
    hypotheticalTaxDeductionDto: HypotheticalTaxDeductionDto[];
    grossUpTaxTypeDto: GrossUpTaxTypeDto[];
    teqClientSettingsDto: TeqClientSettingsDto | null;
    policyExceptions: PolicyExceptionDto[];
  }

  export class PeriodOfCoverageDto implements IPeriodOfCoverageDto {
    optionValue!: PeriodOfCoverage;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IPeriodOfCoverageDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): PeriodOfCoverageDto {
      data = typeof data === 'object' ? data : {};
      let result = new PeriodOfCoverageDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IPeriodOfCoverageDto {
    optionValue: PeriodOfCoverage;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum PeriodOfCoverage {
    WholeAwardIsEqualized = 'WholeAwardIsEqualized',
    OnlyEqualizedPeriods = 'OnlyEqualizedPeriods',
    EqualizedPeriods = 'EqualizedPeriods',
  }

  export class MultiplePeriodsOfCoverageDto
    implements IMultiplePeriodsOfCoverageDto
  {
    optionValue!: MultiplePeriodsOfCoverage;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IMultiplePeriodsOfCoverageDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): MultiplePeriodsOfCoverageDto {
      data = typeof data === 'object' ? data : {};
      let result = new MultiplePeriodsOfCoverageDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IMultiplePeriodsOfCoverageDto {
    optionValue: MultiplePeriodsOfCoverage;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum MultiplePeriodsOfCoverage {
    EarliestTaxEqualization = 'EarliestTaxEqualization',
    LatestTaxEqualization = 'LatestTaxEqualization',
  }

  export class GrossUpSettingDto implements IGrossUpSettingDto {
    optionValue!: GrossUpSetting;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IGrossUpSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): GrossUpSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new GrossUpSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IGrossUpSettingDto {
    optionValue: GrossUpSetting;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class GrossUpTaxesDto implements IGrossUpTaxesDto {
    optionValue!: GrossUpTaxes;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IGrossUpTaxesDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): GrossUpTaxesDto {
      data = typeof data === 'object' ? data : {};
      let result = new GrossUpTaxesDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IGrossUpTaxesDto {
    optionValue: GrossUpTaxes;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum GrossUpTaxes {
    FollowCountryLegislation = 'FollowCountryLegislation',
    ApplyGrossUpToAllTaxes = 'ApplyGrossUpToAllTaxes',
  }

  export class HypotheticalTaxDeductionDto
    implements IHypotheticalTaxDeductionDto
  {
    optionValue!: HypotheticalTaxDeduction;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IHypotheticalTaxDeductionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalTaxDeductionDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalTaxDeductionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IHypotheticalTaxDeductionDto {
    optionValue: HypotheticalTaxDeduction;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class GrossUpTaxTypeDto implements IGrossUpTaxTypeDto {
    optionValue!: GrossUpTaxType;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IGrossUpTaxTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): GrossUpTaxTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new GrossUpTaxTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IGrossUpTaxTypeDto {
    optionValue: GrossUpTaxType;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export enum GrossUpTaxType {
    IncomeTax = 'IncomeTax',
    SocialTax = 'SocialTax',
    RegionTax = 'RegionTax',
  }

  export class TeqClientSettingsDto implements ITeqClientSettingsDto {
    clientId!: string;
    periodOfCoverage!: PeriodOfCoverage;
    multiplePeriodsOfCoverage!: MultiplePeriodsOfCoverage;
    grossUpSetting!: GrossUpSetting;
    grossUpTaxes!: GrossUpTaxes;
    hypoTaxSetting!: HypotheticalTaxDeduction;

    constructor(data?: ITeqClientSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.periodOfCoverage =
          _data['periodOfCoverage'] !== undefined
            ? _data['periodOfCoverage']
            : <any>null;
        this.multiplePeriodsOfCoverage =
          _data['multiplePeriodsOfCoverage'] !== undefined
            ? _data['multiplePeriodsOfCoverage']
            : <any>null;
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.grossUpTaxes =
          _data['grossUpTaxes'] !== undefined
            ? _data['grossUpTaxes']
            : <any>null;
        this.hypoTaxSetting =
          _data['hypoTaxSetting'] !== undefined
            ? _data['hypoTaxSetting']
            : <any>null;
      }
    }

    static fromJS(data: any): TeqClientSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeqClientSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['periodOfCoverage'] =
        this.periodOfCoverage !== undefined ? this.periodOfCoverage : <any>null;
      data['multiplePeriodsOfCoverage'] =
        this.multiplePeriodsOfCoverage !== undefined
          ? this.multiplePeriodsOfCoverage
          : <any>null;
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['grossUpTaxes'] =
        this.grossUpTaxes !== undefined ? this.grossUpTaxes : <any>null;
      data['hypoTaxSetting'] =
        this.hypoTaxSetting !== undefined ? this.hypoTaxSetting : <any>null;
      return data;
    }
  }

  export interface ITeqClientSettingsDto {
    clientId: string;
    periodOfCoverage: PeriodOfCoverage;
    multiplePeriodsOfCoverage: MultiplePeriodsOfCoverage;
    grossUpSetting: GrossUpSetting;
    grossUpTaxes: GrossUpTaxes;
    hypoTaxSetting: HypotheticalTaxDeduction;
  }

  export class GetTeqClientSettingsQueryResultFailure
    extends GetTeqClientSettingsQueryResult
    implements IGetTeqClientSettingsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTeqClientSettingsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTeqClientSettingsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTeqClientSettingsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTeqClientSettingsQueryResultFailure
    extends IGetTeqClientSettingsQueryResult {
    errors: ResultError[];
  }

  export class UpsertTeqClientSettingsCommandResult
    implements IUpsertTeqClientSettingsCommandResult
  {
    constructor(data?: IUpsertTeqClientSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTeqClientSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqClientSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTeqClientSettingsCommandResult {}

  export class UpsertTeqClientSettingsCommandResultSuccess
    extends UpsertTeqClientSettingsCommandResult
    implements IUpsertTeqClientSettingsCommandResultSuccess
  {
    constructor(data?: IUpsertTeqClientSettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTeqClientSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqClientSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTeqClientSettingsCommandResultSuccess
    extends IUpsertTeqClientSettingsCommandResult {}

  export class UpsertTeqClientSettingsCommandResultFailure
    extends UpsertTeqClientSettingsCommandResult
    implements IUpsertTeqClientSettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertTeqClientSettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTeqClientSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqClientSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTeqClientSettingsCommandResultFailure
    extends IUpsertTeqClientSettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertTeqClientSettingsCommand
    implements IUpsertTeqClientSettingsCommand
  {
    clientId!: string;
    periodOfCoverage!: PeriodOfCoverage;
    multiplePeriodsOfCoverage!: MultiplePeriodsOfCoverage;
    grossUpSetting!: GrossUpSetting;
    grossUpTaxes!: GrossUpTaxes;
    hypotheticalTaxDeduction!: HypotheticalTaxDeduction;

    constructor(data?: IUpsertTeqClientSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.periodOfCoverage =
          _data['periodOfCoverage'] !== undefined
            ? _data['periodOfCoverage']
            : <any>null;
        this.multiplePeriodsOfCoverage =
          _data['multiplePeriodsOfCoverage'] !== undefined
            ? _data['multiplePeriodsOfCoverage']
            : <any>null;
        this.grossUpSetting =
          _data['grossUpSetting'] !== undefined
            ? _data['grossUpSetting']
            : <any>null;
        this.grossUpTaxes =
          _data['grossUpTaxes'] !== undefined
            ? _data['grossUpTaxes']
            : <any>null;
        this.hypotheticalTaxDeduction =
          _data['hypotheticalTaxDeduction'] !== undefined
            ? _data['hypotheticalTaxDeduction']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertTeqClientSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTeqClientSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['periodOfCoverage'] =
        this.periodOfCoverage !== undefined ? this.periodOfCoverage : <any>null;
      data['multiplePeriodsOfCoverage'] =
        this.multiplePeriodsOfCoverage !== undefined
          ? this.multiplePeriodsOfCoverage
          : <any>null;
      data['grossUpSetting'] =
        this.grossUpSetting !== undefined ? this.grossUpSetting : <any>null;
      data['grossUpTaxes'] =
        this.grossUpTaxes !== undefined ? this.grossUpTaxes : <any>null;
      data['hypotheticalTaxDeduction'] =
        this.hypotheticalTaxDeduction !== undefined
          ? this.hypotheticalTaxDeduction
          : <any>null;
      return data;
    }
  }

  export interface IUpsertTeqClientSettingsCommand {
    clientId: string;
    periodOfCoverage: PeriodOfCoverage;
    multiplePeriodsOfCoverage: MultiplePeriodsOfCoverage;
    grossUpSetting: GrossUpSetting;
    grossUpTaxes: GrossUpTaxes;
    hypotheticalTaxDeduction: HypotheticalTaxDeduction;
  }

  export class GetTaxRatePolicyPageDataQueryResult
    implements IGetTaxRatePolicyPageDataQueryResult
  {
    constructor(data?: IGetTaxRatePolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxRatePolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRatePolicyPageDataQueryResult {}

  export class GetTaxRatePolicyPageDataQueryResultSuccess
    extends GetTaxRatePolicyPageDataQueryResult
    implements IGetTaxRatePolicyPageDataQueryResultSuccess
  {
    result!: TaxRatePolicyPageData;

    constructor(data?: IGetTaxRatePolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TaxRatePolicyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxRatePolicyPageData.fromJS(_data['result'])
          : new TaxRatePolicyPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRatePolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRatePolicyPageDataQueryResultSuccess
    extends IGetTaxRatePolicyPageDataQueryResult {
    result: TaxRatePolicyPageData;
  }

  export class TaxRatePolicyPageData implements ITaxRatePolicyPageData {
    residencyStatusOptions!: ResidencyStatusDto[];
    taxRatePolicyOptions!: TaxRatePolicyDto[];
    batchActionOptions!: TaxRatePolicyBatchActionOptionDto[];
    countriesInFootprint!: TaxRatePolicyCountryData[];
    taxRatePolicySettings!: TaxRatePolicySettingsDto | null;

    constructor(data?: ITaxRatePolicyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyStatusOptions = [];
        this.taxRatePolicyOptions = [];
        this.batchActionOptions = [];
        this.countriesInFootprint = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['residencyStatusOptions'])) {
          this.residencyStatusOptions = [] as any;
          for (let item of _data['residencyStatusOptions'])
            this.residencyStatusOptions!.push(ResidencyStatusDto.fromJS(item));
        } else {
          this.residencyStatusOptions = <any>null;
        }
        if (Array.isArray(_data['taxRatePolicyOptions'])) {
          this.taxRatePolicyOptions = [] as any;
          for (let item of _data['taxRatePolicyOptions'])
            this.taxRatePolicyOptions!.push(TaxRatePolicyDto.fromJS(item));
        } else {
          this.taxRatePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['batchActionOptions'])) {
          this.batchActionOptions = [] as any;
          for (let item of _data['batchActionOptions'])
            this.batchActionOptions!.push(
              TaxRatePolicyBatchActionOptionDto.fromJS(item),
            );
        } else {
          this.batchActionOptions = <any>null;
        }
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              TaxRatePolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        this.taxRatePolicySettings = _data['taxRatePolicySettings']
          ? TaxRatePolicySettingsDto.fromJS(_data['taxRatePolicySettings'])
          : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.residencyStatusOptions)) {
        data['residencyStatusOptions'] = [];
        for (let item of this.residencyStatusOptions)
          data['residencyStatusOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRatePolicyOptions)) {
        data['taxRatePolicyOptions'] = [];
        for (let item of this.taxRatePolicyOptions)
          data['taxRatePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.batchActionOptions)) {
        data['batchActionOptions'] = [];
        for (let item of this.batchActionOptions)
          data['batchActionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      data['taxRatePolicySettings'] = this.taxRatePolicySettings
        ? this.taxRatePolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyPageData {
    residencyStatusOptions: ResidencyStatusDto[];
    taxRatePolicyOptions: TaxRatePolicyDto[];
    batchActionOptions: TaxRatePolicyBatchActionOptionDto[];
    countriesInFootprint: TaxRatePolicyCountryData[];
    taxRatePolicySettings: TaxRatePolicySettingsDto | null;
  }

  export class ResidencyStatusDto implements IResidencyStatusDto {
    optionValue!: ResidencyStatus;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IResidencyStatusDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ResidencyStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyStatusDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IResidencyStatusDto {
    optionValue: ResidencyStatus;
    displayValue: string;
    displayOrder: number;
  }

  export enum ResidencyStatus {
    Resident = 'Resident',
    NonResident = 'NonResident',
  }

  export class TaxRatePolicyDto implements ITaxRatePolicyDto {
    optionValue!: TaxRatePolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyDto {
    optionValue: TaxRatePolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum TaxRatePolicy {
    Banded = 'Banded',
    TopRate = 'TopRate',
  }

  export class TaxRatePolicyBatchActionOptionDto
    implements ITaxRatePolicyBatchActionOptionDto
  {
    optionValue!: TaxRatePolicyBatchActionOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxRatePolicyBatchActionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyBatchActionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyBatchActionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyBatchActionOptionDto {
    optionValue: TaxRatePolicyBatchActionOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum TaxRatePolicyBatchActionOption {
    CompanyDefault = 'CompanyDefault',
    Banded = 'Banded',
    TopRate = 'TopRate',
  }

  export class TaxRatePolicyCountryData implements ITaxRatePolicyCountryData {
    countryCode!: string;
    countryName!: string;

    constructor(data?: ITaxRatePolicyCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyCountryData {
    countryCode: string;
    countryName: string;
  }

  export class TaxRatePolicySettingsDto implements ITaxRatePolicySettingsDto {
    id!: string;
    companyDefault!: TaxRatePolicy;
    countrySettings!: CountryResidencyStatusTaxRatePolicySettingDto[];
    countrySettingsByCountry!: {
      [key: string]: CountryResidencyStatusTaxRatePolicySettingDto;
    };

    constructor(data?: ITaxRatePolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
        this.countrySettingsByCountry = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.companyDefault =
          _data['companyDefault'] !== undefined
            ? _data['companyDefault']
            : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CountryResidencyStatusTaxRatePolicySettingDto.fromJS(item),
            );
        } else {
          this.countrySettings = <any>null;
        }
        if (_data['countrySettingsByCountry']) {
          this.countrySettingsByCountry = {} as any;
          for (let key in _data['countrySettingsByCountry']) {
            if (_data['countrySettingsByCountry'].hasOwnProperty(key))
              (<any>this.countrySettingsByCountry)![key] = _data[
                'countrySettingsByCountry'
              ][key]
                ? CountryResidencyStatusTaxRatePolicySettingDto.fromJS(
                    _data['countrySettingsByCountry'][key],
                  )
                : new CountryResidencyStatusTaxRatePolicySettingDto();
          }
        } else {
          this.countrySettingsByCountry = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRatePolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['companyDefault'] =
        this.companyDefault !== undefined ? this.companyDefault : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      if (this.countrySettingsByCountry) {
        data['countrySettingsByCountry'] = {};
        for (let key in this.countrySettingsByCountry) {
          if (this.countrySettingsByCountry.hasOwnProperty(key))
            (<any>data['countrySettingsByCountry'])[key] = this
              .countrySettingsByCountry[key]
              ? this.countrySettingsByCountry[key].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface ITaxRatePolicySettingsDto {
    id: string;
    companyDefault: TaxRatePolicy;
    countrySettings: CountryResidencyStatusTaxRatePolicySettingDto[];
    countrySettingsByCountry: {
      [key: string]: CountryResidencyStatusTaxRatePolicySettingDto;
    };
  }

  export class CountryResidencyStatusTaxRatePolicySettingDto
    implements ICountryResidencyStatusTaxRatePolicySettingDto
  {
    countryCode!: string;
    residentTaxRatePolicy!: TaxRatePolicy | null;
    nonResidentTaxRatePolicy!: TaxRatePolicy | null;

    constructor(data?: ICountryResidencyStatusTaxRatePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.residentTaxRatePolicy =
          _data['residentTaxRatePolicy'] !== undefined
            ? _data['residentTaxRatePolicy']
            : <any>null;
        this.nonResidentTaxRatePolicy =
          _data['nonResidentTaxRatePolicy'] !== undefined
            ? _data['nonResidentTaxRatePolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryResidencyStatusTaxRatePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryResidencyStatusTaxRatePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['residentTaxRatePolicy'] =
        this.residentTaxRatePolicy !== undefined
          ? this.residentTaxRatePolicy
          : <any>null;
      data['nonResidentTaxRatePolicy'] =
        this.nonResidentTaxRatePolicy !== undefined
          ? this.nonResidentTaxRatePolicy
          : <any>null;
      return data;
    }
  }

  export interface ICountryResidencyStatusTaxRatePolicySettingDto {
    countryCode: string;
    residentTaxRatePolicy: TaxRatePolicy | null;
    nonResidentTaxRatePolicy: TaxRatePolicy | null;
  }

  export class GetTaxRatePolicyPageDataQueryResultFailure
    extends GetTaxRatePolicyPageDataQueryResult
    implements IGetTaxRatePolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxRatePolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRatePolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRatePolicyPageDataQueryResultFailure
    extends IGetTaxRatePolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertTaxRatePolicySettingsCommandResult
    implements IUpsertTaxRatePolicySettingsCommandResult
  {
    constructor(data?: IUpsertTaxRatePolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTaxRatePolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRatePolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTaxRatePolicySettingsCommandResult {}

  export class UpsertTaxRatePolicySettingsCommandResultSuccess
    extends UpsertTaxRatePolicySettingsCommandResult
    implements IUpsertTaxRatePolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertTaxRatePolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRatePolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRatePolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRatePolicySettingsCommandResultSuccess
    extends IUpsertTaxRatePolicySettingsCommandResult {}

  export class UpsertTaxRatePolicySettingsCommandResultFailure
    extends UpsertTaxRatePolicySettingsCommandResult
    implements IUpsertTaxRatePolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertTaxRatePolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRatePolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRatePolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRatePolicySettingsCommandResultFailure
    extends IUpsertTaxRatePolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertTaxRatePolicySettingsCommand
    implements IUpsertTaxRatePolicySettingsCommand
  {
    clientId!: string;
    companyDefault!: TaxRatePolicy;
    countrySettings!: CountryResidencyStatusTaxRatePolicySettingDto[];

    constructor(data?: IUpsertTaxRatePolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.companyDefault =
          _data['companyDefault'] !== undefined
            ? _data['companyDefault']
            : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CountryResidencyStatusTaxRatePolicySettingDto.fromJS(item),
            );
        } else {
          this.countrySettings = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertTaxRatePolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRatePolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['companyDefault'] =
        this.companyDefault !== undefined ? this.companyDefault : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertTaxRatePolicySettingsCommand {
    clientId: string;
    companyDefault: TaxRatePolicy;
    countrySettings: CountryResidencyStatusTaxRatePolicySettingDto[];
  }

  export class GetRegionTaxPositionsPageDataQueryResult
    implements IGetRegionTaxPositionsPageDataQueryResult
  {
    constructor(data?: IGetRegionTaxPositionsPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRegionTaxPositionsPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxPositionsPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionTaxPositionsPageDataQueryResult {}

  export class GetRegionTaxPositionsPageDataQueryResultSuccess
    extends GetRegionTaxPositionsPageDataQueryResult
    implements IGetRegionTaxPositionsPageDataQueryResultSuccess
  {
    result!: RegionTaxPositionsPageData;

    constructor(data?: IGetRegionTaxPositionsPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new RegionTaxPositionsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RegionTaxPositionsPageData.fromJS(_data['result'])
          : new RegionTaxPositionsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxPositionsPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxPositionsPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxPositionsPageDataQueryResultSuccess
    extends IGetRegionTaxPositionsPageDataQueryResult {
    result: RegionTaxPositionsPageData;
  }

  export class RegionTaxPositionsPageData
    implements IRegionTaxPositionsPageData
  {
    regionTaxPositionLineItems!: RegionTaxPositionLineItemDto[];

    constructor(data?: IRegionTaxPositionsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regionTaxPositionLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['regionTaxPositionLineItems'])) {
          this.regionTaxPositionLineItems = [] as any;
          for (let item of _data['regionTaxPositionLineItems'])
            this.regionTaxPositionLineItems!.push(
              RegionTaxPositionLineItemDto.fromJS(item),
            );
        } else {
          this.regionTaxPositionLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionTaxPositionsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.regionTaxPositionLineItems)) {
        data['regionTaxPositionLineItems'] = [];
        for (let item of this.regionTaxPositionLineItems)
          data['regionTaxPositionLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRegionTaxPositionsPageData {
    regionTaxPositionLineItems: RegionTaxPositionLineItemDto[];
  }

  export class RegionTaxPositionLineItemDto
    implements IRegionTaxPositionLineItemDto
  {
    country!: RegionTaxPositionCountryDto;
    numberOfRegions!: number;
    status!: CountryRegionTaxPositionStatus;
    isDeloittePositionUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: IRegionTaxPositionLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new RegionTaxPositionCountryDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? RegionTaxPositionCountryDto.fromJS(_data['country'])
          : new RegionTaxPositionCountryDto();
        this.numberOfRegions =
          _data['numberOfRegions'] !== undefined
            ? _data['numberOfRegions']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.isDeloittePositionUpdated =
          _data['isDeloittePositionUpdated'] !== undefined
            ? _data['isDeloittePositionUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['numberOfRegions'] =
        this.numberOfRegions !== undefined ? this.numberOfRegions : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['isDeloittePositionUpdated'] =
        this.isDeloittePositionUpdated !== undefined
          ? this.isDeloittePositionUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionLineItemDto {
    country: RegionTaxPositionCountryDto;
    numberOfRegions: number;
    status: CountryRegionTaxPositionStatus;
    isDeloittePositionUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class RegionTaxPositionCountryDto
    implements IRegionTaxPositionCountryDto
  {
    isoCode!: string;
    display!: string;

    constructor(data?: IRegionTaxPositionCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionCountryDto {
    isoCode: string;
    display: string;
  }

  export enum CountryRegionTaxPositionStatus {
    Unread = 'Unread',
    Reviewed = 'Reviewed',
  }

  export class GetRegionTaxPositionsPageDataQueryResultFailure
    extends GetRegionTaxPositionsPageDataQueryResult
    implements IGetRegionTaxPositionsPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetRegionTaxPositionsPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxPositionsPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxPositionsPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxPositionsPageDataQueryResultFailure
    extends IGetRegionTaxPositionsPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class SaveCountryRegionTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryRegionTaxPositionsWorkflowStepCommandResult
  {
    constructor(
      data?: ISaveCountryRegionTaxPositionsWorkflowStepCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): SaveCountryRegionTaxPositionsWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveCountryRegionTaxPositionsWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCountryRegionTaxPositionsWorkflowStepCommandResult {}

  export class SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess
    extends SaveCountryRegionTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryRegionTaxPositionsWorkflowStepCommandResultSuccess
    extends ISaveCountryRegionTaxPositionsWorkflowStepCommandResult {}

  export class SaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure
    extends SaveCountryRegionTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryRegionTaxPositionsWorkflowStepCommandResultFailure
    extends ISaveCountryRegionTaxPositionsWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveCountryRegionTaxPositionsWorkflowStepCommand
    implements ISaveCountryRegionTaxPositionsWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveCountryRegionTaxPositionsWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveCountryRegionTaxPositionsWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryRegionTaxPositionsWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveCountryRegionTaxPositionsWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadRegionTaxPositionsDataCommandResult
    implements IDownloadRegionTaxPositionsDataCommandResult
  {
    constructor(data?: IDownloadRegionTaxPositionsDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadRegionTaxPositionsDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadRegionTaxPositionsDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadRegionTaxPositionsDataCommandResult {}

  export class DownloadRegionTaxPositionsDataCommandResultSuccess
    extends DownloadRegionTaxPositionsDataCommandResult
    implements IDownloadRegionTaxPositionsDataCommandResultSuccess
  {
    result!: DownloadRegionTaxPositionsResponse;

    constructor(data?: IDownloadRegionTaxPositionsDataCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new DownloadRegionTaxPositionsResponse();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DownloadRegionTaxPositionsResponse.fromJS(_data['result'])
          : new DownloadRegionTaxPositionsResponse();
      }
    }

    static override fromJS(
      data: any,
    ): DownloadRegionTaxPositionsDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxPositionsDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadRegionTaxPositionsDataCommandResultSuccess
    extends IDownloadRegionTaxPositionsDataCommandResult {
    result: DownloadRegionTaxPositionsResponse;
  }

  export class DownloadRegionTaxPositionsResponse
    implements IDownloadRegionTaxPositionsResponse
  {
    fileName!: string;
    fileData!: string;

    constructor(data?: IDownloadRegionTaxPositionsResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.fileData =
          _data['fileData'] !== undefined ? _data['fileData'] : <any>null;
      }
    }

    static fromJS(data: any): DownloadRegionTaxPositionsResponse {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxPositionsResponse();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['fileData'] =
        this.fileData !== undefined ? this.fileData : <any>null;
      return data;
    }
  }

  export interface IDownloadRegionTaxPositionsResponse {
    fileName: string;
    fileData: string;
  }

  export class DownloadRegionTaxPositionsDataCommandResultFailure
    extends DownloadRegionTaxPositionsDataCommandResult
    implements IDownloadRegionTaxPositionsDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadRegionTaxPositionsDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadRegionTaxPositionsDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxPositionsDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadRegionTaxPositionsDataCommandResultFailure
    extends IDownloadRegionTaxPositionsDataCommandResult {
    errorMessage: string;
  }

  export class DownloadRegionTaxPositionsDataCommand
    implements IDownloadRegionTaxPositionsDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadRegionTaxPositionsDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadRegionTaxPositionsDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxPositionsDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadRegionTaxPositionsDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export abstract class GetRegionTaxPositionsCountryPageDataQueryResult
    implements IGetRegionTaxPositionsCountryPageDataQueryResult
  {
    constructor(data?: IGetRegionTaxPositionsCountryPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRegionTaxPositionsCountryPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetRegionTaxPositionsCountryPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionTaxPositionsCountryPageDataQueryResult {}

  export class GetRegionTaxPositionsCountryPageDataQueryResultSuccess
    extends GetRegionTaxPositionsCountryPageDataQueryResult
    implements IGetRegionTaxPositionsCountryPageDataQueryResultSuccess
  {
    result!: RegionTaxPositionsCountryPageData;

    constructor(
      data?: IGetRegionTaxPositionsCountryPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new RegionTaxPositionsCountryPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RegionTaxPositionsCountryPageData.fromJS(_data['result'])
          : new RegionTaxPositionsCountryPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxPositionsCountryPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxPositionsCountryPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxPositionsCountryPageDataQueryResultSuccess
    extends IGetRegionTaxPositionsCountryPageDataQueryResult {
    result: RegionTaxPositionsCountryPageData;
  }

  export class RegionTaxPositionsCountryPageData
    implements IRegionTaxPositionsCountryPageData
  {
    country!: RegionTaxPositionsCountryDto;
    regions!: RegionTaxPositionsRegionDto[];
    planTypes!: PlanTypeDto[];
    taxPositionSections!: RegionTaxPositionsPlanTypeTaxPositions[];

    constructor(data?: IRegionTaxPositionsCountryPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new RegionTaxPositionsCountryDto();
        this.regions = [];
        this.planTypes = [];
        this.taxPositionSections = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? RegionTaxPositionsCountryDto.fromJS(_data['country'])
          : new RegionTaxPositionsCountryDto();
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(RegionTaxPositionsRegionDto.fromJS(item));
        } else {
          this.regions = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['taxPositionSections'])) {
          this.taxPositionSections = [] as any;
          for (let item of _data['taxPositionSections'])
            this.taxPositionSections!.push(
              RegionTaxPositionsPlanTypeTaxPositions.fromJS(item),
            );
        } else {
          this.taxPositionSections = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionTaxPositionsCountryPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionsCountryPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxPositionSections)) {
        data['taxPositionSections'] = [];
        for (let item of this.taxPositionSections)
          data['taxPositionSections'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRegionTaxPositionsCountryPageData {
    country: RegionTaxPositionsCountryDto;
    regions: RegionTaxPositionsRegionDto[];
    planTypes: PlanTypeDto[];
    taxPositionSections: RegionTaxPositionsPlanTypeTaxPositions[];
  }

  export class RegionTaxPositionsCountryDto
    implements IRegionTaxPositionsCountryDto
  {
    isoCode!: string;
    display!: string;

    constructor(data?: IRegionTaxPositionsCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionsCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionsCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionsCountryDto {
    isoCode: string;
    display: string;
  }

  export class RegionTaxPositionsRegionDto
    implements IRegionTaxPositionsRegionDto
  {
    code!: string;
    display!: string;

    constructor(data?: IRegionTaxPositionsRegionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionsRegionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionsRegionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionsRegionDto {
    code: string;
    display: string;
  }

  export class PlanTypeDto implements IPlanTypeDto {
    optionValue!: PlanType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IPlanTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): PlanTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IPlanTypeDto {
    optionValue: PlanType;
    displayValue: string;
    displayOrder: number;
  }

  export class RegionTaxPositionsPlanTypeTaxPositions
    implements IRegionTaxPositionsPlanTypeTaxPositions
  {
    planType!: PlanType;
    taxPositionRows!: RegionTaxPositionRow[];

    constructor(data?: IRegionTaxPositionsPlanTypeTaxPositions) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositionRows = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        if (Array.isArray(_data['taxPositionRows'])) {
          this.taxPositionRows = [] as any;
          for (let item of _data['taxPositionRows'])
            this.taxPositionRows!.push(RegionTaxPositionRow.fromJS(item));
        } else {
          this.taxPositionRows = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionTaxPositionsPlanTypeTaxPositions {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionsPlanTypeTaxPositions();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      if (Array.isArray(this.taxPositionRows)) {
        data['taxPositionRows'] = [];
        for (let item of this.taxPositionRows)
          data['taxPositionRows'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRegionTaxPositionsPlanTypeTaxPositions {
    planType: PlanType;
    taxPositionRows: RegionTaxPositionRow[];
  }

  export class RegionTaxPositionRow implements IRegionTaxPositionRow {
    display!: string;
    displayOrder!: string;
    taxPositions!: RegionTaxPositionDto[];
    isEditable!: boolean;

    constructor(data?: IRegionTaxPositionRow) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(RegionTaxPositionDto.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
        this.isEditable =
          _data['isEditable'] !== undefined ? _data['isEditable'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionRow {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionRow();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      data['isEditable'] =
        this.isEditable !== undefined ? this.isEditable : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionRow {
    display: string;
    displayOrder: string;
    taxPositions: RegionTaxPositionDto[];
    isEditable: boolean;
  }

  export class RegionTaxPositionDto implements IRegionTaxPositionDto {
    code!: string;
    planType!: PlanType;
    regionCode!: string;
    isEditable!: boolean;
    configuredValue!: TaxPositionConfiguredValue | null;
    options!: TaxPositionOptionDto[];
    dataType!: string;
    defaultPosition!: TaxPositionDeloitteDefaultPosition | null;
    extraInformation!: string | null;

    constructor(data?: IRegionTaxPositionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.options = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.isEditable =
          _data['isEditable'] !== undefined ? _data['isEditable'] : <any>null;
        this.configuredValue = _data['configuredValue']
          ? TaxPositionConfiguredValue.fromJS(_data['configuredValue'])
          : <any>null;
        if (Array.isArray(_data['options'])) {
          this.options = [] as any;
          for (let item of _data['options'])
            this.options!.push(TaxPositionOptionDto.fromJS(item));
        } else {
          this.options = <any>null;
        }
        this.dataType =
          _data['dataType'] !== undefined ? _data['dataType'] : <any>null;
        this.defaultPosition = _data['defaultPosition']
          ? TaxPositionDeloitteDefaultPosition.fromJS(_data['defaultPosition'])
          : <any>null;
        this.extraInformation =
          _data['extraInformation'] !== undefined
            ? _data['extraInformation']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxPositionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxPositionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['isEditable'] =
        this.isEditable !== undefined ? this.isEditable : <any>null;
      data['configuredValue'] = this.configuredValue
        ? this.configuredValue.toJSON()
        : <any>null;
      if (Array.isArray(this.options)) {
        data['options'] = [];
        for (let item of this.options) data['options'].push(item.toJSON());
      }
      data['dataType'] =
        this.dataType !== undefined ? this.dataType : <any>null;
      data['defaultPosition'] = this.defaultPosition
        ? this.defaultPosition.toJSON()
        : <any>null;
      data['extraInformation'] =
        this.extraInformation !== undefined ? this.extraInformation : <any>null;
      return data;
    }
  }

  export interface IRegionTaxPositionDto {
    code: string;
    planType: PlanType;
    regionCode: string;
    isEditable: boolean;
    configuredValue: TaxPositionConfiguredValue | null;
    options: TaxPositionOptionDto[];
    dataType: string;
    defaultPosition: TaxPositionDeloitteDefaultPosition | null;
    extraInformation: string | null;
  }

  export class TaxPositionConfiguredValue
    implements ITaxPositionConfiguredValue
  {
    code!: string | null;
    display!: string;

    constructor(data?: ITaxPositionConfiguredValue) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): TaxPositionConfiguredValue {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPositionConfiguredValue();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ITaxPositionConfiguredValue {
    code: string | null;
    display: string;
  }

  export class TaxPositionOptionDto implements ITaxPositionOptionDto {
    code!: string;
    display!: string;

    constructor(data?: ITaxPositionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): TaxPositionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPositionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ITaxPositionOptionDto {
    code: string;
    display: string;
  }

  export class TaxPositionDeloitteDefaultPosition
    implements ITaxPositionDeloitteDefaultPosition
  {
    code!: string;
    display!: string;

    constructor(data?: ITaxPositionDeloitteDefaultPosition) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): TaxPositionDeloitteDefaultPosition {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPositionDeloitteDefaultPosition();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ITaxPositionDeloitteDefaultPosition {
    code: string;
    display: string;
  }

  export class GetRegionTaxPositionsCountryPageDataQueryResultFailure
    extends GetRegionTaxPositionsCountryPageDataQueryResult
    implements IGetRegionTaxPositionsCountryPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetRegionTaxPositionsCountryPageDataQueryResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxPositionsCountryPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxPositionsCountryPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxPositionsCountryPageDataQueryResultFailure
    extends IGetRegionTaxPositionsCountryPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertRegionTaxPositionsCommandResult
    implements IUpsertRegionTaxPositionsCommandResult
  {
    constructor(data?: IUpsertRegionTaxPositionsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertRegionTaxPositionsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertRegionTaxPositionsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRegionTaxPositionsCommandResult {}

  export class UpsertRegionTaxPositionsCommandResultSuccess
    extends UpsertRegionTaxPositionsCommandResult
    implements IUpsertRegionTaxPositionsCommandResultSuccess
  {
    constructor(data?: IUpsertRegionTaxPositionsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRegionTaxPositionsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxPositionsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionTaxPositionsCommandResultSuccess
    extends IUpsertRegionTaxPositionsCommandResult {}

  export class UpsertRegionTaxPositionsCommandResultFailure
    extends UpsertRegionTaxPositionsCommandResult
    implements IUpsertRegionTaxPositionsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertRegionTaxPositionsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRegionTaxPositionsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxPositionsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionTaxPositionsCommandResultFailure
    extends IUpsertRegionTaxPositionsCommandResult {
    errors: ResultError[];
  }

  export class UpsertRegionTaxPositionsCommand
    implements IUpsertRegionTaxPositionsCommand
  {
    clientId!: string;
    countryCode!: string;
    taxPositions!: UpsertRegionTaxPositionDto[];

    constructor(data?: IUpsertRegionTaxPositionsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(UpsertRegionTaxPositionDto.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertRegionTaxPositionsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxPositionsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertRegionTaxPositionsCommand {
    clientId: string;
    countryCode: string;
    taxPositions: UpsertRegionTaxPositionDto[];
  }

  export class UpsertRegionTaxPositionDto
    implements IUpsertRegionTaxPositionDto
  {
    taxPositionCode!: string;
    planType!: PlanType;
    regionCode!: string;
    configuredValueCode!: string;

    constructor(data?: IUpsertRegionTaxPositionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxPositionCode =
          _data['taxPositionCode'] !== undefined
            ? _data['taxPositionCode']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertRegionTaxPositionDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxPositionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxPositionCode'] =
        this.taxPositionCode !== undefined ? this.taxPositionCode : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface IUpsertRegionTaxPositionDto {
    taxPositionCode: string;
    planType: PlanType;
    regionCode: string;
    configuredValueCode: string;
  }

  export abstract class MarkCountryRegionTaxPositionStatusAsReadCommandResult
    implements IMarkCountryRegionTaxPositionStatusAsReadCommandResult
  {
    constructor(data?: IMarkCountryRegionTaxPositionStatusAsReadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): MarkCountryRegionTaxPositionStatusAsReadCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'MarkCountryRegionTaxPositionStatusAsReadCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IMarkCountryRegionTaxPositionStatusAsReadCommandResult {}

  export class MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess
    extends MarkCountryRegionTaxPositionStatusAsReadCommandResult
    implements IMarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess
  {
    constructor(
      data?: IMarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new MarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkCountryRegionTaxPositionStatusAsReadCommandResultSuccess
    extends IMarkCountryRegionTaxPositionStatusAsReadCommandResult {}

  export class MarkCountryRegionTaxPositionStatusAsReadCommandResultFailure
    extends MarkCountryRegionTaxPositionStatusAsReadCommandResult
    implements IMarkCountryRegionTaxPositionStatusAsReadCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IMarkCountryRegionTaxPositionStatusAsReadCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): MarkCountryRegionTaxPositionStatusAsReadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new MarkCountryRegionTaxPositionStatusAsReadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkCountryRegionTaxPositionStatusAsReadCommandResultFailure
    extends IMarkCountryRegionTaxPositionStatusAsReadCommandResult {
    errors: ResultError[];
  }

  export class MarkCountryRegionTaxPositionStatusAsReadCommand
    implements IMarkCountryRegionTaxPositionStatusAsReadCommand
  {
    clientId!: string;
    countryCode!: string;

    constructor(data?: IMarkCountryRegionTaxPositionStatusAsReadCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
      }
    }

    static fromJS(data: any): MarkCountryRegionTaxPositionStatusAsReadCommand {
      data = typeof data === 'object' ? data : {};
      let result = new MarkCountryRegionTaxPositionStatusAsReadCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      return data;
    }
  }

  export interface IMarkCountryRegionTaxPositionStatusAsReadCommand {
    clientId: string;
    countryCode: string;
  }

  export abstract class GetEmployeeOverridesPageDataQueryResult
    implements IGetEmployeeOverridesPageDataQueryResult
  {
    constructor(data?: IGetEmployeeOverridesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEmployeeOverridesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetEmployeeOverridesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEmployeeOverridesPageDataQueryResult {}

  export class GetEmployeeOverridesPageDataQueryResultSuccess
    extends GetEmployeeOverridesPageDataQueryResult
    implements IGetEmployeeOverridesPageDataQueryResultSuccess
  {
    result!: EmployeeOverridesPageData;

    constructor(data?: IGetEmployeeOverridesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new EmployeeOverridesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? EmployeeOverridesPageData.fromJS(_data['result'])
          : new EmployeeOverridesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeOverridesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeOverridesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeOverridesPageDataQueryResultSuccess
    extends IGetEmployeeOverridesPageDataQueryResult {
    result: EmployeeOverridesPageData;
  }

  export class EmployeeOverridesPageData implements IEmployeeOverridesPageData {
    employeeTaxPositionOverrideSettings!: EmployeeTaxPositionOverrideSettingsDto | null;
    planTypesForTaxPositionAndConfiguredPlan!: PlanTypeDto[];
    countryFootprintCodes!: string[];

    constructor(data?: IEmployeeOverridesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypesForTaxPositionAndConfiguredPlan = [];
        this.countryFootprintCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeTaxPositionOverrideSettings = _data[
          'employeeTaxPositionOverrideSettings'
        ]
          ? EmployeeTaxPositionOverrideSettingsDto.fromJS(
              _data['employeeTaxPositionOverrideSettings'],
            )
          : <any>null;
        if (Array.isArray(_data['planTypesForTaxPositionAndConfiguredPlan'])) {
          this.planTypesForTaxPositionAndConfiguredPlan = [] as any;
          for (let item of _data['planTypesForTaxPositionAndConfiguredPlan'])
            this.planTypesForTaxPositionAndConfiguredPlan!.push(
              PlanTypeDto.fromJS(item),
            );
        } else {
          this.planTypesForTaxPositionAndConfiguredPlan = <any>null;
        }
        if (Array.isArray(_data['countryFootprintCodes'])) {
          this.countryFootprintCodes = [] as any;
          for (let item of _data['countryFootprintCodes'])
            this.countryFootprintCodes!.push(item);
        } else {
          this.countryFootprintCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeOverridesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverridesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeTaxPositionOverrideSettings'] = this
        .employeeTaxPositionOverrideSettings
        ? this.employeeTaxPositionOverrideSettings.toJSON()
        : <any>null;
      if (Array.isArray(this.planTypesForTaxPositionAndConfiguredPlan)) {
        data['planTypesForTaxPositionAndConfiguredPlan'] = [];
        for (let item of this.planTypesForTaxPositionAndConfiguredPlan)
          data['planTypesForTaxPositionAndConfiguredPlan'].push(item.toJSON());
      }
      if (Array.isArray(this.countryFootprintCodes)) {
        data['countryFootprintCodes'] = [];
        for (let item of this.countryFootprintCodes)
          data['countryFootprintCodes'].push(item);
      }
      return data;
    }
  }

  export interface IEmployeeOverridesPageData {
    employeeTaxPositionOverrideSettings: EmployeeTaxPositionOverrideSettingsDto | null;
    planTypesForTaxPositionAndConfiguredPlan: PlanTypeDto[];
    countryFootprintCodes: string[];
  }

  export class EmployeeTaxPositionOverrideSettingsDto
    implements IEmployeeTaxPositionOverrideSettingsDto
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    countryCode!: string;
    regionCode!: string | null;
    overrideTaxPosition!: EmployeeOverrideTaxPositionDto;
    overrides!: EmployeeTaxPositionPlanTypeOverrideDto[];

    constructor(data?: IEmployeeTaxPositionOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.overrideTaxPosition = new EmployeeOverrideTaxPositionDto();
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.overrideTaxPosition = _data['overrideTaxPosition']
          ? EmployeeOverrideTaxPositionDto.fromJS(_data['overrideTaxPosition'])
          : new EmployeeOverrideTaxPositionDto();
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(
              EmployeeTaxPositionPlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeTaxPositionOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeTaxPositionOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['overrideTaxPosition'] = this.overrideTaxPosition
        ? this.overrideTaxPosition.toJSON()
        : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeeTaxPositionOverrideSettingsDto {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    countryCode: string;
    regionCode: string | null;
    overrideTaxPosition: EmployeeOverrideTaxPositionDto;
    overrides: EmployeeTaxPositionPlanTypeOverrideDto[];
  }

  export class EmployeeOverrideTaxPositionDto
    implements IEmployeeOverrideTaxPositionDto
  {
    taxPositionTypeCode!: string;
    displayValue!: string;
    countryCode!: string;
    regionCode!: string | null;
    overrideAppliesToAllPlanTypes!: boolean;
    taxPositionPlanTypes!: EmployeeOverrideTaxPositionPlanType[];

    constructor(data?: IEmployeeOverrideTaxPositionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositionPlanTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxPositionTypeCode =
          _data['taxPositionTypeCode'] !== undefined
            ? _data['taxPositionTypeCode']
            : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.overrideAppliesToAllPlanTypes =
          _data['overrideAppliesToAllPlanTypes'] !== undefined
            ? _data['overrideAppliesToAllPlanTypes']
            : <any>null;
        if (Array.isArray(_data['taxPositionPlanTypes'])) {
          this.taxPositionPlanTypes = [] as any;
          for (let item of _data['taxPositionPlanTypes'])
            this.taxPositionPlanTypes!.push(
              EmployeeOverrideTaxPositionPlanType.fromJS(item),
            );
        } else {
          this.taxPositionPlanTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeOverrideTaxPositionDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideTaxPositionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxPositionTypeCode'] =
        this.taxPositionTypeCode !== undefined
          ? this.taxPositionTypeCode
          : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['overrideAppliesToAllPlanTypes'] =
        this.overrideAppliesToAllPlanTypes !== undefined
          ? this.overrideAppliesToAllPlanTypes
          : <any>null;
      if (Array.isArray(this.taxPositionPlanTypes)) {
        data['taxPositionPlanTypes'] = [];
        for (let item of this.taxPositionPlanTypes)
          data['taxPositionPlanTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeeOverrideTaxPositionDto {
    taxPositionTypeCode: string;
    displayValue: string;
    countryCode: string;
    regionCode: string | null;
    overrideAppliesToAllPlanTypes: boolean;
    taxPositionPlanTypes: EmployeeOverrideTaxPositionPlanType[];
  }

  export class EmployeeOverrideTaxPositionPlanType
    implements IEmployeeOverrideTaxPositionPlanType
  {
    planType!: PlanType;
    taxPositionCode!: string;
    options!: EmployeeOverrideTaxPositionOptionDto[];
    configuredPlanCodeSettings!: ConfiguredPlanCodeSettings[] | null;
    currentConfiguredValue!: EmployeeOverrideTaxPositionConfiguredValue | null;
    dataType!: string;

    constructor(data?: IEmployeeOverrideTaxPositionPlanType) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.options = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.taxPositionCode =
          _data['taxPositionCode'] !== undefined
            ? _data['taxPositionCode']
            : <any>null;
        if (Array.isArray(_data['options'])) {
          this.options = [] as any;
          for (let item of _data['options'])
            this.options!.push(
              EmployeeOverrideTaxPositionOptionDto.fromJS(item),
            );
        } else {
          this.options = <any>null;
        }
        if (Array.isArray(_data['configuredPlanCodeSettings'])) {
          this.configuredPlanCodeSettings = [] as any;
          for (let item of _data['configuredPlanCodeSettings'])
            this.configuredPlanCodeSettings!.push(
              ConfiguredPlanCodeSettings.fromJS(item),
            );
        } else {
          this.configuredPlanCodeSettings = <any>null;
        }
        this.currentConfiguredValue = _data['currentConfiguredValue']
          ? EmployeeOverrideTaxPositionConfiguredValue.fromJS(
              _data['currentConfiguredValue'],
            )
          : <any>null;
        this.dataType =
          _data['dataType'] !== undefined ? _data['dataType'] : <any>null;
      }
    }

    static fromJS(data: any): EmployeeOverrideTaxPositionPlanType {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideTaxPositionPlanType();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['taxPositionCode'] =
        this.taxPositionCode !== undefined ? this.taxPositionCode : <any>null;
      if (Array.isArray(this.options)) {
        data['options'] = [];
        for (let item of this.options) data['options'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredPlanCodeSettings)) {
        data['configuredPlanCodeSettings'] = [];
        for (let item of this.configuredPlanCodeSettings)
          data['configuredPlanCodeSettings'].push(item.toJSON());
      }
      data['currentConfiguredValue'] = this.currentConfiguredValue
        ? this.currentConfiguredValue.toJSON()
        : <any>null;
      data['dataType'] =
        this.dataType !== undefined ? this.dataType : <any>null;
      return data;
    }
  }

  export interface IEmployeeOverrideTaxPositionPlanType {
    planType: PlanType;
    taxPositionCode: string;
    options: EmployeeOverrideTaxPositionOptionDto[];
    configuredPlanCodeSettings: ConfiguredPlanCodeSettings[] | null;
    currentConfiguredValue: EmployeeOverrideTaxPositionConfiguredValue | null;
    dataType: string;
  }

  export class EmployeeOverrideTaxPositionOptionDto
    implements IEmployeeOverrideTaxPositionOptionDto
  {
    code!: string;
    display!: string;

    constructor(data?: IEmployeeOverrideTaxPositionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): EmployeeOverrideTaxPositionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideTaxPositionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IEmployeeOverrideTaxPositionOptionDto {
    code: string;
    display: string;
  }

  export class ConfiguredPlanCodeSettings
    implements IConfiguredPlanCodeSettings
  {
    planCode!: string;
    configuredValueCode!: string;

    constructor(data?: IConfiguredPlanCodeSettings) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): ConfiguredPlanCodeSettings {
      data = typeof data === 'object' ? data : {};
      let result = new ConfiguredPlanCodeSettings();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface IConfiguredPlanCodeSettings {
    planCode: string;
    configuredValueCode: string;
  }

  export class EmployeeOverrideTaxPositionConfiguredValue
    implements IEmployeeOverrideTaxPositionConfiguredValue
  {
    code!: string;
    display!: string;

    constructor(data?: IEmployeeOverrideTaxPositionConfiguredValue) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): EmployeeOverrideTaxPositionConfiguredValue {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideTaxPositionConfiguredValue();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IEmployeeOverrideTaxPositionConfiguredValue {
    code: string;
    display: string;
  }

  export class EmployeeTaxPositionPlanTypeOverrideDto
    implements IEmployeeTaxPositionPlanTypeOverrideDto
  {
    planType!: PlanType | null;
    configuredValueCode!: string;

    constructor(data?: IEmployeeTaxPositionPlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): EmployeeTaxPositionPlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeTaxPositionPlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface IEmployeeTaxPositionPlanTypeOverrideDto {
    planType: PlanType | null;
    configuredValueCode: string;
  }

  export class GetEmployeeOverridesPageDataQueryResultFailure
    extends GetEmployeeOverridesPageDataQueryResult
    implements IGetEmployeeOverridesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetEmployeeOverridesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeOverridesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeOverridesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeOverridesPageDataQueryResultFailure
    extends IGetEmployeeOverridesPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class GetTaxPositionsQueryResult
    implements IGetTaxPositionsQueryResult
  {
    constructor(data?: IGetTaxPositionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxPositionsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxPositionsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxPositionsQueryResult {}

  export class GetTaxPositionsQueryResultSuccess
    extends GetTaxPositionsQueryResult
    implements IGetTaxPositionsQueryResultSuccess
  {
    taxPositions!: EmployeeOverrideTaxPositionDto[];

    constructor(data?: IGetTaxPositionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.taxPositions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(
              EmployeeOverrideTaxPositionDto.fromJS(item),
            );
        } else {
          this.taxPositions = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTaxPositionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxPositionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxPositionsQueryResultSuccess
    extends IGetTaxPositionsQueryResult {
    taxPositions: EmployeeOverrideTaxPositionDto[];
  }

  export class GetTaxPositionsQueryResultFailure
    extends GetTaxPositionsQueryResult
    implements IGetTaxPositionsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxPositionsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTaxPositionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxPositionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxPositionsQueryResultFailure
    extends IGetTaxPositionsQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertEmployeeOverrideCommandResult
    implements IUpsertEmployeeOverrideCommandResult
  {
    constructor(data?: IUpsertEmployeeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertEmployeeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertEmployeeOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertEmployeeOverrideCommandResult {}

  export class UpsertEmployeeOverrideCommandResultSuccess
    extends UpsertEmployeeOverrideCommandResult
    implements IUpsertEmployeeOverrideCommandResultSuccess
  {
    ids!: string[];

    constructor(data?: IUpsertEmployeeOverrideCommandResultSuccess) {
      super(data);
      if (!data) {
        this.ids = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['ids'])) {
          this.ids = [] as any;
          for (let item of _data['ids']) this.ids!.push(item);
        } else {
          this.ids = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertEmployeeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertEmployeeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.ids)) {
        data['ids'] = [];
        for (let item of this.ids) data['ids'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertEmployeeOverrideCommandResultSuccess
    extends IUpsertEmployeeOverrideCommandResult {
    ids: string[];
  }

  export class UpsertEmployeeOverrideCommandResultFailure
    extends UpsertEmployeeOverrideCommandResult
    implements IUpsertEmployeeOverrideCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpsertEmployeeOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertEmployeeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertEmployeeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertEmployeeOverrideCommandResultFailure
    extends IUpsertEmployeeOverrideCommandResult {
    errors: string;
  }

  export class UpsertEmployeeOverrideCommand
    implements IUpsertEmployeeOverrideCommand
  {
    clientId!: string;
    id!: string | null;
    employeeTransactionIds!: UpsertEmployeeIdTransactionIdSettingDto[];
    countryCode!: string;
    regionCode!: string | null;
    taxPositionTypeCode!: string;
    overrideAppliesToAllPlanTypes!: boolean;
    overrides!: UpsertEmployeeOverridePlanTypeSettingDto[];

    constructor(data?: IUpsertEmployeeOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              UpsertEmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxPositionTypeCode =
          _data['taxPositionTypeCode'] !== undefined
            ? _data['taxPositionTypeCode']
            : <any>null;
        this.overrideAppliesToAllPlanTypes =
          _data['overrideAppliesToAllPlanTypes'] !== undefined
            ? _data['overrideAppliesToAllPlanTypes']
            : <any>null;
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(
              UpsertEmployeeOverridePlanTypeSettingDto.fromJS(item),
            );
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertEmployeeOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertEmployeeOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxPositionTypeCode'] =
        this.taxPositionTypeCode !== undefined
          ? this.taxPositionTypeCode
          : <any>null;
      data['overrideAppliesToAllPlanTypes'] =
        this.overrideAppliesToAllPlanTypes !== undefined
          ? this.overrideAppliesToAllPlanTypes
          : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertEmployeeOverrideCommand {
    clientId: string;
    id: string | null;
    employeeTransactionIds: UpsertEmployeeIdTransactionIdSettingDto[];
    countryCode: string;
    regionCode: string | null;
    taxPositionTypeCode: string;
    overrideAppliesToAllPlanTypes: boolean;
    overrides: UpsertEmployeeOverridePlanTypeSettingDto[];
  }

  export class UpsertEmployeeOverridePlanTypeSettingDto
    implements IUpsertEmployeeOverridePlanTypeSettingDto
  {
    taxPositionCode!: string;
    planType!: PlanType | null;
    configuredValueCode!: string;

    constructor(data?: IUpsertEmployeeOverridePlanTypeSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxPositionCode =
          _data['taxPositionCode'] !== undefined
            ? _data['taxPositionCode']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertEmployeeOverridePlanTypeSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertEmployeeOverridePlanTypeSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxPositionCode'] =
        this.taxPositionCode !== undefined ? this.taxPositionCode : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface IUpsertEmployeeOverridePlanTypeSettingDto {
    taxPositionCode: string;
    planType: PlanType | null;
    configuredValueCode: string;
  }

  export class DownloadMultipleOverrideFileCommand
    implements IDownloadMultipleOverrideFileCommand
  {
    constructor(data?: IDownloadMultipleOverrideFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadMultipleOverrideFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadMultipleOverrideFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadMultipleOverrideFileCommand {}

  export class UploadMultipleOverrideFileCommandResult
    implements IUploadMultipleOverrideFileCommandResult
  {
    constructor(data?: IUploadMultipleOverrideFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadMultipleOverrideFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadMultipleOverrideFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadMultipleOverrideFileCommandResult {}

  export class UploadMultipleOverrideFileCommandResultSuccess
    extends UploadMultipleOverrideFileCommandResult
    implements IUploadMultipleOverrideFileCommandResultSuccess
  {
    result!: MultipleOverrideResultDto[];

    constructor(data?: IUploadMultipleOverrideFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(MultipleOverrideResultDto.fromJS(item));
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UploadMultipleOverrideFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadMultipleOverrideFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadMultipleOverrideFileCommandResultSuccess
    extends IUploadMultipleOverrideFileCommandResult {
    result: MultipleOverrideResultDto[];
  }

  export class MultipleOverrideResultDto implements IMultipleOverrideResultDto {
    employeeId!: string;
    transactionId!: string | null;
    isRecordDuplicate!: boolean;

    constructor(data?: IMultipleOverrideResultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.isRecordDuplicate =
          _data['isRecordDuplicate'] !== undefined
            ? _data['isRecordDuplicate']
            : <any>null;
      }
    }

    static fromJS(data: any): MultipleOverrideResultDto {
      data = typeof data === 'object' ? data : {};
      let result = new MultipleOverrideResultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['isRecordDuplicate'] =
        this.isRecordDuplicate !== undefined
          ? this.isRecordDuplicate
          : <any>null;
      return data;
    }
  }

  export interface IMultipleOverrideResultDto {
    employeeId: string;
    transactionId: string | null;
    isRecordDuplicate: boolean;
  }

  export class UploadMultipleOverrideFileCommandResultFailure
    extends UploadMultipleOverrideFileCommandResult
    implements IUploadMultipleOverrideFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IUploadMultipleOverrideFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UploadMultipleOverrideFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadMultipleOverrideFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadMultipleOverrideFileCommandResultFailure
    extends IUploadMultipleOverrideFileCommandResult {
    errorMessage: string;
  }

  export abstract class CheckEmployeeOverrideDuplicateDataCommandResult
    implements ICheckEmployeeOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckEmployeeOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckEmployeeOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckEmployeeOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckEmployeeOverrideDuplicateDataCommandResult {}

  export class CheckEmployeeOverrideDuplicateDataCommandResultSuccess
    extends CheckEmployeeOverrideDuplicateDataCommandResult
    implements ICheckEmployeeOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckEmployeeOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckEmployeeOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CheckEmployeeOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckEmployeeOverrideDuplicateDataCommandResultSuccess
    extends ICheckEmployeeOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckEmployeeOverrideDuplicateDataCommandResultFailure
    extends CheckEmployeeOverrideDuplicateDataCommandResult
    implements ICheckEmployeeOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckEmployeeOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckEmployeeOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckEmployeeOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckEmployeeOverrideDuplicateDataCommandResultFailure
    extends ICheckEmployeeOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckEmployeeOverrideDuplicateDataCommand
    implements ICheckEmployeeOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: UpsertEmployeeIdTransactionIdSettingDto[];
    countryCode!: string;
    regionCode!: string | null;
    taxPositionTypeCode!: string;
    planTypes!: PlanType[];

    constructor(data?: ICheckEmployeeOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.planTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              UpsertEmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxPositionTypeCode =
          _data['taxPositionTypeCode'] !== undefined
            ? _data['taxPositionTypeCode']
            : <any>null;
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckEmployeeOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckEmployeeOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxPositionTypeCode'] =
        this.taxPositionTypeCode !== undefined
          ? this.taxPositionTypeCode
          : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      return data;
    }
  }

  export interface ICheckEmployeeOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: UpsertEmployeeIdTransactionIdSettingDto[];
    countryCode: string;
    regionCode: string | null;
    taxPositionTypeCode: string;
    planTypes: PlanType[];
  }

  export abstract class GetEmployeeOverridesIndexPageDataQueryResult
    implements IGetEmployeeOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetEmployeeOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEmployeeOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetEmployeeOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEmployeeOverridesIndexPageDataQueryResult {}

  export class GetEmployeeOverridesIndexPageDataQueryResultSuccess
    extends GetEmployeeOverridesIndexPageDataQueryResult
    implements IGetEmployeeOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetEmployeeOverridesIndexPageData;

    constructor(data?: IGetEmployeeOverridesIndexPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new GetEmployeeOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetEmployeeOverridesIndexPageData.fromJS(_data['result'])
          : new GetEmployeeOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeOverridesIndexPageDataQueryResultSuccess
    extends IGetEmployeeOverridesIndexPageDataQueryResult {
    result: GetEmployeeOverridesIndexPageData;
  }

  export class GetEmployeeOverridesIndexPageData
    implements IGetEmployeeOverridesIndexPageData
  {
    planTypes!: PlanTypeDto[];
    lineItems!: EmployeeOverrideLineItem[];

    constructor(data?: IGetEmployeeOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.lineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(EmployeeOverrideLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): GetEmployeeOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetEmployeeOverridesIndexPageData {
    planTypes: PlanTypeDto[];
    lineItems: EmployeeOverrideLineItem[];
  }

  export class EmployeeOverrideLineItem implements IEmployeeOverrideLineItem {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    countryCode!: string;
    regionCode!: string | null;
    taxPosition!: EmployeeOverrideTaxPositionDto;
    overrides!: EmployeeOverrideSubLineItem[];

    constructor(data?: IEmployeeOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPosition = new EmployeeOverrideTaxPositionDto();
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxPosition = _data['taxPosition']
          ? EmployeeOverrideTaxPositionDto.fromJS(_data['taxPosition'])
          : new EmployeeOverrideTaxPositionDto();
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(EmployeeOverrideSubLineItem.fromJS(item));
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxPosition'] = this.taxPosition
        ? this.taxPosition.toJSON()
        : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeeOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    countryCode: string;
    regionCode: string | null;
    taxPosition: EmployeeOverrideTaxPositionDto;
    overrides: EmployeeOverrideSubLineItem[];
  }

  export class EmployeeOverrideSubLineItem
    implements IEmployeeOverrideSubLineItem
  {
    planType!: PlanType | null;
    overrideDisplay!: string;

    constructor(data?: IEmployeeOverrideSubLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
      }
    }

    static fromJS(data: any): EmployeeOverrideSubLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeOverrideSubLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      return data;
    }
  }

  export interface IEmployeeOverrideSubLineItem {
    planType: PlanType | null;
    overrideDisplay: string;
  }

  export class GetEmployeeOverridesIndexPageDataQueryResultFailure
    extends GetEmployeeOverridesIndexPageDataQueryResult
    implements IGetEmployeeOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetEmployeeOverridesIndexPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeOverridesIndexPageDataQueryResultFailure
    extends IGetEmployeeOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export enum GetEmployeeOverridesIndexPageDataQueryBehavior {
    Default = 'Default',
    ReturnFakeResults = 'ReturnFakeResults',
  }

  export abstract class DeleteEmployeeOverrideCommandResult
    implements IDeleteEmployeeOverrideCommandResult
  {
    constructor(data?: IDeleteEmployeeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteEmployeeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DeleteEmployeeOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteEmployeeOverrideCommandResult {}

  export class DeleteEmployeeOverrideCommandResultSuccess
    extends DeleteEmployeeOverrideCommandResult
    implements IDeleteEmployeeOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteEmployeeOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteEmployeeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteEmployeeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteEmployeeOverrideCommandResultSuccess
    extends IDeleteEmployeeOverrideCommandResult {}

  export class DeleteEmployeeOverrideCommandResultFailure
    extends DeleteEmployeeOverrideCommandResult
    implements IDeleteEmployeeOverrideCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteEmployeeOverrideCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteEmployeeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteEmployeeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteEmployeeOverrideCommandResultFailure
    extends IDeleteEmployeeOverrideCommandResult {
    errors: ResultError[];
  }

  export class GetCountryTaxPositionsPageDataQueryResult
    implements IGetCountryTaxPositionsPageDataQueryResult
  {
    constructor(data?: IGetCountryTaxPositionsPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryTaxPositionsPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxPositionsPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryTaxPositionsPageDataQueryResult {}

  export class GetCountryTaxPositionsPageDataQueryResultSuccess
    extends GetCountryTaxPositionsPageDataQueryResult
    implements IGetCountryTaxPositionsPageDataQueryResultSuccess
  {
    result!: CountryTaxPositionsPageData;

    constructor(data?: IGetCountryTaxPositionsPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CountryTaxPositionsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CountryTaxPositionsPageData.fromJS(_data['result'])
          : new CountryTaxPositionsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxPositionsPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxPositionsPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxPositionsPageDataQueryResultSuccess
    extends IGetCountryTaxPositionsPageDataQueryResult {
    result: CountryTaxPositionsPageData;
  }

  export class CountryTaxPositionsPageData
    implements ICountryTaxPositionsPageData
  {
    countryTaxPositionLineItems!: CountryTaxPositionLineItemDto[];

    constructor(data?: ICountryTaxPositionsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryTaxPositionLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countryTaxPositionLineItems'])) {
          this.countryTaxPositionLineItems = [] as any;
          for (let item of _data['countryTaxPositionLineItems'])
            this.countryTaxPositionLineItems!.push(
              CountryTaxPositionLineItemDto.fromJS(item),
            );
        } else {
          this.countryTaxPositionLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryTaxPositionsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countryTaxPositionLineItems)) {
        data['countryTaxPositionLineItems'] = [];
        for (let item of this.countryTaxPositionLineItems)
          data['countryTaxPositionLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryTaxPositionsPageData {
    countryTaxPositionLineItems: CountryTaxPositionLineItemDto[];
  }

  export class CountryTaxPositionLineItemDto
    implements ICountryTaxPositionLineItemDto
  {
    country!: CountryTaxPositionCountryDto;
    status!: CountryTaxPositionStatus;
    isDeloittePositionUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: ICountryTaxPositionLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new CountryTaxPositionCountryDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? CountryTaxPositionCountryDto.fromJS(_data['country'])
          : new CountryTaxPositionCountryDto();
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.isDeloittePositionUpdated =
          _data['isDeloittePositionUpdated'] !== undefined
            ? _data['isDeloittePositionUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxPositionLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['isDeloittePositionUpdated'] =
        this.isDeloittePositionUpdated !== undefined
          ? this.isDeloittePositionUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICountryTaxPositionLineItemDto {
    country: CountryTaxPositionCountryDto;
    status: CountryTaxPositionStatus;
    isDeloittePositionUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class CountryTaxPositionCountryDto
    implements ICountryTaxPositionCountryDto
  {
    isoCode!: string;
    display!: string;

    constructor(data?: ICountryTaxPositionCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxPositionCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ICountryTaxPositionCountryDto {
    isoCode: string;
    display: string;
  }

  export enum CountryTaxPositionStatus {
    Unread = 'Unread',
    Reviewed = 'Reviewed',
  }

  export class GetCountryTaxPositionsPageDataQueryResultFailure
    extends GetCountryTaxPositionsPageDataQueryResult
    implements IGetCountryTaxPositionsPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCountryTaxPositionsPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxPositionsPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxPositionsPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxPositionsPageDataQueryResultFailure
    extends IGetCountryTaxPositionsPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class MarkCountryTaxPositionStatusAsReadCommandResult
    implements IMarkCountryTaxPositionStatusAsReadCommandResult
  {
    constructor(data?: IMarkCountryTaxPositionStatusAsReadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): MarkCountryTaxPositionStatusAsReadCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'MarkCountryTaxPositionStatusAsReadCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IMarkCountryTaxPositionStatusAsReadCommandResult {}

  export class MarkCountryTaxPositionStatusAsReadCommandResultSuccess
    extends MarkCountryTaxPositionStatusAsReadCommandResult
    implements IMarkCountryTaxPositionStatusAsReadCommandResultSuccess
  {
    constructor(
      data?: IMarkCountryTaxPositionStatusAsReadCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): MarkCountryTaxPositionStatusAsReadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new MarkCountryTaxPositionStatusAsReadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkCountryTaxPositionStatusAsReadCommandResultSuccess
    extends IMarkCountryTaxPositionStatusAsReadCommandResult {}

  export class MarkCountryTaxPositionStatusAsReadCommandResultFailure
    extends MarkCountryTaxPositionStatusAsReadCommandResult
    implements IMarkCountryTaxPositionStatusAsReadCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IMarkCountryTaxPositionStatusAsReadCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): MarkCountryTaxPositionStatusAsReadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new MarkCountryTaxPositionStatusAsReadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkCountryTaxPositionStatusAsReadCommandResultFailure
    extends IMarkCountryTaxPositionStatusAsReadCommandResult {
    errors: ResultError[];
  }

  export class MarkCountryTaxPositionStatusAsReadCommand
    implements IMarkCountryTaxPositionStatusAsReadCommand
  {
    clientId!: string;
    countryCode!: string;

    constructor(data?: IMarkCountryTaxPositionStatusAsReadCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
      }
    }

    static fromJS(data: any): MarkCountryTaxPositionStatusAsReadCommand {
      data = typeof data === 'object' ? data : {};
      let result = new MarkCountryTaxPositionStatusAsReadCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      return data;
    }
  }

  export interface IMarkCountryTaxPositionStatusAsReadCommand {
    clientId: string;
    countryCode: string;
  }

  export abstract class SaveCountryTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryTaxPositionsWorkflowStepCommandResult
  {
    constructor(data?: ISaveCountryTaxPositionsWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveCountryTaxPositionsWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveCountryTaxPositionsWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCountryTaxPositionsWorkflowStepCommandResult {}

  export class SaveCountryTaxPositionsWorkflowStepCommandResultSuccess
    extends SaveCountryTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryTaxPositionsWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveCountryTaxPositionsWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveCountryTaxPositionsWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveCountryTaxPositionsWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryTaxPositionsWorkflowStepCommandResultSuccess
    extends ISaveCountryTaxPositionsWorkflowStepCommandResult {}

  export class SaveCountryTaxPositionsWorkflowStepCommandResultFailure
    extends SaveCountryTaxPositionsWorkflowStepCommandResult
    implements ISaveCountryTaxPositionsWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveCountryTaxPositionsWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveCountryTaxPositionsWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveCountryTaxPositionsWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryTaxPositionsWorkflowStepCommandResultFailure
    extends ISaveCountryTaxPositionsWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveCountryTaxPositionsWorkflowStepCommand
    implements ISaveCountryTaxPositionsWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveCountryTaxPositionsWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveCountryTaxPositionsWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryTaxPositionsWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveCountryTaxPositionsWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadCountryTaxPositionsDataCommandResult
    implements IDownloadCountryTaxPositionsDataCommandResult
  {
    constructor(data?: IDownloadCountryTaxPositionsDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadCountryTaxPositionsDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadCountryTaxPositionsDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadCountryTaxPositionsDataCommandResult {}

  export class DownloadCountryTaxPositionsDataCommandResultSuccess
    extends DownloadCountryTaxPositionsDataCommandResult
    implements IDownloadCountryTaxPositionsDataCommandResultSuccess
  {
    result!: DownloadCountryTaxPositionsResponse;

    constructor(data?: IDownloadCountryTaxPositionsDataCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new DownloadCountryTaxPositionsResponse();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DownloadCountryTaxPositionsResponse.fromJS(_data['result'])
          : new DownloadCountryTaxPositionsResponse();
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryTaxPositionsDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxPositionsDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryTaxPositionsDataCommandResultSuccess
    extends IDownloadCountryTaxPositionsDataCommandResult {
    result: DownloadCountryTaxPositionsResponse;
  }

  export class DownloadCountryTaxPositionsResponse
    implements IDownloadCountryTaxPositionsResponse
  {
    fileName!: string;
    fileData!: string;

    constructor(data?: IDownloadCountryTaxPositionsResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.fileData =
          _data['fileData'] !== undefined ? _data['fileData'] : <any>null;
      }
    }

    static fromJS(data: any): DownloadCountryTaxPositionsResponse {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxPositionsResponse();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['fileData'] =
        this.fileData !== undefined ? this.fileData : <any>null;
      return data;
    }
  }

  export interface IDownloadCountryTaxPositionsResponse {
    fileName: string;
    fileData: string;
  }

  export class DownloadCountryTaxPositionsDataCommandResultFailure
    extends DownloadCountryTaxPositionsDataCommandResult
    implements IDownloadCountryTaxPositionsDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadCountryTaxPositionsDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryTaxPositionsDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxPositionsDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryTaxPositionsDataCommandResultFailure
    extends IDownloadCountryTaxPositionsDataCommandResult {
    errorMessage: string;
  }

  export class DownloadCountryTaxPositionsDataCommand
    implements IDownloadCountryTaxPositionsDataCommand
  {
    clientId!: string;
    countryCodes!: string;

    constructor(data?: IDownloadCountryTaxPositionsDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCodes =
          _data['countryCodes'] !== undefined
            ? _data['countryCodes']
            : <any>null;
      }
    }

    static fromJS(data: any): DownloadCountryTaxPositionsDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxPositionsDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCodes'] =
        this.countryCodes !== undefined ? this.countryCodes : <any>null;
      return data;
    }
  }

  export interface IDownloadCountryTaxPositionsDataCommand {
    clientId: string;
    countryCodes: string;
  }

  export class GetCountryTaxPositionsCountryPageDataQueryResult
    implements IGetCountryTaxPositionsCountryPageDataQueryResult
  {
    constructor(data?: IGetCountryTaxPositionsCountryPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryTaxPositionsCountryPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxPositionsCountryPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryTaxPositionsCountryPageDataQueryResult {}

  export class GetCountryTaxPositionsCountryPageDataQueryResultSuccess
    extends GetCountryTaxPositionsCountryPageDataQueryResult
    implements IGetCountryTaxPositionsCountryPageDataQueryResultSuccess
  {
    result!: CountryTaxPositionsCountryPageData;

    constructor(
      data?: IGetCountryTaxPositionsCountryPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new CountryTaxPositionsCountryPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CountryTaxPositionsCountryPageData.fromJS(_data['result'])
          : new CountryTaxPositionsCountryPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxPositionsCountryPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetCountryTaxPositionsCountryPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxPositionsCountryPageDataQueryResultSuccess
    extends IGetCountryTaxPositionsCountryPageDataQueryResult {
    result: CountryTaxPositionsCountryPageData;
  }

  export class CountryTaxPositionsCountryPageData
    implements ICountryTaxPositionsCountryPageData
  {
    country!: CountryTaxPositionCountryDto;
    planTypes!: PlanTypeDto[];
    taxPositionRows!: CountryTaxPositionRow[];
    taxPositionTableCells!: {
      [key: string]: { [key: string]: CountryTaxPositionDto };
    };
    taxPositionsByCode!: { [key: string]: CountryTaxPositionDto[] };

    constructor(data?: ICountryTaxPositionsCountryPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new CountryTaxPositionCountryDto();
        this.planTypes = [];
        this.taxPositionRows = [];
        this.taxPositionTableCells = {};
        this.taxPositionsByCode = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? CountryTaxPositionCountryDto.fromJS(_data['country'])
          : new CountryTaxPositionCountryDto();
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['taxPositionRows'])) {
          this.taxPositionRows = [] as any;
          for (let item of _data['taxPositionRows'])
            this.taxPositionRows!.push(CountryTaxPositionRow.fromJS(item));
        } else {
          this.taxPositionRows = <any>null;
        }
        if (_data['taxPositionTableCells']) {
          this.taxPositionTableCells = {} as any;
          for (let key in _data['taxPositionTableCells']) {
            if (_data['taxPositionTableCells'].hasOwnProperty(key))
              (<any>this.taxPositionTableCells)![key] =
                _data['taxPositionTableCells'][key] !== undefined
                  ? _data['taxPositionTableCells'][key]
                  : {};
          }
        } else {
          this.taxPositionTableCells = <any>null;
        }
        if (_data['taxPositionsByCode']) {
          this.taxPositionsByCode = {} as any;
          for (let key in _data['taxPositionsByCode']) {
            if (_data['taxPositionsByCode'].hasOwnProperty(key))
              (<any>this.taxPositionsByCode)![key] = _data[
                'taxPositionsByCode'
              ][key]
                ? _data['taxPositionsByCode'][key].map((i: any) =>
                    CountryTaxPositionDto.fromJS(i),
                  )
                : [];
          }
        } else {
          this.taxPositionsByCode = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryTaxPositionsCountryPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionsCountryPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxPositionRows)) {
        data['taxPositionRows'] = [];
        for (let item of this.taxPositionRows)
          data['taxPositionRows'].push(item.toJSON());
      }
      if (this.taxPositionTableCells) {
        data['taxPositionTableCells'] = {};
        for (let key in this.taxPositionTableCells) {
          if (this.taxPositionTableCells.hasOwnProperty(key))
            (<any>data['taxPositionTableCells'])[key] =
              this.taxPositionTableCells[key] !== undefined
                ? this.taxPositionTableCells[key]
                : <any>null;
        }
      }
      if (this.taxPositionsByCode) {
        data['taxPositionsByCode'] = {};
        for (let key in this.taxPositionsByCode) {
          if (this.taxPositionsByCode.hasOwnProperty(key))
            (<any>data['taxPositionsByCode'])[key] =
              this.taxPositionsByCode[key] !== undefined
                ? this.taxPositionsByCode[key]
                : <any>null;
        }
      }
      return data;
    }
  }

  export interface ICountryTaxPositionsCountryPageData {
    country: CountryTaxPositionCountryDto;
    planTypes: PlanTypeDto[];
    taxPositionRows: CountryTaxPositionRow[];
    taxPositionTableCells: {
      [key: string]: { [key: string]: CountryTaxPositionDto };
    };
    taxPositionsByCode: { [key: string]: CountryTaxPositionDto[] };
  }

  export class CountryTaxPositionRow implements ICountryTaxPositionRow {
    taxPositionTypeCode!: string;
    display!: string;
    displayOrder!: string;
    taxPositions!: CountryTaxPositionDto[];
    isEditable!: boolean;

    constructor(data?: ICountryTaxPositionRow) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxPositionTypeCode =
          _data['taxPositionTypeCode'] !== undefined
            ? _data['taxPositionTypeCode']
            : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(CountryTaxPositionDto.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
        this.isEditable =
          _data['isEditable'] !== undefined ? _data['isEditable'] : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxPositionRow {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionRow();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxPositionTypeCode'] =
        this.taxPositionTypeCode !== undefined
          ? this.taxPositionTypeCode
          : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      data['isEditable'] =
        this.isEditable !== undefined ? this.isEditable : <any>null;
      return data;
    }
  }

  export interface ICountryTaxPositionRow {
    taxPositionTypeCode: string;
    display: string;
    displayOrder: string;
    taxPositions: CountryTaxPositionDto[];
    isEditable: boolean;
  }

  export class CountryTaxPositionDto implements ICountryTaxPositionDto {
    code!: string;
    planType!: PlanType;
    isEditable!: boolean;
    configuredValue!: TaxPositionConfiguredValue | null;
    configuredPlanCodeSettings!: ConfiguredPlanCodeSettings[] | null;
    options!: TaxPositionOptionDto[];
    dataType!: string;
    defaultPosition!: TaxPositionDeloitteDefaultPosition | null;
    extraInformation!: string | null;

    constructor(data?: ICountryTaxPositionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.options = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.isEditable =
          _data['isEditable'] !== undefined ? _data['isEditable'] : <any>null;
        this.configuredValue = _data['configuredValue']
          ? TaxPositionConfiguredValue.fromJS(_data['configuredValue'])
          : <any>null;
        if (Array.isArray(_data['configuredPlanCodeSettings'])) {
          this.configuredPlanCodeSettings = [] as any;
          for (let item of _data['configuredPlanCodeSettings'])
            this.configuredPlanCodeSettings!.push(
              ConfiguredPlanCodeSettings.fromJS(item),
            );
        } else {
          this.configuredPlanCodeSettings = <any>null;
        }
        if (Array.isArray(_data['options'])) {
          this.options = [] as any;
          for (let item of _data['options'])
            this.options!.push(TaxPositionOptionDto.fromJS(item));
        } else {
          this.options = <any>null;
        }
        this.dataType =
          _data['dataType'] !== undefined ? _data['dataType'] : <any>null;
        this.defaultPosition = _data['defaultPosition']
          ? TaxPositionDeloitteDefaultPosition.fromJS(_data['defaultPosition'])
          : <any>null;
        this.extraInformation =
          _data['extraInformation'] !== undefined
            ? _data['extraInformation']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxPositionDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxPositionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['isEditable'] =
        this.isEditable !== undefined ? this.isEditable : <any>null;
      data['configuredValue'] = this.configuredValue
        ? this.configuredValue.toJSON()
        : <any>null;
      if (Array.isArray(this.configuredPlanCodeSettings)) {
        data['configuredPlanCodeSettings'] = [];
        for (let item of this.configuredPlanCodeSettings)
          data['configuredPlanCodeSettings'].push(item.toJSON());
      }
      if (Array.isArray(this.options)) {
        data['options'] = [];
        for (let item of this.options) data['options'].push(item.toJSON());
      }
      data['dataType'] =
        this.dataType !== undefined ? this.dataType : <any>null;
      data['defaultPosition'] = this.defaultPosition
        ? this.defaultPosition.toJSON()
        : <any>null;
      data['extraInformation'] =
        this.extraInformation !== undefined ? this.extraInformation : <any>null;
      return data;
    }
  }

  export interface ICountryTaxPositionDto {
    code: string;
    planType: PlanType;
    isEditable: boolean;
    configuredValue: TaxPositionConfiguredValue | null;
    configuredPlanCodeSettings: ConfiguredPlanCodeSettings[] | null;
    options: TaxPositionOptionDto[];
    dataType: string;
    defaultPosition: TaxPositionDeloitteDefaultPosition | null;
    extraInformation: string | null;
  }

  export class GetCountryTaxPositionsCountryPageDataQueryResultFailure
    extends GetCountryTaxPositionsCountryPageDataQueryResult
    implements IGetCountryTaxPositionsCountryPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetCountryTaxPositionsCountryPageDataQueryResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxPositionsCountryPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetCountryTaxPositionsCountryPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxPositionsCountryPageDataQueryResultFailure
    extends IGetCountryTaxPositionsCountryPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertCountryTaxPositionsCommandResult
    implements IUpsertCountryTaxPositionsCommandResult
  {
    constructor(data?: IUpsertCountryTaxPositionsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertCountryTaxPositionsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertCountryTaxPositionsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCountryTaxPositionsCommandResult {}

  export class UpsertCountryTaxPositionsCommandResultSuccess
    extends UpsertCountryTaxPositionsCommandResult
    implements IUpsertCountryTaxPositionsCommandResultSuccess
  {
    constructor(data?: IUpsertCountryTaxPositionsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertCountryTaxPositionsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxPositionsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCountryTaxPositionsCommandResultSuccess
    extends IUpsertCountryTaxPositionsCommandResult {}

  export class UpsertCountryTaxPositionsCommandResultFailure
    extends UpsertCountryTaxPositionsCommandResult
    implements IUpsertCountryTaxPositionsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertCountryTaxPositionsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertCountryTaxPositionsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxPositionsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCountryTaxPositionsCommandResultFailure
    extends IUpsertCountryTaxPositionsCommandResult {
    errors: ResultError[];
  }

  export class UpsertCountryTaxPositionsCommand
    implements IUpsertCountryTaxPositionsCommand
  {
    clientId!: string;
    countryCode!: string;
    taxPositions!: UpsertCountryTaxPositionDto[];

    constructor(data?: IUpsertCountryTaxPositionsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxPositions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(UpsertCountryTaxPositionDto.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCountryTaxPositionsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxPositionsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCountryTaxPositionsCommand {
    clientId: string;
    countryCode: string;
    taxPositions: UpsertCountryTaxPositionDto[];
  }

  export class UpsertCountryTaxPositionDto
    implements IUpsertCountryTaxPositionDto
  {
    taxPositionCode!: string;
    planType!: PlanType;
    configuredValueCode!: string;
    configuredPlanCodeSettings!: ConfiguredPlanCodeSettings[];

    constructor(data?: IUpsertCountryTaxPositionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.configuredPlanCodeSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxPositionCode =
          _data['taxPositionCode'] !== undefined
            ? _data['taxPositionCode']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
        if (Array.isArray(_data['configuredPlanCodeSettings'])) {
          this.configuredPlanCodeSettings = [] as any;
          for (let item of _data['configuredPlanCodeSettings'])
            this.configuredPlanCodeSettings!.push(
              ConfiguredPlanCodeSettings.fromJS(item),
            );
        } else {
          this.configuredPlanCodeSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCountryTaxPositionDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxPositionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxPositionCode'] =
        this.taxPositionCode !== undefined ? this.taxPositionCode : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      if (Array.isArray(this.configuredPlanCodeSettings)) {
        data['configuredPlanCodeSettings'] = [];
        for (let item of this.configuredPlanCodeSettings)
          data['configuredPlanCodeSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCountryTaxPositionDto {
    taxPositionCode: string;
    planType: PlanType;
    configuredValueCode: string;
    configuredPlanCodeSettings: ConfiguredPlanCodeSettings[];
  }

  export abstract class GetCountryConfigurationPoliciesQueryResult
    implements IGetCountryConfigurationPoliciesQueryResult
  {
    constructor(data?: IGetCountryConfigurationPoliciesQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryConfigurationPoliciesQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCountryConfigurationPoliciesQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryConfigurationPoliciesQueryResult {}

  export class GetCountryConfigurationPoliciesQueryResultSuccess
    extends GetCountryConfigurationPoliciesQueryResult
    implements IGetCountryConfigurationPoliciesQueryResultSuccess
  {
    rows!: CountryConfigurationPolicyRowDto[];

    constructor(data?: IGetCountryConfigurationPoliciesQueryResultSuccess) {
      super(data);
      if (!data) {
        this.rows = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['rows'])) {
          this.rows = [] as any;
          for (let item of _data['rows'])
            this.rows!.push(CountryConfigurationPolicyRowDto.fromJS(item));
        } else {
          this.rows = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryConfigurationPoliciesQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryConfigurationPoliciesQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.rows)) {
        data['rows'] = [];
        for (let item of this.rows) data['rows'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryConfigurationPoliciesQueryResultSuccess
    extends IGetCountryConfigurationPoliciesQueryResult {
    rows: CountryConfigurationPolicyRowDto[];
  }

  export class CountryConfigurationPolicyRowDto
    implements ICountryConfigurationPolicyRowDto
  {
    policyType!: CountryConfigurationPolicyTypeDto;
    clientApproachLines!: string[];
    exceptionsForCountryLines!: string[];

    constructor(data?: ICountryConfigurationPolicyRowDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.policyType = new CountryConfigurationPolicyTypeDto();
        this.clientApproachLines = [];
        this.exceptionsForCountryLines = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.policyType = _data['policyType']
          ? CountryConfigurationPolicyTypeDto.fromJS(_data['policyType'])
          : new CountryConfigurationPolicyTypeDto();
        if (Array.isArray(_data['clientApproachLines'])) {
          this.clientApproachLines = [] as any;
          for (let item of _data['clientApproachLines'])
            this.clientApproachLines!.push(item);
        } else {
          this.clientApproachLines = <any>null;
        }
        if (Array.isArray(_data['exceptionsForCountryLines'])) {
          this.exceptionsForCountryLines = [] as any;
          for (let item of _data['exceptionsForCountryLines'])
            this.exceptionsForCountryLines!.push(item);
        } else {
          this.exceptionsForCountryLines = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryConfigurationPolicyRowDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryConfigurationPolicyRowDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policyType'] = this.policyType
        ? this.policyType.toJSON()
        : <any>null;
      if (Array.isArray(this.clientApproachLines)) {
        data['clientApproachLines'] = [];
        for (let item of this.clientApproachLines)
          data['clientApproachLines'].push(item);
      }
      if (Array.isArray(this.exceptionsForCountryLines)) {
        data['exceptionsForCountryLines'] = [];
        for (let item of this.exceptionsForCountryLines)
          data['exceptionsForCountryLines'].push(item);
      }
      return data;
    }
  }

  export interface ICountryConfigurationPolicyRowDto {
    policyType: CountryConfigurationPolicyTypeDto;
    clientApproachLines: string[];
    exceptionsForCountryLines: string[];
  }

  export class CountryConfigurationPolicyTypeDto
    implements ICountryConfigurationPolicyTypeDto
  {
    policyType!: CountryConfigurationPolicyType;
    policyTypeDescription!: string;

    constructor(data?: ICountryConfigurationPolicyTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.policyType =
          _data['policyType'] !== undefined ? _data['policyType'] : <any>null;
        this.policyTypeDescription =
          _data['policyTypeDescription'] !== undefined
            ? _data['policyTypeDescription']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryConfigurationPolicyTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryConfigurationPolicyTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policyType'] =
        this.policyType !== undefined ? this.policyType : <any>null;
      data['policyTypeDescription'] =
        this.policyTypeDescription !== undefined
          ? this.policyTypeDescription
          : <any>null;
      return data;
    }
  }

  export interface ICountryConfigurationPolicyTypeDto {
    policyType: CountryConfigurationPolicyType;
    policyTypeDescription: string;
  }

  export enum CountryConfigurationPolicyType {
    TaxableConsideration = 'TaxableConsideration',
    Residency = 'Residency',
    CertificateOfCoverage = 'CertificateOfCoverage',
    SocialTax = 'SocialTax',
    TaxAdjustment = 'TaxAdjustment',
    Recharge = 'Recharge',
    CashPayment = 'CashPayment',
    CountryDoubleTaxRelief = 'CountryDoubleTaxRelief',
    RegionDoubleTaxRelief = 'RegionDoubleTaxRelief',
    IncomeTaxRates = 'IncomeTaxRates',
    SocialTaxRates = 'SocialTaxRates',
    RegionTaxRates = 'RegionTaxRates',
  }

  export class GetCountryConfigurationPoliciesQueryResultFailure
    extends GetCountryConfigurationPoliciesQueryResult
    implements IGetCountryConfigurationPoliciesQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCountryConfigurationPoliciesQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryConfigurationPoliciesQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryConfigurationPoliciesQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryConfigurationPoliciesQueryResultFailure
    extends IGetCountryConfigurationPoliciesQueryResult {
    errorMessage: string;
  }

  export abstract class DownloadCountryPositionDocumentQueryResult
    implements IDownloadCountryPositionDocumentQueryResult
  {
    constructor(data?: IDownloadCountryPositionDocumentQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadCountryPositionDocumentQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadCountryPositionDocumentQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadCountryPositionDocumentQueryResult {}

  export class DownloadCountryPositionDocumentQueryResultSuccess
    extends DownloadCountryPositionDocumentQueryResult
    implements IDownloadCountryPositionDocumentQueryResultSuccess
  {
    encodedfile!: string | null;
    fileName!: string | null;

    constructor(data?: IDownloadCountryPositionDocumentQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.encodedfile =
          _data['encodedfile'] !== undefined ? _data['encodedfile'] : <any>null;
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryPositionDocumentQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryPositionDocumentQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['encodedfile'] =
        this.encodedfile !== undefined ? this.encodedfile : <any>null;
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryPositionDocumentQueryResultSuccess
    extends IDownloadCountryPositionDocumentQueryResult {
    encodedfile: string | null;
    fileName: string | null;
  }

  export class DownloadCountryPositionDocumentQueryResultFailure
    extends DownloadCountryPositionDocumentQueryResult
    implements IDownloadCountryPositionDocumentQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDownloadCountryPositionDocumentQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryPositionDocumentQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryPositionDocumentQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryPositionDocumentQueryResultFailure
    extends IDownloadCountryPositionDocumentQueryResult {
    errors: ResultError[];
  }

  export enum CountryPositionDocumentFileType {
    Xlsx = 'Xlsx',
    Pdf = 'Pdf',
  }

  export abstract class GetTaxTypeDescriptionDataCommandResult
    implements IGetTaxTypeDescriptionDataCommandResult
  {
    constructor(data?: IGetTaxTypeDescriptionDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxTypeDescriptionDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxTypeDescriptionDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxTypeDescriptionDataCommandResult {}

  export class GetTaxTypeDescriptionDataCommandResultSuccess
    extends GetTaxTypeDescriptionDataCommandResult
    implements IGetTaxTypeDescriptionDataCommandResultSuccess
  {
    taxTypeDescriptions!: TaxTypeDescription[];

    constructor(data?: IGetTaxTypeDescriptionDataCommandResultSuccess) {
      super(data);
      if (!data) {
        this.taxTypeDescriptions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['taxTypeDescriptions'])) {
          this.taxTypeDescriptions = [] as any;
          for (let item of _data['taxTypeDescriptions'])
            this.taxTypeDescriptions!.push(TaxTypeDescription.fromJS(item));
        } else {
          this.taxTypeDescriptions = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxTypeDescriptionDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxTypeDescriptionDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxTypeDescriptions)) {
        data['taxTypeDescriptions'] = [];
        for (let item of this.taxTypeDescriptions)
          data['taxTypeDescriptions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxTypeDescriptionDataCommandResultSuccess
    extends IGetTaxTypeDescriptionDataCommandResult {
    taxTypeDescriptions: TaxTypeDescription[];
  }

  export class TaxTypeDescription implements ITaxTypeDescription {
    taxType!: TaxType;
    code!: string;
    countryCode!: string;
    regionCode!: string | null;
    description!: string;
    isCustom!: boolean;

    constructor(data?: ITaxTypeDescription) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.isCustom =
          _data['isCustom'] !== undefined ? _data['isCustom'] : <any>null;
      }
    }

    static fromJS(data: any): TaxTypeDescription {
      data = typeof data === 'object' ? data : {};
      let result = new TaxTypeDescription();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['isCustom'] =
        this.isCustom !== undefined ? this.isCustom : <any>null;
      return data;
    }
  }

  export interface ITaxTypeDescription {
    taxType: TaxType;
    code: string;
    countryCode: string;
    regionCode: string | null;
    description: string;
    isCustom: boolean;
  }

  export enum TaxType {
    IncomeTax = 'IncomeTax',
    SocialTax = 'SocialTax',
  }

  export class GetTaxTypeDescriptionDataCommandResultFailure
    extends GetTaxTypeDescriptionDataCommandResult
    implements IGetTaxTypeDescriptionDataCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxTypeDescriptionDataCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxTypeDescriptionDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxTypeDescriptionDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxTypeDescriptionDataCommandResultFailure
    extends IGetTaxTypeDescriptionDataCommandResult {
    errors: ResultError[];
  }

  export class GetTaxTypeDescriptionDataCommand
    implements IGetTaxTypeDescriptionDataCommand
  {
    clientId!: string;
    taxTypes!: TaxType[];
    countryCode!: string;
    regionCode!: string | null;
    includeRegionTaxOnly!: boolean | null;

    constructor(data?: IGetTaxTypeDescriptionDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['taxTypes'])) {
          this.taxTypes = [] as any;
          for (let item of _data['taxTypes']) this.taxTypes!.push(item);
        } else {
          this.taxTypes = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.includeRegionTaxOnly =
          _data['includeRegionTaxOnly'] !== undefined
            ? _data['includeRegionTaxOnly']
            : <any>null;
      }
    }

    static fromJS(data: any): GetTaxTypeDescriptionDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxTypeDescriptionDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.taxTypes)) {
        data['taxTypes'] = [];
        for (let item of this.taxTypes) data['taxTypes'].push(item);
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['includeRegionTaxOnly'] =
        this.includeRegionTaxOnly !== undefined
          ? this.includeRegionTaxOnly
          : <any>null;
      return data;
    }
  }

  export interface IGetTaxTypeDescriptionDataCommand {
    clientId: string;
    taxTypes: TaxType[];
    countryCode: string;
    regionCode: string | null;
    includeRegionTaxOnly: boolean | null;
  }

  export abstract class GetRegionCodeFromTaxTypeDescriptionCommandResult
    implements IGetRegionCodeFromTaxTypeDescriptionCommandResult
  {
    constructor(data?: IGetRegionCodeFromTaxTypeDescriptionCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRegionCodeFromTaxTypeDescriptionCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetRegionCodeFromTaxTypeDescriptionCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionCodeFromTaxTypeDescriptionCommandResult {}

  export class GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess
    extends GetRegionCodeFromTaxTypeDescriptionCommandResult
    implements IGetRegionCodeFromTaxTypeDescriptionCommandResultSuccess
  {
    regionCode!: string | null;

    constructor(
      data?: IGetRegionCodeFromTaxTypeDescriptionCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetRegionCodeFromTaxTypeDescriptionCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionCodeFromTaxTypeDescriptionCommandResultSuccess
    extends IGetRegionCodeFromTaxTypeDescriptionCommandResult {
    regionCode: string | null;
  }

  export class GetRegionCodeFromTaxTypeDescriptionCommandResultFailure
    extends GetRegionCodeFromTaxTypeDescriptionCommandResult
    implements IGetRegionCodeFromTaxTypeDescriptionCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetRegionCodeFromTaxTypeDescriptionCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionCodeFromTaxTypeDescriptionCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetRegionCodeFromTaxTypeDescriptionCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionCodeFromTaxTypeDescriptionCommandResultFailure
    extends IGetRegionCodeFromTaxTypeDescriptionCommandResult {
    errors: ResultError[];
  }

  export class GetRegionCodeFromTaxTypeDescriptionCommand
    implements IGetRegionCodeFromTaxTypeDescriptionCommand
  {
    clientId!: string;
    taxTypes!: TaxType[];
    countryCode!: string;
    taxTypeDescriptionText!: string[];

    constructor(data?: IGetRegionCodeFromTaxTypeDescriptionCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxTypes = [];
        this.taxTypeDescriptionText = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['taxTypes'])) {
          this.taxTypes = [] as any;
          for (let item of _data['taxTypes']) this.taxTypes!.push(item);
        } else {
          this.taxTypes = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['taxTypeDescriptionText'])) {
          this.taxTypeDescriptionText = [] as any;
          for (let item of _data['taxTypeDescriptionText'])
            this.taxTypeDescriptionText!.push(item);
        } else {
          this.taxTypeDescriptionText = <any>null;
        }
      }
    }

    static fromJS(data: any): GetRegionCodeFromTaxTypeDescriptionCommand {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionCodeFromTaxTypeDescriptionCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.taxTypes)) {
        data['taxTypes'] = [];
        for (let item of this.taxTypes) data['taxTypes'].push(item);
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.taxTypeDescriptionText)) {
        data['taxTypeDescriptionText'] = [];
        for (let item of this.taxTypeDescriptionText)
          data['taxTypeDescriptionText'].push(item);
      }
      return data;
    }
  }

  export interface IGetRegionCodeFromTaxTypeDescriptionCommand {
    clientId: string;
    taxTypes: TaxType[];
    countryCode: string;
    taxTypeDescriptionText: string[];
  }

  export abstract class GetTaxRateEmployeeOverridePageDataQueryResult
    implements IGetTaxRateEmployeeOverridePageDataQueryResult
  {
    constructor(data?: IGetTaxRateEmployeeOverridePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxRateEmployeeOverridePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxRateEmployeeOverridePageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridePageDataQueryResult {}

  export class GetTaxRateEmployeeOverridePageDataQueryResultSuccess
    extends GetTaxRateEmployeeOverridePageDataQueryResult
    implements IGetTaxRateEmployeeOverridePageDataQueryResultSuccess
  {
    result!: TaxRateEmployeeOverridePageData;

    constructor(data?: IGetTaxRateEmployeeOverridePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TaxRateEmployeeOverridePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxRateEmployeeOverridePageData.fromJS(_data['result'])
          : new TaxRateEmployeeOverridePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateEmployeeOverridePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateEmployeeOverridePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridePageDataQueryResultSuccess
    extends IGetTaxRateEmployeeOverridePageDataQueryResult {
    result: TaxRateEmployeeOverridePageData;
  }

  export class TaxRateEmployeeOverridePageData
    implements ITaxRateEmployeeOverridePageData
  {
    taxRateEmployeeOverride!: TaxRateEmployeeOverrideDto | null;
    countriesInFootprint!: string[];
    taxTypes!: TaxRateTaxTypeOptionDto[];
    configuredPlanTypes!: PlanTypeDto[];
    residencyStatuses!: CountryTaxRateResidencyDto[];
    hasUploadedClientProvidedRates!: boolean;

    constructor(data?: ITaxRateEmployeeOverridePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.taxTypes = [];
        this.configuredPlanTypes = [];
        this.residencyStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxRateEmployeeOverride = _data['taxRateEmployeeOverride']
          ? TaxRateEmployeeOverrideDto.fromJS(_data['taxRateEmployeeOverride'])
          : <any>null;
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(item);
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['taxTypes'])) {
          this.taxTypes = [] as any;
          for (let item of _data['taxTypes'])
            this.taxTypes!.push(TaxRateTaxTypeOptionDto.fromJS(item));
        } else {
          this.taxTypes = <any>null;
        }
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(
              CountryTaxRateResidencyDto.fromJS(item),
            );
        } else {
          this.residencyStatuses = <any>null;
        }
        this.hasUploadedClientProvidedRates =
          _data['hasUploadedClientProvidedRates'] !== undefined
            ? _data['hasUploadedClientProvidedRates']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverridePageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverridePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxRateEmployeeOverride'] = this.taxRateEmployeeOverride
        ? this.taxRateEmployeeOverride.toJSON()
        : <any>null;
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item);
      }
      if (Array.isArray(this.taxTypes)) {
        data['taxTypes'] = [];
        for (let item of this.taxTypes) data['taxTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item.toJSON());
      }
      data['hasUploadedClientProvidedRates'] =
        this.hasUploadedClientProvidedRates !== undefined
          ? this.hasUploadedClientProvidedRates
          : <any>null;
      return data;
    }
  }

  export interface ITaxRateEmployeeOverridePageData {
    taxRateEmployeeOverride: TaxRateEmployeeOverrideDto | null;
    countriesInFootprint: string[];
    taxTypes: TaxRateTaxTypeOptionDto[];
    configuredPlanTypes: PlanTypeDto[];
    residencyStatuses: CountryTaxRateResidencyDto[];
    hasUploadedClientProvidedRates: boolean;
  }

  export class TaxRateEmployeeOverrideDto
    implements ITaxRateEmployeeOverrideDto
  {
    id!: string;
    clientId!: string;
    configuration!: TaxRateEmployeeOverrideConfigurationDto;

    constructor(data?: ITaxRateEmployeeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.configuration = new TaxRateEmployeeOverrideConfigurationDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.configuration = _data['configuration']
          ? TaxRateEmployeeOverrideConfigurationDto.fromJS(
              _data['configuration'],
            )
          : new TaxRateEmployeeOverrideConfigurationDto();
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxRateEmployeeOverrideDto {
    id: string;
    clientId: string;
    configuration: TaxRateEmployeeOverrideConfigurationDto;
  }

  export class TaxRateEmployeeOverrideConfigurationDto
    implements ITaxRateEmployeeOverrideConfigurationDto
  {
    employeeId!: string;
    transactionId!: string | null;
    countryCode!: string;
    regionCode!: string | null;
    taxType!: TaxRateTaxTypeOption;
    taxRateType!: TaxRateTypeDto;
    planTypeOverrides!: { [key: string]: number };

    constructor(data?: ITaxRateEmployeeOverrideConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxRateType = new TaxRateTypeDto();
        this.planTypeOverrides = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.taxRateType = _data['taxRateType']
          ? TaxRateTypeDto.fromJS(_data['taxRateType'])
          : new TaxRateTypeDto();
        if (_data['planTypeOverrides']) {
          this.planTypeOverrides = {} as any;
          for (let key in _data['planTypeOverrides']) {
            if (_data['planTypeOverrides'].hasOwnProperty(key))
              (<any>this.planTypeOverrides)![key] =
                _data['planTypeOverrides'][key] !== undefined
                  ? _data['planTypeOverrides'][key]
                  : <any>null;
          }
        } else {
          this.planTypeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverrideConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverrideConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['taxRateType'] = this.taxRateType
        ? this.taxRateType.toJSON()
        : <any>null;
      if (this.planTypeOverrides) {
        data['planTypeOverrides'] = {};
        for (let key in this.planTypeOverrides) {
          if (this.planTypeOverrides.hasOwnProperty(key))
            (<any>data['planTypeOverrides'])[key] =
              this.planTypeOverrides[key] !== undefined
                ? this.planTypeOverrides[key]
                : <any>null;
        }
      }
      return data;
    }
  }

  export interface ITaxRateEmployeeOverrideConfigurationDto {
    employeeId: string;
    transactionId: string | null;
    countryCode: string;
    regionCode: string | null;
    taxType: TaxRateTaxTypeOption;
    taxRateType: TaxRateTypeDto;
    planTypeOverrides: { [key: string]: number };
  }

  export enum TaxRateTaxTypeOption {
    Income = 'Income',
    Social = 'Social',
  }

  export class TaxRateTypeDto implements ITaxRateTypeDto {
    code!: string;
    description!: string;
    taxType!: TaxRateTaxTypeOption;
    residency!: CountryTaxRateResidency;
    bandingType!: TaxRateBandingType;

    constructor(data?: ITaxRateTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.residency =
          _data['residency'] !== undefined ? _data['residency'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
      }
    }

    static fromJS(data: any): TaxRateTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['residency'] =
        this.residency !== undefined ? this.residency : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      return data;
    }
  }

  export interface ITaxRateTypeDto {
    code: string;
    description: string;
    taxType: TaxRateTaxTypeOption;
    residency: CountryTaxRateResidency;
    bandingType: TaxRateBandingType;
  }

  export enum CountryTaxRateResidency {
    Both = 'Both',
    NonResident = 'NonResident',
    Resident = 'Resident',
  }

  export enum TaxRateBandingType {
    Annual = 'Annual',
    Monthly = 'Monthly',
    Weekly = 'Weekly',
  }

  export class TaxRateTaxTypeOptionDto implements ITaxRateTaxTypeOptionDto {
    optionValue!: TaxRateTaxTypeOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxRateTaxTypeOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxRateTaxTypeOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateTaxTypeOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxRateTaxTypeOptionDto {
    optionValue: TaxRateTaxTypeOption;
    displayValue: string;
    displayOrder: number;
  }

  export class CountryTaxRateResidencyDto
    implements ICountryTaxRateResidencyDto
  {
    value!: CountryTaxRateResidency;
    display!: string;

    constructor(data?: ICountryTaxRateResidencyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxRateResidencyDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxRateResidencyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ICountryTaxRateResidencyDto {
    value: CountryTaxRateResidency;
    display: string;
  }

  export class GetTaxRateEmployeeOverridePageDataQueryResultFailure
    extends GetTaxRateEmployeeOverridePageDataQueryResult
    implements IGetTaxRateEmployeeOverridePageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetTaxRateEmployeeOverridePageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateEmployeeOverridePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateEmployeeOverridePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridePageDataQueryResultFailure
    extends IGetTaxRateEmployeeOverridePageDataQueryResult {
    errorMessage: string;
  }

  export abstract class GetTaxRateTypesQueryResult
    implements IGetTaxRateTypesQueryResult
  {
    constructor(data?: IGetTaxRateTypesQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxRateTypesQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxRateTypesQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRateTypesQueryResult {}

  export class GetTaxRateTypesQueryResultSuccess
    extends GetTaxRateTypesQueryResult
    implements IGetTaxRateTypesQueryResultSuccess
  {
    taxRateTypes!: TaxRateTypeDto[];

    constructor(data?: IGetTaxRateTypesQueryResultSuccess) {
      super(data);
      if (!data) {
        this.taxRateTypes = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['taxRateTypes'])) {
          this.taxRateTypes = [] as any;
          for (let item of _data['taxRateTypes'])
            this.taxRateTypes!.push(TaxRateTypeDto.fromJS(item));
        } else {
          this.taxRateTypes = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTaxRateTypesQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateTypesQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxRateTypes)) {
        data['taxRateTypes'] = [];
        for (let item of this.taxRateTypes)
          data['taxRateTypes'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateTypesQueryResultSuccess
    extends IGetTaxRateTypesQueryResult {
    taxRateTypes: TaxRateTypeDto[];
  }

  export class GetTaxRateTypesQueryResultFailure
    extends GetTaxRateTypesQueryResult
    implements IGetTaxRateTypesQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetTaxRateTypesQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetTaxRateTypesQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateTypesQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateTypesQueryResultFailure
    extends IGetTaxRateTypesQueryResult {
    errorMessage: string;
  }

  export abstract class UpsertTaxRateEmployeeOverrideCommandResult
    implements IUpsertTaxRateEmployeeOverrideCommandResult
  {
    constructor(data?: IUpsertTaxRateEmployeeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTaxRateEmployeeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertTaxRateEmployeeOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTaxRateEmployeeOverrideCommandResult {}

  export class UpsertTaxRateEmployeeOverrideCommandResultSuccess
    extends UpsertTaxRateEmployeeOverrideCommandResult
    implements IUpsertTaxRateEmployeeOverrideCommandResultSuccess
  {
    constructor(data?: IUpsertTaxRateEmployeeOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRateEmployeeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRateEmployeeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRateEmployeeOverrideCommandResultSuccess
    extends IUpsertTaxRateEmployeeOverrideCommandResult {}

  export class UpsertTaxRateEmployeeOverrideCommandResultFailure
    extends UpsertTaxRateEmployeeOverrideCommandResult
    implements IUpsertTaxRateEmployeeOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IUpsertTaxRateEmployeeOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRateEmployeeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRateEmployeeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRateEmployeeOverrideCommandResultFailure
    extends IUpsertTaxRateEmployeeOverrideCommandResult {
    errorMessage: string;
  }

  export class UpsertTaxRateEmployeeOverrideCommand
    implements IUpsertTaxRateEmployeeOverrideCommand
  {
    clientId!: string;
    id!: string | null;
    configuration!: TaxRateEmployeeOverrideConfigurationDto;

    constructor(data?: IUpsertTaxRateEmployeeOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.configuration = new TaxRateEmployeeOverrideConfigurationDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.configuration = _data['configuration']
          ? TaxRateEmployeeOverrideConfigurationDto.fromJS(
              _data['configuration'],
            )
          : new TaxRateEmployeeOverrideConfigurationDto();
      }
    }

    static fromJS(data: any): UpsertTaxRateEmployeeOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRateEmployeeOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertTaxRateEmployeeOverrideCommand {
    clientId: string;
    id: string | null;
    configuration: TaxRateEmployeeOverrideConfigurationDto;
  }

  export abstract class CheckTaxRateEmployeeOverrideDuplicateDataCommandResult
    implements ICheckTaxRateEmployeeOverrideDuplicateDataCommandResult
  {
    constructor(
      data?: ICheckTaxRateEmployeeOverrideDuplicateDataCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): CheckTaxRateEmployeeOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckTaxRateEmployeeOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckTaxRateEmployeeOverrideDuplicateDataCommandResult {}

  export class CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess
    extends CheckTaxRateEmployeeOverrideDuplicateDataCommandResult
    implements ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultSuccess
    extends ICheckTaxRateEmployeeOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure
    extends CheckTaxRateEmployeeOverrideDuplicateDataCommandResult
    implements ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTaxRateEmployeeOverrideDuplicateDataCommandResultFailure
    extends ICheckTaxRateEmployeeOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckTaxRateEmployeeOverrideDuplicateDataCommand
    implements ICheckTaxRateEmployeeOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeId!: string;
    transactionId!: string | null;
    countryCode!: string;
    regionCode!: string | null;
    taxType!: TaxRateTaxTypeOption;
    taxRateType!: TaxRateTypeDto;
    planTypes!: PlanType[];

    constructor(data?: ICheckTaxRateEmployeeOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxRateType = new TaxRateTypeDto();
        this.planTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.taxRateType = _data['taxRateType']
          ? TaxRateTypeDto.fromJS(_data['taxRateType'])
          : new TaxRateTypeDto();
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckTaxRateEmployeeOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTaxRateEmployeeOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['taxRateType'] = this.taxRateType
        ? this.taxRateType.toJSON()
        : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      return data;
    }
  }

  export interface ICheckTaxRateEmployeeOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeId: string;
    transactionId: string | null;
    countryCode: string;
    regionCode: string | null;
    taxType: TaxRateTaxTypeOption;
    taxRateType: TaxRateTypeDto;
    planTypes: PlanType[];
  }

  export class DownloadClientProvidedRatesTemplateQueryResult
    implements IDownloadClientProvidedRatesTemplateQueryResult
  {
    constructor(data?: IDownloadClientProvidedRatesTemplateQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadClientProvidedRatesTemplateQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadClientProvidedRatesTemplateQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadClientProvidedRatesTemplateQueryResult {}

  export class DownloadClientProvidedRatesTemplateQueryResultSuccess
    extends DownloadClientProvidedRatesTemplateQueryResult
    implements IDownloadClientProvidedRatesTemplateQueryResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadClientProvidedRatesTemplateQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadClientProvidedRatesTemplateQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadClientProvidedRatesTemplateQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadClientProvidedRatesTemplateQueryResultSuccess
    extends IDownloadClientProvidedRatesTemplateQueryResult {
    result: string;
  }

  export class DownloadClientProvidedRatesTemplateQueryResultFailure
    extends DownloadClientProvidedRatesTemplateQueryResult
    implements IDownloadClientProvidedRatesTemplateQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDownloadClientProvidedRatesTemplateQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadClientProvidedRatesTemplateQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadClientProvidedRatesTemplateQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadClientProvidedRatesTemplateQueryResultFailure
    extends IDownloadClientProvidedRatesTemplateQueryResult {
    errors: ResultError[];
  }

  export class UploadClientProvidedRatesFileCommandResult
    implements IUploadClientProvidedRatesFileCommandResult
  {
    constructor(data?: IUploadClientProvidedRatesFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadClientProvidedRatesFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadClientProvidedRatesFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadClientProvidedRatesFileCommandResult {}

  export class UploadClientProvidedRatesFileCommandResultSuccess
    extends UploadClientProvidedRatesFileCommandResult
    implements IUploadClientProvidedRatesFileCommandResultSuccess
  {
    constructor(data?: IUploadClientProvidedRatesFileCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UploadClientProvidedRatesFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadClientProvidedRatesFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadClientProvidedRatesFileCommandResultSuccess
    extends IUploadClientProvidedRatesFileCommandResult {}

  export class UploadClientProvidedRatesFileCommandResultFailure
    extends UploadClientProvidedRatesFileCommandResult
    implements IUploadClientProvidedRatesFileCommandResultFailure
  {
    errors!: ExcelValidationErrorDto[];

    constructor(data?: IUploadClientProvidedRatesFileCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ExcelValidationErrorDto.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UploadClientProvidedRatesFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadClientProvidedRatesFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadClientProvidedRatesFileCommandResultFailure
    extends IUploadClientProvidedRatesFileCommandResult {
    errors: ExcelValidationErrorDto[];
  }

  export abstract class GetTaxRateEmployeeOverridesIndexPageDataQueryResult
    implements IGetTaxRateEmployeeOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetTaxRateEmployeeOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetTaxRateEmployeeOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxRateEmployeeOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridesIndexPageDataQueryResult {}

  export class GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess
    extends GetTaxRateEmployeeOverridesIndexPageDataQueryResult
    implements IGetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess
  {
    result!: TaxRateEmployeeOverridesIndexPageData;

    constructor(
      data?: IGetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new TaxRateEmployeeOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxRateEmployeeOverridesIndexPageData.fromJS(_data['result'])
          : new TaxRateEmployeeOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridesIndexPageDataQueryResultSuccess
    extends IGetTaxRateEmployeeOverridesIndexPageDataQueryResult {
    result: TaxRateEmployeeOverridesIndexPageData;
  }

  export class TaxRateEmployeeOverridesIndexPageData
    implements ITaxRateEmployeeOverridesIndexPageData
  {
    lineItems!: TaxRateEmployeeOverrideLineItem[];

    constructor(data?: ITaxRateEmployeeOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.lineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(TaxRateEmployeeOverrideLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxRateEmployeeOverridesIndexPageData {
    lineItems: TaxRateEmployeeOverrideLineItem[];
  }

  export class TaxRateEmployeeOverrideLineItem
    implements ITaxRateEmployeeOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    country!: string;
    region!: string | null;
    taxType!: string;
    taxDescription!: string;
    planType!: string;
    override!: string;
    subLineItems!: TaxRateEmployeeOverrideSubLineItem[];

    constructor(data?: ITaxRateEmployeeOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.subLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.taxDescription =
          _data['taxDescription'] !== undefined
            ? _data['taxDescription']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
        if (Array.isArray(_data['subLineItems'])) {
          this.subLineItems = [] as any;
          for (let item of _data['subLineItems'])
            this.subLineItems!.push(
              TaxRateEmployeeOverrideSubLineItem.fromJS(item),
            );
        } else {
          this.subLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['taxDescription'] =
        this.taxDescription !== undefined ? this.taxDescription : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      if (Array.isArray(this.subLineItems)) {
        data['subLineItems'] = [];
        for (let item of this.subLineItems)
          data['subLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxRateEmployeeOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    country: string;
    region: string | null;
    taxType: string;
    taxDescription: string;
    planType: string;
    override: string;
    subLineItems: TaxRateEmployeeOverrideSubLineItem[];
  }

  export class TaxRateEmployeeOverrideSubLineItem
    implements ITaxRateEmployeeOverrideSubLineItem
  {
    planType!: string;
    override!: string;

    constructor(data?: ITaxRateEmployeeOverrideSubLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): TaxRateEmployeeOverrideSubLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateEmployeeOverrideSubLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface ITaxRateEmployeeOverrideSubLineItem {
    planType: string;
    override: string;
  }

  export class GetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure
    extends GetTaxRateEmployeeOverridesIndexPageDataQueryResult
    implements IGetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IGetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateEmployeeOverridesIndexPageDataQueryResultFailure
    extends IGetTaxRateEmployeeOverridesIndexPageDataQueryResult {
    errorMessage: string;
  }

  export abstract class DeleteTaxRateEmployeeOverrideCommandResult
    implements IDeleteTaxRateEmployeeOverrideCommandResult
  {
    constructor(data?: IDeleteTaxRateEmployeeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteTaxRateEmployeeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DeleteTaxRateEmployeeOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteTaxRateEmployeeOverrideCommandResult {}

  export class DeleteTaxRateEmployeeOverrideCommandResultSuccess
    extends DeleteTaxRateEmployeeOverrideCommandResult
    implements IDeleteTaxRateEmployeeOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteTaxRateEmployeeOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteTaxRateEmployeeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRateEmployeeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTaxRateEmployeeOverrideCommandResultSuccess
    extends IDeleteTaxRateEmployeeOverrideCommandResult {}

  export class DeleteTaxRateEmployeeOverrideCommandResultFailure
    extends DeleteTaxRateEmployeeOverrideCommandResult
    implements IDeleteTaxRateEmployeeOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteTaxRateEmployeeOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteTaxRateEmployeeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRateEmployeeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTaxRateEmployeeOverrideCommandResultFailure
    extends IDeleteTaxRateEmployeeOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteTaxRateEmployeeOverrideCommand
    implements IDeleteTaxRateEmployeeOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteTaxRateEmployeeOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteTaxRateEmployeeOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRateEmployeeOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteTaxRateEmployeeOverrideCommand {
    clientId: string;
    id: string;
  }

  export abstract class GetRegionTaxRatesPageDataQueryResult
    implements IGetRegionTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetRegionTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRegionTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetRegionTaxRatesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionTaxRatesPageDataQueryResult {}

  export class GetRegionTaxRatesPageDataQueryResultSuccess
    extends GetRegionTaxRatesPageDataQueryResult
    implements IGetRegionTaxRatesPageDataQueryResultSuccess
  {
    lineItems!: RegionTaxRatesLineItem[];

    constructor(data?: IGetRegionTaxRatesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.lineItems = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(RegionTaxRatesLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxRatesPageDataQueryResultSuccess
    extends IGetRegionTaxRatesPageDataQueryResult {
    lineItems: RegionTaxRatesLineItem[];
  }

  export class RegionTaxRatesLineItem implements IRegionTaxRatesLineItem {
    countryCode!: string;
    regionsCount!: number;
    isDeloitteRateUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: IRegionTaxRatesLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionsCount =
          _data['regionsCount'] !== undefined
            ? _data['regionsCount']
            : <any>null;
        this.isDeloitteRateUpdated =
          _data['isDeloitteRateUpdated'] !== undefined
            ? _data['isDeloitteRateUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatesLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatesLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionsCount'] =
        this.regionsCount !== undefined ? this.regionsCount : <any>null;
      data['isDeloitteRateUpdated'] =
        this.isDeloitteRateUpdated !== undefined
          ? this.isDeloitteRateUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatesLineItem {
    countryCode: string;
    regionsCount: number;
    isDeloitteRateUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class GetRegionTaxRatesPageDataQueryResultFailure
    extends GetRegionTaxRatesPageDataQueryResult
    implements IGetRegionTaxRatesPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetRegionTaxRatesPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxRatesPageDataQueryResultFailure
    extends IGetRegionTaxRatesPageDataQueryResult {
    errorMessage: string;
  }

  export abstract class SaveRegionTaxRatesWorkflowStepCommandResult
    implements ISaveRegionTaxRatesWorkflowStepCommandResult
  {
    constructor(data?: ISaveRegionTaxRatesWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveRegionTaxRatesWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveRegionTaxRatesWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveRegionTaxRatesWorkflowStepCommandResult {}

  export class SaveRegionTaxRatesWorkflowStepCommandResultSuccess
    extends SaveRegionTaxRatesWorkflowStepCommandResult
    implements ISaveRegionTaxRatesWorkflowStepCommandResultSuccess
  {
    constructor(data?: ISaveRegionTaxRatesWorkflowStepCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveRegionTaxRatesWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveRegionTaxRatesWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveRegionTaxRatesWorkflowStepCommandResultSuccess
    extends ISaveRegionTaxRatesWorkflowStepCommandResult {}

  export class SaveRegionTaxRatesWorkflowStepCommandResultFailure
    extends SaveRegionTaxRatesWorkflowStepCommandResult
    implements ISaveRegionTaxRatesWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISaveRegionTaxRatesWorkflowStepCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveRegionTaxRatesWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveRegionTaxRatesWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveRegionTaxRatesWorkflowStepCommandResultFailure
    extends ISaveRegionTaxRatesWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveRegionTaxRatesWorkflowStepCommand
    implements ISaveRegionTaxRatesWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveRegionTaxRatesWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveRegionTaxRatesWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveRegionTaxRatesWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveRegionTaxRatesWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadRegionTaxRatePageDataCommandResult
    implements IDownloadRegionTaxRatePageDataCommandResult
  {
    constructor(data?: IDownloadRegionTaxRatePageDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadRegionTaxRatePageDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadRegionTaxRatePageDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadRegionTaxRatePageDataCommandResult {}

  export class DownloadRegionTaxRatePageDataCommandResultSuccess
    extends DownloadRegionTaxRatePageDataCommandResult
    implements IDownloadRegionTaxRatePageDataCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadRegionTaxRatePageDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadRegionTaxRatePageDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxRatePageDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadRegionTaxRatePageDataCommandResultSuccess
    extends IDownloadRegionTaxRatePageDataCommandResult {
    result: string;
  }

  export class DownloadRegionTaxRatePageDataCommandResultFailure
    extends DownloadRegionTaxRatePageDataCommandResult
    implements IDownloadRegionTaxRatePageDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadRegionTaxRatePageDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadRegionTaxRatePageDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxRatePageDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadRegionTaxRatePageDataCommandResultFailure
    extends IDownloadRegionTaxRatePageDataCommandResult {
    errorMessage: string;
  }

  export class DownloadRegionTaxRatePageDataCommand
    implements IDownloadRegionTaxRatePageDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadRegionTaxRatePageDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadRegionTaxRatePageDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadRegionTaxRatePageDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadRegionTaxRatePageDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export class GetHypoCustomTaxesOverrideQueryResult
    implements IGetHypoCustomTaxesOverrideQueryResult
  {
    constructor(data?: IGetHypoCustomTaxesOverrideQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetHypoCustomTaxesOverrideQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesOverrideQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetHypoCustomTaxesOverrideQueryResult {}

  export class GetHypoCustomTaxesOverrideQueryResultSuccess
    extends GetHypoCustomTaxesOverrideQueryResult
    implements IGetHypoCustomTaxesOverrideQueryResultSuccess
  {
    result!: HypoSpecificCustomTaxRatesPageData;

    constructor(data?: IGetHypoCustomTaxesOverrideQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new HypoSpecificCustomTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? HypoSpecificCustomTaxRatesPageData.fromJS(_data['result'])
          : new HypoSpecificCustomTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoCustomTaxesOverrideQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesOverrideQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCustomTaxesOverrideQueryResultSuccess
    extends IGetHypoCustomTaxesOverrideQueryResult {
    result: HypoSpecificCustomTaxRatesPageData;
  }

  export class HypoSpecificCustomTaxRatesPageData
    implements IHypoSpecificCustomTaxRatesPageData
  {
    configuredPlanTypes!: PlanTypeDto[];
    taxRateTables!: CustomTaxDto[];
    groupedTaxRates!: HypoCustomTaxRateTable[];
    overriddenTaxTypePlanType!: OverriddenTaxTypePlanType[];

    constructor(data?: IHypoSpecificCustomTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.configuredPlanTypes = [];
        this.taxRateTables = [];
        this.groupedTaxRates = [];
        this.overriddenTaxTypePlanType = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (Array.isArray(_data['taxRateTables'])) {
          this.taxRateTables = [] as any;
          for (let item of _data['taxRateTables'])
            this.taxRateTables!.push(CustomTaxDto.fromJS(item));
        } else {
          this.taxRateTables = <any>null;
        }
        if (Array.isArray(_data['groupedTaxRates'])) {
          this.groupedTaxRates = [] as any;
          for (let item of _data['groupedTaxRates'])
            this.groupedTaxRates!.push(HypoCustomTaxRateTable.fromJS(item));
        } else {
          this.groupedTaxRates = <any>null;
        }
        if (Array.isArray(_data['overriddenTaxTypePlanType'])) {
          this.overriddenTaxTypePlanType = [] as any;
          for (let item of _data['overriddenTaxTypePlanType'])
            this.overriddenTaxTypePlanType!.push(
              OverriddenTaxTypePlanType.fromJS(item),
            );
        } else {
          this.overriddenTaxTypePlanType = <any>null;
        }
      }
    }

    static fromJS(data: any): HypoSpecificCustomTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new HypoSpecificCustomTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRateTables)) {
        data['taxRateTables'] = [];
        for (let item of this.taxRateTables)
          data['taxRateTables'].push(item.toJSON());
      }
      if (Array.isArray(this.groupedTaxRates)) {
        data['groupedTaxRates'] = [];
        for (let item of this.groupedTaxRates)
          data['groupedTaxRates'].push(item.toJSON());
      }
      if (Array.isArray(this.overriddenTaxTypePlanType)) {
        data['overriddenTaxTypePlanType'] = [];
        for (let item of this.overriddenTaxTypePlanType)
          data['overriddenTaxTypePlanType'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IHypoSpecificCustomTaxRatesPageData {
    configuredPlanTypes: PlanTypeDto[];
    taxRateTables: CustomTaxDto[];
    groupedTaxRates: HypoCustomTaxRateTable[];
    overriddenTaxTypePlanType: OverriddenTaxTypePlanType[];
  }

  export class CustomTaxDto implements ICustomTaxDto {
    clientId!: string;
    id!: string;
    restrictedStockUnitIncomeBasis!: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis!: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis!: CashBonusIncomeBasisSettingDto | null;
    taxType!: TaxType;
    bandingType!: BandingType;
    code!: string;
    countryCode!: string;
    regionCode!: string | null;
    currencyCode!: string;
    taxTypeDisplay!: string;
    bands!: CustomTaxBandDto[];

    constructor(data?: ICustomTaxDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.bands = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.restrictedStockUnitIncomeBasis = _data[
          'restrictedStockUnitIncomeBasis'
        ]
          ? RestrictedStockUnitIncomeBasisSettingDto.fromJS(
              _data['restrictedStockUnitIncomeBasis'],
            )
          : <any>null;
        this.stockOptionIncomeBasis = _data['stockOptionIncomeBasis']
          ? StockOptionIncomeBasisSettingDto.fromJS(
              _data['stockOptionIncomeBasis'],
            )
          : <any>null;
        this.cashBonusIncomeBasis = _data['cashBonusIncomeBasis']
          ? CashBonusIncomeBasisSettingDto.fromJS(_data['cashBonusIncomeBasis'])
          : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.taxTypeDisplay =
          _data['taxTypeDisplay'] !== undefined
            ? _data['taxTypeDisplay']
            : <any>null;
        if (Array.isArray(_data['bands'])) {
          this.bands = [] as any;
          for (let item of _data['bands'])
            this.bands!.push(CustomTaxBandDto.fromJS(item));
        } else {
          this.bands = <any>null;
        }
      }
    }

    static fromJS(data: any): CustomTaxDto {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['restrictedStockUnitIncomeBasis'] = this
        .restrictedStockUnitIncomeBasis
        ? this.restrictedStockUnitIncomeBasis.toJSON()
        : <any>null;
      data['stockOptionIncomeBasis'] = this.stockOptionIncomeBasis
        ? this.stockOptionIncomeBasis.toJSON()
        : <any>null;
      data['cashBonusIncomeBasis'] = this.cashBonusIncomeBasis
        ? this.cashBonusIncomeBasis.toJSON()
        : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['taxTypeDisplay'] =
        this.taxTypeDisplay !== undefined ? this.taxTypeDisplay : <any>null;
      if (Array.isArray(this.bands)) {
        data['bands'] = [];
        for (let item of this.bands) data['bands'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICustomTaxDto {
    clientId: string;
    id: string;
    restrictedStockUnitIncomeBasis: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis: CashBonusIncomeBasisSettingDto | null;
    taxType: TaxType;
    bandingType: BandingType;
    code: string;
    countryCode: string;
    regionCode: string | null;
    currencyCode: string;
    taxTypeDisplay: string;
    bands: CustomTaxBandDto[];
  }

  export class RestrictedStockUnitIncomeBasisSettingDto
    implements IRestrictedStockUnitIncomeBasisSettingDto
  {
    resident!: RestrictedStockUnitIncomeBasis;
    nonResident!: RestrictedStockUnitIncomeBasis;

    constructor(data?: IRestrictedStockUnitIncomeBasisSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.resident =
          _data['resident'] !== undefined ? _data['resident'] : <any>null;
        this.nonResident =
          _data['nonResident'] !== undefined ? _data['nonResident'] : <any>null;
      }
    }

    static fromJS(data: any): RestrictedStockUnitIncomeBasisSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitIncomeBasisSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['resident'] =
        this.resident !== undefined ? this.resident : <any>null;
      data['nonResident'] =
        this.nonResident !== undefined ? this.nonResident : <any>null;
      return data;
    }
  }

  export interface IRestrictedStockUnitIncomeBasisSettingDto {
    resident: RestrictedStockUnitIncomeBasis;
    nonResident: RestrictedStockUnitIncomeBasis;
  }

  export enum RestrictedStockUnitIncomeBasis {
    FollowTaxTypeTreatment = 'FollowTaxTypeTreatment',
    GrantToVest = 'GrantToVest',
    GrantToDistribution = 'GrantToDistribution',
    OneHundredPercent = 'OneHundredPercent',
    ZeroPercent = 'ZeroPercent',
  }

  export class StockOptionIncomeBasisSettingDto
    implements IStockOptionIncomeBasisSettingDto
  {
    resident!: StockOptionIncomeBasis;
    nonResident!: StockOptionIncomeBasis;

    constructor(data?: IStockOptionIncomeBasisSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.resident =
          _data['resident'] !== undefined ? _data['resident'] : <any>null;
        this.nonResident =
          _data['nonResident'] !== undefined ? _data['nonResident'] : <any>null;
      }
    }

    static fromJS(data: any): StockOptionIncomeBasisSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionIncomeBasisSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['resident'] =
        this.resident !== undefined ? this.resident : <any>null;
      data['nonResident'] =
        this.nonResident !== undefined ? this.nonResident : <any>null;
      return data;
    }
  }

  export interface IStockOptionIncomeBasisSettingDto {
    resident: StockOptionIncomeBasis;
    nonResident: StockOptionIncomeBasis;
  }

  export enum StockOptionIncomeBasis {
    FollowTaxTypeTreatment = 'FollowTaxTypeTreatment',
    GrantToVest = 'GrantToVest',
    GrantToExercise = 'GrantToExercise',
    OneHundredPercent = 'OneHundredPercent',
    ZeroPercent = 'ZeroPercent',
  }

  export class CashBonusIncomeBasisSettingDto
    implements ICashBonusIncomeBasisSettingDto
  {
    resident!: CashBonusIncomeBasis;
    nonResident!: CashBonusIncomeBasis;

    constructor(data?: ICashBonusIncomeBasisSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.resident =
          _data['resident'] !== undefined ? _data['resident'] : <any>null;
        this.nonResident =
          _data['nonResident'] !== undefined ? _data['nonResident'] : <any>null;
      }
    }

    static fromJS(data: any): CashBonusIncomeBasisSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusIncomeBasisSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['resident'] =
        this.resident !== undefined ? this.resident : <any>null;
      data['nonResident'] =
        this.nonResident !== undefined ? this.nonResident : <any>null;
      return data;
    }
  }

  export interface ICashBonusIncomeBasisSettingDto {
    resident: CashBonusIncomeBasis;
    nonResident: CashBonusIncomeBasis;
  }

  export enum CashBonusIncomeBasis {
    FollowTaxTypeTreatment = 'FollowTaxTypeTreatment',
    PerformanceStartDateToPerformanceEndDate = 'PerformanceStartDateToPerformanceEndDate',
    PerformanceStartDateToPaymentDate = 'PerformanceStartDateToPaymentDate',
    OneHundredPercent = 'OneHundredPercent',
    ZeroPercent = 'ZeroPercent',
  }

  export enum BandingType {
    Weekly = 'Weekly',
    Monthly = 'Monthly',
    Annual = 'Annual',
  }

  export class CustomTaxBandDto implements ICustomTaxBandDto {
    lowerThreshold!: number;
    upperThreshold!: number | null;
    taxRate!: number;

    constructor(data?: ICustomTaxBandDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
      }
    }

    static fromJS(data: any): CustomTaxBandDto {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxBandDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      return data;
    }
  }

  export interface ICustomTaxBandDto {
    lowerThreshold: number;
    upperThreshold: number | null;
    taxRate: number;
  }

  export class HypoCustomTaxRateTable implements IHypoCustomTaxRateTable {
    taxType!: HypoCustomTaxTypeDto;
    rowGroups!: CustomTaxRateTableRowGroup[];

    constructor(data?: IHypoCustomTaxRateTable) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxType = new HypoCustomTaxTypeDto();
        this.rowGroups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType = _data['taxType']
          ? HypoCustomTaxTypeDto.fromJS(_data['taxType'])
          : new HypoCustomTaxTypeDto();
        if (Array.isArray(_data['rowGroups'])) {
          this.rowGroups = [] as any;
          for (let item of _data['rowGroups'])
            this.rowGroups!.push(CustomTaxRateTableRowGroup.fromJS(item));
        } else {
          this.rowGroups = <any>null;
        }
      }
    }

    static fromJS(data: any): HypoCustomTaxRateTable {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCustomTaxRateTable();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType ? this.taxType.toJSON() : <any>null;
      if (Array.isArray(this.rowGroups)) {
        data['rowGroups'] = [];
        for (let item of this.rowGroups) data['rowGroups'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IHypoCustomTaxRateTable {
    taxType: HypoCustomTaxTypeDto;
    rowGroups: CustomTaxRateTableRowGroup[];
  }

  export class HypoCustomTaxTypeDto implements IHypoCustomTaxTypeDto {
    value!: HypoCustomTaxType;
    display!: string;

    constructor(data?: IHypoCustomTaxTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): HypoCustomTaxTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCustomTaxTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IHypoCustomTaxTypeDto {
    value: HypoCustomTaxType;
    display: string;
  }

  export enum HypoCustomTaxType {
    Income = 'Income',
    Social = 'Social',
    RegionIncome = 'RegionIncome',
    RegionSocial = 'RegionSocial',
    CustomTax = 'CustomTax',
  }

  export class CustomTaxRateTableRowGroup
    implements ICustomTaxRateTableRowGroup
  {
    bands!: HypoCustomTaxRateBandDto[];

    constructor(data?: ICustomTaxRateTableRowGroup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.bands = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['bands'])) {
          this.bands = [] as any;
          for (let item of _data['bands'])
            this.bands!.push(HypoCustomTaxRateBandDto.fromJS(item));
        } else {
          this.bands = <any>null;
        }
      }
    }

    static fromJS(data: any): CustomTaxRateTableRowGroup {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxRateTableRowGroup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.bands)) {
        data['bands'] = [];
        for (let item of this.bands) data['bands'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICustomTaxRateTableRowGroup {
    bands: HypoCustomTaxRateBandDto[];
  }

  export class HypoCustomTaxRateBandDto implements IHypoCustomTaxRateBandDto {
    customTaxId!: string;
    countryCode!: string;
    regionCode!: string | null;
    taxTypeDisplay!: string;
    taxType!: TaxType;
    bandingType!: TaxRateBandingType;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    defaultTaxRate!: number | null;
    taxCode!: string | null;
    restrictedStockUnitIncomeBasis!: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis!: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis!: CashBonusIncomeBasisSettingDto | null;
    taxRateOverrides!: TaxRateOverridesDto;

    constructor(data?: IHypoCustomTaxRateBandDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxRateOverrides = new TaxRateOverridesDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTaxId =
          _data['customTaxId'] !== undefined ? _data['customTaxId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxTypeDisplay =
          _data['taxTypeDisplay'] !== undefined
            ? _data['taxTypeDisplay']
            : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.defaultTaxRate =
          _data['defaultTaxRate'] !== undefined
            ? _data['defaultTaxRate']
            : <any>null;
        this.taxCode =
          _data['taxCode'] !== undefined ? _data['taxCode'] : <any>null;
        this.restrictedStockUnitIncomeBasis = _data[
          'restrictedStockUnitIncomeBasis'
        ]
          ? RestrictedStockUnitIncomeBasisSettingDto.fromJS(
              _data['restrictedStockUnitIncomeBasis'],
            )
          : <any>null;
        this.stockOptionIncomeBasis = _data['stockOptionIncomeBasis']
          ? StockOptionIncomeBasisSettingDto.fromJS(
              _data['stockOptionIncomeBasis'],
            )
          : <any>null;
        this.cashBonusIncomeBasis = _data['cashBonusIncomeBasis']
          ? CashBonusIncomeBasisSettingDto.fromJS(_data['cashBonusIncomeBasis'])
          : <any>null;
        this.taxRateOverrides = _data['taxRateOverrides']
          ? TaxRateOverridesDto.fromJS(_data['taxRateOverrides'])
          : new TaxRateOverridesDto();
      }
    }

    static fromJS(data: any): HypoCustomTaxRateBandDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCustomTaxRateBandDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTaxId'] =
        this.customTaxId !== undefined ? this.customTaxId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxTypeDisplay'] =
        this.taxTypeDisplay !== undefined ? this.taxTypeDisplay : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['defaultTaxRate'] =
        this.defaultTaxRate !== undefined ? this.defaultTaxRate : <any>null;
      data['taxCode'] = this.taxCode !== undefined ? this.taxCode : <any>null;
      data['restrictedStockUnitIncomeBasis'] = this
        .restrictedStockUnitIncomeBasis
        ? this.restrictedStockUnitIncomeBasis.toJSON()
        : <any>null;
      data['stockOptionIncomeBasis'] = this.stockOptionIncomeBasis
        ? this.stockOptionIncomeBasis.toJSON()
        : <any>null;
      data['cashBonusIncomeBasis'] = this.cashBonusIncomeBasis
        ? this.cashBonusIncomeBasis.toJSON()
        : <any>null;
      data['taxRateOverrides'] = this.taxRateOverrides
        ? this.taxRateOverrides.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IHypoCustomTaxRateBandDto {
    customTaxId: string;
    countryCode: string;
    regionCode: string | null;
    taxTypeDisplay: string;
    taxType: TaxType;
    bandingType: TaxRateBandingType;
    lowerThreshold: number;
    upperThreshold: number | null;
    defaultTaxRate: number | null;
    taxCode: string | null;
    restrictedStockUnitIncomeBasis: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis: CashBonusIncomeBasisSettingDto | null;
    taxRateOverrides: TaxRateOverridesDto;
  }

  export class TaxRateOverridesDto implements ITaxRateOverridesDto {
    planTypeOverrides!: PlanTypeTaxRateOverrideDto[];
    planOverrides!: PlanTaxRateOverrideDto[];

    constructor(data?: ITaxRateOverridesDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypeOverrides = [];
        this.planOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypeOverrides'])) {
          this.planTypeOverrides = [] as any;
          for (let item of _data['planTypeOverrides'])
            this.planTypeOverrides!.push(
              PlanTypeTaxRateOverrideDto.fromJS(item),
            );
        } else {
          this.planTypeOverrides = <any>null;
        }
        if (Array.isArray(_data['planOverrides'])) {
          this.planOverrides = [] as any;
          for (let item of _data['planOverrides'])
            this.planOverrides!.push(PlanTaxRateOverrideDto.fromJS(item));
        } else {
          this.planOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateOverridesDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateOverridesDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypeOverrides)) {
        data['planTypeOverrides'] = [];
        for (let item of this.planTypeOverrides)
          data['planTypeOverrides'].push(item.toJSON());
      }
      if (Array.isArray(this.planOverrides)) {
        data['planOverrides'] = [];
        for (let item of this.planOverrides)
          data['planOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxRateOverridesDto {
    planTypeOverrides: PlanTypeTaxRateOverrideDto[];
    planOverrides: PlanTaxRateOverrideDto[];
  }

  export class PlanTypeTaxRateOverrideDto
    implements IPlanTypeTaxRateOverrideDto
  {
    planType!: PlanType;
    override!: number;

    constructor(data?: IPlanTypeTaxRateOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): PlanTypeTaxRateOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanTypeTaxRateOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface IPlanTypeTaxRateOverrideDto {
    planType: PlanType;
    override: number;
  }

  export class PlanTaxRateOverrideDto implements IPlanTaxRateOverrideDto {
    planId!: string;
    override!: number;

    constructor(data?: IPlanTaxRateOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planId =
          _data['planId'] !== undefined ? _data['planId'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): PlanTaxRateOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanTaxRateOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planId'] = this.planId !== undefined ? this.planId : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface IPlanTaxRateOverrideDto {
    planId: string;
    override: number;
  }

  export class OverriddenTaxTypePlanType implements IOverriddenTaxTypePlanType {
    taxTypeDisplay!: HypoCustomTaxType;
    planType!: PlanType;

    constructor(data?: IOverriddenTaxTypePlanType) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxTypeDisplay =
          _data['taxTypeDisplay'] !== undefined
            ? _data['taxTypeDisplay']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
      }
    }

    static fromJS(data: any): OverriddenTaxTypePlanType {
      data = typeof data === 'object' ? data : {};
      let result = new OverriddenTaxTypePlanType();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxTypeDisplay'] =
        this.taxTypeDisplay !== undefined ? this.taxTypeDisplay : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      return data;
    }
  }

  export interface IOverriddenTaxTypePlanType {
    taxTypeDisplay: HypoCustomTaxType;
    planType: PlanType;
  }

  export class GetHypoCustomTaxesOverrideQueryResultFailure
    extends GetHypoCustomTaxesOverrideQueryResult
    implements IGetHypoCustomTaxesOverrideQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetHypoCustomTaxesOverrideQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoCustomTaxesOverrideQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesOverrideQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCustomTaxesOverrideQueryResultFailure
    extends IGetHypoCustomTaxesOverrideQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertHypoCustomTaxRateOverridesCommandResult
    implements IUpsertHypoCustomTaxRateOverridesCommandResult
  {
    constructor(data?: IUpsertHypoCustomTaxRateOverridesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertHypoCustomTaxRateOverridesCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertHypoCustomTaxRateOverridesCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRateOverridesCommandResult {}

  export class UpsertHypoCustomTaxRateOverridesCommandResultSuccess
    extends UpsertHypoCustomTaxRateOverridesCommandResult
    implements IUpsertHypoCustomTaxRateOverridesCommandResultSuccess
  {
    constructor(data?: IUpsertHypoCustomTaxRateOverridesCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertHypoCustomTaxRateOverridesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCustomTaxRateOverridesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRateOverridesCommandResultSuccess
    extends IUpsertHypoCustomTaxRateOverridesCommandResult {}

  export class UpsertHypoCustomTaxRateOverridesCommandResultFailure
    extends UpsertHypoCustomTaxRateOverridesCommandResult
    implements IUpsertHypoCustomTaxRateOverridesCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IUpsertHypoCustomTaxRateOverridesCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertHypoCustomTaxRateOverridesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCustomTaxRateOverridesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRateOverridesCommandResultFailure
    extends IUpsertHypoCustomTaxRateOverridesCommandResult {
    errorMessage: string;
  }

  export class UpsertHypoCustomTaxRateOverridesCommand
    implements IUpsertHypoCustomTaxRateOverridesCommand
  {
    clientId!: string;
    countryCode!: string;
    overrides!: UpsertHypoCustomTaxRateOverrideDto[];

    constructor(data?: IUpsertHypoCustomTaxRateOverridesCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(
              UpsertHypoCustomTaxRateOverrideDto.fromJS(item),
            );
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertHypoCustomTaxRateOverridesCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCustomTaxRateOverridesCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRateOverridesCommand {
    clientId: string;
    countryCode: string;
    overrides: UpsertHypoCustomTaxRateOverrideDto[];
  }

  export class UpsertHypoCustomTaxRateOverrideDto
    implements IUpsertHypoCustomTaxRateOverrideDto
  {
    customTaxId!: string;
    countryCode!: string;
    taxType!: HypoCustomTaxType;
    residency!: CountryTaxRateResidency;
    bandingType!: TaxRateBandingType;
    taxRateTypeCode!: string;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    defaultTaxRate!: number;
    planTypeOverrides!: UpsertHypoCustomTaxRatePlanTypeOverrideDto[];

    constructor(data?: IUpsertHypoCustomTaxRateOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTaxId =
          _data['customTaxId'] !== undefined ? _data['customTaxId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.residency =
          _data['residency'] !== undefined ? _data['residency'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.taxRateTypeCode =
          _data['taxRateTypeCode'] !== undefined
            ? _data['taxRateTypeCode']
            : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.defaultTaxRate =
          _data['defaultTaxRate'] !== undefined
            ? _data['defaultTaxRate']
            : <any>null;
        if (Array.isArray(_data['planTypeOverrides'])) {
          this.planTypeOverrides = [] as any;
          for (let item of _data['planTypeOverrides'])
            this.planTypeOverrides!.push(
              UpsertHypoCustomTaxRatePlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.planTypeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertHypoCustomTaxRateOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCustomTaxRateOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTaxId'] =
        this.customTaxId !== undefined ? this.customTaxId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['residency'] =
        this.residency !== undefined ? this.residency : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['taxRateTypeCode'] =
        this.taxRateTypeCode !== undefined ? this.taxRateTypeCode : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['defaultTaxRate'] =
        this.defaultTaxRate !== undefined ? this.defaultTaxRate : <any>null;
      if (Array.isArray(this.planTypeOverrides)) {
        data['planTypeOverrides'] = [];
        for (let item of this.planTypeOverrides)
          data['planTypeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRateOverrideDto {
    customTaxId: string;
    countryCode: string;
    taxType: HypoCustomTaxType;
    residency: CountryTaxRateResidency;
    bandingType: TaxRateBandingType;
    taxRateTypeCode: string;
    lowerThreshold: number;
    upperThreshold: number | null;
    defaultTaxRate: number;
    planTypeOverrides: UpsertHypoCustomTaxRatePlanTypeOverrideDto[];
  }

  export class UpsertHypoCustomTaxRatePlanTypeOverrideDto
    implements IUpsertHypoCustomTaxRatePlanTypeOverrideDto
  {
    planType!: PlanType;
    override!: number;

    constructor(data?: IUpsertHypoCustomTaxRatePlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): UpsertHypoCustomTaxRatePlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCustomTaxRatePlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface IUpsertHypoCustomTaxRatePlanTypeOverrideDto {
    planType: PlanType;
    override: number;
  }

  export abstract class GetSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetSpecificCountryRegionTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetSpecificCountryRegionTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetSpecificCountryRegionTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetSpecificCountryRegionTaxRatesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSpecificCountryRegionTaxRatesPageDataQueryResult {}

  export class GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
    extends GetSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
  {
    result!: SpecificCountryRegionTaxRatesPageData;

    constructor(
      data?: IGetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new SpecificCountryRegionTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? SpecificCountryRegionTaxRatesPageData.fromJS(_data['result'])
          : new SpecificCountryRegionTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
    extends IGetSpecificCountryRegionTaxRatesPageDataQueryResult {
    result: SpecificCountryRegionTaxRatesPageData;
  }

  export class SpecificCountryRegionTaxRatesPageData
    implements ISpecificCountryRegionTaxRatesPageData
  {
    incomeTaxRatePolicy!: SpecificCountryRegionIncomeTaxRatePolicyDto;
    socialTaxRatePolicy!: SpecificCountryRegionSocialTaxRatePolicyDto;
    configuredPlanTypes!: PlanTypeDto[];
    plansByPlanType!: { [key: string]: PlanDto[] };
    taxRateTables!: TaxRateTable[];
    overriddenTaxTypePlanType!: OverriddenTaxTypePlanType2[];

    constructor(data?: ISpecificCountryRegionTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.incomeTaxRatePolicy =
          new SpecificCountryRegionIncomeTaxRatePolicyDto();
        this.socialTaxRatePolicy =
          new SpecificCountryRegionSocialTaxRatePolicyDto();
        this.configuredPlanTypes = [];
        this.plansByPlanType = {};
        this.taxRateTables = [];
        this.overriddenTaxTypePlanType = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.incomeTaxRatePolicy = _data['incomeTaxRatePolicy']
          ? SpecificCountryRegionIncomeTaxRatePolicyDto.fromJS(
              _data['incomeTaxRatePolicy'],
            )
          : new SpecificCountryRegionIncomeTaxRatePolicyDto();
        this.socialTaxRatePolicy = _data['socialTaxRatePolicy']
          ? SpecificCountryRegionSocialTaxRatePolicyDto.fromJS(
              _data['socialTaxRatePolicy'],
            )
          : new SpecificCountryRegionSocialTaxRatePolicyDto();
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (_data['plansByPlanType']) {
          this.plansByPlanType = {} as any;
          for (let key in _data['plansByPlanType']) {
            if (_data['plansByPlanType'].hasOwnProperty(key))
              (<any>this.plansByPlanType)![key] = _data['plansByPlanType'][key]
                ? _data['plansByPlanType'][key].map((i: any) =>
                    PlanDto.fromJS(i),
                  )
                : [];
          }
        } else {
          this.plansByPlanType = <any>null;
        }
        if (Array.isArray(_data['taxRateTables'])) {
          this.taxRateTables = [] as any;
          for (let item of _data['taxRateTables'])
            this.taxRateTables!.push(TaxRateTable.fromJS(item));
        } else {
          this.taxRateTables = <any>null;
        }
        if (Array.isArray(_data['overriddenTaxTypePlanType'])) {
          this.overriddenTaxTypePlanType = [] as any;
          for (let item of _data['overriddenTaxTypePlanType'])
            this.overriddenTaxTypePlanType!.push(
              OverriddenTaxTypePlanType2.fromJS(item),
            );
        } else {
          this.overriddenTaxTypePlanType = <any>null;
        }
      }
    }

    static fromJS(data: any): SpecificCountryRegionTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new SpecificCountryRegionTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['incomeTaxRatePolicy'] = this.incomeTaxRatePolicy
        ? this.incomeTaxRatePolicy.toJSON()
        : <any>null;
      data['socialTaxRatePolicy'] = this.socialTaxRatePolicy
        ? this.socialTaxRatePolicy.toJSON()
        : <any>null;
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (this.plansByPlanType) {
        data['plansByPlanType'] = {};
        for (let key in this.plansByPlanType) {
          if (this.plansByPlanType.hasOwnProperty(key))
            (<any>data['plansByPlanType'])[key] =
              this.plansByPlanType[key] !== undefined
                ? this.plansByPlanType[key]
                : <any>null;
        }
      }
      if (Array.isArray(this.taxRateTables)) {
        data['taxRateTables'] = [];
        for (let item of this.taxRateTables)
          data['taxRateTables'].push(item.toJSON());
      }
      if (Array.isArray(this.overriddenTaxTypePlanType)) {
        data['overriddenTaxTypePlanType'] = [];
        for (let item of this.overriddenTaxTypePlanType)
          data['overriddenTaxTypePlanType'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISpecificCountryRegionTaxRatesPageData {
    incomeTaxRatePolicy: SpecificCountryRegionIncomeTaxRatePolicyDto;
    socialTaxRatePolicy: SpecificCountryRegionSocialTaxRatePolicyDto;
    configuredPlanTypes: PlanTypeDto[];
    plansByPlanType: { [key: string]: PlanDto[] };
    taxRateTables: TaxRateTable[];
    overriddenTaxTypePlanType: OverriddenTaxTypePlanType2[];
  }

  export class SpecificCountryRegionIncomeTaxRatePolicyDto
    implements ISpecificCountryRegionIncomeTaxRatePolicyDto
  {
    residentPolicy!: string | null;
    nonResidentPolicy!: string | null;

    constructor(data?: ISpecificCountryRegionIncomeTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.residentPolicy =
          _data['residentPolicy'] !== undefined
            ? _data['residentPolicy']
            : <any>null;
        this.nonResidentPolicy =
          _data['nonResidentPolicy'] !== undefined
            ? _data['nonResidentPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): SpecificCountryRegionIncomeTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new SpecificCountryRegionIncomeTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['residentPolicy'] =
        this.residentPolicy !== undefined ? this.residentPolicy : <any>null;
      data['nonResidentPolicy'] =
        this.nonResidentPolicy !== undefined
          ? this.nonResidentPolicy
          : <any>null;
      return data;
    }
  }

  export interface ISpecificCountryRegionIncomeTaxRatePolicyDto {
    residentPolicy: string | null;
    nonResidentPolicy: string | null;
  }

  export class SpecificCountryRegionSocialTaxRatePolicyDto
    implements ISpecificCountryRegionSocialTaxRatePolicyDto
  {
    policy!: string | null;

    constructor(data?: ISpecificCountryRegionSocialTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.policy =
          _data['policy'] !== undefined ? _data['policy'] : <any>null;
      }
    }

    static fromJS(data: any): SpecificCountryRegionSocialTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new SpecificCountryRegionSocialTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policy'] = this.policy !== undefined ? this.policy : <any>null;
      return data;
    }
  }

  export interface ISpecificCountryRegionSocialTaxRatePolicyDto {
    policy: string | null;
  }

  export class PlanDto implements IPlanDto {
    id!: string;
    code!: string;
    name!: string;

    constructor(data?: IPlanDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): PlanDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IPlanDto {
    id: string;
    code: string;
    name: string;
  }

  export class TaxRateTable implements ITaxRateTable {
    taxType!: TaxTypeDto;
    rowGroups!: TaxRateTableRowGroup[];

    constructor(data?: ITaxRateTable) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxType = new TaxTypeDto();
        this.rowGroups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType = _data['taxType']
          ? TaxTypeDto.fromJS(_data['taxType'])
          : new TaxTypeDto();
        if (Array.isArray(_data['rowGroups'])) {
          this.rowGroups = [] as any;
          for (let item of _data['rowGroups'])
            this.rowGroups!.push(TaxRateTableRowGroup.fromJS(item));
        } else {
          this.rowGroups = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateTable {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateTable();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType ? this.taxType.toJSON() : <any>null;
      if (Array.isArray(this.rowGroups)) {
        data['rowGroups'] = [];
        for (let item of this.rowGroups) data['rowGroups'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxRateTable {
    taxType: TaxTypeDto;
    rowGroups: TaxRateTableRowGroup[];
  }

  export class TaxTypeDto implements ITaxTypeDto {
    value!: TaxType;
    display!: string;

    constructor(data?: ITaxTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): TaxTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ITaxTypeDto {
    value: TaxType;
    display: string;
  }

  export class TaxRateTableRowGroup implements ITaxRateTableRowGroup {
    taxRateType!: TaxRateTypeDto;
    bandingType!: TaxRateBandingTypeDto;
    residency!: CountryTaxRateResidencyDto;
    bands!: TaxRateBandDto[];

    constructor(data?: ITaxRateTableRowGroup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxRateType = new TaxRateTypeDto();
        this.bandingType = new TaxRateBandingTypeDto();
        this.residency = new CountryTaxRateResidencyDto();
        this.bands = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxRateType = _data['taxRateType']
          ? TaxRateTypeDto.fromJS(_data['taxRateType'])
          : new TaxRateTypeDto();
        this.bandingType = _data['bandingType']
          ? TaxRateBandingTypeDto.fromJS(_data['bandingType'])
          : new TaxRateBandingTypeDto();
        this.residency = _data['residency']
          ? CountryTaxRateResidencyDto.fromJS(_data['residency'])
          : new CountryTaxRateResidencyDto();
        if (Array.isArray(_data['bands'])) {
          this.bands = [] as any;
          for (let item of _data['bands'])
            this.bands!.push(TaxRateBandDto.fromJS(item));
        } else {
          this.bands = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxRateTableRowGroup {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateTableRowGroup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxRateType'] = this.taxRateType
        ? this.taxRateType.toJSON()
        : <any>null;
      data['bandingType'] = this.bandingType
        ? this.bandingType.toJSON()
        : <any>null;
      data['residency'] = this.residency ? this.residency.toJSON() : <any>null;
      if (Array.isArray(this.bands)) {
        data['bands'] = [];
        for (let item of this.bands) data['bands'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxRateTableRowGroup {
    taxRateType: TaxRateTypeDto;
    bandingType: TaxRateBandingTypeDto;
    residency: CountryTaxRateResidencyDto;
    bands: TaxRateBandDto[];
  }

  export class TaxRateBandingTypeDto implements ITaxRateBandingTypeDto {
    value!: TaxRateBandingType;
    display!: string;

    constructor(data?: ITaxRateBandingTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): TaxRateBandingTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateBandingTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ITaxRateBandingTypeDto {
    value: TaxRateBandingType;
    display: string;
  }

  export class TaxRateBandDto implements ITaxRateBandDto {
    lowerThreshold!: number;
    upperThreshold!: number | null;
    defaultTaxRate!: number | null;
    taxRateFormula!: string | null;
    taxRateOverrides!: TaxRateOverridesDto;

    constructor(data?: ITaxRateBandDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxRateOverrides = new TaxRateOverridesDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.defaultTaxRate =
          _data['defaultTaxRate'] !== undefined
            ? _data['defaultTaxRate']
            : <any>null;
        this.taxRateFormula =
          _data['taxRateFormula'] !== undefined
            ? _data['taxRateFormula']
            : <any>null;
        this.taxRateOverrides = _data['taxRateOverrides']
          ? TaxRateOverridesDto.fromJS(_data['taxRateOverrides'])
          : new TaxRateOverridesDto();
      }
    }

    static fromJS(data: any): TaxRateBandDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRateBandDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['defaultTaxRate'] =
        this.defaultTaxRate !== undefined ? this.defaultTaxRate : <any>null;
      data['taxRateFormula'] =
        this.taxRateFormula !== undefined ? this.taxRateFormula : <any>null;
      data['taxRateOverrides'] = this.taxRateOverrides
        ? this.taxRateOverrides.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxRateBandDto {
    lowerThreshold: number;
    upperThreshold: number | null;
    defaultTaxRate: number | null;
    taxRateFormula: string | null;
    taxRateOverrides: TaxRateOverridesDto;
  }

  export class OverriddenTaxTypePlanType2
    implements IOverriddenTaxTypePlanType2
  {
    taxTypeDisplay!: string;
    taxTypeValue!: TaxType;
    planType!: PlanType;

    constructor(data?: IOverriddenTaxTypePlanType2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxTypeDisplay =
          _data['taxTypeDisplay'] !== undefined
            ? _data['taxTypeDisplay']
            : <any>null;
        this.taxTypeValue =
          _data['taxTypeValue'] !== undefined
            ? _data['taxTypeValue']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
      }
    }

    static fromJS(data: any): OverriddenTaxTypePlanType2 {
      data = typeof data === 'object' ? data : {};
      let result = new OverriddenTaxTypePlanType2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxTypeDisplay'] =
        this.taxTypeDisplay !== undefined ? this.taxTypeDisplay : <any>null;
      data['taxTypeValue'] =
        this.taxTypeValue !== undefined ? this.taxTypeValue : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      return data;
    }
  }

  export interface IOverriddenTaxTypePlanType2 {
    taxTypeDisplay: string;
    taxTypeValue: TaxType;
    planType: PlanType;
  }

  export class GetSpecificCountryRegionTaxRatesPageDataQueryResultFailure
    extends GetSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetSpecificCountryRegionTaxRatesPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IGetSpecificCountryRegionTaxRatesPageDataQueryResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetSpecificCountryRegionTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetSpecificCountryRegionTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSpecificCountryRegionTaxRatesPageDataQueryResultFailure
    extends IGetSpecificCountryRegionTaxRatesPageDataQueryResult {
    errorMessage: string;
  }

  export abstract class UpsertCountryRegionTaxRateOverridesCommandResult
    implements IUpsertCountryRegionTaxRateOverridesCommandResult
  {
    constructor(data?: IUpsertCountryRegionTaxRateOverridesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertCountryRegionTaxRateOverridesCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertCountryRegionTaxRateOverridesCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCountryRegionTaxRateOverridesCommandResult {}

  export class UpsertCountryRegionTaxRateOverridesCommandResultSuccess
    extends UpsertCountryRegionTaxRateOverridesCommandResult
    implements IUpsertCountryRegionTaxRateOverridesCommandResultSuccess
  {
    constructor(
      data?: IUpsertCountryRegionTaxRateOverridesCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertCountryRegionTaxRateOverridesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertCountryRegionTaxRateOverridesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCountryRegionTaxRateOverridesCommandResultSuccess
    extends IUpsertCountryRegionTaxRateOverridesCommandResult {}

  export class UpsertCountryRegionTaxRateOverridesCommandResultFailure
    extends UpsertCountryRegionTaxRateOverridesCommandResult
    implements IUpsertCountryRegionTaxRateOverridesCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IUpsertCountryRegionTaxRateOverridesCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertCountryRegionTaxRateOverridesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertCountryRegionTaxRateOverridesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCountryRegionTaxRateOverridesCommandResultFailure
    extends IUpsertCountryRegionTaxRateOverridesCommandResult {
    errorMessage: string;
  }

  export class UpsertCountryRegionTaxRateOverridesCommand
    implements IUpsertCountryRegionTaxRateOverridesCommand
  {
    clientId!: string;
    countryCode!: string;
    regionCode!: string | null;
    overrides!: UpsertCountryTaxRateOverrideDto[];

    constructor(data?: IUpsertCountryRegionTaxRateOverridesCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(UpsertCountryTaxRateOverrideDto.fromJS(item));
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCountryRegionTaxRateOverridesCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryRegionTaxRateOverridesCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCountryRegionTaxRateOverridesCommand {
    clientId: string;
    countryCode: string;
    regionCode: string | null;
    overrides: UpsertCountryTaxRateOverrideDto[];
  }

  export class UpsertCountryTaxRateOverrideDto
    implements IUpsertCountryTaxRateOverrideDto
  {
    taxType!: TaxType;
    residency!: CountryTaxRateResidency;
    bandingType!: TaxRateBandingType;
    taxRateTypeCode!: string;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    planTypeOverrides!: UpsertCountryTaxRatePlanTypeOverrideDto[];

    constructor(data?: IUpsertCountryTaxRateOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.residency =
          _data['residency'] !== undefined ? _data['residency'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.taxRateTypeCode =
          _data['taxRateTypeCode'] !== undefined
            ? _data['taxRateTypeCode']
            : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        if (Array.isArray(_data['planTypeOverrides'])) {
          this.planTypeOverrides = [] as any;
          for (let item of _data['planTypeOverrides'])
            this.planTypeOverrides!.push(
              UpsertCountryTaxRatePlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.planTypeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCountryTaxRateOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxRateOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['residency'] =
        this.residency !== undefined ? this.residency : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['taxRateTypeCode'] =
        this.taxRateTypeCode !== undefined ? this.taxRateTypeCode : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      if (Array.isArray(this.planTypeOverrides)) {
        data['planTypeOverrides'] = [];
        for (let item of this.planTypeOverrides)
          data['planTypeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCountryTaxRateOverrideDto {
    taxType: TaxType;
    residency: CountryTaxRateResidency;
    bandingType: TaxRateBandingType;
    taxRateTypeCode: string;
    lowerThreshold: number;
    upperThreshold: number | null;
    planTypeOverrides: UpsertCountryTaxRatePlanTypeOverrideDto[];
  }

  export class UpsertCountryTaxRatePlanTypeOverrideDto
    implements IUpsertCountryTaxRatePlanTypeOverrideDto
  {
    planType!: PlanType;
    override!: number;

    constructor(data?: IUpsertCountryTaxRatePlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): UpsertCountryTaxRatePlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCountryTaxRatePlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface IUpsertCountryTaxRatePlanTypeOverrideDto {
    planType: PlanType;
    override: number;
  }

  export abstract class GetHypoSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResult
  {
    constructor(
      data?: IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetHypoSpecificCountryRegionTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetHypoSpecificCountryRegionTaxRatesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResult {}

  export class GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
    extends GetHypoSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
  {
    result!: HypoSpecificCountryRegionTaxRatesPageData;

    constructor(
      data?: IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new HypoSpecificCountryRegionTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? HypoSpecificCountryRegionTaxRatesPageData.fromJS(_data['result'])
          : new HypoSpecificCountryRegionTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultSuccess
    extends IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResult {
    result: HypoSpecificCountryRegionTaxRatesPageData;
  }

  export class HypoSpecificCountryRegionTaxRatesPageData
    implements IHypoSpecificCountryRegionTaxRatesPageData
  {
    incomeTaxRatePolicy!: SpecificHypoCountryRegionIncomeTaxRatePolicyDto;
    socialTaxRatePolicy!: SpecificHypoCountryRegionSocialTaxRatePolicyDto;
    configuredPlanTypes!: PlanTypeDto[];
    plansByPlanType!: { [key: string]: PlanDto[] };
    taxRateTables!: TaxRateTable[];
    overriddenTaxTypePlanType!: OverriddenTaxTypePlanType2[];

    constructor(data?: IHypoSpecificCountryRegionTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.incomeTaxRatePolicy =
          new SpecificHypoCountryRegionIncomeTaxRatePolicyDto();
        this.socialTaxRatePolicy =
          new SpecificHypoCountryRegionSocialTaxRatePolicyDto();
        this.configuredPlanTypes = [];
        this.plansByPlanType = {};
        this.taxRateTables = [];
        this.overriddenTaxTypePlanType = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.incomeTaxRatePolicy = _data['incomeTaxRatePolicy']
          ? SpecificHypoCountryRegionIncomeTaxRatePolicyDto.fromJS(
              _data['incomeTaxRatePolicy'],
            )
          : new SpecificHypoCountryRegionIncomeTaxRatePolicyDto();
        this.socialTaxRatePolicy = _data['socialTaxRatePolicy']
          ? SpecificHypoCountryRegionSocialTaxRatePolicyDto.fromJS(
              _data['socialTaxRatePolicy'],
            )
          : new SpecificHypoCountryRegionSocialTaxRatePolicyDto();
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (_data['plansByPlanType']) {
          this.plansByPlanType = {} as any;
          for (let key in _data['plansByPlanType']) {
            if (_data['plansByPlanType'].hasOwnProperty(key))
              (<any>this.plansByPlanType)![key] = _data['plansByPlanType'][key]
                ? _data['plansByPlanType'][key].map((i: any) =>
                    PlanDto.fromJS(i),
                  )
                : [];
          }
        } else {
          this.plansByPlanType = <any>null;
        }
        if (Array.isArray(_data['taxRateTables'])) {
          this.taxRateTables = [] as any;
          for (let item of _data['taxRateTables'])
            this.taxRateTables!.push(TaxRateTable.fromJS(item));
        } else {
          this.taxRateTables = <any>null;
        }
        if (Array.isArray(_data['overriddenTaxTypePlanType'])) {
          this.overriddenTaxTypePlanType = [] as any;
          for (let item of _data['overriddenTaxTypePlanType'])
            this.overriddenTaxTypePlanType!.push(
              OverriddenTaxTypePlanType2.fromJS(item),
            );
        } else {
          this.overriddenTaxTypePlanType = <any>null;
        }
      }
    }

    static fromJS(data: any): HypoSpecificCountryRegionTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new HypoSpecificCountryRegionTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['incomeTaxRatePolicy'] = this.incomeTaxRatePolicy
        ? this.incomeTaxRatePolicy.toJSON()
        : <any>null;
      data['socialTaxRatePolicy'] = this.socialTaxRatePolicy
        ? this.socialTaxRatePolicy.toJSON()
        : <any>null;
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (this.plansByPlanType) {
        data['plansByPlanType'] = {};
        for (let key in this.plansByPlanType) {
          if (this.plansByPlanType.hasOwnProperty(key))
            (<any>data['plansByPlanType'])[key] =
              this.plansByPlanType[key] !== undefined
                ? this.plansByPlanType[key]
                : <any>null;
        }
      }
      if (Array.isArray(this.taxRateTables)) {
        data['taxRateTables'] = [];
        for (let item of this.taxRateTables)
          data['taxRateTables'].push(item.toJSON());
      }
      if (Array.isArray(this.overriddenTaxTypePlanType)) {
        data['overriddenTaxTypePlanType'] = [];
        for (let item of this.overriddenTaxTypePlanType)
          data['overriddenTaxTypePlanType'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IHypoSpecificCountryRegionTaxRatesPageData {
    incomeTaxRatePolicy: SpecificHypoCountryRegionIncomeTaxRatePolicyDto;
    socialTaxRatePolicy: SpecificHypoCountryRegionSocialTaxRatePolicyDto;
    configuredPlanTypes: PlanTypeDto[];
    plansByPlanType: { [key: string]: PlanDto[] };
    taxRateTables: TaxRateTable[];
    overriddenTaxTypePlanType: OverriddenTaxTypePlanType2[];
  }

  export class SpecificHypoCountryRegionIncomeTaxRatePolicyDto
    implements ISpecificHypoCountryRegionIncomeTaxRatePolicyDto
  {
    residentPolicy!: string | null;
    nonResidentPolicy!: string | null;

    constructor(data?: ISpecificHypoCountryRegionIncomeTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.residentPolicy =
          _data['residentPolicy'] !== undefined
            ? _data['residentPolicy']
            : <any>null;
        this.nonResidentPolicy =
          _data['nonResidentPolicy'] !== undefined
            ? _data['nonResidentPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): SpecificHypoCountryRegionIncomeTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new SpecificHypoCountryRegionIncomeTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['residentPolicy'] =
        this.residentPolicy !== undefined ? this.residentPolicy : <any>null;
      data['nonResidentPolicy'] =
        this.nonResidentPolicy !== undefined
          ? this.nonResidentPolicy
          : <any>null;
      return data;
    }
  }

  export interface ISpecificHypoCountryRegionIncomeTaxRatePolicyDto {
    residentPolicy: string | null;
    nonResidentPolicy: string | null;
  }

  export class SpecificHypoCountryRegionSocialTaxRatePolicyDto
    implements ISpecificHypoCountryRegionSocialTaxRatePolicyDto
  {
    policy!: string | null;

    constructor(data?: ISpecificHypoCountryRegionSocialTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.policy =
          _data['policy'] !== undefined ? _data['policy'] : <any>null;
      }
    }

    static fromJS(data: any): SpecificHypoCountryRegionSocialTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new SpecificHypoCountryRegionSocialTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policy'] = this.policy !== undefined ? this.policy : <any>null;
      return data;
    }
  }

  export interface ISpecificHypoCountryRegionSocialTaxRatePolicyDto {
    policy: string | null;
  }

  export class GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure
    extends GetHypoSpecificCountryRegionTaxRatesPageDataQueryResult
    implements IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResultFailure
    extends IGetHypoSpecificCountryRegionTaxRatesPageDataQueryResult {
    errorMessage: string;
  }

  export abstract class UpsertHypoCountryRegionTaxRateOverridesCommandResult
    implements IUpsertHypoCountryRegionTaxRateOverridesCommandResult
  {
    constructor(data?: IUpsertHypoCountryRegionTaxRateOverridesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertHypoCountryRegionTaxRateOverridesCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertHypoCountryRegionTaxRateOverridesCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertHypoCountryRegionTaxRateOverridesCommandResult {}

  export class UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess
    extends UpsertHypoCountryRegionTaxRateOverridesCommandResult
    implements IUpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess
  {
    constructor(
      data?: IUpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertHypoCountryRegionTaxRateOverridesCommandResultSuccess
    extends IUpsertHypoCountryRegionTaxRateOverridesCommandResult {}

  export class UpsertHypoCountryRegionTaxRateOverridesCommandResultFailure
    extends UpsertHypoCountryRegionTaxRateOverridesCommandResult
    implements IUpsertHypoCountryRegionTaxRateOverridesCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IUpsertHypoCountryRegionTaxRateOverridesCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertHypoCountryRegionTaxRateOverridesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertHypoCountryRegionTaxRateOverridesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertHypoCountryRegionTaxRateOverridesCommandResultFailure
    extends IUpsertHypoCountryRegionTaxRateOverridesCommandResult {
    errorMessage: string;
  }

  export class UpsertHypoCountryRegionTaxRateOverridesCommand
    implements IUpsertHypoCountryRegionTaxRateOverridesCommand
  {
    clientId!: string;
    countryCode!: string;
    hypoRegionTaxRatePage!: boolean;
    regionCode!: string | null;
    overrides!: UpsertHypoCountryTaxRateOverrideDto[];

    constructor(data?: IUpsertHypoCountryRegionTaxRateOverridesCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.overrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.hypoRegionTaxRatePage =
          _data['hypoRegionTaxRatePage'] !== undefined
            ? _data['hypoRegionTaxRatePage']
            : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        if (Array.isArray(_data['overrides'])) {
          this.overrides = [] as any;
          for (let item of _data['overrides'])
            this.overrides!.push(
              UpsertHypoCountryTaxRateOverrideDto.fromJS(item),
            );
        } else {
          this.overrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertHypoCountryRegionTaxRateOverridesCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCountryRegionTaxRateOverridesCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['hypoRegionTaxRatePage'] =
        this.hypoRegionTaxRatePage !== undefined
          ? this.hypoRegionTaxRatePage
          : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      if (Array.isArray(this.overrides)) {
        data['overrides'] = [];
        for (let item of this.overrides) data['overrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertHypoCountryRegionTaxRateOverridesCommand {
    clientId: string;
    countryCode: string;
    hypoRegionTaxRatePage: boolean;
    regionCode: string | null;
    overrides: UpsertHypoCountryTaxRateOverrideDto[];
  }

  export class UpsertHypoCountryTaxRateOverrideDto
    implements IUpsertHypoCountryTaxRateOverrideDto
  {
    taxType!: TaxType;
    residency!: CountryTaxRateResidency;
    bandingType!: TaxRateBandingType;
    taxRateTypeCode!: string;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    planTypeOverrides!: UpsertHypoCountryTaxRatePlanTypeOverrideDto[];

    constructor(data?: IUpsertHypoCountryTaxRateOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.residency =
          _data['residency'] !== undefined ? _data['residency'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.taxRateTypeCode =
          _data['taxRateTypeCode'] !== undefined
            ? _data['taxRateTypeCode']
            : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        if (Array.isArray(_data['planTypeOverrides'])) {
          this.planTypeOverrides = [] as any;
          for (let item of _data['planTypeOverrides'])
            this.planTypeOverrides!.push(
              UpsertHypoCountryTaxRatePlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.planTypeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertHypoCountryTaxRateOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCountryTaxRateOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['residency'] =
        this.residency !== undefined ? this.residency : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['taxRateTypeCode'] =
        this.taxRateTypeCode !== undefined ? this.taxRateTypeCode : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      if (Array.isArray(this.planTypeOverrides)) {
        data['planTypeOverrides'] = [];
        for (let item of this.planTypeOverrides)
          data['planTypeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertHypoCountryTaxRateOverrideDto {
    taxType: TaxType;
    residency: CountryTaxRateResidency;
    bandingType: TaxRateBandingType;
    taxRateTypeCode: string;
    lowerThreshold: number;
    upperThreshold: number | null;
    planTypeOverrides: UpsertHypoCountryTaxRatePlanTypeOverrideDto[];
  }

  export class UpsertHypoCountryTaxRatePlanTypeOverrideDto
    implements IUpsertHypoCountryTaxRatePlanTypeOverrideDto
  {
    planType!: PlanType;
    override!: number;

    constructor(data?: IUpsertHypoCountryTaxRatePlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
      }
    }

    static fromJS(data: any): UpsertHypoCountryTaxRatePlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertHypoCountryTaxRatePlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      return data;
    }
  }

  export interface IUpsertHypoCountryTaxRatePlanTypeOverrideDto {
    planType: PlanType;
    override: number;
  }

  export abstract class GetHypoRegionTaxRatesPageDataQueryResult
    implements IGetHypoRegionTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetHypoRegionTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetHypoRegionTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetHypoRegionTaxRatesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetHypoRegionTaxRatesPageDataQueryResult {}

  export class GetHypoRegionTaxRatesPageDataQueryResultSuccess
    extends GetHypoRegionTaxRatesPageDataQueryResult
    implements IGetHypoRegionTaxRatesPageDataQueryResultSuccess
  {
    lineItems!: HypoRegionTaxRatesLineItem[];

    constructor(data?: IGetHypoRegionTaxRatesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.lineItems = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(HypoRegionTaxRatesLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoRegionTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoRegionTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoRegionTaxRatesPageDataQueryResultSuccess
    extends IGetHypoRegionTaxRatesPageDataQueryResult {
    lineItems: HypoRegionTaxRatesLineItem[];
  }

  export class HypoRegionTaxRatesLineItem
    implements IHypoRegionTaxRatesLineItem
  {
    countryCode!: string;
    regionsCount!: number;
    isDeloitteRateUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: IHypoRegionTaxRatesLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionsCount =
          _data['regionsCount'] !== undefined
            ? _data['regionsCount']
            : <any>null;
        this.isDeloitteRateUpdated =
          _data['isDeloitteRateUpdated'] !== undefined
            ? _data['isDeloitteRateUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): HypoRegionTaxRatesLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new HypoRegionTaxRatesLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionsCount'] =
        this.regionsCount !== undefined ? this.regionsCount : <any>null;
      data['isDeloitteRateUpdated'] =
        this.isDeloitteRateUpdated !== undefined
          ? this.isDeloitteRateUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IHypoRegionTaxRatesLineItem {
    countryCode: string;
    regionsCount: number;
    isDeloitteRateUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class GetHypoRegionTaxRatesPageDataQueryResultFailure
    extends GetHypoRegionTaxRatesPageDataQueryResult
    implements IGetHypoRegionTaxRatesPageDataQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetHypoRegionTaxRatesPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoRegionTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoRegionTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoRegionTaxRatesPageDataQueryResultFailure
    extends IGetHypoRegionTaxRatesPageDataQueryResult {
    errorMessage: string;
  }

  export abstract class SaveHypoRegionTaxRatesWorkflowStepCommandResult
    implements ISaveHypoRegionTaxRatesWorkflowStepCommandResult
  {
    constructor(data?: ISaveHypoRegionTaxRatesWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveHypoRegionTaxRatesWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveHypoRegionTaxRatesWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveHypoRegionTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess
    extends SaveHypoRegionTaxRatesWorkflowStepCommandResult
    implements ISaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoRegionTaxRatesWorkflowStepCommandResultSuccess
    extends ISaveHypoRegionTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoRegionTaxRatesWorkflowStepCommandResultFailure
    extends SaveHypoRegionTaxRatesWorkflowStepCommandResult
    implements ISaveHypoRegionTaxRatesWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveHypoRegionTaxRatesWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveHypoRegionTaxRatesWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoRegionTaxRatesWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoRegionTaxRatesWorkflowStepCommandResultFailure
    extends ISaveHypoRegionTaxRatesWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveHypoRegionTaxRatesWorkflowStepCommand
    implements ISaveHypoRegionTaxRatesWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveHypoRegionTaxRatesWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveHypoRegionTaxRatesWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoRegionTaxRatesWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveHypoRegionTaxRatesWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadHypoRegionTaxRatePageDataCommandResult
    implements IDownloadHypoRegionTaxRatePageDataCommandResult
  {
    constructor(data?: IDownloadHypoRegionTaxRatePageDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadHypoRegionTaxRatePageDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadHypoRegionTaxRatePageDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadHypoRegionTaxRatePageDataCommandResult {}

  export class DownloadHypoRegionTaxRatePageDataCommandResultSuccess
    extends DownloadHypoRegionTaxRatePageDataCommandResult
    implements IDownloadHypoRegionTaxRatePageDataCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadHypoRegionTaxRatePageDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoRegionTaxRatePageDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoRegionTaxRatePageDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoRegionTaxRatePageDataCommandResultSuccess
    extends IDownloadHypoRegionTaxRatePageDataCommandResult {
    result: string;
  }

  export class DownloadHypoRegionTaxRatePageDataCommandResultFailure
    extends DownloadHypoRegionTaxRatePageDataCommandResult
    implements IDownloadHypoRegionTaxRatePageDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadHypoRegionTaxRatePageDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoRegionTaxRatePageDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoRegionTaxRatePageDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoRegionTaxRatePageDataCommandResultFailure
    extends IDownloadHypoRegionTaxRatePageDataCommandResult {
    errorMessage: string;
  }

  export class DownloadHypoRegionTaxRatePageDataCommand
    implements IDownloadHypoRegionTaxRatePageDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadHypoRegionTaxRatePageDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadHypoRegionTaxRatePageDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoRegionTaxRatePageDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadHypoRegionTaxRatePageDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export class GetHypoCustomTaxesQueryResult
    implements IGetHypoCustomTaxesQueryResult
  {
    constructor(data?: IGetHypoCustomTaxesQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetHypoCustomTaxesQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetHypoCustomTaxesQueryResult {}

  export class GetHypoCustomTaxesQueryResultSuccess
    extends GetHypoCustomTaxesQueryResult
    implements IGetHypoCustomTaxesQueryResultSuccess
  {
    result!: HypoCustomTaxRatesPageData;

    constructor(data?: IGetHypoCustomTaxesQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new HypoCustomTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? HypoCustomTaxRatesPageData.fromJS(_data['result'])
          : new HypoCustomTaxRatesPageData();
      }
    }

    static override fromJS(data: any): GetHypoCustomTaxesQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCustomTaxesQueryResultSuccess
    extends IGetHypoCustomTaxesQueryResult {
    result: HypoCustomTaxRatesPageData;
  }

  export class HypoCustomTaxRatesPageData
    implements IHypoCustomTaxRatesPageData
  {
    hypoCustomTaxRateLineItems!: HypoCustomTaxRateLineItemDto[];

    constructor(data?: IHypoCustomTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.hypoCustomTaxRateLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['hypoCustomTaxRateLineItems'])) {
          this.hypoCustomTaxRateLineItems = [] as any;
          for (let item of _data['hypoCustomTaxRateLineItems'])
            this.hypoCustomTaxRateLineItems!.push(
              HypoCustomTaxRateLineItemDto.fromJS(item),
            );
        } else {
          this.hypoCustomTaxRateLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): HypoCustomTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCustomTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.hypoCustomTaxRateLineItems)) {
        data['hypoCustomTaxRateLineItems'] = [];
        for (let item of this.hypoCustomTaxRateLineItems)
          data['hypoCustomTaxRateLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IHypoCustomTaxRatesPageData {
    hypoCustomTaxRateLineItems: HypoCustomTaxRateLineItemDto[];
  }

  export class HypoCustomTaxRateLineItemDto
    implements IHypoCustomTaxRateLineItemDto
  {
    countryCode!: string;
    countryName!: string;
    isDeloitteRateUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: IHypoCustomTaxRateLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
        this.isDeloitteRateUpdated =
          _data['isDeloitteRateUpdated'] !== undefined
            ? _data['isDeloitteRateUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): HypoCustomTaxRateLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCustomTaxRateLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      data['isDeloitteRateUpdated'] =
        this.isDeloitteRateUpdated !== undefined
          ? this.isDeloitteRateUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IHypoCustomTaxRateLineItemDto {
    countryCode: string;
    countryName: string;
    isDeloitteRateUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class GetHypoCustomTaxesQueryResultFailure
    extends GetHypoCustomTaxesQueryResult
    implements IGetHypoCustomTaxesQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetHypoCustomTaxesQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetHypoCustomTaxesQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCustomTaxesQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCustomTaxesQueryResultFailure
    extends IGetHypoCustomTaxesQueryResult {
    errors: ResultError[];
  }

  export abstract class SaveHypoCustomTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCustomTaxRatesWorkflowStepCommandResult
  {
    constructor(data?: ISaveHypoCustomTaxRatesWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveHypoCustomTaxRatesWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveHypoCustomTaxRatesWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveHypoCustomTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess
    extends SaveHypoCustomTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoCustomTaxRatesWorkflowStepCommandResultSuccess
    extends ISaveHypoCustomTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoCustomTaxRatesWorkflowStepCommandResultFailure
    extends SaveHypoCustomTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCustomTaxRatesWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveHypoCustomTaxRatesWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveHypoCustomTaxRatesWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoCustomTaxRatesWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoCustomTaxRatesWorkflowStepCommandResultFailure
    extends ISaveHypoCustomTaxRatesWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveHypoCustomTaxRatesWorkflowStepCommand
    implements ISaveHypoCustomTaxRatesWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveHypoCustomTaxRatesWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveHypoCustomTaxRatesWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoCustomTaxRatesWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveHypoCustomTaxRatesWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadHypoCustomTaxRatesDataCommandResult
    implements IDownloadHypoCustomTaxRatesDataCommandResult
  {
    constructor(data?: IDownloadHypoCustomTaxRatesDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadHypoCustomTaxRatesDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadHypoCustomTaxRatesDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadHypoCustomTaxRatesDataCommandResult {}

  export class DownloadHypoCustomTaxRatesDataCommandResultSuccess
    extends DownloadHypoCustomTaxRatesDataCommandResult
    implements IDownloadHypoCustomTaxRatesDataCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadHypoCustomTaxRatesDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoCustomTaxRatesDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCustomTaxRatesDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoCustomTaxRatesDataCommandResultSuccess
    extends IDownloadHypoCustomTaxRatesDataCommandResult {
    result: string;
  }

  export class DownloadHypoCustomTaxRatesDataCommandResultFailure
    extends DownloadHypoCustomTaxRatesDataCommandResult
    implements IDownloadHypoCustomTaxRatesDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadHypoCustomTaxRatesDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoCustomTaxRatesDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCustomTaxRatesDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoCustomTaxRatesDataCommandResultFailure
    extends IDownloadHypoCustomTaxRatesDataCommandResult {
    errorMessage: string;
  }

  export class DownloadHypoCustomTaxRatesDataCommand
    implements IDownloadHypoCustomTaxRatesDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadHypoCustomTaxRatesDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadHypoCustomTaxRatesDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCustomTaxRatesDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadHypoCustomTaxRatesDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export class GetHypoCountryTaxRatesPageDataQueryResult
    implements IGetHypoCountryTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetHypoCountryTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetHypoCountryTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCountryTaxRatesPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetHypoCountryTaxRatesPageDataQueryResult {}

  export class GetHypoCountryTaxRatesPageDataQueryResultSuccess
    extends GetHypoCountryTaxRatesPageDataQueryResult
    implements IGetHypoCountryTaxRatesPageDataQueryResultSuccess
  {
    result!: HypoCountryTaxRatesPageData;

    constructor(data?: IGetHypoCountryTaxRatesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new HypoCountryTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? HypoCountryTaxRatesPageData.fromJS(_data['result'])
          : new HypoCountryTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoCountryTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCountryTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCountryTaxRatesPageDataQueryResultSuccess
    extends IGetHypoCountryTaxRatesPageDataQueryResult {
    result: HypoCountryTaxRatesPageData;
  }

  export class HypoCountryTaxRatesPageData
    implements IHypoCountryTaxRatesPageData
  {
    hypoCountryTaxRateLineItems!: HypoCountryTaxRateLineItemDto[];

    constructor(data?: IHypoCountryTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.hypoCountryTaxRateLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['hypoCountryTaxRateLineItems'])) {
          this.hypoCountryTaxRateLineItems = [] as any;
          for (let item of _data['hypoCountryTaxRateLineItems'])
            this.hypoCountryTaxRateLineItems!.push(
              HypoCountryTaxRateLineItemDto.fromJS(item),
            );
        } else {
          this.hypoCountryTaxRateLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): HypoCountryTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCountryTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.hypoCountryTaxRateLineItems)) {
        data['hypoCountryTaxRateLineItems'] = [];
        for (let item of this.hypoCountryTaxRateLineItems)
          data['hypoCountryTaxRateLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IHypoCountryTaxRatesPageData {
    hypoCountryTaxRateLineItems: HypoCountryTaxRateLineItemDto[];
  }

  export class HypoCountryTaxRateLineItemDto
    implements IHypoCountryTaxRateLineItemDto
  {
    country!: HypoCountryTaxRateCountryDto;
    isDeloitteRateUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: IHypoCountryTaxRateLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new HypoCountryTaxRateCountryDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? HypoCountryTaxRateCountryDto.fromJS(_data['country'])
          : new HypoCountryTaxRateCountryDto();
        this.isDeloitteRateUpdated =
          _data['isDeloitteRateUpdated'] !== undefined
            ? _data['isDeloitteRateUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): HypoCountryTaxRateLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCountryTaxRateLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['isDeloitteRateUpdated'] =
        this.isDeloitteRateUpdated !== undefined
          ? this.isDeloitteRateUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IHypoCountryTaxRateLineItemDto {
    country: HypoCountryTaxRateCountryDto;
    isDeloitteRateUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class HypoCountryTaxRateCountryDto
    implements IHypoCountryTaxRateCountryDto
  {
    isoCode!: string;
    display!: string;

    constructor(data?: IHypoCountryTaxRateCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): HypoCountryTaxRateCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypoCountryTaxRateCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IHypoCountryTaxRateCountryDto {
    isoCode: string;
    display: string;
  }

  export class GetHypoCountryTaxRatesPageDataQueryResultFailure
    extends GetHypoCountryTaxRatesPageDataQueryResult
    implements IGetHypoCountryTaxRatesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetHypoCountryTaxRatesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetHypoCountryTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetHypoCountryTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetHypoCountryTaxRatesPageDataQueryResultFailure
    extends IGetHypoCountryTaxRatesPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class SaveHypoCountryTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCountryTaxRatesWorkflowStepCommandResult
  {
    constructor(data?: ISaveHypoCountryTaxRatesWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveHypoCountryTaxRatesWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveHypoCountryTaxRatesWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveHypoCountryTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess
    extends SaveHypoCountryTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess
  {
    constructor(
      data?: ISaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoCountryTaxRatesWorkflowStepCommandResultSuccess
    extends ISaveHypoCountryTaxRatesWorkflowStepCommandResult {}

  export class SaveHypoCountryTaxRatesWorkflowStepCommandResultFailure
    extends SaveHypoCountryTaxRatesWorkflowStepCommandResult
    implements ISaveHypoCountryTaxRatesWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISaveHypoCountryTaxRatesWorkflowStepCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveHypoCountryTaxRatesWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SaveHypoCountryTaxRatesWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveHypoCountryTaxRatesWorkflowStepCommandResultFailure
    extends ISaveHypoCountryTaxRatesWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveHypoCountryTaxRatesWorkflowStepCommand
    implements ISaveHypoCountryTaxRatesWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveHypoCountryTaxRatesWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveHypoCountryTaxRatesWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveHypoCountryTaxRatesWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveHypoCountryTaxRatesWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadHypoCountryTaxRatesDataCommandResult
    implements IDownloadHypoCountryTaxRatesDataCommandResult
  {
    constructor(data?: IDownloadHypoCountryTaxRatesDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadHypoCountryTaxRatesDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadHypoCountryTaxRatesDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadHypoCountryTaxRatesDataCommandResult {}

  export class DownloadHypoCountryTaxRatesDataCommandResultSuccess
    extends DownloadHypoCountryTaxRatesDataCommandResult
    implements IDownloadHypoCountryTaxRatesDataCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadHypoCountryTaxRatesDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoCountryTaxRatesDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCountryTaxRatesDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoCountryTaxRatesDataCommandResultSuccess
    extends IDownloadHypoCountryTaxRatesDataCommandResult {
    result: string;
  }

  export class DownloadHypoCountryTaxRatesDataCommandResultFailure
    extends DownloadHypoCountryTaxRatesDataCommandResult
    implements IDownloadHypoCountryTaxRatesDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadHypoCountryTaxRatesDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadHypoCountryTaxRatesDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCountryTaxRatesDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadHypoCountryTaxRatesDataCommandResultFailure
    extends IDownloadHypoCountryTaxRatesDataCommandResult {
    errorMessage: string;
  }

  export class DownloadHypoCountryTaxRatesDataCommand
    implements IDownloadHypoCountryTaxRatesDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadHypoCountryTaxRatesDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadHypoCountryTaxRatesDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadHypoCountryTaxRatesDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadHypoCountryTaxRatesDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export class GetExchangeTaxRatesPageDataQueryResult
    implements IGetExchangeTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetExchangeTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetExchangeTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeTaxRatesPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetExchangeTaxRatesPageDataQueryResult {}

  export class GetExchangeTaxRatesPageDataQueryResultSuccess
    extends GetExchangeTaxRatesPageDataQueryResult
    implements IGetExchangeTaxRatesPageDataQueryResultSuccess
  {
    pageData!: ExchangeTaxRatesPageData;

    constructor(data?: IGetExchangeTaxRatesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.pageData = new ExchangeTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.pageData = _data['pageData']
          ? ExchangeTaxRatesPageData.fromJS(_data['pageData'])
          : new ExchangeTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetExchangeTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pageData'] = this.pageData ? this.pageData.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeTaxRatesPageDataQueryResultSuccess
    extends IGetExchangeTaxRatesPageDataQueryResult {
    pageData: ExchangeTaxRatesPageData;
  }

  export class ExchangeTaxRatesPageData implements IExchangeTaxRatesPageData {
    exchangeTaxRatePolicySettingsDto!: ExchangeTaxRatePolicySettingsDto | null;

    constructor(data?: IExchangeTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.exchangeTaxRatePolicySettingsDto = _data[
          'exchangeTaxRatePolicySettingsDto'
        ]
          ? ExchangeTaxRatePolicySettingsDto.fromJS(
              _data['exchangeTaxRatePolicySettingsDto'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): ExchangeTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ExchangeTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['exchangeTaxRatePolicySettingsDto'] = this
        .exchangeTaxRatePolicySettingsDto
        ? this.exchangeTaxRatePolicySettingsDto.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IExchangeTaxRatesPageData {
    exchangeTaxRatePolicySettingsDto: ExchangeTaxRatePolicySettingsDto | null;
  }

  export class ExchangeTaxRatePolicySettingsDto
    implements IExchangeTaxRatePolicySettingsDto
  {
    id!: string;
    exchangeTaxRatePolicySetting!: ExchangeTaxRateOption;

    constructor(data?: IExchangeTaxRatePolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.exchangeTaxRatePolicySetting =
          _data['exchangeTaxRatePolicySetting'] !== undefined
            ? _data['exchangeTaxRatePolicySetting']
            : <any>null;
      }
    }

    static fromJS(data: any): ExchangeTaxRatePolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExchangeTaxRatePolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['exchangeTaxRatePolicySetting'] =
        this.exchangeTaxRatePolicySetting !== undefined
          ? this.exchangeTaxRatePolicySetting
          : <any>null;
      return data;
    }
  }

  export interface IExchangeTaxRatePolicySettingsDto {
    id: string;
    exchangeTaxRatePolicySetting: ExchangeTaxRateOption;
  }

  export enum ExchangeTaxRateOption {
    UseOandaRates = 'UseOandaRates',
    CompanyProvidePartial = 'CompanyProvidePartial',
    CompanyProvideFull = 'CompanyProvideFull',
  }

  export class GetExchangeTaxRatesPageDataQueryResultFailure
    extends GetExchangeTaxRatesPageDataQueryResult
    implements IGetExchangeTaxRatesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetExchangeTaxRatesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetExchangeTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeTaxRatesPageDataQueryResultFailure
    extends IGetExchangeTaxRatesPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertExchangeTaxRatesPolicySettingsCommandResult
    implements IUpsertExchangeTaxRatesPolicySettingsCommandResult
  {
    constructor(data?: IUpsertExchangeTaxRatesPolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertExchangeTaxRatesPolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertExchangeTaxRatesPolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertExchangeTaxRatesPolicySettingsCommandResult {}

  export class UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess
    extends UpsertExchangeTaxRatesPolicySettingsCommandResult
    implements IUpsertExchangeTaxRatesPolicySettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertExchangeTaxRatesPolicySettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertExchangeTaxRatesPolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertExchangeTaxRatesPolicySettingsCommandResultSuccess
    extends IUpsertExchangeTaxRatesPolicySettingsCommandResult {}

  export class UpsertExchangeTaxRatesPolicySettingsCommandResultFailure
    extends UpsertExchangeTaxRatesPolicySettingsCommandResult
    implements IUpsertExchangeTaxRatesPolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IUpsertExchangeTaxRatesPolicySettingsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertExchangeTaxRatesPolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertExchangeTaxRatesPolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertExchangeTaxRatesPolicySettingsCommandResultFailure
    extends IUpsertExchangeTaxRatesPolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertExchangeTaxRatesPolicySettingsCommand
    implements IUpsertExchangeTaxRatesPolicySettingsCommand
  {
    clientId!: string;
    id!: string | null;
    exchangeTaxRateOption!: ExchangeTaxRateOption;

    constructor(data?: IUpsertExchangeTaxRatesPolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.exchangeTaxRateOption =
          _data['exchangeTaxRateOption'] !== undefined
            ? _data['exchangeTaxRateOption']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertExchangeTaxRatesPolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertExchangeTaxRatesPolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['exchangeTaxRateOption'] =
        this.exchangeTaxRateOption !== undefined
          ? this.exchangeTaxRateOption
          : <any>null;
      return data;
    }
  }

  export interface IUpsertExchangeTaxRatesPolicySettingsCommand {
    clientId: string;
    id: string | null;
    exchangeTaxRateOption: ExchangeTaxRateOption;
  }

  export class GetCountryTaxRatesPageDataQueryResult
    implements IGetCountryTaxRatesPageDataQueryResult
  {
    constructor(data?: IGetCountryTaxRatesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryTaxRatesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxRatesPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryTaxRatesPageDataQueryResult {}

  export class GetCountryTaxRatesPageDataQueryResultSuccess
    extends GetCountryTaxRatesPageDataQueryResult
    implements IGetCountryTaxRatesPageDataQueryResultSuccess
  {
    result!: CountryTaxRatesPageData;

    constructor(data?: IGetCountryTaxRatesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CountryTaxRatesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CountryTaxRatesPageData.fromJS(_data['result'])
          : new CountryTaxRatesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxRatesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxRatesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxRatesPageDataQueryResultSuccess
    extends IGetCountryTaxRatesPageDataQueryResult {
    result: CountryTaxRatesPageData;
  }

  export class CountryTaxRatesPageData implements ICountryTaxRatesPageData {
    countryTaxRateLineItems!: CountryTaxRateLineItemDto[];

    constructor(data?: ICountryTaxRatesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryTaxRateLineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countryTaxRateLineItems'])) {
          this.countryTaxRateLineItems = [] as any;
          for (let item of _data['countryTaxRateLineItems'])
            this.countryTaxRateLineItems!.push(
              CountryTaxRateLineItemDto.fromJS(item),
            );
        } else {
          this.countryTaxRateLineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryTaxRatesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxRatesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countryTaxRateLineItems)) {
        data['countryTaxRateLineItems'] = [];
        for (let item of this.countryTaxRateLineItems)
          data['countryTaxRateLineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryTaxRatesPageData {
    countryTaxRateLineItems: CountryTaxRateLineItemDto[];
  }

  export class CountryTaxRateLineItemDto implements ICountryTaxRateLineItemDto {
    country!: CountryTaxRateCountryDto;
    isDeloitteRateUpdated!: boolean;
    updatedBy!: string | null;
    updatedOn!: Date | null;

    constructor(data?: ICountryTaxRateLineItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new CountryTaxRateCountryDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country = _data['country']
          ? CountryTaxRateCountryDto.fromJS(_data['country'])
          : new CountryTaxRateCountryDto();
        this.isDeloitteRateUpdated =
          _data['isDeloitteRateUpdated'] !== undefined
            ? _data['isDeloitteRateUpdated']
            : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
        this.updatedOn = _data['updatedOn']
          ? new Date(_data['updatedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxRateLineItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxRateLineItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['isDeloitteRateUpdated'] =
        this.isDeloitteRateUpdated !== undefined
          ? this.isDeloitteRateUpdated
          : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      data['updatedOn'] = this.updatedOn
        ? this.updatedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICountryTaxRateLineItemDto {
    country: CountryTaxRateCountryDto;
    isDeloitteRateUpdated: boolean;
    updatedBy: string | null;
    updatedOn: Date | null;
  }

  export class CountryTaxRateCountryDto implements ICountryTaxRateCountryDto {
    isoCode!: string;
    display!: string;

    constructor(data?: ICountryTaxRateCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): CountryTaxRateCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTaxRateCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface ICountryTaxRateCountryDto {
    isoCode: string;
    display: string;
  }

  export class GetCountryTaxRatesPageDataQueryResultFailure
    extends GetCountryTaxRatesPageDataQueryResult
    implements IGetCountryTaxRatesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCountryTaxRatesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryTaxRatesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryTaxRatesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryTaxRatesPageDataQueryResultFailure
    extends IGetCountryTaxRatesPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class SaveCountryTaxRatesWorkflowStepCommandResult
    implements ISaveCountryTaxRatesWorkflowStepCommandResult
  {
    constructor(data?: ISaveCountryTaxRatesWorkflowStepCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveCountryTaxRatesWorkflowStepCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveCountryTaxRatesWorkflowStepCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCountryTaxRatesWorkflowStepCommandResult {}

  export class SaveCountryTaxRatesWorkflowStepCommandResultSuccess
    extends SaveCountryTaxRatesWorkflowStepCommandResult
    implements ISaveCountryTaxRatesWorkflowStepCommandResultSuccess
  {
    constructor(data?: ISaveCountryTaxRatesWorkflowStepCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveCountryTaxRatesWorkflowStepCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryTaxRatesWorkflowStepCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryTaxRatesWorkflowStepCommandResultSuccess
    extends ISaveCountryTaxRatesWorkflowStepCommandResult {}

  export class SaveCountryTaxRatesWorkflowStepCommandResultFailure
    extends SaveCountryTaxRatesWorkflowStepCommandResult
    implements ISaveCountryTaxRatesWorkflowStepCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISaveCountryTaxRatesWorkflowStepCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveCountryTaxRatesWorkflowStepCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryTaxRatesWorkflowStepCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryTaxRatesWorkflowStepCommandResultFailure
    extends ISaveCountryTaxRatesWorkflowStepCommandResult {
    errorMessage: string;
  }

  export class SaveCountryTaxRatesWorkflowStepCommand
    implements ISaveCountryTaxRatesWorkflowStepCommand
  {
    clientId!: string;

    constructor(data?: ISaveCountryTaxRatesWorkflowStepCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveCountryTaxRatesWorkflowStepCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryTaxRatesWorkflowStepCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveCountryTaxRatesWorkflowStepCommand {
    clientId: string;
  }

  export abstract class DownloadCountryTaxRatePageDataCommandResult
    implements IDownloadCountryTaxRatePageDataCommandResult
  {
    constructor(data?: IDownloadCountryTaxRatePageDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadCountryTaxRatePageDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadCountryTaxRatePageDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadCountryTaxRatePageDataCommandResult {}

  export class DownloadCountryTaxRatePageDataCommandResultSuccess
    extends DownloadCountryTaxRatePageDataCommandResult
    implements IDownloadCountryTaxRatePageDataCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadCountryTaxRatePageDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryTaxRatePageDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxRatePageDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryTaxRatePageDataCommandResultSuccess
    extends IDownloadCountryTaxRatePageDataCommandResult {
    result: string;
  }

  export class DownloadCountryTaxRatePageDataCommandResultFailure
    extends DownloadCountryTaxRatePageDataCommandResult
    implements IDownloadCountryTaxRatePageDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadCountryTaxRatePageDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCountryTaxRatePageDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxRatePageDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCountryTaxRatePageDataCommandResultFailure
    extends IDownloadCountryTaxRatePageDataCommandResult {
    errorMessage: string;
  }

  export class DownloadCountryTaxRatePageDataCommand
    implements IDownloadCountryTaxRatePageDataCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IDownloadCountryTaxRatePageDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): DownloadCountryTaxRatePageDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCountryTaxRatePageDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IDownloadCountryTaxRatePageDataCommand {
    clientId: string;
    countryCodes: string[];
  }

  export abstract class GetTaxRateOverridesIndexPageDataQueryResult
    implements IGetTaxRateOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetTaxRateOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxRateOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetTaxRateOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRateOverridesIndexPageDataQueryResult {}

  export class GetTaxRateOverridesIndexPageDataQueryResultSuccess
    extends GetTaxRateOverridesIndexPageDataQueryResult
    implements IGetTaxRateOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetTaxRateOverridesIndexPageData;

    constructor(data?: IGetTaxRateOverridesIndexPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new GetTaxRateOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetTaxRateOverridesIndexPageData.fromJS(_data['result'])
          : new GetTaxRateOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateOverridesIndexPageDataQueryResultSuccess
    extends IGetTaxRateOverridesIndexPageDataQueryResult {
    result: GetTaxRateOverridesIndexPageData;
  }

  export class GetTaxRateOverridesIndexPageData
    implements IGetTaxRateOverridesIndexPageData
  {
    countriesInFootprint!: string[];
    configuredPlanTypes!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    taxRatePolicyOptions!: TaxRatePolicyDto[];
    residencyStatuses!: ResidencyStatusDto[];
    cashBonusLineItems!: CashBonusTaxRateOverrideLineItem[];
    restrictedStockUnitLineItems!: RestrictedStockUnitTaxRateOverrideLineItem[];
    stockOptionLineItems!: StockOptionTaxRateOverrideLineItem[];
    taxRatePolicyOverrideSettings!: TaxRatePolicyOverrideSettings[];

    constructor(data?: IGetTaxRateOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.configuredPlanTypes = [];
        this.taxOverridePlans = [];
        this.taxRatePolicyOptions = [];
        this.residencyStatuses = [];
        this.cashBonusLineItems = [];
        this.restrictedStockUnitLineItems = [];
        this.stockOptionLineItems = [];
        this.taxRatePolicyOverrideSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(item);
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['taxRatePolicyOptions'])) {
          this.taxRatePolicyOptions = [] as any;
          for (let item of _data['taxRatePolicyOptions'])
            this.taxRatePolicyOptions!.push(TaxRatePolicyDto.fromJS(item));
        } else {
          this.taxRatePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(ResidencyStatusDto.fromJS(item));
        } else {
          this.residencyStatuses = <any>null;
        }
        if (Array.isArray(_data['cashBonusLineItems'])) {
          this.cashBonusLineItems = [] as any;
          for (let item of _data['cashBonusLineItems'])
            this.cashBonusLineItems!.push(
              CashBonusTaxRateOverrideLineItem.fromJS(item),
            );
        } else {
          this.cashBonusLineItems = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitLineItems'])) {
          this.restrictedStockUnitLineItems = [] as any;
          for (let item of _data['restrictedStockUnitLineItems'])
            this.restrictedStockUnitLineItems!.push(
              RestrictedStockUnitTaxRateOverrideLineItem.fromJS(item),
            );
        } else {
          this.restrictedStockUnitLineItems = <any>null;
        }
        if (Array.isArray(_data['stockOptionLineItems'])) {
          this.stockOptionLineItems = [] as any;
          for (let item of _data['stockOptionLineItems'])
            this.stockOptionLineItems!.push(
              StockOptionTaxRateOverrideLineItem.fromJS(item),
            );
        } else {
          this.stockOptionLineItems = <any>null;
        }
        if (Array.isArray(_data['taxRatePolicyOverrideSettings'])) {
          this.taxRatePolicyOverrideSettings = [] as any;
          for (let item of _data['taxRatePolicyOverrideSettings'])
            this.taxRatePolicyOverrideSettings!.push(
              TaxRatePolicyOverrideSettings.fromJS(item),
            );
        } else {
          this.taxRatePolicyOverrideSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): GetTaxRateOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item);
      }
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRatePolicyOptions)) {
        data['taxRatePolicyOptions'] = [];
        for (let item of this.taxRatePolicyOptions)
          data['taxRatePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusLineItems)) {
        data['cashBonusLineItems'] = [];
        for (let item of this.cashBonusLineItems)
          data['cashBonusLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitLineItems)) {
        data['restrictedStockUnitLineItems'] = [];
        for (let item of this.restrictedStockUnitLineItems)
          data['restrictedStockUnitLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionLineItems)) {
        data['stockOptionLineItems'] = [];
        for (let item of this.stockOptionLineItems)
          data['stockOptionLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRatePolicyOverrideSettings)) {
        data['taxRatePolicyOverrideSettings'] = [];
        for (let item of this.taxRatePolicyOverrideSettings)
          data['taxRatePolicyOverrideSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetTaxRateOverridesIndexPageData {
    countriesInFootprint: string[];
    configuredPlanTypes: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    taxRatePolicyOptions: TaxRatePolicyDto[];
    residencyStatuses: ResidencyStatusDto[];
    cashBonusLineItems: CashBonusTaxRateOverrideLineItem[];
    restrictedStockUnitLineItems: RestrictedStockUnitTaxRateOverrideLineItem[];
    stockOptionLineItems: StockOptionTaxRateOverrideLineItem[];
    taxRatePolicyOverrideSettings: TaxRatePolicyOverrideSettings[];
  }

  export class TaxOverridePlanDto implements ITaxOverridePlanDto {
    type!: PlanType;
    id!: string;
    name!: string;
    code!: string;

    constructor(data?: ITaxOverridePlanDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): TaxOverridePlanDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxOverridePlanDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ITaxOverridePlanDto {
    type: PlanType;
    id: string;
    name: string;
    code: string;
  }

  export class CashBonusTaxRateOverrideLineItem
    implements ICashBonusTaxRateOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;
    planCodeOverrides!: PlanCodeOverrideSubLineItem[];

    constructor(data?: ICashBonusTaxRateOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyStatuses = [];
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): CashBonusTaxRateOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusTaxRateOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashBonusTaxRateOverrideLineItem {
    id: string;
    employeeId: string;
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
    planCodeOverrides: PlanCodeOverrideSubLineItem[];
  }

  export class PlanCodeOverrideSubLineItem
    implements IPlanCodeOverrideSubLineItem
  {
    planCode!: string;
    overrideDisplay!: string;

    constructor(data?: IPlanCodeOverrideSubLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
      }
    }

    static fromJS(data: any): PlanCodeOverrideSubLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new PlanCodeOverrideSubLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      return data;
    }
  }

  export interface IPlanCodeOverrideSubLineItem {
    planCode: string;
    overrideDisplay: string;
  }

  export class RestrictedStockUnitTaxRateOverrideLineItem
    implements IRestrictedStockUnitTaxRateOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;
    planCodeOverrides!: PlanCodeOverrideSubLineItem[];

    constructor(data?: IRestrictedStockUnitTaxRateOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyStatuses = [];
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): RestrictedStockUnitTaxRateOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitTaxRateOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRestrictedStockUnitTaxRateOverrideLineItem {
    id: string;
    employeeId: string;
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
    planCodeOverrides: PlanCodeOverrideSubLineItem[];
  }

  export class StockOptionTaxRateOverrideLineItem
    implements IStockOptionTaxRateOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;
    planCodeOverrides!: PlanCodeOverrideSubLineItem[];

    constructor(data?: IStockOptionTaxRateOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyStatuses = [];
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): StockOptionTaxRateOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionTaxRateOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IStockOptionTaxRateOverrideLineItem {
    id: string;
    employeeId: string;
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
    planCodeOverrides: PlanCodeOverrideSubLineItem[];
  }

  export abstract class TrackedAggregateRoot implements ITrackedAggregateRoot {
    constructor(data?: ITrackedAggregateRoot) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): TrackedAggregateRoot {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'TrackedAggregateRoot' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ITrackedAggregateRoot {}

  export class TaxRatePolicyOverrideSettings
    extends TrackedAggregateRoot
    implements ITaxRatePolicyOverrideSettings
  {
    id!: string;
    clientId!: string;
    employeeId!: string;
    planTypes!: PlanType[];
    selectedPlanIds!: string[];
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;
    entityKey!: string;

    constructor(data?: ITaxRatePolicyOverrideSettings) {
      super(data);
      if (!data) {
        this.planTypes = [];
        this.selectedPlanIds = [];
        this.residencyStatuses = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
        this.entityKey =
          _data['entityKey'] !== undefined ? _data['entityKey'] : <any>null;
      }
    }

    static override fromJS(data: any): TaxRatePolicyOverrideSettings {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyOverrideSettings();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      data['entityKey'] =
        this.entityKey !== undefined ? this.entityKey : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ITaxRatePolicyOverrideSettings
    extends ITrackedAggregateRoot {
    id: string;
    clientId: string;
    employeeId: string;
    planTypes: PlanType[];
    selectedPlanIds: string[];
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
    entityKey: string;
  }

  export class GetTaxRateOverridesIndexPageDataQueryResultFailure
    extends GetTaxRateOverridesIndexPageDataQueryResult
    implements IGetTaxRateOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxRateOverridesIndexPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRateOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRateOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRateOverridesIndexPageDataQueryResultFailure
    extends IGetTaxRateOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetTaxRatePolicyOverridePageDataQueryResult
    implements IGetTaxRatePolicyOverridePageDataQueryResult
  {
    constructor(data?: IGetTaxRatePolicyOverridePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxRatePolicyOverridePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyOverridePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxRatePolicyOverridePageDataQueryResult {}

  export class GetTaxRatePolicyOverridePageDataQueryResultSuccess
    extends GetTaxRatePolicyOverridePageDataQueryResult
    implements IGetTaxRatePolicyOverridePageDataQueryResultSuccess
  {
    result!: TaxRatePolicyOverridePageData;

    constructor(data?: IGetTaxRatePolicyOverridePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TaxRatePolicyOverridePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxRatePolicyOverridePageData.fromJS(_data['result'])
          : new TaxRatePolicyOverridePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRatePolicyOverridePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyOverridePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRatePolicyOverridePageDataQueryResultSuccess
    extends IGetTaxRatePolicyOverridePageDataQueryResult {
    result: TaxRatePolicyOverridePageData;
  }

  export class TaxRatePolicyOverridePageData
    implements ITaxRatePolicyOverridePageData
  {
    countriesInFootprint!: string[];
    configuredPlanTypes!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    taxRatePolicyOptions!: TaxRatePolicyDto[];
    residencyStatuses!: ResidencyStatusDto[];
    clientTaxRatePolicyOverrideSettingDto!: TaxRatePolicyOverrideSettingsDto | null;

    constructor(data?: ITaxRatePolicyOverridePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.configuredPlanTypes = [];
        this.taxOverridePlans = [];
        this.taxRatePolicyOptions = [];
        this.residencyStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(item);
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['taxRatePolicyOptions'])) {
          this.taxRatePolicyOptions = [] as any;
          for (let item of _data['taxRatePolicyOptions'])
            this.taxRatePolicyOptions!.push(TaxRatePolicyDto.fromJS(item));
        } else {
          this.taxRatePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(ResidencyStatusDto.fromJS(item));
        } else {
          this.residencyStatuses = <any>null;
        }
        this.clientTaxRatePolicyOverrideSettingDto = _data[
          'clientTaxRatePolicyOverrideSettingDto'
        ]
          ? TaxRatePolicyOverrideSettingsDto.fromJS(
              _data['clientTaxRatePolicyOverrideSettingDto'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyOverridePageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyOverridePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item);
      }
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRatePolicyOptions)) {
        data['taxRatePolicyOptions'] = [];
        for (let item of this.taxRatePolicyOptions)
          data['taxRatePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item.toJSON());
      }
      data['clientTaxRatePolicyOverrideSettingDto'] = this
        .clientTaxRatePolicyOverrideSettingDto
        ? this.clientTaxRatePolicyOverrideSettingDto.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyOverridePageData {
    countriesInFootprint: string[];
    configuredPlanTypes: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    taxRatePolicyOptions: TaxRatePolicyDto[];
    residencyStatuses: ResidencyStatusDto[];
    clientTaxRatePolicyOverrideSettingDto: TaxRatePolicyOverrideSettingsDto | null;
  }

  export class TaxRatePolicyOverrideSettingsDto
    implements ITaxRatePolicyOverrideSettingsDto
  {
    id!: string;
    clientId!: string;
    employeeId!: string;
    planTypes!: PlanType[];
    selectedPlanIds!: string[];
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;

    constructor(data?: ITaxRatePolicyOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.selectedPlanIds = [];
        this.residencyStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxRatePolicyOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRatePolicyOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      return data;
    }
  }

  export interface ITaxRatePolicyOverrideSettingsDto {
    id: string;
    clientId: string;
    employeeId: string;
    planTypes: PlanType[];
    selectedPlanIds: string[];
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
  }

  export class GetTaxRatePolicyOverridePageDataQueryResultFailure
    extends GetTaxRatePolicyOverridePageDataQueryResult
    implements IGetTaxRatePolicyOverridePageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxRatePolicyOverridePageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxRatePolicyOverridePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxRatePolicyOverridePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxRatePolicyOverridePageDataQueryResultFailure
    extends IGetTaxRatePolicyOverridePageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertTaxRatePolicyOverrideSettingsCommandResult
    implements IUpsertTaxRatePolicyOverrideSettingsCommandResult
  {
    constructor(data?: IUpsertTaxRatePolicyOverrideSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTaxRatePolicyOverrideSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertTaxRatePolicyOverrideSettingsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTaxRatePolicyOverrideSettingsCommandResult {}

  export class UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess
    extends UpsertTaxRatePolicyOverrideSettingsCommandResult
    implements IUpsertTaxRatePolicyOverrideSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertTaxRatePolicyOverrideSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertTaxRatePolicyOverrideSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRatePolicyOverrideSettingsCommandResultSuccess
    extends IUpsertTaxRatePolicyOverrideSettingsCommandResult {}

  export class UpsertTaxRatePolicyOverrideSettingsCommandResultFailure
    extends UpsertTaxRatePolicyOverrideSettingsCommandResult
    implements IUpsertTaxRatePolicyOverrideSettingsCommandResultFailure
  {
    errors!: string;

    constructor(
      data?: IUpsertTaxRatePolicyOverrideSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTaxRatePolicyOverrideSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertTaxRatePolicyOverrideSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxRatePolicyOverrideSettingsCommandResultFailure
    extends IUpsertTaxRatePolicyOverrideSettingsCommandResult {
    errors: string;
  }

  export class UpsertTaxRatePolicyOverrideSettingsCommand
    implements IUpsertTaxRatePolicyOverrideSettingsCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    planTypes!: PlanType[];
    selectedPlanCodes!: string[];
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];
    taxRatePolicy!: TaxRatePolicy;

    constructor(data?: IUpsertTaxRatePolicyOverrideSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.planTypes = [];
        this.selectedPlanCodes = [];
        this.residencyStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
        this.taxRatePolicy =
          _data['taxRatePolicy'] !== undefined
            ? _data['taxRatePolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertTaxRatePolicyOverrideSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxRatePolicyOverrideSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      data['taxRatePolicy'] =
        this.taxRatePolicy !== undefined ? this.taxRatePolicy : <any>null;
      return data;
    }
  }

  export interface IUpsertTaxRatePolicyOverrideSettingsCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    planTypes: PlanType[];
    selectedPlanCodes: string[];
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
    taxRatePolicy: TaxRatePolicy;
  }

  export class DeleteTaxRatePolicyOverrideCommandResult
    implements IDeleteTaxRatePolicyOverrideCommandResult
  {
    constructor(data?: IDeleteTaxRatePolicyOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteTaxRatePolicyOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRatePolicyOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteTaxRatePolicyOverrideCommandResult {}

  export class DeleteTaxRatePolicyOverrideCommandResultSuccess
    extends DeleteTaxRatePolicyOverrideCommandResult
    implements IDeleteTaxRatePolicyOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteTaxRatePolicyOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteTaxRatePolicyOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRatePolicyOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTaxRatePolicyOverrideCommandResultSuccess
    extends IDeleteTaxRatePolicyOverrideCommandResult {}

  export class DeleteTaxRatePolicyOverrideCommandResultFailure
    extends DeleteTaxRatePolicyOverrideCommandResult
    implements IDeleteTaxRatePolicyOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteTaxRatePolicyOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteTaxRatePolicyOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRatePolicyOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteTaxRatePolicyOverrideCommandResultFailure
    extends IDeleteTaxRatePolicyOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteTaxRatePolicyOverrideCommand
    implements IDeleteTaxRatePolicyOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteTaxRatePolicyOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteTaxRatePolicyOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteTaxRatePolicyOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteTaxRatePolicyOverrideCommand {
    clientId: string;
    id: string;
  }

  export class DownloadMultipleOverrideWithoutTransactionIdCommand
    implements IDownloadMultipleOverrideWithoutTransactionIdCommand
  {
    constructor(data?: IDownloadMultipleOverrideWithoutTransactionIdCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DownloadMultipleOverrideWithoutTransactionIdCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadMultipleOverrideWithoutTransactionIdCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadMultipleOverrideWithoutTransactionIdCommand {}

  export class UploadTaxPolicyMultipleOverrideFileCommandResult
    implements IUploadTaxPolicyMultipleOverrideFileCommandResult
  {
    constructor(data?: IUploadTaxPolicyMultipleOverrideFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadTaxPolicyMultipleOverrideFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadTaxPolicyMultipleOverrideFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadTaxPolicyMultipleOverrideFileCommandResult {}

  export class UploadTaxPolicyMultipleOverrideFileCommandResultSuccess
    extends UploadTaxPolicyMultipleOverrideFileCommandResult
    implements IUploadTaxPolicyMultipleOverrideFileCommandResultSuccess
  {
    result!: TaxPolicyMultipleOverrideResultDto[];

    constructor(
      data?: IUploadTaxPolicyMultipleOverrideFileCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(TaxPolicyMultipleOverrideResultDto.fromJS(item));
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UploadTaxPolicyMultipleOverrideFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UploadTaxPolicyMultipleOverrideFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadTaxPolicyMultipleOverrideFileCommandResultSuccess
    extends IUploadTaxPolicyMultipleOverrideFileCommandResult {
    result: TaxPolicyMultipleOverrideResultDto[];
  }

  export class TaxPolicyMultipleOverrideResultDto
    implements ITaxPolicyMultipleOverrideResultDto
  {
    employeeId!: string;
    transactionId!: string | null;
    isRecordDuplicate!: boolean;

    constructor(data?: ITaxPolicyMultipleOverrideResultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.isRecordDuplicate =
          _data['isRecordDuplicate'] !== undefined
            ? _data['isRecordDuplicate']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxPolicyMultipleOverrideResultDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPolicyMultipleOverrideResultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['isRecordDuplicate'] =
        this.isRecordDuplicate !== undefined
          ? this.isRecordDuplicate
          : <any>null;
      return data;
    }
  }

  export interface ITaxPolicyMultipleOverrideResultDto {
    employeeId: string;
    transactionId: string | null;
    isRecordDuplicate: boolean;
  }

  export class UploadTaxPolicyMultipleOverrideFileCommandResultFailure
    extends UploadTaxPolicyMultipleOverrideFileCommandResult
    implements IUploadTaxPolicyMultipleOverrideFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IUploadTaxPolicyMultipleOverrideFileCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UploadTaxPolicyMultipleOverrideFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UploadTaxPolicyMultipleOverrideFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadTaxPolicyMultipleOverrideFileCommandResultFailure
    extends IUploadTaxPolicyMultipleOverrideFileCommandResult {
    errorMessage: string;
  }

  export enum OverrideSubType {
    NA = 'NA',
    TaxRate = 'TaxRate',
    Recharge = 'Recharge',
    CashPayment = 'CashPayment',
    SocialTax = 'SocialTax',
    DoubleTaxRelief = 'DoubleTaxRelief',
    RechargeAmount = 'RechargeAmount',
    CashPaymentAmount = 'CashPaymentAmount',
    ClientProvidedRates = 'ClientProvidedRates',
  }

  export abstract class CheckTaxRateOverrideDuplicateDataCommandResult
    implements ICheckTaxRateOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckTaxRateOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckTaxRateOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckTaxRateOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckTaxRateOverrideDuplicateDataCommandResult {}

  export class CheckTaxRateOverrideDuplicateDataCommandResultSuccess
    extends CheckTaxRateOverrideDuplicateDataCommandResult
    implements ICheckTaxRateOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(data?: ICheckTaxRateOverrideDuplicateDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTaxRateOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTaxRateOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTaxRateOverrideDuplicateDataCommandResultSuccess
    extends ICheckTaxRateOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckTaxRateOverrideDuplicateDataCommandResultFailure
    extends CheckTaxRateOverrideDuplicateDataCommandResult
    implements ICheckTaxRateOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ICheckTaxRateOverrideDuplicateDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckTaxRateOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTaxRateOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckTaxRateOverrideDuplicateDataCommandResultFailure
    extends ICheckTaxRateOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckTaxRateOverrideDuplicateDataCommand
    implements ICheckTaxRateOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes!: string[];
    country!: string;
    region!: string | null;
    residencyStatuses!: ResidencyStatus[];

    constructor(data?: ICheckTaxRateOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedPlanCodes = [];
        this.residencyStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        if (Array.isArray(_data['residencyStatuses'])) {
          this.residencyStatuses = [] as any;
          for (let item of _data['residencyStatuses'])
            this.residencyStatuses!.push(item);
        } else {
          this.residencyStatuses = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckTaxRateOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckTaxRateOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      if (Array.isArray(this.residencyStatuses)) {
        data['residencyStatuses'] = [];
        for (let item of this.residencyStatuses)
          data['residencyStatuses'].push(item);
      }
      return data;
    }
  }

  export interface ICheckTaxRateOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes: string[];
    country: string;
    region: string | null;
    residencyStatuses: ResidencyStatus[];
  }

  export class GetSocialTaxPolicyOverridePageDataQueryResult
    implements IGetSocialTaxPolicyOverridePageDataQueryResult
  {
    constructor(data?: IGetSocialTaxPolicyOverridePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetSocialTaxPolicyOverridePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyOverridePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSocialTaxPolicyOverridePageDataQueryResult {}

  export class GetSocialTaxPolicyOverridePageDataQueryResultSuccess
    extends GetSocialTaxPolicyOverridePageDataQueryResult
    implements IGetSocialTaxPolicyOverridePageDataQueryResultSuccess
  {
    result!: SocialTaxPolicyOverridePageData;

    constructor(data?: IGetSocialTaxPolicyOverridePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new SocialTaxPolicyOverridePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? SocialTaxPolicyOverridePageData.fromJS(_data['result'])
          : new SocialTaxPolicyOverridePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxPolicyOverridePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyOverridePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxPolicyOverridePageDataQueryResultSuccess
    extends IGetSocialTaxPolicyOverridePageDataQueryResult {
    result: SocialTaxPolicyOverridePageData;
  }

  export class SocialTaxPolicyOverridePageData
    implements ISocialTaxPolicyOverridePageData
  {
    clientSocialTaxPolicyOptions!: ClientSocialTaxPolicyDto[];
    trailingSocialTaxPolicyOptions!: TrailingSocialTaxPolicyDto[];
    socialTaxLocationOptions!: SocialTaxLocationOptionDto[];
    countriesInFootprint!: string[];
    clientSocialTaxPolicyOverrideSetting!: SocialTaxPolicyOverrideSettingsDto | null;

    constructor(data?: ISocialTaxPolicyOverridePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientSocialTaxPolicyOptions = [];
        this.trailingSocialTaxPolicyOptions = [];
        this.socialTaxLocationOptions = [];
        this.countriesInFootprint = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['clientSocialTaxPolicyOptions'])) {
          this.clientSocialTaxPolicyOptions = [] as any;
          for (let item of _data['clientSocialTaxPolicyOptions'])
            this.clientSocialTaxPolicyOptions!.push(
              ClientSocialTaxPolicyDto.fromJS(item),
            );
        } else {
          this.clientSocialTaxPolicyOptions = <any>null;
        }
        if (Array.isArray(_data['trailingSocialTaxPolicyOptions'])) {
          this.trailingSocialTaxPolicyOptions = [] as any;
          for (let item of _data['trailingSocialTaxPolicyOptions'])
            this.trailingSocialTaxPolicyOptions!.push(
              TrailingSocialTaxPolicyDto.fromJS(item),
            );
        } else {
          this.trailingSocialTaxPolicyOptions = <any>null;
        }
        if (Array.isArray(_data['socialTaxLocationOptions'])) {
          this.socialTaxLocationOptions = [] as any;
          for (let item of _data['socialTaxLocationOptions'])
            this.socialTaxLocationOptions!.push(
              SocialTaxLocationOptionDto.fromJS(item),
            );
        } else {
          this.socialTaxLocationOptions = <any>null;
        }
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(item);
        } else {
          this.countriesInFootprint = <any>null;
        }
        this.clientSocialTaxPolicyOverrideSetting = _data[
          'clientSocialTaxPolicyOverrideSetting'
        ]
          ? SocialTaxPolicyOverrideSettingsDto.fromJS(
              _data['clientSocialTaxPolicyOverrideSetting'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxPolicyOverridePageData {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicyOverridePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.clientSocialTaxPolicyOptions)) {
        data['clientSocialTaxPolicyOptions'] = [];
        for (let item of this.clientSocialTaxPolicyOptions)
          data['clientSocialTaxPolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.trailingSocialTaxPolicyOptions)) {
        data['trailingSocialTaxPolicyOptions'] = [];
        for (let item of this.trailingSocialTaxPolicyOptions)
          data['trailingSocialTaxPolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.socialTaxLocationOptions)) {
        data['socialTaxLocationOptions'] = [];
        for (let item of this.socialTaxLocationOptions)
          data['socialTaxLocationOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item);
      }
      data['clientSocialTaxPolicyOverrideSetting'] = this
        .clientSocialTaxPolicyOverrideSetting
        ? this.clientSocialTaxPolicyOverrideSetting.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicyOverridePageData {
    clientSocialTaxPolicyOptions: ClientSocialTaxPolicyDto[];
    trailingSocialTaxPolicyOptions: TrailingSocialTaxPolicyDto[];
    socialTaxLocationOptions: SocialTaxLocationOptionDto[];
    countriesInFootprint: string[];
    clientSocialTaxPolicyOverrideSetting: SocialTaxPolicyOverrideSettingsDto | null;
  }

  export class ClientSocialTaxPolicyDto implements IClientSocialTaxPolicyDto {
    optionValue!: ClientSocialTaxPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IClientSocialTaxPolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientSocialTaxPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientSocialTaxPolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IClientSocialTaxPolicyDto {
    optionValue: ClientSocialTaxPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum ClientSocialTaxPolicy {
    ConsiderSocialTaxBasedOnCurrentLocationOnly = 'ConsiderSocialTaxBasedOnCurrentLocationOnly',
    ConsiderTrailingSocialTax = 'ConsiderTrailingSocialTax',
  }

  export class TrailingSocialTaxPolicyDto
    implements ITrailingSocialTaxPolicyDto
  {
    optionValue!: TrailingSocialTaxPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITrailingSocialTaxPolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TrailingSocialTaxPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new TrailingSocialTaxPolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITrailingSocialTaxPolicyDto {
    optionValue: TrailingSocialTaxPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum TrailingSocialTaxPolicy {
    AllLocationsWhereRequiredByCountryLegislationOnly = 'AllLocationsWhereRequiredByCountryLegislationOnly',
    SpecifiedListOfCountries = 'SpecifiedListOfCountries',
  }

  export class SocialTaxLocationOptionDto
    implements ISocialTaxLocationOptionDto
  {
    optionValue!: SocialTaxLocationOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ISocialTaxLocationOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxLocationOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxLocationOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ISocialTaxLocationOptionDto {
    optionValue: SocialTaxLocationOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum SocialTaxLocationOption {
    CurrentAssignedWorkCountryOnly = 'CurrentAssignedWorkCountryOnly',
    CurrentLiveCountryOnly = 'CurrentLiveCountryOnly',
    CurrentEmploymentContractCountryOnly = 'CurrentEmploymentContractCountryOnly',
    CurrentPayrollCountryOnly = 'CurrentPayrollCountryOnly',
    ResidentCountryOnly = 'ResidentCountryOnly',
  }

  export class SocialTaxPolicyOverrideSettingsDto
    implements ISocialTaxPolicyOverrideSettingsDto
  {
    id!: string;
    clientId!: string;
    employeeId!: string;
    clientSocialTaxPolicy!: ClientSocialTaxPolicy;
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxSetting!: TrailingSocialTaxSettingDto | null;

    constructor(data?: ISocialTaxPolicyOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.clientSocialTaxPolicy =
          _data['clientSocialTaxPolicy'] !== undefined
            ? _data['clientSocialTaxPolicy']
            : <any>null;
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxSetting = _data['trailingSocialTaxSetting']
          ? TrailingSocialTaxSettingDto.fromJS(
              _data['trailingSocialTaxSetting'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxPolicyOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicyOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['clientSocialTaxPolicy'] =
        this.clientSocialTaxPolicy !== undefined
          ? this.clientSocialTaxPolicy
          : <any>null;
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxSetting'] = this.trailingSocialTaxSetting
        ? this.trailingSocialTaxSetting.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicyOverrideSettingsDto {
    id: string;
    clientId: string;
    employeeId: string;
    clientSocialTaxPolicy: ClientSocialTaxPolicy;
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxSetting: TrailingSocialTaxSettingDto | null;
  }

  export class TrailingSocialTaxSettingDto
    implements ITrailingSocialTaxSettingDto
  {
    countryCodes!: string[];
    policy!: TrailingSocialTaxPolicy;

    constructor(data?: ITrailingSocialTaxSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
        this.policy =
          _data['policy'] !== undefined ? _data['policy'] : <any>null;
      }
    }

    static fromJS(data: any): TrailingSocialTaxSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new TrailingSocialTaxSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      data['policy'] = this.policy !== undefined ? this.policy : <any>null;
      return data;
    }
  }

  export interface ITrailingSocialTaxSettingDto {
    countryCodes: string[];
    policy: TrailingSocialTaxPolicy;
  }

  export class GetSocialTaxPolicyOverridePageDataQueryResultFailure
    extends GetSocialTaxPolicyOverridePageDataQueryResult
    implements IGetSocialTaxPolicyOverridePageDataQueryResultFailure
  {
    constructor(data?: IGetSocialTaxPolicyOverridePageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxPolicyOverridePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyOverridePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxPolicyOverridePageDataQueryResultFailure
    extends IGetSocialTaxPolicyOverridePageDataQueryResult {}

  export class UpsertSocialTaxPolicyOverrideSettingsCommandResult
    implements IUpsertSocialTaxPolicyOverrideSettingsCommandResult
  {
    constructor(data?: IUpsertSocialTaxPolicyOverrideSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertSocialTaxPolicyOverrideSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicyOverrideSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicyOverrideSettingsCommandResult {}

  export class UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess
    extends UpsertSocialTaxPolicyOverrideSettingsCommandResult
    implements IUpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicyOverrideSettingsCommandResultSuccess
    extends IUpsertSocialTaxPolicyOverrideSettingsCommandResult {}

  export class UpsertSocialTaxPolicyOverrideSettingsCommandResultFailure
    extends UpsertSocialTaxPolicyOverrideSettingsCommandResult
    implements IUpsertSocialTaxPolicyOverrideSettingsCommandResultFailure
  {
    errors!: string;

    constructor(
      data?: IUpsertSocialTaxPolicyOverrideSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxPolicyOverrideSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertSocialTaxPolicyOverrideSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicyOverrideSettingsCommandResultFailure
    extends IUpsertSocialTaxPolicyOverrideSettingsCommandResult {
    errors: string;
  }

  export class UpsertSocialTaxPolicyOverrideSettingsCommand
    implements IUpsertSocialTaxPolicyOverrideSettingsCommand
  {
    clientId!: string;
    id!: string | null;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxSetting!: TrailingSocialTaxSettingDto | null;

    constructor(data?: IUpsertSocialTaxPolicyOverrideSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxSetting = _data['trailingSocialTaxSetting']
          ? TrailingSocialTaxSettingDto.fromJS(
              _data['trailingSocialTaxSetting'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertSocialTaxPolicyOverrideSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicyOverrideSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxSetting'] = this.trailingSocialTaxSetting
        ? this.trailingSocialTaxSetting.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicyOverrideSettingsCommand {
    clientId: string;
    id: string | null;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxSetting: TrailingSocialTaxSettingDto | null;
  }

  export class DeleteSocialTaxPolicyOverrideCommandResult
    implements IDeleteSocialTaxPolicyOverrideCommandResult
  {
    constructor(data?: IDeleteSocialTaxPolicyOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteSocialTaxPolicyOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteSocialTaxPolicyOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteSocialTaxPolicyOverrideCommandResult {}

  export class DeleteSocialTaxPolicyOverrideCommandResultSuccess
    extends DeleteSocialTaxPolicyOverrideCommandResult
    implements IDeleteSocialTaxPolicyOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteSocialTaxPolicyOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteSocialTaxPolicyOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteSocialTaxPolicyOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteSocialTaxPolicyOverrideCommandResultSuccess
    extends IDeleteSocialTaxPolicyOverrideCommandResult {}

  export class DeleteSocialTaxPolicyOverrideCommandResultFailure
    extends DeleteSocialTaxPolicyOverrideCommandResult
    implements IDeleteSocialTaxPolicyOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteSocialTaxPolicyOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteSocialTaxPolicyOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteSocialTaxPolicyOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteSocialTaxPolicyOverrideCommandResultFailure
    extends IDeleteSocialTaxPolicyOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteSocialTaxPolicyOverrideCommand
    implements IDeleteSocialTaxPolicyOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteSocialTaxPolicyOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteSocialTaxPolicyOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteSocialTaxPolicyOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteSocialTaxPolicyOverrideCommand {
    clientId: string;
    id: string;
  }

  export abstract class CheckSocialTaxOverrideDuplicateDataCommandResult
    implements ICheckSocialTaxOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckSocialTaxOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckSocialTaxOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckSocialTaxOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckSocialTaxOverrideDuplicateDataCommandResult {}

  export class CheckSocialTaxOverrideDuplicateDataCommandResultSuccess
    extends CheckSocialTaxOverrideDuplicateDataCommandResult
    implements ICheckSocialTaxOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckSocialTaxOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckSocialTaxOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckSocialTaxOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckSocialTaxOverrideDuplicateDataCommandResultSuccess
    extends ICheckSocialTaxOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckSocialTaxOverrideDuplicateDataCommandResultFailure
    extends CheckSocialTaxOverrideDuplicateDataCommandResult
    implements ICheckSocialTaxOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckSocialTaxOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckSocialTaxOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckSocialTaxOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckSocialTaxOverrideDuplicateDataCommandResultFailure
    extends ICheckSocialTaxOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckSocialTaxOverrideDuplicateDataCommand
    implements ICheckSocialTaxOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];

    constructor(data?: ICheckSocialTaxOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckSocialTaxOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckSocialTaxOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICheckSocialTaxOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
  }

  export abstract class GetSocialTaxOverridesIndexPageDataQueryResult
    implements IGetSocialTaxOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetSocialTaxOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetSocialTaxOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetSocialTaxOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSocialTaxOverridesIndexPageDataQueryResult {}

  export class GetSocialTaxOverridesIndexPageDataQueryResultSuccess
    extends GetSocialTaxOverridesIndexPageDataQueryResult
    implements IGetSocialTaxOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetSocialTaxOverridesIndexPageData;

    constructor(data?: IGetSocialTaxOverridesIndexPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new GetSocialTaxOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetSocialTaxOverridesIndexPageData.fromJS(_data['result'])
          : new GetSocialTaxOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxOverridesIndexPageDataQueryResultSuccess
    extends IGetSocialTaxOverridesIndexPageDataQueryResult {
    result: GetSocialTaxOverridesIndexPageData;
  }

  export class GetSocialTaxOverridesIndexPageData
    implements IGetSocialTaxOverridesIndexPageData
  {
    lineItems!: SocialTaxOverrideLineItem[];

    constructor(data?: IGetSocialTaxOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.lineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(SocialTaxOverrideLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): GetSocialTaxOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetSocialTaxOverridesIndexPageData {
    lineItems: SocialTaxOverrideLineItem[];
  }

  export class SocialTaxOverrideLineItem implements ISocialTaxOverrideLineItem {
    id!: string;
    employeeId!: string;
    clientSocialTaxPolicy!: ClientSocialTaxPolicy;
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy!: TrailingSocialTaxPolicy | null;
    specifiedCountryCodes!: string[];

    constructor(data?: ISocialTaxOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.specifiedCountryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.clientSocialTaxPolicy =
          _data['clientSocialTaxPolicy'] !== undefined
            ? _data['clientSocialTaxPolicy']
            : <any>null;
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxPolicy =
          _data['trailingSocialTaxPolicy'] !== undefined
            ? _data['trailingSocialTaxPolicy']
            : <any>null;
        if (Array.isArray(_data['specifiedCountryCodes'])) {
          this.specifiedCountryCodes = [] as any;
          for (let item of _data['specifiedCountryCodes'])
            this.specifiedCountryCodes!.push(item);
        } else {
          this.specifiedCountryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): SocialTaxOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['clientSocialTaxPolicy'] =
        this.clientSocialTaxPolicy !== undefined
          ? this.clientSocialTaxPolicy
          : <any>null;
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxPolicy'] =
        this.trailingSocialTaxPolicy !== undefined
          ? this.trailingSocialTaxPolicy
          : <any>null;
      if (Array.isArray(this.specifiedCountryCodes)) {
        data['specifiedCountryCodes'] = [];
        for (let item of this.specifiedCountryCodes)
          data['specifiedCountryCodes'].push(item);
      }
      return data;
    }
  }

  export interface ISocialTaxOverrideLineItem {
    id: string;
    employeeId: string;
    clientSocialTaxPolicy: ClientSocialTaxPolicy;
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy: TrailingSocialTaxPolicy | null;
    specifiedCountryCodes: string[];
  }

  export class GetSocialTaxOverridesIndexPageDataQueryResultFailure
    extends GetSocialTaxOverridesIndexPageDataQueryResult
    implements IGetSocialTaxOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetSocialTaxOverridesIndexPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxOverridesIndexPageDataQueryResultFailure
    extends IGetSocialTaxOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class GetRechargeOverridesPageDataQueryResult
    implements IGetRechargeOverridesPageDataQueryResult
  {
    constructor(data?: IGetRechargeOverridesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRechargeOverridesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetRechargeOverridesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRechargeOverridesPageDataQueryResult {}

  export class GetRechargeOverridesPageDataQueryResultSuccess
    extends GetRechargeOverridesPageDataQueryResult
    implements IGetRechargeOverridesPageDataQueryResultSuccess
  {
    result!: RechargeOverridesPageData;

    constructor(data?: IGetRechargeOverridesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new RechargeOverridesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RechargeOverridesPageData.fromJS(_data['result'])
          : new RechargeOverridesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeOverridesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeOverridesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeOverridesPageDataQueryResultSuccess
    extends IGetRechargeOverridesPageDataQueryResult {
    result: RechargeOverridesPageData;
  }

  export class RechargeOverridesPageData implements IRechargeOverridesPageData {
    planTypesForTaxPolicy!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    cashBonusRechargePolicySettingOptions!: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions!: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions!: StockOptionRechargePolicySettingDto[];
    clientRechargePolicyOverrideSettings!: RechargePolicyOverrideSettingsDto | null;

    constructor(data?: IRechargeOverridesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypesForTaxPolicy = [];
        this.taxOverridePlans = [];
        this.cashBonusRechargePolicySettingOptions = [];
        this.restrictedStockUnitRechargePolicySettingOptions = [];
        this.stockOptionRechargePolicySettingOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypesForTaxPolicy'])) {
          this.planTypesForTaxPolicy = [] as any;
          for (let item of _data['planTypesForTaxPolicy'])
            this.planTypesForTaxPolicy!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypesForTaxPolicy = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['cashBonusRechargePolicySettingOptions'])) {
          this.cashBonusRechargePolicySettingOptions = [] as any;
          for (let item of _data['cashBonusRechargePolicySettingOptions'])
            this.cashBonusRechargePolicySettingOptions!.push(
              CashBonusRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusRechargePolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitRechargePolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitRechargePolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitRechargePolicySettingOptions'
          ])
            this.restrictedStockUnitRechargePolicySettingOptions!.push(
              RestrictedStockUnitRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitRechargePolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['stockOptionRechargePolicySettingOptions'])) {
          this.stockOptionRechargePolicySettingOptions = [] as any;
          for (let item of _data['stockOptionRechargePolicySettingOptions'])
            this.stockOptionRechargePolicySettingOptions!.push(
              StockOptionRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionRechargePolicySettingOptions = <any>null;
        }
        this.clientRechargePolicyOverrideSettings = _data[
          'clientRechargePolicyOverrideSettings'
        ]
          ? RechargePolicyOverrideSettingsDto.fromJS(
              _data['clientRechargePolicyOverrideSettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): RechargeOverridesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RechargeOverridesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypesForTaxPolicy)) {
        data['planTypesForTaxPolicy'] = [];
        for (let item of this.planTypesForTaxPolicy)
          data['planTypesForTaxPolicy'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusRechargePolicySettingOptions)) {
        data['cashBonusRechargePolicySettingOptions'] = [];
        for (let item of this.cashBonusRechargePolicySettingOptions)
          data['cashBonusRechargePolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitRechargePolicySettingOptions)) {
        data['restrictedStockUnitRechargePolicySettingOptions'] = [];
        for (let item of this.restrictedStockUnitRechargePolicySettingOptions)
          data['restrictedStockUnitRechargePolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionRechargePolicySettingOptions)) {
        data['stockOptionRechargePolicySettingOptions'] = [];
        for (let item of this.stockOptionRechargePolicySettingOptions)
          data['stockOptionRechargePolicySettingOptions'].push(item.toJSON());
      }
      data['clientRechargePolicyOverrideSettings'] = this
        .clientRechargePolicyOverrideSettings
        ? this.clientRechargePolicyOverrideSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRechargeOverridesPageData {
    planTypesForTaxPolicy: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    cashBonusRechargePolicySettingOptions: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions: StockOptionRechargePolicySettingDto[];
    clientRechargePolicyOverrideSettings: RechargePolicyOverrideSettingsDto | null;
  }

  export class CashBonusRechargePolicySettingDto
    implements ICashBonusRechargePolicySettingDto
  {
    optionValue!: CashBonusRechargePolicySetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ICashBonusRechargePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): CashBonusRechargePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusRechargePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ICashBonusRechargePolicySettingDto {
    optionValue: CashBonusRechargePolicySetting;
    displayValue: string;
    displayOrder: number;
  }

  export enum CashBonusRechargePolicySetting {
    ApportionPerformanceStartDateToPaymentDateInAllAssignedWorkLocations = 'ApportionPerformanceStartDateToPaymentDateInAllAssignedWorkLocations',
    ApportionPerformanceStartDateToPaymentDateInAllEmploymentContractLocations = 'ApportionPerformanceStartDateToPaymentDateInAllEmploymentContractLocations',
    ApportionPerformanceStartDateToPaymentDateInAllLiveLocations = 'ApportionPerformanceStartDateToPaymentDateInAllLiveLocations',
    ApportionPerformanceStartDateToPerformanceEndDateInAllAssignedWorkLocations = 'ApportionPerformanceStartDateToPerformanceEndDateInAllAssignedWorkLocations',
    ApportionPerformanceStartDateToPerformanceEndDateInAllEmploymentContractLocations = 'ApportionPerformanceStartDateToPerformanceEndDateInAllEmploymentContractLocations',
    ApportionPerformanceStartDateToPerformanceEndDateInAllLiveLocations = 'ApportionPerformanceStartDateToPerformanceEndDateInAllLiveLocations',
    FullAmountEmploymentContractLocationAtPaymentDate = 'FullAmountEmploymentContractLocationAtPaymentDate',
    FullAmountInAssignedWorkLocationAtPerformanceStartDate = 'FullAmountInAssignedWorkLocationAtPerformanceStartDate',
    FullAmountInEmploymentContractLocationAtPerformanceStartDate = 'FullAmountInEmploymentContractLocationAtPerformanceStartDate',
    FullAmountInLiveLocationAtPerformanceStartDate = 'FullAmountInLiveLocationAtPerformanceStartDate',
    FullAmountInPayrollLocationAtPaymentDate = 'FullAmountInPayrollLocationAtPaymentDate',
    FullAmountLiveLocationAtPaymentDate = 'FullAmountLiveLocationAtPaymentDate',
    NoRecharge = 'NoRecharge',
  }

  export class RestrictedStockUnitRechargePolicySettingDto
    implements IRestrictedStockUnitRechargePolicySettingDto
  {
    optionValue!: RestrictedStockUnitRechargePolicySetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRestrictedStockUnitRechargePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RestrictedStockUnitRechargePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitRechargePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRestrictedStockUnitRechargePolicySettingDto {
    optionValue: RestrictedStockUnitRechargePolicySetting;
    displayValue: string;
    displayOrder: number;
  }

  export enum RestrictedStockUnitRechargePolicySetting {
    ApportionGrantToDistributionInAllAssignedWorkLocations = 'ApportionGrantToDistributionInAllAssignedWorkLocations',
    ApportionGrantToVestInAllAssignedWorkLocations = 'ApportionGrantToVestInAllAssignedWorkLocations',
    FullAmountInAssignedWorkLocationAtGrantDate = 'FullAmountInAssignedWorkLocationAtGrantDate',
    FullAmountAssignedWorkLocationAtDistribution = 'FullAmountAssignedWorkLocationAtDistribution',
    NoRecharge = 'NoRecharge',
    ApportionGrantToDistributionInAllEmploymentContractLocations = 'ApportionGrantToDistributionInAllEmploymentContractLocations',
    ApportionGrantToVestInAllEmploymentContractLocations = 'ApportionGrantToVestInAllEmploymentContractLocations',
    FullAmountInEmploymentContractLocationAtGrantDate = 'FullAmountInEmploymentContractLocationAtGrantDate',
    FullAmountEmploymentContractLocationAtDistribution = 'FullAmountEmploymentContractLocationAtDistribution',
    ApportionGrantToDistributionInAllLiveLocations = 'ApportionGrantToDistributionInAllLiveLocations',
    ApportionGrantToVestInAllLiveLocations = 'ApportionGrantToVestInAllLiveLocations',
    FullAmountInLiveLocationAtGrantDate = 'FullAmountInLiveLocationAtGrantDate',
    FullAmountLiveLocationAtDistribution = 'FullAmountLiveLocationAtDistribution',
  }

  export class StockOptionRechargePolicySettingDto
    implements IStockOptionRechargePolicySettingDto
  {
    optionValue!: StockOptionRechargePolicySetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IStockOptionRechargePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): StockOptionRechargePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionRechargePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IStockOptionRechargePolicySettingDto {
    optionValue: StockOptionRechargePolicySetting;
    displayValue: string;
    displayOrder: number;
  }

  export enum StockOptionRechargePolicySetting {
    ApportionGrantToExerciseInAllAssignedWorkLocations = 'ApportionGrantToExerciseInAllAssignedWorkLocations',
    ApportionGrantToVestInAllAssignedWorkLocations = 'ApportionGrantToVestInAllAssignedWorkLocations',
    FullAmountInAssignedWorkLocationAtGrantDate = 'FullAmountInAssignedWorkLocationAtGrantDate',
    FullAmountInAssignedWorkLocationAtExerciseDate = 'FullAmountInAssignedWorkLocationAtExerciseDate',
    NoRecharge = 'NoRecharge',
    ApportionGrantToExerciseInAllEmploymentContractLocations = 'ApportionGrantToExerciseInAllEmploymentContractLocations',
    ApportionGrantToVestInAllEmploymentContractLocations = 'ApportionGrantToVestInAllEmploymentContractLocations',
    FullAmountInEmploymentContractLocationsAtGrantDate = 'FullAmountInEmploymentContractLocationsAtGrantDate',
    FullAmountEmploymentContractLocationAtExercise = 'FullAmountEmploymentContractLocationAtExercise',
    ApportionGrantToExerciseInAllLiveLocations = 'ApportionGrantToExerciseInAllLiveLocations',
    ApportionGrantToVestInAllLiveLocations = 'ApportionGrantToVestInAllLiveLocations',
    FullAmountInLiveLocationAtGrantDate = 'FullAmountInLiveLocationAtGrantDate',
    FullAmountLiveLocationAtExercise = 'FullAmountLiveLocationAtExercise',
  }

  export class RechargePolicyOverrideSettingsDto
    implements IRechargePolicyOverrideSettingsDto
  {
    id!: string;
    clientId!: string;
    employeeId!: string;
    transactionId!: string | null;
    selectedPlanIds!: string[];
    policyOverrides!: RechargePolicyPlanTypeOverrideDto[];

    constructor(data?: IRechargePolicyOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.selectedPlanIds = [];
        this.policyOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        if (Array.isArray(_data['policyOverrides'])) {
          this.policyOverrides = [] as any;
          for (let item of _data['policyOverrides'])
            this.policyOverrides!.push(
              RechargePolicyPlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.policyOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): RechargePolicyOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicyOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      if (Array.isArray(this.policyOverrides)) {
        data['policyOverrides'] = [];
        for (let item of this.policyOverrides)
          data['policyOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRechargePolicyOverrideSettingsDto {
    id: string;
    clientId: string;
    employeeId: string;
    transactionId: string | null;
    selectedPlanIds: string[];
    policyOverrides: RechargePolicyPlanTypeOverrideDto[];
  }

  export class RechargePolicyPlanTypeOverrideDto
    implements IRechargePolicyPlanTypeOverrideDto
  {
    planType!: PlanType;
    configuredValueCode!: string;

    constructor(data?: IRechargePolicyPlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): RechargePolicyPlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicyPlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface IRechargePolicyPlanTypeOverrideDto {
    planType: PlanType;
    configuredValueCode: string;
  }

  export class GetRechargeOverridesPageDataQueryResultFailure
    extends GetRechargeOverridesPageDataQueryResult
    implements IGetRechargeOverridesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetRechargeOverridesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeOverridesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeOverridesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeOverridesPageDataQueryResultFailure
    extends IGetRechargeOverridesPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertRechargeOverrideCommandResult
    implements IUpsertRechargeOverrideCommandResult
  {
    constructor(data?: IUpsertRechargeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertRechargeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertRechargeOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRechargeOverrideCommandResult {}

  export class UpsertRechargeOverrideCommandResultSuccess
    extends UpsertRechargeOverrideCommandResult
    implements IUpsertRechargeOverrideCommandResultSuccess
  {
    ids!: string[];

    constructor(data?: IUpsertRechargeOverrideCommandResultSuccess) {
      super(data);
      if (!data) {
        this.ids = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['ids'])) {
          this.ids = [] as any;
          for (let item of _data['ids']) this.ids!.push(item);
        } else {
          this.ids = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRechargeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.ids)) {
        data['ids'] = [];
        for (let item of this.ids) data['ids'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargeOverrideCommandResultSuccess
    extends IUpsertRechargeOverrideCommandResult {
    ids: string[];
  }

  export class UpsertRechargeOverrideCommandResultFailure
    extends UpsertRechargeOverrideCommandResult
    implements IUpsertRechargeOverrideCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpsertRechargeOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRechargeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargeOverrideCommandResultFailure
    extends IUpsertRechargeOverrideCommandResult {
    errors: string;
  }

  export class UpsertRechargeOverrideCommand
    implements IUpsertRechargeOverrideCommand
  {
    clientId!: string;
    id!: string | null;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes!: string[];
    cashBonusPolicy!: CashBonusRechargePolicySetting | null;
    stockOptionPolicy!: StockOptionRechargePolicySetting | null;
    restrictedStockUnitPolicy!: RestrictedStockUnitRechargePolicySetting | null;

    constructor(data?: IUpsertRechargeOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
        this.cashBonusPolicy =
          _data['cashBonusPolicy'] !== undefined
            ? _data['cashBonusPolicy']
            : <any>null;
        this.stockOptionPolicy =
          _data['stockOptionPolicy'] !== undefined
            ? _data['stockOptionPolicy']
            : <any>null;
        this.restrictedStockUnitPolicy =
          _data['restrictedStockUnitPolicy'] !== undefined
            ? _data['restrictedStockUnitPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertRechargeOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargeOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      data['cashBonusPolicy'] =
        this.cashBonusPolicy !== undefined ? this.cashBonusPolicy : <any>null;
      data['stockOptionPolicy'] =
        this.stockOptionPolicy !== undefined
          ? this.stockOptionPolicy
          : <any>null;
      data['restrictedStockUnitPolicy'] =
        this.restrictedStockUnitPolicy !== undefined
          ? this.restrictedStockUnitPolicy
          : <any>null;
      return data;
    }
  }

  export interface IUpsertRechargeOverrideCommand {
    clientId: string;
    id: string | null;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes: string[];
    cashBonusPolicy: CashBonusRechargePolicySetting | null;
    stockOptionPolicy: StockOptionRechargePolicySetting | null;
    restrictedStockUnitPolicy: RestrictedStockUnitRechargePolicySetting | null;
  }

  export class DownloadMultipleOverrideFileCommand2
    implements IDownloadMultipleOverrideFileCommand2
  {
    constructor(data?: IDownloadMultipleOverrideFileCommand2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadMultipleOverrideFileCommand2 {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadMultipleOverrideFileCommand2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadMultipleOverrideFileCommand2 {}

  export class DeleteRechargeOverrideCommandResult
    implements IDeleteRechargeOverrideCommandResult
  {
    constructor(data?: IDeleteRechargeOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteRechargeOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRechargeOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteRechargeOverrideCommandResult {}

  export class DeleteRechargeOverrideCommandResultSuccess
    extends DeleteRechargeOverrideCommandResult
    implements IDeleteRechargeOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteRechargeOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteRechargeOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRechargeOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRechargeOverrideCommandResultSuccess
    extends IDeleteRechargeOverrideCommandResult {}

  export class DeleteRechargeOverrideCommandResultFailure
    extends DeleteRechargeOverrideCommandResult
    implements IDeleteRechargeOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteRechargeOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteRechargeOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRechargeOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRechargeOverrideCommandResultFailure
    extends IDeleteRechargeOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteRechargeOverrideCommand
    implements IDeleteRechargeOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteRechargeOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteRechargeOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRechargeOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteRechargeOverrideCommand {
    clientId: string;
    id: string;
  }

  export abstract class CheckRechargeOverrideDuplicateDataCommandResult
    implements ICheckRechargeOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckRechargeOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckRechargeOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckRechargeOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckRechargeOverrideDuplicateDataCommandResult {}

  export class CheckRechargeOverrideDuplicateDataCommandResultSuccess
    extends CheckRechargeOverrideDuplicateDataCommandResult
    implements ICheckRechargeOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckRechargeOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckRechargeOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CheckRechargeOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckRechargeOverrideDuplicateDataCommandResultSuccess
    extends ICheckRechargeOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckRechargeOverrideDuplicateDataCommandResultFailure
    extends CheckRechargeOverrideDuplicateDataCommandResult
    implements ICheckRechargeOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckRechargeOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckRechargeOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckRechargeOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckRechargeOverrideDuplicateDataCommandResultFailure
    extends ICheckRechargeOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckRechargeOverrideDuplicateDataCommand
    implements ICheckRechargeOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes!: string[];

    constructor(data?: ICheckRechargeOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckRechargeOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckRechargeOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      return data;
    }
  }

  export interface ICheckRechargeOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes: string[];
  }

  export abstract class GetRechargeOverridesIndexPageDataQueryResult
    implements IGetRechargeOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetRechargeOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRechargeOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetRechargeOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRechargeOverridesIndexPageDataQueryResult {}

  export class GetRechargeOverridesIndexPageDataQueryResultSuccess
    extends GetRechargeOverridesIndexPageDataQueryResult
    implements IGetRechargeOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetRechargeOverridesIndexPageData;

    constructor(data?: IGetRechargeOverridesIndexPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new GetRechargeOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetRechargeOverridesIndexPageData.fromJS(_data['result'])
          : new GetRechargeOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeOverridesIndexPageDataQueryResultSuccess
    extends IGetRechargeOverridesIndexPageDataQueryResult {
    result: GetRechargeOverridesIndexPageData;
  }

  export class GetRechargeOverridesIndexPageData
    implements IGetRechargeOverridesIndexPageData
  {
    planTypes!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    cashBonusRechargePolicySettingOptions!: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions!: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions!: StockOptionRechargePolicySettingDto[];
    cashBonusLineItems!: CashBonusRechargeOverrideLineItem[];
    restrictedStockUnitLineItems!: RestrictedStockUnitRechargeOverrideLineItem[];
    stockOptionLineItems!: StockOptionRechargeOverrideLineItem[];
    rechargeOverrideSettings!: RechargeOverrideSettings[];

    constructor(data?: IGetRechargeOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.taxOverridePlans = [];
        this.cashBonusRechargePolicySettingOptions = [];
        this.restrictedStockUnitRechargePolicySettingOptions = [];
        this.stockOptionRechargePolicySettingOptions = [];
        this.cashBonusLineItems = [];
        this.restrictedStockUnitLineItems = [];
        this.stockOptionLineItems = [];
        this.rechargeOverrideSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['cashBonusRechargePolicySettingOptions'])) {
          this.cashBonusRechargePolicySettingOptions = [] as any;
          for (let item of _data['cashBonusRechargePolicySettingOptions'])
            this.cashBonusRechargePolicySettingOptions!.push(
              CashBonusRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusRechargePolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitRechargePolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitRechargePolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitRechargePolicySettingOptions'
          ])
            this.restrictedStockUnitRechargePolicySettingOptions!.push(
              RestrictedStockUnitRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitRechargePolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['stockOptionRechargePolicySettingOptions'])) {
          this.stockOptionRechargePolicySettingOptions = [] as any;
          for (let item of _data['stockOptionRechargePolicySettingOptions'])
            this.stockOptionRechargePolicySettingOptions!.push(
              StockOptionRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionRechargePolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['cashBonusLineItems'])) {
          this.cashBonusLineItems = [] as any;
          for (let item of _data['cashBonusLineItems'])
            this.cashBonusLineItems!.push(
              CashBonusRechargeOverrideLineItem.fromJS(item),
            );
        } else {
          this.cashBonusLineItems = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitLineItems'])) {
          this.restrictedStockUnitLineItems = [] as any;
          for (let item of _data['restrictedStockUnitLineItems'])
            this.restrictedStockUnitLineItems!.push(
              RestrictedStockUnitRechargeOverrideLineItem.fromJS(item),
            );
        } else {
          this.restrictedStockUnitLineItems = <any>null;
        }
        if (Array.isArray(_data['stockOptionLineItems'])) {
          this.stockOptionLineItems = [] as any;
          for (let item of _data['stockOptionLineItems'])
            this.stockOptionLineItems!.push(
              StockOptionRechargeOverrideLineItem.fromJS(item),
            );
        } else {
          this.stockOptionLineItems = <any>null;
        }
        if (Array.isArray(_data['rechargeOverrideSettings'])) {
          this.rechargeOverrideSettings = [] as any;
          for (let item of _data['rechargeOverrideSettings'])
            this.rechargeOverrideSettings!.push(
              RechargeOverrideSettings.fromJS(item),
            );
        } else {
          this.rechargeOverrideSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): GetRechargeOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusRechargePolicySettingOptions)) {
        data['cashBonusRechargePolicySettingOptions'] = [];
        for (let item of this.cashBonusRechargePolicySettingOptions)
          data['cashBonusRechargePolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitRechargePolicySettingOptions)) {
        data['restrictedStockUnitRechargePolicySettingOptions'] = [];
        for (let item of this.restrictedStockUnitRechargePolicySettingOptions)
          data['restrictedStockUnitRechargePolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionRechargePolicySettingOptions)) {
        data['stockOptionRechargePolicySettingOptions'] = [];
        for (let item of this.stockOptionRechargePolicySettingOptions)
          data['stockOptionRechargePolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusLineItems)) {
        data['cashBonusLineItems'] = [];
        for (let item of this.cashBonusLineItems)
          data['cashBonusLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitLineItems)) {
        data['restrictedStockUnitLineItems'] = [];
        for (let item of this.restrictedStockUnitLineItems)
          data['restrictedStockUnitLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionLineItems)) {
        data['stockOptionLineItems'] = [];
        for (let item of this.stockOptionLineItems)
          data['stockOptionLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.rechargeOverrideSettings)) {
        data['rechargeOverrideSettings'] = [];
        for (let item of this.rechargeOverrideSettings)
          data['rechargeOverrideSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetRechargeOverridesIndexPageData {
    planTypes: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    cashBonusRechargePolicySettingOptions: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions: StockOptionRechargePolicySettingDto[];
    cashBonusLineItems: CashBonusRechargeOverrideLineItem[];
    restrictedStockUnitLineItems: RestrictedStockUnitRechargeOverrideLineItem[];
    stockOptionLineItems: StockOptionRechargeOverrideLineItem[];
    rechargeOverrideSettings: RechargeOverrideSettings[];
  }

  export class CashBonusRechargeOverrideLineItem
    implements ICashBonusRechargeOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem2[];

    constructor(data?: ICashBonusRechargeOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem2.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): CashBonusRechargeOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusRechargeOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashBonusRechargeOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem2[];
  }

  export class PlanCodeOverrideSubLineItem2
    implements IPlanCodeOverrideSubLineItem2
  {
    planCode!: string;
    overrideDisplay!: string;

    constructor(data?: IPlanCodeOverrideSubLineItem2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
      }
    }

    static fromJS(data: any): PlanCodeOverrideSubLineItem2 {
      data = typeof data === 'object' ? data : {};
      let result = new PlanCodeOverrideSubLineItem2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      return data;
    }
  }

  export interface IPlanCodeOverrideSubLineItem2 {
    planCode: string;
    overrideDisplay: string;
  }

  export class RestrictedStockUnitRechargeOverrideLineItem
    implements IRestrictedStockUnitRechargeOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem2[];

    constructor(data?: IRestrictedStockUnitRechargeOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem2.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): RestrictedStockUnitRechargeOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitRechargeOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRestrictedStockUnitRechargeOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem2[];
  }

  export class StockOptionRechargeOverrideLineItem
    implements IStockOptionRechargeOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem2[];

    constructor(data?: IStockOptionRechargeOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem2.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): StockOptionRechargeOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionRechargeOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IStockOptionRechargeOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem2[];
  }

  export class RechargeOverrideSettings
    extends TrackedAggregateRoot
    implements IRechargeOverrideSettings
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    selectedPlanIds!: string[];
    cashBonusPolicySetting!: CashBonusRechargePolicySetting | null;
    stockOptionPolicySetting!: StockOptionRechargePolicySetting | null;
    restrictedStockUnitPolicySetting!: RestrictedStockUnitRechargePolicySetting | null;
    entityKey!: string;

    constructor(data?: IRechargeOverrideSettings) {
      super(data);
      if (!data) {
        this.selectedPlanIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        this.cashBonusPolicySetting =
          _data['cashBonusPolicySetting'] !== undefined
            ? _data['cashBonusPolicySetting']
            : <any>null;
        this.stockOptionPolicySetting =
          _data['stockOptionPolicySetting'] !== undefined
            ? _data['stockOptionPolicySetting']
            : <any>null;
        this.restrictedStockUnitPolicySetting =
          _data['restrictedStockUnitPolicySetting'] !== undefined
            ? _data['restrictedStockUnitPolicySetting']
            : <any>null;
        this.entityKey =
          _data['entityKey'] !== undefined ? _data['entityKey'] : <any>null;
      }
    }

    static override fromJS(data: any): RechargeOverrideSettings {
      data = typeof data === 'object' ? data : {};
      let result = new RechargeOverrideSettings();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      data['cashBonusPolicySetting'] =
        this.cashBonusPolicySetting !== undefined
          ? this.cashBonusPolicySetting
          : <any>null;
      data['stockOptionPolicySetting'] =
        this.stockOptionPolicySetting !== undefined
          ? this.stockOptionPolicySetting
          : <any>null;
      data['restrictedStockUnitPolicySetting'] =
        this.restrictedStockUnitPolicySetting !== undefined
          ? this.restrictedStockUnitPolicySetting
          : <any>null;
      data['entityKey'] =
        this.entityKey !== undefined ? this.entityKey : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRechargeOverrideSettings extends ITrackedAggregateRoot {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    selectedPlanIds: string[];
    cashBonusPolicySetting: CashBonusRechargePolicySetting | null;
    stockOptionPolicySetting: StockOptionRechargePolicySetting | null;
    restrictedStockUnitPolicySetting: RestrictedStockUnitRechargePolicySetting | null;
    entityKey: string;
  }

  export class GetRechargeOverridesIndexPageDataQueryResultFailure
    extends GetRechargeOverridesIndexPageDataQueryResult
    implements IGetRechargeOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetRechargeOverridesIndexPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeOverridesIndexPageDataQueryResultFailure
    extends IGetRechargeOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetDoubleTaxReliefPolicyOverridePageDataQueryResult
    implements IGetDoubleTaxReliefPolicyOverridePageDataQueryResult
  {
    constructor(data?: IGetDoubleTaxReliefPolicyOverridePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetDoubleTaxReliefPolicyOverridePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyOverridePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyOverridePageDataQueryResult {}

  export class GetDoubleTaxReliefPolicyPageDataQueryResultSuccess
    extends GetDoubleTaxReliefPolicyOverridePageDataQueryResult
    implements IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess
  {
    result!: DoubleTaxReliefOverridePageData;

    constructor(data?: IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new DoubleTaxReliefOverridePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DoubleTaxReliefOverridePageData.fromJS(_data['result'])
          : new DoubleTaxReliefOverridePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefPolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess
    extends IGetDoubleTaxReliefPolicyOverridePageDataQueryResult {
    result: DoubleTaxReliefOverridePageData;
  }

  export class DoubleTaxReliefOverridePageData
    implements IDoubleTaxReliefOverridePageData
  {
    countriesInFootprint!: DoubleTaxReliefPolicyOverrideCountryData[];
    doubleTaxReliefPolicySettingOptions!: DoubleTaxReliefPolicySettingDto[];
    clientDoubleTaxReliefPolicyOverrideSettingsDto!: DoubleTaxReliefPolicyOverrideSettingsDto | null;

    constructor(data?: IDoubleTaxReliefOverridePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.doubleTaxReliefPolicySettingOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              DoubleTaxReliefPolicyOverrideCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['doubleTaxReliefPolicySettingOptions'])) {
          this.doubleTaxReliefPolicySettingOptions = [] as any;
          for (let item of _data['doubleTaxReliefPolicySettingOptions'])
            this.doubleTaxReliefPolicySettingOptions!.push(
              DoubleTaxReliefPolicySettingDto.fromJS(item),
            );
        } else {
          this.doubleTaxReliefPolicySettingOptions = <any>null;
        }
        this.clientDoubleTaxReliefPolicyOverrideSettingsDto = _data[
          'clientDoubleTaxReliefPolicyOverrideSettingsDto'
        ]
          ? DoubleTaxReliefPolicyOverrideSettingsDto.fromJS(
              _data['clientDoubleTaxReliefPolicyOverrideSettingsDto'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefOverridePageData {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefOverridePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.doubleTaxReliefPolicySettingOptions)) {
        data['doubleTaxReliefPolicySettingOptions'] = [];
        for (let item of this.doubleTaxReliefPolicySettingOptions)
          data['doubleTaxReliefPolicySettingOptions'].push(item.toJSON());
      }
      data['clientDoubleTaxReliefPolicyOverrideSettingsDto'] = this
        .clientDoubleTaxReliefPolicyOverrideSettingsDto
        ? this.clientDoubleTaxReliefPolicyOverrideSettingsDto.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefOverridePageData {
    countriesInFootprint: DoubleTaxReliefPolicyOverrideCountryData[];
    doubleTaxReliefPolicySettingOptions: DoubleTaxReliefPolicySettingDto[];
    clientDoubleTaxReliefPolicyOverrideSettingsDto: DoubleTaxReliefPolicyOverrideSettingsDto | null;
  }

  export class DoubleTaxReliefPolicyOverrideCountryData
    implements IDoubleTaxReliefPolicyOverrideCountryData
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IDoubleTaxReliefPolicyOverrideCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPolicyOverrideCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPolicyOverrideCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPolicyOverrideCountryData {
    countryCode: string;
    countryName: string;
  }

  export class DoubleTaxReliefPolicySettingDto
    implements IDoubleTaxReliefPolicySettingDto
  {
    optionValue!: DoubleTaxReliefPolicySetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IDoubleTaxReliefPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPolicySettingDto {
    optionValue: DoubleTaxReliefPolicySetting;
    displayValue: string;
    displayOrder: number;
  }

  export enum DoubleTaxReliefPolicySetting {
    ForeignTaxCreditConsideringIncomeAndRegionTaxes = 'ForeignTaxCreditConsideringIncomeAndRegionTaxes',
    ForeignTaxCreditConsideringIncomeTaxesOnly = 'ForeignTaxCreditConsideringIncomeTaxesOnly',
    FollowCountryLegislation = 'FollowCountryLegislation',
    NoDoubleTaxRelief = 'NoDoubleTaxRelief',
  }

  export class DoubleTaxReliefPolicyOverrideSettingsDto
    implements IDoubleTaxReliefPolicyOverrideSettingsDto
  {
    id!: string;
    clientId!: string;
    transactionId!: string;
    employeeId!: string;
    countryCode!: string;
    doubleTaxReliefPolicyOverrideSetting!: DoubleTaxReliefPolicySetting;

    constructor(data?: IDoubleTaxReliefPolicyOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.doubleTaxReliefPolicyOverrideSetting =
          _data['doubleTaxReliefPolicyOverrideSetting'] !== undefined
            ? _data['doubleTaxReliefPolicyOverrideSetting']
            : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPolicyOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPolicyOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['doubleTaxReliefPolicyOverrideSetting'] =
        this.doubleTaxReliefPolicyOverrideSetting !== undefined
          ? this.doubleTaxReliefPolicyOverrideSetting
          : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPolicyOverrideSettingsDto {
    id: string;
    clientId: string;
    transactionId: string;
    employeeId: string;
    countryCode: string;
    doubleTaxReliefPolicyOverrideSetting: DoubleTaxReliefPolicySetting;
  }

  export class GetDoubleTaxReliefPolicyPageDataQueryResultFailure
    extends GetDoubleTaxReliefPolicyOverridePageDataQueryResult
    implements IGetDoubleTaxReliefPolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetDoubleTaxReliefPolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefPolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyPageDataQueryResultFailure
    extends IGetDoubleTaxReliefPolicyOverridePageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult
  {
    constructor(
      data?: IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult {}

  export class UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess
    extends UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultSuccess
    extends IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult {}

  export class UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure
    extends UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure
  {
    errors!: string;

    constructor(
      data?: IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResultFailure
    extends IUpsertDoubleTaxReliefPolicyOverrideSettingsCommandResult {
    errors: string;
  }

  export class UpsertDoubleTaxReliefPolicyOverrideSettingsCommand
    implements IUpsertDoubleTaxReliefPolicyOverrideSettingsCommand
  {
    clientId!: string;
    id!: string | null;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    countryCode!: string;
    doubleTaxReliefPolicyOverrideSetting!: DoubleTaxReliefPolicySetting;

    constructor(data?: IUpsertDoubleTaxReliefPolicyOverrideSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.doubleTaxReliefPolicyOverrideSetting =
          _data['doubleTaxReliefPolicyOverrideSetting'] !== undefined
            ? _data['doubleTaxReliefPolicyOverrideSetting']
            : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicyOverrideSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertDoubleTaxReliefPolicyOverrideSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['doubleTaxReliefPolicyOverrideSetting'] =
        this.doubleTaxReliefPolicyOverrideSetting !== undefined
          ? this.doubleTaxReliefPolicyOverrideSetting
          : <any>null;
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicyOverrideSettingsCommand {
    clientId: string;
    id: string | null;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    countryCode: string;
    doubleTaxReliefPolicyOverrideSetting: DoubleTaxReliefPolicySetting;
  }

  export class DeleteDoubleTaxReliefPolicyOverrideCommandResult
    implements IDeleteDoubleTaxReliefPolicyOverrideCommandResult
  {
    constructor(data?: IDeleteDoubleTaxReliefPolicyOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteDoubleTaxReliefPolicyOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteDoubleTaxReliefPolicyOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteDoubleTaxReliefPolicyOverrideCommandResult {}

  export class DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess
    extends DeleteDoubleTaxReliefPolicyOverrideCommandResult
    implements IDeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess
  {
    constructor(
      data?: IDeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteDoubleTaxReliefPolicyOverrideCommandResultSuccess
    extends IDeleteDoubleTaxReliefPolicyOverrideCommandResult {}

  export class DeleteDoubleTaxReliefPolicyOverrideCommandResultFailure
    extends DeleteDoubleTaxReliefPolicyOverrideCommandResult
    implements IDeleteDoubleTaxReliefPolicyOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IDeleteDoubleTaxReliefPolicyOverrideCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteDoubleTaxReliefPolicyOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteDoubleTaxReliefPolicyOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteDoubleTaxReliefPolicyOverrideCommandResultFailure
    extends IDeleteDoubleTaxReliefPolicyOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteDoubleTaxReliefPolicyOverrideCommand
    implements IDeleteDoubleTaxReliefPolicyOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteDoubleTaxReliefPolicyOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteDoubleTaxReliefPolicyOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteDoubleTaxReliefPolicyOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteDoubleTaxReliefPolicyOverrideCommand {
    clientId: string;
    id: string;
  }

  export abstract class CheckDoubleTaxReliefOverrideDuplicateDataCommandResult
    implements ICheckDoubleTaxReliefOverrideDuplicateDataCommandResult
  {
    constructor(
      data?: ICheckDoubleTaxReliefOverrideDuplicateDataCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): CheckDoubleTaxReliefOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckDoubleTaxReliefOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckDoubleTaxReliefOverrideDuplicateDataCommandResult {}

  export class CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess
    extends CheckDoubleTaxReliefOverrideDuplicateDataCommandResult
    implements ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultSuccess
    extends ICheckDoubleTaxReliefOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure
    extends CheckDoubleTaxReliefOverrideDuplicateDataCommandResult
    implements ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckDoubleTaxReliefOverrideDuplicateDataCommandResultFailure
    extends ICheckDoubleTaxReliefOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckDoubleTaxReliefOverrideDuplicateDataCommand
    implements ICheckDoubleTaxReliefOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    countryCode!: string;

    constructor(data?: ICheckDoubleTaxReliefOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
      }
    }

    static fromJS(data: any): CheckDoubleTaxReliefOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckDoubleTaxReliefOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      return data;
    }
  }

  export interface ICheckDoubleTaxReliefOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    countryCode: string;
  }

  export abstract class GetDoubleTaxReliefOverridesIndexPageDataQueryResult
    implements IGetDoubleTaxReliefOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetDoubleTaxReliefOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetDoubleTaxReliefOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDoubleTaxReliefOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDoubleTaxReliefOverridesIndexPageDataQueryResult {}

  export class GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess
    extends GetDoubleTaxReliefOverridesIndexPageDataQueryResult
    implements IGetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetDoubleTaxReliefOverridesIndexPageData;

    constructor(
      data?: IGetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new GetDoubleTaxReliefOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetDoubleTaxReliefOverridesIndexPageData.fromJS(_data['result'])
          : new GetDoubleTaxReliefOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefOverridesIndexPageDataQueryResultSuccess
    extends IGetDoubleTaxReliefOverridesIndexPageDataQueryResult {
    result: GetDoubleTaxReliefOverridesIndexPageData;
  }

  export class GetDoubleTaxReliefOverridesIndexPageData
    implements IGetDoubleTaxReliefOverridesIndexPageData
  {
    countriesInFootprint!: DoubleTaxReliefPolicyCountryData[];
    doubleTaxReliefPolicySettingOptions!: DoubleTaxReliefPolicySettingDto[];
    lineItems!: DoubleTaxReliefOverrideLineItem[];

    constructor(data?: IGetDoubleTaxReliefOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.doubleTaxReliefPolicySettingOptions = [];
        this.lineItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              DoubleTaxReliefPolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['doubleTaxReliefPolicySettingOptions'])) {
          this.doubleTaxReliefPolicySettingOptions = [] as any;
          for (let item of _data['doubleTaxReliefPolicySettingOptions'])
            this.doubleTaxReliefPolicySettingOptions!.push(
              DoubleTaxReliefPolicySettingDto.fromJS(item),
            );
        } else {
          this.doubleTaxReliefPolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['lineItems'])) {
          this.lineItems = [] as any;
          for (let item of _data['lineItems'])
            this.lineItems!.push(DoubleTaxReliefOverrideLineItem.fromJS(item));
        } else {
          this.lineItems = <any>null;
        }
      }
    }

    static fromJS(data: any): GetDoubleTaxReliefOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.doubleTaxReliefPolicySettingOptions)) {
        data['doubleTaxReliefPolicySettingOptions'] = [];
        for (let item of this.doubleTaxReliefPolicySettingOptions)
          data['doubleTaxReliefPolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.lineItems)) {
        data['lineItems'] = [];
        for (let item of this.lineItems) data['lineItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetDoubleTaxReliefOverridesIndexPageData {
    countriesInFootprint: DoubleTaxReliefPolicyCountryData[];
    doubleTaxReliefPolicySettingOptions: DoubleTaxReliefPolicySettingDto[];
    lineItems: DoubleTaxReliefOverrideLineItem[];
  }

  export class DoubleTaxReliefPolicyCountryData
    implements IDoubleTaxReliefPolicyCountryData
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IDoubleTaxReliefPolicyCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPolicyCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPolicyCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPolicyCountryData {
    countryCode: string;
    countryName: string;
  }

  export class DoubleTaxReliefOverrideLineItem
    implements IDoubleTaxReliefOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    countryCode!: string;
    doubleTaxReliefPolicySetting!: DoubleTaxReliefPolicySetting;

    constructor(data?: IDoubleTaxReliefOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.doubleTaxReliefPolicySetting =
          _data['doubleTaxReliefPolicySetting'] !== undefined
            ? _data['doubleTaxReliefPolicySetting']
            : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['doubleTaxReliefPolicySetting'] =
        this.doubleTaxReliefPolicySetting !== undefined
          ? this.doubleTaxReliefPolicySetting
          : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    countryCode: string;
    doubleTaxReliefPolicySetting: DoubleTaxReliefPolicySetting;
  }

  export class GetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure
    extends GetDoubleTaxReliefOverridesIndexPageDataQueryResult
    implements IGetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefOverridesIndexPageDataQueryResultFailure
    extends IGetDoubleTaxReliefOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class GetCashPaymentOverridesPageDataQueryResult
    implements IGetCashPaymentOverridesPageDataQueryResult
  {
    constructor(data?: IGetCashPaymentOverridesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCashPaymentOverridesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCashPaymentOverridesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCashPaymentOverridesPageDataQueryResult {}

  export class GetCashPaymentOverridesPageDataQueryResultSuccess
    extends GetCashPaymentOverridesPageDataQueryResult
    implements IGetCashPaymentOverridesPageDataQueryResultSuccess
  {
    result!: CashPaymentOverridesPageData;

    constructor(data?: IGetCashPaymentOverridesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CashPaymentOverridesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CashPaymentOverridesPageData.fromJS(_data['result'])
          : new CashPaymentOverridesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentOverridesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentOverridesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentOverridesPageDataQueryResultSuccess
    extends IGetCashPaymentOverridesPageDataQueryResult {
    result: CashPaymentOverridesPageData;
  }

  export class CashPaymentOverridesPageData
    implements ICashPaymentOverridesPageData
  {
    planTypesForTaxPolicy!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    cashBonusCashPaymentPolicySettingOptions!: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions!: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions!: StockOptionCashPaymentPolicySettingDto[];
    clientCashPaymentPolicyOverrideSettings!: CashPaymentPolicyOverrideSettingsDto | null;

    constructor(data?: ICashPaymentOverridesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypesForTaxPolicy = [];
        this.taxOverridePlans = [];
        this.cashBonusCashPaymentPolicySettingOptions = [];
        this.restrictedStockUnitCashPaymentPolicySettingOptions = [];
        this.stockOptionCashPaymentPolicySettingOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypesForTaxPolicy'])) {
          this.planTypesForTaxPolicy = [] as any;
          for (let item of _data['planTypesForTaxPolicy'])
            this.planTypesForTaxPolicy!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypesForTaxPolicy = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['cashBonusCashPaymentPolicySettingOptions'])) {
          this.cashBonusCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['cashBonusCashPaymentPolicySettingOptions'])
            this.cashBonusCashPaymentPolicySettingOptions!.push(
              CashBonusCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitCashPaymentPolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitCashPaymentPolicySettingOptions'
          ])
            this.restrictedStockUnitCashPaymentPolicySettingOptions!.push(
              RestrictedStockUnitCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(_data['stockOptionCashPaymentPolicySettingOptions'])
        ) {
          this.stockOptionCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['stockOptionCashPaymentPolicySettingOptions'])
            this.stockOptionCashPaymentPolicySettingOptions!.push(
              StockOptionCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionCashPaymentPolicySettingOptions = <any>null;
        }
        this.clientCashPaymentPolicyOverrideSettings = _data[
          'clientCashPaymentPolicyOverrideSettings'
        ]
          ? CashPaymentPolicyOverrideSettingsDto.fromJS(
              _data['clientCashPaymentPolicyOverrideSettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentOverridesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentOverridesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypesForTaxPolicy)) {
        data['planTypesForTaxPolicy'] = [];
        for (let item of this.planTypesForTaxPolicy)
          data['planTypesForTaxPolicy'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusCashPaymentPolicySettingOptions)) {
        data['cashBonusCashPaymentPolicySettingOptions'] = [];
        for (let item of this.cashBonusCashPaymentPolicySettingOptions)
          data['cashBonusCashPaymentPolicySettingOptions'].push(item.toJSON());
      }
      if (
        Array.isArray(this.restrictedStockUnitCashPaymentPolicySettingOptions)
      ) {
        data['restrictedStockUnitCashPaymentPolicySettingOptions'] = [];
        for (let item of this
          .restrictedStockUnitCashPaymentPolicySettingOptions)
          data['restrictedStockUnitCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionCashPaymentPolicySettingOptions)) {
        data['stockOptionCashPaymentPolicySettingOptions'] = [];
        for (let item of this.stockOptionCashPaymentPolicySettingOptions)
          data['stockOptionCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      data['clientCashPaymentPolicyOverrideSettings'] = this
        .clientCashPaymentPolicyOverrideSettings
        ? this.clientCashPaymentPolicyOverrideSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICashPaymentOverridesPageData {
    planTypesForTaxPolicy: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    cashBonusCashPaymentPolicySettingOptions: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions: StockOptionCashPaymentPolicySettingDto[];
    clientCashPaymentPolicyOverrideSettings: CashPaymentPolicyOverrideSettingsDto | null;
  }

  export class CashBonusCashPaymentPolicySettingDto
    implements ICashBonusCashPaymentPolicySettingDto
  {
    optionValue!: CashBonusCashPaymentPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ICashBonusCashPaymentPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): CashBonusCashPaymentPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusCashPaymentPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ICashBonusCashPaymentPolicySettingDto {
    optionValue: CashBonusCashPaymentPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum CashBonusCashPaymentPolicy {
    FullAmountInPayrollLocationAtPaymentDate = 'FullAmountInPayrollLocationAtPaymentDate',
    NoCashPayments = 'NoCashPayments',
    ApportionPerformanceStartToPerformanceEndInAllPayrollLocations = 'ApportionPerformanceStartToPerformanceEndInAllPayrollLocations',
    ApportionPerformanceStartToPaymentDateInAllPayrollLocations = 'ApportionPerformanceStartToPaymentDateInAllPayrollLocations',
  }

  export class RestrictedStockUnitCashPaymentPolicySettingDto
    implements IRestrictedStockUnitCashPaymentPolicySettingDto
  {
    optionValue!: RestrictedStockUnitCashPaymentPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRestrictedStockUnitCashPaymentPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RestrictedStockUnitCashPaymentPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitCashPaymentPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRestrictedStockUnitCashPaymentPolicySettingDto {
    optionValue: RestrictedStockUnitCashPaymentPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum RestrictedStockUnitCashPaymentPolicy {
    FullAmountInPayrollLocationAtDistributionDate = 'FullAmountInPayrollLocationAtDistributionDate',
    NoCashPayments = 'NoCashPayments',
    ApportionGrantToVestInAllPayrollLocations = 'ApportionGrantToVestInAllPayrollLocations',
    ApportionGrantToDistributionInAllPayrollLocations = 'ApportionGrantToDistributionInAllPayrollLocations',
  }

  export class StockOptionCashPaymentPolicySettingDto
    implements IStockOptionCashPaymentPolicySettingDto
  {
    optionValue!: StockOptionCashPaymentPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IStockOptionCashPaymentPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): StockOptionCashPaymentPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionCashPaymentPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IStockOptionCashPaymentPolicySettingDto {
    optionValue: StockOptionCashPaymentPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum StockOptionCashPaymentPolicy {
    FullAmountInPayrollLocationAtExerciseDate = 'FullAmountInPayrollLocationAtExerciseDate',
    NoCashPayments = 'NoCashPayments',
    ApportionGrantToVestInAllPayrollLocations = 'ApportionGrantToVestInAllPayrollLocations',
    ApportionGrantToExerciseInAllPayrollLocations = 'ApportionGrantToExerciseInAllPayrollLocations',
  }

  export class CashPaymentPolicyOverrideSettingsDto
    implements ICashPaymentPolicyOverrideSettingsDto
  {
    id!: string;
    clientId!: string;
    employeeId!: string;
    transactionId!: string | null;
    selectedPlanIds!: string[];
    policyOverrides!: CashPaymentPolicyPlanTypeOverrideDto[];

    constructor(data?: ICashPaymentPolicyOverrideSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.selectedPlanIds = [];
        this.policyOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        if (Array.isArray(_data['policyOverrides'])) {
          this.policyOverrides = [] as any;
          for (let item of _data['policyOverrides'])
            this.policyOverrides!.push(
              CashPaymentPolicyPlanTypeOverrideDto.fromJS(item),
            );
        } else {
          this.policyOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): CashPaymentPolicyOverrideSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicyOverrideSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      if (Array.isArray(this.policyOverrides)) {
        data['policyOverrides'] = [];
        for (let item of this.policyOverrides)
          data['policyOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyOverrideSettingsDto {
    id: string;
    clientId: string;
    employeeId: string;
    transactionId: string | null;
    selectedPlanIds: string[];
    policyOverrides: CashPaymentPolicyPlanTypeOverrideDto[];
  }

  export class CashPaymentPolicyPlanTypeOverrideDto
    implements ICashPaymentPolicyPlanTypeOverrideDto
  {
    planType!: PlanType;
    configuredValueCode!: string;

    constructor(data?: ICashPaymentPolicyPlanTypeOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.configuredValueCode =
          _data['configuredValueCode'] !== undefined
            ? _data['configuredValueCode']
            : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentPolicyPlanTypeOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicyPlanTypeOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['configuredValueCode'] =
        this.configuredValueCode !== undefined
          ? this.configuredValueCode
          : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicyPlanTypeOverrideDto {
    planType: PlanType;
    configuredValueCode: string;
  }

  export class GetCashPaymentOverridesPageDataQueryResultFailure
    extends GetCashPaymentOverridesPageDataQueryResult
    implements IGetCashPaymentOverridesPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCashPaymentOverridesPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentOverridesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentOverridesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentOverridesPageDataQueryResultFailure
    extends IGetCashPaymentOverridesPageDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertCashPaymentOverrideCommandResult
    implements IUpsertCashPaymentOverrideCommandResult
  {
    constructor(data?: IUpsertCashPaymentOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertCashPaymentOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertCashPaymentOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCashPaymentOverrideCommandResult {}

  export class UpsertCashPaymentOverrideCommandResultSuccess
    extends UpsertCashPaymentOverrideCommandResult
    implements IUpsertCashPaymentOverrideCommandResultSuccess
  {
    ids!: string[];

    constructor(data?: IUpsertCashPaymentOverrideCommandResultSuccess) {
      super(data);
      if (!data) {
        this.ids = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['ids'])) {
          this.ids = [] as any;
          for (let item of _data['ids']) this.ids!.push(item);
        } else {
          this.ids = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.ids)) {
        data['ids'] = [];
        for (let item of this.ids) data['ids'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentOverrideCommandResultSuccess
    extends IUpsertCashPaymentOverrideCommandResult {
    ids: string[];
  }

  export class UpsertCashPaymentOverrideCommandResultFailure
    extends UpsertCashPaymentOverrideCommandResult
    implements IUpsertCashPaymentOverrideCommandResultFailure
  {
    errors!: string;

    constructor(data?: IUpsertCashPaymentOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentOverrideCommandResultFailure
    extends IUpsertCashPaymentOverrideCommandResult {
    errors: string;
  }

  export class UpsertCashPaymentOverrideCommand
    implements IUpsertCashPaymentOverrideCommand
  {
    clientId!: string;
    id!: string | null;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes!: string[];
    cashBonusPolicy!: CashBonusCashPaymentPolicy | null;
    stockOptionPolicy!: StockOptionCashPaymentPolicy | null;
    restrictedStockUnitPolicy!: RestrictedStockUnitCashPaymentPolicy | null;

    constructor(data?: IUpsertCashPaymentOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
        this.cashBonusPolicy =
          _data['cashBonusPolicy'] !== undefined
            ? _data['cashBonusPolicy']
            : <any>null;
        this.stockOptionPolicy =
          _data['stockOptionPolicy'] !== undefined
            ? _data['stockOptionPolicy']
            : <any>null;
        this.restrictedStockUnitPolicy =
          _data['restrictedStockUnitPolicy'] !== undefined
            ? _data['restrictedStockUnitPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertCashPaymentOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      data['cashBonusPolicy'] =
        this.cashBonusPolicy !== undefined ? this.cashBonusPolicy : <any>null;
      data['stockOptionPolicy'] =
        this.stockOptionPolicy !== undefined
          ? this.stockOptionPolicy
          : <any>null;
      data['restrictedStockUnitPolicy'] =
        this.restrictedStockUnitPolicy !== undefined
          ? this.restrictedStockUnitPolicy
          : <any>null;
      return data;
    }
  }

  export interface IUpsertCashPaymentOverrideCommand {
    clientId: string;
    id: string | null;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes: string[];
    cashBonusPolicy: CashBonusCashPaymentPolicy | null;
    stockOptionPolicy: StockOptionCashPaymentPolicy | null;
    restrictedStockUnitPolicy: RestrictedStockUnitCashPaymentPolicy | null;
  }

  export class DeleteCashPaymentOverrideCommandResult
    implements IDeleteCashPaymentOverrideCommandResult
  {
    constructor(data?: IDeleteCashPaymentOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteCashPaymentOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentOverrideCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteCashPaymentOverrideCommandResult {}

  export class DeleteCashPaymentOverrideCommandResultSuccess
    extends DeleteCashPaymentOverrideCommandResult
    implements IDeleteCashPaymentOverrideCommandResultSuccess
  {
    constructor(data?: IDeleteCashPaymentOverrideCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteCashPaymentOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashPaymentOverrideCommandResultSuccess
    extends IDeleteCashPaymentOverrideCommandResult {}

  export class DeleteCashPaymentOverrideCommandResultFailure
    extends DeleteCashPaymentOverrideCommandResult
    implements IDeleteCashPaymentOverrideCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDeleteCashPaymentOverrideCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteCashPaymentOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashPaymentOverrideCommandResultFailure
    extends IDeleteCashPaymentOverrideCommandResult {
    errorMessage: string;
  }

  export class DeleteCashPaymentOverrideCommand
    implements IDeleteCashPaymentOverrideCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteCashPaymentOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteCashPaymentOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteCashPaymentOverrideCommand {
    clientId: string;
    id: string;
  }

  export abstract class CheckCashPaymentOverrideDuplicateDataCommandResult
    implements ICheckCashPaymentOverrideDuplicateDataCommandResult
  {
    constructor(data?: ICheckCashPaymentOverrideDuplicateDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): CheckCashPaymentOverrideDuplicateDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckCashPaymentOverrideDuplicateDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckCashPaymentOverrideDuplicateDataCommandResult {}

  export class CheckCashPaymentOverrideDuplicateDataCommandResultSuccess
    extends CheckCashPaymentOverrideDuplicateDataCommandResult
    implements ICheckCashPaymentOverrideDuplicateDataCommandResultSuccess
  {
    duplicatesExist!: boolean;

    constructor(
      data?: ICheckCashPaymentOverrideDuplicateDataCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.duplicatesExist =
          _data['duplicatesExist'] !== undefined
            ? _data['duplicatesExist']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckCashPaymentOverrideDuplicateDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckCashPaymentOverrideDuplicateDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['duplicatesExist'] =
        this.duplicatesExist !== undefined ? this.duplicatesExist : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckCashPaymentOverrideDuplicateDataCommandResultSuccess
    extends ICheckCashPaymentOverrideDuplicateDataCommandResult {
    duplicatesExist: boolean;
  }

  export class CheckCashPaymentOverrideDuplicateDataCommandResultFailure
    extends CheckCashPaymentOverrideDuplicateDataCommandResult
    implements ICheckCashPaymentOverrideDuplicateDataCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ICheckCashPaymentOverrideDuplicateDataCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CheckCashPaymentOverrideDuplicateDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new CheckCashPaymentOverrideDuplicateDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckCashPaymentOverrideDuplicateDataCommandResultFailure
    extends ICheckCashPaymentOverrideDuplicateDataCommandResult {
    errorMessage: string;
  }

  export class CheckCashPaymentOverrideDuplicateDataCommand
    implements ICheckCashPaymentOverrideDuplicateDataCommand
  {
    id!: string | null;
    clientId!: string;
    employeeTransactionIds!: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes!: string[];

    constructor(data?: ICheckCashPaymentOverrideDuplicateDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeeTransactionIds = [];
        this.selectedPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeTransactionIds'])) {
          this.employeeTransactionIds = [] as any;
          for (let item of _data['employeeTransactionIds'])
            this.employeeTransactionIds!.push(
              EmployeeIdTransactionIdSettingDto.fromJS(item),
            );
        } else {
          this.employeeTransactionIds = <any>null;
        }
        if (Array.isArray(_data['selectedPlanCodes'])) {
          this.selectedPlanCodes = [] as any;
          for (let item of _data['selectedPlanCodes'])
            this.selectedPlanCodes!.push(item);
        } else {
          this.selectedPlanCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckCashPaymentOverrideDuplicateDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckCashPaymentOverrideDuplicateDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeTransactionIds)) {
        data['employeeTransactionIds'] = [];
        for (let item of this.employeeTransactionIds)
          data['employeeTransactionIds'].push(item.toJSON());
      }
      if (Array.isArray(this.selectedPlanCodes)) {
        data['selectedPlanCodes'] = [];
        for (let item of this.selectedPlanCodes)
          data['selectedPlanCodes'].push(item);
      }
      return data;
    }
  }

  export interface ICheckCashPaymentOverrideDuplicateDataCommand {
    id: string | null;
    clientId: string;
    employeeTransactionIds: EmployeeIdTransactionIdSettingDto[];
    selectedPlanCodes: string[];
  }

  export abstract class GetCashPaymentOverridesIndexPageDataQueryResult
    implements IGetCashPaymentOverridesIndexPageDataQueryResult
  {
    constructor(data?: IGetCashPaymentOverridesIndexPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCashPaymentOverridesIndexPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCashPaymentOverridesIndexPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCashPaymentOverridesIndexPageDataQueryResult {}

  export class GetCashPaymentOverridesIndexPageDataQueryResultSuccess
    extends GetCashPaymentOverridesIndexPageDataQueryResult
    implements IGetCashPaymentOverridesIndexPageDataQueryResultSuccess
  {
    result!: GetCashPaymentOverridesIndexPageData;

    constructor(
      data?: IGetCashPaymentOverridesIndexPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new GetCashPaymentOverridesIndexPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? GetCashPaymentOverridesIndexPageData.fromJS(_data['result'])
          : new GetCashPaymentOverridesIndexPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentOverridesIndexPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentOverridesIndexPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentOverridesIndexPageDataQueryResultSuccess
    extends IGetCashPaymentOverridesIndexPageDataQueryResult {
    result: GetCashPaymentOverridesIndexPageData;
  }

  export class GetCashPaymentOverridesIndexPageData
    implements IGetCashPaymentOverridesIndexPageData
  {
    planTypes!: PlanTypeDto[];
    taxOverridePlans!: TaxOverridePlanDto[];
    cashBonusCashPaymentPolicySettingOptions!: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions!: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions!: StockOptionCashPaymentPolicySettingDto[];
    cashBonusLineItems!: CashBonusCashPaymentOverrideLineItem[];
    restrictedStockUnitLineItems!: RestrictedStockUnitCashPaymentOverrideLineItem[];
    stockOptionLineItems!: StockOptionCashPaymentOverrideLineItem[];
    cashPaymentOverrideSettings!: CashPaymentOverrideSettings[];

    constructor(data?: IGetCashPaymentOverridesIndexPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.taxOverridePlans = [];
        this.cashBonusCashPaymentPolicySettingOptions = [];
        this.restrictedStockUnitCashPaymentPolicySettingOptions = [];
        this.stockOptionCashPaymentPolicySettingOptions = [];
        this.cashBonusLineItems = [];
        this.restrictedStockUnitLineItems = [];
        this.stockOptionLineItems = [];
        this.cashPaymentOverrideSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['taxOverridePlans'])) {
          this.taxOverridePlans = [] as any;
          for (let item of _data['taxOverridePlans'])
            this.taxOverridePlans!.push(TaxOverridePlanDto.fromJS(item));
        } else {
          this.taxOverridePlans = <any>null;
        }
        if (Array.isArray(_data['cashBonusCashPaymentPolicySettingOptions'])) {
          this.cashBonusCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['cashBonusCashPaymentPolicySettingOptions'])
            this.cashBonusCashPaymentPolicySettingOptions!.push(
              CashBonusCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitCashPaymentPolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitCashPaymentPolicySettingOptions'
          ])
            this.restrictedStockUnitCashPaymentPolicySettingOptions!.push(
              RestrictedStockUnitCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(_data['stockOptionCashPaymentPolicySettingOptions'])
        ) {
          this.stockOptionCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['stockOptionCashPaymentPolicySettingOptions'])
            this.stockOptionCashPaymentPolicySettingOptions!.push(
              StockOptionCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionCashPaymentPolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['cashBonusLineItems'])) {
          this.cashBonusLineItems = [] as any;
          for (let item of _data['cashBonusLineItems'])
            this.cashBonusLineItems!.push(
              CashBonusCashPaymentOverrideLineItem.fromJS(item),
            );
        } else {
          this.cashBonusLineItems = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitLineItems'])) {
          this.restrictedStockUnitLineItems = [] as any;
          for (let item of _data['restrictedStockUnitLineItems'])
            this.restrictedStockUnitLineItems!.push(
              RestrictedStockUnitCashPaymentOverrideLineItem.fromJS(item),
            );
        } else {
          this.restrictedStockUnitLineItems = <any>null;
        }
        if (Array.isArray(_data['stockOptionLineItems'])) {
          this.stockOptionLineItems = [] as any;
          for (let item of _data['stockOptionLineItems'])
            this.stockOptionLineItems!.push(
              StockOptionCashPaymentOverrideLineItem.fromJS(item),
            );
        } else {
          this.stockOptionLineItems = <any>null;
        }
        if (Array.isArray(_data['cashPaymentOverrideSettings'])) {
          this.cashPaymentOverrideSettings = [] as any;
          for (let item of _data['cashPaymentOverrideSettings'])
            this.cashPaymentOverrideSettings!.push(
              CashPaymentOverrideSettings.fromJS(item),
            );
        } else {
          this.cashPaymentOverrideSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): GetCashPaymentOverridesIndexPageData {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentOverridesIndexPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxOverridePlans)) {
        data['taxOverridePlans'] = [];
        for (let item of this.taxOverridePlans)
          data['taxOverridePlans'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusCashPaymentPolicySettingOptions)) {
        data['cashBonusCashPaymentPolicySettingOptions'] = [];
        for (let item of this.cashBonusCashPaymentPolicySettingOptions)
          data['cashBonusCashPaymentPolicySettingOptions'].push(item.toJSON());
      }
      if (
        Array.isArray(this.restrictedStockUnitCashPaymentPolicySettingOptions)
      ) {
        data['restrictedStockUnitCashPaymentPolicySettingOptions'] = [];
        for (let item of this
          .restrictedStockUnitCashPaymentPolicySettingOptions)
          data['restrictedStockUnitCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionCashPaymentPolicySettingOptions)) {
        data['stockOptionCashPaymentPolicySettingOptions'] = [];
        for (let item of this.stockOptionCashPaymentPolicySettingOptions)
          data['stockOptionCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.cashBonusLineItems)) {
        data['cashBonusLineItems'] = [];
        for (let item of this.cashBonusLineItems)
          data['cashBonusLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitLineItems)) {
        data['restrictedStockUnitLineItems'] = [];
        for (let item of this.restrictedStockUnitLineItems)
          data['restrictedStockUnitLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionLineItems)) {
        data['stockOptionLineItems'] = [];
        for (let item of this.stockOptionLineItems)
          data['stockOptionLineItems'].push(item.toJSON());
      }
      if (Array.isArray(this.cashPaymentOverrideSettings)) {
        data['cashPaymentOverrideSettings'] = [];
        for (let item of this.cashPaymentOverrideSettings)
          data['cashPaymentOverrideSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IGetCashPaymentOverridesIndexPageData {
    planTypes: PlanTypeDto[];
    taxOverridePlans: TaxOverridePlanDto[];
    cashBonusCashPaymentPolicySettingOptions: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions: StockOptionCashPaymentPolicySettingDto[];
    cashBonusLineItems: CashBonusCashPaymentOverrideLineItem[];
    restrictedStockUnitLineItems: RestrictedStockUnitCashPaymentOverrideLineItem[];
    stockOptionLineItems: StockOptionCashPaymentOverrideLineItem[];
    cashPaymentOverrideSettings: CashPaymentOverrideSettings[];
  }

  export class CashBonusCashPaymentOverrideLineItem
    implements ICashBonusCashPaymentOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem3[];

    constructor(data?: ICashBonusCashPaymentOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem3.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): CashBonusCashPaymentOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusCashPaymentOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashBonusCashPaymentOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem3[];
  }

  export class PlanCodeOverrideSubLineItem3
    implements IPlanCodeOverrideSubLineItem3
  {
    planCode!: string;
    overrideDisplay!: string;

    constructor(data?: IPlanCodeOverrideSubLineItem3) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
      }
    }

    static fromJS(data: any): PlanCodeOverrideSubLineItem3 {
      data = typeof data === 'object' ? data : {};
      let result = new PlanCodeOverrideSubLineItem3();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      return data;
    }
  }

  export interface IPlanCodeOverrideSubLineItem3 {
    planCode: string;
    overrideDisplay: string;
  }

  export class RestrictedStockUnitCashPaymentOverrideLineItem
    implements IRestrictedStockUnitCashPaymentOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem3[];

    constructor(data?: IRestrictedStockUnitCashPaymentOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem3.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): RestrictedStockUnitCashPaymentOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitCashPaymentOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRestrictedStockUnitCashPaymentOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem3[];
  }

  export class StockOptionCashPaymentOverrideLineItem
    implements IStockOptionCashPaymentOverrideLineItem
  {
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    overrideDisplay!: string | null;
    planCodeOverrides!: PlanCodeOverrideSubLineItem3[];

    constructor(data?: IStockOptionCashPaymentOverrideLineItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planCodeOverrides = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.overrideDisplay =
          _data['overrideDisplay'] !== undefined
            ? _data['overrideDisplay']
            : <any>null;
        if (Array.isArray(_data['planCodeOverrides'])) {
          this.planCodeOverrides = [] as any;
          for (let item of _data['planCodeOverrides'])
            this.planCodeOverrides!.push(
              PlanCodeOverrideSubLineItem3.fromJS(item),
            );
        } else {
          this.planCodeOverrides = <any>null;
        }
      }
    }

    static fromJS(data: any): StockOptionCashPaymentOverrideLineItem {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionCashPaymentOverrideLineItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['overrideDisplay'] =
        this.overrideDisplay !== undefined ? this.overrideDisplay : <any>null;
      if (Array.isArray(this.planCodeOverrides)) {
        data['planCodeOverrides'] = [];
        for (let item of this.planCodeOverrides)
          data['planCodeOverrides'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IStockOptionCashPaymentOverrideLineItem {
    id: string;
    employeeId: string;
    transactionId: string | null;
    overrideDisplay: string | null;
    planCodeOverrides: PlanCodeOverrideSubLineItem3[];
  }

  export class CashPaymentOverrideSettings
    extends TrackedAggregateRoot
    implements ICashPaymentOverrideSettings
  {
    clientId!: string;
    id!: string;
    employeeId!: string;
    transactionId!: string | null;
    selectedPlanIds!: string[];
    cashBonusPolicy!: CashBonusCashPaymentPolicy | null;
    stockOptionPolicy!: StockOptionCashPaymentPolicy | null;
    restrictedStockUnitPolicy!: RestrictedStockUnitCashPaymentPolicy | null;
    entityKey!: string;

    constructor(data?: ICashPaymentOverrideSettings) {
      super(data);
      if (!data) {
        this.selectedPlanIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['selectedPlanIds'])) {
          this.selectedPlanIds = [] as any;
          for (let item of _data['selectedPlanIds'])
            this.selectedPlanIds!.push(item);
        } else {
          this.selectedPlanIds = <any>null;
        }
        this.cashBonusPolicy =
          _data['cashBonusPolicy'] !== undefined
            ? _data['cashBonusPolicy']
            : <any>null;
        this.stockOptionPolicy =
          _data['stockOptionPolicy'] !== undefined
            ? _data['stockOptionPolicy']
            : <any>null;
        this.restrictedStockUnitPolicy =
          _data['restrictedStockUnitPolicy'] !== undefined
            ? _data['restrictedStockUnitPolicy']
            : <any>null;
        this.entityKey =
          _data['entityKey'] !== undefined ? _data['entityKey'] : <any>null;
      }
    }

    static override fromJS(data: any): CashPaymentOverrideSettings {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentOverrideSettings();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.selectedPlanIds)) {
        data['selectedPlanIds'] = [];
        for (let item of this.selectedPlanIds)
          data['selectedPlanIds'].push(item);
      }
      data['cashBonusPolicy'] =
        this.cashBonusPolicy !== undefined ? this.cashBonusPolicy : <any>null;
      data['stockOptionPolicy'] =
        this.stockOptionPolicy !== undefined
          ? this.stockOptionPolicy
          : <any>null;
      data['restrictedStockUnitPolicy'] =
        this.restrictedStockUnitPolicy !== undefined
          ? this.restrictedStockUnitPolicy
          : <any>null;
      data['entityKey'] =
        this.entityKey !== undefined ? this.entityKey : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICashPaymentOverrideSettings extends ITrackedAggregateRoot {
    clientId: string;
    id: string;
    employeeId: string;
    transactionId: string | null;
    selectedPlanIds: string[];
    cashBonusPolicy: CashBonusCashPaymentPolicy | null;
    stockOptionPolicy: StockOptionCashPaymentPolicy | null;
    restrictedStockUnitPolicy: RestrictedStockUnitCashPaymentPolicy | null;
    entityKey: string;
  }

  export class GetCashPaymentOverridesIndexPageDataQueryResultFailure
    extends GetCashPaymentOverridesIndexPageDataQueryResult
    implements IGetCashPaymentOverridesIndexPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetCashPaymentOverridesIndexPageDataQueryResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentOverridesIndexPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentOverridesIndexPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentOverridesIndexPageDataQueryResultFailure
    extends IGetCashPaymentOverridesIndexPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetTaxAdjustmentDataQueryResult
    implements IGetTaxAdjustmentDataQueryResult
  {
    constructor(data?: IGetTaxAdjustmentDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxAdjustmentDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxAdjustmentDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxAdjustmentDataQueryResult {}

  export class GetTaxAdjustmentDataQueryResultSuccess
    extends GetTaxAdjustmentDataQueryResult
    implements IGetTaxAdjustmentDataQueryResultSuccess
  {
    result!: TaxAdjustmentPageData;

    constructor(data?: IGetTaxAdjustmentDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TaxAdjustmentPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxAdjustmentPageData.fromJS(_data['result'])
          : new TaxAdjustmentPageData();
      }
    }

    static override fromJS(data: any): GetTaxAdjustmentDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxAdjustmentDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxAdjustmentDataQueryResultSuccess
    extends IGetTaxAdjustmentDataQueryResult {
    result: TaxAdjustmentPageData;
  }

  export class TaxAdjustmentPageData implements ITaxAdjustmentPageData {
    adjustmentSettings!: TaxAdjustmentSettingsDto | null;
    locationPriorityOption!: LocationPriorityOptionDto[];
    nssRoundingOption!: NSSRoundingDto[];
    nssTaxTypeOrderingOption!: NSSTaxTypeOrderingOptionDto[];

    constructor(data?: ITaxAdjustmentPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.locationPriorityOption = [];
        this.nssRoundingOption = [];
        this.nssTaxTypeOrderingOption = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.adjustmentSettings = _data['adjustmentSettings']
          ? TaxAdjustmentSettingsDto.fromJS(_data['adjustmentSettings'])
          : <any>null;
        if (Array.isArray(_data['locationPriorityOption'])) {
          this.locationPriorityOption = [] as any;
          for (let item of _data['locationPriorityOption'])
            this.locationPriorityOption!.push(
              LocationPriorityOptionDto.fromJS(item),
            );
        } else {
          this.locationPriorityOption = <any>null;
        }
        if (Array.isArray(_data['nssRoundingOption'])) {
          this.nssRoundingOption = [] as any;
          for (let item of _data['nssRoundingOption'])
            this.nssRoundingOption!.push(NSSRoundingDto.fromJS(item));
        } else {
          this.nssRoundingOption = <any>null;
        }
        if (Array.isArray(_data['nssTaxTypeOrderingOption'])) {
          this.nssTaxTypeOrderingOption = [] as any;
          for (let item of _data['nssTaxTypeOrderingOption'])
            this.nssTaxTypeOrderingOption!.push(
              NSSTaxTypeOrderingOptionDto.fromJS(item),
            );
        } else {
          this.nssTaxTypeOrderingOption = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxAdjustmentPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxAdjustmentPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['adjustmentSettings'] = this.adjustmentSettings
        ? this.adjustmentSettings.toJSON()
        : <any>null;
      if (Array.isArray(this.locationPriorityOption)) {
        data['locationPriorityOption'] = [];
        for (let item of this.locationPriorityOption)
          data['locationPriorityOption'].push(item.toJSON());
      }
      if (Array.isArray(this.nssRoundingOption)) {
        data['nssRoundingOption'] = [];
        for (let item of this.nssRoundingOption)
          data['nssRoundingOption'].push(item.toJSON());
      }
      if (Array.isArray(this.nssTaxTypeOrderingOption)) {
        data['nssTaxTypeOrderingOption'] = [];
        for (let item of this.nssTaxTypeOrderingOption)
          data['nssTaxTypeOrderingOption'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxAdjustmentPageData {
    adjustmentSettings: TaxAdjustmentSettingsDto | null;
    locationPriorityOption: LocationPriorityOptionDto[];
    nssRoundingOption: NSSRoundingDto[];
    nssTaxTypeOrderingOption: NSSTaxTypeOrderingOptionDto[];
  }

  export class TaxAdjustmentSettingsDto implements ITaxAdjustmentSettingsDto {
    id!: string | null;
    clientId!: string;
    configuration!: TaxAdjustmentConfigurationDto | null;

    constructor(data?: ITaxAdjustmentSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.configuration = _data['configuration']
          ? TaxAdjustmentConfigurationDto.fromJS(_data['configuration'])
          : <any>null;
      }
    }

    static fromJS(data: any): TaxAdjustmentSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxAdjustmentSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxAdjustmentSettingsDto {
    id: string | null;
    clientId: string;
    configuration: TaxAdjustmentConfigurationDto | null;
  }

  export class TaxAdjustmentConfigurationDto
    implements ITaxAdjustmentConfigurationDto
  {
    gainAdjustmentSettings!: GainAdjustmentSettingsDto | null;
    taxTypeOrdering!: TaxOrderingOptionDto[];

    constructor(data?: ITaxAdjustmentConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxTypeOrdering = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.gainAdjustmentSettings = _data['gainAdjustmentSettings']
          ? GainAdjustmentSettingsDto.fromJS(_data['gainAdjustmentSettings'])
          : <any>null;
        if (Array.isArray(_data['taxTypeOrdering'])) {
          this.taxTypeOrdering = [] as any;
          for (let item of _data['taxTypeOrdering'])
            this.taxTypeOrdering!.push(TaxOrderingOptionDto.fromJS(item));
        } else {
          this.taxTypeOrdering = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxAdjustmentConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxAdjustmentConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['gainAdjustmentSettings'] = this.gainAdjustmentSettings
        ? this.gainAdjustmentSettings.toJSON()
        : <any>null;
      if (Array.isArray(this.taxTypeOrdering)) {
        data['taxTypeOrdering'] = [];
        for (let item of this.taxTypeOrdering)
          data['taxTypeOrdering'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxAdjustmentConfigurationDto {
    gainAdjustmentSettings: GainAdjustmentSettingsDto | null;
    taxTypeOrdering: TaxOrderingOptionDto[];
  }

  export class GainAdjustmentSettingsDto implements IGainAdjustmentSettingsDto {
    decimalRoundingPlace!: number;

    constructor(data?: IGainAdjustmentSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.decimalRoundingPlace =
          _data['decimalRoundingPlace'] !== undefined
            ? _data['decimalRoundingPlace']
            : <any>null;
      }
    }

    static fromJS(data: any): GainAdjustmentSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new GainAdjustmentSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['decimalRoundingPlace'] =
        this.decimalRoundingPlace !== undefined
          ? this.decimalRoundingPlace
          : <any>null;
      return data;
    }
  }

  export interface IGainAdjustmentSettingsDto {
    decimalRoundingPlace: number;
  }

  export class TaxOrderingOptionDto implements ITaxOrderingOptionDto {
    taxTypeOrderingOption!: NSSTaxTypeOrderingOption;
    orderNumber!: number;

    constructor(data?: ITaxOrderingOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxTypeOrderingOption =
          _data['taxTypeOrderingOption'] !== undefined
            ? _data['taxTypeOrderingOption']
            : <any>null;
        this.orderNumber =
          _data['orderNumber'] !== undefined ? _data['orderNumber'] : <any>null;
      }
    }

    static fromJS(data: any): TaxOrderingOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxOrderingOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxTypeOrderingOption'] =
        this.taxTypeOrderingOption !== undefined
          ? this.taxTypeOrderingOption
          : <any>null;
      data['orderNumber'] =
        this.orderNumber !== undefined ? this.orderNumber : <any>null;
      return data;
    }
  }

  export interface ITaxOrderingOptionDto {
    taxTypeOrderingOption: NSSTaxTypeOrderingOption;
    orderNumber: number;
  }

  export enum NSSTaxTypeOrderingOption {
    HypotheticalTax = 'HypotheticalTax',
    USIncomeTax = 'USIncomeTax',
    USSocialTax = 'USSocialTax',
    USRegionIncomeTax = 'USRegionIncomeTax',
    USRegionSocialTax = 'USRegionSocialTax',
    CurrentPayrollIncomeTax = 'CurrentPayrollIncomeTax',
    CurrentPayrollSocialTax = 'CurrentPayrollSocialTax',
    CurrentPayrollRegionIncomeTax = 'CurrentPayrollRegionIncomeTax',
    CurrentPayrollRegionSocialTax = 'CurrentPayrollRegionSocialTax',
    OtherLocationsInOrderOfLocationPeriodIncomeTax = 'OtherLocationsInOrderOfLocationPeriodIncomeTax',
    OtherLocationsInOrderOfLocationPeriodSocialTax = 'OtherLocationsInOrderOfLocationPeriodSocialTax',
    OtherLocationsInOrderOfLocationPeriodRegionIncomeTax = 'OtherLocationsInOrderOfLocationPeriodRegionIncomeTax',
    OtherLocationsInOrderOfLocationPeriodRegionSocialTax = 'OtherLocationsInOrderOfLocationPeriodRegionSocialTax',
  }

  export class LocationPriorityOptionDto implements ILocationPriorityOptionDto {
    optionValue!: LocationPriorityOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ILocationPriorityOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): LocationPriorityOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new LocationPriorityOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ILocationPriorityOptionDto {
    optionValue: LocationPriorityOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum LocationPriorityOption {
    US = 'US',
    CurrentPayroll = 'CurrentPayroll',
  }

  export class NSSRoundingDto implements INSSRoundingDto {
    optionValue!: NSSRounding;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: INSSRoundingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): NSSRoundingDto {
      data = typeof data === 'object' ? data : {};
      let result = new NSSRoundingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface INSSRoundingDto {
    optionValue: NSSRounding;
    displayValue: string;
    displayOrder: number;
  }

  export enum NSSRounding {
    GAIN = 'GAIN',
    Broker = 'Broker',
  }

  export class NSSTaxTypeOrderingOptionDto
    implements INSSTaxTypeOrderingOptionDto
  {
    optionValue!: NSSTaxTypeOrderingOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: INSSTaxTypeOrderingOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): NSSTaxTypeOrderingOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new NSSTaxTypeOrderingOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface INSSTaxTypeOrderingOptionDto {
    optionValue: NSSTaxTypeOrderingOption;
    displayValue: string;
    displayOrder: number;
  }

  export class GetTaxAdjustmentDataQueryResultFailure
    extends GetTaxAdjustmentDataQueryResult
    implements IGetTaxAdjustmentDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxAdjustmentDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetTaxAdjustmentDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxAdjustmentDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxAdjustmentDataQueryResultFailure
    extends IGetTaxAdjustmentDataQueryResult {
    errors: ResultError[];
  }

  export abstract class UpsertTaxAdjustmentCommandResult
    implements IUpsertTaxAdjustmentCommandResult
  {
    constructor(data?: IUpsertTaxAdjustmentCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTaxAdjustmentCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertTaxAdjustmentCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTaxAdjustmentCommandResult {}

  export class UpsertTaxAdjustmentCommandResultSuccess
    extends UpsertTaxAdjustmentCommandResult
    implements IUpsertTaxAdjustmentCommandResultSuccess
  {
    constructor(data?: IUpsertTaxAdjustmentCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpsertTaxAdjustmentCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxAdjustmentCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxAdjustmentCommandResultSuccess
    extends IUpsertTaxAdjustmentCommandResult {}

  export class UpsertTaxAdjustmentCommandResultFailure
    extends UpsertTaxAdjustmentCommandResult
    implements IUpsertTaxAdjustmentCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertTaxAdjustmentCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpsertTaxAdjustmentCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxAdjustmentCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxAdjustmentCommandResultFailure
    extends IUpsertTaxAdjustmentCommandResult {
    errors: ResultError[];
  }

  export class UpsertTaxAdjustmentCommand
    implements IUpsertTaxAdjustmentCommand
  {
    clientId!: string;
    taxAdjustmentSettings!: TaxAdjustmentSettingsDto;

    constructor(data?: IUpsertTaxAdjustmentCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxAdjustmentSettings = new TaxAdjustmentSettingsDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.taxAdjustmentSettings = _data['taxAdjustmentSettings']
          ? TaxAdjustmentSettingsDto.fromJS(_data['taxAdjustmentSettings'])
          : new TaxAdjustmentSettingsDto();
      }
    }

    static fromJS(data: any): UpsertTaxAdjustmentCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxAdjustmentCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['taxAdjustmentSettings'] = this.taxAdjustmentSettings
        ? this.taxAdjustmentSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertTaxAdjustmentCommand {
    clientId: string;
    taxAdjustmentSettings: TaxAdjustmentSettingsDto;
  }

  export class GetTaxableConsiderationPageDataQueryResult
    implements IGetTaxableConsiderationPageDataQueryResult
  {
    constructor(data?: IGetTaxableConsiderationPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTaxableConsiderationPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxableConsiderationPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTaxableConsiderationPageDataQueryResult {}

  export class GetTaxableConsiderationPageDataQueryResultSuccess
    extends GetTaxableConsiderationPageDataQueryResult
    implements IGetTaxableConsiderationPageDataQueryResultSuccess
  {
    result!: TaxableConsiderationPageData;

    constructor(data?: IGetTaxableConsiderationPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TaxableConsiderationPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TaxableConsiderationPageData.fromJS(_data['result'])
          : new TaxableConsiderationPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxableConsiderationPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxableConsiderationPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxableConsiderationPageDataQueryResultSuccess
    extends IGetTaxableConsiderationPageDataQueryResult {
    result: TaxableConsiderationPageData;
  }

  export class TaxableConsiderationPageData
    implements ITaxableConsiderationPageData
  {
    taxableLocationConsiderations!: TaxableLocationConsiderationDto[];
    scenarios!: TaxableConsiderationScenarios;
    dropdownOptions!: TaxableConsiderationDropdownOptionDto[];

    constructor(data?: ITaxableConsiderationPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxableLocationConsiderations = [];
        this.scenarios = new TaxableConsiderationScenarios();
        this.dropdownOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxableLocationConsiderations'])) {
          this.taxableLocationConsiderations = [] as any;
          for (let item of _data['taxableLocationConsiderations'])
            this.taxableLocationConsiderations!.push(
              TaxableLocationConsiderationDto.fromJS(item),
            );
        } else {
          this.taxableLocationConsiderations = <any>null;
        }
        this.scenarios = _data['scenarios']
          ? TaxableConsiderationScenarios.fromJS(_data['scenarios'])
          : new TaxableConsiderationScenarios();
        if (Array.isArray(_data['dropdownOptions'])) {
          this.dropdownOptions = [] as any;
          for (let item of _data['dropdownOptions'])
            this.dropdownOptions!.push(
              TaxableConsiderationDropdownOptionDto.fromJS(item),
            );
        } else {
          this.dropdownOptions = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxableConsiderationPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableConsiderationPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxableLocationConsiderations)) {
        data['taxableLocationConsiderations'] = [];
        for (let item of this.taxableLocationConsiderations)
          data['taxableLocationConsiderations'].push(item.toJSON());
      }
      data['scenarios'] = this.scenarios ? this.scenarios.toJSON() : <any>null;
      if (Array.isArray(this.dropdownOptions)) {
        data['dropdownOptions'] = [];
        for (let item of this.dropdownOptions)
          data['dropdownOptions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxableConsiderationPageData {
    taxableLocationConsiderations: TaxableLocationConsiderationDto[];
    scenarios: TaxableConsiderationScenarios;
    dropdownOptions: TaxableConsiderationDropdownOptionDto[];
  }

  export class TaxableLocationConsiderationDto
    implements ITaxableLocationConsiderationDto
  {
    optionValue!: TaxableLocationConsideration;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxableLocationConsiderationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxableLocationConsiderationDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableLocationConsiderationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxableLocationConsiderationDto {
    optionValue: TaxableLocationConsideration;
    displayValue: string;
    displayOrder: number;
  }

  export enum TaxableLocationConsideration {
    AssignedWorkLocation = 'AssignedWorkLocation',
    LiveLocation = 'LiveLocation',
    EmploymentContractLocation = 'EmploymentContractLocation',
  }

  export class TaxableConsiderationScenarios
    implements ITaxableConsiderationScenarios
  {
    scenarioAAA!: TaxableConsiderationScenario;
    scenarioABA!: TaxableConsiderationScenario;
    scenarioAAB!: TaxableConsiderationScenario;
    scenarioABC!: TaxableConsiderationScenario;
    scenarioABB!: TaxableConsiderationScenario;

    constructor(data?: ITaxableConsiderationScenarios) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.scenarioAAA = new TaxableConsiderationScenario();
        this.scenarioABA = new TaxableConsiderationScenario();
        this.scenarioAAB = new TaxableConsiderationScenario();
        this.scenarioABC = new TaxableConsiderationScenario();
        this.scenarioABB = new TaxableConsiderationScenario();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.scenarioAAA = _data['scenarioAAA']
          ? TaxableConsiderationScenario.fromJS(_data['scenarioAAA'])
          : new TaxableConsiderationScenario();
        this.scenarioABA = _data['scenarioABA']
          ? TaxableConsiderationScenario.fromJS(_data['scenarioABA'])
          : new TaxableConsiderationScenario();
        this.scenarioAAB = _data['scenarioAAB']
          ? TaxableConsiderationScenario.fromJS(_data['scenarioAAB'])
          : new TaxableConsiderationScenario();
        this.scenarioABC = _data['scenarioABC']
          ? TaxableConsiderationScenario.fromJS(_data['scenarioABC'])
          : new TaxableConsiderationScenario();
        this.scenarioABB = _data['scenarioABB']
          ? TaxableConsiderationScenario.fromJS(_data['scenarioABB'])
          : new TaxableConsiderationScenario();
      }
    }

    static fromJS(data: any): TaxableConsiderationScenarios {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableConsiderationScenarios();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['scenarioAAA'] = this.scenarioAAA
        ? this.scenarioAAA.toJSON()
        : <any>null;
      data['scenarioABA'] = this.scenarioABA
        ? this.scenarioABA.toJSON()
        : <any>null;
      data['scenarioAAB'] = this.scenarioAAB
        ? this.scenarioAAB.toJSON()
        : <any>null;
      data['scenarioABC'] = this.scenarioABC
        ? this.scenarioABC.toJSON()
        : <any>null;
      data['scenarioABB'] = this.scenarioABB
        ? this.scenarioABB.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ITaxableConsiderationScenarios {
    scenarioAAA: TaxableConsiderationScenario;
    scenarioABA: TaxableConsiderationScenario;
    scenarioAAB: TaxableConsiderationScenario;
    scenarioABC: TaxableConsiderationScenario;
    scenarioABB: TaxableConsiderationScenario;
  }

  export class TaxableConsiderationScenario
    implements ITaxableConsiderationScenario
  {
    defaults!: TaxableLocationConsideration[];
    cellLabelByTaxableLocationConsideration!: { [key: string]: string };
    userSelections!: TaxableLocationConsideration[] | null;

    constructor(data?: ITaxableConsiderationScenario) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.defaults = [];
        this.cellLabelByTaxableLocationConsideration = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['defaults'])) {
          this.defaults = [] as any;
          for (let item of _data['defaults']) this.defaults!.push(item);
        } else {
          this.defaults = <any>null;
        }
        if (_data['cellLabelByTaxableLocationConsideration']) {
          this.cellLabelByTaxableLocationConsideration = {} as any;
          for (let key in _data['cellLabelByTaxableLocationConsideration']) {
            if (
              _data['cellLabelByTaxableLocationConsideration'].hasOwnProperty(
                key,
              )
            )
              (<any>this.cellLabelByTaxableLocationConsideration)![key] =
                _data['cellLabelByTaxableLocationConsideration'][key] !==
                undefined
                  ? _data['cellLabelByTaxableLocationConsideration'][key]
                  : <any>null;
          }
        } else {
          this.cellLabelByTaxableLocationConsideration = <any>null;
        }
        if (Array.isArray(_data['userSelections'])) {
          this.userSelections = [] as any;
          for (let item of _data['userSelections'])
            this.userSelections!.push(item);
        } else {
          this.userSelections = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxableConsiderationScenario {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableConsiderationScenario();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.defaults)) {
        data['defaults'] = [];
        for (let item of this.defaults) data['defaults'].push(item);
      }
      if (this.cellLabelByTaxableLocationConsideration) {
        data['cellLabelByTaxableLocationConsideration'] = {};
        for (let key in this.cellLabelByTaxableLocationConsideration) {
          if (this.cellLabelByTaxableLocationConsideration.hasOwnProperty(key))
            (<any>data['cellLabelByTaxableLocationConsideration'])[key] =
              this.cellLabelByTaxableLocationConsideration[key] !== undefined
                ? this.cellLabelByTaxableLocationConsideration[key]
                : <any>null;
        }
      }
      if (Array.isArray(this.userSelections)) {
        data['userSelections'] = [];
        for (let item of this.userSelections) data['userSelections'].push(item);
      }
      return data;
    }
  }

  export interface ITaxableConsiderationScenario {
    defaults: TaxableLocationConsideration[];
    cellLabelByTaxableLocationConsideration: { [key: string]: string };
    userSelections: TaxableLocationConsideration[] | null;
  }

  export class TaxableConsiderationDropdownOptionDto
    implements ITaxableConsiderationDropdownOptionDto
  {
    optionValue!: TaxableConsiderationDropdownOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxableConsiderationDropdownOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxableConsiderationDropdownOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableConsiderationDropdownOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxableConsiderationDropdownOptionDto {
    optionValue: TaxableConsiderationDropdownOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum TaxableConsiderationDropdownOption {
    AssignedWorkLocation = 'AssignedWorkLocation',
    LiveLocation = 'LiveLocation',
    EmploymentContractLocation = 'EmploymentContractLocation',
    DeloitteDefault = 'DeloitteDefault',
  }

  export class GetTaxableConsiderationPageDataQueryResultFailure
    extends GetTaxableConsiderationPageDataQueryResult
    implements IGetTaxableConsiderationPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTaxableConsiderationPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTaxableConsiderationPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTaxableConsiderationPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTaxableConsiderationPageDataQueryResultFailure
    extends IGetTaxableConsiderationPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertTaxableConsiderationSettingsCommandResult
    implements IUpsertTaxableConsiderationSettingsCommandResult
  {
    constructor(data?: IUpsertTaxableConsiderationSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertTaxableConsiderationSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxableConsiderationSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertTaxableConsiderationSettingsCommandResult {}

  export class UpsertTaxableConsiderationSettingsCommandResultSuccess
    extends UpsertTaxableConsiderationSettingsCommandResult
    implements IUpsertTaxableConsiderationSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertTaxableConsiderationSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertTaxableConsiderationSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxableConsiderationSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxableConsiderationSettingsCommandResultSuccess
    extends IUpsertTaxableConsiderationSettingsCommandResult {}

  export class UpsertTaxableConsiderationSettingsCommandResultFailure
    extends UpsertTaxableConsiderationSettingsCommandResult
    implements IUpsertTaxableConsiderationSettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IUpsertTaxableConsiderationSettingsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertTaxableConsiderationSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxableConsiderationSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertTaxableConsiderationSettingsCommandResultFailure
    extends IUpsertTaxableConsiderationSettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertTaxableConsiderationSettingsCommand
    implements IUpsertTaxableConsiderationSettingsCommand
  {
    clientId!: string;
    taxableConsiderationSettings!: TaxableConsiderationSettingsUpsertDto;

    constructor(data?: IUpsertTaxableConsiderationSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxableConsiderationSettings =
          new TaxableConsiderationSettingsUpsertDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.taxableConsiderationSettings = _data[
          'taxableConsiderationSettings'
        ]
          ? TaxableConsiderationSettingsUpsertDto.fromJS(
              _data['taxableConsiderationSettings'],
            )
          : new TaxableConsiderationSettingsUpsertDto();
      }
    }

    static fromJS(data: any): UpsertTaxableConsiderationSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertTaxableConsiderationSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['taxableConsiderationSettings'] = this.taxableConsiderationSettings
        ? this.taxableConsiderationSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertTaxableConsiderationSettingsCommand {
    clientId: string;
    taxableConsiderationSettings: TaxableConsiderationSettingsUpsertDto;
  }

  export class TaxableConsiderationSettingsUpsertDto
    implements ITaxableConsiderationSettingsUpsertDto
  {
    scenarioAAA!: TaxableLocationConsideration[];
    scenarioABA!: TaxableLocationConsideration[];
    scenarioAAB!: TaxableLocationConsideration[];
    scenarioABC!: TaxableLocationConsideration[];
    scenarioABB!: TaxableLocationConsideration[];

    constructor(data?: ITaxableConsiderationSettingsUpsertDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.scenarioAAA = [];
        this.scenarioABA = [];
        this.scenarioAAB = [];
        this.scenarioABC = [];
        this.scenarioABB = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['scenarioAAA'])) {
          this.scenarioAAA = [] as any;
          for (let item of _data['scenarioAAA']) this.scenarioAAA!.push(item);
        } else {
          this.scenarioAAA = <any>null;
        }
        if (Array.isArray(_data['scenarioABA'])) {
          this.scenarioABA = [] as any;
          for (let item of _data['scenarioABA']) this.scenarioABA!.push(item);
        } else {
          this.scenarioABA = <any>null;
        }
        if (Array.isArray(_data['scenarioAAB'])) {
          this.scenarioAAB = [] as any;
          for (let item of _data['scenarioAAB']) this.scenarioAAB!.push(item);
        } else {
          this.scenarioAAB = <any>null;
        }
        if (Array.isArray(_data['scenarioABC'])) {
          this.scenarioABC = [] as any;
          for (let item of _data['scenarioABC']) this.scenarioABC!.push(item);
        } else {
          this.scenarioABC = <any>null;
        }
        if (Array.isArray(_data['scenarioABB'])) {
          this.scenarioABB = [] as any;
          for (let item of _data['scenarioABB']) this.scenarioABB!.push(item);
        } else {
          this.scenarioABB = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxableConsiderationSettingsUpsertDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxableConsiderationSettingsUpsertDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.scenarioAAA)) {
        data['scenarioAAA'] = [];
        for (let item of this.scenarioAAA) data['scenarioAAA'].push(item);
      }
      if (Array.isArray(this.scenarioABA)) {
        data['scenarioABA'] = [];
        for (let item of this.scenarioABA) data['scenarioABA'].push(item);
      }
      if (Array.isArray(this.scenarioAAB)) {
        data['scenarioAAB'] = [];
        for (let item of this.scenarioAAB) data['scenarioAAB'].push(item);
      }
      if (Array.isArray(this.scenarioABC)) {
        data['scenarioABC'] = [];
        for (let item of this.scenarioABC) data['scenarioABC'].push(item);
      }
      if (Array.isArray(this.scenarioABB)) {
        data['scenarioABB'] = [];
        for (let item of this.scenarioABB) data['scenarioABB'].push(item);
      }
      return data;
    }
  }

  export interface ITaxableConsiderationSettingsUpsertDto {
    scenarioAAA: TaxableLocationConsideration[];
    scenarioABA: TaxableLocationConsideration[];
    scenarioAAB: TaxableLocationConsideration[];
    scenarioABC: TaxableLocationConsideration[];
    scenarioABB: TaxableLocationConsideration[];
  }

  export class GetSocialTaxRatePolicyPageDataQueryResult
    implements IGetSocialTaxRatePolicyPageDataQueryResult
  {
    constructor(data?: IGetSocialTaxRatePolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetSocialTaxRatePolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxRatePolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSocialTaxRatePolicyPageDataQueryResult {}

  export class GetSocialTaxRatePolicyPageDataQueryResultSuccess
    extends GetSocialTaxRatePolicyPageDataQueryResult
    implements IGetSocialTaxRatePolicyPageDataQueryResultSuccess
  {
    result!: SocialTaxRatePolicyPageData;

    constructor(data?: IGetSocialTaxRatePolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new SocialTaxRatePolicyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? SocialTaxRatePolicyPageData.fromJS(_data['result'])
          : new SocialTaxRatePolicyPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxRatePolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxRatePolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxRatePolicyPageDataQueryResultSuccess
    extends IGetSocialTaxRatePolicyPageDataQueryResult {
    result: SocialTaxRatePolicyPageData;
  }

  export class SocialTaxRatePolicyPageData
    implements ISocialTaxRatePolicyPageData
  {
    socialTaxRatePolicyOptions!: SocialTaxRatePolicyDto[];
    batchActionOptions!: SocialTaxRatePolicyBatchActionOptionDto[];
    countriesInFootprint!: SocialTaxRatePolicyCountryData[];
    socialTaxRatePolicySettings!: SocialTaxRatePolicySettingsDto | null;

    constructor(data?: ISocialTaxRatePolicyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.socialTaxRatePolicyOptions = [];
        this.batchActionOptions = [];
        this.countriesInFootprint = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['socialTaxRatePolicyOptions'])) {
          this.socialTaxRatePolicyOptions = [] as any;
          for (let item of _data['socialTaxRatePolicyOptions'])
            this.socialTaxRatePolicyOptions!.push(
              SocialTaxRatePolicyDto.fromJS(item),
            );
        } else {
          this.socialTaxRatePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['batchActionOptions'])) {
          this.batchActionOptions = [] as any;
          for (let item of _data['batchActionOptions'])
            this.batchActionOptions!.push(
              SocialTaxRatePolicyBatchActionOptionDto.fromJS(item),
            );
        } else {
          this.batchActionOptions = <any>null;
        }
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              SocialTaxRatePolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        this.socialTaxRatePolicySettings = _data['socialTaxRatePolicySettings']
          ? SocialTaxRatePolicySettingsDto.fromJS(
              _data['socialTaxRatePolicySettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxRatePolicyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxRatePolicyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.socialTaxRatePolicyOptions)) {
        data['socialTaxRatePolicyOptions'] = [];
        for (let item of this.socialTaxRatePolicyOptions)
          data['socialTaxRatePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.batchActionOptions)) {
        data['batchActionOptions'] = [];
        for (let item of this.batchActionOptions)
          data['batchActionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      data['socialTaxRatePolicySettings'] = this.socialTaxRatePolicySettings
        ? this.socialTaxRatePolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxRatePolicyPageData {
    socialTaxRatePolicyOptions: SocialTaxRatePolicyDto[];
    batchActionOptions: SocialTaxRatePolicyBatchActionOptionDto[];
    countriesInFootprint: SocialTaxRatePolicyCountryData[];
    socialTaxRatePolicySettings: SocialTaxRatePolicySettingsDto | null;
  }

  export class SocialTaxRatePolicyDto implements ISocialTaxRatePolicyDto {
    optionValue!: SocialTaxRatePolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ISocialTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ISocialTaxRatePolicyDto {
    optionValue: SocialTaxRatePolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum SocialTaxRatePolicy {
    AssumeCapsHaveBeenMet = 'AssumeCapsHaveBeenMet',
    DoNotAssumeCapsHaveBeenMet = 'DoNotAssumeCapsHaveBeenMet',
  }

  export class SocialTaxRatePolicyBatchActionOptionDto
    implements ISocialTaxRatePolicyBatchActionOptionDto
  {
    optionValue!: SocialTaxRatePolicyBatchActionOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ISocialTaxRatePolicyBatchActionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxRatePolicyBatchActionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxRatePolicyBatchActionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ISocialTaxRatePolicyBatchActionOptionDto {
    optionValue: SocialTaxRatePolicyBatchActionOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum SocialTaxRatePolicyBatchActionOption {
    CompanyDefault = 'CompanyDefault',
    AssumeCapsHaveBeenMet = 'AssumeCapsHaveBeenMet',
    DoNotAssumeCapsHaveBeenMet = 'DoNotAssumeCapsHaveBeenMet',
  }

  export class SocialTaxRatePolicyCountryData
    implements ISocialTaxRatePolicyCountryData
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: ISocialTaxRatePolicyCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxRatePolicyCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxRatePolicyCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface ISocialTaxRatePolicyCountryData {
    countryCode: string;
    countryName: string;
  }

  export class SocialTaxRatePolicySettingsDto
    implements ISocialTaxRatePolicySettingsDto
  {
    id!: string;
    companyDefault!: SocialTaxRatePolicy;
    countrySettings!: CountrySocialTaxRatePolicySettingDto[];
    countrySettingsByCountry!: {
      [key: string]: CountrySocialTaxRatePolicySettingDto;
    };

    constructor(data?: ISocialTaxRatePolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
        this.countrySettingsByCountry = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.companyDefault =
          _data['companyDefault'] !== undefined
            ? _data['companyDefault']
            : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CountrySocialTaxRatePolicySettingDto.fromJS(item),
            );
        } else {
          this.countrySettings = <any>null;
        }
        if (_data['countrySettingsByCountry']) {
          this.countrySettingsByCountry = {} as any;
          for (let key in _data['countrySettingsByCountry']) {
            if (_data['countrySettingsByCountry'].hasOwnProperty(key))
              (<any>this.countrySettingsByCountry)![key] = _data[
                'countrySettingsByCountry'
              ][key]
                ? CountrySocialTaxRatePolicySettingDto.fromJS(
                    _data['countrySettingsByCountry'][key],
                  )
                : new CountrySocialTaxRatePolicySettingDto();
          }
        } else {
          this.countrySettingsByCountry = <any>null;
        }
      }
    }

    static fromJS(data: any): SocialTaxRatePolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxRatePolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['companyDefault'] =
        this.companyDefault !== undefined ? this.companyDefault : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      if (this.countrySettingsByCountry) {
        data['countrySettingsByCountry'] = {};
        for (let key in this.countrySettingsByCountry) {
          if (this.countrySettingsByCountry.hasOwnProperty(key))
            (<any>data['countrySettingsByCountry'])[key] = this
              .countrySettingsByCountry[key]
              ? this.countrySettingsByCountry[key].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface ISocialTaxRatePolicySettingsDto {
    id: string;
    companyDefault: SocialTaxRatePolicy;
    countrySettings: CountrySocialTaxRatePolicySettingDto[];
    countrySettingsByCountry: {
      [key: string]: CountrySocialTaxRatePolicySettingDto;
    };
  }

  export class CountrySocialTaxRatePolicySettingDto
    implements ICountrySocialTaxRatePolicySettingDto
  {
    countryCode!: string;
    socialTaxRatePolicy!: SocialTaxRatePolicy | null;

    constructor(data?: ICountrySocialTaxRatePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.socialTaxRatePolicy =
          _data['socialTaxRatePolicy'] !== undefined
            ? _data['socialTaxRatePolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): CountrySocialTaxRatePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountrySocialTaxRatePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['socialTaxRatePolicy'] =
        this.socialTaxRatePolicy !== undefined
          ? this.socialTaxRatePolicy
          : <any>null;
      return data;
    }
  }

  export interface ICountrySocialTaxRatePolicySettingDto {
    countryCode: string;
    socialTaxRatePolicy: SocialTaxRatePolicy | null;
  }

  export class GetSocialTaxRatePolicyPageDataQueryResultFailure
    extends GetSocialTaxRatePolicyPageDataQueryResult
    implements IGetSocialTaxRatePolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetSocialTaxRatePolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxRatePolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxRatePolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxRatePolicyPageDataQueryResultFailure
    extends IGetSocialTaxRatePolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertSocialTaxRatePolicySettingsCommandResult
    implements IUpsertSocialTaxRatePolicySettingsCommandResult
  {
    constructor(data?: IUpsertSocialTaxRatePolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertSocialTaxRatePolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxRatePolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertSocialTaxRatePolicySettingsCommandResult {}

  export class UpsertSocialTaxRatePolicySettingsCommandResultSuccess
    extends UpsertSocialTaxRatePolicySettingsCommandResult
    implements IUpsertSocialTaxRatePolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertSocialTaxRatePolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxRatePolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxRatePolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxRatePolicySettingsCommandResultSuccess
    extends IUpsertSocialTaxRatePolicySettingsCommandResult {}

  export class UpsertSocialTaxRatePolicySettingsCommandResultFailure
    extends UpsertSocialTaxRatePolicySettingsCommandResult
    implements IUpsertSocialTaxRatePolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertSocialTaxRatePolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxRatePolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxRatePolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxRatePolicySettingsCommandResultFailure
    extends IUpsertSocialTaxRatePolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertSocialTaxRatePolicySettingsCommand
    implements IUpsertSocialTaxRatePolicySettingsCommand
  {
    clientId!: string;
    companyDefault!: SocialTaxRatePolicy;
    countrySettings!: CountrySocialTaxRatePolicySettingDto[];

    constructor(data?: IUpsertSocialTaxRatePolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.companyDefault =
          _data['companyDefault'] !== undefined
            ? _data['companyDefault']
            : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CountrySocialTaxRatePolicySettingDto.fromJS(item),
            );
        } else {
          this.countrySettings = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertSocialTaxRatePolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxRatePolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['companyDefault'] =
        this.companyDefault !== undefined ? this.companyDefault : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertSocialTaxRatePolicySettingsCommand {
    clientId: string;
    companyDefault: SocialTaxRatePolicy;
    countrySettings: CountrySocialTaxRatePolicySettingDto[];
  }

  export class GetSocialTaxPolicyPageDataQueryResult
    implements IGetSocialTaxPolicyPageDataQueryResult
  {
    constructor(data?: IGetSocialTaxPolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetSocialTaxPolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSocialTaxPolicyPageDataQueryResult {}

  export class GetSocialTaxPolicyPageDataQueryResultSuccess
    extends GetSocialTaxPolicyPageDataQueryResult
    implements IGetSocialTaxPolicyPageDataQueryResultSuccess
  {
    result!: SocialTaxPageData;

    constructor(data?: IGetSocialTaxPolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new SocialTaxPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? SocialTaxPageData.fromJS(_data['result'])
          : new SocialTaxPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxPolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxPolicyPageDataQueryResultSuccess
    extends IGetSocialTaxPolicyPageDataQueryResult {
    result: SocialTaxPageData;
  }

  export class SocialTaxPageData implements ISocialTaxPageData {
    certificateOfCoveragePolicyOptions!: CertificateOfCoveragePolicyDto[];
    clientSocialTaxPolicyOptions!: ClientSocialTaxPolicyDto2[];
    trailingSocialTaxPolicyOptions!: TrailingSocialTaxPolicyDto2[];
    socialTaxLocationOptions!: SocialTaxLocationOptionDto[];
    clientSocialTaxWorkLocationTypePolicyOptions!: ClientSocialTaxWorkLocationTypePolicyOptionDto[];
    countriesInFootprint!: string[];
    socialTaxPolicySettings!: SocialTaxPolicySettingsDto | null;
    employeePopulationPolicyDetails!:
      | EmployeePopulationPolicyDetailsDto[]
      | null;
    configuredWorkLocationTypes!: WorkLocationTypeSettingDto[];

    constructor(data?: ISocialTaxPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.certificateOfCoveragePolicyOptions = [];
        this.clientSocialTaxPolicyOptions = [];
        this.trailingSocialTaxPolicyOptions = [];
        this.socialTaxLocationOptions = [];
        this.clientSocialTaxWorkLocationTypePolicyOptions = [];
        this.countriesInFootprint = [];
        this.configuredWorkLocationTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['certificateOfCoveragePolicyOptions'])) {
          this.certificateOfCoveragePolicyOptions = [] as any;
          for (let item of _data['certificateOfCoveragePolicyOptions'])
            this.certificateOfCoveragePolicyOptions!.push(
              CertificateOfCoveragePolicyDto.fromJS(item),
            );
        } else {
          this.certificateOfCoveragePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['clientSocialTaxPolicyOptions'])) {
          this.clientSocialTaxPolicyOptions = [] as any;
          for (let item of _data['clientSocialTaxPolicyOptions'])
            this.clientSocialTaxPolicyOptions!.push(
              ClientSocialTaxPolicyDto2.fromJS(item),
            );
        } else {
          this.clientSocialTaxPolicyOptions = <any>null;
        }
        if (Array.isArray(_data['trailingSocialTaxPolicyOptions'])) {
          this.trailingSocialTaxPolicyOptions = [] as any;
          for (let item of _data['trailingSocialTaxPolicyOptions'])
            this.trailingSocialTaxPolicyOptions!.push(
              TrailingSocialTaxPolicyDto2.fromJS(item),
            );
        } else {
          this.trailingSocialTaxPolicyOptions = <any>null;
        }
        if (Array.isArray(_data['socialTaxLocationOptions'])) {
          this.socialTaxLocationOptions = [] as any;
          for (let item of _data['socialTaxLocationOptions'])
            this.socialTaxLocationOptions!.push(
              SocialTaxLocationOptionDto.fromJS(item),
            );
        } else {
          this.socialTaxLocationOptions = <any>null;
        }
        if (
          Array.isArray(_data['clientSocialTaxWorkLocationTypePolicyOptions'])
        ) {
          this.clientSocialTaxWorkLocationTypePolicyOptions = [] as any;
          for (let item of _data[
            'clientSocialTaxWorkLocationTypePolicyOptions'
          ])
            this.clientSocialTaxWorkLocationTypePolicyOptions!.push(
              ClientSocialTaxWorkLocationTypePolicyOptionDto.fromJS(item),
            );
        } else {
          this.clientSocialTaxWorkLocationTypePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(item);
        } else {
          this.countriesInFootprint = <any>null;
        }
        this.socialTaxPolicySettings = _data['socialTaxPolicySettings']
          ? SocialTaxPolicySettingsDto.fromJS(_data['socialTaxPolicySettings'])
          : <any>null;
        if (Array.isArray(_data['employeePopulationPolicyDetails'])) {
          this.employeePopulationPolicyDetails = [] as any;
          for (let item of _data['employeePopulationPolicyDetails'])
            this.employeePopulationPolicyDetails!.push(
              EmployeePopulationPolicyDetailsDto.fromJS(item),
            );
        } else {
          this.employeePopulationPolicyDetails = <any>null;
        }
        if (Array.isArray(_data['configuredWorkLocationTypes'])) {
          this.configuredWorkLocationTypes = [] as any;
          for (let item of _data['configuredWorkLocationTypes'])
            this.configuredWorkLocationTypes!.push(
              WorkLocationTypeSettingDto.fromJS(item),
            );
        } else {
          this.configuredWorkLocationTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): SocialTaxPageData {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.certificateOfCoveragePolicyOptions)) {
        data['certificateOfCoveragePolicyOptions'] = [];
        for (let item of this.certificateOfCoveragePolicyOptions)
          data['certificateOfCoveragePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.clientSocialTaxPolicyOptions)) {
        data['clientSocialTaxPolicyOptions'] = [];
        for (let item of this.clientSocialTaxPolicyOptions)
          data['clientSocialTaxPolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.trailingSocialTaxPolicyOptions)) {
        data['trailingSocialTaxPolicyOptions'] = [];
        for (let item of this.trailingSocialTaxPolicyOptions)
          data['trailingSocialTaxPolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.socialTaxLocationOptions)) {
        data['socialTaxLocationOptions'] = [];
        for (let item of this.socialTaxLocationOptions)
          data['socialTaxLocationOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.clientSocialTaxWorkLocationTypePolicyOptions)) {
        data['clientSocialTaxWorkLocationTypePolicyOptions'] = [];
        for (let item of this.clientSocialTaxWorkLocationTypePolicyOptions)
          data['clientSocialTaxWorkLocationTypePolicyOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item);
      }
      data['socialTaxPolicySettings'] = this.socialTaxPolicySettings
        ? this.socialTaxPolicySettings.toJSON()
        : <any>null;
      if (Array.isArray(this.employeePopulationPolicyDetails)) {
        data['employeePopulationPolicyDetails'] = [];
        for (let item of this.employeePopulationPolicyDetails)
          data['employeePopulationPolicyDetails'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredWorkLocationTypes)) {
        data['configuredWorkLocationTypes'] = [];
        for (let item of this.configuredWorkLocationTypes)
          data['configuredWorkLocationTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISocialTaxPageData {
    certificateOfCoveragePolicyOptions: CertificateOfCoveragePolicyDto[];
    clientSocialTaxPolicyOptions: ClientSocialTaxPolicyDto2[];
    trailingSocialTaxPolicyOptions: TrailingSocialTaxPolicyDto2[];
    socialTaxLocationOptions: SocialTaxLocationOptionDto[];
    clientSocialTaxWorkLocationTypePolicyOptions: ClientSocialTaxWorkLocationTypePolicyOptionDto[];
    countriesInFootprint: string[];
    socialTaxPolicySettings: SocialTaxPolicySettingsDto | null;
    employeePopulationPolicyDetails:
      | EmployeePopulationPolicyDetailsDto[]
      | null;
    configuredWorkLocationTypes: WorkLocationTypeSettingDto[];
  }

  export class CertificateOfCoveragePolicyDto
    implements ICertificateOfCoveragePolicyDto
  {
    optionValue!: CertificateOfCoveragePolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ICertificateOfCoveragePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): CertificateOfCoveragePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new CertificateOfCoveragePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ICertificateOfCoveragePolicyDto {
    optionValue: CertificateOfCoveragePolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum CertificateOfCoveragePolicy {
    AssumeCoc = 'AssumeCoc',
    ProvideAsInput = 'ProvideAsInput',
  }

  export class ClientSocialTaxPolicyDto2 implements IClientSocialTaxPolicyDto2 {
    optionValue!: ClientSocialTaxPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IClientSocialTaxPolicyDto2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientSocialTaxPolicyDto2 {
      data = typeof data === 'object' ? data : {};
      let result = new ClientSocialTaxPolicyDto2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IClientSocialTaxPolicyDto2 {
    optionValue: ClientSocialTaxPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export class TrailingSocialTaxPolicyDto2
    implements ITrailingSocialTaxPolicyDto2
  {
    optionValue!: TrailingSocialTaxPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITrailingSocialTaxPolicyDto2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TrailingSocialTaxPolicyDto2 {
      data = typeof data === 'object' ? data : {};
      let result = new TrailingSocialTaxPolicyDto2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITrailingSocialTaxPolicyDto2 {
    optionValue: TrailingSocialTaxPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export class ClientSocialTaxWorkLocationTypePolicyOptionDto
    implements IClientSocialTaxWorkLocationTypePolicyOptionDto
  {
    optionValue!: ClientSocialTaxWorkLocationTypePolicyOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IClientSocialTaxWorkLocationTypePolicyOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientSocialTaxWorkLocationTypePolicyOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientSocialTaxWorkLocationTypePolicyOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IClientSocialTaxWorkLocationTypePolicyOptionDto {
    optionValue: ClientSocialTaxWorkLocationTypePolicyOption;
    displayValue: string;
    displayOrder: number;
  }

  export enum ClientSocialTaxWorkLocationTypePolicyOption {
    CompanyDefault = 'CompanyDefault',
    ConsiderSocialTaxBasedOnCurrentLocationOnly = 'ConsiderSocialTaxBasedOnCurrentLocationOnly',
    ConsiderTrailingSocialTax = 'ConsiderTrailingSocialTax',
  }

  export class SocialTaxPolicySettingsDto
    implements ISocialTaxPolicySettingsDto
  {
    id!: string;
    certificateOfCoverageSettings!: CertificateOfCoverageSettingsDto | null;
    socialTaxPolicyConfiguration!: SocialTaxPolicyConfigurationDto;

    constructor(data?: ISocialTaxPolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.socialTaxPolicyConfiguration =
          new SocialTaxPolicyConfigurationDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.certificateOfCoverageSettings = _data[
          'certificateOfCoverageSettings'
        ]
          ? CertificateOfCoverageSettingsDto.fromJS(
              _data['certificateOfCoverageSettings'],
            )
          : <any>null;
        this.socialTaxPolicyConfiguration = _data[
          'socialTaxPolicyConfiguration'
        ]
          ? SocialTaxPolicyConfigurationDto.fromJS(
              _data['socialTaxPolicyConfiguration'],
            )
          : new SocialTaxPolicyConfigurationDto();
      }
    }

    static fromJS(data: any): SocialTaxPolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['certificateOfCoverageSettings'] = this.certificateOfCoverageSettings
        ? this.certificateOfCoverageSettings.toJSON()
        : <any>null;
      data['socialTaxPolicyConfiguration'] = this.socialTaxPolicyConfiguration
        ? this.socialTaxPolicyConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicySettingsDto {
    id: string;
    certificateOfCoverageSettings: CertificateOfCoverageSettingsDto | null;
    socialTaxPolicyConfiguration: SocialTaxPolicyConfigurationDto;
  }

  export class CertificateOfCoverageSettingsDto
    implements ICertificateOfCoverageSettingsDto
  {
    assumeCoCSettingsDto!: AssumeCoCSettingsDto | null;
    clientWorkLocationPolicyIds!: string[];
    policy!: CertificateOfCoveragePolicy;

    constructor(data?: ICertificateOfCoverageSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientWorkLocationPolicyIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.assumeCoCSettingsDto = _data['assumeCoCSettingsDto']
          ? AssumeCoCSettingsDto.fromJS(_data['assumeCoCSettingsDto'])
          : <any>null;
        if (Array.isArray(_data['clientWorkLocationPolicyIds'])) {
          this.clientWorkLocationPolicyIds = [] as any;
          for (let item of _data['clientWorkLocationPolicyIds'])
            this.clientWorkLocationPolicyIds!.push(item);
        } else {
          this.clientWorkLocationPolicyIds = <any>null;
        }
        this.policy =
          _data['policy'] !== undefined ? _data['policy'] : <any>null;
      }
    }

    static fromJS(data: any): CertificateOfCoverageSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CertificateOfCoverageSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['assumeCoCSettingsDto'] = this.assumeCoCSettingsDto
        ? this.assumeCoCSettingsDto.toJSON()
        : <any>null;
      if (Array.isArray(this.clientWorkLocationPolicyIds)) {
        data['clientWorkLocationPolicyIds'] = [];
        for (let item of this.clientWorkLocationPolicyIds)
          data['clientWorkLocationPolicyIds'].push(item);
      }
      data['policy'] = this.policy !== undefined ? this.policy : <any>null;
      return data;
    }
  }

  export interface ICertificateOfCoverageSettingsDto {
    assumeCoCSettingsDto: AssumeCoCSettingsDto | null;
    clientWorkLocationPolicyIds: string[];
    policy: CertificateOfCoveragePolicy;
  }

  export class AssumeCoCSettingsDto implements IAssumeCoCSettingsDto {
    assumeThatExtensionHasBeenGrantedWhenCocInPlace!: boolean;

    constructor(data?: IAssumeCoCSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.assumeThatExtensionHasBeenGrantedWhenCocInPlace =
          _data['assumeThatExtensionHasBeenGrantedWhenCocInPlace'] !== undefined
            ? _data['assumeThatExtensionHasBeenGrantedWhenCocInPlace']
            : <any>null;
      }
    }

    static fromJS(data: any): AssumeCoCSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AssumeCoCSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['assumeThatExtensionHasBeenGrantedWhenCocInPlace'] =
        this.assumeThatExtensionHasBeenGrantedWhenCocInPlace !== undefined
          ? this.assumeThatExtensionHasBeenGrantedWhenCocInPlace
          : <any>null;
      return data;
    }
  }

  export interface IAssumeCoCSettingsDto {
    assumeThatExtensionHasBeenGrantedWhenCocInPlace: boolean;
  }

  export class SocialTaxPolicyConfigurationDto
    implements ISocialTaxPolicyConfigurationDto
  {
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy!: TrailingSocialTaxPolicy | null;
    trailingSocialTaxCountries!: string[];
    workLocationTypeLevelSocialTaxSettings!: WorkLocationTypeLevelSocialTaxSettingsDto | null;
    policy!: ClientSocialTaxPolicy;

    constructor(data?: ISocialTaxPolicyConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.trailingSocialTaxCountries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxPolicy =
          _data['trailingSocialTaxPolicy'] !== undefined
            ? _data['trailingSocialTaxPolicy']
            : <any>null;
        if (Array.isArray(_data['trailingSocialTaxCountries'])) {
          this.trailingSocialTaxCountries = [] as any;
          for (let item of _data['trailingSocialTaxCountries'])
            this.trailingSocialTaxCountries!.push(item);
        } else {
          this.trailingSocialTaxCountries = <any>null;
        }
        this.workLocationTypeLevelSocialTaxSettings = _data[
          'workLocationTypeLevelSocialTaxSettings'
        ]
          ? WorkLocationTypeLevelSocialTaxSettingsDto.fromJS(
              _data['workLocationTypeLevelSocialTaxSettings'],
            )
          : <any>null;
        this.policy =
          _data['policy'] !== undefined ? _data['policy'] : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxPolicyConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicyConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxPolicy'] =
        this.trailingSocialTaxPolicy !== undefined
          ? this.trailingSocialTaxPolicy
          : <any>null;
      if (Array.isArray(this.trailingSocialTaxCountries)) {
        data['trailingSocialTaxCountries'] = [];
        for (let item of this.trailingSocialTaxCountries)
          data['trailingSocialTaxCountries'].push(item);
      }
      data['workLocationTypeLevelSocialTaxSettings'] = this
        .workLocationTypeLevelSocialTaxSettings
        ? this.workLocationTypeLevelSocialTaxSettings.toJSON()
        : <any>null;
      data['policy'] = this.policy !== undefined ? this.policy : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicyConfigurationDto {
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy: TrailingSocialTaxPolicy | null;
    trailingSocialTaxCountries: string[];
    workLocationTypeLevelSocialTaxSettings: WorkLocationTypeLevelSocialTaxSettingsDto | null;
    policy: ClientSocialTaxPolicy;
  }

  export class WorkLocationTypeLevelSocialTaxSettingsDto
    implements IWorkLocationTypeLevelSocialTaxSettingsDto
  {
    workLocationPolicySocialTaxConfigurationDtos!: WorkLocationPolicySocialTaxConfigurationDto[];

    constructor(data?: IWorkLocationTypeLevelSocialTaxSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationPolicySocialTaxConfigurationDtos = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (
          Array.isArray(_data['workLocationPolicySocialTaxConfigurationDtos'])
        ) {
          this.workLocationPolicySocialTaxConfigurationDtos = [] as any;
          for (let item of _data[
            'workLocationPolicySocialTaxConfigurationDtos'
          ])
            this.workLocationPolicySocialTaxConfigurationDtos!.push(
              WorkLocationPolicySocialTaxConfigurationDto.fromJS(item),
            );
        } else {
          this.workLocationPolicySocialTaxConfigurationDtos = <any>null;
        }
      }
    }

    static fromJS(data: any): WorkLocationTypeLevelSocialTaxSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTypeLevelSocialTaxSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationPolicySocialTaxConfigurationDtos)) {
        data['workLocationPolicySocialTaxConfigurationDtos'] = [];
        for (let item of this.workLocationPolicySocialTaxConfigurationDtos)
          data['workLocationPolicySocialTaxConfigurationDtos'].push(
            item.toJSON(),
          );
      }
      return data;
    }
  }

  export interface IWorkLocationTypeLevelSocialTaxSettingsDto {
    workLocationPolicySocialTaxConfigurationDtos: WorkLocationPolicySocialTaxConfigurationDto[];
  }

  export class WorkLocationPolicySocialTaxConfigurationDto
    implements IWorkLocationPolicySocialTaxConfigurationDto
  {
    workLocationType!: WorkLocationType;
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy!: TrailingSocialTaxPolicy | null;
    socialTaxPolicySelection!: ClientSocialTaxWorkLocationTypePolicyOption;

    constructor(data?: IWorkLocationPolicySocialTaxConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxPolicy =
          _data['trailingSocialTaxPolicy'] !== undefined
            ? _data['trailingSocialTaxPolicy']
            : <any>null;
        this.socialTaxPolicySelection =
          _data['socialTaxPolicySelection'] !== undefined
            ? _data['socialTaxPolicySelection']
            : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationPolicySocialTaxConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationPolicySocialTaxConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxPolicy'] =
        this.trailingSocialTaxPolicy !== undefined
          ? this.trailingSocialTaxPolicy
          : <any>null;
      data['socialTaxPolicySelection'] =
        this.socialTaxPolicySelection !== undefined
          ? this.socialTaxPolicySelection
          : <any>null;
      return data;
    }
  }

  export interface IWorkLocationPolicySocialTaxConfigurationDto {
    workLocationType: WorkLocationType;
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy: TrailingSocialTaxPolicy | null;
    socialTaxPolicySelection: ClientSocialTaxWorkLocationTypePolicyOption;
  }

  export enum WorkLocationType {
    LongTermAssignment = 'LongTermAssignment',
    RemoteWorker = 'RemoteWorker',
    Local = 'Local',
    PermanentTransfer = 'PermanentTransfer',
  }

  export class EmployeePopulationPolicyDetailsDto
    implements IEmployeePopulationPolicyDetailsDto
  {
    id!: string;
    clientPolicyName!: string;
    clientPolicyWorkLocationTypeId!: WorkLocationTypeSetting;
    teqConsidered!: boolean;

    constructor(data?: IEmployeePopulationPolicyDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyWorkLocationTypeId =
          _data['clientPolicyWorkLocationTypeId'] !== undefined
            ? _data['clientPolicyWorkLocationTypeId']
            : <any>null;
        this.teqConsidered =
          _data['teqConsidered'] !== undefined
            ? _data['teqConsidered']
            : <any>null;
      }
    }

    static fromJS(data: any): EmployeePopulationPolicyDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeePopulationPolicyDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyWorkLocationTypeId'] =
        this.clientPolicyWorkLocationTypeId !== undefined
          ? this.clientPolicyWorkLocationTypeId
          : <any>null;
      data['teqConsidered'] =
        this.teqConsidered !== undefined ? this.teqConsidered : <any>null;
      return data;
    }
  }

  export interface IEmployeePopulationPolicyDetailsDto {
    id: string;
    clientPolicyName: string;
    clientPolicyWorkLocationTypeId: WorkLocationTypeSetting;
    teqConsidered: boolean;
  }

  export class WorkLocationTypeSettingDto
    implements IWorkLocationTypeSettingDto
  {
    optionValue!: WorkLocationTypeSetting;
    displayValue!: string;
    displayorder!: number;

    constructor(data?: IWorkLocationTypeSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayorder =
          _data['displayorder'] !== undefined
            ? _data['displayorder']
            : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationTypeSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTypeSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayorder'] =
        this.displayorder !== undefined ? this.displayorder : <any>null;
      return data;
    }
  }

  export interface IWorkLocationTypeSettingDto {
    optionValue: WorkLocationTypeSetting;
    displayValue: string;
    displayorder: number;
  }

  export class GetSocialTaxPolicyPageDataQueryResultFailure
    extends GetSocialTaxPolicyPageDataQueryResult
    implements IGetSocialTaxPolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetSocialTaxPolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetSocialTaxPolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetSocialTaxPolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSocialTaxPolicyPageDataQueryResultFailure
    extends IGetSocialTaxPolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertSocialTaxPolicySettingsCommandResult
    implements IUpsertSocialTaxPolicySettingsCommandResult
  {
    constructor(data?: IUpsertSocialTaxPolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertSocialTaxPolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicySettingsCommandResult {}

  export class UpsertSocialTaxPolicySettingsCommandResultSuccess
    extends UpsertSocialTaxPolicySettingsCommandResult
    implements IUpsertSocialTaxPolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertSocialTaxPolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxPolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicySettingsCommandResultSuccess
    extends IUpsertSocialTaxPolicySettingsCommandResult {}

  export class UpsertSocialTaxPolicySettingsCommandResultFailure
    extends UpsertSocialTaxPolicySettingsCommandResult
    implements IUpsertSocialTaxPolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertSocialTaxPolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertSocialTaxPolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicySettingsCommandResultFailure
    extends IUpsertSocialTaxPolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertSocialTaxPolicySettingsCommand
    implements IUpsertSocialTaxPolicySettingsCommand
  {
    clientId!: string;
    socialTaxPolicySettingsParams!: SocialTaxPolicySettingsParams;

    constructor(data?: IUpsertSocialTaxPolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.socialTaxPolicySettingsParams =
          new SocialTaxPolicySettingsParams();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.socialTaxPolicySettingsParams = _data[
          'socialTaxPolicySettingsParams'
        ]
          ? SocialTaxPolicySettingsParams.fromJS(
              _data['socialTaxPolicySettingsParams'],
            )
          : new SocialTaxPolicySettingsParams();
      }
    }

    static fromJS(data: any): UpsertSocialTaxPolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertSocialTaxPolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['socialTaxPolicySettingsParams'] = this.socialTaxPolicySettingsParams
        ? this.socialTaxPolicySettingsParams.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertSocialTaxPolicySettingsCommand {
    clientId: string;
    socialTaxPolicySettingsParams: SocialTaxPolicySettingsParams;
  }

  export class SocialTaxPolicySettingsParams
    implements ISocialTaxPolicySettingsParams
  {
    certificateOfCoverageApplicationSettings!: CertificateOfCoverageSettingsParams | null;
    socialTaxPolicyConfiguration!: SocialTaxPolicyConfigurationParams;

    constructor(data?: ISocialTaxPolicySettingsParams) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.socialTaxPolicyConfiguration =
          new SocialTaxPolicyConfigurationParams();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.certificateOfCoverageApplicationSettings = _data[
          'certificateOfCoverageApplicationSettings'
        ]
          ? CertificateOfCoverageSettingsParams.fromJS(
              _data['certificateOfCoverageApplicationSettings'],
            )
          : <any>null;
        this.socialTaxPolicyConfiguration = _data[
          'socialTaxPolicyConfiguration'
        ]
          ? SocialTaxPolicyConfigurationParams.fromJS(
              _data['socialTaxPolicyConfiguration'],
            )
          : new SocialTaxPolicyConfigurationParams();
      }
    }

    static fromJS(data: any): SocialTaxPolicySettingsParams {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicySettingsParams();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['certificateOfCoverageApplicationSettings'] = this
        .certificateOfCoverageApplicationSettings
        ? this.certificateOfCoverageApplicationSettings.toJSON()
        : <any>null;
      data['socialTaxPolicyConfiguration'] = this.socialTaxPolicyConfiguration
        ? this.socialTaxPolicyConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicySettingsParams {
    certificateOfCoverageApplicationSettings: CertificateOfCoverageSettingsParams | null;
    socialTaxPolicyConfiguration: SocialTaxPolicyConfigurationParams;
  }

  export class CertificateOfCoverageSettingsParams
    implements ICertificateOfCoverageSettingsParams
  {
    assumeCoCSettingsParams!: AssumeCoCSettingsParams | null;
    clientWorkLocationPolicyIds!: string[];

    constructor(data?: ICertificateOfCoverageSettingsParams) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientWorkLocationPolicyIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.assumeCoCSettingsParams = _data['assumeCoCSettingsParams']
          ? AssumeCoCSettingsParams.fromJS(_data['assumeCoCSettingsParams'])
          : <any>null;
        if (Array.isArray(_data['clientWorkLocationPolicyIds'])) {
          this.clientWorkLocationPolicyIds = [] as any;
          for (let item of _data['clientWorkLocationPolicyIds'])
            this.clientWorkLocationPolicyIds!.push(item);
        } else {
          this.clientWorkLocationPolicyIds = <any>null;
        }
      }
    }

    static fromJS(data: any): CertificateOfCoverageSettingsParams {
      data = typeof data === 'object' ? data : {};
      let result = new CertificateOfCoverageSettingsParams();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['assumeCoCSettingsParams'] = this.assumeCoCSettingsParams
        ? this.assumeCoCSettingsParams.toJSON()
        : <any>null;
      if (Array.isArray(this.clientWorkLocationPolicyIds)) {
        data['clientWorkLocationPolicyIds'] = [];
        for (let item of this.clientWorkLocationPolicyIds)
          data['clientWorkLocationPolicyIds'].push(item);
      }
      return data;
    }
  }

  export interface ICertificateOfCoverageSettingsParams {
    assumeCoCSettingsParams: AssumeCoCSettingsParams | null;
    clientWorkLocationPolicyIds: string[];
  }

  export class AssumeCoCSettingsParams implements IAssumeCoCSettingsParams {
    assumeThatExtensionHasBeenGrantedWhenCocInPlace!: boolean;

    constructor(data?: IAssumeCoCSettingsParams) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.assumeThatExtensionHasBeenGrantedWhenCocInPlace =
          _data['assumeThatExtensionHasBeenGrantedWhenCocInPlace'] !== undefined
            ? _data['assumeThatExtensionHasBeenGrantedWhenCocInPlace']
            : <any>null;
      }
    }

    static fromJS(data: any): AssumeCoCSettingsParams {
      data = typeof data === 'object' ? data : {};
      let result = new AssumeCoCSettingsParams();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['assumeThatExtensionHasBeenGrantedWhenCocInPlace'] =
        this.assumeThatExtensionHasBeenGrantedWhenCocInPlace !== undefined
          ? this.assumeThatExtensionHasBeenGrantedWhenCocInPlace
          : <any>null;
      return data;
    }
  }

  export interface IAssumeCoCSettingsParams {
    assumeThatExtensionHasBeenGrantedWhenCocInPlace: boolean;
  }

  export class SocialTaxPolicyConfigurationParams
    implements ISocialTaxPolicyConfigurationParams
  {
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy!: TrailingSocialTaxPolicy | null;
    trailingSocialTaxCountries!: string[];
    workLocationTypeLevelSocialTaxSettings!: WorkLocationTypeLevelSocialTaxSettingsParams | null;

    constructor(data?: ISocialTaxPolicyConfigurationParams) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.trailingSocialTaxCountries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxPolicy =
          _data['trailingSocialTaxPolicy'] !== undefined
            ? _data['trailingSocialTaxPolicy']
            : <any>null;
        if (Array.isArray(_data['trailingSocialTaxCountries'])) {
          this.trailingSocialTaxCountries = [] as any;
          for (let item of _data['trailingSocialTaxCountries'])
            this.trailingSocialTaxCountries!.push(item);
        } else {
          this.trailingSocialTaxCountries = <any>null;
        }
        this.workLocationTypeLevelSocialTaxSettings = _data[
          'workLocationTypeLevelSocialTaxSettings'
        ]
          ? WorkLocationTypeLevelSocialTaxSettingsParams.fromJS(
              _data['workLocationTypeLevelSocialTaxSettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): SocialTaxPolicyConfigurationParams {
      data = typeof data === 'object' ? data : {};
      let result = new SocialTaxPolicyConfigurationParams();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxPolicy'] =
        this.trailingSocialTaxPolicy !== undefined
          ? this.trailingSocialTaxPolicy
          : <any>null;
      if (Array.isArray(this.trailingSocialTaxCountries)) {
        data['trailingSocialTaxCountries'] = [];
        for (let item of this.trailingSocialTaxCountries)
          data['trailingSocialTaxCountries'].push(item);
      }
      data['workLocationTypeLevelSocialTaxSettings'] = this
        .workLocationTypeLevelSocialTaxSettings
        ? this.workLocationTypeLevelSocialTaxSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISocialTaxPolicyConfigurationParams {
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy: TrailingSocialTaxPolicy | null;
    trailingSocialTaxCountries: string[];
    workLocationTypeLevelSocialTaxSettings: WorkLocationTypeLevelSocialTaxSettingsParams | null;
  }

  export class WorkLocationTypeLevelSocialTaxSettingsParams
    implements IWorkLocationTypeLevelSocialTaxSettingsParams
  {
    workLocationPolicySocialTaxConfiguration!: WorkLocationPolicySocialTaxConfigurationParam[];

    constructor(data?: IWorkLocationTypeLevelSocialTaxSettingsParams) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationPolicySocialTaxConfiguration = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['workLocationPolicySocialTaxConfiguration'])) {
          this.workLocationPolicySocialTaxConfiguration = [] as any;
          for (let item of _data['workLocationPolicySocialTaxConfiguration'])
            this.workLocationPolicySocialTaxConfiguration!.push(
              WorkLocationPolicySocialTaxConfigurationParam.fromJS(item),
            );
        } else {
          this.workLocationPolicySocialTaxConfiguration = <any>null;
        }
      }
    }

    static fromJS(data: any): WorkLocationTypeLevelSocialTaxSettingsParams {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationTypeLevelSocialTaxSettingsParams();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationPolicySocialTaxConfiguration)) {
        data['workLocationPolicySocialTaxConfiguration'] = [];
        for (let item of this.workLocationPolicySocialTaxConfiguration)
          data['workLocationPolicySocialTaxConfiguration'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IWorkLocationTypeLevelSocialTaxSettingsParams {
    workLocationPolicySocialTaxConfiguration: WorkLocationPolicySocialTaxConfigurationParam[];
  }

  export class WorkLocationPolicySocialTaxConfigurationParam
    implements IWorkLocationPolicySocialTaxConfigurationParam
  {
    workLocationPolicyType!: WorkLocationType;
    socialTaxLocationOption!: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy!: TrailingSocialTaxPolicy | null;
    socialTaxPolicySelection!: ClientSocialTaxWorkLocationTypePolicyOption;

    constructor(data?: IWorkLocationPolicySocialTaxConfigurationParam) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationPolicyType =
          _data['workLocationPolicyType'] !== undefined
            ? _data['workLocationPolicyType']
            : <any>null;
        this.socialTaxLocationOption =
          _data['socialTaxLocationOption'] !== undefined
            ? _data['socialTaxLocationOption']
            : <any>null;
        this.trailingSocialTaxPolicy =
          _data['trailingSocialTaxPolicy'] !== undefined
            ? _data['trailingSocialTaxPolicy']
            : <any>null;
        this.socialTaxPolicySelection =
          _data['socialTaxPolicySelection'] !== undefined
            ? _data['socialTaxPolicySelection']
            : <any>null;
      }
    }

    static fromJS(data: any): WorkLocationPolicySocialTaxConfigurationParam {
      data = typeof data === 'object' ? data : {};
      let result = new WorkLocationPolicySocialTaxConfigurationParam();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationPolicyType'] =
        this.workLocationPolicyType !== undefined
          ? this.workLocationPolicyType
          : <any>null;
      data['socialTaxLocationOption'] =
        this.socialTaxLocationOption !== undefined
          ? this.socialTaxLocationOption
          : <any>null;
      data['trailingSocialTaxPolicy'] =
        this.trailingSocialTaxPolicy !== undefined
          ? this.trailingSocialTaxPolicy
          : <any>null;
      data['socialTaxPolicySelection'] =
        this.socialTaxPolicySelection !== undefined
          ? this.socialTaxPolicySelection
          : <any>null;
      return data;
    }
  }

  export interface IWorkLocationPolicySocialTaxConfigurationParam {
    workLocationPolicyType: WorkLocationType;
    socialTaxLocationOption: SocialTaxLocationOption | null;
    trailingSocialTaxPolicy: TrailingSocialTaxPolicy | null;
    socialTaxPolicySelection: ClientSocialTaxWorkLocationTypePolicyOption;
  }

  export class GetSetupByCountryPageDataQueryResult
    implements IGetSetupByCountryPageDataQueryResult
  {
    constructor(data?: IGetSetupByCountryPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetSetupByCountryPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetSetupByCountryPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetSetupByCountryPageDataQueryResult {}

  export class GetSetupByCountryPageDataQueryResultSuccess
    extends GetSetupByCountryPageDataQueryResult
    implements IGetSetupByCountryPageDataQueryResultSuccess
  {
    result!: SetupByCountryPageData;

    constructor(data?: IGetSetupByCountryPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new SetupByCountryPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? SetupByCountryPageData.fromJS(_data['result'])
          : new SetupByCountryPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetSetupByCountryPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetSetupByCountryPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSetupByCountryPageDataQueryResultSuccess
    extends IGetSetupByCountryPageDataQueryResult {
    result: SetupByCountryPageData;
  }

  export class SetupByCountryPageData implements ISetupByCountryPageData {
    policyOptions!: PlanTypeCalculationMethodSettingsDto;
    calculationMethodSettings!: CalculationMethodSettingDto[];

    constructor(data?: ISetupByCountryPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.policyOptions = new PlanTypeCalculationMethodSettingsDto();
        this.calculationMethodSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.policyOptions = _data['policyOptions']
          ? PlanTypeCalculationMethodSettingsDto.fromJS(_data['policyOptions'])
          : new PlanTypeCalculationMethodSettingsDto();
        if (Array.isArray(_data['calculationMethodSettings'])) {
          this.calculationMethodSettings = [] as any;
          for (let item of _data['calculationMethodSettings'])
            this.calculationMethodSettings!.push(
              CalculationMethodSettingDto.fromJS(item),
            );
        } else {
          this.calculationMethodSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): SetupByCountryPageData {
      data = typeof data === 'object' ? data : {};
      let result = new SetupByCountryPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['policyOptions'] = this.policyOptions
        ? this.policyOptions.toJSON()
        : <any>null;
      if (Array.isArray(this.calculationMethodSettings)) {
        data['calculationMethodSettings'] = [];
        for (let item of this.calculationMethodSettings)
          data['calculationMethodSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISetupByCountryPageData {
    policyOptions: PlanTypeCalculationMethodSettingsDto;
    calculationMethodSettings: CalculationMethodSettingDto[];
  }

  export class PlanTypeCalculationMethodSettingsDto
    implements IPlanTypeCalculationMethodSettingsDto
  {
    countryPlanCalculationMethodSettings!: {
      [key: string]: CountryPlanCalculationMethodSettingDto;
    };
    countries!: SetupByCountryCountryDataDto[];
    plans!: SetupByCountryPlanDataDto[];

    constructor(data?: IPlanTypeCalculationMethodSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryPlanCalculationMethodSettings = {};
        this.countries = [];
        this.plans = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (_data['countryPlanCalculationMethodSettings']) {
          this.countryPlanCalculationMethodSettings = {} as any;
          for (let key in _data['countryPlanCalculationMethodSettings']) {
            if (
              _data['countryPlanCalculationMethodSettings'].hasOwnProperty(key)
            )
              (<any>this.countryPlanCalculationMethodSettings)![key] = _data[
                'countryPlanCalculationMethodSettings'
              ][key]
                ? CountryPlanCalculationMethodSettingDto.fromJS(
                    _data['countryPlanCalculationMethodSettings'][key],
                  )
                : new CountryPlanCalculationMethodSettingDto();
          }
        } else {
          this.countryPlanCalculationMethodSettings = <any>null;
        }
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(SetupByCountryCountryDataDto.fromJS(item));
        } else {
          this.countries = <any>null;
        }
        if (Array.isArray(_data['plans'])) {
          this.plans = [] as any;
          for (let item of _data['plans'])
            this.plans!.push(SetupByCountryPlanDataDto.fromJS(item));
        } else {
          this.plans = <any>null;
        }
      }
    }

    static fromJS(data: any): PlanTypeCalculationMethodSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanTypeCalculationMethodSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.countryPlanCalculationMethodSettings) {
        data['countryPlanCalculationMethodSettings'] = {};
        for (let key in this.countryPlanCalculationMethodSettings) {
          if (this.countryPlanCalculationMethodSettings.hasOwnProperty(key))
            (<any>data['countryPlanCalculationMethodSettings'])[key] = this
              .countryPlanCalculationMethodSettings[key]
              ? this.countryPlanCalculationMethodSettings[key].toJSON()
              : <any>null;
        }
      }
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      if (Array.isArray(this.plans)) {
        data['plans'] = [];
        for (let item of this.plans) data['plans'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPlanTypeCalculationMethodSettingsDto {
    countryPlanCalculationMethodSettings: {
      [key: string]: CountryPlanCalculationMethodSettingDto;
    };
    countries: SetupByCountryCountryDataDto[];
    plans: SetupByCountryPlanDataDto[];
  }

  export class CountryPlanCalculationMethodSettingDto
    implements ICountryPlanCalculationMethodSettingDto
  {
    countryData!: SetupByCountryCountryDataDto;
    planData!: SetupByCountryPlanDataDto;
    calculationMethod!: CalculationMethodSetting;

    constructor(data?: ICountryPlanCalculationMethodSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryData = new SetupByCountryCountryDataDto();
        this.planData = new SetupByCountryPlanDataDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryData = _data['countryData']
          ? SetupByCountryCountryDataDto.fromJS(_data['countryData'])
          : new SetupByCountryCountryDataDto();
        this.planData = _data['planData']
          ? SetupByCountryPlanDataDto.fromJS(_data['planData'])
          : new SetupByCountryPlanDataDto();
        this.calculationMethod =
          _data['calculationMethod'] !== undefined
            ? _data['calculationMethod']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryPlanCalculationMethodSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryPlanCalculationMethodSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryData'] = this.countryData
        ? this.countryData.toJSON()
        : <any>null;
      data['planData'] = this.planData ? this.planData.toJSON() : <any>null;
      data['calculationMethod'] =
        this.calculationMethod !== undefined
          ? this.calculationMethod
          : <any>null;
      return data;
    }
  }

  export interface ICountryPlanCalculationMethodSettingDto {
    countryData: SetupByCountryCountryDataDto;
    planData: SetupByCountryPlanDataDto;
    calculationMethod: CalculationMethodSetting;
  }

  export class SetupByCountryCountryDataDto
    implements ISetupByCountryCountryDataDto
  {
    countryCode!: string;
    countryName!: string;
    countrySupported!: boolean;

    constructor(data?: ISetupByCountryCountryDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
        this.countrySupported =
          _data['countrySupported'] !== undefined
            ? _data['countrySupported']
            : <any>null;
      }
    }

    static fromJS(data: any): SetupByCountryCountryDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new SetupByCountryCountryDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      data['countrySupported'] =
        this.countrySupported !== undefined ? this.countrySupported : <any>null;
      return data;
    }
  }

  export interface ISetupByCountryCountryDataDto {
    countryCode: string;
    countryName: string;
    countrySupported: boolean;
  }

  export class SetupByCountryPlanDataDto implements ISetupByCountryPlanDataDto {
    planId!: string;
    planCode!: string;

    constructor(data?: ISetupByCountryPlanDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planId =
          _data['planId'] !== undefined ? _data['planId'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
      }
    }

    static fromJS(data: any): SetupByCountryPlanDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new SetupByCountryPlanDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planId'] = this.planId !== undefined ? this.planId : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      return data;
    }
  }

  export interface ISetupByCountryPlanDataDto {
    planId: string;
    planCode: string;
  }

  export enum CalculationMethodSetting {
    Automate = 'Automate',
    Manual = 'Manual',
    ReturnZero = 'ReturnZero',
  }

  export class CalculationMethodSettingDto
    implements ICalculationMethodSettingDto
  {
    calculationMethodSetting!: CalculationMethodSetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ICalculationMethodSettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.calculationMethodSetting =
          _data['calculationMethodSetting'] !== undefined
            ? _data['calculationMethodSetting']
            : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationMethodSettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationMethodSettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationMethodSetting'] =
        this.calculationMethodSetting !== undefined
          ? this.calculationMethodSetting
          : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ICalculationMethodSettingDto {
    calculationMethodSetting: CalculationMethodSetting;
    displayValue: string;
    displayOrder: number;
  }

  export class GetSetupByCountryPageDataQueryResultFailure
    extends GetSetupByCountryPageDataQueryResult
    implements IGetSetupByCountryPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetSetupByCountryPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetSetupByCountryPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetSetupByCountryPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetSetupByCountryPageDataQueryResultFailure
    extends IGetSetupByCountryPageDataQueryResult {
    errors: ResultError[];
  }

  export class SaveCountryPlanAutomationSettingsCommandResult
    implements ISaveCountryPlanAutomationSettingsCommandResult
  {
    constructor(data?: ISaveCountryPlanAutomationSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveCountryPlanAutomationSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryPlanAutomationSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCountryPlanAutomationSettingsCommandResult {}

  export class SaveCountryPlanAutomationSettingsCommandResultSuccess
    extends SaveCountryPlanAutomationSettingsCommandResult
    implements ISaveCountryPlanAutomationSettingsCommandResultSuccess
  {
    constructor(data?: ISaveCountryPlanAutomationSettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveCountryPlanAutomationSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryPlanAutomationSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryPlanAutomationSettingsCommandResultSuccess
    extends ISaveCountryPlanAutomationSettingsCommandResult {}

  export class SaveCountryPlanAutomationSettingsCommandResultFailure
    extends SaveCountryPlanAutomationSettingsCommandResult
    implements ISaveCountryPlanAutomationSettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveCountryPlanAutomationSettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveCountryPlanAutomationSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryPlanAutomationSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryPlanAutomationSettingsCommandResultFailure
    extends ISaveCountryPlanAutomationSettingsCommandResult {
    errors: ResultError[];
  }

  export class SaveCountryPlanAutomationSettingsCommand
    implements ISaveCountryPlanAutomationSettingsCommand
  {
    clientId!: string;
    saveCountryPlanAutomationSettingsList!: SaveCountryPlanAutomationSettingsDto[];

    constructor(data?: ISaveCountryPlanAutomationSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.saveCountryPlanAutomationSettingsList = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['saveCountryPlanAutomationSettingsList'])) {
          this.saveCountryPlanAutomationSettingsList = [] as any;
          for (let item of _data['saveCountryPlanAutomationSettingsList'])
            this.saveCountryPlanAutomationSettingsList!.push(
              SaveCountryPlanAutomationSettingsDto.fromJS(item),
            );
        } else {
          this.saveCountryPlanAutomationSettingsList = <any>null;
        }
      }
    }

    static fromJS(data: any): SaveCountryPlanAutomationSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryPlanAutomationSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.saveCountryPlanAutomationSettingsList)) {
        data['saveCountryPlanAutomationSettingsList'] = [];
        for (let item of this.saveCountryPlanAutomationSettingsList)
          data['saveCountryPlanAutomationSettingsList'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISaveCountryPlanAutomationSettingsCommand {
    clientId: string;
    saveCountryPlanAutomationSettingsList: SaveCountryPlanAutomationSettingsDto[];
  }

  export class SaveCountryPlanAutomationSettingsDto
    implements ISaveCountryPlanAutomationSettingsDto
  {
    countryCode!: string;
    planCodeId!: string;
    calculationMethodSetting!: CalculationMethodSetting;

    constructor(data?: ISaveCountryPlanAutomationSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.planCodeId =
          _data['planCodeId'] !== undefined ? _data['planCodeId'] : <any>null;
        this.calculationMethodSetting =
          _data['calculationMethodSetting'] !== undefined
            ? _data['calculationMethodSetting']
            : <any>null;
      }
    }

    static fromJS(data: any): SaveCountryPlanAutomationSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryPlanAutomationSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['planCodeId'] =
        this.planCodeId !== undefined ? this.planCodeId : <any>null;
      data['calculationMethodSetting'] =
        this.calculationMethodSetting !== undefined
          ? this.calculationMethodSetting
          : <any>null;
      return data;
    }
  }

  export interface ISaveCountryPlanAutomationSettingsDto {
    countryCode: string;
    planCodeId: string;
    calculationMethodSetting: CalculationMethodSetting;
  }

  export class GetResidencyPageDataQueryResult
    implements IGetResidencyPageDataQueryResult
  {
    constructor(data?: IGetResidencyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetResidencyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetResidencyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetResidencyPageDataQueryResult {}

  export class GetResidencyPageDataQueryResultSuccess
    extends GetResidencyPageDataQueryResult
    implements IGetResidencyPageDataQueryResultSuccess
  {
    result!: ResidencyPageData;

    constructor(data?: IGetResidencyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ResidencyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ResidencyPageData.fromJS(_data['result'])
          : new ResidencyPageData();
      }
    }

    static override fromJS(data: any): GetResidencyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetResidencyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetResidencyPageDataQueryResultSuccess
    extends IGetResidencyPageDataQueryResult {
    result: ResidencyPageData;
  }

  export class ResidencyPageData implements IResidencyPageData {
    residencyLocations!: ResidencyLocationDto[];
    scenarios!: ResidencyScenarios;

    constructor(data?: IResidencyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyLocations = [];
        this.scenarios = new ResidencyScenarios();
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['residencyLocations'])) {
          this.residencyLocations = [] as any;
          for (let item of _data['residencyLocations'])
            this.residencyLocations!.push(ResidencyLocationDto.fromJS(item));
        } else {
          this.residencyLocations = <any>null;
        }
        this.scenarios = _data['scenarios']
          ? ResidencyScenarios.fromJS(_data['scenarios'])
          : new ResidencyScenarios();
      }
    }

    static fromJS(data: any): ResidencyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.residencyLocations)) {
        data['residencyLocations'] = [];
        for (let item of this.residencyLocations)
          data['residencyLocations'].push(item.toJSON());
      }
      data['scenarios'] = this.scenarios ? this.scenarios.toJSON() : <any>null;
      return data;
    }
  }

  export interface IResidencyPageData {
    residencyLocations: ResidencyLocationDto[];
    scenarios: ResidencyScenarios;
  }

  export class ResidencyLocationDto implements IResidencyLocationDto {
    value!: ResidencyLocation;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IResidencyLocationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ResidencyLocationDto {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyLocationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IResidencyLocationDto {
    value: ResidencyLocation;
    displayValue: string;
    displayOrder: number;
  }

  export enum ResidencyLocation {
    AssignedWorkLocation = 'AssignedWorkLocation',
    LiveLocation = 'LiveLocation',
    EmploymentContractLocation = 'EmploymentContractLocation',
  }

  export class ResidencyScenarios implements IResidencyScenarios {
    scenarioAAA!: ResidencyScenario;
    scenarioABA!: ResidencyScenario;
    scenarioAAB!: ResidencyScenario;
    scenarioABC!: ResidencyScenario;
    scenarioABB!: ResidencyScenario;

    constructor(data?: IResidencyScenarios) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.scenarioAAA = new ResidencyScenario();
        this.scenarioABA = new ResidencyScenario();
        this.scenarioAAB = new ResidencyScenario();
        this.scenarioABC = new ResidencyScenario();
        this.scenarioABB = new ResidencyScenario();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.scenarioAAA = _data['scenarioAAA']
          ? ResidencyScenario.fromJS(_data['scenarioAAA'])
          : new ResidencyScenario();
        this.scenarioABA = _data['scenarioABA']
          ? ResidencyScenario.fromJS(_data['scenarioABA'])
          : new ResidencyScenario();
        this.scenarioAAB = _data['scenarioAAB']
          ? ResidencyScenario.fromJS(_data['scenarioAAB'])
          : new ResidencyScenario();
        this.scenarioABC = _data['scenarioABC']
          ? ResidencyScenario.fromJS(_data['scenarioABC'])
          : new ResidencyScenario();
        this.scenarioABB = _data['scenarioABB']
          ? ResidencyScenario.fromJS(_data['scenarioABB'])
          : new ResidencyScenario();
      }
    }

    static fromJS(data: any): ResidencyScenarios {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyScenarios();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['scenarioAAA'] = this.scenarioAAA
        ? this.scenarioAAA.toJSON()
        : <any>null;
      data['scenarioABA'] = this.scenarioABA
        ? this.scenarioABA.toJSON()
        : <any>null;
      data['scenarioAAB'] = this.scenarioAAB
        ? this.scenarioAAB.toJSON()
        : <any>null;
      data['scenarioABC'] = this.scenarioABC
        ? this.scenarioABC.toJSON()
        : <any>null;
      data['scenarioABB'] = this.scenarioABB
        ? this.scenarioABB.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IResidencyScenarios {
    scenarioAAA: ResidencyScenario;
    scenarioABA: ResidencyScenario;
    scenarioAAB: ResidencyScenario;
    scenarioABC: ResidencyScenario;
    scenarioABB: ResidencyScenario;
  }

  export class ResidencyScenario implements IResidencyScenario {
    deloitteDefault!: ResidencyLocation;
    cellLabelByResidencyLocation!: { [key: string]: string };
    companySetting!: ResidencyLocation | null;

    constructor(data?: IResidencyScenario) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.cellLabelByResidencyLocation = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.deloitteDefault =
          _data['deloitteDefault'] !== undefined
            ? _data['deloitteDefault']
            : <any>null;
        if (_data['cellLabelByResidencyLocation']) {
          this.cellLabelByResidencyLocation = {} as any;
          for (let key in _data['cellLabelByResidencyLocation']) {
            if (_data['cellLabelByResidencyLocation'].hasOwnProperty(key))
              (<any>this.cellLabelByResidencyLocation)![key] =
                _data['cellLabelByResidencyLocation'][key] !== undefined
                  ? _data['cellLabelByResidencyLocation'][key]
                  : <any>null;
          }
        } else {
          this.cellLabelByResidencyLocation = <any>null;
        }
        this.companySetting =
          _data['companySetting'] !== undefined
            ? _data['companySetting']
            : <any>null;
      }
    }

    static fromJS(data: any): ResidencyScenario {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyScenario();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['deloitteDefault'] =
        this.deloitteDefault !== undefined ? this.deloitteDefault : <any>null;
      if (this.cellLabelByResidencyLocation) {
        data['cellLabelByResidencyLocation'] = {};
        for (let key in this.cellLabelByResidencyLocation) {
          if (this.cellLabelByResidencyLocation.hasOwnProperty(key))
            (<any>data['cellLabelByResidencyLocation'])[key] =
              this.cellLabelByResidencyLocation[key] !== undefined
                ? this.cellLabelByResidencyLocation[key]
                : <any>null;
        }
      }
      data['companySetting'] =
        this.companySetting !== undefined ? this.companySetting : <any>null;
      return data;
    }
  }

  export interface IResidencyScenario {
    deloitteDefault: ResidencyLocation;
    cellLabelByResidencyLocation: { [key: string]: string };
    companySetting: ResidencyLocation | null;
  }

  export class GetResidencyPageDataQueryResultFailure
    extends GetResidencyPageDataQueryResult
    implements IGetResidencyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetResidencyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetResidencyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetResidencyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetResidencyPageDataQueryResultFailure
    extends IGetResidencyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertResidencySettingsCommandResult
    implements IUpsertResidencySettingsCommandResult
  {
    constructor(data?: IUpsertResidencySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertResidencySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertResidencySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertResidencySettingsCommandResult {}

  export class UpsertResidencySettingsCommandResultSuccess
    extends UpsertResidencySettingsCommandResult
    implements IUpsertResidencySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertResidencySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertResidencySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertResidencySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertResidencySettingsCommandResultSuccess
    extends IUpsertResidencySettingsCommandResult {}

  export class UpsertResidencySettingsCommandResultFailure
    extends UpsertResidencySettingsCommandResult
    implements IUpsertResidencySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertResidencySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertResidencySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertResidencySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertResidencySettingsCommandResultFailure
    extends IUpsertResidencySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertResidencySettingsCommand
    implements IUpsertResidencySettingsCommand
  {
    clientId!: string;
    residencySettings!: ResidencySettingsUpsertDto;

    constructor(data?: IUpsertResidencySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencySettings = new ResidencySettingsUpsertDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.residencySettings = _data['residencySettings']
          ? ResidencySettingsUpsertDto.fromJS(_data['residencySettings'])
          : new ResidencySettingsUpsertDto();
      }
    }

    static fromJS(data: any): UpsertResidencySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertResidencySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['residencySettings'] = this.residencySettings
        ? this.residencySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertResidencySettingsCommand {
    clientId: string;
    residencySettings: ResidencySettingsUpsertDto;
  }

  export class ResidencySettingsUpsertDto
    implements IResidencySettingsUpsertDto
  {
    scenarioAAA!: ResidencyLocation | null;
    scenarioABA!: ResidencyLocation | null;
    scenarioAAB!: ResidencyLocation | null;
    scenarioABC!: ResidencyLocation | null;
    scenarioABB!: ResidencyLocation | null;

    constructor(data?: IResidencySettingsUpsertDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.scenarioAAA =
          _data['scenarioAAA'] !== undefined ? _data['scenarioAAA'] : <any>null;
        this.scenarioABA =
          _data['scenarioABA'] !== undefined ? _data['scenarioABA'] : <any>null;
        this.scenarioAAB =
          _data['scenarioAAB'] !== undefined ? _data['scenarioAAB'] : <any>null;
        this.scenarioABC =
          _data['scenarioABC'] !== undefined ? _data['scenarioABC'] : <any>null;
        this.scenarioABB =
          _data['scenarioABB'] !== undefined ? _data['scenarioABB'] : <any>null;
      }
    }

    static fromJS(data: any): ResidencySettingsUpsertDto {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencySettingsUpsertDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['scenarioAAA'] =
        this.scenarioAAA !== undefined ? this.scenarioAAA : <any>null;
      data['scenarioABA'] =
        this.scenarioABA !== undefined ? this.scenarioABA : <any>null;
      data['scenarioAAB'] =
        this.scenarioAAB !== undefined ? this.scenarioAAB : <any>null;
      data['scenarioABC'] =
        this.scenarioABC !== undefined ? this.scenarioABC : <any>null;
      data['scenarioABB'] =
        this.scenarioABB !== undefined ? this.scenarioABB : <any>null;
      return data;
    }
  }

  export interface IResidencySettingsUpsertDto {
    scenarioAAA: ResidencyLocation | null;
    scenarioABA: ResidencyLocation | null;
    scenarioAAB: ResidencyLocation | null;
    scenarioABC: ResidencyLocation | null;
    scenarioABB: ResidencyLocation | null;
  }

  export abstract class GetClientTeamQueryResult
    implements IGetClientTeamQueryResult
  {
    constructor(data?: IGetClientTeamQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientTeamQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetClientTeamQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientTeamQueryResult {}

  export class GetClientTeamQueryResultSuccess
    extends GetClientTeamQueryResult
    implements IGetClientTeamQueryResultSuccess
  {
    clientId!: string;
    members!: ClientTeamMemberReportingDto[];

    constructor(data?: IGetClientTeamQueryResultSuccess) {
      super(data);
      if (!data) {
        this.members = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['members'])) {
          this.members = [] as any;
          for (let item of _data['members'])
            this.members!.push(ClientTeamMemberReportingDto.fromJS(item));
        } else {
          this.members = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetClientTeamQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientTeamQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.members)) {
        data['members'] = [];
        for (let item of this.members) data['members'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientTeamQueryResultSuccess
    extends IGetClientTeamQueryResult {
    clientId: string;
    members: ClientTeamMemberReportingDto[];
  }

  export class ClientTeamMemberReportingDto
    implements IClientTeamMemberReportingDto
  {
    id!: string;
    name!: string;
    jobTitle!: string;
    email!: string;

    constructor(data?: IClientTeamMemberReportingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.jobTitle =
          _data['jobTitle'] !== undefined ? _data['jobTitle'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
      }
    }

    static fromJS(data: any): ClientTeamMemberReportingDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientTeamMemberReportingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['jobTitle'] =
        this.jobTitle !== undefined ? this.jobTitle : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      return data;
    }
  }

  export interface IClientTeamMemberReportingDto {
    id: string;
    name: string;
    jobTitle: string;
    email: string;
  }

  export class GetClientTeamQueryResultFailure
    extends GetClientTeamQueryResult
    implements IGetClientTeamQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetClientTeamQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetClientTeamQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientTeamQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientTeamQueryResultFailure
    extends IGetClientTeamQueryResult {
    errorMessage: string;
  }

  export abstract class GetCountryFootprintQueryResult
    implements IGetCountryFootprintQueryResult
  {
    constructor(data?: IGetCountryFootprintQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryFootprintQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCountryFootprintQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryFootprintQueryResult {}

  export class GetCountryFootprintQueryResultSuccess
    extends GetCountryFootprintQueryResult
    implements IGetCountryFootprintQueryResultSuccess
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: IGetCountryFootprintQueryResultSuccess) {
      super(data);
      if (!data) {
        this.countryCodes = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCountryFootprintQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryFootprintQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryFootprintQueryResultSuccess
    extends IGetCountryFootprintQueryResult {
    clientId: string;
    countryCodes: string[];
  }

  export class GetCountryFootprintQueryResultFailure
    extends GetCountryFootprintQueryResult
    implements IGetCountryFootprintQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCountryFootprintQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetCountryFootprintQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryFootprintQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryFootprintQueryResultFailure
    extends IGetCountryFootprintQueryResult {
    errorMessage: string;
  }

  export abstract class GetEngagementRolesQueryResult
    implements IGetEngagementRolesQueryResult
  {
    constructor(data?: IGetEngagementRolesQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEngagementRolesQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetEngagementRolesQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEngagementRolesQueryResult {}

  export class GetEngagementRolesQueryResultSuccess
    extends GetEngagementRolesQueryResult
    implements IGetEngagementRolesQueryResultSuccess
  {
    roles!: EngagementRoleReportingDto[];

    constructor(data?: IGetEngagementRolesQueryResultSuccess) {
      super(data);
      if (!data) {
        this.roles = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['roles'])) {
          this.roles = [] as any;
          for (let item of _data['roles'])
            this.roles!.push(EngagementRoleReportingDto.fromJS(item));
        } else {
          this.roles = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetEngagementRolesQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEngagementRolesQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.roles)) {
        data['roles'] = [];
        for (let item of this.roles) data['roles'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEngagementRolesQueryResultSuccess
    extends IGetEngagementRolesQueryResult {
    roles: EngagementRoleReportingDto[];
  }

  export class EngagementRoleReportingDto
    implements IEngagementRoleReportingDto
  {
    id!: string;
    name!: string;

    constructor(data?: IEngagementRoleReportingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): EngagementRoleReportingDto {
      data = typeof data === 'object' ? data : {};
      let result = new EngagementRoleReportingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IEngagementRoleReportingDto {
    id: string;
    name: string;
  }

  export class GetEngagementRolesQueryResultFailure
    extends GetEngagementRolesQueryResult
    implements IGetEngagementRolesQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetEngagementRolesQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetEngagementRolesQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEngagementRolesQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEngagementRolesQueryResultFailure
    extends IGetEngagementRolesQueryResult {
    errors: ResultError[];
  }

  export class GetEngagementRolesQuery implements IGetEngagementRolesQuery {
    constructor(data?: IGetEngagementRolesQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEngagementRolesQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetEngagementRolesQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEngagementRolesQuery {}

  export abstract class GetPlansQueryResult implements IGetPlansQueryResult {
    constructor(data?: IGetPlansQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPlansQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetPlansQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPlansQueryResult {}

  export class GetPlansQueryResultSuccess
    extends GetPlansQueryResult
    implements IGetPlansQueryResultSuccess
  {
    clientId!: string;
    plans!: PlanReportingDto[];

    constructor(data?: IGetPlansQueryResultSuccess) {
      super(data);
      if (!data) {
        this.plans = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['plans'])) {
          this.plans = [] as any;
          for (let item of _data['plans'])
            this.plans!.push(PlanReportingDto.fromJS(item));
        } else {
          this.plans = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetPlansQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPlansQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.plans)) {
        data['plans'] = [];
        for (let item of this.plans) data['plans'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPlansQueryResultSuccess extends IGetPlansQueryResult {
    clientId: string;
    plans: PlanReportingDto[];
  }

  export class PlanReportingDto implements IPlanReportingDto {
    type!: PlanType;
    code!: string;

    constructor(data?: IPlanReportingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PlanReportingDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanReportingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPlanReportingDto {
    type: PlanType;
    code: string;
  }

  export class GetPlansQueryResultFailure
    extends GetPlansQueryResult
    implements IGetPlansQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetPlansQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetPlansQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPlansQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPlansQueryResultFailure extends IGetPlansQueryResult {
    errorMessage: string;
  }

  export abstract class GetDeloitteTeamMemberRoleQueryResult
    implements IGetDeloitteTeamMemberRoleQueryResult
  {
    constructor(data?: IGetDeloitteTeamMemberRoleQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeloitteTeamMemberRoleQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDeloitteTeamMemberRoleQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeloitteTeamMemberRoleQueryResult {}

  export class GetDeloitteTeamMemberRoleQueryResultSuccess
    extends GetDeloitteTeamMemberRoleQueryResult
    implements IGetDeloitteTeamMemberRoleQueryResultSuccess
  {
    clientId!: string;
    teamMemberId!: string;
    roleId!: string | null;

    constructor(data?: IGetDeloitteTeamMemberRoleQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.teamMemberId =
          _data['teamMemberId'] !== undefined
            ? _data['teamMemberId']
            : <any>null;
        this.roleId =
          _data['roleId'] !== undefined ? _data['roleId'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteTeamMemberRoleQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteTeamMemberRoleQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['teamMemberId'] =
        this.teamMemberId !== undefined ? this.teamMemberId : <any>null;
      data['roleId'] = this.roleId !== undefined ? this.roleId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteTeamMemberRoleQueryResultSuccess
    extends IGetDeloitteTeamMemberRoleQueryResult {
    clientId: string;
    teamMemberId: string;
    roleId: string | null;
  }

  export class GetDeloitteTeamMemberRoleQueryResultFailure
    extends GetDeloitteTeamMemberRoleQueryResult
    implements IGetDeloitteTeamMemberRoleQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetDeloitteTeamMemberRoleQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteTeamMemberRoleQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteTeamMemberRoleQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteTeamMemberRoleQueryResultFailure
    extends IGetDeloitteTeamMemberRoleQueryResult {
    errorMessage: string;
  }

  export abstract class GetBatchIdsQueryResult
    implements IGetBatchIdsQueryResult
  {
    constructor(data?: IGetBatchIdsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchIdsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchIdsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchIdsQueryResult {}

  export class GetBatchIdsQueryResultSuccess
    extends GetBatchIdsQueryResult
    implements IGetBatchIdsQueryResultSuccess
  {
    batchIds!: string[];

    constructor(data?: IGetBatchIdsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.batchIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBatchIdsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchIdsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchIdsQueryResultSuccess
    extends IGetBatchIdsQueryResult {
    batchIds: string[];
  }

  export class GetBatchIdsQueryResultFailure
    extends GetBatchIdsQueryResult
    implements IGetBatchIdsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetBatchIdsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetBatchIdsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchIdsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchIdsQueryResultFailure
    extends IGetBatchIdsQueryResult {
    errorMessage: string;
  }

  export abstract class SearchBatchIdsCommandResult
    implements ISearchBatchIdsCommandResult
  {
    constructor(data?: ISearchBatchIdsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchBatchIdsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SearchBatchIdsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchBatchIdsCommandResult {}

  export class SearchBatchIdsCommandResultSuccess
    extends SearchBatchIdsCommandResult
    implements ISearchBatchIdsCommandResultSuccess
  {
    batchIds!: string[];

    constructor(data?: ISearchBatchIdsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.batchIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
      }
    }

    static override fromJS(data: any): SearchBatchIdsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchBatchIdsCommandResultSuccess
    extends ISearchBatchIdsCommandResult {
    batchIds: string[];
  }

  export class SearchBatchIdsCommandResultFailure
    extends SearchBatchIdsCommandResult
    implements ISearchBatchIdsCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISearchBatchIdsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): SearchBatchIdsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchBatchIdsCommandResultFailure
    extends ISearchBatchIdsCommandResult {
    errorMessage: string;
  }

  export class SearchBatchIdsCommand implements ISearchBatchIdsCommand {
    clientId!: string;
    batchIdsStartsWithQuery!: string[];
    size!: number;

    constructor(data?: ISearchBatchIdsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchIdsStartsWithQuery = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['batchIdsStartsWithQuery'])) {
          this.batchIdsStartsWithQuery = [] as any;
          for (let item of _data['batchIdsStartsWithQuery'])
            this.batchIdsStartsWithQuery!.push(item);
        } else {
          this.batchIdsStartsWithQuery = <any>null;
        }
        this.size = _data['size'] !== undefined ? _data['size'] : <any>null;
      }
    }

    static fromJS(data: any): SearchBatchIdsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.batchIdsStartsWithQuery)) {
        data['batchIdsStartsWithQuery'] = [];
        for (let item of this.batchIdsStartsWithQuery)
          data['batchIdsStartsWithQuery'].push(item);
      }
      data['size'] = this.size !== undefined ? this.size : <any>null;
      return data;
    }
  }

  export interface ISearchBatchIdsCommand {
    clientId: string;
    batchIdsStartsWithQuery: string[];
    size: number;
  }

  export class GetReportCriteraIdsQueryResult
    implements IGetReportCriteraIdsQueryResult
  {
    constructor(data?: IGetReportCriteraIdsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetReportCriteraIdsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetReportCriteraIdsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetReportCriteraIdsQueryResult {}

  export class GetReportCriteraIdsQueryResultSuccess
    extends GetReportCriteraIdsQueryResult
    implements IGetReportCriteraIdsQueryResultSuccess
  {
    employeeIds!: string[];
    transactionIds!: string[];
    transactionGuids!: string[];

    constructor(data?: IGetReportCriteraIdsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.employeeIds = [];
        this.transactionIds = [];
        this.transactionGuids = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['employeeIds'])) {
          this.employeeIds = [] as any;
          for (let item of _data['employeeIds']) this.employeeIds!.push(item);
        } else {
          this.employeeIds = <any>null;
        }
        if (Array.isArray(_data['transactionIds'])) {
          this.transactionIds = [] as any;
          for (let item of _data['transactionIds'])
            this.transactionIds!.push(item);
        } else {
          this.transactionIds = <any>null;
        }
        if (Array.isArray(_data['transactionGuids'])) {
          this.transactionGuids = [] as any;
          for (let item of _data['transactionGuids'])
            this.transactionGuids!.push(item);
        } else {
          this.transactionGuids = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetReportCriteraIdsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetReportCriteraIdsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.employeeIds)) {
        data['employeeIds'] = [];
        for (let item of this.employeeIds) data['employeeIds'].push(item);
      }
      if (Array.isArray(this.transactionIds)) {
        data['transactionIds'] = [];
        for (let item of this.transactionIds) data['transactionIds'].push(item);
      }
      if (Array.isArray(this.transactionGuids)) {
        data['transactionGuids'] = [];
        for (let item of this.transactionGuids)
          data['transactionGuids'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetReportCriteraIdsQueryResultSuccess
    extends IGetReportCriteraIdsQueryResult {
    employeeIds: string[];
    transactionIds: string[];
    transactionGuids: string[];
  }

  export class GetReportCriteraIdsQueryResultFailure
    extends GetReportCriteraIdsQueryResult
    implements IGetReportCriteraIdsQueryResultFailure
  {
    constructor(data?: IGetReportCriteraIdsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetReportCriteraIdsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetReportCriteraIdsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetReportCriteraIdsQueryResultFailure
    extends IGetReportCriteraIdsQueryResult {}

  export class SearchReportCriteriaIdsQueryResult
    implements ISearchReportCriteriaIdsQueryResult
  {
    constructor(data?: ISearchReportCriteriaIdsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchReportCriteriaIdsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new SearchReportCriteriaIdsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchReportCriteriaIdsQueryResult {}

  export class SearchReportCriteriaIdsQueryResultSuccess
    extends SearchReportCriteriaIdsQueryResult
    implements ISearchReportCriteriaIdsQueryResultSuccess
  {
    employeeIds!: string[];
    transactionIds!: string[];
    transactionGuids!: string[];

    constructor(data?: ISearchReportCriteriaIdsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.employeeIds = [];
        this.transactionIds = [];
        this.transactionGuids = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['employeeIds'])) {
          this.employeeIds = [] as any;
          for (let item of _data['employeeIds']) this.employeeIds!.push(item);
        } else {
          this.employeeIds = <any>null;
        }
        if (Array.isArray(_data['transactionIds'])) {
          this.transactionIds = [] as any;
          for (let item of _data['transactionIds'])
            this.transactionIds!.push(item);
        } else {
          this.transactionIds = <any>null;
        }
        if (Array.isArray(_data['transactionGuids'])) {
          this.transactionGuids = [] as any;
          for (let item of _data['transactionGuids'])
            this.transactionGuids!.push(item);
        } else {
          this.transactionGuids = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SearchReportCriteriaIdsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchReportCriteriaIdsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.employeeIds)) {
        data['employeeIds'] = [];
        for (let item of this.employeeIds) data['employeeIds'].push(item);
      }
      if (Array.isArray(this.transactionIds)) {
        data['transactionIds'] = [];
        for (let item of this.transactionIds) data['transactionIds'].push(item);
      }
      if (Array.isArray(this.transactionGuids)) {
        data['transactionGuids'] = [];
        for (let item of this.transactionGuids)
          data['transactionGuids'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchReportCriteriaIdsQueryResultSuccess
    extends ISearchReportCriteriaIdsQueryResult {
    employeeIds: string[];
    transactionIds: string[];
    transactionGuids: string[];
  }

  export class SearchReportCriteriaIdsQueryResultFailure
    extends SearchReportCriteriaIdsQueryResult
    implements ISearchReportCriteriaIdsQueryResultFailure
  {
    constructor(data?: ISearchReportCriteriaIdsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SearchReportCriteriaIdsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchReportCriteriaIdsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchReportCriteriaIdsQueryResultFailure
    extends ISearchReportCriteriaIdsQueryResult {}

  export class SearchReportCriteriaIdsQuery
    implements ISearchReportCriteriaIdsQuery
  {
    clientId!: string;
    employeeIds!: string[] | null;
    transactionIds!: string[] | null;
    transactionGuids!: string[] | null;
    size!: number;

    constructor(data?: ISearchReportCriteriaIdsQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeeIds'])) {
          this.employeeIds = [] as any;
          for (let item of _data['employeeIds']) this.employeeIds!.push(item);
        } else {
          this.employeeIds = <any>null;
        }
        if (Array.isArray(_data['transactionIds'])) {
          this.transactionIds = [] as any;
          for (let item of _data['transactionIds'])
            this.transactionIds!.push(item);
        } else {
          this.transactionIds = <any>null;
        }
        if (Array.isArray(_data['transactionGuids'])) {
          this.transactionGuids = [] as any;
          for (let item of _data['transactionGuids'])
            this.transactionGuids!.push(item);
        } else {
          this.transactionGuids = <any>null;
        }
        this.size = _data['size'] !== undefined ? _data['size'] : <any>null;
      }
    }

    static fromJS(data: any): SearchReportCriteriaIdsQuery {
      data = typeof data === 'object' ? data : {};
      let result = new SearchReportCriteriaIdsQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeeIds)) {
        data['employeeIds'] = [];
        for (let item of this.employeeIds) data['employeeIds'].push(item);
      }
      if (Array.isArray(this.transactionIds)) {
        data['transactionIds'] = [];
        for (let item of this.transactionIds) data['transactionIds'].push(item);
      }
      if (Array.isArray(this.transactionGuids)) {
        data['transactionGuids'] = [];
        for (let item of this.transactionGuids)
          data['transactionGuids'].push(item);
      }
      data['size'] = this.size !== undefined ? this.size : <any>null;
      return data;
    }
  }

  export interface ISearchReportCriteriaIdsQuery {
    clientId: string;
    employeeIds: string[] | null;
    transactionIds: string[] | null;
    transactionGuids: string[] | null;
    size: number;
  }

  export abstract class GetEmployeePopulationQueryResult
    implements IGetEmployeePopulationQueryResult
  {
    constructor(data?: IGetEmployeePopulationQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEmployeePopulationQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetEmployeePopulationQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEmployeePopulationQueryResult {}

  export class GetEmployeePopulationQueryResultSuccess
    extends GetEmployeePopulationQueryResult
    implements IGetEmployeePopulationQueryResultSuccess
  {
    clientId!: string;
    employeePopulationPolicyDetails!: EmployeePopulationPolicyDto[];

    constructor(data?: IGetEmployeePopulationQueryResultSuccess) {
      super(data);
      if (!data) {
        this.employeePopulationPolicyDetails = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['employeePopulationPolicyDetails'])) {
          this.employeePopulationPolicyDetails = [] as any;
          for (let item of _data['employeePopulationPolicyDetails'])
            this.employeePopulationPolicyDetails!.push(
              EmployeePopulationPolicyDto.fromJS(item),
            );
        } else {
          this.employeePopulationPolicyDetails = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetEmployeePopulationQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeePopulationQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.employeePopulationPolicyDetails)) {
        data['employeePopulationPolicyDetails'] = [];
        for (let item of this.employeePopulationPolicyDetails)
          data['employeePopulationPolicyDetails'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeePopulationQueryResultSuccess
    extends IGetEmployeePopulationQueryResult {
    clientId: string;
    employeePopulationPolicyDetails: EmployeePopulationPolicyDto[];
  }

  export class EmployeePopulationPolicyDto
    implements IEmployeePopulationPolicyDto
  {
    clientPolicyName!: string;
    clientPolicyWorkLocationTypeId!: WorkLocationTypeSetting;
    createdDate!: Date;

    constructor(data?: IEmployeePopulationPolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyWorkLocationTypeId =
          _data['clientPolicyWorkLocationTypeId'] !== undefined
            ? _data['clientPolicyWorkLocationTypeId']
            : <any>null;
        this.createdDate = _data['createdDate']
          ? new Date(_data['createdDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): EmployeePopulationPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeePopulationPolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyWorkLocationTypeId'] =
        this.clientPolicyWorkLocationTypeId !== undefined
          ? this.clientPolicyWorkLocationTypeId
          : <any>null;
      data['createdDate'] = this.createdDate
        ? this.createdDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IEmployeePopulationPolicyDto {
    clientPolicyName: string;
    clientPolicyWorkLocationTypeId: WorkLocationTypeSetting;
    createdDate: Date;
  }

  export class GetEmployeePopulationQueryResultFailure
    extends GetEmployeePopulationQueryResult
    implements IGetEmployeePopulationQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetEmployeePopulationQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetEmployeePopulationQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeePopulationQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeePopulationQueryResultFailure
    extends IGetEmployeePopulationQueryResult {
    errorMessage: string;
  }

  export abstract class GetLimitedClientIdsResult
    implements IGetLimitedClientIdsResult
  {
    constructor(data?: IGetLimitedClientIdsResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetLimitedClientIdsResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetLimitedClientIdsResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetLimitedClientIdsResult {}

  export class GetLimitedClientIdsQueryResultSuccess
    extends GetLimitedClientIdsResult
    implements IGetLimitedClientIdsQueryResultSuccess
  {
    viewClientsAuthorizationResult!: string;
    clientIds!: string[] | null;

    constructor(data?: IGetLimitedClientIdsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.viewClientsAuthorizationResult =
          _data['viewClientsAuthorizationResult'] !== undefined
            ? _data['viewClientsAuthorizationResult']
            : <any>null;
        if (Array.isArray(_data['clientIds'])) {
          this.clientIds = [] as any;
          for (let item of _data['clientIds']) this.clientIds!.push(item);
        } else {
          this.clientIds = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetLimitedClientIdsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetLimitedClientIdsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['viewClientsAuthorizationResult'] =
        this.viewClientsAuthorizationResult !== undefined
          ? this.viewClientsAuthorizationResult
          : <any>null;
      if (Array.isArray(this.clientIds)) {
        data['clientIds'] = [];
        for (let item of this.clientIds) data['clientIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLimitedClientIdsQueryResultSuccess
    extends IGetLimitedClientIdsResult {
    viewClientsAuthorizationResult: string;
    clientIds: string[] | null;
  }

  export class GetLimitedClientIdsResultFailure
    extends GetLimitedClientIdsResult
    implements IGetLimitedClientIdsResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetLimitedClientIdsResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetLimitedClientIdsResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetLimitedClientIdsResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLimitedClientIdsResultFailure
    extends IGetLimitedClientIdsResult {
    errorMessage: string;
  }

  export abstract class GetClientByPortalIdQueryResult
    implements IGetClientByPortalIdQueryResult
  {
    constructor(data?: IGetClientByPortalIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientByPortalIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetClientByPortalIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientByPortalIdQueryResult {}

  export class GetClientByPortalIdQueryandResultSuccess
    extends GetClientByPortalIdQueryResult
    implements IGetClientByPortalIdQueryandResultSuccess
  {
    client!: ClientDto;

    constructor(data?: IGetClientByPortalIdQueryandResultSuccess) {
      super(data);
      if (!data) {
        this.client = new ClientDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.client = _data['client']
          ? ClientDto.fromJS(_data['client'])
          : new ClientDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetClientByPortalIdQueryandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientByPortalIdQueryandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['client'] = this.client ? this.client.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientByPortalIdQueryandResultSuccess
    extends IGetClientByPortalIdQueryResult {
    client: ClientDto;
  }

  export class ClientDto implements IClientDto {
    id!: string;
    portalId!: string;
    name!: string;
    state!: ClientStateDto;
    clientTeamDetailsId!: string | null;
    deloitteTeamDetailsId!: string | null;
    contractAndPricingId!: string | null;
    countryFootprintDetailsId!: string | null;
    planSetupDetailsId!: string | null;
    liveEventDetailsId!: string | null;
    manualCalculationsId!: string | null;
    clientWorkflowDto!: ClientWorkflowDto;
    clientPayrollDetails!: ClientPayrollDetailsDto | null;
    clientBrokerDetails!: ClientBrokerDetailsDto | null;
    empPopulationDetailsId!: string | null;
    cashPaymentPolicySettingsId!: string | null;

    constructor(data?: IClientDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientWorkflowDto = new ClientWorkflowDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.state = _data['state'] !== undefined ? _data['state'] : <any>null;
        this.clientTeamDetailsId =
          _data['clientTeamDetailsId'] !== undefined
            ? _data['clientTeamDetailsId']
            : <any>null;
        this.deloitteTeamDetailsId =
          _data['deloitteTeamDetailsId'] !== undefined
            ? _data['deloitteTeamDetailsId']
            : <any>null;
        this.contractAndPricingId =
          _data['contractAndPricingId'] !== undefined
            ? _data['contractAndPricingId']
            : <any>null;
        this.countryFootprintDetailsId =
          _data['countryFootprintDetailsId'] !== undefined
            ? _data['countryFootprintDetailsId']
            : <any>null;
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.liveEventDetailsId =
          _data['liveEventDetailsId'] !== undefined
            ? _data['liveEventDetailsId']
            : <any>null;
        this.manualCalculationsId =
          _data['manualCalculationsId'] !== undefined
            ? _data['manualCalculationsId']
            : <any>null;
        this.clientWorkflowDto = _data['clientWorkflowDto']
          ? ClientWorkflowDto.fromJS(_data['clientWorkflowDto'])
          : new ClientWorkflowDto();
        this.clientPayrollDetails = _data['clientPayrollDetails']
          ? ClientPayrollDetailsDto.fromJS(_data['clientPayrollDetails'])
          : <any>null;
        this.clientBrokerDetails = _data['clientBrokerDetails']
          ? ClientBrokerDetailsDto.fromJS(_data['clientBrokerDetails'])
          : <any>null;
        this.empPopulationDetailsId =
          _data['empPopulationDetailsId'] !== undefined
            ? _data['empPopulationDetailsId']
            : <any>null;
        this.cashPaymentPolicySettingsId =
          _data['cashPaymentPolicySettingsId'] !== undefined
            ? _data['cashPaymentPolicySettingsId']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['state'] = this.state !== undefined ? this.state : <any>null;
      data['clientTeamDetailsId'] =
        this.clientTeamDetailsId !== undefined
          ? this.clientTeamDetailsId
          : <any>null;
      data['deloitteTeamDetailsId'] =
        this.deloitteTeamDetailsId !== undefined
          ? this.deloitteTeamDetailsId
          : <any>null;
      data['contractAndPricingId'] =
        this.contractAndPricingId !== undefined
          ? this.contractAndPricingId
          : <any>null;
      data['countryFootprintDetailsId'] =
        this.countryFootprintDetailsId !== undefined
          ? this.countryFootprintDetailsId
          : <any>null;
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['liveEventDetailsId'] =
        this.liveEventDetailsId !== undefined
          ? this.liveEventDetailsId
          : <any>null;
      data['manualCalculationsId'] =
        this.manualCalculationsId !== undefined
          ? this.manualCalculationsId
          : <any>null;
      data['clientWorkflowDto'] = this.clientWorkflowDto
        ? this.clientWorkflowDto.toJSON()
        : <any>null;
      data['clientPayrollDetails'] = this.clientPayrollDetails
        ? this.clientPayrollDetails.toJSON()
        : <any>null;
      data['clientBrokerDetails'] = this.clientBrokerDetails
        ? this.clientBrokerDetails.toJSON()
        : <any>null;
      data['empPopulationDetailsId'] =
        this.empPopulationDetailsId !== undefined
          ? this.empPopulationDetailsId
          : <any>null;
      data['cashPaymentPolicySettingsId'] =
        this.cashPaymentPolicySettingsId !== undefined
          ? this.cashPaymentPolicySettingsId
          : <any>null;
      return data;
    }
  }

  export interface IClientDto {
    id: string;
    portalId: string;
    name: string;
    state: ClientStateDto;
    clientTeamDetailsId: string | null;
    deloitteTeamDetailsId: string | null;
    contractAndPricingId: string | null;
    countryFootprintDetailsId: string | null;
    planSetupDetailsId: string | null;
    liveEventDetailsId: string | null;
    manualCalculationsId: string | null;
    clientWorkflowDto: ClientWorkflowDto;
    clientPayrollDetails: ClientPayrollDetailsDto | null;
    clientBrokerDetails: ClientBrokerDetailsDto | null;
    empPopulationDetailsId: string | null;
    cashPaymentPolicySettingsId: string | null;
  }

  export enum ClientStateDto {
    Enrolling = 'Enrolling',
    Active = 'Active',
  }

  export class ClientWorkflowDto implements IClientWorkflowDto {
    clientTeamState!: StepStateDto;
    deloitteTeamState!: StepStateDto;
    contractAndPricingState!: StepStateDto;
    payrollState!: StepStateDto;
    brokerState!: StepStateDto;
    employeePopulationsState!: StepStateDto;
    countryFootprintState!: StepStateDto;
    planSetupState!: StepStateDto;
    countryPlanAutomationSettingsState!: StepStateDto;
    manualCalculationsState!: StepStateDto;
    liveEventDetailsState!: StepStateDto;
    cashPaymentPolicyState!: StepStateDto;
    rechargePolicyState!: StepStateDto;
    doubleTaxReliefPolicyState!: StepStateDto;
    regionDoubleTaxReliefPolicyState!: StepStateDto;
    socialTaxPolicyState!: StepStateDto;
    taxRatePolicyState!: StepStateDto;
    socialTaxRatePolicyState!: StepStateDto;
    regionTaxRatePolicyState!: StepStateDto;
    taxableConsiderationPolicyState!: StepStateDto;
    residencyPolicyState!: StepStateDto;
    taxAdjustmentState!: StepStateDto;
    countryTaxPositionsState!: StepStateDto;
    countryRegionTaxPositionsState!: StepStateDto;
    customTaxesState!: StepStateDto;
    countryTaxRatesState!: StepStateDto;
    regionTaxRatesState!: StepStateDto;
    exchangeTaxRatesState!: StepStateDto;
    precisionState!: StepStateDto;
    teqClientState!: StepStateDto;
    teqWorkLocationState!: StepStateDto;
    hypoCountryTaxRatesState!: StepStateDto;
    hypoRegionTaxRatesState!: StepStateDto;
    hypoCustomTaxRatesState!: StepStateDto;

    constructor(data?: IClientWorkflowDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientTeamState =
          _data['clientTeamState'] !== undefined
            ? _data['clientTeamState']
            : <any>null;
        this.deloitteTeamState =
          _data['deloitteTeamState'] !== undefined
            ? _data['deloitteTeamState']
            : <any>null;
        this.contractAndPricingState =
          _data['contractAndPricingState'] !== undefined
            ? _data['contractAndPricingState']
            : <any>null;
        this.payrollState =
          _data['payrollState'] !== undefined
            ? _data['payrollState']
            : <any>null;
        this.brokerState =
          _data['brokerState'] !== undefined ? _data['brokerState'] : <any>null;
        this.employeePopulationsState =
          _data['employeePopulationsState'] !== undefined
            ? _data['employeePopulationsState']
            : <any>null;
        this.countryFootprintState =
          _data['countryFootprintState'] !== undefined
            ? _data['countryFootprintState']
            : <any>null;
        this.planSetupState =
          _data['planSetupState'] !== undefined
            ? _data['planSetupState']
            : <any>null;
        this.countryPlanAutomationSettingsState =
          _data['countryPlanAutomationSettingsState'] !== undefined
            ? _data['countryPlanAutomationSettingsState']
            : <any>null;
        this.manualCalculationsState =
          _data['manualCalculationsState'] !== undefined
            ? _data['manualCalculationsState']
            : <any>null;
        this.liveEventDetailsState =
          _data['liveEventDetailsState'] !== undefined
            ? _data['liveEventDetailsState']
            : <any>null;
        this.cashPaymentPolicyState =
          _data['cashPaymentPolicyState'] !== undefined
            ? _data['cashPaymentPolicyState']
            : <any>null;
        this.rechargePolicyState =
          _data['rechargePolicyState'] !== undefined
            ? _data['rechargePolicyState']
            : <any>null;
        this.doubleTaxReliefPolicyState =
          _data['doubleTaxReliefPolicyState'] !== undefined
            ? _data['doubleTaxReliefPolicyState']
            : <any>null;
        this.regionDoubleTaxReliefPolicyState =
          _data['regionDoubleTaxReliefPolicyState'] !== undefined
            ? _data['regionDoubleTaxReliefPolicyState']
            : <any>null;
        this.socialTaxPolicyState =
          _data['socialTaxPolicyState'] !== undefined
            ? _data['socialTaxPolicyState']
            : <any>null;
        this.taxRatePolicyState =
          _data['taxRatePolicyState'] !== undefined
            ? _data['taxRatePolicyState']
            : <any>null;
        this.socialTaxRatePolicyState =
          _data['socialTaxRatePolicyState'] !== undefined
            ? _data['socialTaxRatePolicyState']
            : <any>null;
        this.regionTaxRatePolicyState =
          _data['regionTaxRatePolicyState'] !== undefined
            ? _data['regionTaxRatePolicyState']
            : <any>null;
        this.taxableConsiderationPolicyState =
          _data['taxableConsiderationPolicyState'] !== undefined
            ? _data['taxableConsiderationPolicyState']
            : <any>null;
        this.residencyPolicyState =
          _data['residencyPolicyState'] !== undefined
            ? _data['residencyPolicyState']
            : <any>null;
        this.taxAdjustmentState =
          _data['taxAdjustmentState'] !== undefined
            ? _data['taxAdjustmentState']
            : <any>null;
        this.countryTaxPositionsState =
          _data['countryTaxPositionsState'] !== undefined
            ? _data['countryTaxPositionsState']
            : <any>null;
        this.countryRegionTaxPositionsState =
          _data['countryRegionTaxPositionsState'] !== undefined
            ? _data['countryRegionTaxPositionsState']
            : <any>null;
        this.customTaxesState =
          _data['customTaxesState'] !== undefined
            ? _data['customTaxesState']
            : <any>null;
        this.countryTaxRatesState =
          _data['countryTaxRatesState'] !== undefined
            ? _data['countryTaxRatesState']
            : <any>null;
        this.regionTaxRatesState =
          _data['regionTaxRatesState'] !== undefined
            ? _data['regionTaxRatesState']
            : <any>null;
        this.exchangeTaxRatesState =
          _data['exchangeTaxRatesState'] !== undefined
            ? _data['exchangeTaxRatesState']
            : <any>null;
        this.precisionState =
          _data['precisionState'] !== undefined
            ? _data['precisionState']
            : <any>null;
        this.teqClientState =
          _data['teqClientState'] !== undefined
            ? _data['teqClientState']
            : <any>null;
        this.teqWorkLocationState =
          _data['teqWorkLocationState'] !== undefined
            ? _data['teqWorkLocationState']
            : <any>null;
        this.hypoCountryTaxRatesState =
          _data['hypoCountryTaxRatesState'] !== undefined
            ? _data['hypoCountryTaxRatesState']
            : <any>null;
        this.hypoRegionTaxRatesState =
          _data['hypoRegionTaxRatesState'] !== undefined
            ? _data['hypoRegionTaxRatesState']
            : <any>null;
        this.hypoCustomTaxRatesState =
          _data['hypoCustomTaxRatesState'] !== undefined
            ? _data['hypoCustomTaxRatesState']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientWorkflowDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientWorkflowDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientTeamState'] =
        this.clientTeamState !== undefined ? this.clientTeamState : <any>null;
      data['deloitteTeamState'] =
        this.deloitteTeamState !== undefined
          ? this.deloitteTeamState
          : <any>null;
      data['contractAndPricingState'] =
        this.contractAndPricingState !== undefined
          ? this.contractAndPricingState
          : <any>null;
      data['payrollState'] =
        this.payrollState !== undefined ? this.payrollState : <any>null;
      data['brokerState'] =
        this.brokerState !== undefined ? this.brokerState : <any>null;
      data['employeePopulationsState'] =
        this.employeePopulationsState !== undefined
          ? this.employeePopulationsState
          : <any>null;
      data['countryFootprintState'] =
        this.countryFootprintState !== undefined
          ? this.countryFootprintState
          : <any>null;
      data['planSetupState'] =
        this.planSetupState !== undefined ? this.planSetupState : <any>null;
      data['countryPlanAutomationSettingsState'] =
        this.countryPlanAutomationSettingsState !== undefined
          ? this.countryPlanAutomationSettingsState
          : <any>null;
      data['manualCalculationsState'] =
        this.manualCalculationsState !== undefined
          ? this.manualCalculationsState
          : <any>null;
      data['liveEventDetailsState'] =
        this.liveEventDetailsState !== undefined
          ? this.liveEventDetailsState
          : <any>null;
      data['cashPaymentPolicyState'] =
        this.cashPaymentPolicyState !== undefined
          ? this.cashPaymentPolicyState
          : <any>null;
      data['rechargePolicyState'] =
        this.rechargePolicyState !== undefined
          ? this.rechargePolicyState
          : <any>null;
      data['doubleTaxReliefPolicyState'] =
        this.doubleTaxReliefPolicyState !== undefined
          ? this.doubleTaxReliefPolicyState
          : <any>null;
      data['regionDoubleTaxReliefPolicyState'] =
        this.regionDoubleTaxReliefPolicyState !== undefined
          ? this.regionDoubleTaxReliefPolicyState
          : <any>null;
      data['socialTaxPolicyState'] =
        this.socialTaxPolicyState !== undefined
          ? this.socialTaxPolicyState
          : <any>null;
      data['taxRatePolicyState'] =
        this.taxRatePolicyState !== undefined
          ? this.taxRatePolicyState
          : <any>null;
      data['socialTaxRatePolicyState'] =
        this.socialTaxRatePolicyState !== undefined
          ? this.socialTaxRatePolicyState
          : <any>null;
      data['regionTaxRatePolicyState'] =
        this.regionTaxRatePolicyState !== undefined
          ? this.regionTaxRatePolicyState
          : <any>null;
      data['taxableConsiderationPolicyState'] =
        this.taxableConsiderationPolicyState !== undefined
          ? this.taxableConsiderationPolicyState
          : <any>null;
      data['residencyPolicyState'] =
        this.residencyPolicyState !== undefined
          ? this.residencyPolicyState
          : <any>null;
      data['taxAdjustmentState'] =
        this.taxAdjustmentState !== undefined
          ? this.taxAdjustmentState
          : <any>null;
      data['countryTaxPositionsState'] =
        this.countryTaxPositionsState !== undefined
          ? this.countryTaxPositionsState
          : <any>null;
      data['countryRegionTaxPositionsState'] =
        this.countryRegionTaxPositionsState !== undefined
          ? this.countryRegionTaxPositionsState
          : <any>null;
      data['customTaxesState'] =
        this.customTaxesState !== undefined ? this.customTaxesState : <any>null;
      data['countryTaxRatesState'] =
        this.countryTaxRatesState !== undefined
          ? this.countryTaxRatesState
          : <any>null;
      data['regionTaxRatesState'] =
        this.regionTaxRatesState !== undefined
          ? this.regionTaxRatesState
          : <any>null;
      data['exchangeTaxRatesState'] =
        this.exchangeTaxRatesState !== undefined
          ? this.exchangeTaxRatesState
          : <any>null;
      data['precisionState'] =
        this.precisionState !== undefined ? this.precisionState : <any>null;
      data['teqClientState'] =
        this.teqClientState !== undefined ? this.teqClientState : <any>null;
      data['teqWorkLocationState'] =
        this.teqWorkLocationState !== undefined
          ? this.teqWorkLocationState
          : <any>null;
      data['hypoCountryTaxRatesState'] =
        this.hypoCountryTaxRatesState !== undefined
          ? this.hypoCountryTaxRatesState
          : <any>null;
      data['hypoRegionTaxRatesState'] =
        this.hypoRegionTaxRatesState !== undefined
          ? this.hypoRegionTaxRatesState
          : <any>null;
      data['hypoCustomTaxRatesState'] =
        this.hypoCustomTaxRatesState !== undefined
          ? this.hypoCustomTaxRatesState
          : <any>null;
      return data;
    }
  }

  export interface IClientWorkflowDto {
    clientTeamState: StepStateDto;
    deloitteTeamState: StepStateDto;
    contractAndPricingState: StepStateDto;
    payrollState: StepStateDto;
    brokerState: StepStateDto;
    employeePopulationsState: StepStateDto;
    countryFootprintState: StepStateDto;
    planSetupState: StepStateDto;
    countryPlanAutomationSettingsState: StepStateDto;
    manualCalculationsState: StepStateDto;
    liveEventDetailsState: StepStateDto;
    cashPaymentPolicyState: StepStateDto;
    rechargePolicyState: StepStateDto;
    doubleTaxReliefPolicyState: StepStateDto;
    regionDoubleTaxReliefPolicyState: StepStateDto;
    socialTaxPolicyState: StepStateDto;
    taxRatePolicyState: StepStateDto;
    socialTaxRatePolicyState: StepStateDto;
    regionTaxRatePolicyState: StepStateDto;
    taxableConsiderationPolicyState: StepStateDto;
    residencyPolicyState: StepStateDto;
    taxAdjustmentState: StepStateDto;
    countryTaxPositionsState: StepStateDto;
    countryRegionTaxPositionsState: StepStateDto;
    customTaxesState: StepStateDto;
    countryTaxRatesState: StepStateDto;
    regionTaxRatesState: StepStateDto;
    exchangeTaxRatesState: StepStateDto;
    precisionState: StepStateDto;
    teqClientState: StepStateDto;
    teqWorkLocationState: StepStateDto;
    hypoCountryTaxRatesState: StepStateDto;
    hypoRegionTaxRatesState: StepStateDto;
    hypoCustomTaxRatesState: StepStateDto;
  }

  export enum StepStateDto {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Completed = 'Completed',
    PendingApproval = 'PendingApproval',
  }

  export class ClientPayrollDetailsDto implements IClientPayrollDetailsDto {
    payrollOptions!: string[];
    otherPayrollName!: string | null;

    constructor(data?: IClientPayrollDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.payrollOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['payrollOptions'])) {
          this.payrollOptions = [] as any;
          for (let item of _data['payrollOptions'])
            this.payrollOptions!.push(item);
        } else {
          this.payrollOptions = <any>null;
        }
        this.otherPayrollName =
          _data['otherPayrollName'] !== undefined
            ? _data['otherPayrollName']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientPayrollDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientPayrollDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.payrollOptions)) {
        data['payrollOptions'] = [];
        for (let item of this.payrollOptions) data['payrollOptions'].push(item);
      }
      data['otherPayrollName'] =
        this.otherPayrollName !== undefined ? this.otherPayrollName : <any>null;
      return data;
    }
  }

  export interface IClientPayrollDetailsDto {
    payrollOptions: string[];
    otherPayrollName: string | null;
  }

  export class ClientBrokerDetailsDto implements IClientBrokerDetailsDto {
    brokerOptions!: string[];
    otherBrokerName!: string | null;

    constructor(data?: IClientBrokerDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.brokerOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['brokerOptions'])) {
          this.brokerOptions = [] as any;
          for (let item of _data['brokerOptions'])
            this.brokerOptions!.push(item);
        } else {
          this.brokerOptions = <any>null;
        }
        this.otherBrokerName =
          _data['otherBrokerName'] !== undefined
            ? _data['otherBrokerName']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientBrokerDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientBrokerDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.brokerOptions)) {
        data['brokerOptions'] = [];
        for (let item of this.brokerOptions) data['brokerOptions'].push(item);
      }
      data['otherBrokerName'] =
        this.otherBrokerName !== undefined ? this.otherBrokerName : <any>null;
      return data;
    }
  }

  export interface IClientBrokerDetailsDto {
    brokerOptions: string[];
    otherBrokerName: string | null;
  }

  export class GetClientByPortalIdQueryResultFailure
    extends GetClientByPortalIdQueryResult
    implements IGetClientByPortalIdQueryResultFailure
  {
    message!: string;

    constructor(data?: IGetClientByPortalIdQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.message =
          _data['message'] !== undefined ? _data['message'] : <any>null;
      }
    }

    static override fromJS(data: any): GetClientByPortalIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientByPortalIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['message'] = this.message !== undefined ? this.message : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientByPortalIdQueryResultFailure
    extends IGetClientByPortalIdQueryResult {
    message: string;
  }

  export class GetClientByOrgIdQueryResult
    implements IGetClientByOrgIdQueryResult
  {
    constructor(data?: IGetClientByOrgIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientByOrgIdQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientByOrgIdQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientByOrgIdQueryResult {}

  export class GetClientByOrgIdQueryResultSuccess
    extends GetClientByOrgIdQueryResult
    implements IGetClientByOrgIdQueryResultSuccess
  {
    result!: DeloitteTeamAndClientDetails;

    constructor(data?: IGetClientByOrgIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new DeloitteTeamAndClientDetails();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DeloitteTeamAndClientDetails.fromJS(_data['result'])
          : new DeloitteTeamAndClientDetails();
      }
    }

    static override fromJS(data: any): GetClientByOrgIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientByOrgIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientByOrgIdQueryResultSuccess
    extends IGetClientByOrgIdQueryResult {
    result: DeloitteTeamAndClientDetails;
  }

  export class DeloitteTeamAndClientDetails
    implements IDeloitteTeamAndClientDetails
  {
    deloitteTeamDetails!: DeloitteTeamDetailsData | null;
    roleOptions!: RoleOptionData[] | null;
    clientDetails!: ClientDetailDataDto | null;

    constructor(data?: IDeloitteTeamAndClientDetails) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.deloitteTeamDetails = _data['deloitteTeamDetails']
          ? DeloitteTeamDetailsData.fromJS(_data['deloitteTeamDetails'])
          : <any>null;
        if (Array.isArray(_data['roleOptions'])) {
          this.roleOptions = [] as any;
          for (let item of _data['roleOptions'])
            this.roleOptions!.push(RoleOptionData.fromJS(item));
        } else {
          this.roleOptions = <any>null;
        }
        this.clientDetails = _data['clientDetails']
          ? ClientDetailDataDto.fromJS(_data['clientDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): DeloitteTeamAndClientDetails {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamAndClientDetails();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['deloitteTeamDetails'] = this.deloitteTeamDetails
        ? this.deloitteTeamDetails.toJSON()
        : <any>null;
      if (Array.isArray(this.roleOptions)) {
        data['roleOptions'] = [];
        for (let item of this.roleOptions)
          data['roleOptions'].push(item.toJSON());
      }
      data['clientDetails'] = this.clientDetails
        ? this.clientDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IDeloitteTeamAndClientDetails {
    deloitteTeamDetails: DeloitteTeamDetailsData | null;
    roleOptions: RoleOptionData[] | null;
    clientDetails: ClientDetailDataDto | null;
  }

  export class DeloitteTeamDetailsData implements IDeloitteTeamDetailsData {
    id!: string;
    office!: DeloitteOfficeOptionData | null;
    partner!: DeloitteUserOptionData | null;
    deloitteTeamMembers!: DeloitteTeamMemberDataDto[];

    constructor(data?: IDeloitteTeamDetailsData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.deloitteTeamMembers = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.office = _data['office']
          ? DeloitteOfficeOptionData.fromJS(_data['office'])
          : <any>null;
        this.partner = _data['partner']
          ? DeloitteUserOptionData.fromJS(_data['partner'])
          : <any>null;
        if (Array.isArray(_data['deloitteTeamMembers'])) {
          this.deloitteTeamMembers = [] as any;
          for (let item of _data['deloitteTeamMembers'])
            this.deloitteTeamMembers!.push(
              DeloitteTeamMemberDataDto.fromJS(item),
            );
        } else {
          this.deloitteTeamMembers = <any>null;
        }
      }
    }

    static fromJS(data: any): DeloitteTeamDetailsData {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamDetailsData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['office'] = this.office ? this.office.toJSON() : <any>null;
      data['partner'] = this.partner ? this.partner.toJSON() : <any>null;
      if (Array.isArray(this.deloitteTeamMembers)) {
        data['deloitteTeamMembers'] = [];
        for (let item of this.deloitteTeamMembers)
          data['deloitteTeamMembers'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IDeloitteTeamDetailsData {
    id: string;
    office: DeloitteOfficeOptionData | null;
    partner: DeloitteUserOptionData | null;
    deloitteTeamMembers: DeloitteTeamMemberDataDto[];
  }

  export class DeloitteOfficeOptionData implements IDeloitteOfficeOptionData {
    id!: string;
    name!: string;

    constructor(data?: IDeloitteOfficeOptionData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteOfficeOptionData {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteOfficeOptionData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IDeloitteOfficeOptionData {
    id: string;
    name: string;
  }

  export class DeloitteUserOptionData implements IDeloitteUserOptionData {
    id!: string;
    email!: string;
    firstName!: string;
    lastName!: string;
    fullName!: string;

    constructor(data?: IDeloitteUserOptionData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteUserOptionData {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteUserOptionData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      return data;
    }
  }

  export interface IDeloitteUserOptionData {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }

  export class DeloitteTeamMemberDataDto implements IDeloitteTeamMemberDataDto {
    userId!: string;
    fullName!: string;
    email!: string;
    role!: DeloitteTeamMemberRoleDataDto;
    canApproveManualCalculations!: boolean;

    constructor(data?: IDeloitteTeamMemberDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.role = new DeloitteTeamMemberRoleDataDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userId =
          _data['userId'] !== undefined ? _data['userId'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.role = _data['role']
          ? DeloitteTeamMemberRoleDataDto.fromJS(_data['role'])
          : new DeloitteTeamMemberRoleDataDto();
        this.canApproveManualCalculations =
          _data['canApproveManualCalculations'] !== undefined
            ? _data['canApproveManualCalculations']
            : <any>null;
      }
    }

    static fromJS(data: any): DeloitteTeamMemberDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamMemberDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userId'] = this.userId !== undefined ? this.userId : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['role'] = this.role ? this.role.toJSON() : <any>null;
      data['canApproveManualCalculations'] =
        this.canApproveManualCalculations !== undefined
          ? this.canApproveManualCalculations
          : <any>null;
      return data;
    }
  }

  export interface IDeloitteTeamMemberDataDto {
    userId: string;
    fullName: string;
    email: string;
    role: DeloitteTeamMemberRoleDataDto;
    canApproveManualCalculations: boolean;
  }

  export class DeloitteTeamMemberRoleDataDto
    implements IDeloitteTeamMemberRoleDataDto
  {
    id!: string;
    name!: string;

    constructor(data?: IDeloitteTeamMemberRoleDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteTeamMemberRoleDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamMemberRoleDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IDeloitteTeamMemberRoleDataDto {
    id: string;
    name: string;
  }

  export class RoleOptionData implements IRoleOptionData {
    id!: string;
    name!: string;

    constructor(data?: IRoleOptionData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): RoleOptionData {
      data = typeof data === 'object' ? data : {};
      let result = new RoleOptionData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IRoleOptionData {
    id: string;
    name: string;
  }

  export class ClientDetailDataDto implements IClientDetailDataDto {
    clientName!: string;
    clientPortalId!: string;

    constructor(data?: IClientDetailDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientName =
          _data['clientName'] !== undefined ? _data['clientName'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientDetailDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientDetailDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientName'] =
        this.clientName !== undefined ? this.clientName : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      return data;
    }
  }

  export interface IClientDetailDataDto {
    clientName: string;
    clientPortalId: string;
  }

  export class GetClientByOrgIdQueryResultFailure
    extends GetClientByOrgIdQueryResult
    implements IGetClientByOrgIdQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetClientByOrgIdQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetClientByOrgIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientByOrgIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientByOrgIdQueryResultFailure
    extends IGetClientByOrgIdQueryResult {
    errors: ResultError[];
  }

  export abstract class GetCalculationIdsByBatchIdQueryResult
    implements IGetCalculationIdsByBatchIdQueryResult
  {
    constructor(data?: IGetCalculationIdsByBatchIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationIdsByBatchIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationIdsByBatchIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationIdsByBatchIdQueryResult {}

  export class GetCalculationIdsByBatchIdQueryResultSuccess
    extends GetCalculationIdsByBatchIdQueryResult
    implements IGetCalculationIdsByBatchIdQueryResultSuccess
  {
    calculationsIds!: string[];

    constructor(data?: IGetCalculationIdsByBatchIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.calculationsIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['calculationsIds'])) {
          this.calculationsIds = [] as any;
          for (let item of _data['calculationsIds'])
            this.calculationsIds!.push(item);
        } else {
          this.calculationsIds = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationIdsByBatchIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationIdsByBatchIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.calculationsIds)) {
        data['calculationsIds'] = [];
        for (let item of this.calculationsIds)
          data['calculationsIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationIdsByBatchIdQueryResultSuccess
    extends IGetCalculationIdsByBatchIdQueryResult {
    calculationsIds: string[];
  }

  export class GetCalculationIdsByBatchIdQueryResultFailure
    extends GetCalculationIdsByBatchIdQueryResult
    implements IGetCalculationIdsByBatchIdQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationIdsByBatchIdQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationIdsByBatchIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationIdsByBatchIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationIdsByBatchIdQueryResultFailure
    extends IGetCalculationIdsByBatchIdQueryResult {
    errorMessage: string;
  }

  export abstract class GetCompanyQueryResult
    implements IGetCompanyQueryResult
  {
    constructor(data?: IGetCompanyQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCompanyQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCompanyQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCompanyQueryResult {}

  export class GetCompanyQueryResultSuccess
    extends GetCompanyQueryResult
    implements IGetCompanyQueryResultSuccess
  {
    result!: PageModelOfGetCompanyDto;

    constructor(data?: IGetCompanyQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PageModelOfGetCompanyDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PageModelOfGetCompanyDto.fromJS(_data['result'])
          : new PageModelOfGetCompanyDto();
      }
    }

    static override fromJS(data: any): GetCompanyQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCompanyQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCompanyQueryResultSuccess
    extends IGetCompanyQueryResult {
    result: PageModelOfGetCompanyDto;
  }

  export abstract class PageModel implements IPageModel {
    constructor(data?: IPageModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PageModel {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class 'PageModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPageModel {}

  export class PageModelOfGetCompanyDto
    extends PageModel
    implements IPageModelOfGetCompanyDto
  {
    items!: GetCompanyDto[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfGetCompanyDto) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(GetCompanyDto.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfGetCompanyDto {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfGetCompanyDto();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfGetCompanyDto extends IPageModel {
    items: GetCompanyDto[];
    totalItems: number | null;
  }

  export class GetCompanyDto implements IGetCompanyDto {
    id!: string;
    portalId!: string;
    name!: string;

    constructor(data?: IGetCompanyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): GetCompanyDto {
      data = typeof data === 'object' ? data : {};
      let result = new GetCompanyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IGetCompanyDto {
    id: string;
    portalId: string;
    name: string;
  }

  export class GetCompanyQueryResultFailure
    extends GetCompanyQueryResult
    implements IGetCompanyQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCompanyQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetCompanyQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCompanyQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCompanyQueryResultFailure
    extends IGetCompanyQueryResult {
    errorMessage: string;
  }

  export class GetCompanyQuery implements IGetCompanyQuery {
    constructor(data?: IGetCompanyQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCompanyQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetCompanyQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCompanyQuery {}

  export abstract class GetCustomTaxesQueryResult
    implements IGetCustomTaxesQueryResult
  {
    constructor(data?: IGetCustomTaxesQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCustomTaxesQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCustomTaxesQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResult {}

  export class GetCustomTaxesQueryResultSuccess
    extends GetCustomTaxesQueryResult
    implements IGetCustomTaxesQueryResultSuccess
  {
    customTaxes!: CustomTaxInfoDto[];

    constructor(data?: IGetCustomTaxesQueryResultSuccess) {
      super(data);
      if (!data) {
        this.customTaxes = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['customTaxes'])) {
          this.customTaxes = [] as any;
          for (let item of _data['customTaxes'])
            this.customTaxes!.push(CustomTaxInfoDto.fromJS(item));
        } else {
          this.customTaxes = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCustomTaxesQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxesQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.customTaxes)) {
        data['customTaxes'] = [];
        for (let item of this.customTaxes)
          data['customTaxes'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResultSuccess
    extends IGetCustomTaxesQueryResult {
    customTaxes: CustomTaxInfoDto[];
  }

  export class CustomTaxInfoDto implements ICustomTaxInfoDto {
    code!: string;
    countryCode!: string;
    regionCode!: string | null;
    taxType!: TaxType;

    constructor(data?: ICustomTaxInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
      }
    }

    static fromJS(data: any): CustomTaxInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      return data;
    }
  }

  export interface ICustomTaxInfoDto {
    code: string;
    countryCode: string;
    regionCode: string | null;
    taxType: TaxType;
  }

  export class GetCustomTaxesQueryResultFailure
    extends GetCustomTaxesQueryResult
    implements IGetCustomTaxesQueryResultFailure
  {
    constructor(data?: IGetCustomTaxesQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetCustomTaxesQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxesQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResultFailure
    extends IGetCustomTaxesQueryResult {}

  export abstract class GetClientPortalIdFromOrgIdQueryResult
    implements IGetClientPortalIdFromOrgIdQueryResult
  {
    constructor(data?: IGetClientPortalIdFromOrgIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientPortalIdFromOrgIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetClientPortalIdFromOrgIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientPortalIdFromOrgIdQueryResult {}

  export class GetClientPortalIdFromOrgIdQueryResultSuccess
    extends GetClientPortalIdFromOrgIdQueryResult
    implements IGetClientPortalIdFromOrgIdQueryResultSuccess
  {
    clientPortalId!: string;

    constructor(data?: IGetClientPortalIdFromOrgIdQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetClientPortalIdFromOrgIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientPortalIdFromOrgIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientPortalIdFromOrgIdQueryResultSuccess
    extends IGetClientPortalIdFromOrgIdQueryResult {
    clientPortalId: string;
  }

  export class GetClientPortalIdFromOrgIdQueryResultFailure
    extends GetClientPortalIdFromOrgIdQueryResult
    implements IGetClientPortalIdFromOrgIdQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetClientPortalIdFromOrgIdQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetClientPortalIdFromOrgIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientPortalIdFromOrgIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientPortalIdFromOrgIdQueryResultFailure
    extends IGetClientPortalIdFromOrgIdQueryResult {
    errorMessage: string;
  }

  export abstract class GetCustomTaxTypeDescriptionsFromOrgIdCommandResult
    implements IGetCustomTaxTypeDescriptionsFromOrgIdCommandResult
  {
    constructor(data?: IGetCustomTaxTypeDescriptionsFromOrgIdCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetCustomTaxTypeDescriptionsFromOrgIdCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCustomTaxTypeDescriptionsFromOrgIdCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCustomTaxTypeDescriptionsFromOrgIdCommandResult {}

  export class GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess
    extends GetCustomTaxTypeDescriptionsFromOrgIdCommandResult
    implements IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess
  {
    customTaxTypeDescriptions!: CountryWiseCustomTaxTypeDescriptionDto[];

    constructor(
      data?: IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.customTaxTypeDescriptions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['customTaxTypeDescriptions'])) {
          this.customTaxTypeDescriptions = [] as any;
          for (let item of _data['customTaxTypeDescriptions'])
            this.customTaxTypeDescriptions!.push(
              CountryWiseCustomTaxTypeDescriptionDto.fromJS(item),
            );
        } else {
          this.customTaxTypeDescriptions = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.customTaxTypeDescriptions)) {
        data['customTaxTypeDescriptions'] = [];
        for (let item of this.customTaxTypeDescriptions)
          data['customTaxTypeDescriptions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultSuccess
    extends IGetCustomTaxTypeDescriptionsFromOrgIdCommandResult {
    customTaxTypeDescriptions: CountryWiseCustomTaxTypeDescriptionDto[];
  }

  export class CountryWiseCustomTaxTypeDescriptionDto
    implements ICountryWiseCustomTaxTypeDescriptionDto
  {
    countryCode!: string;
    customTaxTypeDescriptions!: CutomTaxTypeDescriptionDto[];

    constructor(data?: ICountryWiseCustomTaxTypeDescriptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.customTaxTypeDescriptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['customTaxTypeDescriptions'])) {
          this.customTaxTypeDescriptions = [] as any;
          for (let item of _data['customTaxTypeDescriptions'])
            this.customTaxTypeDescriptions!.push(
              CutomTaxTypeDescriptionDto.fromJS(item),
            );
        } else {
          this.customTaxTypeDescriptions = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryWiseCustomTaxTypeDescriptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryWiseCustomTaxTypeDescriptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.customTaxTypeDescriptions)) {
        data['customTaxTypeDescriptions'] = [];
        for (let item of this.customTaxTypeDescriptions)
          data['customTaxTypeDescriptions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryWiseCustomTaxTypeDescriptionDto {
    countryCode: string;
    customTaxTypeDescriptions: CutomTaxTypeDescriptionDto[];
  }

  export class CutomTaxTypeDescriptionDto
    implements ICutomTaxTypeDescriptionDto
  {
    taxType!: TaxType;
    code!: string;
    countryCode!: string;
    regionCode!: string;
    description!: string;
    createdOn!: Date;

    constructor(data?: ICutomTaxTypeDescriptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.createdOn = _data['createdOn']
          ? new Date(_data['createdOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CutomTaxTypeDescriptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new CutomTaxTypeDescriptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['createdOn'] = this.createdOn
        ? this.createdOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICutomTaxTypeDescriptionDto {
    taxType: TaxType;
    code: string;
    countryCode: string;
    regionCode: string;
    description: string;
    createdOn: Date;
  }

  export class GetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure
    extends GetCustomTaxTypeDescriptionsFromOrgIdCommandResult
    implements IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxTypeDescriptionsFromOrgIdCommandResultFailure
    extends IGetCustomTaxTypeDescriptionsFromOrgIdCommandResult {
    errors: ResultError[];
  }

  export class GetCustomTaxTypeDescriptionsFromOrgIdCommand
    implements IGetCustomTaxTypeDescriptionsFromOrgIdCommand
  {
    clientId!: string;

    constructor(data?: IGetCustomTaxTypeDescriptionsFromOrgIdCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): GetCustomTaxTypeDescriptionsFromOrgIdCommand {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxTypeDescriptionsFromOrgIdCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface IGetCustomTaxTypeDescriptionsFromOrgIdCommand {
    clientId: string;
  }

  export abstract class GetDeletionStatusCountsQueryResult
    implements IGetDeletionStatusCountsQueryResult
  {
    constructor(data?: IGetDeletionStatusCountsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeletionStatusCountsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDeletionStatusCountsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeletionStatusCountsQueryResult {}

  export class GetDeletionStatusCountsQueryResultSuccess
    extends GetDeletionStatusCountsQueryResult
    implements IGetDeletionStatusCountsQueryResultSuccess
  {
    deletionStatusCounts!: DeletionStatusCountsReportingDto;

    constructor(data?: IGetDeletionStatusCountsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.deletionStatusCounts = new DeletionStatusCountsReportingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.deletionStatusCounts = _data['deletionStatusCounts']
          ? DeletionStatusCountsReportingDto.fromJS(
              _data['deletionStatusCounts'],
            )
          : new DeletionStatusCountsReportingDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetDeletionStatusCountsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeletionStatusCountsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['deletionStatusCounts'] = this.deletionStatusCounts
        ? this.deletionStatusCounts.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeletionStatusCountsQueryResultSuccess
    extends IGetDeletionStatusCountsQueryResult {
    deletionStatusCounts: DeletionStatusCountsReportingDto;
  }

  export class DeletionStatusCountsReportingDto
    implements IDeletionStatusCountsReportingDto
  {
    batchDeletionCounts!: DeletionCounts;
    calculationDeletionCounts!: DeletionCounts;
    transactionDeletionCounts!: DeletionCounts;

    constructor(data?: IDeletionStatusCountsReportingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchDeletionCounts = new DeletionCounts();
        this.calculationDeletionCounts = new DeletionCounts();
        this.transactionDeletionCounts = new DeletionCounts();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchDeletionCounts = _data['batchDeletionCounts']
          ? DeletionCounts.fromJS(_data['batchDeletionCounts'])
          : new DeletionCounts();
        this.calculationDeletionCounts = _data['calculationDeletionCounts']
          ? DeletionCounts.fromJS(_data['calculationDeletionCounts'])
          : new DeletionCounts();
        this.transactionDeletionCounts = _data['transactionDeletionCounts']
          ? DeletionCounts.fromJS(_data['transactionDeletionCounts'])
          : new DeletionCounts();
      }
    }

    static fromJS(data: any): DeletionStatusCountsReportingDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeletionStatusCountsReportingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchDeletionCounts'] = this.batchDeletionCounts
        ? this.batchDeletionCounts.toJSON()
        : <any>null;
      data['calculationDeletionCounts'] = this.calculationDeletionCounts
        ? this.calculationDeletionCounts.toJSON()
        : <any>null;
      data['transactionDeletionCounts'] = this.transactionDeletionCounts
        ? this.transactionDeletionCounts.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IDeletionStatusCountsReportingDto {
    batchDeletionCounts: DeletionCounts;
    calculationDeletionCounts: DeletionCounts;
    transactionDeletionCounts: DeletionCounts;
  }

  export class DeletionCounts implements IDeletionCounts {
    pendingDeleteCount!: number;
    failedDeleteCount!: number;

    constructor(data?: IDeletionCounts) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.pendingDeleteCount =
          _data['pendingDeleteCount'] !== undefined
            ? _data['pendingDeleteCount']
            : <any>null;
        this.failedDeleteCount =
          _data['failedDeleteCount'] !== undefined
            ? _data['failedDeleteCount']
            : <any>null;
      }
    }

    static fromJS(data: any): DeletionCounts {
      data = typeof data === 'object' ? data : {};
      let result = new DeletionCounts();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pendingDeleteCount'] =
        this.pendingDeleteCount !== undefined
          ? this.pendingDeleteCount
          : <any>null;
      data['failedDeleteCount'] =
        this.failedDeleteCount !== undefined
          ? this.failedDeleteCount
          : <any>null;
      return data;
    }
  }

  export interface IDeletionCounts {
    pendingDeleteCount: number;
    failedDeleteCount: number;
  }

  export class GetDeletionStatusCountsQueryResultFailure
    extends GetDeletionStatusCountsQueryResult
    implements IGetDeletionStatusCountsQueryResultFailure
  {
    errorCode!: GetDeletionStatusCountsQueryResultFailureErrorCode;
    errorMessage!: string | null;

    constructor(data?: IGetDeletionStatusCountsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetDeletionStatusCountsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeletionStatusCountsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeletionStatusCountsQueryResultFailure
    extends IGetDeletionStatusCountsQueryResult {
    errorCode: GetDeletionStatusCountsQueryResultFailureErrorCode;
    errorMessage: string | null;
  }

  export enum GetDeletionStatusCountsQueryResultFailureErrorCode {
    ClientNotFound = 'ClientNotFound',
    FailedToSearchDeletionStatusCounts = 'FailedToSearchDeletionStatusCounts',
  }

  export class GetRegionTaxRatePolicyPageDataQueryResult
    implements IGetRegionTaxRatePolicyPageDataQueryResult
  {
    constructor(data?: IGetRegionTaxRatePolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRegionTaxRatePolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxRatePolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionTaxRatePolicyPageDataQueryResult {}

  export class GetRegionTaxRatePolicyPageDataQueryResultSuccess
    extends GetRegionTaxRatePolicyPageDataQueryResult
    implements IGetRegionTaxRatePolicyPageDataQueryResultSuccess
  {
    result!: RegionTaxRatePolicyPageData;

    constructor(data?: IGetRegionTaxRatePolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new RegionTaxRatePolicyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RegionTaxRatePolicyPageData.fromJS(_data['result'])
          : new RegionTaxRatePolicyPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxRatePolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxRatePolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxRatePolicyPageDataQueryResultSuccess
    extends IGetRegionTaxRatePolicyPageDataQueryResult {
    result: RegionTaxRatePolicyPageData;
  }

  export class RegionTaxRatePolicyPageData
    implements IRegionTaxRatePolicyPageData
  {
    residencyStatusOptions!: ResidencyStatusDto2[];
    regionTaxRatePolicyOptions!: RegionTaxRatePolicyDto[];
    batchActionOptions!: RegionTaxRatePolicyBatchActionOptionDto[];
    regionsList!: RegionTaxRatePolicyRegionData[];
    regionTaxRatePolicySettings!: RegionTaxRatePolicySettingsDto | null;
    isUSConfigured!: boolean;

    constructor(data?: IRegionTaxRatePolicyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residencyStatusOptions = [];
        this.regionTaxRatePolicyOptions = [];
        this.batchActionOptions = [];
        this.regionsList = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['residencyStatusOptions'])) {
          this.residencyStatusOptions = [] as any;
          for (let item of _data['residencyStatusOptions'])
            this.residencyStatusOptions!.push(ResidencyStatusDto2.fromJS(item));
        } else {
          this.residencyStatusOptions = <any>null;
        }
        if (Array.isArray(_data['regionTaxRatePolicyOptions'])) {
          this.regionTaxRatePolicyOptions = [] as any;
          for (let item of _data['regionTaxRatePolicyOptions'])
            this.regionTaxRatePolicyOptions!.push(
              RegionTaxRatePolicyDto.fromJS(item),
            );
        } else {
          this.regionTaxRatePolicyOptions = <any>null;
        }
        if (Array.isArray(_data['batchActionOptions'])) {
          this.batchActionOptions = [] as any;
          for (let item of _data['batchActionOptions'])
            this.batchActionOptions!.push(
              RegionTaxRatePolicyBatchActionOptionDto.fromJS(item),
            );
        } else {
          this.batchActionOptions = <any>null;
        }
        if (Array.isArray(_data['regionsList'])) {
          this.regionsList = [] as any;
          for (let item of _data['regionsList'])
            this.regionsList!.push(RegionTaxRatePolicyRegionData.fromJS(item));
        } else {
          this.regionsList = <any>null;
        }
        this.regionTaxRatePolicySettings = _data['regionTaxRatePolicySettings']
          ? RegionTaxRatePolicySettingsDto.fromJS(
              _data['regionTaxRatePolicySettings'],
            )
          : <any>null;
        this.isUSConfigured =
          _data['isUSConfigured'] !== undefined
            ? _data['isUSConfigured']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatePolicyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.residencyStatusOptions)) {
        data['residencyStatusOptions'] = [];
        for (let item of this.residencyStatusOptions)
          data['residencyStatusOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.regionTaxRatePolicyOptions)) {
        data['regionTaxRatePolicyOptions'] = [];
        for (let item of this.regionTaxRatePolicyOptions)
          data['regionTaxRatePolicyOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.batchActionOptions)) {
        data['batchActionOptions'] = [];
        for (let item of this.batchActionOptions)
          data['batchActionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.regionsList)) {
        data['regionsList'] = [];
        for (let item of this.regionsList)
          data['regionsList'].push(item.toJSON());
      }
      data['regionTaxRatePolicySettings'] = this.regionTaxRatePolicySettings
        ? this.regionTaxRatePolicySettings.toJSON()
        : <any>null;
      data['isUSConfigured'] =
        this.isUSConfigured !== undefined ? this.isUSConfigured : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatePolicyPageData {
    residencyStatusOptions: ResidencyStatusDto2[];
    regionTaxRatePolicyOptions: RegionTaxRatePolicyDto[];
    batchActionOptions: RegionTaxRatePolicyBatchActionOptionDto[];
    regionsList: RegionTaxRatePolicyRegionData[];
    regionTaxRatePolicySettings: RegionTaxRatePolicySettingsDto | null;
    isUSConfigured: boolean;
  }

  export class ResidencyStatusDto2 implements IResidencyStatusDto2 {
    optionValue!: ResidencyStatus;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IResidencyStatusDto2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): ResidencyStatusDto2 {
      data = typeof data === 'object' ? data : {};
      let result = new ResidencyStatusDto2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IResidencyStatusDto2 {
    optionValue: ResidencyStatus;
    displayValue: string;
    displayOrder: number;
  }

  export class RegionTaxRatePolicyDto implements IRegionTaxRatePolicyDto {
    optionValue!: TaxRatePolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRegionTaxRatePolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatePolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatePolicyDto {
    optionValue: TaxRatePolicy;
    displayValue: string;
    displayOrder: number;
  }

  export class RegionTaxRatePolicyBatchActionOptionDto
    implements IRegionTaxRatePolicyBatchActionOptionDto
  {
    optionValue!: TaxRatePolicyBatchActionOption;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRegionTaxRatePolicyBatchActionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatePolicyBatchActionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicyBatchActionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatePolicyBatchActionOptionDto {
    optionValue: TaxRatePolicyBatchActionOption;
    displayValue: string;
    displayOrder: number;
  }

  export class RegionTaxRatePolicyRegionData
    implements IRegionTaxRatePolicyRegionData
  {
    regionCode!: string;
    regionName!: string;

    constructor(data?: IRegionTaxRatePolicyRegionData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.regionName =
          _data['regionName'] !== undefined ? _data['regionName'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatePolicyRegionData {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicyRegionData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['regionName'] =
        this.regionName !== undefined ? this.regionName : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatePolicyRegionData {
    regionCode: string;
    regionName: string;
  }

  export class RegionTaxRatePolicySettingsDto
    implements IRegionTaxRatePolicySettingsDto
  {
    clientId!: string;
    regionTaxRatePolicySettingsDefault!: RegionTaxRatePolicySettingsDefaultDto | null;

    constructor(data?: IRegionTaxRatePolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.regionTaxRatePolicySettingsDefault = _data[
          'regionTaxRatePolicySettingsDefault'
        ]
          ? RegionTaxRatePolicySettingsDefaultDto.fromJS(
              _data['regionTaxRatePolicySettingsDefault'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): RegionTaxRatePolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['regionTaxRatePolicySettingsDefault'] = this
        .regionTaxRatePolicySettingsDefault
        ? this.regionTaxRatePolicySettingsDefault.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRegionTaxRatePolicySettingsDto {
    clientId: string;
    regionTaxRatePolicySettingsDefault: RegionTaxRatePolicySettingsDefaultDto | null;
  }

  export class RegionTaxRatePolicySettingsDefaultDto
    implements IRegionTaxRatePolicySettingsDefaultDto
  {
    companyDefault!: TaxRatePolicy;
    regionSettings!: RegionResidencyStatusRegionTaxRatePolicySettingDto[];
    regionSettingsByRegion!: {
      [key: string]: RegionResidencyStatusRegionTaxRatePolicySettingDto;
    };

    constructor(data?: IRegionTaxRatePolicySettingsDefaultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regionSettings = [];
        this.regionSettingsByRegion = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.companyDefault =
          _data['companyDefault'] !== undefined
            ? _data['companyDefault']
            : <any>null;
        if (Array.isArray(_data['regionSettings'])) {
          this.regionSettings = [] as any;
          for (let item of _data['regionSettings'])
            this.regionSettings!.push(
              RegionResidencyStatusRegionTaxRatePolicySettingDto.fromJS(item),
            );
        } else {
          this.regionSettings = <any>null;
        }
        if (_data['regionSettingsByRegion']) {
          this.regionSettingsByRegion = {} as any;
          for (let key in _data['regionSettingsByRegion']) {
            if (_data['regionSettingsByRegion'].hasOwnProperty(key))
              (<any>this.regionSettingsByRegion)![key] = _data[
                'regionSettingsByRegion'
              ][key]
                ? RegionResidencyStatusRegionTaxRatePolicySettingDto.fromJS(
                    _data['regionSettingsByRegion'][key],
                  )
                : new RegionResidencyStatusRegionTaxRatePolicySettingDto();
          }
        } else {
          this.regionSettingsByRegion = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionTaxRatePolicySettingsDefaultDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTaxRatePolicySettingsDefaultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['companyDefault'] =
        this.companyDefault !== undefined ? this.companyDefault : <any>null;
      if (Array.isArray(this.regionSettings)) {
        data['regionSettings'] = [];
        for (let item of this.regionSettings)
          data['regionSettings'].push(item.toJSON());
      }
      if (this.regionSettingsByRegion) {
        data['regionSettingsByRegion'] = {};
        for (let key in this.regionSettingsByRegion) {
          if (this.regionSettingsByRegion.hasOwnProperty(key))
            (<any>data['regionSettingsByRegion'])[key] = this
              .regionSettingsByRegion[key]
              ? this.regionSettingsByRegion[key].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface IRegionTaxRatePolicySettingsDefaultDto {
    companyDefault: TaxRatePolicy;
    regionSettings: RegionResidencyStatusRegionTaxRatePolicySettingDto[];
    regionSettingsByRegion: {
      [key: string]: RegionResidencyStatusRegionTaxRatePolicySettingDto;
    };
  }

  export class RegionResidencyStatusRegionTaxRatePolicySettingDto
    implements IRegionResidencyStatusRegionTaxRatePolicySettingDto
  {
    regionCode!: string;
    residentRegionTaxRatePolicy!: TaxRatePolicy | null;
    nonResidentRegionTaxRatePolicy!: TaxRatePolicy | null;

    constructor(data?: IRegionResidencyStatusRegionTaxRatePolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.residentRegionTaxRatePolicy =
          _data['residentRegionTaxRatePolicy'] !== undefined
            ? _data['residentRegionTaxRatePolicy']
            : <any>null;
        this.nonResidentRegionTaxRatePolicy =
          _data['nonResidentRegionTaxRatePolicy'] !== undefined
            ? _data['nonResidentRegionTaxRatePolicy']
            : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): RegionResidencyStatusRegionTaxRatePolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionResidencyStatusRegionTaxRatePolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['residentRegionTaxRatePolicy'] =
        this.residentRegionTaxRatePolicy !== undefined
          ? this.residentRegionTaxRatePolicy
          : <any>null;
      data['nonResidentRegionTaxRatePolicy'] =
        this.nonResidentRegionTaxRatePolicy !== undefined
          ? this.nonResidentRegionTaxRatePolicy
          : <any>null;
      return data;
    }
  }

  export interface IRegionResidencyStatusRegionTaxRatePolicySettingDto {
    regionCode: string;
    residentRegionTaxRatePolicy: TaxRatePolicy | null;
    nonResidentRegionTaxRatePolicy: TaxRatePolicy | null;
  }

  export class GetRegionTaxRatePolicyPageDataQueryResultFailure
    extends GetRegionTaxRatePolicyPageDataQueryResult
    implements IGetRegionTaxRatePolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetRegionTaxRatePolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionTaxRatePolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionTaxRatePolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionTaxRatePolicyPageDataQueryResultFailure
    extends IGetRegionTaxRatePolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertRegionTaxRatePolicySettingsCommandResult
    implements IUpsertRegionTaxRatePolicySettingsCommandResult
  {
    constructor(data?: IUpsertRegionTaxRatePolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertRegionTaxRatePolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxRatePolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRegionTaxRatePolicySettingsCommandResult {}

  export class UpsertRegionTaxRatePolicySettingsCommandResultSuccess
    extends UpsertRegionTaxRatePolicySettingsCommandResult
    implements IUpsertRegionTaxRatePolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertRegionTaxRatePolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRegionTaxRatePolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxRatePolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionTaxRatePolicySettingsCommandResultSuccess
    extends IUpsertRegionTaxRatePolicySettingsCommandResult {}

  export class UpsertRegionTaxRatePolicySettingsCommandResultFailure
    extends UpsertRegionTaxRatePolicySettingsCommandResult
    implements IUpsertRegionTaxRatePolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertRegionTaxRatePolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRegionTaxRatePolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxRatePolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionTaxRatePolicySettingsCommandResultFailure
    extends IUpsertRegionTaxRatePolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertRegionTaxRatePolicySettingsCommand
    implements IUpsertRegionTaxRatePolicySettingsCommand
  {
    clientId!: string;
    regionTaxRatePolicySettings!: RegionTaxRatePolicySettingsDefaultDto | null;

    constructor(data?: IUpsertRegionTaxRatePolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.regionTaxRatePolicySettings = _data['regionTaxRatePolicySettings']
          ? RegionTaxRatePolicySettingsDefaultDto.fromJS(
              _data['regionTaxRatePolicySettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertRegionTaxRatePolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionTaxRatePolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['regionTaxRatePolicySettings'] = this.regionTaxRatePolicySettings
        ? this.regionTaxRatePolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertRegionTaxRatePolicySettingsCommand {
    clientId: string;
    regionTaxRatePolicySettings: RegionTaxRatePolicySettingsDefaultDto | null;
  }

  export class GetRegionDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetRegionDoubleTaxReliefPolicyPageDataQueryResult
  {
    constructor(data?: IGetRegionDoubleTaxReliefPolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetRegionDoubleTaxReliefPolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRegionDoubleTaxReliefPolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRegionDoubleTaxReliefPolicyPageDataQueryResult {}

  export class GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess
    extends GetRegionDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess
  {
    result!: RegionDoubleTaxReliefPageData;

    constructor(
      data?: IGetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new RegionDoubleTaxReliefPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RegionDoubleTaxReliefPageData.fromJS(_data['result'])
          : new RegionDoubleTaxReliefPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionDoubleTaxReliefPolicyPageDataQueryResultSuccess
    extends IGetRegionDoubleTaxReliefPolicyPageDataQueryResult {
    result: RegionDoubleTaxReliefPageData;
  }

  export class RegionDoubleTaxReliefPageData
    implements IRegionDoubleTaxReliefPageData
  {
    regionDoubleTaxReliefPolicySettingOptions!: RegionDoubleTaxReliefPolicySettingDto[];
    regionDoubleTaxReliefPolicySettings!: RegionDoubleTaxReliefPolicySettingsDto | null;

    constructor(data?: IRegionDoubleTaxReliefPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regionDoubleTaxReliefPolicySettingOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['regionDoubleTaxReliefPolicySettingOptions'])) {
          this.regionDoubleTaxReliefPolicySettingOptions = [] as any;
          for (let item of _data['regionDoubleTaxReliefPolicySettingOptions'])
            this.regionDoubleTaxReliefPolicySettingOptions!.push(
              RegionDoubleTaxReliefPolicySettingDto.fromJS(item),
            );
        } else {
          this.regionDoubleTaxReliefPolicySettingOptions = <any>null;
        }
        this.regionDoubleTaxReliefPolicySettings = _data[
          'regionDoubleTaxReliefPolicySettings'
        ]
          ? RegionDoubleTaxReliefPolicySettingsDto.fromJS(
              _data['regionDoubleTaxReliefPolicySettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): RegionDoubleTaxReliefPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RegionDoubleTaxReliefPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.regionDoubleTaxReliefPolicySettingOptions)) {
        data['regionDoubleTaxReliefPolicySettingOptions'] = [];
        for (let item of this.regionDoubleTaxReliefPolicySettingOptions)
          data['regionDoubleTaxReliefPolicySettingOptions'].push(item.toJSON());
      }
      data['regionDoubleTaxReliefPolicySettings'] = this
        .regionDoubleTaxReliefPolicySettings
        ? this.regionDoubleTaxReliefPolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRegionDoubleTaxReliefPageData {
    regionDoubleTaxReliefPolicySettingOptions: RegionDoubleTaxReliefPolicySettingDto[];
    regionDoubleTaxReliefPolicySettings: RegionDoubleTaxReliefPolicySettingsDto | null;
  }

  export class RegionDoubleTaxReliefPolicySettingDto
    implements IRegionDoubleTaxReliefPolicySettingDto
  {
    optionValue!: RegionDoubleTaxReliefPolicySetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRegionDoubleTaxReliefPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionDoubleTaxReliefPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionDoubleTaxReliefPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRegionDoubleTaxReliefPolicySettingDto {
    optionValue: RegionDoubleTaxReliefPolicySetting;
    displayValue: string;
    displayOrder: number;
  }

  export enum RegionDoubleTaxReliefPolicySetting {
    ReciprocalAgreements = 'ReciprocalAgreements',
    TrailingReciprocalAgreements = 'TrailingReciprocalAgreements',
    StateCredits = 'StateCredits',
    ReverseStateCredits = 'ReverseStateCredits',
    ConvenienceOfEmployer = 'ConvenienceOfEmployer',
  }

  export class RegionDoubleTaxReliefPolicySettingsDto
    implements IRegionDoubleTaxReliefPolicySettingsDto
  {
    id!: string | null;
    configuration!: RegionDoubleTaxReliefPolicySetting[] | null;

    constructor(data?: IRegionDoubleTaxReliefPolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['configuration'])) {
          this.configuration = [] as any;
          for (let item of _data['configuration'])
            this.configuration!.push(item);
        } else {
          this.configuration = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionDoubleTaxReliefPolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionDoubleTaxReliefPolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.configuration)) {
        data['configuration'] = [];
        for (let item of this.configuration) data['configuration'].push(item);
      }
      return data;
    }
  }

  export interface IRegionDoubleTaxReliefPolicySettingsDto {
    id: string | null;
    configuration: RegionDoubleTaxReliefPolicySetting[] | null;
  }

  export class GetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure
    extends GetRegionDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IGetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRegionDoubleTaxReliefPolicyPageDataQueryResultFailure
    extends IGetRegionDoubleTaxReliefPolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertRegionDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertRegionDoubleTaxReliefPolicySettingsCommandResult
  {
    constructor(
      data?: IUpsertRegionDoubleTaxReliefPolicySettingsCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertRegionDoubleTaxReliefPolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionDoubleTaxReliefPolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRegionDoubleTaxReliefPolicySettingsCommandResult {}

  export class UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess
    extends UpsertRegionDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultSuccess
    extends IUpsertRegionDoubleTaxReliefPolicySettingsCommandResult {}

  export class UpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure
    extends UpsertRegionDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRegionDoubleTaxReliefPolicySettingsCommandResultFailure
    extends IUpsertRegionDoubleTaxReliefPolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertRegionDoubleTaxReliefPolicySettingsCommand
    implements IUpsertRegionDoubleTaxReliefPolicySettingsCommand
  {
    clientId!: string;
    regionDoubleTaxReliefPolicySettings!: RegionDoubleTaxReliefPolicySettingsDto | null;

    constructor(data?: IUpsertRegionDoubleTaxReliefPolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.regionDoubleTaxReliefPolicySettings = _data[
          'regionDoubleTaxReliefPolicySettings'
        ]
          ? RegionDoubleTaxReliefPolicySettingsDto.fromJS(
              _data['regionDoubleTaxReliefPolicySettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertRegionDoubleTaxReliefPolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRegionDoubleTaxReliefPolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['regionDoubleTaxReliefPolicySettings'] = this
        .regionDoubleTaxReliefPolicySettings
        ? this.regionDoubleTaxReliefPolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertRegionDoubleTaxReliefPolicySettingsCommand {
    clientId: string;
    regionDoubleTaxReliefPolicySettings: RegionDoubleTaxReliefPolicySettingsDto | null;
  }

  export class GetRechargePolicyPageDataQueryResult
    implements IGetRechargePolicyPageDataQueryResult
  {
    constructor(data?: IGetRechargePolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRechargePolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargePolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRechargePolicyPageDataQueryResult {}

  export class GetRechargePolicyPageDataQueryResultSuccess
    extends GetRechargePolicyPageDataQueryResult
    implements IGetRechargePolicyPageDataQueryResultSuccess
  {
    result!: RechargePolicyPageData;

    constructor(data?: IGetRechargePolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new RechargePolicyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? RechargePolicyPageData.fromJS(_data['result'])
          : new RechargePolicyPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargePolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargePolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargePolicyPageDataQueryResultSuccess
    extends IGetRechargePolicyPageDataQueryResult {
    result: RechargePolicyPageData;
  }

  export class RechargePolicyPageData implements IRechargePolicyPageData {
    rechargePolicySettings!: RechargePolicySettingsV2Dto;
    countriesInFootprint!: RechargePolicyCountryData[];
    batchActionOptions!: RechargeCountryPlanLevelPolicyDto[];
    cashBonusRechargePolicySettingOptions!: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions!: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions!: StockOptionRechargePolicySettingDto[];
    planTypes!: PlanTypeDto[];
    configuredPlanTypes!: PlanTypeDto[];
    planIdToCodeMap!: { [key: string]: string };
    rsuPlanCodes!: string[];
    stockOptionPlanCodes!: string[];
    cashBonusPlanCodes!: string[];

    constructor(data?: IRechargePolicyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.rechargePolicySettings = new RechargePolicySettingsV2Dto();
        this.countriesInFootprint = [];
        this.batchActionOptions = [];
        this.cashBonusRechargePolicySettingOptions = [];
        this.restrictedStockUnitRechargePolicySettingOptions = [];
        this.stockOptionRechargePolicySettingOptions = [];
        this.planTypes = [];
        this.configuredPlanTypes = [];
        this.planIdToCodeMap = {};
        this.rsuPlanCodes = [];
        this.stockOptionPlanCodes = [];
        this.cashBonusPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.rechargePolicySettings = _data['rechargePolicySettings']
          ? RechargePolicySettingsV2Dto.fromJS(_data['rechargePolicySettings'])
          : new RechargePolicySettingsV2Dto();
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              RechargePolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['batchActionOptions'])) {
          this.batchActionOptions = [] as any;
          for (let item of _data['batchActionOptions'])
            this.batchActionOptions!.push(
              RechargeCountryPlanLevelPolicyDto.fromJS(item),
            );
        } else {
          this.batchActionOptions = <any>null;
        }
        if (Array.isArray(_data['cashBonusRechargePolicySettingOptions'])) {
          this.cashBonusRechargePolicySettingOptions = [] as any;
          for (let item of _data['cashBonusRechargePolicySettingOptions'])
            this.cashBonusRechargePolicySettingOptions!.push(
              CashBonusRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusRechargePolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitRechargePolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitRechargePolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitRechargePolicySettingOptions'
          ])
            this.restrictedStockUnitRechargePolicySettingOptions!.push(
              RestrictedStockUnitRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitRechargePolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['stockOptionRechargePolicySettingOptions'])) {
          this.stockOptionRechargePolicySettingOptions = [] as any;
          for (let item of _data['stockOptionRechargePolicySettingOptions'])
            this.stockOptionRechargePolicySettingOptions!.push(
              StockOptionRechargePolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionRechargePolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (_data['planIdToCodeMap']) {
          this.planIdToCodeMap = {} as any;
          for (let key in _data['planIdToCodeMap']) {
            if (_data['planIdToCodeMap'].hasOwnProperty(key))
              (<any>this.planIdToCodeMap)![key] =
                _data['planIdToCodeMap'][key] !== undefined
                  ? _data['planIdToCodeMap'][key]
                  : <any>null;
          }
        } else {
          this.planIdToCodeMap = <any>null;
        }
        if (Array.isArray(_data['rsuPlanCodes'])) {
          this.rsuPlanCodes = [] as any;
          for (let item of _data['rsuPlanCodes']) this.rsuPlanCodes!.push(item);
        } else {
          this.rsuPlanCodes = <any>null;
        }
        if (Array.isArray(_data['stockOptionPlanCodes'])) {
          this.stockOptionPlanCodes = [] as any;
          for (let item of _data['stockOptionPlanCodes'])
            this.stockOptionPlanCodes!.push(item);
        } else {
          this.stockOptionPlanCodes = <any>null;
        }
        if (Array.isArray(_data['cashBonusPlanCodes'])) {
          this.cashBonusPlanCodes = [] as any;
          for (let item of _data['cashBonusPlanCodes'])
            this.cashBonusPlanCodes!.push(item);
        } else {
          this.cashBonusPlanCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): RechargePolicyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['rechargePolicySettings'] = this.rechargePolicySettings
        ? this.rechargePolicySettings.toJSON()
        : <any>null;
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.batchActionOptions)) {
        data['batchActionOptions'] = [];
        for (let item of this.batchActionOptions)
          data['batchActionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusRechargePolicySettingOptions)) {
        data['cashBonusRechargePolicySettingOptions'] = [];
        for (let item of this.cashBonusRechargePolicySettingOptions)
          data['cashBonusRechargePolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitRechargePolicySettingOptions)) {
        data['restrictedStockUnitRechargePolicySettingOptions'] = [];
        for (let item of this.restrictedStockUnitRechargePolicySettingOptions)
          data['restrictedStockUnitRechargePolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionRechargePolicySettingOptions)) {
        data['stockOptionRechargePolicySettingOptions'] = [];
        for (let item of this.stockOptionRechargePolicySettingOptions)
          data['stockOptionRechargePolicySettingOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (this.planIdToCodeMap) {
        data['planIdToCodeMap'] = {};
        for (let key in this.planIdToCodeMap) {
          if (this.planIdToCodeMap.hasOwnProperty(key))
            (<any>data['planIdToCodeMap'])[key] =
              this.planIdToCodeMap[key] !== undefined
                ? this.planIdToCodeMap[key]
                : <any>null;
        }
      }
      if (Array.isArray(this.rsuPlanCodes)) {
        data['rsuPlanCodes'] = [];
        for (let item of this.rsuPlanCodes) data['rsuPlanCodes'].push(item);
      }
      if (Array.isArray(this.stockOptionPlanCodes)) {
        data['stockOptionPlanCodes'] = [];
        for (let item of this.stockOptionPlanCodes)
          data['stockOptionPlanCodes'].push(item);
      }
      if (Array.isArray(this.cashBonusPlanCodes)) {
        data['cashBonusPlanCodes'] = [];
        for (let item of this.cashBonusPlanCodes)
          data['cashBonusPlanCodes'].push(item);
      }
      return data;
    }
  }

  export interface IRechargePolicyPageData {
    rechargePolicySettings: RechargePolicySettingsV2Dto;
    countriesInFootprint: RechargePolicyCountryData[];
    batchActionOptions: RechargeCountryPlanLevelPolicyDto[];
    cashBonusRechargePolicySettingOptions: CashBonusRechargePolicySettingDto[];
    restrictedStockUnitRechargePolicySettingOptions: RestrictedStockUnitRechargePolicySettingDto[];
    stockOptionRechargePolicySettingOptions: StockOptionRechargePolicySettingDto[];
    planTypes: PlanTypeDto[];
    configuredPlanTypes: PlanTypeDto[];
    planIdToCodeMap: { [key: string]: string };
    rsuPlanCodes: string[];
    stockOptionPlanCodes: string[];
    cashBonusPlanCodes: string[];
  }

  export class RechargePolicySettingsV2Dto
    implements IRechargePolicySettingsV2Dto
  {
    clientId!: string;
    isConfigured!: boolean;
    configuration!: RechargePolicySettingsV2ConfigurationReadDto | null;

    constructor(data?: IRechargePolicySettingsV2Dto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.isConfigured =
          _data['isConfigured'] !== undefined
            ? _data['isConfigured']
            : <any>null;
        this.configuration = _data['configuration']
          ? RechargePolicySettingsV2ConfigurationReadDto.fromJS(
              _data['configuration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): RechargePolicySettingsV2Dto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicySettingsV2Dto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['isConfigured'] =
        this.isConfigured !== undefined ? this.isConfigured : <any>null;
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRechargePolicySettingsV2Dto {
    clientId: string;
    isConfigured: boolean;
    configuration: RechargePolicySettingsV2ConfigurationReadDto | null;
  }

  export class RechargePolicySettingsV2ConfigurationReadDto
    implements IRechargePolicySettingsV2ConfigurationReadDto
  {
    defaultCashBonusRechargePolicySetting!: CashBonusRechargePolicySetting;
    defaultRestrictedStockUnitRechargePolicySetting!: RestrictedStockUnitRechargePolicySetting;
    defaultStockOptionRechargePolicySetting!: StockOptionRechargePolicySetting;
    noRechargePlanCountryPairs!: CountryPlanCodePair[];
    overriddenAtCountryLevel!: boolean;

    constructor(data?: IRechargePolicySettingsV2ConfigurationReadDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.noRechargePlanCountryPairs = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.defaultCashBonusRechargePolicySetting =
          _data['defaultCashBonusRechargePolicySetting'] !== undefined
            ? _data['defaultCashBonusRechargePolicySetting']
            : <any>null;
        this.defaultRestrictedStockUnitRechargePolicySetting =
          _data['defaultRestrictedStockUnitRechargePolicySetting'] !== undefined
            ? _data['defaultRestrictedStockUnitRechargePolicySetting']
            : <any>null;
        this.defaultStockOptionRechargePolicySetting =
          _data['defaultStockOptionRechargePolicySetting'] !== undefined
            ? _data['defaultStockOptionRechargePolicySetting']
            : <any>null;
        if (Array.isArray(_data['noRechargePlanCountryPairs'])) {
          this.noRechargePlanCountryPairs = [] as any;
          for (let item of _data['noRechargePlanCountryPairs'])
            this.noRechargePlanCountryPairs!.push(
              CountryPlanCodePair.fromJS(item),
            );
        } else {
          this.noRechargePlanCountryPairs = <any>null;
        }
        this.overriddenAtCountryLevel =
          _data['overriddenAtCountryLevel'] !== undefined
            ? _data['overriddenAtCountryLevel']
            : <any>null;
      }
    }

    static fromJS(data: any): RechargePolicySettingsV2ConfigurationReadDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicySettingsV2ConfigurationReadDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['defaultCashBonusRechargePolicySetting'] =
        this.defaultCashBonusRechargePolicySetting !== undefined
          ? this.defaultCashBonusRechargePolicySetting
          : <any>null;
      data['defaultRestrictedStockUnitRechargePolicySetting'] =
        this.defaultRestrictedStockUnitRechargePolicySetting !== undefined
          ? this.defaultRestrictedStockUnitRechargePolicySetting
          : <any>null;
      data['defaultStockOptionRechargePolicySetting'] =
        this.defaultStockOptionRechargePolicySetting !== undefined
          ? this.defaultStockOptionRechargePolicySetting
          : <any>null;
      if (Array.isArray(this.noRechargePlanCountryPairs)) {
        data['noRechargePlanCountryPairs'] = [];
        for (let item of this.noRechargePlanCountryPairs)
          data['noRechargePlanCountryPairs'].push(item.toJSON());
      }
      data['overriddenAtCountryLevel'] =
        this.overriddenAtCountryLevel !== undefined
          ? this.overriddenAtCountryLevel
          : <any>null;
      return data;
    }
  }

  export interface IRechargePolicySettingsV2ConfigurationReadDto {
    defaultCashBonusRechargePolicySetting: CashBonusRechargePolicySetting;
    defaultRestrictedStockUnitRechargePolicySetting: RestrictedStockUnitRechargePolicySetting;
    defaultStockOptionRechargePolicySetting: StockOptionRechargePolicySetting;
    noRechargePlanCountryPairs: CountryPlanCodePair[];
    overriddenAtCountryLevel: boolean;
  }

  export class CountryPlanCodePair implements ICountryPlanCodePair {
    country!: string;
    planCode!: string;

    constructor(data?: ICountryPlanCodePair) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
      }
    }

    static fromJS(data: any): CountryPlanCodePair {
      data = typeof data === 'object' ? data : {};
      let result = new CountryPlanCodePair();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      return data;
    }
  }

  export interface ICountryPlanCodePair {
    country: string;
    planCode: string;
  }

  export class RechargePolicyCountryData implements IRechargePolicyCountryData {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IRechargePolicyCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): RechargePolicyCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicyCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IRechargePolicyCountryData {
    countryCode: string;
    countryName: string;
  }

  export class RechargeCountryPlanLevelPolicyDto
    implements IRechargeCountryPlanLevelPolicyDto
  {
    optionValue!: RechargeCountryPlanLevelPolicy;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRechargeCountryPlanLevelPolicyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RechargeCountryPlanLevelPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargeCountryPlanLevelPolicyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRechargeCountryPlanLevelPolicyDto {
    optionValue: RechargeCountryPlanLevelPolicy;
    displayValue: string;
    displayOrder: number;
  }

  export enum RechargeCountryPlanLevelPolicy {
    CompanyDefault = 'CompanyDefault',
    NoRecharge = 'NoRecharge',
  }

  export class GetRechargePolicyPageDataQueryResultFailure
    extends GetRechargePolicyPageDataQueryResult
    implements IGetRechargePolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetRechargePolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargePolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargePolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargePolicyPageDataQueryResultFailure
    extends IGetRechargePolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertRechargePolicySettingsCommandResult
    implements IUpsertRechargePolicySettingsCommandResult
  {
    constructor(data?: IUpsertRechargePolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertRechargePolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargePolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRechargePolicySettingsCommandResult {}

  export class UpsertRechargePolicySettingsCommandResultSuccess
    extends UpsertRechargePolicySettingsCommandResult
    implements IUpsertRechargePolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertRechargePolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRechargePolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargePolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargePolicySettingsCommandResultSuccess
    extends IUpsertRechargePolicySettingsCommandResult {}

  export class UpsertRechargePolicySettingsCommandResultFailure
    extends UpsertRechargePolicySettingsCommandResult
    implements IUpsertRechargePolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertRechargePolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertRechargePolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargePolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargePolicySettingsCommandResultFailure
    extends IUpsertRechargePolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertRechargePolicySettingsCommand
    implements IUpsertRechargePolicySettingsCommand
  {
    clientId!: string;
    upsertRechargePolicySettingsV2!: UpsertRechargePolicySettingsV2Dto;

    constructor(data?: IUpsertRechargePolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.upsertRechargePolicySettingsV2 =
          new UpsertRechargePolicySettingsV2Dto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.upsertRechargePolicySettingsV2 = _data[
          'upsertRechargePolicySettingsV2'
        ]
          ? UpsertRechargePolicySettingsV2Dto.fromJS(
              _data['upsertRechargePolicySettingsV2'],
            )
          : new UpsertRechargePolicySettingsV2Dto();
      }
    }

    static fromJS(data: any): UpsertRechargePolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargePolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['upsertRechargePolicySettingsV2'] = this
        .upsertRechargePolicySettingsV2
        ? this.upsertRechargePolicySettingsV2.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertRechargePolicySettingsCommand {
    clientId: string;
    upsertRechargePolicySettingsV2: UpsertRechargePolicySettingsV2Dto;
  }

  export class UpsertRechargePolicySettingsV2Dto
    implements IUpsertRechargePolicySettingsV2Dto
  {
    configuration!: RechargePolicySettingsV2ConfigurationDto | null;

    constructor(data?: IUpsertRechargePolicySettingsV2Dto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.configuration = _data['configuration']
          ? RechargePolicySettingsV2ConfigurationDto.fromJS(
              _data['configuration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertRechargePolicySettingsV2Dto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargePolicySettingsV2Dto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertRechargePolicySettingsV2Dto {
    configuration: RechargePolicySettingsV2ConfigurationDto | null;
  }

  export class RechargePolicySettingsV2ConfigurationDto
    implements IRechargePolicySettingsV2ConfigurationDto
  {
    defaultCashBonusRechargePolicySetting!: CashBonusRechargePolicySetting;
    defaultRestrictedStockUnitRechargePolicySetting!: RestrictedStockUnitRechargePolicySetting;
    defaultStockOptionRechargePolicySetting!: StockOptionRechargePolicySetting;
    noRechargePlanCountryPairs!: CountryPlanCodePair[];

    constructor(data?: IRechargePolicySettingsV2ConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.noRechargePlanCountryPairs = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.defaultCashBonusRechargePolicySetting =
          _data['defaultCashBonusRechargePolicySetting'] !== undefined
            ? _data['defaultCashBonusRechargePolicySetting']
            : <any>null;
        this.defaultRestrictedStockUnitRechargePolicySetting =
          _data['defaultRestrictedStockUnitRechargePolicySetting'] !== undefined
            ? _data['defaultRestrictedStockUnitRechargePolicySetting']
            : <any>null;
        this.defaultStockOptionRechargePolicySetting =
          _data['defaultStockOptionRechargePolicySetting'] !== undefined
            ? _data['defaultStockOptionRechargePolicySetting']
            : <any>null;
        if (Array.isArray(_data['noRechargePlanCountryPairs'])) {
          this.noRechargePlanCountryPairs = [] as any;
          for (let item of _data['noRechargePlanCountryPairs'])
            this.noRechargePlanCountryPairs!.push(
              CountryPlanCodePair.fromJS(item),
            );
        } else {
          this.noRechargePlanCountryPairs = <any>null;
        }
      }
    }

    static fromJS(data: any): RechargePolicySettingsV2ConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargePolicySettingsV2ConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['defaultCashBonusRechargePolicySetting'] =
        this.defaultCashBonusRechargePolicySetting !== undefined
          ? this.defaultCashBonusRechargePolicySetting
          : <any>null;
      data['defaultRestrictedStockUnitRechargePolicySetting'] =
        this.defaultRestrictedStockUnitRechargePolicySetting !== undefined
          ? this.defaultRestrictedStockUnitRechargePolicySetting
          : <any>null;
      data['defaultStockOptionRechargePolicySetting'] =
        this.defaultStockOptionRechargePolicySetting !== undefined
          ? this.defaultStockOptionRechargePolicySetting
          : <any>null;
      if (Array.isArray(this.noRechargePlanCountryPairs)) {
        data['noRechargePlanCountryPairs'] = [];
        for (let item of this.noRechargePlanCountryPairs)
          data['noRechargePlanCountryPairs'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRechargePolicySettingsV2ConfigurationDto {
    defaultCashBonusRechargePolicySetting: CashBonusRechargePolicySetting;
    defaultRestrictedStockUnitRechargePolicySetting: RestrictedStockUnitRechargePolicySetting;
    defaultStockOptionRechargePolicySetting: StockOptionRechargePolicySetting;
    noRechargePlanCountryPairs: CountryPlanCodePair[];
  }

  export class UpsertRechargeCountryAmountSettingsCommandResult
    implements IUpsertRechargeCountryAmountSettingsCommandResult
  {
    constructor(data?: IUpsertRechargeCountryAmountSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertRechargeCountryAmountSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargeCountryAmountSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertRechargeCountryAmountSettingsCommandResult {}

  export class UpsertRechargeCountryAmountSettingsCommandResultSuccess
    extends UpsertRechargeCountryAmountSettingsCommandResult
    implements IUpsertRechargeCountryAmountSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertRechargeCountryAmountSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRechargeCountryAmountSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertRechargeCountryAmountSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargeCountryAmountSettingsCommandResultSuccess
    extends IUpsertRechargeCountryAmountSettingsCommandResult {}

  export class UpsertRechargeCountryAmountSettingsCommandResultFailure
    extends UpsertRechargeCountryAmountSettingsCommandResult
    implements IUpsertRechargeCountryAmountSettingsCommandResultFailure
  {
    constructor(
      data?: IUpsertRechargeCountryAmountSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertRechargeCountryAmountSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertRechargeCountryAmountSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertRechargeCountryAmountSettingsCommandResultFailure
    extends IUpsertRechargeCountryAmountSettingsCommandResult {}

  export class UpsertRechargeCountryAmountSettingsCommand
    implements IUpsertRechargeCountryAmountSettingsCommand
  {
    clientId!: string;
    id!: string | null;
    transactionId!: string;
    countryAmounts!: CountryAmountDto[];

    constructor(data?: IUpsertRechargeCountryAmountSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryAmounts = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['countryAmounts'])) {
          this.countryAmounts = [] as any;
          for (let item of _data['countryAmounts'])
            this.countryAmounts!.push(CountryAmountDto.fromJS(item));
        } else {
          this.countryAmounts = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertRechargeCountryAmountSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertRechargeCountryAmountSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.countryAmounts)) {
        data['countryAmounts'] = [];
        for (let item of this.countryAmounts)
          data['countryAmounts'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertRechargeCountryAmountSettingsCommand {
    clientId: string;
    id: string | null;
    transactionId: string;
    countryAmounts: CountryAmountDto[];
  }

  export class CountryAmountDto implements ICountryAmountDto {
    countryCode!: string;
    currencyCode!: string;
    amount!: number;

    constructor(data?: ICountryAmountDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.amount =
          _data['amount'] !== undefined ? _data['amount'] : <any>null;
      }
    }

    static fromJS(data: any): CountryAmountDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryAmountDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['amount'] = this.amount !== undefined ? this.amount : <any>null;
      return data;
    }
  }

  export interface ICountryAmountDto {
    countryCode: string;
    currencyCode: string;
    amount: number;
  }

  export class GetRechargeCountryAmountPageDataQueryResult
    implements IGetRechargeCountryAmountPageDataQueryResult
  {
    constructor(data?: IGetRechargeCountryAmountPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRechargeCountryAmountPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRechargeCountryAmountPageDataQueryResult {}

  export class GetRechargeCountryAmountPageDataQueryResultSuccess
    extends GetRechargeCountryAmountPageDataQueryResult
    implements IGetRechargeCountryAmountPageDataQueryResultSuccess
  {
    countriesInFootprintIsoCodes!: string[];
    rechargeCountryAmountSettingsDto!: RechargeCountryAmountSettingsDto | null;

    constructor(data?: IGetRechargeCountryAmountPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.countriesInFootprintIsoCodes = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['countriesInFootprintIsoCodes'])) {
          this.countriesInFootprintIsoCodes = [] as any;
          for (let item of _data['countriesInFootprintIsoCodes'])
            this.countriesInFootprintIsoCodes!.push(item);
        } else {
          this.countriesInFootprintIsoCodes = <any>null;
        }
        this.rechargeCountryAmountSettingsDto = _data[
          'rechargeCountryAmountSettingsDto'
        ]
          ? RechargeCountryAmountSettingsDto.fromJS(
              _data['rechargeCountryAmountSettingsDto'],
            )
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeCountryAmountPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprintIsoCodes)) {
        data['countriesInFootprintIsoCodes'] = [];
        for (let item of this.countriesInFootprintIsoCodes)
          data['countriesInFootprintIsoCodes'].push(item);
      }
      data['rechargeCountryAmountSettingsDto'] = this
        .rechargeCountryAmountSettingsDto
        ? this.rechargeCountryAmountSettingsDto.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeCountryAmountPageDataQueryResultSuccess
    extends IGetRechargeCountryAmountPageDataQueryResult {
    countriesInFootprintIsoCodes: string[];
    rechargeCountryAmountSettingsDto: RechargeCountryAmountSettingsDto | null;
  }

  export class RechargeCountryAmountSettingsDto
    implements IRechargeCountryAmountSettingsDto
  {
    id!: string;
    clientId!: string;
    transactionId!: string;
    countryAmounts!: CountryAmountDto[];

    constructor(data?: IRechargeCountryAmountSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryAmounts = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['countryAmounts'])) {
          this.countryAmounts = [] as any;
          for (let item of _data['countryAmounts'])
            this.countryAmounts!.push(CountryAmountDto.fromJS(item));
        } else {
          this.countryAmounts = <any>null;
        }
      }
    }

    static fromJS(data: any): RechargeCountryAmountSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new RechargeCountryAmountSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.countryAmounts)) {
        data['countryAmounts'] = [];
        for (let item of this.countryAmounts)
          data['countryAmounts'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRechargeCountryAmountSettingsDto {
    id: string;
    clientId: string;
    transactionId: string;
    countryAmounts: CountryAmountDto[];
  }

  export class GetRechargeCountryAmountPageDataQueryResultFailure
    extends GetRechargeCountryAmountPageDataQueryResult
    implements IGetRechargeCountryAmountPageDataQueryResultFailure
  {
    constructor(data?: IGetRechargeCountryAmountPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetRechargeCountryAmountPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeCountryAmountPageDataQueryResultFailure
    extends IGetRechargeCountryAmountPageDataQueryResult {}

  export class GetRechargeCountryAmountsQueryResult
    implements IGetRechargeCountryAmountsQueryResult
  {
    constructor(data?: IGetRechargeCountryAmountsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRechargeCountryAmountsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRechargeCountryAmountsQueryResult {}

  export class GetRechargeCountryAmountsQueryResultSuccess
    extends GetRechargeCountryAmountsQueryResult
    implements IGetRechargeCountryAmountsQueryResultSuccess
  {
    rechargeCountryAmounts!: RechargeCountryAmountSettingsDto[];

    constructor(data?: IGetRechargeCountryAmountsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.rechargeCountryAmounts = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['rechargeCountryAmounts'])) {
          this.rechargeCountryAmounts = [] as any;
          for (let item of _data['rechargeCountryAmounts'])
            this.rechargeCountryAmounts!.push(
              RechargeCountryAmountSettingsDto.fromJS(item),
            );
        } else {
          this.rechargeCountryAmounts = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRechargeCountryAmountsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.rechargeCountryAmounts)) {
        data['rechargeCountryAmounts'] = [];
        for (let item of this.rechargeCountryAmounts)
          data['rechargeCountryAmounts'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeCountryAmountsQueryResultSuccess
    extends IGetRechargeCountryAmountsQueryResult {
    rechargeCountryAmounts: RechargeCountryAmountSettingsDto[];
  }

  export class GetRechargeCountryAmountsQueryResultFailure
    extends GetRechargeCountryAmountsQueryResult
    implements IGetRechargeCountryAmountsQueryResultFailure
  {
    constructor(data?: IGetRechargeCountryAmountsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetRechargeCountryAmountsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRechargeCountryAmountsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRechargeCountryAmountsQueryResultFailure
    extends IGetRechargeCountryAmountsQueryResult {}

  export abstract class DeleteRechargeCountryAmountSettingsCommandResult
    implements IDeleteRechargeCountryAmountSettingsCommandResult
  {
    constructor(data?: IDeleteRechargeCountryAmountSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteRechargeCountryAmountSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DeleteRechargeCountryAmountSettingsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteRechargeCountryAmountSettingsCommandResult {}

  export class DeleteRechargeCountryAmountSettingsCommandResultSuccess
    extends DeleteRechargeCountryAmountSettingsCommandResult
    implements IDeleteRechargeCountryAmountSettingsCommandResultSuccess
  {
    constructor(
      data?: IDeleteRechargeCountryAmountSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteRechargeCountryAmountSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteRechargeCountryAmountSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRechargeCountryAmountSettingsCommandResultSuccess
    extends IDeleteRechargeCountryAmountSettingsCommandResult {}

  export class DeleteRechargeCountryAmountSettingsCommandResultFailure
    extends DeleteRechargeCountryAmountSettingsCommandResult
    implements IDeleteRechargeCountryAmountSettingsCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IDeleteRechargeCountryAmountSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteRechargeCountryAmountSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteRechargeCountryAmountSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRechargeCountryAmountSettingsCommandResultFailure
    extends IDeleteRechargeCountryAmountSettingsCommandResult {
    errorMessage: string;
  }

  export class DeleteRechargeCountryAmountSettingsCommand
    implements IDeleteRechargeCountryAmountSettingsCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteRechargeCountryAmountSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteRechargeCountryAmountSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRechargeCountryAmountSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteRechargeCountryAmountSettingsCommand {
    clientId: string;
    id: string;
  }

  export class GetPrecisionPageDataQueryResult
    implements IGetPrecisionPageDataQueryResult
  {
    constructor(data?: IGetPrecisionPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPrecisionPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetPrecisionPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPrecisionPageDataQueryResult {}

  export class GetPrecisionPageDataQueryResultSuccess
    extends GetPrecisionPageDataQueryResult
    implements IGetPrecisionPageDataQueryResultSuccess
  {
    result!: PrecisionPageData;

    constructor(data?: IGetPrecisionPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PrecisionPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PrecisionPageData.fromJS(_data['result'])
          : new PrecisionPageData();
      }
    }

    static override fromJS(data: any): GetPrecisionPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPrecisionPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPrecisionPageDataQueryResultSuccess
    extends IGetPrecisionPageDataQueryResult {
    result: PrecisionPageData;
  }

  export class PrecisionPageData implements IPrecisionPageData {
    precision!: PrecisionSettingsDto | null;
    defaultNumericPrecision!: number;
    defaultPercentagePrecision!: number;

    constructor(data?: IPrecisionPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.precision = _data['precision']
          ? PrecisionSettingsDto.fromJS(_data['precision'])
          : <any>null;
        this.defaultNumericPrecision =
          _data['defaultNumericPrecision'] !== undefined
            ? _data['defaultNumericPrecision']
            : <any>null;
        this.defaultPercentagePrecision =
          _data['defaultPercentagePrecision'] !== undefined
            ? _data['defaultPercentagePrecision']
            : <any>null;
      }
    }

    static fromJS(data: any): PrecisionPageData {
      data = typeof data === 'object' ? data : {};
      let result = new PrecisionPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['precision'] = this.precision ? this.precision.toJSON() : <any>null;
      data['defaultNumericPrecision'] =
        this.defaultNumericPrecision !== undefined
          ? this.defaultNumericPrecision
          : <any>null;
      data['defaultPercentagePrecision'] =
        this.defaultPercentagePrecision !== undefined
          ? this.defaultPercentagePrecision
          : <any>null;
      return data;
    }
  }

  export interface IPrecisionPageData {
    precision: PrecisionSettingsDto | null;
    defaultNumericPrecision: number;
    defaultPercentagePrecision: number;
  }

  export class PrecisionSettingsDto implements IPrecisionSettingsDto {
    id!: string;
    numericPrecision!: number;
    percentagePrecision!: number;

    constructor(data?: IPrecisionSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.numericPrecision =
          _data['numericPrecision'] !== undefined
            ? _data['numericPrecision']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
      }
    }

    static fromJS(data: any): PrecisionSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PrecisionSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['numericPrecision'] =
        this.numericPrecision !== undefined ? this.numericPrecision : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      return data;
    }
  }

  export interface IPrecisionSettingsDto {
    id: string;
    numericPrecision: number;
    percentagePrecision: number;
  }

  export class GetPrecisionPageDataQueryResultFailure
    extends GetPrecisionPageDataQueryResult
    implements IGetPrecisionPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetPrecisionPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetPrecisionPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPrecisionPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPrecisionPageDataQueryResultFailure
    extends IGetPrecisionPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertPrecisionSettingsCommandResult
    implements IUpsertPrecisionSettingsCommandResult
  {
    constructor(data?: IUpsertPrecisionSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertPrecisionSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPrecisionSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertPrecisionSettingsCommandResult {}

  export class UpsertPrecisionSettingsCommandResultSuccess
    extends UpsertPrecisionSettingsCommandResult
    implements IUpsertPrecisionSettingsCommandResultSuccess
  {
    constructor(data?: IUpsertPrecisionSettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertPrecisionSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPrecisionSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPrecisionSettingsCommandResultSuccess
    extends IUpsertPrecisionSettingsCommandResult {}

  export class UpsertPrecisionSettingsCommandResultFailure
    extends UpsertPrecisionSettingsCommandResult
    implements IUpsertPrecisionSettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertPrecisionSettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertPrecisionSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPrecisionSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPrecisionSettingsCommandResultFailure
    extends IUpsertPrecisionSettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertPrecisionSettingsCommand
    implements IUpsertPrecisionSettingsCommand
  {
    clientId!: string;
    id!: string | null;
    numericPrecision!: number;
    percentagePrecision!: number;

    constructor(data?: IUpsertPrecisionSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.numericPrecision =
          _data['numericPrecision'] !== undefined
            ? _data['numericPrecision']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertPrecisionSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPrecisionSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['numericPrecision'] =
        this.numericPrecision !== undefined ? this.numericPrecision : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      return data;
    }
  }

  export interface IUpsertPrecisionSettingsCommand {
    clientId: string;
    id: string | null;
    numericPrecision: number;
    percentagePrecision: number;
  }

  export class GetPlanSetupPageDataQueryResult
    implements IGetPlanSetupPageDataQueryResult
  {
    constructor(data?: IGetPlanSetupPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPlanSetupPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetPlanSetupPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPlanSetupPageDataQueryResult {}

  export class GetPlanSetupPageDataQueryResultSuccess
    extends GetPlanSetupPageDataQueryResult
    implements IGetPlanSetupPageDataQueryResultSuccess
  {
    result!: PlanSetupPageData;

    constructor(data?: IGetPlanSetupPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupPageData.fromJS(_data['result'])
          : new PlanSetupPageData();
      }
    }

    static override fromJS(data: any): GetPlanSetupPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPlanSetupPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPlanSetupPageDataQueryResultSuccess
    extends IGetPlanSetupPageDataQueryResult {
    result: PlanSetupPageData;
  }

  export class PlanSetupPageData implements IPlanSetupPageData {
    cashBonusEarningsPeriods!: CashBonusEarningsPeriodDto[];
    restrictedStockUnitEarningsPeriods!: RestrictedStockUnitEarningsPeriodDto[];
    stockOptionEarningsPeriods!: StockOptionEarningsPeriodDto[];
    supportedCountriesInFootprint!: PlanSetupCountryData[];
    planSetupDetails!: PlanSetupDetailsDto | null;

    constructor(data?: IPlanSetupPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.cashBonusEarningsPeriods = [];
        this.restrictedStockUnitEarningsPeriods = [];
        this.stockOptionEarningsPeriods = [];
        this.supportedCountriesInFootprint = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['cashBonusEarningsPeriods'])) {
          this.cashBonusEarningsPeriods = [] as any;
          for (let item of _data['cashBonusEarningsPeriods'])
            this.cashBonusEarningsPeriods!.push(
              CashBonusEarningsPeriodDto.fromJS(item),
            );
        } else {
          this.cashBonusEarningsPeriods = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitEarningsPeriods'])) {
          this.restrictedStockUnitEarningsPeriods = [] as any;
          for (let item of _data['restrictedStockUnitEarningsPeriods'])
            this.restrictedStockUnitEarningsPeriods!.push(
              RestrictedStockUnitEarningsPeriodDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitEarningsPeriods = <any>null;
        }
        if (Array.isArray(_data['stockOptionEarningsPeriods'])) {
          this.stockOptionEarningsPeriods = [] as any;
          for (let item of _data['stockOptionEarningsPeriods'])
            this.stockOptionEarningsPeriods!.push(
              StockOptionEarningsPeriodDto.fromJS(item),
            );
        } else {
          this.stockOptionEarningsPeriods = <any>null;
        }
        if (Array.isArray(_data['supportedCountriesInFootprint'])) {
          this.supportedCountriesInFootprint = [] as any;
          for (let item of _data['supportedCountriesInFootprint'])
            this.supportedCountriesInFootprint!.push(
              PlanSetupCountryData.fromJS(item),
            );
        } else {
          this.supportedCountriesInFootprint = <any>null;
        }
        this.planSetupDetails = _data['planSetupDetails']
          ? PlanSetupDetailsDto.fromJS(_data['planSetupDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): PlanSetupPageData {
      data = typeof data === 'object' ? data : {};
      let result = new PlanSetupPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.cashBonusEarningsPeriods)) {
        data['cashBonusEarningsPeriods'] = [];
        for (let item of this.cashBonusEarningsPeriods)
          data['cashBonusEarningsPeriods'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitEarningsPeriods)) {
        data['restrictedStockUnitEarningsPeriods'] = [];
        for (let item of this.restrictedStockUnitEarningsPeriods)
          data['restrictedStockUnitEarningsPeriods'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionEarningsPeriods)) {
        data['stockOptionEarningsPeriods'] = [];
        for (let item of this.stockOptionEarningsPeriods)
          data['stockOptionEarningsPeriods'].push(item.toJSON());
      }
      if (Array.isArray(this.supportedCountriesInFootprint)) {
        data['supportedCountriesInFootprint'] = [];
        for (let item of this.supportedCountriesInFootprint)
          data['supportedCountriesInFootprint'].push(item.toJSON());
      }
      data['planSetupDetails'] = this.planSetupDetails
        ? this.planSetupDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IPlanSetupPageData {
    cashBonusEarningsPeriods: CashBonusEarningsPeriodDto[];
    restrictedStockUnitEarningsPeriods: RestrictedStockUnitEarningsPeriodDto[];
    stockOptionEarningsPeriods: StockOptionEarningsPeriodDto[];
    supportedCountriesInFootprint: PlanSetupCountryData[];
    planSetupDetails: PlanSetupDetailsDto | null;
  }

  export class CashBonusEarningsPeriodDto
    implements ICashBonusEarningsPeriodDto
  {
    optionValue!: CashBonusEarningsPeriod;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ICashBonusEarningsPeriodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): CashBonusEarningsPeriodDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusEarningsPeriodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ICashBonusEarningsPeriodDto {
    optionValue: CashBonusEarningsPeriod;
    displayValue: string;
    displayOrder: number;
  }

  export enum CashBonusEarningsPeriod {
    PerformanceStartToPerformanceEnd = 'PerformanceStartToPerformanceEnd',
    PriorYear = 'PriorYear',
    FirstJanuaryOfPriorYearToPayment = 'FirstJanuaryOfPriorYearToPayment',
  }

  export class RestrictedStockUnitEarningsPeriodDto
    implements IRestrictedStockUnitEarningsPeriodDto
  {
    optionValue!: RestrictedStockUnitEarningsPeriod;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IRestrictedStockUnitEarningsPeriodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): RestrictedStockUnitEarningsPeriodDto {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitEarningsPeriodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IRestrictedStockUnitEarningsPeriodDto {
    optionValue: RestrictedStockUnitEarningsPeriod;
    displayValue: string;
    displayOrder: number;
  }

  export enum RestrictedStockUnitEarningsPeriod {
    GrantToVest = 'GrantToVest',
    GrantToDistribution = 'GrantToDistribution',
    FirstJanuaryOfPriorYearToDistribution = 'FirstJanuaryOfPriorYearToDistribution',
  }

  export class StockOptionEarningsPeriodDto
    implements IStockOptionEarningsPeriodDto
  {
    optionValue!: StockOptionEarningsPeriod;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IStockOptionEarningsPeriodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): StockOptionEarningsPeriodDto {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionEarningsPeriodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IStockOptionEarningsPeriodDto {
    optionValue: StockOptionEarningsPeriod;
    displayValue: string;
    displayOrder: number;
  }

  export enum StockOptionEarningsPeriod {
    GrantToVest = 'GrantToVest',
    GrantToExercise = 'GrantToExercise',
    FirstJanuaryOfPriorYearToExercise = 'FirstJanuaryOfPriorYearToExercise',
  }

  export class PlanSetupCountryData implements IPlanSetupCountryData {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IPlanSetupCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): PlanSetupCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new PlanSetupCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IPlanSetupCountryData {
    countryCode: string;
    countryName: string;
  }

  export class PlanSetupDetailsDto implements IPlanSetupDetailsDto {
    id!: string;
    rsuDetails!: RestrictedStockUnitPlanTypeDetailsDto[];
    stockOptionDetails!: StockOptionPlanTypeDetailsDto[];
    cashBonusDetails!: CashBonusPlanTypeDetailsDto[];

    constructor(data?: IPlanSetupDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.rsuDetails = [];
        this.stockOptionDetails = [];
        this.cashBonusDetails = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['rsuDetails'])) {
          this.rsuDetails = [] as any;
          for (let item of _data['rsuDetails'])
            this.rsuDetails!.push(
              RestrictedStockUnitPlanTypeDetailsDto.fromJS(item),
            );
        } else {
          this.rsuDetails = <any>null;
        }
        if (Array.isArray(_data['stockOptionDetails'])) {
          this.stockOptionDetails = [] as any;
          for (let item of _data['stockOptionDetails'])
            this.stockOptionDetails!.push(
              StockOptionPlanTypeDetailsDto.fromJS(item),
            );
        } else {
          this.stockOptionDetails = <any>null;
        }
        if (Array.isArray(_data['cashBonusDetails'])) {
          this.cashBonusDetails = [] as any;
          for (let item of _data['cashBonusDetails'])
            this.cashBonusDetails!.push(
              CashBonusPlanTypeDetailsDto.fromJS(item),
            );
        } else {
          this.cashBonusDetails = <any>null;
        }
      }
    }

    static fromJS(data: any): PlanSetupDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PlanSetupDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.rsuDetails)) {
        data['rsuDetails'] = [];
        for (let item of this.rsuDetails)
          data['rsuDetails'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionDetails)) {
        data['stockOptionDetails'] = [];
        for (let item of this.stockOptionDetails)
          data['stockOptionDetails'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusDetails)) {
        data['cashBonusDetails'] = [];
        for (let item of this.cashBonusDetails)
          data['cashBonusDetails'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPlanSetupDetailsDto {
    id: string;
    rsuDetails: RestrictedStockUnitPlanTypeDetailsDto[];
    stockOptionDetails: StockOptionPlanTypeDetailsDto[];
    cashBonusDetails: CashBonusPlanTypeDetailsDto[];
  }

  export class RestrictedStockUnitPlanTypeDetailsDto
    implements IRestrictedStockUnitPlanTypeDetailsDto
  {
    id!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IRestrictedStockUnitPlanTypeDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): RestrictedStockUnitPlanTypeDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitPlanTypeDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IRestrictedStockUnitPlanTypeDetailsDto {
    id: string;
    planName: string;
    planCode: string;
    earningsPeriod: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class StockOptionPlanTypeDetailsDto
    implements IStockOptionPlanTypeDetailsDto
  {
    id!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: StockOptionEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IStockOptionPlanTypeDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): StockOptionPlanTypeDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionPlanTypeDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IStockOptionPlanTypeDetailsDto {
    id: string;
    planName: string;
    planCode: string;
    earningsPeriod: StockOptionEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class CashBonusPlanTypeDetailsDto
    implements ICashBonusPlanTypeDetailsDto
  {
    id!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: CashBonusEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: ICashBonusPlanTypeDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): CashBonusPlanTypeDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashBonusPlanTypeDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface ICashBonusPlanTypeDetailsDto {
    id: string;
    planName: string;
    planCode: string;
    earningsPeriod: CashBonusEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class GetPlanSetupPageDataQueryResultFailure
    extends GetPlanSetupPageDataQueryResult
    implements IGetPlanSetupPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetPlanSetupPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetPlanSetupPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPlanSetupPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPlanSetupPageDataQueryResultFailure
    extends IGetPlanSetupPageDataQueryResult {
    errors: ResultError[];
  }

  export class SavePlanSetupDetailsCommandResult
    implements ISavePlanSetupDetailsCommandResult
  {
    constructor(data?: ISavePlanSetupDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SavePlanSetupDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SavePlanSetupDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISavePlanSetupDetailsCommandResult {}

  export class SavePlanSetupDetailsCommandResultSuccess
    extends SavePlanSetupDetailsCommandResult
    implements ISavePlanSetupDetailsCommandResultSuccess
  {
    constructor(data?: ISavePlanSetupDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SavePlanSetupDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SavePlanSetupDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISavePlanSetupDetailsCommandResultSuccess
    extends ISavePlanSetupDetailsCommandResult {}

  export class SavePlanSetupDetailsCommandResultFailure
    extends SavePlanSetupDetailsCommandResult
    implements ISavePlanSetupDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISavePlanSetupDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SavePlanSetupDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SavePlanSetupDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISavePlanSetupDetailsCommandResultFailure
    extends ISavePlanSetupDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddRsuPlanTypeDetailsCommandResult
    implements IAddRsuPlanTypeDetailsCommandResult
  {
    constructor(data?: IAddRsuPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddRsuPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new AddRsuPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddRsuPlanTypeDetailsCommandResult {}

  export class AddRsuPlanTypeDetailsCommandResultSuccess
    extends AddRsuPlanTypeDetailsCommandResult
    implements IAddRsuPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IAddRsuPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): AddRsuPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddRsuPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddRsuPlanTypeDetailsCommandResultSuccess
    extends IAddRsuPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class AddRsuPlanTypeDetailsCommandResultFailure
    extends AddRsuPlanTypeDetailsCommandResult
    implements IAddRsuPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IAddRsuPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): AddRsuPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddRsuPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddRsuPlanTypeDetailsCommandResultFailure
    extends IAddRsuPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddRsuPlanTypeDetailsCommand
    implements IAddRsuPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IAddRsuPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): AddRsuPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddRsuPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IAddRsuPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    planName: string;
    planCode: string;
    earningsPeriod: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class UpdateRsuPlanTypeDetailsCommandResult
    implements IUpdateRsuPlanTypeDetailsCommandResult
  {
    constructor(data?: IUpdateRsuPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateRsuPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateRsuPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateRsuPlanTypeDetailsCommandResult {}

  export class UpdateRsuPlanTypeDetailsCommandResultSuccess
    extends UpdateRsuPlanTypeDetailsCommandResult
    implements IUpdateRsuPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IUpdateRsuPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpdateRsuPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateRsuPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateRsuPlanTypeDetailsCommandResultSuccess
    extends IUpdateRsuPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class UpdateRsuPlanTypeDetailsCommandResultFailure
    extends UpdateRsuPlanTypeDetailsCommandResult
    implements IUpdateRsuPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateRsuPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpdateRsuPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateRsuPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateRsuPlanTypeDetailsCommandResultFailure
    extends IUpdateRsuPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class UpdateRsuPlanTypeDetailsCommand
    implements IUpdateRsuPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    rsuPlanTypeDetailsId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IUpdateRsuPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.rsuPlanTypeDetailsId =
          _data['rsuPlanTypeDetailsId'] !== undefined
            ? _data['rsuPlanTypeDetailsId']
            : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateRsuPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateRsuPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['rsuPlanTypeDetailsId'] =
        this.rsuPlanTypeDetailsId !== undefined
          ? this.rsuPlanTypeDetailsId
          : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IUpdateRsuPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    rsuPlanTypeDetailsId: string;
    planName: string;
    planCode: string;
    earningsPeriod: RestrictedStockUnitEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class DeleteRsuPlanTypeDetailsCommandResult
    implements IDeleteRsuPlanTypeDetailsCommandResult
  {
    constructor(data?: IDeleteRsuPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteRsuPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRsuPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteRsuPlanTypeDetailsCommandResult {}

  export class DeleteRsuPlanTypeDetailsCommandResultSuccess
    extends DeleteRsuPlanTypeDetailsCommandResult
    implements IDeleteRsuPlanTypeDetailsCommandResultSuccess
  {
    constructor(data?: IDeleteRsuPlanTypeDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteRsuPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRsuPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRsuPlanTypeDetailsCommandResultSuccess
    extends IDeleteRsuPlanTypeDetailsCommandResult {}

  export class DeleteRsuPlanTypeDetailsCommandResultFailure
    extends DeleteRsuPlanTypeDetailsCommandResult
    implements IDeleteRsuPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteRsuPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteRsuPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteRsuPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteRsuPlanTypeDetailsCommandResultFailure
    extends IDeleteRsuPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddStockOptionPlanTypeDetailsCommandResult
    implements IAddStockOptionPlanTypeDetailsCommandResult
  {
    constructor(data?: IAddStockOptionPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddStockOptionPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new AddStockOptionPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddStockOptionPlanTypeDetailsCommandResult {}

  export class AddStockOptionPlanTypeDetailsCommandResultSuccess
    extends AddStockOptionPlanTypeDetailsCommandResult
    implements IAddStockOptionPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IAddStockOptionPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): AddStockOptionPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddStockOptionPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddStockOptionPlanTypeDetailsCommandResultSuccess
    extends IAddStockOptionPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class AddStockOptionPlanTypeDetailsCommandResultFailure
    extends AddStockOptionPlanTypeDetailsCommandResult
    implements IAddStockOptionPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IAddStockOptionPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): AddStockOptionPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddStockOptionPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddStockOptionPlanTypeDetailsCommandResultFailure
    extends IAddStockOptionPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddStockOptionPlanTypeDetailsCommand
    implements IAddStockOptionPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: StockOptionEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IAddStockOptionPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): AddStockOptionPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddStockOptionPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IAddStockOptionPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    planName: string;
    planCode: string;
    earningsPeriod: StockOptionEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class UpdateStockOptionPlanTypeDetailsCommandResult
    implements IUpdateStockOptionPlanTypeDetailsCommandResult
  {
    constructor(data?: IUpdateStockOptionPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateStockOptionPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateStockOptionPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateStockOptionPlanTypeDetailsCommandResult {}

  export class UpdateStockOptionPlanTypeDetailsCommandResultSuccess
    extends UpdateStockOptionPlanTypeDetailsCommandResult
    implements IUpdateStockOptionPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IUpdateStockOptionPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpdateStockOptionPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateStockOptionPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateStockOptionPlanTypeDetailsCommandResultSuccess
    extends IUpdateStockOptionPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class UpdateStockOptionPlanTypeDetailsCommandResultFailure
    extends UpdateStockOptionPlanTypeDetailsCommandResult
    implements IUpdateStockOptionPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateStockOptionPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpdateStockOptionPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateStockOptionPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateStockOptionPlanTypeDetailsCommandResultFailure
    extends IUpdateStockOptionPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class UpdateStockOptionPlanTypeDetailsCommand
    implements IUpdateStockOptionPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    stockOptionPlanTypeDetailsId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: StockOptionEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IUpdateStockOptionPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.stockOptionPlanTypeDetailsId =
          _data['stockOptionPlanTypeDetailsId'] !== undefined
            ? _data['stockOptionPlanTypeDetailsId']
            : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateStockOptionPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateStockOptionPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['stockOptionPlanTypeDetailsId'] =
        this.stockOptionPlanTypeDetailsId !== undefined
          ? this.stockOptionPlanTypeDetailsId
          : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IUpdateStockOptionPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    stockOptionPlanTypeDetailsId: string;
    planName: string;
    planCode: string;
    earningsPeriod: StockOptionEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class DeleteStockOptionPlanTypeDetailsCommandResult
    implements IDeleteStockOptionPlanTypeDetailsCommandResult
  {
    constructor(data?: IDeleteStockOptionPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteStockOptionPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStockOptionPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteStockOptionPlanTypeDetailsCommandResult {}

  export class DeleteStockOptionPlanTypeDetailsCommandResultSuccess
    extends DeleteStockOptionPlanTypeDetailsCommandResult
    implements IDeleteStockOptionPlanTypeDetailsCommandResultSuccess
  {
    constructor(data?: IDeleteStockOptionPlanTypeDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteStockOptionPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStockOptionPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteStockOptionPlanTypeDetailsCommandResultSuccess
    extends IDeleteStockOptionPlanTypeDetailsCommandResult {}

  export class DeleteStockOptionPlanTypeDetailsCommandResultFailure
    extends DeleteStockOptionPlanTypeDetailsCommandResult
    implements IDeleteStockOptionPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteStockOptionPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteStockOptionPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStockOptionPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteStockOptionPlanTypeDetailsCommandResultFailure
    extends IDeleteStockOptionPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddCashBonusPlanTypeDetailsCommandResult
    implements IAddCashBonusPlanTypeDetailsCommandResult
  {
    constructor(data?: IAddCashBonusPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddCashBonusPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new AddCashBonusPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddCashBonusPlanTypeDetailsCommandResult {}

  export class AddCashBonusPlanTypeDetailsCommandResultSuccess
    extends AddCashBonusPlanTypeDetailsCommandResult
    implements IAddCashBonusPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IAddCashBonusPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): AddCashBonusPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddCashBonusPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddCashBonusPlanTypeDetailsCommandResultSuccess
    extends IAddCashBonusPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class AddCashBonusPlanTypeDetailsCommandResultFailure
    extends AddCashBonusPlanTypeDetailsCommandResult
    implements IAddCashBonusPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IAddCashBonusPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): AddCashBonusPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddCashBonusPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddCashBonusPlanTypeDetailsCommandResultFailure
    extends IAddCashBonusPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddCashBonusPlanTypeDetailsCommand
    implements IAddCashBonusPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: CashBonusEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IAddCashBonusPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): AddCashBonusPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddCashBonusPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IAddCashBonusPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    planName: string;
    planCode: string;
    earningsPeriod: CashBonusEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class UpdateCashBonusPlanTypeDetailsCommandResult
    implements IUpdateCashBonusPlanTypeDetailsCommandResult
  {
    constructor(data?: IUpdateCashBonusPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateCashBonusPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCashBonusPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateCashBonusPlanTypeDetailsCommandResult {}

  export class UpdateCashBonusPlanTypeDetailsCommandResultSuccess
    extends UpdateCashBonusPlanTypeDetailsCommandResult
    implements IUpdateCashBonusPlanTypeDetailsCommandResultSuccess
  {
    result!: PlanSetupDetailsDto;

    constructor(data?: IUpdateCashBonusPlanTypeDetailsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PlanSetupDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PlanSetupDetailsDto.fromJS(_data['result'])
          : new PlanSetupDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpdateCashBonusPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCashBonusPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateCashBonusPlanTypeDetailsCommandResultSuccess
    extends IUpdateCashBonusPlanTypeDetailsCommandResult {
    result: PlanSetupDetailsDto;
  }

  export class UpdateCashBonusPlanTypeDetailsCommandResultFailure
    extends UpdateCashBonusPlanTypeDetailsCommandResult
    implements IUpdateCashBonusPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateCashBonusPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpdateCashBonusPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCashBonusPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateCashBonusPlanTypeDetailsCommandResultFailure
    extends IUpdateCashBonusPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export class UpdateCashBonusPlanTypeDetailsCommand
    implements IUpdateCashBonusPlanTypeDetailsCommand
  {
    planSetupDetailsId!: string | null;
    clientId!: string;
    cashBonusPlanTypeDetailsId!: string;
    planName!: string;
    planCode!: string;
    earningsPeriod!: CashBonusEarningsPeriod;
    taxQualifiedPlan!: boolean;
    taxQualifiedCountry!: string;
    taxQualifiedPlanName!: string;

    constructor(data?: IUpdateCashBonusPlanTypeDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planSetupDetailsId =
          _data['planSetupDetailsId'] !== undefined
            ? _data['planSetupDetailsId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.cashBonusPlanTypeDetailsId =
          _data['cashBonusPlanTypeDetailsId'] !== undefined
            ? _data['cashBonusPlanTypeDetailsId']
            : <any>null;
        this.planName =
          _data['planName'] !== undefined ? _data['planName'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.earningsPeriod =
          _data['earningsPeriod'] !== undefined
            ? _data['earningsPeriod']
            : <any>null;
        this.taxQualifiedPlan =
          _data['taxQualifiedPlan'] !== undefined
            ? _data['taxQualifiedPlan']
            : <any>null;
        this.taxQualifiedCountry =
          _data['taxQualifiedCountry'] !== undefined
            ? _data['taxQualifiedCountry']
            : <any>null;
        this.taxQualifiedPlanName =
          _data['taxQualifiedPlanName'] !== undefined
            ? _data['taxQualifiedPlanName']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateCashBonusPlanTypeDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCashBonusPlanTypeDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planSetupDetailsId'] =
        this.planSetupDetailsId !== undefined
          ? this.planSetupDetailsId
          : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['cashBonusPlanTypeDetailsId'] =
        this.cashBonusPlanTypeDetailsId !== undefined
          ? this.cashBonusPlanTypeDetailsId
          : <any>null;
      data['planName'] =
        this.planName !== undefined ? this.planName : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['earningsPeriod'] =
        this.earningsPeriod !== undefined ? this.earningsPeriod : <any>null;
      data['taxQualifiedPlan'] =
        this.taxQualifiedPlan !== undefined ? this.taxQualifiedPlan : <any>null;
      data['taxQualifiedCountry'] =
        this.taxQualifiedCountry !== undefined
          ? this.taxQualifiedCountry
          : <any>null;
      data['taxQualifiedPlanName'] =
        this.taxQualifiedPlanName !== undefined
          ? this.taxQualifiedPlanName
          : <any>null;
      return data;
    }
  }

  export interface IUpdateCashBonusPlanTypeDetailsCommand {
    planSetupDetailsId: string | null;
    clientId: string;
    cashBonusPlanTypeDetailsId: string;
    planName: string;
    planCode: string;
    earningsPeriod: CashBonusEarningsPeriod;
    taxQualifiedPlan: boolean;
    taxQualifiedCountry: string;
    taxQualifiedPlanName: string;
  }

  export class DeleteCashBonusPlanTypeDetailsCommandResult
    implements IDeleteCashBonusPlanTypeDetailsCommandResult
  {
    constructor(data?: IDeleteCashBonusPlanTypeDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteCashBonusPlanTypeDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashBonusPlanTypeDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteCashBonusPlanTypeDetailsCommandResult {}

  export class DeleteCashBonusPlanTypeDetailsCommandResultSuccess
    extends DeleteCashBonusPlanTypeDetailsCommandResult
    implements IDeleteCashBonusPlanTypeDetailsCommandResultSuccess
  {
    constructor(data?: IDeleteCashBonusPlanTypeDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteCashBonusPlanTypeDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashBonusPlanTypeDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashBonusPlanTypeDetailsCommandResultSuccess
    extends IDeleteCashBonusPlanTypeDetailsCommandResult {}

  export class DeleteCashBonusPlanTypeDetailsCommandResultFailure
    extends DeleteCashBonusPlanTypeDetailsCommandResult
    implements IDeleteCashBonusPlanTypeDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteCashBonusPlanTypeDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteCashBonusPlanTypeDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashBonusPlanTypeDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashBonusPlanTypeDetailsCommandResultFailure
    extends IDeleteCashBonusPlanTypeDetailsCommandResult {
    errors: ResultError[];
  }

  export abstract class DownloadExportOverridesFileCommandResult
    implements IDownloadExportOverridesFileCommandResult
  {
    constructor(data?: IDownloadExportOverridesFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadExportOverridesFileCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadExportOverridesFileCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadExportOverridesFileCommandResult {}

  export class DownloadExportOverridesFileCommandResultSuccess
    extends DownloadExportOverridesFileCommandResult
    implements IDownloadExportOverridesFileCommandResultSuccess
  {
    encodedFile!: string;

    constructor(data?: IDownloadExportOverridesFileCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.encodedFile =
          _data['encodedFile'] !== undefined ? _data['encodedFile'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadExportOverridesFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadExportOverridesFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['encodedFile'] =
        this.encodedFile !== undefined ? this.encodedFile : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadExportOverridesFileCommandResultSuccess
    extends IDownloadExportOverridesFileCommandResult {
    encodedFile: string;
  }

  export class DownloadExportOverridesFileCommandResultFailure
    extends DownloadExportOverridesFileCommandResult
    implements IDownloadExportOverridesFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadExportOverridesFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadExportOverridesFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadExportOverridesFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadExportOverridesFileCommandResultFailure
    extends IDownloadExportOverridesFileCommandResult {
    errorMessage: string;
  }

  export class DownloadExportOverridesFileCommand
    implements IDownloadExportOverridesFileCommand
  {
    clientId!: string;

    constructor(data?: IDownloadExportOverridesFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): DownloadExportOverridesFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadExportOverridesFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface IDownloadExportOverridesFileCommand {
    clientId: string;
  }

  export class GetOverridesDashboardIndexQueryResult
    implements IGetOverridesDashboardIndexQueryResult
  {
    constructor(data?: IGetOverridesDashboardIndexQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetOverridesDashboardIndexQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridesDashboardIndexQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetOverridesDashboardIndexQueryResult {}

  export class GetOverridesDashboardIndexQueryResultSuccess
    extends GetOverridesDashboardIndexQueryResult
    implements IGetOverridesDashboardIndexQueryResultSuccess
  {
    result!: PageModelOfOverridesDashboardIndexModel;
    allOverridesIds!: string[];

    constructor(data?: IGetOverridesDashboardIndexQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PageModelOfOverridesDashboardIndexModel();
        this.allOverridesIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PageModelOfOverridesDashboardIndexModel.fromJS(_data['result'])
          : new PageModelOfOverridesDashboardIndexModel();
        if (Array.isArray(_data['allOverridesIds'])) {
          this.allOverridesIds = [] as any;
          for (let item of _data['allOverridesIds'])
            this.allOverridesIds!.push(item);
        } else {
          this.allOverridesIds = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetOverridesDashboardIndexQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridesDashboardIndexQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      if (Array.isArray(this.allOverridesIds)) {
        data['allOverridesIds'] = [];
        for (let item of this.allOverridesIds)
          data['allOverridesIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridesDashboardIndexQueryResultSuccess
    extends IGetOverridesDashboardIndexQueryResult {
    result: PageModelOfOverridesDashboardIndexModel;
    allOverridesIds: string[];
  }

  export class PageModelOfOverridesDashboardIndexModel
    extends PageModel
    implements IPageModelOfOverridesDashboardIndexModel
  {
    items!: OverridesDashboardIndexModel[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfOverridesDashboardIndexModel) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(OverridesDashboardIndexModel.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfOverridesDashboardIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfOverridesDashboardIndexModel();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfOverridesDashboardIndexModel extends IPageModel {
    items: OverridesDashboardIndexModel[];
    totalItems: number | null;
  }

  export class OverridesDashboardIndexModel
    implements IOverridesDashboardIndexModel
  {
    clientId!: string;
    overrideId!: string;
    override!: OverrideType;
    overrideSubType!: OverrideSubType;
    employeeId!: string | null;
    transactionId!: string | null;
    planType!: PlanType[];
    dateUpdated!: Date | null;
    updatedBy!: string | null;

    constructor(data?: IOverridesDashboardIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planType = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.overrideId =
          _data['overrideId'] !== undefined ? _data['overrideId'] : <any>null;
        this.override =
          _data['override'] !== undefined ? _data['override'] : <any>null;
        this.overrideSubType =
          _data['overrideSubType'] !== undefined
            ? _data['overrideSubType']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['planType'])) {
          this.planType = [] as any;
          for (let item of _data['planType']) this.planType!.push(item);
        } else {
          this.planType = <any>null;
        }
        this.dateUpdated = _data['dateUpdated']
          ? new Date(_data['dateUpdated'].toString())
          : <any>null;
        this.updatedBy =
          _data['updatedBy'] !== undefined ? _data['updatedBy'] : <any>null;
      }
    }

    static fromJS(data: any): OverridesDashboardIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new OverridesDashboardIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['overrideId'] =
        this.overrideId !== undefined ? this.overrideId : <any>null;
      data['override'] =
        this.override !== undefined ? this.override : <any>null;
      data['overrideSubType'] =
        this.overrideSubType !== undefined ? this.overrideSubType : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.planType)) {
        data['planType'] = [];
        for (let item of this.planType) data['planType'].push(item);
      }
      data['dateUpdated'] = this.dateUpdated
        ? this.dateUpdated.toISOString()
        : <any>null;
      data['updatedBy'] =
        this.updatedBy !== undefined ? this.updatedBy : <any>null;
      return data;
    }
  }

  export interface IOverridesDashboardIndexModel {
    clientId: string;
    overrideId: string;
    override: OverrideType;
    overrideSubType: OverrideSubType;
    employeeId: string | null;
    transactionId: string | null;
    planType: PlanType[];
    dateUpdated: Date | null;
    updatedBy: string | null;
  }

  export enum OverrideType {
    TaxPolicy = 'TaxPolicy',
    TaxRate = 'TaxRate',
    TaxPosition = 'TaxPosition',
    CountryAmount = 'CountryAmount',
    TaxEqualization = 'TaxEqualization',
  }

  export class GetOverridesDashboardIndexQueryResultFailure
    extends GetOverridesDashboardIndexQueryResult
    implements IGetOverridesDashboardIndexQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetOverridesDashboardIndexQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetOverridesDashboardIndexQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridesDashboardIndexQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridesDashboardIndexQueryResultFailure
    extends IGetOverridesDashboardIndexQueryResult {
    errors: ResultError[];
  }

  export class GetPortalAppsDataQueryResult
    implements IGetPortalAppsDataQueryResult
  {
    constructor(data?: IGetPortalAppsDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPortalAppsDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetPortalAppsDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPortalAppsDataQueryResult {}

  export class GetPortalAppsDataQueryResultSuccess
    extends GetPortalAppsDataQueryResult
    implements IGetPortalAppsDataQueryResultSuccess
  {
    portalAppsData!: PortalAppsDto | null;

    constructor(data?: IGetPortalAppsDataQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.portalAppsData = _data['portalAppsData']
          ? PortalAppsDto.fromJS(_data['portalAppsData'])
          : <any>null;
      }
    }

    static override fromJS(data: any): GetPortalAppsDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPortalAppsDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['portalAppsData'] = this.portalAppsData
        ? this.portalAppsData.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPortalAppsDataQueryResultSuccess
    extends IGetPortalAppsDataQueryResult {
    portalAppsData: PortalAppsDto | null;
  }

  export class PortalAppsDto implements IPortalAppsDto {
    tiles!: PortalAppTilesDto[];

    constructor(data?: IPortalAppsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.tiles = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['tiles'])) {
          this.tiles = [] as any;
          for (let item of _data['tiles'])
            this.tiles!.push(PortalAppTilesDto.fromJS(item));
        } else {
          this.tiles = <any>null;
        }
      }
    }

    static fromJS(data: any): PortalAppsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PortalAppsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.tiles)) {
        data['tiles'] = [];
        for (let item of this.tiles) data['tiles'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPortalAppsDto {
    tiles: PortalAppTilesDto[];
  }

  export class PortalAppTilesDto implements IPortalAppTilesDto {
    navUrl!: string | null;
    productId!: number | null;
    portletInfo!: string | null;
    tileId!: string | null;
    tileName!: string | null;
    tileSort!: string | null;
    tileType!: string | null;
    tiles!: PortalAppTilesDto[] | null;
    toolGroupId!: number | null;
    url!: string | null;

    constructor(data?: IPortalAppTilesDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.navUrl =
          _data['navUrl'] !== undefined ? _data['navUrl'] : <any>null;
        this.productId =
          _data['productId'] !== undefined ? _data['productId'] : <any>null;
        this.portletInfo =
          _data['portletInfo'] !== undefined ? _data['portletInfo'] : <any>null;
        this.tileId =
          _data['tileId'] !== undefined ? _data['tileId'] : <any>null;
        this.tileName =
          _data['tileName'] !== undefined ? _data['tileName'] : <any>null;
        this.tileSort =
          _data['tileSort'] !== undefined ? _data['tileSort'] : <any>null;
        this.tileType =
          _data['tileType'] !== undefined ? _data['tileType'] : <any>null;
        if (Array.isArray(_data['tiles'])) {
          this.tiles = [] as any;
          for (let item of _data['tiles'])
            this.tiles!.push(PortalAppTilesDto.fromJS(item));
        } else {
          this.tiles = <any>null;
        }
        this.toolGroupId =
          _data['toolGroupId'] !== undefined ? _data['toolGroupId'] : <any>null;
        this.url = _data['url'] !== undefined ? _data['url'] : <any>null;
      }
    }

    static fromJS(data: any): PortalAppTilesDto {
      data = typeof data === 'object' ? data : {};
      let result = new PortalAppTilesDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['navUrl'] = this.navUrl !== undefined ? this.navUrl : <any>null;
      data['productId'] =
        this.productId !== undefined ? this.productId : <any>null;
      data['portletInfo'] =
        this.portletInfo !== undefined ? this.portletInfo : <any>null;
      data['tileId'] = this.tileId !== undefined ? this.tileId : <any>null;
      data['tileName'] =
        this.tileName !== undefined ? this.tileName : <any>null;
      data['tileSort'] =
        this.tileSort !== undefined ? this.tileSort : <any>null;
      data['tileType'] =
        this.tileType !== undefined ? this.tileType : <any>null;
      if (Array.isArray(this.tiles)) {
        data['tiles'] = [];
        for (let item of this.tiles) data['tiles'].push(item.toJSON());
      }
      data['toolGroupId'] =
        this.toolGroupId !== undefined ? this.toolGroupId : <any>null;
      data['url'] = this.url !== undefined ? this.url : <any>null;
      return data;
    }
  }

  export interface IPortalAppTilesDto {
    navUrl: string | null;
    productId: number | null;
    portletInfo: string | null;
    tileId: string | null;
    tileName: string | null;
    tileSort: string | null;
    tileType: string | null;
    tiles: PortalAppTilesDto[] | null;
    toolGroupId: number | null;
    url: string | null;
  }

  export class GetPortalAppsDataQueryResultFailure
    extends GetPortalAppsDataQueryResult
    implements IGetPortalAppsDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetPortalAppsDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetPortalAppsDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPortalAppsDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPortalAppsDataQueryResultFailure
    extends IGetPortalAppsDataQueryResult {
    errors: ResultError[];
  }

  export class GetPortalAppsDataQuery implements IGetPortalAppsDataQuery {
    constructor(data?: IGetPortalAppsDataQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPortalAppsDataQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetPortalAppsDataQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPortalAppsDataQuery {}

  export class PortalTileOrToolClickedQueryResult
    implements IPortalTileOrToolClickedQueryResult
  {
    constructor(data?: IPortalTileOrToolClickedQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PortalTileOrToolClickedQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new PortalTileOrToolClickedQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPortalTileOrToolClickedQueryResult {}

  export class PortalTileOrToolClickedQueryResultSuccess
    extends PortalTileOrToolClickedQueryResult
    implements IPortalTileOrToolClickedQueryResultSuccess
  {
    result!: string;

    constructor(data?: IPortalTileOrToolClickedQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): PortalTileOrToolClickedQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PortalTileOrToolClickedQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPortalTileOrToolClickedQueryResultSuccess
    extends IPortalTileOrToolClickedQueryResult {
    result: string;
  }

  export class PortalTileOrToolClickedQueryResultFailure
    extends PortalTileOrToolClickedQueryResult
    implements IPortalTileOrToolClickedQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IPortalTileOrToolClickedQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): PortalTileOrToolClickedQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PortalTileOrToolClickedQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IPortalTileOrToolClickedQueryResultFailure
    extends IPortalTileOrToolClickedQueryResult {
    errors: ResultError[];
  }

  export class PortalTileOrToolClickedQuery
    implements IPortalTileOrToolClickedQuery
  {
    id!: string;
    isTool!: boolean;

    constructor(data?: IPortalTileOrToolClickedQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.isTool =
          _data['isTool'] !== undefined ? _data['isTool'] : <any>null;
      }
    }

    static fromJS(data: any): PortalTileOrToolClickedQuery {
      data = typeof data === 'object' ? data : {};
      let result = new PortalTileOrToolClickedQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['isTool'] = this.isTool !== undefined ? this.isTool : <any>null;
      return data;
    }
  }

  export interface IPortalTileOrToolClickedQuery {
    id: string;
    isTool: boolean;
  }

  export class PostSAMLDataQueryResult implements IPostSAMLDataQueryResult {
    constructor(data?: IPostSAMLDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PostSAMLDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPostSAMLDataQueryResult {}

  export class PostSAMLDataQueryResultSuccess
    extends PostSAMLDataQueryResult
    implements IPostSAMLDataQueryResultSuccess
  {
    token!: string;

    constructor(data?: IPostSAMLDataQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.token = _data['token'] !== undefined ? _data['token'] : <any>null;
      }
    }

    static override fromJS(data: any): PostSAMLDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['token'] = this.token !== undefined ? this.token : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPostSAMLDataQueryResultSuccess
    extends IPostSAMLDataQueryResult {
    token: string;
  }

  export class PostSAMLDataQueryResultFailure
    extends PostSAMLDataQueryResult
    implements IPostSAMLDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IPostSAMLDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): PostSAMLDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IPostSAMLDataQueryResultFailure
    extends IPostSAMLDataQueryResult {
    errors: ResultError[];
  }

  export class PostSAMLDataQuery implements IPostSAMLDataQuery {
    redirectUrl!: string;
    toolId!: string;

    constructor(data?: IPostSAMLDataQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.redirectUrl =
          _data['redirectUrl'] !== undefined ? _data['redirectUrl'] : <any>null;
        this.toolId =
          _data['toolId'] !== undefined ? _data['toolId'] : <any>null;
      }
    }

    static fromJS(data: any): PostSAMLDataQuery {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['redirectUrl'] =
        this.redirectUrl !== undefined ? this.redirectUrl : <any>null;
      data['toolId'] = this.toolId !== undefined ? this.toolId : <any>null;
      return data;
    }
  }

  export interface IPostSAMLDataQuery {
    redirectUrl: string;
    toolId: string;
  }

  export class PostSAMLDataByProdIdQueryResult
    implements IPostSAMLDataByProdIdQueryResult
  {
    constructor(data?: IPostSAMLDataByProdIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PostSAMLDataByProdIdQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataByProdIdQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPostSAMLDataByProdIdQueryResult {}

  export class PostSAMLDataByProdIdQueryResultSuccess
    extends PostSAMLDataByProdIdQueryResult
    implements IPostSAMLDataByProdIdQueryResultSuccess
  {
    samlData!: SAMLDataDto;

    constructor(data?: IPostSAMLDataByProdIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.samlData = new SAMLDataDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.samlData = _data['samlData']
          ? SAMLDataDto.fromJS(_data['samlData'])
          : new SAMLDataDto();
      }
    }

    static override fromJS(data: any): PostSAMLDataByProdIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataByProdIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['samlData'] = this.samlData ? this.samlData.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPostSAMLDataByProdIdQueryResultSuccess
    extends IPostSAMLDataByProdIdQueryResult {
    samlData: SAMLDataDto;
  }

  export class SAMLDataDto implements ISAMLDataDto {
    saml!: string;
    redirectUrl!: string;

    constructor(data?: ISAMLDataDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.saml = _data['saml'] !== undefined ? _data['saml'] : <any>null;
        this.redirectUrl =
          _data['redirectUrl'] !== undefined ? _data['redirectUrl'] : <any>null;
      }
    }

    static fromJS(data: any): SAMLDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new SAMLDataDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['saml'] = this.saml !== undefined ? this.saml : <any>null;
      data['redirectUrl'] =
        this.redirectUrl !== undefined ? this.redirectUrl : <any>null;
      return data;
    }
  }

  export interface ISAMLDataDto {
    saml: string;
    redirectUrl: string;
  }

  export class PostSAMLDataByProdIdQueryResultFailure
    extends PostSAMLDataByProdIdQueryResult
    implements IPostSAMLDataByProdIdQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IPostSAMLDataByProdIdQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): PostSAMLDataByProdIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataByProdIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IPostSAMLDataByProdIdQueryResultFailure
    extends IPostSAMLDataByProdIdQueryResult {
    errors: ResultError[];
  }

  export class PostSAMLDataByProdIdQuery implements IPostSAMLDataByProdIdQuery {
    prodId!: string;

    constructor(data?: IPostSAMLDataByProdIdQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.prodId =
          _data['prodId'] !== undefined ? _data['prodId'] : <any>null;
      }
    }

    static fromJS(data: any): PostSAMLDataByProdIdQuery {
      data = typeof data === 'object' ? data : {};
      let result = new PostSAMLDataByProdIdQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['prodId'] = this.prodId !== undefined ? this.prodId : <any>null;
      return data;
    }
  }

  export interface IPostSAMLDataByProdIdQuery {
    prodId: string;
  }

  export abstract class GlobalSearchCommandResult
    implements IGlobalSearchCommandResult
  {
    constructor(data?: IGlobalSearchCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GlobalSearchCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GlobalSearchCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGlobalSearchCommandResult {}

  export class GlobalSearchCommandResultSuccess
    extends GlobalSearchCommandResult
    implements IGlobalSearchCommandResultSuccess
  {
    results!: CombinedSearchResults;

    constructor(data?: IGlobalSearchCommandResultSuccess) {
      super(data);
      if (!data) {
        this.results = new CombinedSearchResults();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.results = _data['results']
          ? CombinedSearchResults.fromJS(_data['results'])
          : new CombinedSearchResults();
      }
    }

    static override fromJS(data: any): GlobalSearchCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GlobalSearchCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['results'] = this.results ? this.results.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGlobalSearchCommandResultSuccess
    extends IGlobalSearchCommandResult {
    results: CombinedSearchResults;
  }

  export class CombinedSearchResults implements ICombinedSearchResults {
    batchSearchResults!: PageModelOfBatchIndexModel | null;
    calculationSearchResults!: PageModelOfCalculationIndexModel | null;
    transactionSearchResults!: PageModelOfTransactionIndexModel | null;

    constructor(data?: ICombinedSearchResults) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchSearchResults = _data['batchSearchResults']
          ? PageModelOfBatchIndexModel.fromJS(_data['batchSearchResults'])
          : <any>null;
        this.calculationSearchResults = _data['calculationSearchResults']
          ? PageModelOfCalculationIndexModel.fromJS(
              _data['calculationSearchResults'],
            )
          : <any>null;
        this.transactionSearchResults = _data['transactionSearchResults']
          ? PageModelOfTransactionIndexModel.fromJS(
              _data['transactionSearchResults'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CombinedSearchResults {
      data = typeof data === 'object' ? data : {};
      let result = new CombinedSearchResults();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchSearchResults'] = this.batchSearchResults
        ? this.batchSearchResults.toJSON()
        : <any>null;
      data['calculationSearchResults'] = this.calculationSearchResults
        ? this.calculationSearchResults.toJSON()
        : <any>null;
      data['transactionSearchResults'] = this.transactionSearchResults
        ? this.transactionSearchResults.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICombinedSearchResults {
    batchSearchResults: PageModelOfBatchIndexModel | null;
    calculationSearchResults: PageModelOfCalculationIndexModel | null;
    transactionSearchResults: PageModelOfTransactionIndexModel | null;
  }

  export class PageModelOfBatchIndexModel
    extends PageModel
    implements IPageModelOfBatchIndexModel
  {
    items!: BatchIndexModel[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfBatchIndexModel) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(BatchIndexModel.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfBatchIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfBatchIndexModel();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfBatchIndexModel extends IPageModel {
    items: BatchIndexModel[];
    totalItems: number | null;
  }

  export class BatchIndexModel implements IBatchIndexModel {
    id!: string;
    calculationType!: BatchCalculationType;
    calculationDate!: Date | null;
    clientId!: string;
    status!: BatchStatus;
    brokerAdjustmentJobs!: BatchBrokerAdjustmentJobIndexModel[];
    latestBatchDeleteRequest!: BatchDeleteRequestIndexModel | null;
    pendingDeletion!: boolean;
    creationSource!: BatchCreationSource;
    executionMode!: BatchExecutionMode | null;
    calculationCount!: number;
    transactionCount!: number;
    deletedCalculationCount!: number | null;
    deletedTransactionCount!: number | null;
    succeeded!: boolean | null;
    failed!: boolean;
    finished!: boolean;
    activelyRunning!: boolean;
    brokerAdjustmentRunning!: boolean;
    statusDescription!: string | null;
    dateCreated!: Date;
    inputProcessingStartedTimestamp!: Date | null;
    inputProcessingCompletedTimestamp!: Date | null;
    inputProcessingFailedTimestamp!: Date | null;
    timeInputProcessingInMs!: number | null;
    timeInputProcessingWithFailureInMs!: number | null;
    configurationSnapshotStartedTimestamp!: Date | null;
    configurationSnapshotCompletedTimestamp!: Date | null;
    configurationSnapshotFailedTimestamp!: Date | null;
    timeSnapshottingConfigurationInMs!: number | null;
    timeSnapshottingConfigurationWithFailureInMs!: number | null;
    timeSnapshottingConfigurationWithSuccessOrFailureInMs!: number | null;
    calculationsStartedTimestamp!: Date | null;
    calculationsCompletedTimestamp!: Date | null;
    postProcessingTimestamp!: Date | null;
    calculationsFailedTimestamp!: Date | null;
    timeCalculatingInMs!: number | null;
    timeCalculatingWithFailureInMs!: number | null;
    timeCalculatingWithSuccessOrFailureInMs!: number | null;
    completedTimestamp!: Date | null;
    failedTimestamp!: Date | null;
    totalTimeExecutingInMs!: number | null;
    totalTimeExecutingWithFailureInMs!: number | null;
    totalTimeExecutingWithSuccessOrFailureInMs!: number | null;
    timeInputProcessingWithSuccessOrFailureInMs!: number | null;
    pendingReportingDataEntry!: boolean;
    legacyAvailableInReporting!: boolean | null;

    constructor(data?: IBatchIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.brokerAdjustmentJobs = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.calculationType =
          _data['calculationType'] !== undefined
            ? _data['calculationType']
            : <any>null;
        this.calculationDate = _data['calculationDate']
          ? new Date(_data['calculationDate'].toString())
          : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        if (Array.isArray(_data['brokerAdjustmentJobs'])) {
          this.brokerAdjustmentJobs = [] as any;
          for (let item of _data['brokerAdjustmentJobs'])
            this.brokerAdjustmentJobs!.push(
              BatchBrokerAdjustmentJobIndexModel.fromJS(item),
            );
        } else {
          this.brokerAdjustmentJobs = <any>null;
        }
        this.latestBatchDeleteRequest = _data['latestBatchDeleteRequest']
          ? BatchDeleteRequestIndexModel.fromJS(
              _data['latestBatchDeleteRequest'],
            )
          : <any>null;
        this.pendingDeletion =
          _data['pendingDeletion'] !== undefined
            ? _data['pendingDeletion']
            : <any>null;
        this.creationSource =
          _data['creationSource'] !== undefined
            ? _data['creationSource']
            : <any>null;
        this.executionMode =
          _data['executionMode'] !== undefined
            ? _data['executionMode']
            : <any>null;
        this.calculationCount =
          _data['calculationCount'] !== undefined
            ? _data['calculationCount']
            : <any>null;
        this.transactionCount =
          _data['transactionCount'] !== undefined
            ? _data['transactionCount']
            : <any>null;
        this.deletedCalculationCount =
          _data['deletedCalculationCount'] !== undefined
            ? _data['deletedCalculationCount']
            : <any>null;
        this.deletedTransactionCount =
          _data['deletedTransactionCount'] !== undefined
            ? _data['deletedTransactionCount']
            : <any>null;
        this.succeeded =
          _data['succeeded'] !== undefined ? _data['succeeded'] : <any>null;
        this.failed =
          _data['failed'] !== undefined ? _data['failed'] : <any>null;
        this.finished =
          _data['finished'] !== undefined ? _data['finished'] : <any>null;
        this.activelyRunning =
          _data['activelyRunning'] !== undefined
            ? _data['activelyRunning']
            : <any>null;
        this.brokerAdjustmentRunning =
          _data['brokerAdjustmentRunning'] !== undefined
            ? _data['brokerAdjustmentRunning']
            : <any>null;
        this.statusDescription =
          _data['statusDescription'] !== undefined
            ? _data['statusDescription']
            : <any>null;
        this.dateCreated = _data['dateCreated']
          ? new Date(_data['dateCreated'].toString())
          : <any>null;
        this.inputProcessingStartedTimestamp = _data[
          'inputProcessingStartedTimestamp'
        ]
          ? new Date(_data['inputProcessingStartedTimestamp'].toString())
          : <any>null;
        this.inputProcessingCompletedTimestamp = _data[
          'inputProcessingCompletedTimestamp'
        ]
          ? new Date(_data['inputProcessingCompletedTimestamp'].toString())
          : <any>null;
        this.inputProcessingFailedTimestamp = _data[
          'inputProcessingFailedTimestamp'
        ]
          ? new Date(_data['inputProcessingFailedTimestamp'].toString())
          : <any>null;
        this.timeInputProcessingInMs =
          _data['timeInputProcessingInMs'] !== undefined
            ? _data['timeInputProcessingInMs']
            : <any>null;
        this.timeInputProcessingWithFailureInMs =
          _data['timeInputProcessingWithFailureInMs'] !== undefined
            ? _data['timeInputProcessingWithFailureInMs']
            : <any>null;
        this.configurationSnapshotStartedTimestamp = _data[
          'configurationSnapshotStartedTimestamp'
        ]
          ? new Date(_data['configurationSnapshotStartedTimestamp'].toString())
          : <any>null;
        this.configurationSnapshotCompletedTimestamp = _data[
          'configurationSnapshotCompletedTimestamp'
        ]
          ? new Date(
              _data['configurationSnapshotCompletedTimestamp'].toString(),
            )
          : <any>null;
        this.configurationSnapshotFailedTimestamp = _data[
          'configurationSnapshotFailedTimestamp'
        ]
          ? new Date(_data['configurationSnapshotFailedTimestamp'].toString())
          : <any>null;
        this.timeSnapshottingConfigurationInMs =
          _data['timeSnapshottingConfigurationInMs'] !== undefined
            ? _data['timeSnapshottingConfigurationInMs']
            : <any>null;
        this.timeSnapshottingConfigurationWithFailureInMs =
          _data['timeSnapshottingConfigurationWithFailureInMs'] !== undefined
            ? _data['timeSnapshottingConfigurationWithFailureInMs']
            : <any>null;
        this.timeSnapshottingConfigurationWithSuccessOrFailureInMs =
          _data['timeSnapshottingConfigurationWithSuccessOrFailureInMs'] !==
          undefined
            ? _data['timeSnapshottingConfigurationWithSuccessOrFailureInMs']
            : <any>null;
        this.calculationsStartedTimestamp = _data[
          'calculationsStartedTimestamp'
        ]
          ? new Date(_data['calculationsStartedTimestamp'].toString())
          : <any>null;
        this.calculationsCompletedTimestamp = _data[
          'calculationsCompletedTimestamp'
        ]
          ? new Date(_data['calculationsCompletedTimestamp'].toString())
          : <any>null;
        this.postProcessingTimestamp = _data['postProcessingTimestamp']
          ? new Date(_data['postProcessingTimestamp'].toString())
          : <any>null;
        this.calculationsFailedTimestamp = _data['calculationsFailedTimestamp']
          ? new Date(_data['calculationsFailedTimestamp'].toString())
          : <any>null;
        this.timeCalculatingInMs =
          _data['timeCalculatingInMs'] !== undefined
            ? _data['timeCalculatingInMs']
            : <any>null;
        this.timeCalculatingWithFailureInMs =
          _data['timeCalculatingWithFailureInMs'] !== undefined
            ? _data['timeCalculatingWithFailureInMs']
            : <any>null;
        this.timeCalculatingWithSuccessOrFailureInMs =
          _data['timeCalculatingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timeCalculatingWithSuccessOrFailureInMs']
            : <any>null;
        this.completedTimestamp = _data['completedTimestamp']
          ? new Date(_data['completedTimestamp'].toString())
          : <any>null;
        this.failedTimestamp = _data['failedTimestamp']
          ? new Date(_data['failedTimestamp'].toString())
          : <any>null;
        this.totalTimeExecutingInMs =
          _data['totalTimeExecutingInMs'] !== undefined
            ? _data['totalTimeExecutingInMs']
            : <any>null;
        this.totalTimeExecutingWithFailureInMs =
          _data['totalTimeExecutingWithFailureInMs'] !== undefined
            ? _data['totalTimeExecutingWithFailureInMs']
            : <any>null;
        this.totalTimeExecutingWithSuccessOrFailureInMs =
          _data['totalTimeExecutingWithSuccessOrFailureInMs'] !== undefined
            ? _data['totalTimeExecutingWithSuccessOrFailureInMs']
            : <any>null;
        this.timeInputProcessingWithSuccessOrFailureInMs =
          _data['timeInputProcessingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timeInputProcessingWithSuccessOrFailureInMs']
            : <any>null;
        this.pendingReportingDataEntry =
          _data['pendingReportingDataEntry'] !== undefined
            ? _data['pendingReportingDataEntry']
            : <any>null;
        this.legacyAvailableInReporting =
          _data['legacyAvailableInReporting'] !== undefined
            ? _data['legacyAvailableInReporting']
            : <any>null;
      }
    }

    static fromJS(data: any): BatchIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new BatchIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['calculationType'] =
        this.calculationType !== undefined ? this.calculationType : <any>null;
      data['calculationDate'] = this.calculationDate
        ? this.calculationDate.toISOString()
        : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      if (Array.isArray(this.brokerAdjustmentJobs)) {
        data['brokerAdjustmentJobs'] = [];
        for (let item of this.brokerAdjustmentJobs)
          data['brokerAdjustmentJobs'].push(item.toJSON());
      }
      data['latestBatchDeleteRequest'] = this.latestBatchDeleteRequest
        ? this.latestBatchDeleteRequest.toJSON()
        : <any>null;
      data['pendingDeletion'] =
        this.pendingDeletion !== undefined ? this.pendingDeletion : <any>null;
      data['creationSource'] =
        this.creationSource !== undefined ? this.creationSource : <any>null;
      data['executionMode'] =
        this.executionMode !== undefined ? this.executionMode : <any>null;
      data['calculationCount'] =
        this.calculationCount !== undefined ? this.calculationCount : <any>null;
      data['transactionCount'] =
        this.transactionCount !== undefined ? this.transactionCount : <any>null;
      data['deletedCalculationCount'] =
        this.deletedCalculationCount !== undefined
          ? this.deletedCalculationCount
          : <any>null;
      data['deletedTransactionCount'] =
        this.deletedTransactionCount !== undefined
          ? this.deletedTransactionCount
          : <any>null;
      data['succeeded'] =
        this.succeeded !== undefined ? this.succeeded : <any>null;
      data['failed'] = this.failed !== undefined ? this.failed : <any>null;
      data['finished'] =
        this.finished !== undefined ? this.finished : <any>null;
      data['activelyRunning'] =
        this.activelyRunning !== undefined ? this.activelyRunning : <any>null;
      data['brokerAdjustmentRunning'] =
        this.brokerAdjustmentRunning !== undefined
          ? this.brokerAdjustmentRunning
          : <any>null;
      data['statusDescription'] =
        this.statusDescription !== undefined
          ? this.statusDescription
          : <any>null;
      data['dateCreated'] = this.dateCreated
        ? this.dateCreated.toISOString()
        : <any>null;
      data['inputProcessingStartedTimestamp'] = this
        .inputProcessingStartedTimestamp
        ? this.inputProcessingStartedTimestamp.toISOString()
        : <any>null;
      data['inputProcessingCompletedTimestamp'] = this
        .inputProcessingCompletedTimestamp
        ? this.inputProcessingCompletedTimestamp.toISOString()
        : <any>null;
      data['inputProcessingFailedTimestamp'] = this
        .inputProcessingFailedTimestamp
        ? this.inputProcessingFailedTimestamp.toISOString()
        : <any>null;
      data['timeInputProcessingInMs'] =
        this.timeInputProcessingInMs !== undefined
          ? this.timeInputProcessingInMs
          : <any>null;
      data['timeInputProcessingWithFailureInMs'] =
        this.timeInputProcessingWithFailureInMs !== undefined
          ? this.timeInputProcessingWithFailureInMs
          : <any>null;
      data['configurationSnapshotStartedTimestamp'] = this
        .configurationSnapshotStartedTimestamp
        ? this.configurationSnapshotStartedTimestamp.toISOString()
        : <any>null;
      data['configurationSnapshotCompletedTimestamp'] = this
        .configurationSnapshotCompletedTimestamp
        ? this.configurationSnapshotCompletedTimestamp.toISOString()
        : <any>null;
      data['configurationSnapshotFailedTimestamp'] = this
        .configurationSnapshotFailedTimestamp
        ? this.configurationSnapshotFailedTimestamp.toISOString()
        : <any>null;
      data['timeSnapshottingConfigurationInMs'] =
        this.timeSnapshottingConfigurationInMs !== undefined
          ? this.timeSnapshottingConfigurationInMs
          : <any>null;
      data['timeSnapshottingConfigurationWithFailureInMs'] =
        this.timeSnapshottingConfigurationWithFailureInMs !== undefined
          ? this.timeSnapshottingConfigurationWithFailureInMs
          : <any>null;
      data['timeSnapshottingConfigurationWithSuccessOrFailureInMs'] =
        this.timeSnapshottingConfigurationWithSuccessOrFailureInMs !== undefined
          ? this.timeSnapshottingConfigurationWithSuccessOrFailureInMs
          : <any>null;
      data['calculationsStartedTimestamp'] = this.calculationsStartedTimestamp
        ? this.calculationsStartedTimestamp.toISOString()
        : <any>null;
      data['calculationsCompletedTimestamp'] = this
        .calculationsCompletedTimestamp
        ? this.calculationsCompletedTimestamp.toISOString()
        : <any>null;
      data['postProcessingTimestamp'] = this.postProcessingTimestamp
        ? this.postProcessingTimestamp.toISOString()
        : <any>null;
      data['calculationsFailedTimestamp'] = this.calculationsFailedTimestamp
        ? this.calculationsFailedTimestamp.toISOString()
        : <any>null;
      data['timeCalculatingInMs'] =
        this.timeCalculatingInMs !== undefined
          ? this.timeCalculatingInMs
          : <any>null;
      data['timeCalculatingWithFailureInMs'] =
        this.timeCalculatingWithFailureInMs !== undefined
          ? this.timeCalculatingWithFailureInMs
          : <any>null;
      data['timeCalculatingWithSuccessOrFailureInMs'] =
        this.timeCalculatingWithSuccessOrFailureInMs !== undefined
          ? this.timeCalculatingWithSuccessOrFailureInMs
          : <any>null;
      data['completedTimestamp'] = this.completedTimestamp
        ? this.completedTimestamp.toISOString()
        : <any>null;
      data['failedTimestamp'] = this.failedTimestamp
        ? this.failedTimestamp.toISOString()
        : <any>null;
      data['totalTimeExecutingInMs'] =
        this.totalTimeExecutingInMs !== undefined
          ? this.totalTimeExecutingInMs
          : <any>null;
      data['totalTimeExecutingWithFailureInMs'] =
        this.totalTimeExecutingWithFailureInMs !== undefined
          ? this.totalTimeExecutingWithFailureInMs
          : <any>null;
      data['totalTimeExecutingWithSuccessOrFailureInMs'] =
        this.totalTimeExecutingWithSuccessOrFailureInMs !== undefined
          ? this.totalTimeExecutingWithSuccessOrFailureInMs
          : <any>null;
      data['timeInputProcessingWithSuccessOrFailureInMs'] =
        this.timeInputProcessingWithSuccessOrFailureInMs !== undefined
          ? this.timeInputProcessingWithSuccessOrFailureInMs
          : <any>null;
      data['pendingReportingDataEntry'] =
        this.pendingReportingDataEntry !== undefined
          ? this.pendingReportingDataEntry
          : <any>null;
      data['legacyAvailableInReporting'] =
        this.legacyAvailableInReporting !== undefined
          ? this.legacyAvailableInReporting
          : <any>null;
      return data;
    }
  }

  export interface IBatchIndexModel {
    id: string;
    calculationType: BatchCalculationType;
    calculationDate: Date | null;
    clientId: string;
    status: BatchStatus;
    brokerAdjustmentJobs: BatchBrokerAdjustmentJobIndexModel[];
    latestBatchDeleteRequest: BatchDeleteRequestIndexModel | null;
    pendingDeletion: boolean;
    creationSource: BatchCreationSource;
    executionMode: BatchExecutionMode | null;
    calculationCount: number;
    transactionCount: number;
    deletedCalculationCount: number | null;
    deletedTransactionCount: number | null;
    succeeded: boolean | null;
    failed: boolean;
    finished: boolean;
    activelyRunning: boolean;
    brokerAdjustmentRunning: boolean;
    statusDescription: string | null;
    dateCreated: Date;
    inputProcessingStartedTimestamp: Date | null;
    inputProcessingCompletedTimestamp: Date | null;
    inputProcessingFailedTimestamp: Date | null;
    timeInputProcessingInMs: number | null;
    timeInputProcessingWithFailureInMs: number | null;
    configurationSnapshotStartedTimestamp: Date | null;
    configurationSnapshotCompletedTimestamp: Date | null;
    configurationSnapshotFailedTimestamp: Date | null;
    timeSnapshottingConfigurationInMs: number | null;
    timeSnapshottingConfigurationWithFailureInMs: number | null;
    timeSnapshottingConfigurationWithSuccessOrFailureInMs: number | null;
    calculationsStartedTimestamp: Date | null;
    calculationsCompletedTimestamp: Date | null;
    postProcessingTimestamp: Date | null;
    calculationsFailedTimestamp: Date | null;
    timeCalculatingInMs: number | null;
    timeCalculatingWithFailureInMs: number | null;
    timeCalculatingWithSuccessOrFailureInMs: number | null;
    completedTimestamp: Date | null;
    failedTimestamp: Date | null;
    totalTimeExecutingInMs: number | null;
    totalTimeExecutingWithFailureInMs: number | null;
    totalTimeExecutingWithSuccessOrFailureInMs: number | null;
    timeInputProcessingWithSuccessOrFailureInMs: number | null;
    pendingReportingDataEntry: boolean;
    legacyAvailableInReporting: boolean | null;
  }

  export enum BatchCalculationType {
    Live = 'Live',
    PreVest = 'PreVest',
    Test = 'Test',
  }

  export enum BatchStatus {
    New = 'New',
    Draft = 'Draft',
    InputProcessingStarted = 'InputProcessingStarted',
    InputProcessingFailed = 'InputProcessingFailed',
    InputProcessingCompleted = 'InputProcessingCompleted',
    ConfigurationSnapshotStarted = 'ConfigurationSnapshotStarted',
    ConfigurationSnapshotFailed = 'ConfigurationSnapshotFailed',
    ConfigurationSnapshotCompleted = 'ConfigurationSnapshotCompleted',
    Calculating = 'Calculating',
    PostProcessing = 'PostProcessing',
    CalculationsFailed = 'CalculationsFailed',
    CalculationsCompleted = 'CalculationsCompleted',
    Completed = 'Completed',
    Failed = 'Failed',
    PendingDelete = 'PendingDelete',
    FailedDelete = 'FailedDelete',
  }

  export class BatchBrokerAdjustmentJobIndexModel
    implements IBatchBrokerAdjustmentJobIndexModel
  {
    brokerAdjustmentJobId!: string;
    status!: BatchBrokerAdjustmentJobStatus;
    startedTimestamp!: Date;
    finishedTimestamp!: Date | null;

    constructor(data?: IBatchBrokerAdjustmentJobIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.brokerAdjustmentJobId =
          _data['brokerAdjustmentJobId'] !== undefined
            ? _data['brokerAdjustmentJobId']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.startedTimestamp = _data['startedTimestamp']
          ? new Date(_data['startedTimestamp'].toString())
          : <any>null;
        this.finishedTimestamp = _data['finishedTimestamp']
          ? new Date(_data['finishedTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): BatchBrokerAdjustmentJobIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new BatchBrokerAdjustmentJobIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['brokerAdjustmentJobId'] =
        this.brokerAdjustmentJobId !== undefined
          ? this.brokerAdjustmentJobId
          : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['startedTimestamp'] = this.startedTimestamp
        ? this.startedTimestamp.toISOString()
        : <any>null;
      data['finishedTimestamp'] = this.finishedTimestamp
        ? this.finishedTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IBatchBrokerAdjustmentJobIndexModel {
    brokerAdjustmentJobId: string;
    status: BatchBrokerAdjustmentJobStatus;
    startedTimestamp: Date;
    finishedTimestamp: Date | null;
  }

  export enum BatchBrokerAdjustmentJobStatus {
    Running = 'Running',
    Finished = 'Finished',
  }

  export class BatchDeleteRequestIndexModel
    implements IBatchDeleteRequestIndexModel
  {
    id!: string;
    status!: BatchDeleteRequestStatus;
    actorPortalId!: string;
    startedTimestamp!: Date;
    finishedTimestamp!: Date | null;

    constructor(data?: IBatchDeleteRequestIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.actorPortalId =
          _data['actorPortalId'] !== undefined
            ? _data['actorPortalId']
            : <any>null;
        this.startedTimestamp = _data['startedTimestamp']
          ? new Date(_data['startedTimestamp'].toString())
          : <any>null;
        this.finishedTimestamp = _data['finishedTimestamp']
          ? new Date(_data['finishedTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): BatchDeleteRequestIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new BatchDeleteRequestIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['actorPortalId'] =
        this.actorPortalId !== undefined ? this.actorPortalId : <any>null;
      data['startedTimestamp'] = this.startedTimestamp
        ? this.startedTimestamp.toISOString()
        : <any>null;
      data['finishedTimestamp'] = this.finishedTimestamp
        ? this.finishedTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IBatchDeleteRequestIndexModel {
    id: string;
    status: BatchDeleteRequestStatus;
    actorPortalId: string;
    startedTimestamp: Date;
    finishedTimestamp: Date | null;
  }

  export enum BatchDeleteRequestStatus {
    Pending = 'Pending',
    Failed = 'Failed',
    Succeeded = 'Succeeded',
  }

  export enum BatchCreationSource {
    WebUI = 'WebUI',
    BatchFile = 'BatchFile',
    Cloned = 'Cloned',
    CDX = 'CDX',
  }

  export enum BatchExecutionMode {
    Sync = 'Sync',
    Async = 'Async',
  }

  export class PageModelOfCalculationIndexModel
    extends PageModel
    implements IPageModelOfCalculationIndexModel
  {
    items!: CalculationIndexModel[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfCalculationIndexModel) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(CalculationIndexModel.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfCalculationIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfCalculationIndexModel();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfCalculationIndexModel extends IPageModel {
    items: CalculationIndexModel[];
    totalItems: number | null;
  }

  export class CalculationIndexModel implements ICalculationIndexModel {
    id!: string;
    batchId!: string;
    clientId!: string;
    clientPortalId!: string;
    succeeded!: boolean | null;
    failed!: boolean;
    finished!: boolean;
    finishedOrInPostProcessing!: boolean;
    status!: CalculationStatus;
    latestBrokerAdjustmentJob!: CalculationBrokerAdjustmentJobIndexModel | null;
    latestGainAdjustmentJob!: CalculationGainAdjustmentJobIndexModel | null;
    statusDescription!: string | null;
    employeeId!: string | null;
    employeeFirstName!: string | null;
    employeeLastName!: string | null;
    manualCalculationSendToWorkflow!: boolean;
    dateCreated!: Date;
    creationSource!: CalculationCreationSource;
    executionMode!: CalculationExecutionMode | null;
    inputProcessingStartedTimestamp!: Date | null;
    inputProcessingCompletedTimestamp!: Date | null;
    inputProcessingFailedTimestamp!: Date | null;
    timeInputProcessingInMs!: number | null;
    timeInputProcessingWithFailureInMs!: number | null;
    timeInputProcessingWithSuccessOrFailureInMs!: number | null;
    preProcessingStartedTimestamp!: Date | null;
    preProcessingCompletedTimestamp!: Date | null;
    preProcessingFailedTimestamp!: Date | null;
    timePreProcessingInMs!: number | null;
    timePreProcessingWithFailureInMs!: number | null;
    timePreProcessingWithSuccessOrFailureInMs!: number | null;
    enqueuedTimestamp!: Date | null;
    dequeuedTimestamp!: Date | null;
    calculationTimedOutTimestamp!: Date | null;
    timeEnqueuedInMs!: number | null;
    timeEnqueuedWithFailureInMs!: number | null;
    timeEnqueuedWithSuccessOrFailureInMs!: number | null;
    calculationStartedTimestamp!: Date | null;
    calculationCompletedTimestamp!: Date | null;
    calculationFailedTimestamp!: Date | null;
    timeCalculatingInMs!: number | null;
    timeCalculatingWithFailureInMs!: number | null;
    timeCalculatingWithSuccessOrFailureInMs!: number | null;
    postProcessingStartedTimestamp!: Date | null;
    postProcessingCompletedTimestamp!: Date | null;
    postProcessingFailedTimestamp!: Date | null;
    timePostProcessingInMs!: number | null;
    timePostProcessingWithFailureInMs!: number | null;
    timePostProcessingWithSuccessOrFailureInMs!: number | null;
    completedTimestamp!: Date | null;
    failedTimestamp!: Date | null;
    latestCalculationDeleteRequest!: CalculationDeleteRequestIndexModel | null;
    pendingDeletion!: boolean;
    totalTimeExecutingInMs!: number | null;
    totalTimeWithFailureInMs!: number | null;
    totalTimeWithSuccessOrFailureInMs!: number | null;
    dateIndexed!: Date | null;
    inputTransactions!: CalculationTransactionIndexModel[];
    manualCalculationWorkflowDetails!: ManualCalculationWorkflowDetailsIndexModel | null;
    checkOutDetails!: CalculationCheckOutDetailsIndexModel | null;
    manualCalculationEditTimestamp!: Date | null;
    calculationType!: BatchCalculationType | null;
    planTypeCounts!: CalculationTransactionPlanTypeCount[];

    constructor(data?: ICalculationIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.inputTransactions = [];
        this.planTypeCounts = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.succeeded =
          _data['succeeded'] !== undefined ? _data['succeeded'] : <any>null;
        this.failed =
          _data['failed'] !== undefined ? _data['failed'] : <any>null;
        this.finished =
          _data['finished'] !== undefined ? _data['finished'] : <any>null;
        this.finishedOrInPostProcessing =
          _data['finishedOrInPostProcessing'] !== undefined
            ? _data['finishedOrInPostProcessing']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.latestBrokerAdjustmentJob = _data['latestBrokerAdjustmentJob']
          ? CalculationBrokerAdjustmentJobIndexModel.fromJS(
              _data['latestBrokerAdjustmentJob'],
            )
          : <any>null;
        this.latestGainAdjustmentJob = _data['latestGainAdjustmentJob']
          ? CalculationGainAdjustmentJobIndexModel.fromJS(
              _data['latestGainAdjustmentJob'],
            )
          : <any>null;
        this.statusDescription =
          _data['statusDescription'] !== undefined
            ? _data['statusDescription']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.employeeFirstName =
          _data['employeeFirstName'] !== undefined
            ? _data['employeeFirstName']
            : <any>null;
        this.employeeLastName =
          _data['employeeLastName'] !== undefined
            ? _data['employeeLastName']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
        this.dateCreated = _data['dateCreated']
          ? new Date(_data['dateCreated'].toString())
          : <any>null;
        this.creationSource =
          _data['creationSource'] !== undefined
            ? _data['creationSource']
            : <any>null;
        this.executionMode =
          _data['executionMode'] !== undefined
            ? _data['executionMode']
            : <any>null;
        this.inputProcessingStartedTimestamp = _data[
          'inputProcessingStartedTimestamp'
        ]
          ? new Date(_data['inputProcessingStartedTimestamp'].toString())
          : <any>null;
        this.inputProcessingCompletedTimestamp = _data[
          'inputProcessingCompletedTimestamp'
        ]
          ? new Date(_data['inputProcessingCompletedTimestamp'].toString())
          : <any>null;
        this.inputProcessingFailedTimestamp = _data[
          'inputProcessingFailedTimestamp'
        ]
          ? new Date(_data['inputProcessingFailedTimestamp'].toString())
          : <any>null;
        this.timeInputProcessingInMs =
          _data['timeInputProcessingInMs'] !== undefined
            ? _data['timeInputProcessingInMs']
            : <any>null;
        this.timeInputProcessingWithFailureInMs =
          _data['timeInputProcessingWithFailureInMs'] !== undefined
            ? _data['timeInputProcessingWithFailureInMs']
            : <any>null;
        this.timeInputProcessingWithSuccessOrFailureInMs =
          _data['timeInputProcessingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timeInputProcessingWithSuccessOrFailureInMs']
            : <any>null;
        this.preProcessingStartedTimestamp = _data[
          'preProcessingStartedTimestamp'
        ]
          ? new Date(_data['preProcessingStartedTimestamp'].toString())
          : <any>null;
        this.preProcessingCompletedTimestamp = _data[
          'preProcessingCompletedTimestamp'
        ]
          ? new Date(_data['preProcessingCompletedTimestamp'].toString())
          : <any>null;
        this.preProcessingFailedTimestamp = _data[
          'preProcessingFailedTimestamp'
        ]
          ? new Date(_data['preProcessingFailedTimestamp'].toString())
          : <any>null;
        this.timePreProcessingInMs =
          _data['timePreProcessingInMs'] !== undefined
            ? _data['timePreProcessingInMs']
            : <any>null;
        this.timePreProcessingWithFailureInMs =
          _data['timePreProcessingWithFailureInMs'] !== undefined
            ? _data['timePreProcessingWithFailureInMs']
            : <any>null;
        this.timePreProcessingWithSuccessOrFailureInMs =
          _data['timePreProcessingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timePreProcessingWithSuccessOrFailureInMs']
            : <any>null;
        this.enqueuedTimestamp = _data['enqueuedTimestamp']
          ? new Date(_data['enqueuedTimestamp'].toString())
          : <any>null;
        this.dequeuedTimestamp = _data['dequeuedTimestamp']
          ? new Date(_data['dequeuedTimestamp'].toString())
          : <any>null;
        this.calculationTimedOutTimestamp = _data[
          'calculationTimedOutTimestamp'
        ]
          ? new Date(_data['calculationTimedOutTimestamp'].toString())
          : <any>null;
        this.timeEnqueuedInMs =
          _data['timeEnqueuedInMs'] !== undefined
            ? _data['timeEnqueuedInMs']
            : <any>null;
        this.timeEnqueuedWithFailureInMs =
          _data['timeEnqueuedWithFailureInMs'] !== undefined
            ? _data['timeEnqueuedWithFailureInMs']
            : <any>null;
        this.timeEnqueuedWithSuccessOrFailureInMs =
          _data['timeEnqueuedWithSuccessOrFailureInMs'] !== undefined
            ? _data['timeEnqueuedWithSuccessOrFailureInMs']
            : <any>null;
        this.calculationStartedTimestamp = _data['calculationStartedTimestamp']
          ? new Date(_data['calculationStartedTimestamp'].toString())
          : <any>null;
        this.calculationCompletedTimestamp = _data[
          'calculationCompletedTimestamp'
        ]
          ? new Date(_data['calculationCompletedTimestamp'].toString())
          : <any>null;
        this.calculationFailedTimestamp = _data['calculationFailedTimestamp']
          ? new Date(_data['calculationFailedTimestamp'].toString())
          : <any>null;
        this.timeCalculatingInMs =
          _data['timeCalculatingInMs'] !== undefined
            ? _data['timeCalculatingInMs']
            : <any>null;
        this.timeCalculatingWithFailureInMs =
          _data['timeCalculatingWithFailureInMs'] !== undefined
            ? _data['timeCalculatingWithFailureInMs']
            : <any>null;
        this.timeCalculatingWithSuccessOrFailureInMs =
          _data['timeCalculatingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timeCalculatingWithSuccessOrFailureInMs']
            : <any>null;
        this.postProcessingStartedTimestamp = _data[
          'postProcessingStartedTimestamp'
        ]
          ? new Date(_data['postProcessingStartedTimestamp'].toString())
          : <any>null;
        this.postProcessingCompletedTimestamp = _data[
          'postProcessingCompletedTimestamp'
        ]
          ? new Date(_data['postProcessingCompletedTimestamp'].toString())
          : <any>null;
        this.postProcessingFailedTimestamp = _data[
          'postProcessingFailedTimestamp'
        ]
          ? new Date(_data['postProcessingFailedTimestamp'].toString())
          : <any>null;
        this.timePostProcessingInMs =
          _data['timePostProcessingInMs'] !== undefined
            ? _data['timePostProcessingInMs']
            : <any>null;
        this.timePostProcessingWithFailureInMs =
          _data['timePostProcessingWithFailureInMs'] !== undefined
            ? _data['timePostProcessingWithFailureInMs']
            : <any>null;
        this.timePostProcessingWithSuccessOrFailureInMs =
          _data['timePostProcessingWithSuccessOrFailureInMs'] !== undefined
            ? _data['timePostProcessingWithSuccessOrFailureInMs']
            : <any>null;
        this.completedTimestamp = _data['completedTimestamp']
          ? new Date(_data['completedTimestamp'].toString())
          : <any>null;
        this.failedTimestamp = _data['failedTimestamp']
          ? new Date(_data['failedTimestamp'].toString())
          : <any>null;
        this.latestCalculationDeleteRequest = _data[
          'latestCalculationDeleteRequest'
        ]
          ? CalculationDeleteRequestIndexModel.fromJS(
              _data['latestCalculationDeleteRequest'],
            )
          : <any>null;
        this.pendingDeletion =
          _data['pendingDeletion'] !== undefined
            ? _data['pendingDeletion']
            : <any>null;
        this.totalTimeExecutingInMs =
          _data['totalTimeExecutingInMs'] !== undefined
            ? _data['totalTimeExecutingInMs']
            : <any>null;
        this.totalTimeWithFailureInMs =
          _data['totalTimeWithFailureInMs'] !== undefined
            ? _data['totalTimeWithFailureInMs']
            : <any>null;
        this.totalTimeWithSuccessOrFailureInMs =
          _data['totalTimeWithSuccessOrFailureInMs'] !== undefined
            ? _data['totalTimeWithSuccessOrFailureInMs']
            : <any>null;
        this.dateIndexed = _data['dateIndexed']
          ? new Date(_data['dateIndexed'].toString())
          : <any>null;
        if (Array.isArray(_data['inputTransactions'])) {
          this.inputTransactions = [] as any;
          for (let item of _data['inputTransactions'])
            this.inputTransactions!.push(
              CalculationTransactionIndexModel.fromJS(item),
            );
        } else {
          this.inputTransactions = <any>null;
        }
        this.manualCalculationWorkflowDetails = _data[
          'manualCalculationWorkflowDetails'
        ]
          ? ManualCalculationWorkflowDetailsIndexModel.fromJS(
              _data['manualCalculationWorkflowDetails'],
            )
          : <any>null;
        this.checkOutDetails = _data['checkOutDetails']
          ? CalculationCheckOutDetailsIndexModel.fromJS(
              _data['checkOutDetails'],
            )
          : <any>null;
        this.manualCalculationEditTimestamp = _data[
          'manualCalculationEditTimestamp'
        ]
          ? new Date(_data['manualCalculationEditTimestamp'].toString())
          : <any>null;
        this.calculationType =
          _data['calculationType'] !== undefined
            ? _data['calculationType']
            : <any>null;
        if (Array.isArray(_data['planTypeCounts'])) {
          this.planTypeCounts = [] as any;
          for (let item of _data['planTypeCounts'])
            this.planTypeCounts!.push(
              CalculationTransactionPlanTypeCount.fromJS(item),
            );
        } else {
          this.planTypeCounts = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['succeeded'] =
        this.succeeded !== undefined ? this.succeeded : <any>null;
      data['failed'] = this.failed !== undefined ? this.failed : <any>null;
      data['finished'] =
        this.finished !== undefined ? this.finished : <any>null;
      data['finishedOrInPostProcessing'] =
        this.finishedOrInPostProcessing !== undefined
          ? this.finishedOrInPostProcessing
          : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['latestBrokerAdjustmentJob'] = this.latestBrokerAdjustmentJob
        ? this.latestBrokerAdjustmentJob.toJSON()
        : <any>null;
      data['latestGainAdjustmentJob'] = this.latestGainAdjustmentJob
        ? this.latestGainAdjustmentJob.toJSON()
        : <any>null;
      data['statusDescription'] =
        this.statusDescription !== undefined
          ? this.statusDescription
          : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['employeeFirstName'] =
        this.employeeFirstName !== undefined
          ? this.employeeFirstName
          : <any>null;
      data['employeeLastName'] =
        this.employeeLastName !== undefined ? this.employeeLastName : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      data['dateCreated'] = this.dateCreated
        ? this.dateCreated.toISOString()
        : <any>null;
      data['creationSource'] =
        this.creationSource !== undefined ? this.creationSource : <any>null;
      data['executionMode'] =
        this.executionMode !== undefined ? this.executionMode : <any>null;
      data['inputProcessingStartedTimestamp'] = this
        .inputProcessingStartedTimestamp
        ? this.inputProcessingStartedTimestamp.toISOString()
        : <any>null;
      data['inputProcessingCompletedTimestamp'] = this
        .inputProcessingCompletedTimestamp
        ? this.inputProcessingCompletedTimestamp.toISOString()
        : <any>null;
      data['inputProcessingFailedTimestamp'] = this
        .inputProcessingFailedTimestamp
        ? this.inputProcessingFailedTimestamp.toISOString()
        : <any>null;
      data['timeInputProcessingInMs'] =
        this.timeInputProcessingInMs !== undefined
          ? this.timeInputProcessingInMs
          : <any>null;
      data['timeInputProcessingWithFailureInMs'] =
        this.timeInputProcessingWithFailureInMs !== undefined
          ? this.timeInputProcessingWithFailureInMs
          : <any>null;
      data['timeInputProcessingWithSuccessOrFailureInMs'] =
        this.timeInputProcessingWithSuccessOrFailureInMs !== undefined
          ? this.timeInputProcessingWithSuccessOrFailureInMs
          : <any>null;
      data['preProcessingStartedTimestamp'] = this.preProcessingStartedTimestamp
        ? this.preProcessingStartedTimestamp.toISOString()
        : <any>null;
      data['preProcessingCompletedTimestamp'] = this
        .preProcessingCompletedTimestamp
        ? this.preProcessingCompletedTimestamp.toISOString()
        : <any>null;
      data['preProcessingFailedTimestamp'] = this.preProcessingFailedTimestamp
        ? this.preProcessingFailedTimestamp.toISOString()
        : <any>null;
      data['timePreProcessingInMs'] =
        this.timePreProcessingInMs !== undefined
          ? this.timePreProcessingInMs
          : <any>null;
      data['timePreProcessingWithFailureInMs'] =
        this.timePreProcessingWithFailureInMs !== undefined
          ? this.timePreProcessingWithFailureInMs
          : <any>null;
      data['timePreProcessingWithSuccessOrFailureInMs'] =
        this.timePreProcessingWithSuccessOrFailureInMs !== undefined
          ? this.timePreProcessingWithSuccessOrFailureInMs
          : <any>null;
      data['enqueuedTimestamp'] = this.enqueuedTimestamp
        ? this.enqueuedTimestamp.toISOString()
        : <any>null;
      data['dequeuedTimestamp'] = this.dequeuedTimestamp
        ? this.dequeuedTimestamp.toISOString()
        : <any>null;
      data['calculationTimedOutTimestamp'] = this.calculationTimedOutTimestamp
        ? this.calculationTimedOutTimestamp.toISOString()
        : <any>null;
      data['timeEnqueuedInMs'] =
        this.timeEnqueuedInMs !== undefined ? this.timeEnqueuedInMs : <any>null;
      data['timeEnqueuedWithFailureInMs'] =
        this.timeEnqueuedWithFailureInMs !== undefined
          ? this.timeEnqueuedWithFailureInMs
          : <any>null;
      data['timeEnqueuedWithSuccessOrFailureInMs'] =
        this.timeEnqueuedWithSuccessOrFailureInMs !== undefined
          ? this.timeEnqueuedWithSuccessOrFailureInMs
          : <any>null;
      data['calculationStartedTimestamp'] = this.calculationStartedTimestamp
        ? this.calculationStartedTimestamp.toISOString()
        : <any>null;
      data['calculationCompletedTimestamp'] = this.calculationCompletedTimestamp
        ? this.calculationCompletedTimestamp.toISOString()
        : <any>null;
      data['calculationFailedTimestamp'] = this.calculationFailedTimestamp
        ? this.calculationFailedTimestamp.toISOString()
        : <any>null;
      data['timeCalculatingInMs'] =
        this.timeCalculatingInMs !== undefined
          ? this.timeCalculatingInMs
          : <any>null;
      data['timeCalculatingWithFailureInMs'] =
        this.timeCalculatingWithFailureInMs !== undefined
          ? this.timeCalculatingWithFailureInMs
          : <any>null;
      data['timeCalculatingWithSuccessOrFailureInMs'] =
        this.timeCalculatingWithSuccessOrFailureInMs !== undefined
          ? this.timeCalculatingWithSuccessOrFailureInMs
          : <any>null;
      data['postProcessingStartedTimestamp'] = this
        .postProcessingStartedTimestamp
        ? this.postProcessingStartedTimestamp.toISOString()
        : <any>null;
      data['postProcessingCompletedTimestamp'] = this
        .postProcessingCompletedTimestamp
        ? this.postProcessingCompletedTimestamp.toISOString()
        : <any>null;
      data['postProcessingFailedTimestamp'] = this.postProcessingFailedTimestamp
        ? this.postProcessingFailedTimestamp.toISOString()
        : <any>null;
      data['timePostProcessingInMs'] =
        this.timePostProcessingInMs !== undefined
          ? this.timePostProcessingInMs
          : <any>null;
      data['timePostProcessingWithFailureInMs'] =
        this.timePostProcessingWithFailureInMs !== undefined
          ? this.timePostProcessingWithFailureInMs
          : <any>null;
      data['timePostProcessingWithSuccessOrFailureInMs'] =
        this.timePostProcessingWithSuccessOrFailureInMs !== undefined
          ? this.timePostProcessingWithSuccessOrFailureInMs
          : <any>null;
      data['completedTimestamp'] = this.completedTimestamp
        ? this.completedTimestamp.toISOString()
        : <any>null;
      data['failedTimestamp'] = this.failedTimestamp
        ? this.failedTimestamp.toISOString()
        : <any>null;
      data['latestCalculationDeleteRequest'] = this
        .latestCalculationDeleteRequest
        ? this.latestCalculationDeleteRequest.toJSON()
        : <any>null;
      data['pendingDeletion'] =
        this.pendingDeletion !== undefined ? this.pendingDeletion : <any>null;
      data['totalTimeExecutingInMs'] =
        this.totalTimeExecutingInMs !== undefined
          ? this.totalTimeExecutingInMs
          : <any>null;
      data['totalTimeWithFailureInMs'] =
        this.totalTimeWithFailureInMs !== undefined
          ? this.totalTimeWithFailureInMs
          : <any>null;
      data['totalTimeWithSuccessOrFailureInMs'] =
        this.totalTimeWithSuccessOrFailureInMs !== undefined
          ? this.totalTimeWithSuccessOrFailureInMs
          : <any>null;
      data['dateIndexed'] = this.dateIndexed
        ? this.dateIndexed.toISOString()
        : <any>null;
      if (Array.isArray(this.inputTransactions)) {
        data['inputTransactions'] = [];
        for (let item of this.inputTransactions)
          data['inputTransactions'].push(item.toJSON());
      }
      data['manualCalculationWorkflowDetails'] = this
        .manualCalculationWorkflowDetails
        ? this.manualCalculationWorkflowDetails.toJSON()
        : <any>null;
      data['checkOutDetails'] = this.checkOutDetails
        ? this.checkOutDetails.toJSON()
        : <any>null;
      data['manualCalculationEditTimestamp'] = this
        .manualCalculationEditTimestamp
        ? this.manualCalculationEditTimestamp.toISOString()
        : <any>null;
      data['calculationType'] =
        this.calculationType !== undefined ? this.calculationType : <any>null;
      if (Array.isArray(this.planTypeCounts)) {
        data['planTypeCounts'] = [];
        for (let item of this.planTypeCounts)
          data['planTypeCounts'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationIndexModel {
    id: string;
    batchId: string;
    clientId: string;
    clientPortalId: string;
    succeeded: boolean | null;
    failed: boolean;
    finished: boolean;
    finishedOrInPostProcessing: boolean;
    status: CalculationStatus;
    latestBrokerAdjustmentJob: CalculationBrokerAdjustmentJobIndexModel | null;
    latestGainAdjustmentJob: CalculationGainAdjustmentJobIndexModel | null;
    statusDescription: string | null;
    employeeId: string | null;
    employeeFirstName: string | null;
    employeeLastName: string | null;
    manualCalculationSendToWorkflow: boolean;
    dateCreated: Date;
    creationSource: CalculationCreationSource;
    executionMode: CalculationExecutionMode | null;
    inputProcessingStartedTimestamp: Date | null;
    inputProcessingCompletedTimestamp: Date | null;
    inputProcessingFailedTimestamp: Date | null;
    timeInputProcessingInMs: number | null;
    timeInputProcessingWithFailureInMs: number | null;
    timeInputProcessingWithSuccessOrFailureInMs: number | null;
    preProcessingStartedTimestamp: Date | null;
    preProcessingCompletedTimestamp: Date | null;
    preProcessingFailedTimestamp: Date | null;
    timePreProcessingInMs: number | null;
    timePreProcessingWithFailureInMs: number | null;
    timePreProcessingWithSuccessOrFailureInMs: number | null;
    enqueuedTimestamp: Date | null;
    dequeuedTimestamp: Date | null;
    calculationTimedOutTimestamp: Date | null;
    timeEnqueuedInMs: number | null;
    timeEnqueuedWithFailureInMs: number | null;
    timeEnqueuedWithSuccessOrFailureInMs: number | null;
    calculationStartedTimestamp: Date | null;
    calculationCompletedTimestamp: Date | null;
    calculationFailedTimestamp: Date | null;
    timeCalculatingInMs: number | null;
    timeCalculatingWithFailureInMs: number | null;
    timeCalculatingWithSuccessOrFailureInMs: number | null;
    postProcessingStartedTimestamp: Date | null;
    postProcessingCompletedTimestamp: Date | null;
    postProcessingFailedTimestamp: Date | null;
    timePostProcessingInMs: number | null;
    timePostProcessingWithFailureInMs: number | null;
    timePostProcessingWithSuccessOrFailureInMs: number | null;
    completedTimestamp: Date | null;
    failedTimestamp: Date | null;
    latestCalculationDeleteRequest: CalculationDeleteRequestIndexModel | null;
    pendingDeletion: boolean;
    totalTimeExecutingInMs: number | null;
    totalTimeWithFailureInMs: number | null;
    totalTimeWithSuccessOrFailureInMs: number | null;
    dateIndexed: Date | null;
    inputTransactions: CalculationTransactionIndexModel[];
    manualCalculationWorkflowDetails: ManualCalculationWorkflowDetailsIndexModel | null;
    checkOutDetails: CalculationCheckOutDetailsIndexModel | null;
    manualCalculationEditTimestamp: Date | null;
    calculationType: BatchCalculationType | null;
    planTypeCounts: CalculationTransactionPlanTypeCount[];
  }

  export enum CalculationStatus {
    New = 'New',
    Draft = 'Draft',
    InputProcessingStarted = 'InputProcessingStarted',
    InputProcessingFailed = 'InputProcessingFailed',
    InputProcessingCompleted = 'InputProcessingCompleted',
    PreProcessingStarted = 'PreProcessingStarted',
    PreProcessingFailed = 'PreProcessingFailed',
    PreProcessingCompleted = 'PreProcessingCompleted',
    Enqueued = 'Enqueued',
    CalculationStarted = 'CalculationStarted',
    CalculationTimedOut = 'CalculationTimedOut',
    CalculationFailed = 'CalculationFailed',
    CalculationCompleted = 'CalculationCompleted',
    PostProcessingStarted = 'PostProcessingStarted',
    PostProcessingFailed = 'PostProcessingFailed',
    PostProcessingCompleted = 'PostProcessingCompleted',
    ManualCalculationPendingReview = 'ManualCalculationPendingReview',
    ManualCalculationPendingApproval = 'ManualCalculationPendingApproval',
    AwaitingGainAdjustment = 'AwaitingGainAdjustment',
    PerformingGainAdjustment = 'PerformingGainAdjustment',
    AwaitingBrokerAdjustment = 'AwaitingBrokerAdjustment',
    BrokerAdjustmentPreProcessing = 'BrokerAdjustmentPreProcessing',
    PerformingBrokerAdjustment = 'PerformingBrokerAdjustment',
    Completed = 'Completed',
    Failed = 'Failed',
    PendingDelete = 'PendingDelete',
    FailedDelete = 'FailedDelete',
  }

  export class CalculationBrokerAdjustmentJobIndexModel
    implements ICalculationBrokerAdjustmentJobIndexModel
  {
    brokerAdjustmentJobId!: string;
    status!: CalculationBrokerAdjustmentJobStatus;
    startedTimestamp!: Date;
    finishedTimestamp!: Date | null;

    constructor(data?: ICalculationBrokerAdjustmentJobIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.brokerAdjustmentJobId =
          _data['brokerAdjustmentJobId'] !== undefined
            ? _data['brokerAdjustmentJobId']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.startedTimestamp = _data['startedTimestamp']
          ? new Date(_data['startedTimestamp'].toString())
          : <any>null;
        this.finishedTimestamp = _data['finishedTimestamp']
          ? new Date(_data['finishedTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationBrokerAdjustmentJobIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationBrokerAdjustmentJobIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['brokerAdjustmentJobId'] =
        this.brokerAdjustmentJobId !== undefined
          ? this.brokerAdjustmentJobId
          : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['startedTimestamp'] = this.startedTimestamp
        ? this.startedTimestamp.toISOString()
        : <any>null;
      data['finishedTimestamp'] = this.finishedTimestamp
        ? this.finishedTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationBrokerAdjustmentJobIndexModel {
    brokerAdjustmentJobId: string;
    status: CalculationBrokerAdjustmentJobStatus;
    startedTimestamp: Date;
    finishedTimestamp: Date | null;
  }

  export enum CalculationBrokerAdjustmentJobStatus {
    Running = 'Running',
    SucceededButIncomplete = 'SucceededButIncomplete',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
  }

  export class CalculationGainAdjustmentJobIndexModel
    implements ICalculationGainAdjustmentJobIndexModel
  {
    id!: string;
    status!: CalculationGainAdjustmentJobStatus;
    startedTimestamp!: Date;
    finishedTimestamp!: Date | null;

    constructor(data?: ICalculationGainAdjustmentJobIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.startedTimestamp = _data['startedTimestamp']
          ? new Date(_data['startedTimestamp'].toString())
          : <any>null;
        this.finishedTimestamp = _data['finishedTimestamp']
          ? new Date(_data['finishedTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationGainAdjustmentJobIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationGainAdjustmentJobIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['startedTimestamp'] = this.startedTimestamp
        ? this.startedTimestamp.toISOString()
        : <any>null;
      data['finishedTimestamp'] = this.finishedTimestamp
        ? this.finishedTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationGainAdjustmentJobIndexModel {
    id: string;
    status: CalculationGainAdjustmentJobStatus;
    startedTimestamp: Date;
    finishedTimestamp: Date | null;
  }

  export enum CalculationGainAdjustmentJobStatus {
    Running = 'Running',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
  }

  export enum CalculationCreationSource {
    WebUI = 'WebUI',
    BatchFile = 'BatchFile',
    Cloned = 'Cloned',
    CDX = 'CDX',
    ClonedFromOriginalBatch = 'ClonedFromOriginalBatch',
  }

  export enum CalculationExecutionMode {
    Sync = 'Sync',
    Async = 'Async',
  }

  export class CalculationDeleteRequestIndexModel
    implements ICalculationDeleteRequestIndexModel
  {
    id!: string;
    status!: CalculationDeleteRequestStatus;
    actorPortalId!: string;
    startedTimestamp!: Date;
    finishedTimestamp!: Date | null;

    constructor(data?: ICalculationDeleteRequestIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.actorPortalId =
          _data['actorPortalId'] !== undefined
            ? _data['actorPortalId']
            : <any>null;
        this.startedTimestamp = _data['startedTimestamp']
          ? new Date(_data['startedTimestamp'].toString())
          : <any>null;
        this.finishedTimestamp = _data['finishedTimestamp']
          ? new Date(_data['finishedTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationDeleteRequestIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationDeleteRequestIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['actorPortalId'] =
        this.actorPortalId !== undefined ? this.actorPortalId : <any>null;
      data['startedTimestamp'] = this.startedTimestamp
        ? this.startedTimestamp.toISOString()
        : <any>null;
      data['finishedTimestamp'] = this.finishedTimestamp
        ? this.finishedTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationDeleteRequestIndexModel {
    id: string;
    status: CalculationDeleteRequestStatus;
    actorPortalId: string;
    startedTimestamp: Date;
    finishedTimestamp: Date | null;
  }

  export enum CalculationDeleteRequestStatus {
    Pending = 'Pending',
    FailedInReporting = 'FailedInReporting',
    Failed = 'Failed',
    SucceedInReporting = 'SucceedInReporting',
    Succeeded = 'Succeeded',
  }

  export class CalculationTransactionIndexModel
    implements ICalculationTransactionIndexModel
  {
    transactionId!: string;
    transactionGuid!: string;
    planType!: PlanType;
    planCode!: string;
    assignedWorkCountries!: string[] | null;
    manualCalculationReason!: string | null;
    transactionStatus!: TransactionStatus | null;
    manualCalculationWorkflowDetails!: ManualCalculationWorkflowTransactionDetailsIndexModel | null;

    constructor(data?: ICalculationTransactionIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        if (Array.isArray(_data['assignedWorkCountries'])) {
          this.assignedWorkCountries = [] as any;
          for (let item of _data['assignedWorkCountries'])
            this.assignedWorkCountries!.push(item);
        } else {
          this.assignedWorkCountries = <any>null;
        }
        this.manualCalculationReason =
          _data['manualCalculationReason'] !== undefined
            ? _data['manualCalculationReason']
            : <any>null;
        this.transactionStatus =
          _data['transactionStatus'] !== undefined
            ? _data['transactionStatus']
            : <any>null;
        this.manualCalculationWorkflowDetails = _data[
          'manualCalculationWorkflowDetails'
        ]
          ? ManualCalculationWorkflowTransactionDetailsIndexModel.fromJS(
              _data['manualCalculationWorkflowDetails'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationTransactionIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationTransactionIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      if (Array.isArray(this.assignedWorkCountries)) {
        data['assignedWorkCountries'] = [];
        for (let item of this.assignedWorkCountries)
          data['assignedWorkCountries'].push(item);
      }
      data['manualCalculationReason'] =
        this.manualCalculationReason !== undefined
          ? this.manualCalculationReason
          : <any>null;
      data['transactionStatus'] =
        this.transactionStatus !== undefined
          ? this.transactionStatus
          : <any>null;
      data['manualCalculationWorkflowDetails'] = this
        .manualCalculationWorkflowDetails
        ? this.manualCalculationWorkflowDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationTransactionIndexModel {
    transactionId: string;
    transactionGuid: string;
    planType: PlanType;
    planCode: string;
    assignedWorkCountries: string[] | null;
    manualCalculationReason: string | null;
    transactionStatus: TransactionStatus | null;
    manualCalculationWorkflowDetails: ManualCalculationWorkflowTransactionDetailsIndexModel | null;
  }

  export enum TransactionStatus {
    New = 'New',
    Draft = 'Draft',
    InputProcessing = 'InputProcessing',
    PreProcessing = 'PreProcessing',
    Enqueued = 'Enqueued',
    CalculationEngine = 'CalculationEngine',
    TransactionPendingReview = 'TransactionPendingReview',
    TransactionReviewed = 'TransactionReviewed',
    TransactionPendingApproval = 'TransactionPendingApproval',
    TransactionApproved = 'TransactionApproved',
    AwaitingGainAdjustment = 'AwaitingGainAdjustment',
    AwaitingBrokerAdjustment = 'AwaitingBrokerAdjustment',
    AwaitingOtherTransactionBrokerAdjustment = 'AwaitingOtherTransactionBrokerAdjustment',
    BrokerAdjustmentPreProcessing = 'BrokerAdjustmentPreProcessing',
    PerformingBrokerAdjustment = 'PerformingBrokerAdjustment',
    Completed = 'Completed',
    Failed = 'Failed',
    PendingDelete = 'PendingDelete',
    FailedDelete = 'FailedDelete',
  }

  export class ManualCalculationWorkflowTransactionDetailsIndexModel
    implements IManualCalculationWorkflowTransactionDetailsIndexModel
  {
    isSaved!: boolean;
    latestSave!: ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel | null;
    latestApproverAction!: ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel | null;

    constructor(data?: IManualCalculationWorkflowTransactionDetailsIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isSaved =
          _data['isSaved'] !== undefined ? _data['isSaved'] : <any>null;
        this.latestSave = _data['latestSave']
          ? ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel.fromJS(
              _data['latestSave'],
            )
          : <any>null;
        this.latestApproverAction = _data['latestApproverAction']
          ? ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel.fromJS(
              _data['latestApproverAction'],
            )
          : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): ManualCalculationWorkflowTransactionDetailsIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationWorkflowTransactionDetailsIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isSaved'] = this.isSaved !== undefined ? this.isSaved : <any>null;
      data['latestSave'] = this.latestSave
        ? this.latestSave.toJSON()
        : <any>null;
      data['latestApproverAction'] = this.latestApproverAction
        ? this.latestApproverAction.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationWorkflowTransactionDetailsIndexModel {
    isSaved: boolean;
    latestSave: ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel | null;
    latestApproverAction: ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel | null;
  }

  export class ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel
    implements IManualCalculationWorkflowTransactionDetailsLogEntryIndexModel
  {
    timestamp!: Date;
    actorPortalId!: string;
    actorName!: string | null;
    comment!: string | null;
    action!: ManualCalculationWorkflowTransactionAction;

    constructor(
      data?: IManualCalculationWorkflowTransactionDetailsLogEntryIndexModel,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
        this.actorPortalId =
          _data['actorPortalId'] !== undefined
            ? _data['actorPortalId']
            : <any>null;
        this.actorName =
          _data['actorName'] !== undefined ? _data['actorName'] : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.action =
          _data['action'] !== undefined ? _data['action'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel {
      data = typeof data === 'object' ? data : {};
      let result =
        new ManualCalculationWorkflowTransactionDetailsLogEntryIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      data['actorPortalId'] =
        this.actorPortalId !== undefined ? this.actorPortalId : <any>null;
      data['actorName'] =
        this.actorName !== undefined ? this.actorName : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['action'] = this.action !== undefined ? this.action : <any>null;
      return data;
    }
  }

  export interface IManualCalculationWorkflowTransactionDetailsLogEntryIndexModel {
    timestamp: Date;
    actorPortalId: string;
    actorName: string | null;
    comment: string | null;
    action: ManualCalculationWorkflowTransactionAction;
  }

  export enum ManualCalculationWorkflowTransactionAction {
    Returned = 'Returned',
    Approved = 'Approved',
    Saved = 'Saved',
    NeedsAttention = 'NeedsAttention',
  }

  export class ManualCalculationWorkflowDetailsIndexModel
    implements IManualCalculationWorkflowDetailsIndexModel
  {
    latestSentForApproval!: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    latestSave!: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    latestApproverAction!: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    approvalDetails!: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;

    constructor(data?: IManualCalculationWorkflowDetailsIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.latestSentForApproval = _data['latestSentForApproval']
          ? ManualCalculationWorkflowDetailsLogEntryIndexModel.fromJS(
              _data['latestSentForApproval'],
            )
          : <any>null;
        this.latestSave = _data['latestSave']
          ? ManualCalculationWorkflowDetailsLogEntryIndexModel.fromJS(
              _data['latestSave'],
            )
          : <any>null;
        this.latestApproverAction = _data['latestApproverAction']
          ? ManualCalculationWorkflowDetailsLogEntryIndexModel.fromJS(
              _data['latestApproverAction'],
            )
          : <any>null;
        this.approvalDetails = _data['approvalDetails']
          ? ManualCalculationWorkflowDetailsLogEntryIndexModel.fromJS(
              _data['approvalDetails'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationWorkflowDetailsIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationWorkflowDetailsIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['latestSentForApproval'] = this.latestSentForApproval
        ? this.latestSentForApproval.toJSON()
        : <any>null;
      data['latestSave'] = this.latestSave
        ? this.latestSave.toJSON()
        : <any>null;
      data['latestApproverAction'] = this.latestApproverAction
        ? this.latestApproverAction.toJSON()
        : <any>null;
      data['approvalDetails'] = this.approvalDetails
        ? this.approvalDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationWorkflowDetailsIndexModel {
    latestSentForApproval: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    latestSave: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    latestApproverAction: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
    approvalDetails: ManualCalculationWorkflowDetailsLogEntryIndexModel | null;
  }

  export class ManualCalculationWorkflowDetailsLogEntryIndexModel
    implements IManualCalculationWorkflowDetailsLogEntryIndexModel
  {
    timestamp!: Date;
    actorPortalId!: string;
    actorName!: string | null;
    comment!: string | null;
    action!: ManualCalculationWorkflowAction;

    constructor(data?: IManualCalculationWorkflowDetailsLogEntryIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
        this.actorPortalId =
          _data['actorPortalId'] !== undefined
            ? _data['actorPortalId']
            : <any>null;
        this.actorName =
          _data['actorName'] !== undefined ? _data['actorName'] : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.action =
          _data['action'] !== undefined ? _data['action'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): ManualCalculationWorkflowDetailsLogEntryIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationWorkflowDetailsLogEntryIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      data['actorPortalId'] =
        this.actorPortalId !== undefined ? this.actorPortalId : <any>null;
      data['actorName'] =
        this.actorName !== undefined ? this.actorName : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['action'] = this.action !== undefined ? this.action : <any>null;
      return data;
    }
  }

  export interface IManualCalculationWorkflowDetailsLogEntryIndexModel {
    timestamp: Date;
    actorPortalId: string;
    actorName: string | null;
    comment: string | null;
    action: ManualCalculationWorkflowAction;
  }

  export enum ManualCalculationWorkflowAction {
    Saved = 'Saved',
    SentForApproval = 'SentForApproval',
    Returned = 'Returned',
    Approved = 'Approved',
  }

  export class CalculationCheckOutDetailsIndexModel
    implements ICalculationCheckOutDetailsIndexModel
  {
    portalId!: string;
    checkedOutByName!: string | null;
    timestamp!: Date;

    constructor(data?: ICalculationCheckOutDetailsIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.checkedOutByName =
          _data['checkedOutByName'] !== undefined
            ? _data['checkedOutByName']
            : <any>null;
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationCheckOutDetailsIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationCheckOutDetailsIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['checkedOutByName'] =
        this.checkedOutByName !== undefined ? this.checkedOutByName : <any>null;
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationCheckOutDetailsIndexModel {
    portalId: string;
    checkedOutByName: string | null;
    timestamp: Date;
  }

  export class CalculationTransactionPlanTypeCount
    implements ICalculationTransactionPlanTypeCount
  {
    planType!: PlanType;
    count!: number;

    constructor(data?: ICalculationTransactionPlanTypeCount) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.count = _data['count'] !== undefined ? _data['count'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationTransactionPlanTypeCount {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationTransactionPlanTypeCount();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['count'] = this.count !== undefined ? this.count : <any>null;
      return data;
    }
  }

  export interface ICalculationTransactionPlanTypeCount {
    planType: PlanType;
    count: number;
  }

  export class PageModelOfTransactionIndexModel
    extends PageModel
    implements IPageModelOfTransactionIndexModel
  {
    items!: TransactionIndexModel[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfTransactionIndexModel) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(TransactionIndexModel.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfTransactionIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfTransactionIndexModel();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfTransactionIndexModel extends IPageModel {
    items: TransactionIndexModel[];
    totalItems: number | null;
  }

  export class TransactionIndexModel implements ITransactionIndexModel {
    transactionGuid!: string;
    transactionId!: string;
    batchDateCreated!: Date;
    calculationDateCreated!: Date;
    transactionDate!: Date;
    clientId!: string;
    clientPortalId!: string;
    batchId!: string;
    employeeId!: string;
    employeeFirstName!: string | null;
    employeeLastName!: string | null;
    batchCalculationType!: BatchCalculationType;
    dateIndexed!: Date;
    planType!: PlanType;
    calculationId!: string;
    manualCalculationRequired!: boolean;
    manualCalculationSendToWorkflow!: boolean;
    calculationStatus!: CalculationStatus;
    transactionStatus!: TransactionStatus | null;

    constructor(data?: ITransactionIndexModel) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.batchDateCreated = _data['batchDateCreated']
          ? new Date(_data['batchDateCreated'].toString())
          : <any>null;
        this.calculationDateCreated = _data['calculationDateCreated']
          ? new Date(_data['calculationDateCreated'].toString())
          : <any>null;
        this.transactionDate = _data['transactionDate']
          ? new Date(_data['transactionDate'].toString())
          : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.employeeFirstName =
          _data['employeeFirstName'] !== undefined
            ? _data['employeeFirstName']
            : <any>null;
        this.employeeLastName =
          _data['employeeLastName'] !== undefined
            ? _data['employeeLastName']
            : <any>null;
        this.batchCalculationType =
          _data['batchCalculationType'] !== undefined
            ? _data['batchCalculationType']
            : <any>null;
        this.dateIndexed = _data['dateIndexed']
          ? new Date(_data['dateIndexed'].toString())
          : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
        this.calculationStatus =
          _data['calculationStatus'] !== undefined
            ? _data['calculationStatus']
            : <any>null;
        this.transactionStatus =
          _data['transactionStatus'] !== undefined
            ? _data['transactionStatus']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionIndexModel {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionIndexModel();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['batchDateCreated'] = this.batchDateCreated
        ? this.batchDateCreated.toISOString()
        : <any>null;
      data['calculationDateCreated'] = this.calculationDateCreated
        ? this.calculationDateCreated.toISOString()
        : <any>null;
      data['transactionDate'] = this.transactionDate
        ? this.transactionDate.toISOString()
        : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['employeeFirstName'] =
        this.employeeFirstName !== undefined
          ? this.employeeFirstName
          : <any>null;
      data['employeeLastName'] =
        this.employeeLastName !== undefined ? this.employeeLastName : <any>null;
      data['batchCalculationType'] =
        this.batchCalculationType !== undefined
          ? this.batchCalculationType
          : <any>null;
      data['dateIndexed'] = this.dateIndexed
        ? this.dateIndexed.toISOString()
        : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      data['calculationStatus'] =
        this.calculationStatus !== undefined
          ? this.calculationStatus
          : <any>null;
      data['transactionStatus'] =
        this.transactionStatus !== undefined
          ? this.transactionStatus
          : <any>null;
      return data;
    }
  }

  export interface ITransactionIndexModel {
    transactionGuid: string;
    transactionId: string;
    batchDateCreated: Date;
    calculationDateCreated: Date;
    transactionDate: Date;
    clientId: string;
    clientPortalId: string;
    batchId: string;
    employeeId: string;
    employeeFirstName: string | null;
    employeeLastName: string | null;
    batchCalculationType: BatchCalculationType;
    dateIndexed: Date;
    planType: PlanType;
    calculationId: string;
    manualCalculationRequired: boolean;
    manualCalculationSendToWorkflow: boolean;
    calculationStatus: CalculationStatus;
    transactionStatus: TransactionStatus | null;
  }

  export class GlobalSearchCommandResultFailure
    extends GlobalSearchCommandResult
    implements IGlobalSearchCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGlobalSearchCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GlobalSearchCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GlobalSearchCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGlobalSearchCommandResultFailure
    extends IGlobalSearchCommandResult {
    errorMessage: string;
  }

  export class SearchCommand implements ISearchCommand {
    clientId!: string;
    search!: SearchBarArgs | null;
    pagination!: SearchPaginationArgs;

    constructor(data?: ISearchCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.pagination = new SearchPaginationArgs();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.search = _data['search']
          ? SearchBarArgs.fromJS(_data['search'])
          : <any>null;
        this.pagination = _data['pagination']
          ? SearchPaginationArgs.fromJS(_data['pagination'])
          : new SearchPaginationArgs();
      }
    }

    static fromJS(data: any): SearchCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['search'] = this.search ? this.search.toJSON() : <any>null;
      data['pagination'] = this.pagination
        ? this.pagination.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISearchCommand {
    clientId: string;
    search: SearchBarArgs | null;
    pagination: SearchPaginationArgs;
  }

  export class SearchBarArgs implements ISearchBarArgs {
    query!: string | null;

    constructor(data?: ISearchBarArgs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.query = _data['query'] !== undefined ? _data['query'] : <any>null;
      }
    }

    static fromJS(data: any): SearchBarArgs {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBarArgs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['query'] = this.query !== undefined ? this.query : <any>null;
      return data;
    }
  }

  export interface ISearchBarArgs {
    query: string | null;
  }

  export class SearchPaginationArgs implements ISearchPaginationArgs {
    page!: number;
    pageSize!: number;

    constructor(data?: ISearchPaginationArgs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.page = _data['page'] !== undefined ? _data['page'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): SearchPaginationArgs {
      data = typeof data === 'object' ? data : {};
      let result = new SearchPaginationArgs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['page'] = this.page !== undefined ? this.page : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface ISearchPaginationArgs {
    page: number;
    pageSize: number;
  }

  export class GetManualCalculationsSettingsQueryResult
    implements IGetManualCalculationsSettingsQueryResult
  {
    constructor(data?: IGetManualCalculationsSettingsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetManualCalculationsSettingsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationsSettingsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetManualCalculationsSettingsQueryResult {}

  export class GetManualCalculationsSettingsQueryResultSuccess
    extends GetManualCalculationsSettingsQueryResult
    implements IGetManualCalculationsSettingsQueryResultSuccess
  {
    result!: ManualCalculationPageData;

    constructor(data?: IGetManualCalculationsSettingsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ManualCalculationPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ManualCalculationPageData.fromJS(_data['result'])
          : new ManualCalculationPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationsSettingsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationsSettingsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationsSettingsQueryResultSuccess
    extends IGetManualCalculationsSettingsQueryResult {
    result: ManualCalculationPageData;
  }

  export class ManualCalculationPageData implements IManualCalculationPageData {
    manualCalculationsSettings!: ManualCalculationsSettingsDto | null;

    constructor(data?: IManualCalculationPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.manualCalculationsSettings = _data['manualCalculationsSettings']
          ? ManualCalculationsSettingsDto.fromJS(
              _data['manualCalculationsSettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['manualCalculationsSettings'] = this.manualCalculationsSettings
        ? this.manualCalculationsSettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationPageData {
    manualCalculationsSettings: ManualCalculationsSettingsDto | null;
  }

  export class ManualCalculationsSettingsDto
    implements IManualCalculationsSettingsDto
  {
    clientId!: string;
    manualCalculationsConfigured!: boolean;
    highWithholdingConfig!: HighWithholdingConfigDto | null;
    highTotalGainConfig!: HighTotalGainConfigDto | null;
    preVestCalc!: boolean;
    testCalc!: boolean;

    constructor(data?: IManualCalculationsSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.manualCalculationsConfigured =
          _data['manualCalculationsConfigured'] !== undefined
            ? _data['manualCalculationsConfigured']
            : <any>null;
        this.highWithholdingConfig = _data['highWithholdingConfig']
          ? HighWithholdingConfigDto.fromJS(_data['highWithholdingConfig'])
          : <any>null;
        this.highTotalGainConfig = _data['highTotalGainConfig']
          ? HighTotalGainConfigDto.fromJS(_data['highTotalGainConfig'])
          : <any>null;
        this.preVestCalc =
          _data['preVestCalc'] !== undefined ? _data['preVestCalc'] : <any>null;
        this.testCalc =
          _data['testCalc'] !== undefined ? _data['testCalc'] : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationsSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationsSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['manualCalculationsConfigured'] =
        this.manualCalculationsConfigured !== undefined
          ? this.manualCalculationsConfigured
          : <any>null;
      data['highWithholdingConfig'] = this.highWithholdingConfig
        ? this.highWithholdingConfig.toJSON()
        : <any>null;
      data['highTotalGainConfig'] = this.highTotalGainConfig
        ? this.highTotalGainConfig.toJSON()
        : <any>null;
      data['preVestCalc'] =
        this.preVestCalc !== undefined ? this.preVestCalc : <any>null;
      data['testCalc'] =
        this.testCalc !== undefined ? this.testCalc : <any>null;
      return data;
    }
  }

  export interface IManualCalculationsSettingsDto {
    clientId: string;
    manualCalculationsConfigured: boolean;
    highWithholdingConfig: HighWithholdingConfigDto | null;
    highTotalGainConfig: HighTotalGainConfigDto | null;
    preVestCalc: boolean;
    testCalc: boolean;
  }

  export class HighWithholdingConfigDto implements IHighWithholdingConfigDto {
    highWithholdingAmount!: number;

    constructor(data?: IHighWithholdingConfigDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.highWithholdingAmount =
          _data['highWithholdingAmount'] !== undefined
            ? _data['highWithholdingAmount']
            : <any>null;
      }
    }

    static fromJS(data: any): HighWithholdingConfigDto {
      data = typeof data === 'object' ? data : {};
      let result = new HighWithholdingConfigDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['highWithholdingAmount'] =
        this.highWithholdingAmount !== undefined
          ? this.highWithholdingAmount
          : <any>null;
      return data;
    }
  }

  export interface IHighWithholdingConfigDto {
    highWithholdingAmount: number;
  }

  export class HighTotalGainConfigDto implements IHighTotalGainConfigDto {
    highTotalGainAmount!: number;
    highTotalGainCurrency!: string;

    constructor(data?: IHighTotalGainConfigDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.highTotalGainAmount =
          _data['highTotalGainAmount'] !== undefined
            ? _data['highTotalGainAmount']
            : <any>null;
        this.highTotalGainCurrency =
          _data['highTotalGainCurrency'] !== undefined
            ? _data['highTotalGainCurrency']
            : <any>null;
      }
    }

    static fromJS(data: any): HighTotalGainConfigDto {
      data = typeof data === 'object' ? data : {};
      let result = new HighTotalGainConfigDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['highTotalGainAmount'] =
        this.highTotalGainAmount !== undefined
          ? this.highTotalGainAmount
          : <any>null;
      data['highTotalGainCurrency'] =
        this.highTotalGainCurrency !== undefined
          ? this.highTotalGainCurrency
          : <any>null;
      return data;
    }
  }

  export interface IHighTotalGainConfigDto {
    highTotalGainAmount: number;
    highTotalGainCurrency: string;
  }

  export class GetManualCalculationsSettingsQueryResultFailure
    extends GetManualCalculationsSettingsQueryResult
    implements IGetManualCalculationsSettingsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetManualCalculationsSettingsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationsSettingsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationsSettingsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationsSettingsQueryResultFailure
    extends IGetManualCalculationsSettingsQueryResult {
    errors: ResultError[];
  }

  export class SaveManualCalculationsSettingsCommandResult
    implements ISaveManualCalculationsSettingsCommandResult
  {
    constructor(data?: ISaveManualCalculationsSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveManualCalculationsSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveManualCalculationsSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveManualCalculationsSettingsCommandResult {}

  export class SaveManualCalculationsSettingsCommandResultSuccess
    extends SaveManualCalculationsSettingsCommandResult
    implements ISaveManualCalculationsSettingsCommandResultSuccess
  {
    constructor(data?: ISaveManualCalculationsSettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveManualCalculationsSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveManualCalculationsSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveManualCalculationsSettingsCommandResultSuccess
    extends ISaveManualCalculationsSettingsCommandResult {}

  export class SaveManualCalculationsSettingsCommandResultFailure
    extends SaveManualCalculationsSettingsCommandResult
    implements ISaveManualCalculationsSettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveManualCalculationsSettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveManualCalculationsSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveManualCalculationsSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveManualCalculationsSettingsCommandResultFailure
    extends ISaveManualCalculationsSettingsCommandResult {
    errors: ResultError[];
  }

  export class SaveManualCalculationsSettingsCommand
    implements ISaveManualCalculationsSettingsCommand
  {
    clientId!: string;
    manualCalculationsConfigured!: boolean;
    highWithholdingConfig!: HighWithholdingConfigDto | null;
    highTotalGainConfig!: HighTotalGainConfigDto | null;
    preVestCalc!: boolean;
    testCalc!: boolean;

    constructor(data?: ISaveManualCalculationsSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.manualCalculationsConfigured =
          _data['manualCalculationsConfigured'] !== undefined
            ? _data['manualCalculationsConfigured']
            : <any>null;
        this.highWithholdingConfig = _data['highWithholdingConfig']
          ? HighWithholdingConfigDto.fromJS(_data['highWithholdingConfig'])
          : <any>null;
        this.highTotalGainConfig = _data['highTotalGainConfig']
          ? HighTotalGainConfigDto.fromJS(_data['highTotalGainConfig'])
          : <any>null;
        this.preVestCalc =
          _data['preVestCalc'] !== undefined ? _data['preVestCalc'] : <any>null;
        this.testCalc =
          _data['testCalc'] !== undefined ? _data['testCalc'] : <any>null;
      }
    }

    static fromJS(data: any): SaveManualCalculationsSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveManualCalculationsSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['manualCalculationsConfigured'] =
        this.manualCalculationsConfigured !== undefined
          ? this.manualCalculationsConfigured
          : <any>null;
      data['highWithholdingConfig'] = this.highWithholdingConfig
        ? this.highWithholdingConfig.toJSON()
        : <any>null;
      data['highTotalGainConfig'] = this.highTotalGainConfig
        ? this.highTotalGainConfig.toJSON()
        : <any>null;
      data['preVestCalc'] =
        this.preVestCalc !== undefined ? this.preVestCalc : <any>null;
      data['testCalc'] =
        this.testCalc !== undefined ? this.testCalc : <any>null;
      return data;
    }
  }

  export interface ISaveManualCalculationsSettingsCommand {
    clientId: string;
    manualCalculationsConfigured: boolean;
    highWithholdingConfig: HighWithholdingConfigDto | null;
    highTotalGainConfig: HighTotalGainConfigDto | null;
    preVestCalc: boolean;
    testCalc: boolean;
  }

  export abstract class LogMetricsCommandResult
    implements ILogMetricsCommandResult
  {
    constructor(data?: ILogMetricsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): LogMetricsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'LogMetricsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ILogMetricsCommandResult {}

  export class LogMetricsCommandResultSuccess
    extends LogMetricsCommandResult
    implements ILogMetricsCommandResultSuccess
  {
    constructor(data?: ILogMetricsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): LogMetricsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new LogMetricsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ILogMetricsCommandResultSuccess
    extends ILogMetricsCommandResult {}

  export class LogMetricsCommandResultFailure
    extends LogMetricsCommandResult
    implements ILogMetricsCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ILogMetricsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): LogMetricsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new LogMetricsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ILogMetricsCommandResultFailure
    extends ILogMetricsCommandResult {
    errorMessage: string;
  }

  export class LogMetricsCommand implements ILogMetricsCommand {
    metrics!: LogMetric[];

    constructor(data?: ILogMetricsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.metrics = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['metrics'])) {
          this.metrics = [] as any;
          for (let item of _data['metrics'])
            this.metrics!.push(LogMetric.fromJS(item));
        } else {
          this.metrics = <any>null;
        }
      }
    }

    static fromJS(data: any): LogMetricsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new LogMetricsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.metrics)) {
        data['metrics'] = [];
        for (let item of this.metrics) data['metrics'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILogMetricsCommand {
    metrics: LogMetric[];
  }

  export class LogMetric implements ILogMetric {
    name!: string;
    namespace!: string;
    unit!: Unit;
    storageResolution!: StorageResolution | null;
    value!: number;
    properties!: { [key: string]: any } | null;

    constructor(data?: ILogMetric) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.namespace =
          _data['namespace'] !== undefined ? _data['namespace'] : <any>null;
        this.unit = _data['unit'] !== undefined ? _data['unit'] : <any>null;
        this.storageResolution =
          _data['storageResolution'] !== undefined
            ? _data['storageResolution']
            : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        if (_data['properties']) {
          this.properties = {} as any;
          for (let key in _data['properties']) {
            if (_data['properties'].hasOwnProperty(key))
              (<any>this.properties)![key] =
                _data['properties'][key] !== undefined
                  ? _data['properties'][key]
                  : <any>null;
          }
        } else {
          this.properties = <any>null;
        }
      }
    }

    static fromJS(data: any): LogMetric {
      data = typeof data === 'object' ? data : {};
      let result = new LogMetric();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['namespace'] =
        this.namespace !== undefined ? this.namespace : <any>null;
      data['unit'] = this.unit !== undefined ? this.unit : <any>null;
      data['storageResolution'] =
        this.storageResolution !== undefined
          ? this.storageResolution
          : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      if (this.properties) {
        data['properties'] = {};
        for (let key in this.properties) {
          if (this.properties.hasOwnProperty(key))
            (<any>data['properties'])[key] =
              this.properties[key] !== undefined
                ? this.properties[key]
                : <any>null;
        }
      }
      return data;
    }
  }

  export interface ILogMetric {
    name: string;
    namespace: string;
    unit: Unit;
    storageResolution: StorageResolution | null;
    value: number;
    properties: { [key: string]: any } | null;
  }

  export enum Unit {
    NONE = 'None',
    SECONDS = 'Seconds',
    MICROSECONDS = 'Microseconds',
    MILLISECONDS = 'Milliseconds',
    BYTES = 'Bytes',
    KILOBYTES = 'Kilobytes',
    MEGABYTES = 'Megabytes',
    GIGABYTES = 'Gigabytes',
    TERABYTES = 'Terabytes',
    BITS = 'Bits',
    KILOBITS = 'Kilobits',
    MEGABITS = 'Megabits',
    GIGABITS = 'Gigabits',
    TERABITS = 'Terabits',
    PERCENT = 'Percent',
    COUNT = 'Count',
    BYTES_PER_SECOND = 'Bytes/Second',
    KILOBYTES_PER_SECOND = 'Kilobytes/Second',
    MEGABYTES_PER_SECOND = 'Megabytes/Second',
    GIGABYTES_PER_SECOND = 'Gigabytes/Second',
    TERABYTES_PER_SECOND = 'Terabytes/Second',
    BITS_PER_SECOND = 'Bits/Second',
    KILOBITS_PER_SECOND = 'Kilobits/Second',
    MEGABITS_PER_SECOND = 'Megabits/Second',
    GIGABITS_PER_SECOND = 'Gigabits/Second',
    TERABITS_PER_SECOND = 'Terabits/Second',
    COUNT_PER_SECOND = 'Count/Second',
  }

  export enum StorageResolution {
    HIGH = 'HIGH',
    STANDARD = 'STANDARD',
  }

  export class GetLiveEventDetailsResult implements IGetLiveEventDetailsResult {
    constructor(data?: IGetLiveEventDetailsResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetLiveEventDetailsResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetLiveEventDetailsResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetLiveEventDetailsResult {}

  export class GetLiveEventDetailsResultSuccess
    extends GetLiveEventDetailsResult
    implements IGetLiveEventDetailsResultSuccess
  {
    result!: LiveEventsPageData;

    constructor(data?: IGetLiveEventDetailsResultSuccess) {
      super(data);
      if (!data) {
        this.result = new LiveEventsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? LiveEventsPageData.fromJS(_data['result'])
          : new LiveEventsPageData();
      }
    }

    static override fromJS(data: any): GetLiveEventDetailsResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetLiveEventDetailsResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLiveEventDetailsResultSuccess
    extends IGetLiveEventDetailsResult {
    result: LiveEventsPageData;
  }

  export class LiveEventsPageData implements ILiveEventsPageData {
    liveEventDetails!: LiveEventDetailsDto | null;
    planTypes!: LiveEventPlanTypeDto[];
    eventTypes!: LiveEventTypeDto[];
    frequencyTypes!: LiveEventFrequencyDto[];

    constructor(data?: ILiveEventsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.eventTypes = [];
        this.frequencyTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.liveEventDetails = _data['liveEventDetails']
          ? LiveEventDetailsDto.fromJS(_data['liveEventDetails'])
          : <any>null;
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(LiveEventPlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['eventTypes'])) {
          this.eventTypes = [] as any;
          for (let item of _data['eventTypes'])
            this.eventTypes!.push(LiveEventTypeDto.fromJS(item));
        } else {
          this.eventTypes = <any>null;
        }
        if (Array.isArray(_data['frequencyTypes'])) {
          this.frequencyTypes = [] as any;
          for (let item of _data['frequencyTypes'])
            this.frequencyTypes!.push(LiveEventFrequencyDto.fromJS(item));
        } else {
          this.frequencyTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): LiveEventsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['liveEventDetails'] = this.liveEventDetails
        ? this.liveEventDetails.toJSON()
        : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.eventTypes)) {
        data['eventTypes'] = [];
        for (let item of this.eventTypes)
          data['eventTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.frequencyTypes)) {
        data['frequencyTypes'] = [];
        for (let item of this.frequencyTypes)
          data['frequencyTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILiveEventsPageData {
    liveEventDetails: LiveEventDetailsDto | null;
    planTypes: LiveEventPlanTypeDto[];
    eventTypes: LiveEventTypeDto[];
    frequencyTypes: LiveEventFrequencyDto[];
  }

  export class LiveEventDetailsDto implements ILiveEventDetailsDto {
    id!: string;
    liveEventItems!: LiveEventItemDto[];

    constructor(data?: ILiveEventDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.liveEventItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['liveEventItems'])) {
          this.liveEventItems = [] as any;
          for (let item of _data['liveEventItems'])
            this.liveEventItems!.push(LiveEventItemDto.fromJS(item));
        } else {
          this.liveEventItems = <any>null;
        }
      }
    }

    static fromJS(data: any): LiveEventDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.liveEventItems)) {
        data['liveEventItems'] = [];
        for (let item of this.liveEventItems)
          data['liveEventItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILiveEventDetailsDto {
    id: string;
    liveEventItems: LiveEventItemDto[];
  }

  export class LiveEventItemDto implements ILiveEventItemDto {
    id!: string;
    eventType!: LiveEventType;
    planType!: PlanType;
    frequency!: LiveEventFrequencyType;
    startDate!: Date;
    endDate!: Date;
    expectedVolume!: number;
    dateCreated!: Date;
    vestScheduleItems!: VestScheduleItemDto[];

    constructor(data?: ILiveEventItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.vestScheduleItems = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.eventType =
          _data['eventType'] !== undefined ? _data['eventType'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.frequency =
          _data['frequency'] !== undefined ? _data['frequency'] : <any>null;
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.expectedVolume =
          _data['expectedVolume'] !== undefined
            ? _data['expectedVolume']
            : <any>null;
        this.dateCreated = _data['dateCreated']
          ? new Date(_data['dateCreated'].toString())
          : <any>null;
        if (Array.isArray(_data['vestScheduleItems'])) {
          this.vestScheduleItems = [] as any;
          for (let item of _data['vestScheduleItems'])
            this.vestScheduleItems!.push(VestScheduleItemDto.fromJS(item));
        } else {
          this.vestScheduleItems = <any>null;
        }
      }
    }

    static fromJS(data: any): LiveEventItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['eventType'] =
        this.eventType !== undefined ? this.eventType : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['frequency'] =
        this.frequency !== undefined ? this.frequency : <any>null;
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['expectedVolume'] =
        this.expectedVolume !== undefined ? this.expectedVolume : <any>null;
      data['dateCreated'] = this.dateCreated
        ? this.dateCreated.toISOString()
        : <any>null;
      if (Array.isArray(this.vestScheduleItems)) {
        data['vestScheduleItems'] = [];
        for (let item of this.vestScheduleItems)
          data['vestScheduleItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILiveEventItemDto {
    id: string;
    eventType: LiveEventType;
    planType: PlanType;
    frequency: LiveEventFrequencyType;
    startDate: Date;
    endDate: Date;
    expectedVolume: number;
    dateCreated: Date;
    vestScheduleItems: VestScheduleItemDto[];
  }

  export enum LiveEventType {
    Payment = 'Payment',
    PreVest = 'PreVest',
    Test = 'Test',
    Vest = 'Vest',
    Exercises = 'Exercises',
  }

  export enum LiveEventFrequencyType {
    DailyWithWeekends = 'DailyWithWeekends',
    DailyWithoutWeekends = 'DailyWithoutWeekends',
    Monthly = 'Monthly',
    OneTime = 'OneTime',
    Quarterly = 'Quarterly',
    Annual = 'Annual',
  }

  export class VestScheduleItemDto implements IVestScheduleItemDto {
    vestDate!: Date;
    vestDay!: string;

    constructor(data?: IVestScheduleItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.vestDate = _data['vestDate']
          ? new Date(_data['vestDate'].toString())
          : <any>null;
        this.vestDay =
          _data['vestDay'] !== undefined ? _data['vestDay'] : <any>null;
      }
    }

    static fromJS(data: any): VestScheduleItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new VestScheduleItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['vestDate'] = this.vestDate
        ? this.vestDate.toISOString()
        : <any>null;
      data['vestDay'] = this.vestDay !== undefined ? this.vestDay : <any>null;
      return data;
    }
  }

  export interface IVestScheduleItemDto {
    vestDate: Date;
    vestDay: string;
  }

  export class LiveEventPlanTypeDto implements ILiveEventPlanTypeDto {
    optionValue!: PlanType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ILiveEventPlanTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): LiveEventPlanTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventPlanTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ILiveEventPlanTypeDto {
    optionValue: PlanType;
    displayValue: string;
    displayOrder: number;
  }

  export class LiveEventTypeDto implements ILiveEventTypeDto {
    optionValue!: LiveEventType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ILiveEventTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): LiveEventTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ILiveEventTypeDto {
    optionValue: LiveEventType;
    displayValue: string;
    displayOrder: number;
  }

  export class LiveEventFrequencyDto implements ILiveEventFrequencyDto {
    optionValue!: LiveEventFrequencyType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ILiveEventFrequencyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): LiveEventFrequencyDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiveEventFrequencyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ILiveEventFrequencyDto {
    optionValue: LiveEventFrequencyType;
    displayValue: string;
    displayOrder: number;
  }

  export class GetLiveEventDetailsResultFailure
    extends GetLiveEventDetailsResult
    implements IGetLiveEventDetailsResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetLiveEventDetailsResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetLiveEventDetailsResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetLiveEventDetailsResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLiveEventDetailsResultFailure
    extends IGetLiveEventDetailsResult {
    errors: ResultError[];
  }

  export class UpsertLiveEventItemCommandResult
    implements IUpsertLiveEventItemCommandResult
  {
    constructor(data?: IUpsertLiveEventItemCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertLiveEventItemCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertLiveEventItemCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertLiveEventItemCommandResult {}

  export class UpsertLiveEventItemCommandResultSuccess
    extends UpsertLiveEventItemCommandResult
    implements IUpsertLiveEventItemCommandResultSuccess
  {
    result!: LiveEventDetailsDto;

    constructor(data?: IUpsertLiveEventItemCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new LiveEventDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? LiveEventDetailsDto.fromJS(_data['result'])
          : new LiveEventDetailsDto();
      }
    }

    static override fromJS(data: any): UpsertLiveEventItemCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertLiveEventItemCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertLiveEventItemCommandResultSuccess
    extends IUpsertLiveEventItemCommandResult {
    result: LiveEventDetailsDto;
  }

  export class UpsertLiveEventItemCommandResultFailure
    extends UpsertLiveEventItemCommandResult
    implements IUpsertLiveEventItemCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertLiveEventItemCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpsertLiveEventItemCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertLiveEventItemCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertLiveEventItemCommandResultFailure
    extends IUpsertLiveEventItemCommandResult {
    errors: ResultError[];
  }

  export class UpsertLiveEventItemCommand
    implements IUpsertLiveEventItemCommand
  {
    clientId!: string;
    liveEventItemId!: string | null;
    eventType!: LiveEventType;
    planType!: PlanType;
    frequency!: LiveEventFrequencyType;
    startDate!: Date;
    endDate!: Date;
    expectedVolume!: number;

    constructor(data?: IUpsertLiveEventItemCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.liveEventItemId =
          _data['liveEventItemId'] !== undefined
            ? _data['liveEventItemId']
            : <any>null;
        this.eventType =
          _data['eventType'] !== undefined ? _data['eventType'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.frequency =
          _data['frequency'] !== undefined ? _data['frequency'] : <any>null;
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.expectedVolume =
          _data['expectedVolume'] !== undefined
            ? _data['expectedVolume']
            : <any>null;
      }
    }

    static fromJS(data: any): UpsertLiveEventItemCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertLiveEventItemCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['liveEventItemId'] =
        this.liveEventItemId !== undefined ? this.liveEventItemId : <any>null;
      data['eventType'] =
        this.eventType !== undefined ? this.eventType : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['frequency'] =
        this.frequency !== undefined ? this.frequency : <any>null;
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['expectedVolume'] =
        this.expectedVolume !== undefined ? this.expectedVolume : <any>null;
      return data;
    }
  }

  export interface IUpsertLiveEventItemCommand {
    clientId: string;
    liveEventItemId: string | null;
    eventType: LiveEventType;
    planType: PlanType;
    frequency: LiveEventFrequencyType;
    startDate: Date;
    endDate: Date;
    expectedVolume: number;
  }

  export class DeleteLiveEventItemCommandResult
    implements IDeleteLiveEventItemCommandResult
  {
    constructor(data?: IDeleteLiveEventItemCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteLiveEventItemCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteLiveEventItemCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteLiveEventItemCommandResult {}

  export class DeleteLiveEventItemCommandResultSuccess
    extends DeleteLiveEventItemCommandResult
    implements IDeleteLiveEventItemCommandResultSuccess
  {
    constructor(data?: IDeleteLiveEventItemCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): DeleteLiveEventItemCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteLiveEventItemCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteLiveEventItemCommandResultSuccess
    extends IDeleteLiveEventItemCommandResult {}

  export class DeleteLiveEventItemCommandResultFailure
    extends DeleteLiveEventItemCommandResult
    implements IDeleteLiveEventItemCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteLiveEventItemCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): DeleteLiveEventItemCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteLiveEventItemCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteLiveEventItemCommandResultFailure
    extends IDeleteLiveEventItemCommandResult {
    errors: ResultError[];
  }

  export class UpdateVestScheduleCommandResult
    implements IUpdateVestScheduleCommandResult
  {
    constructor(data?: IUpdateVestScheduleCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateVestScheduleCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateVestScheduleCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateVestScheduleCommandResult {}

  export class UpdateVestScheduleCommandResultSuccess
    extends UpdateVestScheduleCommandResult
    implements IUpdateVestScheduleCommandResultSuccess
  {
    constructor(data?: IUpdateVestScheduleCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpdateVestScheduleCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateVestScheduleCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateVestScheduleCommandResultSuccess
    extends IUpdateVestScheduleCommandResult {}

  export class UpdateVestScheduleCommandResultFailure
    extends UpdateVestScheduleCommandResult
    implements IUpdateVestScheduleCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateVestScheduleCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpdateVestScheduleCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateVestScheduleCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateVestScheduleCommandResultFailure
    extends IUpdateVestScheduleCommandResult {
    errors: ResultError[];
  }

  export class UpdateVestScheduleCommand implements IUpdateVestScheduleCommand {
    clientId!: string;
    liveEventItemId!: string;
    vestDates!: Date[];

    constructor(data?: IUpdateVestScheduleCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.vestDates = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.liveEventItemId =
          _data['liveEventItemId'] !== undefined
            ? _data['liveEventItemId']
            : <any>null;
        if (Array.isArray(_data['vestDates'])) {
          this.vestDates = [] as any;
          for (let item of _data['vestDates'])
            this.vestDates!.push(new Date(item));
        } else {
          this.vestDates = <any>null;
        }
      }
    }

    static fromJS(data: any): UpdateVestScheduleCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateVestScheduleCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['liveEventItemId'] =
        this.liveEventItemId !== undefined ? this.liveEventItemId : <any>null;
      if (Array.isArray(this.vestDates)) {
        data['vestDates'] = [];
        for (let item of this.vestDates)
          data['vestDates'].push(item.toISOString());
      }
      return data;
    }
  }

  export interface IUpdateVestScheduleCommand {
    clientId: string;
    liveEventItemId: string;
    vestDates: Date[];
  }

  export class SaveLiveEventDetailsCommandResult
    implements ISaveLiveEventDetailsCommandResult
  {
    constructor(data?: ISaveLiveEventDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveLiveEventDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveLiveEventDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveLiveEventDetailsCommandResult {}

  export class SaveLiveEventDetailsCommandResultSuccess
    extends SaveLiveEventDetailsCommandResult
    implements ISaveLiveEventDetailsCommandResultSuccess
  {
    constructor(data?: ISaveLiveEventDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveLiveEventDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveLiveEventDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveLiveEventDetailsCommandResultSuccess
    extends ISaveLiveEventDetailsCommandResult {}

  export class SaveLiveEventDetailsCommandResultFailure
    extends SaveLiveEventDetailsCommandResult
    implements ISaveLiveEventDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveLiveEventDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveLiveEventDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveLiveEventDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveLiveEventDetailsCommandResultFailure
    extends ISaveLiveEventDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveLiveEventDetailsCommand
    implements ISaveLiveEventDetailsCommand
  {
    clientId!: string;

    constructor(data?: ISaveLiveEventDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveLiveEventDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveLiveEventDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveLiveEventDetailsCommand {
    clientId: string;
  }

  export class SaveEmployeePopulationDetailsCommandResult
    implements ISaveEmployeePopulationDetailsCommandResult
  {
    constructor(data?: ISaveEmployeePopulationDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveEmployeePopulationDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveEmployeePopulationDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveEmployeePopulationDetailsCommandResult {}

  export class SaveEmployeePopulationDetailsCommandResultSuccess
    extends SaveEmployeePopulationDetailsCommandResult
    implements ISaveEmployeePopulationDetailsCommandResultSuccess
  {
    constructor(data?: ISaveEmployeePopulationDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveEmployeePopulationDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveEmployeePopulationDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveEmployeePopulationDetailsCommandResultSuccess
    extends ISaveEmployeePopulationDetailsCommandResult {}

  export class SaveEmployeePopulationDetailsCommandResultFailure
    extends SaveEmployeePopulationDetailsCommandResult
    implements ISaveEmployeePopulationDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveEmployeePopulationDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveEmployeePopulationDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveEmployeePopulationDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveEmployeePopulationDetailsCommandResultFailure
    extends ISaveEmployeePopulationDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveEmployeePopulationDetailsCommand
    implements ISaveEmployeePopulationDetailsCommand
  {
    clientId!: string;

    constructor(data?: ISaveEmployeePopulationDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveEmployeePopulationDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveEmployeePopulationDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveEmployeePopulationDetailsCommand {
    clientId: string;
  }

  export class GetEmployeePopulationDetailsQueryResult
    implements IGetEmployeePopulationDetailsQueryResult
  {
    constructor(data?: IGetEmployeePopulationDetailsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEmployeePopulationDetailsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeePopulationDetailsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEmployeePopulationDetailsQueryResult {}

  export class GetEmployeePopulationDetailsQueryResultSuccess
    extends GetEmployeePopulationDetailsQueryResult
    implements IGetEmployeePopulationDetailsQueryResultSuccess
  {
    result!: EmployeePopulationPageData;

    constructor(data?: IGetEmployeePopulationDetailsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new EmployeePopulationPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? EmployeePopulationPageData.fromJS(_data['result'])
          : new EmployeePopulationPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeePopulationDetailsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeePopulationDetailsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeePopulationDetailsQueryResultSuccess
    extends IGetEmployeePopulationDetailsQueryResult {
    result: EmployeePopulationPageData;
  }

  export class EmployeePopulationPageData
    implements IEmployeePopulationPageData
  {
    workLocationType!: EmployeePopulationWorkLocationDto[];
    employeePopulationData!: EmployeePopulationDetailsDto | null;

    constructor(data?: IEmployeePopulationPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationType = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['workLocationType'])) {
          this.workLocationType = [] as any;
          for (let item of _data['workLocationType'])
            this.workLocationType!.push(
              EmployeePopulationWorkLocationDto.fromJS(item),
            );
        } else {
          this.workLocationType = <any>null;
        }
        this.employeePopulationData = _data['employeePopulationData']
          ? EmployeePopulationDetailsDto.fromJS(_data['employeePopulationData'])
          : <any>null;
      }
    }

    static fromJS(data: any): EmployeePopulationPageData {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeePopulationPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationType)) {
        data['workLocationType'] = [];
        for (let item of this.workLocationType)
          data['workLocationType'].push(item.toJSON());
      }
      data['employeePopulationData'] = this.employeePopulationData
        ? this.employeePopulationData.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IEmployeePopulationPageData {
    workLocationType: EmployeePopulationWorkLocationDto[];
    employeePopulationData: EmployeePopulationDetailsDto | null;
  }

  export class EmployeePopulationWorkLocationDto
    implements IEmployeePopulationWorkLocationDto
  {
    optionValue!: WorkLocationTypeSetting;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IEmployeePopulationWorkLocationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): EmployeePopulationWorkLocationDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeePopulationWorkLocationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IEmployeePopulationWorkLocationDto {
    optionValue: WorkLocationTypeSetting;
    displayValue: string;
    displayOrder: number;
  }

  export class EmployeePopulationDetailsDto
    implements IEmployeePopulationDetailsDto
  {
    id!: string;
    employeePopulationPolicyDetails!: EmployeePopulationPolicyDetailsDto[];

    constructor(data?: IEmployeePopulationDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employeePopulationPolicyDetails = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['employeePopulationPolicyDetails'])) {
          this.employeePopulationPolicyDetails = [] as any;
          for (let item of _data['employeePopulationPolicyDetails'])
            this.employeePopulationPolicyDetails!.push(
              EmployeePopulationPolicyDetailsDto.fromJS(item),
            );
        } else {
          this.employeePopulationPolicyDetails = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeePopulationDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeePopulationDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.employeePopulationPolicyDetails)) {
        data['employeePopulationPolicyDetails'] = [];
        for (let item of this.employeePopulationPolicyDetails)
          data['employeePopulationPolicyDetails'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeePopulationDetailsDto {
    id: string;
    employeePopulationPolicyDetails: EmployeePopulationPolicyDetailsDto[];
  }

  export class GetEmployeePopulationDetailsQueryResultFailure
    extends GetEmployeePopulationDetailsQueryResult
    implements IGetEmployeePopulationDetailsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetEmployeePopulationDetailsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeePopulationDetailsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeePopulationDetailsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeePopulationDetailsQueryResultFailure
    extends IGetEmployeePopulationDetailsQueryResult {
    errors: ResultError[];
  }

  export class AddEmployeePopulationPolicyDetailsCommandResult
    implements IAddEmployeePopulationPolicyDetailsCommandResult
  {
    constructor(data?: IAddEmployeePopulationPolicyDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddEmployeePopulationPolicyDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new AddEmployeePopulationPolicyDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddEmployeePopulationPolicyDetailsCommandResult {}

  export class AddEmployeePopulationPolicyDetailsCommandResultSuccess
    extends AddEmployeePopulationPolicyDetailsCommandResult
    implements IAddEmployeePopulationPolicyDetailsCommandResultSuccess
  {
    result!: EmployeePopulationDetailsDto;

    constructor(
      data?: IAddEmployeePopulationPolicyDetailsCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new EmployeePopulationDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? EmployeePopulationDetailsDto.fromJS(_data['result'])
          : new EmployeePopulationDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): AddEmployeePopulationPolicyDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddEmployeePopulationPolicyDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddEmployeePopulationPolicyDetailsCommandResultSuccess
    extends IAddEmployeePopulationPolicyDetailsCommandResult {
    result: EmployeePopulationDetailsDto;
  }

  export class AddEmployeePopulationPolicyDetailsCommandResultFailure
    extends AddEmployeePopulationPolicyDetailsCommandResult
    implements IAddEmployeePopulationPolicyDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IAddEmployeePopulationPolicyDetailsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): AddEmployeePopulationPolicyDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddEmployeePopulationPolicyDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddEmployeePopulationPolicyDetailsCommandResultFailure
    extends IAddEmployeePopulationPolicyDetailsCommandResult {
    errors: ResultError[];
  }

  export class AddEmployeePopulationPolicyDetailsCommand
    implements IAddEmployeePopulationPolicyDetailsCommand
  {
    clientId!: string;
    clientPolicyName!: string;
    clientPolicyWorkLocationTypeId!: WorkLocationTypeSetting;
    teqConsidered!: boolean;

    constructor(data?: IAddEmployeePopulationPolicyDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyWorkLocationTypeId =
          _data['clientPolicyWorkLocationTypeId'] !== undefined
            ? _data['clientPolicyWorkLocationTypeId']
            : <any>null;
        this.teqConsidered =
          _data['teqConsidered'] !== undefined
            ? _data['teqConsidered']
            : <any>null;
      }
    }

    static fromJS(data: any): AddEmployeePopulationPolicyDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddEmployeePopulationPolicyDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyWorkLocationTypeId'] =
        this.clientPolicyWorkLocationTypeId !== undefined
          ? this.clientPolicyWorkLocationTypeId
          : <any>null;
      data['teqConsidered'] =
        this.teqConsidered !== undefined ? this.teqConsidered : <any>null;
      return data;
    }
  }

  export interface IAddEmployeePopulationPolicyDetailsCommand {
    clientId: string;
    clientPolicyName: string;
    clientPolicyWorkLocationTypeId: WorkLocationTypeSetting;
    teqConsidered: boolean;
  }

  export class UpdateEmployeePopulationPolicyDetailsCommandResult
    implements IUpdateEmployeePopulationPolicyDetailsCommandResult
  {
    constructor(data?: IUpdateEmployeePopulationPolicyDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpdateEmployeePopulationPolicyDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateEmployeePopulationPolicyDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateEmployeePopulationPolicyDetailsCommandResult {}

  export class UpdateEmployeePopulationPolicyDetailsCommandResultSuccess
    extends UpdateEmployeePopulationPolicyDetailsCommandResult
    implements IUpdateEmployeePopulationPolicyDetailsCommandResultSuccess
  {
    result!: EmployeePopulationDetailsDto;

    constructor(
      data?: IUpdateEmployeePopulationPolicyDetailsCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = new EmployeePopulationDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? EmployeePopulationDetailsDto.fromJS(_data['result'])
          : new EmployeePopulationDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpdateEmployeePopulationPolicyDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpdateEmployeePopulationPolicyDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateEmployeePopulationPolicyDetailsCommandResultSuccess
    extends IUpdateEmployeePopulationPolicyDetailsCommandResult {
    result: EmployeePopulationDetailsDto;
  }

  export class UpdateEmployeePopulationPolicyDetailsCommandResultFailure
    extends UpdateEmployeePopulationPolicyDetailsCommandResult
    implements IUpdateEmployeePopulationPolicyDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IUpdateEmployeePopulationPolicyDetailsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpdateEmployeePopulationPolicyDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpdateEmployeePopulationPolicyDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateEmployeePopulationPolicyDetailsCommandResultFailure
    extends IUpdateEmployeePopulationPolicyDetailsCommandResult {
    errors: ResultError[];
  }

  export class UpdateEmployeePopulationPolicyDetailsCommand
    implements IUpdateEmployeePopulationPolicyDetailsCommand
  {
    clientId!: string;
    employeePopulationPolicyDetailsId!: string;
    clientPolicyName!: string;
    clientPolicyWorkLocationTypeId!: WorkLocationTypeSetting;
    teqConsidered!: boolean;

    constructor(data?: IUpdateEmployeePopulationPolicyDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.employeePopulationPolicyDetailsId =
          _data['employeePopulationPolicyDetailsId'] !== undefined
            ? _data['employeePopulationPolicyDetailsId']
            : <any>null;
        this.clientPolicyName =
          _data['clientPolicyName'] !== undefined
            ? _data['clientPolicyName']
            : <any>null;
        this.clientPolicyWorkLocationTypeId =
          _data['clientPolicyWorkLocationTypeId'] !== undefined
            ? _data['clientPolicyWorkLocationTypeId']
            : <any>null;
        this.teqConsidered =
          _data['teqConsidered'] !== undefined
            ? _data['teqConsidered']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateEmployeePopulationPolicyDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateEmployeePopulationPolicyDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['employeePopulationPolicyDetailsId'] =
        this.employeePopulationPolicyDetailsId !== undefined
          ? this.employeePopulationPolicyDetailsId
          : <any>null;
      data['clientPolicyName'] =
        this.clientPolicyName !== undefined ? this.clientPolicyName : <any>null;
      data['clientPolicyWorkLocationTypeId'] =
        this.clientPolicyWorkLocationTypeId !== undefined
          ? this.clientPolicyWorkLocationTypeId
          : <any>null;
      data['teqConsidered'] =
        this.teqConsidered !== undefined ? this.teqConsidered : <any>null;
      return data;
    }
  }

  export interface IUpdateEmployeePopulationPolicyDetailsCommand {
    clientId: string;
    employeePopulationPolicyDetailsId: string;
    clientPolicyName: string;
    clientPolicyWorkLocationTypeId: WorkLocationTypeSetting;
    teqConsidered: boolean;
  }

  export class DeleteEmployeePopulationPolicyDetailsCommandResult
    implements IDeleteEmployeePopulationPolicyDetailsCommandResult
  {
    constructor(data?: IDeleteEmployeePopulationPolicyDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DeleteEmployeePopulationPolicyDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteEmployeePopulationPolicyDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteEmployeePopulationPolicyDetailsCommandResult {}

  export class DeleteEmployeePopulationPolicyDetailsCommandResultSuccess
    extends DeleteEmployeePopulationPolicyDetailsCommandResult
    implements IDeleteEmployeePopulationPolicyDetailsCommandResultSuccess
  {
    constructor(
      data?: IDeleteEmployeePopulationPolicyDetailsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteEmployeePopulationPolicyDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteEmployeePopulationPolicyDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteEmployeePopulationPolicyDetailsCommandResultSuccess
    extends IDeleteEmployeePopulationPolicyDetailsCommandResult {}

  export class DeleteEmployeePopulationPolicyDetailsCommandResultFailure
    extends DeleteEmployeePopulationPolicyDetailsCommandResult
    implements IDeleteEmployeePopulationPolicyDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IDeleteEmployeePopulationPolicyDetailsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteEmployeePopulationPolicyDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteEmployeePopulationPolicyDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteEmployeePopulationPolicyDetailsCommandResultFailure
    extends IDeleteEmployeePopulationPolicyDetailsCommandResult {
    errors: ResultError[];
  }

  export class GetDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetDoubleTaxReliefPolicyPageDataQueryResult
  {
    constructor(data?: IGetDoubleTaxReliefPolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDoubleTaxReliefPolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyPageDataQueryResult {}

  export class GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2
    extends GetDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess2
  {
    result!: DoubleTaxReliefPageData;

    constructor(data?: IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess2) {
      super(data);
      if (!data) {
        this.result = new DoubleTaxReliefPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DoubleTaxReliefPageData.fromJS(_data['result'])
          : new DoubleTaxReliefPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2 {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyPageDataQueryResultSuccess2();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyPageDataQueryResultSuccess2
    extends IGetDoubleTaxReliefPolicyPageDataQueryResult {
    result: DoubleTaxReliefPageData;
  }

  export class DoubleTaxReliefPageData implements IDoubleTaxReliefPageData {
    countriesInFootprint!: DoubleTaxReliefPolicyCountryData[];
    batchActionOptions!: DoubleTaxReliefBatchActionOptionDto[];
    configurePlanTypes!: PlanTypeDto[];
    doubleTaxReliefPolicySettingOptions!: DoubleTaxReliefPolicySettingDto[];
    doubleTaxReliefPolicySettings!: DoubleTaxReliefPolicySettingsDto | null;

    constructor(data?: IDoubleTaxReliefPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprint = [];
        this.batchActionOptions = [];
        this.configurePlanTypes = [];
        this.doubleTaxReliefPolicySettingOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              DoubleTaxReliefPolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['batchActionOptions'])) {
          this.batchActionOptions = [] as any;
          for (let item of _data['batchActionOptions'])
            this.batchActionOptions!.push(
              DoubleTaxReliefBatchActionOptionDto.fromJS(item),
            );
        } else {
          this.batchActionOptions = <any>null;
        }
        if (Array.isArray(_data['configurePlanTypes'])) {
          this.configurePlanTypes = [] as any;
          for (let item of _data['configurePlanTypes'])
            this.configurePlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configurePlanTypes = <any>null;
        }
        if (Array.isArray(_data['doubleTaxReliefPolicySettingOptions'])) {
          this.doubleTaxReliefPolicySettingOptions = [] as any;
          for (let item of _data['doubleTaxReliefPolicySettingOptions'])
            this.doubleTaxReliefPolicySettingOptions!.push(
              DoubleTaxReliefPolicySettingDto.fromJS(item),
            );
        } else {
          this.doubleTaxReliefPolicySettingOptions = <any>null;
        }
        this.doubleTaxReliefPolicySettings = _data[
          'doubleTaxReliefPolicySettings'
        ]
          ? DoubleTaxReliefPolicySettingsDto.fromJS(
              _data['doubleTaxReliefPolicySettings'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPageData {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.batchActionOptions)) {
        data['batchActionOptions'] = [];
        for (let item of this.batchActionOptions)
          data['batchActionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.configurePlanTypes)) {
        data['configurePlanTypes'] = [];
        for (let item of this.configurePlanTypes)
          data['configurePlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.doubleTaxReliefPolicySettingOptions)) {
        data['doubleTaxReliefPolicySettingOptions'] = [];
        for (let item of this.doubleTaxReliefPolicySettingOptions)
          data['doubleTaxReliefPolicySettingOptions'].push(item.toJSON());
      }
      data['doubleTaxReliefPolicySettings'] = this.doubleTaxReliefPolicySettings
        ? this.doubleTaxReliefPolicySettings.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPageData {
    countriesInFootprint: DoubleTaxReliefPolicyCountryData[];
    batchActionOptions: DoubleTaxReliefBatchActionOptionDto[];
    configurePlanTypes: PlanTypeDto[];
    doubleTaxReliefPolicySettingOptions: DoubleTaxReliefPolicySettingDto[];
    doubleTaxReliefPolicySettings: DoubleTaxReliefPolicySettingsDto | null;
  }

  export class DoubleTaxReliefBatchActionOptionDto
    implements IDoubleTaxReliefBatchActionOptionDto
  {
    optionValue!: DoubleTaxReliefBatchActionOption;
    display!: string;
    displayOrder!: number;

    constructor(data?: IDoubleTaxReliefBatchActionOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefBatchActionOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefBatchActionOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefBatchActionOptionDto {
    optionValue: DoubleTaxReliefBatchActionOption;
    display: string;
    displayOrder: number;
  }

  export enum DoubleTaxReliefBatchActionOption {
    CompanyDefault = 'CompanyDefault',
    ForeignTaxCreditConsideringIncomeAndRegionTaxes = 'ForeignTaxCreditConsideringIncomeAndRegionTaxes',
    ForeignTaxCreditConsideringIncomeTaxesOnly = 'ForeignTaxCreditConsideringIncomeTaxesOnly',
    FollowCountryLegislation = 'FollowCountryLegislation',
    NoDoubleTaxRelief = 'NoDoubleTaxRelief',
  }

  export class DoubleTaxReliefPolicySettingsDto
    implements IDoubleTaxReliefPolicySettingsDto
  {
    id!: string;
    companyDoubleTaxReliefPolicySettingsDefault!: CompanyDoubleTaxReliefPolicySettingsDefaultDto | null;

    constructor(data?: IDoubleTaxReliefPolicySettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.companyDoubleTaxReliefPolicySettingsDefault = _data[
          'companyDoubleTaxReliefPolicySettingsDefault'
        ]
          ? CompanyDoubleTaxReliefPolicySettingsDefaultDto.fromJS(
              _data['companyDoubleTaxReliefPolicySettingsDefault'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): DoubleTaxReliefPolicySettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DoubleTaxReliefPolicySettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['companyDoubleTaxReliefPolicySettingsDefault'] = this
        .companyDoubleTaxReliefPolicySettingsDefault
        ? this.companyDoubleTaxReliefPolicySettingsDefault.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IDoubleTaxReliefPolicySettingsDto {
    id: string;
    companyDoubleTaxReliefPolicySettingsDefault: CompanyDoubleTaxReliefPolicySettingsDefaultDto | null;
  }

  export class CompanyDoubleTaxReliefPolicySettingsDefaultDto
    implements ICompanyDoubleTaxReliefPolicySettingsDefaultDto
  {
    doubleTaxReliefPolicySetting!: DoubleTaxReliefPolicySetting;
    countryPlanTypeDoubleTaxPolicySettings!: CountryPlanTypeDoubleTaxPolicySettingDto[];
    countryPlanTypeDoubleTaxPolicySettingsByCountry!: {
      [key: string]: CountryPlanTypeDoubleTaxPolicySettingDto;
    };

    constructor(data?: ICompanyDoubleTaxReliefPolicySettingsDefaultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryPlanTypeDoubleTaxPolicySettings = [];
        this.countryPlanTypeDoubleTaxPolicySettingsByCountry = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.doubleTaxReliefPolicySetting =
          _data['doubleTaxReliefPolicySetting'] !== undefined
            ? _data['doubleTaxReliefPolicySetting']
            : <any>null;
        if (Array.isArray(_data['countryPlanTypeDoubleTaxPolicySettings'])) {
          this.countryPlanTypeDoubleTaxPolicySettings = [] as any;
          for (let item of _data['countryPlanTypeDoubleTaxPolicySettings'])
            this.countryPlanTypeDoubleTaxPolicySettings!.push(
              CountryPlanTypeDoubleTaxPolicySettingDto.fromJS(item),
            );
        } else {
          this.countryPlanTypeDoubleTaxPolicySettings = <any>null;
        }
        if (_data['countryPlanTypeDoubleTaxPolicySettingsByCountry']) {
          this.countryPlanTypeDoubleTaxPolicySettingsByCountry = {} as any;
          for (let key in _data[
            'countryPlanTypeDoubleTaxPolicySettingsByCountry'
          ]) {
            if (
              _data[
                'countryPlanTypeDoubleTaxPolicySettingsByCountry'
              ].hasOwnProperty(key)
            )
              (<any>this.countryPlanTypeDoubleTaxPolicySettingsByCountry)![
                key
              ] = _data['countryPlanTypeDoubleTaxPolicySettingsByCountry'][key]
                ? CountryPlanTypeDoubleTaxPolicySettingDto.fromJS(
                    _data['countryPlanTypeDoubleTaxPolicySettingsByCountry'][
                      key
                    ],
                  )
                : new CountryPlanTypeDoubleTaxPolicySettingDto();
          }
        } else {
          this.countryPlanTypeDoubleTaxPolicySettingsByCountry = <any>null;
        }
      }
    }

    static fromJS(data: any): CompanyDoubleTaxReliefPolicySettingsDefaultDto {
      data = typeof data === 'object' ? data : {};
      let result = new CompanyDoubleTaxReliefPolicySettingsDefaultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['doubleTaxReliefPolicySetting'] =
        this.doubleTaxReliefPolicySetting !== undefined
          ? this.doubleTaxReliefPolicySetting
          : <any>null;
      if (Array.isArray(this.countryPlanTypeDoubleTaxPolicySettings)) {
        data['countryPlanTypeDoubleTaxPolicySettings'] = [];
        for (let item of this.countryPlanTypeDoubleTaxPolicySettings)
          data['countryPlanTypeDoubleTaxPolicySettings'].push(item.toJSON());
      }
      if (this.countryPlanTypeDoubleTaxPolicySettingsByCountry) {
        data['countryPlanTypeDoubleTaxPolicySettingsByCountry'] = {};
        for (let key in this.countryPlanTypeDoubleTaxPolicySettingsByCountry) {
          if (
            this.countryPlanTypeDoubleTaxPolicySettingsByCountry.hasOwnProperty(
              key,
            )
          )
            (<any>data['countryPlanTypeDoubleTaxPolicySettingsByCountry'])[
              key
            ] = this.countryPlanTypeDoubleTaxPolicySettingsByCountry[key]
              ? this.countryPlanTypeDoubleTaxPolicySettingsByCountry[
                  key
                ].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface ICompanyDoubleTaxReliefPolicySettingsDefaultDto {
    doubleTaxReliefPolicySetting: DoubleTaxReliefPolicySetting;
    countryPlanTypeDoubleTaxPolicySettings: CountryPlanTypeDoubleTaxPolicySettingDto[];
    countryPlanTypeDoubleTaxPolicySettingsByCountry: {
      [key: string]: CountryPlanTypeDoubleTaxPolicySettingDto;
    };
  }

  export class CountryPlanTypeDoubleTaxPolicySettingDto
    implements ICountryPlanTypeDoubleTaxPolicySettingDto
  {
    countryCode!: string;
    cashBonusDoubleTaxReliefPolicy!: DoubleTaxReliefPolicySetting | null;
    rsuDoubleTaxReliefPolicy!: DoubleTaxReliefPolicySetting | null;
    stockOptionDoubleTaxReliefPolicy!: DoubleTaxReliefPolicySetting | null;

    constructor(data?: ICountryPlanTypeDoubleTaxPolicySettingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.cashBonusDoubleTaxReliefPolicy =
          _data['cashBonusDoubleTaxReliefPolicy'] !== undefined
            ? _data['cashBonusDoubleTaxReliefPolicy']
            : <any>null;
        this.rsuDoubleTaxReliefPolicy =
          _data['rsuDoubleTaxReliefPolicy'] !== undefined
            ? _data['rsuDoubleTaxReliefPolicy']
            : <any>null;
        this.stockOptionDoubleTaxReliefPolicy =
          _data['stockOptionDoubleTaxReliefPolicy'] !== undefined
            ? _data['stockOptionDoubleTaxReliefPolicy']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryPlanTypeDoubleTaxPolicySettingDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryPlanTypeDoubleTaxPolicySettingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['cashBonusDoubleTaxReliefPolicy'] =
        this.cashBonusDoubleTaxReliefPolicy !== undefined
          ? this.cashBonusDoubleTaxReliefPolicy
          : <any>null;
      data['rsuDoubleTaxReliefPolicy'] =
        this.rsuDoubleTaxReliefPolicy !== undefined
          ? this.rsuDoubleTaxReliefPolicy
          : <any>null;
      data['stockOptionDoubleTaxReliefPolicy'] =
        this.stockOptionDoubleTaxReliefPolicy !== undefined
          ? this.stockOptionDoubleTaxReliefPolicy
          : <any>null;
      return data;
    }
  }

  export interface ICountryPlanTypeDoubleTaxPolicySettingDto {
    countryCode: string;
    cashBonusDoubleTaxReliefPolicy: DoubleTaxReliefPolicySetting | null;
    rsuDoubleTaxReliefPolicy: DoubleTaxReliefPolicySetting | null;
    stockOptionDoubleTaxReliefPolicy: DoubleTaxReliefPolicySetting | null;
  }

  export class GetDoubleTaxReliefPolicyPageDataQueryResultFailure2
    extends GetDoubleTaxReliefPolicyPageDataQueryResult
    implements IGetDoubleTaxReliefPolicyPageDataQueryResultFailure2
  {
    errors!: ResultError[];

    constructor(data?: IGetDoubleTaxReliefPolicyPageDataQueryResultFailure2) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDoubleTaxReliefPolicyPageDataQueryResultFailure2 {
      data = typeof data === 'object' ? data : {};
      let result = new GetDoubleTaxReliefPolicyPageDataQueryResultFailure2();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDoubleTaxReliefPolicyPageDataQueryResultFailure2
    extends IGetDoubleTaxReliefPolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicySettingsCommandResult
  {
    constructor(data?: IUpsertDoubleTaxReliefPolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertDoubleTaxReliefPolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertDoubleTaxReliefPolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicySettingsCommandResult {}

  export class UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess
    extends UpsertDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicySettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertDoubleTaxReliefPolicySettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertDoubleTaxReliefPolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicySettingsCommandResultSuccess
    extends IUpsertDoubleTaxReliefPolicySettingsCommandResult {}

  export class UpsertDoubleTaxReliefPolicySettingsCommandResultFailure
    extends UpsertDoubleTaxReliefPolicySettingsCommandResult
    implements IUpsertDoubleTaxReliefPolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IUpsertDoubleTaxReliefPolicySettingsCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertDoubleTaxReliefPolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertDoubleTaxReliefPolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicySettingsCommandResultFailure
    extends IUpsertDoubleTaxReliefPolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertDoubleTaxReliefPolicySettingsCommand
    implements IUpsertDoubleTaxReliefPolicySettingsCommand
  {
    clientId!: string;
    companyDoubleTaxReliefPolicySettingsDefault!: CompanyDoubleTaxReliefPolicySettingsDefaultDto | null;

    constructor(data?: IUpsertDoubleTaxReliefPolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.companyDoubleTaxReliefPolicySettingsDefault = _data[
          'companyDoubleTaxReliefPolicySettingsDefault'
        ]
          ? CompanyDoubleTaxReliefPolicySettingsDefaultDto.fromJS(
              _data['companyDoubleTaxReliefPolicySettingsDefault'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertDoubleTaxReliefPolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertDoubleTaxReliefPolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['companyDoubleTaxReliefPolicySettingsDefault'] = this
        .companyDoubleTaxReliefPolicySettingsDefault
        ? this.companyDoubleTaxReliefPolicySettingsDefault.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertDoubleTaxReliefPolicySettingsCommand {
    clientId: string;
    companyDoubleTaxReliefPolicySettingsDefault: CompanyDoubleTaxReliefPolicySettingsDefaultDto | null;
  }

  export class GetDeloitteTeamDetailsQueryResult
    implements IGetDeloitteTeamDetailsQueryResult
  {
    constructor(data?: IGetDeloitteTeamDetailsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeloitteTeamDetailsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteTeamDetailsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeloitteTeamDetailsQueryResult {}

  export class GetDeloitteTeamDetailsQueryResultSuccess
    extends GetDeloitteTeamDetailsQueryResult
    implements IGetDeloitteTeamDetailsQueryResultSuccess
  {
    result!: DeloitteTeamDetailsPageData;

    constructor(data?: IGetDeloitteTeamDetailsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new DeloitteTeamDetailsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? DeloitteTeamDetailsPageData.fromJS(_data['result'])
          : new DeloitteTeamDetailsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteTeamDetailsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteTeamDetailsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteTeamDetailsQueryResultSuccess
    extends IGetDeloitteTeamDetailsQueryResult {
    result: DeloitteTeamDetailsPageData;
  }

  export class DeloitteTeamDetailsPageData
    implements IDeloitteTeamDetailsPageData
  {
    deloitteTeamDetails!: DeloitteTeamDetailsDto | null;
    roleOptions!: RoleOption[] | null;

    constructor(data?: IDeloitteTeamDetailsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.deloitteTeamDetails = _data['deloitteTeamDetails']
          ? DeloitteTeamDetailsDto.fromJS(_data['deloitteTeamDetails'])
          : <any>null;
        if (Array.isArray(_data['roleOptions'])) {
          this.roleOptions = [] as any;
          for (let item of _data['roleOptions'])
            this.roleOptions!.push(RoleOption.fromJS(item));
        } else {
          this.roleOptions = <any>null;
        }
      }
    }

    static fromJS(data: any): DeloitteTeamDetailsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamDetailsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['deloitteTeamDetails'] = this.deloitteTeamDetails
        ? this.deloitteTeamDetails.toJSON()
        : <any>null;
      if (Array.isArray(this.roleOptions)) {
        data['roleOptions'] = [];
        for (let item of this.roleOptions)
          data['roleOptions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IDeloitteTeamDetailsPageData {
    deloitteTeamDetails: DeloitteTeamDetailsDto | null;
    roleOptions: RoleOption[] | null;
  }

  export class DeloitteTeamDetailsDto implements IDeloitteTeamDetailsDto {
    id!: string;
    office!: DeloitteOfficeOption | null;
    partner!: DeloitteUserOption | null;
    deloitteTeamMembers!: DeloitteTeamMemberDto[];

    constructor(data?: IDeloitteTeamDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.deloitteTeamMembers = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.office = _data['office']
          ? DeloitteOfficeOption.fromJS(_data['office'])
          : <any>null;
        this.partner = _data['partner']
          ? DeloitteUserOption.fromJS(_data['partner'])
          : <any>null;
        if (Array.isArray(_data['deloitteTeamMembers'])) {
          this.deloitteTeamMembers = [] as any;
          for (let item of _data['deloitteTeamMembers'])
            this.deloitteTeamMembers!.push(DeloitteTeamMemberDto.fromJS(item));
        } else {
          this.deloitteTeamMembers = <any>null;
        }
      }
    }

    static fromJS(data: any): DeloitteTeamDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['office'] = this.office ? this.office.toJSON() : <any>null;
      data['partner'] = this.partner ? this.partner.toJSON() : <any>null;
      if (Array.isArray(this.deloitteTeamMembers)) {
        data['deloitteTeamMembers'] = [];
        for (let item of this.deloitteTeamMembers)
          data['deloitteTeamMembers'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IDeloitteTeamDetailsDto {
    id: string;
    office: DeloitteOfficeOption | null;
    partner: DeloitteUserOption | null;
    deloitteTeamMembers: DeloitteTeamMemberDto[];
  }

  export class DeloitteOfficeOption implements IDeloitteOfficeOption {
    id!: string;
    name!: string;

    constructor(data?: IDeloitteOfficeOption) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteOfficeOption {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteOfficeOption();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IDeloitteOfficeOption {
    id: string;
    name: string;
  }

  export class DeloitteUserOption implements IDeloitteUserOption {
    id!: string;
    email!: string;
    firstName!: string;
    lastName!: string;
    fullName!: string;

    constructor(data?: IDeloitteUserOption) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteUserOption {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteUserOption();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      return data;
    }
  }

  export interface IDeloitteUserOption {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }

  export class DeloitteTeamMemberDto implements IDeloitteTeamMemberDto {
    userId!: string;
    fullName!: string;
    email!: string;
    role!: DeloitteTeamMemberRoleDto;
    canApproveManualCalculations!: boolean;

    constructor(data?: IDeloitteTeamMemberDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.role = new DeloitteTeamMemberRoleDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userId =
          _data['userId'] !== undefined ? _data['userId'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.role = _data['role']
          ? DeloitteTeamMemberRoleDto.fromJS(_data['role'])
          : new DeloitteTeamMemberRoleDto();
        this.canApproveManualCalculations =
          _data['canApproveManualCalculations'] !== undefined
            ? _data['canApproveManualCalculations']
            : <any>null;
      }
    }

    static fromJS(data: any): DeloitteTeamMemberDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamMemberDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userId'] = this.userId !== undefined ? this.userId : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['role'] = this.role ? this.role.toJSON() : <any>null;
      data['canApproveManualCalculations'] =
        this.canApproveManualCalculations !== undefined
          ? this.canApproveManualCalculations
          : <any>null;
      return data;
    }
  }

  export interface IDeloitteTeamMemberDto {
    userId: string;
    fullName: string;
    email: string;
    role: DeloitteTeamMemberRoleDto;
    canApproveManualCalculations: boolean;
  }

  export class DeloitteTeamMemberRoleDto implements IDeloitteTeamMemberRoleDto {
    id!: string;
    name!: string;

    constructor(data?: IDeloitteTeamMemberRoleDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteTeamMemberRoleDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteTeamMemberRoleDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IDeloitteTeamMemberRoleDto {
    id: string;
    name: string;
  }

  export class RoleOption implements IRoleOption {
    id!: string;
    name!: string;

    constructor(data?: IRoleOption) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): RoleOption {
      data = typeof data === 'object' ? data : {};
      let result = new RoleOption();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IRoleOption {
    id: string;
    name: string;
  }

  export class GetDeloitteTeamDetailsQueryResultFailure
    extends GetDeloitteTeamDetailsQueryResult
    implements IGetDeloitteTeamDetailsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetDeloitteTeamDetailsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteTeamDetailsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteTeamDetailsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteTeamDetailsQueryResultFailure
    extends IGetDeloitteTeamDetailsQueryResult {
    errors: ResultError[];
  }

  export class GetDeloitteOfficeOptionsQueryResult
    implements IGetDeloitteOfficeOptionsQueryResult
  {
    constructor(data?: IGetDeloitteOfficeOptionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeloitteOfficeOptionsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteOfficeOptionsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeloitteOfficeOptionsQueryResult {}

  export class GetDeloitteOfficeOptionsQueryResultSuccess
    extends GetDeloitteOfficeOptionsQueryResult
    implements IGetDeloitteOfficeOptionsQueryResultSuccess
  {
    result!: DeloitteOfficeOption2[];

    constructor(data?: IGetDeloitteOfficeOptionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(DeloitteOfficeOption2.fromJS(item));
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteOfficeOptionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteOfficeOptionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteOfficeOptionsQueryResultSuccess
    extends IGetDeloitteOfficeOptionsQueryResult {
    result: DeloitteOfficeOption2[];
  }

  export class DeloitteOfficeOption2 implements IDeloitteOfficeOption2 {
    id!: string;
    name!: string;

    constructor(data?: IDeloitteOfficeOption2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteOfficeOption2 {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteOfficeOption2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IDeloitteOfficeOption2 {
    id: string;
    name: string;
  }

  export class GetDeloitteOfficeOptionsQueryResultFailure
    extends GetDeloitteOfficeOptionsQueryResult
    implements IGetDeloitteOfficeOptionsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetDeloitteOfficeOptionsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteOfficeOptionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteOfficeOptionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteOfficeOptionsQueryResultFailure
    extends IGetDeloitteOfficeOptionsQueryResult {
    errors: ResultError[];
  }

  export class GetDeloitteUserOptionsQueryResult
    implements IGetDeloitteUserOptionsQueryResult
  {
    constructor(data?: IGetDeloitteUserOptionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeloitteUserOptionsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteUserOptionsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeloitteUserOptionsQueryResult {}

  export class GetDeloitteUserOptionsQueryResultSuccess
    extends GetDeloitteUserOptionsQueryResult
    implements IGetDeloitteUserOptionsQueryResultSuccess
  {
    result!: DeloitteUserOption2[];

    constructor(data?: IGetDeloitteUserOptionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(DeloitteUserOption2.fromJS(item));
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteUserOptionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteUserOptionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteUserOptionsQueryResultSuccess
    extends IGetDeloitteUserOptionsQueryResult {
    result: DeloitteUserOption2[];
  }

  export class DeloitteUserOption2 implements IDeloitteUserOption2 {
    id!: string;
    email!: string;
    firstName!: string;
    lastName!: string;
    fullName!: string;

    constructor(data?: IDeloitteUserOption2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
      }
    }

    static fromJS(data: any): DeloitteUserOption2 {
      data = typeof data === 'object' ? data : {};
      let result = new DeloitteUserOption2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      return data;
    }
  }

  export interface IDeloitteUserOption2 {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }

  export class GetDeloitteUserOptionsQueryResultFailure
    extends GetDeloitteUserOptionsQueryResult
    implements IGetDeloitteUserOptionsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetDeloitteUserOptionsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeloitteUserOptionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeloitteUserOptionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeloitteUserOptionsQueryResultFailure
    extends IGetDeloitteUserOptionsQueryResult {
    errors: ResultError[];
  }

  export class SaveDeloitteTeamDetailsCommandResult
    implements ISaveDeloitteTeamDetailsCommandResult
  {
    constructor(data?: ISaveDeloitteTeamDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveDeloitteTeamDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveDeloitteTeamDetailsCommandResult {}

  export class SaveDeloitteTeamDetailsCommandResultSuccess
    extends SaveDeloitteTeamDetailsCommandResult
    implements ISaveDeloitteTeamDetailsCommandResultSuccess
  {
    constructor(data?: ISaveDeloitteTeamDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveDeloitteTeamDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveDeloitteTeamDetailsCommandResultSuccess
    extends ISaveDeloitteTeamDetailsCommandResult {}

  export class SaveDeloitteTeamDetailsCommandResultFailure
    extends SaveDeloitteTeamDetailsCommandResult
    implements ISaveDeloitteTeamDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveDeloitteTeamDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveDeloitteTeamDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveDeloitteTeamDetailsCommandResultFailure
    extends ISaveDeloitteTeamDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveDeloitteTeamDetailsCommand
    implements ISaveDeloitteTeamDetailsCommand
  {
    clientId!: string;
    officeId!: string;
    partnerId!: string;
    teamMembers!: SaveDeloitteTeamMemberDto[];

    constructor(data?: ISaveDeloitteTeamDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.teamMembers = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.officeId =
          _data['officeId'] !== undefined ? _data['officeId'] : <any>null;
        this.partnerId =
          _data['partnerId'] !== undefined ? _data['partnerId'] : <any>null;
        if (Array.isArray(_data['teamMembers'])) {
          this.teamMembers = [] as any;
          for (let item of _data['teamMembers'])
            this.teamMembers!.push(SaveDeloitteTeamMemberDto.fromJS(item));
        } else {
          this.teamMembers = <any>null;
        }
      }
    }

    static fromJS(data: any): SaveDeloitteTeamDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['officeId'] =
        this.officeId !== undefined ? this.officeId : <any>null;
      data['partnerId'] =
        this.partnerId !== undefined ? this.partnerId : <any>null;
      if (Array.isArray(this.teamMembers)) {
        data['teamMembers'] = [];
        for (let item of this.teamMembers)
          data['teamMembers'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISaveDeloitteTeamDetailsCommand {
    clientId: string;
    officeId: string;
    partnerId: string;
    teamMembers: SaveDeloitteTeamMemberDto[];
  }

  export class SaveDeloitteTeamMemberDto implements ISaveDeloitteTeamMemberDto {
    userId!: string;
    roleId!: string;
    canApproveManualCalculations!: boolean;

    constructor(data?: ISaveDeloitteTeamMemberDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userId =
          _data['userId'] !== undefined ? _data['userId'] : <any>null;
        this.roleId =
          _data['roleId'] !== undefined ? _data['roleId'] : <any>null;
        this.canApproveManualCalculations =
          _data['canApproveManualCalculations'] !== undefined
            ? _data['canApproveManualCalculations']
            : <any>null;
      }
    }

    static fromJS(data: any): SaveDeloitteTeamMemberDto {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamMemberDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userId'] = this.userId !== undefined ? this.userId : <any>null;
      data['roleId'] = this.roleId !== undefined ? this.roleId : <any>null;
      data['canApproveManualCalculations'] =
        this.canApproveManualCalculations !== undefined
          ? this.canApproveManualCalculations
          : <any>null;
      return data;
    }
  }

  export interface ISaveDeloitteTeamMemberDto {
    userId: string;
    roleId: string;
    canApproveManualCalculations: boolean;
  }

  export abstract class SaveDeloitteTeamMembersCommandResult
    implements ISaveDeloitteTeamMembersCommandResult
  {
    constructor(data?: ISaveDeloitteTeamMembersCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveDeloitteTeamMembersCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SaveDeloitteTeamMembersCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveDeloitteTeamMembersCommandResult {}

  export class SaveDeloitteTeamMembersCommandResultSuccess
    extends SaveDeloitteTeamMembersCommandResult
    implements ISaveDeloitteTeamMembersCommandResultSuccess
  {
    teamMembers!: DeloitteTeamMemberDto[];

    constructor(data?: ISaveDeloitteTeamMembersCommandResultSuccess) {
      super(data);
      if (!data) {
        this.teamMembers = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['teamMembers'])) {
          this.teamMembers = [] as any;
          for (let item of _data['teamMembers'])
            this.teamMembers!.push(DeloitteTeamMemberDto.fromJS(item));
        } else {
          this.teamMembers = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveDeloitteTeamMembersCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamMembersCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.teamMembers)) {
        data['teamMembers'] = [];
        for (let item of this.teamMembers)
          data['teamMembers'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveDeloitteTeamMembersCommandResultSuccess
    extends ISaveDeloitteTeamMembersCommandResult {
    teamMembers: DeloitteTeamMemberDto[];
  }

  export class SaveDeloitteTeamMembersCommandResultFailure
    extends SaveDeloitteTeamMembersCommandResult
    implements ISaveDeloitteTeamMembersCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISaveDeloitteTeamMembersCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SaveDeloitteTeamMembersCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamMembersCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveDeloitteTeamMembersCommandResultFailure
    extends ISaveDeloitteTeamMembersCommandResult {
    errorMessage: string;
  }

  export class SaveDeloitteTeamMembersCommand
    implements ISaveDeloitteTeamMembersCommand
  {
    clientId!: string;
    teamMembers!: SaveDeloitteTeamMemberDto[];

    constructor(data?: ISaveDeloitteTeamMembersCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.teamMembers = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['teamMembers'])) {
          this.teamMembers = [] as any;
          for (let item of _data['teamMembers'])
            this.teamMembers!.push(SaveDeloitteTeamMemberDto.fromJS(item));
        } else {
          this.teamMembers = <any>null;
        }
      }
    }

    static fromJS(data: any): SaveDeloitteTeamMembersCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveDeloitteTeamMembersCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.teamMembers)) {
        data['teamMembers'] = [];
        for (let item of this.teamMembers)
          data['teamMembers'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISaveDeloitteTeamMembersCommand {
    clientId: string;
    teamMembers: SaveDeloitteTeamMemberDto[];
  }

  export class DownloadInputMappingsTemplateFileCommandResult
    implements IDownloadInputMappingsTemplateFileCommandResult
  {
    constructor(data?: IDownloadInputMappingsTemplateFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadInputMappingsTemplateFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadInputMappingsTemplateFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadInputMappingsTemplateFileCommandResult {}

  export class DownloadInputMappingsTemplateFileCommandResultSuccess
    extends DownloadInputMappingsTemplateFileCommandResult
    implements IDownloadInputMappingsTemplateFileCommandResultSuccess
  {
    base64String!: string;

    constructor(data?: IDownloadInputMappingsTemplateFileCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.base64String =
          _data['base64String'] !== undefined
            ? _data['base64String']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadInputMappingsTemplateFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadInputMappingsTemplateFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['base64String'] =
        this.base64String !== undefined ? this.base64String : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadInputMappingsTemplateFileCommandResultSuccess
    extends IDownloadInputMappingsTemplateFileCommandResult {
    base64String: string;
  }

  export class DownloadInputMappingsTemplateFileCommandResultFailure
    extends DownloadInputMappingsTemplateFileCommandResult
    implements IDownloadInputMappingsTemplateFileCommandResultFailure
  {
    constructor(data?: IDownloadInputMappingsTemplateFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DownloadInputMappingsTemplateFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadInputMappingsTemplateFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadInputMappingsTemplateFileCommandResultFailure
    extends IDownloadInputMappingsTemplateFileCommandResult {}

  export class DownloadInputMappingsTemplateFileCommand
    implements IDownloadInputMappingsTemplateFileCommand
  {
    constructor(data?: IDownloadInputMappingsTemplateFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadInputMappingsTemplateFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadInputMappingsTemplateFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadInputMappingsTemplateFileCommand {}

  export abstract class GetInputMappingsPageDataQueryResult
    implements IGetInputMappingsPageDataQueryResult
  {
    constructor(data?: IGetInputMappingsPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetInputMappingsPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetInputMappingsPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetInputMappingsPageDataQueryResult {}

  export class GetInputMappingsPageDataQueryResultSuccess
    extends GetInputMappingsPageDataQueryResult
    implements IGetInputMappingsPageDataQueryResultSuccess
  {
    inputMappingsPageData!: InputMappingsDto;

    constructor(data?: IGetInputMappingsPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.inputMappingsPageData = new InputMappingsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.inputMappingsPageData = _data['inputMappingsPageData']
          ? InputMappingsDto.fromJS(_data['inputMappingsPageData'])
          : new InputMappingsDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetInputMappingsPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputMappingsPageData'] = this.inputMappingsPageData
        ? this.inputMappingsPageData.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsPageDataQueryResultSuccess
    extends IGetInputMappingsPageDataQueryResult {
    inputMappingsPageData: InputMappingsDto;
  }

  export class InputMappingsDto implements IInputMappingsDto {
    inputMappingsStatus!: InputMappingsStatusDto;
    inputMappingFiles!: InputMappingFileInfoDto[];

    constructor(data?: IInputMappingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.inputMappingFiles = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.inputMappingsStatus =
          _data['inputMappingsStatus'] !== undefined
            ? _data['inputMappingsStatus']
            : <any>null;
        if (Array.isArray(_data['inputMappingFiles'])) {
          this.inputMappingFiles = [] as any;
          for (let item of _data['inputMappingFiles'])
            this.inputMappingFiles!.push(InputMappingFileInfoDto.fromJS(item));
        } else {
          this.inputMappingFiles = <any>null;
        }
      }
    }

    static fromJS(data: any): InputMappingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new InputMappingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputMappingsStatus'] =
        this.inputMappingsStatus !== undefined
          ? this.inputMappingsStatus
          : <any>null;
      if (Array.isArray(this.inputMappingFiles)) {
        data['inputMappingFiles'] = [];
        for (let item of this.inputMappingFiles)
          data['inputMappingFiles'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IInputMappingsDto {
    inputMappingsStatus: InputMappingsStatusDto;
    inputMappingFiles: InputMappingFileInfoDto[];
  }

  export enum InputMappingsStatusDto {
    NotStarted = 'NotStarted',
    RequirementsStarted = 'RequirementsStarted',
    ReadyForImplementation = 'ReadyForImplementation',
    MappingInProgress = 'MappingInProgress',
    ReadyForTesting = 'ReadyForTesting',
    SignedOff = 'SignedOff',
  }

  export class InputMappingFileInfoDto implements IInputMappingFileInfoDto {
    fileName!: string;
    uploadedOn!: Date;

    constructor(data?: IInputMappingFileInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.uploadedOn = _data['uploadedOn']
          ? new Date(_data['uploadedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): InputMappingFileInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new InputMappingFileInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['uploadedOn'] = this.uploadedOn
        ? this.uploadedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IInputMappingFileInfoDto {
    fileName: string;
    uploadedOn: Date;
  }

  export class GetInputMappingsPageDataQueryResultFailure
    extends GetInputMappingsPageDataQueryResult
    implements IGetInputMappingsPageDataQueryResultFailure
  {
    constructor(data?: IGetInputMappingsPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetInputMappingsPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsPageDataQueryResultFailure
    extends IGetInputMappingsPageDataQueryResult {}

  export abstract class HandlePostInputMappingsUploadCommandResult
    implements IHandlePostInputMappingsUploadCommandResult
  {
    constructor(data?: IHandlePostInputMappingsUploadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): HandlePostInputMappingsUploadCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'HandlePostInputMappingsUploadCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IHandlePostInputMappingsUploadCommandResult {}

  export class HandlePostInputMappingsUploadCommandResultSuccess
    extends HandlePostInputMappingsUploadCommandResult
    implements IHandlePostInputMappingsUploadCommandResultSuccess
  {
    inputMappings!: InputMappingsDto;

    constructor(data?: IHandlePostInputMappingsUploadCommandResultSuccess) {
      super(data);
      if (!data) {
        this.inputMappings = new InputMappingsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.inputMappings = _data['inputMappings']
          ? InputMappingsDto.fromJS(_data['inputMappings'])
          : new InputMappingsDto();
      }
    }

    static override fromJS(
      data: any,
    ): HandlePostInputMappingsUploadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostInputMappingsUploadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputMappings'] = this.inputMappings
        ? this.inputMappings.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandlePostInputMappingsUploadCommandResultSuccess
    extends IHandlePostInputMappingsUploadCommandResult {
    inputMappings: InputMappingsDto;
  }

  export class HandlePostInputMappingsUploadCommandResultFailure
    extends HandlePostInputMappingsUploadCommandResult
    implements IHandlePostInputMappingsUploadCommandResultFailure
  {
    constructor(data?: IHandlePostInputMappingsUploadCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): HandlePostInputMappingsUploadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostInputMappingsUploadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandlePostInputMappingsUploadCommandResultFailure
    extends IHandlePostInputMappingsUploadCommandResult {}

  export abstract class DeleteInputMappingsFileCommandResult
    implements IDeleteInputMappingsFileCommandResult
  {
    constructor(data?: IDeleteInputMappingsFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteInputMappingsFileCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DeleteInputMappingsFileCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteInputMappingsFileCommandResult {}

  export class DeleteInputMappingsFileCommandResultSuccess
    extends DeleteInputMappingsFileCommandResult
    implements IDeleteInputMappingsFileCommandResultSuccess
  {
    inputMappings!: InputMappingsDto;

    constructor(data?: IDeleteInputMappingsFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.inputMappings = new InputMappingsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.inputMappings = _data['inputMappings']
          ? InputMappingsDto.fromJS(_data['inputMappings'])
          : new InputMappingsDto();
      }
    }

    static override fromJS(
      data: any,
    ): DeleteInputMappingsFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteInputMappingsFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputMappings'] = this.inputMappings
        ? this.inputMappings.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteInputMappingsFileCommandResultSuccess
    extends IDeleteInputMappingsFileCommandResult {
    inputMappings: InputMappingsDto;
  }

  export class DeleteInputMappingsFileCommandResultFailure
    extends DeleteInputMappingsFileCommandResult
    implements IDeleteInputMappingsFileCommandResultFailure
  {
    constructor(data?: IDeleteInputMappingsFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteInputMappingsFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteInputMappingsFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteInputMappingsFileCommandResultFailure
    extends IDeleteInputMappingsFileCommandResult {}

  export abstract class GetInputMappingsFilePreSignedUrlForDownloadCommandResult
    implements IGetInputMappingsFilePreSignedUrlForDownloadCommandResult
  {
    constructor(
      data?: IGetInputMappingsFilePreSignedUrlForDownloadCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetInputMappingsFilePreSignedUrlForDownloadCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetInputMappingsFilePreSignedUrlForDownloadCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetInputMappingsFilePreSignedUrlForDownloadCommandResult {}

  export class GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess
    extends GetInputMappingsFilePreSignedUrlForDownloadCommandResult
    implements IGetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess
  {
    preSignedUrl!: string;

    constructor(
      data?: IGetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.preSignedUrl =
          _data['preSignedUrl'] !== undefined
            ? _data['preSignedUrl']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['preSignedUrl'] =
        this.preSignedUrl !== undefined ? this.preSignedUrl : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsFilePreSignedUrlForDownloadCommandResultSuccess
    extends IGetInputMappingsFilePreSignedUrlForDownloadCommandResult {
    preSignedUrl: string;
  }

  export class GetInputMappingsFilePreSignedUrlForDownloadResultFailure
    extends GetInputMappingsFilePreSignedUrlForDownloadCommandResult
    implements IGetInputMappingsFilePreSignedUrlForDownloadResultFailure
  {
    constructor(
      data?: IGetInputMappingsFilePreSignedUrlForDownloadResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsFilePreSignedUrlForDownloadResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetInputMappingsFilePreSignedUrlForDownloadResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsFilePreSignedUrlForDownloadResultFailure
    extends IGetInputMappingsFilePreSignedUrlForDownloadCommandResult {}

  export class UpdateInputMappingsCommandResult
    implements IUpdateInputMappingsCommandResult
  {
    constructor(data?: IUpdateInputMappingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateInputMappingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateInputMappingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateInputMappingsCommandResult {}

  export class UpdateInputMappingsCommandResultSuccess
    extends UpdateInputMappingsCommandResult
    implements IUpdateInputMappingsCommandResultSuccess
  {
    constructor(data?: IUpdateInputMappingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpdateInputMappingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateInputMappingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateInputMappingsCommandResultSuccess
    extends IUpdateInputMappingsCommandResult {}

  export class UpdateInputMappingsCommandResultFailure
    extends UpdateInputMappingsCommandResult
    implements IUpdateInputMappingsCommandResultFailure
  {
    constructor(data?: IUpdateInputMappingsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpdateInputMappingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateInputMappingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateInputMappingsCommandResultFailure
    extends IUpdateInputMappingsCommandResult {}

  export class GetInputMappingsFilesPreSignedUrlsForUploadCommandResult
    implements IGetInputMappingsFilesPreSignedUrlsForUploadCommandResult
  {
    constructor(
      data?: IGetInputMappingsFilesPreSignedUrlsForUploadCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetInputMappingsFilesPreSignedUrlsForUploadCommandResult {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetInputMappingsFilesPreSignedUrlsForUploadCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetInputMappingsFilesPreSignedUrlsForUploadCommandResult {}

  export class GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess
    extends GetInputMappingsFilesPreSignedUrlsForUploadCommandResult
    implements IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess
  {
    preSignedUrls!: InputMappingsFilePreSignedUrlForUploadDto[];

    constructor(
      data?: IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.preSignedUrls = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['preSignedUrls'])) {
          this.preSignedUrls = [] as any;
          for (let item of _data['preSignedUrls'])
            this.preSignedUrls!.push(
              InputMappingsFilePreSignedUrlForUploadDto.fromJS(item),
            );
        } else {
          this.preSignedUrls = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.preSignedUrls)) {
        data['preSignedUrls'] = [];
        for (let item of this.preSignedUrls)
          data['preSignedUrls'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultSuccess
    extends IGetInputMappingsFilesPreSignedUrlsForUploadCommandResult {
    preSignedUrls: InputMappingsFilePreSignedUrlForUploadDto[];
  }

  export class InputMappingsFilePreSignedUrlForUploadDto
    implements IInputMappingsFilePreSignedUrlForUploadDto
  {
    fileName!: string;
    url!: string;
    headers!: { [key: string]: string };
    virusScanningJobId!: string;

    constructor(data?: IInputMappingsFilePreSignedUrlForUploadDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.headers = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.url = _data['url'] !== undefined ? _data['url'] : <any>null;
        if (_data['headers']) {
          this.headers = {} as any;
          for (let key in _data['headers']) {
            if (_data['headers'].hasOwnProperty(key))
              (<any>this.headers)![key] =
                _data['headers'][key] !== undefined
                  ? _data['headers'][key]
                  : <any>null;
          }
        } else {
          this.headers = <any>null;
        }
        this.virusScanningJobId =
          _data['virusScanningJobId'] !== undefined
            ? _data['virusScanningJobId']
            : <any>null;
      }
    }

    static fromJS(data: any): InputMappingsFilePreSignedUrlForUploadDto {
      data = typeof data === 'object' ? data : {};
      let result = new InputMappingsFilePreSignedUrlForUploadDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['url'] = this.url !== undefined ? this.url : <any>null;
      if (this.headers) {
        data['headers'] = {};
        for (let key in this.headers) {
          if (this.headers.hasOwnProperty(key))
            (<any>data['headers'])[key] =
              this.headers[key] !== undefined ? this.headers[key] : <any>null;
        }
      }
      data['virusScanningJobId'] =
        this.virusScanningJobId !== undefined
          ? this.virusScanningJobId
          : <any>null;
      return data;
    }
  }

  export interface IInputMappingsFilePreSignedUrlForUploadDto {
    fileName: string;
    url: string;
    headers: { [key: string]: string };
    virusScanningJobId: string;
  }

  export class GetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure
    extends GetInputMappingsFilesPreSignedUrlsForUploadCommandResult
    implements IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure
  {
    constructor(
      data?: IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetInputMappingsFilesPreSignedUrlsForUploadCommandResultFailure
    extends IGetInputMappingsFilesPreSignedUrlsForUploadCommandResult {}

  export class GetInputMappingsFilePreSignedUrlDto
    implements IGetInputMappingsFilePreSignedUrlDto
  {
    fileName!: string;
    contentType!: string;

    constructor(data?: IGetInputMappingsFilePreSignedUrlDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.contentType =
          _data['contentType'] !== undefined ? _data['contentType'] : <any>null;
      }
    }

    static fromJS(data: any): GetInputMappingsFilePreSignedUrlDto {
      data = typeof data === 'object' ? data : {};
      let result = new GetInputMappingsFilePreSignedUrlDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['contentType'] =
        this.contentType !== undefined ? this.contentType : <any>null;
      return data;
    }
  }

  export interface IGetInputMappingsFilePreSignedUrlDto {
    fileName: string;
    contentType: string;
  }

  export abstract class GetChangesLogPageDataQueryResult
    implements IGetChangesLogPageDataQueryResult
  {
    constructor(data?: IGetChangesLogPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetChangesLogPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetChangesLogPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetChangesLogPageDataQueryResult {}

  export class GetChangesLogPageDataQueryResultSuccess
    extends GetChangesLogPageDataQueryResult
    implements IGetChangesLogPageDataQueryResultSuccess
  {
    currentInputMappingsStatus!: InputMappingsStatusDto | null;
    changesLogs!: ChangesLogDto[];

    constructor(data?: IGetChangesLogPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.changesLogs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.currentInputMappingsStatus =
          _data['currentInputMappingsStatus'] !== undefined
            ? _data['currentInputMappingsStatus']
            : <any>null;
        if (Array.isArray(_data['changesLogs'])) {
          this.changesLogs = [] as any;
          for (let item of _data['changesLogs'])
            this.changesLogs!.push(ChangesLogDto.fromJS(item));
        } else {
          this.changesLogs = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetChangesLogPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetChangesLogPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['currentInputMappingsStatus'] =
        this.currentInputMappingsStatus !== undefined
          ? this.currentInputMappingsStatus
          : <any>null;
      if (Array.isArray(this.changesLogs)) {
        data['changesLogs'] = [];
        for (let item of this.changesLogs)
          data['changesLogs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetChangesLogPageDataQueryResultSuccess
    extends IGetChangesLogPageDataQueryResult {
    currentInputMappingsStatus: InputMappingsStatusDto | null;
    changesLogs: ChangesLogDto[];
  }

  export class ChangesLogDto implements IChangesLogDto {
    inputMappingsStatus!: InputMappingsStatusDto;
    comment!: string;
    submittedBy!: string;
    submittedOn!: Date;

    constructor(data?: IChangesLogDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.inputMappingsStatus =
          _data['inputMappingsStatus'] !== undefined
            ? _data['inputMappingsStatus']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.submittedBy =
          _data['submittedBy'] !== undefined ? _data['submittedBy'] : <any>null;
        this.submittedOn = _data['submittedOn']
          ? new Date(_data['submittedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ChangesLogDto {
      data = typeof data === 'object' ? data : {};
      let result = new ChangesLogDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputMappingsStatus'] =
        this.inputMappingsStatus !== undefined
          ? this.inputMappingsStatus
          : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['submittedBy'] =
        this.submittedBy !== undefined ? this.submittedBy : <any>null;
      data['submittedOn'] = this.submittedOn
        ? this.submittedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IChangesLogDto {
    inputMappingsStatus: InputMappingsStatusDto;
    comment: string;
    submittedBy: string;
    submittedOn: Date;
  }

  export class GetChangesLogPageDataQueryResultFailure
    extends GetChangesLogPageDataQueryResult
    implements IGetChangesLogPageDataQueryResultFailure
  {
    constructor(data?: IGetChangesLogPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetChangesLogPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetChangesLogPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetChangesLogPageDataQueryResultFailure
    extends IGetChangesLogPageDataQueryResult {}

  export class GetCustomTaxesQueryResult2
    implements IGetCustomTaxesQueryResult2
  {
    constructor(data?: IGetCustomTaxesQueryResult2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCustomTaxesQueryResult2 {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxesQueryResult2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResult2 {}

  export class GetCustomTaxesQueryResultSuccess2
    extends GetCustomTaxesQueryResult2
    implements IGetCustomTaxesQueryResultSuccess2
  {
    result!: CustomTaxDto[];
    planTypes!: PlanSetupDetailsDto;
    countryFootprintDetails!: CustomTaxCountryFootprintDto;
    isCountryHasRegionSupported!: boolean;

    constructor(data?: IGetCustomTaxesQueryResultSuccess2) {
      super(data);
      if (!data) {
        this.result = [];
        this.planTypes = new PlanSetupDetailsDto();
        this.countryFootprintDetails = new CustomTaxCountryFootprintDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(CustomTaxDto.fromJS(item));
        } else {
          this.result = <any>null;
        }
        this.planTypes = _data['planTypes']
          ? PlanSetupDetailsDto.fromJS(_data['planTypes'])
          : new PlanSetupDetailsDto();
        this.countryFootprintDetails = _data['countryFootprintDetails']
          ? CustomTaxCountryFootprintDto.fromJS(
              _data['countryFootprintDetails'],
            )
          : new CustomTaxCountryFootprintDto();
        this.isCountryHasRegionSupported =
          _data['isCountryHasRegionSupported'] !== undefined
            ? _data['isCountryHasRegionSupported']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetCustomTaxesQueryResultSuccess2 {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxesQueryResultSuccess2();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      data['planTypes'] = this.planTypes ? this.planTypes.toJSON() : <any>null;
      data['countryFootprintDetails'] = this.countryFootprintDetails
        ? this.countryFootprintDetails.toJSON()
        : <any>null;
      data['isCountryHasRegionSupported'] =
        this.isCountryHasRegionSupported !== undefined
          ? this.isCountryHasRegionSupported
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResultSuccess2
    extends IGetCustomTaxesQueryResult2 {
    result: CustomTaxDto[];
    planTypes: PlanSetupDetailsDto;
    countryFootprintDetails: CustomTaxCountryFootprintDto;
    isCountryHasRegionSupported: boolean;
  }

  export class CustomTaxCountryFootprintDto
    implements ICustomTaxCountryFootprintDto
  {
    countryCodes!: string[];

    constructor(data?: ICustomTaxCountryFootprintDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): CustomTaxCountryFootprintDto {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxCountryFootprintDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface ICustomTaxCountryFootprintDto {
    countryCodes: string[];
  }

  export class GetCustomTaxesQueryResultFailure2
    extends GetCustomTaxesQueryResult2
    implements IGetCustomTaxesQueryResultFailure2
  {
    errors!: ResultError[];

    constructor(data?: IGetCustomTaxesQueryResultFailure2) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCustomTaxesQueryResultFailure2 {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxesQueryResultFailure2();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxesQueryResultFailure2
    extends IGetCustomTaxesQueryResult2 {
    errors: ResultError[];
  }

  export class UpsertCustomTaxCommandResult
    implements IUpsertCustomTaxCommandResult
  {
    constructor(data?: IUpsertCustomTaxCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertCustomTaxCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCustomTaxCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCustomTaxCommandResult {}

  export class UpsertCustomTaxCommandResultSuccess
    extends UpsertCustomTaxCommandResult
    implements IUpsertCustomTaxCommandResultSuccess
  {
    constructor(data?: IUpsertCustomTaxCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpsertCustomTaxCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCustomTaxCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCustomTaxCommandResultSuccess
    extends IUpsertCustomTaxCommandResult {}

  export class UpsertCustomTaxCommandResultFailure
    extends UpsertCustomTaxCommandResult
    implements IUpsertCustomTaxCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertCustomTaxCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpsertCustomTaxCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCustomTaxCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCustomTaxCommandResultFailure
    extends IUpsertCustomTaxCommandResult {
    errors: ResultError[];
  }

  export class UpsertCustomTaxCommand implements IUpsertCustomTaxCommand {
    id!: string | null;
    clientId!: string;
    restrictedStockUnitIncomeBasis!: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis!: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis!: CashBonusIncomeBasisSettingDto | null;
    taxType!: TaxType;
    bandingType!: BandingType;
    code!: string;
    countryCode!: string;
    regionCode!: string | null;
    currencyCode!: string;
    bands!: CustomTaxBandDto[];

    constructor(data?: IUpsertCustomTaxCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.bands = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.restrictedStockUnitIncomeBasis = _data[
          'restrictedStockUnitIncomeBasis'
        ]
          ? RestrictedStockUnitIncomeBasisSettingDto.fromJS(
              _data['restrictedStockUnitIncomeBasis'],
            )
          : <any>null;
        this.stockOptionIncomeBasis = _data['stockOptionIncomeBasis']
          ? StockOptionIncomeBasisSettingDto.fromJS(
              _data['stockOptionIncomeBasis'],
            )
          : <any>null;
        this.cashBonusIncomeBasis = _data['cashBonusIncomeBasis']
          ? CashBonusIncomeBasisSettingDto.fromJS(_data['cashBonusIncomeBasis'])
          : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        if (Array.isArray(_data['bands'])) {
          this.bands = [] as any;
          for (let item of _data['bands'])
            this.bands!.push(CustomTaxBandDto.fromJS(item));
        } else {
          this.bands = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCustomTaxCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCustomTaxCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['restrictedStockUnitIncomeBasis'] = this
        .restrictedStockUnitIncomeBasis
        ? this.restrictedStockUnitIncomeBasis.toJSON()
        : <any>null;
      data['stockOptionIncomeBasis'] = this.stockOptionIncomeBasis
        ? this.stockOptionIncomeBasis.toJSON()
        : <any>null;
      data['cashBonusIncomeBasis'] = this.cashBonusIncomeBasis
        ? this.cashBonusIncomeBasis.toJSON()
        : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      if (Array.isArray(this.bands)) {
        data['bands'] = [];
        for (let item of this.bands) data['bands'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCustomTaxCommand {
    id: string | null;
    clientId: string;
    restrictedStockUnitIncomeBasis: RestrictedStockUnitIncomeBasisSettingDto | null;
    stockOptionIncomeBasis: StockOptionIncomeBasisSettingDto | null;
    cashBonusIncomeBasis: CashBonusIncomeBasisSettingDto | null;
    taxType: TaxType;
    bandingType: BandingType;
    code: string;
    countryCode: string;
    regionCode: string | null;
    currencyCode: string;
    bands: CustomTaxBandDto[];
  }

  export class DeleteCustomTaxCommandResult
    implements IDeleteCustomTaxCommandResult
  {
    constructor(data?: IDeleteCustomTaxCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteCustomTaxCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCustomTaxCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteCustomTaxCommandResult {}

  export class DeleteCustomTaxCommandResultSuccess
    extends DeleteCustomTaxCommandResult
    implements IDeleteCustomTaxCommandResultSuccess
  {
    constructor(data?: IDeleteCustomTaxCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): DeleteCustomTaxCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCustomTaxCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCustomTaxCommandResultSuccess
    extends IDeleteCustomTaxCommandResult {}

  export class DeleteCustomTaxCommandResultFailure
    extends DeleteCustomTaxCommandResult
    implements IDeleteCustomTaxCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteCustomTaxCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): DeleteCustomTaxCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCustomTaxCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCustomTaxCommandResultFailure
    extends IDeleteCustomTaxCommandResult {
    errors: ResultError[];
  }

  export class SaveCustomTaxesCommandResult
    implements ISaveCustomTaxesCommandResult
  {
    constructor(data?: ISaveCustomTaxesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveCustomTaxesCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCustomTaxesCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCustomTaxesCommandResult {}

  export class SaveCustomTaxesCommandResultSuccess
    extends SaveCustomTaxesCommandResult
    implements ISaveCustomTaxesCommandResultSuccess
  {
    constructor(data?: ISaveCustomTaxesCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): SaveCustomTaxesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCustomTaxesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCustomTaxesCommandResultSuccess
    extends ISaveCustomTaxesCommandResult {}

  export class SaveCustomTaxesCommandResultFailure
    extends SaveCustomTaxesCommandResult
    implements ISaveCustomTaxesCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveCustomTaxesCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): SaveCustomTaxesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCustomTaxesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCustomTaxesCommandResultFailure
    extends ISaveCustomTaxesCommandResult {
    errors: ResultError[];
  }

  export class SaveCustomTaxesCommand implements ISaveCustomTaxesCommand {
    clientId!: string;

    constructor(data?: ISaveCustomTaxesCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveCustomTaxesCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCustomTaxesCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveCustomTaxesCommand {
    clientId: string;
  }

  export class UploadCustomTaxesCommandResult
    implements IUploadCustomTaxesCommandResult
  {
    constructor(data?: IUploadCustomTaxesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadCustomTaxesCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadCustomTaxesCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadCustomTaxesCommandResult {}

  export class UploadCustomTaxesCommandResultSuccess
    extends UploadCustomTaxesCommandResult
    implements IUploadCustomTaxesCommandResultSuccess
  {
    constructor(data?: IUploadCustomTaxesCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UploadCustomTaxesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadCustomTaxesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadCustomTaxesCommandResultSuccess
    extends IUploadCustomTaxesCommandResult {}

  export class UploadCustomTaxesCommandResultFailure
    extends UploadCustomTaxesCommandResult
    implements IUploadCustomTaxesCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUploadCustomTaxesCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UploadCustomTaxesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadCustomTaxesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadCustomTaxesCommandResultFailure
    extends IUploadCustomTaxesCommandResult {
    errors: ResultError[];
  }

  export class DownloadCustomTaxesTemplateCommandResult
    implements IDownloadCustomTaxesTemplateCommandResult
  {
    constructor(data?: IDownloadCustomTaxesTemplateCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadCustomTaxesTemplateCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCustomTaxesTemplateCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadCustomTaxesTemplateCommandResult {}

  export class DownloadCustomTaxesTemplateCommandResultSuccess
    extends DownloadCustomTaxesTemplateCommandResult
    implements IDownloadCustomTaxesTemplateCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadCustomTaxesTemplateCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCustomTaxesTemplateCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCustomTaxesTemplateCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCustomTaxesTemplateCommandResultSuccess
    extends IDownloadCustomTaxesTemplateCommandResult {
    result: string;
  }

  export class DownloadCustomTaxesTemplateCommandResultFailure
    extends DownloadCustomTaxesTemplateCommandResult
    implements IDownloadCustomTaxesTemplateCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDownloadCustomTaxesTemplateCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadCustomTaxesTemplateCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadCustomTaxesTemplateCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadCustomTaxesTemplateCommandResultFailure
    extends IDownloadCustomTaxesTemplateCommandResult {
    errors: ResultError[];
  }

  export abstract class GetExchangeRateByDateQueryResult
    implements IGetExchangeRateByDateQueryResult
  {
    constructor(data?: IGetExchangeRateByDateQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetExchangeRateByDateQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetExchangeRateByDateQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetExchangeRateByDateQueryResult {}

  export class GetExchangeRateByDateQueryResultSuccess
    extends GetExchangeRateByDateQueryResult
    implements IGetExchangeRateByDateQueryResultSuccess
  {
    rate!: number | null;

    constructor(data?: IGetExchangeRateByDateQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.rate = _data['rate'] !== undefined ? _data['rate'] : <any>null;
      }
    }

    static override fromJS(data: any): GetExchangeRateByDateQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeRateByDateQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['rate'] = this.rate !== undefined ? this.rate : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeRateByDateQueryResultSuccess
    extends IGetExchangeRateByDateQueryResult {
    rate: number | null;
  }

  export class GetExchangeRateByDateQueryResultFailure
    extends GetExchangeRateByDateQueryResult
    implements IGetExchangeRateByDateQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetExchangeRateByDateQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): GetExchangeRateByDateQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetExchangeRateByDateQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetExchangeRateByDateQueryResultFailure
    extends IGetExchangeRateByDateQueryResult {
    errorMessage: string;
  }

  export abstract class GetCountryRegionDataQueryResult
    implements IGetCountryRegionDataQueryResult
  {
    constructor(data?: IGetCountryRegionDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryRegionDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCountryRegionDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryRegionDataQueryResult {}

  export class GetCountryRegionDataQueryResultSuccess
    extends GetCountryRegionDataQueryResult
    implements IGetCountryRegionDataQueryResultSuccess
  {
    countries!: CountryDto[];

    constructor(data?: IGetCountryRegionDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.countries = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(CountryDto.fromJS(item));
        } else {
          this.countries = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCountryRegionDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryRegionDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryRegionDataQueryResultSuccess
    extends IGetCountryRegionDataQueryResult {
    countries: CountryDto[];
  }

  export class CountryDto implements ICountryDto {
    code!: string;
    name!: string;
    currency!: CurrencyDto | null;
    supportsCalculations!: boolean;
    supportsRegionCalculations!: boolean;
    regions!: RegionDto[];

    constructor(data?: ICountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.currency = _data['currency']
          ? CurrencyDto.fromJS(_data['currency'])
          : <any>null;
        this.supportsCalculations =
          _data['supportsCalculations'] !== undefined
            ? _data['supportsCalculations']
            : <any>null;
        this.supportsRegionCalculations =
          _data['supportsRegionCalculations'] !== undefined
            ? _data['supportsRegionCalculations']
            : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(RegionDto.fromJS(item));
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['currency'] = this.currency ? this.currency.toJSON() : <any>null;
      data['supportsCalculations'] =
        this.supportsCalculations !== undefined
          ? this.supportsCalculations
          : <any>null;
      data['supportsRegionCalculations'] =
        this.supportsRegionCalculations !== undefined
          ? this.supportsRegionCalculations
          : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryDto {
    code: string;
    name: string;
    currency: CurrencyDto | null;
    supportsCalculations: boolean;
    supportsRegionCalculations: boolean;
    regions: RegionDto[];
  }

  export class CurrencyDto implements ICurrencyDto {
    code!: string;
    name!: string;

    constructor(data?: ICurrencyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): CurrencyDto {
      data = typeof data === 'object' ? data : {};
      let result = new CurrencyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface ICurrencyDto {
    code: string;
    name: string;
  }

  export class RegionDto implements IRegionDto {
    code!: string;
    name!: string;

    constructor(data?: IRegionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
      }
    }

    static fromJS(data: any): RegionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RegionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      return data;
    }
  }

  export interface IRegionDto {
    code: string;
    name: string;
  }

  export class GetCountryRegionDataQueryResultFailure
    extends GetCountryRegionDataQueryResult
    implements IGetCountryRegionDataQueryResultFailure
  {
    errorMessage!: string;
    errors!: ResultError[];

    constructor(data?: IGetCountryRegionDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCountryRegionDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryRegionDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryRegionDataQueryResultFailure
    extends IGetCountryRegionDataQueryResult {
    errorMessage: string;
    errors: ResultError[];
  }

  export class GetCountryRegionDataQuery implements IGetCountryRegionDataQuery {
    constructor(data?: IGetCountryRegionDataQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryRegionDataQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryRegionDataQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryRegionDataQuery {}

  export class GetCountryFootprintDetailsQueryResult
    implements IGetCountryFootprintDetailsQueryResult
  {
    constructor(data?: IGetCountryFootprintDetailsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryFootprintDetailsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryFootprintDetailsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryFootprintDetailsQueryResult {}

  export class GetCountryFootprintDetailsQueryResultSuccess
    extends GetCountryFootprintDetailsQueryResult
    implements IGetCountryFootprintDetailsQueryResultSuccess
  {
    result!: CountryFootPrintPageData;

    constructor(data?: IGetCountryFootprintDetailsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CountryFootPrintPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CountryFootPrintPageData.fromJS(_data['result'])
          : new CountryFootPrintPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryFootprintDetailsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryFootprintDetailsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryFootprintDetailsQueryResultSuccess
    extends IGetCountryFootprintDetailsQueryResult {
    result: CountryFootPrintPageData;
  }

  export class CountryFootPrintPageData implements ICountryFootPrintPageData {
    countryFootprintDetails!: CountryFootprintDetailsDto | null;

    constructor(data?: ICountryFootPrintPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryFootprintDetails = _data['countryFootprintDetails']
          ? CountryFootprintDetailsDto.fromJS(_data['countryFootprintDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): CountryFootPrintPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CountryFootPrintPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryFootprintDetails'] = this.countryFootprintDetails
        ? this.countryFootprintDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICountryFootPrintPageData {
    countryFootprintDetails: CountryFootprintDetailsDto | null;
  }

  export class CountryFootprintDetailsDto
    implements ICountryFootprintDetailsDto
  {
    id!: string;
    countryCodes!: string[];

    constructor(data?: ICountryFootprintDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryFootprintDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryFootprintDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface ICountryFootprintDetailsDto {
    id: string;
    countryCodes: string[];
  }

  export class GetCountryFootprintDetailsQueryResultFailure
    extends GetCountryFootprintDetailsQueryResult
    implements IGetCountryFootprintDetailsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCountryFootprintDetailsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryFootprintDetailsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryFootprintDetailsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryFootprintDetailsQueryResultFailure
    extends IGetCountryFootprintDetailsQueryResult {
    errors: ResultError[];
  }

  export class GenerateCountryFootPrintFileCommand
    implements IGenerateCountryFootPrintFileCommand
  {
    countryCodes!: string[];

    constructor(data?: IGenerateCountryFootPrintFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): GenerateCountryFootPrintFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new GenerateCountryFootPrintFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface IGenerateCountryFootPrintFileCommand {
    countryCodes: string[];
  }

  export class SaveCountryFootprintDetailsCommandResult
    implements ISaveCountryFootprintDetailsCommandResult
  {
    constructor(data?: ISaveCountryFootprintDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveCountryFootprintDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryFootprintDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveCountryFootprintDetailsCommandResult {}

  export class SaveCountryFootprintDetailsCommandResultSuccess
    extends SaveCountryFootprintDetailsCommandResult
    implements ISaveCountryFootprintDetailsCommandResultSuccess
  {
    constructor(data?: ISaveCountryFootprintDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveCountryFootprintDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryFootprintDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryFootprintDetailsCommandResultSuccess
    extends ISaveCountryFootprintDetailsCommandResult {}

  export class SaveCountryFootprintDetailsCommandResultFailure
    extends SaveCountryFootprintDetailsCommandResult
    implements ISaveCountryFootprintDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveCountryFootprintDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveCountryFootprintDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryFootprintDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveCountryFootprintDetailsCommandResultFailure
    extends ISaveCountryFootprintDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveCountryFootprintDetailsCommand
    implements ISaveCountryFootprintDetailsCommand
  {
    clientId!: string;
    countryCodes!: string[];

    constructor(data?: ISaveCountryFootprintDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): SaveCountryFootprintDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveCountryFootprintDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      return data;
    }
  }

  export interface ISaveCountryFootprintDetailsCommand {
    clientId: string;
    countryCodes: string[];
  }

  export class ParseCountriesFromTemplateFileCommandResult
    implements IParseCountriesFromTemplateFileCommandResult
  {
    constructor(data?: IParseCountriesFromTemplateFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ParseCountriesFromTemplateFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ParseCountriesFromTemplateFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IParseCountriesFromTemplateFileCommandResult {}

  export class ParseCountriesFromTemplateFileCommandResultSuccess
    extends ParseCountriesFromTemplateFileCommandResult
    implements IParseCountriesFromTemplateFileCommandResultSuccess
  {
    result!: string[];

    constructor(data?: IParseCountriesFromTemplateFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result']) this.result!.push(item);
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ParseCountriesFromTemplateFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ParseCountriesFromTemplateFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IParseCountriesFromTemplateFileCommandResultSuccess
    extends IParseCountriesFromTemplateFileCommandResult {
    result: string[];
  }

  export class ParseCountriesFromTemplateFileCommandResultFailure
    extends ParseCountriesFromTemplateFileCommandResult
    implements IParseCountriesFromTemplateFileCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IParseCountriesFromTemplateFileCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ParseCountriesFromTemplateFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ParseCountriesFromTemplateFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IParseCountriesFromTemplateFileCommandResultFailure
    extends IParseCountriesFromTemplateFileCommandResult {
    errors: ResultError[];
  }

  export class UploadContractFileCommandResult
    implements IUploadContractFileCommandResult
  {
    constructor(data?: IUploadContractFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadContractFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadContractFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadContractFileCommandResult {}

  export class UploadContractFileCommandResultSuccess
    extends UploadContractFileCommandResult
    implements IUploadContractFileCommandResultSuccess
  {
    result!: ContractAndPricingDto;

    constructor(data?: IUploadContractFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ContractAndPricingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ContractAndPricingDto.fromJS(_data['result'])
          : new ContractAndPricingDto();
      }
    }

    static override fromJS(data: any): UploadContractFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadContractFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadContractFileCommandResultSuccess
    extends IUploadContractFileCommandResult {
    result: ContractAndPricingDto;
  }

  export class ContractAndPricingDto implements IContractAndPricingDto {
    id!: string;
    contractStartDate!: Date | null;
    contractEndDate!: Date | null;
    deloitteOfficeLeadBillingAddress!: string | null;
    wbsCode!: string | null;
    dataCenter!: DataCenterDto | null;
    clientContractType!: ClientContractTypeDto | null;
    chargeFeeType!: ChargeFeeTypeDto | null;
    calculationFee!: CurrencyFeeDto | null;
    isImplementationFeeCharged!: boolean | null;
    implementationFee!: CurrencyFeeDto | null;
    contractFiles!: ContractFileInfoDto[] | null;
    contractFilesStatusDetails!: ContractFilesStatusDetailsDto | null;

    constructor(data?: IContractAndPricingDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.contractStartDate = _data['contractStartDate']
          ? new Date(_data['contractStartDate'].toString())
          : <any>null;
        this.contractEndDate = _data['contractEndDate']
          ? new Date(_data['contractEndDate'].toString())
          : <any>null;
        this.deloitteOfficeLeadBillingAddress =
          _data['deloitteOfficeLeadBillingAddress'] !== undefined
            ? _data['deloitteOfficeLeadBillingAddress']
            : <any>null;
        this.wbsCode =
          _data['wbsCode'] !== undefined ? _data['wbsCode'] : <any>null;
        this.dataCenter =
          _data['dataCenter'] !== undefined ? _data['dataCenter'] : <any>null;
        this.clientContractType =
          _data['clientContractType'] !== undefined
            ? _data['clientContractType']
            : <any>null;
        this.chargeFeeType =
          _data['chargeFeeType'] !== undefined
            ? _data['chargeFeeType']
            : <any>null;
        this.calculationFee = _data['calculationFee']
          ? CurrencyFeeDto.fromJS(_data['calculationFee'])
          : <any>null;
        this.isImplementationFeeCharged =
          _data['isImplementationFeeCharged'] !== undefined
            ? _data['isImplementationFeeCharged']
            : <any>null;
        this.implementationFee = _data['implementationFee']
          ? CurrencyFeeDto.fromJS(_data['implementationFee'])
          : <any>null;
        if (Array.isArray(_data['contractFiles'])) {
          this.contractFiles = [] as any;
          for (let item of _data['contractFiles'])
            this.contractFiles!.push(ContractFileInfoDto.fromJS(item));
        } else {
          this.contractFiles = <any>null;
        }
        this.contractFilesStatusDetails = _data['contractFilesStatusDetails']
          ? ContractFilesStatusDetailsDto.fromJS(
              _data['contractFilesStatusDetails'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): ContractAndPricingDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContractAndPricingDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['contractStartDate'] = this.contractStartDate
        ? this.contractStartDate.toISOString()
        : <any>null;
      data['contractEndDate'] = this.contractEndDate
        ? this.contractEndDate.toISOString()
        : <any>null;
      data['deloitteOfficeLeadBillingAddress'] =
        this.deloitteOfficeLeadBillingAddress !== undefined
          ? this.deloitteOfficeLeadBillingAddress
          : <any>null;
      data['wbsCode'] = this.wbsCode !== undefined ? this.wbsCode : <any>null;
      data['dataCenter'] =
        this.dataCenter !== undefined ? this.dataCenter : <any>null;
      data['clientContractType'] =
        this.clientContractType !== undefined
          ? this.clientContractType
          : <any>null;
      data['chargeFeeType'] =
        this.chargeFeeType !== undefined ? this.chargeFeeType : <any>null;
      data['calculationFee'] = this.calculationFee
        ? this.calculationFee.toJSON()
        : <any>null;
      data['isImplementationFeeCharged'] =
        this.isImplementationFeeCharged !== undefined
          ? this.isImplementationFeeCharged
          : <any>null;
      data['implementationFee'] = this.implementationFee
        ? this.implementationFee.toJSON()
        : <any>null;
      if (Array.isArray(this.contractFiles)) {
        data['contractFiles'] = [];
        for (let item of this.contractFiles)
          data['contractFiles'].push(item.toJSON());
      }
      data['contractFilesStatusDetails'] = this.contractFilesStatusDetails
        ? this.contractFilesStatusDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IContractAndPricingDto {
    id: string;
    contractStartDate: Date | null;
    contractEndDate: Date | null;
    deloitteOfficeLeadBillingAddress: string | null;
    wbsCode: string | null;
    dataCenter: DataCenterDto | null;
    clientContractType: ClientContractTypeDto | null;
    chargeFeeType: ChargeFeeTypeDto | null;
    calculationFee: CurrencyFeeDto | null;
    isImplementationFeeCharged: boolean | null;
    implementationFee: CurrencyFeeDto | null;
    contractFiles: ContractFileInfoDto[] | null;
    contractFilesStatusDetails: ContractFilesStatusDetailsDto | null;
  }

  export enum DataCenterDto {
    US = 'US',
    EU = 'EU',
  }

  export enum ClientContractTypeDto {
    GAIncentives = 'GAIncentives',
    IncentivesCalculationServices = 'IncentivesCalculationServices',
  }

  export enum ChargeFeeTypeDto {
    AnnualUsageFee = 'AnnualUsageFee',
    PerCalculationFee = 'PerCalculationFee',
  }

  export class CurrencyFeeDto implements ICurrencyFeeDto {
    currencyCode!: string;
    amount!: number;

    constructor(data?: ICurrencyFeeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.amount =
          _data['amount'] !== undefined ? _data['amount'] : <any>null;
      }
    }

    static fromJS(data: any): CurrencyFeeDto {
      data = typeof data === 'object' ? data : {};
      let result = new CurrencyFeeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['amount'] = this.amount !== undefined ? this.amount : <any>null;
      return data;
    }
  }

  export interface ICurrencyFeeDto {
    currencyCode: string;
    amount: number;
  }

  export class ContractFileInfoDto implements IContractFileInfoDto {
    id!: string;
    fileName!: string;
    versionId!: string;
    fileSizeInBytes!: number;
    uploadedOn!: Date;

    constructor(data?: IContractFileInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.versionId =
          _data['versionId'] !== undefined ? _data['versionId'] : <any>null;
        this.fileSizeInBytes =
          _data['fileSizeInBytes'] !== undefined
            ? _data['fileSizeInBytes']
            : <any>null;
        this.uploadedOn = _data['uploadedOn']
          ? new Date(_data['uploadedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ContractFileInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContractFileInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['versionId'] =
        this.versionId !== undefined ? this.versionId : <any>null;
      data['fileSizeInBytes'] =
        this.fileSizeInBytes !== undefined ? this.fileSizeInBytes : <any>null;
      data['uploadedOn'] = this.uploadedOn
        ? this.uploadedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IContractFileInfoDto {
    id: string;
    fileName: string;
    versionId: string;
    fileSizeInBytes: number;
    uploadedOn: Date;
  }

  export class ContractFilesStatusDetailsDto
    implements IContractFilesStatusDetailsDto
  {
    contractFilesStatus!: ContractFilesStatusDto;
    comment!: string | null;

    constructor(data?: IContractFilesStatusDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.contractFilesStatus =
          _data['contractFilesStatus'] !== undefined
            ? _data['contractFilesStatus']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(data: any): ContractFilesStatusDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContractFilesStatusDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractFilesStatus'] =
        this.contractFilesStatus !== undefined
          ? this.contractFilesStatus
          : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IContractFilesStatusDetailsDto {
    contractFilesStatus: ContractFilesStatusDto;
    comment: string | null;
  }

  export enum ContractFilesStatusDto {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
  }

  export class UploadContractFileCommandResultFailure
    extends UploadContractFileCommandResult
    implements IUploadContractFileCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUploadContractFileCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UploadContractFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadContractFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadContractFileCommandResultFailure
    extends IUploadContractFileCommandResult {
    errors: ResultError[];
  }

  export class DeleteContractFileCommandResult
    implements IDeleteContractFileCommandResult
  {
    constructor(data?: IDeleteContractFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteContractFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteContractFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteContractFileCommandResult {}

  export class DeleteContractFileCommandResultSuccess
    extends DeleteContractFileCommandResult
    implements IDeleteContractFileCommandResultSuccess
  {
    contractAndPricing!: ContractAndPricingDto;

    constructor(data?: IDeleteContractFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.contractAndPricing = new ContractAndPricingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.contractAndPricing = _data['contractAndPricing']
          ? ContractAndPricingDto.fromJS(_data['contractAndPricing'])
          : new ContractAndPricingDto();
      }
    }

    static override fromJS(data: any): DeleteContractFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteContractFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractAndPricing'] = this.contractAndPricing
        ? this.contractAndPricing.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteContractFileCommandResultSuccess
    extends IDeleteContractFileCommandResult {
    contractAndPricing: ContractAndPricingDto;
  }

  export class DeleteContractFileCommandResultFailure
    extends DeleteContractFileCommandResult
    implements IDeleteContractFileCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteContractFileCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): DeleteContractFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteContractFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteContractFileCommandResultFailure
    extends IDeleteContractFileCommandResult {
    errors: ResultError[];
  }

  export class SaveContractAndPricingCommandResult
    implements ISaveContractAndPricingCommandResult
  {
    constructor(data?: ISaveContractAndPricingCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveContractAndPricingCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveContractAndPricingCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveContractAndPricingCommandResult {}

  export class SaveContractAndPricingCommandResultSuccess
    extends SaveContractAndPricingCommandResult
    implements ISaveContractAndPricingCommandResultSuccess
  {
    constructor(data?: ISaveContractAndPricingCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveContractAndPricingCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveContractAndPricingCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveContractAndPricingCommandResultSuccess
    extends ISaveContractAndPricingCommandResult {}

  export class SaveContractAndPricingCommandResultFailure
    extends SaveContractAndPricingCommandResult
    implements ISaveContractAndPricingCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveContractAndPricingCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveContractAndPricingCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveContractAndPricingCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveContractAndPricingCommandResultFailure
    extends ISaveContractAndPricingCommandResult {
    errors: ResultError[];
  }

  export class SaveContractAndPricingCommand
    implements ISaveContractAndPricingCommand
  {
    clientId!: string;
    contractStartDate!: Date;
    contractEndDate!: Date;
    deloitteOfficeLeadBillingAddress!: string;
    wbsCode!: string;
    dataCenter!: DataCenterDto;
    clientContractType!: ClientContractTypeDto;
    chargeFeeType!: ChargeFeeTypeDto;
    calculationFee!: CurrencyFeeDto;
    isImplementationFeeCharged!: boolean;
    implementationFee!: CurrencyFeeDto | null;

    constructor(data?: ISaveContractAndPricingCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationFee = new CurrencyFeeDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.contractStartDate = _data['contractStartDate']
          ? new Date(_data['contractStartDate'].toString())
          : <any>null;
        this.contractEndDate = _data['contractEndDate']
          ? new Date(_data['contractEndDate'].toString())
          : <any>null;
        this.deloitteOfficeLeadBillingAddress =
          _data['deloitteOfficeLeadBillingAddress'] !== undefined
            ? _data['deloitteOfficeLeadBillingAddress']
            : <any>null;
        this.wbsCode =
          _data['wbsCode'] !== undefined ? _data['wbsCode'] : <any>null;
        this.dataCenter =
          _data['dataCenter'] !== undefined ? _data['dataCenter'] : <any>null;
        this.clientContractType =
          _data['clientContractType'] !== undefined
            ? _data['clientContractType']
            : <any>null;
        this.chargeFeeType =
          _data['chargeFeeType'] !== undefined
            ? _data['chargeFeeType']
            : <any>null;
        this.calculationFee = _data['calculationFee']
          ? CurrencyFeeDto.fromJS(_data['calculationFee'])
          : new CurrencyFeeDto();
        this.isImplementationFeeCharged =
          _data['isImplementationFeeCharged'] !== undefined
            ? _data['isImplementationFeeCharged']
            : <any>null;
        this.implementationFee = _data['implementationFee']
          ? CurrencyFeeDto.fromJS(_data['implementationFee'])
          : <any>null;
      }
    }

    static fromJS(data: any): SaveContractAndPricingCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveContractAndPricingCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['contractStartDate'] = this.contractStartDate
        ? this.contractStartDate.toISOString()
        : <any>null;
      data['contractEndDate'] = this.contractEndDate
        ? this.contractEndDate.toISOString()
        : <any>null;
      data['deloitteOfficeLeadBillingAddress'] =
        this.deloitteOfficeLeadBillingAddress !== undefined
          ? this.deloitteOfficeLeadBillingAddress
          : <any>null;
      data['wbsCode'] = this.wbsCode !== undefined ? this.wbsCode : <any>null;
      data['dataCenter'] =
        this.dataCenter !== undefined ? this.dataCenter : <any>null;
      data['clientContractType'] =
        this.clientContractType !== undefined
          ? this.clientContractType
          : <any>null;
      data['chargeFeeType'] =
        this.chargeFeeType !== undefined ? this.chargeFeeType : <any>null;
      data['calculationFee'] = this.calculationFee
        ? this.calculationFee.toJSON()
        : <any>null;
      data['isImplementationFeeCharged'] =
        this.isImplementationFeeCharged !== undefined
          ? this.isImplementationFeeCharged
          : <any>null;
      data['implementationFee'] = this.implementationFee
        ? this.implementationFee.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISaveContractAndPricingCommand {
    clientId: string;
    contractStartDate: Date;
    contractEndDate: Date;
    deloitteOfficeLeadBillingAddress: string;
    wbsCode: string;
    dataCenter: DataCenterDto;
    clientContractType: ClientContractTypeDto;
    chargeFeeType: ChargeFeeTypeDto;
    calculationFee: CurrencyFeeDto;
    isImplementationFeeCharged: boolean;
    implementationFee: CurrencyFeeDto | null;
  }

  export class GetContractAndPricingQueryResult
    implements IGetContractAndPricingQueryResult
  {
    constructor(data?: IGetContractAndPricingQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetContractAndPricingQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetContractAndPricingQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetContractAndPricingQueryResult {}

  export class GetContractAndPricingQueryResultSuccess
    extends GetContractAndPricingQueryResult
    implements IGetContractAndPricingQueryResultSuccess
  {
    result!: ContractPricingPageData;

    constructor(data?: IGetContractAndPricingQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ContractPricingPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ContractPricingPageData.fromJS(_data['result'])
          : new ContractPricingPageData();
      }
    }

    static override fromJS(data: any): GetContractAndPricingQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetContractAndPricingQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetContractAndPricingQueryResultSuccess
    extends IGetContractAndPricingQueryResult {
    result: ContractPricingPageData;
  }

  export class ContractPricingPageData implements IContractPricingPageData {
    contractPricing!: ContractAndPricingDto | null;

    constructor(data?: IContractPricingPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.contractPricing = _data['contractPricing']
          ? ContractAndPricingDto.fromJS(_data['contractPricing'])
          : <any>null;
      }
    }

    static fromJS(data: any): ContractPricingPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ContractPricingPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractPricing'] = this.contractPricing
        ? this.contractPricing.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IContractPricingPageData {
    contractPricing: ContractAndPricingDto | null;
  }

  export class GetContractAndPricingQueryResultFailure
    extends GetContractAndPricingQueryResult
    implements IGetContractAndPricingQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetContractAndPricingQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetContractAndPricingQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetContractAndPricingQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetContractAndPricingQueryResultFailure
    extends IGetContractAndPricingQueryResult {
    errors: ResultError[];
  }

  export class SubmitContractFilesForApprovalCommandResult
    implements ISubmitContractFilesForApprovalCommandResult
  {
    constructor(data?: ISubmitContractFilesForApprovalCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SubmitContractFilesForApprovalCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SubmitContractFilesForApprovalCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISubmitContractFilesForApprovalCommandResult {}

  export class SubmitContractFilesForApprovalCommandResultSuccess
    extends SubmitContractFilesForApprovalCommandResult
    implements ISubmitContractFilesForApprovalCommandResultSuccess
  {
    contractAndPricing!: ContractAndPricingDto;

    constructor(data?: ISubmitContractFilesForApprovalCommandResultSuccess) {
      super(data);
      if (!data) {
        this.contractAndPricing = new ContractAndPricingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.contractAndPricing = _data['contractAndPricing']
          ? ContractAndPricingDto.fromJS(_data['contractAndPricing'])
          : new ContractAndPricingDto();
      }
    }

    static override fromJS(
      data: any,
    ): SubmitContractFilesForApprovalCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SubmitContractFilesForApprovalCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractAndPricing'] = this.contractAndPricing
        ? this.contractAndPricing.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISubmitContractFilesForApprovalCommandResultSuccess
    extends ISubmitContractFilesForApprovalCommandResult {
    contractAndPricing: ContractAndPricingDto;
  }

  export class SubmitContractFilesForApprovalCommandResultFailure
    extends SubmitContractFilesForApprovalCommandResult
    implements ISubmitContractFilesForApprovalCommandResultFailure
  {
    constructor(data?: ISubmitContractFilesForApprovalCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SubmitContractFilesForApprovalCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SubmitContractFilesForApprovalCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISubmitContractFilesForApprovalCommandResultFailure
    extends ISubmitContractFilesForApprovalCommandResult {}

  export class ApproveContractFilesCommandResult
    implements IApproveContractFilesCommandResult
  {
    constructor(data?: IApproveContractFilesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ApproveContractFilesCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveContractFilesCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IApproveContractFilesCommandResult {}

  export class ApproveContractFilesCommandResultSuccess
    extends ApproveContractFilesCommandResult
    implements IApproveContractFilesCommandResultSuccess
  {
    contractAndPricing!: ContractAndPricingDto;

    constructor(data?: IApproveContractFilesCommandResultSuccess) {
      super(data);
      if (!data) {
        this.contractAndPricing = new ContractAndPricingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.contractAndPricing = _data['contractAndPricing']
          ? ContractAndPricingDto.fromJS(_data['contractAndPricing'])
          : new ContractAndPricingDto();
      }
    }

    static override fromJS(
      data: any,
    ): ApproveContractFilesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveContractFilesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractAndPricing'] = this.contractAndPricing
        ? this.contractAndPricing.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveContractFilesCommandResultSuccess
    extends IApproveContractFilesCommandResult {
    contractAndPricing: ContractAndPricingDto;
  }

  export class ApproveContractFilesCommandResultFailure
    extends ApproveContractFilesCommandResult
    implements IApproveContractFilesCommandResultFailure
  {
    constructor(data?: IApproveContractFilesCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): ApproveContractFilesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveContractFilesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveContractFilesCommandResultFailure
    extends IApproveContractFilesCommandResult {}

  export class RejectContractFilesCommandResult
    implements IRejectContractFilesCommandResult
  {
    constructor(data?: IRejectContractFilesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): RejectContractFilesCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new RejectContractFilesCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IRejectContractFilesCommandResult {}

  export class RejectContractFilesCommandResultSuccess
    extends RejectContractFilesCommandResult
    implements IRejectContractFilesCommandResultSuccess
  {
    contractAndPricing!: ContractAndPricingDto;

    constructor(data?: IRejectContractFilesCommandResultSuccess) {
      super(data);
      if (!data) {
        this.contractAndPricing = new ContractAndPricingDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.contractAndPricing = _data['contractAndPricing']
          ? ContractAndPricingDto.fromJS(_data['contractAndPricing'])
          : new ContractAndPricingDto();
      }
    }

    static override fromJS(data: any): RejectContractFilesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new RejectContractFilesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['contractAndPricing'] = this.contractAndPricing
        ? this.contractAndPricing.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRejectContractFilesCommandResultSuccess
    extends IRejectContractFilesCommandResult {
    contractAndPricing: ContractAndPricingDto;
  }

  export class RejectContractFilesCommandResultFailure
    extends RejectContractFilesCommandResult
    implements IRejectContractFilesCommandResultFailure
  {
    constructor(data?: IRejectContractFilesCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): RejectContractFilesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new RejectContractFilesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IRejectContractFilesCommandResultFailure
    extends IRejectContractFilesCommandResult {}

  export class GetClientTeamPageDataQueryResult
    implements IGetClientTeamPageDataQueryResult
  {
    constructor(data?: IGetClientTeamPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientTeamPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientTeamPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientTeamPageDataQueryResult {}

  export class GetClientTeamPageDataQueryResultSuccess
    extends GetClientTeamPageDataQueryResult
    implements IGetClientTeamPageDataQueryResultSuccess
  {
    result!: ClientTeamPageData;

    constructor(data?: IGetClientTeamPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ClientTeamPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ClientTeamPageData.fromJS(_data['result'])
          : new ClientTeamPageData();
      }
    }

    static override fromJS(data: any): GetClientTeamPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientTeamPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientTeamPageDataQueryResultSuccess
    extends IGetClientTeamPageDataQueryResult {
    result: ClientTeamPageData;
  }

  export class ClientTeamPageData implements IClientTeamPageData {
    clientTeamDetails!: ClientTeamDetailsDto | null;

    constructor(data?: IClientTeamPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientTeamDetails = _data['clientTeamDetails']
          ? ClientTeamDetailsDto.fromJS(_data['clientTeamDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): ClientTeamPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ClientTeamPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientTeamDetails'] = this.clientTeamDetails
        ? this.clientTeamDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IClientTeamPageData {
    clientTeamDetails: ClientTeamDetailsDto | null;
  }

  export class ClientTeamDetailsDto implements IClientTeamDetailsDto {
    id!: string;
    clientTeamMembers!: ClientTeamMemberDto[];

    constructor(data?: IClientTeamDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientTeamMembers = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        if (Array.isArray(_data['clientTeamMembers'])) {
          this.clientTeamMembers = [] as any;
          for (let item of _data['clientTeamMembers'])
            this.clientTeamMembers!.push(ClientTeamMemberDto.fromJS(item));
        } else {
          this.clientTeamMembers = <any>null;
        }
      }
    }

    static fromJS(data: any): ClientTeamDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientTeamDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      if (Array.isArray(this.clientTeamMembers)) {
        data['clientTeamMembers'] = [];
        for (let item of this.clientTeamMembers)
          data['clientTeamMembers'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IClientTeamDetailsDto {
    id: string;
    clientTeamMembers: ClientTeamMemberDto[];
  }

  export class ClientTeamMemberDto implements IClientTeamMemberDto {
    id!: string;
    name!: string;
    email!: string;
    jobTitle!: string;

    constructor(data?: IClientTeamMemberDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.jobTitle =
          _data['jobTitle'] !== undefined ? _data['jobTitle'] : <any>null;
      }
    }

    static fromJS(data: any): ClientTeamMemberDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientTeamMemberDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['jobTitle'] =
        this.jobTitle !== undefined ? this.jobTitle : <any>null;
      return data;
    }
  }

  export interface IClientTeamMemberDto {
    id: string;
    name: string;
    email: string;
    jobTitle: string;
  }

  export class GetClientTeamPageDataQueryResultFailure
    extends GetClientTeamPageDataQueryResult
    implements IGetClientTeamPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetClientTeamPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetClientTeamPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientTeamPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientTeamPageDataQueryResultFailure
    extends IGetClientTeamPageDataQueryResult {
    errors: ResultError[];
  }

  export class AddClientTeamMemberCommandResult
    implements IAddClientTeamMemberCommandResult
  {
    constructor(data?: IAddClientTeamMemberCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): AddClientTeamMemberCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new AddClientTeamMemberCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IAddClientTeamMemberCommandResult {}

  export class AddClientTeamMemberCommandResultSuccess
    extends AddClientTeamMemberCommandResult
    implements IAddClientTeamMemberCommandResultSuccess
  {
    result!: ClientTeamDetailsDto;

    constructor(data?: IAddClientTeamMemberCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ClientTeamDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ClientTeamDetailsDto.fromJS(_data['result'])
          : new ClientTeamDetailsDto();
      }
    }

    static override fromJS(data: any): AddClientTeamMemberCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new AddClientTeamMemberCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddClientTeamMemberCommandResultSuccess
    extends IAddClientTeamMemberCommandResult {
    result: ClientTeamDetailsDto;
  }

  export class AddClientTeamMemberCommandResultFailure
    extends AddClientTeamMemberCommandResult
    implements IAddClientTeamMemberCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IAddClientTeamMemberCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): AddClientTeamMemberCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new AddClientTeamMemberCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IAddClientTeamMemberCommandResultFailure
    extends IAddClientTeamMemberCommandResult {
    errors: ResultError[];
  }

  export class AddClientTeamMemberCommand
    implements IAddClientTeamMemberCommand
  {
    portalId!: string;
    clientId!: string;
    name!: string;
    email!: string;
    jobTitle!: string;

    constructor(data?: IAddClientTeamMemberCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.jobTitle =
          _data['jobTitle'] !== undefined ? _data['jobTitle'] : <any>null;
      }
    }

    static fromJS(data: any): AddClientTeamMemberCommand {
      data = typeof data === 'object' ? data : {};
      let result = new AddClientTeamMemberCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['jobTitle'] =
        this.jobTitle !== undefined ? this.jobTitle : <any>null;
      return data;
    }
  }

  export interface IAddClientTeamMemberCommand {
    portalId: string;
    clientId: string;
    name: string;
    email: string;
    jobTitle: string;
  }

  export class UpdateClientTeamMemberCommandResult
    implements IUpdateClientTeamMemberCommandResult
  {
    constructor(data?: IUpdateClientTeamMemberCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateClientTeamMemberCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateClientTeamMemberCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateClientTeamMemberCommandResult {}

  export class UpdateClientTeamMemberCommandResultSuccess
    extends UpdateClientTeamMemberCommandResult
    implements IUpdateClientTeamMemberCommandResultSuccess
  {
    result!: ClientTeamDetailsDto;

    constructor(data?: IUpdateClientTeamMemberCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ClientTeamDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ClientTeamDetailsDto.fromJS(_data['result'])
          : new ClientTeamDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): UpdateClientTeamMemberCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateClientTeamMemberCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateClientTeamMemberCommandResultSuccess
    extends IUpdateClientTeamMemberCommandResult {
    result: ClientTeamDetailsDto;
  }

  export class UpdateClientTeamMemberCommandResultFailure
    extends UpdateClientTeamMemberCommandResult
    implements IUpdateClientTeamMemberCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateClientTeamMemberCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpdateClientTeamMemberCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateClientTeamMemberCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateClientTeamMemberCommandResultFailure
    extends IUpdateClientTeamMemberCommandResult {
    errors: ResultError[];
  }

  export class UpdateClientTeamMemberCommand
    implements IUpdateClientTeamMemberCommand
  {
    clientId!: string;
    clientTeamMemberId!: string;
    name!: string;
    email!: string;
    jobTitle!: string;

    constructor(data?: IUpdateClientTeamMemberCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientTeamMemberId =
          _data['clientTeamMemberId'] !== undefined
            ? _data['clientTeamMemberId']
            : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.jobTitle =
          _data['jobTitle'] !== undefined ? _data['jobTitle'] : <any>null;
      }
    }

    static fromJS(data: any): UpdateClientTeamMemberCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateClientTeamMemberCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientTeamMemberId'] =
        this.clientTeamMemberId !== undefined
          ? this.clientTeamMemberId
          : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['jobTitle'] =
        this.jobTitle !== undefined ? this.jobTitle : <any>null;
      return data;
    }
  }

  export interface IUpdateClientTeamMemberCommand {
    clientId: string;
    clientTeamMemberId: string;
    name: string;
    email: string;
    jobTitle: string;
  }

  export class DeleteClientTeamMemberCommandResult
    implements IDeleteClientTeamMemberCommandResult
  {
    constructor(data?: IDeleteClientTeamMemberCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteClientTeamMemberCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteClientTeamMemberCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteClientTeamMemberCommandResult {}

  export class DeleteClientTeamMemberCommandResultSuccess
    extends DeleteClientTeamMemberCommandResult
    implements IDeleteClientTeamMemberCommandResultSuccess
  {
    constructor(data?: IDeleteClientTeamMemberCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteClientTeamMemberCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteClientTeamMemberCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteClientTeamMemberCommandResultSuccess
    extends IDeleteClientTeamMemberCommandResult {}

  export class DeleteClientTeamMemberCommandResultFailure
    extends DeleteClientTeamMemberCommandResult
    implements IDeleteClientTeamMemberCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDeleteClientTeamMemberCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteClientTeamMemberCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteClientTeamMemberCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteClientTeamMemberCommandResultFailure
    extends IDeleteClientTeamMemberCommandResult {
    errors: ResultError[];
  }

  export class SaveClientTeamDetailsCommandResult
    implements ISaveClientTeamDetailsCommandResult
  {
    constructor(data?: ISaveClientTeamDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveClientTeamDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientTeamDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveClientTeamDetailsCommandResult {}

  export class SaveClientTeamDetailsCommandResultSuccess
    extends SaveClientTeamDetailsCommandResult
    implements ISaveClientTeamDetailsCommandResultSuccess
  {
    constructor(data?: ISaveClientTeamDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveClientTeamDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientTeamDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientTeamDetailsCommandResultSuccess
    extends ISaveClientTeamDetailsCommandResult {}

  export class SaveClientTeamDetailsCommandResultFailure
    extends SaveClientTeamDetailsCommandResult
    implements ISaveClientTeamDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveClientTeamDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveClientTeamDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientTeamDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientTeamDetailsCommandResultFailure
    extends ISaveClientTeamDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveClientTeamDetailsCommand
    implements ISaveClientTeamDetailsCommand
  {
    clientId!: string;

    constructor(data?: ISaveClientTeamDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
      }
    }

    static fromJS(data: any): SaveClientTeamDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientTeamDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      return data;
    }
  }

  export interface ISaveClientTeamDetailsCommand {
    clientId: string;
  }

  export class GetPayrollPageDataQueryResult
    implements IGetPayrollPageDataQueryResult
  {
    constructor(data?: IGetPayrollPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPayrollPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetPayrollPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPayrollPageDataQueryResult {}

  export class GetPayrollPageDataQueryResultSuccess
    extends GetPayrollPageDataQueryResult
    implements IGetPayrollPageDataQueryResultSuccess
  {
    result!: PayrollPageData;

    constructor(data?: IGetPayrollPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PayrollPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PayrollPageData.fromJS(_data['result'])
          : new PayrollPageData();
      }
    }

    static override fromJS(data: any): GetPayrollPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPayrollPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPayrollPageDataQueryResultSuccess
    extends IGetPayrollPageDataQueryResult {
    result: PayrollPageData;
  }

  export class PayrollPageData implements IPayrollPageData {
    payrollProviders!: PayrollProviderLookupOptionDto[];
    clientPayrollDetails!: ClientPayrollDetailsDto | null;

    constructor(data?: IPayrollPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.payrollProviders = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['payrollProviders'])) {
          this.payrollProviders = [] as any;
          for (let item of _data['payrollProviders'])
            this.payrollProviders!.push(
              PayrollProviderLookupOptionDto.fromJS(item),
            );
        } else {
          this.payrollProviders = <any>null;
        }
        this.clientPayrollDetails = _data['clientPayrollDetails']
          ? ClientPayrollDetailsDto.fromJS(_data['clientPayrollDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): PayrollPageData {
      data = typeof data === 'object' ? data : {};
      let result = new PayrollPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.payrollProviders)) {
        data['payrollProviders'] = [];
        for (let item of this.payrollProviders)
          data['payrollProviders'].push(item.toJSON());
      }
      data['clientPayrollDetails'] = this.clientPayrollDetails
        ? this.clientPayrollDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IPayrollPageData {
    payrollProviders: PayrollProviderLookupOptionDto[];
    clientPayrollDetails: ClientPayrollDetailsDto | null;
  }

  export class PayrollProviderLookupOptionDto
    implements IPayrollProviderLookupOptionDto
  {
    id!: string;
    display!: string;
    displayOrder!: number;

    constructor(data?: IPayrollProviderLookupOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): PayrollProviderLookupOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new PayrollProviderLookupOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IPayrollProviderLookupOptionDto {
    id: string;
    display: string;
    displayOrder: number;
  }

  export class GetPayrollPageDataQueryResultFailure
    extends GetPayrollPageDataQueryResult
    implements IGetPayrollPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetPayrollPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetPayrollPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPayrollPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPayrollPageDataQueryResultFailure
    extends IGetPayrollPageDataQueryResult {
    errors: ResultError[];
  }

  export class SaveClientPayrollDetailsCommandResult
    implements ISaveClientPayrollDetailsCommandResult
  {
    constructor(data?: ISaveClientPayrollDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveClientPayrollDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientPayrollDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveClientPayrollDetailsCommandResult {}

  export class SaveClientPayrollDetailsCommandResultSuccess
    extends SaveClientPayrollDetailsCommandResult
    implements ISaveClientPayrollDetailsCommandResultSuccess
  {
    constructor(data?: ISaveClientPayrollDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveClientPayrollDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientPayrollDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientPayrollDetailsCommandResultSuccess
    extends ISaveClientPayrollDetailsCommandResult {}

  export class SaveClientPayrollDetailsCommandResultFailure
    extends SaveClientPayrollDetailsCommandResult
    implements ISaveClientPayrollDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveClientPayrollDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveClientPayrollDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientPayrollDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientPayrollDetailsCommandResultFailure
    extends ISaveClientPayrollDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveClientPayrollDetailsCommand
    implements ISaveClientPayrollDetailsCommand
  {
    clientId!: string;
    payrollOptions!: string[];
    otherPayrollOption!: string;

    constructor(data?: ISaveClientPayrollDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.payrollOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['payrollOptions'])) {
          this.payrollOptions = [] as any;
          for (let item of _data['payrollOptions'])
            this.payrollOptions!.push(item);
        } else {
          this.payrollOptions = <any>null;
        }
        this.otherPayrollOption =
          _data['otherPayrollOption'] !== undefined
            ? _data['otherPayrollOption']
            : <any>null;
      }
    }

    static fromJS(data: any): SaveClientPayrollDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientPayrollDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.payrollOptions)) {
        data['payrollOptions'] = [];
        for (let item of this.payrollOptions) data['payrollOptions'].push(item);
      }
      data['otherPayrollOption'] =
        this.otherPayrollOption !== undefined
          ? this.otherPayrollOption
          : <any>null;
      return data;
    }
  }

  export interface ISaveClientPayrollDetailsCommand {
    clientId: string;
    payrollOptions: string[];
    otherPayrollOption: string;
  }

  export class GetClientEnrollmentOptionsQueryResult
    implements IGetClientEnrollmentOptionsQueryResult
  {
    constructor(data?: IGetClientEnrollmentOptionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientEnrollmentOptionsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientEnrollmentOptionsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientEnrollmentOptionsQueryResult {}

  export class GetClientEnrollmentOptionsQueryResultSuccess
    extends GetClientEnrollmentOptionsQueryResult
    implements IGetClientEnrollmentOptionsQueryResultSuccess
  {
    result!: ClientEnrollmentOption[];

    constructor(data?: IGetClientEnrollmentOptionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(ClientEnrollmentOption.fromJS(item));
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetClientEnrollmentOptionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientEnrollmentOptionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientEnrollmentOptionsQueryResultSuccess
    extends IGetClientEnrollmentOptionsQueryResult {
    result: ClientEnrollmentOption[];
  }

  export class ClientEnrollmentOption implements IClientEnrollmentOption {
    id!: string;
    name!: string;
    existingClientState!: ClientState | null;

    constructor(data?: IClientEnrollmentOption) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.existingClientState =
          _data['existingClientState'] !== undefined
            ? _data['existingClientState']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientEnrollmentOption {
      data = typeof data === 'object' ? data : {};
      let result = new ClientEnrollmentOption();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['existingClientState'] =
        this.existingClientState !== undefined
          ? this.existingClientState
          : <any>null;
      return data;
    }
  }

  export interface IClientEnrollmentOption {
    id: string;
    name: string;
    existingClientState: ClientState | null;
  }

  export enum ClientState {
    Enrolling = 'Enrolling',
    Active = 'Active',
  }

  export class GetClientEnrollmentOptionsQueryResultFailure
    extends GetClientEnrollmentOptionsQueryResult
    implements IGetClientEnrollmentOptionsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetClientEnrollmentOptionsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetClientEnrollmentOptionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientEnrollmentOptionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientEnrollmentOptionsQueryResultFailure
    extends IGetClientEnrollmentOptionsQueryResult {
    errors: ResultError[];
  }

  export class EnrollClientCommandResult implements IEnrollClientCommandResult {
    constructor(data?: IEnrollClientCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): EnrollClientCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new EnrollClientCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IEnrollClientCommandResult {}

  export class EnrollClientCommandResultSuccess
    extends EnrollClientCommandResult
    implements IEnrollClientCommandResultSuccess
  {
    result!: ClientDto;

    constructor(data?: IEnrollClientCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ClientDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ClientDto.fromJS(_data['result'])
          : new ClientDto();
      }
    }

    static override fromJS(data: any): EnrollClientCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new EnrollClientCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IEnrollClientCommandResultSuccess
    extends IEnrollClientCommandResult {
    result: ClientDto;
  }

  export class EnrollClientCommandResultFailure
    extends EnrollClientCommandResult
    implements IEnrollClientCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IEnrollClientCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): EnrollClientCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new EnrollClientCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IEnrollClientCommandResultFailure
    extends IEnrollClientCommandResult {
    errors: ResultError[];
  }

  export class EnrollClientCommand implements IEnrollClientCommand {
    id!: string;

    constructor(data?: IEnrollClientCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): EnrollClientCommand {
      data = typeof data === 'object' ? data : {};
      let result = new EnrollClientCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IEnrollClientCommand {
    id: string;
  }

  export abstract class ClientIndexPageQueryResult
    implements IClientIndexPageQueryResult
  {
    constructor(data?: IClientIndexPageQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ClientIndexPageQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ClientIndexPageQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IClientIndexPageQueryResult {}

  export class ClientIndexPageQuerySuccess
    extends ClientIndexPageQueryResult
    implements IClientIndexPageQuerySuccess
  {
    result!: PageModelOfClientIndexPageRow;

    constructor(data?: IClientIndexPageQuerySuccess) {
      super(data);
      if (!data) {
        this.result = new PageModelOfClientIndexPageRow();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PageModelOfClientIndexPageRow.fromJS(_data['result'])
          : new PageModelOfClientIndexPageRow();
      }
    }

    static override fromJS(data: any): ClientIndexPageQuerySuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ClientIndexPageQuerySuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IClientIndexPageQuerySuccess
    extends IClientIndexPageQueryResult {
    result: PageModelOfClientIndexPageRow;
  }

  export class PageModelOfClientIndexPageRow
    extends PageModel
    implements IPageModelOfClientIndexPageRow
  {
    items!: ClientIndexPageRow[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfClientIndexPageRow) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(ClientIndexPageRow.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfClientIndexPageRow {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfClientIndexPageRow();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfClientIndexPageRow extends IPageModel {
    items: ClientIndexPageRow[];
    totalItems: number | null;
  }

  export class ClientIndexPageRow implements IClientIndexPageRow {
    id!: string;
    portalId!: string;
    name!: string;
    configurationStatus!: string;
    contractEndDate!: Date | null;
    nextLiveEvent!: Date | null;
    manualCalculationInfo!: ClientIndexPageRowManualCalcInfo | null;

    constructor(data?: IClientIndexPageRow) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.configurationStatus =
          _data['configurationStatus'] !== undefined
            ? _data['configurationStatus']
            : <any>null;
        this.contractEndDate = _data['contractEndDate']
          ? new Date(_data['contractEndDate'].toString())
          : <any>null;
        this.nextLiveEvent = _data['nextLiveEvent']
          ? new Date(_data['nextLiveEvent'].toString())
          : <any>null;
        this.manualCalculationInfo = _data['manualCalculationInfo']
          ? ClientIndexPageRowManualCalcInfo.fromJS(
              _data['manualCalculationInfo'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): ClientIndexPageRow {
      data = typeof data === 'object' ? data : {};
      let result = new ClientIndexPageRow();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['configurationStatus'] =
        this.configurationStatus !== undefined
          ? this.configurationStatus
          : <any>null;
      data['contractEndDate'] = this.contractEndDate
        ? this.contractEndDate.toISOString()
        : <any>null;
      data['nextLiveEvent'] = this.nextLiveEvent
        ? this.nextLiveEvent.toISOString()
        : <any>null;
      data['manualCalculationInfo'] = this.manualCalculationInfo
        ? this.manualCalculationInfo.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IClientIndexPageRow {
    id: string;
    portalId: string;
    name: string;
    configurationStatus: string;
    contractEndDate: Date | null;
    nextLiveEvent: Date | null;
    manualCalculationInfo: ClientIndexPageRowManualCalcInfo | null;
  }

  export class ClientIndexPageRowManualCalcInfo
    implements IClientIndexPageRowManualCalcInfo
  {
    employeesCount!: number;
    transactionsCount!: number;

    constructor(data?: IClientIndexPageRowManualCalcInfo) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeesCount =
          _data['employeesCount'] !== undefined
            ? _data['employeesCount']
            : <any>null;
        this.transactionsCount =
          _data['transactionsCount'] !== undefined
            ? _data['transactionsCount']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientIndexPageRowManualCalcInfo {
      data = typeof data === 'object' ? data : {};
      let result = new ClientIndexPageRowManualCalcInfo();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeesCount'] =
        this.employeesCount !== undefined ? this.employeesCount : <any>null;
      data['transactionsCount'] =
        this.transactionsCount !== undefined
          ? this.transactionsCount
          : <any>null;
      return data;
    }
  }

  export interface IClientIndexPageRowManualCalcInfo {
    employeesCount: number;
    transactionsCount: number;
  }

  export class ClientIndexPageQueryFailure
    extends ClientIndexPageQueryResult
    implements IClientIndexPageQueryFailure
  {
    errors!: ResultError[];

    constructor(data?: IClientIndexPageQueryFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): ClientIndexPageQueryFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ClientIndexPageQueryFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IClientIndexPageQueryFailure
    extends IClientIndexPageQueryResult {
    errors: ResultError[];
  }

  export class ClientIndexPageQuery implements IClientIndexPageQuery {
    portalId!: string;
    query!: string | null;
    currentPage!: number;
    pageSize!: number;

    constructor(data?: IClientIndexPageQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.portalId =
          _data['portalId'] !== undefined ? _data['portalId'] : <any>null;
        this.query = _data['query'] !== undefined ? _data['query'] : <any>null;
        this.currentPage =
          _data['currentPage'] !== undefined ? _data['currentPage'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): ClientIndexPageQuery {
      data = typeof data === 'object' ? data : {};
      let result = new ClientIndexPageQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['portalId'] =
        this.portalId !== undefined ? this.portalId : <any>null;
      data['query'] = this.query !== undefined ? this.query : <any>null;
      data['currentPage'] =
        this.currentPage !== undefined ? this.currentPage : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface IClientIndexPageQuery {
    portalId: string;
    query: string | null;
    currentPage: number;
    pageSize: number;
  }

  export class GetClientContextByPortalIdQueryResult
    implements IGetClientContextByPortalIdQueryResult
  {
    constructor(data?: IGetClientContextByPortalIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientContextByPortalIdQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientContextByPortalIdQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientContextByPortalIdQueryResult {}

  export class GetClientContextByPortalIdQueryResultSuccess
    extends GetClientContextByPortalIdQueryResult
    implements IGetClientContextByPortalIdQueryResultSuccess
  {
    result!: ClientContextDto;

    constructor(data?: IGetClientContextByPortalIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new ClientContextDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? ClientContextDto.fromJS(_data['result'])
          : new ClientContextDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetClientContextByPortalIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientContextByPortalIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientContextByPortalIdQueryResultSuccess
    extends IGetClientContextByPortalIdQueryResult {
    result: ClientContextDto;
  }

  export class ClientContextDto implements IClientContextDto {
    client!: ClientDto;
    userCanManage!: boolean;
    userCanRunCalculations!: boolean;
    userCanMangeContractFiles!: boolean;
    calculationsAreEnabled!: boolean;
    canRunBatchViaDataExchange!: boolean;
    userCanApproveManualCalculations!: boolean;
    numericPrecision!: number;
    percentagePrecision!: number;
    clientExchangeRatePolicyApplicable!: boolean;
    workLocationTypesAreConsideredForTEQ!: boolean;
    taxAdjustmentsEnabled!: boolean;
    teqWorklocationSettingHasHypoTax!: boolean;
    regionTaxRatePageEnabled!: boolean;

    constructor(data?: IClientContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.client = new ClientDto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.client = _data['client']
          ? ClientDto.fromJS(_data['client'])
          : new ClientDto();
        this.userCanManage =
          _data['userCanManage'] !== undefined
            ? _data['userCanManage']
            : <any>null;
        this.userCanRunCalculations =
          _data['userCanRunCalculations'] !== undefined
            ? _data['userCanRunCalculations']
            : <any>null;
        this.userCanMangeContractFiles =
          _data['userCanMangeContractFiles'] !== undefined
            ? _data['userCanMangeContractFiles']
            : <any>null;
        this.calculationsAreEnabled =
          _data['calculationsAreEnabled'] !== undefined
            ? _data['calculationsAreEnabled']
            : <any>null;
        this.canRunBatchViaDataExchange =
          _data['canRunBatchViaDataExchange'] !== undefined
            ? _data['canRunBatchViaDataExchange']
            : <any>null;
        this.userCanApproveManualCalculations =
          _data['userCanApproveManualCalculations'] !== undefined
            ? _data['userCanApproveManualCalculations']
            : <any>null;
        this.numericPrecision =
          _data['numericPrecision'] !== undefined
            ? _data['numericPrecision']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
        this.clientExchangeRatePolicyApplicable =
          _data['clientExchangeRatePolicyApplicable'] !== undefined
            ? _data['clientExchangeRatePolicyApplicable']
            : <any>null;
        this.workLocationTypesAreConsideredForTEQ =
          _data['workLocationTypesAreConsideredForTEQ'] !== undefined
            ? _data['workLocationTypesAreConsideredForTEQ']
            : <any>null;
        this.taxAdjustmentsEnabled =
          _data['taxAdjustmentsEnabled'] !== undefined
            ? _data['taxAdjustmentsEnabled']
            : <any>null;
        this.teqWorklocationSettingHasHypoTax =
          _data['teqWorklocationSettingHasHypoTax'] !== undefined
            ? _data['teqWorklocationSettingHasHypoTax']
            : <any>null;
        this.regionTaxRatePageEnabled =
          _data['regionTaxRatePageEnabled'] !== undefined
            ? _data['regionTaxRatePageEnabled']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['client'] = this.client ? this.client.toJSON() : <any>null;
      data['userCanManage'] =
        this.userCanManage !== undefined ? this.userCanManage : <any>null;
      data['userCanRunCalculations'] =
        this.userCanRunCalculations !== undefined
          ? this.userCanRunCalculations
          : <any>null;
      data['userCanMangeContractFiles'] =
        this.userCanMangeContractFiles !== undefined
          ? this.userCanMangeContractFiles
          : <any>null;
      data['calculationsAreEnabled'] =
        this.calculationsAreEnabled !== undefined
          ? this.calculationsAreEnabled
          : <any>null;
      data['canRunBatchViaDataExchange'] =
        this.canRunBatchViaDataExchange !== undefined
          ? this.canRunBatchViaDataExchange
          : <any>null;
      data['userCanApproveManualCalculations'] =
        this.userCanApproveManualCalculations !== undefined
          ? this.userCanApproveManualCalculations
          : <any>null;
      data['numericPrecision'] =
        this.numericPrecision !== undefined ? this.numericPrecision : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      data['clientExchangeRatePolicyApplicable'] =
        this.clientExchangeRatePolicyApplicable !== undefined
          ? this.clientExchangeRatePolicyApplicable
          : <any>null;
      data['workLocationTypesAreConsideredForTEQ'] =
        this.workLocationTypesAreConsideredForTEQ !== undefined
          ? this.workLocationTypesAreConsideredForTEQ
          : <any>null;
      data['taxAdjustmentsEnabled'] =
        this.taxAdjustmentsEnabled !== undefined
          ? this.taxAdjustmentsEnabled
          : <any>null;
      data['teqWorklocationSettingHasHypoTax'] =
        this.teqWorklocationSettingHasHypoTax !== undefined
          ? this.teqWorklocationSettingHasHypoTax
          : <any>null;
      data['regionTaxRatePageEnabled'] =
        this.regionTaxRatePageEnabled !== undefined
          ? this.regionTaxRatePageEnabled
          : <any>null;
      return data;
    }
  }

  export interface IClientContextDto {
    client: ClientDto;
    userCanManage: boolean;
    userCanRunCalculations: boolean;
    userCanMangeContractFiles: boolean;
    calculationsAreEnabled: boolean;
    canRunBatchViaDataExchange: boolean;
    userCanApproveManualCalculations: boolean;
    numericPrecision: number;
    percentagePrecision: number;
    clientExchangeRatePolicyApplicable: boolean;
    workLocationTypesAreConsideredForTEQ: boolean;
    taxAdjustmentsEnabled: boolean;
    teqWorklocationSettingHasHypoTax: boolean;
    regionTaxRatePageEnabled: boolean;
  }

  export class GetClientContextByPortalIdQueryResultFailure
    extends GetClientContextByPortalIdQueryResult
    implements IGetClientContextByPortalIdQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetClientContextByPortalIdQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetClientContextByPortalIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientContextByPortalIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientContextByPortalIdQueryResultFailure
    extends IGetClientContextByPortalIdQueryResult {
    errors: ResultError[];
  }

  export class SearchTransactionsCommandResult
    implements ISearchTransactionsCommandResult
  {
    constructor(data?: ISearchTransactionsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchTransactionsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SearchTransactionsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchTransactionsCommandResult {}

  export class SearchTransactionsCommandResultSuccess
    extends SearchTransactionsCommandResult
    implements ISearchTransactionsCommandResultSuccess
  {
    result!: PageModelOfTransactionIndexModelDto;

    constructor(data?: ISearchTransactionsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PageModelOfTransactionIndexModelDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PageModelOfTransactionIndexModelDto.fromJS(_data['result'])
          : new PageModelOfTransactionIndexModelDto();
      }
    }

    static override fromJS(data: any): SearchTransactionsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchTransactionsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchTransactionsCommandResultSuccess
    extends ISearchTransactionsCommandResult {
    result: PageModelOfTransactionIndexModelDto;
  }

  export class PageModelOfTransactionIndexModelDto
    extends PageModel
    implements IPageModelOfTransactionIndexModelDto
  {
    items!: TransactionIndexModelDto[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfTransactionIndexModelDto) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(TransactionIndexModelDto.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfTransactionIndexModelDto {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfTransactionIndexModelDto();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfTransactionIndexModelDto extends IPageModel {
    items: TransactionIndexModelDto[];
    totalItems: number | null;
  }

  export class TransactionIndexModelDto implements ITransactionIndexModelDto {
    transactionGuid!: string;
    transactionId!: string;
    transactionDate!: Date;
    clientId!: string;
    clientPortalId!: string;
    batchId!: string;
    employeeId!: string;
    employeeFirstName!: string | null;
    employeeLastName!: string | null;
    batchCalculationType!: BatchCalculationType;
    planType!: PlanType;
    calculationId!: string;
    manualCalculationRequired!: boolean;
    calculationStatus!: CalculationStatus;
    transactionStatus!: TransactionStatus | null;

    constructor(data?: ITransactionIndexModelDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.transactionDate = _data['transactionDate']
          ? new Date(_data['transactionDate'].toString())
          : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.employeeFirstName =
          _data['employeeFirstName'] !== undefined
            ? _data['employeeFirstName']
            : <any>null;
        this.employeeLastName =
          _data['employeeLastName'] !== undefined
            ? _data['employeeLastName']
            : <any>null;
        this.batchCalculationType =
          _data['batchCalculationType'] !== undefined
            ? _data['batchCalculationType']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.calculationStatus =
          _data['calculationStatus'] !== undefined
            ? _data['calculationStatus']
            : <any>null;
        this.transactionStatus =
          _data['transactionStatus'] !== undefined
            ? _data['transactionStatus']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionIndexModelDto {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionIndexModelDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['transactionDate'] = this.transactionDate
        ? this.transactionDate.toISOString()
        : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['employeeFirstName'] =
        this.employeeFirstName !== undefined
          ? this.employeeFirstName
          : <any>null;
      data['employeeLastName'] =
        this.employeeLastName !== undefined ? this.employeeLastName : <any>null;
      data['batchCalculationType'] =
        this.batchCalculationType !== undefined
          ? this.batchCalculationType
          : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['calculationStatus'] =
        this.calculationStatus !== undefined
          ? this.calculationStatus
          : <any>null;
      data['transactionStatus'] =
        this.transactionStatus !== undefined
          ? this.transactionStatus
          : <any>null;
      return data;
    }
  }

  export interface ITransactionIndexModelDto {
    transactionGuid: string;
    transactionId: string;
    transactionDate: Date;
    clientId: string;
    clientPortalId: string;
    batchId: string;
    employeeId: string;
    employeeFirstName: string | null;
    employeeLastName: string | null;
    batchCalculationType: BatchCalculationType;
    planType: PlanType;
    calculationId: string;
    manualCalculationRequired: boolean;
    calculationStatus: CalculationStatus;
    transactionStatus: TransactionStatus | null;
  }

  export class SearchTransactionsCommandResultFailure
    extends SearchTransactionsCommandResult
    implements ISearchTransactionsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISearchTransactionsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): SearchTransactionsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchTransactionsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchTransactionsCommandResultFailure
    extends ISearchTransactionsCommandResult {
    errors: ResultError[];
  }

  export class SearchTransactionsCommand implements ISearchTransactionsCommand {
    clientId!: string;
    planTypes!: PlanType[];
    batchCalculationTypes!: BatchCalculationType[];
    calculationStatuses!: CalculationStatus[];
    transactionStatuses!: TransactionStatus[];
    transactionStartDate!: Date | null;
    transactionEndDate!: Date | null;
    query!: string | null;
    requiresManualCalculation!: boolean | null;
    page!: number;
    pageSize!: number;

    constructor(data?: ISearchTransactionsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.planTypes = [];
        this.batchCalculationTypes = [];
        this.calculationStatuses = [];
        this.transactionStatuses = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['batchCalculationTypes'])) {
          this.batchCalculationTypes = [] as any;
          for (let item of _data['batchCalculationTypes'])
            this.batchCalculationTypes!.push(item);
        } else {
          this.batchCalculationTypes = <any>null;
        }
        if (Array.isArray(_data['calculationStatuses'])) {
          this.calculationStatuses = [] as any;
          for (let item of _data['calculationStatuses'])
            this.calculationStatuses!.push(item);
        } else {
          this.calculationStatuses = <any>null;
        }
        if (Array.isArray(_data['transactionStatuses'])) {
          this.transactionStatuses = [] as any;
          for (let item of _data['transactionStatuses'])
            this.transactionStatuses!.push(item);
        } else {
          this.transactionStatuses = <any>null;
        }
        this.transactionStartDate = _data['transactionStartDate']
          ? new Date(_data['transactionStartDate'].toString())
          : <any>null;
        this.transactionEndDate = _data['transactionEndDate']
          ? new Date(_data['transactionEndDate'].toString())
          : <any>null;
        this.query = _data['query'] !== undefined ? _data['query'] : <any>null;
        this.requiresManualCalculation =
          _data['requiresManualCalculation'] !== undefined
            ? _data['requiresManualCalculation']
            : <any>null;
        this.page = _data['page'] !== undefined ? _data['page'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): SearchTransactionsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchTransactionsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.batchCalculationTypes)) {
        data['batchCalculationTypes'] = [];
        for (let item of this.batchCalculationTypes)
          data['batchCalculationTypes'].push(item);
      }
      if (Array.isArray(this.calculationStatuses)) {
        data['calculationStatuses'] = [];
        for (let item of this.calculationStatuses)
          data['calculationStatuses'].push(item);
      }
      if (Array.isArray(this.transactionStatuses)) {
        data['transactionStatuses'] = [];
        for (let item of this.transactionStatuses)
          data['transactionStatuses'].push(item);
      }
      data['transactionStartDate'] = this.transactionStartDate
        ? this.transactionStartDate.toISOString()
        : <any>null;
      data['transactionEndDate'] = this.transactionEndDate
        ? this.transactionEndDate.toISOString()
        : <any>null;
      data['query'] = this.query !== undefined ? this.query : <any>null;
      data['requiresManualCalculation'] =
        this.requiresManualCalculation !== undefined
          ? this.requiresManualCalculation
          : <any>null;
      data['page'] = this.page !== undefined ? this.page : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface ISearchTransactionsCommand {
    clientId: string;
    planTypes: PlanType[];
    batchCalculationTypes: BatchCalculationType[];
    calculationStatuses: CalculationStatus[];
    transactionStatuses: TransactionStatus[];
    transactionStartDate: Date | null;
    transactionEndDate: Date | null;
    query: string | null;
    requiresManualCalculation: boolean | null;
    page: number;
    pageSize: number;
  }

  export class DownloadTaxAdjustmentBatchFileTemplateCommandResult
    implements IDownloadTaxAdjustmentBatchFileTemplateCommandResult
  {
    constructor(data?: IDownloadTaxAdjustmentBatchFileTemplateCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DownloadTaxAdjustmentBatchFileTemplateCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadTaxAdjustmentBatchFileTemplateCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadTaxAdjustmentBatchFileTemplateCommandResult {}

  export class DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess
    extends DownloadTaxAdjustmentBatchFileTemplateCommandResult
    implements IDownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess
  {
    result!: string;

    constructor(
      data?: IDownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadTaxAdjustmentBatchFileTemplateCommandResultSuccess
    extends IDownloadTaxAdjustmentBatchFileTemplateCommandResult {
    result: string;
  }

  export class DownloadTaxAdjustmentBatchFileTemplateCommandResultFailure
    extends DownloadTaxAdjustmentBatchFileTemplateCommandResult
    implements IDownloadTaxAdjustmentBatchFileTemplateCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IDownloadTaxAdjustmentBatchFileTemplateCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadTaxAdjustmentBatchFileTemplateCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadTaxAdjustmentBatchFileTemplateCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadTaxAdjustmentBatchFileTemplateCommandResultFailure
    extends IDownloadTaxAdjustmentBatchFileTemplateCommandResult {
    errors: ResultError[];
  }

  export abstract class DownloadPrePopulatedTaxAdjustmentBatchFileCommandResult
    implements IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResult
  {
    constructor(
      data?: IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DownloadPrePopulatedTaxAdjustmentBatchFileCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadPrePopulatedTaxAdjustmentBatchFileCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResult {}

  export class DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess
    extends DownloadPrePopulatedTaxAdjustmentBatchFileCommandResult
    implements IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess
  {
    result!: string;
    hasMore!: boolean;

    constructor(
      data?: IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
        this.hasMore =
          _data['hasMore'] !== undefined ? _data['hasMore'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      data['hasMore'] = this.hasMore !== undefined ? this.hasMore : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultSuccess
    extends IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResult {
    result: string;
    hasMore: boolean;
  }

  export class DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure
    extends DownloadPrePopulatedTaxAdjustmentBatchFileCommandResult
    implements IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResultFailure
    extends IDownloadPrePopulatedTaxAdjustmentBatchFileCommandResult {
    errorMessage: string;
  }

  export class DownloadPrePopulatedTaxAdjustmentBatchFileCommand
    implements IDownloadPrePopulatedTaxAdjustmentBatchFileCommand
  {
    clientId!: string;
    batchId!: string;
    skipTake!: DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake | null;

    constructor(data?: IDownloadPrePopulatedTaxAdjustmentBatchFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.skipTake = _data['skipTake']
          ? DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake.fromJS(
              _data['skipTake'],
            )
          : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): DownloadPrePopulatedTaxAdjustmentBatchFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadPrePopulatedTaxAdjustmentBatchFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['skipTake'] = this.skipTake ? this.skipTake.toJSON() : <any>null;
      return data;
    }
  }

  export interface IDownloadPrePopulatedTaxAdjustmentBatchFileCommand {
    clientId: string;
    batchId: string;
    skipTake: DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake | null;
  }

  export class DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake
    implements IDownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake
  {
    skip!: number;
    take!: number;

    constructor(
      data?: IDownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.skip = _data['skip'] !== undefined ? _data['skip'] : <any>null;
        this.take = _data['take'] !== undefined ? _data['take'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['skip'] = this.skip !== undefined ? this.skip : <any>null;
      data['take'] = this.take !== undefined ? this.take : <any>null;
      return data;
    }
  }

  export interface IDownloadPrePopulatedTaxAdjustmentBatchFileCommandSkipTake {
    skip: number;
    take: number;
  }

  export class UploadTaxAdjustmentBatchFileCommandResult
    implements IUploadTaxAdjustmentBatchFileCommandResult
  {
    constructor(data?: IUploadTaxAdjustmentBatchFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UploadTaxAdjustmentBatchFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UploadTaxAdjustmentBatchFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadTaxAdjustmentBatchFileCommandResult {}

  export class UploadTaxAdjustmentBatchFileCommandResultSuccess
    extends UploadTaxAdjustmentBatchFileCommandResult
    implements IUploadTaxAdjustmentBatchFileCommandResultSuccess
  {
    brokerAdjustmentJobId!: string;

    constructor(data?: IUploadTaxAdjustmentBatchFileCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.brokerAdjustmentJobId =
          _data['brokerAdjustmentJobId'] !== undefined
            ? _data['brokerAdjustmentJobId']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UploadTaxAdjustmentBatchFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UploadTaxAdjustmentBatchFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['brokerAdjustmentJobId'] =
        this.brokerAdjustmentJobId !== undefined
          ? this.brokerAdjustmentJobId
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadTaxAdjustmentBatchFileCommandResultSuccess
    extends IUploadTaxAdjustmentBatchFileCommandResult {
    brokerAdjustmentJobId: string;
  }

  export class UploadTaxAdjustmentBatchFileCommandResultFailure
    extends UploadTaxAdjustmentBatchFileCommandResult
    implements IUploadTaxAdjustmentBatchFileCommandResultFailure
  {
    error!: string;

    constructor(data?: IUploadTaxAdjustmentBatchFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.error = _data['error'] !== undefined ? _data['error'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UploadTaxAdjustmentBatchFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UploadTaxAdjustmentBatchFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['error'] = this.error !== undefined ? this.error : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadTaxAdjustmentBatchFileCommandResultFailure
    extends IUploadTaxAdjustmentBatchFileCommandResult {
    error: string;
  }

  export abstract class GetBrokerAdjustmentJobQueryResult
    implements IGetBrokerAdjustmentJobQueryResult
  {
    constructor(data?: IGetBrokerAdjustmentJobQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBrokerAdjustmentJobQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBrokerAdjustmentJobQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBrokerAdjustmentJobQueryResult {}

  export class GetBrokerAdjustmentJobQueryResultSuccess
    extends GetBrokerAdjustmentJobQueryResult
    implements IGetBrokerAdjustmentJobQueryResultSuccess
  {
    result!: BrokerAdjustmentJobDto;

    constructor(data?: IGetBrokerAdjustmentJobQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new BrokerAdjustmentJobDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? BrokerAdjustmentJobDto.fromJS(_data['result'])
          : new BrokerAdjustmentJobDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetBrokerAdjustmentJobQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBrokerAdjustmentJobQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBrokerAdjustmentJobQueryResultSuccess
    extends IGetBrokerAdjustmentJobQueryResult {
    result: BrokerAdjustmentJobDto;
  }

  export class BrokerAdjustmentJobDto implements IBrokerAdjustmentJobDto {
    status!: BrokerAdjustmentJobStatus;
    finished!: boolean;
    batchIds!: string[];
    errors!: ExcelValidationErrorDto[];
    totalErrors!: number;

    constructor(data?: IBrokerAdjustmentJobDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchIds = [];
        this.errors = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.finished =
          _data['finished'] !== undefined ? _data['finished'] : <any>null;
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ExcelValidationErrorDto.fromJS(item));
        } else {
          this.errors = <any>null;
        }
        this.totalErrors =
          _data['totalErrors'] !== undefined ? _data['totalErrors'] : <any>null;
      }
    }

    static fromJS(data: any): BrokerAdjustmentJobDto {
      data = typeof data === 'object' ? data : {};
      let result = new BrokerAdjustmentJobDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['finished'] =
        this.finished !== undefined ? this.finished : <any>null;
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      data['totalErrors'] =
        this.totalErrors !== undefined ? this.totalErrors : <any>null;
      return data;
    }
  }

  export interface IBrokerAdjustmentJobDto {
    status: BrokerAdjustmentJobStatus;
    finished: boolean;
    batchIds: string[];
    errors: ExcelValidationErrorDto[];
    totalErrors: number;
  }

  export enum BrokerAdjustmentJobStatus {
    New = 'New',
    Running = 'Running',
    SentToBatches = 'SentToBatches',
    Failed = 'Failed',
  }

  export class GetBrokerAdjustmentJobQueryResultFailure
    extends GetBrokerAdjustmentJobQueryResult
    implements IGetBrokerAdjustmentJobQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetBrokerAdjustmentJobQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetBrokerAdjustmentJobQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBrokerAdjustmentJobQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBrokerAdjustmentJobQueryResultFailure
    extends IGetBrokerAdjustmentJobQueryResult {
    errorMessage: string;
  }

  export class GetBatchFileStatusQueryResult
    implements IGetBatchFileStatusQueryResult
  {
    constructor(data?: IGetBatchFileStatusQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchFileStatusQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileStatusQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchFileStatusQueryResult {}

  export class GetBatchFileStatusQueryResultSuccess
    extends GetBatchFileStatusQueryResult
    implements IGetBatchFileStatusQueryResultSuccess
  {
    result!: BatchFileStatusDto;

    constructor(data?: IGetBatchFileStatusQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new BatchFileStatusDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? BatchFileStatusDto.fromJS(_data['result'])
          : new BatchFileStatusDto();
      }
    }

    static override fromJS(data: any): GetBatchFileStatusQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileStatusQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchFileStatusQueryResultSuccess
    extends IGetBatchFileStatusQueryResult {
    result: BatchFileStatusDto;
  }

  export class BatchFileStatusDto implements IBatchFileStatusDto {
    id!: string;
    status!: BatchStatus;
    errors!: string[];

    constructor(data?: IBatchFileStatusDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.errors = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors']) this.errors!.push(item);
        } else {
          this.errors = <any>null;
        }
      }
    }

    static fromJS(data: any): BatchFileStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new BatchFileStatusDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item);
      }
      return data;
    }
  }

  export interface IBatchFileStatusDto {
    id: string;
    status: BatchStatus;
    errors: string[];
  }

  export class GetBatchFileStatusQueryResultFailure
    extends GetBatchFileStatusQueryResult
    implements IGetBatchFileStatusQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBatchFileStatusQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBatchFileStatusQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileStatusQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchFileStatusQueryResultFailure
    extends IGetBatchFileStatusQueryResult {
    errors: ResultError[];
  }

  export class CreateBatchCommandResult implements ICreateBatchCommandResult {
    constructor(data?: ICreateBatchCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CreateBatchCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new CreateBatchCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICreateBatchCommandResult {}

  export class CreateBatchCommandResultSuccess
    extends CreateBatchCommandResult
    implements ICreateBatchCommandResultSuccess
  {
    result!: BatchFileStatusDto;

    constructor(data?: ICreateBatchCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new BatchFileStatusDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? BatchFileStatusDto.fromJS(_data['result'])
          : new BatchFileStatusDto();
      }
    }

    static override fromJS(data: any): CreateBatchCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CreateBatchCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICreateBatchCommandResultSuccess
    extends ICreateBatchCommandResult {
    result: BatchFileStatusDto;
  }

  export class CreateBatchCommandResultFailure
    extends CreateBatchCommandResult
    implements ICreateBatchCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ICreateBatchCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): CreateBatchCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CreateBatchCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ICreateBatchCommandResultFailure
    extends ICreateBatchCommandResult {
    errors: ResultError[];
  }

  export class CreateBatchCommand implements ICreateBatchCommand {
    clientId!: string;
    calculationType!: BatchCalculationType;

    constructor(data?: ICreateBatchCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationType =
          _data['calculationType'] !== undefined
            ? _data['calculationType']
            : <any>null;
      }
    }

    static fromJS(data: any): CreateBatchCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateBatchCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationType'] =
        this.calculationType !== undefined ? this.calculationType : <any>null;
      return data;
    }
  }

  export interface ICreateBatchCommand {
    clientId: string;
    calculationType: BatchCalculationType;
  }

  export class GetBatchFileUploadUrlCommandResult
    implements IGetBatchFileUploadUrlCommandResult
  {
    constructor(data?: IGetBatchFileUploadUrlCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchFileUploadUrlCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileUploadUrlCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchFileUploadUrlCommandResult {}

  export class GetBatchFileUploadUrlCommandResultSuccess
    extends GetBatchFileUploadUrlCommandResult
    implements IGetBatchFileUploadUrlCommandResultSuccess
  {
    preSignedUrl!: string;
    headers!: { [key: string]: string };

    constructor(data?: IGetBatchFileUploadUrlCommandResultSuccess) {
      super(data);
      if (!data) {
        this.headers = {};
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.preSignedUrl =
          _data['preSignedUrl'] !== undefined
            ? _data['preSignedUrl']
            : <any>null;
        if (_data['headers']) {
          this.headers = {} as any;
          for (let key in _data['headers']) {
            if (_data['headers'].hasOwnProperty(key))
              (<any>this.headers)![key] =
                _data['headers'][key] !== undefined
                  ? _data['headers'][key]
                  : <any>null;
          }
        } else {
          this.headers = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchFileUploadUrlCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileUploadUrlCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['preSignedUrl'] =
        this.preSignedUrl !== undefined ? this.preSignedUrl : <any>null;
      if (this.headers) {
        data['headers'] = {};
        for (let key in this.headers) {
          if (this.headers.hasOwnProperty(key))
            (<any>data['headers'])[key] =
              this.headers[key] !== undefined ? this.headers[key] : <any>null;
        }
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchFileUploadUrlCommandResultSuccess
    extends IGetBatchFileUploadUrlCommandResult {
    preSignedUrl: string;
    headers: { [key: string]: string };
  }

  export class GetBatchFileUploadUrlCommandResultFailure
    extends GetBatchFileUploadUrlCommandResult
    implements IGetBatchFileUploadUrlCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBatchFileUploadUrlCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchFileUploadUrlCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchFileUploadUrlCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchFileUploadUrlCommandResultFailure
    extends IGetBatchFileUploadUrlCommandResult {
    errors: ResultError[];
  }

  export class DownloadBatchFileTemplateCommandResult
    implements IDownloadBatchFileTemplateCommandResult
  {
    constructor(data?: IDownloadBatchFileTemplateCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadBatchFileTemplateCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchFileTemplateCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadBatchFileTemplateCommandResult {}

  export class DownloadBatchFileTemplateCommandResultSuccess
    extends DownloadBatchFileTemplateCommandResult
    implements IDownloadBatchFileTemplateCommandResultSuccess
  {
    result!: string;

    constructor(data?: IDownloadBatchFileTemplateCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result =
          _data['result'] !== undefined ? _data['result'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadBatchFileTemplateCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchFileTemplateCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result !== undefined ? this.result : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadBatchFileTemplateCommandResultSuccess
    extends IDownloadBatchFileTemplateCommandResult {
    result: string;
  }

  export class DownloadBatchFileTemplateCommandResultFailure
    extends DownloadBatchFileTemplateCommandResult
    implements IDownloadBatchFileTemplateCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IDownloadBatchFileTemplateCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DownloadBatchFileTemplateCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchFileTemplateCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadBatchFileTemplateCommandResultFailure
    extends IDownloadBatchFileTemplateCommandResult {
    errors: ResultError[];
  }

  export abstract class HandleBatchFileUploadFailureCommandResult
    implements IHandleBatchFileUploadFailureCommandResult
  {
    constructor(data?: IHandleBatchFileUploadFailureCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): HandleBatchFileUploadFailureCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'HandleBatchFileUploadFailureCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IHandleBatchFileUploadFailureCommandResult {}

  export class HandleBatchFileUploadFailureCommandResultSuccess
    extends HandleBatchFileUploadFailureCommandResult
    implements IHandleBatchFileUploadFailureCommandResultSuccess
  {
    constructor(data?: IHandleBatchFileUploadFailureCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): HandleBatchFileUploadFailureCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new HandleBatchFileUploadFailureCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandleBatchFileUploadFailureCommandResultSuccess
    extends IHandleBatchFileUploadFailureCommandResult {}

  export class HandleBatchFileUploadFailureCommandResultFailure
    extends HandleBatchFileUploadFailureCommandResult
    implements IHandleBatchFileUploadFailureCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IHandleBatchFileUploadFailureCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): HandleBatchFileUploadFailureCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new HandleBatchFileUploadFailureCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandleBatchFileUploadFailureCommandResultFailure
    extends IHandleBatchFileUploadFailureCommandResult {
    errorMessage: string;
  }

  export class HandleBatchFileUploadFailureCommand
    implements IHandleBatchFileUploadFailureCommand
  {
    batchId!: string;
    statusCode!: number;
    error!: string;

    constructor(data?: IHandleBatchFileUploadFailureCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.statusCode =
          _data['statusCode'] !== undefined ? _data['statusCode'] : <any>null;
        this.error = _data['error'] !== undefined ? _data['error'] : <any>null;
      }
    }

    static fromJS(data: any): HandleBatchFileUploadFailureCommand {
      data = typeof data === 'object' ? data : {};
      let result = new HandleBatchFileUploadFailureCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['statusCode'] =
        this.statusCode !== undefined ? this.statusCode : <any>null;
      data['error'] = this.error !== undefined ? this.error : <any>null;
      return data;
    }
  }

  export interface IHandleBatchFileUploadFailureCommand {
    batchId: string;
    statusCode: number;
    error: string;
  }

  export abstract class RunBatchOfOneCommandResult
    implements IRunBatchOfOneCommandResult
  {
    constructor(data?: IRunBatchOfOneCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): RunBatchOfOneCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'RunBatchOfOneCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IRunBatchOfOneCommandResult {}

  export class RunBatchOfOneCommandResultSuccess
    extends RunBatchOfOneCommandResult
    implements IRunBatchOfOneCommandResultSuccess
  {
    clientPortalId!: string;
    batchId!: string;
    calculationId!: string;
    calculationCompletedSuccessfully!: boolean;

    constructor(data?: IRunBatchOfOneCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.calculationCompletedSuccessfully =
          _data['calculationCompletedSuccessfully'] !== undefined
            ? _data['calculationCompletedSuccessfully']
            : <any>null;
      }
    }

    static override fromJS(data: any): RunBatchOfOneCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new RunBatchOfOneCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['calculationCompletedSuccessfully'] =
        this.calculationCompletedSuccessfully !== undefined
          ? this.calculationCompletedSuccessfully
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRunBatchOfOneCommandResultSuccess
    extends IRunBatchOfOneCommandResult {
    clientPortalId: string;
    batchId: string;
    calculationId: string;
    calculationCompletedSuccessfully: boolean;
  }

  export class RunBatchOfOneCommandResultFailure
    extends RunBatchOfOneCommandResult
    implements IRunBatchOfOneCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IRunBatchOfOneCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): RunBatchOfOneCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new RunBatchOfOneCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRunBatchOfOneCommandResultFailure
    extends IRunBatchOfOneCommandResult {
    errorMessage: string;
  }

  export class RunBatchOfOneCommand implements IRunBatchOfOneCommand {
    clientId!: string;
    calculationId!: string;

    constructor(data?: IRunBatchOfOneCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): RunBatchOfOneCommand {
      data = typeof data === 'object' ? data : {};
      let result = new RunBatchOfOneCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface IRunBatchOfOneCommand {
    clientId: string;
    calculationId: string;
  }

  export abstract class GetCalculationStatusByIdQueryResult
    implements IGetCalculationStatusByIdQueryResult
  {
    constructor(data?: IGetCalculationStatusByIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationStatusByIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationStatusByIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationStatusByIdQueryResult {}

  export class GetCalculationStatusByIdQueryResultSuccess
    extends GetCalculationStatusByIdQueryResult
    implements IGetCalculationStatusByIdQueryResultSuccess
  {
    calculationId!: string;
    batchId!: string;
    status!: CalculationStatus;
    shouldRedirect!: boolean;
    isPostProcessing!: boolean;
    isFailed!: boolean;

    constructor(data?: IGetCalculationStatusByIdQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.shouldRedirect =
          _data['shouldRedirect'] !== undefined
            ? _data['shouldRedirect']
            : <any>null;
        this.isPostProcessing =
          _data['isPostProcessing'] !== undefined
            ? _data['isPostProcessing']
            : <any>null;
        this.isFailed =
          _data['isFailed'] !== undefined ? _data['isFailed'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationStatusByIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationStatusByIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['shouldRedirect'] =
        this.shouldRedirect !== undefined ? this.shouldRedirect : <any>null;
      data['isPostProcessing'] =
        this.isPostProcessing !== undefined ? this.isPostProcessing : <any>null;
      data['isFailed'] =
        this.isFailed !== undefined ? this.isFailed : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationStatusByIdQueryResultSuccess
    extends IGetCalculationStatusByIdQueryResult {
    calculationId: string;
    batchId: string;
    status: CalculationStatus;
    shouldRedirect: boolean;
    isPostProcessing: boolean;
    isFailed: boolean;
  }

  export class GetCalculationStatusByIdQueryResultFailure
    extends GetCalculationStatusByIdQueryResult
    implements IGetCalculationStatusByIdQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationStatusByIdQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationStatusByIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationStatusByIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationStatusByIdQueryResultFailure
    extends IGetCalculationStatusByIdQueryResult {
    errorMessage: string;
  }

  export abstract class EnqueueRunBatchOfOneCommandResult
    implements IEnqueueRunBatchOfOneCommandResult
  {
    constructor(data?: IEnqueueRunBatchOfOneCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): EnqueueRunBatchOfOneCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'EnqueueRunBatchOfOneCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IEnqueueRunBatchOfOneCommandResult {}

  export class EnqueueRunBatchOfOneCommandResultSuccess
    extends EnqueueRunBatchOfOneCommandResult
    implements IEnqueueRunBatchOfOneCommandResultSuccess
  {
    constructor(data?: IEnqueueRunBatchOfOneCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): EnqueueRunBatchOfOneCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new EnqueueRunBatchOfOneCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IEnqueueRunBatchOfOneCommandResultSuccess
    extends IEnqueueRunBatchOfOneCommandResult {}

  export class EnqueueRunBatchOfOneCommandResultFailure
    extends EnqueueRunBatchOfOneCommandResult
    implements IEnqueueRunBatchOfOneCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IEnqueueRunBatchOfOneCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): EnqueueRunBatchOfOneCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new EnqueueRunBatchOfOneCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IEnqueueRunBatchOfOneCommandResultFailure
    extends IEnqueueRunBatchOfOneCommandResult {
    errorMessage: string;
  }

  export class EnqueueRunBatchOfOneCommand
    implements IEnqueueRunBatchOfOneCommand
  {
    clientId!: string;
    calculationId!: string;

    constructor(data?: IEnqueueRunBatchOfOneCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): EnqueueRunBatchOfOneCommand {
      data = typeof data === 'object' ? data : {};
      let result = new EnqueueRunBatchOfOneCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface IEnqueueRunBatchOfOneCommand {
    clientId: string;
    calculationId: string;
  }

  export abstract class ValidateCalculationCommandResult
    implements IValidateCalculationCommandResult
  {
    constructor(data?: IValidateCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ValidateCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ValidateCalculationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IValidateCalculationCommandResult {}

  export class ValidateCalculationCommandResultSuccess
    extends ValidateCalculationCommandResult
    implements IValidateCalculationCommandResultSuccess
  {
    validationLog!: ReadOnlyLog;
    validationResult!: ValidationSummaryResult;

    constructor(data?: IValidateCalculationCommandResultSuccess) {
      super(data);
      if (!data) {
        this.validationLog = new ReadOnlyLog();
        this.validationResult = new ValidationSummaryResult();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.validationLog = _data['validationLog']
          ? ReadOnlyLog.fromJS(_data['validationLog'])
          : new ReadOnlyLog();
        this.validationResult = _data['validationResult']
          ? ValidationSummaryResult.fromJS(_data['validationResult'])
          : new ValidationSummaryResult();
      }
    }

    static override fromJS(data: any): ValidateCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ValidateCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['validationLog'] = this.validationLog
        ? this.validationLog.toJSON()
        : <any>null;
      data['validationResult'] = this.validationResult
        ? this.validationResult.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IValidateCalculationCommandResultSuccess
    extends IValidateCalculationCommandResult {
    validationLog: ReadOnlyLog;
    validationResult: ValidationSummaryResult;
  }

  export abstract class ReadOnlyLogEntryCollection
    implements IReadOnlyLogEntryCollection
  {
    stats!: LogEntryCollectionStats;
    entries!: LogEntry[];
    spans!: ReadOnlyLogSpan[];
    metadata!: { [key: string]: MetadataValue };

    constructor(data?: IReadOnlyLogEntryCollection) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.stats = new LogEntryCollectionStats();
        this.entries = [];
        this.spans = [];
        this.metadata = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.stats = _data['stats']
          ? LogEntryCollectionStats.fromJS(_data['stats'])
          : new LogEntryCollectionStats();
        if (Array.isArray(_data['entries'])) {
          this.entries = [] as any;
          for (let item of _data['entries'])
            this.entries!.push(LogEntry.fromJS(item));
        } else {
          this.entries = <any>null;
        }
        if (Array.isArray(_data['spans'])) {
          this.spans = [] as any;
          for (let item of _data['spans'])
            this.spans!.push(ReadOnlyLogSpan.fromJS(item));
        } else {
          this.spans = <any>null;
        }
        if (_data['metadata']) {
          this.metadata = {} as any;
          for (let key in _data['metadata']) {
            if (_data['metadata'].hasOwnProperty(key))
              (<any>this.metadata)![key] = _data['metadata'][key]
                ? MetadataValue.fromJS(_data['metadata'][key])
                : new MetadataValue();
          }
        } else {
          this.metadata = <any>null;
        }
      }
    }

    static fromJS(data: any): ReadOnlyLogEntryCollection {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReadOnlyLogEntryCollection' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['stats'] = this.stats ? this.stats.toJSON() : <any>null;
      if (Array.isArray(this.entries)) {
        data['entries'] = [];
        for (let item of this.entries) data['entries'].push(item.toJSON());
      }
      if (Array.isArray(this.spans)) {
        data['spans'] = [];
        for (let item of this.spans) data['spans'].push(item.toJSON());
      }
      if (this.metadata) {
        data['metadata'] = {};
        for (let key in this.metadata) {
          if (this.metadata.hasOwnProperty(key))
            (<any>data['metadata'])[key] = this.metadata[key]
              ? this.metadata[key].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface IReadOnlyLogEntryCollection {
    stats: LogEntryCollectionStats;
    entries: LogEntry[];
    spans: ReadOnlyLogSpan[];
    metadata: { [key: string]: MetadataValue };
  }

  export class ReadOnlyLog
    extends ReadOnlyLogEntryCollection
    implements IReadOnlyLog
  {
    constructor(data?: IReadOnlyLog) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): ReadOnlyLog {
      data = typeof data === 'object' ? data : {};
      let result = new ReadOnlyLog();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IReadOnlyLog extends IReadOnlyLogEntryCollection {}

  export class LogEntryCollectionStats implements ILogEntryCollectionStats {
    errors!: number;
    warnings!: number;
    infos!: number;
    entries!: number;
    totalErrors!: number;
    totalWarnings!: number;
    totalInfos!: number;
    totalEntries!: number;

    constructor(data?: ILogEntryCollectionStats) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.errors =
          _data['errors'] !== undefined ? _data['errors'] : <any>null;
        this.warnings =
          _data['warnings'] !== undefined ? _data['warnings'] : <any>null;
        this.infos = _data['infos'] !== undefined ? _data['infos'] : <any>null;
        this.entries =
          _data['entries'] !== undefined ? _data['entries'] : <any>null;
        this.totalErrors =
          _data['totalErrors'] !== undefined ? _data['totalErrors'] : <any>null;
        this.totalWarnings =
          _data['totalWarnings'] !== undefined
            ? _data['totalWarnings']
            : <any>null;
        this.totalInfos =
          _data['totalInfos'] !== undefined ? _data['totalInfos'] : <any>null;
        this.totalEntries =
          _data['totalEntries'] !== undefined
            ? _data['totalEntries']
            : <any>null;
      }
    }

    static fromJS(data: any): LogEntryCollectionStats {
      data = typeof data === 'object' ? data : {};
      let result = new LogEntryCollectionStats();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errors'] = this.errors !== undefined ? this.errors : <any>null;
      data['warnings'] =
        this.warnings !== undefined ? this.warnings : <any>null;
      data['infos'] = this.infos !== undefined ? this.infos : <any>null;
      data['entries'] = this.entries !== undefined ? this.entries : <any>null;
      data['totalErrors'] =
        this.totalErrors !== undefined ? this.totalErrors : <any>null;
      data['totalWarnings'] =
        this.totalWarnings !== undefined ? this.totalWarnings : <any>null;
      data['totalInfos'] =
        this.totalInfos !== undefined ? this.totalInfos : <any>null;
      data['totalEntries'] =
        this.totalEntries !== undefined ? this.totalEntries : <any>null;
      return data;
    }
  }

  export interface ILogEntryCollectionStats {
    errors: number;
    warnings: number;
    infos: number;
    entries: number;
    totalErrors: number;
    totalWarnings: number;
    totalInfos: number;
    totalEntries: number;
  }

  export class LogEntry implements ILogEntry {
    message!: string;
    detail!: string | null;
    code!: string | null;
    level!: LogLevel;
    timestamp!: Date;
    metadata!: { [key: string]: MetadataValue } | null;

    constructor(data?: ILogEntry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.message =
          _data['message'] !== undefined ? _data['message'] : <any>null;
        this.detail =
          _data['detail'] !== undefined ? _data['detail'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.level = _data['level'] !== undefined ? _data['level'] : <any>null;
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
        if (_data['metadata']) {
          this.metadata = {} as any;
          for (let key in _data['metadata']) {
            if (_data['metadata'].hasOwnProperty(key))
              (<any>this.metadata)![key] = _data['metadata'][key]
                ? MetadataValue.fromJS(_data['metadata'][key])
                : new MetadataValue();
          }
        } else {
          this.metadata = <any>null;
        }
      }
    }

    static fromJS(data: any): LogEntry {
      data = typeof data === 'object' ? data : {};
      let result = new LogEntry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['message'] = this.message !== undefined ? this.message : <any>null;
      data['detail'] = this.detail !== undefined ? this.detail : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['level'] = this.level !== undefined ? this.level : <any>null;
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      if (this.metadata) {
        data['metadata'] = {};
        for (let key in this.metadata) {
          if (this.metadata.hasOwnProperty(key))
            (<any>data['metadata'])[key] = this.metadata[key]
              ? this.metadata[key].toJSON()
              : <any>null;
        }
      }
      return data;
    }
  }

  export interface ILogEntry {
    message: string;
    detail: string | null;
    code: string | null;
    level: LogLevel;
    timestamp: Date;
    metadata: { [key: string]: MetadataValue } | null;
  }

  export enum LogLevel {
    Information = 'Information',
    Warning = 'Warning',
    Error = 'Error',
  }

  export class MetadataValue implements IMetadataValue {
    displayName!: string | null;
    value!: Scalar;

    constructor(data?: IMetadataValue) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.value = new Scalar();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.displayName =
          _data['displayName'] !== undefined ? _data['displayName'] : <any>null;
        this.value = _data['value']
          ? Scalar.fromJS(_data['value'])
          : new Scalar();
      }
    }

    static fromJS(data: any): MetadataValue {
      data = typeof data === 'object' ? data : {};
      let result = new MetadataValue();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['displayName'] =
        this.displayName !== undefined ? this.displayName : <any>null;
      data['value'] = this.value ? this.value.toJSON() : <any>null;
      return data;
    }
  }

  export interface IMetadataValue {
    displayName: string | null;
    value: Scalar;
  }

  export class Scalar implements IScalar {
    type!: string;
    value!: string;

    constructor(data?: IScalar) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
      }
    }

    static fromJS(data: any): Scalar {
      data = typeof data === 'object' ? data : {};
      let result = new Scalar();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      return data;
    }
  }

  export interface IScalar {
    type: string;
    value: string;
  }

  export class ReadOnlyLogSpan
    extends ReadOnlyLogEntryCollection
    implements IReadOnlyLogSpan
  {
    name!: string;
    startTime!: Date;
    endTime!: Date | null;
    durationInMs!: number | null;

    constructor(data?: IReadOnlyLogSpan) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.startTime = _data['startTime']
          ? new Date(_data['startTime'].toString())
          : <any>null;
        this.endTime = _data['endTime']
          ? new Date(_data['endTime'].toString())
          : <any>null;
        this.durationInMs =
          _data['durationInMs'] !== undefined
            ? _data['durationInMs']
            : <any>null;
      }
    }

    static override fromJS(data: any): ReadOnlyLogSpan {
      data = typeof data === 'object' ? data : {};
      let result = new ReadOnlyLogSpan();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['startTime'] = this.startTime
        ? this.startTime.toISOString()
        : <any>null;
      data['endTime'] = this.endTime ? this.endTime.toISOString() : <any>null;
      data['durationInMs'] =
        this.durationInMs !== undefined ? this.durationInMs : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReadOnlyLogSpan extends IReadOnlyLogEntryCollection {
    name: string;
    startTime: Date;
    endTime: Date | null;
    durationInMs: number | null;
  }

  export abstract class ValidationRuleResult implements IValidationRuleResult {
    constructor(data?: IValidationRuleResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ValidationRuleResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ValidationRuleResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IValidationRuleResult {}

  export class ValidationSummaryResult
    extends ValidationRuleResult
    implements IValidationSummaryResult
  {
    isSuccess!: boolean;
    errors!: ValidationRuleFailure[];

    constructor(data?: IValidationSummaryResult) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.isSuccess =
          _data['isSuccess'] !== undefined ? _data['isSuccess'] : <any>null;
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ValidationRuleFailure.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): ValidationSummaryResult {
      data = typeof data === 'object' ? data : {};
      let result = new ValidationSummaryResult();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isSuccess'] =
        this.isSuccess !== undefined ? this.isSuccess : <any>null;
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IValidationSummaryResult extends IValidationRuleResult {
    isSuccess: boolean;
    errors: ValidationRuleFailure[];
  }

  export class ValidationRuleFailure
    extends ValidationRuleResult
    implements IValidationRuleFailure
  {
    code!: string;
    errorMessage!: string;

    constructor(data?: IValidationRuleFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): ValidationRuleFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ValidationRuleFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IValidationRuleFailure extends IValidationRuleResult {
    code: string;
    errorMessage: string;
  }

  export class ValidateCalculationCommandResultFailure
    extends ValidateCalculationCommandResult
    implements IValidateCalculationCommandResultFailure
  {
    error!: string;

    constructor(data?: IValidateCalculationCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.error = _data['error'] !== undefined ? _data['error'] : <any>null;
      }
    }

    static override fromJS(data: any): ValidateCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ValidateCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['error'] = this.error !== undefined ? this.error : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IValidateCalculationCommandResultFailure
    extends IValidateCalculationCommandResult {
    error: string;
  }

  export class ValidateCalculationCommand
    implements IValidateCalculationCommand
  {
    clientId!: string;
    calculationId!: string;

    constructor(data?: IValidateCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): ValidateCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ValidateCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface IValidateCalculationCommand {
    clientId: string;
    calculationId: string;
  }

  export class UpdateCalculationCommandResult
    implements IUpdateCalculationCommandResult
  {
    constructor(data?: IUpdateCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpdateCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCalculationCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateCalculationCommandResult {}

  export class UpdateCalculationCommandResultSuccess
    extends UpdateCalculationCommandResult
    implements IUpdateCalculationCommandResultSuccess
  {
    constructor(data?: IUpdateCalculationCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpdateCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateCalculationCommandResultSuccess
    extends IUpdateCalculationCommandResult {}

  export class UpdateCalculationCommandResultFailure
    extends UpdateCalculationCommandResult
    implements IUpdateCalculationCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpdateCalculationCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpdateCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateCalculationCommandResultFailure
    extends IUpdateCalculationCommandResult {
    errors: ResultError[];
  }

  export class UpdateCalculationCommand implements IUpdateCalculationCommand {
    clientId!: string;
    calculationId!: string;
    employee!: PreProcessorInputsEmployee;
    employer!: PreProcessorInputsEmployer;
    batchCalcType!: BatchCalculationType;

    constructor(data?: IUpdateCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employee = new PreProcessorInputsEmployee();
        this.employer = new PreProcessorInputsEmployer();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.employee = _data['employee']
          ? PreProcessorInputsEmployee.fromJS(_data['employee'])
          : new PreProcessorInputsEmployee();
        this.employer = _data['employer']
          ? PreProcessorInputsEmployer.fromJS(_data['employer'])
          : new PreProcessorInputsEmployer();
        this.batchCalcType =
          _data['batchCalcType'] !== undefined
            ? _data['batchCalcType']
            : <any>null;
      }
    }

    static fromJS(data: any): UpdateCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['employee'] = this.employee ? this.employee.toJSON() : <any>null;
      data['employer'] = this.employer ? this.employer.toJSON() : <any>null;
      data['batchCalcType'] =
        this.batchCalcType !== undefined ? this.batchCalcType : <any>null;
      return data;
    }
  }

  export interface IUpdateCalculationCommand {
    clientId: string;
    calculationId: string;
    employee: PreProcessorInputsEmployee;
    employer: PreProcessorInputsEmployer;
    batchCalcType: BatchCalculationType;
  }

  export class PreProcessorInputsEmployee
    implements IPreProcessorInputsEmployee
  {
    firstName!: string | null;
    lastName!: string | null;
    emailAddress!: string | null;
    clientEmployeeType!: string | null;
    clientSocialTaxCountryCode!: string | null;
    employeeId!: string;
    nationalityCountryCode!: string;
    secondNationalityCountryCode!: string | null;
    residentCountry!: PreProcessorInputsResidentCountry | null;
    terminationDate!: Date | null;
    terminationReason!: TerminationReason | null;
    userDefinedFields!: UserDefinedField[];
    restrictedStockUnitTransactions!: PreProcessorInputsRestrictedStockUnitTransaction[];
    cashBonusTransactions!: PreProcessorInputsCashBonusTransaction[];
    stockOptionTransactions!: PreProcessorInputsStockOptionTransaction[];
    locationPeriods!: PreProcessorInputsLocationPeriod[];
    taxRates!: TaxRate[];
    taxPositions!: TaxPosition[];
    manualCalculationRequired!: boolean;
    manualCalculationSendToWorkflow!: boolean | null;
    incomeForBanding!: PreProcessorInputsIncomeForBanding[];
    transactionOrdering!: TransactionOrdering;
    hypotheticalProfiles!: PreProcessorInputsHypotheticalProfile[];
    taxFundingAndGrossups!: PreProcessorInputsTaxFundingAndGrossup[];

    constructor(data?: IPreProcessorInputsEmployee) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.userDefinedFields = [];
        this.restrictedStockUnitTransactions = [];
        this.cashBonusTransactions = [];
        this.stockOptionTransactions = [];
        this.locationPeriods = [];
        this.taxRates = [];
        this.taxPositions = [];
        this.incomeForBanding = [];
        this.transactionOrdering = new TransactionOrdering();
        this.hypotheticalProfiles = [];
        this.taxFundingAndGrossups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.emailAddress =
          _data['emailAddress'] !== undefined
            ? _data['emailAddress']
            : <any>null;
        this.clientEmployeeType =
          _data['clientEmployeeType'] !== undefined
            ? _data['clientEmployeeType']
            : <any>null;
        this.clientSocialTaxCountryCode =
          _data['clientSocialTaxCountryCode'] !== undefined
            ? _data['clientSocialTaxCountryCode']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.nationalityCountryCode =
          _data['nationalityCountryCode'] !== undefined
            ? _data['nationalityCountryCode']
            : <any>null;
        this.secondNationalityCountryCode =
          _data['secondNationalityCountryCode'] !== undefined
            ? _data['secondNationalityCountryCode']
            : <any>null;
        this.residentCountry = _data['residentCountry']
          ? PreProcessorInputsResidentCountry.fromJS(_data['residentCountry'])
          : <any>null;
        this.terminationDate = _data['terminationDate']
          ? new Date(_data['terminationDate'].toString())
          : <any>null;
        this.terminationReason =
          _data['terminationReason'] !== undefined
            ? _data['terminationReason']
            : <any>null;
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitTransactions'])) {
          this.restrictedStockUnitTransactions = [] as any;
          for (let item of _data['restrictedStockUnitTransactions'])
            this.restrictedStockUnitTransactions!.push(
              PreProcessorInputsRestrictedStockUnitTransaction.fromJS(item),
            );
        } else {
          this.restrictedStockUnitTransactions = <any>null;
        }
        if (Array.isArray(_data['cashBonusTransactions'])) {
          this.cashBonusTransactions = [] as any;
          for (let item of _data['cashBonusTransactions'])
            this.cashBonusTransactions!.push(
              PreProcessorInputsCashBonusTransaction.fromJS(item),
            );
        } else {
          this.cashBonusTransactions = <any>null;
        }
        if (Array.isArray(_data['stockOptionTransactions'])) {
          this.stockOptionTransactions = [] as any;
          for (let item of _data['stockOptionTransactions'])
            this.stockOptionTransactions!.push(
              PreProcessorInputsStockOptionTransaction.fromJS(item),
            );
        } else {
          this.stockOptionTransactions = <any>null;
        }
        if (Array.isArray(_data['locationPeriods'])) {
          this.locationPeriods = [] as any;
          for (let item of _data['locationPeriods'])
            this.locationPeriods!.push(
              PreProcessorInputsLocationPeriod.fromJS(item),
            );
        } else {
          this.locationPeriods = <any>null;
        }
        if (Array.isArray(_data['taxRates'])) {
          this.taxRates = [] as any;
          for (let item of _data['taxRates'])
            this.taxRates!.push(TaxRate.fromJS(item));
        } else {
          this.taxRates = <any>null;
        }
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(TaxPosition.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
        if (Array.isArray(_data['incomeForBanding'])) {
          this.incomeForBanding = [] as any;
          for (let item of _data['incomeForBanding'])
            this.incomeForBanding!.push(
              PreProcessorInputsIncomeForBanding.fromJS(item),
            );
        } else {
          this.incomeForBanding = <any>null;
        }
        this.transactionOrdering = _data['transactionOrdering']
          ? TransactionOrdering.fromJS(_data['transactionOrdering'])
          : new TransactionOrdering();
        if (Array.isArray(_data['hypotheticalProfiles'])) {
          this.hypotheticalProfiles = [] as any;
          for (let item of _data['hypotheticalProfiles'])
            this.hypotheticalProfiles!.push(
              PreProcessorInputsHypotheticalProfile.fromJS(item),
            );
        } else {
          this.hypotheticalProfiles = <any>null;
        }
        if (Array.isArray(_data['taxFundingAndGrossups'])) {
          this.taxFundingAndGrossups = [] as any;
          for (let item of _data['taxFundingAndGrossups'])
            this.taxFundingAndGrossups!.push(
              PreProcessorInputsTaxFundingAndGrossup.fromJS(item),
            );
        } else {
          this.taxFundingAndGrossups = <any>null;
        }
      }
    }

    static fromJS(data: any): PreProcessorInputsEmployee {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsEmployee();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['emailAddress'] =
        this.emailAddress !== undefined ? this.emailAddress : <any>null;
      data['clientEmployeeType'] =
        this.clientEmployeeType !== undefined
          ? this.clientEmployeeType
          : <any>null;
      data['clientSocialTaxCountryCode'] =
        this.clientSocialTaxCountryCode !== undefined
          ? this.clientSocialTaxCountryCode
          : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['nationalityCountryCode'] =
        this.nationalityCountryCode !== undefined
          ? this.nationalityCountryCode
          : <any>null;
      data['secondNationalityCountryCode'] =
        this.secondNationalityCountryCode !== undefined
          ? this.secondNationalityCountryCode
          : <any>null;
      data['residentCountry'] = this.residentCountry
        ? this.residentCountry.toJSON()
        : <any>null;
      data['terminationDate'] = this.terminationDate
        ? this.terminationDate.toISOString()
        : <any>null;
      data['terminationReason'] =
        this.terminationReason !== undefined
          ? this.terminationReason
          : <any>null;
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitTransactions)) {
        data['restrictedStockUnitTransactions'] = [];
        for (let item of this.restrictedStockUnitTransactions)
          data['restrictedStockUnitTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusTransactions)) {
        data['cashBonusTransactions'] = [];
        for (let item of this.cashBonusTransactions)
          data['cashBonusTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionTransactions)) {
        data['stockOptionTransactions'] = [];
        for (let item of this.stockOptionTransactions)
          data['stockOptionTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.locationPeriods)) {
        data['locationPeriods'] = [];
        for (let item of this.locationPeriods)
          data['locationPeriods'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRates)) {
        data['taxRates'] = [];
        for (let item of this.taxRates) data['taxRates'].push(item.toJSON());
      }
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      if (Array.isArray(this.incomeForBanding)) {
        data['incomeForBanding'] = [];
        for (let item of this.incomeForBanding)
          data['incomeForBanding'].push(item.toJSON());
      }
      data['transactionOrdering'] = this.transactionOrdering
        ? this.transactionOrdering.toJSON()
        : <any>null;
      if (Array.isArray(this.hypotheticalProfiles)) {
        data['hypotheticalProfiles'] = [];
        for (let item of this.hypotheticalProfiles)
          data['hypotheticalProfiles'].push(item.toJSON());
      }
      if (Array.isArray(this.taxFundingAndGrossups)) {
        data['taxFundingAndGrossups'] = [];
        for (let item of this.taxFundingAndGrossups)
          data['taxFundingAndGrossups'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPreProcessorInputsEmployee {
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    clientEmployeeType: string | null;
    clientSocialTaxCountryCode: string | null;
    employeeId: string;
    nationalityCountryCode: string;
    secondNationalityCountryCode: string | null;
    residentCountry: PreProcessorInputsResidentCountry | null;
    terminationDate: Date | null;
    terminationReason: TerminationReason | null;
    userDefinedFields: UserDefinedField[];
    restrictedStockUnitTransactions: PreProcessorInputsRestrictedStockUnitTransaction[];
    cashBonusTransactions: PreProcessorInputsCashBonusTransaction[];
    stockOptionTransactions: PreProcessorInputsStockOptionTransaction[];
    locationPeriods: PreProcessorInputsLocationPeriod[];
    taxRates: TaxRate[];
    taxPositions: TaxPosition[];
    manualCalculationRequired: boolean;
    manualCalculationSendToWorkflow: boolean | null;
    incomeForBanding: PreProcessorInputsIncomeForBanding[];
    transactionOrdering: TransactionOrdering;
    hypotheticalProfiles: PreProcessorInputsHypotheticalProfile[];
    taxFundingAndGrossups: PreProcessorInputsTaxFundingAndGrossup[];
  }

  export class PreProcessorInputsResidentCountry
    implements IPreProcessorInputsResidentCountry
  {
    code!: string;
    region!: PreProcessorInputsResidentRegion | null;

    constructor(data?: IPreProcessorInputsResidentCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsResidentRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsResidentCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsResidentCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsResidentCountry {
    code: string;
    region: PreProcessorInputsResidentRegion | null;
  }

  export class PreProcessorInputsResidentRegion
    implements IPreProcessorInputsResidentRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsResidentRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsResidentRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsResidentRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsResidentRegion {
    code: string;
  }

  export enum TerminationReason {
    Death = 'Death',
    Other = 'Other',
    Retirement = 'Retirement',
    Disability = 'Disability',
  }

  export class UserDefinedField implements IUserDefinedField {
    key!: string;
    value!: Scalar | null;

    constructor(data?: IUserDefinedField) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.key = _data['key'] !== undefined ? _data['key'] : <any>null;
        this.value = _data['value'] ? Scalar.fromJS(_data['value']) : <any>null;
      }
    }

    static fromJS(data: any): UserDefinedField {
      data = typeof data === 'object' ? data : {};
      let result = new UserDefinedField();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['key'] = this.key !== undefined ? this.key : <any>null;
      data['value'] = this.value ? this.value.toJSON() : <any>null;
      return data;
    }
  }

  export interface IUserDefinedField {
    key: string;
    value: Scalar | null;
  }

  export abstract class PreProcessorInputsTransaction
    implements IPreProcessorInputsTransaction
  {
    customTaxes!: PreProcessorInputsCustomTax[];
    transactionGuid!: string;
    transactionId!: string;
    planCode!: string;
    awardName!: string | null;
    currencyCode!: string;
    userDefinedFields!: UserDefinedField[];
    manualCalculationRequired!: boolean;
    manualCalculationReason!: string | null;

    constructor(data?: IPreProcessorInputsTransaction) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.customTaxes = [];
        this.userDefinedFields = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['customTaxes'])) {
          this.customTaxes = [] as any;
          for (let item of _data['customTaxes'])
            this.customTaxes!.push(PreProcessorInputsCustomTax.fromJS(item));
        } else {
          this.customTaxes = <any>null;
        }
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.awardName =
          _data['awardName'] !== undefined ? _data['awardName'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationReason =
          _data['manualCalculationReason'] !== undefined
            ? _data['manualCalculationReason']
            : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsTransaction {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'PreProcessorInputsTransaction' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.customTaxes)) {
        data['customTaxes'] = [];
        for (let item of this.customTaxes)
          data['customTaxes'].push(item.toJSON());
      }
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['awardName'] =
        this.awardName !== undefined ? this.awardName : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationReason'] =
        this.manualCalculationReason !== undefined
          ? this.manualCalculationReason
          : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsTransaction {
    customTaxes: PreProcessorInputsCustomTax[];
    transactionGuid: string;
    transactionId: string;
    planCode: string;
    awardName: string | null;
    currencyCode: string;
    userDefinedFields: UserDefinedField[];
    manualCalculationRequired: boolean;
    manualCalculationReason: string | null;
  }

  export class PreProcessorInputsRestrictedStockUnitTransaction
    extends PreProcessorInputsTransaction
    implements IPreProcessorInputsRestrictedStockUnitTransaction
  {
    unitsGranted!: number;
    numberOfUnitsDistributed!: number;
    fairMarketValues!: RestrictedStockUnitFairMarketValue[];
    vests!: PreProcessorInputsRestrictedStockUnitVest[];
    planType!: PlanType;
    grantDate!: Date;
    distributionDate!: Date;
    deliveryType!: DeliveryType;
    taxWithholdingMethod!: TaxWithholdingMethod | null;

    constructor(data?: IPreProcessorInputsRestrictedStockUnitTransaction) {
      super(data);
      if (!data) {
        this.fairMarketValues = [];
        this.vests = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.unitsGranted =
          _data['unitsGranted'] !== undefined
            ? _data['unitsGranted']
            : <any>null;
        this.numberOfUnitsDistributed =
          _data['numberOfUnitsDistributed'] !== undefined
            ? _data['numberOfUnitsDistributed']
            : <any>null;
        if (Array.isArray(_data['fairMarketValues'])) {
          this.fairMarketValues = [] as any;
          for (let item of _data['fairMarketValues'])
            this.fairMarketValues!.push(
              RestrictedStockUnitFairMarketValue.fromJS(item),
            );
        } else {
          this.fairMarketValues = <any>null;
        }
        if (Array.isArray(_data['vests'])) {
          this.vests = [] as any;
          for (let item of _data['vests'])
            this.vests!.push(
              PreProcessorInputsRestrictedStockUnitVest.fromJS(item),
            );
        } else {
          this.vests = <any>null;
        }
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.grantDate = _data['grantDate']
          ? new Date(_data['grantDate'].toString())
          : <any>null;
        this.distributionDate = _data['distributionDate']
          ? new Date(_data['distributionDate'].toString())
          : <any>null;
        this.deliveryType =
          _data['deliveryType'] !== undefined
            ? _data['deliveryType']
            : <any>null;
        this.taxWithholdingMethod =
          _data['taxWithholdingMethod'] !== undefined
            ? _data['taxWithholdingMethod']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): PreProcessorInputsRestrictedStockUnitTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsRestrictedStockUnitTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['unitsGranted'] =
        this.unitsGranted !== undefined ? this.unitsGranted : <any>null;
      data['numberOfUnitsDistributed'] =
        this.numberOfUnitsDistributed !== undefined
          ? this.numberOfUnitsDistributed
          : <any>null;
      if (Array.isArray(this.fairMarketValues)) {
        data['fairMarketValues'] = [];
        for (let item of this.fairMarketValues)
          data['fairMarketValues'].push(item.toJSON());
      }
      if (Array.isArray(this.vests)) {
        data['vests'] = [];
        for (let item of this.vests) data['vests'].push(item.toJSON());
      }
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['grantDate'] = this.grantDate
        ? this.grantDate.toISOString()
        : <any>null;
      data['distributionDate'] = this.distributionDate
        ? this.distributionDate.toISOString()
        : <any>null;
      data['deliveryType'] =
        this.deliveryType !== undefined ? this.deliveryType : <any>null;
      data['taxWithholdingMethod'] =
        this.taxWithholdingMethod !== undefined
          ? this.taxWithholdingMethod
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPreProcessorInputsRestrictedStockUnitTransaction
    extends IPreProcessorInputsTransaction {
    unitsGranted: number;
    numberOfUnitsDistributed: number;
    fairMarketValues: RestrictedStockUnitFairMarketValue[];
    vests: PreProcessorInputsRestrictedStockUnitVest[];
    planType: PlanType;
    grantDate: Date;
    distributionDate: Date;
    deliveryType: DeliveryType;
    taxWithholdingMethod: TaxWithholdingMethod | null;
  }

  export abstract class FairMarketValue implements IFairMarketValue {
    value!: number;
    date!: Date;
    countryCode!: string | null;
    description!: string | null;

    constructor(data?: IFairMarketValue) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.date = _data['date']
          ? new Date(_data['date'].toString())
          : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
      }
    }

    static fromJS(data: any): FairMarketValue {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'FairMarketValue' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['date'] = this.date ? this.date.toISOString() : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      return data;
    }
  }

  export interface IFairMarketValue {
    value: number;
    date: Date;
    countryCode: string | null;
    description: string | null;
  }

  export class RestrictedStockUnitFairMarketValue
    extends FairMarketValue
    implements IRestrictedStockUnitFairMarketValue
  {
    type!: RestrictedStockUnitFairMarketValueType;

    constructor(data?: IRestrictedStockUnitFairMarketValue) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
      }
    }

    static override fromJS(data: any): RestrictedStockUnitFairMarketValue {
      data = typeof data === 'object' ? data : {};
      let result = new RestrictedStockUnitFairMarketValue();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRestrictedStockUnitFairMarketValue
    extends IFairMarketValue {
    type: RestrictedStockUnitFairMarketValueType;
  }

  export enum RestrictedStockUnitFairMarketValueType {
    Vest = 'Vest',
    Distribution = 'Distribution',
  }

  export class PreProcessorInputsRestrictedStockUnitVest
    implements IPreProcessorInputsRestrictedStockUnitVest
  {
    date!: Date;
    unitsVested!: number;

    constructor(data?: IPreProcessorInputsRestrictedStockUnitVest) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.date = _data['date']
          ? new Date(_data['date'].toString())
          : <any>null;
        this.unitsVested =
          _data['unitsVested'] !== undefined ? _data['unitsVested'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsRestrictedStockUnitVest {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsRestrictedStockUnitVest();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['date'] = this.date ? this.date.toISOString() : <any>null;
      data['unitsVested'] =
        this.unitsVested !== undefined ? this.unitsVested : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsRestrictedStockUnitVest {
    date: Date;
    unitsVested: number;
  }

  export enum DeliveryType {
    Cash = 'Cash',
    Shares = 'Shares',
  }

  export enum TaxWithholdingMethod {
    HoldAll = 'HoldAll',
    SellAll = 'SellAll',
    SellToCover = 'SellToCover',
    NetSettlement = 'NetSettlement',
  }

  export class PreProcessorInputsCustomTax
    implements IPreProcessorInputsCustomTax
  {
    code!: string;

    constructor(data?: IPreProcessorInputsCustomTax) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsCustomTax {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsCustomTax();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsCustomTax {
    code: string;
  }

  export class PreProcessorInputsCashBonusTransaction
    extends PreProcessorInputsTransaction
    implements IPreProcessorInputsCashBonusTransaction
  {
    paymentAmount!: number;
    planType!: PlanType;
    performancePeriodStart!: Date;
    performancePeriodEnd!: Date;
    paymentDate!: Date;

    constructor(data?: IPreProcessorInputsCashBonusTransaction) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.paymentAmount =
          _data['paymentAmount'] !== undefined
            ? _data['paymentAmount']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.performancePeriodStart = _data['performancePeriodStart']
          ? new Date(_data['performancePeriodStart'].toString())
          : <any>null;
        this.performancePeriodEnd = _data['performancePeriodEnd']
          ? new Date(_data['performancePeriodEnd'].toString())
          : <any>null;
        this.paymentDate = _data['paymentDate']
          ? new Date(_data['paymentDate'].toString())
          : <any>null;
      }
    }

    static override fromJS(data: any): PreProcessorInputsCashBonusTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsCashBonusTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['paymentAmount'] =
        this.paymentAmount !== undefined ? this.paymentAmount : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['performancePeriodStart'] = this.performancePeriodStart
        ? this.performancePeriodStart.toISOString()
        : <any>null;
      data['performancePeriodEnd'] = this.performancePeriodEnd
        ? this.performancePeriodEnd.toISOString()
        : <any>null;
      data['paymentDate'] = this.paymentDate
        ? this.paymentDate.toISOString()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPreProcessorInputsCashBonusTransaction
    extends IPreProcessorInputsTransaction {
    paymentAmount: number;
    planType: PlanType;
    performancePeriodStart: Date;
    performancePeriodEnd: Date;
    paymentDate: Date;
  }

  export class PreProcessorInputsStockOptionTransaction
    extends PreProcessorInputsTransaction
    implements IPreProcessorInputsStockOptionTransaction
  {
    unitsGranted!: number;
    exercisePrice!: number;
    fairMarketValues!: StockOptionFairMarketValue[];
    numberOfOptionsExercised!: number;
    numberOfOptionsPreviouslyExercised!: number | null;
    vests!: PreProcessorInputsStockOptionVest[];
    planType!: PlanType;
    grantDate!: Date;
    deliveryType!: DeliveryType;
    taxWithholdingMethod!: TaxWithholdingMethod | null;
    exerciseDate!: Date;

    constructor(data?: IPreProcessorInputsStockOptionTransaction) {
      super(data);
      if (!data) {
        this.fairMarketValues = [];
        this.vests = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.unitsGranted =
          _data['unitsGranted'] !== undefined
            ? _data['unitsGranted']
            : <any>null;
        this.exercisePrice =
          _data['exercisePrice'] !== undefined
            ? _data['exercisePrice']
            : <any>null;
        if (Array.isArray(_data['fairMarketValues'])) {
          this.fairMarketValues = [] as any;
          for (let item of _data['fairMarketValues'])
            this.fairMarketValues!.push(
              StockOptionFairMarketValue.fromJS(item),
            );
        } else {
          this.fairMarketValues = <any>null;
        }
        this.numberOfOptionsExercised =
          _data['numberOfOptionsExercised'] !== undefined
            ? _data['numberOfOptionsExercised']
            : <any>null;
        this.numberOfOptionsPreviouslyExercised =
          _data['numberOfOptionsPreviouslyExercised'] !== undefined
            ? _data['numberOfOptionsPreviouslyExercised']
            : <any>null;
        if (Array.isArray(_data['vests'])) {
          this.vests = [] as any;
          for (let item of _data['vests'])
            this.vests!.push(PreProcessorInputsStockOptionVest.fromJS(item));
        } else {
          this.vests = <any>null;
        }
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.grantDate = _data['grantDate']
          ? new Date(_data['grantDate'].toString())
          : <any>null;
        this.deliveryType =
          _data['deliveryType'] !== undefined
            ? _data['deliveryType']
            : <any>null;
        this.taxWithholdingMethod =
          _data['taxWithholdingMethod'] !== undefined
            ? _data['taxWithholdingMethod']
            : <any>null;
        this.exerciseDate = _data['exerciseDate']
          ? new Date(_data['exerciseDate'].toString())
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): PreProcessorInputsStockOptionTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsStockOptionTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['unitsGranted'] =
        this.unitsGranted !== undefined ? this.unitsGranted : <any>null;
      data['exercisePrice'] =
        this.exercisePrice !== undefined ? this.exercisePrice : <any>null;
      if (Array.isArray(this.fairMarketValues)) {
        data['fairMarketValues'] = [];
        for (let item of this.fairMarketValues)
          data['fairMarketValues'].push(item.toJSON());
      }
      data['numberOfOptionsExercised'] =
        this.numberOfOptionsExercised !== undefined
          ? this.numberOfOptionsExercised
          : <any>null;
      data['numberOfOptionsPreviouslyExercised'] =
        this.numberOfOptionsPreviouslyExercised !== undefined
          ? this.numberOfOptionsPreviouslyExercised
          : <any>null;
      if (Array.isArray(this.vests)) {
        data['vests'] = [];
        for (let item of this.vests) data['vests'].push(item.toJSON());
      }
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['grantDate'] = this.grantDate
        ? this.grantDate.toISOString()
        : <any>null;
      data['deliveryType'] =
        this.deliveryType !== undefined ? this.deliveryType : <any>null;
      data['taxWithholdingMethod'] =
        this.taxWithholdingMethod !== undefined
          ? this.taxWithholdingMethod
          : <any>null;
      data['exerciseDate'] = this.exerciseDate
        ? this.exerciseDate.toISOString()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPreProcessorInputsStockOptionTransaction
    extends IPreProcessorInputsTransaction {
    unitsGranted: number;
    exercisePrice: number;
    fairMarketValues: StockOptionFairMarketValue[];
    numberOfOptionsExercised: number;
    numberOfOptionsPreviouslyExercised: number | null;
    vests: PreProcessorInputsStockOptionVest[];
    planType: PlanType;
    grantDate: Date;
    deliveryType: DeliveryType;
    taxWithholdingMethod: TaxWithholdingMethod | null;
    exerciseDate: Date;
  }

  export class StockOptionFairMarketValue
    extends FairMarketValue
    implements IStockOptionFairMarketValue
  {
    type!: StockOptionFairMarketValueType;

    constructor(data?: IStockOptionFairMarketValue) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
      }
    }

    static override fromJS(data: any): StockOptionFairMarketValue {
      data = typeof data === 'object' ? data : {};
      let result = new StockOptionFairMarketValue();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IStockOptionFairMarketValue extends IFairMarketValue {
    type: StockOptionFairMarketValueType;
  }

  export enum StockOptionFairMarketValueType {
    Exercise = 'Exercise',
  }

  export class PreProcessorInputsStockOptionVest
    implements IPreProcessorInputsStockOptionVest
  {
    date!: Date;
    unitsVested!: number;

    constructor(data?: IPreProcessorInputsStockOptionVest) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.date = _data['date']
          ? new Date(_data['date'].toString())
          : <any>null;
        this.unitsVested =
          _data['unitsVested'] !== undefined ? _data['unitsVested'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsStockOptionVest {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsStockOptionVest();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['date'] = this.date ? this.date.toISOString() : <any>null;
      data['unitsVested'] =
        this.unitsVested !== undefined ? this.unitsVested : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsStockOptionVest {
    date: Date;
    unitsVested: number;
  }

  export class PreProcessorInputsLocationPeriod
    implements IPreProcessorInputsLocationPeriod
  {
    workLocationType!: WorkLocationType | null;
    clientWorkLocationType!: string | null;
    assignedWorkCountry!: PreProcessorInputsAssignedWorkCountry;
    employmentContractCountry!: PreProcessorInputsEmploymentContractCountry | null;
    liveCountry!: PreProcessorInputsLiveCountry | null;
    socialTaxCountry!: PreProcessorInputsSocialTaxCountry | null;
    certificateOfCoverageCountry!: PreProcessorInputsCertificateOfCoverageCountry | null;
    payrollCountry!: PreProcessorInputsPayrollCountry | null;
    startDate!: Date;
    endDate!: Date;
    teqPeriod!: boolean;

    constructor(data?: IPreProcessorInputsLocationPeriod) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.assignedWorkCountry = new PreProcessorInputsAssignedWorkCountry();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        this.assignedWorkCountry = _data['assignedWorkCountry']
          ? PreProcessorInputsAssignedWorkCountry.fromJS(
              _data['assignedWorkCountry'],
            )
          : new PreProcessorInputsAssignedWorkCountry();
        this.employmentContractCountry = _data['employmentContractCountry']
          ? PreProcessorInputsEmploymentContractCountry.fromJS(
              _data['employmentContractCountry'],
            )
          : <any>null;
        this.liveCountry = _data['liveCountry']
          ? PreProcessorInputsLiveCountry.fromJS(_data['liveCountry'])
          : <any>null;
        this.socialTaxCountry = _data['socialTaxCountry']
          ? PreProcessorInputsSocialTaxCountry.fromJS(_data['socialTaxCountry'])
          : <any>null;
        this.certificateOfCoverageCountry = _data[
          'certificateOfCoverageCountry'
        ]
          ? PreProcessorInputsCertificateOfCoverageCountry.fromJS(
              _data['certificateOfCoverageCountry'],
            )
          : <any>null;
        this.payrollCountry = _data['payrollCountry']
          ? PreProcessorInputsPayrollCountry.fromJS(_data['payrollCountry'])
          : <any>null;
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.teqPeriod =
          _data['teqPeriod'] !== undefined ? _data['teqPeriod'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsLocationPeriod {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsLocationPeriod();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      data['assignedWorkCountry'] = this.assignedWorkCountry
        ? this.assignedWorkCountry.toJSON()
        : <any>null;
      data['employmentContractCountry'] = this.employmentContractCountry
        ? this.employmentContractCountry.toJSON()
        : <any>null;
      data['liveCountry'] = this.liveCountry
        ? this.liveCountry.toJSON()
        : <any>null;
      data['socialTaxCountry'] = this.socialTaxCountry
        ? this.socialTaxCountry.toJSON()
        : <any>null;
      data['certificateOfCoverageCountry'] = this.certificateOfCoverageCountry
        ? this.certificateOfCoverageCountry.toJSON()
        : <any>null;
      data['payrollCountry'] = this.payrollCountry
        ? this.payrollCountry.toJSON()
        : <any>null;
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['teqPeriod'] =
        this.teqPeriod !== undefined ? this.teqPeriod : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsLocationPeriod {
    workLocationType: WorkLocationType | null;
    clientWorkLocationType: string | null;
    assignedWorkCountry: PreProcessorInputsAssignedWorkCountry;
    employmentContractCountry: PreProcessorInputsEmploymentContractCountry | null;
    liveCountry: PreProcessorInputsLiveCountry | null;
    socialTaxCountry: PreProcessorInputsSocialTaxCountry | null;
    certificateOfCoverageCountry: PreProcessorInputsCertificateOfCoverageCountry | null;
    payrollCountry: PreProcessorInputsPayrollCountry | null;
    startDate: Date;
    endDate: Date;
    teqPeriod: boolean;
  }

  export class PreProcessorInputsAssignedWorkCountry
    implements IPreProcessorInputsAssignedWorkCountry
  {
    code!: string;
    allocationPercentage!: number | null;
    region!: PreProcessorInputsAssignedWorkRegion | null;

    constructor(data?: IPreProcessorInputsAssignedWorkCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsAssignedWorkRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsAssignedWorkCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsAssignedWorkCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsAssignedWorkCountry {
    code: string;
    allocationPercentage: number | null;
    region: PreProcessorInputsAssignedWorkRegion | null;
  }

  export class PreProcessorInputsAssignedWorkRegion
    implements IPreProcessorInputsAssignedWorkRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsAssignedWorkRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsAssignedWorkRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsAssignedWorkRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsAssignedWorkRegion {
    code: string;
  }

  export class PreProcessorInputsEmploymentContractCountry
    implements IPreProcessorInputsEmploymentContractCountry
  {
    code!: string;
    employmentEntity!: string | null;
    region!: PreProcessorInputsEmploymentContractRegion | null;

    constructor(data?: IPreProcessorInputsEmploymentContractCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.employmentEntity =
          _data['employmentEntity'] !== undefined
            ? _data['employmentEntity']
            : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsEmploymentContractRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsEmploymentContractCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsEmploymentContractCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['employmentEntity'] =
        this.employmentEntity !== undefined ? this.employmentEntity : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsEmploymentContractCountry {
    code: string;
    employmentEntity: string | null;
    region: PreProcessorInputsEmploymentContractRegion | null;
  }

  export class PreProcessorInputsEmploymentContractRegion
    implements IPreProcessorInputsEmploymentContractRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsEmploymentContractRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsEmploymentContractRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsEmploymentContractRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsEmploymentContractRegion {
    code: string;
  }

  export class PreProcessorInputsLiveCountry
    implements IPreProcessorInputsLiveCountry
  {
    allocationPercentage!: number | null;
    code!: string;
    region!: PreProcessorInputsLiveRegion | null;

    constructor(data?: IPreProcessorInputsLiveCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsLiveRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsLiveCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsLiveCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsLiveCountry {
    allocationPercentage: number | null;
    code: string;
    region: PreProcessorInputsLiveRegion | null;
  }

  export class PreProcessorInputsLiveRegion
    implements IPreProcessorInputsLiveRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsLiveRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsLiveRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsLiveRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsLiveRegion {
    code: string;
  }

  export class PreProcessorInputsSocialTaxCountry
    implements IPreProcessorInputsSocialTaxCountry
  {
    code!: string;

    constructor(data?: IPreProcessorInputsSocialTaxCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsSocialTaxCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsSocialTaxCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsSocialTaxCountry {
    code: string;
  }

  export class PreProcessorInputsCertificateOfCoverageCountry
    implements IPreProcessorInputsCertificateOfCoverageCountry
  {
    code!: string;
    certificateOfCoverageExpirationDate!: Date | null;

    constructor(data?: IPreProcessorInputsCertificateOfCoverageCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.certificateOfCoverageExpirationDate = _data[
          'certificateOfCoverageExpirationDate'
        ]
          ? new Date(_data['certificateOfCoverageExpirationDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsCertificateOfCoverageCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsCertificateOfCoverageCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['certificateOfCoverageExpirationDate'] = this
        .certificateOfCoverageExpirationDate
        ? this.certificateOfCoverageExpirationDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsCertificateOfCoverageCountry {
    code: string;
    certificateOfCoverageExpirationDate: Date | null;
  }

  export class PreProcessorInputsPayrollCountry
    implements IPreProcessorInputsPayrollCountry
  {
    code!: string;
    payrollName!: string | null;

    constructor(data?: IPreProcessorInputsPayrollCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.payrollName =
          _data['payrollName'] !== undefined ? _data['payrollName'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsPayrollCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsPayrollCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['payrollName'] =
        this.payrollName !== undefined ? this.payrollName : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsPayrollCountry {
    code: string;
    payrollName: string | null;
  }

  export class TaxRate implements ITaxRate {
    taxRateType!: TaxRateType | null;
    customTax!: boolean;
    countryCode!: string;
    regionCode!: string | null;
    planType!: PlanType | null;
    planCode!: string | null;
    transactionId!: string | null;
    type!: TaxType;
    code!: string;
    banding!: Band[];
    doubleTaxReliefOverride!: number | null;
    residentBasisOfIncome!: BasisOfIncome | null;
    nonResidentBasisOfIncome!: BasisOfIncome | null;
    effectiveDate!: Date | null;
    endDate!: Date | null;
    residency!: ResidencyStatus | null;

    constructor(data?: ITaxRate) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.banding = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxRateType =
          _data['taxRateType'] !== undefined ? _data['taxRateType'] : <any>null;
        this.customTax =
          _data['customTax'] !== undefined ? _data['customTax'] : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['banding'])) {
          this.banding = [] as any;
          for (let item of _data['banding'])
            this.banding!.push(Band.fromJS(item));
        } else {
          this.banding = <any>null;
        }
        this.doubleTaxReliefOverride =
          _data['doubleTaxReliefOverride'] !== undefined
            ? _data['doubleTaxReliefOverride']
            : <any>null;
        this.residentBasisOfIncome =
          _data['residentBasisOfIncome'] !== undefined
            ? _data['residentBasisOfIncome']
            : <any>null;
        this.nonResidentBasisOfIncome =
          _data['nonResidentBasisOfIncome'] !== undefined
            ? _data['nonResidentBasisOfIncome']
            : <any>null;
        this.effectiveDate = _data['effectiveDate']
          ? new Date(_data['effectiveDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.residency =
          _data['residency'] !== undefined ? _data['residency'] : <any>null;
      }
    }

    static fromJS(data: any): TaxRate {
      data = typeof data === 'object' ? data : {};
      let result = new TaxRate();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxRateType'] =
        this.taxRateType !== undefined ? this.taxRateType : <any>null;
      data['customTax'] =
        this.customTax !== undefined ? this.customTax : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.banding)) {
        data['banding'] = [];
        for (let item of this.banding) data['banding'].push(item.toJSON());
      }
      data['doubleTaxReliefOverride'] =
        this.doubleTaxReliefOverride !== undefined
          ? this.doubleTaxReliefOverride
          : <any>null;
      data['residentBasisOfIncome'] =
        this.residentBasisOfIncome !== undefined
          ? this.residentBasisOfIncome
          : <any>null;
      data['nonResidentBasisOfIncome'] =
        this.nonResidentBasisOfIncome !== undefined
          ? this.nonResidentBasisOfIncome
          : <any>null;
      data['effectiveDate'] = this.effectiveDate
        ? this.effectiveDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['residency'] =
        this.residency !== undefined ? this.residency : <any>null;
      return data;
    }
  }

  export interface ITaxRate {
    taxRateType: TaxRateType | null;
    customTax: boolean;
    countryCode: string;
    regionCode: string | null;
    planType: PlanType | null;
    planCode: string | null;
    transactionId: string | null;
    type: TaxType;
    code: string;
    banding: Band[];
    doubleTaxReliefOverride: number | null;
    residentBasisOfIncome: BasisOfIncome | null;
    nonResidentBasisOfIncome: BasisOfIncome | null;
    effectiveDate: Date | null;
    endDate: Date | null;
    residency: ResidencyStatus | null;
  }

  export enum TaxRateType {
    Actual = 'Actual',
    Hypothetical = 'Hypothetical',
  }

  export class Band implements IBand {
    bandingType!: BandingType;
    currencyCode!: string | null;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    taxRate!: number;
    taxRateFormula!: string | null;

    constructor(data?: IBand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.taxRateFormula =
          _data['taxRateFormula'] !== undefined
            ? _data['taxRateFormula']
            : <any>null;
      }
    }

    static fromJS(data: any): Band {
      data = typeof data === 'object' ? data : {};
      let result = new Band();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['taxRateFormula'] =
        this.taxRateFormula !== undefined ? this.taxRateFormula : <any>null;
      return data;
    }
  }

  export interface IBand {
    bandingType: BandingType;
    currencyCode: string | null;
    lowerThreshold: number;
    upperThreshold: number | null;
    taxRate: number;
    taxRateFormula: string | null;
  }

  export enum BasisOfIncome {
    ZeroPercent = 'ZeroPercent',
    OneHundredPercent = 'OneHundredPercent',
    GV = 'GV',
    GD = 'GD',
    GE = 'GE',
    PSPE = 'PSPE',
    PSPD = 'PSPD',
    FollowTaxType = 'FollowTaxType',
  }

  export class TaxPosition implements ITaxPosition {
    code!: string;
    value!: Scalar;
    planType!: PlanType | null;
    planCode!: string | null;
    workLocationType!: WorkLocationType | null;
    clientWorkLocationType!: string | null;
    countries!: TaxPositionCountry[];
    transactionId!: string | null;

    constructor(data?: ITaxPosition) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.value = new Scalar();
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.value = _data['value']
          ? Scalar.fromJS(_data['value'])
          : new Scalar();
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(TaxPositionCountry.fromJS(item));
        } else {
          this.countries = <any>null;
        }
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxPosition {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPosition();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['value'] = this.value ? this.value.toJSON() : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface ITaxPosition {
    code: string;
    value: Scalar;
    planType: PlanType | null;
    planCode: string | null;
    workLocationType: WorkLocationType | null;
    clientWorkLocationType: string | null;
    countries: TaxPositionCountry[];
    transactionId: string | null;
  }

  export class TaxPositionCountry implements ITaxPositionCountry {
    code!: string;
    regions!: TaxPositionRegion[];

    constructor(data?: ITaxPositionCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(TaxPositionRegion.fromJS(item));
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): TaxPositionCountry {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPositionCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITaxPositionCountry {
    code: string;
    regions: TaxPositionRegion[];
  }

  export class TaxPositionRegion implements ITaxPositionRegion {
    code!: string;

    constructor(data?: ITaxPositionRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): TaxPositionRegion {
      data = typeof data === 'object' ? data : {};
      let result = new TaxPositionRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ITaxPositionRegion {
    code: string;
  }

  export class PreProcessorInputsIncomeForBanding
    implements IPreProcessorInputsIncomeForBanding
  {
    taxType!: TaxType | null;
    country!: PreProcessorInputsIncomeForBandingCountry;
    taxRateCode!: string | null;
    employmentEntity!: string | null;
    currencyCode!: string;
    amount!: number;

    constructor(data?: IPreProcessorInputsIncomeForBanding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new PreProcessorInputsIncomeForBandingCountry();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.country = _data['country']
          ? PreProcessorInputsIncomeForBandingCountry.fromJS(_data['country'])
          : new PreProcessorInputsIncomeForBandingCountry();
        this.taxRateCode =
          _data['taxRateCode'] !== undefined ? _data['taxRateCode'] : <any>null;
        this.employmentEntity =
          _data['employmentEntity'] !== undefined
            ? _data['employmentEntity']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.amount =
          _data['amount'] !== undefined ? _data['amount'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsIncomeForBanding {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsIncomeForBanding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['taxRateCode'] =
        this.taxRateCode !== undefined ? this.taxRateCode : <any>null;
      data['employmentEntity'] =
        this.employmentEntity !== undefined ? this.employmentEntity : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['amount'] = this.amount !== undefined ? this.amount : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsIncomeForBanding {
    taxType: TaxType | null;
    country: PreProcessorInputsIncomeForBandingCountry;
    taxRateCode: string | null;
    employmentEntity: string | null;
    currencyCode: string;
    amount: number;
  }

  export class PreProcessorInputsIncomeForBandingCountry
    implements IPreProcessorInputsIncomeForBandingCountry
  {
    code!: string;
    region!: PreProcessorInputsIncomeForBandingRegion | null;

    constructor(data?: IPreProcessorInputsIncomeForBandingCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsIncomeForBandingRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsIncomeForBandingCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsIncomeForBandingCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsIncomeForBandingCountry {
    code: string;
    region: PreProcessorInputsIncomeForBandingRegion | null;
  }

  export class PreProcessorInputsIncomeForBandingRegion
    implements IPreProcessorInputsIncomeForBandingRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsIncomeForBandingRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsIncomeForBandingRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsIncomeForBandingRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsIncomeForBandingRegion {
    code: string;
  }

  export class TransactionOrdering implements ITransactionOrdering {
    method!: TransactionOrderingMethod;
    sequence!: TransactionOrder[];

    constructor(data?: ITransactionOrdering) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.sequence = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.method =
          _data['method'] !== undefined ? _data['method'] : <any>null;
        if (Array.isArray(_data['sequence'])) {
          this.sequence = [] as any;
          for (let item of _data['sequence'])
            this.sequence!.push(TransactionOrder.fromJS(item));
        } else {
          this.sequence = <any>null;
        }
      }
    }

    static fromJS(data: any): TransactionOrdering {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionOrdering();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['method'] = this.method !== undefined ? this.method : <any>null;
      if (Array.isArray(this.sequence)) {
        data['sequence'] = [];
        for (let item of this.sequence) data['sequence'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITransactionOrdering {
    method: TransactionOrderingMethod;
    sequence: TransactionOrder[];
  }

  export enum TransactionOrderingMethod {
    InputImpliedOrder = 'InputImpliedOrder',
    InputCustomOrder = 'InputCustomOrder',
  }

  export class TransactionOrder implements ITransactionOrder {
    transactionId!: string;
    order!: number;

    constructor(data?: ITransactionOrder) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.order = _data['order'] !== undefined ? _data['order'] : <any>null;
      }
    }

    static fromJS(data: any): TransactionOrder {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionOrder();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['order'] = this.order !== undefined ? this.order : <any>null;
      return data;
    }
  }

  export interface ITransactionOrder {
    transactionId: string;
    order: number;
  }

  export class PreProcessorInputsHypotheticalProfile
    implements IPreProcessorInputsHypotheticalProfile
  {
    rateType!: HypotheticalProfileRateType | null;
    taxType!: TaxType | null;
    hypotheticalProfileCountry!: PreProcessorInputsHypotheticalProfileCountry | null;
    taxRate!: number | null;
    customTaxCode!: string | null;
    jurisdictionLevel!: JurisdictionLevel | null;
    transactionId!: string | null;

    constructor(data?: IPreProcessorInputsHypotheticalProfile) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.rateType =
          _data['rateType'] !== undefined ? _data['rateType'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.hypotheticalProfileCountry = _data['hypotheticalProfileCountry']
          ? PreProcessorInputsHypotheticalProfileCountry.fromJS(
              _data['hypotheticalProfileCountry'],
            )
          : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.customTaxCode =
          _data['customTaxCode'] !== undefined
            ? _data['customTaxCode']
            : <any>null;
        this.jurisdictionLevel =
          _data['jurisdictionLevel'] !== undefined
            ? _data['jurisdictionLevel']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsHypotheticalProfile {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsHypotheticalProfile();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['rateType'] =
        this.rateType !== undefined ? this.rateType : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['hypotheticalProfileCountry'] = this.hypotheticalProfileCountry
        ? this.hypotheticalProfileCountry.toJSON()
        : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['customTaxCode'] =
        this.customTaxCode !== undefined ? this.customTaxCode : <any>null;
      data['jurisdictionLevel'] =
        this.jurisdictionLevel !== undefined
          ? this.jurisdictionLevel
          : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsHypotheticalProfile {
    rateType: HypotheticalProfileRateType | null;
    taxType: TaxType | null;
    hypotheticalProfileCountry: PreProcessorInputsHypotheticalProfileCountry | null;
    taxRate: number | null;
    customTaxCode: string | null;
    jurisdictionLevel: JurisdictionLevel | null;
    transactionId: string | null;
  }

  export enum HypotheticalProfileRateType {
    Jurisdiction = 'Jurisdiction',
    FlatRate = 'FlatRate',
  }

  export class PreProcessorInputsHypotheticalProfileCountry
    implements IPreProcessorInputsHypotheticalProfileCountry
  {
    code!: string;
    region!: PreProcessorInputsHypotheticalProfileRegion | null;

    constructor(data?: IPreProcessorInputsHypotheticalProfileCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? PreProcessorInputsHypotheticalProfileRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsHypotheticalProfileCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsHypotheticalProfileCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsHypotheticalProfileCountry {
    code: string;
    region: PreProcessorInputsHypotheticalProfileRegion | null;
  }

  export class PreProcessorInputsHypotheticalProfileRegion
    implements IPreProcessorInputsHypotheticalProfileRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsHypotheticalProfileRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsHypotheticalProfileRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsHypotheticalProfileRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsHypotheticalProfileRegion {
    code: string;
  }

  export enum JurisdictionLevel {
    Country = 'Country',
    Region = 'Region',
  }

  export class PreProcessorInputsTaxFundingAndGrossup
    implements IPreProcessorInputsTaxFundingAndGrossup
  {
    taxesToGrossup!: PreProcessorInputsTaxToGrossup[];
    taxesFundedBy!: PreProcessorInputsTaxFundedBy[];

    constructor(data?: IPreProcessorInputsTaxFundingAndGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxesToGrossup = [];
        this.taxesFundedBy = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxesToGrossup'])) {
          this.taxesToGrossup = [] as any;
          for (let item of _data['taxesToGrossup'])
            this.taxesToGrossup!.push(
              PreProcessorInputsTaxToGrossup.fromJS(item),
            );
        } else {
          this.taxesToGrossup = <any>null;
        }
        if (Array.isArray(_data['taxesFundedBy'])) {
          this.taxesFundedBy = [] as any;
          for (let item of _data['taxesFundedBy'])
            this.taxesFundedBy!.push(
              PreProcessorInputsTaxFundedBy.fromJS(item),
            );
        } else {
          this.taxesFundedBy = <any>null;
        }
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxFundingAndGrossup {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxFundingAndGrossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxesToGrossup)) {
        data['taxesToGrossup'] = [];
        for (let item of this.taxesToGrossup)
          data['taxesToGrossup'].push(item.toJSON());
      }
      if (Array.isArray(this.taxesFundedBy)) {
        data['taxesFundedBy'] = [];
        for (let item of this.taxesFundedBy)
          data['taxesFundedBy'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPreProcessorInputsTaxFundingAndGrossup {
    taxesToGrossup: PreProcessorInputsTaxToGrossup[];
    taxesFundedBy: PreProcessorInputsTaxFundedBy[];
  }

  export class PreProcessorInputsTaxToGrossup
    implements IPreProcessorInputsTaxToGrossup
  {
    taxType!: GrossupTaxType;
    grossupElection!: TaxToGrossupElection;
    planType!: PlanType | null;
    planCode!: string | null;
    workLocationType!: WorkLocationType | null;
    clientWorkLocationType!: string | null;
    countries!: PreProcessorInputsTaxToGrossupCountry[];
    transactionId!: string | null;

    constructor(data?: IPreProcessorInputsTaxToGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.grossupElection =
          _data['grossupElection'] !== undefined
            ? _data['grossupElection']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(
              PreProcessorInputsTaxToGrossupCountry.fromJS(item),
            );
        } else {
          this.countries = <any>null;
        }
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxToGrossup {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxToGrossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['grossupElection'] =
        this.grossupElection !== undefined ? this.grossupElection : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsTaxToGrossup {
    taxType: GrossupTaxType;
    grossupElection: TaxToGrossupElection;
    planType: PlanType | null;
    planCode: string | null;
    workLocationType: WorkLocationType | null;
    clientWorkLocationType: string | null;
    countries: PreProcessorInputsTaxToGrossupCountry[];
    transactionId: string | null;
  }

  export enum GrossupTaxType {
    IncomeTax = 'IncomeTax',
    SocialTax = 'SocialTax',
    RegionTax = 'RegionTax',
  }

  export enum TaxToGrossupElection {
    Yes = 'Yes',
    No = 'No',
    FollowCountryLegislation = 'FollowCountryLegislation',
  }

  export class PreProcessorInputsTaxToGrossupCountry
    implements IPreProcessorInputsTaxToGrossupCountry
  {
    code!: string;
    regions!: PreProcessorInputsTaxToGrossupRegion[];

    constructor(data?: IPreProcessorInputsTaxToGrossupCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(
              PreProcessorInputsTaxToGrossupRegion.fromJS(item),
            );
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxToGrossupCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxToGrossupCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPreProcessorInputsTaxToGrossupCountry {
    code: string;
    regions: PreProcessorInputsTaxToGrossupRegion[];
  }

  export class PreProcessorInputsTaxToGrossupRegion
    implements IPreProcessorInputsTaxToGrossupRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsTaxToGrossupRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxToGrossupRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxToGrossupRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsTaxToGrossupRegion {
    code: string;
  }

  export class PreProcessorInputsTaxFundedBy
    implements IPreProcessorInputsTaxFundedBy
  {
    grossupLocationType!: GrossupLocationType;
    taxType!: GrossupTaxType;
    hypotheticalFundedByEmployee!: boolean;
    actualFundedBy!: ActualTaxFundedBy;
    grossupFundedBy!: GrossupFundedBy | null;
    planType!: PlanType | null;
    planCode!: string | null;
    workLocationType!: WorkLocationType | null;
    countries!: PreProcessorInputsTaxFundedByCountry[];
    transactionId!: string | null;

    constructor(data?: IPreProcessorInputsTaxFundedBy) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.grossupLocationType =
          _data['grossupLocationType'] !== undefined
            ? _data['grossupLocationType']
            : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.hypotheticalFundedByEmployee =
          _data['hypotheticalFundedByEmployee'] !== undefined
            ? _data['hypotheticalFundedByEmployee']
            : <any>null;
        this.actualFundedBy =
          _data['actualFundedBy'] !== undefined
            ? _data['actualFundedBy']
            : <any>null;
        this.grossupFundedBy =
          _data['grossupFundedBy'] !== undefined
            ? _data['grossupFundedBy']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(
              PreProcessorInputsTaxFundedByCountry.fromJS(item),
            );
        } else {
          this.countries = <any>null;
        }
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxFundedBy {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxFundedBy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['grossupLocationType'] =
        this.grossupLocationType !== undefined
          ? this.grossupLocationType
          : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['hypotheticalFundedByEmployee'] =
        this.hypotheticalFundedByEmployee !== undefined
          ? this.hypotheticalFundedByEmployee
          : <any>null;
      data['actualFundedBy'] =
        this.actualFundedBy !== undefined ? this.actualFundedBy : <any>null;
      data['grossupFundedBy'] =
        this.grossupFundedBy !== undefined ? this.grossupFundedBy : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsTaxFundedBy {
    grossupLocationType: GrossupLocationType;
    taxType: GrossupTaxType;
    hypotheticalFundedByEmployee: boolean;
    actualFundedBy: ActualTaxFundedBy;
    grossupFundedBy: GrossupFundedBy | null;
    planType: PlanType | null;
    planCode: string | null;
    workLocationType: WorkLocationType | null;
    countries: PreProcessorInputsTaxFundedByCountry[];
    transactionId: string | null;
  }

  export enum GrossupLocationType {
    EmploymentContract = 'EmploymentContract',
    AssignedWork = 'AssignedWork',
    Other = 'Other',
  }

  export enum ActualTaxFundedBy {
    Employee = 'Employee',
    Employer = 'Employer',
  }

  export enum GrossupFundedBy {
    Employee = 'Employee',
    Employer = 'Employer',
  }

  export class PreProcessorInputsTaxFundedByCountry
    implements IPreProcessorInputsTaxFundedByCountry
  {
    code!: string;
    regions!: PreProcessorInputsTaxFundedByRegion[];

    constructor(data?: IPreProcessorInputsTaxFundedByCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(
              PreProcessorInputsTaxFundedByRegion.fromJS(item),
            );
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxFundedByCountry {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxFundedByCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPreProcessorInputsTaxFundedByCountry {
    code: string;
    regions: PreProcessorInputsTaxFundedByRegion[];
  }

  export class PreProcessorInputsTaxFundedByRegion
    implements IPreProcessorInputsTaxFundedByRegion
  {
    code!: string;

    constructor(data?: IPreProcessorInputsTaxFundedByRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): PreProcessorInputsTaxFundedByRegion {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsTaxFundedByRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputsTaxFundedByRegion {
    code: string;
  }

  export class PreProcessorInputsEmployer
    implements IPreProcessorInputsEmployer
  {
    userDefinedFields!: UserDefinedField[];
    clientId!: string;
    clientPortalId!: number;
    clientName!: string;
    manualCalculationSettings!: ManualCalculationSettings;
    exchangeRates!: ClientProvidedExchangeRate[] | null;

    constructor(data?: IPreProcessorInputsEmployer) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.userDefinedFields = [];
        this.manualCalculationSettings = new ManualCalculationSettings();
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.clientName =
          _data['clientName'] !== undefined ? _data['clientName'] : <any>null;
        this.manualCalculationSettings = _data['manualCalculationSettings']
          ? ManualCalculationSettings.fromJS(_data['manualCalculationSettings'])
          : new ManualCalculationSettings();
        if (Array.isArray(_data['exchangeRates'])) {
          this.exchangeRates = [] as any;
          for (let item of _data['exchangeRates'])
            this.exchangeRates!.push(ClientProvidedExchangeRate.fromJS(item));
        } else {
          this.exchangeRates = <any>null;
        }
      }
    }

    static fromJS(data: any): PreProcessorInputsEmployer {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputsEmployer();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['clientName'] =
        this.clientName !== undefined ? this.clientName : <any>null;
      data['manualCalculationSettings'] = this.manualCalculationSettings
        ? this.manualCalculationSettings.toJSON()
        : <any>null;
      if (Array.isArray(this.exchangeRates)) {
        data['exchangeRates'] = [];
        for (let item of this.exchangeRates)
          data['exchangeRates'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPreProcessorInputsEmployer {
    userDefinedFields: UserDefinedField[];
    clientId: string;
    clientPortalId: number;
    clientName: string;
    manualCalculationSettings: ManualCalculationSettings;
    exchangeRates: ClientProvidedExchangeRate[] | null;
  }

  export class ManualCalculationSettings implements IManualCalculationSettings {
    specialSituations!: ManualCalculationSpecialSituation[];
    workflowTypes!: ManualCalculationWorkflowType[];
    countryPlanAutomationSettings!: CountryPlanAutomationSetting[];

    constructor(data?: IManualCalculationSettings) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.specialSituations = [];
        this.workflowTypes = [];
        this.countryPlanAutomationSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['specialSituations'])) {
          this.specialSituations = [] as any;
          for (let item of _data['specialSituations'])
            this.specialSituations!.push(
              ManualCalculationSpecialSituation.fromJS(item),
            );
        } else {
          this.specialSituations = <any>null;
        }
        if (Array.isArray(_data['workflowTypes'])) {
          this.workflowTypes = [] as any;
          for (let item of _data['workflowTypes'])
            this.workflowTypes!.push(
              ManualCalculationWorkflowType.fromJS(item),
            );
        } else {
          this.workflowTypes = <any>null;
        }
        if (Array.isArray(_data['countryPlanAutomationSettings'])) {
          this.countryPlanAutomationSettings = [] as any;
          for (let item of _data['countryPlanAutomationSettings'])
            this.countryPlanAutomationSettings!.push(
              CountryPlanAutomationSetting.fromJS(item),
            );
        } else {
          this.countryPlanAutomationSettings = <any>null;
        }
      }
    }

    static fromJS(data: any): ManualCalculationSettings {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationSettings();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.specialSituations)) {
        data['specialSituations'] = [];
        for (let item of this.specialSituations)
          data['specialSituations'].push(item.toJSON());
      }
      if (Array.isArray(this.workflowTypes)) {
        data['workflowTypes'] = [];
        for (let item of this.workflowTypes)
          data['workflowTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.countryPlanAutomationSettings)) {
        data['countryPlanAutomationSettings'] = [];
        for (let item of this.countryPlanAutomationSettings)
          data['countryPlanAutomationSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IManualCalculationSettings {
    specialSituations: ManualCalculationSpecialSituation[];
    workflowTypes: ManualCalculationWorkflowType[];
    countryPlanAutomationSettings: CountryPlanAutomationSetting[];
  }

  export class ManualCalculationSpecialSituation
    implements IManualCalculationSpecialSituation
  {
    situation!: string;
    thresholdValue!: Scalar;

    constructor(data?: IManualCalculationSpecialSituation) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.thresholdValue = new Scalar();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.situation =
          _data['situation'] !== undefined ? _data['situation'] : <any>null;
        this.thresholdValue = _data['thresholdValue']
          ? Scalar.fromJS(_data['thresholdValue'])
          : new Scalar();
      }
    }

    static fromJS(data: any): ManualCalculationSpecialSituation {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationSpecialSituation();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['situation'] =
        this.situation !== undefined ? this.situation : <any>null;
      data['thresholdValue'] = this.thresholdValue
        ? this.thresholdValue.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationSpecialSituation {
    situation: string;
    thresholdValue: Scalar;
  }

  export class ManualCalculationWorkflowType
    implements IManualCalculationWorkflowType
  {
    name!: string;
    value!: boolean;

    constructor(data?: IManualCalculationWorkflowType) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationWorkflowType {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationWorkflowType();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      return data;
    }
  }

  export interface IManualCalculationWorkflowType {
    name: string;
    value: boolean;
  }

  export class CountryPlanAutomationSetting
    implements ICountryPlanAutomationSetting
  {
    countryCode!: string;
    planCode!: string;
    planType!: PlanType;
    automationSetting!: CalculationMethodSetting;

    constructor(data?: ICountryPlanAutomationSetting) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.automationSetting =
          _data['automationSetting'] !== undefined
            ? _data['automationSetting']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryPlanAutomationSetting {
      data = typeof data === 'object' ? data : {};
      let result = new CountryPlanAutomationSetting();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['automationSetting'] =
        this.automationSetting !== undefined
          ? this.automationSetting
          : <any>null;
      return data;
    }
  }

  export interface ICountryPlanAutomationSetting {
    countryCode: string;
    planCode: string;
    planType: PlanType;
    automationSetting: CalculationMethodSetting;
  }

  export class ClientProvidedExchangeRate
    implements IClientProvidedExchangeRate
  {
    transactionCurrencyCode!: string;
    localCurrencyCode!: string;
    exchangeRate!: number;
    planType!: PlanType | null;
    planCode!: string | null;
    fromTransactionDate!: Date;
    toTransactionDate!: Date;

    constructor(data?: IClientProvidedExchangeRate) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionCurrencyCode =
          _data['transactionCurrencyCode'] !== undefined
            ? _data['transactionCurrencyCode']
            : <any>null;
        this.localCurrencyCode =
          _data['localCurrencyCode'] !== undefined
            ? _data['localCurrencyCode']
            : <any>null;
        this.exchangeRate =
          _data['exchangeRate'] !== undefined
            ? _data['exchangeRate']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.fromTransactionDate = _data['fromTransactionDate']
          ? new Date(_data['fromTransactionDate'].toString())
          : <any>null;
        this.toTransactionDate = _data['toTransactionDate']
          ? new Date(_data['toTransactionDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ClientProvidedExchangeRate {
      data = typeof data === 'object' ? data : {};
      let result = new ClientProvidedExchangeRate();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionCurrencyCode'] =
        this.transactionCurrencyCode !== undefined
          ? this.transactionCurrencyCode
          : <any>null;
      data['localCurrencyCode'] =
        this.localCurrencyCode !== undefined
          ? this.localCurrencyCode
          : <any>null;
      data['exchangeRate'] =
        this.exchangeRate !== undefined ? this.exchangeRate : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['fromTransactionDate'] = this.fromTransactionDate
        ? this.fromTransactionDate.toISOString()
        : <any>null;
      data['toTransactionDate'] = this.toTransactionDate
        ? this.toTransactionDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IClientProvidedExchangeRate {
    transactionCurrencyCode: string;
    localCurrencyCode: string;
    exchangeRate: number;
    planType: PlanType | null;
    planCode: string | null;
    fromTransactionDate: Date;
    toTransactionDate: Date;
  }

  export class GetRunBatchViaDataExchangePageDataQueryResult
    implements IGetRunBatchViaDataExchangePageDataQueryResult
  {
    constructor(data?: IGetRunBatchViaDataExchangePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetRunBatchViaDataExchangePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetRunBatchViaDataExchangePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetRunBatchViaDataExchangePageDataQueryResult {}

  export class GetRunBatchViaDataExchangePageDataQueryResultSuccess
    extends GetRunBatchViaDataExchangePageDataQueryResult
    implements IGetRunBatchViaDataExchangePageDataQueryResultSuccess
  {
    stagingFiles!: StagingFileInfoDto[];

    constructor(data?: IGetRunBatchViaDataExchangePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.stagingFiles = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['stagingFiles'])) {
          this.stagingFiles = [] as any;
          for (let item of _data['stagingFiles'])
            this.stagingFiles!.push(StagingFileInfoDto.fromJS(item));
        } else {
          this.stagingFiles = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetRunBatchViaDataExchangePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetRunBatchViaDataExchangePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.stagingFiles)) {
        data['stagingFiles'] = [];
        for (let item of this.stagingFiles)
          data['stagingFiles'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRunBatchViaDataExchangePageDataQueryResultSuccess
    extends IGetRunBatchViaDataExchangePageDataQueryResult {
    stagingFiles: StagingFileInfoDto[];
  }

  export class StagingFileInfoDto implements IStagingFileInfoDto {
    fileName!: string;
    uploadedOn!: Date;

    constructor(data?: IStagingFileInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.uploadedOn = _data['uploadedOn']
          ? new Date(_data['uploadedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): StagingFileInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new StagingFileInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['uploadedOn'] = this.uploadedOn
        ? this.uploadedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IStagingFileInfoDto {
    fileName: string;
    uploadedOn: Date;
  }

  export class GetRunBatchViaDataExchangePageDataQueryResultFailure
    extends GetRunBatchViaDataExchangePageDataQueryResult
    implements IGetRunBatchViaDataExchangePageDataQueryResultFailure
  {
    constructor(data?: IGetRunBatchViaDataExchangePageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetRunBatchViaDataExchangePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetRunBatchViaDataExchangePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetRunBatchViaDataExchangePageDataQueryResultFailure
    extends IGetRunBatchViaDataExchangePageDataQueryResult {}

  export class GetStagingFilesPreSignedUrlsForUploadResult
    implements IGetStagingFilesPreSignedUrlsForUploadResult
  {
    constructor(data?: IGetStagingFilesPreSignedUrlsForUploadResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetStagingFilesPreSignedUrlsForUploadResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetStagingFilesPreSignedUrlsForUploadResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetStagingFilesPreSignedUrlsForUploadResult {}

  export class GetStagingFilesPreSignedUrlsForUploadResultSuccess
    extends GetStagingFilesPreSignedUrlsForUploadResult
    implements IGetStagingFilesPreSignedUrlsForUploadResultSuccess
  {
    preSignedUrls!: StagingFilePreSignedUrlForUploadDto[];

    constructor(data?: IGetStagingFilesPreSignedUrlsForUploadResultSuccess) {
      super(data);
      if (!data) {
        this.preSignedUrls = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['preSignedUrls'])) {
          this.preSignedUrls = [] as any;
          for (let item of _data['preSignedUrls'])
            this.preSignedUrls!.push(
              StagingFilePreSignedUrlForUploadDto.fromJS(item),
            );
        } else {
          this.preSignedUrls = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetStagingFilesPreSignedUrlsForUploadResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetStagingFilesPreSignedUrlsForUploadResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.preSignedUrls)) {
        data['preSignedUrls'] = [];
        for (let item of this.preSignedUrls)
          data['preSignedUrls'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetStagingFilesPreSignedUrlsForUploadResultSuccess
    extends IGetStagingFilesPreSignedUrlsForUploadResult {
    preSignedUrls: StagingFilePreSignedUrlForUploadDto[];
  }

  export class StagingFilePreSignedUrlForUploadDto
    implements IStagingFilePreSignedUrlForUploadDto
  {
    fileName!: string;
    url!: string;
    headers!: { [key: string]: string };
    virusScanningJobId!: string;

    constructor(data?: IStagingFilePreSignedUrlForUploadDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.headers = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.url = _data['url'] !== undefined ? _data['url'] : <any>null;
        if (_data['headers']) {
          this.headers = {} as any;
          for (let key in _data['headers']) {
            if (_data['headers'].hasOwnProperty(key))
              (<any>this.headers)![key] =
                _data['headers'][key] !== undefined
                  ? _data['headers'][key]
                  : <any>null;
          }
        } else {
          this.headers = <any>null;
        }
        this.virusScanningJobId =
          _data['virusScanningJobId'] !== undefined
            ? _data['virusScanningJobId']
            : <any>null;
      }
    }

    static fromJS(data: any): StagingFilePreSignedUrlForUploadDto {
      data = typeof data === 'object' ? data : {};
      let result = new StagingFilePreSignedUrlForUploadDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['url'] = this.url !== undefined ? this.url : <any>null;
      if (this.headers) {
        data['headers'] = {};
        for (let key in this.headers) {
          if (this.headers.hasOwnProperty(key))
            (<any>data['headers'])[key] =
              this.headers[key] !== undefined ? this.headers[key] : <any>null;
        }
      }
      data['virusScanningJobId'] =
        this.virusScanningJobId !== undefined
          ? this.virusScanningJobId
          : <any>null;
      return data;
    }
  }

  export interface IStagingFilePreSignedUrlForUploadDto {
    fileName: string;
    url: string;
    headers: { [key: string]: string };
    virusScanningJobId: string;
  }

  export class GetStagingFilesPreSignedUrlsForUploadResultFailure
    extends GetStagingFilesPreSignedUrlsForUploadResult
    implements IGetStagingFilesPreSignedUrlsForUploadResultFailure
  {
    constructor(data?: IGetStagingFilesPreSignedUrlsForUploadResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetStagingFilesPreSignedUrlsForUploadResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetStagingFilesPreSignedUrlsForUploadResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetStagingFilesPreSignedUrlsForUploadResultFailure
    extends IGetStagingFilesPreSignedUrlsForUploadResult {}

  export class GetStagingFilePreSignedUrlDto
    implements IGetStagingFilePreSignedUrlDto
  {
    fileName!: string;
    contentType!: string;

    constructor(data?: IGetStagingFilePreSignedUrlDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.contentType =
          _data['contentType'] !== undefined ? _data['contentType'] : <any>null;
      }
    }

    static fromJS(data: any): GetStagingFilePreSignedUrlDto {
      data = typeof data === 'object' ? data : {};
      let result = new GetStagingFilePreSignedUrlDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['contentType'] =
        this.contentType !== undefined ? this.contentType : <any>null;
      return data;
    }
  }

  export interface IGetStagingFilePreSignedUrlDto {
    fileName: string;
    contentType: string;
  }

  export class HandlePostStagingFilesUploadCommandResult
    implements IHandlePostStagingFilesUploadCommandResult
  {
    constructor(data?: IHandlePostStagingFilesUploadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): HandlePostStagingFilesUploadCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostStagingFilesUploadCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IHandlePostStagingFilesUploadCommandResult {}

  export class HandlePostStagingFilesUploadCommandResultSuccess
    extends HandlePostStagingFilesUploadCommandResult
    implements IHandlePostStagingFilesUploadCommandResultSuccess
  {
    batchId!: string | null;
    stagingFiles!: StagingFileInfoDto[];

    constructor(data?: IHandlePostStagingFilesUploadCommandResultSuccess) {
      super(data);
      if (!data) {
        this.stagingFiles = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        if (Array.isArray(_data['stagingFiles'])) {
          this.stagingFiles = [] as any;
          for (let item of _data['stagingFiles'])
            this.stagingFiles!.push(StagingFileInfoDto.fromJS(item));
        } else {
          this.stagingFiles = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): HandlePostStagingFilesUploadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostStagingFilesUploadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      if (Array.isArray(this.stagingFiles)) {
        data['stagingFiles'] = [];
        for (let item of this.stagingFiles)
          data['stagingFiles'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandlePostStagingFilesUploadCommandResultSuccess
    extends IHandlePostStagingFilesUploadCommandResult {
    batchId: string | null;
    stagingFiles: StagingFileInfoDto[];
  }

  export class HandlePostStagingFilesUploadCommandResultFailure
    extends HandlePostStagingFilesUploadCommandResult
    implements IHandlePostStagingFilesUploadCommandResultFailure
  {
    constructor(data?: IHandlePostStagingFilesUploadCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): HandlePostStagingFilesUploadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostStagingFilesUploadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IHandlePostStagingFilesUploadCommandResultFailure
    extends IHandlePostStagingFilesUploadCommandResult {}

  export class HandlePostStagingFilesUploadCommand
    implements IHandlePostStagingFilesUploadCommand
  {
    clientId!: string;
    uploadedFiles!: string[];

    constructor(data?: IHandlePostStagingFilesUploadCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.uploadedFiles = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['uploadedFiles'])) {
          this.uploadedFiles = [] as any;
          for (let item of _data['uploadedFiles'])
            this.uploadedFiles!.push(item);
        } else {
          this.uploadedFiles = <any>null;
        }
      }
    }

    static fromJS(data: any): HandlePostStagingFilesUploadCommand {
      data = typeof data === 'object' ? data : {};
      let result = new HandlePostStagingFilesUploadCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.uploadedFiles)) {
        data['uploadedFiles'] = [];
        for (let item of this.uploadedFiles) data['uploadedFiles'].push(item);
      }
      return data;
    }
  }

  export interface IHandlePostStagingFilesUploadCommand {
    clientId: string;
    uploadedFiles: string[];
  }

  export class GetStagingFilePreSignedUrlsForDownloadCommandResult
    implements IGetStagingFilePreSignedUrlsForDownloadCommandResult
  {
    constructor(data?: IGetStagingFilePreSignedUrlsForDownloadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetStagingFilePreSignedUrlsForDownloadCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetStagingFilePreSignedUrlsForDownloadCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetStagingFilePreSignedUrlsForDownloadCommandResult {}

  export class GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess
    extends GetStagingFilePreSignedUrlsForDownloadCommandResult
    implements IGetStagingFilePreSignedUrlsForDownloadCommandResultSuccess
  {
    preSignedUrl!: string;

    constructor(
      data?: IGetStagingFilePreSignedUrlsForDownloadCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.preSignedUrl =
          _data['preSignedUrl'] !== undefined
            ? _data['preSignedUrl']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetStagingFilePreSignedUrlsForDownloadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['preSignedUrl'] =
        this.preSignedUrl !== undefined ? this.preSignedUrl : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetStagingFilePreSignedUrlsForDownloadCommandResultSuccess
    extends IGetStagingFilePreSignedUrlsForDownloadCommandResult {
    preSignedUrl: string;
  }

  export class GetStagingFilePreSignedUrlsForDownloadCommandResultFailure
    extends GetStagingFilePreSignedUrlsForDownloadCommandResult
    implements IGetStagingFilePreSignedUrlsForDownloadCommandResultFailure
  {
    constructor(
      data?: IGetStagingFilePreSignedUrlsForDownloadCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetStagingFilePreSignedUrlsForDownloadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetStagingFilePreSignedUrlsForDownloadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetStagingFilePreSignedUrlsForDownloadCommandResultFailure
    extends IGetStagingFilePreSignedUrlsForDownloadCommandResult {}

  export class DeleteStagingFileCommandResult
    implements IDeleteStagingFileCommandResult
  {
    constructor(data?: IDeleteStagingFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteStagingFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStagingFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteStagingFileCommandResult {}

  export class DeleteStagingFileCommandResultSuccess
    extends DeleteStagingFileCommandResult
    implements IDeleteStagingFileCommandResultSuccess
  {
    stagingFiles!: StagingFileInfoDto[];

    constructor(data?: IDeleteStagingFileCommandResultSuccess) {
      super(data);
      if (!data) {
        this.stagingFiles = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['stagingFiles'])) {
          this.stagingFiles = [] as any;
          for (let item of _data['stagingFiles'])
            this.stagingFiles!.push(StagingFileInfoDto.fromJS(item));
        } else {
          this.stagingFiles = <any>null;
        }
      }
    }

    static override fromJS(data: any): DeleteStagingFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStagingFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.stagingFiles)) {
        data['stagingFiles'] = [];
        for (let item of this.stagingFiles)
          data['stagingFiles'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteStagingFileCommandResultSuccess
    extends IDeleteStagingFileCommandResult {
    stagingFiles: StagingFileInfoDto[];
  }

  export class DeleteStagingFileCommandResultFailure
    extends DeleteStagingFileCommandResult
    implements IDeleteStagingFileCommandResultFailure
  {
    constructor(data?: IDeleteStagingFileCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): DeleteStagingFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteStagingFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteStagingFileCommandResultFailure
    extends IDeleteStagingFileCommandResult {}

  export abstract class GetBatchStatusQueryResult
    implements IGetBatchStatusQueryResult
  {
    constructor(data?: IGetBatchStatusQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchStatusQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchStatusQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchStatusQueryResult {}

  export class GetBatchStatusQueryResultSuccess
    extends GetBatchStatusQueryResult
    implements IGetBatchStatusQueryResultSuccess
  {
    batchStatus!: BatchStatus | null;

    constructor(data?: IGetBatchStatusQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.batchStatus =
          _data['batchStatus'] !== undefined ? _data['batchStatus'] : <any>null;
      }
    }

    static override fromJS(data: any): GetBatchStatusQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchStatusQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchStatus'] =
        this.batchStatus !== undefined ? this.batchStatus : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchStatusQueryResultSuccess
    extends IGetBatchStatusQueryResult {
    batchStatus: BatchStatus | null;
  }

  export class GetBatchStatusQueryResultFailure
    extends GetBatchStatusQueryResult
    implements IGetBatchStatusQueryResultFailure
  {
    constructor(data?: IGetBatchStatusQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetBatchStatusQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchStatusQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchStatusQueryResultFailure
    extends IGetBatchStatusQueryResult {}

  export abstract class UpdateManualCalculationEngineResultsCommandResult
    implements IUpdateManualCalculationEngineResultsCommandResult
  {
    constructor(data?: IUpdateManualCalculationEngineResultsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpdateManualCalculationEngineResultsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpdateManualCalculationEngineResultsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpdateManualCalculationEngineResultsCommandResult {}

  export class UpdateManualCalculationEngineResultsCommandResultSuccess
    extends UpdateManualCalculationEngineResultsCommandResult
    implements IUpdateManualCalculationEngineResultsCommandResultSuccess
  {
    transactionResult!: TransactionResult;
    calculation!: CalculationIndexModel;
    calcEngineRequestPayload!: string | null;

    constructor(
      data?: IUpdateManualCalculationEngineResultsCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.transactionResult = new TransactionResult();
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.transactionResult = _data['transactionResult']
          ? TransactionResult.fromJS(_data['transactionResult'])
          : new TransactionResult();
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
        this.calcEngineRequestPayload =
          _data['calcEngineRequestPayload'] !== undefined
            ? _data['calcEngineRequestPayload']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpdateManualCalculationEngineResultsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpdateManualCalculationEngineResultsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionResult'] = this.transactionResult
        ? this.transactionResult.toJSON()
        : <any>null;
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      data['calcEngineRequestPayload'] =
        this.calcEngineRequestPayload !== undefined
          ? this.calcEngineRequestPayload
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateManualCalculationEngineResultsCommandResultSuccess
    extends IUpdateManualCalculationEngineResultsCommandResult {
    transactionResult: TransactionResult;
    calculation: CalculationIndexModel;
    calcEngineRequestPayload: string | null;
  }

  export class TransactionResult implements ITransactionResult {
    teq!: boolean;
    resultType!: TransactionResultType;
    transactionGuid!: string;
    status!: string | null;
    order!: number;
    transactionId!: string;
    currencyCode!: string;
    currencyConversionSpotDate!: Date | null;
    exchangeRateUsedDate!: Date | null;
    gain!: TransactionGain;
    manualCalculationRequired!: boolean | null;
    manualCalculationReason!: string | null;
    adjustmentRequired!: AdjustmentType | null;
    countryWorkings!: CountryWorking[];
    countryTotals!: CountryTotals[];
    exchangeRatesUsed!: ExchangeRate[];
    locationPeriodResults!: LocationPeriodResult[];
    totals!: TransactionTotals;
    hypotheticalResultsTotals!: HypotheticalResultTotals[];
    manualUpdate!: boolean | null;

    constructor(data?: ITransactionResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gain = new TransactionGain();
        this.countryWorkings = [];
        this.countryTotals = [];
        this.exchangeRatesUsed = [];
        this.locationPeriodResults = [];
        this.totals = new TransactionTotals();
        this.hypotheticalResultsTotals = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.teq = _data['teq'] !== undefined ? _data['teq'] : <any>null;
        this.resultType =
          _data['resultType'] !== undefined ? _data['resultType'] : <any>null;
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.order = _data['order'] !== undefined ? _data['order'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.currencyConversionSpotDate = _data['currencyConversionSpotDate']
          ? new Date(_data['currencyConversionSpotDate'].toString())
          : <any>null;
        this.exchangeRateUsedDate = _data['exchangeRateUsedDate']
          ? new Date(_data['exchangeRateUsedDate'].toString())
          : <any>null;
        this.gain = _data['gain']
          ? TransactionGain.fromJS(_data['gain'])
          : new TransactionGain();
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationReason =
          _data['manualCalculationReason'] !== undefined
            ? _data['manualCalculationReason']
            : <any>null;
        this.adjustmentRequired =
          _data['adjustmentRequired'] !== undefined
            ? _data['adjustmentRequired']
            : <any>null;
        if (Array.isArray(_data['countryWorkings'])) {
          this.countryWorkings = [] as any;
          for (let item of _data['countryWorkings'])
            this.countryWorkings!.push(CountryWorking.fromJS(item));
        } else {
          this.countryWorkings = <any>null;
        }
        if (Array.isArray(_data['countryTotals'])) {
          this.countryTotals = [] as any;
          for (let item of _data['countryTotals'])
            this.countryTotals!.push(CountryTotals.fromJS(item));
        } else {
          this.countryTotals = <any>null;
        }
        if (Array.isArray(_data['exchangeRatesUsed'])) {
          this.exchangeRatesUsed = [] as any;
          for (let item of _data['exchangeRatesUsed'])
            this.exchangeRatesUsed!.push(ExchangeRate.fromJS(item));
        } else {
          this.exchangeRatesUsed = <any>null;
        }
        if (Array.isArray(_data['locationPeriodResults'])) {
          this.locationPeriodResults = [] as any;
          for (let item of _data['locationPeriodResults'])
            this.locationPeriodResults!.push(LocationPeriodResult.fromJS(item));
        } else {
          this.locationPeriodResults = <any>null;
        }
        this.totals = _data['totals']
          ? TransactionTotals.fromJS(_data['totals'])
          : new TransactionTotals();
        if (Array.isArray(_data['hypotheticalResultsTotals'])) {
          this.hypotheticalResultsTotals = [] as any;
          for (let item of _data['hypotheticalResultsTotals'])
            this.hypotheticalResultsTotals!.push(
              HypotheticalResultTotals.fromJS(item),
            );
        } else {
          this.hypotheticalResultsTotals = <any>null;
        }
        this.manualUpdate =
          _data['manualUpdate'] !== undefined
            ? _data['manualUpdate']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionResult {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['teq'] = this.teq !== undefined ? this.teq : <any>null;
      data['resultType'] =
        this.resultType !== undefined ? this.resultType : <any>null;
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['order'] = this.order !== undefined ? this.order : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['currencyConversionSpotDate'] = this.currencyConversionSpotDate
        ? this.currencyConversionSpotDate.toISOString()
        : <any>null;
      data['exchangeRateUsedDate'] = this.exchangeRateUsedDate
        ? this.exchangeRateUsedDate.toISOString()
        : <any>null;
      data['gain'] = this.gain ? this.gain.toJSON() : <any>null;
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationReason'] =
        this.manualCalculationReason !== undefined
          ? this.manualCalculationReason
          : <any>null;
      data['adjustmentRequired'] =
        this.adjustmentRequired !== undefined
          ? this.adjustmentRequired
          : <any>null;
      if (Array.isArray(this.countryWorkings)) {
        data['countryWorkings'] = [];
        for (let item of this.countryWorkings)
          data['countryWorkings'].push(item.toJSON());
      }
      if (Array.isArray(this.countryTotals)) {
        data['countryTotals'] = [];
        for (let item of this.countryTotals)
          data['countryTotals'].push(item.toJSON());
      }
      if (Array.isArray(this.exchangeRatesUsed)) {
        data['exchangeRatesUsed'] = [];
        for (let item of this.exchangeRatesUsed)
          data['exchangeRatesUsed'].push(item.toJSON());
      }
      if (Array.isArray(this.locationPeriodResults)) {
        data['locationPeriodResults'] = [];
        for (let item of this.locationPeriodResults)
          data['locationPeriodResults'].push(item.toJSON());
      }
      data['totals'] = this.totals ? this.totals.toJSON() : <any>null;
      if (Array.isArray(this.hypotheticalResultsTotals)) {
        data['hypotheticalResultsTotals'] = [];
        for (let item of this.hypotheticalResultsTotals)
          data['hypotheticalResultsTotals'].push(item.toJSON());
      }
      data['manualUpdate'] =
        this.manualUpdate !== undefined ? this.manualUpdate : <any>null;
      return data;
    }
  }

  export interface ITransactionResult {
    teq: boolean;
    resultType: TransactionResultType;
    transactionGuid: string;
    status: string | null;
    order: number;
    transactionId: string;
    currencyCode: string;
    currencyConversionSpotDate: Date | null;
    exchangeRateUsedDate: Date | null;
    gain: TransactionGain;
    manualCalculationRequired: boolean | null;
    manualCalculationReason: string | null;
    adjustmentRequired: AdjustmentType | null;
    countryWorkings: CountryWorking[];
    countryTotals: CountryTotals[];
    exchangeRatesUsed: ExchangeRate[];
    locationPeriodResults: LocationPeriodResult[];
    totals: TransactionTotals;
    hypotheticalResultsTotals: HypotheticalResultTotals[];
    manualUpdate: boolean | null;
  }

  export enum TransactionResultType {
    TEQOnly = 'TEQOnly',
    NonTEQOnly = 'NonTEQOnly',
    Both = 'Both',
  }

  export class TransactionGain implements ITransactionGain {
    value!: number;
    currencyCode!: string;
    fairMarketValue!: number;
    fairMarketValueType!: FairMarketValueType;
    fairMarketValueDescription!: string | null;

    constructor(data?: ITransactionGain) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.fairMarketValue =
          _data['fairMarketValue'] !== undefined
            ? _data['fairMarketValue']
            : <any>null;
        this.fairMarketValueType =
          _data['fairMarketValueType'] !== undefined
            ? _data['fairMarketValueType']
            : <any>null;
        this.fairMarketValueDescription =
          _data['fairMarketValueDescription'] !== undefined
            ? _data['fairMarketValueDescription']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionGain {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionGain();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['fairMarketValue'] =
        this.fairMarketValue !== undefined ? this.fairMarketValue : <any>null;
      data['fairMarketValueType'] =
        this.fairMarketValueType !== undefined
          ? this.fairMarketValueType
          : <any>null;
      data['fairMarketValueDescription'] =
        this.fairMarketValueDescription !== undefined
          ? this.fairMarketValueDescription
          : <any>null;
      return data;
    }
  }

  export interface ITransactionGain {
    value: number;
    currencyCode: string;
    fairMarketValue: number;
    fairMarketValueType: FairMarketValueType;
    fairMarketValueDescription: string | null;
  }

  export enum FairMarketValueType {
    Vest = 'Vest',
    Distribution = 'Distribution',
    Exercise = 'Exercise',
    Payment = 'Payment',
  }

  export enum AdjustmentType {
    Broker = 'Broker',
    GAIN = 'GAIN',
  }

  export class CountryWorking implements ICountryWorking {
    countryCode!: string;
    currencyCode!: string;
    rechargeAmount!: number | null;
    grossCashPayment!: number | null;
    netCashPayment!: number | null;
    totalFutureReportableAfterAllocation!: number;
    additionalFutureReportableAfterAllocation!: number;

    constructor(data?: ICountryWorking) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.rechargeAmount =
          _data['rechargeAmount'] !== undefined
            ? _data['rechargeAmount']
            : <any>null;
        this.grossCashPayment =
          _data['grossCashPayment'] !== undefined
            ? _data['grossCashPayment']
            : <any>null;
        this.netCashPayment =
          _data['netCashPayment'] !== undefined
            ? _data['netCashPayment']
            : <any>null;
        this.totalFutureReportableAfterAllocation =
          _data['totalFutureReportableAfterAllocation'] !== undefined
            ? _data['totalFutureReportableAfterAllocation']
            : <any>null;
        this.additionalFutureReportableAfterAllocation =
          _data['additionalFutureReportableAfterAllocation'] !== undefined
            ? _data['additionalFutureReportableAfterAllocation']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryWorking {
      data = typeof data === 'object' ? data : {};
      let result = new CountryWorking();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['rechargeAmount'] =
        this.rechargeAmount !== undefined ? this.rechargeAmount : <any>null;
      data['grossCashPayment'] =
        this.grossCashPayment !== undefined ? this.grossCashPayment : <any>null;
      data['netCashPayment'] =
        this.netCashPayment !== undefined ? this.netCashPayment : <any>null;
      data['totalFutureReportableAfterAllocation'] =
        this.totalFutureReportableAfterAllocation !== undefined
          ? this.totalFutureReportableAfterAllocation
          : <any>null;
      data['additionalFutureReportableAfterAllocation'] =
        this.additionalFutureReportableAfterAllocation !== undefined
          ? this.additionalFutureReportableAfterAllocation
          : <any>null;
      return data;
    }
  }

  export interface ICountryWorking {
    countryCode: string;
    currencyCode: string;
    rechargeAmount: number | null;
    grossCashPayment: number | null;
    netCashPayment: number | null;
    totalFutureReportableAfterAllocation: number;
    additionalFutureReportableAfterAllocation: number;
  }

  export class CountryTotals implements ICountryTotals {
    countryTotalType!: CountryTotalType;
    countryCode!: string;
    currencyCode!: string;
    reportableIncome!: CountryTotalReportableIncome;
    incomeSubjectToWithholding!: CountryTotalIncomeSubjectToWithholding[];
    regionTotals!: RegionTotals[];
    totalTax!: CountryTotalTax;
    timeSpentAllocationPercentage!: number | null;
    timeSpentAllocationAmount!: number | null;

    constructor(data?: ICountryTotals) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.reportableIncome = new CountryTotalReportableIncome();
        this.incomeSubjectToWithholding = [];
        this.regionTotals = [];
        this.totalTax = new CountryTotalTax();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryTotalType =
          _data['countryTotalType'] !== undefined
            ? _data['countryTotalType']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.reportableIncome = _data['reportableIncome']
          ? CountryTotalReportableIncome.fromJS(_data['reportableIncome'])
          : new CountryTotalReportableIncome();
        if (Array.isArray(_data['incomeSubjectToWithholding'])) {
          this.incomeSubjectToWithholding = [] as any;
          for (let item of _data['incomeSubjectToWithholding'])
            this.incomeSubjectToWithholding!.push(
              CountryTotalIncomeSubjectToWithholding.fromJS(item),
            );
        } else {
          this.incomeSubjectToWithholding = <any>null;
        }
        if (Array.isArray(_data['regionTotals'])) {
          this.regionTotals = [] as any;
          for (let item of _data['regionTotals'])
            this.regionTotals!.push(RegionTotals.fromJS(item));
        } else {
          this.regionTotals = <any>null;
        }
        this.totalTax = _data['totalTax']
          ? CountryTotalTax.fromJS(_data['totalTax'])
          : new CountryTotalTax();
        this.timeSpentAllocationPercentage =
          _data['timeSpentAllocationPercentage'] !== undefined
            ? _data['timeSpentAllocationPercentage']
            : <any>null;
        this.timeSpentAllocationAmount =
          _data['timeSpentAllocationAmount'] !== undefined
            ? _data['timeSpentAllocationAmount']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryTotals {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotals();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryTotalType'] =
        this.countryTotalType !== undefined ? this.countryTotalType : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['reportableIncome'] = this.reportableIncome
        ? this.reportableIncome.toJSON()
        : <any>null;
      if (Array.isArray(this.incomeSubjectToWithholding)) {
        data['incomeSubjectToWithholding'] = [];
        for (let item of this.incomeSubjectToWithholding)
          data['incomeSubjectToWithholding'].push(item.toJSON());
      }
      if (Array.isArray(this.regionTotals)) {
        data['regionTotals'] = [];
        for (let item of this.regionTotals)
          data['regionTotals'].push(item.toJSON());
      }
      data['totalTax'] = this.totalTax ? this.totalTax.toJSON() : <any>null;
      data['timeSpentAllocationPercentage'] =
        this.timeSpentAllocationPercentage !== undefined
          ? this.timeSpentAllocationPercentage
          : <any>null;
      data['timeSpentAllocationAmount'] =
        this.timeSpentAllocationAmount !== undefined
          ? this.timeSpentAllocationAmount
          : <any>null;
      return data;
    }
  }

  export interface ICountryTotals {
    countryTotalType: CountryTotalType;
    countryCode: string;
    currencyCode: string;
    reportableIncome: CountryTotalReportableIncome;
    incomeSubjectToWithholding: CountryTotalIncomeSubjectToWithholding[];
    regionTotals: RegionTotals[];
    totalTax: CountryTotalTax;
    timeSpentAllocationPercentage: number | null;
    timeSpentAllocationAmount: number | null;
  }

  export enum CountryTotalType {
    TEQTotal = 'TEQTotal',
    NonTEQTotal = 'NonTEQTotal',
    CombinedCountryTotal = 'CombinedCountryTotal',
  }

  export class CountryTotalReportableIncome
    implements ICountryTotalReportableIncome
  {
    gainUsed!: TransactionGainUsed[];
    transactionGain!: number | null;
    allocationPercentage!: number;
    reportableIncomeAfterAllocation!: number;
    hypotheticalTaxDeductions!: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction!: number | null;
    countrySpecificDeduction!: number | null;
    countrySpecificDeductions!: CountrySpecificDeduction[] | null;
    reportableIncomeAfterDeduction!: number;
    grossups!: Grossup[];
    reportableIncomeAfterGrossup!: number;

    constructor(data?: ICountryTotalReportableIncome) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.hypotheticalTaxDeductions = [];
        this.grossups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.reportableIncomeAfterAllocation =
          _data['reportableIncomeAfterAllocation'] !== undefined
            ? _data['reportableIncomeAfterAllocation']
            : <any>null;
        if (Array.isArray(_data['hypotheticalTaxDeductions'])) {
          this.hypotheticalTaxDeductions = [] as any;
          for (let item of _data['hypotheticalTaxDeductions'])
            this.hypotheticalTaxDeductions!.push(
              HypotheticalTaxDeduction2.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductions = <any>null;
        }
        this.totalHypotheticalTaxDeduction =
          _data['totalHypotheticalTaxDeduction'] !== undefined
            ? _data['totalHypotheticalTaxDeduction']
            : <any>null;
        this.countrySpecificDeduction =
          _data['countrySpecificDeduction'] !== undefined
            ? _data['countrySpecificDeduction']
            : <any>null;
        if (Array.isArray(_data['countrySpecificDeductions'])) {
          this.countrySpecificDeductions = [] as any;
          for (let item of _data['countrySpecificDeductions'])
            this.countrySpecificDeductions!.push(
              CountrySpecificDeduction.fromJS(item),
            );
        } else {
          this.countrySpecificDeductions = <any>null;
        }
        this.reportableIncomeAfterDeduction =
          _data['reportableIncomeAfterDeduction'] !== undefined
            ? _data['reportableIncomeAfterDeduction']
            : <any>null;
        if (Array.isArray(_data['grossups'])) {
          this.grossups = [] as any;
          for (let item of _data['grossups'])
            this.grossups!.push(Grossup.fromJS(item));
        } else {
          this.grossups = <any>null;
        }
        this.reportableIncomeAfterGrossup =
          _data['reportableIncomeAfterGrossup'] !== undefined
            ? _data['reportableIncomeAfterGrossup']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryTotalReportableIncome {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotalReportableIncome();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['reportableIncomeAfterAllocation'] =
        this.reportableIncomeAfterAllocation !== undefined
          ? this.reportableIncomeAfterAllocation
          : <any>null;
      if (Array.isArray(this.hypotheticalTaxDeductions)) {
        data['hypotheticalTaxDeductions'] = [];
        for (let item of this.hypotheticalTaxDeductions)
          data['hypotheticalTaxDeductions'].push(item.toJSON());
      }
      data['totalHypotheticalTaxDeduction'] =
        this.totalHypotheticalTaxDeduction !== undefined
          ? this.totalHypotheticalTaxDeduction
          : <any>null;
      data['countrySpecificDeduction'] =
        this.countrySpecificDeduction !== undefined
          ? this.countrySpecificDeduction
          : <any>null;
      if (Array.isArray(this.countrySpecificDeductions)) {
        data['countrySpecificDeductions'] = [];
        for (let item of this.countrySpecificDeductions)
          data['countrySpecificDeductions'].push(item.toJSON());
      }
      data['reportableIncomeAfterDeduction'] =
        this.reportableIncomeAfterDeduction !== undefined
          ? this.reportableIncomeAfterDeduction
          : <any>null;
      if (Array.isArray(this.grossups)) {
        data['grossups'] = [];
        for (let item of this.grossups) data['grossups'].push(item.toJSON());
      }
      data['reportableIncomeAfterGrossup'] =
        this.reportableIncomeAfterGrossup !== undefined
          ? this.reportableIncomeAfterGrossup
          : <any>null;
      return data;
    }
  }

  export interface ICountryTotalReportableIncome {
    gainUsed: TransactionGainUsed[];
    transactionGain: number | null;
    allocationPercentage: number;
    reportableIncomeAfterAllocation: number;
    hypotheticalTaxDeductions: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction: number | null;
    countrySpecificDeduction: number | null;
    countrySpecificDeductions: CountrySpecificDeduction[] | null;
    reportableIncomeAfterDeduction: number;
    grossups: Grossup[];
    reportableIncomeAfterGrossup: number;
  }

  export class TransactionGainUsed implements ITransactionGainUsed {
    pointOfTaxation!: PointOfTaxation;
    valuation!: Valuation;
    fairMarketValue!: number;
    allocationPercentage!: number;
    transactionGain!: number | null;

    constructor(data?: ITransactionGainUsed) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.pointOfTaxation =
          _data['pointOfTaxation'] !== undefined
            ? _data['pointOfTaxation']
            : <any>null;
        this.valuation =
          _data['valuation'] !== undefined ? _data['valuation'] : <any>null;
        this.fairMarketValue =
          _data['fairMarketValue'] !== undefined
            ? _data['fairMarketValue']
            : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionGainUsed {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionGainUsed();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pointOfTaxation'] =
        this.pointOfTaxation !== undefined ? this.pointOfTaxation : <any>null;
      data['valuation'] =
        this.valuation !== undefined ? this.valuation : <any>null;
      data['fairMarketValue'] =
        this.fairMarketValue !== undefined ? this.fairMarketValue : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      return data;
    }
  }

  export interface ITransactionGainUsed {
    pointOfTaxation: PointOfTaxation;
    valuation: Valuation;
    fairMarketValue: number;
    allocationPercentage: number;
    transactionGain: number | null;
  }

  export enum PointOfTaxation {
    None = 'None',
    Distribution = 'Distribution',
    Exercise = 'Exercise',
    PaymentDate = 'PaymentDate',
    Vest = 'Vest',
    PerformancePeriodEnd = 'PerformancePeriodEnd',
  }

  export enum Valuation {
    None = 'None',
    Vest = 'Vest',
    Distribution = 'Distribution',
    Exercise = 'Exercise',
    PaymentDate = 'PaymentDate',
    CountrySpecific = 'CountrySpecific',
  }

  export class HypotheticalTaxDeduction2 implements IHypotheticalTaxDeduction2 {
    value!: number;
    description!: string;

    constructor(data?: IHypotheticalTaxDeduction2) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalTaxDeduction2 {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalTaxDeduction2();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      return data;
    }
  }

  export interface IHypotheticalTaxDeduction2 {
    value: number;
    description: string;
  }

  export class CountrySpecificDeduction implements ICountrySpecificDeduction {
    value!: number;
    description!: string | null;

    constructor(data?: ICountrySpecificDeduction) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
      }
    }

    static fromJS(data: any): CountrySpecificDeduction {
      data = typeof data === 'object' ? data : {};
      let result = new CountrySpecificDeduction();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      return data;
    }
  }

  export interface ICountrySpecificDeduction {
    value: number;
    description: string | null;
  }

  export class Grossup implements IGrossup {
    totalGrossup!: number;
    inCountryGrossup!: number | null;
    otherCountryGrossup!: number | null;

    constructor(data?: IGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.totalGrossup =
          _data['totalGrossup'] !== undefined
            ? _data['totalGrossup']
            : <any>null;
        this.inCountryGrossup =
          _data['inCountryGrossup'] !== undefined
            ? _data['inCountryGrossup']
            : <any>null;
        this.otherCountryGrossup =
          _data['otherCountryGrossup'] !== undefined
            ? _data['otherCountryGrossup']
            : <any>null;
      }
    }

    static fromJS(data: any): Grossup {
      data = typeof data === 'object' ? data : {};
      let result = new Grossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['totalGrossup'] =
        this.totalGrossup !== undefined ? this.totalGrossup : <any>null;
      data['inCountryGrossup'] =
        this.inCountryGrossup !== undefined ? this.inCountryGrossup : <any>null;
      data['otherCountryGrossup'] =
        this.otherCountryGrossup !== undefined
          ? this.otherCountryGrossup
          : <any>null;
      return data;
    }
  }

  export interface IGrossup {
    totalGrossup: number;
    inCountryGrossup: number | null;
    otherCountryGrossup: number | null;
  }

  export class CountryTotalIncomeSubjectToWithholding
    implements ICountryTotalIncomeSubjectToWithholding
  {
    customTax!: boolean;
    taxType!: TaxType;
    gainUsed!: TransactionGainUsed[];
    transactionGain!: number | null;
    allocationPercentage!: number;
    incomeSubjectToWithholdingAfterAllocation!: number;
    hypotheticalTaxDeductions!: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction!: number | null;
    countrySpecificDeduction!: number | null;
    countrySpecificDeductions!: CountrySpecificDeduction[] | null;
    incomeSubjectToWithholdingAfterDeduction!: number;
    grossups!: Grossup[];
    incomeSubjectToWithholdingAfterGrossup!: number;
    taxWithholding!: CountryTotalIncomeTaxWithholdingSummary;

    constructor(data?: ICountryTotalIncomeSubjectToWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.hypotheticalTaxDeductions = [];
        this.grossups = [];
        this.taxWithholding = new CountryTotalIncomeTaxWithholdingSummary();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTax =
          _data['customTax'] !== undefined ? _data['customTax'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.incomeSubjectToWithholdingAfterAllocation =
          _data['incomeSubjectToWithholdingAfterAllocation'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterAllocation']
            : <any>null;
        if (Array.isArray(_data['hypotheticalTaxDeductions'])) {
          this.hypotheticalTaxDeductions = [] as any;
          for (let item of _data['hypotheticalTaxDeductions'])
            this.hypotheticalTaxDeductions!.push(
              HypotheticalTaxDeduction2.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductions = <any>null;
        }
        this.totalHypotheticalTaxDeduction =
          _data['totalHypotheticalTaxDeduction'] !== undefined
            ? _data['totalHypotheticalTaxDeduction']
            : <any>null;
        this.countrySpecificDeduction =
          _data['countrySpecificDeduction'] !== undefined
            ? _data['countrySpecificDeduction']
            : <any>null;
        if (Array.isArray(_data['countrySpecificDeductions'])) {
          this.countrySpecificDeductions = [] as any;
          for (let item of _data['countrySpecificDeductions'])
            this.countrySpecificDeductions!.push(
              CountrySpecificDeduction.fromJS(item),
            );
        } else {
          this.countrySpecificDeductions = <any>null;
        }
        this.incomeSubjectToWithholdingAfterDeduction =
          _data['incomeSubjectToWithholdingAfterDeduction'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterDeduction']
            : <any>null;
        if (Array.isArray(_data['grossups'])) {
          this.grossups = [] as any;
          for (let item of _data['grossups'])
            this.grossups!.push(Grossup.fromJS(item));
        } else {
          this.grossups = <any>null;
        }
        this.incomeSubjectToWithholdingAfterGrossup =
          _data['incomeSubjectToWithholdingAfterGrossup'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterGrossup']
            : <any>null;
        this.taxWithholding = _data['taxWithholding']
          ? CountryTotalIncomeTaxWithholdingSummary.fromJS(
              _data['taxWithholding'],
            )
          : new CountryTotalIncomeTaxWithholdingSummary();
      }
    }

    static fromJS(data: any): CountryTotalIncomeSubjectToWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotalIncomeSubjectToWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTax'] =
        this.customTax !== undefined ? this.customTax : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['incomeSubjectToWithholdingAfterAllocation'] =
        this.incomeSubjectToWithholdingAfterAllocation !== undefined
          ? this.incomeSubjectToWithholdingAfterAllocation
          : <any>null;
      if (Array.isArray(this.hypotheticalTaxDeductions)) {
        data['hypotheticalTaxDeductions'] = [];
        for (let item of this.hypotheticalTaxDeductions)
          data['hypotheticalTaxDeductions'].push(item.toJSON());
      }
      data['totalHypotheticalTaxDeduction'] =
        this.totalHypotheticalTaxDeduction !== undefined
          ? this.totalHypotheticalTaxDeduction
          : <any>null;
      data['countrySpecificDeduction'] =
        this.countrySpecificDeduction !== undefined
          ? this.countrySpecificDeduction
          : <any>null;
      if (Array.isArray(this.countrySpecificDeductions)) {
        data['countrySpecificDeductions'] = [];
        for (let item of this.countrySpecificDeductions)
          data['countrySpecificDeductions'].push(item.toJSON());
      }
      data['incomeSubjectToWithholdingAfterDeduction'] =
        this.incomeSubjectToWithholdingAfterDeduction !== undefined
          ? this.incomeSubjectToWithholdingAfterDeduction
          : <any>null;
      if (Array.isArray(this.grossups)) {
        data['grossups'] = [];
        for (let item of this.grossups) data['grossups'].push(item.toJSON());
      }
      data['incomeSubjectToWithholdingAfterGrossup'] =
        this.incomeSubjectToWithholdingAfterGrossup !== undefined
          ? this.incomeSubjectToWithholdingAfterGrossup
          : <any>null;
      data['taxWithholding'] = this.taxWithholding
        ? this.taxWithholding.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICountryTotalIncomeSubjectToWithholding {
    customTax: boolean;
    taxType: TaxType;
    gainUsed: TransactionGainUsed[];
    transactionGain: number | null;
    allocationPercentage: number;
    incomeSubjectToWithholdingAfterAllocation: number;
    hypotheticalTaxDeductions: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction: number | null;
    countrySpecificDeduction: number | null;
    countrySpecificDeductions: CountrySpecificDeduction[] | null;
    incomeSubjectToWithholdingAfterDeduction: number;
    grossups: Grossup[];
    incomeSubjectToWithholdingAfterGrossup: number;
    taxWithholding: CountryTotalIncomeTaxWithholdingSummary;
  }

  export class CountryTotalIncomeTaxWithholdingSummary
    implements ICountryTotalIncomeTaxWithholdingSummary
  {
    taxWithholdings!: CountryTotalIncomeTaxWithholding[];
    taxDue!: number;
    taxCredits!: TaxCredit[];
    netTaxDue!: number;
    excessWithholding!: number | null;
    excessWithholdingDescription!: string | null;
    netTaxDueAndExcessWithholding!: number | null;

    constructor(data?: ICountryTotalIncomeTaxWithholdingSummary) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxWithholdings = [];
        this.taxCredits = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxWithholdings'])) {
          this.taxWithholdings = [] as any;
          for (let item of _data['taxWithholdings'])
            this.taxWithholdings!.push(
              CountryTotalIncomeTaxWithholding.fromJS(item),
            );
        } else {
          this.taxWithholdings = <any>null;
        }
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
        if (Array.isArray(_data['taxCredits'])) {
          this.taxCredits = [] as any;
          for (let item of _data['taxCredits'])
            this.taxCredits!.push(TaxCredit.fromJS(item));
        } else {
          this.taxCredits = <any>null;
        }
        this.netTaxDue =
          _data['netTaxDue'] !== undefined ? _data['netTaxDue'] : <any>null;
        this.excessWithholding =
          _data['excessWithholding'] !== undefined
            ? _data['excessWithholding']
            : <any>null;
        this.excessWithholdingDescription =
          _data['excessWithholdingDescription'] !== undefined
            ? _data['excessWithholdingDescription']
            : <any>null;
        this.netTaxDueAndExcessWithholding =
          _data['netTaxDueAndExcessWithholding'] !== undefined
            ? _data['netTaxDueAndExcessWithholding']
            : <any>null;
      }
    }

    static fromJS(data: any): CountryTotalIncomeTaxWithholdingSummary {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotalIncomeTaxWithholdingSummary();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxWithholdings)) {
        data['taxWithholdings'] = [];
        for (let item of this.taxWithholdings)
          data['taxWithholdings'].push(item.toJSON());
      }
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      if (Array.isArray(this.taxCredits)) {
        data['taxCredits'] = [];
        for (let item of this.taxCredits)
          data['taxCredits'].push(item.toJSON());
      }
      data['netTaxDue'] =
        this.netTaxDue !== undefined ? this.netTaxDue : <any>null;
      data['excessWithholding'] =
        this.excessWithholding !== undefined
          ? this.excessWithholding
          : <any>null;
      data['excessWithholdingDescription'] =
        this.excessWithholdingDescription !== undefined
          ? this.excessWithholdingDescription
          : <any>null;
      data['netTaxDueAndExcessWithholding'] =
        this.netTaxDueAndExcessWithholding !== undefined
          ? this.netTaxDueAndExcessWithholding
          : <any>null;
      return data;
    }
  }

  export interface ICountryTotalIncomeTaxWithholdingSummary {
    taxWithholdings: CountryTotalIncomeTaxWithholding[];
    taxDue: number;
    taxCredits: TaxCredit[];
    netTaxDue: number;
    excessWithholding: number | null;
    excessWithholdingDescription: string | null;
    netTaxDueAndExcessWithholding: number | null;
  }

  export class CountryTotalIncomeTaxWithholding
    implements ICountryTotalIncomeTaxWithholding
  {
    type!: string;
    description!: string;
    incomeSubjectToWithholding!: number;
    taxRate!: number;
    taxDue!: number;

    constructor(data?: ICountryTotalIncomeTaxWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.incomeSubjectToWithholding =
          _data['incomeSubjectToWithholding'] !== undefined
            ? _data['incomeSubjectToWithholding']
            : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
      }
    }

    static fromJS(data: any): CountryTotalIncomeTaxWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotalIncomeTaxWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['incomeSubjectToWithholding'] =
        this.incomeSubjectToWithholding !== undefined
          ? this.incomeSubjectToWithholding
          : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      return data;
    }
  }

  export interface ICountryTotalIncomeTaxWithholding {
    type: string;
    description: string;
    incomeSubjectToWithholding: number;
    taxRate: number;
    taxDue: number;
  }

  export class TaxCredit implements ITaxCredit {
    value!: number;
    description!: string;

    constructor(data?: ITaxCredit) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
      }
    }

    static fromJS(data: any): TaxCredit {
      data = typeof data === 'object' ? data : {};
      let result = new TaxCredit();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      return data;
    }
  }

  export interface ITaxCredit {
    value: number;
    description: string;
  }

  export class RegionTotals implements IRegionTotals {
    regionCode!: string;
    reportableIncome!: RegionTotalReportableIncome;
    incomeSubjectToWithholding!: RegionTotalIncomeSubjectToWithholding[];
    totalTax!: RegionTotalTax;
    timeSpentAllocationPercentage!: number | null;
    timeSpentAllocationAmount!: number | null;

    constructor(data?: IRegionTotals) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.reportableIncome = new RegionTotalReportableIncome();
        this.incomeSubjectToWithholding = [];
        this.totalTax = new RegionTotalTax();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.reportableIncome = _data['reportableIncome']
          ? RegionTotalReportableIncome.fromJS(_data['reportableIncome'])
          : new RegionTotalReportableIncome();
        if (Array.isArray(_data['incomeSubjectToWithholding'])) {
          this.incomeSubjectToWithholding = [] as any;
          for (let item of _data['incomeSubjectToWithholding'])
            this.incomeSubjectToWithholding!.push(
              RegionTotalIncomeSubjectToWithholding.fromJS(item),
            );
        } else {
          this.incomeSubjectToWithholding = <any>null;
        }
        this.totalTax = _data['totalTax']
          ? RegionTotalTax.fromJS(_data['totalTax'])
          : new RegionTotalTax();
        this.timeSpentAllocationPercentage =
          _data['timeSpentAllocationPercentage'] !== undefined
            ? _data['timeSpentAllocationPercentage']
            : <any>null;
        this.timeSpentAllocationAmount =
          _data['timeSpentAllocationAmount'] !== undefined
            ? _data['timeSpentAllocationAmount']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTotals {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotals();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['reportableIncome'] = this.reportableIncome
        ? this.reportableIncome.toJSON()
        : <any>null;
      if (Array.isArray(this.incomeSubjectToWithholding)) {
        data['incomeSubjectToWithholding'] = [];
        for (let item of this.incomeSubjectToWithholding)
          data['incomeSubjectToWithholding'].push(item.toJSON());
      }
      data['totalTax'] = this.totalTax ? this.totalTax.toJSON() : <any>null;
      data['timeSpentAllocationPercentage'] =
        this.timeSpentAllocationPercentage !== undefined
          ? this.timeSpentAllocationPercentage
          : <any>null;
      data['timeSpentAllocationAmount'] =
        this.timeSpentAllocationAmount !== undefined
          ? this.timeSpentAllocationAmount
          : <any>null;
      return data;
    }
  }

  export interface IRegionTotals {
    regionCode: string;
    reportableIncome: RegionTotalReportableIncome;
    incomeSubjectToWithholding: RegionTotalIncomeSubjectToWithholding[];
    totalTax: RegionTotalTax;
    timeSpentAllocationPercentage: number | null;
    timeSpentAllocationAmount: number | null;
  }

  export class RegionTotalReportableIncome
    implements IRegionTotalReportableIncome
  {
    gainUsed!: TransactionGainUsed[];
    transactionGain!: number | null;
    allocationPercentage!: number;
    reportableIncomeAfterAllocation!: number;
    hypotheticalTaxDeductions!: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction!: number | null;
    countrySpecificDeduction!: number | null;
    countrySpecificDeductions!: CountrySpecificDeduction[] | null;
    reportableIncomeAfterDeduction!: number;
    grossups!: Grossup[];
    reportableIncomeAfterGrossup!: number;

    constructor(data?: IRegionTotalReportableIncome) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.hypotheticalTaxDeductions = [];
        this.grossups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.reportableIncomeAfterAllocation =
          _data['reportableIncomeAfterAllocation'] !== undefined
            ? _data['reportableIncomeAfterAllocation']
            : <any>null;
        if (Array.isArray(_data['hypotheticalTaxDeductions'])) {
          this.hypotheticalTaxDeductions = [] as any;
          for (let item of _data['hypotheticalTaxDeductions'])
            this.hypotheticalTaxDeductions!.push(
              HypotheticalTaxDeduction2.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductions = <any>null;
        }
        this.totalHypotheticalTaxDeduction =
          _data['totalHypotheticalTaxDeduction'] !== undefined
            ? _data['totalHypotheticalTaxDeduction']
            : <any>null;
        this.countrySpecificDeduction =
          _data['countrySpecificDeduction'] !== undefined
            ? _data['countrySpecificDeduction']
            : <any>null;
        if (Array.isArray(_data['countrySpecificDeductions'])) {
          this.countrySpecificDeductions = [] as any;
          for (let item of _data['countrySpecificDeductions'])
            this.countrySpecificDeductions!.push(
              CountrySpecificDeduction.fromJS(item),
            );
        } else {
          this.countrySpecificDeductions = <any>null;
        }
        this.reportableIncomeAfterDeduction =
          _data['reportableIncomeAfterDeduction'] !== undefined
            ? _data['reportableIncomeAfterDeduction']
            : <any>null;
        if (Array.isArray(_data['grossups'])) {
          this.grossups = [] as any;
          for (let item of _data['grossups'])
            this.grossups!.push(Grossup.fromJS(item));
        } else {
          this.grossups = <any>null;
        }
        this.reportableIncomeAfterGrossup =
          _data['reportableIncomeAfterGrossup'] !== undefined
            ? _data['reportableIncomeAfterGrossup']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTotalReportableIncome {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotalReportableIncome();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['reportableIncomeAfterAllocation'] =
        this.reportableIncomeAfterAllocation !== undefined
          ? this.reportableIncomeAfterAllocation
          : <any>null;
      if (Array.isArray(this.hypotheticalTaxDeductions)) {
        data['hypotheticalTaxDeductions'] = [];
        for (let item of this.hypotheticalTaxDeductions)
          data['hypotheticalTaxDeductions'].push(item.toJSON());
      }
      data['totalHypotheticalTaxDeduction'] =
        this.totalHypotheticalTaxDeduction !== undefined
          ? this.totalHypotheticalTaxDeduction
          : <any>null;
      data['countrySpecificDeduction'] =
        this.countrySpecificDeduction !== undefined
          ? this.countrySpecificDeduction
          : <any>null;
      if (Array.isArray(this.countrySpecificDeductions)) {
        data['countrySpecificDeductions'] = [];
        for (let item of this.countrySpecificDeductions)
          data['countrySpecificDeductions'].push(item.toJSON());
      }
      data['reportableIncomeAfterDeduction'] =
        this.reportableIncomeAfterDeduction !== undefined
          ? this.reportableIncomeAfterDeduction
          : <any>null;
      if (Array.isArray(this.grossups)) {
        data['grossups'] = [];
        for (let item of this.grossups) data['grossups'].push(item.toJSON());
      }
      data['reportableIncomeAfterGrossup'] =
        this.reportableIncomeAfterGrossup !== undefined
          ? this.reportableIncomeAfterGrossup
          : <any>null;
      return data;
    }
  }

  export interface IRegionTotalReportableIncome {
    gainUsed: TransactionGainUsed[];
    transactionGain: number | null;
    allocationPercentage: number;
    reportableIncomeAfterAllocation: number;
    hypotheticalTaxDeductions: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction: number | null;
    countrySpecificDeduction: number | null;
    countrySpecificDeductions: CountrySpecificDeduction[] | null;
    reportableIncomeAfterDeduction: number;
    grossups: Grossup[];
    reportableIncomeAfterGrossup: number;
  }

  export class RegionTotalIncomeSubjectToWithholding
    implements IRegionTotalIncomeSubjectToWithholding
  {
    customTax!: boolean;
    taxType!: TaxType;
    gainUsed!: TransactionGainUsed[];
    transactionGain!: number | null;
    allocationPercentage!: number;
    incomeSubjectToWithholdingAfterAllocation!: number;
    hypotheticalTaxDeductions!: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction!: number | null;
    countrySpecificDeduction!: number | null;
    countrySpecificDeductions!: CountrySpecificDeduction[] | null;
    incomeSubjectToWithholdingAfterDeduction!: number;
    grossups!: Grossup[];
    incomeSubjectToWithholdingAfterGrossup!: number;
    taxWithholding!: RegionTotalIncomeTaxWithholdingSummary;

    constructor(data?: IRegionTotalIncomeSubjectToWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.hypotheticalTaxDeductions = [];
        this.grossups = [];
        this.taxWithholding = new RegionTotalIncomeTaxWithholdingSummary();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTax =
          _data['customTax'] !== undefined ? _data['customTax'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.incomeSubjectToWithholdingAfterAllocation =
          _data['incomeSubjectToWithholdingAfterAllocation'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterAllocation']
            : <any>null;
        if (Array.isArray(_data['hypotheticalTaxDeductions'])) {
          this.hypotheticalTaxDeductions = [] as any;
          for (let item of _data['hypotheticalTaxDeductions'])
            this.hypotheticalTaxDeductions!.push(
              HypotheticalTaxDeduction2.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductions = <any>null;
        }
        this.totalHypotheticalTaxDeduction =
          _data['totalHypotheticalTaxDeduction'] !== undefined
            ? _data['totalHypotheticalTaxDeduction']
            : <any>null;
        this.countrySpecificDeduction =
          _data['countrySpecificDeduction'] !== undefined
            ? _data['countrySpecificDeduction']
            : <any>null;
        if (Array.isArray(_data['countrySpecificDeductions'])) {
          this.countrySpecificDeductions = [] as any;
          for (let item of _data['countrySpecificDeductions'])
            this.countrySpecificDeductions!.push(
              CountrySpecificDeduction.fromJS(item),
            );
        } else {
          this.countrySpecificDeductions = <any>null;
        }
        this.incomeSubjectToWithholdingAfterDeduction =
          _data['incomeSubjectToWithholdingAfterDeduction'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterDeduction']
            : <any>null;
        if (Array.isArray(_data['grossups'])) {
          this.grossups = [] as any;
          for (let item of _data['grossups'])
            this.grossups!.push(Grossup.fromJS(item));
        } else {
          this.grossups = <any>null;
        }
        this.incomeSubjectToWithholdingAfterGrossup =
          _data['incomeSubjectToWithholdingAfterGrossup'] !== undefined
            ? _data['incomeSubjectToWithholdingAfterGrossup']
            : <any>null;
        this.taxWithholding = _data['taxWithholding']
          ? RegionTotalIncomeTaxWithholdingSummary.fromJS(
              _data['taxWithholding'],
            )
          : new RegionTotalIncomeTaxWithholdingSummary();
      }
    }

    static fromJS(data: any): RegionTotalIncomeSubjectToWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotalIncomeSubjectToWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTax'] =
        this.customTax !== undefined ? this.customTax : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['incomeSubjectToWithholdingAfterAllocation'] =
        this.incomeSubjectToWithholdingAfterAllocation !== undefined
          ? this.incomeSubjectToWithholdingAfterAllocation
          : <any>null;
      if (Array.isArray(this.hypotheticalTaxDeductions)) {
        data['hypotheticalTaxDeductions'] = [];
        for (let item of this.hypotheticalTaxDeductions)
          data['hypotheticalTaxDeductions'].push(item.toJSON());
      }
      data['totalHypotheticalTaxDeduction'] =
        this.totalHypotheticalTaxDeduction !== undefined
          ? this.totalHypotheticalTaxDeduction
          : <any>null;
      data['countrySpecificDeduction'] =
        this.countrySpecificDeduction !== undefined
          ? this.countrySpecificDeduction
          : <any>null;
      if (Array.isArray(this.countrySpecificDeductions)) {
        data['countrySpecificDeductions'] = [];
        for (let item of this.countrySpecificDeductions)
          data['countrySpecificDeductions'].push(item.toJSON());
      }
      data['incomeSubjectToWithholdingAfterDeduction'] =
        this.incomeSubjectToWithholdingAfterDeduction !== undefined
          ? this.incomeSubjectToWithholdingAfterDeduction
          : <any>null;
      if (Array.isArray(this.grossups)) {
        data['grossups'] = [];
        for (let item of this.grossups) data['grossups'].push(item.toJSON());
      }
      data['incomeSubjectToWithholdingAfterGrossup'] =
        this.incomeSubjectToWithholdingAfterGrossup !== undefined
          ? this.incomeSubjectToWithholdingAfterGrossup
          : <any>null;
      data['taxWithholding'] = this.taxWithholding
        ? this.taxWithholding.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRegionTotalIncomeSubjectToWithholding {
    customTax: boolean;
    taxType: TaxType;
    gainUsed: TransactionGainUsed[];
    transactionGain: number | null;
    allocationPercentage: number;
    incomeSubjectToWithholdingAfterAllocation: number;
    hypotheticalTaxDeductions: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction: number | null;
    countrySpecificDeduction: number | null;
    countrySpecificDeductions: CountrySpecificDeduction[] | null;
    incomeSubjectToWithholdingAfterDeduction: number;
    grossups: Grossup[];
    incomeSubjectToWithholdingAfterGrossup: number;
    taxWithholding: RegionTotalIncomeTaxWithholdingSummary;
  }

  export class RegionTotalIncomeTaxWithholdingSummary
    implements IRegionTotalIncomeTaxWithholdingSummary
  {
    taxWithholdings!: RegionTotalIncomeTaxWithholding[];
    taxDue!: number;
    taxCredits!: TaxCredit[];
    netTaxDue!: number;
    excessWithholding!: number | null;
    excessWithholdingDescription!: string | null;
    netTaxDueAndExcessWithholding!: number | null;

    constructor(data?: IRegionTotalIncomeTaxWithholdingSummary) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxWithholdings = [];
        this.taxCredits = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxWithholdings'])) {
          this.taxWithholdings = [] as any;
          for (let item of _data['taxWithholdings'])
            this.taxWithholdings!.push(
              RegionTotalIncomeTaxWithholding.fromJS(item),
            );
        } else {
          this.taxWithholdings = <any>null;
        }
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
        if (Array.isArray(_data['taxCredits'])) {
          this.taxCredits = [] as any;
          for (let item of _data['taxCredits'])
            this.taxCredits!.push(TaxCredit.fromJS(item));
        } else {
          this.taxCredits = <any>null;
        }
        this.netTaxDue =
          _data['netTaxDue'] !== undefined ? _data['netTaxDue'] : <any>null;
        this.excessWithholding =
          _data['excessWithholding'] !== undefined
            ? _data['excessWithholding']
            : <any>null;
        this.excessWithholdingDescription =
          _data['excessWithholdingDescription'] !== undefined
            ? _data['excessWithholdingDescription']
            : <any>null;
        this.netTaxDueAndExcessWithholding =
          _data['netTaxDueAndExcessWithholding'] !== undefined
            ? _data['netTaxDueAndExcessWithholding']
            : <any>null;
      }
    }

    static fromJS(data: any): RegionTotalIncomeTaxWithholdingSummary {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotalIncomeTaxWithholdingSummary();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxWithholdings)) {
        data['taxWithholdings'] = [];
        for (let item of this.taxWithholdings)
          data['taxWithholdings'].push(item.toJSON());
      }
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      if (Array.isArray(this.taxCredits)) {
        data['taxCredits'] = [];
        for (let item of this.taxCredits)
          data['taxCredits'].push(item.toJSON());
      }
      data['netTaxDue'] =
        this.netTaxDue !== undefined ? this.netTaxDue : <any>null;
      data['excessWithholding'] =
        this.excessWithholding !== undefined
          ? this.excessWithholding
          : <any>null;
      data['excessWithholdingDescription'] =
        this.excessWithholdingDescription !== undefined
          ? this.excessWithholdingDescription
          : <any>null;
      data['netTaxDueAndExcessWithholding'] =
        this.netTaxDueAndExcessWithholding !== undefined
          ? this.netTaxDueAndExcessWithholding
          : <any>null;
      return data;
    }
  }

  export interface IRegionTotalIncomeTaxWithholdingSummary {
    taxWithholdings: RegionTotalIncomeTaxWithholding[];
    taxDue: number;
    taxCredits: TaxCredit[];
    netTaxDue: number;
    excessWithholding: number | null;
    excessWithholdingDescription: string | null;
    netTaxDueAndExcessWithholding: number | null;
  }

  export class RegionTotalIncomeTaxWithholding
    implements IRegionTotalIncomeTaxWithholding
  {
    type!: string;
    description!: string;
    taxRateTypeUsed!: TaxRateTypeUsed;
    taxRate!: number;
    taxDue!: number;

    constructor(data?: IRegionTotalIncomeTaxWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.taxRateTypeUsed =
          _data['taxRateTypeUsed'] !== undefined
            ? _data['taxRateTypeUsed']
            : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
      }
    }

    static fromJS(data: any): RegionTotalIncomeTaxWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotalIncomeTaxWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['taxRateTypeUsed'] =
        this.taxRateTypeUsed !== undefined ? this.taxRateTypeUsed : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      return data;
    }
  }

  export interface IRegionTotalIncomeTaxWithholding {
    type: string;
    description: string;
    taxRateTypeUsed: TaxRateTypeUsed;
    taxRate: number;
    taxDue: number;
  }

  export enum TaxRateTypeUsed {
    Banded = 'Banded',
    NotBanded = 'NotBanded',
    CapsMet = 'CapsMet',
    CapsNotMet = 'CapsNotMet',
  }

  export class RegionTotalTax implements IRegionTotalTax {
    whoPays!: WhoPaysTotalTax;
    allTaxes!: TotalTaxes | null;
    incomeTaxes!: TotalTaxes | null;
    socialTaxes!: TotalTaxes | null;

    constructor(data?: IRegionTotalTax) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.whoPays =
          _data['whoPays'] !== undefined ? _data['whoPays'] : <any>null;
        this.allTaxes = _data['allTaxes']
          ? TotalTaxes.fromJS(_data['allTaxes'])
          : <any>null;
        this.incomeTaxes = _data['incomeTaxes']
          ? TotalTaxes.fromJS(_data['incomeTaxes'])
          : <any>null;
        this.socialTaxes = _data['socialTaxes']
          ? TotalTaxes.fromJS(_data['socialTaxes'])
          : <any>null;
      }
    }

    static fromJS(data: any): RegionTotalTax {
      data = typeof data === 'object' ? data : {};
      let result = new RegionTotalTax();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['whoPays'] = this.whoPays !== undefined ? this.whoPays : <any>null;
      data['allTaxes'] = this.allTaxes ? this.allTaxes.toJSON() : <any>null;
      data['incomeTaxes'] = this.incomeTaxes
        ? this.incomeTaxes.toJSON()
        : <any>null;
      data['socialTaxes'] = this.socialTaxes
        ? this.socialTaxes.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRegionTotalTax {
    whoPays: WhoPaysTotalTax;
    allTaxes: TotalTaxes | null;
    incomeTaxes: TotalTaxes | null;
    socialTaxes: TotalTaxes | null;
  }

  export enum WhoPaysTotalTax {
    Employee = 'Employee',
    Employer = 'Employer',
    Combined = 'Combined',
  }

  export class TotalTaxes implements ITotalTaxes {
    taxDue!: number;
    taxDueEffectiveTaxRate!: number;
    taxCredit!: number;
    netTaxDue!: number;
    netTaxDueEffectiveTaxRate!: number;

    constructor(data?: ITotalTaxes) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
        this.taxDueEffectiveTaxRate =
          _data['taxDueEffectiveTaxRate'] !== undefined
            ? _data['taxDueEffectiveTaxRate']
            : <any>null;
        this.taxCredit =
          _data['taxCredit'] !== undefined ? _data['taxCredit'] : <any>null;
        this.netTaxDue =
          _data['netTaxDue'] !== undefined ? _data['netTaxDue'] : <any>null;
        this.netTaxDueEffectiveTaxRate =
          _data['netTaxDueEffectiveTaxRate'] !== undefined
            ? _data['netTaxDueEffectiveTaxRate']
            : <any>null;
      }
    }

    static fromJS(data: any): TotalTaxes {
      data = typeof data === 'object' ? data : {};
      let result = new TotalTaxes();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      data['taxDueEffectiveTaxRate'] =
        this.taxDueEffectiveTaxRate !== undefined
          ? this.taxDueEffectiveTaxRate
          : <any>null;
      data['taxCredit'] =
        this.taxCredit !== undefined ? this.taxCredit : <any>null;
      data['netTaxDue'] =
        this.netTaxDue !== undefined ? this.netTaxDue : <any>null;
      data['netTaxDueEffectiveTaxRate'] =
        this.netTaxDueEffectiveTaxRate !== undefined
          ? this.netTaxDueEffectiveTaxRate
          : <any>null;
      return data;
    }
  }

  export interface ITotalTaxes {
    taxDue: number;
    taxDueEffectiveTaxRate: number;
    taxCredit: number;
    netTaxDue: number;
    netTaxDueEffectiveTaxRate: number;
  }

  export class CountryTotalTax implements ICountryTotalTax {
    whoPays!: WhoPaysTotalTax;
    allTaxes!: TotalTaxes | null;
    incomeTaxes!: TotalTaxes | null;
    regionTaxes!: TotalTaxes | null;
    socialTaxes!: TotalTaxes | null;

    constructor(data?: ICountryTotalTax) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.whoPays =
          _data['whoPays'] !== undefined ? _data['whoPays'] : <any>null;
        this.allTaxes = _data['allTaxes']
          ? TotalTaxes.fromJS(_data['allTaxes'])
          : <any>null;
        this.incomeTaxes = _data['incomeTaxes']
          ? TotalTaxes.fromJS(_data['incomeTaxes'])
          : <any>null;
        this.regionTaxes = _data['regionTaxes']
          ? TotalTaxes.fromJS(_data['regionTaxes'])
          : <any>null;
        this.socialTaxes = _data['socialTaxes']
          ? TotalTaxes.fromJS(_data['socialTaxes'])
          : <any>null;
      }
    }

    static fromJS(data: any): CountryTotalTax {
      data = typeof data === 'object' ? data : {};
      let result = new CountryTotalTax();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['whoPays'] = this.whoPays !== undefined ? this.whoPays : <any>null;
      data['allTaxes'] = this.allTaxes ? this.allTaxes.toJSON() : <any>null;
      data['incomeTaxes'] = this.incomeTaxes
        ? this.incomeTaxes.toJSON()
        : <any>null;
      data['regionTaxes'] = this.regionTaxes
        ? this.regionTaxes.toJSON()
        : <any>null;
      data['socialTaxes'] = this.socialTaxes
        ? this.socialTaxes.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICountryTotalTax {
    whoPays: WhoPaysTotalTax;
    allTaxes: TotalTaxes | null;
    incomeTaxes: TotalTaxes | null;
    regionTaxes: TotalTaxes | null;
    socialTaxes: TotalTaxes | null;
  }

  export class ExchangeRate implements IExchangeRate {
    exchangeRateTypeUsed!: ExchangeRateTypeUsed;
    currencyPair!: string;
    rate!: number;

    constructor(data?: IExchangeRate) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.exchangeRateTypeUsed =
          _data['exchangeRateTypeUsed'] !== undefined
            ? _data['exchangeRateTypeUsed']
            : <any>null;
        this.currencyPair =
          _data['currencyPair'] !== undefined
            ? _data['currencyPair']
            : <any>null;
        this.rate = _data['rate'] !== undefined ? _data['rate'] : <any>null;
      }
    }

    static fromJS(data: any): ExchangeRate {
      data = typeof data === 'object' ? data : {};
      let result = new ExchangeRate();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['exchangeRateTypeUsed'] =
        this.exchangeRateTypeUsed !== undefined
          ? this.exchangeRateTypeUsed
          : <any>null;
      data['currencyPair'] =
        this.currencyPair !== undefined ? this.currencyPair : <any>null;
      data['rate'] = this.rate !== undefined ? this.rate : <any>null;
      return data;
    }
  }

  export interface IExchangeRate {
    exchangeRateTypeUsed: ExchangeRateTypeUsed;
    currencyPair: string;
    rate: number;
  }

  export enum ExchangeRateTypeUsed {
    Oanda = 'Oanda',
    ClientProvided = 'ClientProvided',
  }

  export class LocationPeriodResult implements ILocationPeriodResult {
    startDate!: Date;
    endDate!: Date;
    periodAllocationPercentageGVPSPE!: number;
    periodAllocationAmountGVPSPE!: number;
    periodAllocationPercentageGDGEPSPD!: number;
    periodAllocationAmountGDGEPSPD!: number;
    assignedWorkCountry!: AssignedWorkCountryResult | null;
    transactionGain!: number;
    countryWorkings!: CountryWorking[];
    countryResults!: CountryResult[];
    hypotheticalResults!: HypotheticalResult[];

    constructor(data?: ILocationPeriodResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryWorkings = [];
        this.countryResults = [];
        this.hypotheticalResults = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.periodAllocationPercentageGVPSPE =
          _data['periodAllocationPercentageGVPSPE'] !== undefined
            ? _data['periodAllocationPercentageGVPSPE']
            : <any>null;
        this.periodAllocationAmountGVPSPE =
          _data['periodAllocationAmountGVPSPE'] !== undefined
            ? _data['periodAllocationAmountGVPSPE']
            : <any>null;
        this.periodAllocationPercentageGDGEPSPD =
          _data['periodAllocationPercentageGDGEPSPD'] !== undefined
            ? _data['periodAllocationPercentageGDGEPSPD']
            : <any>null;
        this.periodAllocationAmountGDGEPSPD =
          _data['periodAllocationAmountGDGEPSPD'] !== undefined
            ? _data['periodAllocationAmountGDGEPSPD']
            : <any>null;
        this.assignedWorkCountry = _data['assignedWorkCountry']
          ? AssignedWorkCountryResult.fromJS(_data['assignedWorkCountry'])
          : <any>null;
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        if (Array.isArray(_data['countryWorkings'])) {
          this.countryWorkings = [] as any;
          for (let item of _data['countryWorkings'])
            this.countryWorkings!.push(CountryWorking.fromJS(item));
        } else {
          this.countryWorkings = <any>null;
        }
        if (Array.isArray(_data['countryResults'])) {
          this.countryResults = [] as any;
          for (let item of _data['countryResults'])
            this.countryResults!.push(CountryResult.fromJS(item));
        } else {
          this.countryResults = <any>null;
        }
        if (Array.isArray(_data['hypotheticalResults'])) {
          this.hypotheticalResults = [] as any;
          for (let item of _data['hypotheticalResults'])
            this.hypotheticalResults!.push(HypotheticalResult.fromJS(item));
        } else {
          this.hypotheticalResults = <any>null;
        }
      }
    }

    static fromJS(data: any): LocationPeriodResult {
      data = typeof data === 'object' ? data : {};
      let result = new LocationPeriodResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['periodAllocationPercentageGVPSPE'] =
        this.periodAllocationPercentageGVPSPE !== undefined
          ? this.periodAllocationPercentageGVPSPE
          : <any>null;
      data['periodAllocationAmountGVPSPE'] =
        this.periodAllocationAmountGVPSPE !== undefined
          ? this.periodAllocationAmountGVPSPE
          : <any>null;
      data['periodAllocationPercentageGDGEPSPD'] =
        this.periodAllocationPercentageGDGEPSPD !== undefined
          ? this.periodAllocationPercentageGDGEPSPD
          : <any>null;
      data['periodAllocationAmountGDGEPSPD'] =
        this.periodAllocationAmountGDGEPSPD !== undefined
          ? this.periodAllocationAmountGDGEPSPD
          : <any>null;
      data['assignedWorkCountry'] = this.assignedWorkCountry
        ? this.assignedWorkCountry.toJSON()
        : <any>null;
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      if (Array.isArray(this.countryWorkings)) {
        data['countryWorkings'] = [];
        for (let item of this.countryWorkings)
          data['countryWorkings'].push(item.toJSON());
      }
      if (Array.isArray(this.countryResults)) {
        data['countryResults'] = [];
        for (let item of this.countryResults)
          data['countryResults'].push(item.toJSON());
      }
      if (Array.isArray(this.hypotheticalResults)) {
        data['hypotheticalResults'] = [];
        for (let item of this.hypotheticalResults)
          data['hypotheticalResults'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILocationPeriodResult {
    startDate: Date;
    endDate: Date;
    periodAllocationPercentageGVPSPE: number;
    periodAllocationAmountGVPSPE: number;
    periodAllocationPercentageGDGEPSPD: number;
    periodAllocationAmountGDGEPSPD: number;
    assignedWorkCountry: AssignedWorkCountryResult | null;
    transactionGain: number;
    countryWorkings: CountryWorking[];
    countryResults: CountryResult[];
    hypotheticalResults: HypotheticalResult[];
  }

  export class AssignedWorkCountryResult implements IAssignedWorkCountryResult {
    code!: string;
    timeSpentAllocationPercentage!: number;
    timeSpentAllocationAmount!: number | null;
    region!: AssignedWorkRegionResult | null;

    constructor(data?: IAssignedWorkCountryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.timeSpentAllocationPercentage =
          _data['timeSpentAllocationPercentage'] !== undefined
            ? _data['timeSpentAllocationPercentage']
            : <any>null;
        this.timeSpentAllocationAmount =
          _data['timeSpentAllocationAmount'] !== undefined
            ? _data['timeSpentAllocationAmount']
            : <any>null;
        this.region = _data['region']
          ? AssignedWorkRegionResult.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): AssignedWorkCountryResult {
      data = typeof data === 'object' ? data : {};
      let result = new AssignedWorkCountryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['timeSpentAllocationPercentage'] =
        this.timeSpentAllocationPercentage !== undefined
          ? this.timeSpentAllocationPercentage
          : <any>null;
      data['timeSpentAllocationAmount'] =
        this.timeSpentAllocationAmount !== undefined
          ? this.timeSpentAllocationAmount
          : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IAssignedWorkCountryResult {
    code: string;
    timeSpentAllocationPercentage: number;
    timeSpentAllocationAmount: number | null;
    region: AssignedWorkRegionResult | null;
  }

  export class AssignedWorkRegionResult implements IAssignedWorkRegionResult {
    code!: string;

    constructor(data?: IAssignedWorkRegionResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): AssignedWorkRegionResult {
      data = typeof data === 'object' ? data : {};
      let result = new AssignedWorkRegionResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IAssignedWorkRegionResult {
    code: string;
  }

  export class CountryResult implements ICountryResult {
    teqResultType!: TEQResultType;
    countryCode!: string;
    currencyCode!: string;
    countryComment!: string | null;
    /** Client payroll identifier */
    payrollName!: string | null;
    employmentEntity!: string | null;
    payroll!: Payroll;
    incomeSubjectToWithholding!: IncomeSubjectToWithholding[];
    regionResults!: RegionResult[];

    constructor(data?: ICountryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.payroll = new Payroll();
        this.incomeSubjectToWithholding = [];
        this.regionResults = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.teqResultType =
          _data['teqResultType'] !== undefined
            ? _data['teqResultType']
            : <any>null;
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.countryComment =
          _data['countryComment'] !== undefined
            ? _data['countryComment']
            : <any>null;
        this.payrollName =
          _data['payrollName'] !== undefined ? _data['payrollName'] : <any>null;
        this.employmentEntity =
          _data['employmentEntity'] !== undefined
            ? _data['employmentEntity']
            : <any>null;
        this.payroll = _data['payroll']
          ? Payroll.fromJS(_data['payroll'])
          : new Payroll();
        if (Array.isArray(_data['incomeSubjectToWithholding'])) {
          this.incomeSubjectToWithholding = [] as any;
          for (let item of _data['incomeSubjectToWithholding'])
            this.incomeSubjectToWithholding!.push(
              IncomeSubjectToWithholding.fromJS(item),
            );
        } else {
          this.incomeSubjectToWithholding = <any>null;
        }
        if (Array.isArray(_data['regionResults'])) {
          this.regionResults = [] as any;
          for (let item of _data['regionResults'])
            this.regionResults!.push(RegionResult.fromJS(item));
        } else {
          this.regionResults = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryResult {
      data = typeof data === 'object' ? data : {};
      let result = new CountryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['teqResultType'] =
        this.teqResultType !== undefined ? this.teqResultType : <any>null;
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['countryComment'] =
        this.countryComment !== undefined ? this.countryComment : <any>null;
      data['payrollName'] =
        this.payrollName !== undefined ? this.payrollName : <any>null;
      data['employmentEntity'] =
        this.employmentEntity !== undefined ? this.employmentEntity : <any>null;
      data['payroll'] = this.payroll ? this.payroll.toJSON() : <any>null;
      if (Array.isArray(this.incomeSubjectToWithholding)) {
        data['incomeSubjectToWithholding'] = [];
        for (let item of this.incomeSubjectToWithholding)
          data['incomeSubjectToWithholding'].push(item.toJSON());
      }
      if (Array.isArray(this.regionResults)) {
        data['regionResults'] = [];
        for (let item of this.regionResults)
          data['regionResults'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryResult {
    teqResultType: TEQResultType;
    countryCode: string;
    currencyCode: string;
    countryComment: string | null;
    /** Client payroll identifier */
    payrollName: string | null;
    employmentEntity: string | null;
    payroll: Payroll;
    incomeSubjectToWithholding: IncomeSubjectToWithholding[];
    regionResults: RegionResult[];
  }

  export enum TEQResultType {
    NonTEQResults = 'NonTEQResults',
    TEQResults = 'TEQResults',
  }

  export class Payroll implements IPayroll {
    reportableIncome!: Income | null;

    constructor(data?: IPayroll) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.reportableIncome = _data['reportableIncome']
          ? Income.fromJS(_data['reportableIncome'])
          : <any>null;
      }
    }

    static fromJS(data: any): Payroll {
      data = typeof data === 'object' ? data : {};
      let result = new Payroll();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['reportableIncome'] = this.reportableIncome
        ? this.reportableIncome.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IPayroll {
    reportableIncome: Income | null;
  }

  export class Income implements IIncome {
    gainUsed!: TransactionGainUsed[];
    afterAllocation!: IncomeAfterAllocation;
    afterDeductions!: AfterDeductions;
    afterGrossup!: AfterGrossup;

    constructor(data?: IIncome) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.afterAllocation = new IncomeAfterAllocation();
        this.afterDeductions = new AfterDeductions();
        this.afterGrossup = new AfterGrossup();
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.afterAllocation = _data['afterAllocation']
          ? IncomeAfterAllocation.fromJS(_data['afterAllocation'])
          : new IncomeAfterAllocation();
        this.afterDeductions = _data['afterDeductions']
          ? AfterDeductions.fromJS(_data['afterDeductions'])
          : new AfterDeductions();
        this.afterGrossup = _data['afterGrossup']
          ? AfterGrossup.fromJS(_data['afterGrossup'])
          : new AfterGrossup();
      }
    }

    static fromJS(data: any): Income {
      data = typeof data === 'object' ? data : {};
      let result = new Income();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['afterAllocation'] = this.afterAllocation
        ? this.afterAllocation.toJSON()
        : <any>null;
      data['afterDeductions'] = this.afterDeductions
        ? this.afterDeductions.toJSON()
        : <any>null;
      data['afterGrossup'] = this.afterGrossup
        ? this.afterGrossup.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IIncome {
    gainUsed: TransactionGainUsed[];
    afterAllocation: IncomeAfterAllocation;
    afterDeductions: AfterDeductions;
    afterGrossup: AfterGrossup;
  }

  export class IncomeAfterAllocation implements IIncomeAfterAllocation {
    value!: number;
    hypotheticalTaxDeductions!: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction!: number | null;
    countrySpecificDeductions!: CountrySpecificDeduction[];

    constructor(data?: IIncomeAfterAllocation) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.hypotheticalTaxDeductions = [];
        this.countrySpecificDeductions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        if (Array.isArray(_data['hypotheticalTaxDeductions'])) {
          this.hypotheticalTaxDeductions = [] as any;
          for (let item of _data['hypotheticalTaxDeductions'])
            this.hypotheticalTaxDeductions!.push(
              HypotheticalTaxDeduction2.fromJS(item),
            );
        } else {
          this.hypotheticalTaxDeductions = <any>null;
        }
        this.totalHypotheticalTaxDeduction =
          _data['totalHypotheticalTaxDeduction'] !== undefined
            ? _data['totalHypotheticalTaxDeduction']
            : <any>null;
        if (Array.isArray(_data['countrySpecificDeductions'])) {
          this.countrySpecificDeductions = [] as any;
          for (let item of _data['countrySpecificDeductions'])
            this.countrySpecificDeductions!.push(
              CountrySpecificDeduction.fromJS(item),
            );
        } else {
          this.countrySpecificDeductions = <any>null;
        }
      }
    }

    static fromJS(data: any): IncomeAfterAllocation {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeAfterAllocation();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      if (Array.isArray(this.hypotheticalTaxDeductions)) {
        data['hypotheticalTaxDeductions'] = [];
        for (let item of this.hypotheticalTaxDeductions)
          data['hypotheticalTaxDeductions'].push(item.toJSON());
      }
      data['totalHypotheticalTaxDeduction'] =
        this.totalHypotheticalTaxDeduction !== undefined
          ? this.totalHypotheticalTaxDeduction
          : <any>null;
      if (Array.isArray(this.countrySpecificDeductions)) {
        data['countrySpecificDeductions'] = [];
        for (let item of this.countrySpecificDeductions)
          data['countrySpecificDeductions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IIncomeAfterAllocation {
    value: number;
    hypotheticalTaxDeductions: HypotheticalTaxDeduction2[];
    totalHypotheticalTaxDeduction: number | null;
    countrySpecificDeductions: CountrySpecificDeduction[];
  }

  export class AfterDeductions implements IAfterDeductions {
    value!: number;
    countryGrossups!: CountryGrossups[];
    totalGrossup!: number | null;
    grossupPercentage!: number | null;

    constructor(data?: IAfterDeductions) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryGrossups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        if (Array.isArray(_data['countryGrossups'])) {
          this.countryGrossups = [] as any;
          for (let item of _data['countryGrossups'])
            this.countryGrossups!.push(CountryGrossups.fromJS(item));
        } else {
          this.countryGrossups = <any>null;
        }
        this.totalGrossup =
          _data['totalGrossup'] !== undefined
            ? _data['totalGrossup']
            : <any>null;
        this.grossupPercentage =
          _data['grossupPercentage'] !== undefined
            ? _data['grossupPercentage']
            : <any>null;
      }
    }

    static fromJS(data: any): AfterDeductions {
      data = typeof data === 'object' ? data : {};
      let result = new AfterDeductions();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      if (Array.isArray(this.countryGrossups)) {
        data['countryGrossups'] = [];
        for (let item of this.countryGrossups)
          data['countryGrossups'].push(item.toJSON());
      }
      data['totalGrossup'] =
        this.totalGrossup !== undefined ? this.totalGrossup : <any>null;
      data['grossupPercentage'] =
        this.grossupPercentage !== undefined
          ? this.grossupPercentage
          : <any>null;
      return data;
    }
  }

  export interface IAfterDeductions {
    value: number;
    countryGrossups: CountryGrossups[];
    totalGrossup: number | null;
    grossupPercentage: number | null;
  }

  export class CountryGrossups implements ICountryGrossups {
    countryCode!: string;
    regionCode!: string | null;
    value!: number;
    taxType!: TaxType;

    constructor(data?: ICountryGrossups) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
      }
    }

    static fromJS(data: any): CountryGrossups {
      data = typeof data === 'object' ? data : {};
      let result = new CountryGrossups();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      return data;
    }
  }

  export interface ICountryGrossups {
    countryCode: string;
    regionCode: string | null;
    value: number;
    taxType: TaxType;
  }

  export class AfterGrossup implements IAfterGrossup {
    value!: number;

    constructor(data?: IAfterGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
      }
    }

    static fromJS(data: any): AfterGrossup {
      data = typeof data === 'object' ? data : {};
      let result = new AfterGrossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['value'] = this.value !== undefined ? this.value : <any>null;
      return data;
    }
  }

  export interface IAfterGrossup {
    value: number;
  }

  export class IncomeSubjectToWithholding
    implements IIncomeSubjectToWithholding
  {
    customTax!: boolean;
    taxType!: TaxType;
    gainUsed!: TransactionGainUsed[];
    afterAllocation!: IncomeAfterAllocation;
    afterDeductions!: AfterDeductions;
    afterGrossup!: AfterGrossup;
    taxWithholding!: TaxWithholdingSummary;

    constructor(data?: IIncomeSubjectToWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.gainUsed = [];
        this.afterAllocation = new IncomeAfterAllocation();
        this.afterDeductions = new AfterDeductions();
        this.afterGrossup = new AfterGrossup();
        this.taxWithholding = new TaxWithholdingSummary();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTax =
          _data['customTax'] !== undefined ? _data['customTax'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        if (Array.isArray(_data['gainUsed'])) {
          this.gainUsed = [] as any;
          for (let item of _data['gainUsed'])
            this.gainUsed!.push(TransactionGainUsed.fromJS(item));
        } else {
          this.gainUsed = <any>null;
        }
        this.afterAllocation = _data['afterAllocation']
          ? IncomeAfterAllocation.fromJS(_data['afterAllocation'])
          : new IncomeAfterAllocation();
        this.afterDeductions = _data['afterDeductions']
          ? AfterDeductions.fromJS(_data['afterDeductions'])
          : new AfterDeductions();
        this.afterGrossup = _data['afterGrossup']
          ? AfterGrossup.fromJS(_data['afterGrossup'])
          : new AfterGrossup();
        this.taxWithholding = _data['taxWithholding']
          ? TaxWithholdingSummary.fromJS(_data['taxWithholding'])
          : new TaxWithholdingSummary();
      }
    }

    static fromJS(data: any): IncomeSubjectToWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeSubjectToWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTax'] =
        this.customTax !== undefined ? this.customTax : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      if (Array.isArray(this.gainUsed)) {
        data['gainUsed'] = [];
        for (let item of this.gainUsed) data['gainUsed'].push(item.toJSON());
      }
      data['afterAllocation'] = this.afterAllocation
        ? this.afterAllocation.toJSON()
        : <any>null;
      data['afterDeductions'] = this.afterDeductions
        ? this.afterDeductions.toJSON()
        : <any>null;
      data['afterGrossup'] = this.afterGrossup
        ? this.afterGrossup.toJSON()
        : <any>null;
      data['taxWithholding'] = this.taxWithholding
        ? this.taxWithholding.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IIncomeSubjectToWithholding {
    customTax: boolean;
    taxType: TaxType;
    gainUsed: TransactionGainUsed[];
    afterAllocation: IncomeAfterAllocation;
    afterDeductions: AfterDeductions;
    afterGrossup: AfterGrossup;
    taxWithholding: TaxWithholdingSummary;
  }

  export class TaxWithholdingSummary implements ITaxWithholdingSummary {
    taxWithholdings!: TaxWithholding[];
    taxDue!: number;
    taxCredits!: TaxCredit[];
    netTaxDue!: number;

    constructor(data?: ITaxWithholdingSummary) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxWithholdings = [];
        this.taxCredits = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxWithholdings'])) {
          this.taxWithholdings = [] as any;
          for (let item of _data['taxWithholdings'])
            this.taxWithholdings!.push(TaxWithholding.fromJS(item));
        } else {
          this.taxWithholdings = <any>null;
        }
        this.taxDue =
          _data['taxDue'] !== undefined ? _data['taxDue'] : <any>null;
        if (Array.isArray(_data['taxCredits'])) {
          this.taxCredits = [] as any;
          for (let item of _data['taxCredits'])
            this.taxCredits!.push(TaxCredit.fromJS(item));
        } else {
          this.taxCredits = <any>null;
        }
        this.netTaxDue =
          _data['netTaxDue'] !== undefined ? _data['netTaxDue'] : <any>null;
      }
    }

    static fromJS(data: any): TaxWithholdingSummary {
      data = typeof data === 'object' ? data : {};
      let result = new TaxWithholdingSummary();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxWithholdings)) {
        data['taxWithholdings'] = [];
        for (let item of this.taxWithholdings)
          data['taxWithholdings'].push(item.toJSON());
      }
      data['taxDue'] = this.taxDue !== undefined ? this.taxDue : <any>null;
      if (Array.isArray(this.taxCredits)) {
        data['taxCredits'] = [];
        for (let item of this.taxCredits)
          data['taxCredits'].push(item.toJSON());
      }
      data['netTaxDue'] =
        this.netTaxDue !== undefined ? this.netTaxDue : <any>null;
      return data;
    }
  }

  export interface ITaxWithholdingSummary {
    taxWithholdings: TaxWithholding[];
    taxDue: number;
    taxCredits: TaxCredit[];
    netTaxDue: number;
  }

  export class TaxWithholding implements ITaxWithholding {
    type!: string;
    description!: string;
    grossupPercentage!: number | null;
    taxRateTypeUsed!: TaxRateTypeUsed;
    banding!: BandResult[];
    bandingTaxAmountSum!: number;

    constructor(data?: ITaxWithholding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.banding = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.type = _data['type'] !== undefined ? _data['type'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.grossupPercentage =
          _data['grossupPercentage'] !== undefined
            ? _data['grossupPercentage']
            : <any>null;
        this.taxRateTypeUsed =
          _data['taxRateTypeUsed'] !== undefined
            ? _data['taxRateTypeUsed']
            : <any>null;
        if (Array.isArray(_data['banding'])) {
          this.banding = [] as any;
          for (let item of _data['banding'])
            this.banding!.push(BandResult.fromJS(item));
        } else {
          this.banding = <any>null;
        }
        this.bandingTaxAmountSum =
          _data['bandingTaxAmountSum'] !== undefined
            ? _data['bandingTaxAmountSum']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxWithholding {
      data = typeof data === 'object' ? data : {};
      let result = new TaxWithholding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['type'] = this.type !== undefined ? this.type : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['grossupPercentage'] =
        this.grossupPercentage !== undefined
          ? this.grossupPercentage
          : <any>null;
      data['taxRateTypeUsed'] =
        this.taxRateTypeUsed !== undefined ? this.taxRateTypeUsed : <any>null;
      if (Array.isArray(this.banding)) {
        data['banding'] = [];
        for (let item of this.banding) data['banding'].push(item.toJSON());
      }
      data['bandingTaxAmountSum'] =
        this.bandingTaxAmountSum !== undefined
          ? this.bandingTaxAmountSum
          : <any>null;
      return data;
    }
  }

  export interface ITaxWithholding {
    type: string;
    description: string;
    grossupPercentage: number | null;
    taxRateTypeUsed: TaxRateTypeUsed;
    banding: BandResult[];
    bandingTaxAmountSum: number;
  }

  export class BandResult implements IBandResult {
    bandingType!: BandingType;
    lowerThreshold!: number;
    upperThreshold!: number | null;
    taxRate!: number;
    gain!: number;
    taxAmount!: number;

    constructor(data?: IBandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.bandingType =
          _data['bandingType'] !== undefined ? _data['bandingType'] : <any>null;
        this.lowerThreshold =
          _data['lowerThreshold'] !== undefined
            ? _data['lowerThreshold']
            : <any>null;
        this.upperThreshold =
          _data['upperThreshold'] !== undefined
            ? _data['upperThreshold']
            : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.gain = _data['gain'] !== undefined ? _data['gain'] : <any>null;
        this.taxAmount =
          _data['taxAmount'] !== undefined ? _data['taxAmount'] : <any>null;
      }
    }

    static fromJS(data: any): BandResult {
      data = typeof data === 'object' ? data : {};
      let result = new BandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['bandingType'] =
        this.bandingType !== undefined ? this.bandingType : <any>null;
      data['lowerThreshold'] =
        this.lowerThreshold !== undefined ? this.lowerThreshold : <any>null;
      data['upperThreshold'] =
        this.upperThreshold !== undefined ? this.upperThreshold : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['gain'] = this.gain !== undefined ? this.gain : <any>null;
      data['taxAmount'] =
        this.taxAmount !== undefined ? this.taxAmount : <any>null;
      return data;
    }
  }

  export interface IBandResult {
    bandingType: BandingType;
    lowerThreshold: number;
    upperThreshold: number | null;
    taxRate: number;
    gain: number;
    taxAmount: number;
  }

  export class RegionResult implements IRegionResult {
    regionCode!: string;
    currencyCode!: string;
    regionComment!: string | null;
    payroll!: Payroll;
    incomeSubjectToWithholding!: IncomeSubjectToWithholding[];

    constructor(data?: IRegionResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.payroll = new Payroll();
        this.incomeSubjectToWithholding = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.regionCode =
          _data['regionCode'] !== undefined ? _data['regionCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.regionComment =
          _data['regionComment'] !== undefined
            ? _data['regionComment']
            : <any>null;
        this.payroll = _data['payroll']
          ? Payroll.fromJS(_data['payroll'])
          : new Payroll();
        if (Array.isArray(_data['incomeSubjectToWithholding'])) {
          this.incomeSubjectToWithholding = [] as any;
          for (let item of _data['incomeSubjectToWithholding'])
            this.incomeSubjectToWithholding!.push(
              IncomeSubjectToWithholding.fromJS(item),
            );
        } else {
          this.incomeSubjectToWithholding = <any>null;
        }
      }
    }

    static fromJS(data: any): RegionResult {
      data = typeof data === 'object' ? data : {};
      let result = new RegionResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['regionCode'] =
        this.regionCode !== undefined ? this.regionCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['regionComment'] =
        this.regionComment !== undefined ? this.regionComment : <any>null;
      data['payroll'] = this.payroll ? this.payroll.toJSON() : <any>null;
      if (Array.isArray(this.incomeSubjectToWithholding)) {
        data['incomeSubjectToWithholding'] = [];
        for (let item of this.incomeSubjectToWithholding)
          data['incomeSubjectToWithholding'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRegionResult {
    regionCode: string;
    currencyCode: string;
    regionComment: string | null;
    payroll: Payroll;
    incomeSubjectToWithholding: IncomeSubjectToWithholding[];
  }

  export class HypotheticalResult implements IHypotheticalResult {
    customTax!: boolean;
    country!: HypotheticalResultCountry | null;
    taxRateCode!: string | null;
    taxType!: TaxType;
    jurisdictionLevel!: JurisdictionLevel;
    hypotheticalAllocationPercent!: number;
    hypotheticalTaxRate!: number;
    hypotheticalTaxValue!: number;

    constructor(data?: IHypotheticalResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.customTax =
          _data['customTax'] !== undefined ? _data['customTax'] : <any>null;
        this.country = _data['country']
          ? HypotheticalResultCountry.fromJS(_data['country'])
          : <any>null;
        this.taxRateCode =
          _data['taxRateCode'] !== undefined ? _data['taxRateCode'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.jurisdictionLevel =
          _data['jurisdictionLevel'] !== undefined
            ? _data['jurisdictionLevel']
            : <any>null;
        this.hypotheticalAllocationPercent =
          _data['hypotheticalAllocationPercent'] !== undefined
            ? _data['hypotheticalAllocationPercent']
            : <any>null;
        this.hypotheticalTaxRate =
          _data['hypotheticalTaxRate'] !== undefined
            ? _data['hypotheticalTaxRate']
            : <any>null;
        this.hypotheticalTaxValue =
          _data['hypotheticalTaxValue'] !== undefined
            ? _data['hypotheticalTaxValue']
            : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalResult {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['customTax'] =
        this.customTax !== undefined ? this.customTax : <any>null;
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['taxRateCode'] =
        this.taxRateCode !== undefined ? this.taxRateCode : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['jurisdictionLevel'] =
        this.jurisdictionLevel !== undefined
          ? this.jurisdictionLevel
          : <any>null;
      data['hypotheticalAllocationPercent'] =
        this.hypotheticalAllocationPercent !== undefined
          ? this.hypotheticalAllocationPercent
          : <any>null;
      data['hypotheticalTaxRate'] =
        this.hypotheticalTaxRate !== undefined
          ? this.hypotheticalTaxRate
          : <any>null;
      data['hypotheticalTaxValue'] =
        this.hypotheticalTaxValue !== undefined
          ? this.hypotheticalTaxValue
          : <any>null;
      return data;
    }
  }

  export interface IHypotheticalResult {
    customTax: boolean;
    country: HypotheticalResultCountry | null;
    taxRateCode: string | null;
    taxType: TaxType;
    jurisdictionLevel: JurisdictionLevel;
    hypotheticalAllocationPercent: number;
    hypotheticalTaxRate: number;
    hypotheticalTaxValue: number;
  }

  export class HypotheticalResultCountry implements IHypotheticalResultCountry {
    code!: string;
    region!: HypotheticalResultRegion | null;

    constructor(data?: IHypotheticalResultCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? HypotheticalResultRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalResultCountry {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalResultCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface IHypotheticalResultCountry {
    code: string;
    region: HypotheticalResultRegion | null;
  }

  export class HypotheticalResultRegion implements IHypotheticalResultRegion {
    code!: string;

    constructor(data?: IHypotheticalResultRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalResultRegion {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalResultRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IHypotheticalResultRegion {
    code: string;
  }

  export class TransactionTotals implements ITransactionTotals {
    transactionGain!: number;
    employeeTaxRate!: number;
    currencyCode!: string;
    excessWithholding!: number | null;
    excessWithholdingDescription!: ExcessWithHoldingDescription | null;
    totalHypotheticalIncomeTax!: number | null;
    totalHypotheticalSocialTax!: number | null;
    totalHypotheticalRegionTax!: number | null;
    totalHypotheticalTax!: number | null;
    totalHypotheticalExcessWithholding!: number | null;
    totalHypotheticalTaxAndExcessWithholding!: number | null;
    totalActualEmployeeTaxWithholding!: number;
    totalActualExcessWithholding!: number | null;
    totalActualEmployeeTaxWithholdingAndExcessWithholding!: number | null;
    totalEmployeeTaxWithholding!: number;
    totalEmployeeTaxWithholdingAndExcessWithholding!: number | null;
    totalSharesWithheld!: number | null;
    valueAfterTaxWithholding!: number | null;
    employerTaxRate!: number | null;
    totalEmployerTaxWithholding!: number | null;

    constructor(data?: ITransactionTotals) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionGain =
          _data['transactionGain'] !== undefined
            ? _data['transactionGain']
            : <any>null;
        this.employeeTaxRate =
          _data['employeeTaxRate'] !== undefined
            ? _data['employeeTaxRate']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.excessWithholding =
          _data['excessWithholding'] !== undefined
            ? _data['excessWithholding']
            : <any>null;
        this.excessWithholdingDescription =
          _data['excessWithholdingDescription'] !== undefined
            ? _data['excessWithholdingDescription']
            : <any>null;
        this.totalHypotheticalIncomeTax =
          _data['totalHypotheticalIncomeTax'] !== undefined
            ? _data['totalHypotheticalIncomeTax']
            : <any>null;
        this.totalHypotheticalSocialTax =
          _data['totalHypotheticalSocialTax'] !== undefined
            ? _data['totalHypotheticalSocialTax']
            : <any>null;
        this.totalHypotheticalRegionTax =
          _data['totalHypotheticalRegionTax'] !== undefined
            ? _data['totalHypotheticalRegionTax']
            : <any>null;
        this.totalHypotheticalTax =
          _data['totalHypotheticalTax'] !== undefined
            ? _data['totalHypotheticalTax']
            : <any>null;
        this.totalHypotheticalExcessWithholding =
          _data['totalHypotheticalExcessWithholding'] !== undefined
            ? _data['totalHypotheticalExcessWithholding']
            : <any>null;
        this.totalHypotheticalTaxAndExcessWithholding =
          _data['totalHypotheticalTaxAndExcessWithholding'] !== undefined
            ? _data['totalHypotheticalTaxAndExcessWithholding']
            : <any>null;
        this.totalActualEmployeeTaxWithholding =
          _data['totalActualEmployeeTaxWithholding'] !== undefined
            ? _data['totalActualEmployeeTaxWithholding']
            : <any>null;
        this.totalActualExcessWithholding =
          _data['totalActualExcessWithholding'] !== undefined
            ? _data['totalActualExcessWithholding']
            : <any>null;
        this.totalActualEmployeeTaxWithholdingAndExcessWithholding =
          _data['totalActualEmployeeTaxWithholdingAndExcessWithholding'] !==
          undefined
            ? _data['totalActualEmployeeTaxWithholdingAndExcessWithholding']
            : <any>null;
        this.totalEmployeeTaxWithholding =
          _data['totalEmployeeTaxWithholding'] !== undefined
            ? _data['totalEmployeeTaxWithholding']
            : <any>null;
        this.totalEmployeeTaxWithholdingAndExcessWithholding =
          _data['totalEmployeeTaxWithholdingAndExcessWithholding'] !== undefined
            ? _data['totalEmployeeTaxWithholdingAndExcessWithholding']
            : <any>null;
        this.totalSharesWithheld =
          _data['totalSharesWithheld'] !== undefined
            ? _data['totalSharesWithheld']
            : <any>null;
        this.valueAfterTaxWithholding =
          _data['valueAfterTaxWithholding'] !== undefined
            ? _data['valueAfterTaxWithholding']
            : <any>null;
        this.employerTaxRate =
          _data['employerTaxRate'] !== undefined
            ? _data['employerTaxRate']
            : <any>null;
        this.totalEmployerTaxWithholding =
          _data['totalEmployerTaxWithholding'] !== undefined
            ? _data['totalEmployerTaxWithholding']
            : <any>null;
      }
    }

    static fromJS(data: any): TransactionTotals {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionTotals();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionGain'] =
        this.transactionGain !== undefined ? this.transactionGain : <any>null;
      data['employeeTaxRate'] =
        this.employeeTaxRate !== undefined ? this.employeeTaxRate : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['excessWithholding'] =
        this.excessWithholding !== undefined
          ? this.excessWithholding
          : <any>null;
      data['excessWithholdingDescription'] =
        this.excessWithholdingDescription !== undefined
          ? this.excessWithholdingDescription
          : <any>null;
      data['totalHypotheticalIncomeTax'] =
        this.totalHypotheticalIncomeTax !== undefined
          ? this.totalHypotheticalIncomeTax
          : <any>null;
      data['totalHypotheticalSocialTax'] =
        this.totalHypotheticalSocialTax !== undefined
          ? this.totalHypotheticalSocialTax
          : <any>null;
      data['totalHypotheticalRegionTax'] =
        this.totalHypotheticalRegionTax !== undefined
          ? this.totalHypotheticalRegionTax
          : <any>null;
      data['totalHypotheticalTax'] =
        this.totalHypotheticalTax !== undefined
          ? this.totalHypotheticalTax
          : <any>null;
      data['totalHypotheticalExcessWithholding'] =
        this.totalHypotheticalExcessWithholding !== undefined
          ? this.totalHypotheticalExcessWithholding
          : <any>null;
      data['totalHypotheticalTaxAndExcessWithholding'] =
        this.totalHypotheticalTaxAndExcessWithholding !== undefined
          ? this.totalHypotheticalTaxAndExcessWithholding
          : <any>null;
      data['totalActualEmployeeTaxWithholding'] =
        this.totalActualEmployeeTaxWithholding !== undefined
          ? this.totalActualEmployeeTaxWithholding
          : <any>null;
      data['totalActualExcessWithholding'] =
        this.totalActualExcessWithholding !== undefined
          ? this.totalActualExcessWithholding
          : <any>null;
      data['totalActualEmployeeTaxWithholdingAndExcessWithholding'] =
        this.totalActualEmployeeTaxWithholdingAndExcessWithholding !== undefined
          ? this.totalActualEmployeeTaxWithholdingAndExcessWithholding
          : <any>null;
      data['totalEmployeeTaxWithholding'] =
        this.totalEmployeeTaxWithholding !== undefined
          ? this.totalEmployeeTaxWithholding
          : <any>null;
      data['totalEmployeeTaxWithholdingAndExcessWithholding'] =
        this.totalEmployeeTaxWithholdingAndExcessWithholding !== undefined
          ? this.totalEmployeeTaxWithholdingAndExcessWithholding
          : <any>null;
      data['totalSharesWithheld'] =
        this.totalSharesWithheld !== undefined
          ? this.totalSharesWithheld
          : <any>null;
      data['valueAfterTaxWithholding'] =
        this.valueAfterTaxWithholding !== undefined
          ? this.valueAfterTaxWithholding
          : <any>null;
      data['employerTaxRate'] =
        this.employerTaxRate !== undefined ? this.employerTaxRate : <any>null;
      data['totalEmployerTaxWithholding'] =
        this.totalEmployerTaxWithholding !== undefined
          ? this.totalEmployerTaxWithholding
          : <any>null;
      return data;
    }
  }

  export interface ITransactionTotals {
    transactionGain: number;
    employeeTaxRate: number;
    currencyCode: string;
    excessWithholding: number | null;
    excessWithholdingDescription: ExcessWithHoldingDescription | null;
    totalHypotheticalIncomeTax: number | null;
    totalHypotheticalSocialTax: number | null;
    totalHypotheticalRegionTax: number | null;
    totalHypotheticalTax: number | null;
    totalHypotheticalExcessWithholding: number | null;
    totalHypotheticalTaxAndExcessWithholding: number | null;
    totalActualEmployeeTaxWithholding: number;
    totalActualExcessWithholding: number | null;
    totalActualEmployeeTaxWithholdingAndExcessWithholding: number | null;
    totalEmployeeTaxWithholding: number;
    totalEmployeeTaxWithholdingAndExcessWithholding: number | null;
    totalSharesWithheld: number | null;
    valueAfterTaxWithholding: number | null;
    employerTaxRate: number | null;
    totalEmployerTaxWithholding: number | null;
  }

  export enum ExcessWithHoldingDescription {
    IncomeTax = 'IncomeTax',
    SocialTax = 'SocialTax',
    RegionTax = 'RegionTax',
    HypoTax = 'HypoTax',
  }

  export class HypotheticalResultTotals implements IHypotheticalResultTotals {
    hypotheticalTransactionGain!: number;
    hypotheticalAllocationPercent!: number;
    hypotheticalTaxRate!: number;
    hypotheticalTaxValue!: number;

    constructor(data?: IHypotheticalResultTotals) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.hypotheticalTransactionGain =
          _data['hypotheticalTransactionGain'] !== undefined
            ? _data['hypotheticalTransactionGain']
            : <any>null;
        this.hypotheticalAllocationPercent =
          _data['hypotheticalAllocationPercent'] !== undefined
            ? _data['hypotheticalAllocationPercent']
            : <any>null;
        this.hypotheticalTaxRate =
          _data['hypotheticalTaxRate'] !== undefined
            ? _data['hypotheticalTaxRate']
            : <any>null;
        this.hypotheticalTaxValue =
          _data['hypotheticalTaxValue'] !== undefined
            ? _data['hypotheticalTaxValue']
            : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalResultTotals {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalResultTotals();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['hypotheticalTransactionGain'] =
        this.hypotheticalTransactionGain !== undefined
          ? this.hypotheticalTransactionGain
          : <any>null;
      data['hypotheticalAllocationPercent'] =
        this.hypotheticalAllocationPercent !== undefined
          ? this.hypotheticalAllocationPercent
          : <any>null;
      data['hypotheticalTaxRate'] =
        this.hypotheticalTaxRate !== undefined
          ? this.hypotheticalTaxRate
          : <any>null;
      data['hypotheticalTaxValue'] =
        this.hypotheticalTaxValue !== undefined
          ? this.hypotheticalTaxValue
          : <any>null;
      return data;
    }
  }

  export interface IHypotheticalResultTotals {
    hypotheticalTransactionGain: number;
    hypotheticalAllocationPercent: number;
    hypotheticalTaxRate: number;
    hypotheticalTaxValue: number;
  }

  export class UpdateManualCalculationEngineResultsCommandResultFailure
    extends UpdateManualCalculationEngineResultsCommandResult
    implements IUpdateManualCalculationEngineResultsCommandResultFailure
  {
    errorCode!: SaveTransactionManualCalculationResultFailureErrorCode;
    errorMessage!: string | null;
    manualReCalcResultsRequestBody!: string | null;
    manualReCalcResultsResponseBody!: string | null;

    constructor(
      data?: IUpdateManualCalculationEngineResultsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
        this.manualReCalcResultsRequestBody =
          _data['manualReCalcResultsRequestBody'] !== undefined
            ? _data['manualReCalcResultsRequestBody']
            : <any>null;
        this.manualReCalcResultsResponseBody =
          _data['manualReCalcResultsResponseBody'] !== undefined
            ? _data['manualReCalcResultsResponseBody']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpdateManualCalculationEngineResultsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpdateManualCalculationEngineResultsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      data['manualReCalcResultsRequestBody'] =
        this.manualReCalcResultsRequestBody !== undefined
          ? this.manualReCalcResultsRequestBody
          : <any>null;
      data['manualReCalcResultsResponseBody'] =
        this.manualReCalcResultsResponseBody !== undefined
          ? this.manualReCalcResultsResponseBody
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpdateManualCalculationEngineResultsCommandResultFailure
    extends IUpdateManualCalculationEngineResultsCommandResult {
    errorCode: SaveTransactionManualCalculationResultFailureErrorCode;
    errorMessage: string | null;
    manualReCalcResultsRequestBody: string | null;
    manualReCalcResultsResponseBody: string | null;
  }

  export enum SaveTransactionManualCalculationResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationNotInManualCalculationPendingReview = 'CalculationNotInManualCalculationPendingReview',
    CalculationIsNotCheckedOutToUser = 'CalculationIsNotCheckedOutToUser',
    TransactionNotFound = 'TransactionNotFound',
    TransactionNotInValidState = 'TransactionNotInValidState',
    TransactionUpdateActionFailed = 'TransactionUpdateActionFailed',
    ManualCalculationReTotalingError = 'ManualCalculationReTotalingError',
    Unauthorized = 'Unauthorized',
    Unknown = 'Unknown',
  }

  export class UpdateManualCalculationEngineResultsCommand
    implements IUpdateManualCalculationEngineResultsCommand
  {
    clientId!: string;
    calculationId!: string;
    transactionResult!: TransactionResult;
    comment!: string | null;
    action!: UpdateManualCalculationAction;

    constructor(data?: IUpdateManualCalculationEngineResultsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionResult = new TransactionResult();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.transactionResult = _data['transactionResult']
          ? TransactionResult.fromJS(_data['transactionResult'])
          : new TransactionResult();
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.action =
          _data['action'] !== undefined ? _data['action'] : <any>null;
      }
    }

    static fromJS(data: any): UpdateManualCalculationEngineResultsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateManualCalculationEngineResultsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['transactionResult'] = this.transactionResult
        ? this.transactionResult.toJSON()
        : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['action'] = this.action !== undefined ? this.action : <any>null;
      return data;
    }
  }

  export interface IUpdateManualCalculationEngineResultsCommand {
    clientId: string;
    calculationId: string;
    transactionResult: TransactionResult;
    comment: string | null;
    action: UpdateManualCalculationAction;
  }

  export enum UpdateManualCalculationAction {
    MarkPendingReview = 'MarkPendingReview',
    MarkReviewed = 'MarkReviewed',
    MarkPendingApproval = 'MarkPendingApproval',
    MarkNeedsAttention = 'MarkNeedsAttention',
    MarkApproved = 'MarkApproved',
  }

  export abstract class RecalculateManualTotalsCommandResult
    implements IRecalculateManualTotalsCommandResult
  {
    constructor(data?: IRecalculateManualTotalsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): RecalculateManualTotalsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'RecalculateManualTotalsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IRecalculateManualTotalsCommandResult {}

  export class RecalculateManualTotalsCommandResultSuccess
    extends RecalculateManualTotalsCommandResult
    implements IRecalculateManualTotalsCommandResultSuccess
  {
    transactionResult!: TransactionResult;
    manualReCalcResultsRequestBody!: string | null;
    manualReCalcResultsResponseBody!: string | null;

    constructor(data?: IRecalculateManualTotalsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.transactionResult = new TransactionResult();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.transactionResult = _data['transactionResult']
          ? TransactionResult.fromJS(_data['transactionResult'])
          : new TransactionResult();
        this.manualReCalcResultsRequestBody =
          _data['manualReCalcResultsRequestBody'] !== undefined
            ? _data['manualReCalcResultsRequestBody']
            : <any>null;
        this.manualReCalcResultsResponseBody =
          _data['manualReCalcResultsResponseBody'] !== undefined
            ? _data['manualReCalcResultsResponseBody']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecalculateManualTotalsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new RecalculateManualTotalsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionResult'] = this.transactionResult
        ? this.transactionResult.toJSON()
        : <any>null;
      data['manualReCalcResultsRequestBody'] =
        this.manualReCalcResultsRequestBody !== undefined
          ? this.manualReCalcResultsRequestBody
          : <any>null;
      data['manualReCalcResultsResponseBody'] =
        this.manualReCalcResultsResponseBody !== undefined
          ? this.manualReCalcResultsResponseBody
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecalculateManualTotalsCommandResultSuccess
    extends IRecalculateManualTotalsCommandResult {
    transactionResult: TransactionResult;
    manualReCalcResultsRequestBody: string | null;
    manualReCalcResultsResponseBody: string | null;
  }

  export class RecalculateManualTotalsCommandResultFailure
    extends RecalculateManualTotalsCommandResult
    implements IRecalculateManualTotalsCommandResultFailure
  {
    errorMessage!: string | null;

    constructor(data?: IRecalculateManualTotalsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecalculateManualTotalsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new RecalculateManualTotalsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecalculateManualTotalsCommandResultFailure
    extends IRecalculateManualTotalsCommandResult {
    errorMessage: string | null;
  }

  export class RecalculateManualTotalsCommand
    implements IRecalculateManualTotalsCommand
  {
    clientId!: string;
    calculationId!: string;
    transactionResult!: TransactionResult;

    constructor(data?: IRecalculateManualTotalsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionResult = new TransactionResult();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.transactionResult = _data['transactionResult']
          ? TransactionResult.fromJS(_data['transactionResult'])
          : new TransactionResult();
      }
    }

    static fromJS(data: any): RecalculateManualTotalsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new RecalculateManualTotalsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['transactionResult'] = this.transactionResult
        ? this.transactionResult.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IRecalculateManualTotalsCommand {
    clientId: string;
    calculationId: string;
    transactionResult: TransactionResult;
  }

  export abstract class GetManualCalculationsTransactionInputsPageDataQueryResult
    implements IGetManualCalculationsTransactionInputsPageDataQueryResult
  {
    constructor(
      data?: IGetManualCalculationsTransactionInputsPageDataQueryResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetManualCalculationsTransactionInputsPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetManualCalculationsTransactionInputsPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetManualCalculationsTransactionInputsPageDataQueryResult {}

  export class GetManualCalculationsTransactionInputsPageDataQueryResultSuccess
    extends GetManualCalculationsTransactionInputsPageDataQueryResult
    implements IGetManualCalculationsTransactionInputsPageDataQueryResultSuccess
  {
    pageData!: ManualCalculationsTransactionInputsPageData;

    constructor(
      data?: IGetManualCalculationsTransactionInputsPageDataQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.pageData = new ManualCalculationsTransactionInputsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.pageData = _data['pageData']
          ? ManualCalculationsTransactionInputsPageData.fromJS(
              _data['pageData'],
            )
          : new ManualCalculationsTransactionInputsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationsTransactionInputsPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetManualCalculationsTransactionInputsPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pageData'] = this.pageData ? this.pageData.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationsTransactionInputsPageDataQueryResultSuccess
    extends IGetManualCalculationsTransactionInputsPageDataQueryResult {
    pageData: ManualCalculationsTransactionInputsPageData;
  }

  export class ManualCalculationsTransactionInputsPageData
    implements IManualCalculationsTransactionInputsPageData
  {
    comments!: TransactionComment[];
    fileInfo!: ManualCalculationsTransactionInputsFileInfoDto[] | null;

    constructor(data?: IManualCalculationsTransactionInputsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.comments = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['comments'])) {
          this.comments = [] as any;
          for (let item of _data['comments'])
            this.comments!.push(TransactionComment.fromJS(item));
        } else {
          this.comments = <any>null;
        }
        if (Array.isArray(_data['fileInfo'])) {
          this.fileInfo = [] as any;
          for (let item of _data['fileInfo'])
            this.fileInfo!.push(
              ManualCalculationsTransactionInputsFileInfoDto.fromJS(item),
            );
        } else {
          this.fileInfo = <any>null;
        }
      }
    }

    static fromJS(data: any): ManualCalculationsTransactionInputsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationsTransactionInputsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.comments)) {
        data['comments'] = [];
        for (let item of this.comments) data['comments'].push(item.toJSON());
      }
      if (Array.isArray(this.fileInfo)) {
        data['fileInfo'] = [];
        for (let item of this.fileInfo) data['fileInfo'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IManualCalculationsTransactionInputsPageData {
    comments: TransactionComment[];
    fileInfo: ManualCalculationsTransactionInputsFileInfoDto[] | null;
  }

  export class TransactionComment implements ITransactionComment {
    transactionGuid!: string;
    comment!: string;
    timestamp!: Date;
    author!: TransactionCommentAuthor;

    constructor(data?: ITransactionComment) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.author = new TransactionCommentAuthor();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
        this.author = _data['author']
          ? TransactionCommentAuthor.fromJS(_data['author'])
          : new TransactionCommentAuthor();
      }
    }

    static fromJS(data: any): TransactionComment {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionComment();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      data['author'] = this.author ? this.author.toJSON() : <any>null;
      return data;
    }
  }

  export interface ITransactionComment {
    transactionGuid: string;
    comment: string;
    timestamp: Date;
    author: TransactionCommentAuthor;
  }

  export class TransactionCommentAuthor implements ITransactionCommentAuthor {
    fullName!: string;

    constructor(data?: ITransactionCommentAuthor) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
      }
    }

    static fromJS(data: any): TransactionCommentAuthor {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionCommentAuthor();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      return data;
    }
  }

  export interface ITransactionCommentAuthor {
    fullName: string;
  }

  export class ManualCalculationsTransactionInputsFileInfoDto
    implements IManualCalculationsTransactionInputsFileInfoDto
  {
    fileName!: string;
    fileSizeInBytes!: number;
    uploadedOn!: Date;

    constructor(data?: IManualCalculationsTransactionInputsFileInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.fileSizeInBytes =
          _data['fileSizeInBytes'] !== undefined
            ? _data['fileSizeInBytes']
            : <any>null;
        this.uploadedOn = _data['uploadedOn']
          ? new Date(_data['uploadedOn'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationsTransactionInputsFileInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationsTransactionInputsFileInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['fileSizeInBytes'] =
        this.fileSizeInBytes !== undefined ? this.fileSizeInBytes : <any>null;
      data['uploadedOn'] = this.uploadedOn
        ? this.uploadedOn.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationsTransactionInputsFileInfoDto {
    fileName: string;
    fileSizeInBytes: number;
    uploadedOn: Date;
  }

  export class GetManualCalculationsTransactionInputsPageDataQueryResultFailure
    extends GetManualCalculationsTransactionInputsPageDataQueryResult
    implements IGetManualCalculationsTransactionInputsPageDataQueryResultFailure
  {
    errorCode!: GetManualCalculationsTransactionInputsPageDataQueryResultFailureErrorCode;

    constructor(
      data?: IGetManualCalculationsTransactionInputsPageDataQueryResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationsTransactionInputsPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetManualCalculationsTransactionInputsPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationsTransactionInputsPageDataQueryResultFailure
    extends IGetManualCalculationsTransactionInputsPageDataQueryResult {
    errorCode: GetManualCalculationsTransactionInputsPageDataQueryResultFailureErrorCode;
  }

  export enum GetManualCalculationsTransactionInputsPageDataQueryResultFailureErrorCode {
    Unauthorized = 'Unauthorized',
    CalculationNotFound = 'CalculationNotFound',
    TransactionNotFound = 'TransactionNotFound',
    CommentHistoryNotFound = 'CommentHistoryNotFound',
    Unknown = 'Unknown',
  }

  export class UploadManualCalculationsTransactionInputsFileCommandResult
    implements IUploadManualCalculationsTransactionInputsFileCommandResult
  {
    constructor(
      data?: IUploadManualCalculationsTransactionInputsFileCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UploadManualCalculationsTransactionInputsFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result =
        new UploadManualCalculationsTransactionInputsFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUploadManualCalculationsTransactionInputsFileCommandResult {}

  export class UploadManualCalculationsTransactionInputsFileCommandResultSuccess
    extends UploadManualCalculationsTransactionInputsFileCommandResult
    implements
      IUploadManualCalculationsTransactionInputsFileCommandResultSuccess
  {
    result!: ManualCalculationsTransactionInputsFileInfoDto[];

    constructor(
      data?: IUploadManualCalculationsTransactionInputsFileCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.result = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['result'])) {
          this.result = [] as any;
          for (let item of _data['result'])
            this.result!.push(
              ManualCalculationsTransactionInputsFileInfoDto.fromJS(item),
            );
        } else {
          this.result = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UploadManualCalculationsTransactionInputsFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UploadManualCalculationsTransactionInputsFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.result)) {
        data['result'] = [];
        for (let item of this.result) data['result'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadManualCalculationsTransactionInputsFileCommandResultSuccess
    extends IUploadManualCalculationsTransactionInputsFileCommandResult {
    result: ManualCalculationsTransactionInputsFileInfoDto[];
  }

  export class UploadManualCalculationsTransactionInputsFileCommandResultFailure
    extends UploadManualCalculationsTransactionInputsFileCommandResult
    implements
      IUploadManualCalculationsTransactionInputsFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IUploadManualCalculationsTransactionInputsFileCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UploadManualCalculationsTransactionInputsFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UploadManualCalculationsTransactionInputsFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUploadManualCalculationsTransactionInputsFileCommandResultFailure
    extends IUploadManualCalculationsTransactionInputsFileCommandResult {
    errorMessage: string;
  }

  export class DeleteManualCalculationsTransactionInputsFileCommandResult
    implements IDeleteManualCalculationsTransactionInputsFileCommandResult
  {
    constructor(
      data?: IDeleteManualCalculationsTransactionInputsFileCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DeleteManualCalculationsTransactionInputsFileCommandResult {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteManualCalculationsTransactionInputsFileCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteManualCalculationsTransactionInputsFileCommandResult {}

  export class DeleteManualCalculationsTransactionInputsFileCommandResultSuccess
    extends DeleteManualCalculationsTransactionInputsFileCommandResult
    implements
      IDeleteManualCalculationsTransactionInputsFileCommandResultSuccess
  {
    constructor(
      data?: IDeleteManualCalculationsTransactionInputsFileCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteManualCalculationsTransactionInputsFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteManualCalculationsTransactionInputsFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteManualCalculationsTransactionInputsFileCommandResultSuccess
    extends IDeleteManualCalculationsTransactionInputsFileCommandResult {}

  export class DeleteManualCalculationsTransactionInputsFileCommandResultFailure
    extends DeleteManualCalculationsTransactionInputsFileCommandResult
    implements
      IDeleteManualCalculationsTransactionInputsFileCommandResultFailure
  {
    errors!: ResultError[];

    constructor(
      data?: IDeleteManualCalculationsTransactionInputsFileCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): DeleteManualCalculationsTransactionInputsFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteManualCalculationsTransactionInputsFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteManualCalculationsTransactionInputsFileCommandResultFailure
    extends IDeleteManualCalculationsTransactionInputsFileCommandResult {
    errors: ResultError[];
  }

  export abstract class ApproveCalculationFromSummaryPageCommandResult
    implements IApproveCalculationFromSummaryPageCommandResult
  {
    constructor(data?: IApproveCalculationFromSummaryPageCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ApproveCalculationFromSummaryPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ApproveCalculationFromSummaryPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IApproveCalculationFromSummaryPageCommandResult {}

  export class ApproveCalculationFromSummaryPageCommandResultSuccess
    extends ApproveCalculationFromSummaryPageCommandResult
    implements IApproveCalculationFromSummaryPageCommandResultSuccess
  {
    calculation!: CalculationIndexModel;

    constructor(data?: IApproveCalculationFromSummaryPageCommandResultSuccess) {
      super(data);
      if (!data) {
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
      }
    }

    static override fromJS(
      data: any,
    ): ApproveCalculationFromSummaryPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveCalculationFromSummaryPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveCalculationFromSummaryPageCommandResultSuccess
    extends IApproveCalculationFromSummaryPageCommandResult {
    calculation: CalculationIndexModel;
  }

  export class ApproveCalculationFromSummaryPageCommandResultFailure
    extends ApproveCalculationFromSummaryPageCommandResult
    implements IApproveCalculationFromSummaryPageCommandResultFailure
  {
    errorCode!: ApproveCalculationFromWorkflowResultFailureErrorCode;

    constructor(data?: IApproveCalculationFromSummaryPageCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): ApproveCalculationFromSummaryPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveCalculationFromSummaryPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveCalculationFromSummaryPageCommandResultFailure
    extends IApproveCalculationFromSummaryPageCommandResult {
    errorCode: ApproveCalculationFromWorkflowResultFailureErrorCode;
  }

  export enum ApproveCalculationFromWorkflowResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationNotInCorrectState = 'CalculationNotInCorrectState',
    CalculationIsNotCheckedOutToUser = 'CalculationIsNotCheckedOutToUser',
    NotAllTransactionsAreApproved = 'NotAllTransactionsAreApproved',
    Unauthorized = 'Unauthorized',
    Unknown = 'Unknown',
  }

  export class ApproveCalculationFromSummaryPageCommand
    implements IApproveCalculationFromSummaryPageCommand
  {
    clientId!: string;
    calculationId!: string;

    constructor(data?: IApproveCalculationFromSummaryPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): ApproveCalculationFromSummaryPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveCalculationFromSummaryPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface IApproveCalculationFromSummaryPageCommand {
    clientId: string;
    calculationId: string;
  }

  export abstract class ReturnCalculationFromSummaryPageCommandResult
    implements IReturnCalculationFromSummaryPageCommandResult
  {
    constructor(data?: IReturnCalculationFromSummaryPageCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ReturnCalculationFromSummaryPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReturnCalculationFromSummaryPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IReturnCalculationFromSummaryPageCommandResult {}

  export class ReturnCalculationFromSummaryPageCommandResultSuccess
    extends ReturnCalculationFromSummaryPageCommandResult
    implements IReturnCalculationFromSummaryPageCommandResultSuccess
  {
    calculation!: CalculationIndexModel;

    constructor(data?: IReturnCalculationFromSummaryPageCommandResultSuccess) {
      super(data);
      if (!data) {
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
      }
    }

    static override fromJS(
      data: any,
    ): ReturnCalculationFromSummaryPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnCalculationFromSummaryPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnCalculationFromSummaryPageCommandResultSuccess
    extends IReturnCalculationFromSummaryPageCommandResult {
    calculation: CalculationIndexModel;
  }

  export class ReturnCalculationFromSummaryPageCommandResultFailure
    extends ReturnCalculationFromSummaryPageCommandResult
    implements IReturnCalculationFromSummaryPageCommandResultFailure
  {
    errorCode!: ReturnCalculationToReviewerFromWorkflowResultFailureErrorCode;

    constructor(data?: IReturnCalculationFromSummaryPageCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): ReturnCalculationFromSummaryPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnCalculationFromSummaryPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnCalculationFromSummaryPageCommandResultFailure
    extends IReturnCalculationFromSummaryPageCommandResult {
    errorCode: ReturnCalculationToReviewerFromWorkflowResultFailureErrorCode;
  }

  export enum ReturnCalculationToReviewerFromWorkflowResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationNotInCorrectState = 'CalculationNotInCorrectState',
    CalculationIsNotCheckedOutToUser = 'CalculationIsNotCheckedOutToUser',
    AllTransactionsAreApproved = 'AllTransactionsAreApproved',
    CommentTooLong = 'CommentTooLong',
    Unauthorized = 'Unauthorized',
    Unknown = 'Unknown',
  }

  export class ReturnCalculationFromSummaryPageCommand
    implements IReturnCalculationFromSummaryPageCommand
  {
    clientId!: string;
    calculationId!: string;
    comment!: string | null;

    constructor(data?: IReturnCalculationFromSummaryPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(data: any): ReturnCalculationFromSummaryPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnCalculationFromSummaryPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IReturnCalculationFromSummaryPageCommand {
    clientId: string;
    calculationId: string;
    comment: string | null;
  }

  export abstract class SendCalculationForApprovalFromSummaryPageCommandResult
    implements ISendCalculationForApprovalFromSummaryPageCommandResult
  {
    constructor(
      data?: ISendCalculationForApprovalFromSummaryPageCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): SendCalculationForApprovalFromSummaryPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SendCalculationForApprovalFromSummaryPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISendCalculationForApprovalFromSummaryPageCommandResult {}

  export class SendCalculationForApprovalFromSummaryPageCommandResultSuccess
    extends SendCalculationForApprovalFromSummaryPageCommandResult
    implements ISendCalculationForApprovalFromSummaryPageCommandResultSuccess
  {
    constructor(
      data?: ISendCalculationForApprovalFromSummaryPageCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SendCalculationForApprovalFromSummaryPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SendCalculationForApprovalFromSummaryPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendCalculationForApprovalFromSummaryPageCommandResultSuccess
    extends ISendCalculationForApprovalFromSummaryPageCommandResult {}

  export class SendCalculationForApprovalFromSummaryPageCommandResultFailure
    extends SendCalculationForApprovalFromSummaryPageCommandResult
    implements ISendCalculationForApprovalFromSummaryPageCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: ISendCalculationForApprovalFromSummaryPageCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SendCalculationForApprovalFromSummaryPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SendCalculationForApprovalFromSummaryPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendCalculationForApprovalFromSummaryPageCommandResultFailure
    extends ISendCalculationForApprovalFromSummaryPageCommandResult {
    errorMessage: string;
  }

  export class SendCalculationForApprovalFromSummaryPageCommand
    implements ISendCalculationForApprovalFromSummaryPageCommand
  {
    clientPortalId!: string;
    calculationId!: string;

    constructor(data?: ISendCalculationForApprovalFromSummaryPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): SendCalculationForApprovalFromSummaryPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SendCalculationForApprovalFromSummaryPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface ISendCalculationForApprovalFromSummaryPageCommand {
    clientPortalId: string;
    calculationId: string;
  }

  export class GetManualCalculationAggregationsQueryResult
    implements IGetManualCalculationAggregationsQueryResult
  {
    constructor(data?: IGetManualCalculationAggregationsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetManualCalculationAggregationsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationAggregationsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetManualCalculationAggregationsQueryResult {}

  export class GetManualCalculationAggregationsQueryResultSuccess
    extends GetManualCalculationAggregationsQueryResult
    implements IGetManualCalculationAggregationsQueryResultSuccess
  {
    batchIds!: string[] | null;
    employeeIds!: string[] | null;
    employeeNames!: string[] | null;
    transactionGuids!: string[] | null;
    manualCalculationReasons!: string[] | null;
    countriesInFootprint!: ManualCalculationCountryData[] | null;
    manualCalculationStatus!: CalculationStatus[] | null;
    checkedOutByUsers!: PortalUser[] | null;

    constructor(data?: IGetManualCalculationAggregationsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
        if (Array.isArray(_data['employeeIds'])) {
          this.employeeIds = [] as any;
          for (let item of _data['employeeIds']) this.employeeIds!.push(item);
        } else {
          this.employeeIds = <any>null;
        }
        if (Array.isArray(_data['employeeNames'])) {
          this.employeeNames = [] as any;
          for (let item of _data['employeeNames'])
            this.employeeNames!.push(item);
        } else {
          this.employeeNames = <any>null;
        }
        if (Array.isArray(_data['transactionGuids'])) {
          this.transactionGuids = [] as any;
          for (let item of _data['transactionGuids'])
            this.transactionGuids!.push(item);
        } else {
          this.transactionGuids = <any>null;
        }
        if (Array.isArray(_data['manualCalculationReasons'])) {
          this.manualCalculationReasons = [] as any;
          for (let item of _data['manualCalculationReasons'])
            this.manualCalculationReasons!.push(item);
        } else {
          this.manualCalculationReasons = <any>null;
        }
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              ManualCalculationCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['manualCalculationStatus'])) {
          this.manualCalculationStatus = [] as any;
          for (let item of _data['manualCalculationStatus'])
            this.manualCalculationStatus!.push(item);
        } else {
          this.manualCalculationStatus = <any>null;
        }
        if (Array.isArray(_data['checkedOutByUsers'])) {
          this.checkedOutByUsers = [] as any;
          for (let item of _data['checkedOutByUsers'])
            this.checkedOutByUsers!.push(PortalUser.fromJS(item));
        } else {
          this.checkedOutByUsers = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationAggregationsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationAggregationsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      if (Array.isArray(this.employeeIds)) {
        data['employeeIds'] = [];
        for (let item of this.employeeIds) data['employeeIds'].push(item);
      }
      if (Array.isArray(this.employeeNames)) {
        data['employeeNames'] = [];
        for (let item of this.employeeNames) data['employeeNames'].push(item);
      }
      if (Array.isArray(this.transactionGuids)) {
        data['transactionGuids'] = [];
        for (let item of this.transactionGuids)
          data['transactionGuids'].push(item);
      }
      if (Array.isArray(this.manualCalculationReasons)) {
        data['manualCalculationReasons'] = [];
        for (let item of this.manualCalculationReasons)
          data['manualCalculationReasons'].push(item);
      }
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.manualCalculationStatus)) {
        data['manualCalculationStatus'] = [];
        for (let item of this.manualCalculationStatus)
          data['manualCalculationStatus'].push(item);
      }
      if (Array.isArray(this.checkedOutByUsers)) {
        data['checkedOutByUsers'] = [];
        for (let item of this.checkedOutByUsers)
          data['checkedOutByUsers'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationAggregationsQueryResultSuccess
    extends IGetManualCalculationAggregationsQueryResult {
    batchIds: string[] | null;
    employeeIds: string[] | null;
    employeeNames: string[] | null;
    transactionGuids: string[] | null;
    manualCalculationReasons: string[] | null;
    countriesInFootprint: ManualCalculationCountryData[] | null;
    manualCalculationStatus: CalculationStatus[] | null;
    checkedOutByUsers: PortalUser[] | null;
  }

  export class ManualCalculationCountryData
    implements IManualCalculationCountryData
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: IManualCalculationCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface IManualCalculationCountryData {
    countryCode: string;
    countryName: string;
  }

  export class PortalUser implements IPortalUser {
    id!: string;
    email!: string;
    firstName!: string;
    lastName!: string;
    fullName!: string;

    constructor(data?: IPortalUser) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.email = _data['email'] !== undefined ? _data['email'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
      }
    }

    static fromJS(data: any): PortalUser {
      data = typeof data === 'object' ? data : {};
      let result = new PortalUser();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['email'] = this.email !== undefined ? this.email : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      return data;
    }
  }

  export interface IPortalUser {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }

  export class GetManualCalculationAggregationsQueryResultFailure
    extends GetManualCalculationAggregationsQueryResult
    implements IGetManualCalculationAggregationsQueryResultFailure
  {
    constructor(data?: IGetManualCalculationAggregationsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetManualCalculationAggregationsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetManualCalculationAggregationsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetManualCalculationAggregationsQueryResultFailure
    extends IGetManualCalculationAggregationsQueryResult {}

  export class SearchManualCalculationsCommandResult
    implements ISearchManualCalculationsCommandResult
  {
    constructor(data?: ISearchManualCalculationsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchManualCalculationsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SearchManualCalculationsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchManualCalculationsCommandResult {}

  export class SearchManualCalculationsCommandResultSuccess
    extends SearchManualCalculationsCommandResult
    implements ISearchManualCalculationsCommandResultSuccess
  {
    manualCalculationResult!: PageModelOfManualCalculationRowDto;

    constructor(data?: ISearchManualCalculationsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.manualCalculationResult = new PageModelOfManualCalculationRowDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.manualCalculationResult = _data['manualCalculationResult']
          ? PageModelOfManualCalculationRowDto.fromJS(
              _data['manualCalculationResult'],
            )
          : new PageModelOfManualCalculationRowDto();
      }
    }

    static override fromJS(
      data: any,
    ): SearchManualCalculationsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchManualCalculationsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['manualCalculationResult'] = this.manualCalculationResult
        ? this.manualCalculationResult.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchManualCalculationsCommandResultSuccess
    extends ISearchManualCalculationsCommandResult {
    manualCalculationResult: PageModelOfManualCalculationRowDto;
  }

  export class PageModelOfManualCalculationRowDto
    extends PageModel
    implements IPageModelOfManualCalculationRowDto
  {
    items!: ManualCalculationRowDto[];
    totalItems!: number | null;

    constructor(data?: IPageModelOfManualCalculationRowDto) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(ManualCalculationRowDto.fromJS(item));
        } else {
          this.items = <any>null;
        }
        this.totalItems =
          _data['totalItems'] !== undefined ? _data['totalItems'] : <any>null;
      }
    }

    static override fromJS(data: any): PageModelOfManualCalculationRowDto {
      data = typeof data === 'object' ? data : {};
      let result = new PageModelOfManualCalculationRowDto();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalItems'] =
        this.totalItems !== undefined ? this.totalItems : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPageModelOfManualCalculationRowDto extends IPageModel {
    items: ManualCalculationRowDto[];
    totalItems: number | null;
  }

  export class ManualCalculationRowDto implements IManualCalculationRowDto {
    batchId!: string;
    calculationId!: string;
    employeeId!: string;
    employeeName!: string;
    calculationStatus!: CalculationStatus;
    checkedOutBy!: string | null;
    checkedOutByPortalId!: string | null;
    calculationTypes!: BatchCalculationType | null;
    transactions!: ManualCalculationTransactionDto[];
    userCanEditManualCalculation!: boolean;
    calculationTimestamp!: Date | null;

    constructor(data?: IManualCalculationRowDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.employeeName =
          _data['employeeName'] !== undefined
            ? _data['employeeName']
            : <any>null;
        this.calculationStatus =
          _data['calculationStatus'] !== undefined
            ? _data['calculationStatus']
            : <any>null;
        this.checkedOutBy =
          _data['checkedOutBy'] !== undefined
            ? _data['checkedOutBy']
            : <any>null;
        this.checkedOutByPortalId =
          _data['checkedOutByPortalId'] !== undefined
            ? _data['checkedOutByPortalId']
            : <any>null;
        this.calculationTypes =
          _data['calculationTypes'] !== undefined
            ? _data['calculationTypes']
            : <any>null;
        if (Array.isArray(_data['transactions'])) {
          this.transactions = [] as any;
          for (let item of _data['transactions'])
            this.transactions!.push(
              ManualCalculationTransactionDto.fromJS(item),
            );
        } else {
          this.transactions = <any>null;
        }
        this.userCanEditManualCalculation =
          _data['userCanEditManualCalculation'] !== undefined
            ? _data['userCanEditManualCalculation']
            : <any>null;
        this.calculationTimestamp = _data['calculationTimestamp']
          ? new Date(_data['calculationTimestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationRowDto {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationRowDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['employeeName'] =
        this.employeeName !== undefined ? this.employeeName : <any>null;
      data['calculationStatus'] =
        this.calculationStatus !== undefined
          ? this.calculationStatus
          : <any>null;
      data['checkedOutBy'] =
        this.checkedOutBy !== undefined ? this.checkedOutBy : <any>null;
      data['checkedOutByPortalId'] =
        this.checkedOutByPortalId !== undefined
          ? this.checkedOutByPortalId
          : <any>null;
      data['calculationTypes'] =
        this.calculationTypes !== undefined ? this.calculationTypes : <any>null;
      if (Array.isArray(this.transactions)) {
        data['transactions'] = [];
        for (let item of this.transactions)
          data['transactions'].push(item.toJSON());
      }
      data['userCanEditManualCalculation'] =
        this.userCanEditManualCalculation !== undefined
          ? this.userCanEditManualCalculation
          : <any>null;
      data['calculationTimestamp'] = this.calculationTimestamp
        ? this.calculationTimestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface IManualCalculationRowDto {
    batchId: string;
    calculationId: string;
    employeeId: string;
    employeeName: string;
    calculationStatus: CalculationStatus;
    checkedOutBy: string | null;
    checkedOutByPortalId: string | null;
    calculationTypes: BatchCalculationType | null;
    transactions: ManualCalculationTransactionDto[];
    userCanEditManualCalculation: boolean;
    calculationTimestamp: Date | null;
  }

  export class ManualCalculationTransactionDto
    implements IManualCalculationTransactionDto
  {
    transactionGuid!: string;
    planType!: PlanType;
    countries!: string[];
    manualCalculationReason!: string | null;
    transactionStatus!: TransactionStatus | null;
    latestApproverAction!: ManualCalculationWorkflowTransactionAction | null;

    constructor(data?: IManualCalculationTransactionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries']) this.countries!.push(item);
        } else {
          this.countries = <any>null;
        }
        this.manualCalculationReason =
          _data['manualCalculationReason'] !== undefined
            ? _data['manualCalculationReason']
            : <any>null;
        this.transactionStatus =
          _data['transactionStatus'] !== undefined
            ? _data['transactionStatus']
            : <any>null;
        this.latestApproverAction =
          _data['latestApproverAction'] !== undefined
            ? _data['latestApproverAction']
            : <any>null;
      }
    }

    static fromJS(data: any): ManualCalculationTransactionDto {
      data = typeof data === 'object' ? data : {};
      let result = new ManualCalculationTransactionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item);
      }
      data['manualCalculationReason'] =
        this.manualCalculationReason !== undefined
          ? this.manualCalculationReason
          : <any>null;
      data['transactionStatus'] =
        this.transactionStatus !== undefined
          ? this.transactionStatus
          : <any>null;
      data['latestApproverAction'] =
        this.latestApproverAction !== undefined
          ? this.latestApproverAction
          : <any>null;
      return data;
    }
  }

  export interface IManualCalculationTransactionDto {
    transactionGuid: string;
    planType: PlanType;
    countries: string[];
    manualCalculationReason: string | null;
    transactionStatus: TransactionStatus | null;
    latestApproverAction: ManualCalculationWorkflowTransactionAction | null;
  }

  export class SearchManualCalculationsCommandResultFailure
    extends SearchManualCalculationsCommandResult
    implements ISearchManualCalculationsCommandResultFailure
  {
    constructor(data?: ISearchManualCalculationsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SearchManualCalculationsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchManualCalculationsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchManualCalculationsCommandResultFailure
    extends ISearchManualCalculationsCommandResult {}

  export class SearchManualCalculationsCommand
    implements ISearchManualCalculationsCommand
  {
    clientId!: string;
    batchIds!: string[] | null;
    employeeIds!: string[] | null;
    employeeNames!: string[] | null;
    countryCodes!: string[] | null;
    transactionGuids!: string[] | null;
    planTypes!: PlanType[] | null;
    calculationStatus!: CalculationStatus[] | null;
    manualCalculationReasons!: string[] | null;
    query!: string | null;
    checkedOutByUsers!: string[] | null;
    calculationTypes!: BatchCalculationType[] | null;
    page!: number;
    pageSize!: number;

    constructor(data?: ISearchManualCalculationsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
        if (Array.isArray(_data['employeeIds'])) {
          this.employeeIds = [] as any;
          for (let item of _data['employeeIds']) this.employeeIds!.push(item);
        } else {
          this.employeeIds = <any>null;
        }
        if (Array.isArray(_data['employeeNames'])) {
          this.employeeNames = [] as any;
          for (let item of _data['employeeNames'])
            this.employeeNames!.push(item);
        } else {
          this.employeeNames = <any>null;
        }
        if (Array.isArray(_data['countryCodes'])) {
          this.countryCodes = [] as any;
          for (let item of _data['countryCodes']) this.countryCodes!.push(item);
        } else {
          this.countryCodes = <any>null;
        }
        if (Array.isArray(_data['transactionGuids'])) {
          this.transactionGuids = [] as any;
          for (let item of _data['transactionGuids'])
            this.transactionGuids!.push(item);
        } else {
          this.transactionGuids = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['calculationStatus'])) {
          this.calculationStatus = [] as any;
          for (let item of _data['calculationStatus'])
            this.calculationStatus!.push(item);
        } else {
          this.calculationStatus = <any>null;
        }
        if (Array.isArray(_data['manualCalculationReasons'])) {
          this.manualCalculationReasons = [] as any;
          for (let item of _data['manualCalculationReasons'])
            this.manualCalculationReasons!.push(item);
        } else {
          this.manualCalculationReasons = <any>null;
        }
        this.query = _data['query'] !== undefined ? _data['query'] : <any>null;
        if (Array.isArray(_data['checkedOutByUsers'])) {
          this.checkedOutByUsers = [] as any;
          for (let item of _data['checkedOutByUsers'])
            this.checkedOutByUsers!.push(item);
        } else {
          this.checkedOutByUsers = <any>null;
        }
        if (Array.isArray(_data['calculationTypes'])) {
          this.calculationTypes = [] as any;
          for (let item of _data['calculationTypes'])
            this.calculationTypes!.push(item);
        } else {
          this.calculationTypes = <any>null;
        }
        this.page = _data['page'] !== undefined ? _data['page'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): SearchManualCalculationsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchManualCalculationsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      if (Array.isArray(this.employeeIds)) {
        data['employeeIds'] = [];
        for (let item of this.employeeIds) data['employeeIds'].push(item);
      }
      if (Array.isArray(this.employeeNames)) {
        data['employeeNames'] = [];
        for (let item of this.employeeNames) data['employeeNames'].push(item);
      }
      if (Array.isArray(this.countryCodes)) {
        data['countryCodes'] = [];
        for (let item of this.countryCodes) data['countryCodes'].push(item);
      }
      if (Array.isArray(this.transactionGuids)) {
        data['transactionGuids'] = [];
        for (let item of this.transactionGuids)
          data['transactionGuids'].push(item);
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.calculationStatus)) {
        data['calculationStatus'] = [];
        for (let item of this.calculationStatus)
          data['calculationStatus'].push(item);
      }
      if (Array.isArray(this.manualCalculationReasons)) {
        data['manualCalculationReasons'] = [];
        for (let item of this.manualCalculationReasons)
          data['manualCalculationReasons'].push(item);
      }
      data['query'] = this.query !== undefined ? this.query : <any>null;
      if (Array.isArray(this.checkedOutByUsers)) {
        data['checkedOutByUsers'] = [];
        for (let item of this.checkedOutByUsers)
          data['checkedOutByUsers'].push(item);
      }
      if (Array.isArray(this.calculationTypes)) {
        data['calculationTypes'] = [];
        for (let item of this.calculationTypes)
          data['calculationTypes'].push(item);
      }
      data['page'] = this.page !== undefined ? this.page : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface ISearchManualCalculationsCommand {
    clientId: string;
    batchIds: string[] | null;
    employeeIds: string[] | null;
    employeeNames: string[] | null;
    countryCodes: string[] | null;
    transactionGuids: string[] | null;
    planTypes: PlanType[] | null;
    calculationStatus: CalculationStatus[] | null;
    manualCalculationReasons: string[] | null;
    query: string | null;
    checkedOutByUsers: string[] | null;
    calculationTypes: BatchCalculationType[] | null;
    page: number;
    pageSize: number;
  }

  export abstract class CheckOutManualCalculationCommandResult
    implements ICheckOutManualCalculationCommandResult
  {
    constructor(data?: ICheckOutManualCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckOutManualCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckOutManualCalculationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckOutManualCalculationCommandResult {}

  export class CheckOutManualCalculationCommandResultSuccess
    extends CheckOutManualCalculationCommandResult
    implements ICheckOutManualCalculationCommandResultSuccess
  {
    succeededCalcs!: CheckOutManualCalculationResultSuccess[];
    failedCalcs!: CheckOutManualCalculationResultFailure[];

    constructor(data?: ICheckOutManualCalculationCommandResultSuccess) {
      super(data);
      if (!data) {
        this.succeededCalcs = [];
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['succeededCalcs'])) {
          this.succeededCalcs = [] as any;
          for (let item of _data['succeededCalcs'])
            this.succeededCalcs!.push(
              CheckOutManualCalculationResultSuccess.fromJS(item),
            );
        } else {
          this.succeededCalcs = <any>null;
        }
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              CheckOutManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): CheckOutManualCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CheckOutManualCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.succeededCalcs)) {
        data['succeededCalcs'] = [];
        for (let item of this.succeededCalcs)
          data['succeededCalcs'].push(item.toJSON());
      }
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckOutManualCalculationCommandResultSuccess
    extends ICheckOutManualCalculationCommandResult {
    succeededCalcs: CheckOutManualCalculationResultSuccess[];
    failedCalcs: CheckOutManualCalculationResultFailure[];
  }

  export abstract class CheckOutManualCalculationResult
    implements ICheckOutManualCalculationResult
  {
    constructor(data?: ICheckOutManualCalculationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CheckOutManualCalculationResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CheckOutManualCalculationResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICheckOutManualCalculationResult {}

  export class CheckOutManualCalculationResultSuccess
    extends CheckOutManualCalculationResult
    implements ICheckOutManualCalculationResultSuccess
  {
    calculationId!: string;

    constructor(data?: ICheckOutManualCalculationResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static override fromJS(data: any): CheckOutManualCalculationResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CheckOutManualCalculationResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckOutManualCalculationResultSuccess
    extends ICheckOutManualCalculationResult {
    calculationId: string;
  }

  export class CheckOutManualCalculationResultFailure
    extends CheckOutManualCalculationResult
    implements ICheckOutManualCalculationResultFailure
  {
    calculationId!: string;
    errorCode!: CheckOutManualCalculationResultFailureErrorCode;

    constructor(data?: ICheckOutManualCalculationResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(data: any): CheckOutManualCalculationResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckOutManualCalculationResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckOutManualCalculationResultFailure
    extends ICheckOutManualCalculationResult {
    calculationId: string;
    errorCode: CheckOutManualCalculationResultFailureErrorCode;
  }

  export enum CheckOutManualCalculationResultFailureErrorCode {
    CalculationIsAlreadyCheckedOut = 'CalculationIsAlreadyCheckedOut',
    UserIsNotApprover = 'UserIsNotApprover',
    UserIsNotReviewerOrApprover = 'UserIsNotReviewerOrApprover',
    CalculationNotFound = 'CalculationNotFound',
    CalculationIsNotInManualCalculationWorkflow = 'CalculationIsNotInManualCalculationWorkflow',
    CalculationLockAcquisitionFailed = 'CalculationLockAcquisitionFailed',
    Unknown = 'Unknown',
  }

  export class CheckOutManualCalculationCommandResultFailure
    extends CheckOutManualCalculationCommandResult
    implements ICheckOutManualCalculationCommandResultFailure
  {
    failedCalcs!: CheckOutManualCalculationResultFailure[];

    constructor(data?: ICheckOutManualCalculationCommandResultFailure) {
      super(data);
      if (!data) {
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              CheckOutManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): CheckOutManualCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CheckOutManualCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ICheckOutManualCalculationCommandResultFailure
    extends ICheckOutManualCalculationCommandResult {
    failedCalcs: CheckOutManualCalculationResultFailure[];
  }

  export class CheckOutManualCalculationCommand
    implements ICheckOutManualCalculationCommand
  {
    clientId!: string;
    calculationIds!: string[];

    constructor(data?: ICheckOutManualCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
      }
    }

    static fromJS(data: any): CheckOutManualCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CheckOutManualCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      return data;
    }
  }

  export interface ICheckOutManualCalculationCommand {
    clientId: string;
    calculationIds: string[];
  }

  export abstract class ReleaseManualCalculationCommandResult
    implements IReleaseManualCalculationCommandResult
  {
    constructor(data?: IReleaseManualCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ReleaseManualCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReleaseManualCalculationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IReleaseManualCalculationCommandResult {}

  export class ReleaseManualCalculationCommandResultSuccess
    extends ReleaseManualCalculationCommandResult
    implements IReleaseManualCalculationCommandResultSuccess
  {
    succeededCalcs!: ReleaseManualCalculationResultSuccess[];
    failedCalcs!: ReleaseManualCalculationResultFailure[];

    constructor(data?: IReleaseManualCalculationCommandResultSuccess) {
      super(data);
      if (!data) {
        this.succeededCalcs = [];
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['succeededCalcs'])) {
          this.succeededCalcs = [] as any;
          for (let item of _data['succeededCalcs'])
            this.succeededCalcs!.push(
              ReleaseManualCalculationResultSuccess.fromJS(item),
            );
        } else {
          this.succeededCalcs = <any>null;
        }
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ReleaseManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ReleaseManualCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ReleaseManualCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.succeededCalcs)) {
        data['succeededCalcs'] = [];
        for (let item of this.succeededCalcs)
          data['succeededCalcs'].push(item.toJSON());
      }
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IReleaseManualCalculationCommandResultSuccess
    extends IReleaseManualCalculationCommandResult {
    succeededCalcs: ReleaseManualCalculationResultSuccess[];
    failedCalcs: ReleaseManualCalculationResultFailure[];
  }

  export abstract class ReleaseManualCalculationResult
    implements IReleaseManualCalculationResult
  {
    constructor(data?: IReleaseManualCalculationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ReleaseManualCalculationResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReleaseManualCalculationResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IReleaseManualCalculationResult {}

  export class ReleaseManualCalculationResultSuccess
    extends ReleaseManualCalculationResult
    implements IReleaseManualCalculationResultSuccess
  {
    calculationId!: string;

    constructor(data?: IReleaseManualCalculationResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static override fromJS(data: any): ReleaseManualCalculationResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ReleaseManualCalculationResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReleaseManualCalculationResultSuccess
    extends IReleaseManualCalculationResult {
    calculationId: string;
  }

  export class ReleaseManualCalculationResultFailure
    extends ReleaseManualCalculationResult
    implements IReleaseManualCalculationResultFailure
  {
    calculationId!: string;
    errorCode!: ReleaseManualCalculationResultFailureErrorCode;

    constructor(data?: IReleaseManualCalculationResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(data: any): ReleaseManualCalculationResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ReleaseManualCalculationResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReleaseManualCalculationResultFailure
    extends IReleaseManualCalculationResult {
    calculationId: string;
    errorCode: ReleaseManualCalculationResultFailureErrorCode;
  }

  export enum ReleaseManualCalculationResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationIsNotInManualCalculationWorkflow = 'CalculationIsNotInManualCalculationWorkflow',
    CalculationCheckedOutByAnotherMember = 'CalculationCheckedOutByAnotherMember',
    UserIsNotReviewerOrApprover = 'UserIsNotReviewerOrApprover',
    Unknown = 'Unknown',
  }

  export class ReleaseManualCalculationCommandResultFailure
    extends ReleaseManualCalculationCommandResult
    implements IReleaseManualCalculationCommandResultFailure
  {
    failedCalcs!: ReleaseManualCalculationResultFailure[];

    constructor(data?: IReleaseManualCalculationCommandResultFailure) {
      super(data);
      if (!data) {
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ReleaseManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ReleaseManualCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ReleaseManualCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IReleaseManualCalculationCommandResultFailure
    extends IReleaseManualCalculationCommandResult {
    failedCalcs: ReleaseManualCalculationResultFailure[];
  }

  export class ReleaseManualCalculationCommand
    implements IReleaseManualCalculationCommand
  {
    clientId!: string;
    calculationIds!: string[];

    constructor(data?: IReleaseManualCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
      }
    }

    static fromJS(data: any): ReleaseManualCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ReleaseManualCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      return data;
    }
  }

  export interface IReleaseManualCalculationCommand {
    clientId: string;
    calculationIds: string[];
  }

  export abstract class SendForApprovalFromManualCalculationsPageCommandResult
    implements ISendForApprovalFromManualCalculationsPageCommandResult
  {
    constructor(
      data?: ISendForApprovalFromManualCalculationsPageCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): SendForApprovalFromManualCalculationsPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SendForApprovalFromManualCalculationsPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISendForApprovalFromManualCalculationsPageCommandResult {}

  export class SendForApprovalFromManualCalculationsPageCommandResultSuccess
    extends SendForApprovalFromManualCalculationsPageCommandResult
    implements ISendForApprovalFromManualCalculationsPageCommandResultSuccess
  {
    succeededCalcs!: SendForApprovalManualCalculationResultSuccess[];
    failedCalcs!: SendForApprovalManualCalculationResultFailure[];

    constructor(
      data?: ISendForApprovalFromManualCalculationsPageCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.succeededCalcs = [];
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['succeededCalcs'])) {
          this.succeededCalcs = [] as any;
          for (let item of _data['succeededCalcs'])
            this.succeededCalcs!.push(
              SendForApprovalManualCalculationResultSuccess.fromJS(item),
            );
        } else {
          this.succeededCalcs = <any>null;
        }
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              SendForApprovalManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SendForApprovalFromManualCalculationsPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new SendForApprovalFromManualCalculationsPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.succeededCalcs)) {
        data['succeededCalcs'] = [];
        for (let item of this.succeededCalcs)
          data['succeededCalcs'].push(item.toJSON());
      }
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendForApprovalFromManualCalculationsPageCommandResultSuccess
    extends ISendForApprovalFromManualCalculationsPageCommandResult {
    succeededCalcs: SendForApprovalManualCalculationResultSuccess[];
    failedCalcs: SendForApprovalManualCalculationResultFailure[];
  }

  export abstract class SendForApprovalManualCalculationResult
    implements ISendForApprovalManualCalculationResult
  {
    constructor(data?: ISendForApprovalManualCalculationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SendForApprovalManualCalculationResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SendForApprovalManualCalculationResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISendForApprovalManualCalculationResult {}

  export class SendForApprovalManualCalculationResultSuccess
    extends SendForApprovalManualCalculationResult
    implements ISendForApprovalManualCalculationResultSuccess
  {
    calculation!: CalculationIndexModel;

    constructor(data?: ISendForApprovalManualCalculationResultSuccess) {
      super(data);
      if (!data) {
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
      }
    }

    static override fromJS(
      data: any,
    ): SendForApprovalManualCalculationResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SendForApprovalManualCalculationResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendForApprovalManualCalculationResultSuccess
    extends ISendForApprovalManualCalculationResult {
    calculation: CalculationIndexModel;
  }

  export class SendForApprovalManualCalculationResultFailure
    extends SendForApprovalManualCalculationResult
    implements ISendForApprovalManualCalculationResultFailure
  {
    calculationId!: string;
    errorCode!: SendForApprovalManualCalculationResultFailureErrorCode;

    constructor(data?: ISendForApprovalManualCalculationResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SendForApprovalManualCalculationResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SendForApprovalManualCalculationResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendForApprovalManualCalculationResultFailure
    extends ISendForApprovalManualCalculationResult {
    calculationId: string;
    errorCode: SendForApprovalManualCalculationResultFailureErrorCode;
  }

  export enum SendForApprovalManualCalculationResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationIsNotInManualCalculationWorkflow = 'CalculationIsNotInManualCalculationWorkflow',
    CalculationCheckedOutByAnotherMember = 'CalculationCheckedOutByAnotherMember',
    UserIsNotReviewerOrApprover = 'UserIsNotReviewerOrApprover',
    Unknown = 'Unknown',
  }

  export class SendForApprovalFromManualCalculationsPageCommandResultFailure
    extends SendForApprovalFromManualCalculationsPageCommandResult
    implements ISendForApprovalFromManualCalculationsPageCommandResultFailure
  {
    failedCalcs!: SendForApprovalManualCalculationResultFailure[];

    constructor(
      data?: ISendForApprovalFromManualCalculationsPageCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              SendForApprovalManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SendForApprovalFromManualCalculationsPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new SendForApprovalFromManualCalculationsPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISendForApprovalFromManualCalculationsPageCommandResultFailure
    extends ISendForApprovalFromManualCalculationsPageCommandResult {
    failedCalcs: SendForApprovalManualCalculationResultFailure[];
  }

  export class SendForApprovalFromManualCalculationsPageCommand
    implements ISendForApprovalFromManualCalculationsPageCommand
  {
    clientId!: string;
    calculationIds!: string[];

    constructor(data?: ISendForApprovalFromManualCalculationsPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
      }
    }

    static fromJS(data: any): SendForApprovalFromManualCalculationsPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SendForApprovalFromManualCalculationsPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      return data;
    }
  }

  export interface ISendForApprovalFromManualCalculationsPageCommand {
    clientId: string;
    calculationIds: string[];
  }

  export abstract class ReturnCalculationFromManualCalculationsPageCommandResult
    implements IReturnCalculationFromManualCalculationsPageCommandResult
  {
    constructor(
      data?: IReturnCalculationFromManualCalculationsPageCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): ReturnCalculationFromManualCalculationsPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReturnCalculationFromManualCalculationsPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IReturnCalculationFromManualCalculationsPageCommandResult {}

  export class ReturnCalculationFromManualCalculationsPageCommandResultSuccess
    extends ReturnCalculationFromManualCalculationsPageCommandResult
    implements IReturnCalculationFromManualCalculationsPageCommandResultSuccess
  {
    succeededCalcs!: ReturnToReviewerManualCalculationResultSuccess[];
    failedCalcs!: ReturnToReviewerManualCalculationResultFailure[];

    constructor(
      data?: IReturnCalculationFromManualCalculationsPageCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.succeededCalcs = [];
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['succeededCalcs'])) {
          this.succeededCalcs = [] as any;
          for (let item of _data['succeededCalcs'])
            this.succeededCalcs!.push(
              ReturnToReviewerManualCalculationResultSuccess.fromJS(item),
            );
        } else {
          this.succeededCalcs = <any>null;
        }
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ReturnToReviewerManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ReturnCalculationFromManualCalculationsPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new ReturnCalculationFromManualCalculationsPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.succeededCalcs)) {
        data['succeededCalcs'] = [];
        for (let item of this.succeededCalcs)
          data['succeededCalcs'].push(item.toJSON());
      }
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnCalculationFromManualCalculationsPageCommandResultSuccess
    extends IReturnCalculationFromManualCalculationsPageCommandResult {
    succeededCalcs: ReturnToReviewerManualCalculationResultSuccess[];
    failedCalcs: ReturnToReviewerManualCalculationResultFailure[];
  }

  export abstract class ReturnToReviewerManualCalculationResult
    implements IReturnToReviewerManualCalculationResult
  {
    constructor(data?: IReturnToReviewerManualCalculationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ReturnToReviewerManualCalculationResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ReturnToReviewerManualCalculationResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IReturnToReviewerManualCalculationResult {}

  export class ReturnToReviewerManualCalculationResultSuccess
    extends ReturnToReviewerManualCalculationResult
    implements IReturnToReviewerManualCalculationResultSuccess
  {
    calculation!: CalculationIndexModel;

    constructor(data?: IReturnToReviewerManualCalculationResultSuccess) {
      super(data);
      if (!data) {
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
      }
    }

    static override fromJS(
      data: any,
    ): ReturnToReviewerManualCalculationResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnToReviewerManualCalculationResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnToReviewerManualCalculationResultSuccess
    extends IReturnToReviewerManualCalculationResult {
    calculation: CalculationIndexModel;
  }

  export class ReturnToReviewerManualCalculationResultFailure
    extends ReturnToReviewerManualCalculationResult
    implements IReturnToReviewerManualCalculationResultFailure
  {
    calculationId!: string;
    errorCode!: ReturnToReviewerManualCalculationResultFailureErrorCode;

    constructor(data?: IReturnToReviewerManualCalculationResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): ReturnToReviewerManualCalculationResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnToReviewerManualCalculationResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnToReviewerManualCalculationResultFailure
    extends IReturnToReviewerManualCalculationResult {
    calculationId: string;
    errorCode: ReturnToReviewerManualCalculationResultFailureErrorCode;
  }

  export enum ReturnToReviewerManualCalculationResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationNotInPendingApproval = 'CalculationNotInPendingApproval',
    UserIsNotApprover = 'UserIsNotApprover',
    CommentTooLong = 'CommentTooLong',
    Unknown = 'Unknown',
  }

  export class ReturnCalculationFromManualCalculationsPageCommandResultFailure
    extends ReturnCalculationFromManualCalculationsPageCommandResult
    implements IReturnCalculationFromManualCalculationsPageCommandResultFailure
  {
    failedCalcs!: ReturnToReviewerManualCalculationResultFailure[];

    constructor(
      data?: IReturnCalculationFromManualCalculationsPageCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ReturnToReviewerManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ReturnCalculationFromManualCalculationsPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new ReturnCalculationFromManualCalculationsPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IReturnCalculationFromManualCalculationsPageCommandResultFailure
    extends IReturnCalculationFromManualCalculationsPageCommandResult {
    failedCalcs: ReturnToReviewerManualCalculationResultFailure[];
  }

  export class ReturnCalculationFromManualCalculationsPageCommand
    implements IReturnCalculationFromManualCalculationsPageCommand
  {
    clientId!: string;
    calculationIds!: string[];
    comment!: string | null;

    constructor(data?: IReturnCalculationFromManualCalculationsPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): ReturnCalculationFromManualCalculationsPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ReturnCalculationFromManualCalculationsPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IReturnCalculationFromManualCalculationsPageCommand {
    clientId: string;
    calculationIds: string[];
    comment: string | null;
  }

  export abstract class ApproveCalculationFromManualCalculationsPageCommandResult
    implements IApproveCalculationFromManualCalculationsPageCommandResult
  {
    constructor(
      data?: IApproveCalculationFromManualCalculationsPageCommandResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): ApproveCalculationFromManualCalculationsPageCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ApproveCalculationFromManualCalculationsPageCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IApproveCalculationFromManualCalculationsPageCommandResult {}

  export class ApproveCalculationFromManualCalculationsPageCommandResultSuccess
    extends ApproveCalculationFromManualCalculationsPageCommandResult
    implements IApproveCalculationFromManualCalculationsPageCommandResultSuccess
  {
    succeededCalcs!: ApproveManualCalculationResultSuccess[];
    failedCalcs!: ApproveManualCalculationResultFailure[];

    constructor(
      data?: IApproveCalculationFromManualCalculationsPageCommandResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.succeededCalcs = [];
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['succeededCalcs'])) {
          this.succeededCalcs = [] as any;
          for (let item of _data['succeededCalcs'])
            this.succeededCalcs!.push(
              ApproveManualCalculationResultSuccess.fromJS(item),
            );
        } else {
          this.succeededCalcs = <any>null;
        }
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ApproveManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ApproveCalculationFromManualCalculationsPageCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new ApproveCalculationFromManualCalculationsPageCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.succeededCalcs)) {
        data['succeededCalcs'] = [];
        for (let item of this.succeededCalcs)
          data['succeededCalcs'].push(item.toJSON());
      }
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveCalculationFromManualCalculationsPageCommandResultSuccess
    extends IApproveCalculationFromManualCalculationsPageCommandResult {
    succeededCalcs: ApproveManualCalculationResultSuccess[];
    failedCalcs: ApproveManualCalculationResultFailure[];
  }

  export abstract class ApproveManualCalculationResult
    implements IApproveManualCalculationResult
  {
    constructor(data?: IApproveManualCalculationResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ApproveManualCalculationResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'ApproveManualCalculationResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IApproveManualCalculationResult {}

  export class ApproveManualCalculationResultSuccess
    extends ApproveManualCalculationResult
    implements IApproveManualCalculationResultSuccess
  {
    calculation!: CalculationIndexModel;

    constructor(data?: IApproveManualCalculationResultSuccess) {
      super(data);
      if (!data) {
        this.calculation = new CalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculation = _data['calculation']
          ? CalculationIndexModel.fromJS(_data['calculation'])
          : new CalculationIndexModel();
      }
    }

    static override fromJS(data: any): ApproveManualCalculationResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveManualCalculationResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculation'] = this.calculation
        ? this.calculation.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveManualCalculationResultSuccess
    extends IApproveManualCalculationResult {
    calculation: CalculationIndexModel;
  }

  export class ApproveManualCalculationResultFailure
    extends ApproveManualCalculationResult
    implements IApproveManualCalculationResultFailure
  {
    calculationId!: string;
    errorCode!: ApproveManualCalculationResultFailureErrorCode;

    constructor(data?: IApproveManualCalculationResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(data: any): ApproveManualCalculationResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveManualCalculationResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveManualCalculationResultFailure
    extends IApproveManualCalculationResult {
    calculationId: string;
    errorCode: ApproveManualCalculationResultFailureErrorCode;
  }

  export enum ApproveManualCalculationResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    CalculationIsNotInManualCalculationWorkflow = 'CalculationIsNotInManualCalculationWorkflow',
    UserIsNotApprover = 'UserIsNotApprover',
    CommentTooLong = 'CommentTooLong',
    Unknown = 'Unknown',
  }

  export class ApproveCalculationFromManualCalculationsPageCommandResultFailure
    extends ApproveCalculationFromManualCalculationsPageCommandResult
    implements IApproveCalculationFromManualCalculationsPageCommandResultFailure
  {
    failedCalcs!: ApproveManualCalculationResultFailure[];

    constructor(
      data?: IApproveCalculationFromManualCalculationsPageCommandResultFailure,
    ) {
      super(data);
      if (!data) {
        this.failedCalcs = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['failedCalcs'])) {
          this.failedCalcs = [] as any;
          for (let item of _data['failedCalcs'])
            this.failedCalcs!.push(
              ApproveManualCalculationResultFailure.fromJS(item),
            );
        } else {
          this.failedCalcs = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): ApproveCalculationFromManualCalculationsPageCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new ApproveCalculationFromManualCalculationsPageCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.failedCalcs)) {
        data['failedCalcs'] = [];
        for (let item of this.failedCalcs)
          data['failedCalcs'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IApproveCalculationFromManualCalculationsPageCommandResultFailure
    extends IApproveCalculationFromManualCalculationsPageCommandResult {
    failedCalcs: ApproveManualCalculationResultFailure[];
  }

  export class ApproveCalculationFromManualCalculationsPageCommand
    implements IApproveCalculationFromManualCalculationsPageCommand
  {
    clientId!: string;
    calculationIds!: string[];

    constructor(data?: IApproveCalculationFromManualCalculationsPageCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): ApproveCalculationFromManualCalculationsPageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ApproveCalculationFromManualCalculationsPageCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      return data;
    }
  }

  export interface IApproveCalculationFromManualCalculationsPageCommand {
    clientId: string;
    calculationIds: string[];
  }

  export abstract class DownloadManualCalculationCommandResult
    implements IDownloadManualCalculationCommandResult
  {
    constructor(data?: IDownloadManualCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadManualCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadManualCalculationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadManualCalculationCommandResult {}

  export class DownloadManualCalculationCommandResultSuccess
    extends DownloadManualCalculationCommandResult
    implements IDownloadManualCalculationCommandResultSuccess
  {
    downloadManualCalculationJobId!: string;

    constructor(data?: IDownloadManualCalculationCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.downloadManualCalculationJobId =
          _data['downloadManualCalculationJobId'] !== undefined
            ? _data['downloadManualCalculationJobId']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadManualCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadManualCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['downloadManualCalculationJobId'] =
        this.downloadManualCalculationJobId !== undefined
          ? this.downloadManualCalculationJobId
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadManualCalculationCommandResultSuccess
    extends IDownloadManualCalculationCommandResult {
    downloadManualCalculationJobId: string;
  }

  export class DownloadManualCalculationCommandResultFailure
    extends DownloadManualCalculationCommandResult
    implements IDownloadManualCalculationCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IDownloadManualCalculationCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadManualCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadManualCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadManualCalculationCommandResultFailure
    extends IDownloadManualCalculationCommandResult {
    errorMessage: string;
  }

  export class DownloadManualCalculationCommand
    implements IDownloadManualCalculationCommand
  {
    clientId!: string;
    manualCompleted!: boolean;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IDownloadManualCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.manualCompleted =
          _data['manualCompleted'] !== undefined
            ? _data['manualCompleted']
            : <any>null;
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): DownloadManualCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadManualCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['manualCompleted'] =
        this.manualCompleted !== undefined ? this.manualCompleted : <any>null;
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      return data;
    }
  }

  export interface IDownloadManualCalculationCommand {
    clientId: string;
    manualCompleted: boolean;
    startDate: Date;
    endDate: Date;
  }

  export abstract class GetDownloadManualCalculationsDetailsByJobIdQueryResult
    implements IGetDownloadManualCalculationsDetailsByJobIdQueryResult
  {
    constructor(
      data?: IGetDownloadManualCalculationsDetailsByJobIdQueryResult,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetDownloadManualCalculationsDetailsByJobIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDownloadManualCalculationsDetailsByJobIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDownloadManualCalculationsDetailsByJobIdQueryResult {}

  export class GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess
    extends GetDownloadManualCalculationsDetailsByJobIdQueryResult
    implements IGetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess
  {
    downloadManualCalculationsDetailsByJobIdDto!: GetDownloadManualCalculationsDetailsByJobIdDto;

    constructor(
      data?: IGetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess,
    ) {
      super(data);
      if (!data) {
        this.downloadManualCalculationsDetailsByJobIdDto =
          new GetDownloadManualCalculationsDetailsByJobIdDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.downloadManualCalculationsDetailsByJobIdDto = _data[
          'downloadManualCalculationsDetailsByJobIdDto'
        ]
          ? GetDownloadManualCalculationsDetailsByJobIdDto.fromJS(
              _data['downloadManualCalculationsDetailsByJobIdDto'],
            )
          : new GetDownloadManualCalculationsDetailsByJobIdDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['downloadManualCalculationsDetailsByJobIdDto'] = this
        .downloadManualCalculationsDetailsByJobIdDto
        ? this.downloadManualCalculationsDetailsByJobIdDto.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDownloadManualCalculationsDetailsByJobIdQueryResultSuccess
    extends IGetDownloadManualCalculationsDetailsByJobIdQueryResult {
    downloadManualCalculationsDetailsByJobIdDto: GetDownloadManualCalculationsDetailsByJobIdDto;
  }

  export class GetDownloadManualCalculationsDetailsByJobIdDto
    implements IGetDownloadManualCalculationsDetailsByJobIdDto
  {
    jobId!: string;
    status!: DownloadFilesJobStatus;
    preSignedUrl!: string;

    constructor(data?: IGetDownloadManualCalculationsDetailsByJobIdDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.jobId = _data['jobId'] !== undefined ? _data['jobId'] : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
        this.preSignedUrl =
          _data['preSignedUrl'] !== undefined
            ? _data['preSignedUrl']
            : <any>null;
      }
    }

    static fromJS(data: any): GetDownloadManualCalculationsDetailsByJobIdDto {
      data = typeof data === 'object' ? data : {};
      let result = new GetDownloadManualCalculationsDetailsByJobIdDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['jobId'] = this.jobId !== undefined ? this.jobId : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      data['preSignedUrl'] =
        this.preSignedUrl !== undefined ? this.preSignedUrl : <any>null;
      return data;
    }
  }

  export interface IGetDownloadManualCalculationsDetailsByJobIdDto {
    jobId: string;
    status: DownloadFilesJobStatus;
    preSignedUrl: string;
  }

  export enum DownloadFilesJobStatus {
    Pending = 'Pending',
    Completed = 'Completed',
  }

  export class GetDownloadManualCalculationsDetailsByJobIdQueryResultFailure
    extends GetDownloadManualCalculationsDetailsByJobIdQueryResult
    implements IGetDownloadManualCalculationsDetailsByJobIdQueryResultFailure
  {
    constructor(
      data?: IGetDownloadManualCalculationsDetailsByJobIdQueryResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetDownloadManualCalculationsDetailsByJobIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetDownloadManualCalculationsDetailsByJobIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDownloadManualCalculationsDetailsByJobIdQueryResultFailure
    extends IGetDownloadManualCalculationsDetailsByJobIdQueryResult {}

  export abstract class GetMobilityInformationPageDataQueryResult
    implements IGetMobilityInformationPageDataQueryResult
  {
    constructor(data?: IGetMobilityInformationPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetMobilityInformationPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetMobilityInformationPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetMobilityInformationPageDataQueryResult {}

  export class GetMobilityInformationPageDataQueryResultSuccess
    extends GetMobilityInformationPageDataQueryResult
    implements IGetMobilityInformationPageDataQueryResultSuccess
  {
    result!: MobilityInformationPageData;

    constructor(data?: IGetMobilityInformationPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new MobilityInformationPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? MobilityInformationPageData.fromJS(_data['result'])
          : new MobilityInformationPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetMobilityInformationPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetMobilityInformationPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetMobilityInformationPageDataQueryResultSuccess
    extends IGetMobilityInformationPageDataQueryResult {
    result: MobilityInformationPageData;
  }

  export class MobilityInformationPageData
    implements IMobilityInformationPageData
  {
    workLocationTypes!: MobilityInformationWorkLocationTypeDto[];

    constructor(data?: IMobilityInformationPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(
              MobilityInformationWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.workLocationTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): MobilityInformationPageData {
      data = typeof data === 'object' ? data : {};
      let result = new MobilityInformationPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IMobilityInformationPageData {
    workLocationTypes: MobilityInformationWorkLocationTypeDto[];
  }

  export class MobilityInformationWorkLocationTypeDto
    implements IMobilityInformationWorkLocationTypeDto
  {
    display!: string;
    code!: WorkLocationTypeSetting;

    constructor(data?: IMobilityInformationWorkLocationTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): MobilityInformationWorkLocationTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new MobilityInformationWorkLocationTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface IMobilityInformationWorkLocationTypeDto {
    display: string;
    code: WorkLocationTypeSetting;
  }

  export class GetMobilityInformationPageDataQueryResultFailure
    extends GetMobilityInformationPageDataQueryResult
    implements IGetMobilityInformationPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetMobilityInformationPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetMobilityInformationPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetMobilityInformationPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetMobilityInformationPageDataQueryResultFailure
    extends IGetMobilityInformationPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetTransactionInformationPageDataQueryResult
    implements IGetTransactionInformationPageDataQueryResult
  {
    constructor(data?: IGetTransactionInformationPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetTransactionInformationPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetTransactionInformationPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetTransactionInformationPageDataQueryResult {}

  export class GetTransactionInformationPageDataQueryResultSuccess
    extends GetTransactionInformationPageDataQueryResult
    implements IGetTransactionInformationPageDataQueryResultSuccess
  {
    result!: TransactionInformationPageData;

    constructor(data?: IGetTransactionInformationPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new TransactionInformationPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? TransactionInformationPageData.fromJS(_data['result'])
          : new TransactionInformationPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetTransactionInformationPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetTransactionInformationPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTransactionInformationPageDataQueryResultSuccess
    extends IGetTransactionInformationPageDataQueryResult {
    result: TransactionInformationPageData;
  }

  export class TransactionInformationPageData
    implements ITransactionInformationPageData
  {
    batchCalculationType!: BatchCalculationTypeDto[];
    planSetupDetails!: PlanSetupDetailsDto;
    deliveryTypes!: DeliveryTypeDto[];
    taxWithholdingMethods!: TaxWithholdingMethodDto[];

    constructor(data?: ITransactionInformationPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchCalculationType = [];
        this.planSetupDetails = new PlanSetupDetailsDto();
        this.deliveryTypes = [];
        this.taxWithholdingMethods = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['batchCalculationType'])) {
          this.batchCalculationType = [] as any;
          for (let item of _data['batchCalculationType'])
            this.batchCalculationType!.push(
              BatchCalculationTypeDto.fromJS(item),
            );
        } else {
          this.batchCalculationType = <any>null;
        }
        this.planSetupDetails = _data['planSetupDetails']
          ? PlanSetupDetailsDto.fromJS(_data['planSetupDetails'])
          : new PlanSetupDetailsDto();
        if (Array.isArray(_data['deliveryTypes'])) {
          this.deliveryTypes = [] as any;
          for (let item of _data['deliveryTypes'])
            this.deliveryTypes!.push(DeliveryTypeDto.fromJS(item));
        } else {
          this.deliveryTypes = <any>null;
        }
        if (Array.isArray(_data['taxWithholdingMethods'])) {
          this.taxWithholdingMethods = [] as any;
          for (let item of _data['taxWithholdingMethods'])
            this.taxWithholdingMethods!.push(
              TaxWithholdingMethodDto.fromJS(item),
            );
        } else {
          this.taxWithholdingMethods = <any>null;
        }
      }
    }

    static fromJS(data: any): TransactionInformationPageData {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionInformationPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchCalculationType)) {
        data['batchCalculationType'] = [];
        for (let item of this.batchCalculationType)
          data['batchCalculationType'].push(item.toJSON());
      }
      data['planSetupDetails'] = this.planSetupDetails
        ? this.planSetupDetails.toJSON()
        : <any>null;
      if (Array.isArray(this.deliveryTypes)) {
        data['deliveryTypes'] = [];
        for (let item of this.deliveryTypes)
          data['deliveryTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.taxWithholdingMethods)) {
        data['taxWithholdingMethods'] = [];
        for (let item of this.taxWithholdingMethods)
          data['taxWithholdingMethods'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITransactionInformationPageData {
    batchCalculationType: BatchCalculationTypeDto[];
    planSetupDetails: PlanSetupDetailsDto;
    deliveryTypes: DeliveryTypeDto[];
    taxWithholdingMethods: TaxWithholdingMethodDto[];
  }

  export class BatchCalculationTypeDto implements IBatchCalculationTypeDto {
    optionValue!: BatchCalculationType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IBatchCalculationTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): BatchCalculationTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new BatchCalculationTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IBatchCalculationTypeDto {
    optionValue: BatchCalculationType;
    displayValue: string;
    displayOrder: number;
  }

  export class DeliveryTypeDto implements IDeliveryTypeDto {
    optionValue!: DeliveryType;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IDeliveryTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): DeliveryTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeliveryTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IDeliveryTypeDto {
    optionValue: DeliveryType;
    displayValue: string;
    displayOrder: number;
  }

  export class TaxWithholdingMethodDto implements ITaxWithholdingMethodDto {
    optionValue!: TaxWithholdingMethod;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: ITaxWithholdingMethodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): TaxWithholdingMethodDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxWithholdingMethodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface ITaxWithholdingMethodDto {
    optionValue: TaxWithholdingMethod;
    displayValue: string;
    displayOrder: number;
  }

  export class GetTransactionInformationPageDataQueryResultFailure
    extends GetTransactionInformationPageDataQueryResult
    implements IGetTransactionInformationPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetTransactionInformationPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetTransactionInformationPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetTransactionInformationPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetTransactionInformationPageDataQueryResultFailure
    extends IGetTransactionInformationPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetLocationPeriodPageDataQueryResult
    implements IGetLocationPeriodPageDataQueryResult
  {
    constructor(data?: IGetLocationPeriodPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetLocationPeriodPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetLocationPeriodPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetLocationPeriodPageDataQueryResult {}

  export class GetLocationPeriodPageDataQueryResultSuccess
    extends GetLocationPeriodPageDataQueryResult
    implements IGetLocationPeriodPageDataQueryResultSuccess
  {
    result!: LocationPeriodPageData;

    constructor(data?: IGetLocationPeriodPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new LocationPeriodPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? LocationPeriodPageData.fromJS(_data['result'])
          : new LocationPeriodPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetLocationPeriodPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetLocationPeriodPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLocationPeriodPageDataQueryResultSuccess
    extends IGetLocationPeriodPageDataQueryResult {
    result: LocationPeriodPageData;
  }

  export class LocationPeriodPageData implements ILocationPeriodPageData {
    clientWorkLocationTypes!: LocationPeriodPageClientWorkLocationTypeDto[];

    constructor(data?: ILocationPeriodPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.clientWorkLocationTypes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['clientWorkLocationTypes'])) {
          this.clientWorkLocationTypes = [] as any;
          for (let item of _data['clientWorkLocationTypes'])
            this.clientWorkLocationTypes!.push(
              LocationPeriodPageClientWorkLocationTypeDto.fromJS(item),
            );
        } else {
          this.clientWorkLocationTypes = <any>null;
        }
      }
    }

    static fromJS(data: any): LocationPeriodPageData {
      data = typeof data === 'object' ? data : {};
      let result = new LocationPeriodPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.clientWorkLocationTypes)) {
        data['clientWorkLocationTypes'] = [];
        for (let item of this.clientWorkLocationTypes)
          data['clientWorkLocationTypes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILocationPeriodPageData {
    clientWorkLocationTypes: LocationPeriodPageClientWorkLocationTypeDto[];
  }

  export class LocationPeriodPageClientWorkLocationTypeDto
    implements ILocationPeriodPageClientWorkLocationTypeDto
  {
    clientWorkLocationType!: string;
    deloitteWorkLocationType!: WorkLocationType;

    constructor(data?: ILocationPeriodPageClientWorkLocationTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        this.deloitteWorkLocationType =
          _data['deloitteWorkLocationType'] !== undefined
            ? _data['deloitteWorkLocationType']
            : <any>null;
      }
    }

    static fromJS(data: any): LocationPeriodPageClientWorkLocationTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new LocationPeriodPageClientWorkLocationTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      data['deloitteWorkLocationType'] =
        this.deloitteWorkLocationType !== undefined
          ? this.deloitteWorkLocationType
          : <any>null;
      return data;
    }
  }

  export interface ILocationPeriodPageClientWorkLocationTypeDto {
    clientWorkLocationType: string;
    deloitteWorkLocationType: WorkLocationType;
  }

  export class GetLocationPeriodPageDataQueryResultFailure
    extends GetLocationPeriodPageDataQueryResult
    implements IGetLocationPeriodPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetLocationPeriodPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetLocationPeriodPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetLocationPeriodPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLocationPeriodPageDataQueryResultFailure
    extends IGetLocationPeriodPageDataQueryResult {
    errors: ResultError[];
  }

  export class GetEmployeeHypoProfilePageDataQueryResult
    implements IGetEmployeeHypoProfilePageDataQueryResult
  {
    constructor(data?: IGetEmployeeHypoProfilePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetEmployeeHypoProfilePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeHypoProfilePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetEmployeeHypoProfilePageDataQueryResult {}

  export class GetEmployeeHypoProfilePageDataQueryResultSuccess
    extends GetEmployeeHypoProfilePageDataQueryResult
    implements IGetEmployeeHypoProfilePageDataQueryResultSuccess
  {
    result!: EmployeeHypoProfilePageData;

    constructor(data?: IGetEmployeeHypoProfilePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new EmployeeHypoProfilePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? EmployeeHypoProfilePageData.fromJS(_data['result'])
          : new EmployeeHypoProfilePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeHypoProfilePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeHypoProfilePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeHypoProfilePageDataQueryResultSuccess
    extends IGetEmployeeHypoProfilePageDataQueryResult {
    result: EmployeeHypoProfilePageData;
  }

  export class EmployeeHypoProfilePageData
    implements IEmployeeHypoProfilePageData
  {
    profileTypes!: HypotheticalProfileRateTypeDto[];
    countries!: HypotheticalProfileCountryDto[];
    regions!: HypotheticalProfileRegionDto[];
    customTaxCodes!: string[];
    profileType!: HypotheticalProfileRateType | null;
    applyToAllTransactions!: boolean | null;
    countryProfileForAllTransactions!: EmployeeHypotheticalCountryProfileDto | null;
    countryProfiles!: EmployeeHypotheticalCountryProfileDto[];
    flatRateProfileForAllTransactions!: EmployeeHypotheticalFlatRateProfileDto | null;
    flatRateProfiles!: EmployeeHypotheticalFlatRateProfileDto[];

    constructor(data?: IEmployeeHypoProfilePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.profileTypes = [];
        this.countries = [];
        this.regions = [];
        this.customTaxCodes = [];
        this.countryProfiles = [];
        this.flatRateProfiles = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['profileTypes'])) {
          this.profileTypes = [] as any;
          for (let item of _data['profileTypes'])
            this.profileTypes!.push(
              HypotheticalProfileRateTypeDto.fromJS(item),
            );
        } else {
          this.profileTypes = <any>null;
        }
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(HypotheticalProfileCountryDto.fromJS(item));
        } else {
          this.countries = <any>null;
        }
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(HypotheticalProfileRegionDto.fromJS(item));
        } else {
          this.regions = <any>null;
        }
        if (Array.isArray(_data['customTaxCodes'])) {
          this.customTaxCodes = [] as any;
          for (let item of _data['customTaxCodes'])
            this.customTaxCodes!.push(item);
        } else {
          this.customTaxCodes = <any>null;
        }
        this.profileType =
          _data['profileType'] !== undefined ? _data['profileType'] : <any>null;
        this.applyToAllTransactions =
          _data['applyToAllTransactions'] !== undefined
            ? _data['applyToAllTransactions']
            : <any>null;
        this.countryProfileForAllTransactions = _data[
          'countryProfileForAllTransactions'
        ]
          ? EmployeeHypotheticalCountryProfileDto.fromJS(
              _data['countryProfileForAllTransactions'],
            )
          : <any>null;
        if (Array.isArray(_data['countryProfiles'])) {
          this.countryProfiles = [] as any;
          for (let item of _data['countryProfiles'])
            this.countryProfiles!.push(
              EmployeeHypotheticalCountryProfileDto.fromJS(item),
            );
        } else {
          this.countryProfiles = <any>null;
        }
        this.flatRateProfileForAllTransactions = _data[
          'flatRateProfileForAllTransactions'
        ]
          ? EmployeeHypotheticalFlatRateProfileDto.fromJS(
              _data['flatRateProfileForAllTransactions'],
            )
          : <any>null;
        if (Array.isArray(_data['flatRateProfiles'])) {
          this.flatRateProfiles = [] as any;
          for (let item of _data['flatRateProfiles'])
            this.flatRateProfiles!.push(
              EmployeeHypotheticalFlatRateProfileDto.fromJS(item),
            );
        } else {
          this.flatRateProfiles = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeHypoProfilePageData {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeHypoProfilePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.profileTypes)) {
        data['profileTypes'] = [];
        for (let item of this.profileTypes)
          data['profileTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      if (Array.isArray(this.customTaxCodes)) {
        data['customTaxCodes'] = [];
        for (let item of this.customTaxCodes) data['customTaxCodes'].push(item);
      }
      data['profileType'] =
        this.profileType !== undefined ? this.profileType : <any>null;
      data['applyToAllTransactions'] =
        this.applyToAllTransactions !== undefined
          ? this.applyToAllTransactions
          : <any>null;
      data['countryProfileForAllTransactions'] = this
        .countryProfileForAllTransactions
        ? this.countryProfileForAllTransactions.toJSON()
        : <any>null;
      if (Array.isArray(this.countryProfiles)) {
        data['countryProfiles'] = [];
        for (let item of this.countryProfiles)
          data['countryProfiles'].push(item.toJSON());
      }
      data['flatRateProfileForAllTransactions'] = this
        .flatRateProfileForAllTransactions
        ? this.flatRateProfileForAllTransactions.toJSON()
        : <any>null;
      if (Array.isArray(this.flatRateProfiles)) {
        data['flatRateProfiles'] = [];
        for (let item of this.flatRateProfiles)
          data['flatRateProfiles'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeeHypoProfilePageData {
    profileTypes: HypotheticalProfileRateTypeDto[];
    countries: HypotheticalProfileCountryDto[];
    regions: HypotheticalProfileRegionDto[];
    customTaxCodes: string[];
    profileType: HypotheticalProfileRateType | null;
    applyToAllTransactions: boolean | null;
    countryProfileForAllTransactions: EmployeeHypotheticalCountryProfileDto | null;
    countryProfiles: EmployeeHypotheticalCountryProfileDto[];
    flatRateProfileForAllTransactions: EmployeeHypotheticalFlatRateProfileDto | null;
    flatRateProfiles: EmployeeHypotheticalFlatRateProfileDto[];
  }

  export class HypotheticalProfileRateTypeDto
    implements IHypotheticalProfileRateTypeDto
  {
    optionValue!: HypotheticalProfileRateType;
    displayValue!: string;
    displayOrder!: number;
    disabled!: boolean | null;

    constructor(data?: IHypotheticalProfileRateTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
        this.disabled =
          _data['disabled'] !== undefined ? _data['disabled'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalProfileRateTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalProfileRateTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      data['disabled'] =
        this.disabled !== undefined ? this.disabled : <any>null;
      return data;
    }
  }

  export interface IHypotheticalProfileRateTypeDto {
    optionValue: HypotheticalProfileRateType;
    displayValue: string;
    displayOrder: number;
    disabled: boolean | null;
  }

  export class HypotheticalProfileCountryDto
    implements IHypotheticalProfileCountryDto
  {
    isoCode!: string;
    display!: string;

    constructor(data?: IHypotheticalProfileCountryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalProfileCountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalProfileCountryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IHypotheticalProfileCountryDto {
    isoCode: string;
    display: string;
  }

  export class HypotheticalProfileRegionDto
    implements IHypotheticalProfileRegionDto
  {
    countryIsoCode!: string;
    isoCode!: string;
    display!: string;

    constructor(data?: IHypotheticalProfileRegionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryIsoCode =
          _data['countryIsoCode'] !== undefined
            ? _data['countryIsoCode']
            : <any>null;
        this.isoCode =
          _data['isoCode'] !== undefined ? _data['isoCode'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
      }
    }

    static fromJS(data: any): HypotheticalProfileRegionDto {
      data = typeof data === 'object' ? data : {};
      let result = new HypotheticalProfileRegionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryIsoCode'] =
        this.countryIsoCode !== undefined ? this.countryIsoCode : <any>null;
      data['isoCode'] = this.isoCode !== undefined ? this.isoCode : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      return data;
    }
  }

  export interface IHypotheticalProfileRegionDto {
    countryIsoCode: string;
    isoCode: string;
    display: string;
  }

  export class EmployeeHypotheticalCountryProfileDto
    implements IEmployeeHypotheticalCountryProfileDto
  {
    country!: string | null;
    regionCountry!: string | null;
    region!: string | null;
    socialCountry!: string | null;
    customTaxCodes!: string[];
    transactionIds!: string[];

    constructor(data?: IEmployeeHypotheticalCountryProfileDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.customTaxCodes = [];
        this.transactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.country =
          _data['country'] !== undefined ? _data['country'] : <any>null;
        this.regionCountry =
          _data['regionCountry'] !== undefined
            ? _data['regionCountry']
            : <any>null;
        this.region =
          _data['region'] !== undefined ? _data['region'] : <any>null;
        this.socialCountry =
          _data['socialCountry'] !== undefined
            ? _data['socialCountry']
            : <any>null;
        if (Array.isArray(_data['customTaxCodes'])) {
          this.customTaxCodes = [] as any;
          for (let item of _data['customTaxCodes'])
            this.customTaxCodes!.push(item);
        } else {
          this.customTaxCodes = <any>null;
        }
        if (Array.isArray(_data['transactionIds'])) {
          this.transactionIds = [] as any;
          for (let item of _data['transactionIds'])
            this.transactionIds!.push(item);
        } else {
          this.transactionIds = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeHypotheticalCountryProfileDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeHypotheticalCountryProfileDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['country'] = this.country !== undefined ? this.country : <any>null;
      data['regionCountry'] =
        this.regionCountry !== undefined ? this.regionCountry : <any>null;
      data['region'] = this.region !== undefined ? this.region : <any>null;
      data['socialCountry'] =
        this.socialCountry !== undefined ? this.socialCountry : <any>null;
      if (Array.isArray(this.customTaxCodes)) {
        data['customTaxCodes'] = [];
        for (let item of this.customTaxCodes) data['customTaxCodes'].push(item);
      }
      if (Array.isArray(this.transactionIds)) {
        data['transactionIds'] = [];
        for (let item of this.transactionIds) data['transactionIds'].push(item);
      }
      return data;
    }
  }

  export interface IEmployeeHypotheticalCountryProfileDto {
    country: string | null;
    regionCountry: string | null;
    region: string | null;
    socialCountry: string | null;
    customTaxCodes: string[];
    transactionIds: string[];
  }

  export class EmployeeHypotheticalFlatRateProfileDto
    implements IEmployeeHypotheticalFlatRateProfileDto
  {
    countryRate!: number | null;
    regionRate!: number | null;
    socialCountryRate!: number | null;
    transactionIds!: string[];

    constructor(data?: IEmployeeHypotheticalFlatRateProfileDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryRate =
          _data['countryRate'] !== undefined ? _data['countryRate'] : <any>null;
        this.regionRate =
          _data['regionRate'] !== undefined ? _data['regionRate'] : <any>null;
        this.socialCountryRate =
          _data['socialCountryRate'] !== undefined
            ? _data['socialCountryRate']
            : <any>null;
        if (Array.isArray(_data['transactionIds'])) {
          this.transactionIds = [] as any;
          for (let item of _data['transactionIds'])
            this.transactionIds!.push(item);
        } else {
          this.transactionIds = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeHypotheticalFlatRateProfileDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeHypotheticalFlatRateProfileDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryRate'] =
        this.countryRate !== undefined ? this.countryRate : <any>null;
      data['regionRate'] =
        this.regionRate !== undefined ? this.regionRate : <any>null;
      data['socialCountryRate'] =
        this.socialCountryRate !== undefined
          ? this.socialCountryRate
          : <any>null;
      if (Array.isArray(this.transactionIds)) {
        data['transactionIds'] = [];
        for (let item of this.transactionIds) data['transactionIds'].push(item);
      }
      return data;
    }
  }

  export interface IEmployeeHypotheticalFlatRateProfileDto {
    countryRate: number | null;
    regionRate: number | null;
    socialCountryRate: number | null;
    transactionIds: string[];
  }

  export class GetEmployeeHypoProfilePageDataQueryResultFailure
    extends GetEmployeeHypoProfilePageDataQueryResult
    implements IGetEmployeeHypoProfilePageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetEmployeeHypoProfilePageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetEmployeeHypoProfilePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetEmployeeHypoProfilePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetEmployeeHypoProfilePageDataQueryResultFailure
    extends IGetEmployeeHypoProfilePageDataQueryResult {
    errors: ResultError[];
  }

  export class GetFairMarketValuePageDataQueryResult
    implements IGetFairMarketValuePageDataQueryResult
  {
    constructor(data?: IGetFairMarketValuePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetFairMarketValuePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetFairMarketValuePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetFairMarketValuePageDataQueryResult {}

  export class GetFairMarketValuePageDataQueryResultSuccess
    extends GetFairMarketValuePageDataQueryResult
    implements IGetFairMarketValuePageDataQueryResultSuccess
  {
    result!: FairMarketValuePageData;

    constructor(data?: IGetFairMarketValuePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new FairMarketValuePageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? FairMarketValuePageData.fromJS(_data['result'])
          : new FairMarketValuePageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetFairMarketValuePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetFairMarketValuePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetFairMarketValuePageDataQueryResultSuccess
    extends IGetFairMarketValuePageDataQueryResult {
    result: FairMarketValuePageData;
  }

  export class FairMarketValuePageData implements IFairMarketValuePageData {
    fmvDtos!: FairMarketValueDto[];
    countryFootprintDetails!: CountryFootprintDetailsDto | null;

    constructor(data?: IFairMarketValuePageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.fmvDtos = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['fmvDtos'])) {
          this.fmvDtos = [] as any;
          for (let item of _data['fmvDtos'])
            this.fmvDtos!.push(FairMarketValueDto.fromJS(item));
        } else {
          this.fmvDtos = <any>null;
        }
        this.countryFootprintDetails = _data['countryFootprintDetails']
          ? CountryFootprintDetailsDto.fromJS(_data['countryFootprintDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): FairMarketValuePageData {
      data = typeof data === 'object' ? data : {};
      let result = new FairMarketValuePageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.fmvDtos)) {
        data['fmvDtos'] = [];
        for (let item of this.fmvDtos) data['fmvDtos'].push(item.toJSON());
      }
      data['countryFootprintDetails'] = this.countryFootprintDetails
        ? this.countryFootprintDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IFairMarketValuePageData {
    fmvDtos: FairMarketValueDto[];
    countryFootprintDetails: CountryFootprintDetailsDto | null;
  }

  export class FairMarketValueDto implements IFairMarketValueDto {
    optionValue!: FairMarketValueTypeInputOptions;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IFairMarketValueDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): FairMarketValueDto {
      data = typeof data === 'object' ? data : {};
      let result = new FairMarketValueDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IFairMarketValueDto {
    optionValue: FairMarketValueTypeInputOptions;
    displayValue: string;
    displayOrder: number;
  }

  export enum FairMarketValueTypeInputOptions {
    Distribution = 'Distribution',
    Vest = 'Vest',
    Exercise = 'Exercise',
  }

  export class GetFairMarketValuePageDataQueryResultFailure
    extends GetFairMarketValuePageDataQueryResult
    implements IGetFairMarketValuePageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetFairMarketValuePageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetFairMarketValuePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetFairMarketValuePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetFairMarketValuePageDataQueryResultFailure
    extends IGetFairMarketValuePageDataQueryResult {
    errors: ResultError[];
  }

  export class GetCustomTaxPageDataQueryResult
    implements IGetCustomTaxPageDataQueryResult
  {
    constructor(data?: IGetCustomTaxPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCustomTaxPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCustomTaxPageDataQueryResult {}

  export class GetCustomTaxPageDataQueryResultSuccess
    extends GetCustomTaxPageDataQueryResult
    implements IGetCustomTaxPageDataQueryResultSuccess
  {
    result!: CustomTaxPageData;

    constructor(data?: IGetCustomTaxPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CustomTaxPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CustomTaxPageData.fromJS(_data['result'])
          : new CustomTaxPageData();
      }
    }

    static override fromJS(data: any): GetCustomTaxPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxPageDataQueryResultSuccess
    extends IGetCustomTaxPageDataQueryResult {
    result: CustomTaxPageData;
  }

  export class CustomTaxPageData implements ICustomTaxPageData {
    customTaxes!: CustomTaxDto[];

    constructor(data?: ICustomTaxPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.customTaxes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['customTaxes'])) {
          this.customTaxes = [] as any;
          for (let item of _data['customTaxes'])
            this.customTaxes!.push(CustomTaxDto.fromJS(item));
        } else {
          this.customTaxes = <any>null;
        }
      }
    }

    static fromJS(data: any): CustomTaxPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CustomTaxPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.customTaxes)) {
        data['customTaxes'] = [];
        for (let item of this.customTaxes)
          data['customTaxes'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICustomTaxPageData {
    customTaxes: CustomTaxDto[];
  }

  export class GetCustomTaxPageDataQueryResultFailure
    extends GetCustomTaxPageDataQueryResult
    implements IGetCustomTaxPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCustomTaxPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetCustomTaxPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCustomTaxPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCustomTaxPageDataQueryResultFailure
    extends IGetCustomTaxPageDataQueryResult {
    errors: ResultError[];
  }

  export class CreateCalculationCommandResult
    implements ICreateCalculationCommandResult
  {
    constructor(data?: ICreateCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CreateCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new CreateCalculationCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICreateCalculationCommandResult {}

  export class CreateCalculationCommandResultSuccess
    extends CreateCalculationCommandResult
    implements ICreateCalculationCommandResultSuccess
  {
    result!: CreateCalculationResponse;

    constructor(data?: ICreateCalculationCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CreateCalculationResponse();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CreateCalculationResponse.fromJS(_data['result'])
          : new CreateCalculationResponse();
      }
    }

    static override fromJS(data: any): CreateCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CreateCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICreateCalculationCommandResultSuccess
    extends ICreateCalculationCommandResult {
    result: CreateCalculationResponse;
  }

  export class CreateCalculationResponse implements ICreateCalculationResponse {
    calculationId!: string;

    constructor(data?: ICreateCalculationResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): CreateCalculationResponse {
      data = typeof data === 'object' ? data : {};
      let result = new CreateCalculationResponse();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface ICreateCalculationResponse {
    calculationId: string;
  }

  export class CreateCalculationCommandResultFailure
    extends CreateCalculationCommandResult
    implements ICreateCalculationCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ICreateCalculationCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): CreateCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CreateCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ICreateCalculationCommandResultFailure
    extends ICreateCalculationCommandResult {
    errors: ResultError[];
  }

  export class CreateCalculationCommand implements ICreateCalculationCommand {
    clientId!: string;
    batchCalculationType!: BatchCalculationType;
    employeeId!: string;
    firstName!: string | null;
    lastName!: string | null;
    emailAddress!: string | null;
    clientEmployeeType!: string | null;
    nationalityCountryCode!: string;
    secondNationalityCountryCode!: string | null;
    residentCountry!: PreProcessorInputsResidentCountry | null;
    clientSocialTaxCountryCode!: string | null;
    terminationDate!: Date | null;
    terminationReason!: TerminationReason | null;
    manualCalculationSendToWorkflow!: boolean | null;

    constructor(data?: ICreateCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchCalculationType =
          _data['batchCalculationType'] !== undefined
            ? _data['batchCalculationType']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.emailAddress =
          _data['emailAddress'] !== undefined
            ? _data['emailAddress']
            : <any>null;
        this.clientEmployeeType =
          _data['clientEmployeeType'] !== undefined
            ? _data['clientEmployeeType']
            : <any>null;
        this.nationalityCountryCode =
          _data['nationalityCountryCode'] !== undefined
            ? _data['nationalityCountryCode']
            : <any>null;
        this.secondNationalityCountryCode =
          _data['secondNationalityCountryCode'] !== undefined
            ? _data['secondNationalityCountryCode']
            : <any>null;
        this.residentCountry = _data['residentCountry']
          ? PreProcessorInputsResidentCountry.fromJS(_data['residentCountry'])
          : <any>null;
        this.clientSocialTaxCountryCode =
          _data['clientSocialTaxCountryCode'] !== undefined
            ? _data['clientSocialTaxCountryCode']
            : <any>null;
        this.terminationDate = _data['terminationDate']
          ? new Date(_data['terminationDate'].toString())
          : <any>null;
        this.terminationReason =
          _data['terminationReason'] !== undefined
            ? _data['terminationReason']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
      }
    }

    static fromJS(data: any): CreateCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchCalculationType'] =
        this.batchCalculationType !== undefined
          ? this.batchCalculationType
          : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['emailAddress'] =
        this.emailAddress !== undefined ? this.emailAddress : <any>null;
      data['clientEmployeeType'] =
        this.clientEmployeeType !== undefined
          ? this.clientEmployeeType
          : <any>null;
      data['nationalityCountryCode'] =
        this.nationalityCountryCode !== undefined
          ? this.nationalityCountryCode
          : <any>null;
      data['secondNationalityCountryCode'] =
        this.secondNationalityCountryCode !== undefined
          ? this.secondNationalityCountryCode
          : <any>null;
      data['residentCountry'] = this.residentCountry
        ? this.residentCountry.toJSON()
        : <any>null;
      data['clientSocialTaxCountryCode'] =
        this.clientSocialTaxCountryCode !== undefined
          ? this.clientSocialTaxCountryCode
          : <any>null;
      data['terminationDate'] = this.terminationDate
        ? this.terminationDate.toISOString()
        : <any>null;
      data['terminationReason'] =
        this.terminationReason !== undefined
          ? this.terminationReason
          : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      return data;
    }
  }

  export interface ICreateCalculationCommand {
    clientId: string;
    batchCalculationType: BatchCalculationType;
    employeeId: string;
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    clientEmployeeType: string | null;
    nationalityCountryCode: string;
    secondNationalityCountryCode: string | null;
    residentCountry: PreProcessorInputsResidentCountry | null;
    clientSocialTaxCountryCode: string | null;
    terminationDate: Date | null;
    terminationReason: TerminationReason | null;
    manualCalculationSendToWorkflow: boolean | null;
  }

  export class CloneCalculationCommandResult
    implements ICloneCalculationCommandResult
  {
    constructor(data?: ICloneCalculationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CloneCalculationCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICloneCalculationCommandResult {}

  export class CloneCalculationCommandResultSuccess
    extends CloneCalculationCommandResult
    implements ICloneCalculationCommandResultSuccess
  {
    clientPortalId!: string;
    clientId!: string;
    batchId!: string;
    calculationId!: string;

    constructor(data?: ICloneCalculationCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static override fromJS(data: any): CloneCalculationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICloneCalculationCommandResultSuccess
    extends ICloneCalculationCommandResult {
    clientPortalId: string;
    clientId: string;
    batchId: string;
    calculationId: string;
  }

  export class CloneCalculationCommandResultFailure
    extends CloneCalculationCommandResult
    implements ICloneCalculationCommandResultFailure
  {
    constructor(data?: ICloneCalculationCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): CloneCalculationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ICloneCalculationCommandResultFailure
    extends ICloneCalculationCommandResult {}

  export class CloneCalculationCommand implements ICloneCalculationCommand {
    clientId!: string;
    batchId!: string;
    calculationId!: string;

    constructor(data?: ICloneCalculationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): CloneCalculationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface ICloneCalculationCommand {
    clientId: string;
    batchId: string;
    calculationId: string;
  }

  export class CloneCalculationToOriginaltBatchCommandResult
    implements ICloneCalculationToOriginaltBatchCommandResult
  {
    constructor(data?: ICloneCalculationToOriginaltBatchCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CloneCalculationToOriginaltBatchCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationToOriginaltBatchCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICloneCalculationToOriginaltBatchCommandResult {}

  export class CloneCalculationToOriginalBatchCommandResultSuccess
    extends CloneCalculationToOriginaltBatchCommandResult
    implements ICloneCalculationToOriginalBatchCommandResultSuccess
  {
    clientPortalId!: string;
    clientId!: string;
    batchId!: string;
    calculationId!: string;

    constructor(data?: ICloneCalculationToOriginalBatchCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CloneCalculationToOriginalBatchCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationToOriginalBatchCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICloneCalculationToOriginalBatchCommandResultSuccess
    extends ICloneCalculationToOriginaltBatchCommandResult {
    clientPortalId: string;
    clientId: string;
    batchId: string;
    calculationId: string;
  }

  export class CloneCalculationToOriginalBatchCommandResultFailure
    extends CloneCalculationToOriginaltBatchCommandResult
    implements ICloneCalculationToOriginalBatchCommandResultFailure
  {
    constructor(data?: ICloneCalculationToOriginalBatchCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): CloneCalculationToOriginalBatchCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationToOriginalBatchCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ICloneCalculationToOriginalBatchCommandResultFailure
    extends ICloneCalculationToOriginaltBatchCommandResult {}

  export class CloneCalculationToOriginalBatchCommand
    implements ICloneCalculationToOriginalBatchCommand
  {
    clientId!: string;
    calculationId!: string;

    constructor(data?: ICloneCalculationToOriginalBatchCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
      }
    }

    static fromJS(data: any): CloneCalculationToOriginalBatchCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CloneCalculationToOriginalBatchCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      return data;
    }
  }

  export interface ICloneCalculationToOriginalBatchCommand {
    clientId: string;
    calculationId: string;
  }

  export abstract class SearchCalculationsCommandResult
    implements ISearchCalculationsCommandResult
  {
    constructor(data?: ISearchCalculationsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchCalculationsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SearchCalculationsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchCalculationsCommandResult {}

  export class SearchCalculationsCommandResultSuccess
    extends SearchCalculationsCommandResult
    implements ISearchCalculationsCommandResultSuccess
  {
    result!: PageModelOfCalculationIndexModel;
    pendingReportingDataEntryBatchIds!: string[];

    constructor(data?: ISearchCalculationsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PageModelOfCalculationIndexModel();
        this.pendingReportingDataEntryBatchIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PageModelOfCalculationIndexModel.fromJS(_data['result'])
          : new PageModelOfCalculationIndexModel();
        if (Array.isArray(_data['pendingReportingDataEntryBatchIds'])) {
          this.pendingReportingDataEntryBatchIds = [] as any;
          for (let item of _data['pendingReportingDataEntryBatchIds'])
            this.pendingReportingDataEntryBatchIds!.push(item);
        } else {
          this.pendingReportingDataEntryBatchIds = <any>null;
        }
      }
    }

    static override fromJS(data: any): SearchCalculationsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      if (Array.isArray(this.pendingReportingDataEntryBatchIds)) {
        data['pendingReportingDataEntryBatchIds'] = [];
        for (let item of this.pendingReportingDataEntryBatchIds)
          data['pendingReportingDataEntryBatchIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchCalculationsCommandResultSuccess
    extends ISearchCalculationsCommandResult {
    result: PageModelOfCalculationIndexModel;
    pendingReportingDataEntryBatchIds: string[];
  }

  export class SearchCalculationsCommandResultFailure
    extends SearchCalculationsCommandResult
    implements ISearchCalculationsCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISearchCalculationsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(data: any): SearchCalculationsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchCalculationsCommandResultFailure
    extends ISearchCalculationsCommandResult {
    errorMessage: string;
  }

  export class SearchCalculationsCommand implements ISearchCalculationsCommand {
    clientId!: string;
    filters!: SearchCalculationsFilterArgs | null;
    search!: SearchCalculationsSearchBarArgs | null;
    pagination!: SearchCalculationsPaginationArgs;

    constructor(data?: ISearchCalculationsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.pagination = new SearchCalculationsPaginationArgs();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.filters = _data['filters']
          ? SearchCalculationsFilterArgs.fromJS(_data['filters'])
          : <any>null;
        this.search = _data['search']
          ? SearchCalculationsSearchBarArgs.fromJS(_data['search'])
          : <any>null;
        this.pagination = _data['pagination']
          ? SearchCalculationsPaginationArgs.fromJS(_data['pagination'])
          : new SearchCalculationsPaginationArgs();
      }
    }

    static fromJS(data: any): SearchCalculationsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['filters'] = this.filters ? this.filters.toJSON() : <any>null;
      data['search'] = this.search ? this.search.toJSON() : <any>null;
      data['pagination'] = this.pagination
        ? this.pagination.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ISearchCalculationsCommand {
    clientId: string;
    filters: SearchCalculationsFilterArgs | null;
    search: SearchCalculationsSearchBarArgs | null;
    pagination: SearchCalculationsPaginationArgs;
  }

  export class SearchCalculationsFilterArgs
    implements ISearchCalculationsFilterArgs
  {
    batchIds!: string[];
    planTypes!: PlanType[];
    status!: CalculationStatus[];
    fromDateTime!: Date | null;
    toDateTime!: Date | null;

    constructor(data?: ISearchCalculationsFilterArgs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchIds = [];
        this.planTypes = [];
        this.status = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes']) this.planTypes!.push(item);
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['status'])) {
          this.status = [] as any;
          for (let item of _data['status']) this.status!.push(item);
        } else {
          this.status = <any>null;
        }
        this.fromDateTime = _data['fromDateTime']
          ? new Date(_data['fromDateTime'].toString())
          : <any>null;
        this.toDateTime = _data['toDateTime']
          ? new Date(_data['toDateTime'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): SearchCalculationsFilterArgs {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsFilterArgs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item);
      }
      if (Array.isArray(this.status)) {
        data['status'] = [];
        for (let item of this.status) data['status'].push(item);
      }
      data['fromDateTime'] = this.fromDateTime
        ? this.fromDateTime.toISOString()
        : <any>null;
      data['toDateTime'] = this.toDateTime
        ? this.toDateTime.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ISearchCalculationsFilterArgs {
    batchIds: string[];
    planTypes: PlanType[];
    status: CalculationStatus[];
    fromDateTime: Date | null;
    toDateTime: Date | null;
  }

  export class SearchCalculationsSearchBarArgs
    implements ISearchCalculationsSearchBarArgs
  {
    query!: string | null;

    constructor(data?: ISearchCalculationsSearchBarArgs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.query = _data['query'] !== undefined ? _data['query'] : <any>null;
      }
    }

    static fromJS(data: any): SearchCalculationsSearchBarArgs {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsSearchBarArgs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['query'] = this.query !== undefined ? this.query : <any>null;
      return data;
    }
  }

  export interface ISearchCalculationsSearchBarArgs {
    query: string | null;
  }

  export class SearchCalculationsPaginationArgs
    implements ISearchCalculationsPaginationArgs
  {
    page!: number;
    pageSize!: number;

    constructor(data?: ISearchCalculationsPaginationArgs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.page = _data['page'] !== undefined ? _data['page'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): SearchCalculationsPaginationArgs {
      data = typeof data === 'object' ? data : {};
      let result = new SearchCalculationsPaginationArgs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['page'] = this.page !== undefined ? this.page : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface ISearchCalculationsPaginationArgs {
    page: number;
    pageSize: number;
  }

  export abstract class DeleteCalculationsCommandResult
    implements IDeleteCalculationsCommandResult
  {
    constructor(data?: IDeleteCalculationsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DeleteCalculationsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DeleteCalculationsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteCalculationsCommandResult {}

  export class DeleteCalculationsCommandResultSuccess
    extends DeleteCalculationsCommandResult
    implements IDeleteCalculationsCommandResultSuccess
  {
    deleteCalculationsJobDetails!: DeleteCalculationsJobDto;

    constructor(data?: IDeleteCalculationsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.deleteCalculationsJobDetails = new DeleteCalculationsJobDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.deleteCalculationsJobDetails = _data[
          'deleteCalculationsJobDetails'
        ]
          ? DeleteCalculationsJobDto.fromJS(
              _data['deleteCalculationsJobDetails'],
            )
          : new DeleteCalculationsJobDto();
      }
    }

    static override fromJS(data: any): DeleteCalculationsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCalculationsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['deleteCalculationsJobDetails'] = this.deleteCalculationsJobDetails
        ? this.deleteCalculationsJobDetails.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCalculationsCommandResultSuccess
    extends IDeleteCalculationsCommandResult {
    deleteCalculationsJobDetails: DeleteCalculationsJobDto;
  }

  export class DeleteCalculationsJobDto implements IDeleteCalculationsJobDto {
    jobId!: string;
    jobStatus!: DeleteCalculationsJobStatus;
    failedToDeleteCalculationIds!: string[];

    constructor(data?: IDeleteCalculationsJobDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.failedToDeleteCalculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.jobId = _data['jobId'] !== undefined ? _data['jobId'] : <any>null;
        this.jobStatus =
          _data['jobStatus'] !== undefined ? _data['jobStatus'] : <any>null;
        if (Array.isArray(_data['failedToDeleteCalculationIds'])) {
          this.failedToDeleteCalculationIds = [] as any;
          for (let item of _data['failedToDeleteCalculationIds'])
            this.failedToDeleteCalculationIds!.push(item);
        } else {
          this.failedToDeleteCalculationIds = <any>null;
        }
      }
    }

    static fromJS(data: any): DeleteCalculationsJobDto {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCalculationsJobDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['jobId'] = this.jobId !== undefined ? this.jobId : <any>null;
      data['jobStatus'] =
        this.jobStatus !== undefined ? this.jobStatus : <any>null;
      if (Array.isArray(this.failedToDeleteCalculationIds)) {
        data['failedToDeleteCalculationIds'] = [];
        for (let item of this.failedToDeleteCalculationIds)
          data['failedToDeleteCalculationIds'].push(item);
      }
      return data;
    }
  }

  export interface IDeleteCalculationsJobDto {
    jobId: string;
    jobStatus: DeleteCalculationsJobStatus;
    failedToDeleteCalculationIds: string[];
  }

  export enum DeleteCalculationsJobStatus {
    InProgress = 'InProgress',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
  }

  export class DeleteCalculationsCommandResultFailure
    extends DeleteCalculationsCommandResult
    implements IDeleteCalculationsCommandResultFailure
  {
    errorMessage!: string;
    badCalculationIds!: string[];

    constructor(data?: IDeleteCalculationsCommandResultFailure) {
      super(data);
      if (!data) {
        this.badCalculationIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
        if (Array.isArray(_data['badCalculationIds'])) {
          this.badCalculationIds = [] as any;
          for (let item of _data['badCalculationIds'])
            this.badCalculationIds!.push(item);
        } else {
          this.badCalculationIds = <any>null;
        }
      }
    }

    static override fromJS(data: any): DeleteCalculationsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCalculationsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      if (Array.isArray(this.badCalculationIds)) {
        data['badCalculationIds'] = [];
        for (let item of this.badCalculationIds)
          data['badCalculationIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCalculationsCommandResultFailure
    extends IDeleteCalculationsCommandResult {
    errorMessage: string;
    badCalculationIds: string[];
  }

  export class DeleteCalculationsCommand implements IDeleteCalculationsCommand {
    clientId!: string;
    calculationIds!: string[];

    constructor(data?: IDeleteCalculationsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.calculationIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['calculationIds'])) {
          this.calculationIds = [] as any;
          for (let item of _data['calculationIds'])
            this.calculationIds!.push(item);
        } else {
          this.calculationIds = <any>null;
        }
      }
    }

    static fromJS(data: any): DeleteCalculationsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCalculationsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.calculationIds)) {
        data['calculationIds'] = [];
        for (let item of this.calculationIds) data['calculationIds'].push(item);
      }
      return data;
    }
  }

  export interface IDeleteCalculationsCommand {
    clientId: string;
    calculationIds: string[];
  }

  export abstract class GetDeleteCalculationDetailsByJobIdQueryResult
    implements IGetDeleteCalculationDetailsByJobIdQueryResult
  {
    constructor(data?: IGetDeleteCalculationDetailsByJobIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDeleteCalculationDetailsByJobIdQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDeleteCalculationDetailsByJobIdQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDeleteCalculationDetailsByJobIdQueryResult {}

  export class GetDeleteCalculationDetailsByJobIdQueryResultSuccess
    extends GetDeleteCalculationDetailsByJobIdQueryResult
    implements IGetDeleteCalculationDetailsByJobIdQueryResultSuccess
  {
    deleteCalculationDetailsByJobIdDto!: GetDeleteCalculationDetailsByJobIdDto[];

    constructor(data?: IGetDeleteCalculationDetailsByJobIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.deleteCalculationDetailsByJobIdDto = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['deleteCalculationDetailsByJobIdDto'])) {
          this.deleteCalculationDetailsByJobIdDto = [] as any;
          for (let item of _data['deleteCalculationDetailsByJobIdDto'])
            this.deleteCalculationDetailsByJobIdDto!.push(
              GetDeleteCalculationDetailsByJobIdDto.fromJS(item),
            );
        } else {
          this.deleteCalculationDetailsByJobIdDto = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDeleteCalculationDetailsByJobIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeleteCalculationDetailsByJobIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.deleteCalculationDetailsByJobIdDto)) {
        data['deleteCalculationDetailsByJobIdDto'] = [];
        for (let item of this.deleteCalculationDetailsByJobIdDto)
          data['deleteCalculationDetailsByJobIdDto'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeleteCalculationDetailsByJobIdQueryResultSuccess
    extends IGetDeleteCalculationDetailsByJobIdQueryResult {
    deleteCalculationDetailsByJobIdDto: GetDeleteCalculationDetailsByJobIdDto[];
  }

  export class GetDeleteCalculationDetailsByJobIdDto
    implements IGetDeleteCalculationDetailsByJobIdDto
  {
    jobId!: string;
    calculationId!: string;
    status!: CalculationDeleteRequestStatus;

    constructor(data?: IGetDeleteCalculationDetailsByJobIdDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.jobId = _data['jobId'] !== undefined ? _data['jobId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.status =
          _data['status'] !== undefined ? _data['status'] : <any>null;
      }
    }

    static fromJS(data: any): GetDeleteCalculationDetailsByJobIdDto {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeleteCalculationDetailsByJobIdDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['jobId'] = this.jobId !== undefined ? this.jobId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['status'] = this.status !== undefined ? this.status : <any>null;
      return data;
    }
  }

  export interface IGetDeleteCalculationDetailsByJobIdDto {
    jobId: string;
    calculationId: string;
    status: CalculationDeleteRequestStatus;
  }

  export class GetDeleteCalculationDetailsByJobIdQueryResultFailure
    extends GetDeleteCalculationDetailsByJobIdQueryResult
    implements IGetDeleteCalculationDetailsByJobIdQueryResultFailure
  {
    constructor(data?: IGetDeleteCalculationDetailsByJobIdQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetDeleteCalculationDetailsByJobIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeleteCalculationDetailsByJobIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDeleteCalculationDetailsByJobIdQueryResultFailure
    extends IGetDeleteCalculationDetailsByJobIdQueryResult {}

  export class GetDeleteCalculationDetailsByJobIdQuery
    implements IGetDeleteCalculationDetailsByJobIdQuery
  {
    clientId!: string;
    jobId!: string;

    constructor(data?: IGetDeleteCalculationDetailsByJobIdQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.jobId = _data['jobId'] !== undefined ? _data['jobId'] : <any>null;
      }
    }

    static fromJS(data: any): GetDeleteCalculationDetailsByJobIdQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetDeleteCalculationDetailsByJobIdQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['jobId'] = this.jobId !== undefined ? this.jobId : <any>null;
      return data;
    }
  }

  export interface IGetDeleteCalculationDetailsByJobIdQuery {
    clientId: string;
    jobId: string;
  }

  export class GetCalculationContextByIdQueryResult
    implements IGetCalculationContextByIdQueryResult
  {
    constructor(data?: IGetCalculationContextByIdQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationContextByIdQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationContextByIdQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationContextByIdQueryResult {}

  export class GetCalculationContextByIdQueryResultSuccess
    extends GetCalculationContextByIdQueryResult
    implements IGetCalculationContextByIdQueryResultSuccess
  {
    result!: CalculationContextDto;

    constructor(data?: IGetCalculationContextByIdQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CalculationContextDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CalculationContextDto.fromJS(_data['result'])
          : new CalculationContextDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationContextByIdQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationContextByIdQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationContextByIdQueryResultSuccess
    extends IGetCalculationContextByIdQueryResult {
    result: CalculationContextDto;
  }

  export class CalculationContextDto implements ICalculationContextDto {
    calculationId!: string;
    batchId!: string;
    clientPortalId!: string;
    indexRecord!: CalculationIndexModel;
    preProcessorInputs!: PreProcessorInputs;
    calcEngineInputs!: CalculationEngineInputs | null;
    calcEngineResults!: EmployeeCalculationResults | null;
    calcEngineOriginalResults!: EmployeeCalculationResults | null;
    latestFormattedInputsAndResults!: CalcEngineLatestFormattedInputsAndResults | null;
    calcEngineFailureResult!: CalculateEmployeeCommandResultFailure | null;
    hasTeqConsideredWorkLocations!: boolean;
    calculationCanBeClonedToOriginalBatch!: boolean;

    constructor(data?: ICalculationContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.indexRecord = new CalculationIndexModel();
        this.preProcessorInputs = new PreProcessorInputs();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.indexRecord = _data['indexRecord']
          ? CalculationIndexModel.fromJS(_data['indexRecord'])
          : new CalculationIndexModel();
        this.preProcessorInputs = _data['preProcessorInputs']
          ? PreProcessorInputs.fromJS(_data['preProcessorInputs'])
          : new PreProcessorInputs();
        this.calcEngineInputs = _data['calcEngineInputs']
          ? CalculationEngineInputs.fromJS(_data['calcEngineInputs'])
          : <any>null;
        this.calcEngineResults = _data['calcEngineResults']
          ? EmployeeCalculationResults.fromJS(_data['calcEngineResults'])
          : <any>null;
        this.calcEngineOriginalResults = _data['calcEngineOriginalResults']
          ? EmployeeCalculationResults.fromJS(
              _data['calcEngineOriginalResults'],
            )
          : <any>null;
        this.latestFormattedInputsAndResults = _data[
          'latestFormattedInputsAndResults'
        ]
          ? CalcEngineLatestFormattedInputsAndResults.fromJS(
              _data['latestFormattedInputsAndResults'],
            )
          : <any>null;
        this.calcEngineFailureResult = _data['calcEngineFailureResult']
          ? CalculateEmployeeCommandResultFailure.fromJS(
              _data['calcEngineFailureResult'],
            )
          : <any>null;
        this.hasTeqConsideredWorkLocations =
          _data['hasTeqConsideredWorkLocations'] !== undefined
            ? _data['hasTeqConsideredWorkLocations']
            : <any>null;
        this.calculationCanBeClonedToOriginalBatch =
          _data['calculationCanBeClonedToOriginalBatch'] !== undefined
            ? _data['calculationCanBeClonedToOriginalBatch']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['indexRecord'] = this.indexRecord
        ? this.indexRecord.toJSON()
        : <any>null;
      data['preProcessorInputs'] = this.preProcessorInputs
        ? this.preProcessorInputs.toJSON()
        : <any>null;
      data['calcEngineInputs'] = this.calcEngineInputs
        ? this.calcEngineInputs.toJSON()
        : <any>null;
      data['calcEngineResults'] = this.calcEngineResults
        ? this.calcEngineResults.toJSON()
        : <any>null;
      data['calcEngineOriginalResults'] = this.calcEngineOriginalResults
        ? this.calcEngineOriginalResults.toJSON()
        : <any>null;
      data['latestFormattedInputsAndResults'] = this
        .latestFormattedInputsAndResults
        ? this.latestFormattedInputsAndResults.toJSON()
        : <any>null;
      data['calcEngineFailureResult'] = this.calcEngineFailureResult
        ? this.calcEngineFailureResult.toJSON()
        : <any>null;
      data['hasTeqConsideredWorkLocations'] =
        this.hasTeqConsideredWorkLocations !== undefined
          ? this.hasTeqConsideredWorkLocations
          : <any>null;
      data['calculationCanBeClonedToOriginalBatch'] =
        this.calculationCanBeClonedToOriginalBatch !== undefined
          ? this.calculationCanBeClonedToOriginalBatch
          : <any>null;
      return data;
    }
  }

  export interface ICalculationContextDto {
    calculationId: string;
    batchId: string;
    clientPortalId: string;
    indexRecord: CalculationIndexModel;
    preProcessorInputs: PreProcessorInputs;
    calcEngineInputs: CalculationEngineInputs | null;
    calcEngineResults: EmployeeCalculationResults | null;
    calcEngineOriginalResults: EmployeeCalculationResults | null;
    latestFormattedInputsAndResults: CalcEngineLatestFormattedInputsAndResults | null;
    calcEngineFailureResult: CalculateEmployeeCommandResultFailure | null;
    hasTeqConsideredWorkLocations: boolean;
    calculationCanBeClonedToOriginalBatch: boolean;
  }

  export class PreProcessorInputs implements IPreProcessorInputs {
    version!: number | null;
    batchId!: string;
    batchCalculationType!: BatchCalculationType;
    batchCalculationDate!: Date | null;
    calculationId!: string;
    employee!: PreProcessorInputsEmployee;
    employer!: PreProcessorInputsEmployer;

    constructor(data?: IPreProcessorInputs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employee = new PreProcessorInputsEmployee();
        this.employer = new PreProcessorInputsEmployer();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.version =
          _data['version'] !== undefined ? _data['version'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.batchCalculationType =
          _data['batchCalculationType'] !== undefined
            ? _data['batchCalculationType']
            : <any>null;
        this.batchCalculationDate = _data['batchCalculationDate']
          ? new Date(_data['batchCalculationDate'].toString())
          : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.employee = _data['employee']
          ? PreProcessorInputsEmployee.fromJS(_data['employee'])
          : new PreProcessorInputsEmployee();
        this.employer = _data['employer']
          ? PreProcessorInputsEmployer.fromJS(_data['employer'])
          : new PreProcessorInputsEmployer();
      }
    }

    static fromJS(data: any): PreProcessorInputs {
      data = typeof data === 'object' ? data : {};
      let result = new PreProcessorInputs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['version'] = this.version !== undefined ? this.version : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['batchCalculationType'] =
        this.batchCalculationType !== undefined
          ? this.batchCalculationType
          : <any>null;
      data['batchCalculationDate'] = this.batchCalculationDate
        ? this.batchCalculationDate.toISOString()
        : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['employee'] = this.employee ? this.employee.toJSON() : <any>null;
      data['employer'] = this.employer ? this.employer.toJSON() : <any>null;
      return data;
    }
  }

  export interface IPreProcessorInputs {
    version: number | null;
    batchId: string;
    batchCalculationType: BatchCalculationType;
    batchCalculationDate: Date | null;
    calculationId: string;
    employee: PreProcessorInputsEmployee;
    employer: PreProcessorInputsEmployer;
  }

  export class CalculationEngineInputs implements ICalculationEngineInputs {
    version!: number | null;
    batchId!: string;
    batchCalculationType!: BatchCalculationType;
    batchCalculationDate!: Date | null;
    calculationId!: string;
    employee!: CalculationEngineInputsEmployee;
    employer!: CalculationEngineInputsEmployer;

    constructor(data?: ICalculationEngineInputs) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.employee = new CalculationEngineInputsEmployee();
        this.employer = new CalculationEngineInputsEmployer();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.version =
          _data['version'] !== undefined ? _data['version'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.batchCalculationType =
          _data['batchCalculationType'] !== undefined
            ? _data['batchCalculationType']
            : <any>null;
        this.batchCalculationDate = _data['batchCalculationDate']
          ? new Date(_data['batchCalculationDate'].toString())
          : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.employee = _data['employee']
          ? CalculationEngineInputsEmployee.fromJS(_data['employee'])
          : new CalculationEngineInputsEmployee();
        this.employer = _data['employer']
          ? CalculationEngineInputsEmployer.fromJS(_data['employer'])
          : new CalculationEngineInputsEmployer();
      }
    }

    static fromJS(data: any): CalculationEngineInputs {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputs();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['version'] = this.version !== undefined ? this.version : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['batchCalculationType'] =
        this.batchCalculationType !== undefined
          ? this.batchCalculationType
          : <any>null;
      data['batchCalculationDate'] = this.batchCalculationDate
        ? this.batchCalculationDate.toISOString()
        : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['employee'] = this.employee ? this.employee.toJSON() : <any>null;
      data['employer'] = this.employer ? this.employer.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputs {
    version: number | null;
    batchId: string;
    batchCalculationType: BatchCalculationType;
    batchCalculationDate: Date | null;
    calculationId: string;
    employee: CalculationEngineInputsEmployee;
    employer: CalculationEngineInputsEmployer;
  }

  export class CalculationEngineInputsEmployee
    implements ICalculationEngineInputsEmployee
  {
    firstName!: string | null;
    lastName!: string | null;
    emailAddress!: string | null;
    clientEmployeeType!: string | null;
    clientSocialTaxCountryCode!: string | null;
    employeeId!: string;
    /** 2 letter ISO country code of employee's primary nationality. */
    nationalityCountryCode!: string;
    secondNationalityCountryCode!: string | null;
    residentCountry!: CalculationEngineInputsResidentCountry;
    terminationDate!: Date | null;
    terminationReason!: TerminationReason | null;
    userDefinedFields!: UserDefinedField[];
    restrictedStockUnitTransactions!: CalculationEngineInputsRestrictedStockUnitTransaction[];
    cashBonusTransactions!: CalculationEngineInputsCashBonusTransaction[];
    stockOptionTransactions!: CalculationEngineInputsStockOptionTransaction[];
    locationPeriods!: CalculationEngineInputsLocationPeriod[];
    taxRates!: TaxRate[];
    taxPositions!: TaxPosition[];
    manualCalculationRequired!: boolean;
    manualCalculationSendToWorkflow!: boolean;
    incomeForBanding!: CalculationEngineInputsIncomeForBanding[];
    transactionOrdering!: TransactionOrdering;
    hypotheticalProfiles!: CalculationEngineInputsHypotheticalProfile[];
    taxFundingAndGrossups!: CalculationEngineInputsTaxFundingAndGrossup[];

    constructor(data?: ICalculationEngineInputsEmployee) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.residentCountry = new CalculationEngineInputsResidentCountry();
        this.userDefinedFields = [];
        this.restrictedStockUnitTransactions = [];
        this.cashBonusTransactions = [];
        this.stockOptionTransactions = [];
        this.locationPeriods = [];
        this.taxRates = [];
        this.taxPositions = [];
        this.incomeForBanding = [];
        this.transactionOrdering = new TransactionOrdering();
        this.hypotheticalProfiles = [];
        this.taxFundingAndGrossups = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.firstName =
          _data['firstName'] !== undefined ? _data['firstName'] : <any>null;
        this.lastName =
          _data['lastName'] !== undefined ? _data['lastName'] : <any>null;
        this.emailAddress =
          _data['emailAddress'] !== undefined
            ? _data['emailAddress']
            : <any>null;
        this.clientEmployeeType =
          _data['clientEmployeeType'] !== undefined
            ? _data['clientEmployeeType']
            : <any>null;
        this.clientSocialTaxCountryCode =
          _data['clientSocialTaxCountryCode'] !== undefined
            ? _data['clientSocialTaxCountryCode']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.nationalityCountryCode =
          _data['nationalityCountryCode'] !== undefined
            ? _data['nationalityCountryCode']
            : <any>null;
        this.secondNationalityCountryCode =
          _data['secondNationalityCountryCode'] !== undefined
            ? _data['secondNationalityCountryCode']
            : <any>null;
        this.residentCountry = _data['residentCountry']
          ? CalculationEngineInputsResidentCountry.fromJS(
              _data['residentCountry'],
            )
          : new CalculationEngineInputsResidentCountry();
        this.terminationDate = _data['terminationDate']
          ? new Date(_data['terminationDate'].toString())
          : <any>null;
        this.terminationReason =
          _data['terminationReason'] !== undefined
            ? _data['terminationReason']
            : <any>null;
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        if (Array.isArray(_data['restrictedStockUnitTransactions'])) {
          this.restrictedStockUnitTransactions = [] as any;
          for (let item of _data['restrictedStockUnitTransactions'])
            this.restrictedStockUnitTransactions!.push(
              CalculationEngineInputsRestrictedStockUnitTransaction.fromJS(
                item,
              ),
            );
        } else {
          this.restrictedStockUnitTransactions = <any>null;
        }
        if (Array.isArray(_data['cashBonusTransactions'])) {
          this.cashBonusTransactions = [] as any;
          for (let item of _data['cashBonusTransactions'])
            this.cashBonusTransactions!.push(
              CalculationEngineInputsCashBonusTransaction.fromJS(item),
            );
        } else {
          this.cashBonusTransactions = <any>null;
        }
        if (Array.isArray(_data['stockOptionTransactions'])) {
          this.stockOptionTransactions = [] as any;
          for (let item of _data['stockOptionTransactions'])
            this.stockOptionTransactions!.push(
              CalculationEngineInputsStockOptionTransaction.fromJS(item),
            );
        } else {
          this.stockOptionTransactions = <any>null;
        }
        if (Array.isArray(_data['locationPeriods'])) {
          this.locationPeriods = [] as any;
          for (let item of _data['locationPeriods'])
            this.locationPeriods!.push(
              CalculationEngineInputsLocationPeriod.fromJS(item),
            );
        } else {
          this.locationPeriods = <any>null;
        }
        if (Array.isArray(_data['taxRates'])) {
          this.taxRates = [] as any;
          for (let item of _data['taxRates'])
            this.taxRates!.push(TaxRate.fromJS(item));
        } else {
          this.taxRates = <any>null;
        }
        if (Array.isArray(_data['taxPositions'])) {
          this.taxPositions = [] as any;
          for (let item of _data['taxPositions'])
            this.taxPositions!.push(TaxPosition.fromJS(item));
        } else {
          this.taxPositions = <any>null;
        }
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
        if (Array.isArray(_data['incomeForBanding'])) {
          this.incomeForBanding = [] as any;
          for (let item of _data['incomeForBanding'])
            this.incomeForBanding!.push(
              CalculationEngineInputsIncomeForBanding.fromJS(item),
            );
        } else {
          this.incomeForBanding = <any>null;
        }
        this.transactionOrdering = _data['transactionOrdering']
          ? TransactionOrdering.fromJS(_data['transactionOrdering'])
          : new TransactionOrdering();
        if (Array.isArray(_data['hypotheticalProfiles'])) {
          this.hypotheticalProfiles = [] as any;
          for (let item of _data['hypotheticalProfiles'])
            this.hypotheticalProfiles!.push(
              CalculationEngineInputsHypotheticalProfile.fromJS(item),
            );
        } else {
          this.hypotheticalProfiles = <any>null;
        }
        if (Array.isArray(_data['taxFundingAndGrossups'])) {
          this.taxFundingAndGrossups = [] as any;
          for (let item of _data['taxFundingAndGrossups'])
            this.taxFundingAndGrossups!.push(
              CalculationEngineInputsTaxFundingAndGrossup.fromJS(item),
            );
        } else {
          this.taxFundingAndGrossups = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationEngineInputsEmployee {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsEmployee();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['firstName'] =
        this.firstName !== undefined ? this.firstName : <any>null;
      data['lastName'] =
        this.lastName !== undefined ? this.lastName : <any>null;
      data['emailAddress'] =
        this.emailAddress !== undefined ? this.emailAddress : <any>null;
      data['clientEmployeeType'] =
        this.clientEmployeeType !== undefined
          ? this.clientEmployeeType
          : <any>null;
      data['clientSocialTaxCountryCode'] =
        this.clientSocialTaxCountryCode !== undefined
          ? this.clientSocialTaxCountryCode
          : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['nationalityCountryCode'] =
        this.nationalityCountryCode !== undefined
          ? this.nationalityCountryCode
          : <any>null;
      data['secondNationalityCountryCode'] =
        this.secondNationalityCountryCode !== undefined
          ? this.secondNationalityCountryCode
          : <any>null;
      data['residentCountry'] = this.residentCountry
        ? this.residentCountry.toJSON()
        : <any>null;
      data['terminationDate'] = this.terminationDate
        ? this.terminationDate.toISOString()
        : <any>null;
      data['terminationReason'] =
        this.terminationReason !== undefined
          ? this.terminationReason
          : <any>null;
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      if (Array.isArray(this.restrictedStockUnitTransactions)) {
        data['restrictedStockUnitTransactions'] = [];
        for (let item of this.restrictedStockUnitTransactions)
          data['restrictedStockUnitTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusTransactions)) {
        data['cashBonusTransactions'] = [];
        for (let item of this.cashBonusTransactions)
          data['cashBonusTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.stockOptionTransactions)) {
        data['stockOptionTransactions'] = [];
        for (let item of this.stockOptionTransactions)
          data['stockOptionTransactions'].push(item.toJSON());
      }
      if (Array.isArray(this.locationPeriods)) {
        data['locationPeriods'] = [];
        for (let item of this.locationPeriods)
          data['locationPeriods'].push(item.toJSON());
      }
      if (Array.isArray(this.taxRates)) {
        data['taxRates'] = [];
        for (let item of this.taxRates) data['taxRates'].push(item.toJSON());
      }
      if (Array.isArray(this.taxPositions)) {
        data['taxPositions'] = [];
        for (let item of this.taxPositions)
          data['taxPositions'].push(item.toJSON());
      }
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      if (Array.isArray(this.incomeForBanding)) {
        data['incomeForBanding'] = [];
        for (let item of this.incomeForBanding)
          data['incomeForBanding'].push(item.toJSON());
      }
      data['transactionOrdering'] = this.transactionOrdering
        ? this.transactionOrdering.toJSON()
        : <any>null;
      if (Array.isArray(this.hypotheticalProfiles)) {
        data['hypotheticalProfiles'] = [];
        for (let item of this.hypotheticalProfiles)
          data['hypotheticalProfiles'].push(item.toJSON());
      }
      if (Array.isArray(this.taxFundingAndGrossups)) {
        data['taxFundingAndGrossups'] = [];
        for (let item of this.taxFundingAndGrossups)
          data['taxFundingAndGrossups'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationEngineInputsEmployee {
    firstName: string | null;
    lastName: string | null;
    emailAddress: string | null;
    clientEmployeeType: string | null;
    clientSocialTaxCountryCode: string | null;
    employeeId: string;
    /** 2 letter ISO country code of employee's primary nationality. */
    nationalityCountryCode: string;
    secondNationalityCountryCode: string | null;
    residentCountry: CalculationEngineInputsResidentCountry;
    terminationDate: Date | null;
    terminationReason: TerminationReason | null;
    userDefinedFields: UserDefinedField[];
    restrictedStockUnitTransactions: CalculationEngineInputsRestrictedStockUnitTransaction[];
    cashBonusTransactions: CalculationEngineInputsCashBonusTransaction[];
    stockOptionTransactions: CalculationEngineInputsStockOptionTransaction[];
    locationPeriods: CalculationEngineInputsLocationPeriod[];
    taxRates: TaxRate[];
    taxPositions: TaxPosition[];
    manualCalculationRequired: boolean;
    manualCalculationSendToWorkflow: boolean;
    incomeForBanding: CalculationEngineInputsIncomeForBanding[];
    transactionOrdering: TransactionOrdering;
    hypotheticalProfiles: CalculationEngineInputsHypotheticalProfile[];
    taxFundingAndGrossups: CalculationEngineInputsTaxFundingAndGrossup[];
  }

  export class CalculationEngineInputsResidentCountry
    implements ICalculationEngineInputsResidentCountry
  {
    code!: string;
    region!: CalculationEngineInputsResidentRegion | null;

    constructor(data?: ICalculationEngineInputsResidentCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsResidentRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsResidentCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsResidentCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsResidentCountry {
    code: string;
    region: CalculationEngineInputsResidentRegion | null;
  }

  export class CalculationEngineInputsResidentRegion
    implements ICalculationEngineInputsResidentRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsResidentRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsResidentRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsResidentRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsResidentRegion {
    code: string;
  }

  export abstract class CalculationEngineInputsTransaction
    implements ICalculationEngineInputsTransaction
  {
    customTaxes!: CalculationEngineInputsCustomTax[];
    transactionGuid!: string;
    transactionId!: string;
    planCode!: string;
    awardName!: string | null;
    currencyCode!: string;
    userDefinedFields!: UserDefinedField[];
    manualCalculationRequired!: boolean;
    manualCalculationReason!: string | null;

    constructor(data?: ICalculationEngineInputsTransaction) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.customTaxes = [];
        this.userDefinedFields = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['customTaxes'])) {
          this.customTaxes = [] as any;
          for (let item of _data['customTaxes'])
            this.customTaxes!.push(
              CalculationEngineInputsCustomTax.fromJS(item),
            );
        } else {
          this.customTaxes = <any>null;
        }
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.awardName =
          _data['awardName'] !== undefined ? _data['awardName'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationReason =
          _data['manualCalculationReason'] !== undefined
            ? _data['manualCalculationReason']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsTransaction {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'CalculationEngineInputsTransaction' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.customTaxes)) {
        data['customTaxes'] = [];
        for (let item of this.customTaxes)
          data['customTaxes'].push(item.toJSON());
      }
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['awardName'] =
        this.awardName !== undefined ? this.awardName : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationReason'] =
        this.manualCalculationReason !== undefined
          ? this.manualCalculationReason
          : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsTransaction {
    customTaxes: CalculationEngineInputsCustomTax[];
    transactionGuid: string;
    transactionId: string;
    planCode: string;
    awardName: string | null;
    currencyCode: string;
    userDefinedFields: UserDefinedField[];
    manualCalculationRequired: boolean;
    manualCalculationReason: string | null;
  }

  export class CalculationEngineInputsRestrictedStockUnitTransaction
    extends CalculationEngineInputsTransaction
    implements ICalculationEngineInputsRestrictedStockUnitTransaction
  {
    unitsGranted!: number;
    numberOfUnitsDistributed!: number;
    fairMarketValues!: RestrictedStockUnitFairMarketValue[];
    vests!: CalculationEngineInputsRestrictedStockUnitVest[];
    planType!: PlanType;
    grantDate!: Date;
    distributionDate!: Date;
    deliveryType!: DeliveryType;
    taxWithholdingMethod!: TaxWithholdingMethod | null;

    constructor(data?: ICalculationEngineInputsRestrictedStockUnitTransaction) {
      super(data);
      if (!data) {
        this.fairMarketValues = [];
        this.vests = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.unitsGranted =
          _data['unitsGranted'] !== undefined
            ? _data['unitsGranted']
            : <any>null;
        this.numberOfUnitsDistributed =
          _data['numberOfUnitsDistributed'] !== undefined
            ? _data['numberOfUnitsDistributed']
            : <any>null;
        if (Array.isArray(_data['fairMarketValues'])) {
          this.fairMarketValues = [] as any;
          for (let item of _data['fairMarketValues'])
            this.fairMarketValues!.push(
              RestrictedStockUnitFairMarketValue.fromJS(item),
            );
        } else {
          this.fairMarketValues = <any>null;
        }
        if (Array.isArray(_data['vests'])) {
          this.vests = [] as any;
          for (let item of _data['vests'])
            this.vests!.push(
              CalculationEngineInputsRestrictedStockUnitVest.fromJS(item),
            );
        } else {
          this.vests = <any>null;
        }
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.grantDate = _data['grantDate']
          ? new Date(_data['grantDate'].toString())
          : <any>null;
        this.distributionDate = _data['distributionDate']
          ? new Date(_data['distributionDate'].toString())
          : <any>null;
        this.deliveryType =
          _data['deliveryType'] !== undefined
            ? _data['deliveryType']
            : <any>null;
        this.taxWithholdingMethod =
          _data['taxWithholdingMethod'] !== undefined
            ? _data['taxWithholdingMethod']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CalculationEngineInputsRestrictedStockUnitTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsRestrictedStockUnitTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['unitsGranted'] =
        this.unitsGranted !== undefined ? this.unitsGranted : <any>null;
      data['numberOfUnitsDistributed'] =
        this.numberOfUnitsDistributed !== undefined
          ? this.numberOfUnitsDistributed
          : <any>null;
      if (Array.isArray(this.fairMarketValues)) {
        data['fairMarketValues'] = [];
        for (let item of this.fairMarketValues)
          data['fairMarketValues'].push(item.toJSON());
      }
      if (Array.isArray(this.vests)) {
        data['vests'] = [];
        for (let item of this.vests) data['vests'].push(item.toJSON());
      }
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['grantDate'] = this.grantDate
        ? this.grantDate.toISOString()
        : <any>null;
      data['distributionDate'] = this.distributionDate
        ? this.distributionDate.toISOString()
        : <any>null;
      data['deliveryType'] =
        this.deliveryType !== undefined ? this.deliveryType : <any>null;
      data['taxWithholdingMethod'] =
        this.taxWithholdingMethod !== undefined
          ? this.taxWithholdingMethod
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICalculationEngineInputsRestrictedStockUnitTransaction
    extends ICalculationEngineInputsTransaction {
    unitsGranted: number;
    numberOfUnitsDistributed: number;
    fairMarketValues: RestrictedStockUnitFairMarketValue[];
    vests: CalculationEngineInputsRestrictedStockUnitVest[];
    planType: PlanType;
    grantDate: Date;
    distributionDate: Date;
    deliveryType: DeliveryType;
    taxWithholdingMethod: TaxWithholdingMethod | null;
  }

  export class CalculationEngineInputsRestrictedStockUnitVest
    implements ICalculationEngineInputsRestrictedStockUnitVest
  {
    date!: Date;
    unitsVested!: number;

    constructor(data?: ICalculationEngineInputsRestrictedStockUnitVest) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.date = _data['date']
          ? new Date(_data['date'].toString())
          : <any>null;
        this.unitsVested =
          _data['unitsVested'] !== undefined ? _data['unitsVested'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsRestrictedStockUnitVest {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsRestrictedStockUnitVest();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['date'] = this.date ? this.date.toISOString() : <any>null;
      data['unitsVested'] =
        this.unitsVested !== undefined ? this.unitsVested : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsRestrictedStockUnitVest {
    date: Date;
    unitsVested: number;
  }

  export class CalculationEngineInputsCustomTax
    implements ICalculationEngineInputsCustomTax
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsCustomTax) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsCustomTax {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsCustomTax();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsCustomTax {
    code: string;
  }

  export class CalculationEngineInputsCashBonusTransaction
    extends CalculationEngineInputsTransaction
    implements ICalculationEngineInputsCashBonusTransaction
  {
    paymentAmount!: number;
    planType!: PlanType;
    performancePeriodStart!: Date;
    performancePeriodEnd!: Date;
    paymentDate!: Date;

    constructor(data?: ICalculationEngineInputsCashBonusTransaction) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.paymentAmount =
          _data['paymentAmount'] !== undefined
            ? _data['paymentAmount']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.performancePeriodStart = _data['performancePeriodStart']
          ? new Date(_data['performancePeriodStart'].toString())
          : <any>null;
        this.performancePeriodEnd = _data['performancePeriodEnd']
          ? new Date(_data['performancePeriodEnd'].toString())
          : <any>null;
        this.paymentDate = _data['paymentDate']
          ? new Date(_data['paymentDate'].toString())
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CalculationEngineInputsCashBonusTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsCashBonusTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['paymentAmount'] =
        this.paymentAmount !== undefined ? this.paymentAmount : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['performancePeriodStart'] = this.performancePeriodStart
        ? this.performancePeriodStart.toISOString()
        : <any>null;
      data['performancePeriodEnd'] = this.performancePeriodEnd
        ? this.performancePeriodEnd.toISOString()
        : <any>null;
      data['paymentDate'] = this.paymentDate
        ? this.paymentDate.toISOString()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICalculationEngineInputsCashBonusTransaction
    extends ICalculationEngineInputsTransaction {
    paymentAmount: number;
    planType: PlanType;
    performancePeriodStart: Date;
    performancePeriodEnd: Date;
    paymentDate: Date;
  }

  export class CalculationEngineInputsStockOptionTransaction
    extends CalculationEngineInputsTransaction
    implements ICalculationEngineInputsStockOptionTransaction
  {
    unitsGranted!: number;
    exercisePrice!: number;
    fairMarketValues!: StockOptionFairMarketValue[];
    numberOfOptionsExercised!: number;
    numberOfOptionsPreviouslyExercised!: number | null;
    vests!: CalculationEngineInputsStockOptionVest[];
    planType!: PlanType;
    grantDate!: Date;
    deliveryType!: DeliveryType;
    taxWithholdingMethod!: TaxWithholdingMethod | null;
    exerciseDate!: Date;

    constructor(data?: ICalculationEngineInputsStockOptionTransaction) {
      super(data);
      if (!data) {
        this.fairMarketValues = [];
        this.vests = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.unitsGranted =
          _data['unitsGranted'] !== undefined
            ? _data['unitsGranted']
            : <any>null;
        this.exercisePrice =
          _data['exercisePrice'] !== undefined
            ? _data['exercisePrice']
            : <any>null;
        if (Array.isArray(_data['fairMarketValues'])) {
          this.fairMarketValues = [] as any;
          for (let item of _data['fairMarketValues'])
            this.fairMarketValues!.push(
              StockOptionFairMarketValue.fromJS(item),
            );
        } else {
          this.fairMarketValues = <any>null;
        }
        this.numberOfOptionsExercised =
          _data['numberOfOptionsExercised'] !== undefined
            ? _data['numberOfOptionsExercised']
            : <any>null;
        this.numberOfOptionsPreviouslyExercised =
          _data['numberOfOptionsPreviouslyExercised'] !== undefined
            ? _data['numberOfOptionsPreviouslyExercised']
            : <any>null;
        if (Array.isArray(_data['vests'])) {
          this.vests = [] as any;
          for (let item of _data['vests'])
            this.vests!.push(
              CalculationEngineInputsStockOptionVest.fromJS(item),
            );
        } else {
          this.vests = <any>null;
        }
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.grantDate = _data['grantDate']
          ? new Date(_data['grantDate'].toString())
          : <any>null;
        this.deliveryType =
          _data['deliveryType'] !== undefined
            ? _data['deliveryType']
            : <any>null;
        this.taxWithholdingMethod =
          _data['taxWithholdingMethod'] !== undefined
            ? _data['taxWithholdingMethod']
            : <any>null;
        this.exerciseDate = _data['exerciseDate']
          ? new Date(_data['exerciseDate'].toString())
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): CalculationEngineInputsStockOptionTransaction {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsStockOptionTransaction();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['unitsGranted'] =
        this.unitsGranted !== undefined ? this.unitsGranted : <any>null;
      data['exercisePrice'] =
        this.exercisePrice !== undefined ? this.exercisePrice : <any>null;
      if (Array.isArray(this.fairMarketValues)) {
        data['fairMarketValues'] = [];
        for (let item of this.fairMarketValues)
          data['fairMarketValues'].push(item.toJSON());
      }
      data['numberOfOptionsExercised'] =
        this.numberOfOptionsExercised !== undefined
          ? this.numberOfOptionsExercised
          : <any>null;
      data['numberOfOptionsPreviouslyExercised'] =
        this.numberOfOptionsPreviouslyExercised !== undefined
          ? this.numberOfOptionsPreviouslyExercised
          : <any>null;
      if (Array.isArray(this.vests)) {
        data['vests'] = [];
        for (let item of this.vests) data['vests'].push(item.toJSON());
      }
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['grantDate'] = this.grantDate
        ? this.grantDate.toISOString()
        : <any>null;
      data['deliveryType'] =
        this.deliveryType !== undefined ? this.deliveryType : <any>null;
      data['taxWithholdingMethod'] =
        this.taxWithholdingMethod !== undefined
          ? this.taxWithholdingMethod
          : <any>null;
      data['exerciseDate'] = this.exerciseDate
        ? this.exerciseDate.toISOString()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ICalculationEngineInputsStockOptionTransaction
    extends ICalculationEngineInputsTransaction {
    unitsGranted: number;
    exercisePrice: number;
    fairMarketValues: StockOptionFairMarketValue[];
    numberOfOptionsExercised: number;
    numberOfOptionsPreviouslyExercised: number | null;
    vests: CalculationEngineInputsStockOptionVest[];
    planType: PlanType;
    grantDate: Date;
    deliveryType: DeliveryType;
    taxWithholdingMethod: TaxWithholdingMethod | null;
    exerciseDate: Date;
  }

  export class CalculationEngineInputsStockOptionVest
    implements ICalculationEngineInputsStockOptionVest
  {
    date!: Date;
    unitsVested!: number;

    constructor(data?: ICalculationEngineInputsStockOptionVest) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.date = _data['date']
          ? new Date(_data['date'].toString())
          : <any>null;
        this.unitsVested =
          _data['unitsVested'] !== undefined ? _data['unitsVested'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsStockOptionVest {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsStockOptionVest();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['date'] = this.date ? this.date.toISOString() : <any>null;
      data['unitsVested'] =
        this.unitsVested !== undefined ? this.unitsVested : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsStockOptionVest {
    date: Date;
    unitsVested: number;
  }

  export class CalculationEngineInputsLocationPeriod
    implements ICalculationEngineInputsLocationPeriod
  {
    workLocationType!: WorkLocationType;
    clientWorkLocationType!: string;
    assignedWorkCountry!: CalculationEngineInputsAssignedWorkCountry;
    employmentContractCountry!: CalculationEngineInputsEmploymentContractCountry;
    liveCountry!: CalculationEngineInputsLiveCountry;
    socialTaxCountry!: CalculationEngineInputsSocialTaxCountry | null;
    certificateOfCoverageCountry!: CalculationEngineInputsCertificateOfCoverageCountry | null;
    payrollCountry!: CalculationEngineInputsPayrollCountry;
    startDate!: Date;
    endDate!: Date;
    teqPeriod!: boolean;

    constructor(data?: ICalculationEngineInputsLocationPeriod) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.assignedWorkCountry =
          new CalculationEngineInputsAssignedWorkCountry();
        this.employmentContractCountry =
          new CalculationEngineInputsEmploymentContractCountry();
        this.liveCountry = new CalculationEngineInputsLiveCountry();
        this.payrollCountry = new CalculationEngineInputsPayrollCountry();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        this.assignedWorkCountry = _data['assignedWorkCountry']
          ? CalculationEngineInputsAssignedWorkCountry.fromJS(
              _data['assignedWorkCountry'],
            )
          : new CalculationEngineInputsAssignedWorkCountry();
        this.employmentContractCountry = _data['employmentContractCountry']
          ? CalculationEngineInputsEmploymentContractCountry.fromJS(
              _data['employmentContractCountry'],
            )
          : new CalculationEngineInputsEmploymentContractCountry();
        this.liveCountry = _data['liveCountry']
          ? CalculationEngineInputsLiveCountry.fromJS(_data['liveCountry'])
          : new CalculationEngineInputsLiveCountry();
        this.socialTaxCountry = _data['socialTaxCountry']
          ? CalculationEngineInputsSocialTaxCountry.fromJS(
              _data['socialTaxCountry'],
            )
          : <any>null;
        this.certificateOfCoverageCountry = _data[
          'certificateOfCoverageCountry'
        ]
          ? CalculationEngineInputsCertificateOfCoverageCountry.fromJS(
              _data['certificateOfCoverageCountry'],
            )
          : <any>null;
        this.payrollCountry = _data['payrollCountry']
          ? CalculationEngineInputsPayrollCountry.fromJS(
              _data['payrollCountry'],
            )
          : new CalculationEngineInputsPayrollCountry();
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        this.teqPeriod =
          _data['teqPeriod'] !== undefined ? _data['teqPeriod'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsLocationPeriod {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsLocationPeriod();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      data['assignedWorkCountry'] = this.assignedWorkCountry
        ? this.assignedWorkCountry.toJSON()
        : <any>null;
      data['employmentContractCountry'] = this.employmentContractCountry
        ? this.employmentContractCountry.toJSON()
        : <any>null;
      data['liveCountry'] = this.liveCountry
        ? this.liveCountry.toJSON()
        : <any>null;
      data['socialTaxCountry'] = this.socialTaxCountry
        ? this.socialTaxCountry.toJSON()
        : <any>null;
      data['certificateOfCoverageCountry'] = this.certificateOfCoverageCountry
        ? this.certificateOfCoverageCountry.toJSON()
        : <any>null;
      data['payrollCountry'] = this.payrollCountry
        ? this.payrollCountry.toJSON()
        : <any>null;
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      data['teqPeriod'] =
        this.teqPeriod !== undefined ? this.teqPeriod : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsLocationPeriod {
    workLocationType: WorkLocationType;
    clientWorkLocationType: string;
    assignedWorkCountry: CalculationEngineInputsAssignedWorkCountry;
    employmentContractCountry: CalculationEngineInputsEmploymentContractCountry;
    liveCountry: CalculationEngineInputsLiveCountry;
    socialTaxCountry: CalculationEngineInputsSocialTaxCountry | null;
    certificateOfCoverageCountry: CalculationEngineInputsCertificateOfCoverageCountry | null;
    payrollCountry: CalculationEngineInputsPayrollCountry;
    startDate: Date;
    endDate: Date;
    teqPeriod: boolean;
  }

  export class CalculationEngineInputsAssignedWorkCountry
    implements ICalculationEngineInputsAssignedWorkCountry
  {
    code!: string;
    allocationPercentage!: number;
    region!: CalculationEngineInputsAssignedWorkRegion | null;

    constructor(data?: ICalculationEngineInputsAssignedWorkCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsAssignedWorkRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsAssignedWorkCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsAssignedWorkCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsAssignedWorkCountry {
    code: string;
    allocationPercentage: number;
    region: CalculationEngineInputsAssignedWorkRegion | null;
  }

  export class CalculationEngineInputsAssignedWorkRegion
    implements ICalculationEngineInputsAssignedWorkRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsAssignedWorkRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsAssignedWorkRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsAssignedWorkRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsAssignedWorkRegion {
    code: string;
  }

  export class CalculationEngineInputsEmploymentContractCountry
    implements ICalculationEngineInputsEmploymentContractCountry
  {
    code!: string;
    employmentEntity!: string | null;
    region!: CalculationEngineInputsEmploymentContractRegion | null;

    constructor(data?: ICalculationEngineInputsEmploymentContractCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.employmentEntity =
          _data['employmentEntity'] !== undefined
            ? _data['employmentEntity']
            : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsEmploymentContractRegion.fromJS(
              _data['region'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsEmploymentContractCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsEmploymentContractCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['employmentEntity'] =
        this.employmentEntity !== undefined ? this.employmentEntity : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsEmploymentContractCountry {
    code: string;
    employmentEntity: string | null;
    region: CalculationEngineInputsEmploymentContractRegion | null;
  }

  export class CalculationEngineInputsEmploymentContractRegion
    implements ICalculationEngineInputsEmploymentContractRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsEmploymentContractRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsEmploymentContractRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsEmploymentContractRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsEmploymentContractRegion {
    code: string;
  }

  export class CalculationEngineInputsLiveCountry
    implements ICalculationEngineInputsLiveCountry
  {
    allocationPercentage!: number;
    code!: string;
    region!: CalculationEngineInputsLiveRegion | null;

    constructor(data?: ICalculationEngineInputsLiveCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.allocationPercentage =
          _data['allocationPercentage'] !== undefined
            ? _data['allocationPercentage']
            : <any>null;
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsLiveRegion.fromJS(_data['region'])
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsLiveCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsLiveCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['allocationPercentage'] =
        this.allocationPercentage !== undefined
          ? this.allocationPercentage
          : <any>null;
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsLiveCountry {
    allocationPercentage: number;
    code: string;
    region: CalculationEngineInputsLiveRegion | null;
  }

  export class CalculationEngineInputsLiveRegion
    implements ICalculationEngineInputsLiveRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsLiveRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsLiveRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsLiveRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsLiveRegion {
    code: string;
  }

  export class CalculationEngineInputsSocialTaxCountry
    implements ICalculationEngineInputsSocialTaxCountry
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsSocialTaxCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsSocialTaxCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsSocialTaxCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsSocialTaxCountry {
    code: string;
  }

  export class CalculationEngineInputsCertificateOfCoverageCountry
    implements ICalculationEngineInputsCertificateOfCoverageCountry
  {
    code!: string;
    certificateOfCoverageExpirationDate!: Date | null;

    constructor(data?: ICalculationEngineInputsCertificateOfCoverageCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.certificateOfCoverageExpirationDate = _data[
          'certificateOfCoverageExpirationDate'
        ]
          ? new Date(_data['certificateOfCoverageExpirationDate'].toString())
          : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): CalculationEngineInputsCertificateOfCoverageCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsCertificateOfCoverageCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['certificateOfCoverageExpirationDate'] = this
        .certificateOfCoverageExpirationDate
        ? this.certificateOfCoverageExpirationDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsCertificateOfCoverageCountry {
    code: string;
    certificateOfCoverageExpirationDate: Date | null;
  }

  export class CalculationEngineInputsPayrollCountry
    implements ICalculationEngineInputsPayrollCountry
  {
    code!: string;
    payrollName!: string | null;

    constructor(data?: ICalculationEngineInputsPayrollCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.payrollName =
          _data['payrollName'] !== undefined ? _data['payrollName'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsPayrollCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsPayrollCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['payrollName'] =
        this.payrollName !== undefined ? this.payrollName : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsPayrollCountry {
    code: string;
    payrollName: string | null;
  }

  export class CalculationEngineInputsIncomeForBanding
    implements ICalculationEngineInputsIncomeForBanding
  {
    taxType!: TaxType;
    country!: CalculationEngineInputsIncomeForBandingCountry;
    taxRateCode!: string | null;
    employmentEntity!: string | null;
    currencyCode!: string;
    amount!: number;

    constructor(data?: ICalculationEngineInputsIncomeForBanding) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.country = new CalculationEngineInputsIncomeForBandingCountry();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.country = _data['country']
          ? CalculationEngineInputsIncomeForBandingCountry.fromJS(
              _data['country'],
            )
          : new CalculationEngineInputsIncomeForBandingCountry();
        this.taxRateCode =
          _data['taxRateCode'] !== undefined ? _data['taxRateCode'] : <any>null;
        this.employmentEntity =
          _data['employmentEntity'] !== undefined
            ? _data['employmentEntity']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.amount =
          _data['amount'] !== undefined ? _data['amount'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsIncomeForBanding {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsIncomeForBanding();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['country'] = this.country ? this.country.toJSON() : <any>null;
      data['taxRateCode'] =
        this.taxRateCode !== undefined ? this.taxRateCode : <any>null;
      data['employmentEntity'] =
        this.employmentEntity !== undefined ? this.employmentEntity : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['amount'] = this.amount !== undefined ? this.amount : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsIncomeForBanding {
    taxType: TaxType;
    country: CalculationEngineInputsIncomeForBandingCountry;
    taxRateCode: string | null;
    employmentEntity: string | null;
    currencyCode: string;
    amount: number;
  }

  export class CalculationEngineInputsIncomeForBandingCountry
    implements ICalculationEngineInputsIncomeForBandingCountry
  {
    code!: string;
    region!: CalculationEngineInputsIncomeForBandingRegion | null;

    constructor(data?: ICalculationEngineInputsIncomeForBandingCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsIncomeForBandingRegion.fromJS(
              _data['region'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsIncomeForBandingCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsIncomeForBandingCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsIncomeForBandingCountry {
    code: string;
    region: CalculationEngineInputsIncomeForBandingRegion | null;
  }

  export class CalculationEngineInputsIncomeForBandingRegion
    implements ICalculationEngineInputsIncomeForBandingRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsIncomeForBandingRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsIncomeForBandingRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsIncomeForBandingRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsIncomeForBandingRegion {
    code: string;
  }

  export class CalculationEngineInputsHypotheticalProfile
    implements ICalculationEngineInputsHypotheticalProfile
  {
    rateType!: HypotheticalProfileRateType | null;
    taxType!: TaxType;
    hypotheticalProfileCountry!: CalculationEngineInputsHypotheticalProfileCountry | null;
    taxRate!: number | null;
    customTaxCode!: string | null;
    jurisdictionLevel!: JurisdictionLevel;
    transactionId!: string | null;

    constructor(data?: ICalculationEngineInputsHypotheticalProfile) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.rateType =
          _data['rateType'] !== undefined ? _data['rateType'] : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.hypotheticalProfileCountry = _data['hypotheticalProfileCountry']
          ? CalculationEngineInputsHypotheticalProfileCountry.fromJS(
              _data['hypotheticalProfileCountry'],
            )
          : <any>null;
        this.taxRate =
          _data['taxRate'] !== undefined ? _data['taxRate'] : <any>null;
        this.customTaxCode =
          _data['customTaxCode'] !== undefined
            ? _data['customTaxCode']
            : <any>null;
        this.jurisdictionLevel =
          _data['jurisdictionLevel'] !== undefined
            ? _data['jurisdictionLevel']
            : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsHypotheticalProfile {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsHypotheticalProfile();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['rateType'] =
        this.rateType !== undefined ? this.rateType : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['hypotheticalProfileCountry'] = this.hypotheticalProfileCountry
        ? this.hypotheticalProfileCountry.toJSON()
        : <any>null;
      data['taxRate'] = this.taxRate !== undefined ? this.taxRate : <any>null;
      data['customTaxCode'] =
        this.customTaxCode !== undefined ? this.customTaxCode : <any>null;
      data['jurisdictionLevel'] =
        this.jurisdictionLevel !== undefined
          ? this.jurisdictionLevel
          : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsHypotheticalProfile {
    rateType: HypotheticalProfileRateType | null;
    taxType: TaxType;
    hypotheticalProfileCountry: CalculationEngineInputsHypotheticalProfileCountry | null;
    taxRate: number | null;
    customTaxCode: string | null;
    jurisdictionLevel: JurisdictionLevel;
    transactionId: string | null;
  }

  export class CalculationEngineInputsHypotheticalProfileCountry
    implements ICalculationEngineInputsHypotheticalProfileCountry
  {
    code!: string;
    region!: CalculationEngineInputsHypotheticalProfileRegion | null;

    constructor(data?: ICalculationEngineInputsHypotheticalProfileCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        this.region = _data['region']
          ? CalculationEngineInputsHypotheticalProfileRegion.fromJS(
              _data['region'],
            )
          : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): CalculationEngineInputsHypotheticalProfileCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsHypotheticalProfileCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      data['region'] = this.region ? this.region.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsHypotheticalProfileCountry {
    code: string;
    region: CalculationEngineInputsHypotheticalProfileRegion | null;
  }

  export class CalculationEngineInputsHypotheticalProfileRegion
    implements ICalculationEngineInputsHypotheticalProfileRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsHypotheticalProfileRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsHypotheticalProfileRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsHypotheticalProfileRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsHypotheticalProfileRegion {
    code: string;
  }

  export class CalculationEngineInputsTaxFundingAndGrossup
    implements ICalculationEngineInputsTaxFundingAndGrossup
  {
    taxesToGrossup!: CalculationEngineInputsTaxToGrossup[];
    taxesFundedBy!: CalculationEngineInputsTaxFundedBy[];

    constructor(data?: ICalculationEngineInputsTaxFundingAndGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.taxesToGrossup = [];
        this.taxesFundedBy = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['taxesToGrossup'])) {
          this.taxesToGrossup = [] as any;
          for (let item of _data['taxesToGrossup'])
            this.taxesToGrossup!.push(
              CalculationEngineInputsTaxToGrossup.fromJS(item),
            );
        } else {
          this.taxesToGrossup = <any>null;
        }
        if (Array.isArray(_data['taxesFundedBy'])) {
          this.taxesFundedBy = [] as any;
          for (let item of _data['taxesFundedBy'])
            this.taxesFundedBy!.push(
              CalculationEngineInputsTaxFundedBy.fromJS(item),
            );
        } else {
          this.taxesFundedBy = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxFundingAndGrossup {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxFundingAndGrossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.taxesToGrossup)) {
        data['taxesToGrossup'] = [];
        for (let item of this.taxesToGrossup)
          data['taxesToGrossup'].push(item.toJSON());
      }
      if (Array.isArray(this.taxesFundedBy)) {
        data['taxesFundedBy'] = [];
        for (let item of this.taxesFundedBy)
          data['taxesFundedBy'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxFundingAndGrossup {
    taxesToGrossup: CalculationEngineInputsTaxToGrossup[];
    taxesFundedBy: CalculationEngineInputsTaxFundedBy[];
  }

  export class CalculationEngineInputsTaxToGrossup
    implements ICalculationEngineInputsTaxToGrossup
  {
    taxType!: GrossupTaxType;
    grossupElection!: TaxToGrossupElection;
    planType!: PlanType | null;
    planCode!: string | null;
    workLocationType!: WorkLocationType | null;
    clientWorkLocationType!: string | null;
    countries!: CalculationEngineInputsTaxToGrossupCountry[];
    transactionId!: string | null;

    constructor(data?: ICalculationEngineInputsTaxToGrossup) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.grossupElection =
          _data['grossupElection'] !== undefined
            ? _data['grossupElection']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.clientWorkLocationType =
          _data['clientWorkLocationType'] !== undefined
            ? _data['clientWorkLocationType']
            : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(
              CalculationEngineInputsTaxToGrossupCountry.fromJS(item),
            );
        } else {
          this.countries = <any>null;
        }
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxToGrossup {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxToGrossup();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['grossupElection'] =
        this.grossupElection !== undefined ? this.grossupElection : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['clientWorkLocationType'] =
        this.clientWorkLocationType !== undefined
          ? this.clientWorkLocationType
          : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxToGrossup {
    taxType: GrossupTaxType;
    grossupElection: TaxToGrossupElection;
    planType: PlanType | null;
    planCode: string | null;
    workLocationType: WorkLocationType | null;
    clientWorkLocationType: string | null;
    countries: CalculationEngineInputsTaxToGrossupCountry[];
    transactionId: string | null;
  }

  export class CalculationEngineInputsTaxToGrossupCountry
    implements ICalculationEngineInputsTaxToGrossupCountry
  {
    code!: string;
    regions!: CalculationEngineInputsTaxToGrossupRegion[];

    constructor(data?: ICalculationEngineInputsTaxToGrossupCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(
              CalculationEngineInputsTaxToGrossupRegion.fromJS(item),
            );
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxToGrossupCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxToGrossupCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxToGrossupCountry {
    code: string;
    regions: CalculationEngineInputsTaxToGrossupRegion[];
  }

  export class CalculationEngineInputsTaxToGrossupRegion
    implements ICalculationEngineInputsTaxToGrossupRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsTaxToGrossupRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxToGrossupRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxToGrossupRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxToGrossupRegion {
    code: string;
  }

  export class CalculationEngineInputsTaxFundedBy
    implements ICalculationEngineInputsTaxFundedBy
  {
    grossupLocationType!: GrossupLocationType;
    taxType!: GrossupTaxType;
    hypotheticalFundedByEmployee!: boolean;
    actualFundedBy!: ActualTaxFundedBy;
    grossupFundedBy!: GrossupFundedBy | null;
    planType!: PlanType | null;
    planCode!: string | null;
    workLocationType!: WorkLocationType | null;
    countries!: CalculationEngineInputsTaxFundedByCountry[];
    transactionId!: string | null;

    constructor(data?: ICalculationEngineInputsTaxFundedBy) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countries = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.grossupLocationType =
          _data['grossupLocationType'] !== undefined
            ? _data['grossupLocationType']
            : <any>null;
        this.taxType =
          _data['taxType'] !== undefined ? _data['taxType'] : <any>null;
        this.hypotheticalFundedByEmployee =
          _data['hypotheticalFundedByEmployee'] !== undefined
            ? _data['hypotheticalFundedByEmployee']
            : <any>null;
        this.actualFundedBy =
          _data['actualFundedBy'] !== undefined
            ? _data['actualFundedBy']
            : <any>null;
        this.grossupFundedBy =
          _data['grossupFundedBy'] !== undefined
            ? _data['grossupFundedBy']
            : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        this.planCode =
          _data['planCode'] !== undefined ? _data['planCode'] : <any>null;
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        if (Array.isArray(_data['countries'])) {
          this.countries = [] as any;
          for (let item of _data['countries'])
            this.countries!.push(
              CalculationEngineInputsTaxFundedByCountry.fromJS(item),
            );
        } else {
          this.countries = <any>null;
        }
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxFundedBy {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxFundedBy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['grossupLocationType'] =
        this.grossupLocationType !== undefined
          ? this.grossupLocationType
          : <any>null;
      data['taxType'] = this.taxType !== undefined ? this.taxType : <any>null;
      data['hypotheticalFundedByEmployee'] =
        this.hypotheticalFundedByEmployee !== undefined
          ? this.hypotheticalFundedByEmployee
          : <any>null;
      data['actualFundedBy'] =
        this.actualFundedBy !== undefined ? this.actualFundedBy : <any>null;
      data['grossupFundedBy'] =
        this.grossupFundedBy !== undefined ? this.grossupFundedBy : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      data['planCode'] =
        this.planCode !== undefined ? this.planCode : <any>null;
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      if (Array.isArray(this.countries)) {
        data['countries'] = [];
        for (let item of this.countries) data['countries'].push(item.toJSON());
      }
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxFundedBy {
    grossupLocationType: GrossupLocationType;
    taxType: GrossupTaxType;
    hypotheticalFundedByEmployee: boolean;
    actualFundedBy: ActualTaxFundedBy;
    grossupFundedBy: GrossupFundedBy | null;
    planType: PlanType | null;
    planCode: string | null;
    workLocationType: WorkLocationType | null;
    countries: CalculationEngineInputsTaxFundedByCountry[];
    transactionId: string | null;
  }

  export class CalculationEngineInputsTaxFundedByCountry
    implements ICalculationEngineInputsTaxFundedByCountry
  {
    code!: string;
    regions!: CalculationEngineInputsTaxFundedByRegion[];

    constructor(data?: ICalculationEngineInputsTaxFundedByCountry) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.regions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
        if (Array.isArray(_data['regions'])) {
          this.regions = [] as any;
          for (let item of _data['regions'])
            this.regions!.push(
              CalculationEngineInputsTaxFundedByRegion.fromJS(item),
            );
        } else {
          this.regions = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxFundedByCountry {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxFundedByCountry();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      if (Array.isArray(this.regions)) {
        data['regions'] = [];
        for (let item of this.regions) data['regions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxFundedByCountry {
    code: string;
    regions: CalculationEngineInputsTaxFundedByRegion[];
  }

  export class CalculationEngineInputsTaxFundedByRegion
    implements ICalculationEngineInputsTaxFundedByRegion
  {
    code!: string;

    constructor(data?: ICalculationEngineInputsTaxFundedByRegion) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'] !== undefined ? _data['code'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationEngineInputsTaxFundedByRegion {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsTaxFundedByRegion();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code !== undefined ? this.code : <any>null;
      return data;
    }
  }

  export interface ICalculationEngineInputsTaxFundedByRegion {
    code: string;
  }

  export class CalculationEngineInputsEmployer
    implements ICalculationEngineInputsEmployer
  {
    userDefinedFields!: UserDefinedField[];
    clientId!: string;
    clientPortalId!: number;
    clientName!: string;
    manualCalculationSettings!: ManualCalculationSettings;
    exchangeRates!: ClientProvidedExchangeRate[] | null;

    constructor(data?: ICalculationEngineInputsEmployer) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.userDefinedFields = [];
        this.manualCalculationSettings = new ManualCalculationSettings();
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['userDefinedFields'])) {
          this.userDefinedFields = [] as any;
          for (let item of _data['userDefinedFields'])
            this.userDefinedFields!.push(UserDefinedField.fromJS(item));
        } else {
          this.userDefinedFields = <any>null;
        }
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.clientName =
          _data['clientName'] !== undefined ? _data['clientName'] : <any>null;
        this.manualCalculationSettings = _data['manualCalculationSettings']
          ? ManualCalculationSettings.fromJS(_data['manualCalculationSettings'])
          : new ManualCalculationSettings();
        if (Array.isArray(_data['exchangeRates'])) {
          this.exchangeRates = [] as any;
          for (let item of _data['exchangeRates'])
            this.exchangeRates!.push(ClientProvidedExchangeRate.fromJS(item));
        } else {
          this.exchangeRates = <any>null;
        }
      }
    }

    static fromJS(data: any): CalculationEngineInputsEmployer {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationEngineInputsEmployer();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.userDefinedFields)) {
        data['userDefinedFields'] = [];
        for (let item of this.userDefinedFields)
          data['userDefinedFields'].push(item.toJSON());
      }
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['clientName'] =
        this.clientName !== undefined ? this.clientName : <any>null;
      data['manualCalculationSettings'] = this.manualCalculationSettings
        ? this.manualCalculationSettings.toJSON()
        : <any>null;
      if (Array.isArray(this.exchangeRates)) {
        data['exchangeRates'] = [];
        for (let item of this.exchangeRates)
          data['exchangeRates'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICalculationEngineInputsEmployer {
    userDefinedFields: UserDefinedField[];
    clientId: string;
    clientPortalId: number;
    clientName: string;
    manualCalculationSettings: ManualCalculationSettings;
    exchangeRates: ClientProvidedExchangeRate[] | null;
  }

  export class EmployeeCalculationResults
    implements IEmployeeCalculationResults
  {
    employeeId!: string;
    manualCalculationRequired!: boolean;
    manualCalculationSendToWorkflow!: boolean;
    transactionResults!: TransactionResult[];
    employeeDiagnostic!: EmployeeDiagnostic | null;

    constructor(data?: IEmployeeCalculationResults) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionResults = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.manualCalculationRequired =
          _data['manualCalculationRequired'] !== undefined
            ? _data['manualCalculationRequired']
            : <any>null;
        this.manualCalculationSendToWorkflow =
          _data['manualCalculationSendToWorkflow'] !== undefined
            ? _data['manualCalculationSendToWorkflow']
            : <any>null;
        if (Array.isArray(_data['transactionResults'])) {
          this.transactionResults = [] as any;
          for (let item of _data['transactionResults'])
            this.transactionResults!.push(TransactionResult.fromJS(item));
        } else {
          this.transactionResults = <any>null;
        }
        this.employeeDiagnostic = _data['employeeDiagnostic']
          ? EmployeeDiagnostic.fromJS(_data['employeeDiagnostic'])
          : <any>null;
      }
    }

    static fromJS(data: any): EmployeeCalculationResults {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeCalculationResults();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['manualCalculationRequired'] =
        this.manualCalculationRequired !== undefined
          ? this.manualCalculationRequired
          : <any>null;
      data['manualCalculationSendToWorkflow'] =
        this.manualCalculationSendToWorkflow !== undefined
          ? this.manualCalculationSendToWorkflow
          : <any>null;
      if (Array.isArray(this.transactionResults)) {
        data['transactionResults'] = [];
        for (let item of this.transactionResults)
          data['transactionResults'].push(item.toJSON());
      }
      data['employeeDiagnostic'] = this.employeeDiagnostic
        ? this.employeeDiagnostic.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IEmployeeCalculationResults {
    employeeId: string;
    manualCalculationRequired: boolean;
    manualCalculationSendToWorkflow: boolean;
    transactionResults: TransactionResult[];
    employeeDiagnostic: EmployeeDiagnostic | null;
  }

  export class EmployeeDiagnostic implements IEmployeeDiagnostic {
    transactionDiagnostics!: TransactionDiagnostic[];

    constructor(data?: IEmployeeDiagnostic) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionDiagnostics = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['transactionDiagnostics'])) {
          this.transactionDiagnostics = [] as any;
          for (let item of _data['transactionDiagnostics'])
            this.transactionDiagnostics!.push(
              TransactionDiagnostic.fromJS(item),
            );
        } else {
          this.transactionDiagnostics = <any>null;
        }
      }
    }

    static fromJS(data: any): EmployeeDiagnostic {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeDiagnostic();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.transactionDiagnostics)) {
        data['transactionDiagnostics'] = [];
        for (let item of this.transactionDiagnostics)
          data['transactionDiagnostics'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IEmployeeDiagnostic {
    transactionDiagnostics: TransactionDiagnostic[];
  }

  export class TransactionDiagnostic implements ITransactionDiagnostic {
    transactionId!: string;
    awardName!: string;
    planType!: PlanType;
    transactionLevelDiagnostics!: CalculationDiagnostic[];
    locationPeriodDiagnostics!: LocationPeriodDiagnostic[];

    constructor(data?: ITransactionDiagnostic) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.transactionLevelDiagnostics = [];
        this.locationPeriodDiagnostics = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.awardName =
          _data['awardName'] !== undefined ? _data['awardName'] : <any>null;
        this.planType =
          _data['planType'] !== undefined ? _data['planType'] : <any>null;
        if (Array.isArray(_data['transactionLevelDiagnostics'])) {
          this.transactionLevelDiagnostics = [] as any;
          for (let item of _data['transactionLevelDiagnostics'])
            this.transactionLevelDiagnostics!.push(
              CalculationDiagnostic.fromJS(item),
            );
        } else {
          this.transactionLevelDiagnostics = <any>null;
        }
        if (Array.isArray(_data['locationPeriodDiagnostics'])) {
          this.locationPeriodDiagnostics = [] as any;
          for (let item of _data['locationPeriodDiagnostics'])
            this.locationPeriodDiagnostics!.push(
              LocationPeriodDiagnostic.fromJS(item),
            );
        } else {
          this.locationPeriodDiagnostics = <any>null;
        }
      }
    }

    static fromJS(data: any): TransactionDiagnostic {
      data = typeof data === 'object' ? data : {};
      let result = new TransactionDiagnostic();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['awardName'] =
        this.awardName !== undefined ? this.awardName : <any>null;
      data['planType'] =
        this.planType !== undefined ? this.planType : <any>null;
      if (Array.isArray(this.transactionLevelDiagnostics)) {
        data['transactionLevelDiagnostics'] = [];
        for (let item of this.transactionLevelDiagnostics)
          data['transactionLevelDiagnostics'].push(item.toJSON());
      }
      if (Array.isArray(this.locationPeriodDiagnostics)) {
        data['locationPeriodDiagnostics'] = [];
        for (let item of this.locationPeriodDiagnostics)
          data['locationPeriodDiagnostics'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITransactionDiagnostic {
    transactionId: string;
    awardName: string;
    planType: PlanType;
    transactionLevelDiagnostics: CalculationDiagnostic[];
    locationPeriodDiagnostics: LocationPeriodDiagnostic[];
  }

  export class CalculationDiagnostic implements ICalculationDiagnostic {
    property!: string;
    description!: string | null;
    value!: string | null;
    source!: DiagnosticSource;

    constructor(data?: ICalculationDiagnostic) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.property =
          _data['property'] !== undefined ? _data['property'] : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.source =
          _data['source'] !== undefined ? _data['source'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationDiagnostic {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationDiagnostic();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['property'] =
        this.property !== undefined ? this.property : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['source'] = this.source !== undefined ? this.source : <any>null;
      return data;
    }
  }

  export interface ICalculationDiagnostic {
    property: string;
    description: string | null;
    value: string | null;
    source: DiagnosticSource;
  }

  export enum DiagnosticSource {
    CountryTaxLogic = 'Country Tax Logic',
    CountryTaxBase = 'Country Tax Logic Base',
    ClientInputFile = 'Input File',
    DeloitteDefault = 'Deloitte Default',
  }

  export class LocationPeriodDiagnostic implements ILocationPeriodDiagnostic {
    startDate!: Date;
    endDate!: Date;
    countryDiagnostics!: CountryDiagnostic[];

    constructor(data?: ILocationPeriodDiagnostic) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryDiagnostics = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.startDate = _data['startDate']
          ? new Date(_data['startDate'].toString())
          : <any>null;
        this.endDate = _data['endDate']
          ? new Date(_data['endDate'].toString())
          : <any>null;
        if (Array.isArray(_data['countryDiagnostics'])) {
          this.countryDiagnostics = [] as any;
          for (let item of _data['countryDiagnostics'])
            this.countryDiagnostics!.push(CountryDiagnostic.fromJS(item));
        } else {
          this.countryDiagnostics = <any>null;
        }
      }
    }

    static fromJS(data: any): LocationPeriodDiagnostic {
      data = typeof data === 'object' ? data : {};
      let result = new LocationPeriodDiagnostic();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['startDate'] = this.startDate
        ? this.startDate.toISOString()
        : <any>null;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>null;
      if (Array.isArray(this.countryDiagnostics)) {
        data['countryDiagnostics'] = [];
        for (let item of this.countryDiagnostics)
          data['countryDiagnostics'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ILocationPeriodDiagnostic {
    startDate: Date;
    endDate: Date;
    countryDiagnostics: CountryDiagnostic[];
  }

  export class CountryDiagnostic implements ICountryDiagnostic {
    countryCode!: string;
    incomeTaxDiagnostics!: CalculationDiagnostic[];
    socialTaxDiagnostics!: CalculationDiagnostic[];
    regionTaxDiagnostics!: CalculationDiagnostic[];

    constructor(data?: ICountryDiagnostic) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.incomeTaxDiagnostics = [];
        this.socialTaxDiagnostics = [];
        this.regionTaxDiagnostics = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['incomeTaxDiagnostics'])) {
          this.incomeTaxDiagnostics = [] as any;
          for (let item of _data['incomeTaxDiagnostics'])
            this.incomeTaxDiagnostics!.push(CalculationDiagnostic.fromJS(item));
        } else {
          this.incomeTaxDiagnostics = <any>null;
        }
        if (Array.isArray(_data['socialTaxDiagnostics'])) {
          this.socialTaxDiagnostics = [] as any;
          for (let item of _data['socialTaxDiagnostics'])
            this.socialTaxDiagnostics!.push(CalculationDiagnostic.fromJS(item));
        } else {
          this.socialTaxDiagnostics = <any>null;
        }
        if (Array.isArray(_data['regionTaxDiagnostics'])) {
          this.regionTaxDiagnostics = [] as any;
          for (let item of _data['regionTaxDiagnostics'])
            this.regionTaxDiagnostics!.push(CalculationDiagnostic.fromJS(item));
        } else {
          this.regionTaxDiagnostics = <any>null;
        }
      }
    }

    static fromJS(data: any): CountryDiagnostic {
      data = typeof data === 'object' ? data : {};
      let result = new CountryDiagnostic();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.incomeTaxDiagnostics)) {
        data['incomeTaxDiagnostics'] = [];
        for (let item of this.incomeTaxDiagnostics)
          data['incomeTaxDiagnostics'].push(item.toJSON());
      }
      if (Array.isArray(this.socialTaxDiagnostics)) {
        data['socialTaxDiagnostics'] = [];
        for (let item of this.socialTaxDiagnostics)
          data['socialTaxDiagnostics'].push(item.toJSON());
      }
      if (Array.isArray(this.regionTaxDiagnostics)) {
        data['regionTaxDiagnostics'] = [];
        for (let item of this.regionTaxDiagnostics)
          data['regionTaxDiagnostics'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICountryDiagnostic {
    countryCode: string;
    incomeTaxDiagnostics: CalculationDiagnostic[];
    socialTaxDiagnostics: CalculationDiagnostic[];
    regionTaxDiagnostics: CalculationDiagnostic[];
  }

  export class CalcEngineLatestFormattedInputsAndResults
    implements ICalcEngineLatestFormattedInputsAndResults
  {
    inputs!: string;
    results!: string | null;
    runType!: CalculationRunType;
    timestamp!: Date | null;

    constructor(data?: ICalcEngineLatestFormattedInputsAndResults) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.inputs =
          _data['inputs'] !== undefined ? _data['inputs'] : <any>null;
        this.results =
          _data['results'] !== undefined ? _data['results'] : <any>null;
        this.runType =
          _data['runType'] !== undefined ? _data['runType'] : <any>null;
        this.timestamp = _data['timestamp']
          ? new Date(_data['timestamp'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): CalcEngineLatestFormattedInputsAndResults {
      data = typeof data === 'object' ? data : {};
      let result = new CalcEngineLatestFormattedInputsAndResults();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['inputs'] = this.inputs !== undefined ? this.inputs : <any>null;
      data['results'] = this.results !== undefined ? this.results : <any>null;
      data['runType'] = this.runType !== undefined ? this.runType : <any>null;
      data['timestamp'] = this.timestamp
        ? this.timestamp.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ICalcEngineLatestFormattedInputsAndResults {
    inputs: string;
    results: string | null;
    runType: CalculationRunType;
    timestamp: Date | null;
  }

  export enum CalculationRunType {
    OriginalCalculation = 'OriginalCalculation',
    ManualCalculation = 'ManualCalculation',
    GainAdjustment = 'GainAdjustment',
    BrokerAdjustment = 'BrokerAdjustment',
  }

  export class CalculateEmployeeCommandResult
    implements ICalculateEmployeeCommandResult
  {
    constructor(data?: ICalculateEmployeeCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): CalculateEmployeeCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new CalculateEmployeeCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ICalculateEmployeeCommandResult {}

  export class CalculateEmployeeCommandResultFailure
    extends CalculateEmployeeCommandResult
    implements ICalculateEmployeeCommandResultFailure
  {
    requestId!: string;
    calculationId!: string;
    clientId!: string;
    clientPortalId!: string;
    batchId!: string;
    errors!: ResultError[];

    constructor(data?: ICalculateEmployeeCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.requestId =
          _data['requestId'] !== undefined ? _data['requestId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): CalculateEmployeeCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new CalculateEmployeeCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['requestId'] =
        this.requestId !== undefined ? this.requestId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ICalculateEmployeeCommandResultFailure
    extends ICalculateEmployeeCommandResult {
    requestId: string;
    calculationId: string;
    clientId: string;
    clientPortalId: string;
    batchId: string;
    errors: ResultError[];
  }

  export class GetCalculationContextByIdQueryResultFailure
    extends GetCalculationContextByIdQueryResult
    implements IGetCalculationContextByIdQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCalculationContextByIdQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationContextByIdQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationContextByIdQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationContextByIdQueryResultFailure
    extends IGetCalculationContextByIdQueryResult {
    errors: ResultError[];
  }

  export abstract class GetCalculationAndPreProcessorInputsQueryResult
    implements IGetCalculationAndPreProcessorInputsQueryResult
  {
    constructor(data?: IGetCalculationAndPreProcessorInputsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationAndPreProcessorInputsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationAndPreProcessorInputsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationAndPreProcessorInputsQueryResult {}

  export class GetCalculationAndPreProcessorInputsQueryResultSuccess
    extends GetCalculationAndPreProcessorInputsQueryResult
    implements IGetCalculationAndPreProcessorInputsQueryResultSuccess
  {
    indexModel!: CalculationIndexModel;
    preProcessorInputs!: PreProcessorInputs;

    constructor(data?: IGetCalculationAndPreProcessorInputsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.indexModel = new CalculationIndexModel();
        this.preProcessorInputs = new PreProcessorInputs();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.indexModel = _data['indexModel']
          ? CalculationIndexModel.fromJS(_data['indexModel'])
          : new CalculationIndexModel();
        this.preProcessorInputs = _data['preProcessorInputs']
          ? PreProcessorInputs.fromJS(_data['preProcessorInputs'])
          : new PreProcessorInputs();
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationAndPreProcessorInputsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationAndPreProcessorInputsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['indexModel'] = this.indexModel
        ? this.indexModel.toJSON()
        : <any>null;
      data['preProcessorInputs'] = this.preProcessorInputs
        ? this.preProcessorInputs.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationAndPreProcessorInputsQueryResultSuccess
    extends IGetCalculationAndPreProcessorInputsQueryResult {
    indexModel: CalculationIndexModel;
    preProcessorInputs: PreProcessorInputs;
  }

  export class GetCalculationAndPreProcessorInputsQueryResultFailure
    extends GetCalculationAndPreProcessorInputsQueryResult
    implements IGetCalculationAndPreProcessorInputsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationAndPreProcessorInputsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationAndPreProcessorInputsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationAndPreProcessorInputsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationAndPreProcessorInputsQueryResultFailure
    extends IGetCalculationAndPreProcessorInputsQueryResult {
    errorMessage: string;
  }

  export abstract class GetCalculationEngineInputsQueryResult
    implements IGetCalculationEngineInputsQueryResult
  {
    constructor(data?: IGetCalculationEngineInputsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationEngineInputsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationEngineInputsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationEngineInputsQueryResult {}

  export class GetCalculationEngineInputsQueryResultSuccess
    extends GetCalculationEngineInputsQueryResult
    implements IGetCalculationEngineInputsQueryResultSuccess
  {
    calculationEngineInputs!: CalculationEngineInputs | null;

    constructor(data?: IGetCalculationEngineInputsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationEngineInputs = _data['calculationEngineInputs']
          ? CalculationEngineInputs.fromJS(_data['calculationEngineInputs'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineInputsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineInputsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationEngineInputs'] = this.calculationEngineInputs
        ? this.calculationEngineInputs.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineInputsQueryResultSuccess
    extends IGetCalculationEngineInputsQueryResult {
    calculationEngineInputs: CalculationEngineInputs | null;
  }

  export class GetCalculationEngineInputsQueryResultFailure
    extends GetCalculationEngineInputsQueryResult
    implements IGetCalculationEngineInputsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationEngineInputsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineInputsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineInputsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineInputsQueryResultFailure
    extends IGetCalculationEngineInputsQueryResult {
    errorMessage: string;
  }

  export abstract class GetCalculationEngineResultsQueryResult
    implements IGetCalculationEngineResultsQueryResult
  {
    constructor(data?: IGetCalculationEngineResultsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationEngineResultsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationEngineResultsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationEngineResultsQueryResult {}

  export class GetCalculationEngineResultsQueryResultSuccess
    extends GetCalculationEngineResultsQueryResult
    implements IGetCalculationEngineResultsQueryResultSuccess
  {
    calculationEngineResults!: EmployeeCalculationResults | null;

    constructor(data?: IGetCalculationEngineResultsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculationEngineResults = _data['calculationEngineResults']
          ? EmployeeCalculationResults.fromJS(_data['calculationEngineResults'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineResultsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineResultsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationEngineResults'] = this.calculationEngineResults
        ? this.calculationEngineResults.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineResultsQueryResultSuccess
    extends IGetCalculationEngineResultsQueryResult {
    calculationEngineResults: EmployeeCalculationResults | null;
  }

  export class GetCalculationEngineResultsQueryResultFailure
    extends GetCalculationEngineResultsQueryResult
    implements IGetCalculationEngineResultsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationEngineResultsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineResultsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineResultsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineResultsQueryResultFailure
    extends IGetCalculationEngineResultsQueryResult {
    errorMessage: string;
  }

  export abstract class GetCalculationEngineFailureResultQueryResult
    implements IGetCalculationEngineFailureResultQueryResult
  {
    constructor(data?: IGetCalculationEngineFailureResultQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationEngineFailureResultQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationEngineFailureResultQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationEngineFailureResultQueryResult {}

  export class GetCalculationEngineFailureResultQueryResultSuccess
    extends GetCalculationEngineFailureResultQueryResult
    implements IGetCalculationEngineFailureResultQueryResultSuccess
  {
    failure!: CalculateEmployeeCommandResultFailure | null;

    constructor(data?: IGetCalculationEngineFailureResultQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.failure = _data['failure']
          ? CalculateEmployeeCommandResultFailure.fromJS(_data['failure'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineFailureResultQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineFailureResultQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['failure'] = this.failure ? this.failure.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineFailureResultQueryResultSuccess
    extends IGetCalculationEngineFailureResultQueryResult {
    failure: CalculateEmployeeCommandResultFailure | null;
  }

  export class GetCalculationEngineFailureResultQueryResultFailure
    extends GetCalculationEngineFailureResultQueryResult
    implements IGetCalculationEngineFailureResultQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationEngineFailureResultQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineFailureResultQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineFailureResultQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineFailureResultQueryResultFailure
    extends IGetCalculationEngineFailureResultQueryResult {
    errorMessage: string;
  }

  export abstract class GetLatestFormattedInputsAndResultsQueryResult
    implements IGetLatestFormattedInputsAndResultsQueryResult
  {
    constructor(data?: IGetLatestFormattedInputsAndResultsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetLatestFormattedInputsAndResultsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetLatestFormattedInputsAndResultsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetLatestFormattedInputsAndResultsQueryResult {}

  export class GetLatestFormattedInputsAndResultsQueryResultSuccess
    extends GetLatestFormattedInputsAndResultsQueryResult
    implements IGetLatestFormattedInputsAndResultsQueryResultSuccess
  {
    result!: CalcEngineLatestFormattedInputsAndResults | null;

    constructor(data?: IGetLatestFormattedInputsAndResultsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CalcEngineLatestFormattedInputsAndResults.fromJS(_data['result'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetLatestFormattedInputsAndResultsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetLatestFormattedInputsAndResultsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLatestFormattedInputsAndResultsQueryResultSuccess
    extends IGetLatestFormattedInputsAndResultsQueryResult {
    result: CalcEngineLatestFormattedInputsAndResults | null;
  }

  export class GetLatestFormattedInputsAndResultsQueryResultFailure
    extends GetLatestFormattedInputsAndResultsQueryResult
    implements IGetLatestFormattedInputsAndResultsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetLatestFormattedInputsAndResultsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetLatestFormattedInputsAndResultsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetLatestFormattedInputsAndResultsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetLatestFormattedInputsAndResultsQueryResultFailure
    extends IGetLatestFormattedInputsAndResultsQueryResult {
    errorMessage: string;
  }

  export abstract class GetCalculationEngineOriginalResultsQueryResult
    implements IGetCalculationEngineOriginalResultsQueryResult
  {
    constructor(data?: IGetCalculationEngineOriginalResultsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationEngineOriginalResultsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationEngineOriginalResultsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationEngineOriginalResultsQueryResult {}

  export class GetCalculationEngineOriginalResultsQueryResultSuccess
    extends GetCalculationEngineOriginalResultsQueryResult
    implements IGetCalculationEngineOriginalResultsQueryResultSuccess
  {
    results!: EmployeeCalculationResults | null;

    constructor(data?: IGetCalculationEngineOriginalResultsQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.results = _data['results']
          ? EmployeeCalculationResults.fromJS(_data['results'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineOriginalResultsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineOriginalResultsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['results'] = this.results ? this.results.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineOriginalResultsQueryResultSuccess
    extends IGetCalculationEngineOriginalResultsQueryResult {
    results: EmployeeCalculationResults | null;
  }

  export class GetCalculationEngineOriginalResultsQueryResultFailure
    extends GetCalculationEngineOriginalResultsQueryResult
    implements IGetCalculationEngineOriginalResultsQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetCalculationEngineOriginalResultsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationEngineOriginalResultsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationEngineOriginalResultsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationEngineOriginalResultsQueryResultFailure
    extends IGetCalculationEngineOriginalResultsQueryResult {
    errorMessage: string;
  }

  export abstract class RecomputeCalculationResultsCommandResult
    implements IRecomputeCalculationResultsCommandResult
  {
    constructor(data?: IRecomputeCalculationResultsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): RecomputeCalculationResultsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'RecomputeCalculationResultsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IRecomputeCalculationResultsCommandResult {}

  export class RecomputeCalculationResultsCommandResultSuccess
    extends RecomputeCalculationResultsCommandResult
    implements IRecomputeCalculationResultsCommandResultSuccess
  {
    transactionResult!: TransactionResult;
    recomputeRequestBody!: string | null;
    recomputeResponseBody!: string | null;

    constructor(data?: IRecomputeCalculationResultsCommandResultSuccess) {
      super(data);
      if (!data) {
        this.transactionResult = new TransactionResult();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.transactionResult = _data['transactionResult']
          ? TransactionResult.fromJS(_data['transactionResult'])
          : new TransactionResult();
        this.recomputeRequestBody =
          _data['recomputeRequestBody'] !== undefined
            ? _data['recomputeRequestBody']
            : <any>null;
        this.recomputeResponseBody =
          _data['recomputeResponseBody'] !== undefined
            ? _data['recomputeResponseBody']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecomputeCalculationResultsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeCalculationResultsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['transactionResult'] = this.transactionResult
        ? this.transactionResult.toJSON()
        : <any>null;
      data['recomputeRequestBody'] =
        this.recomputeRequestBody !== undefined
          ? this.recomputeRequestBody
          : <any>null;
      data['recomputeResponseBody'] =
        this.recomputeResponseBody !== undefined
          ? this.recomputeResponseBody
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecomputeCalculationResultsCommandResultSuccess
    extends IRecomputeCalculationResultsCommandResult {
    transactionResult: TransactionResult;
    recomputeRequestBody: string | null;
    recomputeResponseBody: string | null;
  }

  export class RecomputeCalculationResultsCommandResultFailure
    extends RecomputeCalculationResultsCommandResult
    implements IRecomputeCalculationResultsCommandResultFailure
  {
    errorCode!: RecomputeCalculationResultsCommandResultFailureErrorCode;
    errorMessage!: string | null;
    command!: ConvertAndRoundCalculationResultsCommand | null;

    constructor(data?: IRecomputeCalculationResultsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
        this.command = _data['command']
          ? ConvertAndRoundCalculationResultsCommand.fromJS(_data['command'])
          : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecomputeCalculationResultsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeCalculationResultsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      data['command'] = this.command ? this.command.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecomputeCalculationResultsCommandResultFailure
    extends IRecomputeCalculationResultsCommandResult {
    errorCode: RecomputeCalculationResultsCommandResultFailureErrorCode;
    errorMessage: string | null;
    command: ConvertAndRoundCalculationResultsCommand | null;
  }

  export enum RecomputeCalculationResultsCommandResultFailureErrorCode {
    CalculationNotFound = 'CalculationNotFound',
    TransactionNotFound = 'TransactionNotFound',
    ConvertAndRoundCalculationResultsFailed = 'ConvertAndRoundCalculationResultsFailed',
    Unknown = 'Unknown',
  }

  export class ConvertAndRoundCalculationResultsCommand
    implements IConvertAndRoundCalculationResultsCommand
  {
    decimalNumberPrecision!: number | null;
    percentagePrecision!: number | null;
    currency!: string | null;
    currencyParameters!: ConvertAndRoundCalculationResultsCurrencyParameters | null;
    inputs!: CalculationEngineInputs;
    results!: EmployeeCalculationResults;

    constructor(data?: IConvertAndRoundCalculationResultsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.inputs = new CalculationEngineInputs();
        this.results = new EmployeeCalculationResults();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.decimalNumberPrecision =
          _data['decimalNumberPrecision'] !== undefined
            ? _data['decimalNumberPrecision']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
        this.currency =
          _data['currency'] !== undefined ? _data['currency'] : <any>null;
        this.currencyParameters = _data['currencyParameters']
          ? ConvertAndRoundCalculationResultsCurrencyParameters.fromJS(
              _data['currencyParameters'],
            )
          : <any>null;
        this.inputs = _data['inputs']
          ? CalculationEngineInputs.fromJS(_data['inputs'])
          : new CalculationEngineInputs();
        this.results = _data['results']
          ? EmployeeCalculationResults.fromJS(_data['results'])
          : new EmployeeCalculationResults();
      }
    }

    static fromJS(data: any): ConvertAndRoundCalculationResultsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new ConvertAndRoundCalculationResultsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['decimalNumberPrecision'] =
        this.decimalNumberPrecision !== undefined
          ? this.decimalNumberPrecision
          : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      data['currency'] =
        this.currency !== undefined ? this.currency : <any>null;
      data['currencyParameters'] = this.currencyParameters
        ? this.currencyParameters.toJSON()
        : <any>null;
      data['inputs'] = this.inputs ? this.inputs.toJSON() : <any>null;
      data['results'] = this.results ? this.results.toJSON() : <any>null;
      return data;
    }
  }

  export interface IConvertAndRoundCalculationResultsCommand {
    decimalNumberPrecision: number | null;
    percentagePrecision: number | null;
    currency: string | null;
    currencyParameters: ConvertAndRoundCalculationResultsCurrencyParameters | null;
    inputs: CalculationEngineInputs;
    results: EmployeeCalculationResults;
  }

  export class ConvertAndRoundCalculationResultsCurrencyParameters
    implements IConvertAndRoundCalculationResultsCurrencyParameters
  {
    currencyCode!: string;
    exchangeRatePolicy!: ExchangeRatePolicy;
    exchangeRates!: ClientProvidedExchangeRate[];

    constructor(data?: IConvertAndRoundCalculationResultsCurrencyParameters) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.exchangeRates = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.exchangeRatePolicy =
          _data['exchangeRatePolicy'] !== undefined
            ? _data['exchangeRatePolicy']
            : <any>null;
        if (Array.isArray(_data['exchangeRates'])) {
          this.exchangeRates = [] as any;
          for (let item of _data['exchangeRates'])
            this.exchangeRates!.push(ClientProvidedExchangeRate.fromJS(item));
        } else {
          this.exchangeRates = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): ConvertAndRoundCalculationResultsCurrencyParameters {
      data = typeof data === 'object' ? data : {};
      let result = new ConvertAndRoundCalculationResultsCurrencyParameters();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['exchangeRatePolicy'] =
        this.exchangeRatePolicy !== undefined
          ? this.exchangeRatePolicy
          : <any>null;
      if (Array.isArray(this.exchangeRates)) {
        data['exchangeRates'] = [];
        for (let item of this.exchangeRates)
          data['exchangeRates'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IConvertAndRoundCalculationResultsCurrencyParameters {
    currencyCode: string;
    exchangeRatePolicy: ExchangeRatePolicy;
    exchangeRates: ClientProvidedExchangeRate[];
  }

  export enum ExchangeRatePolicy {
    UseOandaRates = 'UseOandaRates',
    CompanyProvidePartial = 'CompanyProvidePartial',
    CompanyProvideFull = 'CompanyProvideFull',
  }

  export class RecomputeCalculationResultsCommand
    implements IRecomputeCalculationResultsCommand
  {
    clientId!: string;
    calculationId!: string;
    transactionGuid!: string;
    currencyCode!: string;
    percentagePrecision!: number | null;
    decimalNumberPrecision!: number | null;

    constructor(data?: IRecomputeCalculationResultsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.transactionGuid =
          _data['transactionGuid'] !== undefined
            ? _data['transactionGuid']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
        this.decimalNumberPrecision =
          _data['decimalNumberPrecision'] !== undefined
            ? _data['decimalNumberPrecision']
            : <any>null;
      }
    }

    static fromJS(data: any): RecomputeCalculationResultsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeCalculationResultsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['transactionGuid'] =
        this.transactionGuid !== undefined ? this.transactionGuid : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      data['decimalNumberPrecision'] =
        this.decimalNumberPrecision !== undefined
          ? this.decimalNumberPrecision
          : <any>null;
      return data;
    }
  }

  export interface IRecomputeCalculationResultsCommand {
    clientId: string;
    calculationId: string;
    transactionGuid: string;
    currencyCode: string;
    percentagePrecision: number | null;
    decimalNumberPrecision: number | null;
  }

  export abstract class RecomputeFullCalculationResultsCommandResult
    implements IRecomputeFullCalculationResultsCommandResult
  {
    constructor(data?: IRecomputeFullCalculationResultsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): RecomputeFullCalculationResultsCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'RecomputeFullCalculationResultsCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IRecomputeFullCalculationResultsCommandResult {}

  export class RecomputeFullCalculationResultsCommandResultSuccess
    extends RecomputeFullCalculationResultsCommandResult
    implements IRecomputeFullCalculationResultsCommandResultSuccess
  {
    recomputedInputJson!: string;
    recomputedResultsJson!: string;

    constructor(data?: IRecomputeFullCalculationResultsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.recomputedInputJson =
          _data['recomputedInputJson'] !== undefined
            ? _data['recomputedInputJson']
            : <any>null;
        this.recomputedResultsJson =
          _data['recomputedResultsJson'] !== undefined
            ? _data['recomputedResultsJson']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecomputeFullCalculationResultsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeFullCalculationResultsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['recomputedInputJson'] =
        this.recomputedInputJson !== undefined
          ? this.recomputedInputJson
          : <any>null;
      data['recomputedResultsJson'] =
        this.recomputedResultsJson !== undefined
          ? this.recomputedResultsJson
          : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecomputeFullCalculationResultsCommandResultSuccess
    extends IRecomputeFullCalculationResultsCommandResult {
    recomputedInputJson: string;
    recomputedResultsJson: string;
  }

  export class RecomputeFullCalculationResultsCommandResultFailure
    extends RecomputeFullCalculationResultsCommandResult
    implements IRecomputeFullCalculationResultsCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: IRecomputeFullCalculationResultsCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): RecomputeFullCalculationResultsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeFullCalculationResultsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IRecomputeFullCalculationResultsCommandResultFailure
    extends IRecomputeFullCalculationResultsCommandResult {
    errorMessage: string;
  }

  export class RecomputeFullCalculationResultsCommand
    implements IRecomputeFullCalculationResultsCommand
  {
    calculationId!: string;
    currencyCode!: string;
    percentagePrecision!: number;
    decimalNumberPrecision!: number;

    constructor(data?: IRecomputeFullCalculationResultsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.calculationId =
          _data['calculationId'] !== undefined
            ? _data['calculationId']
            : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.percentagePrecision =
          _data['percentagePrecision'] !== undefined
            ? _data['percentagePrecision']
            : <any>null;
        this.decimalNumberPrecision =
          _data['decimalNumberPrecision'] !== undefined
            ? _data['decimalNumberPrecision']
            : <any>null;
      }
    }

    static fromJS(data: any): RecomputeFullCalculationResultsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new RecomputeFullCalculationResultsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationId'] =
        this.calculationId !== undefined ? this.calculationId : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['percentagePrecision'] =
        this.percentagePrecision !== undefined
          ? this.percentagePrecision
          : <any>null;
      data['decimalNumberPrecision'] =
        this.decimalNumberPrecision !== undefined
          ? this.decimalNumberPrecision
          : <any>null;
      return data;
    }
  }

  export interface IRecomputeFullCalculationResultsCommand {
    calculationId: string;
    currencyCode: string;
    percentagePrecision: number;
    decimalNumberPrecision: number;
  }

  export class GetBrokerPageDataQueryResult
    implements IGetBrokerPageDataQueryResult
  {
    constructor(data?: IGetBrokerPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBrokerPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetBrokerPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBrokerPageDataQueryResult {}

  export class GetBrokerPageDataQueryResultSuccess
    extends GetBrokerPageDataQueryResult
    implements IGetBrokerPageDataQueryResultSuccess
  {
    result!: BrokerPageData;

    constructor(data?: IGetBrokerPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new BrokerPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? BrokerPageData.fromJS(_data['result'])
          : new BrokerPageData();
      }
    }

    static override fromJS(data: any): GetBrokerPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBrokerPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBrokerPageDataQueryResultSuccess
    extends IGetBrokerPageDataQueryResult {
    result: BrokerPageData;
  }

  export class BrokerPageData implements IBrokerPageData {
    brokerProviders!: BrokerProviderLookupOptionDto[];
    clientBrokerDetails!: ClientBrokerDetailsDto | null;

    constructor(data?: IBrokerPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.brokerProviders = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['brokerProviders'])) {
          this.brokerProviders = [] as any;
          for (let item of _data['brokerProviders'])
            this.brokerProviders!.push(
              BrokerProviderLookupOptionDto.fromJS(item),
            );
        } else {
          this.brokerProviders = <any>null;
        }
        this.clientBrokerDetails = _data['clientBrokerDetails']
          ? ClientBrokerDetailsDto.fromJS(_data['clientBrokerDetails'])
          : <any>null;
      }
    }

    static fromJS(data: any): BrokerPageData {
      data = typeof data === 'object' ? data : {};
      let result = new BrokerPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.brokerProviders)) {
        data['brokerProviders'] = [];
        for (let item of this.brokerProviders)
          data['brokerProviders'].push(item.toJSON());
      }
      data['clientBrokerDetails'] = this.clientBrokerDetails
        ? this.clientBrokerDetails.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IBrokerPageData {
    brokerProviders: BrokerProviderLookupOptionDto[];
    clientBrokerDetails: ClientBrokerDetailsDto | null;
  }

  export class BrokerProviderLookupOptionDto
    implements IBrokerProviderLookupOptionDto
  {
    id!: string;
    display!: string;
    displayOrder!: number;

    constructor(data?: IBrokerProviderLookupOptionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.display =
          _data['display'] !== undefined ? _data['display'] : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): BrokerProviderLookupOptionDto {
      data = typeof data === 'object' ? data : {};
      let result = new BrokerProviderLookupOptionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['display'] = this.display !== undefined ? this.display : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IBrokerProviderLookupOptionDto {
    id: string;
    display: string;
    displayOrder: number;
  }

  export class GetBrokerPageDataQueryResultFailure
    extends GetBrokerPageDataQueryResult
    implements IGetBrokerPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBrokerPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBrokerPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBrokerPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBrokerPageDataQueryResultFailure
    extends IGetBrokerPageDataQueryResult {
    errors: ResultError[];
  }

  export class SaveClientBrokerDetailsCommandResult
    implements ISaveClientBrokerDetailsCommandResult
  {
    constructor(data?: ISaveClientBrokerDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SaveClientBrokerDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientBrokerDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISaveClientBrokerDetailsCommandResult {}

  export class SaveClientBrokerDetailsCommandResultSuccess
    extends SaveClientBrokerDetailsCommandResult
    implements ISaveClientBrokerDetailsCommandResultSuccess
  {
    constructor(data?: ISaveClientBrokerDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): SaveClientBrokerDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientBrokerDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientBrokerDetailsCommandResultSuccess
    extends ISaveClientBrokerDetailsCommandResult {}

  export class SaveClientBrokerDetailsCommandResultFailure
    extends SaveClientBrokerDetailsCommandResult
    implements ISaveClientBrokerDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISaveClientBrokerDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SaveClientBrokerDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientBrokerDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISaveClientBrokerDetailsCommandResultFailure
    extends ISaveClientBrokerDetailsCommandResult {
    errors: ResultError[];
  }

  export class SaveClientBrokerDetailsCommand
    implements ISaveClientBrokerDetailsCommand
  {
    clientId!: string;
    brokerOptions!: string[];
    otherBrokerOption!: string;

    constructor(data?: ISaveClientBrokerDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.brokerOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['brokerOptions'])) {
          this.brokerOptions = [] as any;
          for (let item of _data['brokerOptions'])
            this.brokerOptions!.push(item);
        } else {
          this.brokerOptions = <any>null;
        }
        this.otherBrokerOption =
          _data['otherBrokerOption'] !== undefined
            ? _data['otherBrokerOption']
            : <any>null;
      }
    }

    static fromJS(data: any): SaveClientBrokerDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveClientBrokerDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.brokerOptions)) {
        data['brokerOptions'] = [];
        for (let item of this.brokerOptions) data['brokerOptions'].push(item);
      }
      data['otherBrokerOption'] =
        this.otherBrokerOption !== undefined
          ? this.otherBrokerOption
          : <any>null;
      return data;
    }
  }

  export interface ISaveClientBrokerDetailsCommand {
    clientId: string;
    brokerOptions: string[];
    otherBrokerOption: string;
  }

  export class GetClientDataContextQueryResult
    implements IGetClientDataContextQueryResult
  {
    constructor(data?: IGetClientDataContextQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientDataContextQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataContextQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientDataContextQueryResult {}

  export class GetClientDataContextQueryResultSuccess
    extends GetClientDataContextQueryResult
    implements IGetClientDataContextQueryResultSuccess
  {
    clientDataContext!: ClientDataContextDto;

    constructor(data?: IGetClientDataContextQueryResultSuccess) {
      super(data);
      if (!data) {
        this.clientDataContext = new ClientDataContextDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientDataContext = _data['clientDataContext']
          ? ClientDataContextDto.fromJS(_data['clientDataContext'])
          : new ClientDataContextDto();
      }
    }

    static override fromJS(data: any): GetClientDataContextQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataContextQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientDataContext'] = this.clientDataContext
        ? this.clientDataContext.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientDataContextQueryResultSuccess
    extends IGetClientDataContextQueryResult {
    clientDataContext: ClientDataContextDto;
  }

  export class ClientDataContextDto implements IClientDataContextDto {
    canImportClientPIIData!: boolean;
    canImportClientNonPIIData!: boolean;
    canExportClientPIIData!: boolean;
    canExportClientNonPIIData!: boolean;
    canOnlyImportClientData!: boolean;
    canImportAnyClient!: boolean;
    canImportClientData!: boolean;
    canExportClientData!: boolean;

    constructor(data?: IClientDataContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.canImportClientPIIData =
          _data['canImportClientPIIData'] !== undefined
            ? _data['canImportClientPIIData']
            : <any>null;
        this.canImportClientNonPIIData =
          _data['canImportClientNonPIIData'] !== undefined
            ? _data['canImportClientNonPIIData']
            : <any>null;
        this.canExportClientPIIData =
          _data['canExportClientPIIData'] !== undefined
            ? _data['canExportClientPIIData']
            : <any>null;
        this.canExportClientNonPIIData =
          _data['canExportClientNonPIIData'] !== undefined
            ? _data['canExportClientNonPIIData']
            : <any>null;
        this.canOnlyImportClientData =
          _data['canOnlyImportClientData'] !== undefined
            ? _data['canOnlyImportClientData']
            : <any>null;
        this.canImportAnyClient =
          _data['canImportAnyClient'] !== undefined
            ? _data['canImportAnyClient']
            : <any>null;
        this.canImportClientData =
          _data['canImportClientData'] !== undefined
            ? _data['canImportClientData']
            : <any>null;
        this.canExportClientData =
          _data['canExportClientData'] !== undefined
            ? _data['canExportClientData']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientDataContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientDataContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['canImportClientPIIData'] =
        this.canImportClientPIIData !== undefined
          ? this.canImportClientPIIData
          : <any>null;
      data['canImportClientNonPIIData'] =
        this.canImportClientNonPIIData !== undefined
          ? this.canImportClientNonPIIData
          : <any>null;
      data['canExportClientPIIData'] =
        this.canExportClientPIIData !== undefined
          ? this.canExportClientPIIData
          : <any>null;
      data['canExportClientNonPIIData'] =
        this.canExportClientNonPIIData !== undefined
          ? this.canExportClientNonPIIData
          : <any>null;
      data['canOnlyImportClientData'] =
        this.canOnlyImportClientData !== undefined
          ? this.canOnlyImportClientData
          : <any>null;
      data['canImportAnyClient'] =
        this.canImportAnyClient !== undefined
          ? this.canImportAnyClient
          : <any>null;
      data['canImportClientData'] =
        this.canImportClientData !== undefined
          ? this.canImportClientData
          : <any>null;
      data['canExportClientData'] =
        this.canExportClientData !== undefined
          ? this.canExportClientData
          : <any>null;
      return data;
    }
  }

  export interface IClientDataContextDto {
    canImportClientPIIData: boolean;
    canImportClientNonPIIData: boolean;
    canExportClientPIIData: boolean;
    canExportClientNonPIIData: boolean;
    canOnlyImportClientData: boolean;
    canImportAnyClient: boolean;
    canImportClientData: boolean;
    canExportClientData: boolean;
  }

  export class GetClientDataContextQueryResultFailure
    extends GetClientDataContextQueryResult
    implements IGetClientDataContextQueryResultFailure
  {
    constructor(data?: IGetClientDataContextQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetClientDataContextQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataContextQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientDataContextQueryResultFailure
    extends IGetClientDataContextQueryResult {}

  export class GetClientDataContextQuery implements IGetClientDataContextQuery {
    constructor(data?: IGetClientDataContextQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientDataContextQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataContextQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientDataContextQuery {}

  export class GetClientDataExportContextQueryResult
    implements IGetClientDataExportContextQueryResult
  {
    constructor(data?: IGetClientDataExportContextQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetClientDataExportContextQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataExportContextQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetClientDataExportContextQueryResult {}

  export class GetClientDataExportContextQueryResultSuccess
    extends GetClientDataExportContextQueryResult
    implements IGetClientDataExportContextQueryResultSuccess
  {
    clientDataExportContext!: ClientDataExportContextDto;

    constructor(data?: IGetClientDataExportContextQueryResultSuccess) {
      super(data);
      if (!data) {
        this.clientDataExportContext = new ClientDataExportContextDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientDataExportContext = _data['clientDataExportContext']
          ? ClientDataExportContextDto.fromJS(_data['clientDataExportContext'])
          : new ClientDataExportContextDto();
      }
    }

    static override fromJS(
      data: any,
    ): GetClientDataExportContextQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataExportContextQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientDataExportContext'] = this.clientDataExportContext
        ? this.clientDataExportContext.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientDataExportContextQueryResultSuccess
    extends IGetClientDataExportContextQueryResult {
    clientDataExportContext: ClientDataExportContextDto;
  }

  export class ClientDataExportContextDto
    implements IClientDataExportContextDto
  {
    canExportClientData!: boolean;

    constructor(data?: IClientDataExportContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.canExportClientData =
          _data['canExportClientData'] !== undefined
            ? _data['canExportClientData']
            : <any>null;
      }
    }

    static fromJS(data: any): ClientDataExportContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientDataExportContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['canExportClientData'] =
        this.canExportClientData !== undefined
          ? this.canExportClientData
          : <any>null;
      return data;
    }
  }

  export interface IClientDataExportContextDto {
    canExportClientData: boolean;
  }

  export class GetClientDataExportContextQueryResultFailure
    extends GetClientDataExportContextQueryResult
    implements IGetClientDataExportContextQueryResultFailure
  {
    constructor(data?: IGetClientDataExportContextQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetClientDataExportContextQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetClientDataExportContextQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetClientDataExportContextQueryResultFailure
    extends IGetClientDataExportContextQueryResult {}

  export class ExportClientDataCommandResult
    implements IExportClientDataCommandResult
  {
    constructor(data?: IExportClientDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ExportClientDataCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ExportClientDataCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IExportClientDataCommandResult {}

  export class ExportClientDataCommandResultSuccess
    extends ExportClientDataCommandResult
    implements IExportClientDataCommandResultSuccess
  {
    exportClientNonPIIDetails!: ExportClientDataDetailsDto;
    exportClientPIIDetails!: ExportClientDataDetailsDto | null;
    environment!: string;

    constructor(data?: IExportClientDataCommandResultSuccess) {
      super(data);
      if (!data) {
        this.exportClientNonPIIDetails = new ExportClientDataDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.exportClientNonPIIDetails = _data['exportClientNonPIIDetails']
          ? ExportClientDataDetailsDto.fromJS(
              _data['exportClientNonPIIDetails'],
            )
          : new ExportClientDataDetailsDto();
        this.exportClientPIIDetails = _data['exportClientPIIDetails']
          ? ExportClientDataDetailsDto.fromJS(_data['exportClientPIIDetails'])
          : <any>null;
        this.environment =
          _data['environment'] !== undefined ? _data['environment'] : <any>null;
      }
    }

    static override fromJS(data: any): ExportClientDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ExportClientDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['exportClientNonPIIDetails'] = this.exportClientNonPIIDetails
        ? this.exportClientNonPIIDetails.toJSON()
        : <any>null;
      data['exportClientPIIDetails'] = this.exportClientPIIDetails
        ? this.exportClientPIIDetails.toJSON()
        : <any>null;
      data['environment'] =
        this.environment !== undefined ? this.environment : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IExportClientDataCommandResultSuccess
    extends IExportClientDataCommandResult {
    exportClientNonPIIDetails: ExportClientDataDetailsDto;
    exportClientPIIDetails: ExportClientDataDetailsDto | null;
    environment: string;
  }

  export class ExportClientDataDetailsDto
    implements IExportClientDataDetailsDto
  {
    keyId!: string;
    encryptedDataKey!: string;
    encryptedPreSignedUrls!: string;

    constructor(data?: IExportClientDataDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.keyId = _data['keyId'] !== undefined ? _data['keyId'] : <any>null;
        this.encryptedDataKey =
          _data['encryptedDataKey'] !== undefined
            ? _data['encryptedDataKey']
            : <any>null;
        this.encryptedPreSignedUrls =
          _data['encryptedPreSignedUrls'] !== undefined
            ? _data['encryptedPreSignedUrls']
            : <any>null;
      }
    }

    static fromJS(data: any): ExportClientDataDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExportClientDataDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['keyId'] = this.keyId !== undefined ? this.keyId : <any>null;
      data['encryptedDataKey'] =
        this.encryptedDataKey !== undefined ? this.encryptedDataKey : <any>null;
      data['encryptedPreSignedUrls'] =
        this.encryptedPreSignedUrls !== undefined
          ? this.encryptedPreSignedUrls
          : <any>null;
      return data;
    }
  }

  export interface IExportClientDataDetailsDto {
    keyId: string;
    encryptedDataKey: string;
    encryptedPreSignedUrls: string;
  }

  export class ExportClientDataCommandResultFailure
    extends ExportClientDataCommandResult
    implements IExportClientDataCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IExportClientDataCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): ExportClientDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ExportClientDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IExportClientDataCommandResultFailure
    extends IExportClientDataCommandResult {
    errors: ResultError[];
  }

  export class ImportClientPIIDataCommandResult
    implements IImportClientPIIDataCommandResult
  {
    constructor(data?: IImportClientPIIDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ImportClientPIIDataCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientPIIDataCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IImportClientPIIDataCommandResult {}

  export class ImportClientPIIDataCommandResultSuccess
    extends ImportClientPIIDataCommandResult
    implements IImportClientPIIDataCommandResultSuccess
  {
    clientPortalId!: string;

    constructor(data?: IImportClientPIIDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
      }
    }

    static override fromJS(data: any): ImportClientPIIDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientPIIDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IImportClientPIIDataCommandResultSuccess
    extends IImportClientPIIDataCommandResult {
    clientPortalId: string;
  }

  export class ImportClientPIIDataCommandResultFailure
    extends ImportClientPIIDataCommandResult
    implements IImportClientPIIDataCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IImportClientPIIDataCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): ImportClientPIIDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientPIIDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IImportClientPIIDataCommandResultFailure
    extends IImportClientPIIDataCommandResult {
    errors: ResultError[];
  }

  export class ImportClientNonPIIDataCommandResult
    implements IImportClientNonPIIDataCommandResult
  {
    constructor(data?: IImportClientNonPIIDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): ImportClientNonPIIDataCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientNonPIIDataCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IImportClientNonPIIDataCommandResult {}

  export class ImportClientNonPIIDataCommandResultSuccess
    extends ImportClientNonPIIDataCommandResult
    implements IImportClientNonPIIDataCommandResultSuccess
  {
    clientPortalId!: string;

    constructor(data?: IImportClientNonPIIDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): ImportClientNonPIIDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientNonPIIDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IImportClientNonPIIDataCommandResultSuccess
    extends IImportClientNonPIIDataCommandResult {
    clientPortalId: string;
  }

  export class ImportClientNonPIIDataCommandResultFailure
    extends ImportClientNonPIIDataCommandResult
    implements IImportClientNonPIIDataCommandResultFailure
  {
    constructor(data?: IImportClientNonPIIDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): ImportClientNonPIIDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new ImportClientNonPIIDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IImportClientNonPIIDataCommandResultFailure
    extends IImportClientNonPIIDataCommandResult {}

  export class GetCashPaymentPolicyPageDataQueryResult
    implements IGetCashPaymentPolicyPageDataQueryResult
  {
    constructor(data?: IGetCashPaymentPolicyPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCashPaymentPolicyPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentPolicyPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCashPaymentPolicyPageDataQueryResult {}

  export class GetCashPaymentPolicyPageDataQueryResultSuccess
    extends GetCashPaymentPolicyPageDataQueryResult
    implements IGetCashPaymentPolicyPageDataQueryResultSuccess
  {
    result!: CashPaymentPolicyPageData;

    constructor(data?: IGetCashPaymentPolicyPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CashPaymentPolicyPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CashPaymentPolicyPageData.fromJS(_data['result'])
          : new CashPaymentPolicyPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentPolicyPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentPolicyPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentPolicyPageDataQueryResultSuccess
    extends IGetCashPaymentPolicyPageDataQueryResult {
    result: CashPaymentPolicyPageData;
  }

  export class CashPaymentPolicyPageData implements ICashPaymentPolicyPageData {
    cashPaymentPolicySettings!: CashPaymentPolicySettingsV2Dto;
    countriesInFootprint!: CashPaymentPolicyCountryData[];
    cashBonusCashPaymentPolicySettingOptions!: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions!: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions!: StockOptionCashPaymentPolicySettingDto[];
    planTypes!: PlanTypeDto[];
    configuredPlanTypes!: PlanTypeDto[];
    workLocationTypes!: WorkLocationTypeSettingDto[];
    configuredWorkLocationTypes!: WorkLocationTypeSettingDto[];
    planIdToCodeMap!: { [key: string]: string };
    rsuPlanCodes!: string[];
    stockOptionPlanCodes!: string[];
    cashBonusPlanCodes!: string[];

    constructor(data?: ICashPaymentPolicyPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.cashPaymentPolicySettings = new CashPaymentPolicySettingsV2Dto();
        this.countriesInFootprint = [];
        this.cashBonusCashPaymentPolicySettingOptions = [];
        this.restrictedStockUnitCashPaymentPolicySettingOptions = [];
        this.stockOptionCashPaymentPolicySettingOptions = [];
        this.planTypes = [];
        this.configuredPlanTypes = [];
        this.workLocationTypes = [];
        this.configuredWorkLocationTypes = [];
        this.planIdToCodeMap = {};
        this.rsuPlanCodes = [];
        this.stockOptionPlanCodes = [];
        this.cashBonusPlanCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.cashPaymentPolicySettings = _data['cashPaymentPolicySettings']
          ? CashPaymentPolicySettingsV2Dto.fromJS(
              _data['cashPaymentPolicySettings'],
            )
          : new CashPaymentPolicySettingsV2Dto();
        if (Array.isArray(_data['countriesInFootprint'])) {
          this.countriesInFootprint = [] as any;
          for (let item of _data['countriesInFootprint'])
            this.countriesInFootprint!.push(
              CashPaymentPolicyCountryData.fromJS(item),
            );
        } else {
          this.countriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['cashBonusCashPaymentPolicySettingOptions'])) {
          this.cashBonusCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['cashBonusCashPaymentPolicySettingOptions'])
            this.cashBonusCashPaymentPolicySettingOptions!.push(
              CashBonusCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.cashBonusCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitCashPaymentPolicySettingOptions'],
          )
        ) {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data[
            'restrictedStockUnitCashPaymentPolicySettingOptions'
          ])
            this.restrictedStockUnitCashPaymentPolicySettingOptions!.push(
              RestrictedStockUnitCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.restrictedStockUnitCashPaymentPolicySettingOptions = <any>null;
        }
        if (
          Array.isArray(_data['stockOptionCashPaymentPolicySettingOptions'])
        ) {
          this.stockOptionCashPaymentPolicySettingOptions = [] as any;
          for (let item of _data['stockOptionCashPaymentPolicySettingOptions'])
            this.stockOptionCashPaymentPolicySettingOptions!.push(
              StockOptionCashPaymentPolicySettingDto.fromJS(item),
            );
        } else {
          this.stockOptionCashPaymentPolicySettingOptions = <any>null;
        }
        if (Array.isArray(_data['planTypes'])) {
          this.planTypes = [] as any;
          for (let item of _data['planTypes'])
            this.planTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.planTypes = <any>null;
        }
        if (Array.isArray(_data['configuredPlanTypes'])) {
          this.configuredPlanTypes = [] as any;
          for (let item of _data['configuredPlanTypes'])
            this.configuredPlanTypes!.push(PlanTypeDto.fromJS(item));
        } else {
          this.configuredPlanTypes = <any>null;
        }
        if (Array.isArray(_data['workLocationTypes'])) {
          this.workLocationTypes = [] as any;
          for (let item of _data['workLocationTypes'])
            this.workLocationTypes!.push(
              WorkLocationTypeSettingDto.fromJS(item),
            );
        } else {
          this.workLocationTypes = <any>null;
        }
        if (Array.isArray(_data['configuredWorkLocationTypes'])) {
          this.configuredWorkLocationTypes = [] as any;
          for (let item of _data['configuredWorkLocationTypes'])
            this.configuredWorkLocationTypes!.push(
              WorkLocationTypeSettingDto.fromJS(item),
            );
        } else {
          this.configuredWorkLocationTypes = <any>null;
        }
        if (_data['planIdToCodeMap']) {
          this.planIdToCodeMap = {} as any;
          for (let key in _data['planIdToCodeMap']) {
            if (_data['planIdToCodeMap'].hasOwnProperty(key))
              (<any>this.planIdToCodeMap)![key] =
                _data['planIdToCodeMap'][key] !== undefined
                  ? _data['planIdToCodeMap'][key]
                  : <any>null;
          }
        } else {
          this.planIdToCodeMap = <any>null;
        }
        if (Array.isArray(_data['rsuPlanCodes'])) {
          this.rsuPlanCodes = [] as any;
          for (let item of _data['rsuPlanCodes']) this.rsuPlanCodes!.push(item);
        } else {
          this.rsuPlanCodes = <any>null;
        }
        if (Array.isArray(_data['stockOptionPlanCodes'])) {
          this.stockOptionPlanCodes = [] as any;
          for (let item of _data['stockOptionPlanCodes'])
            this.stockOptionPlanCodes!.push(item);
        } else {
          this.stockOptionPlanCodes = <any>null;
        }
        if (Array.isArray(_data['cashBonusPlanCodes'])) {
          this.cashBonusPlanCodes = [] as any;
          for (let item of _data['cashBonusPlanCodes'])
            this.cashBonusPlanCodes!.push(item);
        } else {
          this.cashBonusPlanCodes = <any>null;
        }
      }
    }

    static fromJS(data: any): CashPaymentPolicyPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicyPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['cashPaymentPolicySettings'] = this.cashPaymentPolicySettings
        ? this.cashPaymentPolicySettings.toJSON()
        : <any>null;
      if (Array.isArray(this.countriesInFootprint)) {
        data['countriesInFootprint'] = [];
        for (let item of this.countriesInFootprint)
          data['countriesInFootprint'].push(item.toJSON());
      }
      if (Array.isArray(this.cashBonusCashPaymentPolicySettingOptions)) {
        data['cashBonusCashPaymentPolicySettingOptions'] = [];
        for (let item of this.cashBonusCashPaymentPolicySettingOptions)
          data['cashBonusCashPaymentPolicySettingOptions'].push(item.toJSON());
      }
      if (
        Array.isArray(this.restrictedStockUnitCashPaymentPolicySettingOptions)
      ) {
        data['restrictedStockUnitCashPaymentPolicySettingOptions'] = [];
        for (let item of this
          .restrictedStockUnitCashPaymentPolicySettingOptions)
          data['restrictedStockUnitCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionCashPaymentPolicySettingOptions)) {
        data['stockOptionCashPaymentPolicySettingOptions'] = [];
        for (let item of this.stockOptionCashPaymentPolicySettingOptions)
          data['stockOptionCashPaymentPolicySettingOptions'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.planTypes)) {
        data['planTypes'] = [];
        for (let item of this.planTypes) data['planTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredPlanTypes)) {
        data['configuredPlanTypes'] = [];
        for (let item of this.configuredPlanTypes)
          data['configuredPlanTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.workLocationTypes)) {
        data['workLocationTypes'] = [];
        for (let item of this.workLocationTypes)
          data['workLocationTypes'].push(item.toJSON());
      }
      if (Array.isArray(this.configuredWorkLocationTypes)) {
        data['configuredWorkLocationTypes'] = [];
        for (let item of this.configuredWorkLocationTypes)
          data['configuredWorkLocationTypes'].push(item.toJSON());
      }
      if (this.planIdToCodeMap) {
        data['planIdToCodeMap'] = {};
        for (let key in this.planIdToCodeMap) {
          if (this.planIdToCodeMap.hasOwnProperty(key))
            (<any>data['planIdToCodeMap'])[key] =
              this.planIdToCodeMap[key] !== undefined
                ? this.planIdToCodeMap[key]
                : <any>null;
        }
      }
      if (Array.isArray(this.rsuPlanCodes)) {
        data['rsuPlanCodes'] = [];
        for (let item of this.rsuPlanCodes) data['rsuPlanCodes'].push(item);
      }
      if (Array.isArray(this.stockOptionPlanCodes)) {
        data['stockOptionPlanCodes'] = [];
        for (let item of this.stockOptionPlanCodes)
          data['stockOptionPlanCodes'].push(item);
      }
      if (Array.isArray(this.cashBonusPlanCodes)) {
        data['cashBonusPlanCodes'] = [];
        for (let item of this.cashBonusPlanCodes)
          data['cashBonusPlanCodes'].push(item);
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyPageData {
    cashPaymentPolicySettings: CashPaymentPolicySettingsV2Dto;
    countriesInFootprint: CashPaymentPolicyCountryData[];
    cashBonusCashPaymentPolicySettingOptions: CashBonusCashPaymentPolicySettingDto[];
    restrictedStockUnitCashPaymentPolicySettingOptions: RestrictedStockUnitCashPaymentPolicySettingDto[];
    stockOptionCashPaymentPolicySettingOptions: StockOptionCashPaymentPolicySettingDto[];
    planTypes: PlanTypeDto[];
    configuredPlanTypes: PlanTypeDto[];
    workLocationTypes: WorkLocationTypeSettingDto[];
    configuredWorkLocationTypes: WorkLocationTypeSettingDto[];
    planIdToCodeMap: { [key: string]: string };
    rsuPlanCodes: string[];
    stockOptionPlanCodes: string[];
    cashBonusPlanCodes: string[];
  }

  export class CashPaymentPolicySettingsV2Dto
    implements ICashPaymentPolicySettingsV2Dto
  {
    clientId!: string;
    isConfigured!: boolean;
    configuration!: CashPaymentPolicySettingsV2ConfigurationReadDto | null;

    constructor(data?: ICashPaymentPolicySettingsV2Dto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.isConfigured =
          _data['isConfigured'] !== undefined
            ? _data['isConfigured']
            : <any>null;
        this.configuration = _data['configuration']
          ? CashPaymentPolicySettingsV2ConfigurationReadDto.fromJS(
              _data['configuration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentPolicySettingsV2Dto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicySettingsV2Dto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['isConfigured'] =
        this.isConfigured !== undefined ? this.isConfigured : <any>null;
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicySettingsV2Dto {
    clientId: string;
    isConfigured: boolean;
    configuration: CashPaymentPolicySettingsV2ConfigurationReadDto | null;
  }

  export class CashPaymentPolicySettingsV2ConfigurationReadDto
    implements ICashPaymentPolicySettingsV2ConfigurationReadDto
  {
    localPayrollConfiguration!: CashPaymentLocalPayrollV2ConfigurationReadDto | null;

    constructor(data?: ICashPaymentPolicySettingsV2ConfigurationReadDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.localPayrollConfiguration = _data['localPayrollConfiguration']
          ? CashPaymentLocalPayrollV2ConfigurationReadDto.fromJS(
              _data['localPayrollConfiguration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentPolicySettingsV2ConfigurationReadDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicySettingsV2ConfigurationReadDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['localPayrollConfiguration'] = this.localPayrollConfiguration
        ? this.localPayrollConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicySettingsV2ConfigurationReadDto {
    localPayrollConfiguration: CashPaymentLocalPayrollV2ConfigurationReadDto | null;
  }

  export class CashPaymentLocalPayrollV2ConfigurationReadDto
    implements ICashPaymentLocalPayrollV2ConfigurationReadDto
  {
    defaultCashBonusCashPaymentPolicySetting!: CashBonusCashPaymentPolicy;
    defaultRestrictedStockUnitCashPaymentPolicySetting!: RestrictedStockUnitCashPaymentPolicy;
    defaultStockOptionCashPaymentPolicySetting!: StockOptionCashPaymentPolicy;
    overriddenAtCountryLevel!: boolean;
    cashBonusPlansCashPaymentPolicySettingsDictionary!: {
      [key: string]: {
        [key: string]: { [key: string]: CashBonusCashPaymentPolicy };
      };
    };
    restrictedStockUnitPlansCashPaymentPolicySettingsDictionary!: {
      [key: string]: {
        [key: string]: { [key: string]: RestrictedStockUnitCashPaymentPolicy };
      };
    };
    stockOptionPlansCashPaymentPolicySettingsDictionary!: {
      [key: string]: {
        [key: string]: { [key: string]: StockOptionCashPaymentPolicy };
      };
    };

    constructor(data?: ICashPaymentLocalPayrollV2ConfigurationReadDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.cashBonusPlansCashPaymentPolicySettingsDictionary = {};
        this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary = {};
        this.stockOptionPlansCashPaymentPolicySettingsDictionary = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        this.defaultCashBonusCashPaymentPolicySetting =
          _data['defaultCashBonusCashPaymentPolicySetting'] !== undefined
            ? _data['defaultCashBonusCashPaymentPolicySetting']
            : <any>null;
        this.defaultRestrictedStockUnitCashPaymentPolicySetting =
          _data['defaultRestrictedStockUnitCashPaymentPolicySetting'] !==
          undefined
            ? _data['defaultRestrictedStockUnitCashPaymentPolicySetting']
            : <any>null;
        this.defaultStockOptionCashPaymentPolicySetting =
          _data['defaultStockOptionCashPaymentPolicySetting'] !== undefined
            ? _data['defaultStockOptionCashPaymentPolicySetting']
            : <any>null;
        this.overriddenAtCountryLevel =
          _data['overriddenAtCountryLevel'] !== undefined
            ? _data['overriddenAtCountryLevel']
            : <any>null;
        if (_data['cashBonusPlansCashPaymentPolicySettingsDictionary']) {
          this.cashBonusPlansCashPaymentPolicySettingsDictionary = {} as any;
          for (let key in _data[
            'cashBonusPlansCashPaymentPolicySettingsDictionary'
          ]) {
            if (
              _data[
                'cashBonusPlansCashPaymentPolicySettingsDictionary'
              ].hasOwnProperty(key)
            )
              (<any>this.cashBonusPlansCashPaymentPolicySettingsDictionary)![
                key
              ] =
                _data['cashBonusPlansCashPaymentPolicySettingsDictionary'][
                  key
                ] !== undefined
                  ? _data['cashBonusPlansCashPaymentPolicySettingsDictionary'][
                      key
                    ]
                  : {};
          }
        } else {
          this.cashBonusPlansCashPaymentPolicySettingsDictionary = <any>null;
        }
        if (
          _data['restrictedStockUnitPlansCashPaymentPolicySettingsDictionary']
        ) {
          this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary =
            {} as any;
          for (let key in _data[
            'restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'
          ]) {
            if (
              _data[
                'restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'
              ].hasOwnProperty(key)
            )
              (<any>(
                this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary
              ))![key] =
                _data[
                  'restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'
                ][key] !== undefined
                  ? _data[
                      'restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'
                    ][key]
                  : {};
          }
        } else {
          this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary = <
            any
          >null;
        }
        if (_data['stockOptionPlansCashPaymentPolicySettingsDictionary']) {
          this.stockOptionPlansCashPaymentPolicySettingsDictionary = {} as any;
          for (let key in _data[
            'stockOptionPlansCashPaymentPolicySettingsDictionary'
          ]) {
            if (
              _data[
                'stockOptionPlansCashPaymentPolicySettingsDictionary'
              ].hasOwnProperty(key)
            )
              (<any>this.stockOptionPlansCashPaymentPolicySettingsDictionary)![
                key
              ] =
                _data['stockOptionPlansCashPaymentPolicySettingsDictionary'][
                  key
                ] !== undefined
                  ? _data[
                      'stockOptionPlansCashPaymentPolicySettingsDictionary'
                    ][key]
                  : {};
          }
        } else {
          this.stockOptionPlansCashPaymentPolicySettingsDictionary = <any>null;
        }
      }
    }

    static fromJS(data: any): CashPaymentLocalPayrollV2ConfigurationReadDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentLocalPayrollV2ConfigurationReadDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['defaultCashBonusCashPaymentPolicySetting'] =
        this.defaultCashBonusCashPaymentPolicySetting !== undefined
          ? this.defaultCashBonusCashPaymentPolicySetting
          : <any>null;
      data['defaultRestrictedStockUnitCashPaymentPolicySetting'] =
        this.defaultRestrictedStockUnitCashPaymentPolicySetting !== undefined
          ? this.defaultRestrictedStockUnitCashPaymentPolicySetting
          : <any>null;
      data['defaultStockOptionCashPaymentPolicySetting'] =
        this.defaultStockOptionCashPaymentPolicySetting !== undefined
          ? this.defaultStockOptionCashPaymentPolicySetting
          : <any>null;
      data['overriddenAtCountryLevel'] =
        this.overriddenAtCountryLevel !== undefined
          ? this.overriddenAtCountryLevel
          : <any>null;
      if (this.cashBonusPlansCashPaymentPolicySettingsDictionary) {
        data['cashBonusPlansCashPaymentPolicySettingsDictionary'] = {};
        for (let key in this
          .cashBonusPlansCashPaymentPolicySettingsDictionary) {
          if (
            this.cashBonusPlansCashPaymentPolicySettingsDictionary.hasOwnProperty(
              key,
            )
          )
            (<any>data['cashBonusPlansCashPaymentPolicySettingsDictionary'])[
              key
            ] =
              this.cashBonusPlansCashPaymentPolicySettingsDictionary[key] !==
              undefined
                ? this.cashBonusPlansCashPaymentPolicySettingsDictionary[key]
                : <any>null;
        }
      }
      if (this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary) {
        data['restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'] =
          {};
        for (let key in this
          .restrictedStockUnitPlansCashPaymentPolicySettingsDictionary) {
          if (
            this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary.hasOwnProperty(
              key,
            )
          )
            (<any>(
              data[
                'restrictedStockUnitPlansCashPaymentPolicySettingsDictionary'
              ]
            ))[key] =
              this.restrictedStockUnitPlansCashPaymentPolicySettingsDictionary[
                key
              ] !== undefined
                ? this
                    .restrictedStockUnitPlansCashPaymentPolicySettingsDictionary[
                    key
                  ]
                : <any>null;
        }
      }
      if (this.stockOptionPlansCashPaymentPolicySettingsDictionary) {
        data['stockOptionPlansCashPaymentPolicySettingsDictionary'] = {};
        for (let key in this
          .stockOptionPlansCashPaymentPolicySettingsDictionary) {
          if (
            this.stockOptionPlansCashPaymentPolicySettingsDictionary.hasOwnProperty(
              key,
            )
          )
            (<any>data['stockOptionPlansCashPaymentPolicySettingsDictionary'])[
              key
            ] =
              this.stockOptionPlansCashPaymentPolicySettingsDictionary[key] !==
              undefined
                ? this.stockOptionPlansCashPaymentPolicySettingsDictionary[key]
                : <any>null;
        }
      }
      return data;
    }
  }

  export interface ICashPaymentLocalPayrollV2ConfigurationReadDto {
    defaultCashBonusCashPaymentPolicySetting: CashBonusCashPaymentPolicy;
    defaultRestrictedStockUnitCashPaymentPolicySetting: RestrictedStockUnitCashPaymentPolicy;
    defaultStockOptionCashPaymentPolicySetting: StockOptionCashPaymentPolicy;
    overriddenAtCountryLevel: boolean;
    cashBonusPlansCashPaymentPolicySettingsDictionary: {
      [key: string]: {
        [key: string]: { [key: string]: CashBonusCashPaymentPolicy };
      };
    };
    restrictedStockUnitPlansCashPaymentPolicySettingsDictionary: {
      [key: string]: {
        [key: string]: { [key: string]: RestrictedStockUnitCashPaymentPolicy };
      };
    };
    stockOptionPlansCashPaymentPolicySettingsDictionary: {
      [key: string]: {
        [key: string]: { [key: string]: StockOptionCashPaymentPolicy };
      };
    };
  }

  export class CashPaymentPolicyCountryData
    implements ICashPaymentPolicyCountryData
  {
    countryCode!: string;
    countryName!: string;

    constructor(data?: ICashPaymentPolicyCountryData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.countryName =
          _data['countryName'] !== undefined ? _data['countryName'] : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentPolicyCountryData {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicyCountryData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['countryName'] =
        this.countryName !== undefined ? this.countryName : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicyCountryData {
    countryCode: string;
    countryName: string;
  }

  export class GetCashPaymentPolicyPageDataQueryResultFailure
    extends GetCashPaymentPolicyPageDataQueryResult
    implements IGetCashPaymentPolicyPageDataQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCashPaymentPolicyPageDataQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentPolicyPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentPolicyPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentPolicyPageDataQueryResultFailure
    extends IGetCashPaymentPolicyPageDataQueryResult {
    errors: ResultError[];
  }

  export class UpsertCashPaymentPolicySettingsCommandResult
    implements IUpsertCashPaymentPolicySettingsCommandResult
  {
    constructor(data?: IUpsertCashPaymentPolicySettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertCashPaymentPolicySettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentPolicySettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCashPaymentPolicySettingsCommandResult {}

  export class UpsertCashPaymentPolicySettingsCommandResultSuccess
    extends UpsertCashPaymentPolicySettingsCommandResult
    implements IUpsertCashPaymentPolicySettingsCommandResultSuccess
  {
    constructor(data?: IUpsertCashPaymentPolicySettingsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentPolicySettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentPolicySettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentPolicySettingsCommandResultSuccess
    extends IUpsertCashPaymentPolicySettingsCommandResult {}

  export class UpsertCashPaymentPolicySettingsCommandResultFailure
    extends UpsertCashPaymentPolicySettingsCommandResult
    implements IUpsertCashPaymentPolicySettingsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertCashPaymentPolicySettingsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentPolicySettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentPolicySettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentPolicySettingsCommandResultFailure
    extends IUpsertCashPaymentPolicySettingsCommandResult {
    errors: ResultError[];
  }

  export class UpsertCashPaymentPolicySettingsCommand
    implements IUpsertCashPaymentPolicySettingsCommand
  {
    clientId!: string;
    upsertCashPaymentPolicySettingsV2!: UpsertCashPaymentPolicySettingsV2Dto;

    constructor(data?: IUpsertCashPaymentPolicySettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.upsertCashPaymentPolicySettingsV2 =
          new UpsertCashPaymentPolicySettingsV2Dto();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.upsertCashPaymentPolicySettingsV2 = _data[
          'upsertCashPaymentPolicySettingsV2'
        ]
          ? UpsertCashPaymentPolicySettingsV2Dto.fromJS(
              _data['upsertCashPaymentPolicySettingsV2'],
            )
          : new UpsertCashPaymentPolicySettingsV2Dto();
      }
    }

    static fromJS(data: any): UpsertCashPaymentPolicySettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentPolicySettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['upsertCashPaymentPolicySettingsV2'] = this
        .upsertCashPaymentPolicySettingsV2
        ? this.upsertCashPaymentPolicySettingsV2.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertCashPaymentPolicySettingsCommand {
    clientId: string;
    upsertCashPaymentPolicySettingsV2: UpsertCashPaymentPolicySettingsV2Dto;
  }

  export class UpsertCashPaymentPolicySettingsV2Dto
    implements IUpsertCashPaymentPolicySettingsV2Dto
  {
    configuration!: CashPaymentPolicySettingsV2ConfigurationDto | null;

    constructor(data?: IUpsertCashPaymentPolicySettingsV2Dto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.configuration = _data['configuration']
          ? CashPaymentPolicySettingsV2ConfigurationDto.fromJS(
              _data['configuration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): UpsertCashPaymentPolicySettingsV2Dto {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentPolicySettingsV2Dto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['configuration'] = this.configuration
        ? this.configuration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface IUpsertCashPaymentPolicySettingsV2Dto {
    configuration: CashPaymentPolicySettingsV2ConfigurationDto | null;
  }

  export class CashPaymentPolicySettingsV2ConfigurationDto
    implements ICashPaymentPolicySettingsV2ConfigurationDto
  {
    localPayrollConfiguration!: CashPaymentLocalPayrollV2ConfigurationDto | null;

    constructor(data?: ICashPaymentPolicySettingsV2ConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.localPayrollConfiguration = _data['localPayrollConfiguration']
          ? CashPaymentLocalPayrollV2ConfigurationDto.fromJS(
              _data['localPayrollConfiguration'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentPolicySettingsV2ConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentPolicySettingsV2ConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['localPayrollConfiguration'] = this.localPayrollConfiguration
        ? this.localPayrollConfiguration.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicySettingsV2ConfigurationDto {
    localPayrollConfiguration: CashPaymentLocalPayrollV2ConfigurationDto | null;
  }

  export class CashPaymentLocalPayrollV2ConfigurationDto
    implements ICashPaymentLocalPayrollV2ConfigurationDto
  {
    defaultCashBonusCashPaymentPolicySetting!: CashBonusCashPaymentPolicy;
    defaultRestrictedStockUnitCashPaymentPolicySetting!: RestrictedStockUnitCashPaymentPolicy;
    defaultStockOptionCashPaymentPolicySetting!: StockOptionCashPaymentPolicy;
    cashBonusPlansCashPaymentPolicySettings!: CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy[];
    restrictedStockUnitPlansCashPaymentPolicySettings!: CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy[];
    stockOptionPlansCashPaymentPolicySettings!: CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy[];

    constructor(data?: ICashPaymentLocalPayrollV2ConfigurationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.cashBonusPlansCashPaymentPolicySettings = [];
        this.restrictedStockUnitPlansCashPaymentPolicySettings = [];
        this.stockOptionPlansCashPaymentPolicySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.defaultCashBonusCashPaymentPolicySetting =
          _data['defaultCashBonusCashPaymentPolicySetting'] !== undefined
            ? _data['defaultCashBonusCashPaymentPolicySetting']
            : <any>null;
        this.defaultRestrictedStockUnitCashPaymentPolicySetting =
          _data['defaultRestrictedStockUnitCashPaymentPolicySetting'] !==
          undefined
            ? _data['defaultRestrictedStockUnitCashPaymentPolicySetting']
            : <any>null;
        this.defaultStockOptionCashPaymentPolicySetting =
          _data['defaultStockOptionCashPaymentPolicySetting'] !== undefined
            ? _data['defaultStockOptionCashPaymentPolicySetting']
            : <any>null;
        if (Array.isArray(_data['cashBonusPlansCashPaymentPolicySettings'])) {
          this.cashBonusPlansCashPaymentPolicySettings = [] as any;
          for (let item of _data['cashBonusPlansCashPaymentPolicySettings'])
            this.cashBonusPlansCashPaymentPolicySettings!.push(
              CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.cashBonusPlansCashPaymentPolicySettings = <any>null;
        }
        if (
          Array.isArray(
            _data['restrictedStockUnitPlansCashPaymentPolicySettings'],
          )
        ) {
          this.restrictedStockUnitPlansCashPaymentPolicySettings = [] as any;
          for (let item of _data[
            'restrictedStockUnitPlansCashPaymentPolicySettings'
          ])
            this.restrictedStockUnitPlansCashPaymentPolicySettings!.push(
              CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.restrictedStockUnitPlansCashPaymentPolicySettings = <any>null;
        }
        if (Array.isArray(_data['stockOptionPlansCashPaymentPolicySettings'])) {
          this.stockOptionPlansCashPaymentPolicySettings = [] as any;
          for (let item of _data['stockOptionPlansCashPaymentPolicySettings'])
            this.stockOptionPlansCashPaymentPolicySettings!.push(
              CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.stockOptionPlansCashPaymentPolicySettings = <any>null;
        }
      }
    }

    static fromJS(data: any): CashPaymentLocalPayrollV2ConfigurationDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentLocalPayrollV2ConfigurationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['defaultCashBonusCashPaymentPolicySetting'] =
        this.defaultCashBonusCashPaymentPolicySetting !== undefined
          ? this.defaultCashBonusCashPaymentPolicySetting
          : <any>null;
      data['defaultRestrictedStockUnitCashPaymentPolicySetting'] =
        this.defaultRestrictedStockUnitCashPaymentPolicySetting !== undefined
          ? this.defaultRestrictedStockUnitCashPaymentPolicySetting
          : <any>null;
      data['defaultStockOptionCashPaymentPolicySetting'] =
        this.defaultStockOptionCashPaymentPolicySetting !== undefined
          ? this.defaultStockOptionCashPaymentPolicySetting
          : <any>null;
      if (Array.isArray(this.cashBonusPlansCashPaymentPolicySettings)) {
        data['cashBonusPlansCashPaymentPolicySettings'] = [];
        for (let item of this.cashBonusPlansCashPaymentPolicySettings)
          data['cashBonusPlansCashPaymentPolicySettings'].push(item.toJSON());
      }
      if (
        Array.isArray(this.restrictedStockUnitPlansCashPaymentPolicySettings)
      ) {
        data['restrictedStockUnitPlansCashPaymentPolicySettings'] = [];
        for (let item of this.restrictedStockUnitPlansCashPaymentPolicySettings)
          data['restrictedStockUnitPlansCashPaymentPolicySettings'].push(
            item.toJSON(),
          );
      }
      if (Array.isArray(this.stockOptionPlansCashPaymentPolicySettings)) {
        data['stockOptionPlansCashPaymentPolicySettings'] = [];
        for (let item of this.stockOptionPlansCashPaymentPolicySettings)
          data['stockOptionPlansCashPaymentPolicySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentLocalPayrollV2ConfigurationDto {
    defaultCashBonusCashPaymentPolicySetting: CashBonusCashPaymentPolicy;
    defaultRestrictedStockUnitCashPaymentPolicySetting: RestrictedStockUnitCashPaymentPolicy;
    defaultStockOptionCashPaymentPolicySetting: StockOptionCashPaymentPolicy;
    cashBonusPlansCashPaymentPolicySettings: CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy[];
    restrictedStockUnitPlansCashPaymentPolicySettings: CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy[];
    stockOptionPlansCashPaymentPolicySettings: CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy[];
  }

  export class CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy
    implements
      ICashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy
  {
    planId!: string;
    countrySettings!: CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planId =
          _data['planId'] !== undefined ? _data['planId'] : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.countrySettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planId'] = this.planId !== undefined ? this.planId : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyPlanSettingsConfigurationDtoOfCashBonusCashPaymentPolicy {
    planId: string;
    countrySettings: CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy[];
  }

  export class CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy
    implements ICashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy
  {
    countryCode!: string;
    workLocationTypeSettings!: CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationTypeSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['workLocationTypeSettings'])) {
          this.workLocationTypeSettings = [] as any;
          for (let item of _data['workLocationTypeSettings'])
            this.workLocationTypeSettings!.push(
              CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.workLocationTypeSettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.workLocationTypeSettings)) {
        data['workLocationTypeSettings'] = [];
        for (let item of this.workLocationTypeSettings)
          data['workLocationTypeSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyCountrySettingsDtoOfCashBonusCashPaymentPolicy {
    countryCode: string;
    workLocationTypeSettings: CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy[];
  }

  export class CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy
    implements
      ICashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy
  {
    workLocationType!: WorkLocationTypeSetting;
    setting!: CashBonusCashPaymentPolicy;

    constructor(
      data?: ICashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.setting =
          _data['setting'] !== undefined ? _data['setting'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['setting'] = this.setting !== undefined ? this.setting : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicyWorkLocationTypeSettingsDtoOfCashBonusCashPaymentPolicy {
    workLocationType: WorkLocationTypeSetting;
    setting: CashBonusCashPaymentPolicy;
  }

  export class CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy
    implements
      ICashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy
  {
    planId!: string;
    countrySettings!: CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planId =
          _data['planId'] !== undefined ? _data['planId'] : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.countrySettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planId'] = this.planId !== undefined ? this.planId : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyPlanSettingsConfigurationDtoOfRestrictedStockUnitCashPaymentPolicy {
    planId: string;
    countrySettings: CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy[];
  }

  export class CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy
    implements
      ICashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy
  {
    countryCode!: string;
    workLocationTypeSettings!: CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationTypeSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['workLocationTypeSettings'])) {
          this.workLocationTypeSettings = [] as any;
          for (let item of _data['workLocationTypeSettings'])
            this.workLocationTypeSettings!.push(
              CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.workLocationTypeSettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.workLocationTypeSettings)) {
        data['workLocationTypeSettings'] = [];
        for (let item of this.workLocationTypeSettings)
          data['workLocationTypeSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyCountrySettingsDtoOfRestrictedStockUnitCashPaymentPolicy {
    countryCode: string;
    workLocationTypeSettings: CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy[];
  }

  export class CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy
    implements
      ICashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy
  {
    workLocationType!: WorkLocationTypeSetting;
    setting!: RestrictedStockUnitCashPaymentPolicy;

    constructor(
      data?: ICashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.setting =
          _data['setting'] !== undefined ? _data['setting'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['setting'] = this.setting !== undefined ? this.setting : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicyWorkLocationTypeSettingsDtoOfRestrictedStockUnitCashPaymentPolicy {
    workLocationType: WorkLocationTypeSetting;
    setting: RestrictedStockUnitCashPaymentPolicy;
  }

  export class CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy
    implements
      ICashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy
  {
    planId!: string;
    countrySettings!: CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countrySettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.planId =
          _data['planId'] !== undefined ? _data['planId'] : <any>null;
        if (Array.isArray(_data['countrySettings'])) {
          this.countrySettings = [] as any;
          for (let item of _data['countrySettings'])
            this.countrySettings!.push(
              CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.countrySettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['planId'] = this.planId !== undefined ? this.planId : <any>null;
      if (Array.isArray(this.countrySettings)) {
        data['countrySettings'] = [];
        for (let item of this.countrySettings)
          data['countrySettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyPlanSettingsConfigurationDtoOfStockOptionCashPaymentPolicy {
    planId: string;
    countrySettings: CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy[];
  }

  export class CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy
    implements
      ICashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy
  {
    countryCode!: string;
    workLocationTypeSettings!: CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy[];

    constructor(
      data?: ICashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.workLocationTypeSettings = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        if (Array.isArray(_data['workLocationTypeSettings'])) {
          this.workLocationTypeSettings = [] as any;
          for (let item of _data['workLocationTypeSettings'])
            this.workLocationTypeSettings!.push(
              CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy.fromJS(
                item,
              ),
            );
        } else {
          this.workLocationTypeSettings = <any>null;
        }
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      if (Array.isArray(this.workLocationTypeSettings)) {
        data['workLocationTypeSettings'] = [];
        for (let item of this.workLocationTypeSettings)
          data['workLocationTypeSettings'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentPolicyCountrySettingsDtoOfStockOptionCashPaymentPolicy {
    countryCode: string;
    workLocationTypeSettings: CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy[];
  }

  export class CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy
    implements
      ICashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy
  {
    workLocationType!: WorkLocationTypeSetting;
    setting!: StockOptionCashPaymentPolicy;

    constructor(
      data?: ICashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy,
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.workLocationType =
          _data['workLocationType'] !== undefined
            ? _data['workLocationType']
            : <any>null;
        this.setting =
          _data['setting'] !== undefined ? _data['setting'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy {
      data = typeof data === 'object' ? data : {};
      let result =
        new CashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['workLocationType'] =
        this.workLocationType !== undefined ? this.workLocationType : <any>null;
      data['setting'] = this.setting !== undefined ? this.setting : <any>null;
      return data;
    }
  }

  export interface ICashPaymentPolicyWorkLocationTypeSettingsDtoOfStockOptionCashPaymentPolicy {
    workLocationType: WorkLocationTypeSetting;
    setting: StockOptionCashPaymentPolicy;
  }

  export class GetCashPaymentCountryAmountPageDataQueryResult
    implements IGetCashPaymentCountryAmountPageDataQueryResult
  {
    constructor(data?: IGetCashPaymentCountryAmountPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCashPaymentCountryAmountPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentCountryAmountPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCashPaymentCountryAmountPageDataQueryResult {}

  export class GetCashPaymentCountryAmountPageDataQueryResultSuccess
    extends GetCashPaymentCountryAmountPageDataQueryResult
    implements IGetCashPaymentCountryAmountPageDataQueryResultSuccess
  {
    result!: CashPaymentCountryAmountPageData;

    constructor(data?: IGetCashPaymentCountryAmountPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new CashPaymentCountryAmountPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? CashPaymentCountryAmountPageData.fromJS(_data['result'])
          : new CashPaymentCountryAmountPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentCountryAmountPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentCountryAmountPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentCountryAmountPageDataQueryResultSuccess
    extends IGetCashPaymentCountryAmountPageDataQueryResult {
    result: CashPaymentCountryAmountPageData;
  }

  export class CashPaymentCountryAmountPageData
    implements ICashPaymentCountryAmountPageData
  {
    countriesInFootprintIsoCodes!: string[];
    cashPaymentCountryAmountSettingsDto!: CashPaymentCountryAmountSettingsDto | null;

    constructor(data?: ICashPaymentCountryAmountPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countriesInFootprintIsoCodes = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['countriesInFootprintIsoCodes'])) {
          this.countriesInFootprintIsoCodes = [] as any;
          for (let item of _data['countriesInFootprintIsoCodes'])
            this.countriesInFootprintIsoCodes!.push(item);
        } else {
          this.countriesInFootprintIsoCodes = <any>null;
        }
        this.cashPaymentCountryAmountSettingsDto = _data[
          'cashPaymentCountryAmountSettingsDto'
        ]
          ? CashPaymentCountryAmountSettingsDto.fromJS(
              _data['cashPaymentCountryAmountSettingsDto'],
            )
          : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentCountryAmountPageData {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentCountryAmountPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.countriesInFootprintIsoCodes)) {
        data['countriesInFootprintIsoCodes'] = [];
        for (let item of this.countriesInFootprintIsoCodes)
          data['countriesInFootprintIsoCodes'].push(item);
      }
      data['cashPaymentCountryAmountSettingsDto'] = this
        .cashPaymentCountryAmountSettingsDto
        ? this.cashPaymentCountryAmountSettingsDto.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICashPaymentCountryAmountPageData {
    countriesInFootprintIsoCodes: string[];
    cashPaymentCountryAmountSettingsDto: CashPaymentCountryAmountSettingsDto | null;
  }

  export class CashPaymentCountryAmountSettingsDto
    implements ICashPaymentCountryAmountSettingsDto
  {
    id!: string;
    clientId!: string;
    transactionId!: string;
    countryAmounts!: CashPaymentCountryAmountDto[];

    constructor(data?: ICashPaymentCountryAmountSettingsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryAmounts = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['countryAmounts'])) {
          this.countryAmounts = [] as any;
          for (let item of _data['countryAmounts'])
            this.countryAmounts!.push(CashPaymentCountryAmountDto.fromJS(item));
        } else {
          this.countryAmounts = <any>null;
        }
      }
    }

    static fromJS(data: any): CashPaymentCountryAmountSettingsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentCountryAmountSettingsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.countryAmounts)) {
        data['countryAmounts'] = [];
        for (let item of this.countryAmounts)
          data['countryAmounts'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ICashPaymentCountryAmountSettingsDto {
    id: string;
    clientId: string;
    transactionId: string;
    countryAmounts: CashPaymentCountryAmountDto[];
  }

  export class CashPaymentCountryAmountDto
    implements ICashPaymentCountryAmountDto
  {
    countryCode!: string;
    currencyCode!: string;
    amount!: number;

    constructor(data?: ICashPaymentCountryAmountDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.countryCode =
          _data['countryCode'] !== undefined ? _data['countryCode'] : <any>null;
        this.currencyCode =
          _data['currencyCode'] !== undefined
            ? _data['currencyCode']
            : <any>null;
        this.amount =
          _data['amount'] !== undefined ? _data['amount'] : <any>null;
      }
    }

    static fromJS(data: any): CashPaymentCountryAmountDto {
      data = typeof data === 'object' ? data : {};
      let result = new CashPaymentCountryAmountDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['countryCode'] =
        this.countryCode !== undefined ? this.countryCode : <any>null;
      data['currencyCode'] =
        this.currencyCode !== undefined ? this.currencyCode : <any>null;
      data['amount'] = this.amount !== undefined ? this.amount : <any>null;
      return data;
    }
  }

  export interface ICashPaymentCountryAmountDto {
    countryCode: string;
    currencyCode: string;
    amount: number;
  }

  export class GetCashPaymentCountryAmountPageDataQueryResultFailure
    extends GetCashPaymentCountryAmountPageDataQueryResult
    implements IGetCashPaymentCountryAmountPageDataQueryResultFailure
  {
    constructor(data?: IGetCashPaymentCountryAmountPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetCashPaymentCountryAmountPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCashPaymentCountryAmountPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCashPaymentCountryAmountPageDataQueryResultFailure
    extends IGetCashPaymentCountryAmountPageDataQueryResult {}

  export class GetCountryAmountCashPaymentsQueryResult
    implements IGetCountryAmountCashPaymentsQueryResult
  {
    constructor(data?: IGetCountryAmountCashPaymentsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCountryAmountCashPaymentsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryAmountCashPaymentsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCountryAmountCashPaymentsQueryResult {}

  export class GetCountryAmountCashPaymentsQueryResultSuccess
    extends GetCountryAmountCashPaymentsQueryResult
    implements IGetCountryAmountCashPaymentsQueryResultSuccess
  {
    cashPaymentCountryAmounts!: CashPaymentCountryAmountSettingsDto[];

    constructor(data?: IGetCountryAmountCashPaymentsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.cashPaymentCountryAmounts = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['cashPaymentCountryAmounts'])) {
          this.cashPaymentCountryAmounts = [] as any;
          for (let item of _data['cashPaymentCountryAmounts'])
            this.cashPaymentCountryAmounts!.push(
              CashPaymentCountryAmountSettingsDto.fromJS(item),
            );
        } else {
          this.cashPaymentCountryAmounts = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCountryAmountCashPaymentsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryAmountCashPaymentsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.cashPaymentCountryAmounts)) {
        data['cashPaymentCountryAmounts'] = [];
        for (let item of this.cashPaymentCountryAmounts)
          data['cashPaymentCountryAmounts'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryAmountCashPaymentsQueryResultSuccess
    extends IGetCountryAmountCashPaymentsQueryResult {
    cashPaymentCountryAmounts: CashPaymentCountryAmountSettingsDto[];
  }

  export class GetCountryAmountCashPaymentsQueryResultFailure
    extends GetCountryAmountCashPaymentsQueryResult
    implements IGetCountryAmountCashPaymentsQueryResultFailure
  {
    constructor(data?: IGetCountryAmountCashPaymentsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetCountryAmountCashPaymentsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCountryAmountCashPaymentsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCountryAmountCashPaymentsQueryResultFailure
    extends IGetCountryAmountCashPaymentsQueryResult {}

  export class UpsertCashPaymentCountryAmountSettingsCommandResult
    implements IUpsertCashPaymentCountryAmountSettingsCommandResult
  {
    constructor(data?: IUpsertCashPaymentCountryAmountSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): UpsertCashPaymentCountryAmountSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentCountryAmountSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertCashPaymentCountryAmountSettingsCommandResult {}

  export class UpsertCashPaymentCountryAmountSettingsCommandResultSuccess
    extends UpsertCashPaymentCountryAmountSettingsCommandResult
    implements IUpsertCashPaymentCountryAmountSettingsCommandResultSuccess
  {
    constructor(
      data?: IUpsertCashPaymentCountryAmountSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentCountryAmountSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertCashPaymentCountryAmountSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentCountryAmountSettingsCommandResultSuccess
    extends IUpsertCashPaymentCountryAmountSettingsCommandResult {}

  export class UpsertCashPaymentCountryAmountSettingsCommandResultFailure
    extends UpsertCashPaymentCountryAmountSettingsCommandResult
    implements IUpsertCashPaymentCountryAmountSettingsCommandResultFailure
  {
    constructor(
      data?: IUpsertCashPaymentCountryAmountSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertCashPaymentCountryAmountSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new UpsertCashPaymentCountryAmountSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertCashPaymentCountryAmountSettingsCommandResultFailure
    extends IUpsertCashPaymentCountryAmountSettingsCommandResult {}

  export class UpsertCashPaymentCountryAmountSettingsCommand
    implements IUpsertCashPaymentCountryAmountSettingsCommand
  {
    clientId!: string;
    id!: string | null;
    transactionId!: string;
    countryAmounts!: CashPaymentCountryAmountDto[];

    constructor(data?: IUpsertCashPaymentCountryAmountSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.countryAmounts = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        if (Array.isArray(_data['countryAmounts'])) {
          this.countryAmounts = [] as any;
          for (let item of _data['countryAmounts'])
            this.countryAmounts!.push(CashPaymentCountryAmountDto.fromJS(item));
        } else {
          this.countryAmounts = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertCashPaymentCountryAmountSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertCashPaymentCountryAmountSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      if (Array.isArray(this.countryAmounts)) {
        data['countryAmounts'] = [];
        for (let item of this.countryAmounts)
          data['countryAmounts'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertCashPaymentCountryAmountSettingsCommand {
    clientId: string;
    id: string | null;
    transactionId: string;
    countryAmounts: CashPaymentCountryAmountDto[];
  }

  export class DeleteCashPaymentCountryAmountSettingsCommandResult
    implements IDeleteCashPaymentCountryAmountSettingsCommandResult
  {
    constructor(data?: IDeleteCashPaymentCountryAmountSettingsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DeleteCashPaymentCountryAmountSettingsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentCountryAmountSettingsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDeleteCashPaymentCountryAmountSettingsCommandResult {}

  export class DeleteCashPaymentCountryAmountSettingsCommandResultSuccess
    extends DeleteCashPaymentCountryAmountSettingsCommandResult
    implements IDeleteCashPaymentCountryAmountSettingsCommandResultSuccess
  {
    constructor(
      data?: IDeleteCashPaymentCountryAmountSettingsCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DeleteCashPaymentCountryAmountSettingsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteCashPaymentCountryAmountSettingsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashPaymentCountryAmountSettingsCommandResultSuccess
    extends IDeleteCashPaymentCountryAmountSettingsCommandResult {}

  export class DeleteCashPaymentCountryAmountSettingsCommandResultFailure
    extends DeleteCashPaymentCountryAmountSettingsCommandResult
    implements IDeleteCashPaymentCountryAmountSettingsCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IDeleteCashPaymentCountryAmountSettingsCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DeleteCashPaymentCountryAmountSettingsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DeleteCashPaymentCountryAmountSettingsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDeleteCashPaymentCountryAmountSettingsCommandResultFailure
    extends IDeleteCashPaymentCountryAmountSettingsCommandResult {
    errorMessage: string;
  }

  export class DeleteCashPaymentCountryAmountSettingsCommand
    implements IDeleteCashPaymentCountryAmountSettingsCommand
  {
    clientId!: string;
    id!: string;

    constructor(data?: IDeleteCashPaymentCountryAmountSettingsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static fromJS(data: any): DeleteCashPaymentCountryAmountSettingsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DeleteCashPaymentCountryAmountSettingsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['id'] = this.id !== undefined ? this.id : <any>null;
      return data;
    }
  }

  export interface IDeleteCashPaymentCountryAmountSettingsCommand {
    clientId: string;
    id: string;
  }

  export abstract class GetCalculationAuditLogQueryResult
    implements IGetCalculationAuditLogQueryResult
  {
    constructor(data?: IGetCalculationAuditLogQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCalculationAuditLogQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCalculationAuditLogQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCalculationAuditLogQueryResult {}

  export class GetCalculationAuditLogQueryResultSuccess
    extends GetCalculationAuditLogQueryResult
    implements IGetCalculationAuditLogQueryResultSuccess
  {
    log!: ReadOnlyLog;
    finalized!: boolean;

    constructor(data?: IGetCalculationAuditLogQueryResultSuccess) {
      super(data);
      if (!data) {
        this.log = new ReadOnlyLog();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.log = _data['log']
          ? ReadOnlyLog.fromJS(_data['log'])
          : new ReadOnlyLog();
        this.finalized =
          _data['finalized'] !== undefined ? _data['finalized'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationAuditLogQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationAuditLogQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['log'] = this.log ? this.log.toJSON() : <any>null;
      data['finalized'] =
        this.finalized !== undefined ? this.finalized : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationAuditLogQueryResultSuccess
    extends IGetCalculationAuditLogQueryResult {
    log: ReadOnlyLog;
    finalized: boolean;
  }

  export class GetCalculationAuditLogQueryResultFailure
    extends GetCalculationAuditLogQueryResult
    implements IGetCalculationAuditLogQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetCalculationAuditLogQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetCalculationAuditLogQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCalculationAuditLogQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCalculationAuditLogQueryResultFailure
    extends IGetCalculationAuditLogQueryResult {
    errors: ResultError[];
  }

  export abstract class GetBatchInputFilesPageDataQueryResult
    implements IGetBatchInputFilesPageDataQueryResult
  {
    constructor(data?: IGetBatchInputFilesPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchInputFilesPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchInputFilesPageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchInputFilesPageDataQueryResult {}

  export class GetBatchInputFilesPageDataQueryResultSuccess
    extends GetBatchInputFilesPageDataQueryResult
    implements IGetBatchInputFilesPageDataQueryResultSuccess
  {
    pageData!: BatchInputFilesPageData;

    constructor(data?: IGetBatchInputFilesPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.pageData = new BatchInputFilesPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.pageData = _data['pageData']
          ? BatchInputFilesPageData.fromJS(_data['pageData'])
          : new BatchInputFilesPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchInputFilesPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchInputFilesPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['pageData'] = this.pageData ? this.pageData.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchInputFilesPageDataQueryResultSuccess
    extends IGetBatchInputFilesPageDataQueryResult {
    pageData: BatchInputFilesPageData;
  }

  export class BatchInputFilesPageData implements IBatchInputFilesPageData {
    batchCreationSource!: BatchCreationSource;
    files!: BatchInputFilesPageFile[];

    constructor(data?: IBatchInputFilesPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.files = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchCreationSource =
          _data['batchCreationSource'] !== undefined
            ? _data['batchCreationSource']
            : <any>null;
        if (Array.isArray(_data['files'])) {
          this.files = [] as any;
          for (let item of _data['files'])
            this.files!.push(BatchInputFilesPageFile.fromJS(item));
        } else {
          this.files = <any>null;
        }
      }
    }

    static fromJS(data: any): BatchInputFilesPageData {
      data = typeof data === 'object' ? data : {};
      let result = new BatchInputFilesPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchCreationSource'] =
        this.batchCreationSource !== undefined
          ? this.batchCreationSource
          : <any>null;
      if (Array.isArray(this.files)) {
        data['files'] = [];
        for (let item of this.files) data['files'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IBatchInputFilesPageData {
    batchCreationSource: BatchCreationSource;
    files: BatchInputFilesPageFile[];
  }

  export class BatchInputFilesPageFile implements IBatchInputFilesPageFile {
    fileName!: string;
    fileId!: string;
    fileType!: BatchInputFilesPageFileType;

    constructor(data?: IBatchInputFilesPageFile) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileName =
          _data['fileName'] !== undefined ? _data['fileName'] : <any>null;
        this.fileId =
          _data['fileId'] !== undefined ? _data['fileId'] : <any>null;
        this.fileType =
          _data['fileType'] !== undefined ? _data['fileType'] : <any>null;
      }
    }

    static fromJS(data: any): BatchInputFilesPageFile {
      data = typeof data === 'object' ? data : {};
      let result = new BatchInputFilesPageFile();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileName'] =
        this.fileName !== undefined ? this.fileName : <any>null;
      data['fileId'] = this.fileId !== undefined ? this.fileId : <any>null;
      data['fileType'] =
        this.fileType !== undefined ? this.fileType : <any>null;
      return data;
    }
  }

  export interface IBatchInputFilesPageFile {
    fileName: string;
    fileId: string;
    fileType: BatchInputFilesPageFileType;
  }

  export enum BatchInputFilesPageFileType {
    BatchInputFile = 'BatchInputFile',
    CdxInputFile = 'CdxInputFile',
    TaxAdjustmentInputFile = 'TaxAdjustmentInputFile',
  }

  export class GetBatchInputFilesPageDataQueryResultFailure
    extends GetBatchInputFilesPageDataQueryResult
    implements IGetBatchInputFilesPageDataQueryResultFailure
  {
    constructor(data?: IGetBatchInputFilesPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetBatchInputFilesPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchInputFilesPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchInputFilesPageDataQueryResultFailure
    extends IGetBatchInputFilesPageDataQueryResult {}

  export abstract class GetBatchInputFilePreSignedUrlForDownloadCommandResult
    implements IGetBatchInputFilePreSignedUrlForDownloadCommandResult
  {
    constructor(data?: IGetBatchInputFilePreSignedUrlForDownloadCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): GetBatchInputFilePreSignedUrlForDownloadCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchInputFilePreSignedUrlForDownloadCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchInputFilePreSignedUrlForDownloadCommandResult {}

  export class GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess
    extends GetBatchInputFilePreSignedUrlForDownloadCommandResult
    implements IGetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess
  {
    preSignedUrl!: string;

    constructor(
      data?: IGetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.preSignedUrl =
          _data['preSignedUrl'] !== undefined
            ? _data['preSignedUrl']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['preSignedUrl'] =
        this.preSignedUrl !== undefined ? this.preSignedUrl : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchInputFilePreSignedUrlForDownloadCommandResultSuccess
    extends IGetBatchInputFilePreSignedUrlForDownloadCommandResult {
    preSignedUrl: string;
  }

  export class GetBatchInputFilePreSignedUrlForDownloadCommandResultFailure
    extends GetBatchInputFilePreSignedUrlForDownloadCommandResult
    implements IGetBatchInputFilePreSignedUrlForDownloadCommandResultFailure
  {
    error!: string;

    constructor(
      data?: IGetBatchInputFilePreSignedUrlForDownloadCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.error = _data['error'] !== undefined ? _data['error'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchInputFilePreSignedUrlForDownloadCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new GetBatchInputFilePreSignedUrlForDownloadCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['error'] = this.error !== undefined ? this.error : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchInputFilePreSignedUrlForDownloadCommandResultFailure
    extends IGetBatchInputFilePreSignedUrlForDownloadCommandResult {
    error: string;
  }

  export class GetBatchInputFilePreSignedUrlForDownloadCommand
    implements IGetBatchInputFilePreSignedUrlForDownloadCommand
  {
    clientId!: string;
    batchId!: string;
    file!: BatchInputFilesPageFile;

    constructor(data?: IGetBatchInputFilePreSignedUrlForDownloadCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.file = new BatchInputFilesPageFile();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.file = _data['file']
          ? BatchInputFilesPageFile.fromJS(_data['file'])
          : new BatchInputFilesPageFile();
      }
    }

    static fromJS(data: any): GetBatchInputFilePreSignedUrlForDownloadCommand {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchInputFilePreSignedUrlForDownloadCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['file'] = this.file ? this.file.toJSON() : <any>null;
      return data;
    }
  }

  export interface IGetBatchInputFilePreSignedUrlForDownloadCommand {
    clientId: string;
    batchId: string;
    file: BatchInputFilesPageFile;
  }

  export abstract class SearchClientBatchesCommandResult
    implements ISearchClientBatchesCommandResult
  {
    constructor(data?: ISearchClientBatchesCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchClientBatchesCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SearchClientBatchesCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchClientBatchesCommandResult {}

  export class SearchClientBatchesCommandResultSuccess
    extends SearchClientBatchesCommandResult
    implements ISearchClientBatchesCommandResultSuccess
  {
    batches!: PageModelOfBatchIndexModel;

    constructor(data?: ISearchClientBatchesCommandResultSuccess) {
      super(data);
      if (!data) {
        this.batches = new PageModelOfBatchIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.batches = _data['batches']
          ? PageModelOfBatchIndexModel.fromJS(_data['batches'])
          : new PageModelOfBatchIndexModel();
      }
    }

    static override fromJS(data: any): SearchClientBatchesCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchClientBatchesCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batches'] = this.batches ? this.batches.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchClientBatchesCommandResultSuccess
    extends ISearchClientBatchesCommandResult {
    batches: PageModelOfBatchIndexModel;
  }

  export class SearchClientBatchesCommandResultFailure
    extends SearchClientBatchesCommandResult
    implements ISearchClientBatchesCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: ISearchClientBatchesCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): SearchClientBatchesCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchClientBatchesCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchClientBatchesCommandResultFailure
    extends ISearchClientBatchesCommandResult {
    errors: ResultError[];
  }

  export class SearchClientBatchesCommand
    implements ISearchClientBatchesCommand
  {
    clientId!: string;
    filters!: SearchClientBatchesCommandFilters;
    searchQuery!: string | null;
    page!: number;
    pageSize!: number;

    constructor(data?: ISearchClientBatchesCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.filters = new SearchClientBatchesCommandFilters();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.filters = _data['filters']
          ? SearchClientBatchesCommandFilters.fromJS(_data['filters'])
          : new SearchClientBatchesCommandFilters();
        this.searchQuery =
          _data['searchQuery'] !== undefined ? _data['searchQuery'] : <any>null;
        this.page = _data['page'] !== undefined ? _data['page'] : <any>null;
        this.pageSize =
          _data['pageSize'] !== undefined ? _data['pageSize'] : <any>null;
      }
    }

    static fromJS(data: any): SearchClientBatchesCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchClientBatchesCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['filters'] = this.filters ? this.filters.toJSON() : <any>null;
      data['searchQuery'] =
        this.searchQuery !== undefined ? this.searchQuery : <any>null;
      data['page'] = this.page !== undefined ? this.page : <any>null;
      data['pageSize'] =
        this.pageSize !== undefined ? this.pageSize : <any>null;
      return data;
    }
  }

  export interface ISearchClientBatchesCommand {
    clientId: string;
    filters: SearchClientBatchesCommandFilters;
    searchQuery: string | null;
    page: number;
    pageSize: number;
  }

  export class SearchClientBatchesCommandFilters
    implements ISearchClientBatchesCommandFilters
  {
    batchIds!: string[];
    fromDate!: Date | null;
    toDate!: Date | null;
    statuses!: BatchStatus[] | null;

    constructor(data?: ISearchClientBatchesCommandFilters) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
        this.fromDate = _data['fromDate']
          ? new Date(_data['fromDate'].toString())
          : <any>null;
        this.toDate = _data['toDate']
          ? new Date(_data['toDate'].toString())
          : <any>null;
        if (Array.isArray(_data['statuses'])) {
          this.statuses = [] as any;
          for (let item of _data['statuses']) this.statuses!.push(item);
        } else {
          this.statuses = <any>null;
        }
      }
    }

    static fromJS(data: any): SearchClientBatchesCommandFilters {
      data = typeof data === 'object' ? data : {};
      let result = new SearchClientBatchesCommandFilters();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      data['fromDate'] = this.fromDate
        ? this.fromDate.toISOString()
        : <any>null;
      data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>null;
      if (Array.isArray(this.statuses)) {
        data['statuses'] = [];
        for (let item of this.statuses) data['statuses'].push(item);
      }
      return data;
    }
  }

  export interface ISearchClientBatchesCommandFilters {
    batchIds: string[];
    fromDate: Date | null;
    toDate: Date | null;
    statuses: BatchStatus[] | null;
  }

  export abstract class MarkBatchesForDeletionCommandResult
    implements IMarkBatchesForDeletionCommandResult
  {
    constructor(data?: IMarkBatchesForDeletionCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): MarkBatchesForDeletionCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'MarkBatchesForDeletionCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IMarkBatchesForDeletionCommandResult {}

  export class MarkBatchesForDeletionCommandResultSuccess
    extends MarkBatchesForDeletionCommandResult
    implements IMarkBatchesForDeletionCommandResultSuccess
  {
    updatedBatches!: BatchIndexModel[];

    constructor(data?: IMarkBatchesForDeletionCommandResultSuccess) {
      super(data);
      if (!data) {
        this.updatedBatches = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['updatedBatches'])) {
          this.updatedBatches = [] as any;
          for (let item of _data['updatedBatches'])
            this.updatedBatches!.push(BatchIndexModel.fromJS(item));
        } else {
          this.updatedBatches = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): MarkBatchesForDeletionCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new MarkBatchesForDeletionCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.updatedBatches)) {
        data['updatedBatches'] = [];
        for (let item of this.updatedBatches)
          data['updatedBatches'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkBatchesForDeletionCommandResultSuccess
    extends IMarkBatchesForDeletionCommandResult {
    updatedBatches: BatchIndexModel[];
  }

  export class MarkBatchesForDeletionCommandResultFailure
    extends MarkBatchesForDeletionCommandResult
    implements IMarkBatchesForDeletionCommandResultFailure
  {
    errorMessage!: string;
    badBatchIds!: string[];

    constructor(data?: IMarkBatchesForDeletionCommandResultFailure) {
      super(data);
      if (!data) {
        this.badBatchIds = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
        if (Array.isArray(_data['badBatchIds'])) {
          this.badBatchIds = [] as any;
          for (let item of _data['badBatchIds']) this.badBatchIds!.push(item);
        } else {
          this.badBatchIds = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): MarkBatchesForDeletionCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new MarkBatchesForDeletionCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      if (Array.isArray(this.badBatchIds)) {
        data['badBatchIds'] = [];
        for (let item of this.badBatchIds) data['badBatchIds'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IMarkBatchesForDeletionCommandResultFailure
    extends IMarkBatchesForDeletionCommandResult {
    errorMessage: string;
    badBatchIds: string[];
  }

  export class MarkBatchesForDeletionCommand
    implements IMarkBatchesForDeletionCommand
  {
    clientId!: string;
    batchIds!: string[];

    constructor(data?: IMarkBatchesForDeletionCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.batchIds = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['batchIds'])) {
          this.batchIds = [] as any;
          for (let item of _data['batchIds']) this.batchIds!.push(item);
        } else {
          this.batchIds = <any>null;
        }
      }
    }

    static fromJS(data: any): MarkBatchesForDeletionCommand {
      data = typeof data === 'object' ? data : {};
      let result = new MarkBatchesForDeletionCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.batchIds)) {
        data['batchIds'] = [];
        for (let item of this.batchIds) data['batchIds'].push(item);
      }
      return data;
    }
  }

  export interface IMarkBatchesForDeletionCommand {
    clientId: string;
    batchIds: string[];
  }

  export abstract class SearchBatchIdsDropdownCommandResult
    implements ISearchBatchIdsDropdownCommandResult
  {
    constructor(data?: ISearchBatchIdsDropdownCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): SearchBatchIdsDropdownCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'SearchBatchIdsDropdownCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownCommandResult {}

  export class SearchBatchIdsDropdownCommandResultSuccess
    extends SearchBatchIdsDropdownCommandResult
    implements ISearchBatchIdsDropdownCommandResultSuccess
  {
    items!: SearchBatchIdsDropdownItem[];

    constructor(data?: ISearchBatchIdsDropdownCommandResultSuccess) {
      super(data);
      if (!data) {
        this.items = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items'])
            this.items!.push(SearchBatchIdsDropdownItem.fromJS(item));
        } else {
          this.items = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): SearchBatchIdsDropdownCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsDropdownCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownCommandResultSuccess
    extends ISearchBatchIdsDropdownCommandResult {
    items: SearchBatchIdsDropdownItem[];
  }

  export class SearchBatchIdsDropdownItem
    implements ISearchBatchIdsDropdownItem
  {
    batchId!: string;
    createdDate!: Date;

    constructor(data?: ISearchBatchIdsDropdownItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.createdDate = _data['createdDate']
          ? new Date(_data['createdDate'].toString())
          : <any>null;
      }
    }

    static fromJS(data: any): SearchBatchIdsDropdownItem {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsDropdownItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['createdDate'] = this.createdDate
        ? this.createdDate.toISOString()
        : <any>null;
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownItem {
    batchId: string;
    createdDate: Date;
  }

  export class SearchBatchIdsDropdownCommandResultFailure
    extends SearchBatchIdsDropdownCommandResult
    implements ISearchBatchIdsDropdownCommandResultFailure
  {
    errorMessage!: string;

    constructor(data?: ISearchBatchIdsDropdownCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): SearchBatchIdsDropdownCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsDropdownCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownCommandResultFailure
    extends ISearchBatchIdsDropdownCommandResult {
    errorMessage: string;
  }

  export class SearchBatchIdsDropdownCommand
    implements ISearchBatchIdsDropdownCommand
  {
    clientId!: string;
    filters!: SearchBatchIdsDropdownFilters;
    limit!: number;

    constructor(data?: ISearchBatchIdsDropdownCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.filters = new SearchBatchIdsDropdownFilters();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.filters = _data['filters']
          ? SearchBatchIdsDropdownFilters.fromJS(_data['filters'])
          : new SearchBatchIdsDropdownFilters();
        this.limit = _data['limit'] !== undefined ? _data['limit'] : <any>null;
      }
    }

    static fromJS(data: any): SearchBatchIdsDropdownCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsDropdownCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['filters'] = this.filters ? this.filters.toJSON() : <any>null;
      data['limit'] = this.limit !== undefined ? this.limit : <any>null;
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownCommand {
    clientId: string;
    filters: SearchBatchIdsDropdownFilters;
    limit: number;
  }

  export class SearchBatchIdsDropdownFilters
    implements ISearchBatchIdsDropdownFilters
  {
    startsWith!: string | null;
    mustBeAvailableForReporting!: boolean;
    mustBeAvailableOnCalculationsSearch!: boolean;

    constructor(data?: ISearchBatchIdsDropdownFilters) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.startsWith =
          _data['startsWith'] !== undefined ? _data['startsWith'] : <any>null;
        this.mustBeAvailableForReporting =
          _data['mustBeAvailableForReporting'] !== undefined
            ? _data['mustBeAvailableForReporting']
            : <any>null;
        this.mustBeAvailableOnCalculationsSearch =
          _data['mustBeAvailableOnCalculationsSearch'] !== undefined
            ? _data['mustBeAvailableOnCalculationsSearch']
            : <any>null;
      }
    }

    static fromJS(data: any): SearchBatchIdsDropdownFilters {
      data = typeof data === 'object' ? data : {};
      let result = new SearchBatchIdsDropdownFilters();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['startsWith'] =
        this.startsWith !== undefined ? this.startsWith : <any>null;
      data['mustBeAvailableForReporting'] =
        this.mustBeAvailableForReporting !== undefined
          ? this.mustBeAvailableForReporting
          : <any>null;
      data['mustBeAvailableOnCalculationsSearch'] =
        this.mustBeAvailableOnCalculationsSearch !== undefined
          ? this.mustBeAvailableOnCalculationsSearch
          : <any>null;
      return data;
    }
  }

  export interface ISearchBatchIdsDropdownFilters {
    startsWith: string | null;
    mustBeAvailableForReporting: boolean;
    mustBeAvailableOnCalculationsSearch: boolean;
  }

  export abstract class GetBatchCalculationsQueryResult
    implements IGetBatchCalculationsQueryResult
  {
    constructor(data?: IGetBatchCalculationsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchCalculationsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchCalculationsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchCalculationsQueryResult {}

  export class GetBatchCalculationsQueryResultSuccess
    extends GetBatchCalculationsQueryResult
    implements IGetBatchCalculationsQueryResultSuccess
  {
    calculations!: PageModelOfCalculationIndexModel;

    constructor(data?: IGetBatchCalculationsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.calculations = new PageModelOfCalculationIndexModel();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.calculations = _data['calculations']
          ? PageModelOfCalculationIndexModel.fromJS(_data['calculations'])
          : new PageModelOfCalculationIndexModel();
      }
    }

    static override fromJS(data: any): GetBatchCalculationsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchCalculationsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculations'] = this.calculations
        ? this.calculations.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchCalculationsQueryResultSuccess
    extends IGetBatchCalculationsQueryResult {
    calculations: PageModelOfCalculationIndexModel;
  }

  export class GetBatchCalculationsQueryResultFailure
    extends GetBatchCalculationsQueryResult
    implements IGetBatchCalculationsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBatchCalculationsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBatchCalculationsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchCalculationsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchCalculationsQueryResultFailure
    extends IGetBatchCalculationsQueryResult {
    errors: ResultError[];
  }

  export enum CalculationIndexSortableFields {
    EmployeeId = 'EmployeeId',
    CalculationStatus = 'CalculationStatus',
    DateCreated = 'DateCreated',
    Score = 'Score',
  }

  export enum SortDirection {
    Ascending = 'Ascending',
    Descending = 'Descending',
  }

  export abstract class GetBatchContextQueryResult
    implements IGetBatchContextQueryResult
  {
    constructor(data?: IGetBatchContextQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchContextQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchContextQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchContextQueryResult {}

  export class GetBatchContextQueryResultSuccess
    extends GetBatchContextQueryResult
    implements IGetBatchContextQueryResultSuccess
  {
    batch!: BatchContext;

    constructor(data?: IGetBatchContextQueryResultSuccess) {
      super(data);
      if (!data) {
        this.batch = new BatchContext();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.batch = _data['batch']
          ? BatchContext.fromJS(_data['batch'])
          : new BatchContext();
      }
    }

    static override fromJS(data: any): GetBatchContextQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchContextQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batch'] = this.batch ? this.batch.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchContextQueryResultSuccess
    extends IGetBatchContextQueryResult {
    batch: BatchContext;
  }

  export class BatchContext implements IBatchContext {
    batchId!: string;
    clientId!: string;
    clientPortalId!: string;
    indexRecord!: BatchIndexModel;
    indexedCalculations!: CalculationAggregations;
    pending!: BatchSummarizedStatusAggregations;
    inputProcessing!: BatchSummarizedStatusAggregations;
    inputProcessingFailed!: BatchSummarizedStatusAggregations;
    preProcessing!: BatchSummarizedStatusAggregations;
    preProcessingFailed!: BatchSummarizedStatusAggregations;
    enqueued!: BatchSummarizedStatusAggregations;
    calculationTimedOut!: BatchSummarizedStatusAggregations;
    calculating!: BatchSummarizedStatusAggregations;
    calculatingFailed!: BatchSummarizedStatusAggregations;
    postProcessing!: BatchSummarizedStatusAggregations;
    postProcessingFailed!: BatchSummarizedStatusAggregations;
    completed!: BatchSummarizedStatusAggregations;
    failed!: BatchSummarizedStatusAggregations;
    calculationDeletionPending!: BatchSummarizedStatusAggregations;
    calculationFailedDeletion!: BatchSummarizedStatusAggregations;
    totalFailed!: BatchSummarizedStatusAggregations;
    totalFailedCompletedOrPostProcessing!: BatchSummarizedStatusAggregations;
    percentCompleteOrPostProcessing!: number;

    constructor(data?: IBatchContext) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.indexRecord = new BatchIndexModel();
        this.indexedCalculations = new CalculationAggregations();
        this.pending = new BatchSummarizedStatusAggregations();
        this.inputProcessing = new BatchSummarizedStatusAggregations();
        this.inputProcessingFailed = new BatchSummarizedStatusAggregations();
        this.preProcessing = new BatchSummarizedStatusAggregations();
        this.preProcessingFailed = new BatchSummarizedStatusAggregations();
        this.enqueued = new BatchSummarizedStatusAggregations();
        this.calculationTimedOut = new BatchSummarizedStatusAggregations();
        this.calculating = new BatchSummarizedStatusAggregations();
        this.calculatingFailed = new BatchSummarizedStatusAggregations();
        this.postProcessing = new BatchSummarizedStatusAggregations();
        this.postProcessingFailed = new BatchSummarizedStatusAggregations();
        this.completed = new BatchSummarizedStatusAggregations();
        this.failed = new BatchSummarizedStatusAggregations();
        this.calculationDeletionPending =
          new BatchSummarizedStatusAggregations();
        this.calculationFailedDeletion =
          new BatchSummarizedStatusAggregations();
        this.totalFailed = new BatchSummarizedStatusAggregations();
        this.totalFailedCompletedOrPostProcessing =
          new BatchSummarizedStatusAggregations();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.clientPortalId =
          _data['clientPortalId'] !== undefined
            ? _data['clientPortalId']
            : <any>null;
        this.indexRecord = _data['indexRecord']
          ? BatchIndexModel.fromJS(_data['indexRecord'])
          : new BatchIndexModel();
        this.indexedCalculations = _data['indexedCalculations']
          ? CalculationAggregations.fromJS(_data['indexedCalculations'])
          : new CalculationAggregations();
        this.pending = _data['pending']
          ? BatchSummarizedStatusAggregations.fromJS(_data['pending'])
          : new BatchSummarizedStatusAggregations();
        this.inputProcessing = _data['inputProcessing']
          ? BatchSummarizedStatusAggregations.fromJS(_data['inputProcessing'])
          : new BatchSummarizedStatusAggregations();
        this.inputProcessingFailed = _data['inputProcessingFailed']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['inputProcessingFailed'],
            )
          : new BatchSummarizedStatusAggregations();
        this.preProcessing = _data['preProcessing']
          ? BatchSummarizedStatusAggregations.fromJS(_data['preProcessing'])
          : new BatchSummarizedStatusAggregations();
        this.preProcessingFailed = _data['preProcessingFailed']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['preProcessingFailed'],
            )
          : new BatchSummarizedStatusAggregations();
        this.enqueued = _data['enqueued']
          ? BatchSummarizedStatusAggregations.fromJS(_data['enqueued'])
          : new BatchSummarizedStatusAggregations();
        this.calculationTimedOut = _data['calculationTimedOut']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['calculationTimedOut'],
            )
          : new BatchSummarizedStatusAggregations();
        this.calculating = _data['calculating']
          ? BatchSummarizedStatusAggregations.fromJS(_data['calculating'])
          : new BatchSummarizedStatusAggregations();
        this.calculatingFailed = _data['calculatingFailed']
          ? BatchSummarizedStatusAggregations.fromJS(_data['calculatingFailed'])
          : new BatchSummarizedStatusAggregations();
        this.postProcessing = _data['postProcessing']
          ? BatchSummarizedStatusAggregations.fromJS(_data['postProcessing'])
          : new BatchSummarizedStatusAggregations();
        this.postProcessingFailed = _data['postProcessingFailed']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['postProcessingFailed'],
            )
          : new BatchSummarizedStatusAggregations();
        this.completed = _data['completed']
          ? BatchSummarizedStatusAggregations.fromJS(_data['completed'])
          : new BatchSummarizedStatusAggregations();
        this.failed = _data['failed']
          ? BatchSummarizedStatusAggregations.fromJS(_data['failed'])
          : new BatchSummarizedStatusAggregations();
        this.calculationDeletionPending = _data['calculationDeletionPending']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['calculationDeletionPending'],
            )
          : new BatchSummarizedStatusAggregations();
        this.calculationFailedDeletion = _data['calculationFailedDeletion']
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['calculationFailedDeletion'],
            )
          : new BatchSummarizedStatusAggregations();
        this.totalFailed = _data['totalFailed']
          ? BatchSummarizedStatusAggregations.fromJS(_data['totalFailed'])
          : new BatchSummarizedStatusAggregations();
        this.totalFailedCompletedOrPostProcessing = _data[
          'totalFailedCompletedOrPostProcessing'
        ]
          ? BatchSummarizedStatusAggregations.fromJS(
              _data['totalFailedCompletedOrPostProcessing'],
            )
          : new BatchSummarizedStatusAggregations();
        this.percentCompleteOrPostProcessing =
          _data['percentCompleteOrPostProcessing'] !== undefined
            ? _data['percentCompleteOrPostProcessing']
            : <any>null;
      }
    }

    static fromJS(data: any): BatchContext {
      data = typeof data === 'object' ? data : {};
      let result = new BatchContext();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['clientPortalId'] =
        this.clientPortalId !== undefined ? this.clientPortalId : <any>null;
      data['indexRecord'] = this.indexRecord
        ? this.indexRecord.toJSON()
        : <any>null;
      data['indexedCalculations'] = this.indexedCalculations
        ? this.indexedCalculations.toJSON()
        : <any>null;
      data['pending'] = this.pending ? this.pending.toJSON() : <any>null;
      data['inputProcessing'] = this.inputProcessing
        ? this.inputProcessing.toJSON()
        : <any>null;
      data['inputProcessingFailed'] = this.inputProcessingFailed
        ? this.inputProcessingFailed.toJSON()
        : <any>null;
      data['preProcessing'] = this.preProcessing
        ? this.preProcessing.toJSON()
        : <any>null;
      data['preProcessingFailed'] = this.preProcessingFailed
        ? this.preProcessingFailed.toJSON()
        : <any>null;
      data['enqueued'] = this.enqueued ? this.enqueued.toJSON() : <any>null;
      data['calculationTimedOut'] = this.calculationTimedOut
        ? this.calculationTimedOut.toJSON()
        : <any>null;
      data['calculating'] = this.calculating
        ? this.calculating.toJSON()
        : <any>null;
      data['calculatingFailed'] = this.calculatingFailed
        ? this.calculatingFailed.toJSON()
        : <any>null;
      data['postProcessing'] = this.postProcessing
        ? this.postProcessing.toJSON()
        : <any>null;
      data['postProcessingFailed'] = this.postProcessingFailed
        ? this.postProcessingFailed.toJSON()
        : <any>null;
      data['completed'] = this.completed ? this.completed.toJSON() : <any>null;
      data['failed'] = this.failed ? this.failed.toJSON() : <any>null;
      data['calculationDeletionPending'] = this.calculationDeletionPending
        ? this.calculationDeletionPending.toJSON()
        : <any>null;
      data['calculationFailedDeletion'] = this.calculationFailedDeletion
        ? this.calculationFailedDeletion.toJSON()
        : <any>null;
      data['totalFailed'] = this.totalFailed
        ? this.totalFailed.toJSON()
        : <any>null;
      data['totalFailedCompletedOrPostProcessing'] = this
        .totalFailedCompletedOrPostProcessing
        ? this.totalFailedCompletedOrPostProcessing.toJSON()
        : <any>null;
      data['percentCompleteOrPostProcessing'] =
        this.percentCompleteOrPostProcessing !== undefined
          ? this.percentCompleteOrPostProcessing
          : <any>null;
      return data;
    }
  }

  export interface IBatchContext {
    batchId: string;
    clientId: string;
    clientPortalId: string;
    indexRecord: BatchIndexModel;
    indexedCalculations: CalculationAggregations;
    pending: BatchSummarizedStatusAggregations;
    inputProcessing: BatchSummarizedStatusAggregations;
    inputProcessingFailed: BatchSummarizedStatusAggregations;
    preProcessing: BatchSummarizedStatusAggregations;
    preProcessingFailed: BatchSummarizedStatusAggregations;
    enqueued: BatchSummarizedStatusAggregations;
    calculationTimedOut: BatchSummarizedStatusAggregations;
    calculating: BatchSummarizedStatusAggregations;
    calculatingFailed: BatchSummarizedStatusAggregations;
    postProcessing: BatchSummarizedStatusAggregations;
    postProcessingFailed: BatchSummarizedStatusAggregations;
    completed: BatchSummarizedStatusAggregations;
    failed: BatchSummarizedStatusAggregations;
    calculationDeletionPending: BatchSummarizedStatusAggregations;
    calculationFailedDeletion: BatchSummarizedStatusAggregations;
    totalFailed: BatchSummarizedStatusAggregations;
    totalFailedCompletedOrPostProcessing: BatchSummarizedStatusAggregations;
    percentCompleteOrPostProcessing: number;
  }

  export class CalculationAggregations implements ICalculationAggregations {
    count!: number;
    transactionCount!: number;
    byStatus!: CalculationAggregationsByStatus;

    constructor(data?: ICalculationAggregations) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.byStatus = new CalculationAggregationsByStatus();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.count = _data['count'] !== undefined ? _data['count'] : <any>null;
        this.transactionCount =
          _data['transactionCount'] !== undefined
            ? _data['transactionCount']
            : <any>null;
        this.byStatus = _data['byStatus']
          ? CalculationAggregationsByStatus.fromJS(_data['byStatus'])
          : new CalculationAggregationsByStatus();
      }
    }

    static fromJS(data: any): CalculationAggregations {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationAggregations();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['count'] = this.count !== undefined ? this.count : <any>null;
      data['transactionCount'] =
        this.transactionCount !== undefined ? this.transactionCount : <any>null;
      data['byStatus'] = this.byStatus ? this.byStatus.toJSON() : <any>null;
      return data;
    }
  }

  export interface ICalculationAggregations {
    count: number;
    transactionCount: number;
    byStatus: CalculationAggregationsByStatus;
  }

  export class CalculationAggregationsByStatus
    implements ICalculationAggregationsByStatus
  {
    new!: BatchCalculationStatusAggregations;
    draft!: BatchCalculationStatusAggregations;
    inputProcessingStarted!: BatchCalculationStatusAggregations;
    inputProcessingFailed!: BatchCalculationStatusAggregations;
    inputProcessingCompleted!: BatchCalculationStatusAggregations;
    preProcessingStarted!: BatchCalculationStatusAggregations;
    preProcessingCompleted!: BatchCalculationStatusAggregations;
    preProcessingFailed!: BatchCalculationStatusAggregations;
    enqueued!: BatchCalculationStatusAggregations;
    calculationTimedOut!: BatchCalculationStatusAggregations;
    calculationStarted!: BatchCalculationStatusAggregations;
    calculationFailed!: BatchCalculationStatusAggregations;
    calculationCompleted!: BatchCalculationStatusAggregations;
    postProcessingStarted!: BatchCalculationStatusAggregations;
    postProcessingCompleted!: BatchCalculationStatusAggregations;
    postProcessingFailed!: BatchCalculationStatusAggregations;
    postProcessing!: BatchCalculationStatusAggregations;
    manualCalculationPendingReview!: BatchCalculationStatusAggregations;
    manualCalculationPendingApproval!: BatchCalculationStatusAggregations;
    awaitingGainAdjustment!: BatchCalculationStatusAggregations;
    performingGainAdjustment!: BatchCalculationStatusAggregations;
    awaitingBrokerAdjustment!: BatchCalculationStatusAggregations;
    performingBrokerAdjustment!: BatchCalculationStatusAggregations;
    completed!: BatchCalculationStatusAggregations;
    failed!: BatchCalculationStatusAggregations;
    calculationDeletionPending!: BatchCalculationStatusAggregations;
    calculationFailedDeletion!: BatchCalculationStatusAggregations;

    constructor(data?: ICalculationAggregationsByStatus) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.new = new BatchCalculationStatusAggregations();
        this.draft = new BatchCalculationStatusAggregations();
        this.inputProcessingStarted = new BatchCalculationStatusAggregations();
        this.inputProcessingFailed = new BatchCalculationStatusAggregations();
        this.inputProcessingCompleted =
          new BatchCalculationStatusAggregations();
        this.preProcessingStarted = new BatchCalculationStatusAggregations();
        this.preProcessingCompleted = new BatchCalculationStatusAggregations();
        this.preProcessingFailed = new BatchCalculationStatusAggregations();
        this.enqueued = new BatchCalculationStatusAggregations();
        this.calculationTimedOut = new BatchCalculationStatusAggregations();
        this.calculationStarted = new BatchCalculationStatusAggregations();
        this.calculationFailed = new BatchCalculationStatusAggregations();
        this.calculationCompleted = new BatchCalculationStatusAggregations();
        this.postProcessingStarted = new BatchCalculationStatusAggregations();
        this.postProcessingCompleted = new BatchCalculationStatusAggregations();
        this.postProcessingFailed = new BatchCalculationStatusAggregations();
        this.postProcessing = new BatchCalculationStatusAggregations();
        this.manualCalculationPendingReview =
          new BatchCalculationStatusAggregations();
        this.manualCalculationPendingApproval =
          new BatchCalculationStatusAggregations();
        this.awaitingGainAdjustment = new BatchCalculationStatusAggregations();
        this.performingGainAdjustment =
          new BatchCalculationStatusAggregations();
        this.awaitingBrokerAdjustment =
          new BatchCalculationStatusAggregations();
        this.performingBrokerAdjustment =
          new BatchCalculationStatusAggregations();
        this.completed = new BatchCalculationStatusAggregations();
        this.failed = new BatchCalculationStatusAggregations();
        this.calculationDeletionPending =
          new BatchCalculationStatusAggregations();
        this.calculationFailedDeletion =
          new BatchCalculationStatusAggregations();
      }
    }

    init(_data?: any) {
      if (_data) {
        this.new = _data['new']
          ? BatchCalculationStatusAggregations.fromJS(_data['new'])
          : new BatchCalculationStatusAggregations();
        this.draft = _data['draft']
          ? BatchCalculationStatusAggregations.fromJS(_data['draft'])
          : new BatchCalculationStatusAggregations();
        this.inputProcessingStarted = _data['inputProcessingStarted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['inputProcessingStarted'],
            )
          : new BatchCalculationStatusAggregations();
        this.inputProcessingFailed = _data['inputProcessingFailed']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['inputProcessingFailed'],
            )
          : new BatchCalculationStatusAggregations();
        this.inputProcessingCompleted = _data['inputProcessingCompleted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['inputProcessingCompleted'],
            )
          : new BatchCalculationStatusAggregations();
        this.preProcessingStarted = _data['preProcessingStarted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['preProcessingStarted'],
            )
          : new BatchCalculationStatusAggregations();
        this.preProcessingCompleted = _data['preProcessingCompleted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['preProcessingCompleted'],
            )
          : new BatchCalculationStatusAggregations();
        this.preProcessingFailed = _data['preProcessingFailed']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['preProcessingFailed'],
            )
          : new BatchCalculationStatusAggregations();
        this.enqueued = _data['enqueued']
          ? BatchCalculationStatusAggregations.fromJS(_data['enqueued'])
          : new BatchCalculationStatusAggregations();
        this.calculationTimedOut = _data['calculationTimedOut']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationTimedOut'],
            )
          : new BatchCalculationStatusAggregations();
        this.calculationStarted = _data['calculationStarted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationStarted'],
            )
          : new BatchCalculationStatusAggregations();
        this.calculationFailed = _data['calculationFailed']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationFailed'],
            )
          : new BatchCalculationStatusAggregations();
        this.calculationCompleted = _data['calculationCompleted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationCompleted'],
            )
          : new BatchCalculationStatusAggregations();
        this.postProcessingStarted = _data['postProcessingStarted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['postProcessingStarted'],
            )
          : new BatchCalculationStatusAggregations();
        this.postProcessingCompleted = _data['postProcessingCompleted']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['postProcessingCompleted'],
            )
          : new BatchCalculationStatusAggregations();
        this.postProcessingFailed = _data['postProcessingFailed']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['postProcessingFailed'],
            )
          : new BatchCalculationStatusAggregations();
        this.postProcessing = _data['postProcessing']
          ? BatchCalculationStatusAggregations.fromJS(_data['postProcessing'])
          : new BatchCalculationStatusAggregations();
        this.manualCalculationPendingReview = _data[
          'manualCalculationPendingReview'
        ]
          ? BatchCalculationStatusAggregations.fromJS(
              _data['manualCalculationPendingReview'],
            )
          : new BatchCalculationStatusAggregations();
        this.manualCalculationPendingApproval = _data[
          'manualCalculationPendingApproval'
        ]
          ? BatchCalculationStatusAggregations.fromJS(
              _data['manualCalculationPendingApproval'],
            )
          : new BatchCalculationStatusAggregations();
        this.awaitingGainAdjustment = _data['awaitingGainAdjustment']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['awaitingGainAdjustment'],
            )
          : new BatchCalculationStatusAggregations();
        this.performingGainAdjustment = _data['performingGainAdjustment']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['performingGainAdjustment'],
            )
          : new BatchCalculationStatusAggregations();
        this.awaitingBrokerAdjustment = _data['awaitingBrokerAdjustment']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['awaitingBrokerAdjustment'],
            )
          : new BatchCalculationStatusAggregations();
        this.performingBrokerAdjustment = _data['performingBrokerAdjustment']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['performingBrokerAdjustment'],
            )
          : new BatchCalculationStatusAggregations();
        this.completed = _data['completed']
          ? BatchCalculationStatusAggregations.fromJS(_data['completed'])
          : new BatchCalculationStatusAggregations();
        this.failed = _data['failed']
          ? BatchCalculationStatusAggregations.fromJS(_data['failed'])
          : new BatchCalculationStatusAggregations();
        this.calculationDeletionPending = _data['calculationDeletionPending']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationDeletionPending'],
            )
          : new BatchCalculationStatusAggregations();
        this.calculationFailedDeletion = _data['calculationFailedDeletion']
          ? BatchCalculationStatusAggregations.fromJS(
              _data['calculationFailedDeletion'],
            )
          : new BatchCalculationStatusAggregations();
      }
    }

    static fromJS(data: any): CalculationAggregationsByStatus {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationAggregationsByStatus();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['new'] = this.new ? this.new.toJSON() : <any>null;
      data['draft'] = this.draft ? this.draft.toJSON() : <any>null;
      data['inputProcessingStarted'] = this.inputProcessingStarted
        ? this.inputProcessingStarted.toJSON()
        : <any>null;
      data['inputProcessingFailed'] = this.inputProcessingFailed
        ? this.inputProcessingFailed.toJSON()
        : <any>null;
      data['inputProcessingCompleted'] = this.inputProcessingCompleted
        ? this.inputProcessingCompleted.toJSON()
        : <any>null;
      data['preProcessingStarted'] = this.preProcessingStarted
        ? this.preProcessingStarted.toJSON()
        : <any>null;
      data['preProcessingCompleted'] = this.preProcessingCompleted
        ? this.preProcessingCompleted.toJSON()
        : <any>null;
      data['preProcessingFailed'] = this.preProcessingFailed
        ? this.preProcessingFailed.toJSON()
        : <any>null;
      data['enqueued'] = this.enqueued ? this.enqueued.toJSON() : <any>null;
      data['calculationTimedOut'] = this.calculationTimedOut
        ? this.calculationTimedOut.toJSON()
        : <any>null;
      data['calculationStarted'] = this.calculationStarted
        ? this.calculationStarted.toJSON()
        : <any>null;
      data['calculationFailed'] = this.calculationFailed
        ? this.calculationFailed.toJSON()
        : <any>null;
      data['calculationCompleted'] = this.calculationCompleted
        ? this.calculationCompleted.toJSON()
        : <any>null;
      data['postProcessingStarted'] = this.postProcessingStarted
        ? this.postProcessingStarted.toJSON()
        : <any>null;
      data['postProcessingCompleted'] = this.postProcessingCompleted
        ? this.postProcessingCompleted.toJSON()
        : <any>null;
      data['postProcessingFailed'] = this.postProcessingFailed
        ? this.postProcessingFailed.toJSON()
        : <any>null;
      data['postProcessing'] = this.postProcessing
        ? this.postProcessing.toJSON()
        : <any>null;
      data['manualCalculationPendingReview'] = this
        .manualCalculationPendingReview
        ? this.manualCalculationPendingReview.toJSON()
        : <any>null;
      data['manualCalculationPendingApproval'] = this
        .manualCalculationPendingApproval
        ? this.manualCalculationPendingApproval.toJSON()
        : <any>null;
      data['awaitingGainAdjustment'] = this.awaitingGainAdjustment
        ? this.awaitingGainAdjustment.toJSON()
        : <any>null;
      data['performingGainAdjustment'] = this.performingGainAdjustment
        ? this.performingGainAdjustment.toJSON()
        : <any>null;
      data['awaitingBrokerAdjustment'] = this.awaitingBrokerAdjustment
        ? this.awaitingBrokerAdjustment.toJSON()
        : <any>null;
      data['performingBrokerAdjustment'] = this.performingBrokerAdjustment
        ? this.performingBrokerAdjustment.toJSON()
        : <any>null;
      data['completed'] = this.completed ? this.completed.toJSON() : <any>null;
      data['failed'] = this.failed ? this.failed.toJSON() : <any>null;
      data['calculationDeletionPending'] = this.calculationDeletionPending
        ? this.calculationDeletionPending.toJSON()
        : <any>null;
      data['calculationFailedDeletion'] = this.calculationFailedDeletion
        ? this.calculationFailedDeletion.toJSON()
        : <any>null;
      return data;
    }
  }

  export interface ICalculationAggregationsByStatus {
    new: BatchCalculationStatusAggregations;
    draft: BatchCalculationStatusAggregations;
    inputProcessingStarted: BatchCalculationStatusAggregations;
    inputProcessingFailed: BatchCalculationStatusAggregations;
    inputProcessingCompleted: BatchCalculationStatusAggregations;
    preProcessingStarted: BatchCalculationStatusAggregations;
    preProcessingCompleted: BatchCalculationStatusAggregations;
    preProcessingFailed: BatchCalculationStatusAggregations;
    enqueued: BatchCalculationStatusAggregations;
    calculationTimedOut: BatchCalculationStatusAggregations;
    calculationStarted: BatchCalculationStatusAggregations;
    calculationFailed: BatchCalculationStatusAggregations;
    calculationCompleted: BatchCalculationStatusAggregations;
    postProcessingStarted: BatchCalculationStatusAggregations;
    postProcessingCompleted: BatchCalculationStatusAggregations;
    postProcessingFailed: BatchCalculationStatusAggregations;
    postProcessing: BatchCalculationStatusAggregations;
    manualCalculationPendingReview: BatchCalculationStatusAggregations;
    manualCalculationPendingApproval: BatchCalculationStatusAggregations;
    awaitingGainAdjustment: BatchCalculationStatusAggregations;
    performingGainAdjustment: BatchCalculationStatusAggregations;
    awaitingBrokerAdjustment: BatchCalculationStatusAggregations;
    performingBrokerAdjustment: BatchCalculationStatusAggregations;
    completed: BatchCalculationStatusAggregations;
    failed: BatchCalculationStatusAggregations;
    calculationDeletionPending: BatchCalculationStatusAggregations;
    calculationFailedDeletion: BatchCalculationStatusAggregations;
  }

  export class BatchCalculationStatusAggregations
    implements IBatchCalculationStatusAggregations
  {
    min!: number | null;
    max!: number | null;
    avg!: number | null;
    p50!: number | null;
    p75!: number | null;
    p90!: number | null;
    p95!: number | null;
    p99!: number | null;
    p99_5!: number | null;
    count!: number;
    transactionCount!: number;
    sum!: number | null;

    constructor(data?: IBatchCalculationStatusAggregations) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.min = _data['min'] !== undefined ? _data['min'] : <any>null;
        this.max = _data['max'] !== undefined ? _data['max'] : <any>null;
        this.avg = _data['avg'] !== undefined ? _data['avg'] : <any>null;
        this.p50 = _data['p50'] !== undefined ? _data['p50'] : <any>null;
        this.p75 = _data['p75'] !== undefined ? _data['p75'] : <any>null;
        this.p90 = _data['p90'] !== undefined ? _data['p90'] : <any>null;
        this.p95 = _data['p95'] !== undefined ? _data['p95'] : <any>null;
        this.p99 = _data['p99'] !== undefined ? _data['p99'] : <any>null;
        this.p99_5 = _data['p99_5'] !== undefined ? _data['p99_5'] : <any>null;
        this.count = _data['count'] !== undefined ? _data['count'] : <any>null;
        this.transactionCount =
          _data['transactionCount'] !== undefined
            ? _data['transactionCount']
            : <any>null;
        this.sum = _data['sum'] !== undefined ? _data['sum'] : <any>null;
      }
    }

    static fromJS(data: any): BatchCalculationStatusAggregations {
      data = typeof data === 'object' ? data : {};
      let result = new BatchCalculationStatusAggregations();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['min'] = this.min !== undefined ? this.min : <any>null;
      data['max'] = this.max !== undefined ? this.max : <any>null;
      data['avg'] = this.avg !== undefined ? this.avg : <any>null;
      data['p50'] = this.p50 !== undefined ? this.p50 : <any>null;
      data['p75'] = this.p75 !== undefined ? this.p75 : <any>null;
      data['p90'] = this.p90 !== undefined ? this.p90 : <any>null;
      data['p95'] = this.p95 !== undefined ? this.p95 : <any>null;
      data['p99'] = this.p99 !== undefined ? this.p99 : <any>null;
      data['p99_5'] = this.p99_5 !== undefined ? this.p99_5 : <any>null;
      data['count'] = this.count !== undefined ? this.count : <any>null;
      data['transactionCount'] =
        this.transactionCount !== undefined ? this.transactionCount : <any>null;
      data['sum'] = this.sum !== undefined ? this.sum : <any>null;
      return data;
    }
  }

  export interface IBatchCalculationStatusAggregations {
    min: number | null;
    max: number | null;
    avg: number | null;
    p50: number | null;
    p75: number | null;
    p90: number | null;
    p95: number | null;
    p99: number | null;
    p99_5: number | null;
    count: number;
    transactionCount: number;
    sum: number | null;
  }

  export class BatchSummarizedStatusAggregations
    implements IBatchSummarizedStatusAggregations
  {
    calculationCount!: number;
    transactionCount!: number;

    constructor(data?: IBatchSummarizedStatusAggregations) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.calculationCount =
          _data['calculationCount'] !== undefined
            ? _data['calculationCount']
            : <any>null;
        this.transactionCount =
          _data['transactionCount'] !== undefined
            ? _data['transactionCount']
            : <any>null;
      }
    }

    static fromJS(data: any): BatchSummarizedStatusAggregations {
      data = typeof data === 'object' ? data : {};
      let result = new BatchSummarizedStatusAggregations();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['calculationCount'] =
        this.calculationCount !== undefined ? this.calculationCount : <any>null;
      data['transactionCount'] =
        this.transactionCount !== undefined ? this.transactionCount : <any>null;
      return data;
    }
  }

  export interface IBatchSummarizedStatusAggregations {
    calculationCount: number;
    transactionCount: number;
  }

  export class GetBatchContextQueryResultFailure
    extends GetBatchContextQueryResult
    implements IGetBatchContextQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBatchContextQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBatchContextQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchContextQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchContextQueryResultFailure
    extends IGetBatchContextQueryResult {
    errors: ResultError[];
  }

  export abstract class GetBatchCalculationErrorSummaryQueryResult
    implements IGetBatchCalculationErrorSummaryQueryResult
  {
    constructor(data?: IGetBatchCalculationErrorSummaryQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchCalculationErrorSummaryQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchCalculationErrorSummaryQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchCalculationErrorSummaryQueryResult {}

  export class GetBatchCalculationErrorSummaryQueryResultSuccess
    extends GetBatchCalculationErrorSummaryQueryResult
    implements IGetBatchCalculationErrorSummaryQueryResultSuccess
  {
    errors!: CalculationErrorLogEntryDto[];

    constructor(data?: IGetBatchCalculationErrorSummaryQueryResultSuccess) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(CalculationErrorLogEntryDto.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchCalculationErrorSummaryQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchCalculationErrorSummaryQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchCalculationErrorSummaryQueryResultSuccess
    extends IGetBatchCalculationErrorSummaryQueryResult {
    errors: CalculationErrorLogEntryDto[];
  }

  export class CalculationErrorLogEntryDto
    implements ICalculationErrorLogEntryDto
  {
    processingStep!: string;
    employeeId!: string | null;
    transactionId!: string | null;
    errorREason!: string;

    constructor(data?: ICalculationErrorLogEntryDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.processingStep =
          _data['processingStep'] !== undefined
            ? _data['processingStep']
            : <any>null;
        this.employeeId =
          _data['employeeId'] !== undefined ? _data['employeeId'] : <any>null;
        this.transactionId =
          _data['transactionId'] !== undefined
            ? _data['transactionId']
            : <any>null;
        this.errorREason =
          _data['errorREason'] !== undefined ? _data['errorREason'] : <any>null;
      }
    }

    static fromJS(data: any): CalculationErrorLogEntryDto {
      data = typeof data === 'object' ? data : {};
      let result = new CalculationErrorLogEntryDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['processingStep'] =
        this.processingStep !== undefined ? this.processingStep : <any>null;
      data['employeeId'] =
        this.employeeId !== undefined ? this.employeeId : <any>null;
      data['transactionId'] =
        this.transactionId !== undefined ? this.transactionId : <any>null;
      data['errorREason'] =
        this.errorREason !== undefined ? this.errorREason : <any>null;
      return data;
    }
  }

  export interface ICalculationErrorLogEntryDto {
    processingStep: string;
    employeeId: string | null;
    transactionId: string | null;
    errorREason: string;
  }

  export class GetBatchCalculationErrorSummaryQueryResultFailure
    extends GetBatchCalculationErrorSummaryQueryResult
    implements IGetBatchCalculationErrorSummaryQueryResultFailure
  {
    errorMessage!: string;

    constructor(data?: IGetBatchCalculationErrorSummaryQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): GetBatchCalculationErrorSummaryQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchCalculationErrorSummaryQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchCalculationErrorSummaryQueryResultFailure
    extends IGetBatchCalculationErrorSummaryQueryResult {
    errorMessage: string;
  }

  export abstract class DownloadBatchCalculationErrorsFileCommandResult
    implements IDownloadBatchCalculationErrorsFileCommandResult
  {
    constructor(data?: IDownloadBatchCalculationErrorsFileCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): DownloadBatchCalculationErrorsFileCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'DownloadBatchCalculationErrorsFileCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadBatchCalculationErrorsFileCommandResult {}

  export class DownloadBatchCalculationErrorsFileCommandResultSuccess
    extends DownloadBatchCalculationErrorsFileCommandResult
    implements IDownloadBatchCalculationErrorsFileCommandResultSuccess
  {
    encodedFile!: string;

    constructor(
      data?: IDownloadBatchCalculationErrorsFileCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.encodedFile =
          _data['encodedFile'] !== undefined ? _data['encodedFile'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadBatchCalculationErrorsFileCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchCalculationErrorsFileCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['encodedFile'] =
        this.encodedFile !== undefined ? this.encodedFile : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadBatchCalculationErrorsFileCommandResultSuccess
    extends IDownloadBatchCalculationErrorsFileCommandResult {
    encodedFile: string;
  }

  export class DownloadBatchCalculationErrorsFileCommandResultFailure
    extends DownloadBatchCalculationErrorsFileCommandResult
    implements IDownloadBatchCalculationErrorsFileCommandResultFailure
  {
    errorMessage!: string;

    constructor(
      data?: IDownloadBatchCalculationErrorsFileCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.errorMessage =
          _data['errorMessage'] !== undefined
            ? _data['errorMessage']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadBatchCalculationErrorsFileCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchCalculationErrorsFileCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['errorMessage'] =
        this.errorMessage !== undefined ? this.errorMessage : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadBatchCalculationErrorsFileCommandResultFailure
    extends IDownloadBatchCalculationErrorsFileCommandResult {
    errorMessage: string;
  }

  export class DownloadBatchCalculationErrorsFileCommand
    implements IDownloadBatchCalculationErrorsFileCommand
  {
    clientId!: string;
    batchId!: string;

    constructor(data?: IDownloadBatchCalculationErrorsFileCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.batchId =
          _data['batchId'] !== undefined ? _data['batchId'] : <any>null;
      }
    }

    static fromJS(data: any): DownloadBatchCalculationErrorsFileCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadBatchCalculationErrorsFileCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['batchId'] = this.batchId !== undefined ? this.batchId : <any>null;
      return data;
    }
  }

  export interface IDownloadBatchCalculationErrorsFileCommand {
    clientId: string;
    batchId: string;
  }

  export abstract class GetBatchAuditLogQueryResult
    implements IGetBatchAuditLogQueryResult
  {
    constructor(data?: IGetBatchAuditLogQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetBatchAuditLogQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetBatchAuditLogQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetBatchAuditLogQueryResult {}

  export class GetBatchAuditLogQueryResultSuccess
    extends GetBatchAuditLogQueryResult
    implements IGetBatchAuditLogQueryResultSuccess
  {
    log!: ReadOnlyLog;
    finalized!: boolean;

    constructor(data?: IGetBatchAuditLogQueryResultSuccess) {
      super(data);
      if (!data) {
        this.log = new ReadOnlyLog();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.log = _data['log']
          ? ReadOnlyLog.fromJS(_data['log'])
          : new ReadOnlyLog();
        this.finalized =
          _data['finalized'] !== undefined ? _data['finalized'] : <any>null;
      }
    }

    static override fromJS(data: any): GetBatchAuditLogQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchAuditLogQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['log'] = this.log ? this.log.toJSON() : <any>null;
      data['finalized'] =
        this.finalized !== undefined ? this.finalized : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchAuditLogQueryResultSuccess
    extends IGetBatchAuditLogQueryResult {
    log: ReadOnlyLog;
    finalized: boolean;
  }

  export class GetBatchAuditLogQueryResultFailure
    extends GetBatchAuditLogQueryResult
    implements IGetBatchAuditLogQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetBatchAuditLogQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetBatchAuditLogQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetBatchAuditLogQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetBatchAuditLogQueryResultFailure
    extends IGetBatchAuditLogQueryResult {
    errors: ResultError[];
  }

  export class ApplicationContextDto implements IApplicationContextDto {
    enums!: { [key: string]: { [key: string]: EnumValueDisplayDetails } };

    constructor(data?: IApplicationContextDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.enums = {};
      }
    }

    init(_data?: any) {
      if (_data) {
        if (_data['enums']) {
          this.enums = {} as any;
          for (let key in _data['enums']) {
            if (_data['enums'].hasOwnProperty(key))
              (<any>this.enums)![key] =
                _data['enums'][key] !== undefined ? _data['enums'][key] : {};
          }
        } else {
          this.enums = <any>null;
        }
      }
    }

    static fromJS(data: any): ApplicationContextDto {
      data = typeof data === 'object' ? data : {};
      let result = new ApplicationContextDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.enums) {
        data['enums'] = {};
        for (let key in this.enums) {
          if (this.enums.hasOwnProperty(key))
            (<any>data['enums'])[key] =
              this.enums[key] !== undefined ? this.enums[key] : <any>null;
        }
      }
      return data;
    }
  }

  export interface IApplicationContextDto {
    enums: { [key: string]: { [key: string]: EnumValueDisplayDetails } };
  }

  export class EnumValueDisplayDetails implements IEnumValueDisplayDetails {
    name!: string;
    displayName!: string | null;
    shortDisplayName!: string | null;
    description!: string | null;
    value!: number;
    obsolete!: boolean;

    constructor(data?: IEnumValueDisplayDetails) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.name = _data['name'] !== undefined ? _data['name'] : <any>null;
        this.displayName =
          _data['displayName'] !== undefined ? _data['displayName'] : <any>null;
        this.shortDisplayName =
          _data['shortDisplayName'] !== undefined
            ? _data['shortDisplayName']
            : <any>null;
        this.description =
          _data['description'] !== undefined ? _data['description'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
        this.obsolete =
          _data['obsolete'] !== undefined ? _data['obsolete'] : <any>null;
      }
    }

    static fromJS(data: any): EnumValueDisplayDetails {
      data = typeof data === 'object' ? data : {};
      let result = new EnumValueDisplayDetails();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['name'] = this.name !== undefined ? this.name : <any>null;
      data['displayName'] =
        this.displayName !== undefined ? this.displayName : <any>null;
      data['shortDisplayName'] =
        this.shortDisplayName !== undefined ? this.shortDisplayName : <any>null;
      data['description'] =
        this.description !== undefined ? this.description : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      data['obsolete'] =
        this.obsolete !== undefined ? this.obsolete : <any>null;
      return data;
    }
  }

  export interface IEnumValueDisplayDetails {
    name: string;
    displayName: string | null;
    shortDisplayName: string | null;
    description: string | null;
    value: number;
    obsolete: boolean;
  }

  export abstract class GetCodeBaseVersionQueryResult
    implements IGetCodeBaseVersionQueryResult
  {
    constructor(data?: IGetCodeBaseVersionQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCodeBaseVersionQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetCodeBaseVersionQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCodeBaseVersionQueryResult {}

  export class GetCodeBaseVersionQueryResultSuccess
    extends GetCodeBaseVersionQueryResult
    implements IGetCodeBaseVersionQueryResultSuccess
  {
    version!: string;

    constructor(data?: IGetCodeBaseVersionQueryResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.version =
          _data['version'] !== undefined ? _data['version'] : <any>null;
      }
    }

    static override fromJS(data: any): GetCodeBaseVersionQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetCodeBaseVersionQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['version'] = this.version !== undefined ? this.version : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCodeBaseVersionQueryResultSuccess
    extends IGetCodeBaseVersionQueryResult {
    version: string;
  }

  export class GetCodeBaseVersionQueryResultFailure
    extends GetCodeBaseVersionQueryResult
    implements IGetCodeBaseVersionQueryResultFailure
  {
    constructor(data?: IGetCodeBaseVersionQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetCodeBaseVersionQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetCodeBaseVersionQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetCodeBaseVersionQueryResultFailure
    extends IGetCodeBaseVersionQueryResult {}

  export class GetCodeBaseVersionQuery implements IGetCodeBaseVersionQuery {
    constructor(data?: IGetCodeBaseVersionQuery) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetCodeBaseVersionQuery {
      data = typeof data === 'object' ? data : {};
      let result = new GetCodeBaseVersionQuery();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetCodeBaseVersionQuery {}

  export class GetPromotionAccessDetailsQueryResult
    implements IGetPromotionAccessDetailsQueryResult
  {
    constructor(data?: IGetPromotionAccessDetailsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetPromotionAccessDetailsQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetPromotionAccessDetailsQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetPromotionAccessDetailsQueryResult {}

  export class GetPromotionAccessDetailsQueryResultSuccess
    extends GetPromotionAccessDetailsQueryResult
    implements IGetPromotionAccessDetailsQueryResultSuccess
  {
    result!: PromotionAccessDetailsPageData;

    constructor(data?: IGetPromotionAccessDetailsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.result = new PromotionAccessDetailsPageData();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.result = _data['result']
          ? PromotionAccessDetailsPageData.fromJS(_data['result'])
          : new PromotionAccessDetailsPageData();
      }
    }

    static override fromJS(
      data: any,
    ): GetPromotionAccessDetailsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetPromotionAccessDetailsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['result'] = this.result ? this.result.toJSON() : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPromotionAccessDetailsQueryResultSuccess
    extends IGetPromotionAccessDetailsQueryResult {
    result: PromotionAccessDetailsPageData;
  }

  export class PromotionAccessDetailsPageData
    implements IPromotionAccessDetailsPageData
  {
    userCanEdit!: boolean;
    promotionAccessMembersDetails!: PromotionAccessMemberDto[];
    promotionAccessPermissionOptions!: PromotionAccessPermissionDto[];
    promotionAccessRoleOptions!: PromotionAccessRoleDto[];

    constructor(data?: IPromotionAccessDetailsPageData) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.promotionAccessMembersDetails = [];
        this.promotionAccessPermissionOptions = [];
        this.promotionAccessRoleOptions = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userCanEdit =
          _data['userCanEdit'] !== undefined ? _data['userCanEdit'] : <any>null;
        if (Array.isArray(_data['promotionAccessMembersDetails'])) {
          this.promotionAccessMembersDetails = [] as any;
          for (let item of _data['promotionAccessMembersDetails'])
            this.promotionAccessMembersDetails!.push(
              PromotionAccessMemberDto.fromJS(item),
            );
        } else {
          this.promotionAccessMembersDetails = <any>null;
        }
        if (Array.isArray(_data['promotionAccessPermissionOptions'])) {
          this.promotionAccessPermissionOptions = [] as any;
          for (let item of _data['promotionAccessPermissionOptions'])
            this.promotionAccessPermissionOptions!.push(
              PromotionAccessPermissionDto.fromJS(item),
            );
        } else {
          this.promotionAccessPermissionOptions = <any>null;
        }
        if (Array.isArray(_data['promotionAccessRoleOptions'])) {
          this.promotionAccessRoleOptions = [] as any;
          for (let item of _data['promotionAccessRoleOptions'])
            this.promotionAccessRoleOptions!.push(
              PromotionAccessRoleDto.fromJS(item),
            );
        } else {
          this.promotionAccessRoleOptions = <any>null;
        }
      }
    }

    static fromJS(data: any): PromotionAccessDetailsPageData {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionAccessDetailsPageData();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userCanEdit'] =
        this.userCanEdit !== undefined ? this.userCanEdit : <any>null;
      if (Array.isArray(this.promotionAccessMembersDetails)) {
        data['promotionAccessMembersDetails'] = [];
        for (let item of this.promotionAccessMembersDetails)
          data['promotionAccessMembersDetails'].push(item.toJSON());
      }
      if (Array.isArray(this.promotionAccessPermissionOptions)) {
        data['promotionAccessPermissionOptions'] = [];
        for (let item of this.promotionAccessPermissionOptions)
          data['promotionAccessPermissionOptions'].push(item.toJSON());
      }
      if (Array.isArray(this.promotionAccessRoleOptions)) {
        data['promotionAccessRoleOptions'] = [];
        for (let item of this.promotionAccessRoleOptions)
          data['promotionAccessRoleOptions'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPromotionAccessDetailsPageData {
    userCanEdit: boolean;
    promotionAccessMembersDetails: PromotionAccessMemberDto[];
    promotionAccessPermissionOptions: PromotionAccessPermissionDto[];
    promotionAccessRoleOptions: PromotionAccessRoleDto[];
  }

  export class PromotionAccessMemberDto implements IPromotionAccessMemberDto {
    userId!: string;
    fullName!: string;
    role!: PromotionAccessRole;
    accesss!: KeyValuePairOfPromotionAccessPermissionAndBoolean[];

    constructor(data?: IPromotionAccessMemberDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.accesss = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userId =
          _data['userId'] !== undefined ? _data['userId'] : <any>null;
        this.fullName =
          _data['fullName'] !== undefined ? _data['fullName'] : <any>null;
        this.role = _data['role'] !== undefined ? _data['role'] : <any>null;
        if (Array.isArray(_data['accesss'])) {
          this.accesss = [] as any;
          for (let item of _data['accesss'])
            this.accesss!.push(
              KeyValuePairOfPromotionAccessPermissionAndBoolean.fromJS(item),
            );
        } else {
          this.accesss = <any>null;
        }
      }
    }

    static fromJS(data: any): PromotionAccessMemberDto {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionAccessMemberDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userId'] = this.userId !== undefined ? this.userId : <any>null;
      data['fullName'] =
        this.fullName !== undefined ? this.fullName : <any>null;
      data['role'] = this.role !== undefined ? this.role : <any>null;
      if (Array.isArray(this.accesss)) {
        data['accesss'] = [];
        for (let item of this.accesss) data['accesss'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPromotionAccessMemberDto {
    userId: string;
    fullName: string;
    role: PromotionAccessRole;
    accesss: KeyValuePairOfPromotionAccessPermissionAndBoolean[];
  }

  export enum PromotionAccessRole {
    EngagementPpmd = 'EngagementPpmd',
    EngagementLead = 'EngagementLead',
    EngagementTeamMember = 'EngagementTeamMember',
  }

  export class KeyValuePairOfPromotionAccessPermissionAndBoolean
    implements IKeyValuePairOfPromotionAccessPermissionAndBoolean
  {
    key!: PromotionAccessPermission;
    value!: boolean;

    constructor(data?: IKeyValuePairOfPromotionAccessPermissionAndBoolean) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.key = _data['key'] !== undefined ? _data['key'] : <any>null;
        this.value = _data['value'] !== undefined ? _data['value'] : <any>null;
      }
    }

    static fromJS(
      data: any,
    ): KeyValuePairOfPromotionAccessPermissionAndBoolean {
      data = typeof data === 'object' ? data : {};
      let result = new KeyValuePairOfPromotionAccessPermissionAndBoolean();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['key'] = this.key !== undefined ? this.key : <any>null;
      data['value'] = this.value !== undefined ? this.value : <any>null;
      return data;
    }
  }

  export interface IKeyValuePairOfPromotionAccessPermissionAndBoolean {
    key: PromotionAccessPermission;
    value: boolean;
  }

  export enum PromotionAccessPermission {
    Configuration = 'Configuration',
    Overrides = 'Overrides',
    DataExchange = 'DataExchange',
    Reports = 'Reports',
  }

  export class PromotionAccessPermissionDto
    implements IPromotionAccessPermissionDto
  {
    optionValue!: PromotionAccessPermission;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IPromotionAccessPermissionDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): PromotionAccessPermissionDto {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionAccessPermissionDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IPromotionAccessPermissionDto {
    optionValue: PromotionAccessPermission;
    displayValue: string;
    displayOrder: number;
  }

  export class PromotionAccessRoleDto implements IPromotionAccessRoleDto {
    optionValue!: PromotionAccessRole;
    displayValue!: string;
    displayOrder!: number;

    constructor(data?: IPromotionAccessRoleDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.optionValue =
          _data['optionValue'] !== undefined ? _data['optionValue'] : <any>null;
        this.displayValue =
          _data['displayValue'] !== undefined
            ? _data['displayValue']
            : <any>null;
        this.displayOrder =
          _data['displayOrder'] !== undefined
            ? _data['displayOrder']
            : <any>null;
      }
    }

    static fromJS(data: any): PromotionAccessRoleDto {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionAccessRoleDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['optionValue'] =
        this.optionValue !== undefined ? this.optionValue : <any>null;
      data['displayValue'] =
        this.displayValue !== undefined ? this.displayValue : <any>null;
      data['displayOrder'] =
        this.displayOrder !== undefined ? this.displayOrder : <any>null;
      return data;
    }
  }

  export interface IPromotionAccessRoleDto {
    optionValue: PromotionAccessRole;
    displayValue: string;
    displayOrder: number;
  }

  export class GetPromotionAccessDetailsQueryResultFailure
    extends GetPromotionAccessDetailsQueryResult
    implements IGetPromotionAccessDetailsQueryResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IGetPromotionAccessDetailsQueryResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetPromotionAccessDetailsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetPromotionAccessDetailsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetPromotionAccessDetailsQueryResultFailure
    extends IGetPromotionAccessDetailsQueryResult {
    errors: ResultError[];
  }

  export class UpsertPromotionAccessDetailsCommandResult
    implements IUpsertPromotionAccessDetailsCommandResult
  {
    constructor(data?: IUpsertPromotionAccessDetailsCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertPromotionAccessDetailsCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPromotionAccessDetailsCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertPromotionAccessDetailsCommandResult {}

  export class UpsertPromotionAccessDetailsCommandResultSuccess
    extends UpsertPromotionAccessDetailsCommandResult
    implements IUpsertPromotionAccessDetailsCommandResultSuccess
  {
    id!: string;

    constructor(data?: IUpsertPromotionAccessDetailsCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): UpsertPromotionAccessDetailsCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPromotionAccessDetailsCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPromotionAccessDetailsCommandResultSuccess
    extends IUpsertPromotionAccessDetailsCommandResult {
    id: string;
  }

  export class UpsertPromotionAccessDetailsCommandResultFailure
    extends UpsertPromotionAccessDetailsCommandResult
    implements IUpsertPromotionAccessDetailsCommandResultFailure
  {
    errors!: ResultError[];

    constructor(data?: IUpsertPromotionAccessDetailsCommandResultFailure) {
      super(data);
      if (!data) {
        this.errors = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['errors'])) {
          this.errors = [] as any;
          for (let item of _data['errors'])
            this.errors!.push(ResultError.fromJS(item));
        } else {
          this.errors = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): UpsertPromotionAccessDetailsCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPromotionAccessDetailsCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.errors)) {
        data['errors'] = [];
        for (let item of this.errors) data['errors'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertPromotionAccessDetailsCommandResultFailure
    extends IUpsertPromotionAccessDetailsCommandResult {
    errors: ResultError[];
  }

  export class UpsertPromotionAccessDetailsCommand
    implements IUpsertPromotionAccessDetailsCommand
  {
    clientId!: string;
    promotionAccessMemberDeatils!: PromotionAccessMemberDetailsDto[];

    constructor(data?: IUpsertPromotionAccessDetailsCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.promotionAccessMemberDeatils = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        if (Array.isArray(_data['promotionAccessMemberDeatils'])) {
          this.promotionAccessMemberDeatils = [] as any;
          for (let item of _data['promotionAccessMemberDeatils'])
            this.promotionAccessMemberDeatils!.push(
              PromotionAccessMemberDetailsDto.fromJS(item),
            );
        } else {
          this.promotionAccessMemberDeatils = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertPromotionAccessDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertPromotionAccessDetailsCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      if (Array.isArray(this.promotionAccessMemberDeatils)) {
        data['promotionAccessMemberDeatils'] = [];
        for (let item of this.promotionAccessMemberDeatils)
          data['promotionAccessMemberDeatils'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IUpsertPromotionAccessDetailsCommand {
    clientId: string;
    promotionAccessMemberDeatils: PromotionAccessMemberDetailsDto[];
  }

  export class PromotionAccessMemberDetailsDto
    implements IPromotionAccessMemberDetailsDto
  {
    userId!: string;
    access!: KeyValuePairOfPromotionAccessPermissionAndBoolean[];

    constructor(data?: IPromotionAccessMemberDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.access = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        this.userId =
          _data['userId'] !== undefined ? _data['userId'] : <any>null;
        if (Array.isArray(_data['access'])) {
          this.access = [] as any;
          for (let item of _data['access'])
            this.access!.push(
              KeyValuePairOfPromotionAccessPermissionAndBoolean.fromJS(item),
            );
        } else {
          this.access = <any>null;
        }
      }
    }

    static fromJS(data: any): PromotionAccessMemberDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionAccessMemberDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['userId'] = this.userId !== undefined ? this.userId : <any>null;
      if (Array.isArray(this.access)) {
        data['access'] = [];
        for (let item of this.access) data['access'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IPromotionAccessMemberDetailsDto {
    userId: string;
    access: KeyValuePairOfPromotionAccessPermissionAndBoolean[];
  }

  export class GetOverridePageDataQueryResult
    implements IGetOverridePageDataQueryResult
  {
    constructor(data?: IGetOverridePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetOverridePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridePageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetOverridePageDataQueryResult {}

  export class GetOverridePageDataQueryResultSuccess
    extends GetOverridePageDataQueryResult
    implements IGetOverridePageDataQueryResultSuccess
  {
    sourceEnvironment!: PromotionEnvironment;
    promotionIsEnabled!: boolean;
    userCanPromote!: boolean;
    canPromote!: boolean;
    canPromoteMessage!: string | null;
    promotions!: PromotionDetailsDto[];

    constructor(data?: IGetOverridePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.promotions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.sourceEnvironment =
          _data['sourceEnvironment'] !== undefined
            ? _data['sourceEnvironment']
            : <any>null;
        this.promotionIsEnabled =
          _data['promotionIsEnabled'] !== undefined
            ? _data['promotionIsEnabled']
            : <any>null;
        this.userCanPromote =
          _data['userCanPromote'] !== undefined
            ? _data['userCanPromote']
            : <any>null;
        this.canPromote =
          _data['canPromote'] !== undefined ? _data['canPromote'] : <any>null;
        this.canPromoteMessage =
          _data['canPromoteMessage'] !== undefined
            ? _data['canPromoteMessage']
            : <any>null;
        if (Array.isArray(_data['promotions'])) {
          this.promotions = [] as any;
          for (let item of _data['promotions'])
            this.promotions!.push(PromotionDetailsDto.fromJS(item));
        } else {
          this.promotions = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetOverridePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['sourceEnvironment'] =
        this.sourceEnvironment !== undefined
          ? this.sourceEnvironment
          : <any>null;
      data['promotionIsEnabled'] =
        this.promotionIsEnabled !== undefined
          ? this.promotionIsEnabled
          : <any>null;
      data['userCanPromote'] =
        this.userCanPromote !== undefined ? this.userCanPromote : <any>null;
      data['canPromote'] =
        this.canPromote !== undefined ? this.canPromote : <any>null;
      data['canPromoteMessage'] =
        this.canPromoteMessage !== undefined
          ? this.canPromoteMessage
          : <any>null;
      if (Array.isArray(this.promotions)) {
        data['promotions'] = [];
        for (let item of this.promotions)
          data['promotions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridePageDataQueryResultSuccess
    extends IGetOverridePageDataQueryResult {
    sourceEnvironment: PromotionEnvironment;
    promotionIsEnabled: boolean;
    userCanPromote: boolean;
    canPromote: boolean;
    canPromoteMessage: string | null;
    promotions: PromotionDetailsDto[];
  }

  export enum PromotionEnvironment {
    Dev = 'Dev',
    QA = 'QA',
    STG = 'STG',
    PreProd = 'PreProd',
    Prod = 'Prod',
  }

  export class PromotionDetailsDto implements IPromotionDetailsDto {
    id!: string;
    promotedOn!: Date | null;
    promotedBy!: string | null;
    promotionVersion!: string;
    comment!: string | null;
    targetEnvironmentsVersion!: string;
    lastUpdatedAfterPromotion!: Date | null;
    configurationSummaryFileUrl!: string | null;

    constructor(data?: IPromotionDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.promotedOn = _data['promotedOn']
          ? new Date(_data['promotedOn'].toString())
          : <any>null;
        this.promotedBy =
          _data['promotedBy'] !== undefined ? _data['promotedBy'] : <any>null;
        this.promotionVersion =
          _data['promotionVersion'] !== undefined
            ? _data['promotionVersion']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.targetEnvironmentsVersion =
          _data['targetEnvironmentsVersion'] !== undefined
            ? _data['targetEnvironmentsVersion']
            : <any>null;
        this.lastUpdatedAfterPromotion = _data['lastUpdatedAfterPromotion']
          ? new Date(_data['lastUpdatedAfterPromotion'].toString())
          : <any>null;
        this.configurationSummaryFileUrl =
          _data['configurationSummaryFileUrl'] !== undefined
            ? _data['configurationSummaryFileUrl']
            : <any>null;
      }
    }

    static fromJS(data: any): PromotionDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PromotionDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['promotedOn'] = this.promotedOn
        ? this.promotedOn.toISOString()
        : <any>null;
      data['promotedBy'] =
        this.promotedBy !== undefined ? this.promotedBy : <any>null;
      data['promotionVersion'] =
        this.promotionVersion !== undefined ? this.promotionVersion : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['targetEnvironmentsVersion'] =
        this.targetEnvironmentsVersion !== undefined
          ? this.targetEnvironmentsVersion
          : <any>null;
      data['lastUpdatedAfterPromotion'] = this.lastUpdatedAfterPromotion
        ? this.lastUpdatedAfterPromotion.toISOString()
        : <any>null;
      data['configurationSummaryFileUrl'] =
        this.configurationSummaryFileUrl !== undefined
          ? this.configurationSummaryFileUrl
          : <any>null;
      return data;
    }
  }

  export interface IPromotionDetailsDto {
    id: string;
    promotedOn: Date | null;
    promotedBy: string | null;
    promotionVersion: string;
    comment: string | null;
    targetEnvironmentsVersion: string;
    lastUpdatedAfterPromotion: Date | null;
    configurationSummaryFileUrl: string | null;
  }

  export class GetOverridePageDataQueryResultFailure
    extends GetOverridePageDataQueryResult
    implements IGetOverridePageDataQueryResultFailure
  {
    constructor(data?: IGetOverridePageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetOverridePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridePageDataQueryResultFailure
    extends IGetOverridePageDataQueryResult {}

  export abstract class PromoteOverrideCommandResult
    implements IPromoteOverrideCommandResult
  {
    constructor(data?: IPromoteOverrideCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PromoteOverrideCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'PromoteOverrideCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPromoteOverrideCommandResult {}

  export class PromoteOverrideCommandResultSuccess
    extends PromoteOverrideCommandResult
    implements IPromoteOverrideCommandResultSuccess
  {
    promotionDetails!: PromotionDetailsDto;

    constructor(data?: IPromoteOverrideCommandResultSuccess) {
      super(data);
      if (!data) {
        this.promotionDetails = new PromotionDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.promotionDetails = _data['promotionDetails']
          ? PromotionDetailsDto.fromJS(_data['promotionDetails'])
          : new PromotionDetailsDto();
      }
    }

    static override fromJS(data: any): PromoteOverrideCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteOverrideCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['promotionDetails'] = this.promotionDetails
        ? this.promotionDetails.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteOverrideCommandResultSuccess
    extends IPromoteOverrideCommandResult {
    promotionDetails: PromotionDetailsDto;
  }

  export class PromoteOverrideCommandResultFailure
    extends PromoteOverrideCommandResult
    implements IPromoteOverrideCommandResultFailure
  {
    missingCountriesInFootprint!: string[];
    missingPlanCodes!: string[];
    missingWorklocationPolicies!: string[];

    constructor(data?: IPromoteOverrideCommandResultFailure) {
      super(data);
      if (!data) {
        this.missingCountriesInFootprint = [];
        this.missingPlanCodes = [];
        this.missingWorklocationPolicies = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['missingCountriesInFootprint'])) {
          this.missingCountriesInFootprint = [] as any;
          for (let item of _data['missingCountriesInFootprint'])
            this.missingCountriesInFootprint!.push(item);
        } else {
          this.missingCountriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['missingPlanCodes'])) {
          this.missingPlanCodes = [] as any;
          for (let item of _data['missingPlanCodes'])
            this.missingPlanCodes!.push(item);
        } else {
          this.missingPlanCodes = <any>null;
        }
        if (Array.isArray(_data['missingWorklocationPolicies'])) {
          this.missingWorklocationPolicies = [] as any;
          for (let item of _data['missingWorklocationPolicies'])
            this.missingWorklocationPolicies!.push(item);
        } else {
          this.missingWorklocationPolicies = <any>null;
        }
      }
    }

    static override fromJS(data: any): PromoteOverrideCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteOverrideCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.missingCountriesInFootprint)) {
        data['missingCountriesInFootprint'] = [];
        for (let item of this.missingCountriesInFootprint)
          data['missingCountriesInFootprint'].push(item);
      }
      if (Array.isArray(this.missingPlanCodes)) {
        data['missingPlanCodes'] = [];
        for (let item of this.missingPlanCodes)
          data['missingPlanCodes'].push(item);
      }
      if (Array.isArray(this.missingWorklocationPolicies)) {
        data['missingWorklocationPolicies'] = [];
        for (let item of this.missingWorklocationPolicies)
          data['missingWorklocationPolicies'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteOverrideCommandResultFailure
    extends IPromoteOverrideCommandResult {
    missingCountriesInFootprint: string[];
    missingPlanCodes: string[];
    missingWorklocationPolicies: string[];
  }

  export class PromoteOverrideCommand implements IPromoteOverrideCommand {
    clientId!: string;
    comment!: string;

    constructor(data?: IPromoteOverrideCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(data: any): PromoteOverrideCommand {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteOverrideCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IPromoteOverrideCommand {
    clientId: string;
    comment: string;
  }

  export abstract class UpsertOverrideDataCommandResult
    implements IUpsertOverrideDataCommandResult
  {
    constructor(data?: IUpsertOverrideDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertOverrideDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertOverrideDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertOverrideDataCommandResult {}

  export class UpsertOverrideDataCommandResultSuccess
    extends UpsertOverrideDataCommandResult
    implements IUpsertOverrideDataCommandResultSuccess
  {
    constructor(data?: IUpsertOverrideDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): UpsertOverrideDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertOverrideDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertOverrideDataCommandResultSuccess
    extends IUpsertOverrideDataCommandResult {}

  export class UpsertOverrideDataCommandResultFailure
    extends UpsertOverrideDataCommandResult
    implements IUpsertOverrideDataCommandResultFailure
  {
    missingCountriesInFootprint!: string[];
    missingPlanCodes!: string[];

    constructor(data?: IUpsertOverrideDataCommandResultFailure) {
      super(data);
      if (!data) {
        this.missingCountriesInFootprint = [];
        this.missingPlanCodes = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['missingCountriesInFootprint'])) {
          this.missingCountriesInFootprint = [] as any;
          for (let item of _data['missingCountriesInFootprint'])
            this.missingCountriesInFootprint!.push(item);
        } else {
          this.missingCountriesInFootprint = <any>null;
        }
        if (Array.isArray(_data['missingPlanCodes'])) {
          this.missingPlanCodes = [] as any;
          for (let item of _data['missingPlanCodes'])
            this.missingPlanCodes!.push(item);
        } else {
          this.missingPlanCodes = <any>null;
        }
      }
    }

    static override fromJS(data: any): UpsertOverrideDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertOverrideDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.missingCountriesInFootprint)) {
        data['missingCountriesInFootprint'] = [];
        for (let item of this.missingCountriesInFootprint)
          data['missingCountriesInFootprint'].push(item);
      }
      if (Array.isArray(this.missingPlanCodes)) {
        data['missingPlanCodes'] = [];
        for (let item of this.missingPlanCodes)
          data['missingPlanCodes'].push(item);
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertOverrideDataCommandResultFailure
    extends IUpsertOverrideDataCommandResult {
    missingCountriesInFootprint: string[];
    missingPlanCodes: string[];
  }

  export class UpsertOverrideDataCommand implements IUpsertOverrideDataCommand {
    preSignedUrls!: string[];

    constructor(data?: IUpsertOverrideDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.preSignedUrls = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['preSignedUrls'])) {
          this.preSignedUrls = [] as any;
          for (let item of _data['preSignedUrls'])
            this.preSignedUrls!.push(item);
        } else {
          this.preSignedUrls = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertOverrideDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertOverrideDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.preSignedUrls)) {
        data['preSignedUrls'] = [];
        for (let item of this.preSignedUrls) data['preSignedUrls'].push(item);
      }
      return data;
    }
  }

  export interface IUpsertOverrideDataCommand {
    preSignedUrls: string[];
  }

  export abstract class GetOverridePromotionsQueryResult
    implements IGetOverridePromotionsQueryResult
  {
    constructor(data?: IGetOverridePromotionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetOverridePromotionsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetOverridePromotionsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetOverridePromotionsQueryResult {}

  export class GetOverridePromotionsQueryResultSuccess
    extends GetOverridePromotionsQueryResult
    implements IGetOverridePromotionsQueryResultSuccess
  {
    overridePromotions!: PromotionDetailsDto[];

    constructor(data?: IGetOverridePromotionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.overridePromotions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['overridePromotions'])) {
          this.overridePromotions = [] as any;
          for (let item of _data['overridePromotions'])
            this.overridePromotions!.push(PromotionDetailsDto.fromJS(item));
        } else {
          this.overridePromotions = <any>null;
        }
      }
    }

    static override fromJS(data: any): GetOverridePromotionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridePromotionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.overridePromotions)) {
        data['overridePromotions'] = [];
        for (let item of this.overridePromotions)
          data['overridePromotions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridePromotionsQueryResultSuccess
    extends IGetOverridePromotionsQueryResult {
    overridePromotions: PromotionDetailsDto[];
  }

  export class GetOverridePromotionsQueryResultFailure
    extends GetOverridePromotionsQueryResult
    implements IGetOverridePromotionsQueryResultFailure
  {
    constructor(data?: IGetOverridePromotionsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(data: any): GetOverridePromotionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetOverridePromotionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetOverridePromotionsQueryResultFailure
    extends IGetOverridePromotionsQueryResult {}

  export class GetConfigurationPageDataQueryResult
    implements IGetConfigurationPageDataQueryResult
  {
    constructor(data?: IGetConfigurationPageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetConfigurationPageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      let result = new GetConfigurationPageDataQueryResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetConfigurationPageDataQueryResult {}

  export class GetConfigurationPageDataQueryResultSuccess
    extends GetConfigurationPageDataQueryResult
    implements IGetConfigurationPageDataQueryResultSuccess
  {
    sourceEnvironment!: PromotionEnvironment;
    promotionIsEnabled!: boolean;
    userCanPromote!: boolean;
    canPromote!: boolean;
    canPromoteMessage!: string | null;
    promotions!: PromotionDetailsDto[];

    constructor(data?: IGetConfigurationPageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.promotions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.sourceEnvironment =
          _data['sourceEnvironment'] !== undefined
            ? _data['sourceEnvironment']
            : <any>null;
        this.promotionIsEnabled =
          _data['promotionIsEnabled'] !== undefined
            ? _data['promotionIsEnabled']
            : <any>null;
        this.userCanPromote =
          _data['userCanPromote'] !== undefined
            ? _data['userCanPromote']
            : <any>null;
        this.canPromote =
          _data['canPromote'] !== undefined ? _data['canPromote'] : <any>null;
        this.canPromoteMessage =
          _data['canPromoteMessage'] !== undefined
            ? _data['canPromoteMessage']
            : <any>null;
        if (Array.isArray(_data['promotions'])) {
          this.promotions = [] as any;
          for (let item of _data['promotions'])
            this.promotions!.push(PromotionDetailsDto.fromJS(item));
        } else {
          this.promotions = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetConfigurationPageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetConfigurationPageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['sourceEnvironment'] =
        this.sourceEnvironment !== undefined
          ? this.sourceEnvironment
          : <any>null;
      data['promotionIsEnabled'] =
        this.promotionIsEnabled !== undefined
          ? this.promotionIsEnabled
          : <any>null;
      data['userCanPromote'] =
        this.userCanPromote !== undefined ? this.userCanPromote : <any>null;
      data['canPromote'] =
        this.canPromote !== undefined ? this.canPromote : <any>null;
      data['canPromoteMessage'] =
        this.canPromoteMessage !== undefined
          ? this.canPromoteMessage
          : <any>null;
      if (Array.isArray(this.promotions)) {
        data['promotions'] = [];
        for (let item of this.promotions)
          data['promotions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetConfigurationPageDataQueryResultSuccess
    extends IGetConfigurationPageDataQueryResult {
    sourceEnvironment: PromotionEnvironment;
    promotionIsEnabled: boolean;
    userCanPromote: boolean;
    canPromote: boolean;
    canPromoteMessage: string | null;
    promotions: PromotionDetailsDto[];
  }

  export class GetConfigurationPageDataQueryResultFailure
    extends GetConfigurationPageDataQueryResult
    implements IGetConfigurationPageDataQueryResultFailure
  {
    constructor(data?: IGetConfigurationPageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetConfigurationPageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetConfigurationPageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetConfigurationPageDataQueryResultFailure
    extends IGetConfigurationPageDataQueryResult {}

  export abstract class PromoteConfigurationCommandResult
    implements IPromoteConfigurationCommandResult
  {
    constructor(data?: IPromoteConfigurationCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PromoteConfigurationCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'PromoteConfigurationCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPromoteConfigurationCommandResult {}

  export class PromoteConfigurationCommandResultSuccess
    extends PromoteConfigurationCommandResult
    implements IPromoteConfigurationCommandResultSuccess
  {
    promotionDetails!: PromotionDetailsDto;

    constructor(data?: IPromoteConfigurationCommandResultSuccess) {
      super(data);
      if (!data) {
        this.promotionDetails = new PromotionDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.promotionDetails = _data['promotionDetails']
          ? PromotionDetailsDto.fromJS(_data['promotionDetails'])
          : new PromotionDetailsDto();
      }
    }

    static override fromJS(
      data: any,
    ): PromoteConfigurationCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteConfigurationCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['promotionDetails'] = this.promotionDetails
        ? this.promotionDetails.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteConfigurationCommandResultSuccess
    extends IPromoteConfigurationCommandResult {
    promotionDetails: PromotionDetailsDto;
  }

  export class PromoteConfigurationCommandResultFailure
    extends PromoteConfigurationCommandResult
    implements IPromoteConfigurationCommandResultFailure
  {
    timedOut!: boolean;
    errorCode!: PromoteConfigurationResultFailureErrorCode;

    constructor(data?: IPromoteConfigurationCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.timedOut =
          _data['timedOut'] !== undefined ? _data['timedOut'] : <any>null;
        this.errorCode =
          _data['errorCode'] !== undefined ? _data['errorCode'] : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): PromoteConfigurationCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteConfigurationCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['timedOut'] =
        this.timedOut !== undefined ? this.timedOut : <any>null;
      data['errorCode'] =
        this.errorCode !== undefined ? this.errorCode : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteConfigurationCommandResultFailure
    extends IPromoteConfigurationCommandResult {
    timedOut: boolean;
    errorCode: PromoteConfigurationResultFailureErrorCode;
  }

  export enum PromoteConfigurationResultFailureErrorCode {
    UserIsInActive = 'UserIsInActive',
    Unknown = 'Unknown',
  }

  export class PromoteConfigurationCommand
    implements IPromoteConfigurationCommand
  {
    clientId!: string;
    comment!: string;

    constructor(data?: IPromoteConfigurationCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(data: any): PromoteConfigurationCommand {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteConfigurationCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IPromoteConfigurationCommand {
    clientId: string;
    comment: string;
  }

  export abstract class UpsertConfigurationDataCommandResult
    implements IUpsertConfigurationDataCommandResult
  {
    constructor(data?: IUpsertConfigurationDataCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): UpsertConfigurationDataCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'UpsertConfigurationDataCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IUpsertConfigurationDataCommandResult {}

  export class UpsertConfigurationDataCommandResultSuccess
    extends UpsertConfigurationDataCommandResult
    implements IUpsertConfigurationDataCommandResultSuccess
  {
    constructor(data?: IUpsertConfigurationDataCommandResultSuccess) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertConfigurationDataCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertConfigurationDataCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertConfigurationDataCommandResultSuccess
    extends IUpsertConfigurationDataCommandResult {}

  export class UpsertConfigurationDataCommandResultFailure
    extends UpsertConfigurationDataCommandResult
    implements IUpsertConfigurationDataCommandResultFailure
  {
    constructor(data?: IUpsertConfigurationDataCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): UpsertConfigurationDataCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertConfigurationDataCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IUpsertConfigurationDataCommandResultFailure
    extends IUpsertConfigurationDataCommandResult {}

  export class UpsertConfigurationDataCommand
    implements IUpsertConfigurationDataCommand
  {
    preSignedUrls!: string[];

    constructor(data?: IUpsertConfigurationDataCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
      if (!data) {
        this.preSignedUrls = [];
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['preSignedUrls'])) {
          this.preSignedUrls = [] as any;
          for (let item of _data['preSignedUrls'])
            this.preSignedUrls!.push(item);
        } else {
          this.preSignedUrls = <any>null;
        }
      }
    }

    static fromJS(data: any): UpsertConfigurationDataCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpsertConfigurationDataCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.preSignedUrls)) {
        data['preSignedUrls'] = [];
        for (let item of this.preSignedUrls) data['preSignedUrls'].push(item);
      }
      return data;
    }
  }

  export interface IUpsertConfigurationDataCommand {
    preSignedUrls: string[];
  }

  export abstract class GetConfigurationPromotionsQueryResult
    implements IGetConfigurationPromotionsQueryResult
  {
    constructor(data?: IGetConfigurationPromotionsQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetConfigurationPromotionsQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetConfigurationPromotionsQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetConfigurationPromotionsQueryResult {}

  export class GetConfigurationPromotionsQueryResultSuccess
    extends GetConfigurationPromotionsQueryResult
    implements IGetConfigurationPromotionsQueryResultSuccess
  {
    configurationPromotions!: PromotionDetailsDto[];

    constructor(data?: IGetConfigurationPromotionsQueryResultSuccess) {
      super(data);
      if (!data) {
        this.configurationPromotions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        if (Array.isArray(_data['configurationPromotions'])) {
          this.configurationPromotions = [] as any;
          for (let item of _data['configurationPromotions'])
            this.configurationPromotions!.push(
              PromotionDetailsDto.fromJS(item),
            );
        } else {
          this.configurationPromotions = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetConfigurationPromotionsQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetConfigurationPromotionsQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.configurationPromotions)) {
        data['configurationPromotions'] = [];
        for (let item of this.configurationPromotions)
          data['configurationPromotions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetConfigurationPromotionsQueryResultSuccess
    extends IGetConfigurationPromotionsQueryResult {
    configurationPromotions: PromotionDetailsDto[];
  }

  export class GetConfigurationPromotionsQueryResultFailure
    extends GetConfigurationPromotionsQueryResult
    implements IGetConfigurationPromotionsQueryResultFailure
  {
    constructor(data?: IGetConfigurationPromotionsQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetConfigurationPromotionsQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetConfigurationPromotionsQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetConfigurationPromotionsQueryResultFailure
    extends IGetConfigurationPromotionsQueryResult {}

  export class DownloadPromotionConfigurationSummaryCommandResult
    implements IDownloadPromotionConfigurationSummaryCommandResult
  {
    constructor(data?: IDownloadPromotionConfigurationSummaryCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(
      data: any,
    ): DownloadPromotionConfigurationSummaryCommandResult {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadPromotionConfigurationSummaryCommandResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IDownloadPromotionConfigurationSummaryCommandResult {}

  export class DownloadPromotionConfigurationSummaryCommandResultSuccess
    extends DownloadPromotionConfigurationSummaryCommandResult
    implements IDownloadPromotionConfigurationSummaryCommandResultSuccess
  {
    encodedString!: string;

    constructor(
      data?: IDownloadPromotionConfigurationSummaryCommandResultSuccess,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.encodedString =
          _data['encodedString'] !== undefined
            ? _data['encodedString']
            : <any>null;
      }
    }

    static override fromJS(
      data: any,
    ): DownloadPromotionConfigurationSummaryCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadPromotionConfigurationSummaryCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['encodedString'] =
        this.encodedString !== undefined ? this.encodedString : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadPromotionConfigurationSummaryCommandResultSuccess
    extends IDownloadPromotionConfigurationSummaryCommandResult {
    encodedString: string;
  }

  export class DownloadPromotionConfigurationSummaryCommandResultFailure
    extends DownloadPromotionConfigurationSummaryCommandResult
    implements IDownloadPromotionConfigurationSummaryCommandResultFailure
  {
    constructor(
      data?: IDownloadPromotionConfigurationSummaryCommandResultFailure,
    ) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): DownloadPromotionConfigurationSummaryCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result =
        new DownloadPromotionConfigurationSummaryCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IDownloadPromotionConfigurationSummaryCommandResultFailure
    extends IDownloadPromotionConfigurationSummaryCommandResult {}

  export class DownloadPromotionConfigurationSummaryCommand
    implements IDownloadPromotionConfigurationSummaryCommand
  {
    clientId!: string;
    promotionId!: string;

    constructor(data?: IDownloadPromotionConfigurationSummaryCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.promotionId =
          _data['promotionId'] !== undefined ? _data['promotionId'] : <any>null;
      }
    }

    static fromJS(data: any): DownloadPromotionConfigurationSummaryCommand {
      data = typeof data === 'object' ? data : {};
      let result = new DownloadPromotionConfigurationSummaryCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['promotionId'] =
        this.promotionId !== undefined ? this.promotionId : <any>null;
      return data;
    }
  }

  export interface IDownloadPromotionConfigurationSummaryCommand {
    clientId: string;
    promotionId: string;
  }

  export abstract class GetDataExchangePageDataQueryResult
    implements IGetDataExchangePageDataQueryResult
  {
    constructor(data?: IGetDataExchangePageDataQueryResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): GetDataExchangePageDataQueryResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'GetDataExchangePageDataQueryResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IGetDataExchangePageDataQueryResult {}

  export class GetDataExchangePageDataQueryResultSuccess
    extends GetDataExchangePageDataQueryResult
    implements IGetDataExchangePageDataQueryResultSuccess
  {
    sourceEnvironment!: PromotionEnvironment;
    promotionIsEnabled!: boolean;
    userCanPromote!: boolean;
    canPromote!: boolean;
    canPromoteMessage!: string | null;
    promotions!: DataExchangePromotionDetailsDto[];

    constructor(data?: IGetDataExchangePageDataQueryResultSuccess) {
      super(data);
      if (!data) {
        this.promotions = [];
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.sourceEnvironment =
          _data['sourceEnvironment'] !== undefined
            ? _data['sourceEnvironment']
            : <any>null;
        this.promotionIsEnabled =
          _data['promotionIsEnabled'] !== undefined
            ? _data['promotionIsEnabled']
            : <any>null;
        this.userCanPromote =
          _data['userCanPromote'] !== undefined
            ? _data['userCanPromote']
            : <any>null;
        this.canPromote =
          _data['canPromote'] !== undefined ? _data['canPromote'] : <any>null;
        this.canPromoteMessage =
          _data['canPromoteMessage'] !== undefined
            ? _data['canPromoteMessage']
            : <any>null;
        if (Array.isArray(_data['promotions'])) {
          this.promotions = [] as any;
          for (let item of _data['promotions'])
            this.promotions!.push(DataExchangePromotionDetailsDto.fromJS(item));
        } else {
          this.promotions = <any>null;
        }
      }
    }

    static override fromJS(
      data: any,
    ): GetDataExchangePageDataQueryResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new GetDataExchangePageDataQueryResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['sourceEnvironment'] =
        this.sourceEnvironment !== undefined
          ? this.sourceEnvironment
          : <any>null;
      data['promotionIsEnabled'] =
        this.promotionIsEnabled !== undefined
          ? this.promotionIsEnabled
          : <any>null;
      data['userCanPromote'] =
        this.userCanPromote !== undefined ? this.userCanPromote : <any>null;
      data['canPromote'] =
        this.canPromote !== undefined ? this.canPromote : <any>null;
      data['canPromoteMessage'] =
        this.canPromoteMessage !== undefined
          ? this.canPromoteMessage
          : <any>null;
      if (Array.isArray(this.promotions)) {
        data['promotions'] = [];
        for (let item of this.promotions)
          data['promotions'].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDataExchangePageDataQueryResultSuccess
    extends IGetDataExchangePageDataQueryResult {
    sourceEnvironment: PromotionEnvironment;
    promotionIsEnabled: boolean;
    userCanPromote: boolean;
    canPromote: boolean;
    canPromoteMessage: string | null;
    promotions: DataExchangePromotionDetailsDto[];
  }

  export class DataExchangePromotionDetailsDto
    implements IDataExchangePromotionDetailsDto
  {
    id!: string;
    promotedOn!: Date | null;
    promotedBy!: string | null;
    promotionVersion!: string;
    comment!: string | null;
    targetEnvironmentsVersion!: string;
    lastUpdatedAfterPromotion!: Date | null;
    revertedOn!: Date | null;
    revertedBy!: string | null;

    constructor(data?: IDataExchangePromotionDetailsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'] !== undefined ? _data['id'] : <any>null;
        this.promotedOn = _data['promotedOn']
          ? new Date(_data['promotedOn'].toString())
          : <any>null;
        this.promotedBy =
          _data['promotedBy'] !== undefined ? _data['promotedBy'] : <any>null;
        this.promotionVersion =
          _data['promotionVersion'] !== undefined
            ? _data['promotionVersion']
            : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
        this.targetEnvironmentsVersion =
          _data['targetEnvironmentsVersion'] !== undefined
            ? _data['targetEnvironmentsVersion']
            : <any>null;
        this.lastUpdatedAfterPromotion = _data['lastUpdatedAfterPromotion']
          ? new Date(_data['lastUpdatedAfterPromotion'].toString())
          : <any>null;
        this.revertedOn = _data['revertedOn']
          ? new Date(_data['revertedOn'].toString())
          : <any>null;
        this.revertedBy =
          _data['revertedBy'] !== undefined ? _data['revertedBy'] : <any>null;
      }
    }

    static fromJS(data: any): DataExchangePromotionDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DataExchangePromotionDetailsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id !== undefined ? this.id : <any>null;
      data['promotedOn'] = this.promotedOn
        ? this.promotedOn.toISOString()
        : <any>null;
      data['promotedBy'] =
        this.promotedBy !== undefined ? this.promotedBy : <any>null;
      data['promotionVersion'] =
        this.promotionVersion !== undefined ? this.promotionVersion : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      data['targetEnvironmentsVersion'] =
        this.targetEnvironmentsVersion !== undefined
          ? this.targetEnvironmentsVersion
          : <any>null;
      data['lastUpdatedAfterPromotion'] = this.lastUpdatedAfterPromotion
        ? this.lastUpdatedAfterPromotion.toISOString()
        : <any>null;
      data['revertedOn'] = this.revertedOn
        ? this.revertedOn.toISOString()
        : <any>null;
      data['revertedBy'] =
        this.revertedBy !== undefined ? this.revertedBy : <any>null;
      return data;
    }
  }

  export interface IDataExchangePromotionDetailsDto {
    id: string;
    promotedOn: Date | null;
    promotedBy: string | null;
    promotionVersion: string;
    comment: string | null;
    targetEnvironmentsVersion: string;
    lastUpdatedAfterPromotion: Date | null;
    revertedOn: Date | null;
    revertedBy: string | null;
  }

  export class GetDataExchangePageDataQueryResultFailure
    extends GetDataExchangePageDataQueryResult
    implements IGetDataExchangePageDataQueryResultFailure
  {
    constructor(data?: IGetDataExchangePageDataQueryResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
    }

    static override fromJS(
      data: any,
    ): GetDataExchangePageDataQueryResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new GetDataExchangePageDataQueryResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
    }
  }

  export interface IGetDataExchangePageDataQueryResultFailure
    extends IGetDataExchangePageDataQueryResult {}

  export abstract class PromoteDataExchangeCommandResult
    implements IPromoteDataExchangeCommandResult
  {
    constructor(data?: IPromoteDataExchangeCommandResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {}

    static fromJS(data: any): PromoteDataExchangeCommandResult {
      data = typeof data === 'object' ? data : {};
      throw new Error(
        "The abstract class 'PromoteDataExchangeCommandResult' cannot be instantiated.",
      );
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
    }
  }

  export interface IPromoteDataExchangeCommandResult {}

  export class PromoteDataExchangeCommandResultSuccess
    extends PromoteDataExchangeCommandResult
    implements IPromoteDataExchangeCommandResultSuccess
  {
    promotionDetails!: DataExchangePromotionDetailsDto;

    constructor(data?: IPromoteDataExchangeCommandResultSuccess) {
      super(data);
      if (!data) {
        this.promotionDetails = new DataExchangePromotionDetailsDto();
      }
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.promotionDetails = _data['promotionDetails']
          ? DataExchangePromotionDetailsDto.fromJS(_data['promotionDetails'])
          : new DataExchangePromotionDetailsDto();
      }
    }

    static override fromJS(data: any): PromoteDataExchangeCommandResultSuccess {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteDataExchangeCommandResultSuccess();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['promotionDetails'] = this.promotionDetails
        ? this.promotionDetails.toJSON()
        : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteDataExchangeCommandResultSuccess
    extends IPromoteDataExchangeCommandResult {
    promotionDetails: DataExchangePromotionDetailsDto;
  }

  export class PromoteDataExchangeCommandResultFailure
    extends PromoteDataExchangeCommandResult
    implements IPromoteDataExchangeCommandResultFailure
  {
    timedOut!: boolean;

    constructor(data?: IPromoteDataExchangeCommandResultFailure) {
      super(data);
    }

    override init(_data?: any) {
      super.init(_data);
      if (_data) {
        this.timedOut =
          _data['timedOut'] !== undefined ? _data['timedOut'] : <any>null;
      }
    }

    static override fromJS(data: any): PromoteDataExchangeCommandResultFailure {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteDataExchangeCommandResultFailure();
      result.init(data);
      return result;
    }

    override toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['timedOut'] =
        this.timedOut !== undefined ? this.timedOut : <any>null;
      super.toJSON(data);
      return data;
    }
  }

  export interface IPromoteDataExchangeCommandResultFailure
    extends IPromoteDataExchangeCommandResult {
    timedOut: boolean;
  }

  export class PromoteDataExchangeCommand
    implements IPromoteDataExchangeCommand
  {
    clientId!: string;
    comment!: string;

    constructor(data?: IPromoteDataExchangeCommand) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.clientId =
          _data['clientId'] !== undefined ? _data['clientId'] : <any>null;
        this.comment =
          _data['comment'] !== undefined ? _data['comment'] : <any>null;
      }
    }

    static fromJS(data: any): PromoteDataExchangeCommand {
      data = typeof data === 'object' ? data : {};
      let result = new PromoteDataExchangeCommand();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['clientId'] =
        this.clientId !== undefined ? this.clientId : <any>null;
      data['comment'] = this.comment !== undefined ? this.comment : <any>null;
      return data;
    }
  }

  export interface IPromoteDataExchangeCommand {
    clientId: string;
    comment: string;
  }

  export interface FileParameter {
    data: any;
    fileName: string;
  }

  export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(
      message: string,
      status: number,
      response: string,
      headers: { [key: string]: any },
      result: any,
    ) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
    }
  }

  function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any,
  ): Observable<any> {
    if (result !== null && result !== undefined)
      return _observableThrow(result);
    else
      return _observableThrow(
        new ApiException(message, status, response, headers, null),
      );
  }

  function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next('');
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = (event) => {
          observer.next((event.target as any).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
}
